import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO-8601 timestamp, with millisecond precision, expressing its timezone offset */
  Timestamp: any;
  /** A date string in YYYY-MM-DD format */
  DateOnlyString: string;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A date only returning scalar */
  DateOnly: any;
  RatingReviewCursor: any;
  /** Currently just template id */
  ContactQuarantinedMessageBatchCursor: any;
  GroupConnectionCursor: any;
  GuestListMemberCursor: any;
  /** A scalar type for handling large integers beyond JavaScript safe integer limit */
  BigInt: any;
  EventSearchCursor: any;
  LinkRedirectBlockCursor: any;
  Url: any;
  /** Currently link redirect id */
  LinkRedirectCursor: any;
  /**
   * An opaque identifier providing a unique reference to an element within a pagination query.
   * The term for it in the Relay Specification is a "Cursor".
   *   https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  ProductCatalogSearchCursor: any;
  ProductCatalogEntityCursor: any;
  NegativeInt: any;
  /** Currently just template id */
  StationeryTemplateCursor: any;
  UserActivityCursor: any;
  /** Represents NULL values */
  Void: any;
};

/** Property Identifier Input. Only one of the fields should be non-null */
export type AccommodationCatalogPropertyIdentifierInput = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export enum AccommodationCategory {
  Hotel = 'Hotel',
  Other = 'Other',
  VacationRental = 'VacationRental'
}

export enum ArchivedStatus {
  archivedByCouple = 'archivedByCouple',
  archivedBySystem = 'archivedBySystem',
  archivedByVendor = 'archivedByVendor',
  notArchived = 'notArchived'
}

export enum DateFormat {
  full = 'full',
  long = 'long',
  numerical = 'numerical',
  short = 'short'
}

export enum TimeFormat {
  time = 'time',
  timeWithSeconds = 'timeWithSeconds'
}

export enum TimezoneFormat {
  long = 'long',
  short = 'short'
}

export enum AccommodationPlaceDisplayLocation {
  AccommodationPage = 'AccommodationPage',
  CustomPage = 'CustomPage'
}

export enum AccommodationPlaceRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled'
}

/** TrackingQueryStringKey */
export enum TrackingQueryStringKey {
  campaignId = 'campaignId',
  clientReference = 'clientReference',
  eventId = 'eventId'
}

/** RedirectMechanismType */
export enum RedirectMechanismType {
  custom = 'custom',
  joyNativeCheckout = 'joyNativeCheckout',
  partnerHotel = 'partnerHotel',
  partnerSearch = 'partnerSearch'
}

export enum TravelCurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GNF = 'GNF',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LBP = 'LBP',
  LKR = 'LKR',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SOS = 'SOS',
  SYP = 'SYP',
  THB = 'THB',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XAF = 'XAF',
  XOF = 'XOF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZWL = 'ZWL'
}

export enum StrikeoutRateProvider {
  booking = 'booking',
  expedia = 'expedia',
  unknown = 'unknown'
}

/** Status of an accommodation place recommendation */
export enum AccommodationPlaceRecommendationStatus {
  abandoned = 'abandoned',
  accepted = 'accepted',
  added = 'added',
  declined = 'declined',
  pending = 'pending'
}

export enum AccommodationPlaceCategory {
  campsite = 'campsite',
  hotel = 'hotel',
  rental = 'rental'
}

export enum DistancesBetweenPointsType {
  DRIVING_DISTANCE = 'DRIVING_DISTANCE',
  GEO_DISTANCE = 'GEO_DISTANCE',
  WALKING_DISTANCE = 'WALKING_DISTANCE'
}

export enum HotelProvider {
  customUrl = 'customUrl',
  googlePlaceUrl = 'googlePlaceUrl',
  hotelWebsiteUrl = 'hotelWebsiteUrl',
  joynativecheckout = 'joynativecheckout',
  nuitee = 'nuitee',
  zh = 'zh'
}

/** AccommodationPlaceType */
export enum AccommodationPlaceType {
  custom = 'custom',
  hotel = 'hotel'
}

export enum EventPageType {
  app = 'app',
  custom = 'custom',
  faq = 'faq',
  guests = 'guests',
  moments = 'moments',
  registry = 'registry',
  rsvp = 'rsvp',
  schedule = 'schedule',
  story = 'story',
  tidbits = 'tidbits',
  travel = 'travel',
  vip = 'vip',
  welcome = 'welcome'
}

export enum EventRSVPAttendanceStatus {
  attending = 'attending',
  noAttendanceQuestion = 'noAttendanceQuestion',
  notAttending = 'notAttending',
  other = 'other',
  unanswered = 'unanswered'
}

export enum PersonGuestState {
  evicted = 'evicted',
  left = 'left',
  user = 'user'
}

export enum VirtualEventProvider {
  eventlive = 'eventlive',
  googleMeet = 'googleMeet',
  unknown = 'unknown',
  youtube = 'youtube',
  zoom = 'zoom'
}

export enum EventUserStatus {
  admin = 'admin',
  crasher = 'crasher',
  guest = 'guest',
  owner = 'owner'
}

export enum LocationAnchorSource {
  approximated_centroid = 'approximated_centroid',
  event_location = 'event_location',
  event_venue = 'event_venue'
}

export enum FavoriteType {
  art = 'art',
  font = 'font',
  template = 'template'
}

export enum DesignLayoutType {
  aloha = 'aloha',
  brannan = 'brannan'
}

export enum FontWeight {
  none = 'none',
  uppercase = 'uppercase'
}

export enum Typeface {
  handwriting = 'handwriting',
  monospace = 'monospace',
  sansSerif = 'sansSerif',
  script = 'script',
  serif = 'serif'
}

export enum ThemeVariationType {
  aloha = 'aloha',
  brannan = 'brannan',
  invite = 'invite',
  prints = 'prints',
  savethedate = 'savethedate',
  thumbnail = 'thumbnail'
}

export enum FeatureValueType {
  boolean = 'boolean',
  color = 'color',
  range = 'range'
}

export enum EventDesignPurpose {
  draft = 'draft',
  live = 'live'
}

export enum BrannanNavigation {
  classic = 'classic',
  singlePage = 'singlePage'
}

export enum DesignFeatureType {
  alohaColorPreference = 'alohaColorPreference',
  alohaTextColorPreference = 'alohaTextColorPreference',
  brannanBackgroundTransparency = 'brannanBackgroundTransparency',
  brannanColorPreference = 'brannanColorPreference',
  brannanInnerFrameBorder = 'brannanInnerFrameBorder',
  brannanTextColorPreference = 'brannanTextColorPreference'
}

export enum ColorPointerLocation {
  event = 'event',
  theme = 'theme'
}

export enum Category {
  BUTTONS = 'BUTTONS',
  CAPTION = 'CAPTION',
  DATE = 'DATE',
  EVENT_TITLE = 'EVENT_TITLE',
  HEADING = 'HEADING',
  LOCATION = 'LOCATION',
  NAVIGATION = 'NAVIGATION',
  PAGE_TITLE = 'PAGE_TITLE',
  PARAGRAPH = 'PARAGRAPH',
  SUB_HEADING = 'SUB_HEADING'
}

export enum GuestSiteTargetEnum {
  bliss = 'bliss',
  charm = 'charm'
}

export type PeopleFindCriteria = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type PeopleFindOptions = {
  allGuestStates?: InputMaybe<Scalars['Boolean']>;
  strategy: PeopleFindStrategy;
};

export enum PeopleFindStrategy {
  fuzzy = 'fuzzy',
  myInvite = 'myInvite'
}

export enum RoomBlockPerks {
  hotelPoints15k = 'hotelPoints15k'
}

export enum LeadState {
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  Viewed = 'Viewed',
  Won = 'Won'
}

export enum LeadStateV2 {
  ConciergeAssigned = 'ConciergeAssigned',
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  NewPricingRequested = 'NewPricingRequested',
  OfferAccepted = 'OfferAccepted',
  OfferSent = 'OfferSent',
  PricingReceived = 'PricingReceived',
  PricingRequested = 'PricingRequested',
  Viewed = 'Viewed',
  Won = 'Won'
}

export enum ContactMethods {
  /** @deprecated deprecated, please use meeting */
  calendly = 'calendly',
  email = 'email',
  meeting = 'meeting',
  phoneCall = 'phoneCall',
  sms = 'sms'
}

export enum ReservedRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled',
  inactive = 'inactive',
  pending = 'pending'
}

/** General information for an Event */
export enum EventType {
  babyRegistry = 'babyRegistry',
  card = 'card',
  general = 'general',
  wedding = 'wedding'
}

export enum QandaType {
  faq = 'faq',
  tidbit = 'tidbit'
}

export enum CustomItemDataType {
  cash = 'cash',
  charity = 'charity',
  gift = 'gift'
}

export enum DonationFundPaymentMethodEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  joyCredit = 'joyCredit',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo'
}

export enum FeePaidByEnum {
  couple = 'couple',
  guest = 'guest'
}

export enum DonationFundPlatformTypeEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo'
}

/**
 * Structured country data is prefered (i.e. the countryCode with
 * the country field set to that countrys name). For freeform country
 * omit the countryCode (null / undefined).
 */
export type ShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export enum LegacyRegistryItemType {
  canned = 'canned',
  custom = 'custom',
  product = 'product'
}

export enum RegistryItemRecommendationStatus {
  skipped = 'skipped',
  swapped = 'swapped',
  unseen = 'unseen'
}

export enum RegistryRecommendationStatus {
  /** The couple has completed viewing and selecting their recommendations */
  completed = 'completed',
  /** registry has recommendations, but couple has not viewed them yet */
  hasRecommendations = 'hasRecommendations',
  /**
   * The couple is in progress viewing and selecting recommendations,
   * but has not viewed the entire selection yet
   */
  inProgress = 'inProgress',
  /** has not started the recommendations process */
  notStarted = 'notStarted'
}

export enum RegistryType {
  /** An adopted external registry that was transferred from the transitional registry. */
  adopted = 'adopted',
  /** Simply add a link to any external registry. */
  linked = 'linked',
  /** Internal registry managed in Joy. */
  standalone = 'standalone',
  /** Automatically and periodically import items from an external registry into Joy. */
  synced = 'synced',
  /** Move an external registry into Joy, manage items, and see gift details within Joy. */
  transferred = 'transferred'
}

export enum SafetyRating {
  none = 'none',
  safeOverride = 'safeOverride',
  unsafeRequiresEscalation = 'unsafeRequiresEscalation'
}

export enum TravelType {
  booking = 'booking',
  ferry = 'ferry',
  flight = 'flight',
  hotel = 'hotel',
  list = 'list',
  note = 'note',
  rentalCar = 'rentalCar',
  rentalHome = 'rentalHome',
  shuttle = 'shuttle',
  taxi = 'taxi',
  tent = 'tent',
  train = 'train'
}

export enum LegacyRsvpQuestionSubtype {
  advice = 'advice',
  attendance = 'attendance',
  food = 'food',
  honeymoon = 'honeymoon',
  hotel = 'hotel',
  multipleChoice = 'multipleChoice',
  phone = 'phone',
  song = 'song',
  text = 'text'
}

export enum LegacyRsvpQuestionType {
  multipleChoice = 'multipleChoice',
  plainText = 'plainText'
}

export enum MagicTokenPermissions {
  upload = 'upload',
  view = 'view'
}

export enum MediaCollectionSortField {
  CREATED_AT = 'CREATED_AT',
  TAKEN_AT = 'TAKEN_AT'
}

export enum MediaCollectionSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum ComponentType {
  eventCountdown = 'eventCountdown',
  eventDetails = 'eventDetails',
  eventDisplayName = 'eventDisplayName',
  greetingMessage = 'greetingMessage',
  jsonDataBlob = 'jsonDataBlob',
  mediaGallery = 'mediaGallery',
  photo = 'photo',
  rsvpAndUnlockGuestDetailsButton = 'rsvpAndUnlockGuestDetailsButton',
  text = 'text',
  travelMap = 'travelMap',
  video = 'video'
}

export enum PointOnMapType {
  venue = 'venue'
}

export enum PageContentType {
  default = 'default',
  userGenerated = 'userGenerated'
}

export enum PhotoXPosition {
  center = 'center',
  left = 'left',
  right = 'right'
}

export enum PhotoYPosition {
  bottom = 'bottom',
  center = 'center',
  top = 'top'
}

export enum EventPageVisibility {
  hidden = 'hidden',
  passwordProtected = 'passwordProtected',
  public = 'public'
}

export enum EventPlaceType {
  venue = 'venue'
}

export type RegistryPayoutAccountOnboardingUrlParamsInput = {
  /**
   * Route where user can start onboarding one more time(as it was not possible to load onboardingUrl this time).
   * For example(default value): "/edit/registry/credit-card/setup"
   */
  restartRoute?: InputMaybe<Scalars['String']>;
  /**
   * Route where users should be returned after they either completed onboarding flow or cancelled it.
   * For example(default value): "/edit/registry/manage?setupCreditCard=true"
   */
  returnRoute?: InputMaybe<Scalars['String']>;
};

/** Settings information for an Event */
export enum PrivacyModeType {
  custom = 'custom',
  private = 'private',
  public = 'public'
}

export enum Layout {
  aloha = 'aloha',
  brannan = 'brannan',
  harrison = 'harrison',
  hennepin = 'hennepin'
}

export enum EventWebsiteState {
  draft = 'draft',
  published = 'published'
}

export type EventUsersFilter = {
  types?: InputMaybe<Array<EventType>>;
};

export enum FeedMessagePushNotificationTypeEnum {
  marketing = 'marketing',
  registryItemOrdered = 'registryItemOrdered',
  unknown = 'unknown'
}

export enum FeedMessageStatusEnum {
  read = 'read',
  seen = 'seen',
  unknown = 'unknown',
  unread = 'unread'
}

export enum FeedMessageTargetIdentifierType {
  registryItemId = 'registryItemId',
  unknown = 'unknown',
  url = 'url'
}

export enum FeedMessageTypeEnum {
  email = 'email',
  generic = 'generic',
  pushNotification = 'pushNotification',
  test = 'test',
  unknown = 'unknown'
}

export enum VendorTypeEnum {
  catering = 'catering',
  dessert = 'dessert',
  djs = 'djs',
  florist = 'florist',
  makeup = 'makeup',
  misc = 'misc',
  officiants = 'officiants',
  photo = 'photo',
  planners = 'planners',
  rental = 'rental',
  transport = 'transport',
  venue = 'venue',
  video = 'video'
}

export enum CredentialTypeEnum {
  APPLE = 'APPLE',
  GOOGLE = 'GOOGLE',
  OUTLOOK = 'OUTLOOK'
}

export enum RoleTypeEnum {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  USER = 'USER'
}

export enum MatchStatus {
  connected = 'connected',
  hired = 'hired',
  matched = 'matched',
  saved = 'saved',
  suggested = 'suggested'
}

export enum VendorState {
  alreadyHired = 'alreadyHired',
  interested = 'interested',
  notInterested = 'notInterested',
  started = 'started'
}

export enum MetaTagFilter {
  event = 'event',
  user = 'user',
  vendor = 'vendor'
}

export enum AccommodationCatalogPhotoSubjectType {
  PROPERTY_LOBBY = 'PROPERTY_LOBBY',
  PROPERTY_MAIN_ENTRANCE = 'PROPERTY_MAIN_ENTRANCE',
  PROPERTY_MAIN_PHOTO = 'PROPERTY_MAIN_PHOTO',
  PROPERTY_RESTAURANT = 'PROPERTY_RESTAURANT',
  PROPERTY_UNKNOWN = 'PROPERTY_UNKNOWN',
  ROOM_BATHROOM = 'ROOM_BATHROOM',
  ROOM_BEDS = 'ROOM_BEDS',
  ROOM_UNKNOWN = 'ROOM_UNKNOWN'
}

export enum AccommodationCatalogPropertyType {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa'
}

export type AdminVendorListPayload = {
  count: Scalars['Int'];
};

export type TravelPricingsComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifier: AccommodationCatalogPropertyIdentifierInput;
};

/** A checkIn/checkOut pair of dates (allows for +/- 2 days), like Kayak using range types */
export type AccommodationCatalogStayDatesInput = {
  checkIn: AccommodationCatalogDateRangeInput;
  checkOut: AccommodationCatalogDateRangeInput;
};

/** A inclusive range of dates [low, high]. When low = high or  it mean this objects represents a single date */
export type AccommodationCatalogDateRangeInput = {
  high: Scalars['DateOnlyString'];
  low: Scalars['DateOnlyString'];
};

export type TravelPricingsComparisonMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum DeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET'
}

/** Room occupancy information when searching for offers */
export type AccommodationCatalogUnitsOccupancyInput = {
  /** Details for the number of Adults and Children staying in each room. If size of array is more than unitCount, then the first unitCount entries are considered. If the number of entries is less then some defaults will be assumed */
  occupancies?: InputMaybe<Array<AccommodationCatalogUnitOccupancyInput>>;
  /** The number of rooms needed. */
  unitCount?: Scalars['Int'];
};

/** Room occupancy information when searching for offers on a single unit */
export type AccommodationCatalogUnitOccupancyInput = {
  /** Number of adults who will be staying in this unit */
  adults: Scalars['Int'];
  /** Ages of children who will be staying in this unit, if known, otherwise array of nulls */
  childrenAges: Array<InputMaybe<Scalars['Int']>>;
};

export type TravelPricingsBatchComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export enum AttendanceState {
  ATTENDING = 'ATTENDING',
  MAYBE = 'MAYBE',
  NOT_ATTENDING = 'NOT_ATTENDING',
  PENDING = 'PENDING'
}

export type AutopopulateOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

export enum IdempotentOperationType {
  autoAccommodation = 'autoAccommodation',
  autoStayAreas = 'autoStayAreas',
  generateRecommendations = 'generateRecommendations'
}

export enum AutopopulateJobStatusV5 {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type AutopopulateStayAreaOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

/** Status of a stay area */
export enum StayAreaStatus {
  abandoned = 'abandoned',
  added = 'added',
  pending = 'pending'
}

export type BookingSlotByEmailArgs = {
  bookingTypeHandle?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  vendorHandle?: InputMaybe<Scalars['String']>;
};

export enum BookingTypeLocationType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT'
}

export enum BookingTypeProcessType {
  INSTANT = 'INSTANT',
  REQUEST = 'REQUEST'
}

export enum BookingTypeEventType {
  INPERSON = 'INPERSON',
  PHONECALL = 'PHONECALL',
  VIDEOCALL = 'VIDEOCALL'
}

export enum BookingSlotVenueEventType {
  CORPORATE = 'CORPORATE',
  GALA_NONPROFIT = 'GALA_NONPROFIT',
  INTERNAL = 'INTERNAL',
  OTHER = 'OTHER',
  SOCIAL = 'SOCIAL',
  WEDDING = 'WEDDING'
}

export enum BookingSlotStatusType {
  CONFIRMED = 'CONFIRMED',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type DateFilter = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

/** Input for calculating a cash fund contribution receipt. */
export type CalculateCashFundContributionReceiptInput = {
  cashFundId: Scalars['ID'];
  contributionAmountInMinorUnits: Scalars['Int'];
};

/** We expect it will slowly evolve and start looking like CreateRegistryPurchaseContextInput type */
export type CalculateRegistryPurchaseInfoInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  printOrder?: InputMaybe<PrintOrder>;
};

export type ECard = {
  details?: InputMaybe<Array<ECardDetails>>;
  emailDraftId: Scalars['String'];
  imageURL?: InputMaybe<Scalars['String']>;
  offerType?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  type: Scalars['String'];
};

export type ECardDetails = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RegistryLineItemInput = {
  /**
   * An opaque value provided as result from an earlier API call
   *
   * Initially any non-empty value will trigger an attempt to apply wedding completion discount
   */
  discountCampaign?: InputMaybe<Scalars['String']>;
  /**
   * For the case of standard dropship item - it is a quantity value for line item.
   * For the case of cash fund - it is a way to provide amount which will be given with this purchase in cents. So quantity=100 means $1.
   */
  quantity: Scalars['Int'];
  registryItemId: Scalars['ID'];
};

export type PrintOrder = {
  orderId: Scalars['String'];
};

export enum HandleStatus {
  available = 'available',
  unavailable = 'unavailable'
}

export enum InvalidTransitionalRegistryUrlReasonCode {
  invalidRegistryUrl = 'invalidRegistryUrl',
  registryIsPrivate = 'registryIsPrivate',
  registryUnavailable = 'registryUnavailable',
  unsupportedDomain = 'unsupportedDomain'
}

export type ProductHeuristicSearchInput = {
  lines: Array<ProductHeuristicSearchInput_Line>;
  shippingAddress: ProductHeuristicSearchInput_ShippingAddress;
};

export type ProductHeuristicSearchInput_Line = {
  productInfo: ProductHeuristicSearchInput_Line_ProductInfo;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductHeuristicSearchInput_Line_ProductInfo = {
  externalUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductHeuristicSearchInput_Price>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProductHeuristicSearchInput_Price = {
  currencyCode: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
};

export type ProductHeuristicSearchInput_ShippingAddress = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};

/**
 * A strategy by which the Client may present Attribute Values to the user for selection.
 *
 * Each is a combination of short-codes.
 *
 * eg. 'image', 'Carousel', 'Multi' =
 *   "Display a Carousel of images from which the User can make multiple selections."
 */
export enum ProductCatalogAttributeSelectionType {
  colorListMulti = 'colorListMulti',
  imageListMulti = 'imageListMulti',
  priceBucket = 'priceBucket',
  priceRange = 'priceRange',
  /** aka. 'titleListMulti' */
  stringListMulti = 'stringListMulti'
}

/**
 * The field within an Attribute Value to be used for presentation by the Client.
 *
 * This Type is similar to GroupDimensionSwatchType.
 */
export enum ProductCatalogAttributeValueType {
  /** The Value should be presented as a swatch of its color hex value */
  color = 'color',
  /** The Value should be presented using its image URL */
  image = 'image',
  price = 'price',
  /** The Value should be presented as a string of text (usually its title) */
  title = 'title'
}

export enum ProductCatalogCollectionType {
  brand = 'brand',
  productFamily = 'productFamily',
  relatedProducts = 'relatedProducts'
}

export enum ProductCatalogDisplayType {
  carousel = 'carousel'
}

export enum ProductCatalogCurationSource {
  expert = 'expert',
  joy = 'joy'
}

export enum PDPSectionType {
  details = 'details',
  gallery = 'gallery',
  highlight = 'highlight',
  productAction = 'productAction',
  productFamilyCollections = 'productFamilyCollections',
  relatedProductCollections = 'relatedProductCollections'
}

/**
 * Supported Dimension swatch types
 * A "swatch" is a visual element representing a Dimension Option; usually it is selectable
 *
 * This Type is similar to ProductCatalogAttributeValueType.
 */
export enum GroupDimensionSwatchType {
  color = 'color',
  image = 'image',
  none = 'none'
}

export enum ProductCatalogAssetType {
  photo = 'photo',
  video = 'video'
}

/** Different types of catalog item tree roots */
export enum CatalogTreeRootInput {
  curations = 'curations',
  /** The default department, category, sub-category hierarchy */
  default = 'default',
  registryStoreRecommendations = 'registryStoreRecommendations'
}

export enum PDPElementType {
  body = 'body',
  heading = 'heading',
  photo = 'photo',
  sectionHeader = 'sectionHeader'
}

export type RatingReviewQueryInput = {
  orderBy?: InputMaybe<RatingReviewOrderBy>;
};

export enum RatingReviewOrderBy {
  newest = 'newest',
  oldest = 'oldest',
  ratingAsc = 'ratingAsc',
  ratingDesc = 'ratingDesc'
}

export enum RatingReviewAssetType {
  photo = 'photo',
  video = 'video'
}

/**
 * The 'Storefront Status' indicates how Merch wants a Catalog Item to behave
 * RE: whether it can be purchased, added to a Registry, found in a search result, etc.
 */
export enum ProductCatalogStorefrontStatus {
  /** This Catalog Item is fully available for search, add-to-Registry, and purchase. */
  available = 'available',
  /** This Catalog Item has a long out-of-stock window, and cannot be purchased today. */
  backordered = 'backordered',
  /** This Catalog Item cannot be purchased today, but can be added to a Registry anticipating future inventory. */
  comingSoon = 'comingSoon',
  /** This Catalog Item can no longer be added to a Registry, but can be purchased if previously added. */
  delisted = 'delisted',
  /** This Catalog Item is no longer available, as a permanent state. */
  discontinued = 'discontinued'
}

export enum ProductCatalogItemTilePresentationType {
  childDetails = 'childDetails',
  parentDetails = 'parentDetails'
}

export type ContactQuarantinedMessageBatchFilter = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  messageBatchId?: InputMaybe<Scalars['ID']>;
  messageBatchType?: InputMaybe<Scalars['String']>;
  quarantineStatus?: InputMaybe<QuarantineStatus>;
};

export enum QuarantineStatus {
  approved = 'approved',
  canceled = 'canceled',
  rejected = 'rejected',
  review = 'review'
}

export type ContactQuarantinedMessageBatchSort = {
  createdAt?: InputMaybe<FilterDirection>;
};

export enum FilterDirection {
  asc = 'asc',
  desc = 'desc'
}

export type GetDesignGuestSiteTargetPayload = {
  layout: DesignLayoutType;
  themeId: Scalars['String'];
};

export type EventTypesByCategoryFilters = {
  category?: InputMaybe<Array<Scalars['String']>>;
  categorySubtype?: InputMaybe<Array<Scalars['String']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['String']>>;
};

export type EventVipsPayload = {
  eventId: Scalars['ID'];
};

export type CashFundsPayoutAccountOnboardingUrlParams = {
  /** Route where user can start onboarding one more time (as it was not possible to load onboardingUrl this time). */
  restartRoute?: InputMaybe<Scalars['String']>;
  /** Route where users should be returned after they either completed onboarding flow or canceled it. */
  returnRoute?: InputMaybe<Scalars['String']>;
};

export type FindDefaultThingsToDoPagePayload = {
  eventId: Scalars['ID'];
};

export type EmailSearchCriteria = {
  emailType?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmail?: InputMaybe<Scalars['String']>;
};

export type FindHotelMatchRateInput = {
  adults: Scalars['Float'];
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  currencyISO4217: Scalars['String'];
  guestNationalityISO2: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsPayload = {
  eventId?: InputMaybe<Scalars['String']>;
  hotelDetails: AccommodationCatalogPropertyDetailsPayload;
  metadata?: InputMaybe<FindMatchingAccommodationCatalogPropertiesByDetailsMetadata>;
};

export type AccommodationCatalogPropertyDetailsPayload = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type FindMatchingAccommodationCatalogPropertyPayload = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

/** AccommodationPlaceSourceType */
export enum AccommodationPlaceSourceType {
  google = 'google',
  joyPlace = 'joyPlace',
  nuitee = 'nuitee',
  zh = 'zh'
}

export type FormAnswerFilters = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  formId?: InputMaybe<Scalars['ID']>;
  guestKey?: InputMaybe<Scalars['String']>;
};

/**
 * State of a ticket type - controls whether tickets can be purchased.
 * Designed for extensibility (future states can be added).
 */
export enum TicketTypeState {
  /** Available for purchase (subject to capacity/dates) */
  ACTIVE = 'ACTIVE',
  /** Not available for purchase (hidden or paused) */
  INACTIVE = 'INACTIVE'
}

export enum FormType {
  OTHER = 'OTHER',
  REGISTRATION = 'REGISTRATION',
  SURVEY = 'SURVEY'
}

export type FormFilters = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type FormTemplateFilters = {
  eventCategoryTags?: InputMaybe<Array<Scalars['String']>>;
  eventSubTypeTags?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCashFundForContributionInput = {
  cashFundId: Scalars['ID'];
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /** Links a specific Invite to the Contribution. */
  inviteToken?: InputMaybe<Scalars['String']>;
};

export enum CollaborationInviteState {
  accepted = 'accepted',
  pending = 'pending',
  revoked = 'revoked'
}

export enum EcardType {
  changethedate = 'changethedate',
  custom = 'custom',
  invitation = 'invitation',
  savethedate = 'savethedate',
  savethedatephoto = 'savethedatephoto'
}

export type EventSearchCriteria = {
  coupleNames?: InputMaybe<Scalars['String']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  includeAllPastEvents?: InputMaybe<Scalars['Boolean']>;
};

export type GuestListMemberSort = {
  direction: SortDirection;
  field: GuestListMemberSortField;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum GuestListMemberSortField {
  ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
  ADDRESS_LINE_2 = 'ADDRESS_LINE_2',
  ATTENDANCE_STATUS = 'ATTENDANCE_STATUS',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  DISPLAY_NAME = 'DISPLAY_NAME',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  STATE = 'STATE',
  ZIP = 'ZIP'
}

export type MessageRelationshipCriteria = {
  externalMessageIds: Array<Scalars['String']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

/**
 * Messaging tier for an event. Determines which messaging features are enabled.
 * - basic: Free tier, email-only messaging (equivalent to null for backwards compatibility)
 * - messagingPlus: Paid tier, enables SMS messaging in addition to email
 */
export enum MessagingTier {
  basic = 'basic',
  messagingPlus = 'messagingPlus'
}

export enum PhoneNumberDeliveryMethod {
  sms = 'sms'
}

export enum PostOfficeMessageType {
  generic = 'generic',
  giftWrap = 'giftWrap',
  greetingCard = 'greetingCard',
  reminder = 'reminder',
  thankyou = 'thankyou'
}

export enum RegistryStoreConnectAction {
  link = 'link',
  sync = 'sync',
  transfer = 'transfer'
}

export type ImageSizingCriteria = {
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  pixelRatio?: InputMaybe<Scalars['Int']>;
};

export type GetThingsToDoContainersPayload = {
  eventId: Scalars['ID'];
};

export type GoogleCalendarLinkStateInput = {
  referrerUri: Scalars['String'];
  vendorUserId: Scalars['ID'];
};

export type HotelInventoryByIdsRequest = {
  hotelIds: Array<Scalars['String']>;
  metadata?: InputMaybe<HotelInventoryByIdsRequestMetadata>;
};

export type HotelInventoryByIdsRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum HotelTypeEnum {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa'
}

export type HotelInventoryByRadiusRequest = {
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  radiusInKM: Scalars['Float'];
};

export enum HotelInventorySearchType {
  ALL = 'ALL'
}

export type HotelInventoryByRadiusRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type HotelRoomsAndRatesRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelId: Scalars['String'];
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
};

export type HotelRoomsAndRatesRequestOccupancy = {
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
  numOfAdults: Scalars['Int'];
};

export type HotelRoomsAndRatesByLocationRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
  radiusInKM: Scalars['Float'];
};

export type HotelSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  metadata?: InputMaybe<HotelInventoryRequestMetadata>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
};

export type HotelInventoryRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ImproveTextInput = {
  /** The type of improvement to apply */
  action: TextImprovementAction;
  /** The context in which the text will be used */
  context: TextContext;
  /** Custom instructions for NEW_DRAFT and MANUAL actions */
  customInstructions?: InputMaybe<Scalars['String']>;
  /** The event ID for which this text improvement is being requested */
  eventId: Scalars['String'];
  /** Additional metadata for text improvement */
  metadata?: InputMaybe<TextImprovementMetadata>;
  /** The raw text to improve */
  rawText: Scalars['String'];
};

/** The type of text improvement to apply */
export enum TextImprovementAction {
  CONCISE = 'CONCISE',
  EXPAND = 'EXPAND',
  FRIENDLY = 'FRIENDLY',
  MANUAL = 'MANUAL',
  NEW_DRAFT = 'NEW_DRAFT',
  PROFESSIONAL = 'PROFESSIONAL',
  PROOFREAD = 'PROOFREAD',
  REWRITE = 'REWRITE',
  SIMPLIFY = 'SIMPLIFY'
}

/** The context in which the text will be used */
export enum TextContext {
  EMAIL_EVENT_HOST_TO_GUESTS = 'EMAIL_EVENT_HOST_TO_GUESTS',
  EMAIL_TO_GUESTS = 'EMAIL_TO_GUESTS',
  GENERAL = 'GENERAL',
  INVITATION_MESSAGE = 'INVITATION_MESSAGE',
  THANK_YOU_NOTE = 'THANK_YOU_NOTE',
  WEBSITE_COMPONENT = 'WEBSITE_COMPONENT'
}

export type TextImprovementMetadata = {
  /** Expected output format (html, markdown, or plaintext) */
  format?: InputMaybe<Scalars['String']>;
  /** Locale for language-specific improvements (e.g., "en-US", "es-ES") */
  locale?: InputMaybe<Scalars['String']>;
};

export type InsightRagQueryInput = {
  query: Scalars['String'];
};

export type InternalEventSearchCriteria = {
  dateCriteria?: InputMaybe<EventSearchDateCriteria>;
  eventTypes?: InputMaybe<Array<EventType>>;
};

export type EventSearchDateCriteria = {
  endDate?: InputMaybe<Scalars['String']>;
  searchField: EventSearchDateType;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum EventSearchDateType {
  createAt = 'createAt',
  eventDate = 'eventDate'
}

/**
 * Search criteria for internal message queries.
 * Supports filtering by recipient, event, message batch, and date range.
 */
export type InternalMessageSearchCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export enum MessageType {
  email = 'email',
  sms = 'sms'
}

export type IsPageContainerSlugAvailablePayload = {
  eventId: Scalars['ID'];
  pageSlug: Scalars['String'];
};

export type JoyPlaceBySourceIdRequest = {
  /** The `eventId` argument is deprecated. Use the `externalPDP` field with the appropriate alternative approach instead. */
  eventId?: InputMaybe<Scalars['ID']>;
  sourceId: Scalars['String'];
  sourceType: Scalars['String'];
};

export type JoyPlacesBySourceIdsRequest = {
  sourceIds: Array<Scalars['String']>;
  sourceType: Scalars['String'];
};

export type JsonDataContainerByIdPayload = {
  id: Scalars['ID'];
};

export type LinkRedirectBlockFilter = {
  blockType?: InputMaybe<BlockType>;
  id?: InputMaybe<Scalars['ID']>;
  targetValue?: InputMaybe<Scalars['String']>;
};

export enum BlockType {
  domain = 'domain',
  event = 'event',
  user = 'user'
}

export type LinkRedirectFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  joyUrl?: InputMaybe<Scalars['Url']>;
  link?: InputMaybe<Scalars['String']>;
  quarantined?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type LocationSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
  types?: InputMaybe<Array<LocationSuggestionType>>;
};

export enum LocationSuggestionType {
  Airport = 'Airport',
  BusStation = 'BusStation',
  City = 'City',
  Country = 'Country',
  Hotel = 'Hotel',
  MultiCity = 'MultiCity',
  Neighborhood = 'Neighborhood',
  PointOfInterest = 'PointOfInterest',
  Region = 'Region',
  State = 'State',
  TrainStation = 'TrainStation'
}

export type MessageSearchQueryCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export enum MessageStatus {
  delivered = 'delivered',
  failed = 'failed',
  none = 'none',
  pending = 'pending',
  read = 'read',
  sent = 'sent'
}

export enum MilestonesActivityAction {
  assignee_changed = 'assignee_changed',
  attachment_added = 'attachment_added',
  attachment_removed = 'attachment_removed',
  comment_added = 'comment_added',
  dependency_added = 'dependency_added',
  dependency_removed = 'dependency_removed',
  export_completed = 'export_completed',
  import_completed = 'import_completed',
  import_started = 'import_started',
  milestone_created = 'milestone_created',
  milestone_deleted = 'milestone_deleted',
  milestone_updated = 'milestone_updated',
  phase_changed = 'phase_changed',
  status_changed = 'status_changed'
}

export type MilestonesFilterInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<MilestoneCategory>>;
  categoryId?: InputMaybe<Array<Scalars['ID']>>;
  dueAfter?: InputMaybe<Scalars['Timestamp']>;
  dueBefore?: InputMaybe<Scalars['Timestamp']>;
  phaseId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<MilestoneStatus>>;
};

export enum MilestoneCategory {
  accommodations = 'accommodations',
  analytics = 'analytics',
  connectivity = 'connectivity',
  expo = 'expo',
  finance = 'finance',
  governance = 'governance',
  hackathon = 'hackathon',
  logistics = 'logistics',
  operations = 'operations',
  procurement = 'procurement',
  production = 'production',
  program = 'program',
  protocol = 'protocol',
  registration = 'registration',
  schedule = 'schedule',
  security = 'security',
  speakers = 'speakers',
  sponsorship = 'sponsorship',
  venue = 'venue',
  website = 'website'
}

export enum MilestoneStatus {
  at_risk = 'at_risk',
  done = 'done',
  in_progress = 'in_progress',
  not_started = 'not_started'
}

export enum MilestonesImportExportFormat {
  csv = 'csv',
  ms_project_xml = 'ms_project_xml',
  xlsx = 'xlsx'
}

export enum MilestonesImportErrorSeverity {
  error = 'error',
  warning = 'warning'
}

export enum MilestonesImportOperation {
  create = 'create',
  skip = 'skip',
  update = 'update'
}

export enum MilestonesImportJobStatus {
  cancelled = 'cancelled',
  completed = 'completed',
  executing = 'executing',
  failed = 'failed',
  parsing = 'parsing',
  pending = 'pending',
  preview_ready = 'preview_ready'
}

export enum MilestoneGroupField {
  assignee = 'assignee',
  category = 'category',
  phase = 'phase',
  status = 'status'
}

export type MilestonesPaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type MilestonesSortInput = {
  direction: MilestonesSortDirection;
  field: MilestonesSortField;
};

export enum MilestonesSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum MilestonesSortField {
  assigneeName = 'assigneeName',
  category = 'category',
  createdAt = 'createdAt',
  dueDate = 'dueDate',
  name = 'name',
  phaseSortOrder = 'phaseSortOrder',
  sortOrder = 'sortOrder',
  status = 'status'
}

export type NearbyAttractionsSearchPayload = {
  metadata: NearbyAttractionsSearchMetadata;
  point: TravelInputPoint;
};

export type NearbyAttractionsSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type TravelInputPoint = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<TravelGeoLocation>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
  pointType: TravelInputPointType;
};

export type TravelGeoLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum TravelInputPointType {
  accommodationPlace = 'accommodationPlace',
  geoLocation = 'geoLocation',
  joyPlace = 'joyPlace'
}

export enum CheckoutType {
  STRIPE_NATIVE = 'STRIPE_NATIVE',
  VAULTERA_VAULT = 'VAULTERA_VAULT'
}

export enum SwitchNames {
  nuitee = 'nuitee',
  zh = 'zh'
}

/**
 * Order lifecycle states - determines how tickets are counted in TicketType.
 *
 * **RESERVED states** (tickets held, count towards reservedCount):
 * - PENDING_PAYMENT: Awaiting payment confirmation
 * - PENDING_APPROVAL: Awaiting manual approval (e.g., for comped tickets)
 *
 * **SOLD state** (tickets confirmed, count towards soldCount):
 * - COMPLETED: Payment confirmed, tickets issued
 *
 * **RELEASED states** (tickets returned to availability pool):
 * - CANCELLED: Order cancelled by user or admin
 * - EXPIRED: Payment window expired
 * - REFUNDED: Payment refunded
 */
export enum OrderStatus {
  /** Released: Order cancelled by user or admin */
  CANCELLED = 'CANCELLED',
  /** Sold: Payment confirmed, tickets issued */
  COMPLETED = 'COMPLETED',
  /** Released: Payment window expired */
  EXPIRED = 'EXPIRED',
  /** Reserved: Awaiting manual approval (e.g., comped tickets) */
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  /** Reserved: Awaiting payment confirmation */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  /** Released: Payment refunded */
  REFUNDED = 'REFUNDED'
}

/** Status of a ticket. */
export enum TicketStatus {
  CANCELLED = 'CANCELLED',
  CHECKED_IN = 'CHECKED_IN',
  VALID = 'VALID'
}

/** Type of order based on payment requirements. */
export enum OrderType {
  COMPED = 'COMPED',
  FREE = 'FREE',
  PAID = 'PAID'
}

export type OutlookCalendarLinkStateInput = {
  referrerUri: Scalars['String'];
  vendorUserId: Scalars['ID'];
};

export type PageContainerBySlugOptions = {
  /** View from the Admin Perspective */
  admin?: InputMaybe<Scalars['Boolean']>;
};

export type PageContainerBySlugPayload = {
  eventName: Scalars['String'];
  pageSlug: Scalars['String'];
};

export type PhotosBySimpleTagsPayload = {
  exclude?: InputMaybe<Array<Scalars['String']>>;
  include: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type GuestNotFoundArgs = {
  buttonLink: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  source?: InputMaybe<Scalars['String']>;
};

export type EmailPerson = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type MessageToHostArgs = {
  guest: EmailPerson;
  message: Scalars['String'];
  recipient: EmailPerson;
};

export type RequestCodeArgs = {
  code: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  website: Scalars['String'];
};

export type TravelPricingsForAccommodationByRegionPayload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** AccommodationSearchType */
export enum AccommodationSearchType {
  ALL = 'ALL'
}

export type TravelPricingsForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** Different ways to give a search region, only one of the fields should be non-null */
export type AccommodationCatalogRegionInput = {
  circular?: InputMaybe<AccommodationCatalogRegionCircularInput>;
};

/** Circular regions input (latitude and longitude) */
export type AccommodationCatalogRegionCircularInput = {
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
  /** radius in KM */
  radius: Scalars['Int'];
};

export enum FeeType {
  payment_processing_fee = 'payment_processing_fee'
}

export type TravelPricingsForAccommodationByRegionV20250708Payload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  executionSpeed?: InputMaybe<ExecutionSpeed>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionV20250708PayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** Execution speed of the query, SLOW = 15s, NORMAL = 10s, FAST = 6s, FASTEST = 3s */
export enum ExecutionSpeed {
  FAST = 'FAST',
  FASTEST = 'FASTEST',
  NORMAL = 'NORMAL',
  SLOW = 'SLOW'
}

export type TravelPricingsForAccommodationByRegionV20250708PayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ProductCatalogBrandsDirectoryQueryInput = {
  /** the category locator */
  category?: InputMaybe<Scalars['String']>;
  /** filter by storefront */
  storefront?: InputMaybe<CatalogStorefront>;
  /**
   * The category URL which ends with the category locator.
   * ie; /shop/brands/:CATEGORY_LOCATOR
   */
  url?: InputMaybe<Scalars['String']>;
};

export enum CatalogStorefront {
  baby = 'baby',
  wedding = 'wedding'
}

/** Reference to a ProductCatalogDisplayInfo, which doesn't have an ID and must be referenced by its displayInfoId and pdpSectionType */
export type ProductCatalogDisplayInfoRef = {
  displayInfoId: Scalars['ID'];
  pdpSectionType: Scalars['String'];
};

export type ProductCatalogItemRecommendationInput = {
  productUrl: Scalars['String'];
};

/** The order that input fields are evaluated is undefined and subject to change in the future */
export type ProductCatalogSearchQueryInput = {
  brandId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Payload for Filter, Search & Sort (FSS) criteria */
  filters?: InputMaybe<ProductCatalogSearchQueryFiltersInput>;
  /**
   * A Category or Item Locator.
   * Other types of Locators (eg. Brand) are not supported by the search logic.
   * NOTE:  A Curation is considered a Category.
   */
  locator?: InputMaybe<Scalars['String']>;
  /**
   * Criteria for sorting.
   * If null, the default is the first value in the 'ProductCatalogSearchQueryOrderBy' enum.
   */
  orderBy?: InputMaybe<ProductCatalogSearchQueryOrderBy>;
  type?: InputMaybe<CatalogTreeRootInput>;
  /**
   * A site URL.
   * The search logic supports URLs for Category, Item, Brand (since they can be differentiated by path structure)
   */
  url?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter, Search & Sort (FSS) */
export type ProductCatalogSearchQueryFiltersInput = {
  /**
   * Criteria for Filter by Attributes.
   *
   * Each Selection Group in the input is AND-ed into the resulting query.
   * Example: ('brand:kitchenaid' AND 'color:red'):
   *
   * filterSelectionGroups: [
   *   [ { groupCode: "brand", valueCodes: [ "kitchenaid" ] } ]
   *   [ { groupCode: "color", valueCodes: [ "red" ] } ]
   * ]
   */
  filterSelectionGroups?: InputMaybe<Array<ProductCatalogSearchQueryFiltersSelectionGroupInput>>;
  /** Criteria for full-text Search */
  queryText?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter by Attributes (part of FSS) */
export type ProductCatalogSearchQueryFiltersSelectionGroupInput = {
  /** A unique Attribute Group code */
  groupCode: Scalars['String'];
  /** OR */
  priceRange?: InputMaybe<ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput>;
  /**
   * One or more unique Attribute Value codes.
   *
   * Each Attribute Value in the input is OR-ed into the resulting query.
   * Example: ('size:small' OR 'size:medium'):
   *
   * {
   *   groupCode: "size",
   *   valueCodes: [ "small", "medium" ]
   * }
   */
  valueCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput = {
  maxValueInMinorUnits?: InputMaybe<Scalars['Int']>;
  minValueInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Possible sorting options.
 * Client should display the enum values in the same order.
 */
export enum ProductCatalogSearchQueryOrderBy {
  featured = 'featured',
  newArrivals = 'newArrivals',
  priceAsc = 'priceAsc',
  priceDesc = 'priceDesc'
}

export type ProductExternalSearchQueryInput = {
  text: Scalars['String'];
};

export type ProductHeroContentInputCriteria = {
  storefront?: InputMaybe<CatalogStorefront>;
};

export enum ProductHeroRedirectUrlType {
  external = 'external',
  inApp = 'inApp'
}

export enum ProductHeroGradientMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light',
  none = 'none'
}

export enum ProductHeroHorizontalAlignment {
  center = 'center',
  left = 'left',
  right = 'right'
}

export enum ProductHeroTextColorMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light'
}

export type ProductInventoryByCatalogItemIdInput = {
  catalogItemId: Scalars['ID'];
  reasonCode?: InputMaybe<InventoryCheckReasonCode>;
};

export enum InventoryCheckReasonCode {
  buyForSelfAvailability = 'buyForSelfAvailability',
  checkoutMechanismsRequest = 'checkoutMechanismsRequest',
  completionDiscount = 'completionDiscount',
  productInventoryRequest = 'productInventoryRequest',
  salesOrderCreation = 'salesOrderCreation',
  salesOrderFulfillment = 'salesOrderFulfillment'
}

/** @Deprecated */
export type ProductUniversalSearchQueryInput = {
  text: Scalars['String'];
};

/** Specifies how many results to return for a given source. */
export type ProductUniversalSearchSourceLimit = {
  /** Maximum number of results for a given source. */
  limit: Scalars['Int'];
  source: ProductUniversalItemSource;
};

export enum ProductUniversalItemSource {
  catalogSearch = 'catalogSearch',
  googleSearch = 'googleSearch',
  googleShoppingRegular = 'googleShoppingRegular',
  googleShoppingSponsored = 'googleShoppingSponsored'
}

export type RecentTravelReservationsByEventPayload = {
  eventId: Scalars['String'];
};

export type RegistryCatalogInventoryInput = {
  catalogItemId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
};

export type AccommodationContentSearchInput = {
  circularRegionSearch?: InputMaybe<AccommodationCatalogRegionCircularInput>;
  maxResults?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<AccommodationContentSearchInputMetadata>;
  propertyIdentifiers?: InputMaybe<Array<AccommodationCatalogPropertyIdentifierInput>>;
};

export type AccommodationContentSearchInputMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferVendor. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location: ExtendedAccommodationCatalogSearchLocation;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  radiusKM?: InputMaybe<Scalars['Float']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates: AccommodationCatalogStayDatesInput;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

/** Strategy for fetching accommodation content from cache vs vendor API */
export enum FetchStrategy {
  CACHE_ONLY = 'CACHE_ONLY',
  PREFER_CACHE = 'PREFER_CACHE',
  PREFER_VENDOR = 'PREFER_VENDOR'
}

export type ExtendedAccommodationCatalogSearchLocation = {
  /** Context of the location */
  context?: InputMaybe<ExtendedAccommodationCatalogSearchLocationContext>;
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
};

export type ExtendedAccommodationCatalogSearchLocationContext = {
  /** Google Place ID of the location */
  googlePlaceId?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  preferredProviderType?: InputMaybe<PreferredHotelProviderType>;
  priceComparisonPayload?: InputMaybe<PriceComparisonPayload>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** PreferredHotelProviderType */
export enum PreferredHotelProviderType {
  hotels = 'hotels',
  joynativecheckout = 'joynativecheckout',
  stays = 'stays'
}

export type PriceComparisonPayload = {
  comparisonType?: InputMaybe<PriceComparisonType>;
  metadata?: InputMaybe<PriceComparisonPayloadMetaData>;
  preferredProvider?: InputMaybe<PreferredHotelProviderType>;
  preferredProviderPriceMaxExtraPercent?: InputMaybe<Scalars['Float']>;
};

/** PriceComparisonType */
export enum PriceComparisonType {
  basePrice = 'basePrice',
  perNightBasePrice = 'perNightBasePrice',
  perNightTotalPrice = 'perNightTotalPrice',
  totalPrice = 'totalPrice'
}

export type PriceComparisonPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum ScoringPriorityField {
  distanceFromSearchLocation = 'distanceFromSearchLocation',
  price = 'price',
  standardRoomPriceDiscountPercent = 'standardRoomPriceDiscountPercent',
  starRating = 'starRating',
  usedByEventsCount = 'usedByEventsCount',
  userRating = 'userRating'
}

export type SearchExtendedAccommodationPropertiesV2Payload = {
  customSearchParams?: InputMaybe<SearchExtendedAccommodationPropertiesV2CustomSearchParams>;
  eventHandle: Scalars['String'];
};

export type SearchExtendedAccommodationPropertiesV2CustomSearchParams = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferCache. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. If not provided, defaults to false in code */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<ExtendedAccommodationCatalogSearchLocation>;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  radiusKM?: InputMaybe<Scalars['Int']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates?: InputMaybe<AccommodationCatalogStayDatesInput>;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceTagSearch = {
  tagName: Scalars['String'];
};

export type SearchPayload = {
  type?: InputMaybe<VendorTypeEnum>;
};

export type SearchTravelOfferReservationsPayload = {
  bookingId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferReservationRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable'
}

export enum TravelReservationGuestAgeClassification {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}

export enum TravelReservationGuestTitle {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS'
}

export enum TravelOfferReservationStatus {
  cancelled = 'cancelled',
  draft = 'draft',
  failed = 'failed',
  processing = 'processing',
  submitted = 'submitted',
  success = 'success'
}

export type GetStationeryDigitalViewInput = {
  cardId?: InputMaybe<Scalars['String']>;
  personIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum StationeryDigitalViewSource {
  copy = 'copy',
  email = 'email',
  link = 'link',
  none = 'none',
  sms = 'sms',
  whatsapp = 'whatsapp'
}

export enum StationeryDraftFormat {
  digital = 'digital',
  print = 'print'
}

export enum StationeryPrintOrderVendorEnum {
  joy_digital = 'joy_digital',
  joy_messaging_plus = 'joy_messaging_plus',
  paperlust = 'paperlust',
  taylor = 'taylor',
  taylor_mm = 'taylor_mm'
}

export enum StationeryTemplateCategoryEnum {
  enclosure = 'enclosure',
  holiday = 'holiday',
  invitation = 'invitation',
  menu = 'menu',
  monogram = 'monogram',
  napkin = 'napkin',
  saveTheDate = 'saveTheDate',
  sign = 'sign',
  thankYou = 'thankYou'
}

export type StationeryDraftsByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryPreviewInput = {
  content: Scalars['JSON'];
  density?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<StationeryImageFormatEnum>;
  layout: StationeryLayout;
  quality?: InputMaybe<Scalars['Float']>;
};

export enum StationeryImageFormatEnum {
  jpg = 'jpg',
  png = 'png'
}

export type StationeryLayout = {
  cutMargin: Scalars['Float'];
  height: Scalars['Float'];
  safeZoneMargin: Scalars['Float'];
  width: Scalars['Float'];
};

export enum StationeryPrintOrderStatusEnum {
  canceled = 'canceled',
  complete = 'complete',
  delivered = 'delivered',
  error = 'error',
  init = 'init',
  inProgress = 'inProgress',
  paid = 'paid',
  paused = 'paused',
  queued = 'queued',
  readyToShip = 'readyToShip',
  refunded = 'refunded',
  sent = 'sent',
  shipped = 'shipped'
}

export enum StationeryPrintOrderDeliveryMethodEnum {
  express = 'express',
  free = 'free',
  mail_innovations_expedited_parcel = 'mail_innovations_expedited_parcel',
  mail_innovations_standard_flat = 'mail_innovations_standard_flat',
  standard = 'standard',
  /** The same as `ups_express_saver` but more readable. */
  ups_canada_express_saver = 'ups_canada_express_saver',
  ups_express_saver = 'ups_express_saver',
  ups_ground_canada_standard = 'ups_ground_canada_standard',
  ups_international_express_saver = 'ups_international_express_saver',
  usps_international_first_class = 'usps_international_first_class'
}

export enum StationeryPrintOrderIssueTarget {
  cx = 'cx',
  user = 'user'
}

export enum StationeryPrintOrderIssueType {
  quality_control = 'quality_control',
  recipient_address_incomplete = 'recipient_address_incomplete'
}

export enum StationeryPrintOrderStateEnum {
  canceled = 'canceled',
  valid = 'valid'
}

export type StationeryPrintOrdersFiltersInput = {
  category?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['ID']>;
  eventName?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<StationeryPrintOrdersOrderByFields>;
  ownerId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<StationeryPrintOrderStatusEnum>;
  statusList?: InputMaybe<Array<StationeryPrintOrderStatusEnum>>;
  type?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrdersOrderByFields = {
  direction?: InputMaybe<StationeryPrintOrdersOrderByDirection>;
  field?: InputMaybe<StationeryPrintOrdersOrderByField>;
};

export enum StationeryPrintOrdersOrderByDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum StationeryPrintOrdersOrderByField {
  createdAt = 'createdAt',
  currentStatus = 'currentStatus'
}

export type StationeryPrintOrdersPaginationInput = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type StationeryPrintOrdersByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryTemplateFilter = {
  approved?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the categories. */
  categories?: InputMaybe<Array<StationeryTemplateCategoryEnum>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the eventIdsFavorites. */
  eventIdsFavorites?: InputMaybe<Array<Scalars['ID']>>;
  heightInches?: InputMaybe<Scalars['Float']>;
  ownerIdFavorites?: InputMaybe<Scalars['ID']>;
  side?: InputMaybe<Scalars['String']>;
  /** Performs "OR" operation on the tags. */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Performs "OR" operation on the themeIds. */
  themeIds?: InputMaybe<Array<Scalars['ID']>>;
  widthInches?: InputMaybe<Scalars['Float']>;
};

/**
 * Favorites can not only be created in single user-scope, but also in event-scope.
 * That option allows for fine-grained control on: "how to derive the information about my favorites."
 * e.g. I want to look at all templates, but only show favorites that I have personally added to favorites (vs. the whole event / or in many events).
 */
export type StationeryTemplateIncludeOptions = {
  includeFavoritesByEventIds?: InputMaybe<Array<Scalars['ID']>>;
  includeFavoritesByOwnerId?: InputMaybe<Scalars['ID']>;
  includeProducts?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryTemplateOrderBy = {
  direction: StationeryTemplateOrderDirection;
  field: StationeryTemplateOrderField;
};

export enum StationeryTemplateOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum StationeryTemplateOrderField {
  MY_FAVORITES = 'MY_FAVORITES'
}

export type SuggestedVendorPayload = {
  count: Scalars['Int'];
  idsToExclude?: InputMaybe<Array<Scalars['ID']>>;
};

export type SuggestionGroupByVendorTypePayload = {
  vendorType: VendorTypeEnum;
};

export type SyntheticCollectionByIdsPayload = {
  collectionIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type SyntheticCollectionByNamesPayload = {
  name: Scalars['String'];
  names: Array<Scalars['String']>;
};

export enum AiModelVersion {
  gpt35turboInstruct = 'gpt35turboInstruct',
  /** @deprecated No longer supported */
  textDavinci003 = 'textDavinci003'
}

export type PayloadStrings = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum PromptType {
  LoveStoryForWeddingWebsite = 'LoveStoryForWeddingWebsite',
  PoliteDeclineToAnInvitation = 'PoliteDeclineToAnInvitation',
  RegistryGiftSuggestions = 'RegistryGiftSuggestions',
  ThankYouNote = 'ThankYouNote',
  WeddingHashtagIdeas = 'WeddingHashtagIdeas',
  WeddingToastSpeech = 'WeddingToastSpeech',
  WeddingVows = 'WeddingVows'
}

export enum TransitionalRegistryStatus {
  failed = 'failed',
  inProgress = 'inProgress',
  ready = 'ready'
}

export type TravelDistancesBetweenPointsPayload = {
  endingPoint: TravelInputPoint;
  startingPoint: TravelInputPoint;
};

export type TravelDistancesFromOriginPayload = {
  destinations: Array<TravelInputPoint>;
  origin: TravelInputPoint;
};

export type TravelOfferFromOfferTokenParams = {
  locale?: InputMaybe<Scalars['String']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferDistributionType {
  Corporate = 'Corporate',
  Distribution = 'Distribution',
  Member = 'Member',
  Unknown = 'Unknown'
}

export enum TravelOfferRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable'
}

export type TravelOffersForAccommodationByRegionPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelOffersForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  /** default pagination: { limit: 20, offset: 0 } */
  pagination?: InputMaybe<Pagination>;
  region: AccommodationCatalogRegionInput;
};

export type TravelOffersForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type Pagination = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type TravelOffersForAccommodationForPropertiesPayload = {
  anonymousId?: InputMaybe<Scalars['String']>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: Scalars['String'];
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  offerProvider?: InputMaybe<TravelOfferProvider>;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferProvider {
  nuitee = 'nuitee',
  zh = 'zh'
}

export type TravelPlacePricingAndBookingDetailsPayload = {
  accommodationPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  currencyCode: TravelCurrencyCode;
  /** Controls how stay dates are resolved. USE_EVENT_DATES uses metadata.eventId and falls back to payload dates if eventId is missing. USE_PAYLOAD_DATES always uses payload dates. */
  dateResolutionStrategy?: InputMaybe<DateResolutionStrategy>;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  joyPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<TravelPlacePricingAndBookingDetailsPayloadMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
};

/** DateResolutionStrategy */
export enum DateResolutionStrategy {
  USE_EVENT_DATES = 'USE_EVENT_DATES',
  USE_PAYLOAD_DATES = 'USE_PAYLOAD_DATES'
}

export type TravelPlacePricingAndBookingDetailsPayloadMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /** Source identifier for tracking API call origins */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  locale?: Scalars['String'];
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum AccommodationDatesSource {
  AROUND_EVENT_DATE = 'AROUND_EVENT_DATE',
  AROUND_PUBLIC_SCHEDULE = 'AROUND_PUBLIC_SCHEDULE',
  FROM_TRAVEL_SETTINGS = 'FROM_TRAVEL_SETTINGS'
}

export type TravelPricingsForAccommodationByPropertyIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export type TravelPricingsForAccommodationByPropertyIdPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /** Source identifier for tracking API call origins */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ComparisonsForTravelPlaceIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  placeIds: Array<PlaceIdInput>;
};

export type PlaceIdInput = {
  accommodationsPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export type TravelReservationBookingDetailsPayload = {
  eventId: Scalars['String'];
};

export type TravelReservationSummariesByPropertyIdentifiersPayload = {
  afterDate: Scalars['DateOnlyString'];
  identifiers: Array<AccommodationCatalogPropertyIdentifierInputV2>;
};

export type AccommodationCatalogPropertyIdentifierInputV2 = {
  id: Scalars['String'];
  type: AccommodationCatalogPropertyIdentifierV2Type;
};

export enum AccommodationCatalogPropertyIdentifierV2Type {
  joyPlace = 'joyPlace'
}

export enum UploadStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum MediaStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export type UrlMetadataInput = {
  cacheBust?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type UserActivityFilter = {
  activities?: InputMaybe<Array<BusinessActivityFilter>>;
  eventId?: InputMaybe<Scalars['ID']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type BusinessActivityFilter = {
  activity: Scalars['String'];
  business: Scalars['String'];
  includeJoyAdminActivity?: InputMaybe<Scalars['Boolean']>;
};

export type VendorListPayload = {
  items: Scalars['Int'];
  offset: Scalars['Int'];
  type: VendorTypeEnum;
};

export enum VendorUserRole {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  USER = 'USER'
}

export enum UrlVerificationStatus {
  invalid = 'invalid',
  valid = 'valid'
}

export type WarehouseInventorySearchInput = {
  joySKU: Scalars['String'];
  reasonCode: InventoryCheckReasonCode;
  requestedQty: Scalars['Int'];
};

export type WebsiteHeaderPresentationLayoutBySchemaInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type ZentrumHubHotelIsValidRequest = {
  checkIn?: InputMaybe<Scalars['DateTime']>;
  checkOut?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<ZentrumHubHotelIsValidRequestWithMetadata>;
  zhId: Scalars['Float'];
};

export type ZentrumHubHotelIsValidRequestWithMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type AddAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  eventId: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData: AccommodationPlaceSourceOfData;
  type?: InputMaybe<AccommodationPlaceType>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type AccommodationPlaceV2RoomBlockRequest = {
  bookingUrl: Scalars['String'];
  checkInDate: Scalars['DateOnlyString'];
  checkOutDate: Scalars['DateOnlyString'];
  currencyCode?: InputMaybe<Scalars['String']>;
  cutoffDate: Scalars['DateOnlyString'];
  isJoyManagedRoomBlock: Scalars['Boolean'];
  numberOfRoomsReserved: Scalars['Float'];
  pricePerNight?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<AccommodationPlaceRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

/** AutoSuggestionAlgoType */
export enum AutoSuggestionAlgoType {
  PastEventBased = 'PastEventBased',
  PriceBased = 'PriceBased',
  Proximity = 'Proximity'
}

export type AccommodationPlaceSourceOfData = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

export type AddAccommodationRecommendationToEventPayload = {
  recommendationId: Scalars['ID'];
};

export type AddContactToGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
  makeLeader?: InputMaybe<Scalars['Boolean']>;
};

export type AddEventCountdownComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDetailsComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDisplayNameComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddGreetingMessageComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddHostToBookingTypePayload = {
  bookingTypeId: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type AddInviteePayload = {
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

export type AddJsonDataBlobComponentPayload = {
  containerId: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddMediaGalleryComponentPayload = {
  containerId: Scalars['ID'];
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type addMediaToCollectionInput = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaId: Scalars['ID'];
};

export type addMediaToCollectionInputV2 = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaIds: Array<Scalars['ID']>;
};

export type PhotoComponentAddPayload = {
  containerId: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PointsOnMapAddPayload = {
  address: Scalars['String'];
  componentId: Scalars['ID'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

export type AddRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type CreateStationeryPrintOrderIssueInput = {
  additionalUserFacingDescription?: InputMaybe<Scalars['String']>;
  createdByEventId?: InputMaybe<Scalars['String']>;
  createdByUserId: Scalars['String'];
  issueTarget: StationeryPrintOrderIssueTarget;
  issueType: StationeryPrintOrderIssueType;
};

export type ServiceTagPayload = {
  serviceTagId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AddTestimonyPayload = {
  content: Scalars['String'];
  matchId?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
};

export type TextComponentAddPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type TravelMapComponentAddPayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddVendorPhotoInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddVendorProfilePhoto = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddMatchToListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type VideoComponentAddPayload = {
  caption?: InputMaybe<Scalars['String']>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type AnnotateRegistryOrderPayload = {
  lineItemAnnotations?: InputMaybe<Array<AnnotateRegistryOrderLineItemInput>>;
  orderAnnotations?: InputMaybe<AnnotateRegistryOrderInput>;
};

export type AnnotateRegistryOrderLineItemInput = {
  lineItemNote?: InputMaybe<Scalars['String']>;
  locator: Scalars['String'];
};

export type AnnotateRegistryOrderInput = {
  giftNote?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ApplyEventConfigPayload = {
  eventConfigData: Scalars['JSONObject'];
  eventConfigSchemaUrl: Scalars['String'];
  eventId: Scalars['ID'];
};

export type ApplyWebsiteColorsPayload = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  eventDesignId: Scalars['ID'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type ApplyWebSiteTemplateSettingsPayload = {
  /** to Apply Brannan Specific Settings (required when websiteLayout is brannan) */
  brannanSettings?: InputMaybe<BrannanSettings>;
  /** to Apply Color Settings */
  colorSettings: EventDesignColorsSettings;
  eventDesignId: Scalars['ID'];
  /** to Apply FontPack Settings */
  fontPackName: Scalars['String'];
  /** to Apply Header Layout Settings */
  headerLayout: HeaderLayoutSettings;
  /** to Apply Theme and Layout Settings */
  themeAndLayoutSettings: ThemeAndLayoutSettings;
};

export type BrannanSettings = {
  bgTransparency?: InputMaybe<BackgroundTransparency>;
  innerFrameBorder?: InputMaybe<InnerFrameBorder>;
};

export type BackgroundTransparency = {
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type InnerFrameBorder = {
  booleanValue: Scalars['Boolean'];
  featureId: Scalars['ID'];
};

export type EventDesignColorsSettings = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type HeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type ThemeAndLayoutSettings = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  fontId: Scalars['ID'];
  layoutId: Scalars['ID'];
  themeId: Scalars['ID'];
  useSuggestedThemeColor: Scalars['Boolean'];
};

export type ArchiveCollectionPayload = {
  id: Scalars['ID'];
};

export type ArchiveUserActivityInput = {
  target: UserActivityTargetInput;
};

export type UserActivityTargetInput = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type AssignAddressPayload = {
  location: InviteeLocation;
  personId: Scalars['ID'];
};

export type InviteeLocation = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type AuthenticateRegistryReservationInput = {
  /** A specially-formatted url the user currently recieves via email */
  url: Scalars['String'];
};

export type AutoPopulateAccommodationPlacesPayload = {
  eventId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocation>;
};

export type AutoPopulateAccommodationPlacesLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV3 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesFilters = {
  priceRange?: InputMaybe<AutoPopulateAccommodationPlacesFiltersPriceRange>;
  starRatings?: InputMaybe<Array<Scalars['Int']>>;
  userRatingRange?: InputMaybe<UserRatingRange>;
};

export type AutoPopulateAccommodationPlacesFiltersPriceRange = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UserRatingRange = {
  excludeUnrated?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type AutoPopulateAccommodationPlacesLocationV3 = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV4 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesPayloadV5 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scenario?: InputMaybe<AutopopulateAccommodationPlacesScenario>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

/** AutopopulateAccommodationPlacesScenario */
export enum AutopopulateAccommodationPlacesScenario {
  eventCreate = 'eventCreate',
  venueChange = 'venueChange'
}

export type AutoPopulateStayAreasPayload = {
  address?: InputMaybe<Scalars['String']>;
  autoPopulate?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
  idempotentId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  location?: InputMaybe<StayAreaCoordinatesInput>;
  scenario?: InputMaybe<Scalars['String']>;
  searchRadius?: InputMaybe<Scalars['Int']>;
};

export type StayAreaCoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export enum DeferredOperationJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type BatchUpdateEventPagesPayload = {
  id: Scalars['ID'];
  payload: PartialUpdatePagePayload;
};

export type PartialUpdatePagePayload = {
  visibility: EventPageVisibility;
};

export type RegistryOrderCancelInput = {
  cancelationMethod: SalesOrderCancelMethod;
  cancelationReason: Scalars['String'];
  registryOrderId: Scalars['ID'];
};

export enum SalesOrderCancelMethod {
  local = 'local'
}

export type ChangeLinkRedirectUrlInput = {
  linkRedirectId: Scalars['ID'];
  redirectUrl: Scalars['Url'];
};

export enum PhoneNumberVerificationStatus {
  approved = 'approved',
  canceled = 'canceled',
  deleted = 'deleted',
  expired = 'expired',
  failed = 'failed',
  maxAttemptsReached = 'maxAttemptsReached',
  pending = 'pending'
}

export type ClaimVendorUserWithToken = {
  token: Scalars['String'];
};

export type BundleStationeryPrintOrderInput = {
  childOrderNumbers: Array<Scalars['String']>;
  mainOrderNumber: Scalars['String'];
};

export type TransferRegistryOptions = {
  timeoutMs?: InputMaybe<Scalars['Int']>;
};

export type CreateConciergePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryConciergePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryConciergePrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  designSetLabel?: InputMaybe<Scalars['String']>;
  designSetName: Scalars['String'];
  eventDate?: InputMaybe<Scalars['String']>;
  formLink: Scalars['String'];
  magnetCard?: InputMaybe<Scalars['Boolean']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderDiscountInput = {
  amountInMinorUnits: Scalars['Int'];
  code: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
};

export type StationeryPrintOrderShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
};

export type CreateDigitalPrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryDigitalPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId: Scalars['ID'];
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryDigitalPrintOrderDetailsInput = {
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderProductInput = {
  attributes: Array<SelectedStationeryPrintOrderProductAttributeInput>;
  selectedShippingMethodId?: InputMaybe<Scalars['String']>;
  variantGroupId?: InputMaybe<Scalars['String']>;
};

export type SelectedStationeryPrintOrderProductAttributeInput = {
  attributeId: Scalars['String'];
  optionId: Scalars['String'];
};

export type CreateStationerySamplePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  details: StationerySamplePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationerySamplePrintOrderDetailsInput = {
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type BookingSlotArgs = {
  alternateEmail?: InputMaybe<Scalars['String']>;
  bookingTypeId: Scalars['String'];
  customerInsights?: InputMaybe<BookingSlotCustomerInsightsInput>;
  dateString: Scalars['String'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  simpleNotes?: InputMaybe<Scalars['String']>;
  simpleSurvey?: InputMaybe<SimpleSurveyInput>;
  timezone: Scalars['String'];
};

export type BookingSlotCustomerInsightsInput = {
  address?: InputMaybe<Scalars['String']>;
  companyWebsite?: InputMaybe<Scalars['String']>;
  consideredVenues?: InputMaybe<Scalars['String']>;
  engagementDate?: InputMaybe<Scalars['DateTime']>;
  hiredVendors?: InputMaybe<Scalars['String']>;
  hostedEventBefore?: InputMaybe<Scalars['Boolean']>;
  pastVenues?: InputMaybe<Scalars['String']>;
  venueEventType?: InputMaybe<BookingSlotVenueEventType>;
};

export type SimpleSurveyInput = {
  dates?: InputMaybe<Array<Scalars['String']>>;
  extraInfo?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['String']>;
  needWeddingPlanner?: InputMaybe<Scalars['String']>;
  totalBudget?: InputMaybe<Scalars['String']>;
  typeOfEvent?: InputMaybe<Scalars['String']>;
};

export type CreateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type BookingTypeInput = {
  availability?: InputMaybe<BookingTypeAvailabilityInput>;
  bookingProcess: BookingTypeProcessType;
  description: Scalars['String'];
  eventLength: Scalars['Int'];
  eventType: BookingTypeEventType;
  handle?: InputMaybe<Scalars['String']>;
  hostId: Scalars['String'];
  interval?: InputMaybe<Scalars['Int']>;
  isPrivate: Scalars['Boolean'];
  locationString?: InputMaybe<Scalars['String']>;
  meetingInfoNotes?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
  vendorId: Scalars['String'];
};

export type BookingTypeAvailabilityInput = {
  bookingTypeId: Scalars['String'];
  friday: Array<BookingTypeAvailabilityDayInput>;
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

export type BookingTypeAvailabilityDayInput = {
  end: Scalars['String'];
  start: Scalars['String'];
};

/** Input for creating a new Cash Fund associated with a host. This initiates the collection mechanism for contributions towards a specific goal or fixed amounts. */
export type CreateCashFundInput = {
  /** Optional fixed amount per contribution in minor units, if contributions are standardized. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Whether to hide the progress towards the total goal from contributors. */
  hideGoal: Scalars['Boolean'];
  /** The ID of the host this cash fund belongs to, linking to the CashFundsHost type. */
  hostId: Scalars['ID'];
  /** The name or title of the cash fund, displayed to contributors. */
  name: Scalars['String'];
  /** Optional descriptive note about the cash fund's purpose. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * URL of a photo to associate with the cash fund, used in solicitations and displays.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /**
   * The total target amount in minor currency units (e.g., cents for USD) for the fund's goal.
   * Currency is not required; it depends upon the connected Payout Account
   */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for creating a Checkout Session for standard checkout flow.
 * This input follows the same field pattern as CreateCashFundPaymentIntentInput.
 */
export type CreateCashFundCheckoutSessionInput = {
  /** Contribution amount. */
  amountInMinorUnits: Scalars['Int'];
  /**
   * URL template where customers will be redirected if they decide to cancel the checkout.
   * The template supports the following placeholders (same as successUrlTemplate)
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  cancelUrlTemplate: Scalars['String'];
  /** The ID of the cash fund. */
  cashFundId: Scalars['ID'];
  /** Contributor's email. */
  contributorEmail: Scalars['String'];
  /** Contributor's full name. */
  contributorFullName: Scalars['String'];
  /** Optional message. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
  /**
   * URL template where customers will be redirected after successful checkout.
   * The template supports the following placeholders:
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  successUrlTemplate: Scalars['String'];
};

/** Input for creating a Payment Intent for express checkout to a cash fund. Used in scenarios where contributor details are captured post-payment. */
export type CreateCashFundPaymentIntentInput = {
  /** The contribution amount in minor currency units. */
  amountInMinorUnits: Scalars['Int'];
  /** The ID of the cash fund receiving the contribution. */
  cashFundId: Scalars['ID'];
  /** Email of the contributor for receipts and tracking. */
  contributorEmail: Scalars['String'];
  /** A single unified name, first + last, same format as the Cardholder name provided by Stripe. */
  contributorFullName: Scalars['String'];
  /** Optional message from contributor to the host. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
};

/** Input for creating a Cash Fund Solicitation, which is an email campaign to invite recipients to contribute to the cash fund. */
export type CreateCashFundSolicitationInput = {
  /** The ID of the cash fund this solicitation promotes. */
  cashFundId: Scalars['ID'];
  /** Configuration for the solicitation's appearance and behavior. */
  config: CashFundSolicitationConfigInput;
  /** The body message for the invitation emails. */
  inviteMessage: Scalars['String'];
  /** The subject line for the invitation emails. */
  inviteSubject: Scalars['String'];
  /** Optional name for the solicitation campaign. */
  name?: InputMaybe<Scalars['String']>;
};

/** Configuration options for a Cash Fund Solicitation, controlling email appearance and personalization. */
export type CashFundSolicitationConfigInput = {
  /** Text for the call-to-action button in the email. */
  buttonText: Scalars['String'];
  /** Whether to include recipient names in the salutation or content. */
  includeRecipientNames: Scalars['Boolean'];
  /**
   * URL for the photo displayed in the solicitation email.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Greeting style for personalized emails (e.g., "Dear friends"). */
  salutation: Scalars['String'];
};

export type ChecklistItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subItems?: InputMaybe<Array<ChecklistSubItemCreateInput>>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChecklistSubItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateCollectionOnEventMatchPayload = {
  description: Scalars['String'];
  eventMatchId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCollectionOnVendorPayload = {
  description: Scalars['String'];
  name: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateCollectionWithPhotos = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  photoIds: Array<Scalars['String']>;
};

export type ContactInput = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type ContactInputData = {
  contactCollectionId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firebaseEventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  legacyAddressString?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<Scalars['String']>;
};

export type ContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type ContactCollectionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  collectHousehold?: InputMaybe<Scalars['Boolean']>;
  eventDateDisplayEnabled: Scalars['Boolean'];
  eventId?: InputMaybe<Scalars['String']>;
  mediaSource: Scalars['String'];
  mediaType: Scalars['String'];
  message: Scalars['String'];
  websiteLinkEnabled: Scalars['Boolean'];
};

export type ContactInputWithoutTags = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
};

export enum ContactTagSource {
  contact = 'contact',
  guestlist = 'guestlist'
}

export type CustomerInsightsInput = {
  bookingSlotId?: InputMaybe<Scalars['ID']>;
  rawData?: InputMaybe<Scalars['JSON']>;
};

export type RegistryItemMetadata = {
  /** Tells us where the registry item is added from, refer to doc for source type */
  source?: InputMaybe<Scalars['String']>;
  sourceMetadata?: InputMaybe<RegistryItemSourceMetadata>;
};

export type RegistryItemSourceMetadata = {
  /**
   * The Registry Item's known price, as a String, in USD, with no currency symbol when first scanned,
   * It does not necessarily have to match the price that was saved (in fact, when it doesn't that's when we care the most).
   */
  scannedPrice?: InputMaybe<Scalars['String']>;
};

export enum InsertPositionType {
  first = 'first',
  last = 'last'
}

export type CreateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  email: Scalars['String'];
  fundId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<DonationFundPaymentMethodEnum>;
};

export type EventChecklistCreateInput = {
  eventId: Scalars['ID'];
  items?: InputMaybe<Array<ChecklistItemCreateInput>>;
  title: Scalars['String'];
};

export type CreateEventDesignPayload = {
  colors?: InputMaybe<CreateEventDesignColorsPayload>;
  eventId: Scalars['ID'];
  fontPackName?: InputMaybe<Scalars['String']>;
  layoutName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  /** ie succulent_sunset */
  themeId?: InputMaybe<Scalars['String']>;
};

export type CreateEventDesignColorsPayload = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  pageSlug?: InputMaybe<Scalars['String']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  type: EventPageType;
};

export type EventPlaceCreatePayload = {
  eventId: Scalars['String'];
  googlePlaceId: Scalars['String'];
  type: EventPlaceType;
};

export type EventScheduleCreateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  showMap?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type CreateEventTypeInput = {
  category: Scalars['String'];
  categorySubtype: Scalars['String'];
  configJson: Scalars['JSONObject'];
  description: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  schemaUrl: Scalars['String'];
  title: Scalars['String'];
};

export type CreateEventPayload0301 = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  headerLayout?: InputMaybe<CreateEventHeaderLayoutSettings>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  mainDate?: InputMaybe<Scalars['String']>;
  mainTzid?: InputMaybe<Scalars['String']>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
  websiteDesignSettings?: InputMaybe<WebsiteDesignSettingsInput>;
};

export type AcquisitionContext = {
  currentTimestamp: Scalars['Float'];
  details: Array<AcquisitionContextDetails>;
};

export type AcquisitionContextDetails = {
  data: Array<AcquisitionContextData>;
  referrer?: InputMaybe<Scalars['String']>;
  relativeUrl: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type AcquisitionContextData = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CreateEventHeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type CreateEventImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  orderId: Scalars['String'];
};

export type WebsiteDesignSettingsInput = {
  colors?: InputMaybe<WebsiteDesignColorSettingsInput>;
  fontPackName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  welcomePhotoPresentationLayout?: InputMaybe<Scalars['String']>;
};

export type WebsiteDesignColorSettingsInput = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFormInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  /** Ticket types for this form. Required when ticketingEnabled is true in settings. */
  ticketTypes?: InputMaybe<Array<FormTicketTypeInput>>;
  title: Scalars['String'];
  type?: InputMaybe<FormType>;
};

/**
 * Ticket type definition for form creation (embedded in CreateFormInput).
 * Note: This is different from CreateTicketTypeInput which is used for standalone ticket type creation.
 * eventId and formId are set from the parent form context.
 */
export type FormTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateGeneralEventPayload = {
  eventCategory?: InputMaybe<Scalars['String']>;
  eventCategorySubtype?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDateISOString?: InputMaybe<Scalars['String']>;
  eventDisplayName: Scalars['String'];
  eventEndTimeISOString?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventLocation?: InputMaybe<GeneralEventPlace>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GeneralEventPlace = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  placeName?: InputMaybe<Scalars['String']>;
};

export type CreateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateInviteePayload = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<InviteeLocation>;
};

export type CreateJoyFeatureCheckoutInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  featureType: JoyFeatureType;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
};

export enum JoyFeatureType {
  messagingPlus = 'messagingPlus'
}

export type CreateJsonDataContainerPayload = {
  content: Scalars['JSONObject'];
  eventId: Scalars['ID'];
  schemaUrl: Scalars['String'];
  type: Scalars['String'];
};

export type CreateLinkRedirectInput = {
  /** Will be set to true if not provided. */
  active?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['ID']>;
  /**
   * https://withjoy.com/go/<link> part.
   * Supports custom links, will generate a short link if not provided.
   */
  link?: InputMaybe<Scalars['String']>;
  /** Metadata: How much service charged for creating this link */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  redirectUrl: Scalars['Url'];
  sourceService: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateLinkRedirectBlockInput = {
  blockType: BlockType;
  reason?: InputMaybe<Scalars['String']>;
  targetValue: Scalars['String'];
};

export type CreateListTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ListTravelSubItems>>;
};

export type ListTravelSubItems = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateMatchPayload = {
  eventId: Scalars['String'];
  matchNote?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MatchStatus>;
  vendorId: Scalars['String'];
  vendorTypeId?: InputMaybe<Scalars['String']>;
};

export type CreateMediaCollectionInput = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
};

export type createMediaPhotoInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoId: Scalars['ID'];
};

export type createMediaPhotosInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateNewEventAdminInvitePayload = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateNoteTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContainerCreatePayload = {
  contentType?: InputMaybe<PageContentType>;
  eventId: Scalars['ID'];
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  sortOrder: Scalars['Float'];
  title: Scalars['String'];
  visibility: EventPageVisibility;
};

export type PhotoAlignment = {
  x: PhotoXPosition;
  y: PhotoYPosition;
};

export type MainPhotoCropInfoInput = {
  height: Scalars['Float'];
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type CreateColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type CreatePlusOneGuestInput = {
  eventId: Scalars['ID'];
  guestListMemberId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optional ID of a previously created plus-one placeholder to consume.
   * If provided, the placeholder will be marked as consumed and linked to the new contact.
   */
  plusOneId?: InputMaybe<Scalars['ID']>;
};

export type CreatePostRsvpHotelBookReminderMessageInput = {
  contactIds: Array<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

export type CreateQandaPayload = {
  answer: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  sampleQuestionId?: InputMaybe<Scalars['String']>;
  type: QandaType;
};

export type CreateQRCodeInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fillColor?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  logoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPayload = {
  name: Scalars['String'];
  /** The URL to the Registry website */
  url: Scalars['String'];
};

export type CreateRegistryChecklistPayload = {
  checklistTemplate: ChecklistTemplateEnum;
  eventId: Scalars['ID'];
};

export enum ChecklistTemplateEnum {
  defaultBabyChecklist = 'defaultBabyChecklist',
  /** Used by default for deprecated createRegistryChecklist mutation. */
  defaultWeddingChecklist = 'defaultWeddingChecklist'
}

export type CreateRegistryItemPayload = {
  /** product level data that we own */
  custom: CreateCustomItemDataInput;
  /** Floating point index value, see docs for RegistryItem type */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** flag to allow the couple to mark an item as a 'must have' / favorite */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateCustomItemDataInput = {
  /** External url of image to be imported for product photo */
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

export type CreateRegistryItemFromCatalogItemPayload = {
  /**
   * The id of the catalog category that the item was added from.
   *
   * An item may appear under multiple categories and the specific category
   * needs to be captured for context.
   *
   * Ideally this field would be mandatory (non-null), but we need a migration
   * path as code is already in the wild.
   */
  catalogCategoryId?: InputMaybe<Scalars['ID']>;
  /** The id of the catalog curation type category */
  catalogItemId: Scalars['ID'];
  /** Indicates whether this item should be hidden for guests */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested: Scalars['Int'];
};

export type CreateRegistryItemsFromCatalogCategoryPayload = {
  /** The id of the catalog curation type category */
  catalogCategoryId: Scalars['ID'];
  /** Optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Optional insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** Optional quantity (number of) times to add each item. Defaults to 1 */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateRegistryPaymentIntentInput = {
  address?: InputMaybe<ShippingAddressInput>;
  /**
   * Used for automatic server-side payment confirmation.
   * Read more about [confirmation tokens](https://docs.stripe.com/payments/finalize-payments-on-the-server?platform=web&type=payment#create-ct)
   */
  confirmationTokenId?: InputMaybe<Scalars['String']>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' */
  returnUrlTemplate: Scalars['String'];
};

export type CreateRegistryPayoutAccountInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPurchaseContextInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  /** will be mandatory (non-nullable) in future */
  failureUrlTemplate?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** deprecated, use successUrlTemplate and failureUrlTemplate instead, this field will be removed in future */
  rootUrl?: InputMaybe<Scalars['String']>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' will be mandatory (non-nullable) in future */
  successUrlTemplate?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryOptions = {
  /** If missing, the registry will automatically check if it is syncable */
  type?: InputMaybe<CreateRegistryType>;
};

/** Subset of the 'RegistryType' enum */
export enum CreateRegistryType {
  linked = 'linked',
  synced = 'synced'
}

export type CreateRemindMeLaterEmailInput = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

export type CreateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateServiceTagPayload = {
  tagName: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateShuttleTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ShuttleTravelSubItems>>;
  notes?: InputMaybe<Scalars['String']>;
};

export type ShuttleTravelSubItems = {
  endTime?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateSingleRegistryItemOrderInput = {
  email: Scalars['String'];
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  registryItemId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateSlimEventAndCollection = {
  collectionName: Scalars['String'];
  description: Scalars['String'];
};

export type CreateStationeryDraftPreviewInput = {
  cardConfig: Scalars['JSON'];
  eventID?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  noLegacyAddressFallback?: InputMaybe<Scalars['Boolean']>;
  stationeryDraftId?: InputMaybe<Scalars['String']>;
};

export type CreateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  format?: InputMaybe<StationeryDraftFormat>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  stationeryTemplateId: Scalars['ID'];
};

export type CreateStationeryDraftFromPrintOrderInput = {
  format?: InputMaybe<StationeryDraftFormat>;
  orderId: Scalars['String'];
};

export type CreateStationeryPriceConfigInput = {
  /** Defaults to false */
  active?: InputMaybe<Scalars['Boolean']>;
  currencyISO4217: Scalars['String'];
  priceConfig: Scalars['JSON'];
  productId: Scalars['ID'];
};

export type CreateStationeryPrintOrderInput = {
  category?: InputMaybe<Scalars['String']>;
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  deliveryPriceCurrencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryPriceInMinorUnits?: InputMaybe<Scalars['Int']>;
  details: StationeryPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  issues?: InputMaybe<Array<CreateStationeryPrintOrderIssueInput>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  priceInMinorUnits: Scalars['Int'];
  purchaseContextId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  salesOrderId?: InputMaybe<Scalars['ID']>;
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  dieCut?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<StationeryPrintOrderDetailsEnvelopeInput>;
  foil?: InputMaybe<StationeryPrintOrderDetailsFoilInput>;
  paymentInfo?: InputMaybe<StationeryPrintOrderPaymentInfoInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress: Scalars['Boolean'];
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type StationeryPrintOrderDetailsFoilInput = {
  colorId: Scalars['String'];
  foilAssetId: Scalars['String'];
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
};

export type StationeryPrintOrderPaymentInfoInput = {
  creditCardBrand: Scalars['String'];
  creditCardLast4: Scalars['String'];
};

export type CreateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new ticket type. */
export type CreateTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTransitionalRegistryPayload = {
  eventId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  handle: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typeId: Scalars['String'];
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type LocationInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateVendorAsCoupleForContactList = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  typeId: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type CreateVendorOrganizationInput = {
  handle: Scalars['String'];
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
};

export type UserInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role: VendorUserRole;
  vendorId: Scalars['String'];
};

export type CreateVendorUserOnVendor = {
  vendorId: Scalars['String'];
};

export type CreateVenueFromPlaceIdPayload = {
  eventId: Scalars['ID'];
  placeId: Scalars['String'];
};

export type CreateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DeleteCustomThemeAssetPayload = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type EventScheduleDeleteItemPayload = {
  scheduleId: Scalars['ID'];
};

export type DeleteEventTypeInput = {
  id: Scalars['ID'];
};

export type DeleteJsonDataContainerPayload = {
  id: Scalars['ID'];
};

export type PageComponentDeletePayload = {
  id: Scalars['ID'];
};

export type PageContainerDeletePayload = {
  id: Scalars['ID'];
};

export type PointsOnMapDeletePayload = {
  id: Scalars['ID'];
};

export type DeleteVipPayload = {
  id: Scalars['ID'];
};

export type DeliverGuestNotFoundMessagePayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

export type DeliverRequestForPasswordPayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

export type DuplicateCashFundInput = {
  cashFundId: Scalars['ID'];
  newName?: InputMaybe<Scalars['String']>;
};

export enum CacheModes {
  CACHE = 'CACHE',
  NOCACHE = 'NOCACHE'
}

export type EditCollectionInfoPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type EditCollectionItemDataPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SetConfigurationInput = {
  category: Category;
  fontId?: InputMaybe<Scalars['ID']>;
  fontSizePercent?: InputMaybe<Scalars['Float']>;
};

export type EditStationeryPrintOrderInput = {
  card: EditStationeryPrintOrderDraftBlobCardInput;
  customizations?: InputMaybe<EditStationeryPrintOrderDraftBlobCustomizationsInput>;
  details: EditStationeryPrintOrderDetailsInput;
  digitalCustomizations?: InputMaybe<EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput>;
  orderId: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobCardInput = {
  back?: InputMaybe<Scalars['JSON']>;
  envelope?: InputMaybe<Scalars['JSON']>;
  front: Scalars['JSON'];
};

export type EditStationeryPrintOrderDraftBlobCustomizationsInput = {
  shape?: InputMaybe<Scalars['String']>;
};

export type EditStationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<EditStationeryPrintOrderDetailsEnvelopeInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type EditStationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  envelopeAnimation?: InputMaybe<Scalars['String']>;
  envelopeColor?: InputMaybe<Scalars['String']>;
};

export type EventSetWebsiteStatePayload = {
  eventId: Scalars['ID'];
  websiteState: EventWebsiteState;
};

export type ExtractMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  handle: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateAccommodationRecommendationsPayload = {
  /**
   * Override configuration for AI recommendation agent. Only available to superAdmin users.
   * Allows experimentation with different prompts and recommendation limits.
   * Note: Only applies when OpenAI recommendation strategy is active.
   */
  agentConfigOverride?: InputMaybe<AiRecommendationAgentConfigInput>;
  /** Override autorecommendation algorithm. */
  algorithmOverride?: InputMaybe<AutoRecommendationAlgoDtoEnum>;
  customLocation?: InputMaybe<GenerateAccommodationRecommendationsCustomLocation>;
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  /** Optional idempotency key for deferred operation. If provided, enables polling for async results using this ID. */
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
};

export type AiRecommendationAgentConfigInput = {
  maxRecommendations?: InputMaybe<Scalars['Int']>;
  modelReasoningEffort?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  systemPrompt?: InputMaybe<Scalars['String']>;
};

/** AutoRecommendation algorithm */
export enum AutoRecommendationAlgoDtoEnum {
  LuxSolidDecent = 'LuxSolidDecent',
  OpenAIInternetFirst = 'OpenAIInternetFirst',
  PartnerPicks = 'PartnerPicks',
  UserPreferences = 'UserPreferences'
}

export type GenerateAccommodationRecommendationsCustomLocation = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GroupContactsInput = {
  contactIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
};

/** Input for creating a Cash Funds Host, which associates payout details with an event. */
export type CreateCashFundsHostInput = {
  /** Address details for the payout account. */
  address: CashFundsHostAddressInput;
  /** The ID of the event to host the cash funds for. */
  eventId: Scalars['ID'];
  /** First name of the host (payee). */
  firstName: Scalars['String'];
  /** Last name of the host (payee). */
  lastName: Scalars['String'];
};

/** Input for the address associated with a Cash Funds Host for payout purposes. */
export type CashFundsHostAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  countryCode: Scalars['String'];
  /** Primary address line. */
  line1?: InputMaybe<Scalars['String']>;
  /** Secondary address line. */
  line2?: InputMaybe<Scalars['String']>;
  /** Full name on the payout account. */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number for verification. */
  phone?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State or province. */
  state?: InputMaybe<Scalars['String']>;
};

export type InstagramAuthorizationPayload = {
  code: Scalars['String'];
  vendorId: Scalars['String'];
};

export type JoinEventAsActiveUserWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
};

export type JoinEventAsPersonWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** Person ID Tag, optional for anonymous unlock */
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type JoinEventWithGuidPayload = {
  guidId: Scalars['String'];
};

export type GoogleCalendarCallbackInput = {
  code: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type LoadImageMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

export type LogUserActivityInput = {
  business: UserActivityBusinessInput;
  target: UserActivityTargetInput;
};

export type UserActivityBusinessInput = {
  print?: InputMaybe<PrintUserActivityInput>;
};

export type PrintUserActivityInput = {
  activity: PrintUserActivity;
};

export enum PrintUserActivity {
  createDraft = 'createDraft'
}

/** Input for managing (replacing) the full list of recipients for a Cash Fund Solicitation. This performs a full replacement: deletes all existing and inserts new. */
export type ManageCashFundSolicitationRecipientsInput = {
  /** The complete new list of recipients; must provide all. */
  recipients: Array<CashFundSolicitationRecipientInput>;
  /** The ID of the solicitation whose recipients are being managed. */
  solicitationId: Scalars['ID'];
};

/** Input for specifying a recipient of a Cash Fund Solicitation invite, linking to contacts or providing direct details. */
export type CashFundSolicitationRecipientInput = {
  /** The email address to send the invite to. */
  email: Scalars['String'];
  /** Optional full name of the recipient. */
  fullName?: InputMaybe<Scalars['String']>;
  /** ID of an existing contact from contact_service. */
  guestKey?: InputMaybe<Scalars['String']>;
};

export type MergeContactsInput = {
  contactId: Scalars['ID'];
  contactIdToMerge: Scalars['ID'];
};

export type MilestonesAddDependenciesBatchInput = {
  /** Array of dependency pairs to create */
  dependencies: Array<MilestonesDependencyInput>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDependencyInput = {
  dependsOnId: Scalars['ID'];
  milestoneId: Scalars['ID'];
};

export type MilestonesCreateAttachmentInput = {
  blobName: Scalars['String'];
  name: Scalars['String'];
};

export type MilestonesCreateCategoriesBatchInput = {
  /** Array of category data to create */
  categories: Array<MilestonesCreateCategoryItemInput>;
  /** Project ID - all categories will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreateCategoryItemInput = {
  name: Scalars['String'];
};

export type MilestonesCreateCategoryInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type MilestonesCreateCommentInput = {
  text: Scalars['String'];
};

export type MilestonesCreateMilestoneInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Timestamp'];
  name: Scalars['String'];
  phaseId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesCreateMilestonesBatchInput = {
  /** Array of milestone data to create */
  milestones: Array<MilestonesCreateMilestoneItemInput>;
  /** Project ID - all milestones will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreateMilestoneItemInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Timestamp'];
  name: Scalars['String'];
  phaseId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesCreatePhaseInput = {
  endDate: Scalars['Timestamp'];
  focus?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Timestamp'];
};

export type MilestonesCreatePhasesBatchInput = {
  /** Array of phase data to create */
  phases: Array<MilestonesCreatePhaseItemInput>;
  /** Project ID - all phases will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreatePhaseItemInput = {
  endDate: Scalars['Timestamp'];
  focus?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Timestamp'];
};

export type MilestonesCreateProjectInput = {
  endDate: Scalars['Timestamp'];
  eventId: Scalars['ID'];
  startDate: Scalars['Timestamp'];
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MilestonesCreateStatusNoteInput = {
  text: Scalars['String'];
};

export type MilestonesDeleteCategoriesBatchInput = {
  /** IDs of categories to delete */
  categoryIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDeleteMilestonesBatchInput = {
  /** IDs of milestones to delete */
  milestoneIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDeletePhasesBatchInput = {
  /** IDs of phases to delete */
  phaseIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesExportInput = {
  format: MilestonesImportExportFormat;
  projectId: Scalars['ID'];
};

export type MilestonesRemoveDependenciesBatchInput = {
  /** Array of dependency pairs to remove */
  dependencies: Array<MilestonesDependencyInput>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesStartImportInput = {
  format: MilestonesImportExportFormat;
  projectId: Scalars['ID'];
  sourceUrl: Scalars['String'];
};

export type MilestonesUpdateCategoryInput = {
  name: Scalars['String'];
};

export type MilestonesUpdateMilestoneInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  phaseId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesUpdatePhaseInput = {
  collapsed?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Timestamp']>;
  focus?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
};

export type MilestonesUpdateProjectInput = {
  endDate?: InputMaybe<Scalars['Timestamp']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** You must provide 3 of 5 properties; (1) `targetId`, (2) **either** `beforeId` or `toLast`, and (3) **either** `afterId` or `toFirst` */
export type ModelReorderPayload = {
  /** The ID of the Model to the left of the Model's new position; *do not specify* `toFirst` */
  afterId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model to the right of the Model's new position; *do not specify* `toLast` */
  beforeId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model being moved to a new position in the list */
  targetId: Scalars['ID'];
  /** The Model's new position will be at the start of the list; *do not specify* `afterId` */
  toFirst?: InputMaybe<Scalars['Boolean']>;
  /** The Model's new position will be at the end of the list; *do not specify* `beforeId` */
  toLast?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryPrintOrderProcessInput = {
  id: Scalars['ID'];
  paymentInfo?: InputMaybe<StationeryPrintOrderPaymentInfoInput>;
  purchaseContextId?: InputMaybe<Scalars['ID']>;
  salesOrderId?: InputMaybe<Scalars['ID']>;
  settlementAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  stripePaymentIntentId?: InputMaybe<Scalars['ID']>;
  taxAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
};

export type ProcessRecommendationPayload = {
  action: ProcessRecommendationAction;
  catalogItemId?: InputMaybe<Scalars['ID']>;
  registryItemId: Scalars['ID'];
};

export enum ProcessRecommendationAction {
  skip = 'skip',
  swap = 'swap'
}

export type QuarantineContactMessageBatchDetailsInput = {
  eventId: Scalars['String'];
  messageBatchId: Scalars['String'];
  messageBatchPayload: Scalars['JSON'];
  messageBatchType: Scalars['String'];
  spamIndicatorsPayload?: InputMaybe<Scalars['JSON']>;
};

export type RecentTravelReservationsByEventMarkAsReadPayload = {
  eventId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};

export type RefreshOfferTokenAfterReservationPayload = {
  currency: Scalars['String'];
  joyOfferId: Scalars['String'];
  originalPriceInMinorUnits: Scalars['Int'];
  /** Room details for all rooms in the reservation. Used for matching offers when old offer is expired. */
  roomDetails: Array<RefreshOfferTokenRoomDetails>;
};

export type RefreshOfferTokenRoomDetails = {
  /** Number of adults in this room */
  adults: Scalars['Int'];
  /** Board basis type */
  boardBasis: Scalars['String'];
  /** Ages of children in this room */
  childrenAges: Array<Scalars['Int']>;
  /** refundable or nonRefundable */
  refundability: Scalars['String'];
  roomName: Scalars['String'];
};

export type RefreshVendorUserTokenPayload = {
  vendorUserId: Scalars['String'];
};

export type TravelOfferReservationRegeneratePaymentPayload = {
  id: Scalars['String'];
};

export type RemoveContactFromGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
};

export type RemoveHostFromBookingTypePayload = {
  bookingTypeId: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type removeMediaFromCollectionInput = {
  collectionId: Scalars['ID'];
  mediaId: Scalars['ID'];
};

export type RemoveMultipleInviteesPayload = {
  eventId: Scalars['ID'];
  personIdsList: Array<Scalars['ID']>;
};

export type RemoveStayAreaPayload = {
  id: Scalars['ID'];
};

export type RemoveMatchFromListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ReorderPayload = {
  currentId: Scalars['String'];
  nextId?: InputMaybe<Scalars['String']>;
  previousId?: InputMaybe<Scalars['String']>;
};

export type ReorderPageComponent = {
  id: Scalars['ID'];
};

export type RequestVendorEdit = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type ResetUserActivityInput = {
  business: UserActivityBusinessInput;
  target: UserActivityTargetInput;
};

export type ElectronicCardInput = {
  additionalMessage?: InputMaybe<Scalars['String']>;
  coupleNameFormat?: InputMaybe<Scalars['String']>;
  displayDateFormat?: InputMaybe<Scalars['String']>;
  displayDateString?: InputMaybe<Scalars['String']>;
  displayEventLink?: InputMaybe<Scalars['Boolean']>;
  displayTypeString?: InputMaybe<Scalars['String']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['String'];
  linkOptionPrimary?: InputMaybe<Scalars['String']>;
  linkOptionSecondary?: InputMaybe<Scalars['String']>;
  locationString?: InputMaybe<Scalars['String']>;
  locationStringFormat?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  photoEcardTheme?: InputMaybe<Scalars['String']>;
  photoEcardThemePositionX?: InputMaybe<Scalars['Float']>;
  photoEcardThemePositionY?: InputMaybe<Scalars['Float']>;
  photoEcardThemeScale?: InputMaybe<Scalars['Float']>;
  photoId?: InputMaybe<Scalars['String']>;
  recipientIds: Array<Scalars['ID']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type EcardDesignInput = {
  ecardDesignId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  shouldUseEventDesign: Scalars['Boolean'];
  themeId: Scalars['ID'];
};

export type ElectronicCardEmailDraftInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailDraftId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  ecardType: EcardType;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ElectronicCardPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  ecardId: Scalars['ID'];
};

export type EmailPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  emailId: Scalars['ID'];
};

export type UpdateEventProductVerticalsPayload = {
  optOutOfGuestList?: InputMaybe<Scalars['Boolean']>;
  optOutOfInvites?: InputMaybe<Scalars['Boolean']>;
  optOutOfRegistry?: InputMaybe<Scalars['Boolean']>;
  optOutOfWebsite?: InputMaybe<Scalars['Boolean']>;
};

export type EventRegistrationInput = {
  answers?: InputMaybe<Array<CreateAnswerInput>>;
  contactInfo?: InputMaybe<FormContactInput>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
  /** Selected ticket type ID. Required when form has ticketingEnabled in settings. */
  ticketTypeId?: InputMaybe<Scalars['ID']>;
};

export type CreateAnswerInput = {
  answerValue: Scalars['String'];
  questionId: Scalars['ID'];
};

export type FormContactInput = {
  address?: InputMaybe<FormContactAddressInput>;
  contact: FormContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<FormContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type FormContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type FormContactInputData = {
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  party?: InputMaybe<Scalars['String']>;
};

export type FormContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type GreetingCardInput = {
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

export type GreetingCardInputWithUrl = {
  baseUrl: Scalars['String'];
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

export type InsightSaveRagPostWithEmbeddingInput = {
  content: Scalars['String'];
  description: Scalars['String'];
  embeddings: Array<Array<Scalars['Float']>>;
  id?: InputMaybe<Scalars['ID']>;
  postSource: InsightRagPostSource;
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum InsightRagPostSource {
  blog = 'blog',
  intercom = 'intercom'
}

export type PostOfficeGenericEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeGiftWrapEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
};

export type PostOfficeGreetingCardEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  greetingCardUrl: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type PostOfficeReminderEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeThankYouEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personEmails?: InputMaybe<Array<Scalars['String']>>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type SaveStationeryProductInput = {
  attributesConfig: Scalars['JSON'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productType: Scalars['String'];
  vendor: StationeryPrintOrderVendorEnum;
  vendorBaseSKU: Scalars['String'];
};

export type SaveStationeryTemplateInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  category: StationeryTemplateCategoryEnum;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  side: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  themeId: Scalars['ID'];
  themeJSON: Scalars['JSON'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type SaveUserConsentForEventInput = {
  consentAnswer: Scalars['Boolean'];
  consentKey: Scalars['String'];
  consentTermsOfServiceLink?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
};

export type ShortListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ShortListEventCreatePayload = {
  vendorId: Scalars['String'];
};

export type ScheduleEventReminderInput = {
  endDate: Scalars['DateTime'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

/** Input for sending a test email for a Cash Fund Solicitation to verify formatting and content. */
export type SendCashFundSolicitationTestEmailInput = {
  /** Email address to send the test to. */
  email: Scalars['String'];
  /** Name to use for the test recipient personalization. */
  name: Scalars['String'];
  /** The ID of the solicitation to test. */
  solicitationId: Scalars['ID'];
};

export type SendContactCollectorMessagesInput = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  link?: InputMaybe<Scalars['String']>;
  linkLabel?: InputMaybe<Scalars['String']>;
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type EcardEmailArgs = {
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  date: Scalars['String'];
  emailType: Scalars['String'];
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  eventWebsite: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  sentToPersonId: Scalars['String'];
  subject: Scalars['String'];
  subTitle: Scalars['String'];
  title: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type ElectronicCardEmailMessageInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailId?: InputMaybe<Scalars['ID']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  ecardType?: InputMaybe<EcardType>;
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SendEventDateReminderInput = {
  emailHeadline: Scalars['String'];
  emailTypeOverride: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  recipientEmailList: Array<Scalars['String']>;
  recipientPhoneNumberList: Array<Scalars['String']>;
  smsHeadline: Scalars['String'];
  subject: Scalars['String'];
  utmCampaign: Scalars['String'];
};

export type GenericEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type GiftCardEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  fromEmail: Scalars['String'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  theme: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type MessageRelationArgs = {
  externalMessageId: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['ID']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendHotelBlockReminderRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  link: Scalars['String'];
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Input for sending a JSON-structured message email to guests.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 */
export type SendJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  /** List of guest keys to send the message to */
  guestKeys: Array<Scalars['String']>;
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Input for sending a JSON-structured message email to people.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type SendJoyJsonMessageEmailByPeopleIdsInput = {
  eventId: Scalars['String'];
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** List of people to send the message to */
  people: Array<PersonRecipientInput>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Person recipient information for sending emails.
 * Client provides all necessary data to avoid redundant M2M calls.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type PersonRecipientInput = {
  /** Person's email address (required for delivery) */
  email: Scalars['String'];
  /** Person's first name for email personalization */
  firstName?: InputMaybe<Scalars['String']>;
  /** Person's last name for email personalization */
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['String'];
};

export type SendJoyJsonMessagesInput = {
  /** Guest keys for email recipients */
  emailGuestKeys: Array<Scalars['String']>;
  eventId: Scalars['String'];
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /** Guest keys for SMS recipients. Requires Messaging Plus tier. */
  smsGuestKeys: Array<Scalars['String']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyJsonMessagesByPersonIdsInput = {
  /** Person IDs for email recipients */
  emailPersonIds: Array<Scalars['ID']>;
  eventId: Scalars['String'];
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /** Person IDs for SMS recipients. Requires Messaging Plus tier. */
  smsPersonIds: Array<Scalars['ID']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  guestKeys: Array<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MessageToMultipleVendorsPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  ids: Array<Scalars['String']>;
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type MessageToVendorPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type PostOfficeGreetingCardEmailInput = {
  draftId: Scalars['ID'];
  eventId: Scalars['ID'];
  giverName: Scalars['String'];
  replyToEmail: Scalars['String'];
};

export type EmailRelationInput = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostOfficeThankYouEmailV2Input = {
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personId: Scalars['String'];
  relationData?: InputMaybe<SendPostOfficeThankYouEmailRelationDataV2Input>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendPostOfficeThankYouEmailRelationDataV2Input = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpEventDetailsEmailInput = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpMessagesInput = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponse>;
};

export type RsvpResponse = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestion>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestion = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SendPostRsvpMessagesInputV2 = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponseV2>;
};

export type RsvpResponseV2 = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestionV2>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestionV2 = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SendPostRsvpSmsInput = {
  code: Scalars['String'];
  eventId: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
};

export type SendPremiumDigitalOrderInput = {
  orderId: Scalars['String'];
  recipientIdList: Array<Scalars['ID']>;
  senderName: Scalars['String'];
  smsRecipientIdList?: InputMaybe<Array<Scalars['ID']>>;
  subject: Scalars['String'];
};

/** An registryItemId and email used to lookup a RegistryOrder item for resending an email */
export type SendRegistryOrderConfirmationInput = {
  email: Scalars['String'];
  emailIntent?: InputMaybe<RegistryOrderEmailIntent>;
  registryItemId: Scalars['String'];
};

/** Email type so send different subject lines and headers */
export enum RegistryOrderEmailIntent {
  find = 'find',
  reminder = 'reminder',
  reservation = 'reservation'
}

export type ReminderEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SendRsvpReminderV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
};

export type AutomaticEventReminderInput = {
  eventDate: Scalars['DateTime'];
  eventDisplayName: Scalars['String'];
  eventId: Scalars['ID'];
  firebaseEventId: Scalars['String'];
};

export type TestEmailWithTemplateArgs = {
  subject: Scalars['String'];
  templateName: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendTestJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  payload: Scalars['JSON'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestPremiumDigitalCardInput = {
  orderId: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
};

export type SendTestRsvpReminderV2Input = {
  body: Scalars['String'];
  eventId: Scalars['String'];
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
};

export type ThankYouEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventName?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SetAccentPayload = {
  accent: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type SetFeaturePreferenceColor = {
  colorLocation?: InputMaybe<ColorPointerLocation>;
  eventDesignId: Scalars['ID'];
  index: Scalars['Int'];
};

export type AttendanceInput = {
  attendanceState: AttendanceState;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  guestKey: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type DesignPreferenceRangeInput = {
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type DesignPreferenceBooleanInput = {
  booleanValue: Scalars['Boolean'];
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
};

export type SetCustomCssPayload = {
  customCss: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type BookingTypeDefaultAvailabilityInput = {
  bookingWindowLeadHours?: InputMaybe<Scalars['Int']>;
  friday: Array<BookingTypeAvailabilityDayInput>;
  handle: Scalars['String'];
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

/** Asset information for an Image */
export type SetAssetPayload = {
  assetId: Scalars['String'];
  fileSize: Scalars['Int'];
  height: Scalars['Int'];
  ignoreChannel?: InputMaybe<Scalars['Boolean']>;
  md5?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  width: Scalars['Int'];
};

export type SetDesignPhotoPayload = {
  designPhotoId?: InputMaybe<Scalars['ID']>;
  eventDesignId: Scalars['ID'];
};

/** Set the desktop photo URL for an event */
export type SetEventPhotoV2Payload = {
  eventId: Scalars['ID'];
  photoV2Url: Scalars['String'];
};

/** Set the mobile version of photo URL for an event */
export type SetEventPhotoV2MobilePayload = {
  eventId: Scalars['ID'];
  photoV2UrlMobile: Scalars['String'];
};

export type SetEventStylePayload = {
  accent?: InputMaybe<Scalars['String']>;
  backgroundType?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Layout>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primaryTextColor?: InputMaybe<Scalars['String']>;
  suggestedColor?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['String']>;
  translucent?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColorAloha?: InputMaybe<Scalars['Boolean']>;
};

export type SetFontPayload = {
  eventDesignId: Scalars['ID'];
  fontId: Scalars['ID'];
};

export type SetHasVisitedDesignPagePayload = {
  eventDesignId: Scalars['ID'];
  hasVisitedDesignPage: Scalars['Boolean'];
};

export type setMediaTokenPermissionsInput = {
  collectionId: Scalars['ID'];
  permissions: Array<InputMaybe<MagicTokenPermissions>>;
};

export type SetColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
  paletteId: Scalars['ID'];
};

export type SetPhotoAlignmentPayload = {
  alignment: PhotoAlignment;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<EventPageType>;
};

export type StationeryPrintOrderStatusInput = {
  message?: InputMaybe<Scalars['String']>;
  printOrderId: Scalars['ID'];
  status: StationeryPrintOrderStatusEnum;
};

export type SetPropertiesPayload = {
  accent?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  eventDesignId: Scalars['ID'];
  fontId?: InputMaybe<Scalars['ID']>;
  layoutId?: InputMaybe<Scalars['ID']>;
  paletteId?: InputMaybe<Scalars['ID']>;
  themeId?: InputMaybe<Scalars['ID']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

/** The currency code */
export type EventCurrencyInput = {
  code: Scalars['String'];
};

export type RegistryEventDataInput = {
  delayOrderFulfillment?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforPartnerItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforSyncedItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforTransferredItems?: InputMaybe<Scalars['Boolean']>;
  hideRegistryInMessaging?: InputMaybe<Scalars['Boolean']>;
};

export type ReservedRoomBlocksRequest = {
  address?: InputMaybe<Scalars['String']>;
  bookingUrl?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateTime']>;
  checkOutDate?: InputMaybe<Scalars['DateTime']>;
  cutoffDate?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  hotelMoreInfoUrl?: InputMaybe<Scalars['String']>;
  hotelRoomBlocksId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  numberOfNightsBooked?: InputMaybe<Scalars['Int']>;
  numberOfNightsGuestBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsGuestBooked?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  pricePerNight?: InputMaybe<Scalars['Float']>;
  starRating?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ReservedRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

export type SetSearchMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateID: Scalars['String'];
};

export type SetStationeryDigitalPrintOrderFeatureSmsInput = {
  enabled: Scalars['Boolean'];
  orderId: Scalars['String'];
};

export type SetStationeryDraftRecipientIdListInput = {
  id: Scalars['ID'];
  recipientIdList?: InputMaybe<Array<Scalars['ID']>>;
};

export type SetThemePayload = {
  eventDesignId: Scalars['ID'];
  themeId: Scalars['ID'];
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetThemeAndLayoutPayload = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
  themeId: Scalars['ID'];
  useCustomTheme?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetLayoutPayload = {
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
};

export type AddSimpleTagToPhotosInCollectionPayload = {
  collectionId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type AddSimpleTagPayload = {
  photoIds: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type SortItemsPayload = {
  eventId: Scalars['String'];
  items: Array<ItemToSort>;
};

export type ItemToSort = {
  id: Scalars['ID'];
  sortKey: Scalars['String'];
};

export enum SalesOrderRefundMethod {
  REFUND = 'REFUND',
  STRIPE_REFUND = 'STRIPE_REFUND',
  SWAP_FOR_CASH = 'SWAP_FOR_CASH'
}

export type StartStationeryCheckoutInput = {
  address: StationeryShippingAddressInput;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  failureUrlTemplate: Scalars['String'];
  name: Scalars['String'];
  printOrder: StationeryCheckoutPrintOrderInput;
  successUrlTemplate: Scalars['String'];
  themeDisplayName?: InputMaybe<Scalars['String']>;
};

export type StationeryShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryCheckoutPrintOrderInput = {
  orderId: Scalars['String'];
};

export type StartStationeryInternationalCheckoutInput = {
  failureUrlTemplate: Scalars['String'];
  printOrderId: Scalars['String'];
  successUrlTemplate: Scalars['String'];
};

export type AIBackgroundPromptPayload = {
  prompt: Scalars['String'];
  style: Scalars['String'];
};

export type CreateStationeryDigitalViewInput = {
  cardOrderId: Scalars['String'];
  personId: Scalars['String'];
  src: Scalars['String'];
};

export type SubmitFormAnswersInput = {
  answers: Array<CreateAnswerInput>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
};

export type HotelRoomBlockLeadInfoSubmittedRequest = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  anyOtherInformation?: InputMaybe<Scalars['String']>;
  calendlyUri?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateOnly']>;
  checkOutDate?: InputMaybe<Scalars['DateOnly']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  destinationWedding?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  externalHotelInfo?: InputMaybe<Array<ExternalHotelInfo>>;
  fullName?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Float']>;
  /** deprecated, use externalHotelInfo */
  hotelUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Is the given address same as the address of the venue */
  isAddressTheVenue?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  outOfTown?: InputMaybe<Scalars['Float']>;
  partner1?: InputMaybe<PartnerInfo>;
  partner2?: InputMaybe<PartnerInfo>;
  phone?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredContactMethod?: InputMaybe<ContactMethods>;
  roomsToBlock?: InputMaybe<Scalars['String']>;
  secondaryEmail?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<LeadSourceTypes>;
  stateRegionProvince?: InputMaybe<Scalars['String']>;
};

export type ExternalHotelInfo = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  hotelUrl: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<HotelLocationProvider>;
};

/** The provider of the hotels data */
export enum HotelLocationProvider {
  Google = 'Google',
  Zentrumhub = 'Zentrumhub'
}

export type PartnerInfo = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** The source of the lead */
export enum LeadSourceTypes {
  preferred = 'preferred'
}

export type SyncReserveRoomBlocksToAccommodationPlacesRequest = {
  batchSize?: InputMaybe<Scalars['Float']>;
};

export type TagUserInPhotoPayload = {
  photoId: Scalars['ID'];
  userId: Scalars['String'];
};

export type TagVendorInPhotoPayload = {
  photoId: Scalars['ID'];
  vendorId: Scalars['String'];
};

export type TagVendorInPhotosOnCollectionPayload = {
  collectionId: Scalars['ID'];
  vendorIds: Array<Scalars['String']>;
};

export type ToggleDesignFavoriteInput = {
  eventId: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
  /** Primary resource to favorite (Font: FontId, Art: ThemeId, Template: ThemeId) */
  resourceId: Scalars['ID'];
  /** Secondary resource to favorite (Template: LayoutId) */
  secondaryResourceId?: InputMaybe<Scalars['ID']>;
  type: FavoriteType;
};

export type ImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  customerEmail: Scalars['String'];
  customerId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  itemCategory1?: InputMaybe<Scalars['String']>;
  itemQuantity1?: InputMaybe<Scalars['Int']>;
  itemSKU1?: InputMaybe<Scalars['String']>;
  itemSubtotal1?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['String'];
  text1?: InputMaybe<Scalars['String']>;
};

export type TransferTransitionalRegistryItemsPayload = {
  transitionalRegistryId: Scalars['ID'];
  transitionalRegistryItemIds: Array<Scalars['ID']>;
};

export type TravelOfferReservationCancelPayload = {
  reservationId: Scalars['String'];
};

export type TravelOfferReservationConfirmPayload = {
  billingContact: TravelOfferReservationBillingContact;
  campaignId?: InputMaybe<Scalars['String']>;
  paymentCredential: Scalars['String'];
  paymentCredentialType: TravelPaymentCredentialType;
  travelOfferReservationId: Scalars['String'];
};

export type TravelOfferReservationBillingContact = {
  age?: InputMaybe<Scalars['Float']>;
  contact?: InputMaybe<TravelOfferReservationBillingContactContact>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: TravelReservationGuestAgeClassification;
};

export type TravelOfferReservationBillingContactContact = {
  address: TravelOfferReservationBillingContactAddress;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type TravelOfferReservationBillingContactAddress = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export enum TravelPaymentCredentialType {
  VAULTERA_CREDIT_CARD_TOKENIZED = 'VAULTERA_CREDIT_CARD_TOKENIZED'
}

export type TravelOfferReservationCreatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  campaignId?: InputMaybe<Scalars['String']>;
  checkoutType?: InputMaybe<TravelOfferReservationCheckoutType>;
  couponCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  offerToken: Scalars['String'];
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
};

/** Type of checkout for TravelOfferReservation */
export enum TravelOfferReservationCheckoutType {
  stripe_native = 'stripe_native',
  vaultera_vault = 'vaultera_vault'
}

export type TravelOfferReservationRoomGuestsInput = {
  guests: Array<TravelOfferReservationGuestInformationInput>;
  unitId: Scalars['String'];
};

export type TravelOfferReservationGuestInformationInput = {
  age?: InputMaybe<Scalars['Float']>;
  ageClassification: TravelReservationGuestAgeClassification;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<TravelReservationGuestTitle>;
};

export type TravelOfferReservationUpdatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
};

export type TravelEventCacheWarmUpRequestPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Event handle/website identifier (e.g., "my-event-handle") */
  eventHandle: Scalars['String'];
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  /** UX scenario triggering the warm-up request */
  scenario: TravelEventCacheWarmUpRequestUxType;
};

/** UX which is triggering the warm-up request */
export enum TravelEventCacheWarmUpRequestUxType {
  GUEST = 'GUEST',
  HOST = 'HOST',
  HOST_CHANGED_VENUE = 'HOST_CHANGED_VENUE'
}

export type UnlockRequestForProposalPayload = {
  id: Scalars['ID'];
};

export type UpdateAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  id: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData?: InputMaybe<AccommodationPlaceSourceOfData>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSessionPayload = {
  givenPassword?: InputMaybe<Scalars['String']>;
  givenSecret?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  isLoggedOut?: InputMaybe<Scalars['Boolean']>;
  permitUserId?: InputMaybe<Scalars['String']>;
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingSlotArgs = {
  alternateEmail?: InputMaybe<Scalars['String']>;
  customerInsights?: InputMaybe<BookingSlotCustomerInsightsInput>;
  dateString?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  simpleNotes?: InputMaybe<Scalars['String']>;
  simpleSurvey?: InputMaybe<SimpleSurveyInput>;
  status?: InputMaybe<BookingSlotStatusType>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type BookingSlotStatusArgs = {
  id: Scalars['ID'];
  status: BookingSlotStatusType;
};

export type UpdateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingTypeInput = {
  availability?: InputMaybe<BookingTypeAvailabilityPayload>;
  bookingProcess?: InputMaybe<BookingTypeProcessType>;
  description?: InputMaybe<Scalars['String']>;
  eventLength?: InputMaybe<Scalars['Int']>;
  eventType?: InputMaybe<BookingTypeEventType>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interval?: InputMaybe<Scalars['Int']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  locationString?: InputMaybe<Scalars['String']>;
  meetingInfoNotes?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BookingTypeAvailabilityPayload = {
  friday: Array<BookingTypeAvailabilityDayInput>;
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

/**
 * Used for updating an existing Cash Fund with complete replacement of fields.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 */
export type UpdateCashFundInput = {
  /** The ID of the cash fund to update. */
  cashFundId: Scalars['ID'];
  /** Updated fixed contribution amount, if omitted will be cleared. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Updated hide goal flag. */
  hideGoal: Scalars['Boolean'];
  /** Updated name of the cash fund. */
  name: Scalars['String'];
  /** Updated note, if omitted will be cleared. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Updated photo URL, if omitted will be cleared.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Updated goal amount, if omitted will be cleared. */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for updating an existing Cash Fund Solicitation.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 */
export type UpdateCashFundSolicitationInput = {
  /** Updated configuration. */
  config: CashFundSolicitationConfigInput;
  /** Updated message body. */
  inviteMessage: Scalars['String'];
  /** Updated subject line. */
  inviteSubject: Scalars['String'];
  /** Updated name, if omitted cleared. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the solicitation to update. */
  solicitationId: Scalars['ID'];
};

export type ChecklistItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChecklistSubItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ConciergeImageUpload = {
  photoUrl: Scalars['String'];
  salesforceOwnerId: Scalars['String'];
};

/** Added in erorr. Do not use */
export type UpdateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  platformType: DonationFundPaymentMethodEnum;
};

export type EventChecklistUpdateInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEventCountdownComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsMessagingPayload = {
  eventDetailsAutomaticRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  eventDetailsMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  rsvpNoCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpNoCustomRedirectUrl?: InputMaybe<Scalars['String']>;
  rsvpYesCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpYesCustomRedirectUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateEventDisplayNameComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDomainPayload = {
  /** The domain name; set this property to null to delete the Event Domain */
  domainName?: InputMaybe<Scalars['String']>;
};

export type UpdateEventInfoPayload = {
  announcementBanner?: InputMaybe<EventAnnouncementBannerPayload>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  date?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventSecret?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type EventAnnouncementBannerPayload = {
  active: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EventDataPayload = {
  budget?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
};

export type UpdateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type EventPlaceUpdatePayload = {
  googlePlaceId: Scalars['String'];
  id: Scalars['ID'];
};

export type EventScheduleUpdateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  scheduleId: Scalars['ID'];
  showMap?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSettingsPayload = {
  allowFacebookAndInstagramSharingOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsNotInGuestListToRSVP?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToInviteOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToRSVPPlusOne?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToViewOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  hideDownloadAppPage?: InputMaybe<Scalars['Boolean']>;
  hideEventCountdown?: InputMaybe<Scalars['Boolean']>;
  hideFromJoySearch?: InputMaybe<Scalars['Boolean']>;
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventDate?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventLocation?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToUploadPhotos?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToViewEngagementPhotos?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEventSuggestionPayload = {
  stateJSON?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateEventTypeInput = {
  category?: InputMaybe<Scalars['String']>;
  categorySubtype?: InputMaybe<Scalars['String']>;
  configJson?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFormInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateAnswerInput = {
  answerValue?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['ID']>;
  guestKey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  questionId?: InputMaybe<Scalars['ID']>;
};

export type UpdateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingMessageComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateInviteePayload = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

export type UpdateJsonDataBlobComponentPayload = {
  id: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateJsonDataContainerPayload = {
  content?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateListTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ListTravelSubItems>>>;
  updatedItems?: InputMaybe<Array<InputMaybe<ListTravelSubItemsWithId>>>;
};

export type ListTravelSubItemsWithId = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MarketingEmailPreferencesInput = {
  email: Scalars['String'];
  preferences: Array<MessagePreferenceInput>;
};

export type MessagePreferenceInput = {
  id: Scalars['Int'];
  isSubscribed: Scalars['Boolean'];
};

export type UpdateMediaCollectionInput = {
  mediaCollectionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
};

export type UpdateMediaGalleryComponentPayload = {
  id: Scalars['ID'];
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateNoteTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContainerUpdatePayload = {
  contentType?: InputMaybe<PageContentType>;
  defaultPhotoJson?: InputMaybe<DefaultPagePhotoInput>;
  id: Scalars['ID'];
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type DefaultPagePhotoInput = {
  assetId: Scalars['String'];
  height: Scalars['Float'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type UpdatePaidMessagingSettingsInput = {
  eventId: Scalars['String'];
  messagingTier?: InputMaybe<MessagingTier>;
};

export type PhotoComponentUpdatePayload = {
  id: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PointsOnMapUpdatePayload = {
  address: Scalars['String'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

export type UpdateQandaPayload = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** Identical to RecommendRegistryOnboardingSurveyResults. */
export type RecommendRegistryOnboardingSurveyPayload = {
  coupleInterests?: InputMaybe<Array<Scalars['String']>>;
  guestCount?: InputMaybe<Scalars['Int']>;
  interestedInBrowserButton?: InputMaybe<Scalars['Boolean']>;
  isSurveyCompleted?: InputMaybe<Scalars['Boolean']>;
  registeringAtOtherStores?: InputMaybe<Scalars['Boolean']>;
  registryTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateRegistryPayload = {
  name?: InputMaybe<Scalars['String']>;
  /** update status as user goes through recommendations */
  recommendationStatus?: InputMaybe<RegistryRecommendationStatus>;
  /** The URL to the Registry website */
  url?: InputMaybe<Scalars['String']>;
  wantSync?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRegistryChecklistItemPayload = {
  isChecked?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Generic update mutation. Note stillNeeded and totalRequested are being withdrawn
 * from this payload. Use specific mutations such as updateRegistryItemQuantity() to
 * update quantity values
 */
export type UpdateRegistryItemPayload = {
  /** product level data that we own */
  custom?: InputMaybe<UpdateCustomItemDataInput>;
  /** donation fund info for group gifting */
  donationFundPayload?: InputMaybe<CreateDonationFundInput>;
  /** always updatable, sort related updates may be moved to dedicated endpoints */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable the get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to enable the group gifting feature */
  isGroupGiftingEnabled?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to hide an item */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to musthave an item */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  stillNeeded?: InputMaybe<Scalars['Int']>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type UpdateCustomItemDataInput = {
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

/**
 * Used to attach donation fund to a physical gift as part of updateRegistryItem mutation
 * when group gifting feature is enabled.
 */
export type CreateDonationFundInput = {
  description?: InputMaybe<Scalars['String']>;
  donationsAreCapped?: InputMaybe<Scalars['Boolean']>;
  enableCashOrCheck?: InputMaybe<Scalars['Boolean']>;
  enforceSuggestedDonationAmount?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  feePaidBy?: InputMaybe<FeePaidByEnum>;
  fpIndex?: InputMaybe<Scalars['Int']>;
  fundType?: InputMaybe<CustomItemDataType>;
  goalMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  hideFundingGoal?: InputMaybe<Scalars['Boolean']>;
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  platformId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<InsertPositionType>;
  suggestedDonationMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ReservedRoomBlocksUpdateRequest = {
  hiddenForGuests?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reservedRoomBlockId: Scalars['ID'];
  status?: InputMaybe<ReservedRoomBlockStatus>;
};

export type UpdateRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateShuttleTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItems>>>;
  notes?: InputMaybe<Scalars['String']>;
  updatedItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItemsWithId>>>;
};

export type ShuttleTravelSubItemsWithId = {
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type UpdateStationeryPrintOrderShippingAddressInput = {
  orderId: Scalars['ID'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
};

export type UpdateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTestimonyPayload = {
  content: Scalars['String'];
  reviewer?: InputMaybe<Scalars['String']>;
  testimonyId: Scalars['String'];
};

export type TextComponentUpdatePayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateThingsToDoContainersPayload = {
  /** An array of Things To Do content to update */
  contents: Array<Scalars['JSONObject']>;
  eventId: Scalars['ID'];
  /** @deprecated(reason: "It only update contents for containers with the same 'poi.id', so the strategy is no longer needed") */
  strategy?: InputMaybe<UpdateThingsToDoContainersStrategy>;
};

export enum UpdateThingsToDoContainersStrategy {
  /** Adds new containers */
  add = 'add',
  /** Removes all containers for the cities specified in the container contents and then creates new containers for that cities */
  replace = 'replace'
}

/**
 * Input for updating an existing ticket type.
 * Nullable fields can be cleared by setting their corresponding clear flag to true.
 */
export type UpdateTicketTypeInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  /** Set to true to clear capacity (make unlimited) */
  clearCapacity?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear the description (set to null) */
  clearDescription?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesEndAt */
  clearSalesEndAt?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesStartAt */
  clearSalesStartAt?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<TicketTypeState>;
};

export type UpdateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TravelMapComponentUpdatePayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  hideExploreCTA?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateTravelSettingsRequest = {
  accommodationsNotePrompt?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateOnlyString']>;
  checkOutDate?: InputMaybe<Scalars['DateOnlyString']>;
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  datesMatchingReminder?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
};

export type UpdateUserPayload = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorAsCouplePayload = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorUserPayload = {
  displayFirstName?: InputMaybe<Scalars['String']>;
  displayLastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  role: VendorUserRole;
};

export type VendorUserInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleTypeEnum>;
};

export type UpdateVendorInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberE164?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type VideoComponentUpdatePayload = {
  caption?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type UpdateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingInput = {
  greeting: Scalars['String'];
};

export type UploadCustomThemeAssetPayload = {
  assetId: Scalars['String'];
  eventId: Scalars['ID'];
  height?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type createMediaFromUrlsInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  magicToken?: InputMaybe<Scalars['String']>;
  photos: Array<PhotoInput>;
};

export type PhotoInput = {
  assetId: Scalars['String'];
  handle?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type UploadPhotoFromUrlPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

export enum PhotoEnvelopeActionCode {
  /** Processing is not possible, and never will be; do not retry */
  abandon = 'abandon',
  /** Processing failed; please retry */
  retry = 'retry',
  /** Processing was successful */
  success = 'success'
}

export type UpsertCustomThemePayload = {
  description?: InputMaybe<Scalars['String']>;
  desktopThemeAssetId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  mobileThemeAssetId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type UpsertStationeryTagInput = {
  category?: InputMaybe<Scalars['String']>;
  displayLabel: Scalars['String'];
  name: Scalars['String'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailPayload = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type WebsiteActivateHeaderForDesignInput = {
  designId: Scalars['String'];
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteActivateHeaderForEventInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteApplyHeaderPresentationSettingsInput = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type websiteCreateOrUpdatePagePhotoPresentationPayload = {
  cropInfo?: InputMaybe<WebsitePagePhotoPresentationCropInfoInput>;
  id?: InputMaybe<Scalars['ID']>;
  pageId?: InputMaybe<Scalars['ID']>;
  /** fullWidth, center */
  presentationLayout: Scalars['String'];
};

export type WebsitePagePhotoPresentationCropInfoInput = {
  height: Scalars['Float'];
  /** percent */
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type WebsiteRemoveActiveHeaderForEventInput = {
  eventId: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type CalendarDate = {
  dayOfMonth: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

/** Represents the role of the user accessing the cash fund. */
export enum CashFundRole {
  admin = 'admin'
}

/** Different types of checkout mechanisms we support */
export enum CheckoutMechanismType {
  /** external link */
  externalNavigation = 'externalNavigation',
  /** we ship it */
  joyWeb = 'joyWeb'
}

export type ContactAuthorizedUseInput = {
  allow: Scalars['Boolean'];
  contactListId: Scalars['String'];
  householdId: Scalars['String'];
  personId: Scalars['String'];
};

export type ContactHouseholdInput = {
  displayName?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
};

export type CreateEventPayload = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  calendarDate?: InputMaybe<CalendarDate>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Float']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fianceeLastName: Scalars['String'];
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
};

export type CreateRegistryOrderInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type EmailMessageInput = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type EventFeaturePreferenceOptions = {
  considerThemeSupport?: InputMaybe<Scalars['Boolean']>;
};

export enum FormActionType {
  ADD_CONTACT_TO_GUEST_LIST = 'ADD_CONTACT_TO_GUEST_LIST',
  SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL',
  SET_ATTENDANCE = 'SET_ATTENDANCE'
}

/**
 * Machine-readable error codes returned in GraphQL error extensions.
 * Use these values to match on specific error conditions in client code.
 */
export enum FormServiceErrorCode {
  ANSWER_ATTENDANCE_ANSWER_REQUIRED = 'ANSWER_ATTENDANCE_ANSWER_REQUIRED',
  ANSWER_CONTACT_UPDATE_FAILED = 'ANSWER_CONTACT_UPDATE_FAILED',
  ANSWER_GUEST_KEY_REQUIRED = 'ANSWER_GUEST_KEY_REQUIRED',
  ANSWER_INVALID_APPROVAL_FLOW = 'ANSWER_INVALID_APPROVAL_FLOW',
  ANSWER_SUBMISSION_FAILED = 'ANSWER_SUBMISSION_FAILED',
  ANSWER_TICKET_TYPE_REQUIRED = 'ANSWER_TICKET_TYPE_REQUIRED',
  FORM_INVALID_SETTINGS = 'FORM_INVALID_SETTINGS',
  FORM_NO_EVENT = 'FORM_NO_EVENT',
  FORM_NOT_FOUND = 'FORM_NOT_FOUND',
  FORM_NOT_REGISTRATION_TYPE = 'FORM_NOT_REGISTRATION_TYPE',
  REGISTRATION_INVALID_STATE = 'REGISTRATION_INVALID_STATE',
  REGISTRATION_NO_FORM = 'REGISTRATION_NO_FORM',
  REGISTRATION_NOT_FOUND = 'REGISTRATION_NOT_FOUND',
  TICKETING_ORDER_ALREADY_CANCELLED = 'TICKETING_ORDER_ALREADY_CANCELLED',
  TICKETING_ORDER_INVALID_INPUT = 'TICKETING_ORDER_INVALID_INPUT',
  TICKETING_ORDER_INVALID_STATE = 'TICKETING_ORDER_INVALID_STATE',
  TICKETING_ORDER_NOT_FOUND = 'TICKETING_ORDER_NOT_FOUND',
  TICKETING_SALES_DATE_INVALID = 'TICKETING_SALES_DATE_INVALID',
  TICKETING_SOLD_OUT = 'TICKETING_SOLD_OUT',
  TICKETING_TICKET_INVALID_STATE = 'TICKETING_TICKET_INVALID_STATE',
  TICKETING_TICKET_NO_TYPE = 'TICKETING_TICKET_NO_TYPE',
  TICKETING_TICKET_NOT_FOUND = 'TICKETING_TICKET_NOT_FOUND',
  TICKETING_TICKET_PAYMENT_INCOMPLETE = 'TICKETING_TICKET_PAYMENT_INCOMPLETE',
  TICKETING_TICKET_TYPE_DUPLICATE_NAME = 'TICKETING_TICKET_TYPE_DUPLICATE_NAME',
  TICKETING_TICKET_TYPE_HAS_SALES = 'TICKETING_TICKET_TYPE_HAS_SALES',
  TICKETING_TICKET_TYPE_INVALID_INPUT = 'TICKETING_TICKET_TYPE_INVALID_INPUT',
  TICKETING_TICKET_TYPE_NOT_FOUND = 'TICKETING_TICKET_TYPE_NOT_FOUND',
  TICKETING_TICKET_TYPE_NOT_FREE = 'TICKETING_TICKET_TYPE_NOT_FREE',
  TICKETING_TICKET_TYPE_UNAVAILABLE = 'TICKETING_TICKET_TYPE_UNAVAILABLE'
}

export type InviteNewVendorToEventPayload = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum ItemDiscountPolicyClause {
  CANNOT_DROPSHIP = 'CANNOT_DROPSHIP',
  IS_EXTERNAL = 'IS_EXTERNAL',
  IS_NOT_A_CATALOG_ITEM = 'IS_NOT_A_CATALOG_ITEM',
  IS_NOT_A_GIFT = 'IS_NOT_A_GIFT',
  IS_NOT_NEEDED = 'IS_NOT_NEEDED',
  IS_NOT_SHIPPABLE = 'IS_NOT_SHIPPABLE',
  QUANTITY_EXCEEDS_LIMIT = 'QUANTITY_EXCEEDS_LIMIT',
  WAS_ADDED_AFTER_EVENT_DATE = 'WAS_ADDED_AFTER_EVENT_DATE'
}

export type PageComponentPayload = {
  sortOrder: Scalars['Float'];
  text?: InputMaybe<Scalars['String']>;
  type: ComponentType;
  url?: InputMaybe<Scalars['String']>;
};

export enum ProductCatalogItemFulfillmentMethod {
  default = 'default',
  email = 'email'
}

export enum ProductCatalogItemType {
  cash = 'cash',
  charity = 'charity',
  experience = 'experience',
  gift_card = 'gift_card',
  product = 'product',
  travel = 'travel'
}

export type PublishEventDesignDraftPayload = {
  eventDesignId: Scalars['ID'];
};

export enum RegistrationApprovalFlow {
  AUTOMATIC = 'AUTOMATIC',
  GUEST_LIST_APPROVAL = 'GUEST_LIST_APPROVAL'
}

export enum RegistryChecklistItemType {
  registryItem = 'registryItem'
}

export enum RegistryDiscountPolicyClause {
  BEFORE_EVENT_DATE = 'BEFORE_EVENT_DATE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE = 'NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE',
  NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE = 'NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE',
  NOT_AN_ADMIN = 'NOT_AN_ADMIN',
  PAST_POST_WEDDING_DISCOUNT_END_DATE = 'PAST_POST_WEDDING_DISCOUNT_END_DATE'
}

export enum RegistryFulfillmentStatusType {
  processing = 'processing',
  shipped = 'shipped'
}

export enum RegistryPayoutAccountWithdrawalStatus {
  failed = 'failed',
  pending = 'pending',
  succeeded = 'succeeded'
}

export type StationeryProductChoiceInput = {
  attributeId: Scalars['ID'];
  attributeOptionId: Scalars['ID'];
};

export type StationeryProductInput = {
  choices: Array<StationeryProductChoiceInput>;
  productId: Scalars['ID'];
};

export type UpdateEventPayload = {
  website: Scalars['String'];
};

export enum WarehouseFulfillmentMethod {
  /** Standard Physical Item Shipping */
  default = 'default',
  /** E-Delivery */
  email = 'email',
  /**
   * Using the option of 'none' will trigger order fulfillment step to be skipped in commerce service for this item
   * avoiding unnecessary fees from Shopify and Logic Broker.  This is designed for features like Joy eCards that are
   * fulfilled with an automated email and do not need physical shipping, tracking, 3rd party vender interactions, returns, etc.
   */
  none = 'none',
  /** Joy Wallet / CC4$ Payout */
  payout = 'payout',
  /** Travel Fulfillment */
  travel = 'travel'
}

export enum WarehouseInventoryCheckResult {
  insufficientInventory = 'insufficientInventory',
  inventoryOK = 'inventoryOK',
  skuNotFound = 'skuNotFound',
  supplierProductNotFound = 'supplierProductNotFound'
}

export enum WarehouseTaxCode {
  cash_fund = 'cash_fund',
  default = 'default',
  /**
   * Digital Greeting Cards - Static text and/or images only  14111605A0003
   * An electronic greeting "card" typically sent via email that contains only static images or text
   * rather than an audio visual or audio only experience.
   */
  ecard_static = 'ecard_static',
  gift_card = 'gift_card',
  /**
   * Tax code: 82121500A0000
   * A charge for the printing, imprinting, lithographing, mimeographing, photocopying, and similar
   * reproductions of various articles including mailers, catalogs, letterhead, envelopes, business cards,
   * presentation folders, forms, signage, etc. The end result is the transfer of tangible personal property to the customer.
   */
  print_card = 'print_card',
  /** Yet TBD */
  travel_accommodation = 'travel_accommodation'
}

export type CreateGeneralEventLandingCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateGeneralEventLandingCategoriesQuery = { __typename?: 'Query', eventTypeCategories: Array<string> };

export type GeneralEventTypeFragment = { __typename?: 'EventTypesConfig', id: string, enabled: boolean, deleted: boolean, title: string, description: string, category: string, categorySubtype: string, configJson: any, schemaUrl: string };

export type CreateGeneralEventEventTypesByCategoryQueryVariables = Exact<{
  filters: EventTypesByCategoryFilters;
}>;


export type CreateGeneralEventEventTypesByCategoryQuery = { __typename?: 'Query', eventTypesByCategory: Array<{ __typename?: 'EventTypesConfig', id: string, enabled: boolean, deleted: boolean, title: string, description: string, category: string, categorySubtype: string, configJson: any, schemaUrl: string }> };

export type GetAllowedDesignParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedDesignParamsQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'Theme', id: string, themeId: string }>, fonts: Array<{ __typename?: 'Font', id: string, display: string }> };

export type CreateEventMutationVariables = Exact<{
  payload: CreateEventPayload0301;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEventV0301?: { __typename: 'Event', website: string, eventId: string, firebaseId: string, id: string, firebaseCreateAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, eventType: EventType, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string } } | null } | null };

export type CreateGeneralEventMutationVariables = Exact<{
  payload: CreateGeneralEventPayload;
}>;


export type CreateGeneralEventMutation = { __typename?: 'Mutation', createGeneralEvent?: { __typename: 'Event', website: string, eventId: string, firebaseId: string, id: string, firebaseCreateAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, eventType: EventType, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string } } | null } | null };

export type SetAndPublishThemeLayoutForCreateSurveyMutationVariables = Exact<{
  themeAndLayoutPayload: SetThemeAndLayoutPayload;
  eventDesignId: Scalars['ID'];
}>;


export type SetAndPublishThemeLayoutForCreateSurveyMutation = { __typename?: 'Mutation', setThemeAndLayout: { __typename?: 'EventDesign', id: string }, publishEventDesignDraft: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, theme: { __typename?: 'Theme', id: string, themeId: string } } };

export type RegistryPhotoByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type RegistryPhotoByEventIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } | null };

export type GetInlineEditEventInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetInlineEditEventInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null } } | null };

export type GetPagePhotoInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  type?: InputMaybe<EventPageType>;
  eventDesignPurpose?: InputMaybe<EventDesignPurpose>;
}>;


export type GetPagePhotoInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pagesInfo?: Array<{ __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null } }> | null, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null } | null };

export type EventWebsitePagesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type EventWebsitePagesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', visibility: EventPageVisibility, pageSlug: string, id: string, type: EventPageType, pageTitle: string, createdAt: { __typename?: 'Date', timestamp: any } }> } | null };

export type EventWebsitePagesVisibilityQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type EventWebsitePagesVisibilityQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', visibility: EventPageVisibility, id: string, type: EventPageType, pageSlug: string }> } | null };

export type UpdateAccommodationsSortOrderDataQueryVariables = Exact<{
  payload: PageContainerBySlugPayload;
  options?: InputMaybe<PageContainerBySlugOptions>;
  name: Scalars['String'];
}>;


export type UpdateAccommodationsSortOrderDataQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent' } | { __typename?: 'TravelMapComponent', id: string, sortOrder: number, blockOrdering?: Array<string> | null } | { __typename?: 'VideoComponent' }> | null } | null, eventByName?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string }> } | null };

export type GetTagsByEventQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetTagsByEventQuery = { __typename?: 'Query', getTagsByEvent: Array<{ __typename?: 'TagDefinition', id: string, label: string, createdAt: any }> };

export type GetTagsByResourceQueryVariables = Exact<{
  eventId: Scalars['String'];
  resourceId: Scalars['String'];
}>;


export type GetTagsByResourceQuery = { __typename?: 'Query', getTagsByResource: Array<{ __typename?: 'TagDefinition', id: string, label: string }> };

export type GetGuestListMembersByTagIdsQueryVariables = Exact<{
  eventId: Scalars['String'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetGuestListMembersByTagIdsQuery = { __typename?: 'Query', getGuestListMembersByTagIds: Array<{ __typename?: 'GuestListMember', id: string, tags: Array<{ __typename?: 'GuestListMemberTag', tagDefinitionId: string }> }> };

export type GetTagsByResourcesQueryVariables = Exact<{
  eventId: Scalars['String'];
  resourceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetTagsByResourcesQuery = { __typename?: 'Query', getTagsByResources: Array<{ __typename?: 'ResourceTags', resourceId: string, tags: Array<{ __typename?: 'TagDefinition', id: string, label: string }> }> };

export type CreateTagMutationVariables = Exact<{
  eventId: Scalars['String'];
  label: Scalars['String'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagDefinition', id: string, label: string } };

export type SetTagsForResourceMutationVariables = Exact<{
  eventId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetTagsForResourceMutation = { __typename?: 'Mutation', setTagsForResource?: any | null };

export type GetUniversalBurgerMenuDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetUniversalBurgerMenuDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, location?: string | null, tentativeDate?: { __typename?: 'Date', timestamp: any } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null, pages: Array<{ __typename?: 'EventPage', visibility: EventPageVisibility, pageSlug: string, id: string, type: EventPageType, pageTitle: string }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null } | null };

export type VIPEditorCreateVIPMutationVariables = Exact<{
  payload: CreateVipPayload;
}>;


export type VIPEditorCreateVIPMutation = { __typename?: 'Mutation', createVip: { __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } };

export type VIPEditorUpdateVIPMutationVariables = Exact<{
  payload: UpdateVipPayload;
}>;


export type VIPEditorUpdateVIPMutation = { __typename?: 'Mutation', updateVip: { __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } };

export type VIPEditorVIPByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VIPEditorVIPByIdQuery = { __typename?: 'Query', vip: { __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } };

export type ContactCollectionEventFragment = { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, fianceeFirstName?: string | null, dateV0918?: { __typename?: 'Date', dateString: string } | null } };

export type GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables = Exact<{
  eventId: Scalars['String'];
  eventHandle: Scalars['String'];
}>;


export type GetContactCollectionByEventIdAndNamesByEventHandleQuery = { __typename?: 'Query', getContactCollectionByEventId?: { __typename?: 'ContactCollection', id: string, eventDateDisplayEnabled: boolean, websiteLinkEnabled: boolean, mediaSource: string, mediaType: string, message: string, magicLink: string, active?: boolean | null, collectHousehold?: boolean | null, contacts?: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, createdAt: any } | null> | null } | null, eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, fianceeFirstName?: string | null, dateV0918?: { __typename?: 'Date', dateString: string } | null } } | null };

export type GetContactCollectionByMagicLinkQueryVariables = Exact<{
  magicLink: Scalars['String'];
}>;


export type GetContactCollectionByMagicLinkQuery = { __typename?: 'Query', getContactCollectionByMagicLink?: { __typename?: 'ContactCollection', id: string, eventId?: string | null, eventDateDisplayEnabled: boolean, mediaSource: string, mediaType: string, message: string, websiteLinkEnabled: boolean, active?: boolean | null, collectHousehold?: boolean | null } | null };

export type GetDataForContactCollectionGuestQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetDataForContactCollectionGuestQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, firebaseId: string, website: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, dateV0918?: { __typename?: 'Date', dateString: string } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null } | null };

export type GetTelemetryDataForContactCollectionGuestQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetTelemetryDataForContactCollectionGuestQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, firebaseId: string, website: string, info: { __typename?: 'EventInfo', id: string, eventType: EventType } } | null };

export type GetContactsByContactCollectionQueryVariables = Exact<{
  contactCollectionId: Scalars['ID'];
}>;


export type GetContactsByContactCollectionQuery = { __typename?: 'Query', getContactsByContactCollection?: Array<{ __typename?: 'Contact', id: string } | null> | null };

export type AuthenticateUserQueryVariables = Exact<{
  authToken: Scalars['String'];
}>;


export type AuthenticateUserQuery = { __typename?: 'Query', authenticateUser?: { __typename?: 'AuthenticatedUserResult', userJWT: string } | null };

export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables = Exact<{
  firebaseEventId: Scalars['ID'];
}>;


export type GetContactCollectionByFirebaseEventIdOrCreateOneQuery = { __typename?: 'Query', getContactCollectionByFirebaseEventIdOrCreateOne?: { __typename?: 'ContactCollection', id: string, eventId?: string | null } | null };

export type CreateContactCollectionMutationVariables = Exact<{
  data: ContactCollectionInput;
}>;


export type CreateContactCollectionMutation = { __typename?: 'Mutation', createContactCollection: { __typename?: 'ContactCollection', id: string, magicLink: string } };

export type UpdateContactCollectionMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ContactCollectionInput;
}>;


export type UpdateContactCollectionMutation = { __typename?: 'Mutation', updateContactCollection: { __typename?: 'ContactCollection', id: string, magicLink: string } };

export type CreateContactMutationVariables = Exact<{
  data: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, householdId: string } };

export type CreateContactsWithoutTagsMutationVariables = Exact<{
  data: Array<ContactInputWithoutTags> | ContactInputWithoutTags;
}>;


export type CreateContactsWithoutTagsMutation = { __typename?: 'Mutation', createContactsWithoutTags: Array<{ __typename?: 'Contact', id: string }> };

export type UpdateContactMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, householdId: string } };

export type DeleteContactsByContactIdsMutationVariables = Exact<{
  contactIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteContactsByContactIdsMutation = { __typename?: 'Mutation', deleteContactsByContactIds: Array<{ __typename?: 'Contact', id: string }> };

export type GuestFragment = { __typename?: 'Contact', id: string, householdId: string, firstName: string, lastName: string, email?: string | null, legacyAddressString?: string | null, household?: { __typename?: 'ContactHousehold', id: string, displayName?: string | null, address?: { __typename?: 'ContactAddress', id: string, address1: string, address2?: string | null, country: string, countryCode: string, region: string, city: string, postalCode: string, validated: boolean } | null } | null, phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber', id: string, number: string } | null> | null };

export type GetContactsByIdsGuestListQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetContactsByIdsGuestListQuery = { __typename?: 'Query', getContactsByIds?: Array<{ __typename?: 'Contact', id: string, householdId: string, firstName: string, lastName: string, email?: string | null, legacyAddressString?: string | null, household?: { __typename?: 'ContactHousehold', id: string, displayName?: string | null, address?: { __typename?: 'ContactAddress', id: string, address1: string, address2?: string | null, country: string, countryCode: string, region: string, city: string, postalCode: string, validated: boolean } | null } | null, phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber', id: string, number: string } | null> | null } | null> | null };

export type GetContactCollectionByEventIdOrCreateOneQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetContactCollectionByEventIdOrCreateOneQuery = { __typename?: 'Query', getContactCollectionByEventIdOrCreateOne?: { __typename?: 'ContactCollection', id: string } | null };

export type CreateContactsWithoutTagsGuestListMutationVariables = Exact<{
  data: Array<ContactInputWithoutTags> | ContactInputWithoutTags;
}>;


export type CreateContactsWithoutTagsGuestListMutation = { __typename?: 'Mutation', createContactsWithoutTags: Array<{ __typename?: 'Contact', id: string, householdId: string, firstName: string, lastName: string, email?: string | null, legacyAddressString?: string | null, household?: { __typename?: 'ContactHousehold', id: string, displayName?: string | null, address?: { __typename?: 'ContactAddress', id: string, address1: string, address2?: string | null, country: string, countryCode: string, region: string, city: string, postalCode: string, validated: boolean } | null } | null, phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber', id: string, number: string } | null> | null }> };

export type UpdateContactGuestListMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ContactInput;
}>;


export type UpdateContactGuestListMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, householdId: string, firstName: string, lastName: string, email?: string | null, legacyAddressString?: string | null, household?: { __typename?: 'ContactHousehold', id: string, displayName?: string | null, address?: { __typename?: 'ContactAddress', id: string, address1: string, address2?: string | null, country: string, countryCode: string, region: string, city: string, postalCode: string, validated: boolean } | null } | null, phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber', id: string, number: string } | null> | null } };

export type DeleteContactsByContactIdsGuestListMutationVariables = Exact<{
  contactIds: Array<Scalars['ID']> | Scalars['ID'];
  firebaseEventId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteContactsByContactIdsGuestListMutation = { __typename?: 'Mutation', deleteContactsByContactIds: Array<{ __typename?: 'Contact', id: string }> };

export type AttendanceByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type AttendanceByEventIdQuery = { __typename?: 'Query', attendanceByEventId: Array<{ __typename: 'Attendance', id: string, guestKey: string, attendanceState: AttendanceState, createdAt: any }> };

export type SetAttendanceByGuestKeyMutationVariables = Exact<{
  input: AttendanceInput;
}>;


export type SetAttendanceByGuestKeyMutation = { __typename?: 'Mutation', setAttendanceByGuestKey: { __typename: 'Attendance', id: string, guestKey: string, attendanceState: AttendanceState, createdAt: any } };

export type SendHotelBlockReminderMutationVariables = Exact<{
  payload: SendHotelReminderEmailV2Input;
}>;


export type SendHotelBlockReminderMutation = { __typename?: 'Mutation', sendHotelBlockReminderEmailV2?: any | null };

export type SendHotelBlockReminderEmailMutationVariables = Exact<{
  payload: SendHotelReminderEmailV2Input;
}>;


export type SendHotelBlockReminderEmailMutation = { __typename?: 'Mutation', sendHotelBlockReminderEmailV2?: any | null };

export type SendGeneralMessageMutationVariables = Exact<{
  data: SendJoyJsonMessageEmailInput;
}>;


export type SendGeneralMessageMutation = { __typename?: 'Mutation', sendJoyJsonMessageEmail?: any | null };

export type SendTestGeneralMessageMutationVariables = Exact<{
  data: SendTestJoyJsonMessageEmailInput;
}>;


export type SendTestGeneralMessageMutation = { __typename?: 'Mutation', sendTestJoyJsonMessageEmail?: any | null };

export type SendGeneralMessageByPeopleIdsMutationVariables = Exact<{
  data: SendJoyJsonMessageEmailByPeopleIdsInput;
}>;


export type SendGeneralMessageByPeopleIdsMutation = { __typename?: 'Mutation', sendJoyJsonMessageEmailByPeopleIds?: any | null };

export type GetMessageBatchesByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetMessageBatchesByEventIdQuery = { __typename?: 'Query', getMessageBatchesByEventId: Array<{ __typename?: 'MessageBatch', displayLabel: string, messageType?: string | null, id: string, sentOn: { __typename?: 'Date', milliseconds: number } }> };

export type GetQuarantinedMessagesByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetQuarantinedMessagesByEventIdQuery = { __typename?: 'Query', contactQuarantinedMessageBatchesByEventId: Array<{ __typename?: 'SanitizedContactQuarantinedMessageBatchDetails', id: string, createdAt: any, messageBatchType: string, messageBatchId: string, eventId: string, messageBatchPayload: any }> };

export type GetMessageStatusesQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['String']>;
  criteria?: InputMaybe<MessageSearchQueryCriteria>;
}>;


export type GetMessageStatusesQuery = { __typename?: 'Query', messageSearchResults: { __typename?: 'MessageSearchResultContainer', allResult: { __typename?: 'MessageResult', messages: Array<{ __typename?: 'Message', status: MessageStatus, id: string }> } } };

export type EventByNameForGuestNameQueryVariables = Exact<{
  name: Scalars['String'];
  admin?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventByNameForGuestNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, guests: { __typename?: 'EventGuests', people: Array<{ __typename?: 'Person', id: string, fullName?: string | null, firstName?: string | null, email?: string | null, phoneNumber?: string | null }> } } | null };

export type MessageSearchResultsQueryVariables = Exact<{
  criteria?: InputMaybe<MessageSearchQueryCriteria>;
  eventId?: InputMaybe<Scalars['String']>;
}>;


export type MessageSearchResultsQuery = { __typename?: 'Query', messageSearchResults: { __typename?: 'MessageSearchResultContainer', allResult: { __typename?: 'MessageResult', messages: Array<{ __typename?: 'Message', id: string, type: MessageType, status: MessageStatus, messageId?: string | null, sentOn?: { __typename?: 'Date', milliseconds: number } | null, lastStatusUpdate?: { __typename?: 'Date', milliseconds: number } | null, statusHistory: Array<{ __typename?: 'MessageStatusRecord', status: MessageStatus, date: { __typename?: 'Date', milliseconds: number } }>, recipient: { __typename?: 'RecipientInfo', personId?: string | null, email?: string | null, phoneNumber?: string | null, guestKey?: string | null }, messageBatch?: { __typename?: 'MessageBatch', id: string, displayLabel: string, messageType?: string | null } | null }> } } };

export type GetContactsByGuestKeyListQueryVariables = Exact<{
  eventId: Scalars['ID'];
  guestKeys: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetContactsByGuestKeyListQuery = { __typename?: 'Query', getContactsByGuestKeyList?: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, guestKey?: string | null, email?: string | null, phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber', id: string, number: string } | null> | null } | null> | null };

export type StationeryPrintOrderByIdQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type StationeryPrintOrderByIdQuery = { __typename?: 'Query', stationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string, orderNumber: string, printCardFrontPreviewUrl: string, cardDraftJSONBlob?: any | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum, name?: string | null } } | null } | null };

export type StationeryDigitalCardViewByOrderIdQueryVariables = Exact<{
  cardViewInput?: InputMaybe<GetStationeryDigitalViewInput>;
}>;


export type StationeryDigitalCardViewByOrderIdQuery = { __typename?: 'Query', stationeryDigitalCardView: Array<{ __typename?: 'StationeryDigitalView', id: number, personId: string, src: StationeryDigitalViewSource }> };

export type SmsByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SmsByIdQuery = { __typename?: 'Query', sms?: { __typename?: 'SMS', id: string, smsContent: string, status: string } | null };

export type GetMessagingTierByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetMessagingTierByEventIdQuery = { __typename?: 'Query', getMessagingSettingsByEventId?: { __typename?: 'MessagingSettings', id: string, eventId: string, messagingTier?: MessagingTier | null } | null };

export type UpdatePaidMessagingSettingsMutationVariables = Exact<{
  input: UpdatePaidMessagingSettingsInput;
}>;


export type UpdatePaidMessagingSettingsMutation = { __typename?: 'Mutation', updatePaidMessagingSettings: { __typename?: 'MessagingSettings', id: string, eventId: string, messagingTier?: MessagingTier | null } };

export type PostOfficeGenericEmailDraftFragment = { __typename?: 'PostOfficeGenericEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean };

export type PostOfficeReminderEmailDraftFragment = { __typename?: 'PostOfficeReminderEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean };

export type PostOfficeThankYouEmailDraftFragment = { __typename?: 'PostOfficeThankYouEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, personIds: Array<string>, personEmails?: Array<string> | null, assetId?: string | null, containerId?: string | null };

type PostOfficeDraft_PostOfficeGenericEmailDraft_Fragment = { __typename?: 'PostOfficeGenericEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean };

type PostOfficeDraft_PostOfficeGiftWrapEmailDraft_Fragment = { __typename?: 'PostOfficeGiftWrapEmailDraft' };

type PostOfficeDraft_PostOfficeGreetingCardEmailDraft_Fragment = { __typename?: 'PostOfficeGreetingCardEmailDraft' };

type PostOfficeDraft_PostOfficeReminderEmailDraft_Fragment = { __typename?: 'PostOfficeReminderEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean };

type PostOfficeDraft_PostOfficeThankYouEmailDraft_Fragment = { __typename?: 'PostOfficeThankYouEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, personIds: Array<string>, personEmails?: Array<string> | null, assetId?: string | null, containerId?: string | null };

export type PostOfficeDraftFragment = PostOfficeDraft_PostOfficeGenericEmailDraft_Fragment | PostOfficeDraft_PostOfficeGiftWrapEmailDraft_Fragment | PostOfficeDraft_PostOfficeGreetingCardEmailDraft_Fragment | PostOfficeDraft_PostOfficeReminderEmailDraft_Fragment | PostOfficeDraft_PostOfficeThankYouEmailDraft_Fragment;

export type PostOfficeDraftByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostOfficeDraftByIdQuery = { __typename?: 'Query', getPostOfficeDraft?: { __typename?: 'PostOfficeGenericEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } | { __typename?: 'PostOfficeGiftWrapEmailDraft' } | { __typename?: 'PostOfficeGreetingCardEmailDraft' } | { __typename?: 'PostOfficeReminderEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } | { __typename?: 'PostOfficeThankYouEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, personIds: Array<string>, personEmails?: Array<string> | null, assetId?: string | null, containerId?: string | null } | null };

export type PostOfficeDraftsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  messageType?: InputMaybe<PostOfficeMessageType>;
}>;


export type PostOfficeDraftsByEventIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, photoV2Url?: string | null, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }> } | null, getPostOfficeDraftsByEventId: Array<{ __typename?: 'PostOfficeGenericEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } | { __typename?: 'PostOfficeGiftWrapEmailDraft' } | { __typename?: 'PostOfficeGreetingCardEmailDraft' } | { __typename?: 'PostOfficeReminderEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } | { __typename?: 'PostOfficeThankYouEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, personIds: Array<string>, personEmails?: Array<string> | null, assetId?: string | null, containerId?: string | null }> };

export type SavePostOfficeGenericEmailDraftMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  includeAppInstructions: Scalars['Boolean'];
  includeWebsiteDetails: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
  salutation?: InputMaybe<Scalars['String']>;
  includeGuestNames: Scalars['Boolean'];
}>;


export type SavePostOfficeGenericEmailDraftMutation = { __typename?: 'Mutation', savePostOfficeGenericEmailDraft: { __typename?: 'PostOfficeGenericEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } };

export type SendPostOfficeGenericEmailMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  includeAppInstructions: Scalars['Boolean'];
  includeWebsiteDetails: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
  testName?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  includeGuestNames: Scalars['Boolean'];
}>;


export type SendPostOfficeGenericEmailMutation = { __typename?: 'Mutation', sendPostOfficeGenericEmail?: any | null };

export type SavePostOfficeReminderEmailDraftMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  includeAppInstructions: Scalars['Boolean'];
  includeWebsiteDetails: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
  salutation?: InputMaybe<Scalars['String']>;
  includeGuestNames: Scalars['Boolean'];
}>;


export type SavePostOfficeReminderEmailDraftMutation = { __typename?: 'Mutation', savePostOfficeReminderEmailDraft: { __typename?: 'PostOfficeReminderEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, includeAppInstructions: boolean, includeWebsiteDetails: boolean, includeEventPassword: boolean, personIds: Array<string>, salutation?: string | null, includeGuestNames: boolean } };

export type SendPostOfficeReminderEmailMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  includeAppInstructions: Scalars['Boolean'];
  includeWebsiteDetails: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
  testName?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  includeGuestNames: Scalars['Boolean'];
}>;


export type SendPostOfficeReminderEmailMutation = { __typename?: 'Mutation', sendPostOfficeReminderEmail?: any | null };

export type SavePostOfficeThankYouEmailDraftMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  personIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  personEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
}>;


export type SavePostOfficeThankYouEmailDraftMutation = { __typename?: 'Mutation', savePostOfficeThankYouEmailDraft: { __typename?: 'PostOfficeThankYouEmailDraft', id: string, eventId: string, subject: string, replyToEmail: string, message: string, imageUrl?: string | null, personIds: Array<string>, personEmails?: Array<string> | null, assetId?: string | null, containerId?: string | null } };

export type SendPostOfficeThankYouEmailMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  subject: Scalars['String'];
  replyToEmail: Scalars['String'];
  message: Scalars['String'];
  personIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  personEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  relation?: InputMaybe<EmailRelationInput>;
  footerText?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
}>;


export type SendPostOfficeThankYouEmailMutation = { __typename?: 'Mutation', sendPostOfficeThankYouEmail?: any | null };

export type ChatGPTTextCompletionQueryVariables = Exact<{
  prompt: Scalars['String'];
  modelVersion?: InputMaybe<AiModelVersion>;
}>;


export type ChatGPTTextCompletionQuery = { __typename?: 'Query', textCompletion: string };

export type CashFundGeneralErrorFragment = { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null };

export type CashFundPhotoFragment = { __typename?: 'Photo', id: string, url: string };

export type PublicCashFundFragment = { __typename?: 'CashFund', id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type AdminCashFundFragment = { __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type CashFundContributorFragment = { __typename?: 'CashFundContributor', id: string, fullName: string, email: string };

export type CashFundContributionFragment = { __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } };

export type CashFundOrderFragment = { __typename?: 'CashFundOrder', id: string, status: string, contributionAmount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalTaxes: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalFees: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, total: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } };

export type CashFundsPayoutAccountFragment = { __typename?: 'CashFundsPayoutAccount', status: string, onboardingUrl?: string | null, balance: { __typename?: 'CashFundsPayoutAccountBalance', received: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, availablePending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, available: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawnPending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawn: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, withdrawals: Array<{ __typename?: 'CashFundsPayoutAccountWithdrawal', id: string, status: string }> };

export type CashFundInviteFragment = { __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null };

export type PublicCashFundsHostFragment = { __typename?: 'CashFundsHost', id: string, firstName?: string | null, lastName?: string | null };

export type AdminCashFundsHostFragment = { __typename?: 'CashFundsHost', id: string, firstName?: string | null, lastName?: string | null, payoutAccount: { __typename?: 'CashFundsPayoutAccount', status: string, onboardingUrl?: string | null, balance: { __typename?: 'CashFundsPayoutAccountBalance', received: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, availablePending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, available: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawnPending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawn: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, withdrawals: Array<{ __typename?: 'CashFundsPayoutAccountWithdrawal', id: string, status: string }> }, cashFunds: Array<{ __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> };

export type CashFundSolicitationFragment = { __typename?: 'CashFundSolicitation', id: string, name?: string | null, status: string, inviteSubject: string, inviteMessage: string, config: { __typename?: 'CashFundSolicitationConfig', buttonText: string, salutation: string, includeRecipientNames: boolean, photo?: { __typename?: 'Photo', id: string, url: string } | null }, invites: Array<{ __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null }> };

export type FindCashFundsHostByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  returnRoute?: InputMaybe<Scalars['String']>;
}>;


export type FindCashFundsHostByEventIdQuery = { __typename?: 'Query', findCashFundsHostByEventId?: { __typename?: 'CashFundsHost', id: string, firstName?: string | null, lastName?: string | null, payoutAccount: { __typename?: 'CashFundsPayoutAccount', status: string, onboardingUrl?: string | null, balance: { __typename?: 'CashFundsPayoutAccountBalance', received: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, availablePending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, available: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawnPending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawn: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, withdrawals: Array<{ __typename?: 'CashFundsPayoutAccountWithdrawal', id: string, status: string }> }, cashFunds: Array<{ __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } | null };

export type GetCashFundsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetCashFundsByEventIdQuery = { __typename?: 'Query', getCashFundsByEventId: Array<{ __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> };

export type GetCashFundByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCashFundByIdQuery = { __typename?: 'Query', getCashFundById: { __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } };

export type InitCashFundsHostMutationVariables = Exact<{
  input: CreateCashFundsHostInput;
  returnRoute?: InputMaybe<Scalars['String']>;
}>;


export type InitCashFundsHostMutation = { __typename?: 'Mutation', initCashFundsHost: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'CashFundsHost', id: string, firstName?: string | null, lastName?: string | null, payoutAccount: { __typename?: 'CashFundsPayoutAccount', status: string, onboardingUrl?: string | null, balance: { __typename?: 'CashFundsPayoutAccountBalance', received: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, availablePending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, available: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawnPending: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, withdrawn: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, withdrawals: Array<{ __typename?: 'CashFundsPayoutAccountWithdrawal', id: string, status: string }> }, cashFunds: Array<{ __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } };

export type CreateCashFundMutationVariables = Exact<{
  input: CreateCashFundInput;
}>;


export type CreateCashFundMutation = { __typename?: 'Mutation', createCashFund: { __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type UpdateCashFundMutationVariables = Exact<{
  input: UpdateCashFundInput;
}>;


export type UpdateCashFundMutation = { __typename?: 'Mutation', updateCashFund: { __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type DuplicateCashFundMutationVariables = Exact<{
  input: DuplicateCashFundInput;
}>;


export type DuplicateCashFundMutation = { __typename?: 'Mutation', duplicateCashFund: { __typename?: 'CashFund', hideGoal: boolean, id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, totalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, totalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, contributions: Array<{ __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } }>, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type ArchiveCashFundMutationVariables = Exact<{
  cashFundId: Scalars['ID'];
}>;


export type ArchiveCashFundMutation = { __typename?: 'Mutation', archiveCashFund: { __typename?: 'ArchiveCashFundSuccess', id: string } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type ReactivateCashFundMutationVariables = Exact<{
  cashFundId: Scalars['ID'];
}>;


export type ReactivateCashFundMutation = { __typename?: 'Mutation', reactivateCashFund: { __typename?: 'CashFund', id: string, archived: boolean } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type CreateCashFundSolicitationMutationVariables = Exact<{
  input: CreateCashFundSolicitationInput;
}>;


export type CreateCashFundSolicitationMutation = { __typename?: 'Mutation', createCashFundSolicitation: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'CashFundSolicitation', id: string, name?: string | null, status: string, inviteSubject: string, inviteMessage: string, config: { __typename?: 'CashFundSolicitationConfig', buttonText: string, salutation: string, includeRecipientNames: boolean, photo?: { __typename?: 'Photo', id: string, url: string } | null }, invites: Array<{ __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null }> } };

export type UpdateCashFundSolicitationMutationVariables = Exact<{
  input: UpdateCashFundSolicitationInput;
}>;


export type UpdateCashFundSolicitationMutation = { __typename?: 'Mutation', updateCashFundSolicitation: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'CashFundSolicitation', id: string, name?: string | null, status: string, inviteSubject: string, inviteMessage: string, config: { __typename?: 'CashFundSolicitationConfig', buttonText: string, salutation: string, includeRecipientNames: boolean, photo?: { __typename?: 'Photo', id: string, url: string } | null }, invites: Array<{ __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null }> } };

export type ManageCashFundSolicitationRecipientsMutationVariables = Exact<{
  input: ManageCashFundSolicitationRecipientsInput;
}>;


export type ManageCashFundSolicitationRecipientsMutation = { __typename?: 'Mutation', manageCashFundSolicitationRecipients: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'CashFundSolicitation', id: string, name?: string | null, status: string, inviteSubject: string, inviteMessage: string, config: { __typename?: 'CashFundSolicitationConfig', buttonText: string, salutation: string, includeRecipientNames: boolean, photo?: { __typename?: 'Photo', id: string, url: string } | null }, invites: Array<{ __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null }> } };

export type SendCashFundSolicitationEmailsMutationVariables = Exact<{
  solicitationId: Scalars['ID'];
}>;


export type SendCashFundSolicitationEmailsMutation = { __typename?: 'Mutation', sendCashFundSolicitationEmails: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'SendCashFundSolicitationEmailsSuccess', id: string } };

export type SendCashFundSolicitationTestEmailMutationVariables = Exact<{
  input: SendCashFundSolicitationTestEmailInput;
}>;


export type SendCashFundSolicitationTestEmailMutation = { __typename?: 'Mutation', sendCashFundSolicitationTestEmail: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'SendCashFundSolicitationTestEmailSuccess', id: string } };

export type AcceptCashFundContributionMutationVariables = Exact<{
  contributionId: Scalars['ID'];
}>;


export type AcceptCashFundContributionMutation = { __typename?: 'Mutation', acceptCashFundContribution: { __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, order: { __typename?: 'CashFundOrder', id: string, status: string, contributionAmount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalTaxes: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalFees: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, total: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type RefundCashFundContributionMutationVariables = Exact<{
  contributionId: Scalars['ID'];
}>;


export type RefundCashFundContributionMutation = { __typename?: 'Mutation', refundCashFundContribution: { __typename?: 'CashFundContribution', id: string, message?: string | null, status: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, contributor: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } } | { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } };

export type WithdrawCashFundsPayoutAccountMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type WithdrawCashFundsPayoutAccountMutation = { __typename?: 'Mutation', withdrawCashFundsPayoutAccount: { __typename?: 'CashFundGeneralError', code: string, nativeMessage?: string | null } | { __typename?: 'CashFundsPayoutAccountWithdrawal', id: string, status: string } };

export type GetEventInfoByIdForDashboardQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventInfoByIdForDashboardQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null } | null };

export type GetWebsiteDesignerVisitStatusQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type GetWebsiteDesignerVisitStatusQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasVisitedDesignPage?: boolean | null } | null } | null };

export type GetUserConsentForEventQueryVariables = Exact<{
  consentKey: Scalars['String'];
  eventId: Scalars['ID'];
}>;


export type GetUserConsentForEventQuery = { __typename?: 'Query', userConsentKeyForEvent?: { __typename?: 'UserConsent', id: string, consentAnswer: boolean, consentKey: string, eventId: string } | null };

export type SetUserConsentForEventMutationVariables = Exact<{
  data: SaveUserConsentForEventInput;
}>;


export type SetUserConsentForEventMutation = { __typename?: 'Mutation', saveUserConsentKeyForEvent: { __typename?: 'UserConsent', id: string, consentAnswer: boolean, consentKey: string, eventId: string } };

export type GetEventCreationDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventCreationDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null }, firebaseCreateAt?: { __typename?: 'Date', timestamp: any } | null, eventDesign?: { __typename?: 'EventDesign', id: string, font: { __typename?: 'Font', id: string, fontFamily: string } } | null } | null };

export type GetDashboardV3BaseEventInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDashboardV3BaseEventInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, visibility: EventPageVisibility, pageSlug: string, type: EventPageType, pageTitle: string }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfInvites?: boolean | null, optOutOfWebsite?: boolean | null } | null } | null };

export type GetWebsitePreviewDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetWebsitePreviewDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, fianceeFirstName?: string | null, location?: string | null, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, guests: { __typename?: 'EventGuests', peopleCount: number, people: Array<{ __typename?: 'Person', id: string, legacyRsvpAnswers?: Array<{ __typename?: 'LegacyRsvpAnswer', answer?: string | null, questionId: string } | null> | null }> }, registry: { __typename?: 'EventData', id: string, itemCount: { __typename?: 'RegistryItemCount', available: number } }, eventDesign?: { __typename?: 'EventDesign', id: string, font: { __typename?: 'Font', id: string, fontFamily: string } } | null } | null };

export type GetRegistryOrdersIdsForAccordionQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryOrdersIdsForAccordionQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, orders?: Array<{ __typename?: 'RegistryOrder', id: string }> | null } } | null };

export type GetDashboardAccordionDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventId: Scalars['String'];
  getEcardsByEventIdId: Scalars['ID'];
  args?: InputMaybe<MessageRelationshipCriteria>;
}>;


export type GetDashboardAccordionDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, guests: { __typename?: 'EventGuests', peopleCount: number, people: Array<{ __typename?: 'Person', id: string, legacyRsvpAnswers?: Array<{ __typename?: 'LegacyRsvpAnswer', answer?: string | null, questionId: string } | null> | null }> }, registry: { __typename?: 'EventData', id: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null, itemCount: { __typename?: 'RegistryItemCount', available: number, purchasedOrReserved: number }, items: Array<{ __typename?: 'RegistryItem', id: string, donationFund?: { __typename?: 'DonationFund', id: string, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, donations: Array<{ __typename?: 'DonationFundDonation', id: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number } }> } | null }> }, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, numberOfRooms?: string | null } | null } | null, getMessageRelationships: Array<{ __typename?: 'MessageRelationResult', id: string } | null>, getContactCollectionByEventId?: { __typename?: 'ContactCollection', id: string, contacts?: Array<{ __typename?: 'Contact', id: string } | null> | null } | null, saveTheDatesECards: Array<{ __typename?: 'ElectronicCard', id: string }>, invitationsECards: Array<{ __typename?: 'ElectronicCard', id: string }>, stationeryPrintOrdersByEvent: { __typename?: 'StationeryPrintOrdersView', orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, quantity: number, cardDraft?: { __typename?: 'StationeryDraft', id: string, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum } } | null }> } };

export type DashboardChecklistItemFragment = { __typename?: 'ChecklistItem', id: string, title: string, subtitle?: string | null, action?: string | null, reminderAt?: any | null, completedAt?: any | null, subItems: Array<{ __typename?: 'ChecklistSubItem', id: string, title: string, action?: string | null, completedAt?: any | null }> };

export type GetDashboardChecklistDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDashboardChecklistDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', milliseconds: number } | null }, checklist?: { __typename?: 'EventChecklist', id: string, title: string, items: Array<{ __typename?: 'ChecklistItem', id: string, title: string, subtitle?: string | null, action?: string | null, reminderAt?: any | null, completedAt?: any | null, subItems: Array<{ __typename?: 'ChecklistSubItem', id: string, title: string, action?: string | null, completedAt?: any | null }> }> } | null } | null };

export type CompleteChecklistItemMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChecklistItemUpdateInput;
}>;


export type CompleteChecklistItemMutation = { __typename?: 'Mutation', updateChecklistItem: { __typename?: 'AuthenticationErrorType' } | { __typename?: 'BadRequestErrorType' } | { __typename?: 'ChecklistItem', id: string, completedAt?: any | null } | { __typename?: 'ForbiddenErrorType' } | { __typename?: 'InternalServerErrorType' } | { __typename?: 'NotFoundErrorType' } };

export type CompleteChecklistSubItemMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChecklistSubItemUpdateInput;
}>;


export type CompleteChecklistSubItemMutation = { __typename?: 'Mutation', updateChecklistSubItem: { __typename?: 'AuthenticationErrorType' } | { __typename?: 'BadRequestErrorType' } | { __typename?: 'ChecklistSubItem', id: string, completedAt?: any | null } | { __typename?: 'ForbiddenErrorType' } | { __typename?: 'InternalServerErrorType' } | { __typename?: 'NotFoundErrorType' } };

export type ReminderChecklistItemMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChecklistItemUpdateInput;
}>;


export type ReminderChecklistItemMutation = { __typename?: 'Mutation', updateChecklistItem: { __typename?: 'AuthenticationErrorType' } | { __typename?: 'BadRequestErrorType' } | { __typename?: 'ChecklistItem', id: string, reminderAt?: any | null } | { __typename?: 'ForbiddenErrorType' } | { __typename?: 'InternalServerErrorType' } | { __typename?: 'NotFoundErrorType' } };

export type GetRegistryOrdersIdsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryOrdersIdsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, orders?: Array<{ __typename?: 'RegistryOrder', id: string }> | null } } | null };

export type GetDashboardStatsDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventId: Scalars['String'];
  getEcardsByEventIdId: Scalars['ID'];
  args?: InputMaybe<MessageRelationshipCriteria>;
}>;


export type GetDashboardStatsDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, visibility: EventPageVisibility, pageSlug: string }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfInvites?: boolean | null, optOutOfWebsite?: boolean | null } | null, guests: { __typename?: 'EventGuests', peopleCount: number, people: Array<{ __typename?: 'Person', id: string, legacyRsvpAnswers?: Array<{ __typename?: 'LegacyRsvpAnswer', answer?: string | null, questionId: string } | null> | null }> }, registry: { __typename?: 'EventData', id: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null, itemCount: { __typename?: 'RegistryItemCount', available: number, purchasedOrReserved: number }, items: Array<{ __typename?: 'RegistryItem', id: string, donationFund?: { __typename?: 'DonationFund', id: string, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, donations: Array<{ __typename?: 'DonationFundDonation', id: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number } }> } | null }> }, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, numberOfRooms?: string | null } | null } | null, getMessageRelationships: Array<{ __typename?: 'MessageRelationResult', id: string } | null>, getContactCollectionByEventId?: { __typename?: 'ContactCollection', id: string, contacts?: Array<{ __typename?: 'Contact', id: string } | null> | null } | null, saveTheDatesECards: Array<{ __typename?: 'ElectronicCard', id: string }>, invitationsECards: Array<{ __typename?: 'ElectronicCard', id: string }>, stationeryPrintOrdersByEvent: { __typename?: 'StationeryPrintOrdersView', orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, quantity: number, cardDraft?: { __typename?: 'StationeryDraft', id: string, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum } } | null }> } };

export type GetDashboardPreviewPagesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDashboardPreviewPagesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, visibility: EventPageVisibility }> } | null };

export type DashboardPreviewStationeryTemplatesQueryVariables = Exact<{
  themeId: Scalars['String'];
}>;


export type DashboardPreviewStationeryTemplatesQuery = { __typename?: 'Query', stationeryTemplates: Array<{ __typename?: 'StationeryTemplate', id: string, themeId: string, thumbnailUrl?: string | null, category: StationeryTemplateCategoryEnum }> };

export type EventRedirectEventMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventRedirectEventMembershipsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, activeEventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, info: { __typename?: 'EventInfo', id: string, eventType: EventType, eventDisplayName?: string | null, location?: string | null, finalizedDate?: { __typename?: 'Date', milliseconds: number, dateString: string } | null }, style: { __typename?: 'EventStyle', id: string, primaryColorV0918: { __typename?: 'Color', hex: string } }, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null }> } | null };

export type ServiceCenterInfoByEventNameQueryVariables = Exact<{
  eventName: Scalars['String'];
}>;


export type ServiceCenterInfoByEventNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, featureFlags?: Array<string | null> | null, firebaseCreateAt?: { __typename?: 'Date', dateString: string } | null } | null };

export type CreateEventFeatureFlagMutationVariables = Exact<{
  eventId: Scalars['ID'];
  flag: Scalars['String'];
}>;


export type CreateEventFeatureFlagMutation = { __typename?: 'Mutation', createEventFeatureFlag: { __typename?: 'FeatureFlag', id: string, flag: string } };

export type DeleteEventFeatureFlagMutationVariables = Exact<{
  eventId: Scalars['ID'];
  flag: Scalars['String'];
}>;


export type DeleteEventFeatureFlagMutation = { __typename?: 'Mutation', deleteEventFeatureFlag?: any | null };

export type ResetOnboardingSurveyResponsesMutationVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type ResetOnboardingSurveyResponsesMutation = { __typename?: 'Mutation', updateRecommendRegistryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string } };

export type ResetShippingAddressMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type ResetShippingAddressMutation = { __typename?: 'Mutation', removeRegistryAddress: boolean };

export type ResetChecklistMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type ResetChecklistMutation = { __typename?: 'Mutation', deleteRegistryChecklist: boolean };

export type RegistryDataForResetFragment = { __typename?: 'Registry', id: string, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null, purchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string } | null>, reservedOrders: Array<{ __typename?: 'RegistryOrder', id: string } | null> };

export type GetRegistriesForDeletionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRegistriesForDeletionQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null, purchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string } | null>, reservedOrders: Array<{ __typename?: 'RegistryOrder', id: string } | null> }> } } | null };

export type TransferredRegistryFragment = { __typename?: 'Registry', id: string, isTransferredType: boolean };

export type GetTransferredRegistriesQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetTransferredRegistriesQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, isTransferredType: boolean }> } } | null };

export type RefreshDraftItemsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshDraftItemsMutation = { __typename?: 'Mutation', refreshRegistryDrafts?: { __typename?: 'Registry', id: string, draftItems?: Array<{ __typename?: 'RegistryItem', id: string }> | null } | null };

export type GetCatalogItemCountQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetCatalogItemCountQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, itemCount: { __typename?: 'RegistryItemCount', shippable: number } } } | null };

export type SubmitEventHotelRoomBlocksMutationVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type SubmitEventHotelRoomBlocksMutation = { __typename?: 'Mutation', hotelRoomBlocksSubmitted: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null } };

export type EventHotelRoomBlocksQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventHotelRoomBlocksQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null, eventDisplayName?: string | null, AnyOtherDetails?: string | null, PreferredContactMethod?: ContactMethods | null, bookingLink?: string | null, leadStateV2?: LeadStateV2 | null, leadStateV2UpdatedAt?: any | null, checkIn?: any | null, checkOut?: any | null, email?: string | null, numberOfRooms?: string | null, destination?: { __typename?: 'LeadDestination', name?: string | null, lat?: number | null, long?: number | null, postalCode?: string | null, address?: string | null } | null, concierge?: { __typename?: 'OwnerDetails', name?: string | null, email?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null } | null } | null };

export type SubmitLeadMutationVariables = Exact<{
  payload: HotelRoomBlockLeadInfoSubmittedRequest;
}>;


export type SubmitLeadMutation = { __typename?: 'Mutation', submitLead?: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null } | null };

export type EventHotelRoomBlocksRoomBlockManagerQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventHotelRoomBlocksRoomBlockManagerQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, customName?: string | null, address?: string | null, name?: string | null, lat?: number | null, long?: number | null, isFavorite?: boolean | null, isPhotoHidden?: boolean | null, starRating?: number | null, joyPlaceId?: string | null, isFromAccommodationCatalog: boolean, createdByType: string, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, cutoffDate: string, checkInDate: string, checkOutDate: string, pricePerNight?: number | null, isJoyManagedRoomBlock: boolean, strikeoutPricePerNight?: number | null, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus } | null }>, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, availablePerks?: Array<RoomBlockPerks> | null } | null } | null };

export type PageDetailsFragment = { __typename?: 'EventPage', id: string, pageTitle: string, disabled: boolean, type: EventPageType, pageSlug: string, visibility: EventPageVisibility, private: boolean, isPageContainer: boolean, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, createdAt: { __typename?: 'Date', timestamp: any }, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', height: number, unit: string, width: number, x: number, y: number } | null } | null };

export type WebsiteInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type WebsiteInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, photoV2Url?: string | null, firebaseId: string, hasMobilePhoto: boolean, photoV2UrlMobile?: string | null, websiteState: EventWebsiteState, photo?: { __typename?: 'Photo', id: string, url: string } | null, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null, liveEventDesign?: { __typename?: 'EventDesign', id: string, brannanNavigation: BrannanNavigation, theme: { __typename?: 'Theme', id: string, themeId: string }, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, websiteLayout: string, dataJSON: any, id: string } | null } | null, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null, safetyRating?: SafetyRating | null, announcementBanner: { __typename?: 'EventAnnouncementBanner', title: string, message: string, active: boolean }, schedule: { __typename?: 'EventScheduleInfo', items: Array<{ __typename?: 'EventSchedule', id: string, name: string, isMain: boolean, startTime?: { __typename?: 'Date', timestamp: any, timezone: string } | null }> }, finalizedDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null }, pages: Array<{ __typename?: 'EventPage', id: string, pageTitle: string, disabled: boolean, type: EventPageType, pageSlug: string, visibility: EventPageVisibility, private: boolean, isPageContainer: boolean, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, createdAt: { __typename?: 'Date', timestamp: any }, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', height: number, unit: string, width: number, x: number, y: number } | null } | null }>, mobilePhoto?: { __typename?: 'Photo', id: string, container: string, url: string } | null, pageContainers?: Array<{ __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null }> | null } | null, me?: { __typename?: 'User', id: string, emailIsVerified: boolean } | null };

export type UpdateEventSettingsMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateEventSettingsPayload;
}>;


export type UpdateEventSettingsMutation = { __typename?: 'Mutation', updateEventSettings: { __typename?: 'EventSettings', id: string, requirePasswordForEventDate: boolean, requirePasswordForEventLocation: boolean, hideDownloadAppPage: boolean, hideEventCountdown: boolean, hideFromJoySearch: boolean, hideFromSearchEngines: boolean } };

export type ReorderEventPagesMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: Array<ModelReorderPayload> | ModelReorderPayload;
}>;


export type ReorderEventPagesMutation = { __typename?: 'Mutation', reorderEventPages: Array<{ __typename?: 'EventPage', id: string, pageTitle: string, disabled: boolean, type: EventPageType, pageSlug: string, visibility: EventPageVisibility, private: boolean, isPageContainer: boolean, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, createdAt: { __typename?: 'Date', timestamp: any }, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', height: number, unit: string, width: number, x: number, y: number } | null } | null }> };

export type BatchUpdateEventPagesVisibilityMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payloads: Array<BatchUpdateEventPagesPayload> | BatchUpdateEventPagesPayload;
}>;


export type BatchUpdateEventPagesVisibilityMutation = { __typename?: 'Mutation', batchUpdateEventPages: Array<{ __typename?: 'EventPage', id: string, visibility: EventPageVisibility, type: EventPageType, pageTitle: string }> };

export type UpdateEventInfoSettingsMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateEventInfoPayload;
}>;


export type UpdateEventInfoSettingsMutation = { __typename?: 'Mutation', updateEventInfo: { __typename?: 'EventInfo', id: string, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, eventDateIsFinalized: boolean, timezone?: string | null, locale: string, announcementBanner: { __typename?: 'EventAnnouncementBanner', active: boolean, message: string, title: string }, tentativeDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null, finalizedDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, state?: string | null, city?: string | null, country?: string | null } | null } };

export type GeneralSettingsInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GeneralSettingsInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null, info: { __typename?: 'EventInfo', id: string, fianceeFirstName?: string | null, fianceeLastName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, eventDisplayName?: string | null, eventDateIsFinalized: boolean, timezone?: string | null, locale: string, finalizedDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null, tentativeDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, state?: string | null, city?: string | null, country?: string | null } | null } } | null };

export type SetEventAssetMutationVariables = Exact<{
  setEventAssetId: Scalars['ID'];
  payload: SetAssetPayload;
  isMobile?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetEventAssetMutation = { __typename?: 'Mutation', setEventAsset: { __typename?: 'Event', id: string, hasMobilePhoto: boolean, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, container: string } | null } };

export type DeleteEventAssetMutationVariables = Exact<{
  deleteEventAssetId: Scalars['ID'];
  isMobile?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteEventAssetMutation = { __typename?: 'Mutation', deleteEventAsset: { __typename?: 'Event', id: string, hasMobilePhoto: boolean, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, container: string } | null } };

export type UpdateMainEventScheduleMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventInfoPayload: UpdateEventInfoPayload;
  scheduleId: Scalars['ID'];
  updateSettings: Scalars['Boolean'];
  eventSettingsPayload: UpdateEventSettingsPayload;
}>;


export type UpdateMainEventScheduleMutation = { __typename?: 'Mutation', updateEventInfo: { __typename?: 'EventInfo', id: string, eventDateIsFinalized: boolean, tentativeDate?: { __typename?: 'Date', milliseconds: number, timezone: string, dateString: string } | null, finalizedDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null }, setMainEventSchedule: { __typename?: 'EventSchedule', id: string, name: string }, updateEventSettings?: { __typename?: 'EventSettings', id: string, hideEventCountdown: boolean } };

export type UpdateEventDateMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateEventInfoPayload;
}>;


export type UpdateEventDateMutation = { __typename?: 'Mutation', updateEventInfo: { __typename?: 'EventInfo', id: string, eventDateIsFinalized: boolean, timezone?: string | null, tentativeDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string } | null, finalizedDate?: { __typename?: 'Date', timezone: string, milliseconds: number, dateString: string, timeString: string } | null }, unsetMainEventSchedule?: { __typename?: 'EventSchedule', id: string } | null };

export type TravelSettingsMapComponentFragment = { __typename: 'TravelMapComponent', id: string, sortOrder: number, hideExploreCTA: boolean };

export type SettingsPageContainerBySlugQueryVariables = Exact<{
  eventName: Scalars['String'];
  pageSlug: Scalars['String'];
}>;


export type SettingsPageContainerBySlugQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent' } | { __typename: 'TravelMapComponent', id: string, sortOrder: number, hideExploreCTA: boolean } | { __typename?: 'VideoComponent' }> | null } | null, eventByName?: { __typename?: 'Event', id: string, travelSettings?: { __typename?: 'TravelSettings', currencyCode?: TravelCurrencyCode | null, checkInDate?: string | null, checkOutDate?: string | null, datesMatchingReminder?: boolean | null } | null } | null };

export type SetEventPhotoV2UrlMobileMutationVariables = Exact<{
  payload: SetEventPhotoV2MobilePayload;
}>;


export type SetEventPhotoV2UrlMobileMutation = { __typename?: 'Mutation', setEventPhotoV2UrlMobile: { __typename?: 'Event', id: string, photoV2UrlMobile?: string | null } };

export type UsersV2UserFragment = { __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null } };

export type SettingsUsersV2EventUsersQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SettingsUsersV2EventUsersQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null } }> } | null };

export type UsersV2PendingInviteFragment = { __typename?: 'CollaborationInvite', id: string, eventId: string, inviteeEmailAddress: string, inviteeFirstName: string, inviteeLastName: string, senderUserId: string, state: CollaborationInviteState };

export type SettingsUsersV2PendingInvitesQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SettingsUsersV2PendingInvitesQuery = { __typename?: 'Query', getPendingCollaborationInvitesByEventHandle: Array<{ __typename?: 'CollaborationInvite', id: string, eventId: string, inviteeEmailAddress: string, inviteeFirstName: string, inviteeLastName: string, senderUserId: string, state: CollaborationInviteState }> };

export type SettingsUsersV2SendInviteMutationVariables = Exact<{
  eventId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type SettingsUsersV2SendInviteMutation = { __typename?: 'Mutation', sendCollaborationInvite: { __typename?: 'CollaborationInvite', id: string, eventId: string, inviteeEmailAddress: string, inviteeFirstName: string, inviteeLastName: string, senderUserId: string, state: CollaborationInviteState } };

export type SettingsUsersV2ResendInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SettingsUsersV2ResendInviteMutation = { __typename?: 'Mutation', resendCollaborationInvite: { __typename?: 'CollaborationInvite', id: string, eventId: string, inviteeEmailAddress: string, inviteeFirstName: string, inviteeLastName: string, senderUserId: string, state: CollaborationInviteState } };

export type SettingsUsersV2RevokeInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SettingsUsersV2RevokeInviteMutation = { __typename?: 'Mutation', revokeCollaborationInvite?: any | null };

export type SetttingsUsersV2RevokeAccessMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventUserId: Scalars['ID'];
}>;


export type SetttingsUsersV2RevokeAccessMutation = { __typename?: 'Mutation', revokeCollaboratorAdminPermissions: boolean };

export type SettingsUsersV2TransferEventOwnershipMutationVariables = Exact<{
  eventId: Scalars['ID'];
  newOwnerEventUserId: Scalars['ID'];
}>;


export type SettingsUsersV2TransferEventOwnershipMutation = { __typename?: 'Mutation', transferEventOwnershipV2: { __typename?: 'EventUser', id: string, auth0Id: string, status: EventUserStatus } };

export type WebsiteEventColorsFragment = { __typename?: 'EventDesign', linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null };

export type CreateEventDesignMutationVariables = Exact<{
  payload: CreateEventDesignPayload;
}>;


export type CreateEventDesignMutation = { __typename?: 'Mutation', createEventDesign: { __typename?: 'EventDesign', purpose: EventDesignPurpose, id: string } };

export type DesignFavoriteQueryVariables = Exact<{
  eventId: Scalars['ID'];
  type?: InputMaybe<FavoriteType>;
}>;


export type DesignFavoriteQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, designFavorite?: Array<{ __typename?: 'DesignFavorite', id: string, resource: { __typename?: 'DesignLayout', id: string } | { __typename?: 'Font', id: string } | { __typename?: 'Theme', id: string, themeId: string }, secondaryResource?: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } | { __typename?: 'Font', id: string } | { __typename?: 'Theme', id: string, themeId: string } | null }> | null } | null };

export type ToggleDesignFavoritesMutationVariables = Exact<{
  payload: Array<ToggleDesignFavoriteInput> | ToggleDesignFavoriteInput;
}>;


export type ToggleDesignFavoritesMutation = { __typename?: 'Mutation', toggleDesignFavorites?: Array<{ __typename?: 'DesignFavorite', id: string }> | null };

export type CreatePaletteColorMutationVariables = Exact<{
  payload: CreateColorPayload;
}>;


export type CreatePaletteColorMutation = { __typename?: 'Mutation', createPaletteColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } } };

export type CreateArtBackgroundAndPageColorsMutationVariables = Exact<{
  artBackgroundPayload: CreateColorPayload;
  pageColorPayload: CreateColorPayload;
  pageFontColorPayload: CreateColorPayload;
}>;


export type CreateArtBackgroundAndPageColorsMutation = { __typename?: 'Mutation', createArtBackgroundColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } }, createPageColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } }, createPageFontColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } } };

export type CreatePageColorsMutationVariables = Exact<{
  pageColorPayload: CreateColorPayload;
  pageFontColorPayload: CreateColorPayload;
}>;


export type CreatePageColorsMutation = { __typename?: 'Mutation', createPageColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } }, createPageFontColor: { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string } } };

export type WebsiteApplyWebsiteColorsMutationVariables = Exact<{
  payload: ApplyWebsiteColorsPayload;
}>;


export type WebsiteApplyWebsiteColorsMutation = { __typename?: 'Mutation', applyWebsiteColors: { __typename?: 'EventDesign', id: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null } };

export type UpdateEventWebsiteStateMutationVariables = Exact<{
  payload: EventSetWebsiteStatePayload;
}>;


export type UpdateEventWebsiteStateMutation = { __typename?: 'Mutation', eventSetWebsiteState: { __typename?: 'Event', id: string, websiteState: EventWebsiteState } };

export type EnableVideoBackgroundFeatureMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EnableVideoBackgroundFeatureMutation = { __typename?: 'Mutation', websiteEnableVideoBackgroundFeature: { __typename?: 'FeatureFlag', id: string } };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'Query', themeVariants: Array<{ __typename?: 'ThemeMarketingData', variationType: ThemeVariationType, imageUrl: string, printUrl?: string | null, vendor: string, tags: Array<string>, colors: Array<string>, font?: string | null, variantColor?: string | null, variantName?: string | null, variantThemeId?: string | null, theme?: { __typename?: 'Theme', id: string, name: string, themeId: string, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string }> }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', id: string, featureName: string, rangeValue: number } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', id: string, featureName: string, booleanValue: boolean } | null } | null } | null }>, previews: Array<{ __typename?: 'ThemeMarketingData', variationType: ThemeVariationType, imageUrl: string, variantThemeId?: string | null }> };

export type ThemesListStationeryTemplatesQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
}>;


export type ThemesListStationeryTemplatesQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', edges: Array<{ __typename?: 'StationeryTemplateEdge', node: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum, thumbnailUrl?: string | null } }> } } };

export type UploadCustomThemeAssetMutationVariables = Exact<{
  payload: UploadCustomThemeAssetPayload;
}>;


export type UploadCustomThemeAssetMutation = { __typename?: 'Mutation', uploadCustomThemeAsset: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } };

export type UpsertCustomThemeMutationVariables = Exact<{
  payload: UpsertCustomThemePayload;
}>;


export type UpsertCustomThemeMutation = { __typename?: 'Mutation', upsertCustomTheme: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } };

export type CustomThemeAssetsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type CustomThemeAssetsByEventIdQuery = { __typename?: 'Query', customThemeAssetsByEventId: Array<{ __typename?: 'CustomThemeAsset', id: string, assetURL: string }> };

export type GetWebsiteHeaderInfoQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetWebsiteHeaderInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, greeting?: string | null } } | null };

export type GetEventPhotoV2QueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventPhotoV2Query = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, photoV2Url?: string | null, photoV2UrlMobile?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type SetEventPhotoV2UrlMutationVariables = Exact<{
  payload: SetEventPhotoV2Payload;
}>;


export type SetEventPhotoV2UrlMutation = { __typename?: 'Mutation', setEventPhotoV2Url: { __typename?: 'Event', id: string, photoV2Url?: string | null } };

export type WebsiteHeaderPresentationLayoutBySchemaQueryVariables = Exact<{
  payload: WebsiteHeaderPresentationLayoutBySchemaInput;
}>;


export type WebsiteHeaderPresentationLayoutBySchemaQuery = { __typename?: 'Query', websiteHeaderPresentationLayoutBySchema?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null };

export type ActiveWebsiteHeaderPresentationLayoutQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type ActiveWebsiteHeaderPresentationLayoutQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, websiteLayout: string, dataJSON: any, id: string } | null } | null, welcomePageInfo?: { __typename?: 'EventPageInfo', id: string, type: EventPageType, page: { __typename?: 'EventPage', id: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, height: number, width: number, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, height: number, width: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null } } | null } | null };

export type WebsiteApplyHeaderPresentationSettingsMutationVariables = Exact<{
  payload: WebsiteApplyHeaderPresentationSettingsInput;
}>;


export type WebsiteApplyHeaderPresentationSettingsMutation = { __typename?: 'Mutation', websiteApplyHeaderPresentationSettings: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, dataJSON: any, websiteLayout: string, id: string } };

export type WebsiteActivateHeaderLayoutMutationVariables = Exact<{
  payload: WebsiteActivateHeaderForDesignInput;
}>;


export type WebsiteActivateHeaderLayoutMutation = { __typename?: 'Mutation', websiteActivateHeaderLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, dataJSON: any, websiteLayout: string, id: string } | null };

export type WebsiteActivateHeaderLayoutForEventMutationVariables = Exact<{
  payload: WebsiteActivateHeaderForEventInput;
}>;


export type WebsiteActivateHeaderLayoutForEventMutation = { __typename?: 'Mutation', websiteActivateHeaderLayoutForEvent?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, dataJSON: any, websiteLayout: string, id: string } | null };

export type WebsiteRemoveActiveHeaderLayoutForEventMutationVariables = Exact<{
  payload?: InputMaybe<WebsiteRemoveActiveHeaderForEventInput>;
}>;


export type WebsiteRemoveActiveHeaderLayoutForEventMutation = { __typename?: 'Mutation', websiteRemoveActiveHeaderLayoutForEvent?: any | null };

export type MonogramLayoutTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MonogramLayoutTemplatesQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'StationeryTemplateEdge', cursor: any, node: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeJSON: any, themeId: string, thumbnailUrl?: string | null } }> } } };

export type UpdateEventDisplayNameMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventDisplayName: Scalars['String'];
}>;


export type UpdateEventDisplayNameMutation = { __typename?: 'Mutation', updateEventInfo: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null } };

export type GetGreetingMessageQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetGreetingMessageQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, greeting?: string | null } } | null };

export type UpdateWebsiteEventGreetingMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateGreetingInput;
}>;


export type UpdateWebsiteEventGreetingMutation = { __typename?: 'Mutation', updateWebsiteEventGreeting: { __typename?: 'EventGreetingResponse', eventId: string, greeting: string } };

export type ApplyFontPackByNameMutationVariables = Exact<{
  eventDesignId: Scalars['ID'];
  fontPackName: Scalars['String'];
}>;


export type ApplyFontPackByNameMutation = { __typename?: 'Mutation', applyFontPackByName?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null };

export type EventThemesForTemplatesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type EventThemesForTemplatesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, themes: Array<{ __typename?: 'Theme', id: string, themeId: string, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', id: string, rangeValue: number } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', id: string, booleanValue: boolean } | null } | null }> } | null };

export type GetWelcomePageInfoForWebsiteTemplateQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetWelcomePageInfoForWebsiteTemplateQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, welcomePageInfo?: { __typename?: 'EventPageInfo', id: string, type: EventPageType, page: { __typename?: 'EventPage', id: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, assetId: string, width: number, height: number, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', height: number, width: number, unit: string, x: number, y: number } | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null } | null } } | null } | null };

export type UpdateWelcomePagePhotoPresentationLayoutMutationVariables = Exact<{
  payload: websiteCreateOrUpdatePagePhotoPresentationPayload;
}>;


export type UpdateWelcomePagePhotoPresentationLayoutMutation = { __typename?: 'Mutation', websiteCreateOrUpdatePagePhotoPresentation?: { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponse', success: boolean, message: string } | { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponseError', id?: string | null, message: string, success: boolean } | null };

export type AccommodationPlaceRecommendationFragment = { __typename?: 'AccommodationPlaceRecommendation', id: string, status: AccommodationPlaceRecommendationStatus, whyThisHotelIsAGreatPick?: string | null, proposedNoteFromHostToGuest?: string | null, highlightTags?: Array<string> | null, venueGooglePlaceId?: string | null };

export type AccommodationRoomBlockFragment = { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null };

export type TravelDistanceBetweenPointsFragment = { __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType };

export type TravelDistancesBetweenPointsResponseFragment = { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> };

export type AccommodationPlaceV2Fragment = { __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, userNote?: string | null, name?: string | null, description?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null, url?: string | null, lat?: number | null, long?: number | null, isPhotoHidden?: boolean | null, zhId?: string | null, starRating?: number | null, googlePlaceId?: string | null, isFavorite?: boolean | null, category?: AccommodationPlaceCategory | null, isHostStayingHere?: boolean | null, createdByType: string, joyPlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, customPhone?: string | null, isFromAccommodationCatalog: boolean, isCustomLinkEnabled?: boolean | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, autoSuggestionRecommendation?: { __typename?: 'AccommodationPlaceRecommendation', id: string, status: AccommodationPlaceRecommendationStatus, whyThisHotelIsAGreatPick?: string | null, proposedNoteFromHostToGuest?: string | null, highlightTags?: Array<string> | null, venueGooglePlaceId?: string | null } | null };

export type AccommodationsInfoFragment = { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, userNote?: string | null, name?: string | null, description?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null, url?: string | null, lat?: number | null, long?: number | null, isPhotoHidden?: boolean | null, zhId?: string | null, starRating?: number | null, googlePlaceId?: string | null, isFavorite?: boolean | null, category?: AccommodationPlaceCategory | null, isHostStayingHere?: boolean | null, createdByType: string, joyPlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, customPhone?: string | null, isFromAccommodationCatalog: boolean, isCustomLinkEnabled?: boolean | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, autoSuggestionRecommendation?: { __typename?: 'AccommodationPlaceRecommendation', id: string, status: AccommodationPlaceRecommendationStatus, whyThisHotelIsAGreatPick?: string | null, proposedNoteFromHostToGuest?: string | null, highlightTags?: Array<string> | null, venueGooglePlaceId?: string | null } | null }>, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null, travelSettings?: { __typename?: 'TravelSettings', currencyCode?: TravelCurrencyCode | null } | null, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null, eventDisplayName?: string | null, AnyOtherDetails?: string | null, PreferredContactMethod?: ContactMethods | null, bookingLink?: string | null, leadStateV2?: LeadStateV2 | null, leadStateV2UpdatedAt?: any | null, checkIn?: any | null, checkOut?: any | null, email?: string | null, numberOfRooms?: string | null, concierge?: { __typename?: 'OwnerDetails', name?: string | null, email?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null, destination?: { __typename?: 'LeadDestination', name?: string | null, lat?: number | null, long?: number | null, postalCode?: string | null, address?: string | null } | null } | null };

export type CreateEventPlaceMutationVariables = Exact<{
  payload: EventPlaceCreatePayload;
}>;


export type CreateEventPlaceMutation = { __typename?: 'Mutation', createEventPlace: { __typename?: 'EventPlace', id?: string | null, googlePlaceId?: string | null, type: EventPlaceType, name: string, displayAddress: string, latitude?: number | null, longitude?: number | null, city?: string | null, stateProvince?: string | null, country?: string | null, countryCode?: string | null } };

export type UpdateEventPlaceMutationVariables = Exact<{
  payload: EventPlaceUpdatePayload;
}>;


export type UpdateEventPlaceMutation = { __typename?: 'Mutation', updateEventPlace: { __typename?: 'EventPlace', id?: string | null, googlePlaceId?: string | null, type: EventPlaceType, name: string, displayAddress: string, latitude?: number | null, longitude?: number | null, city?: string | null, stateProvince?: string | null, country?: string | null, countryCode?: string | null } };

export type DeleteEventPlaceMutationVariables = Exact<{
  deleteEventPlaceId: Scalars['ID'];
}>;


export type DeleteEventPlaceMutation = { __typename?: 'Mutation', deleteEventPlace: { __typename?: 'EventPlace', id?: string | null, googlePlaceId?: string | null, type: EventPlaceType, name: string, displayAddress: string, latitude?: number | null, longitude?: number | null } };

export type DeletePointOnMapMutationVariables = Exact<{
  payload?: InputMaybe<PointsOnMapDeletePayload>;
}>;


export type DeletePointOnMapMutation = { __typename?: 'Mutation', deletePointOnMap: { __typename?: 'PointsOnMap', id: string } };

export type AddAccommodationPlaceV2MutationVariables = Exact<{
  payload: AddAccommodationPlaceV2Request;
}>;


export type AddAccommodationPlaceV2Mutation = { __typename?: 'Mutation', addAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2', id: string } };

export type UpdateAccommodationPlaceV2MutationVariables = Exact<{
  payload: UpdateAccommodationPlaceV2Request;
}>;


export type UpdateAccommodationPlaceV2Mutation = { __typename?: 'Mutation', updateAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2', id: string } };

export type DeleteAccommodationPlaceV2MutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAccommodationPlaceV2Mutation = { __typename?: 'Mutation', deleteAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2', id: string } };

export type AccommodationHotelsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type AccommodationHotelsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, userNote?: string | null, name?: string | null, description?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null, url?: string | null, lat?: number | null, long?: number | null, isPhotoHidden?: boolean | null, zhId?: string | null, starRating?: number | null, googlePlaceId?: string | null, isFavorite?: boolean | null, category?: AccommodationPlaceCategory | null, isHostStayingHere?: boolean | null, createdByType: string, joyPlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, customPhone?: string | null, isFromAccommodationCatalog: boolean, isCustomLinkEnabled?: boolean | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, autoSuggestionRecommendation?: { __typename?: 'AccommodationPlaceRecommendation', id: string, status: AccommodationPlaceRecommendationStatus, whyThisHotelIsAGreatPick?: string | null, proposedNoteFromHostToGuest?: string | null, highlightTags?: Array<string> | null, venueGooglePlaceId?: string | null } | null }>, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null, travelSettings?: { __typename?: 'TravelSettings', currencyCode?: TravelCurrencyCode | null } | null, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null, eventDisplayName?: string | null, AnyOtherDetails?: string | null, PreferredContactMethod?: ContactMethods | null, bookingLink?: string | null, leadStateV2?: LeadStateV2 | null, leadStateV2UpdatedAt?: any | null, checkIn?: any | null, checkOut?: any | null, email?: string | null, numberOfRooms?: string | null, concierge?: { __typename?: 'OwnerDetails', name?: string | null, email?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null, destination?: { __typename?: 'LeadDestination', name?: string | null, lat?: number | null, long?: number | null, postalCode?: string | null, address?: string | null } | null } | null } | null };

export type UpdateTravelMapComponentMutationVariables = Exact<{
  payload?: InputMaybe<TravelMapComponentUpdatePayload>;
}>;


export type UpdateTravelMapComponentMutation = { __typename?: 'Mutation', updateTravelMapComponent: { __typename?: 'TravelMapComponent', id: string } };

export type AccommodationsEditorLeadStateQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type AccommodationsEditorLeadStateQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, bookingLink?: string | null, leadStateV2?: LeadStateV2 | null } | null } | null };

export type AccommodationPropertyPhotosQueryVariables = Exact<{
  payload: AccommodationContentSearchInput;
}>;


export type AccommodationPropertyPhotosQuery = { __typename?: 'Query', searchAccommodationProperties: { __typename?: 'AccommodationContentSearchResult', properties: Array<{ __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }> }> } };

export type RoomBlockLeadStateQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type RoomBlockLeadStateQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, bookingLink?: string | null, leadStateV2?: LeadStateV2 | null } | null } | null };

export type FindMatchingAccommodationCatalogPropertyQueryVariables = Exact<{
  payload: FindMatchingAccommodationCatalogPropertyPayload;
}>;


export type FindMatchingAccommodationCatalogPropertyQuery = { __typename?: 'Query', findMatchingAccommodationCatalogProperty?: { __typename?: 'FindMatchingAccommodationCatalogPropertyResult', accommodationCatalogProperty?: { __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, name: string, starRating?: number | null, plainTextLongDescription: string, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }> } | null } | null };

export type TravelReservationBookingDetailsQueryVariables = Exact<{
  payload: TravelReservationBookingDetailsPayload;
}>;


export type TravelReservationBookingDetailsQuery = { __typename?: 'Query', travelReservationBookingDetails: Array<{ __typename?: 'TravelReservationBookingByEventId', bookingInfo?: Array<{ __typename?: 'TravelReservationBookingInfo', id: string, checkInDate?: string | null, checkOutDate?: string | null, email?: string | null, status?: string | null, bookingDate?: string | null, firstName?: string | null, lastName?: string | null, roomTypes?: Array<string> | null, occupancy?: { __typename?: 'Occupancy', adults?: number | null, children?: number | null } | null }> | null, joyPlace?: { __typename?: 'JoyPlace', id: string, starRating?: number | null, name?: string | null, lat?: number | null, long?: number | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null }> };

export type AddPhotoComponentMutationVariables = Exact<{
  payload: PhotoComponentAddPayload;
}>;


export type AddPhotoComponentMutation = { __typename?: 'Mutation', addPhotoComponent: { __typename?: 'PhotoComponent', id: string, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } };

export type UpdatePhotoComponentMutationVariables = Exact<{
  payload: PhotoComponentUpdatePayload;
}>;


export type UpdatePhotoComponentMutation = { __typename?: 'Mutation', updatePhotoComponent: { __typename?: 'PhotoComponent', id: string } };

export type AddMediaGalleryComponentMutationVariables = Exact<{
  payload?: InputMaybe<AddMediaGalleryComponentPayload>;
}>;


export type AddMediaGalleryComponentMutation = { __typename?: 'Mutation', addMediaGalleryComponent: { __typename?: 'MediaGalleryComponent', id: string, type: ComponentType, sortOrder: number, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string } | null } };

export type UpdateMediaGalleryComponentMutationVariables = Exact<{
  payload?: InputMaybe<UpdateMediaGalleryComponentPayload>;
}>;


export type UpdateMediaGalleryComponentMutation = { __typename?: 'Mutation', updateMediaGalleryComponent: { __typename?: 'MediaGalleryComponent', id: string, type: ComponentType } };

export type AddTextComponentMutationVariables = Exact<{
  payload?: InputMaybe<TextComponentAddPayload>;
}>;


export type AddTextComponentMutation = { __typename?: 'Mutation', addTextComponent: { __typename?: 'TextComponent', id: string, sortOrder: number, text: string } };

export type UpdateTextComponentMutationVariables = Exact<{
  payload?: InputMaybe<TextComponentUpdatePayload>;
}>;


export type UpdateTextComponentMutation = { __typename?: 'Mutation', updateTextComponent: { __typename?: 'TextComponent', id: string } };

export type AddVideoComponentMutationVariables = Exact<{
  payload: VideoComponentAddPayload;
}>;


export type AddVideoComponentMutation = { __typename?: 'Mutation', addVideoComponent: { __typename?: 'VideoComponent', id: string, sortOrder: number, videoUrl: string, caption?: string | null } };

export type UpdateVideoComponentMutationVariables = Exact<{
  payload: VideoComponentUpdatePayload;
}>;


export type UpdateVideoComponentMutation = { __typename?: 'Mutation', updateVideoComponent: { __typename?: 'VideoComponent', id: string } };

export type CustomPageThemeFragment = { __typename?: 'Theme', id: string, themeId: string, supportsPrints: boolean, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, printUrl: string, stockPreviewUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string } }>, marketingData: Array<{ __typename?: 'ThemeMarketingData', imageUrl: string, variationType: ThemeVariationType }> };

export type CustomPageEventDesignFragment = { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, supportsPrints: boolean, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, printUrl: string, stockPreviewUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string } }>, marketingData: Array<{ __typename?: 'ThemeMarketingData', imageUrl: string, variationType: ThemeVariationType }> }, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> };

export type GetWebsitePreviewDesignQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type GetWebsitePreviewDesignQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, supportsPrints: boolean, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, printUrl: string, stockPreviewUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string } }>, marketingData: Array<{ __typename?: 'ThemeMarketingData', imageUrl: string, variationType: ThemeVariationType }> }, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null } | null };

export type TextComponentFragment = { __typename: 'TextComponent', id: string, type: ComponentType, sortOrder: number, text: string };

export type EventCountdownComponentFragment = { __typename: 'EventCountdownComponent', id: string, type: ComponentType, sortOrder: number };

export type EventDetailsComponentFragment = { __typename: 'EventDetailsComponent', id: string, type: ComponentType, sortOrder: number };

export type JsonDataContainerFragment = { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string };

export type JsonDataBlobComponentFragment = { __typename: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string, containerContent: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } };

export type RsvpAndUnlockGuestDetailsButtonComponentFragment = { __typename: 'RsvpAndUnlockGuestDetailsButtonComponent', id: string, type: ComponentType, sortOrder: number };

export type TravelMapComponentFragment = { __typename: 'TravelMapComponent', id: string, type: ComponentType, sortOrder: number, blockOrdering?: Array<string> | null, hideExploreCTA: boolean };

export type WebsiteEditorPhotoComponentFragment = { __typename: 'PhotoComponent', id: string, type: ComponentType, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } };

export type WebsiteEditorVideoComponentFragment = { __typename: 'VideoComponent', id: string, sortOrder: number, type: ComponentType, videoUrl: string, caption?: string | null };

export type WebsiteEditorMediaGalleryComponentFragment = { __typename: 'MediaGalleryComponent', id: string, sortOrder: number, type: ComponentType, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null };

export type CustomPageMainPhotoFragment = { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string };

type CustomPageMainPhotoV2_DefaultPagePhoto_Fragment = { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, assetId: string };

type CustomPageMainPhotoV2_Photo_Fragment = { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string };

export type CustomPageMainPhotoV2Fragment = CustomPageMainPhotoV2_DefaultPagePhoto_Fragment | CustomPageMainPhotoV2_Photo_Fragment;

export type CustomPageMainPhotoAlignmentFragment = { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition };

export type CustomPagePhotoPresentationInfoFragment = { __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null };

export type CustomPageContainerFragment = { __typename?: 'PageContainer', id: string, title: string, slug: string, note?: string | null, visibility: EventPageVisibility, sortOrder: number, contentType?: PageContentType | null, mainPhotoPresentationLayout?: string | null, mainPhotoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, assetId: string } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string } | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, components?: Array<{ __typename: 'EventCountdownComponent', id: string, type: ComponentType, sortOrder: number } | { __typename: 'EventDetailsComponent', id: string, type: ComponentType, sortOrder: number } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string, containerContent: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } } | { __typename: 'MediaGalleryComponent', id: string, sortOrder: number, type: ComponentType, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null } | { __typename: 'PhotoComponent', id: string, type: ComponentType, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename: 'RsvpAndUnlockGuestDetailsButtonComponent', id: string, type: ComponentType, sortOrder: number } | { __typename: 'TextComponent', id: string, type: ComponentType, sortOrder: number, text: string } | { __typename: 'TravelMapComponent', id: string, type: ComponentType, sortOrder: number, blockOrdering?: Array<string> | null, hideExploreCTA: boolean } | { __typename: 'VideoComponent', id: string, sortOrder: number, type: ComponentType, videoUrl: string, caption?: string | null }> | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null };

export type PageContainerBySlugQueryVariables = Exact<{
  payload: PageContainerBySlugPayload;
  eventId: Scalars['ID'];
}>;


export type PageContainerBySlugQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, title: string, slug: string, note?: string | null, visibility: EventPageVisibility, sortOrder: number, contentType?: PageContentType | null, mainPhotoPresentationLayout?: string | null, mainPhotoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, assetId: string } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string } | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, components?: Array<{ __typename: 'EventCountdownComponent', id: string, type: ComponentType, sortOrder: number } | { __typename: 'EventDetailsComponent', id: string, type: ComponentType, sortOrder: number } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string, containerContent: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } } | { __typename: 'MediaGalleryComponent', id: string, sortOrder: number, type: ComponentType, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null } | { __typename: 'PhotoComponent', id: string, type: ComponentType, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename: 'RsvpAndUnlockGuestDetailsButtonComponent', id: string, type: ComponentType, sortOrder: number } | { __typename: 'TextComponent', id: string, type: ComponentType, sortOrder: number, text: string } | { __typename: 'TravelMapComponent', id: string, type: ComponentType, sortOrder: number, blockOrdering?: Array<string> | null, hideExploreCTA: boolean } | { __typename: 'VideoComponent', id: string, sortOrder: number, type: ComponentType, videoUrl: string, caption?: string | null }> | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null } | null, event?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null }, pages: Array<{ __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility, createdAt: { __typename?: 'Date', timestamp: any } }> } | null };

export type CreatePageContainerMutationVariables = Exact<{
  payload: PageContainerCreatePayload;
}>;


export type CreatePageContainerMutation = { __typename?: 'Mutation', createPageContainer: { __typename?: 'PageContainer', id: string } };

export type UpdatePageContainerMutationVariables = Exact<{
  payload: PageContainerUpdatePayload;
}>;


export type UpdatePageContainerMutation = { __typename?: 'Mutation', updatePageContainer: { __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, assetId: string } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string } | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null } };

export type AddTravelMapComponentMutationVariables = Exact<{
  payload?: InputMaybe<TravelMapComponentAddPayload>;
}>;


export type AddTravelMapComponentMutation = { __typename?: 'Mutation', addTravelMapComponent: { __typename?: 'TravelMapComponent', id: string } };

export type DeletePageComponentV2MutationVariables = Exact<{
  payload?: InputMaybe<PageComponentDeletePayload>;
}>;


export type DeletePageComponentV2Mutation = { __typename?: 'Mutation', deletePageComponentV2: boolean };

export type ReorderPageComponentsMutationVariables = Exact<{
  pageContainerId: Scalars['ID'];
  components: Array<ReorderPageComponent> | ReorderPageComponent;
}>;


export type ReorderPageComponentsMutation = { __typename?: 'Mutation', reorderPageComponents: Array<{ __typename?: 'RawPageComponent', id: string, sortOrder: number }> };

export type DeletePageContainerMutationVariables = Exact<{
  payload: PageContainerDeletePayload;
}>;


export type DeletePageContainerMutation = { __typename?: 'Mutation', deletePageContainer: { __typename?: 'PageContainer', id: string } };

export type IsPageContainerSlugAvailableQueryVariables = Exact<{
  payload: IsPageContainerSlugAvailablePayload;
}>;


export type IsPageContainerSlugAvailableQuery = { __typename?: 'Query', isPageContainerSlugAvailable: boolean };

export type GetPageContainersOrderQueryVariables = Exact<{
  name: Scalars['String'];
  admin?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPageContainersOrderQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pageContainers?: Array<{ __typename?: 'PageContainer', id: string, sortOrder: number }> | null, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType }>, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null } } | null };

export type GetWebsiteEditorRegistryLinksPageQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetWebsiteEditorRegistryLinksPageQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, pageSubTitleV0918?: string | null }> } | null };

type TravelItemIds_EventTravelBookingType_Fragment = { __typename?: 'EventTravelBookingType', id: string };

type TravelItemIds_EventTravelList_Fragment = { __typename?: 'EventTravelList', id: string };

type TravelItemIds_EventTravelNote_Fragment = { __typename?: 'EventTravelNote', id: string };

type TravelItemIds_Ferry_Fragment = { __typename?: 'Ferry', id: string };

type TravelItemIds_Flight_Fragment = { __typename?: 'Flight', id: string };

type TravelItemIds_Hotel_Fragment = { __typename?: 'Hotel', id: string };

type TravelItemIds_RentalCar_Fragment = { __typename?: 'RentalCar', id: string };

type TravelItemIds_RentalHome_Fragment = { __typename?: 'RentalHome', id: string };

type TravelItemIds_Shuttle_Fragment = { __typename?: 'Shuttle', id: string };

type TravelItemIds_Taxi_Fragment = { __typename?: 'Taxi', id: string };

type TravelItemIds_Tent_Fragment = { __typename?: 'Tent', id: string };

type TravelItemIds_Train_Fragment = { __typename?: 'Train', id: string };

export type TravelItemIdsFragment = TravelItemIds_EventTravelBookingType_Fragment | TravelItemIds_EventTravelList_Fragment | TravelItemIds_EventTravelNote_Fragment | TravelItemIds_Ferry_Fragment | TravelItemIds_Flight_Fragment | TravelItemIds_Hotel_Fragment | TravelItemIds_RentalCar_Fragment | TravelItemIds_RentalHome_Fragment | TravelItemIds_Shuttle_Fragment | TravelItemIds_Taxi_Fragment | TravelItemIds_Tent_Fragment | TravelItemIds_Train_Fragment;

export type SortTravelItemsMutationVariables = Exact<{
  payload?: InputMaybe<SortItemsPayload>;
}>;


export type SortTravelItemsMutation = { __typename?: 'Mutation', sortTravelItems?: Array<{ __typename?: 'EventTravelBookingType', id: string } | { __typename?: 'EventTravelList', id: string } | { __typename?: 'EventTravelNote', id: string } | { __typename?: 'Ferry', id: string } | { __typename?: 'Flight', id: string } | { __typename?: 'Hotel', id: string } | { __typename?: 'RentalCar', id: string } | { __typename?: 'RentalHome', id: string } | { __typename?: 'Shuttle', id: string } | { __typename?: 'Taxi', id: string } | { __typename?: 'Tent', id: string } | { __typename?: 'Train', id: string } | null> | null };

export type DeleteTravelItemMutationVariables = Exact<{
  deleteTravelItemId: Scalars['ID'];
}>;


export type DeleteTravelItemMutation = { __typename?: 'Mutation', deleteTravelItem?: { __typename?: 'EventTravelBookingType', id: string } | { __typename?: 'EventTravelList', id: string } | { __typename?: 'EventTravelNote', id: string } | { __typename?: 'Ferry', id: string } | { __typename?: 'Flight', id: string } | { __typename?: 'Hotel', id: string } | { __typename?: 'RentalCar', id: string } | { __typename?: 'RentalHome', id: string } | { __typename?: 'Shuttle', id: string } | { __typename?: 'Taxi', id: string } | { __typename?: 'Tent', id: string } | { __typename?: 'Train', id: string } | null };

export type CreateBookingTravelItemMutationVariables = Exact<{
  payload: CreateBookingTravelItemPayload;
}>;


export type CreateBookingTravelItemMutation = { __typename?: 'Mutation', createBookingTravelItem?: { __typename?: 'EventTravelBookingType', address?: string | null, bookingType?: string | null, id: string, name: string, placeId?: string | null, type: TravelType, timezone?: string | null, endTime?: { __typename?: 'Date', dateString: string } | null, startTime?: { __typename?: 'Date', dateString: string } | null } | null };

export type CreateListTravelItemMutationVariables = Exact<{
  payload: CreateListTravelItemPayload;
}>;


export type CreateListTravelItemMutation = { __typename?: 'Mutation', createListTravelItem?: { __typename?: 'EventTravelList', id: string, name: string, type: TravelType, items: Array<{ __typename?: 'EventTravelListItem', title?: string | null, url?: string | null, id: string }> } | null };

export type CreateNoteTravelItemMutationVariables = Exact<{
  payload: CreateNoteTravelItemPayload;
}>;


export type CreateNoteTravelItemMutation = { __typename?: 'Mutation', createNoteTravelItem?: { __typename?: 'EventTravelNote', id: string, name: string, notes?: string | null, type: TravelType, url?: string | null } | null };

export type CreateFlightTravelItemMutationVariables = Exact<{
  payload: CreateFlightTravelItemPayload;
}>;


export type CreateFlightTravelItemMutation = { __typename?: 'Mutation', createFlightTravelItem?: { __typename?: 'Flight', code?: string | null, id: string, name: string, notes?: string | null, type: TravelType, url?: string | null } | null };

export type CreateRentalCarTravelItemMutationVariables = Exact<{
  payload: CreateRentalCarTravelItemPayload;
}>;


export type CreateRentalCarTravelItemMutation = { __typename?: 'Mutation', createRentalCarTravelItem?: { __typename?: 'RentalCar', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateTaxiTravelItemMutationVariables = Exact<{
  payload: CreateTaxiTravelItemPayload;
}>;


export type CreateTaxiTravelItemMutation = { __typename?: 'Mutation', createTaxiTravelItem?: { __typename?: 'Taxi', address?: string | null, id: string, name: string, placeId?: string | null, notes?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateFerryTravelItemMutationVariables = Exact<{
  payload: CreateFerryTravelItemPayload;
}>;


export type CreateFerryTravelItemMutation = { __typename?: 'Mutation', createFerryTravelItem?: { __typename?: 'Ferry', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateTrainTravelItemMutationVariables = Exact<{
  payload: CreateTrainTravelItemPayload;
}>;


export type CreateTrainTravelItemMutation = { __typename?: 'Mutation', createTrainTravelItem?: { __typename?: 'Train', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateHotelTravelItemMutationVariables = Exact<{
  payload: CreateHotelTravelItemPayload;
}>;


export type CreateHotelTravelItemMutation = { __typename?: 'Mutation', createHotelTravelItem?: { __typename?: 'Hotel', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateTentTravelItemMutationVariables = Exact<{
  payload: CreateTentTravelItemPayload;
}>;


export type CreateTentTravelItemMutation = { __typename?: 'Mutation', createTentTravelItem?: { __typename?: 'Tent', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateRentalHomeTravelItemMutationVariables = Exact<{
  payload: CreateRentalHomeTravelItemPayload;
}>;


export type CreateRentalHomeTravelItemMutation = { __typename?: 'Mutation', createRentalHomeTravelItem?: { __typename?: 'RentalHome', address?: string | null, id: string, name: string, notes?: string | null, placeId?: string | null, telephone?: string | null, type: TravelType, url?: string | null } | null };

export type CreateShuttleTravelItemMutationVariables = Exact<{
  payload: CreateShuttleTravelItemPayload;
}>;


export type CreateShuttleTravelItemMutation = { __typename?: 'Mutation', createShuttleTravelItem?: { __typename?: 'Shuttle', id: string, items: Array<{ __typename?: 'ShuttleItem', note?: string | null, timezone?: string | null, url?: string | null, title?: string | null, id: string, endTime?: { __typename?: 'Date', dateString: string, timezone: string, timestamp: any } | null, startTime?: { __typename?: 'Date', timezone: string, dateString: string, timestamp: any } | null }> } | null };

export type UpdateBookingTravelItemMutationVariables = Exact<{
  payload: UpdateBookingTravelItemPayload;
}>;


export type UpdateBookingTravelItemMutation = { __typename?: 'Mutation', updateBookingTravelItem?: { __typename?: 'EventTravelBookingType', id: string, type: TravelType, name: string } | null };

export type UpdateListTravelItemMutationVariables = Exact<{
  payload: UpdateListTravelItemPayload;
}>;


export type UpdateListTravelItemMutation = { __typename?: 'Mutation', updateListTravelItem?: { __typename?: 'EventTravelList', id: string, name: string, type: TravelType } | null };

export type UpdateNoteTravelItemMutationVariables = Exact<{
  payload: UpdateNoteTravelItemPayload;
}>;


export type UpdateNoteTravelItemMutation = { __typename?: 'Mutation', updateNoteTravelItem?: { __typename?: 'EventTravelNote', id: string, name: string, type: TravelType } | null };

export type UpdateFlightTravelItemMutationVariables = Exact<{
  payload: UpdateFlightTravelItemPayload;
}>;


export type UpdateFlightTravelItemMutation = { __typename?: 'Mutation', updateFlightTravelItem?: { __typename?: 'Flight', id: string, name: string, type: TravelType } | null };

export type UpdateRentalCarTravelItemMutationVariables = Exact<{
  payload: UpdateRentalCarTravelItemPayload;
}>;


export type UpdateRentalCarTravelItemMutation = { __typename?: 'Mutation', updateRentalCarTravelItem?: { __typename?: 'RentalCar', id: string, name: string, type: TravelType } | null };

export type UpdateTaxiTravelItemMutationVariables = Exact<{
  payload: UpdateTaxiTravelItemPayload;
}>;


export type UpdateTaxiTravelItemMutation = { __typename?: 'Mutation', updateTaxiTravelItem?: { __typename?: 'Taxi', id: string, name: string, type: TravelType } | null };

export type UpdateFerryTravelItemMutationVariables = Exact<{
  payload: UpdateFerryTravelItemPayload;
}>;


export type UpdateFerryTravelItemMutation = { __typename?: 'Mutation', updateFerryTravelItem?: { __typename?: 'Ferry', id: string, name: string, type: TravelType } | null };

export type UpdateTrainTravelItemMutationVariables = Exact<{
  payload: UpdateTrainTravelItemPayload;
}>;


export type UpdateTrainTravelItemMutation = { __typename?: 'Mutation', updateTrainTravelItem?: { __typename?: 'Train', id: string, name: string, type: TravelType } | null };

export type UpdateHotelTravelItemMutationVariables = Exact<{
  payload: UpdateHotelTravelItemPayload;
}>;


export type UpdateHotelTravelItemMutation = { __typename?: 'Mutation', updateHotelTravelItem?: { __typename?: 'Hotel', id: string, name: string, type: TravelType } | null };

export type UpdateTentTravelItemMutationVariables = Exact<{
  payload: UpdateTentTravelItemPayload;
}>;


export type UpdateTentTravelItemMutation = { __typename?: 'Mutation', updateTentTravelItem?: { __typename?: 'Tent', id: string, name: string, type: TravelType } | null };

export type UpdateRentalHomeTravelItemMutationVariables = Exact<{
  payload: UpdateRentalHomeTravelItemPayload;
}>;


export type UpdateRentalHomeTravelItemMutation = { __typename?: 'Mutation', updateRentalHomeTravelItem?: { __typename?: 'RentalHome', id: string, name: string, type: TravelType } | null };

export type UpdateShuttleTravelItemMutationVariables = Exact<{
  payload: UpdateShuttleTravelItemPayload;
}>;


export type UpdateShuttleTravelItemMutation = { __typename?: 'Mutation', updateShuttleTravelItem?: { __typename?: 'Shuttle', id: string, name: string, type: TravelType } | null };

export type EventVenueAccommodationPlacesV2PhotosQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type EventVenueAccommodationPlacesV2PhotosQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, photo?: { __typename?: 'Photo', id: string, url: string, altTag?: string | null } | null }> } | null };

export type WebsiteEditorOldPagesQueryVariables = Exact<{
  name: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type WebsiteEditorOldPagesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null }, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null, pages: Array<{ __typename?: 'EventPage', visibility: EventPageVisibility, id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }> } | null };

export type UpdateWebsiteEditorOldPageMutationVariables = Exact<{
  updateEventPagePayload: UpdateEventPagePayload;
  pageId: Scalars['ID'];
}>;


export type UpdateWebsiteEditorOldPageMutation = { __typename?: 'Mutation', updateEventPage: { __typename?: 'EventPage', id: string, pageSubTitleV0918?: string | null } };

export type WebsiteOverviewChecklistItemFragment = { __typename?: 'ChecklistItem', id: string, title: string, action?: string | null, subItems: Array<{ __typename?: 'ChecklistSubItem', id: string, title: string, action?: string | null, completedAt?: any | null }> };

export type WebsiteOverviewInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type WebsiteOverviewInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, photoV2Url?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null }, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null } | null, pages: Array<{ __typename?: 'EventPage', id: string, pageTitle: string, disabled: boolean, type: EventPageType, pageSlug: string, visibility: EventPageVisibility, private: boolean, isPageContainer: boolean, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, createdAt: { __typename?: 'Date', timestamp: any }, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', height: number, unit: string, width: number, x: number, y: number } | null } | null }>, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, websiteLayout: string, dataJSON: any, id: string } | null } | null, pageContainers?: Array<{ __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null }> | null, checklist?: { __typename?: 'EventChecklist', id: string, title: string, items: Array<{ __typename?: 'ChecklistItem', id: string, title: string, action?: string | null, subItems: Array<{ __typename?: 'ChecklistSubItem', id: string, title: string, action?: string | null, completedAt?: any | null }> }> } | null } | null };

export type MediaCollectionsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type MediaCollectionsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, mediaInfo?: { __typename?: 'MediaInfo', mediaCount: number, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number } } | { __typename?: 'MediaVideo' }> | null } | null, mediaCollections?: Array<{ __typename?: 'MediaCollection', id: string, name: string, magicTokenPermissions?: Array<MagicTokenPermissions | null> | null, mediaCount: number, createdAt: { __typename?: 'Date', dateString: string, timestamp: any }, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number }, createdAt: { __typename?: 'Date', dateString: string, timestamp: any } } | { __typename?: 'MediaVideo' }> | null }> | null } | null };

export type MediaCollectionByIdQueryVariables = Exact<{
  mediaCollectionById: Scalars['ID'];
}>;


export type MediaCollectionByIdQuery = { __typename?: 'Query', mediaCollectionById?: { __typename?: 'MediaCollection', id: string, name: string, mediaCount: number, sortBy: MediaCollectionSortField, sortDirection: MediaCollectionSortDirection, media?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number } } | { __typename?: 'MediaVideo' }> | null, thumbnails?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number }, createdAt: { __typename?: 'Date', dateString: string, timestamp: any } } | { __typename?: 'MediaVideo' }> | null, createdAt: { __typename?: 'Date', dateString: string, timestamp: any } } | null };

export type CreateMediaCollectionMutationVariables = Exact<{
  payload: CreateMediaCollectionInput;
}>;


export type CreateMediaCollectionMutation = { __typename?: 'Mutation', createMediaCollection: { __typename?: 'MediaCollection', id: string, name: string } };

export type UpdateMediaCollectionMutationVariables = Exact<{
  payload: UpdateMediaCollectionInput;
}>;


export type UpdateMediaCollectionMutation = { __typename?: 'Mutation', updateMediaCollection: { __typename?: 'MediaCollection', id: string, name: string, sortBy: MediaCollectionSortField, sortDirection: MediaCollectionSortDirection } };

export type DeleteMediaCollectionMutationVariables = Exact<{
  deleteMediaCollectionId: Scalars['ID'];
}>;


export type DeleteMediaCollectionMutation = { __typename?: 'Mutation', deleteMediaCollection?: any | null };

export type CreateMediaPhotoMutationVariables = Exact<{
  payload: createMediaPhotoInput;
}>;


export type CreateMediaPhotoMutation = { __typename?: 'Mutation', createMediaPhoto?: { __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number } } | null };

export type AddMediaToCollectionMutationVariables = Exact<{
  payload?: InputMaybe<addMediaToCollectionInput>;
}>;


export type AddMediaToCollectionMutation = { __typename?: 'Mutation', addMediaToCollection: { __typename?: 'MediaCollection', id: string, name: string, media?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number } } | { __typename?: 'MediaVideo' }> | null } };

export type AddMediaToCollectionV2MutationVariables = Exact<{
  payload?: InputMaybe<addMediaToCollectionInputV2>;
}>;


export type AddMediaToCollectionV2Mutation = { __typename?: 'Mutation', addMediaToCollectionV2: { __typename?: 'addMediaToCollectionResponse', success: boolean, message: string, mediaCollection?: { __typename?: 'MediaCollection', id: string } | null, newMedia?: Array<{ __typename?: 'MediaPhoto', id: string } | { __typename?: 'MediaVideo' }> | null } | { __typename?: 'addMediaToCollectionResponseError', failedMediaIds?: Array<string> | null, success: boolean, message: string, newMedia?: Array<{ __typename?: 'MediaPhoto', id: string } | { __typename?: 'MediaVideo' }> | null } };

export type RemoveMediaFromCollectionMutationVariables = Exact<{
  payload?: InputMaybe<removeMediaFromCollectionInput>;
}>;


export type RemoveMediaFromCollectionMutation = { __typename?: 'Mutation', removeMediaFromCollection: { __typename?: 'MediaCollection', id: string, name: string } };

export type DeleteMediaMutationVariables = Exact<{
  mediaId: Scalars['ID'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia?: any | null };

export type GetMediaCollectionMagicTokenQueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type GetMediaCollectionMagicTokenQuery = { __typename?: 'Query', mediaCollectionMagicToken?: string | null };

export type GetMediaCollectionMagicTokenV2QueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type GetMediaCollectionMagicTokenV2Query = { __typename?: 'Query', mediaCollectionMagicTokenV2?: { __typename?: 'MediaMagicToken', token: string, permissions?: Array<MagicTokenPermissions> | null, disabled?: boolean | null } | null };

export type GenerateMagicTokenForMediaCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type GenerateMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation', generateMagicTokenForMediaCollection: string };

export type RemoveMagicTokenFromMediaCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type RemoveMagicTokenFromMediaCollectionMutation = { __typename?: 'Mutation', removeMagicTokenFromMediaCollection?: any | null };

export type DisableMagicTokenForMediaCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type DisableMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation', disableMagicTokenForMediaCollection?: any | null };

export type EnableMagicTokenForMediaCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type EnableMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation', enableMagicTokenForMediaCollection?: any | null };

export type SetMediaTokenPermissionsMutationVariables = Exact<{
  payload?: InputMaybe<setMediaTokenPermissionsInput>;
}>;


export type SetMediaTokenPermissionsMutation = { __typename?: 'Mutation', setMediaTokenPermissions?: any | null };

export type UploadPhotosFromUrlsMutationVariables = Exact<{
  payload: Array<UploadPhotoFromUrlPayload> | UploadPhotoFromUrlPayload;
}>;


export type UploadPhotosFromUrlsMutation = { __typename?: 'Mutation', uploadPhotosFromUrls: Array<{ __typename?: 'Photo', id: string } | null> };

export type GetEventMediaQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventMediaQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, media?: Array<{ __typename?: 'MediaPhoto', id: string, createdAt: { __typename?: 'Date', milliseconds: number }, photo: { __typename?: 'Photo', id: string, url: string, height: number, width: number, assetId: string, mimeType: string, fileSize?: number | null } } | { __typename?: 'MediaVideo' }> | null } | null };

export type UploadMediaFromUrlsMutationVariables = Exact<{
  payload: createMediaFromUrlsInput;
}>;


export type UploadMediaFromUrlsMutation = { __typename?: 'Mutation', uploadMediaFromUrls: { __typename?: 'MediaUploadCollection', id?: string | null, uploadId: string, name?: string | null, status: UploadStatus, attemptInMs: number, uploads: Array<{ __typename?: 'MediaUpload', id?: string | null, assetId: string, status: MediaStatus, photo?: { __typename?: 'MediaUploadPhoto', id: string, url: string, height: number, width: number } | null }> } };

export type UploadMediaStatusQueryVariables = Exact<{
  eventId: Scalars['ID'];
  uploadId: Scalars['ID'];
}>;


export type UploadMediaStatusQuery = { __typename?: 'Query', uploadMediaStatus: { __typename?: 'MediaUploadCollection', id?: string | null, uploadId: string, name?: string | null, status: UploadStatus, attemptInMs: number, uploads: Array<{ __typename?: 'MediaUpload', id?: string | null, assetId: string, status: MediaStatus, photo?: { __typename?: 'MediaUploadPhoto', id: string, url: string, height: number, width: number } | null }> } };

export type SendContactCollectorMessagesMutationVariables = Exact<{
  input: SendContactCollectorMessagesInput;
}>;


export type SendContactCollectorMessagesMutation = { __typename?: 'Mutation', sendContactCollectorMessages: { __typename?: 'SendMessageBatchResult', messageBatchId: string, sentEmails: number, sentSms: number, skippedEmails: number, skippedSms: number, quarantined: boolean } };

export type GetMessagingTierQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetMessagingTierQuery = { __typename?: 'Query', getMessagingSettingsByEventId?: { __typename?: 'MessagingSettings', id: string, messagingTier?: MessagingTier | null } | null };

export type CreateMessagingPlusCheckoutMutationVariables = Exact<{
  data: CreateJoyFeatureCheckoutInput;
}>;


export type CreateMessagingPlusCheckoutMutation = { __typename?: 'Mutation', createJoyFeatureCheckout: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type GetUserStationeryOrdersQueryVariables = Exact<{
  ownerId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type GetUserStationeryOrdersQuery = { __typename?: 'Query', stationeryPrintOrders: { __typename?: 'StationeryPrintOrdersView', count?: number | null, orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, orderNumber: string, currentStatus: StationeryPrintOrderStatusEnum, ownerId: string, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, region: string, postalCode: string, country: string, countryCode: string } }> } };

export type GetMessagingPlusOrdersByEventQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetMessagingPlusOrdersByEventQuery = { __typename?: 'Query', stationeryPrintOrdersByEvent: { __typename?: 'StationeryPrintOrdersView', count?: number | null, orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, currentStatus: StationeryPrintOrderStatusEnum, vendor: StationeryPrintOrderVendorEnum }> } };

export type FormFieldsFragment = { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean };

export type FormTemplateListQueryVariables = Exact<{ [key: string]: never; }>;


export type FormTemplateListQuery = { __typename?: 'Query', formTemplateList: Array<{ __typename?: 'FormTemplate', id: string, title: string, description: string, schemaUrl: string, config: any, eventCategoryTags: Array<string>, eventSubTypeTags: Array<string>, tags?: Array<string> | null }> };

export type FormByIdQueryVariables = Exact<{
  formByIdId: Scalars['ID'];
}>;


export type FormByIdQuery = { __typename?: 'Query', formById?: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean } | null };

export type FormListByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type FormListByEventIdQuery = { __typename?: 'Query', formListByEventId: Array<{ __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean }> };

export type FormAnswerListByFormIdQueryVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type FormAnswerListByFormIdQuery = { __typename?: 'Query', formAnswerListByFormId: Array<{ __typename?: 'Answer', id: string, guestKey?: string | null, formId: string, questionId: string, answerValue: string, contact?: { __typename?: 'FormContactItem', guestKey?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, tags?: Array<string> | null } | null, questionValue?: { __typename?: 'QuestionValue', stepName?: string | null, stepTitle?: string | null, stepDescription?: string | null, placeholder?: string | null, field?: any | null } | null }> };

export type RegistrationFormByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type RegistrationFormByEventIdQuery = { __typename?: 'Query', registrationFormByEventId?: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean } | null };

export type SetFormEnabledMutationVariables = Exact<{
  formId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetFormEnabledMutation = { __typename?: 'Mutation', setFormEnabled: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean } };

export type CreateFormMutationVariables = Exact<{
  input: CreateFormInput;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean } };

export type UpdateFormMutationVariables = Exact<{
  input: UpdateFormInput;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, enabled: boolean } };

export type SubmitFormAnswersMutationVariables = Exact<{
  input: SubmitFormAnswersInput;
}>;


export type SubmitFormAnswersMutation = { __typename?: 'Mutation', submitFormAnswers: { __typename?: 'Form', id: string } };

export type GetGuestsRsvpAnswersQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetGuestsRsvpAnswersQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, guests: { __typename?: 'EventGuests', people: Array<{ __typename?: 'Person', id: string, personIdTag: string, email?: string | null, legacyRsvpAnswers?: Array<{ __typename?: 'LegacyRsvpAnswer', answer?: string | null, questionId: string } | null> | null }> } } | null };

export type SendRsvpReminderMutationVariables = Exact<{
  data: SendRsvpReminderV2Input;
}>;


export type SendRsvpReminderMutation = { __typename?: 'Mutation', sendRsvpReminderV2?: any | null };

export type SendTestRsvpReminderMutationVariables = Exact<{
  data: SendTestRsvpReminderV2Input;
}>;


export type SendTestRsvpReminderMutation = { __typename?: 'Mutation', sendTestRsvpReminderV2?: any | null };

export type SaveTheDateGuestElectronicCardFragment = { __typename?: 'ElectronicCard', id: string, title: string, subTitle?: string | null, message?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationStringFormat?: string | null, displayDateFormat?: string | null, coupleNameFormat?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null };

export type SaveTheDateElectronicCardFragment = { __typename?: 'ElectronicCard', additionalMessage?: string | null, locationString?: string | null, displayDateString?: string | null, id: string, title: string, subTitle?: string | null, message?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationStringFormat?: string | null, displayDateFormat?: string | null, coupleNameFormat?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null };

export type SaveTheDateEcardEmailDraftFragment = { __typename?: 'ElectronicCardEcardEmailDraft', id: string, replyToEmail?: string | null, salutation?: string | null, includeGuestNames: boolean, includeDate: boolean, includeAddToCalendar: boolean, message?: string | null, subject: string, buttonText?: string | null, title: string, subTitle?: string | null, imageUrl?: string | null };

export type SaveTheDateGuestEventByIdDataFragment = { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, date?: string | null, eventPassword?: string | null, location?: string | null, ownerFirstName?: string | null, ownerFullName?: string | null, fianceeFirstName?: string | null, fianceeFullName?: string | null, eventDisplayName?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, state?: string | null, country?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, accent?: string | null } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null };

export type SaveTheDateEventByIdDataFragment = { __typename?: 'Event', id: string, website: string, photo?: { __typename?: 'Photo', id: string, url: string } | null, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, info: { __typename?: 'EventInfo', id: string, date?: string | null, eventPassword?: string | null, location?: string | null, ownerFirstName?: string | null, ownerFullName?: string | null, fianceeFirstName?: string | null, fianceeFullName?: string | null, eventDisplayName?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, state?: string | null, country?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, accent?: string | null } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null };

export type SaveTheDateGetEcardDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
  ecardType?: InputMaybe<EcardType>;
}>;


export type SaveTheDateGetEcardDataQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, photo?: { __typename?: 'Photo', id: string, url: string } | null, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, info: { __typename?: 'EventInfo', id: string, date?: string | null, eventPassword?: string | null, location?: string | null, ownerFirstName?: string | null, ownerFullName?: string | null, fianceeFirstName?: string | null, fianceeFullName?: string | null, eventDisplayName?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, state?: string | null, country?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, accent?: string | null } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null } | null, getMostRecentEcardByEventId?: { __typename?: 'ElectronicCard', additionalMessage?: string | null, locationString?: string | null, displayDateString?: string | null, id: string, title: string, subTitle?: string | null, message?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationStringFormat?: string | null, displayDateFormat?: string | null, coupleNameFormat?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null } | null, getEcardEmailDraftsByEventId: Array<{ __typename?: 'ElectronicCardEcardEmailDraft', id: string, replyToEmail?: string | null, salutation?: string | null, includeGuestNames: boolean, includeDate: boolean, includeAddToCalendar: boolean, message?: string | null, subject: string, buttonText?: string | null, title: string, subTitle?: string | null, imageUrl?: string | null }>, getEcardLinkOptionsByEventId: Array<{ __typename?: 'ElectronicCardCardLinkOption', name: string, label: string }> };

export type SaveTheDateGetEcardByGuidQueryVariables = Exact<{
  lookupId: Scalars['ID'];
}>;


export type SaveTheDateGetEcardByGuidQuery = { __typename?: 'Query', getEcardRecepientDisplayByLookupId?: { __typename?: 'ElectronicCard', id: string, title: string, subTitle?: string | null, message?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationStringFormat?: string | null, displayDateFormat?: string | null, coupleNameFormat?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null } | null };

export type SaveTheDateGetEcardGuestExtraDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type SaveTheDateGetEcardGuestExtraDataQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, date?: string | null, eventPassword?: string | null, location?: string | null, ownerFirstName?: string | null, ownerFullName?: string | null, fianceeFirstName?: string | null, fianceeFullName?: string | null, eventDisplayName?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, state?: string | null, country?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, accent?: string | null } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null } | null, getEcardLinkOptionsByEventId: Array<{ __typename?: 'ElectronicCardCardLinkOption', name: string, label: string }> };

export type SaveTheDateSaveEcardMutationVariables = Exact<{
  payload: ElectronicCardInput;
}>;


export type SaveTheDateSaveEcardMutation = { __typename?: 'Mutation', saveEcard?: { __typename?: 'ElectronicCard', id: string } | null };

export type SaveTheDateSaveEcardPhotoMutationVariables = Exact<{
  payload: ElectronicCardPhotoPayloadInput;
}>;


export type SaveTheDateSaveEcardPhotoMutation = { __typename?: 'Mutation', saveEcardPhoto: { __typename?: 'Photo', id: string } };

export type SaveTheDateSaveEcardEmailMutationVariables = Exact<{
  payload?: InputMaybe<ElectronicCardEmailDraftInput>;
}>;


export type SaveTheDateSaveEcardEmailMutation = { __typename?: 'Mutation', saveEcardEmailDraft?: any | null };

export type SaveTheDateSendEcardGuestEmailMutationVariables = Exact<{
  payload?: InputMaybe<ElectronicCardEmailMessageInput>;
}>;


export type SaveTheDateSendEcardGuestEmailMutation = { __typename?: 'Mutation', sendEcardGuestEmail?: any | null };

export type CreateStationeryDraftFromPrintOrderMutationVariables = Exact<{
  data: CreateStationeryDraftFromPrintOrderInput;
}>;


export type CreateStationeryDraftFromPrintOrderMutation = { __typename?: 'Mutation', createStationeryDraftFromPrintOrder: { __typename?: 'StationeryDraft', id: string, priceConfigId?: string | null, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, premium: boolean, themeId: string } } };

export type SetRecipientSessionIDQueryVariables = Exact<{
  eventID: Scalars['ID'];
  inviteeID: Scalars['String'];
}>;


export type SetRecipientSessionIDQuery = { __typename?: 'Query', getRecipientSessionByInviteePID: string };

export type GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String'];
}>;


export type GetStationaryPrintOrderCardDetailsByOrderNumberQuery = { __typename?: 'Query', stationeryPrintOrderCardDetailsByOrderNumber: { __typename?: 'StationeryPrintOrderCardDetails', detailsJSONBlob?: any | null, digitalEnvelopeImageUrl?: string | null, orderId: string, eventId?: string | null } };

export type GetStationeryEntitiesCountForNavigationByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  input: StationeryDraftsByEventInput;
}>;


export type GetStationeryEntitiesCountForNavigationByEventIdQuery = { __typename?: 'Query', stationeryDraftsCount: Array<{ __typename?: 'StationeryDraft', id: string, cardJSON: any }>, digitalInvitationDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalSaveTheDateDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalPhotoSaveTheDateDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalCustomDraft?: { __typename?: 'ElectronicCard', id: string } | null, stationeryFavoritesCount: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', totalCount: number } } };

export type StationeryTrackDigitalCardViewMutationVariables = Exact<{
  data: CreateStationeryDigitalViewInput;
}>;


export type StationeryTrackDigitalCardViewMutation = { __typename?: 'Mutation', stationeryTrackDigitalCardView?: any | null };

export type GetCurrencyConversionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyConversionsQuery = { __typename?: 'Query', currencyConversions: Array<{ __typename?: 'CurrencyConversion', currencyCode: string, exchangeRate: number, taxesAndFeesMultiplier: number, precision: number, fixedCostPerCardInMinorUnits: number }> };

export type GetCurrencyConversionByCodeQueryVariables = Exact<{
  currencyCode: Scalars['String'];
}>;


export type GetCurrencyConversionByCodeQuery = { __typename?: 'Query', currencyConversionByCode: { __typename?: 'CurrencyConversion', currencyCode: string, exchangeRate: number, taxesAndFeesMultiplier: number, precision: number, fixedCostPerCardInMinorUnits: number } };

export type GetDataForGreetingCardQueryVariables = Exact<{
  ecardId: Scalars['ID'];
}>;


export type GetDataForGreetingCardQuery = { __typename?: 'Query', getGreetingCardById?: { __typename?: 'GreetingCard', id: string, type: string, theme: string, cardDetails: any, eventId: string } | null };

export type SaveGreetingCardAndEmailDraftMutationVariables = Exact<{
  payload: GreetingCardInputWithUrl;
}>;


export type SaveGreetingCardAndEmailDraftMutation = { __typename?: 'Mutation', saveGreetingCardAndEmailDraft?: { __typename?: 'PostOfficeGreetingCardEmailDraft', id: string } | null };

export type SaveGreetingCardMutationVariables = Exact<{
  payload: GreetingCardInput;
}>;


export type SaveGreetingCardMutation = { __typename?: 'Mutation', saveGreetingCard?: { __typename?: 'GreetingCard', id: string } | null };

export type getCardDataForImagineQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
}>;


export type getCardDataForImagineQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', edges: Array<{ __typename?: 'StationeryTemplateEdge', node: { __typename?: 'StationeryTemplate', themeJSON: any, id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, products: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> } }> } } };

export type addAIBackgroundMutationVariables = Exact<{
  promptPayload: AIBackgroundPromptPayload;
  templateId: Scalars['String'];
  m?: InputMaybe<Scalars['String']>;
  oomph?: InputMaybe<Scalars['Float']>;
}>;


export type addAIBackgroundMutation = { __typename?: 'Mutation', stationeryDraftAddAIBackground?: { __typename?: 'ImageHistoryVariation', type: string, baseUrl?: string | null, url: string, resourceID: string, promptPayload: { __typename?: 'VariationPrompt', prompt: string, style: string } } | null };

export type modifyAIBackgroundMutationVariables = Exact<{
  promptPayload: AIBackgroundPromptPayload;
  resourceID: Scalars['String'];
  oomph?: InputMaybe<Scalars['Float']>;
  m?: InputMaybe<Scalars['String']>;
}>;


export type modifyAIBackgroundMutation = { __typename?: 'Mutation', stationeryDraftModifyAIBackground?: { __typename?: 'ImageHistoryVariation', type: string, baseUrl?: string | null, url: string, resourceID: string, promptPayload: { __typename?: 'VariationPrompt', prompt: string, style: string } } | null };

export type GetRegistryShippingAddressQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryShippingAddressQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, postalCode?: string | null, city: string, state: string, countryCode?: string | null, country: string, validated: boolean } | null } } | null };

export type GetStationeryCardDraftByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStationeryCardDraftByIdQuery = { __typename?: 'Query', stationeryDraftById?: { __typename?: 'StationeryDraft', cardJSON: any, eventId?: string | null, format: StationeryDraftFormat, id: string, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, name?: string | null, themeId: string, products: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> }, product?: { __typename?: 'StationeryProduct', id: string } | null } | null };

export type StationeryPrintOrderShippingAddressFragment = { __typename?: 'StationeryPrintOrderShippingAddress', address1: string, address2?: string | null, city: string, country: string, countryCode: string, name: string, postalCode: string, region: string };

export type OrderProductDetailsFragment = { __typename?: 'StationeryPrintOrder', product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null };

export type GetStationaryPrintOrderByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String'];
}>;


export type GetStationaryPrintOrderByOrderNumberQuery = { __typename?: 'Query', stationeryPrintOrderByOrderNumber?: { __typename?: 'StationeryPrintOrder', id: string, priceInMinorUnits: number, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, orderNumber: string, formLink?: string | null, magnetCard?: boolean | null, quantity: number, taxInMinorUnits?: number | null, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, envelopeBackImageUrl?: string | null, envelopeFrontImageUrl?: string | null, cardDraftJSONBlob?: any | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, cardJSON: any, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, themeId: string, products: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> } } | null, statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus', id: string, date: any, status: StationeryPrintOrderStatusEnum }>, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', address1: string, address2?: string | null, city: string, country: string, countryCode: string, name: string, postalCode: string, region: string }, discount?: { __typename?: 'StationeryPrintOrderDiscount', code: string, discountPercentage?: number | null, discountAmountInMinorUnits: any } | null, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget }>, product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null } | null };

export type GetEventPrivacyForCardCustomizerQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventPrivacyForCardCustomizerQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null }, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType } } | null };

export type EventPagesForCardCustomizerQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventPagesForCardCustomizerQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }> } | null };

export type CreateStationeryDraftPreviewMutationVariables = Exact<{
  data: CreateStationeryDraftPreviewInput;
}>;


export type CreateStationeryDraftPreviewMutation = { __typename?: 'Mutation', createStationeryDraftPreview?: { __typename?: 'StationeryDraftPreview', stationeryPDF: string, stationeryFrontImage: string, stationeryBackImage?: string | null, envelopePDF?: string | null, envelopeFrontImage?: string | null, envelopeBackImage?: string | null } | null };

export type CreateStationeryDigitalDraftPreviewMutationVariables = Exact<{
  data: CreateStationeryDraftPreviewInput;
}>;


export type CreateStationeryDigitalDraftPreviewMutation = { __typename?: 'Mutation', createStationeryDigitalDraftPreview?: { __typename?: 'StationeryDigitalDraftPreview', stationeryFrontImage: string, stationeryBackImage: string, digitalEnvelopeImage: string } | null };

export type UpdateStationeryDraftMutationVariables = Exact<{
  payload: UpdateStationeryDraftInput;
}>;


export type UpdateStationeryDraftMutation = { __typename?: 'Mutation', updateStationeryDraft: { __typename?: 'StationeryDraft', id: string, cardJSON: any, eventId?: string | null, ownerId: string, updatedAt: any } };

export type CreateStationeryPrintOrderMutationVariables = Exact<{
  data: CreateStationeryPrintOrderInput;
}>;


export type CreateStationeryPrintOrderMutation = { __typename?: 'Mutation', createStationeryPrintOrder?: { __typename?: 'StationeryPrintOrder', id: string, orderNumber: string } | null };

export type StartStationeryCheckoutMutationVariables = Exact<{
  payload: StartStationeryCheckoutInput;
}>;


export type StartStationeryCheckoutMutation = { __typename?: 'Mutation', startStationeryCheckout: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type StartStationeryInternationalCheckoutMutationVariables = Exact<{
  payload: StartStationeryInternationalCheckoutInput;
}>;


export type StartStationeryInternationalCheckoutMutation = { __typename?: 'Mutation', startStationeryInternationalCheckout: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutation = { __typename?: 'Mutation', deleteStationeryPrintOrderForFailedCheckoutUrl: { __typename?: 'StationeryPrintOrder', id: string } };

export type UpdateWebsiteHandleMutationVariables = Exact<{
  eventId: Scalars['ID'];
  website: Scalars['String'];
}>;


export type UpdateWebsiteHandleMutation = { __typename?: 'Mutation', updateWebsiteHandle: { __typename?: 'Event', id: string, website: string } };

export type CreateQRCodeMutationVariables = Exact<{
  data: CreateQRCodeInput;
}>;


export type CreateQRCodeMutation = { __typename?: 'Mutation', createQRCode: string };

export type EditStationeryPrintOrderMutationVariables = Exact<{
  data: EditStationeryPrintOrderInput;
}>;


export type EditStationeryPrintOrderMutation = { __typename?: 'Mutation', editStationeryPrintOrder: { __typename?: 'StationeryPrintOrder', id: string, eventId?: string | null, ownerId: string, createdAt: any, vendor: StationeryPrintOrderVendorEnum, currentStatus: StationeryPrintOrderStatusEnum, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, quantity: number, priceInMinorUnits: number, taxInMinorUnits?: number | null, currencyConversionData?: any | null, currencyISO4217?: string | null, cardDraftJSONBlob?: any | null, digitalFeatures?: Array<string> | null, orderNumber: string, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, envelopeFrontImageUrl?: string | null, envelopeBackImageUrl?: string | null, stationeryPDFUrl: string, envelopePDFUrl?: string | null, state: StationeryPrintOrderStateEnum, designSetName?: string | null, magnetCard?: boolean | null, statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus', id: string, orderId: string, status: StationeryPrintOrderStatusEnum, date: any }>, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, postalCode: string, region: string, country: string, countryCode: string }, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, paid: boolean, paidAt?: any | null, paymentInfo?: { __typename?: 'StationeryPrintOrderPaymentInfo', creditCardBrand: string, creditCardLast4: string } | null } | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum } } | null, trackingNumbers: Array<{ __typename?: 'StationeryPrintTrackingNumberView', trackingUrl: string }>, refunds: Array<{ __typename?: 'StationeryPrintOrderRefundView', refundAmountInMinorUnits: number }>, discount?: { __typename?: 'StationeryPrintOrderDiscount', code: string, discountAmountInMinorUnits: any, discountPercentage?: number | null } | null, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }>, product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null, selectedProduct?: { __typename?: 'StationeryPrintOrderSelectedProduct', attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute', attributeId: string, optionId: string }> } | null } };

export type CreateAndStartCheckoutDigitalPrintOrderMutationVariables = Exact<{
  data: CreateDigitalPrintOrderInput;
}>;


export type CreateAndStartCheckoutDigitalPrintOrderMutation = { __typename?: 'Mutation', createAndStartCheckoutDigitalPrintOrder: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutationVariables = Exact<{
  data: CreateDigitalPrintOrderInput;
}>;


export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutation = { __typename?: 'Mutation', createAndStartInternationalCheckoutDigitalPrintOrder: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type AddStationeryPrintOrderIssuesMutationVariables = Exact<{
  stationeryPrintOrderId: Scalars['ID'];
  data: Array<CreateStationeryPrintOrderIssueInput> | CreateStationeryPrintOrderIssueInput;
}>;


export type AddStationeryPrintOrderIssuesMutation = { __typename?: 'Mutation', addStationeryPrintOrderIssues: { __typename?: 'StationeryPrintOrder', id: string, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget }> } };

export type ResolveStationeryPrintOrderIssueMutationVariables = Exact<{
  stationeryPrintOrderId: Scalars['ID'];
  issueId: Scalars['ID'];
}>;


export type ResolveStationeryPrintOrderIssueMutation = { __typename?: 'Mutation', resolveStationeryPrintOrderIssue: { __typename?: 'StationeryPrintOrder', id: string, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }> } };

export type CardBackTemplatesByCategoryAndDimensionsQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
}>;


export type CardBackTemplatesByCategoryAndDimensionsQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', edges: Array<{ __typename?: 'StationeryTemplateEdge', node: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, themeJSON: any, thumbnailUrl?: string | null } }> } } };

export type GetEventContactsQueryVariables = Exact<{
  eventId: Scalars['ID'];
  forceGuestListSynch?: InputMaybe<Scalars['Boolean']>;
  firebaseEventId?: InputMaybe<Scalars['ID']>;
}>;


export type GetEventContactsQuery = { __typename?: 'Query', getEventContacts?: any | null };

export type GetContactCollectionByEventIdQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetContactCollectionByEventIdQuery = { __typename?: 'Query', getContactCollectionByEventId?: { __typename?: 'ContactCollection', id: string, magicLink: string, active?: boolean | null } | null };

export type CreateAndStartCheckoutConciergePrintOrderMutationVariables = Exact<{
  payload: CreateConciergePrintOrderInput;
}>;


export type CreateAndStartCheckoutConciergePrintOrderMutation = { __typename?: 'Mutation', createAndStartCheckoutConciergePrintOrder: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type CreateAndStartInternationalCheckoutConciergePrintOrderMutationVariables = Exact<{
  payload: CreateConciergePrintOrderInput;
}>;


export type CreateAndStartInternationalCheckoutConciergePrintOrderMutation = { __typename?: 'Mutation', createAndStartInternationalCheckoutConciergePrintOrder: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type GetEventDateForConciergeQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventDateForConciergeQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null, fianceeFirstName?: string | null, dateV0918?: { __typename?: 'Date', numericalEventDate: string, longEventDate: string } | null } } | null };

export type CardThemeMarketingDataFragment = { __typename?: 'ThemeMarketingData', variationType: ThemeVariationType, id?: string | null, themeId?: string | null, thumbnailUrl: string, name?: string | null, theme?: { __typename?: 'Theme', id: string, themeId: string, name: string } | null };

export type SearchTermToTemplatesQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchTermToTemplatesQuery = { __typename?: 'Query', searchTermToTemplates?: { __typename?: 'SearchTermToTemplatesResponse', tags?: Array<string> | null, query: string, templates: Array<{ __typename?: 'TemplateWithTaggingInfo', templateID: string, matchingTags: number, allTags: Array<string>, matchingDescriptionWords: number }> } | null };

export type PrintDesignsGalleryEventInfoByEventHandleQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type PrintDesignsGalleryEventInfoByEventHandleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, theme: { __typename?: 'Theme', id: string, themeId: string } } | null } | null };

export type StationeryPageInfoFragment = { __typename?: 'StationeryPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null };

export type StationeryDesignGalleryTemplateFragment = { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any };

export type StationeryDesignGalleryFilterTagsFragment = { __typename?: 'StationeryTag', category?: string | null, displayLabel: string, name: string, thumbnailUrl?: string | null };

export type StationeryProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type StationeryProductsQuery = { __typename?: 'Query', stationeryProducts: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> };

export type CardDashboardStationeryTemplatesContainerQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
  includeOptions?: InputMaybe<StationeryTemplateIncludeOptions>;
  first?: InputMaybe<Scalars['Int']>;
  skipDigitalDesigns: Scalars['Boolean'];
}>;


export type CardDashboardStationeryTemplatesContainerQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'StationeryTemplateEdge', cursor: any, node: { __typename?: 'StationeryTemplate', productIds: Array<string>, id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any } }>, pageInfo: { __typename?: 'StationeryPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } }, stationeryTags: Array<{ __typename?: 'StationeryTag', category?: string | null, displayLabel: string, name: string, thumbnailUrl?: string | null }>, ecardDesigns: Array<{ __typename?: 'Theme', id: string, themeId: string, name: string, marketingData: Array<{ __typename?: 'ThemeMarketingData', variantThemeId?: string | null, variationType: ThemeVariationType, imageUrl: string, vendor: string }> }> };

export type MarkStationeryTemplateAsFavoriteMutationVariables = Exact<{
  templateId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type MarkStationeryTemplateAsFavoriteMutation = { __typename?: 'Mutation', markTemplateAsFavorite: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any } };

export type UnmarkStationeryTemplateAsFavoriteMutationVariables = Exact<{
  templateId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type UnmarkStationeryTemplateAsFavoriteMutation = { __typename?: 'Mutation', unmarkTemplateAsFavorite: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any } };

export type StationeryCreateSamplePackOrderMutationVariables = Exact<{
  data: CreateStationerySamplePrintOrderInput;
}>;


export type StationeryCreateSamplePackOrderMutation = { __typename?: 'Mutation', createAndStartCheckoutSamplePrintOrder: { __typename?: 'StartStationeryCheckoutResponse', checkoutUrl?: string | null } };

export type StationeryIsEventEligibleForFreeSampleKitQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type StationeryIsEventEligibleForFreeSampleKitQuery = { __typename?: 'Query', stationeryIsEventEligibleForFreeSampleKit: boolean };

export type EmbeddingQueryVariables = Exact<{
  text: Scalars['String'];
}>;


export type EmbeddingQuery = { __typename?: 'Query', embedding: Array<number> };

export type GetDigitalAndPaperDraftsByEventIdQueryVariables = Exact<{
  input: StationeryDraftsByEventInput;
  eventId: Scalars['ID'];
}>;


export type GetDigitalAndPaperDraftsByEventIdQuery = { __typename?: 'Query', stationeryDrafts: Array<{ __typename?: 'StationeryDraft', format: StationeryDraftFormat, cardJSON: any, eventId?: string | null, id: string, ownerId: string, updatedAt: any, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, thumbnailUrl?: string | null, premium: boolean } }>, digitalInvitationDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalSaveTheDateDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalPhotoSaveTheDateDraft?: { __typename?: 'ElectronicCard', id: string } | null, digitalCustomDraft?: { __typename?: 'ElectronicCard', id: string } | null };

export type DeleteStationeryDraftByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationeryDraftByIdMutation = { __typename?: 'Mutation', deleteStationeryDraftById: { __typename?: 'StationeryDraft', id: string } };

export type GetExistingEventStationeryDraftsWithTemplateQueryVariables = Exact<{
  input: StationeryDraftsByEventInput;
}>;


export type GetExistingEventStationeryDraftsWithTemplateQuery = { __typename?: 'Query', stationeryDraftsByEvent: Array<{ __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum, thumbnailUrl?: string | null } }> };

export type StationeryPrintOrderHistoryByEventQueryVariables = Exact<{
  input: StationeryPrintOrdersByEventInput;
}>;


export type StationeryPrintOrderHistoryByEventQuery = { __typename?: 'Query', stationeryPrintOrdersByEvent: { __typename?: 'StationeryPrintOrdersView', count?: number | null, orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, eventId?: string | null, ownerId: string, createdAt: any, vendor: StationeryPrintOrderVendorEnum, currentStatus: StationeryPrintOrderStatusEnum, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, quantity: number, priceInMinorUnits: number, taxInMinorUnits?: number | null, currencyConversionData?: any | null, currencyISO4217?: string | null, cardDraftJSONBlob?: any | null, digitalFeatures?: Array<string> | null, orderNumber: string, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, envelopeFrontImageUrl?: string | null, envelopeBackImageUrl?: string | null, stationeryPDFUrl: string, envelopePDFUrl?: string | null, state: StationeryPrintOrderStateEnum, designSetName?: string | null, magnetCard?: boolean | null, statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus', id: string, orderId: string, status: StationeryPrintOrderStatusEnum, date: any }>, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, postalCode: string, region: string, country: string, countryCode: string }, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, paid: boolean, paidAt?: any | null, paymentInfo?: { __typename?: 'StationeryPrintOrderPaymentInfo', creditCardBrand: string, creditCardLast4: string } | null } | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum } } | null, trackingNumbers: Array<{ __typename?: 'StationeryPrintTrackingNumberView', trackingUrl: string }>, refunds: Array<{ __typename?: 'StationeryPrintOrderRefundView', refundAmountInMinorUnits: number }>, discount?: { __typename?: 'StationeryPrintOrderDiscount', code: string, discountAmountInMinorUnits: any, discountPercentage?: number | null } | null, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }>, product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null, selectedProduct?: { __typename?: 'StationeryPrintOrderSelectedProduct', attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute', attributeId: string, optionId: string }> } | null }> } };

export type CardPdpDataQueryVariables = Exact<{
  themeId: Scalars['String'];
  category: StationeryTemplateCategoryEnum;
  skipDigitalDesign: Scalars['Boolean'];
}>;


export type CardPdpDataQuery = { __typename?: 'Query', stationeryTemplatesByThemeId: Array<{ __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any, products: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> }>, ecardDesign?: { __typename?: 'Theme', id: string, themeId: string, name: string, marketingData: Array<{ __typename?: 'ThemeMarketingData', variantThemeId?: string | null, variationType: ThemeVariationType, imageUrl: string, vendor: string }> } | null };

export type MatchingFoilTemplateDataQueryVariables = Exact<{
  themeId: Scalars['String'];
  category: StationeryTemplateCategoryEnum;
}>;


export type MatchingFoilTemplateDataQuery = { __typename?: 'Query', stationeryTemplatesByThemeId: Array<{ __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum, thumbnailUrl?: string | null, name?: string | null }> };

export type CreateStationeryDraftMutationVariables = Exact<{
  payload: CreateStationeryDraftInput;
}>;


export type CreateStationeryDraftMutation = { __typename?: 'Mutation', createStationeryDraft: { __typename?: 'StationeryDraft', cardJSON: any, eventId?: string | null, id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum, premium: boolean } } };

export type CardPdpSeoDataQueryVariables = Exact<{
  themeId: Scalars['String'];
  category: StationeryTemplateCategoryEnum;
}>;


export type CardPdpSeoDataQuery = { __typename?: 'Query', stationeryTemplatesByThemeId: Array<{ __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, thumbnailUrl?: string | null }> };

export type StationeryTemplatesBySizeQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
}>;


export type StationeryTemplatesBySizeQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', edges: Array<{ __typename?: 'StationeryTemplateEdge', node: { __typename?: 'StationeryTemplate', id: string, widthInches: number, heightInches: number } }> } } };

export type EventScheduleForStationeryFragment = { __typename?: 'EventSchedule', id: string, placeId?: string | null, location?: string | null, startTime?: { __typename?: 'Date', milliseconds: number, timezone: string } | null };

export type EventWithScheduleQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type EventWithScheduleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, schedule: { __typename?: 'EventScheduleInfo', items: Array<{ __typename?: 'EventSchedule', id: string, placeId?: string | null, location?: string | null, startTime?: { __typename?: 'Date', milliseconds: number, timezone: string } | null }> } } } | null };

export type StationeyDigitalCardCustomizerOrderDataQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  eventHandle: Scalars['String'];
  skipEventData: Scalars['Boolean'];
}>;


export type StationeyDigitalCardCustomizerOrderDataQuery = { __typename?: 'Query', stationeryPrintOrderByOrderNumber?: { __typename?: 'StationeryPrintOrder', id: string, type?: string | null, state: StationeryPrintOrderStateEnum, printCardFrontPreviewUrl: string, digitalEnvelopeImageUrl?: string | null, cardDraftJSONBlob?: any | null, eventId?: string | null, orderNumber: string, digitalFeatures?: Array<string> | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, recipientIdList?: Array<string> | null, cardJSON: any, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum } } | null } | null, eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null } } | null };

export type StationerySendPremiumDigitalOrderToRecipientsMutationVariables = Exact<{
  data: SendPremiumDigitalOrderInput;
}>;


export type StationerySendPremiumDigitalOrderToRecipientsMutation = { __typename?: 'Mutation', sendPremiumDigitalOrder: { __typename?: 'StationeryPrintOrder', id: string, orderNumber: string, state: StationeryPrintOrderStateEnum, currentStatus: StationeryPrintOrderStatusEnum } };

export type StationerySendTestPremiumDigitalEmailMutationVariables = Exact<{
  data: SendTestPremiumDigitalCardInput;
}>;


export type StationerySendTestPremiumDigitalEmailMutation = { __typename?: 'Mutation', sendTestPremiumDigitalCard?: any | null };

export type CardDashboardStationeryFavoriteTemplatesQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type CardDashboardStationeryFavoriteTemplatesQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'StationeryTemplateEdge', cursor: any, node: { __typename?: 'StationeryTemplate', productIds: Array<string>, id: string, category: StationeryTemplateCategoryEnum, approved: boolean, enabled: boolean, name?: string | null, themeId: string, thumbnailUrl?: string | null, premium: boolean, tags: Array<string>, isFavorite: boolean, widthInches: number, heightInches: number, themeJSON: any, favorites: Array<{ __typename?: 'StationeryFavorite', id: string, createdAt: any }> } }> } } };

export type OrderSelectedProductInfoFragment = { __typename?: 'StationeryPrintOrder', id: string, selectedProduct?: { __typename?: 'StationeryPrintOrderSelectedProduct', attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute', attributeId: string, optionId: string }> } | null };

export type StationeryPrintOrderDetailsFragment = { __typename?: 'StationeryPrintOrder', id: string, eventId?: string | null, ownerId: string, createdAt: any, vendor: StationeryPrintOrderVendorEnum, currentStatus: StationeryPrintOrderStatusEnum, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, quantity: number, priceInMinorUnits: number, taxInMinorUnits?: number | null, currencyConversionData?: any | null, currencyISO4217?: string | null, cardDraftJSONBlob?: any | null, digitalFeatures?: Array<string> | null, orderNumber: string, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, envelopeFrontImageUrl?: string | null, envelopeBackImageUrl?: string | null, stationeryPDFUrl: string, envelopePDFUrl?: string | null, state: StationeryPrintOrderStateEnum, designSetName?: string | null, magnetCard?: boolean | null, statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus', id: string, orderId: string, status: StationeryPrintOrderStatusEnum, date: any }>, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, postalCode: string, region: string, country: string, countryCode: string }, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, paid: boolean, paidAt?: any | null, paymentInfo?: { __typename?: 'StationeryPrintOrderPaymentInfo', creditCardBrand: string, creditCardLast4: string } | null } | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum } } | null, trackingNumbers: Array<{ __typename?: 'StationeryPrintTrackingNumberView', trackingUrl: string }>, refunds: Array<{ __typename?: 'StationeryPrintOrderRefundView', refundAmountInMinorUnits: number }>, discount?: { __typename?: 'StationeryPrintOrderDiscount', code: string, discountAmountInMinorUnits: any, discountPercentage?: number | null } | null, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }>, product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null, selectedProduct?: { __typename?: 'StationeryPrintOrderSelectedProduct', attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute', attributeId: string, optionId: string }> } | null };

export type StationeryPrintOrderByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String'];
}>;


export type StationeryPrintOrderByOrderNumberQuery = { __typename?: 'Query', stationeryPrintOrderByOrderNumber?: { __typename?: 'StationeryPrintOrder', id: string, eventId?: string | null, ownerId: string, createdAt: any, vendor: StationeryPrintOrderVendorEnum, currentStatus: StationeryPrintOrderStatusEnum, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, quantity: number, priceInMinorUnits: number, taxInMinorUnits?: number | null, currencyConversionData?: any | null, currencyISO4217?: string | null, cardDraftJSONBlob?: any | null, digitalFeatures?: Array<string> | null, orderNumber: string, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, envelopeFrontImageUrl?: string | null, envelopeBackImageUrl?: string | null, stationeryPDFUrl: string, envelopePDFUrl?: string | null, state: StationeryPrintOrderStateEnum, designSetName?: string | null, magnetCard?: boolean | null, statusHistory: Array<{ __typename?: 'StationeryPrintOrderStatus', id: string, orderId: string, status: StationeryPrintOrderStatusEnum, date: any }>, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, postalCode: string, region: string, country: string, countryCode: string }, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, paid: boolean, paidAt?: any | null, paymentInfo?: { __typename?: 'StationeryPrintOrderPaymentInfo', creditCardBrand: string, creditCardLast4: string } | null } | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, format: StationeryDraftFormat, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, name?: string | null, themeId: string, category: StationeryTemplateCategoryEnum } } | null, trackingNumbers: Array<{ __typename?: 'StationeryPrintTrackingNumberView', trackingUrl: string }>, refunds: Array<{ __typename?: 'StationeryPrintOrderRefundView', refundAmountInMinorUnits: number }>, discount?: { __typename?: 'StationeryPrintOrderDiscount', code: string, discountAmountInMinorUnits: any, discountPercentage?: number | null } | null, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }>, product?: { __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> } | null, selectedProduct?: { __typename?: 'StationeryPrintOrderSelectedProduct', attributes: Array<{ __typename?: 'StationeryPrintOrderProductAttribute', attributeId: string, optionId: string }> } | null } | null };

export type StationeryPrintOrderIdByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  eventId: Scalars['ID'];
}>;


export type StationeryPrintOrderIdByOrderNumberQuery = { __typename?: 'Query', stationeryPrintOrderByOrderNumber?: { __typename?: 'StationeryPrintOrder', id: string, printCardFrontPreviewUrl: string, cardDraftJSONBlob?: any | null, cardDraft?: { __typename?: 'StationeryDraft', id: string, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum, name?: string | null } } | null } | null, event?: { __typename?: 'Event', id: string, guests: { __typename?: 'EventGuests', people: Array<{ __typename?: 'Person', id: string, firstName?: string | null, fullName?: string | null, email?: string | null, phoneNumber?: string | null }> } } | null };

export type StationeryOrderTrackingQueryVariables = Exact<{
  eventId: Scalars['String'];
  criteria?: InputMaybe<MessageSearchQueryCriteria>;
  cardViewInput?: InputMaybe<GetStationeryDigitalViewInput>;
}>;


export type StationeryOrderTrackingQuery = { __typename?: 'Query', messageSearchResults: { __typename?: 'MessageSearchResultContainer', allResult: { __typename?: 'MessageResult', messages: Array<{ __typename?: 'Message', id: string, type: MessageType, status: MessageStatus, sentOn?: { __typename?: 'Date', milliseconds: number } | null, recipient: { __typename?: 'RecipientInfo', personId?: string | null, email?: string | null, phoneNumber?: string | null } }> } }, stationeryDigitalCardView: Array<{ __typename?: 'StationeryDigitalView', id: number, personId: string, src: StationeryDigitalViewSource }> };

export type CreateEcardShortLinkMutationVariables = Exact<{
  data: CreateLinkRedirectInput;
}>;


export type CreateEcardShortLinkMutation = { __typename?: 'Mutation', createLinkRedirect: { __typename?: 'LinkRedirect', id: string, joyUrl: any } };

export type GetPublicCardShopLoginFallbackTemplateQueryVariables = Exact<{
  themeId: Scalars['String'];
  categories?: InputMaybe<Array<StationeryTemplateCategoryEnum> | StationeryTemplateCategoryEnum>;
}>;


export type GetPublicCardShopLoginFallbackTemplateQuery = { __typename?: 'Query', stationeryTemplatesByThemeId: Array<{ __typename?: 'StationeryTemplate', id: string, themeId: string, themeJSON: any, category: StationeryTemplateCategoryEnum, premium: boolean }> };

export type RestoreEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreEventMutation = { __typename?: 'Mutation', restoreEvent?: any | null };

export type GetEmailDeliveryDataQueryVariables = Exact<{
  args?: InputMaybe<EmailSearchCriteria>;
}>;


export type GetEmailDeliveryDataQuery = { __typename?: 'Query', getEmailDeliveryData?: { __typename?: 'EmailSearchResultsSummaryView', pageInfo: { __typename?: 'Email_PageInfo', totalPageCount?: number | null }, edges: Array<{ __typename?: 'EmailSearchCollectionItemsEdge', node: { __typename?: 'EmailDeliverySearchResult', eventId?: string | null, messageId?: string | null, subject: string, toEmail?: string | null, fromEmail?: string | null, status?: string | null, emailType?: string | null, createdDate?: string | null, mainContent?: string | null, replyToEmail?: string | null, statusHistory: Array<{ __typename?: 'EmailStatus', status: string, message?: string | null, description?: string | null }> } }> } | null };

export type GetEventByNameServiceCenterQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type GetEventByNameServiceCenterQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, website: string, firebaseId: string, info: { __typename?: 'EventInfo', id: string, safetyRating?: SafetyRating | null } } | null };

export type GetEventByIdServiceCenterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEventByIdServiceCenterQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, firebaseId: string, info: { __typename?: 'EventInfo', id: string, safetyRating?: SafetyRating | null }, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, email?: string | null } }> } | null };

export type UpdateSafetyRatingMutationVariables = Exact<{
  eventId: Scalars['ID'];
  safetyRating: SafetyRating;
}>;


export type UpdateSafetyRatingMutation = { __typename?: 'Mutation', updateSafetyRating: { __typename?: 'EventInfo', id: string, safetyRating?: SafetyRating | null } };

export type StationeryPrintOrderFieldsFragment = { __typename?: 'StationeryPrintOrder', id: string, createdAt: any, priceInMinorUnits: number, quantity: number, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, currentStatus: StationeryPrintOrderStatusEnum, orderNumber: string, ownerId: string, eventId?: string | null, designSetName?: string | null, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, vendor: StationeryPrintOrderVendorEnum, cardDraft?: { __typename?: 'StationeryDraft', id: string, ownerId: string, eventId?: string | null, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum } } | null, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, stationeryPrintOrderId: string, salesOrderId: string, paid: boolean, paidAt?: any | null } | null, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, region: string, postalCode: string, country: string, countryCode: string }, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }> };

export type GetStationeryPrintOrdersQueryVariables = Exact<{
  filters?: InputMaybe<StationeryPrintOrdersFiltersInput>;
  pagination?: InputMaybe<StationeryPrintOrdersPaginationInput>;
}>;


export type GetStationeryPrintOrdersQuery = { __typename?: 'Query', stationeryPrintOrders: { __typename?: 'StationeryPrintOrdersView', count?: number | null, orders: Array<{ __typename?: 'StationeryPrintOrder', id: string, createdAt: any, priceInMinorUnits: number, quantity: number, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, currentStatus: StationeryPrintOrderStatusEnum, orderNumber: string, ownerId: string, eventId?: string | null, designSetName?: string | null, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, vendor: StationeryPrintOrderVendorEnum, cardDraft?: { __typename?: 'StationeryDraft', id: string, ownerId: string, eventId?: string | null, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum } } | null, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, stationeryPrintOrderId: string, salesOrderId: string, paid: boolean, paidAt?: any | null } | null, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, region: string, postalCode: string, country: string, countryCode: string }, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }> }> } };

export type GetStationeryPrintOrderByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String'];
}>;


export type GetStationeryPrintOrderByOrderNumberQuery = { __typename?: 'Query', stationeryPrintOrderByOrderNumber?: { __typename?: 'StationeryPrintOrder', id: string, createdAt: any, priceInMinorUnits: number, quantity: number, deliveryMethod: StationeryPrintOrderDeliveryMethodEnum, currentStatus: StationeryPrintOrderStatusEnum, orderNumber: string, ownerId: string, eventId?: string | null, designSetName?: string | null, printCardFrontPreviewUrl: string, printCardBackPreviewUrl: string, vendor: StationeryPrintOrderVendorEnum, cardDraft?: { __typename?: 'StationeryDraft', id: string, ownerId: string, eventId?: string | null, stationeryTemplate: { __typename?: 'StationeryTemplate', id: string, themeId: string, category: StationeryTemplateCategoryEnum } } | null, printPayment?: { __typename?: 'StationeryPrintOrderPayment', id: string, stationeryPrintOrderId: string, salesOrderId: string, paid: boolean, paidAt?: any | null } | null, shippingAddress: { __typename?: 'StationeryPrintOrderShippingAddress', name: string, address1: string, address2?: string | null, city: string, region: string, postalCode: string, country: string, countryCode: string }, issues: Array<{ __typename?: 'StationeryPrintOrderIssue', id: string, resolvedAt?: any | null, issueType: StationeryPrintOrderIssueType, issueTarget: StationeryPrintOrderIssueTarget, additionalUserFacingDescription?: string | null }> } | null };

export type CancelStationeryPrintOrderByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelStationeryPrintOrderByIdMutation = { __typename?: 'Mutation', cancelStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string } | null };

export type RefundStationeryPrintOrderByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefundStationeryPrintOrderByIdMutation = { __typename?: 'Mutation', refundStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string } | null };

export type PauseStationeryPrintOrderByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PauseStationeryPrintOrderByIdMutation = { __typename?: 'Mutation', pauseStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string } | null };

export type ResumeStationeryPrintOrderByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResumeStationeryPrintOrderByIdMutation = { __typename?: 'Mutation', resumeStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string } | null };

export type InstantlyProcessStationeryPrintOrderByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InstantlyProcessStationeryPrintOrderByIdMutation = { __typename?: 'Mutation', instantlyProcessStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder', id: string } | null };

export type UpdateStationeryPrintOrderShippingAddressMutationVariables = Exact<{
  data: UpdateStationeryPrintOrderShippingAddressInput;
}>;


export type UpdateStationeryPrintOrderShippingAddressMutation = { __typename?: 'Mutation', updateStationeryPrintOrderShippingAddress?: any | null };

export type CombineStationeryPrintOrdersMutationVariables = Exact<{
  data: BundleStationeryPrintOrderInput;
}>;


export type CombineStationeryPrintOrdersMutation = { __typename?: 'Mutation', combineStationeryPrintOrders?: any | null };

export type SetStationeryDigitalPrintOrderFeatureSmsMutationVariables = Exact<{
  data: SetStationeryDigitalPrintOrderFeatureSmsInput;
}>;


export type SetStationeryDigitalPrintOrderFeatureSmsMutation = { __typename?: 'Mutation', setStationeryDigitalPrintOrderFeatureSms?: any | null };

export type ServiceCenterStationeryTemplatesContainerQueryVariables = Exact<{
  filter: StationeryTemplateFilter;
  includeOptions?: InputMaybe<StationeryTemplateIncludeOptions>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type ServiceCenterStationeryTemplatesContainerQuery = { __typename?: 'Query', stationeryTemplatesContainer: { __typename?: 'StationeryTemplateContainer', pagedResults: { __typename?: 'StationeryTemplateConnection', totalCount: number, edges: Array<{ __typename?: 'StationeryTemplateEdge', cursor: any, node: { __typename?: 'StationeryTemplate', id: string, category: StationeryTemplateCategoryEnum, themeId: string, themeJSON: any, widthInches: number, heightInches: number, side?: string | null } }>, pageInfo: { __typename?: 'StationeryPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } };

export type MessageInfoFragment = { __typename?: 'ContactQuarantinedMessageBatchDetails', id: string, createdAt: any, updatedAt: any, messageBatchType: string, messageBatchId: string, eventId: string, messageBatchPayload: any, spamIndicatorsPayload?: any | null, quarantineStatus: QuarantineStatus, reviewedAt?: any | null, reviewedByUserId?: string | null };

export type MessageInfoCursorFragment = { __typename?: 'ContactQuarantinedMessageBatchEdge', cursor: any };

export type GetQuarantinedMessagesQueryVariables = Exact<{
  filter: ContactQuarantinedMessageBatchFilter;
  sort: ContactQuarantinedMessageBatchSort;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ContactQuarantinedMessageBatchCursor']>;
}>;


export type GetQuarantinedMessagesQuery = { __typename?: 'Query', contactQuarantinedMessageBatchContainer: { __typename?: 'ContactQuarantinedMessageBatchContainer', pagedResults: { __typename?: 'ContactQuarantinedMessageBatchConnection', totalCount: number, edges: Array<{ __typename?: 'ContactQuarantinedMessageBatchEdge', cursor: any, node: { __typename?: 'ContactQuarantinedMessageBatchDetails', id: string, createdAt: any, updatedAt: any, messageBatchType: string, messageBatchId: string, eventId: string, messageBatchPayload: any, spamIndicatorsPayload?: any | null, quarantineStatus: QuarantineStatus, reviewedAt?: any | null, reviewedByUserId?: string | null } }> } } };

export type ResolveUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResolveUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, lastName?: string | null, firstName?: string | null, email?: string | null } | null };

export type GetEventInfoForServiceCenterQueryVariables = Exact<{
  eventByIdId: Scalars['ID'];
}>;


export type GetEventInfoForServiceCenterQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null } } | null };

export type ApproveContactMessageBatchMutationVariables = Exact<{
  approveContactMessageBatchId: Scalars['ID'];
}>;


export type ApproveContactMessageBatchMutation = { __typename?: 'Mutation', approveContactMessageBatch: { __typename?: 'ContactQuarantinedMessageBatchDetails', id: string } };

export type RejectContactMessageBatchMutationVariables = Exact<{
  rejectContactMessageBatchId: Scalars['ID'];
}>;


export type RejectContactMessageBatchMutation = { __typename?: 'Mutation', rejectContactMessageBatch: { __typename?: 'ContactQuarantinedMessageBatchDetails', id: string } };

export type ElectronicCardCardLinkOptionFragment = { __typename?: 'ElectronicCardCardLinkOption', name: string, label: string };

export type EcardDesignFragment = { __typename?: 'EcardDesign', theme?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null };

export type EcardEventDesignFragment = { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null, brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> }, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> };

export type ElectronicCardFragment = { __typename?: 'ElectronicCard', id: string, title: string, subTitle?: string | null, message?: string | null, additionalMessage?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationString?: string | null, displayDateFormat?: string | null, displayDateString?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, event: { __typename?: 'Event', id: string }, design?: { __typename?: 'EcardDesign', shouldUseEventDesign?: boolean | null, theme?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null };

export type EcardEmailDraftFragment = { __typename?: 'ElectronicCardEcardEmailDraft', id: string, ecardId: string, ecardType: EcardType, replyToEmail?: string | null, salutation?: string | null, includeGuestNames: boolean, includeDate: boolean, includeAddToCalendar: boolean, message?: string | null, subject: string, buttonText?: string | null, title: string, subTitle?: string | null, imageUrl?: string | null };

export type DomainDataFragment = { __typename?: 'Event', id: string, website: string, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null };

export type GetEcardDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
  ecardType?: InputMaybe<EcardType>;
}>;


export type GetEcardDataQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, photoV2Url?: string | null, website: string, info: { __typename?: 'EventInfo', id: string, date?: string | null, eventPassword?: string | null, location?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, finalizedDate?: { __typename?: 'Date', timestamp: any } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null, brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> }, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null } | null, getMostRecentEcardByEventId?: { __typename?: 'ElectronicCard', id: string, title: string, subTitle?: string | null, message?: string | null, additionalMessage?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationString?: string | null, displayDateFormat?: string | null, displayDateString?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, event: { __typename?: 'Event', id: string }, design?: { __typename?: 'EcardDesign', shouldUseEventDesign?: boolean | null, theme?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null } | null, getEcardEmailDraftsByEventId: Array<{ __typename?: 'ElectronicCardEcardEmailDraft', id: string, ecardId: string, ecardType: EcardType, replyToEmail?: string | null, salutation?: string | null, includeGuestNames: boolean, includeDate: boolean, includeAddToCalendar: boolean, message?: string | null, subject: string, buttonText?: string | null, title: string, subTitle?: string | null, imageUrl?: string | null }>, getEcardLinkOptionsByEventId: Array<{ __typename?: 'ElectronicCardCardLinkOption', name: string, label: string }> };

export type SaveEcardMutationVariables = Exact<{
  payload: ElectronicCardInput;
}>;


export type SaveEcardMutation = { __typename?: 'Mutation', saveEcard?: { __typename?: 'ElectronicCard', id: string } | null };

export type SaveEcardDesignMutationVariables = Exact<{
  payload: EcardDesignInput;
}>;


export type SaveEcardDesignMutation = { __typename?: 'Mutation', saveEcardDesign?: boolean | null };

export type SendEcardGuestEmailMutationVariables = Exact<{
  payload?: InputMaybe<ElectronicCardEmailMessageInput>;
}>;


export type SendEcardGuestEmailMutation = { __typename?: 'Mutation', sendEcardGuestEmail?: any | null };

export type EcardThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type EcardThemesQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> }> };

export type CharmEditorThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type CharmEditorThemesQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'Theme', id: string, name: string, themeId: string, thumbnailUrl: string, supportsPrints: boolean, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, supportsCustomization: boolean } | null } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }> }> };

export type EcardThemeByThemeIdQueryVariables = Exact<{
  themeId: Scalars['String'];
}>;


export type EcardThemeByThemeIdQuery = { __typename?: 'Query', themeByThemeId?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null };

export type SaveEcardEmailMutationVariables = Exact<{
  payload?: InputMaybe<ElectronicCardEmailDraftInput>;
}>;


export type SaveEcardEmailMutation = { __typename?: 'Mutation', saveEcardEmailDraft?: any | null };

export type GetEcardByGuidQueryVariables = Exact<{
  lookupId: Scalars['ID'];
}>;


export type GetEcardByGuidQuery = { __typename?: 'Query', getEcardRecepientDisplayByLookupId?: { __typename?: 'ElectronicCard', id: string, title: string, subTitle?: string | null, message?: string | null, additionalMessage?: string | null, linkOptionPrimary?: string | null, linkOptionSecondary?: string | null, locationString?: string | null, displayDateFormat?: string | null, displayDateString?: string | null, displayEventLink?: boolean | null, eventId: string, householdDisplayName?: string | null, type?: string | null, guidId?: string | null, photoEcardTheme?: string | null, photoEcardThemePositionX?: number | null, photoEcardThemePositionY?: number | null, photoEcardThemeScale?: number | null, event: { __typename?: 'Event', id: string }, design?: { __typename?: 'EcardDesign', shouldUseEventDesign?: boolean | null, theme?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, assetId: string, width: number, height: number } | null } | null };

export type GetEcardGuestExtraDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEcardGuestExtraDataQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null, eventDisplayName?: string | null, locale: string, finalizedDate?: { __typename?: 'Date', timestamp: any } | null }, settings: { __typename?: 'EventSettings', id: string, privacyMode: PrivacyModeType }, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null } | null, getEcardLinkOptionsByEventId: Array<{ __typename?: 'ElectronicCardCardLinkOption', name: string, label: string }> };

export type GuestCanGetAccessEventByNameActionBarQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GuestCanGetAccessEventByNameActionBarQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, location?: string | null, eventDateIsFinalized: boolean, dateV0918?: { __typename?: 'Date', dateString: string, milliseconds: number } | null, schedule: { __typename?: 'EventScheduleInfo', items: Array<{ __typename?: 'EventSchedule', id: string, startTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', linkText: string, urlLinkText?: string | null, provider: VirtualEventProvider, urlBrowser?: string | null, isLinkValid: boolean } | null }>, virtualScheduleItemNow?: { __typename?: 'EventSchedule', id: string, startTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', linkText: string, urlLinkText?: string | null, provider: VirtualEventProvider, urlBrowser?: string | null, isLinkValid: boolean } | null } | null } } } | null };

export type WebsitePagePhotoPresentationCropInfoFragment = { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string };

export type WebsitePagePhotoPresentationFragment = { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null };

export type EventWebsiteGuestQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventDesignPurpose: EventDesignPurpose;
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventWebsiteGuestQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, useLegacyGuestSite?: boolean | null, photoV2Url?: string | null, photoV2UrlMobile?: string | null, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null, thumbnailUrl?: string | null, mimeType: string, caption?: string | null } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, announcementBanner: { __typename?: 'EventAnnouncementBanner', title: string, message: string, active: boolean }, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, settings: { __typename?: 'EventSettings', id: string, hideFromSearchEngines: boolean }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, pageContainers?: Array<{ __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null }> | null } | null };

export type EventWebsiteGuestTelemetryQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventDesignPurpose: EventDesignPurpose;
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventWebsiteGuestTelemetryQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, activeSession: { __typename?: 'EventSession', id: string, hasUnlocked: boolean }, pages: Array<{ __typename?: 'EventPage', id: string, pageTitle: string, pageSlug: string, visibility: EventPageVisibility, disabled: boolean, private: boolean }> } | null };

export type GetGuestsiteDataForPagesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
  eventDesignPurpose: EventDesignPurpose;
}>;


export type GetGuestsiteDataForPagesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null, info: { __typename?: 'EventInfo', id: string, story?: string | null, tidbits: Array<{ __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string }> } } | null };

export type GetEventCTAPageInfoFragment = { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType };

export type GetEventCTASessionFragment = { __typename?: 'EventSession', id: string, hasUnlocked: boolean, hasIdentity: boolean, eventCTA: { __typename?: 'EventSessionCTA', rsvpIsEnabled: boolean, scheduleHasInviteOnlyItems: boolean, requiresPassword: boolean, label: string, rsvpIsCompleted: boolean, rsvpAttendanceStatus: EventRSVPAttendanceStatus }, person?: { __typename?: 'Person', id: string, fullName?: string | null, firstName?: string | null, avatarName?: string | null, email?: string | null } | null };

export type GetEventCTAButtonsDataQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetEventCTAButtonsDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventType: EventType }, activeSession: { __typename?: 'EventSession', id: string, hasUnlocked: boolean, hasIdentity: boolean, eventCTA: { __typename?: 'EventSessionCTA', rsvpIsEnabled: boolean, scheduleHasInviteOnlyItems: boolean, requiresPassword: boolean, label: string, rsvpIsCompleted: boolean, rsvpAttendanceStatus: EventRSVPAttendanceStatus }, person?: { __typename?: 'Person', id: string, fullName?: string | null, firstName?: string | null, avatarName?: string | null, email?: string | null } | null }, welcomePage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, storyPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, tidbitsPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, schedulePage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, travelPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, faqPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, weddingPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, registryPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, momentsPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, rsvpPage?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType } | null, customPages?: Array<{ __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, type: EventPageType, page: { __typename?: 'EventPage', id: string, pageSlug: string } }> | null } | null };

export type GetRsvpPropertiesQueryVariables = Exact<{
  eventName: Scalars['String'];
}>;


export type GetRsvpPropertiesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, rsvpPage?: { __typename?: 'EventPageInfo', id: string, disabled: boolean, private: boolean, visibility: EventPageVisibility } | null } | null };

export type FindInviteQueryVariables = Exact<{
  eventId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type FindInviteQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, activeSession: { __typename?: 'EventSession', id: string, sessionId: string }, findPeople: { __typename?: 'PeopleFindResultSet', resultCount: number, results: Array<{ __typename?: 'PeopleFindResult', person: { __typename?: 'Person', id: string, personIdTag: string, firstName?: string | null, lastName?: string | null, email?: string | null } }> } } | null };

export type WebsiteHeaderPresentationSettingsFragment = { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string };

export type GuestSiteWebsiteHeaderSettingsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventDesignPurpose: EventDesignPurpose;
}>;


export type GuestSiteWebsiteHeaderSettingsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, greeting?: string | null }, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null } | null } | null };

export type WebsitePageListQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  admin: Scalars['Boolean'];
}>;


export type WebsitePageListQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', pageTitle: string, pageSlug: string, visibility: EventPageVisibility, id: string, isPageContainer: boolean, type: EventPageType, subTitle?: string | null, createdAt: { __typename?: 'Date', timestamp: any } }> } | null };

export type GetGuestsiteCoupleStoryAndQandasQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestsiteCoupleStoryAndQandasQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, story?: string | null, tidbits: Array<{ __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string }> } } | null };

export type GuestTextComponentFragment = { __typename?: 'TextComponent', id: string, text: string, sortOrder: number, type: ComponentType };

export type GuestEventDetailsComponentFragment = { __typename?: 'EventDetailsComponent', id: string, sortOrder: number, type: ComponentType };

export type GuestRsvpAndUnlockGuestDetailsButtonComponentFragment = { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent', id: string, sortOrder: number, type: ComponentType };

export type GuestPhotoComponentFragment = { __typename?: 'PhotoComponent', id: string, type: ComponentType, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string } };

export type GuestVideoComponentFragment = { __typename?: 'VideoComponent', id: string, sortOrder: number, type: ComponentType, videoUrl: string, caption?: string | null };

export type GuestTravelMapComponentFragment = { __typename?: 'TravelMapComponent', id: string, sortOrder: number, blockOrdering?: Array<string> | null, hideExploreCTA: boolean };

export type GuestMediaGalleryComponentFragment = { __typename?: 'MediaGalleryComponent', id: string, sortOrder: number, type: ComponentType, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string, magicTokenPermissions?: Array<MagicTokenPermissions | null> | null, media?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null };

export type GuestJsonDataBlobComponentFragment = { __typename: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string, containerContent: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } };

export type GuestPageDataContainerByIdQueryVariables = Exact<{
  payload: JsonDataContainerByIdPayload;
}>;


export type GuestPageDataContainerByIdQuery = { __typename?: 'Query', jsonDataContainerById?: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } | null };

export type GuestPageContainerBySlugQueryVariables = Exact<{
  payload: PageContainerBySlugPayload;
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GuestPageContainerBySlugQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, slug: string, createdAt: { __typename?: 'Date', timestamp: any }, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent', id: string, sortOrder: number, type: ComponentType } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string, containerContent: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } } | { __typename?: 'MediaGalleryComponent', id: string, sortOrder: number, type: ComponentType, mediaCollection?: { __typename?: 'MediaCollection', id: string, name: string, magicTokenPermissions?: Array<MagicTokenPermissions | null> | null, media?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null } | { __typename?: 'PhotoComponent', id: string, type: ComponentType, sortOrder: number, photo: { __typename?: 'Photo', id: string, url: string } } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent', id: string, sortOrder: number, type: ComponentType } | { __typename?: 'TextComponent', id: string, text: string, sortOrder: number, type: ComponentType } | { __typename?: 'TravelMapComponent', id: string, sortOrder: number, blockOrdering?: Array<string> | null, hideExploreCTA: boolean } | { __typename?: 'VideoComponent', id: string, sortOrder: number, type: ComponentType, videoUrl: string, caption?: string | null }> | null } | null };

export type GuestEventHotelRoomBlocksQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GuestEventHotelRoomBlocksQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, travelSettings?: { __typename?: 'TravelSettings', currencyCode?: TravelCurrencyCode | null } | null, info: { __typename?: 'EventInfo', id: string, timezone?: string | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, isFavorite?: boolean | null, userNote?: string | null, name?: string | null, description?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, starRating?: number | null, country?: string | null, email?: string | null, phone?: string | null, url?: string | null, lat?: number | null, long?: number | null, isPhotoHidden?: boolean | null, zhId?: string | null, googlePlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, customPhone?: string | null, createdByType: string, isFromAccommodationCatalog: boolean, isHostStayingHere?: boolean | null, joyPlaceId?: string | null, isCustomLinkEnabled?: boolean | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> } | null }> } | null };

export type AccommodationPagePricingQueryVariables = Exact<{
  payload: TravelPricingsForAccommodationByPropertyIdPayload;
}>;


export type AccommodationPagePricingQuery = { __typename?: 'Query', travelPricingsForAccommodationByPropertyId: { __typename?: 'TravelPricingsByPropertyIdResult', pricings: Array<{ __typename: 'TravelPricingByPropertyIdItem', property: { __typename: 'AccommodationCatalogProperty', joyPlaceId: string }, pricingData?: { __typename: 'TravelPricingByPropertyIdData', perNightOriginalAmountBeforeTaxesAndFees?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, perNightFinalAmountBeforeTaxesAndFees?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, originalAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null } | null }> } };

export type PricingByPropertyIdFragment = { __typename: 'TravelPricingByPropertyIdItem', property: { __typename: 'AccommodationCatalogProperty', joyPlaceId: string }, pricingData?: { __typename: 'TravelPricingByPropertyIdData', perNightOriginalAmountBeforeTaxesAndFees?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, perNightFinalAmountBeforeTaxesAndFees?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, originalAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null } | null };

export type TravelPlacesPricingAndBookingDetailsQueryVariables = Exact<{
  payload: TravelPlacePricingAndBookingDetailsPayload;
}>;


export type TravelPlacesPricingAndBookingDetailsQuery = { __typename?: 'Query', travelPlacesPricingAndBookingDetails: { __typename?: 'TravelPlacePricingAndBookingDetailsResult', accommodationPlaces: Array<{ __typename: 'AccommodationPlacePricingAndBookingDetails', accommodationPlace: { __typename: 'AccommodationPlaceV2', id: string, lat?: number | null, long?: number | null, googlePlaceId?: string | null, joyPlaceId?: string | null, name?: string | null, address?: string | null, zhId?: string | null, url?: string | null, customUrl?: string | null, starRating?: number | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }, pricingInfo?: { __typename?: 'PricingForAccommodationPlace', strikeoutRateProvider?: StrikeoutRateProvider | null, baseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyTotalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, strikeoutBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, totalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } } | null, redirectMechanisms?: Array<{ __typename: 'RedirectMechanism', telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null, type: RedirectMechanismType, url: string }> | null }>, joyPlaces: Array<{ __typename: 'JoyPlacePricingAndBookingDetails', joyPlace: { __typename: 'JoyPlace', id: string, lat?: number | null, long?: number | null, googlePlaceId?: string | null, name?: string | null, address?: string | null, zhId?: string | null, url?: string | null }, pricingInfo?: { __typename: 'PricingForAccommodationPlace', nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, totalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } } | null, redirectMechanisms?: Array<{ __typename: 'RedirectMechanism', telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null, type: RedirectMechanismType, url: string }> | null }> } };

export type TravelPlacePricingAndBookingDetailsFragment = { __typename: 'AccommodationPlacePricingAndBookingDetails', accommodationPlace: { __typename: 'AccommodationPlaceV2', id: string, lat?: number | null, long?: number | null, googlePlaceId?: string | null, joyPlaceId?: string | null, name?: string | null, address?: string | null, zhId?: string | null, url?: string | null, customUrl?: string | null, starRating?: number | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }, pricingInfo?: { __typename?: 'PricingForAccommodationPlace', strikeoutRateProvider?: StrikeoutRateProvider | null, baseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyTotalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, strikeoutBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, totalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } } | null, redirectMechanisms?: Array<{ __typename: 'RedirectMechanism', telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null, type: RedirectMechanismType, url: string }> | null };

export type TravelJoyPlacePricingAndBookingDetailsFragment = { __typename: 'JoyPlacePricingAndBookingDetails', joyPlace: { __typename: 'JoyPlace', id: string, lat?: number | null, long?: number | null, googlePlaceId?: string | null, name?: string | null, address?: string | null, zhId?: string | null, url?: string | null }, pricingInfo?: { __typename: 'PricingForAccommodationPlace', nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, totalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } } | null, redirectMechanisms?: Array<{ __typename: 'RedirectMechanism', telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null, type: RedirectMechanismType, url: string }> | null };

export type IncrementInterestedGuestCountMutationVariables = Exact<{
  reservedRoomBlockId: Scalars['ID'];
}>;


export type IncrementInterestedGuestCountMutation = { __typename?: 'Mutation', incrementInterestedGuestCount?: any | null };

export type TravelReservationSummariesByPropertyIdentifiersQueryVariables = Exact<{
  payload: TravelReservationSummariesByPropertyIdentifiersPayload;
}>;


export type TravelReservationSummariesByPropertyIdentifiersQuery = { __typename?: 'Query', travelReservationSummariesByPropertyIdentifiers?: { __typename?: 'TravelReservationSummariesByPropertyIdentifiersResult', reservationSummaries?: Array<{ __typename?: 'TravelReservationsSummary', reservationsCount?: number | null, identifier: { __typename?: 'AccommodationCatalogPropertyIdentifier', id: string, type: AccommodationCatalogPropertyIdentifierV2Type } }> | null } | null };

export type TravelRateComparisonsForTravelPlacesQueryVariables = Exact<{
  payload: ComparisonsForTravelPlaceIdPayload;
}>;


export type TravelRateComparisonsForTravelPlacesQuery = { __typename?: 'Query', travelRateComparisonsForTravelPlaces: Array<{ __typename?: 'TravelPlaceComparison', joyPlaceId: string, id: string, providers: Array<{ __typename?: 'TravelPlaceComparisonForProvider', providerFQDN: string, providerSearchURL: string, nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } }> }> };

export type PriceComparisonFragment = { __typename?: 'TravelPlaceComparison', joyPlaceId: string, id: string, providers: Array<{ __typename?: 'TravelPlaceComparisonForProvider', providerFQDN: string, providerSearchURL: string, nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } }> };

export type GetGuestsiteFaqQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestsiteFaqQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, faq: Array<{ __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string }> } } | null };

export type GetGuestsiteRegistryQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetGuestsiteRegistryQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, wantSync?: boolean | null, hasItems: boolean, name?: string | null, url?: string | null, imageUrl?: string | null, items?: Array<{ __typename?: 'RegistryItem', id: string, fpIndex: number, productData: { __typename?: 'RegistryItemProductData', title: string, url?: string | null, registryItem: { __typename?: 'RegistryItem', id: string }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }> | null }> } } | null };

export type GetGuestSiteScheduleCTASessionFragment = { __typename?: 'EventSession', id: string, hasUnlocked: boolean, eventCTA: { __typename?: 'EventSessionCTA', scheduleHasInviteOnlyItems: boolean }, person?: { __typename?: 'Person', id: string, fullName?: string | null } | null };

export type GetGuestSiteScheduleQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestSiteScheduleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, activeSession: { __typename?: 'EventSession', id: string, hasUnlocked: boolean, eventCTA: { __typename?: 'EventSessionCTA', scheduleHasInviteOnlyItems: boolean }, person?: { __typename?: 'Person', id: string, fullName?: string | null } | null }, info: { __typename?: 'EventInfo', id: string, schedule: { __typename?: 'EventScheduleInfo', formattedSchedules: Array<{ __typename?: 'FormattedSchedule', date: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string }, items: Array<{ __typename?: 'EventSchedule', id: string, description?: string | null, dressCode?: string | null, isMain: boolean, isPublic: boolean, location?: string | null, name: string, placeId?: string | null, showMap: boolean, timezone?: string | null, unplugged: boolean, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', provider: VirtualEventProvider, linkText: string, isLinkValid: boolean, isPasswordDetected: boolean, passwordText?: string | null, passwordUrlEmbed?: string | null, streamId?: string | null, urlLinkText?: string | null, urlApp?: string | null, urlBrowser?: string | null } | null }> }>, toBeAnnouncedItems: Array<{ __typename?: 'EventSchedule', id: string, description?: string | null, dressCode?: string | null, isMain: boolean, isPublic: boolean, location?: string | null, name: string, placeId?: string | null, showMap: boolean, timezone?: string | null, unplugged: boolean, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', provider: VirtualEventProvider, linkText: string, isLinkValid: boolean, isPasswordDetected: boolean, passwordText?: string | null, passwordUrlEmbed?: string | null, streamId?: string | null, urlLinkText?: string | null, urlApp?: string | null, urlBrowser?: string | null } | null }> } } } | null };

export type GetGuestsiteTidbitsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestsiteTidbitsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, tidbits: Array<{ __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string }> } } | null };

export type GetGuestsiteTravelListQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestsiteTravelListQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, submittedDateTime?: any | null } | null, info: { __typename?: 'EventInfo', id: string, travel: Array<{ __typename?: 'EventTravelBookingType', address?: string | null, bookingType?: string | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null, id: string, type: TravelType, name: string, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null } | { __typename?: 'EventTravelList', id: string, type: TravelType, name: string, items: Array<{ __typename?: 'EventTravelListItem', id: string, title?: string | null, url?: string | null }> } | { __typename?: 'EventTravelNote', notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Ferry', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Flight', url?: string | null, code?: string | null, notes?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Hotel', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'RentalCar', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'RentalHome', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Shuttle', id: string, type: TravelType, name: string, notes?: string | null, items: Array<{ __typename?: 'ShuttleItem', id: string, note?: string | null, timezone?: string | null, url?: string | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null }> } | { __typename?: 'Taxi', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Tent', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string } | { __typename?: 'Train', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string }> } } | null };

export type GetGuestsiteVipsQueryVariables = Exact<{
  eventId: Scalars['ID'];
  isAdminDashboard?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestsiteVipsQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, vips: Array<{ __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null }> } | null };

export type GetGuestsiteEventVipsQueryVariables = Exact<{
  payload: EventVipsPayload;
}>;


export type GetGuestsiteEventVipsQuery = { __typename?: 'Query', eventVips: Array<{ __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null }> };

export type CashFundPayerFragment = { __typename?: 'CashFundPayer', email: string, fullName: string, message?: string | null };

export type CashFundPaymentAttemptFragment = { __typename?: 'CashFundPaymentAttempt', id: string, createdAt: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, payer: { __typename?: 'CashFundPayer', email: string, fullName: string, message?: string | null } };

export type GetCashFundForContributionQueryVariables = Exact<{
  input: GetCashFundForContributionInput;
}>;


export type GetCashFundForContributionQuery = { __typename?: 'Query', getCashFundForContribution: { __typename?: 'CashFundForContribution', cashFund: { __typename?: 'CashFund', id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }, host: { __typename?: 'CashFundsHost', id: string, firstName?: string | null, lastName?: string | null }, invite?: { __typename?: 'CashFundSolicitationInvite', id: string, email: string, fullName?: string | null, guestKey?: string | null } | null } };

export type GetCashFundPaymentAttemptByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCashFundPaymentAttemptByIdQuery = { __typename?: 'Query', getCashFundPaymentAttemptById: { __typename?: 'CashFundPaymentAttempt', id: string, createdAt: string, order: { __typename?: 'CashFundOrder', id: string, status: string, contributionAmount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalTaxes: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalFees: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, total: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }, cashFund: { __typename?: 'CashFund', id: string, name: string, note?: string | null, currencyCode: string, archived: boolean, publicTotalContributedAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, publicTotalGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fixedContributionAmount?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, payer: { __typename?: 'CashFundPayer', email: string, fullName: string, message?: string | null } } };

export type GetCashFundContributorByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCashFundContributorByIdQuery = { __typename?: 'Query', getCashFundContributorById: { __typename?: 'CashFundContributor', id: string, fullName: string, email: string } };

export type CalculateCashFundContributionReceiptQueryVariables = Exact<{
  input: CalculateCashFundContributionReceiptInput;
}>;


export type CalculateCashFundContributionReceiptQuery = { __typename?: 'Query', calculateCashFundContributionReceipt: { __typename?: 'CashFundContributionReceipt', contributionAmount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, fees: Array<{ __typename?: 'CashFundContributionFee', amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }>, total: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, totalFees: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } } };

export type CreateCashFundPaymentIntentMutationVariables = Exact<{
  input: CreateCashFundPaymentIntentInput;
}>;


export type CreateCashFundPaymentIntentMutation = { __typename?: 'Mutation', createCashFundPaymentIntent: { __typename?: 'CashFundGeneralError', code: string } | { __typename?: 'CashFundPaymentIntent', id: string, clientSecret: string, paymentAttempt: { __typename?: 'CashFundPaymentAttempt', id: string } } };

export type CreateCashFundCheckoutSessionMutationVariables = Exact<{
  input: CreateCashFundCheckoutSessionInput;
}>;


export type CreateCashFundCheckoutSessionMutation = { __typename?: 'Mutation', createCashFundCheckoutSession: { __typename?: 'CashFundCheckoutSession', id: string, redirectUrl: string } | { __typename?: 'CashFundGeneralError', code: string } };

export type CollaboratorsGetCollaborationInviteByIdQueryVariables = Exact<{
  getCollaborationInviteByIdId: Scalars['ID'];
}>;


export type CollaboratorsGetCollaborationInviteByIdQuery = { __typename?: 'Query', getCollaborationInviteById: { __typename?: 'CollaborationInvite', state: CollaborationInviteState, id: string, eventId: string, inviteeEmailAddress: string, inviteeFirstName: string, inviteeLastName: string, senderUserId: string } };

export type CollaboratorsAcceptEventAdminInviteMutationVariables = Exact<{
  acceptCollaborationInviteId: Scalars['ID'];
}>;


export type CollaboratorsAcceptEventAdminInviteMutation = { __typename?: 'Mutation', acceptCollaborationInvite: { __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null } };

export type EventWebsiteGuestHeadQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type EventWebsiteGuestHeadQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, website: string, photoV2Url?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, websiteLayout: string, dataJSON: any, id: string } | null } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, eventDisplayName?: string | null, eventType: EventType }, settings: { __typename?: 'EventSettings', id: string, hideFromSearchEngines: boolean }, pages: Array<{ __typename?: 'EventPage', id: string, pageTitle: string, pageSlug: string, type: EventPageType, disabled: boolean, visibility: EventPageVisibility, private: boolean, isPageContainer: boolean }> } | null };

export type GuestHotelRoomBlocksLinkQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GuestHotelRoomBlocksLinkQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, website: string, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, bookingLink?: string | null } | null } | null };

export type AccommodationPlaceV2ByIdQueryVariables = Exact<{
  accommodationPlaceV2ByIdId: Scalars['ID'];
}>;


export type AccommodationPlaceV2ByIdQuery = { __typename?: 'Query', accommodationPlaceV2ById?: { __typename?: 'AccommodationPlaceV2', id: string, joyPlaceId?: string | null, name?: string | null, address?: string | null, url?: string | null, customUrl?: string | null, lat?: number | null, long?: number | null, zhId?: string | null, googlePlaceId?: string | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null } | null };

export type HotelBookingPartnerSearchJoyPlaceByIdQueryVariables = Exact<{
  joyPlaceByIdId: Scalars['ID'];
}>;


export type HotelBookingPartnerSearchJoyPlaceByIdQuery = { __typename?: 'Query', joyPlaceById?: { __typename?: 'JoyPlace', id: string, name?: string | null, googlePlaceId?: string | null } | null };

export type HotelJoyPlaceDeprecatedQueryVariables = Exact<{
  joyPlaceByIdId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type HotelJoyPlaceDeprecatedQuery = { __typename?: 'Query', joyPlaceById?: { __typename?: 'JoyPlace', id: string, name?: string | null, address?: string | null, lat?: number | null, long?: number | null, googlePlaceId?: string | null, url?: string | null } | null };

export type JoyPlaceIdBySourceIdQueryVariables = Exact<{
  payload: JoyPlaceBySourceIdRequest;
}>;


export type JoyPlaceIdBySourceIdQuery = { __typename?: 'Query', joyPlaceBySourceId?: { __typename?: 'JoyPlace', id: string, zhId?: string | null } | null };

export type JoyPlaceBySourceIdQueryVariables = Exact<{
  payload: JoyPlaceBySourceIdRequest;
}>;


export type JoyPlaceBySourceIdQuery = { __typename?: 'Query', joyPlaceBySourceId?: { __typename?: 'JoyPlace', address?: string | null, id: string, name?: string | null, lat?: number | null, long?: number | null, googlePlaceId?: string | null, url?: string | null } | null };

export type HotelAllLocationAnchorsDeprecatedQueryVariables = Exact<{
  eventByIdId: Scalars['ID'];
}>;


export type HotelAllLocationAnchorsDeprecatedQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, allLocationAnchors: Array<{ __typename?: 'LocationAnchor', friendlyName: string, googlePlaceID: string, latitude: string, longitude: string, source: LocationAnchorSource } | null> } | null };

export type HotelAllLocationAnchorsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type HotelAllLocationAnchorsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, allLocationAnchors: Array<{ __typename?: 'LocationAnchor', friendlyName: string, googlePlaceID: string, latitude: string, longitude: string, source: LocationAnchorSource } | null> } | null };

export type MediaCollectionEventInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventDesignPurpose: EventDesignPurpose;
}>;


export type MediaCollectionEventInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, eventType: EventType }, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type MediaCollectionByMagicTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type MediaCollectionByMagicTokenQuery = { __typename?: 'Query', mediaCollectionByMagicToken?: { __typename?: 'MediaCollection', id: string, name: string, magicTokenPermissions?: Array<MagicTokenPermissions | null> | null, createdAt: { __typename?: 'Date', dateString: string, timestamp: any }, media?: Array<{ __typename?: 'MediaPhoto', id: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number } } | { __typename?: 'MediaVideo' }> | null } | null };

export type GetCustomPagesVisibilitiesFragment = { __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility } };

export type GetDataForThanksForRSVPQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDataForThanksForRSVPQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, event: { __typename?: 'Event', id: string, pagesInfo?: Array<{ __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility } }> | null, registryPages?: Array<{ __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility } }> | null } }, eventDesign?: { __typename?: 'EventDesign', id: string, font: { __typename?: 'Font', id: string, fontFamily: string, textTransform: FontWeight } } | null, registryPage: Array<{ __typename?: 'EventPage', id: string, disabled: boolean }>, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, bookingLink?: string | null } | null } | null };

export type GetDataForTravelThanksForRSVPQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDataForTravelThanksForRSVPQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, event: { __typename?: 'Event', id: string, pagesInfo?: Array<{ __typename?: 'EventPageInfo', id: string, visibility: EventPageVisibility }> | null } } } | null };

export type GetDataForAccommodationsThanksForRSVPQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetDataForAccommodationsThanksForRSVPQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, locationInfo?: { __typename?: 'EventLocation', id?: string | null, latitude?: number | null, longitude?: number | null } | null }, hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks', id: string, bookingLink?: string | null } | null, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, customName?: string | null, isPhotoHidden?: boolean | null, type?: AccommodationPlaceType | null, lat?: number | null, long?: number | null, name?: string | null, joyPlaceId?: string | null, customUrl?: string | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } | null };

export type SendRSVPBasicNoteMutationVariables = Exact<{
  payload?: InputMaybe<PostOfficeGreetingCardEmailInput>;
}>;


export type SendRSVPBasicNoteMutation = { __typename?: 'Mutation', sendPostOfficeGreetingCardEmail?: any | null };

export type GetRegistrySettingForRsvpQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistrySettingForRsvpQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, hideRegistryInMessaging: boolean } | null };

export type GetMessagingSettingsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetMessagingSettingsByEventIdQuery = { __typename?: 'Query', getMessagingSettingsByEventId?: { __typename?: 'MessagingSettings', id: string, eventId: string, eventDetailsMessagingEnabled: boolean, eventDetailsAutomaticRemindersEnabled: boolean, rsvpNoCustomRedirectEnabled: boolean, rsvpYesCustomRedirectEnabled: boolean, rsvpYesCustomRedirectUrl?: string | null, rsvpNoCustomRedirectUrl?: string | null } | null };

export type UpdateEventDetailsMessagingMutationVariables = Exact<{
  payload: UpdateEventDetailsMessagingPayload;
}>;


export type UpdateEventDetailsMessagingMutation = { __typename?: 'Mutation', updateEventDetailsMessaging: { __typename?: 'MessagingSettings', id: string, eventDetailsMessagingEnabled: boolean, eventDetailsAutomaticRemindersEnabled: boolean, rsvpNoCustomRedirectEnabled: boolean, rsvpYesCustomRedirectEnabled: boolean, rsvpYesCustomRedirectUrl?: string | null, rsvpNoCustomRedirectUrl?: string | null } };

export type EventAccommodationOffersQueryVariables = Exact<{
  payload: TravelOffersForAccommodationForPropertiesPayload;
}>;


export type EventAccommodationOffersQuery = { __typename?: 'Query', travelOffersForAccommodationProperties: { __typename?: 'TravelOffersResult', someOffers: Array<{ __typename?: 'TravelOffer', totalAmount: { __typename?: 'TravelMonetaryValue', valueInMinorUnits: number, currency: TravelCurrencyCode } }> } };

export type GetRecommendedRegistryOnboardingSurveyResultsQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type GetRecommendedRegistryOnboardingSurveyResultsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null, info: { __typename?: 'EventInfo', id: string, eventType: EventType }, recommendation: { __typename?: 'RecommendEvent', registryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, registryTypes?: Array<string> | null, registeringAtOtherStores?: boolean | null, coupleInterests?: Array<string> | null, interestedInBrowserButton?: boolean | null, lastUpdatedAt?: { __typename?: 'Date', milliseconds: number } | null } } } | null };

export type AdminRegistryFragment = { __typename?: 'Registry', recommendationStatus: RegistryRecommendationStatus, id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, orders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null };

export type GetAdminRegistryRegistriesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetAdminRegistryRegistriesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, disableWhiteGloveforSyncedItems: boolean, disableWhiteGloveforTransferredItems: boolean }, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', recommendationStatus: RegistryRecommendationStatus, id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, orders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null }> } } | null };

export type GetAdminRegistryOrdersQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetAdminRegistryOrdersQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, orders?: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null }> | null } } | null };

export type GetAdminRegistryDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetAdminRegistryDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, eventType: EventType, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, registry: { __typename?: 'EventData', id: string, itemCount: { __typename?: 'RegistryItemCount', everything: number }, checklist?: { __typename?: 'RegistryChecklist', id: string } | null, summary?: { __typename?: 'EventRegistriesSummary', cannotSync: boolean, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null } | null, currency?: { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null } | null, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null, donationFundInfo: { __typename?: 'DonationFundInfo', defaultPlatform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null } | null, defaultSuggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, platforms: Array<{ __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null, link?: string | null }>, items: Array<{ __typename?: 'DonationFund', id: string, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum } | null }> } }, registryPage: Array<{ __typename?: 'EventPage', id: string, disabled: boolean, subTitle?: string | null }>, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus }> } | null };

export type GetGiftTransactionThankYouAssociationsQueryVariables = Exact<{
  args?: InputMaybe<MessageRelationshipCriteria>;
}>;


export type GetGiftTransactionThankYouAssociationsQuery = { __typename?: 'Query', getMessageRelationships: Array<{ __typename?: 'MessageRelationResult', id: string, relationshipTag?: string | null, externalMessageId: string, status?: string | null, redirectUri?: string | null } | null> };

export type SetRegistryEventDataMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: RegistryEventDataInput;
}>;


export type SetRegistryEventDataMutation = { __typename?: 'Mutation', setRegistryEventData: { __typename?: 'EventData', id: string, disableWhiteGloveforSyncedItems: boolean, disableWhiteGloveforTransferredItems: boolean, disableWhiteGloveforPartnerItems: boolean } };

export type GetRegistryEventDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistryEventDataQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, disableWhiteGloveforSyncedItems: boolean, disableWhiteGloveforTransferredItems: boolean, disableWhiteGloveforPartnerItems: boolean } | null };

export type SetHideRegistryInMessagingSettingMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: RegistryEventDataInput;
}>;


export type SetHideRegistryInMessagingSettingMutation = { __typename?: 'Mutation', setRegistryEventData: { __typename?: 'EventData', id: string, hideRegistryInMessaging: boolean } };

export type GetHideRegistryInMessagingSettingQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetHideRegistryInMessagingSettingQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, hideRegistryInMessaging: boolean } | null };

export type StartRefundMutationVariables = Exact<{
  registryOrderId: Scalars['ID'];
  refundMethod: SalesOrderRefundMethod;
}>;


export type StartRefundMutation = { __typename?: 'Mutation', startRefund?: any | null };

export type GetEventPreviewDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventPreviewDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, registry: { __typename?: 'EventData', id: string, itemCount: { __typename?: 'RegistryItemCount', everything: number } }, registryPage: Array<{ __typename?: 'EventPage', id: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string } | { __typename?: 'Photo', id: string, url: string } | null }> } | null };

export type GetEventDelayShipSettingQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventDelayShipSettingQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, hideDelayShipSetting?: boolean | null } | null };

export type DraftItemFragment = { __typename?: 'RegistryItem', id: string, storeName?: string | null, totalRequested?: number | null, productData: { __typename?: 'RegistryItemProductData', title: string, price?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string } } };

export type RegistryWithDraftItemsFragment = { __typename?: 'Registry', id: string, storeName?: string | null, draftItems?: Array<{ __typename?: 'RegistryItem', id: string, storeName?: string | null, totalRequested?: number | null, productData: { __typename?: 'RegistryItemProductData', title: string, price?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string } } }> | null };

export type GetRegistriesWithDraftItemsQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistriesWithDraftItemsQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, storeName?: string | null, draftItems?: Array<{ __typename?: 'RegistryItem', id: string, storeName?: string | null, totalRequested?: number | null, productData: { __typename?: 'RegistryItemProductData', title: string, price?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string } } }> | null }> } } | null };

export type MovePostTransferItemsToJoyMutationVariables = Exact<{
  registryId: Scalars['ID'];
}>;


export type MovePostTransferItemsToJoyMutation = { __typename?: 'Mutation', convertRegistryDrafts?: { __typename?: 'Registry', id: string, storeName?: string | null } | null };

export type ProductCatalogAdsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCatalogAdsQuery = { __typename?: 'Query', productCatalogAds: { __typename?: 'ProductCatalogAds', brandPromoMosaic?: { __typename?: 'ProductCatalogBrandPromoMosaic', tiles: Array<{ __typename?: 'ProductCatalogBrandPromo', customRedirectUrl?: string | null, brand: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string }, mobileImage?: { __typename?: 'Photo', id: string, url: string } | null, image: { __typename?: 'Photo', id: string, url: string } }> } | null, departmentBrandPromos: Array<{ __typename?: 'ProductCatalogDepartmentBrandPromo', department: { __typename?: 'ProductCatalogCategory', id: string, title: string }, categoryCarousel?: { __typename?: 'ProductCatalogBrandPromo', customRedirectUrl?: string | null, brand: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string }, mobileImage?: { __typename?: 'Photo', id: string, url: string } | null, image: { __typename?: 'Photo', id: string, url: string } } | null, navBar?: { __typename?: 'ProductCatalogBrandPromo', customRedirectUrl?: string | null, brand: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string }, mobileImage?: { __typename?: 'Photo', id: string, url: string } | null, image: { __typename?: 'Photo', id: string, url: string } } | null, productGrid?: { __typename?: 'ProductCatalogBrandPromo', customRedirectUrl?: string | null, brand: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string }, mobileImage?: { __typename?: 'Photo', id: string, url: string } | null, image: { __typename?: 'Photo', id: string, url: string } } | null }> } };

export type CatalogBrandPromoFragment = { __typename?: 'ProductCatalogBrandPromo', customRedirectUrl?: string | null, brand: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string }, mobileImage?: { __typename?: 'Photo', id: string, url: string } | null, image: { __typename?: 'Photo', id: string, url: string } };

export type CompletionDiscountItemFragment = { __typename: 'DiscountedRegistryItem', registryItem: { __typename?: 'RegistryItem', id: string, stillNeeded: number, productData: { __typename?: 'RegistryItemProductData', title: string, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string } } }, discountDetails: { __typename?: 'ItemDiscountCampaignDetails', eligible: boolean, discountedPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null } };

export type GetCompletionDiscountItemsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetCompletionDiscountItemsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, completionDiscount: { __typename?: 'RegistryCompletionDiscount', items: Array<{ __typename: 'DiscountedRegistryItem', registryItem: { __typename?: 'RegistryItem', id: string, stillNeeded: number, productData: { __typename?: 'RegistryItemProductData', title: string, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string } } }, discountDetails: { __typename?: 'ItemDiscountCampaignDetails', eligible: boolean, discountedPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null } }> } } } | null };

export type GetFinalizedDateAndGiftCountQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetFinalizedDateAndGiftCountQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', milliseconds: number } | null }, registry: { __typename?: 'EventData', id: string, itemCount: { __typename?: 'RegistryItemCount', everything: number, purchasedOrReserved: number } } } | null };

export type RegistryDelayOrderFulfillmentQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type RegistryDelayOrderFulfillmentQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, delayOrderFulfillment: boolean } } | null };

export type SetDelayOrderFulfillmentMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: RegistryEventDataInput;
}>;


export type SetDelayOrderFulfillmentMutation = { __typename?: 'Mutation', setRegistryEventData: { __typename?: 'EventData', id: string, delayOrderFulfillment: boolean } };

export type StartOrdersFulfillmentMutationVariables = Exact<{
  registryOrderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type StartOrdersFulfillmentMutation = { __typename?: 'Mutation', startFulfillment: Array<{ __typename?: 'RegistryStartFulfillmentResult', registryOrderId: string, salesOrderId?: string | null, status?: string | null, failedStatusDetails?: string | null }> };

export type GetRegistryVisibilityQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetRegistryVisibilityQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, private: boolean, disabled: boolean }> } | null };

export type GetShippingAddressQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetShippingAddressQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, shippingAddress?: { __typename?: 'ShippingAddress', address1: string } | null } | null };

export type GetRegistryCurrencyQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetRegistryCurrencyQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, currency?: { __typename?: 'RegistryCurrency', id: string, displayName: string, rank?: number | null, code: string, isDefault: boolean } | null } } | null };

export type GetRegistryPageNoteQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetRegistryPageNoteQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registryPage: Array<{ __typename?: 'EventPage', id: string, subTitle?: string | null }> } | null };

export type GetRecommendCatalogHomeSectionsQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRecommendCatalogHomeSectionsQuery = { __typename?: 'Query', recommendCatalogHomeSections: { __typename?: 'ProductCatalogPageSectionContainer', id?: string | null, sections: Array<{ __typename?: 'ProductCatalogPageSection', id: string, displayType: string, catalogEntities: Array<{ __typename?: 'ProductCatalogEntityBrand' } | { __typename?: 'ProductCatalogEntityCategory' } | { __typename?: 'ProductCatalogEntityCuration' } | { __typename?: 'ProductCatalogEntityItem' } | { __typename: 'ProductCatalogEntityItemGroup', id: string, catalogItemGroupData?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewItem?: { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, tilePresentation: { __typename?: 'ProductCatalogItemTilePresentation', presentationType: ProductCatalogItemTilePresentationType, title: string, shortDescription?: string | null, longDescription?: string | null, isFullPrice: boolean, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, priceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null, fullPriceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null }, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean } } | null } | null }> }> } };

export type GetRegistryOrderRefundsQueryVariables = Exact<{
  registryOrderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetRegistryOrderRefundsQuery = { __typename?: 'Query', registryOrdersByIds: Array<{ __typename?: 'RegistryOrder', id: string, refunds: Array<{ __typename?: 'RegistryOrderRefund', refundStatus: string, items: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, taxes: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, shippingAndHandling: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, totalValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } }> } | null> };

export type AdminExternalRegistriesToSetTransferredToPrivateFragment = { __typename?: 'Registry', id: string, urlV0204?: string | null, isTransferredType: boolean, storeName?: string | null, transferredRegistryData?: { __typename?: 'TransferredRegistryData', lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null };

export type GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetAdminExternalRegistriesToSetTransferredToPrivateQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, registries: Array<{ __typename?: 'Registry', id: string, urlV0204?: string | null, isTransferredType: boolean, storeName?: string | null, transferredRegistryData?: { __typename?: 'TransferredRegistryData', lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null }> } } | null };

export type GetRegistryGiftListForCountQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryGiftListForCountQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, items: Array<{ __typename?: 'RegistryItem', id: string, alreadyPurchased?: number | null, alreadyReserved?: number | null, externallyOwned: boolean, stillNeeded: number, donationFund?: { __typename?: 'DonationFund', id: string, enforceSuggestedDonationAmount: boolean, progressToGoalPercent?: number | null, donations: Array<{ __typename?: 'DonationFundDonation', id: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, currency?: { __typename?: 'Currency', places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null } | null }> } } | null };

export type GetBookmarkletEventDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetBookmarkletEventDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, registry: { __typename?: 'EventData', id: string, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null, currency?: { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null } | null } } | null };

export type SubmitRecommendRegistryOnboardingSurveyResponsesMutationVariables = Exact<{
  eventId: Scalars['String'];
  payload: RecommendRegistryOnboardingSurveyPayload;
}>;


export type SubmitRecommendRegistryOnboardingSurveyResponsesMutation = { __typename?: 'Mutation', updateRecommendRegistryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, registryTypes?: Array<string> | null, registeringAtOtherStores?: boolean | null, coupleInterests?: Array<string> | null, interestedInBrowserButton?: boolean | null, lastUpdatedAt?: { __typename?: 'Date', milliseconds: number } | null } };

export type GetOverviewProgressStateQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetOverviewProgressStateQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, checklist?: { __typename?: 'RegistryChecklist', id: string } | null, itemCount: { __typename?: 'RegistryItemCount', everything: number } } } | null };

export type GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetProductCatalogCategoriesByIdsForProductRecommendationsQuery = { __typename?: 'Query', productCatalogCategoriesByIds: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, totalItemCount: number } | null> };

export type GetCoupleInterestsForProductRecommendationsQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type GetCoupleInterestsForProductRecommendationsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, recommendation: { __typename?: 'RecommendEvent', registryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, coupleInterests?: Array<string> | null } } } | null };

export type UpdateCoupleInterestsForProductRecommendationsMutationVariables = Exact<{
  eventId: Scalars['String'];
  payload: RecommendRegistryOnboardingSurveyPayload;
}>;


export type UpdateCoupleInterestsForProductRecommendationsMutation = { __typename?: 'Mutation', updateRecommendRegistryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, coupleInterests?: Array<string> | null } };

export type AdminExternalRegistryFragment = { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null };

export type GetAdminExternalRegistriesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetAdminExternalRegistriesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, registries: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null }> } } | null };

export type GetRecommendableProductsByRegistryIdQueryVariables = Exact<{
  registryId: Scalars['ID'];
}>;


export type GetRecommendableProductsByRegistryIdQuery = { __typename?: 'Query', recommendableItemsByRegistryId: Array<{ __typename?: 'RegistryItem', id: string, recommendationStatus: RegistryItemRecommendationStatus, productData: { __typename?: 'RegistryItemProductData', title: string, brand?: string | null, description?: string | null, pdpUrl?: string | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null, registryItem: { __typename?: 'RegistryItem', id: string, recommendationStatus: RegistryItemRecommendationStatus } } }> };

export type GetRecommendedProductsByProductUrlQueryVariables = Exact<{
  recommendationInputs: Array<ProductCatalogItemRecommendationInput> | ProductCatalogItemRecommendationInput;
}>;


export type GetRecommendedProductsByProductUrlQuery = { __typename?: 'Query', productCatalogItemRecommendations: Array<{ __typename?: 'ProductCatalogItemRecommendationContainer', productUrl: string, recommendations: Array<{ __typename?: 'ProductCatalogItemRecommendation', reason?: string | null, catalogItem: { __typename?: 'ProductCatalogItem', id: string, title: string, productUrl?: string | null, brand?: { __typename?: 'ProductCatalogBrand', name: string, id: string } | null, mediaAssets: Array<{ __typename: 'ProductCatalogPhotoAsset', type: ProductCatalogAssetType, photo: { __typename?: 'Photo', id: string, url: string } } | { __typename?: 'ProductCatalogVideoAsset' } | null>, group?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string } | null }> } | null } | null, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null } }> }> };

export type updateItemrecommendayionStatusMutationVariables = Exact<{
  eventId: Scalars['ID'];
  action: ProcessRecommendationAction;
  catalogItemId: Scalars['ID'];
  registryItemId: Scalars['ID'];
}>;


export type updateItemrecommendayionStatusMutation = { __typename?: 'Mutation', processRecommendations: { __typename?: 'RegistryItemsResult', models: Array<{ __typename?: 'RegistryItem', id: string, recommendationStatus: RegistryItemRecommendationStatus }> } };

export type UpdateRegistryRecommendationStatusMutationVariables = Exact<{
  registryId: Scalars['ID'];
  status: RegistryRecommendationStatus;
}>;


export type UpdateRegistryRecommendationStatusMutation = { __typename?: 'Mutation', updateRegistryWithResult: { __typename?: 'RegistryResult', status: { __typename?: 'ResultStatus', id: string } } };

export type ProductCatalogCollectionMembersFragment = { __typename?: 'ProductCatalogEntityItem', id: string, catalogItemData?: { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', totalReviewCount: number, averageRating: number } } | null } | null };

export type GetProductCatalogCollectionMembersQueryVariables = Exact<{
  collectionsRefList: Array<ProductCatalogDisplayInfoRef> | ProductCatalogDisplayInfoRef;
}>;


export type GetProductCatalogCollectionMembersQuery = { __typename?: 'Query', productCatalogCollectionDisplayInfosByRefs: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, collection: { __typename?: 'ProductCatalogCollection', id: string, members: Array<{ __typename?: 'ProductCatalogEntityBrand' } | { __typename?: 'ProductCatalogEntityCategory' } | { __typename?: 'ProductCatalogEntityCuration' } | { __typename?: 'ProductCatalogEntityItem', id: string, catalogItemData?: { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', totalReviewCount: number, averageRating: number } } | null } | null } | { __typename?: 'ProductCatalogEntityItemGroup' }> } } | null> };

export type ProductCatalogBrandsListQueryVariables = Exact<{
  args?: InputMaybe<ProductCatalogBrandsDirectoryQueryInput>;
}>;


export type ProductCatalogBrandsListQuery = { __typename?: 'Query', productCatalogBrandsDirectory: { __typename?: 'ProductCatalogBrandsDirectory', categories: Array<{ __typename?: 'ProductCatalogCategory', title: string, id: string }>, brands: Array<{ __typename?: 'ProductCatalogBrand', name: string, id: string, publicUrlPath: string }> } };

export type CatalogProductTileViewDimensionsFragment = { __typename?: 'ProductCatalogItemGroup', tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string, isLight: boolean } | null }> } | null, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null }> };

export type GetAllCatalogProductGridItemsQueryVariables = Exact<{
  query: ProductCatalogSearchQueryInput;
  first: Scalars['Int'];
  endCursor?: InputMaybe<Scalars['ProductCatalogSearchCursor']>;
  type?: InputMaybe<CatalogTreeRootInput>;
  withFilters: Scalars['Boolean'];
}>;


export type GetAllCatalogProductGridItemsQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, heroText?: string | null }, productCatalogSearchResults: { __typename?: 'ProductCatalogSearchResultContainer', orderedBy?: ProductCatalogSearchQueryOrderBy | null, pagedResults?: { __typename?: 'ProductCatalogSearchConnection', pageInfo: { __typename?: 'ProductCatalogSearchPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any, endCursor: any, totalCount: number }, edges: Array<{ __typename?: 'ProductCatalogSearchEdge', cursor: any, node: { __typename?: 'ProductCatalogSearchResultItem', catalogItem?: { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, tilePresentation: { __typename?: 'ProductCatalogItemTilePresentation', presentationType: ProductCatalogItemTilePresentationType, title: string, shortDescription?: string | null, longDescription?: string | null, isFullPrice: boolean, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, priceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null, fullPriceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null }, group?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string, isLight: boolean } | null }> } | null, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null }> } | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null } | null } }> } | null, allFilters?: Array<{ __typename?: 'ProductCatalogSearchFilterGroup', attributes: Array<{ __typename?: 'ProductSearchFilterAttribute', id: string, compositeCode: string, isActive: boolean, matchingItemsCount?: number | null, value: { __typename?: 'ProductAttributeValue', id: string, title: string, code: string } }>, attributeGroup: { __typename?: 'ProductAttributeGroup', id: string, title: string, code: string, valueType: ProductCatalogAttributeValueType, filterSelectionType: ProductCatalogAttributeSelectionType }, selectedPriceRange?: { __typename?: 'ProductCatalogSearchFilterGroupSelectedPrice', maxValueInMinorUnits?: number | null, minValueInMinorUnits?: number | null } | null }> } };

export type GetAllUniversalGridItemsQueryVariables = Exact<{
  query: ProductCatalogSearchQueryInput;
  first: Scalars['Int'];
  endCursor?: InputMaybe<Scalars['ProductCatalogSearchCursor']>;
  type?: InputMaybe<CatalogTreeRootInput>;
  withFilters: Scalars['Boolean'];
  sourceLimits?: InputMaybe<Array<ProductUniversalSearchSourceLimit> | ProductUniversalSearchSourceLimit>;
}>;


export type GetAllUniversalGridItemsQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, heroText?: string | null }, productUniversalSearchResults: { __typename?: 'ProductUniversalSearchResultContainer', pagedResults?: { __typename?: 'ProductUniversalSearchConnection', pageInfo: { __typename?: 'ProductCatalogSearchPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any, endCursor: any, totalCount: number }, edges: Array<{ __typename?: 'ProductUniversalSearchEdge', cursor: any, node: { __typename?: 'ProductUniversalSearchNode', source: ProductUniversalItemSource, item: { __typename: 'ProductExternalOfferContainer', offer: { __typename?: 'ProductExternalOffer', id: string, productId: string, productTitle: string, sellerName: string, sellerUrl?: string | null, productThumbnail: { __typename?: 'PhotoSummary', url: string }, productRating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, sellerFullPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, sellerSalePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null } } | { __typename: 'ProductUniversalCatalogItemContainer', catalogItem: { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, tilePresentation: { __typename?: 'ProductCatalogItemTilePresentation', presentationType: ProductCatalogItemTilePresentationType, title: string, shortDescription?: string | null, longDescription?: string | null, isFullPrice: boolean, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, priceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null, fullPriceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null }, group?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string, isLight: boolean } | null }> } | null, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null }> } | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null } } | { __typename: 'ProductUniversalProductContainer' } } }> } | null, allFilters?: Array<{ __typename?: 'ProductCatalogSearchFilterGroup', attributes: Array<{ __typename?: 'ProductSearchFilterAttribute', id: string, compositeCode: string, isActive: boolean, matchingItemsCount?: number | null, value: { __typename?: 'ProductAttributeValue', id: string, title: string, code: string } }>, attributeGroup: { __typename?: 'ProductAttributeGroup', id: string, title: string, code: string, valueType: ProductCatalogAttributeValueType, filterSelectionType: ProductCatalogAttributeSelectionType }, selectedPriceRange?: { __typename?: 'ProductCatalogSearchFilterGroupSelectedPrice', maxValueInMinorUnits?: number | null, minValueInMinorUnits?: number | null } | null }> } };

export type GetProductCatalogBrandsByCriteriaQueryVariables = Exact<{
  brandsUrlsList: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetProductCatalogBrandsByCriteriaQuery = { __typename?: 'Query', productCatalogBrandsByCriteria: Array<{ __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string, description?: string | null, logoImage?: { __typename?: 'Photo', id: string, url: string, altTag?: string | null } | null, header?: { __typename?: 'ProductCatalogBrandHeader', id: string, title?: string | null, description?: string | null, videoUrl?: string | null, textColor?: string | null, gradientColor?: string | null, gradientMarkup?: string | null, backgroundImage?: { __typename?: 'Photo', id: string, url: string } | null, logoImage?: { __typename?: 'Photo', id: string, url: string } | null } | null }> };

export type CatalogPdpDisplayFieldsFragment = { __typename?: 'ProductCatalogItem', whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null };

export type CatalogPdpDimensionsFragment = { __typename?: 'ProductCatalogItem', groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }>, group?: { __typename?: 'ProductCatalogItemGroup', id: string, groupDimensions: Array<{ __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }> }>, items: Array<{ __typename?: 'ProductCatalogItem', whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }>, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string }>, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean } }> } | null };

export type CatalogPdpCollectionDisplayInfosFragment = { __typename?: 'ProductCatalogItem', collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }> };

export type ProductCatalogPhotoAssetFragment = { __typename: 'ProductCatalogPhotoAsset', type: ProductCatalogAssetType, photo: { __typename?: 'Photo', id: string, url: string } };

export type ProductCatalogVideoAssetFragment = { __typename: 'ProductCatalogVideoAsset', type: ProductCatalogAssetType, video: { __typename?: 'ProductCatalogVideo', url: string, thumbnail: { __typename?: 'Photo', id: string, url: string }, fallbackImage: { __typename?: 'Photo', id: string, url: string } } };

export type GetCatalogProductDetailsQueryVariables = Exact<{
  catalogItemId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  withPdpSections: Scalars['Boolean'];
  withProductRating: Scalars['Boolean'];
  withInventory: Scalars['Boolean'];
}>;


export type GetCatalogProductDetailsQuery = { __typename?: 'Query', productCatalogItemById?: { __typename?: 'ProductCatalogItem', whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, mediaAssets: Array<{ __typename: 'ProductCatalogPhotoAsset', type: ProductCatalogAssetType, photo: { __typename?: 'Photo', id: string, url: string } } | { __typename: 'ProductCatalogVideoAsset', type: ProductCatalogAssetType, video: { __typename?: 'ProductCatalogVideo', url: string, thumbnail: { __typename?: 'Photo', id: string, url: string }, fallbackImage: { __typename?: 'Photo', id: string, url: string } } } | null>, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null, parentCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string }> }>, pdpSections?: Array<{ __typename?: 'PDPSection', sectionType: PDPSectionType, collectionType?: string | null, sectionTree?: { __typename?: 'PDPSectionTree', rootElementKey: string, elements: Array<{ __typename?: 'PDPElement', key: string, elementType: PDPElementType, childrenKeys: Array<string>, html?: string | null, text?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } | null }>, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string }>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }>, group?: { __typename?: 'ProductCatalogItemGroup', id: string, groupDimensions: Array<{ __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }> }>, items: Array<{ __typename?: 'ProductCatalogItem', whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string } }>, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string }>, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean } }> } | null, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null } | null, registryCatalogInventoryById?: { __typename?: 'RegistryCatalogInventoryResult', maxQty: number } };

export type GetDepartmentQueryVariables = Exact<{
  storefront?: InputMaybe<CatalogStorefront>;
}>;


export type GetDepartmentQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, locator?: string | null }> } };

export type GetProductCatalogCollectionDisplayInfosByRefsQueryVariables = Exact<{
  collectionsRefList: Array<ProductCatalogDisplayInfoRef> | ProductCatalogDisplayInfoRef;
}>;


export type GetProductCatalogCollectionDisplayInfosByRefsQuery = { __typename?: 'Query', productCatalogCollectionDisplayInfosByRefs: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null, title: string, collection: { __typename?: 'ProductCatalogCollection', id: string, collectionType: ProductCatalogCollectionType, members: Array<{ __typename?: 'ProductCatalogEntityBrand' } | { __typename?: 'ProductCatalogEntityCategory' } | { __typename?: 'ProductCatalogEntityCuration' } | { __typename?: 'ProductCatalogEntityItem', id: string, catalogItemData?: { __typename?: 'ProductCatalogItem', whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, group?: { __typename?: 'ProductCatalogItemGroup', id: string, groupDimensions: Array<{ __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string }> } | null, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null } | null } | { __typename?: 'ProductCatalogEntityItemGroup' }> } } | null> };

export type CatalogProductSharedDisplayFieldsFragment = { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null };

export type ProductCatalogItemTilePresentationFragment = { __typename?: 'ProductCatalogItemTilePresentation', presentationType: ProductCatalogItemTilePresentationType, title: string, shortDescription?: string | null, longDescription?: string | null, isFullPrice: boolean, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, priceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null, fullPriceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null };

export type CustomerReviewStatsFragment = { __typename: 'RatingStats', totalReviewCount: number, averageRating: number, traits: Array<{ __typename?: 'RatingTrait', id: string, label: string, averageRating: number }>, distribution: Array<{ __typename?: 'RatingBucketDistribution', id: string, count: number, ratingBucket: number, percentage: number }> };

export type CustomerProductReviewFragment = { __typename: 'RatingReview', id: string, title: string, description: string, ratingBucket: number, authorName?: string | null, submittedAt: { __typename?: 'Date', milliseconds: number }, syndicationSource?: { __typename?: 'RatingSyndicationSourceV2', id: string, name: string, logoImage?: { __typename?: 'RatingReviewPhotoData', id: string, url: string } | null } | null, mediaAssets: Array<{ __typename: 'RatingReviewPhotoAsset', photo: { __typename?: 'RatingReviewPhoto', thumbnail: { __typename?: 'RatingReviewPhotoData', id: string, url: string }, normal: { __typename?: 'RatingReviewPhotoData', id: string, url: string } } } | { __typename?: 'RatingReviewVideoAsset' }> };

export type GetCatalogProductReviewsQueryVariables = Exact<{
  catalogItemId: Scalars['ID'];
  orderBy?: InputMaybe<RatingReviewOrderBy>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['RatingReviewCursor']>;
}>;


export type GetCatalogProductReviewsQuery = { __typename?: 'Query', productCatalogItemById?: { __typename?: 'ProductCatalogItem', id: string, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename: 'RatingStats', id: string, totalReviewCount: number, averageRating: number, traits: Array<{ __typename?: 'RatingTrait', id: string, label: string, averageRating: number }>, distribution: Array<{ __typename?: 'RatingBucketDistribution', id: string, count: number, ratingBucket: number, percentage: number }> }, reviews: { __typename: 'RatingReviewSearchResultContainer', pagedResults: { __typename: 'RatingReviewsPagination', pageInfo: { __typename?: 'RatingReviewsPageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, totalCount: number }, edges: Array<{ __typename?: 'RatingReviewEdge', cursor: any, node: { __typename: 'RatingReview', id: string, title: string, description: string, ratingBucket: number, authorName?: string | null, submittedAt: { __typename?: 'Date', milliseconds: number }, syndicationSource?: { __typename?: 'RatingSyndicationSourceV2', id: string, name: string, logoImage?: { __typename?: 'RatingReviewPhotoData', id: string, url: string } | null } | null, mediaAssets: Array<{ __typename: 'RatingReviewPhotoAsset', photo: { __typename?: 'RatingReviewPhoto', thumbnail: { __typename?: 'RatingReviewPhotoData', id: string, url: string }, normal: { __typename?: 'RatingReviewPhotoData', id: string, url: string } } } | { __typename?: 'RatingReviewVideoAsset' }> } }> } } } | null } | null };

export type GetCatalogProductRatingQueryVariables = Exact<{
  catalogItemId: Scalars['ID'];
}>;


export type GetCatalogProductRatingQuery = { __typename?: 'Query', productCatalogItemById?: { __typename?: 'ProductCatalogItem', id: string, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, totalReviewCount: number, averageRating: number } } | null } | null };

export type GetProductCatalogHighlightedProductsByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetProductCatalogHighlightedProductsByIdQuery = { __typename?: 'Query', productCatalogItemsByIds: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, publicUrlPath?: string | null, itemType: string, price?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string } | null } | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string } | null, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } | null> };

export type AddProductConfirmationDrawerUpdatesMutationVariables = Exact<{
  registryItemId: Scalars['ID'];
  payload: UpdateRegistryItemPayload;
}>;


export type AddProductConfirmationDrawerUpdatesMutation = { __typename?: 'Mutation', updateRegistryItem: { __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null } };

export type ProductCatalogCategoryByIdQueryVariables = Exact<{
  productCatalogCategoryByIdId: Scalars['ID'];
}>;


export type ProductCatalogCategoryByIdQuery = { __typename?: 'Query', productCatalogCategoryById?: { __typename?: 'ProductCatalogCategory', title: string, id: string, parent?: { __typename?: 'ProductCatalogCategory', id: string, title: string, children: Array<{ __typename?: 'ProductCatalogCategory', title: string, id: string, isFeatured?: boolean | null, publicUrlPath: string, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }> } | null } | null };

export type GetCurationCatalogProductsQueryVariables = Exact<{
  query: ProductCatalogSearchQueryInput;
  first: Scalars['Int'];
  endCursor?: InputMaybe<Scalars['ProductCatalogSearchCursor']>;
  type?: InputMaybe<CatalogTreeRootInput>;
}>;


export type GetCurationCatalogProductsQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null }, productCatalogSearchResults: { __typename: 'ProductCatalogSearchResultContainer', pagedResults?: { __typename: 'ProductCatalogSearchConnection', pageInfo: { __typename: 'ProductCatalogSearchPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any, endCursor: any, totalCount: number }, edges: Array<{ __typename: 'ProductCatalogSearchEdge', cursor: any, node: { __typename: 'ProductCatalogSearchResultItem', catalogItem?: { __typename: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null } | null } }> } | null } };

export type GetRecommendedCatalogCategoriesQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']>;
  storefront?: InputMaybe<CatalogStorefront>;
}>;


export type GetRecommendedCatalogCategoriesQuery = { __typename?: 'Query', recommendCatalogHomeSections: { __typename?: 'ProductCatalogPageSectionContainer', id?: string | null, sections: Array<{ __typename?: 'ProductCatalogPageSection', id: string, displayType: string, catalogEntities: Array<{ __typename?: 'ProductCatalogEntityBrand' } | { __typename: 'ProductCatalogEntityCategory', id: string, catalogCategoryData?: { __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, isFeatured?: boolean | null, browseMoreBanner?: { __typename?: 'ProductCatalogCategoryBrowseBannerMore', image?: { __typename?: 'Photo', id: string, url: string } | null } | null, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, directItemCount: number, isFeatured?: boolean | null, spotlight?: { __typename?: 'ProductCatalogCategorySpotlight', title?: string | null, videoUrl?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null, videoPlaceholder?: { __typename?: 'Photo', id: string, url: string } | null } | null }> } | null } | { __typename?: 'ProductCatalogEntityCuration' } | { __typename?: 'ProductCatalogEntityItem' } | { __typename?: 'ProductCatalogEntityItemGroup' }> }> } };

export type GetRecommendedCatalogProductsQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  endCursor?: InputMaybe<Scalars['ProductCatalogEntityCursor']>;
  storefront?: InputMaybe<CatalogStorefront>;
}>;


export type GetRecommendedCatalogProductsQuery = { __typename?: 'Query', recommendCatalogHomeSections: { __typename: 'ProductCatalogPageSectionContainer', id?: string | null, sections: Array<{ __typename: 'ProductCatalogPageSection', id: string, displayType: string, paginatedCatalogEntities: { __typename: 'ProductCatalogEntitiesPagination', pageInfo: { __typename?: 'ProductCatalogEntitiesPageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, totalCount: number }, edges: Array<{ __typename?: 'ProductCatalogEntityEdge', cursor: any, node: { __typename: 'ProductCatalogEntityBrand', id: string } | { __typename: 'ProductCatalogEntityCategory', id: string } | { __typename: 'ProductCatalogEntityCuration', id: string } | { __typename: 'ProductCatalogEntityItem', id: string } | { __typename: 'ProductCatalogEntityItemGroup', id: string, catalogItemGroupData?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewItem?: { __typename: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, group?: { __typename: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string, isLight: boolean } | null }> } | null, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null }> } | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null } | null } | null } }> } }> } };

export type ProductHeroContentFieldsFragment = { __typename?: 'ProductHeroContent', id: string, title: string, eyebrow: string, description: string, watchVideoUrl?: string | null, gradientCustomColorValue?: string | null, textCustomColorValue?: string | null, storefront: CatalogStorefront, horizontalAlignment: ProductHeroHorizontalAlignment, gradientMode: ProductHeroGradientMode, textColorMode: ProductHeroTextColorMode, cta: { __typename?: 'ProductHeroContentCta', text: string, publicUrlPath: string, redirectUrlType: ProductHeroRedirectUrlType }, desktopMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } }, tabletMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } }, mobileMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } } };

export type ProductHeroContentByCriteriaQueryVariables = Exact<{
  criteria: ProductHeroContentInputCriteria;
}>;


export type ProductHeroContentByCriteriaQuery = { __typename?: 'Query', productHeroContentByCriteria: Array<{ __typename?: 'ProductHeroContent', id: string, title: string, eyebrow: string, description: string, watchVideoUrl?: string | null, gradientCustomColorValue?: string | null, textCustomColorValue?: string | null, storefront: CatalogStorefront, horizontalAlignment: ProductHeroHorizontalAlignment, gradientMode: ProductHeroGradientMode, textColorMode: ProductHeroTextColorMode, cta: { __typename?: 'ProductHeroContentCta', text: string, publicUrlPath: string, redirectUrlType: ProductHeroRedirectUrlType }, desktopMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } }, tabletMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } }, mobileMedia: { __typename?: 'ProductHeroImage', photo: { __typename?: 'ProductHeroImagePhotoAsset', image: { __typename?: 'Photo', id: string, url: string } } } | { __typename?: 'ProductHeroVideo', video: { __typename?: 'ProductHeroVideoAsset', videoUrl: string, fallbackImage: { __typename?: 'Photo', id: string, url: string } } } }> };

export type GetCatalogRootCurationHeroHeaderQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']>;
  storefront?: InputMaybe<CatalogStorefront>;
}>;


export type GetCatalogRootCurationHeroHeaderQuery = { __typename?: 'Query', recommendCatalogHomeSections: { __typename?: 'ProductCatalogPageSectionContainer', id?: string | null, sections: Array<{ __typename?: 'ProductCatalogPageSection', id: string, displayType: string, catalogEntities: Array<{ __typename?: 'ProductCatalogEntityBrand' } | { __typename?: 'ProductCatalogEntityCategory' } | { __typename: 'ProductCatalogEntityCuration', id: string, catalogCurationData?: { __typename?: 'ProductCatalogCuration', id: string, videoUrl?: string | null, header?: { __typename?: 'ProductCatalogCurationHeader', title?: string | null, eyebrow?: string | null, description?: string | null, video?: string | null, backgroundImage?: { __typename?: 'Photo', id: string, url: string } | null, logoImage?: { __typename?: 'Photo', id: string, url: string } | null, videoThumbnail?: { __typename?: 'Photo', id: string, url: string } | null } | null, category: { __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null } } | null } | { __typename?: 'ProductCatalogEntityItem' } | { __typename?: 'ProductCatalogEntityItemGroup' }> }> } };

export type ScannedTransitionalRegistryStatusFragment = { __typename?: 'TransitionalRegistry', id: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string } | null };

export type TransitionalRegistryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TransitionalRegistryQuery = { __typename?: 'Query', transitionalRegistry: { __typename?: 'TransitionalRegistry', id: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string } | null } };

export type CreateTransitionalRegistryMutationVariables = Exact<{
  payload: CreateTransitionalRegistryPayload;
}>;


export type CreateTransitionalRegistryMutation = { __typename?: 'Mutation', createTransitionalRegistry: { __typename?: 'TransitionalRegistry', id: string, name?: string | null, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string } | null } };

export type CheckTransitionalRegistryUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CheckTransitionalRegistryUrlQuery = { __typename?: 'Query', checkTransitionalRegistryUrl: { __typename?: 'InvalidTransitionalRegistryUrlResult', reasonCode: InvalidTransitionalRegistryUrlReasonCode, message?: string | null } | { __typename?: 'ValidTransitionalRegistryUrlResult', canonicalUrl: string } };

export type TransitionalRegistryProductDataFragment = { __typename?: 'TransitionalRegistryProductData', price: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } };

export type TransitionalRegistryFundDataFragment = { __typename?: 'TransitionalRegistryFundData', goal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null };

type TransitionalRegistryItem_TransitionalRegistryFund_Fragment = { __typename: 'TransitionalRegistryFund', id: string, title: string, fundData: { __typename?: 'TransitionalRegistryFundData', goal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null };

type TransitionalRegistryItem_TransitionalRegistryProduct_Fragment = { __typename: 'TransitionalRegistryProduct', id: string, title: string, productData: { __typename?: 'TransitionalRegistryProductData', price: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } }, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type TransitionalRegistryItemFragment = TransitionalRegistryItem_TransitionalRegistryFund_Fragment | TransitionalRegistryItem_TransitionalRegistryProduct_Fragment;

export type TransitionalRegistryDetailsFieldsFragment = { __typename?: 'TransitionalRegistry', id: string, name?: string | null, url: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, items: Array<{ __typename: 'TransitionalRegistryFund', id: string, title: string, fundData: { __typename?: 'TransitionalRegistryFundData', goal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null } | { __typename: 'TransitionalRegistryProduct', id: string, title: string, productData: { __typename?: 'TransitionalRegistryProductData', price: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } }, photo?: { __typename?: 'Photo', id: string, url: string } | null }> };

export type TransitionalRegistryDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TransitionalRegistryDetailsQuery = { __typename?: 'Query', transitionalRegistry: { __typename?: 'TransitionalRegistry', id: string, name?: string | null, url: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, items: Array<{ __typename: 'TransitionalRegistryFund', id: string, title: string, fundData: { __typename?: 'TransitionalRegistryFundData', goal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } | null }, photo?: { __typename?: 'Photo', id: string, url: string } | null } | { __typename: 'TransitionalRegistryProduct', id: string, title: string, productData: { __typename?: 'TransitionalRegistryProductData', price: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string } | null } }, photo?: { __typename?: 'Photo', id: string, url: string } | null }> } };

export type TransferTransitionalRegistryItemsMutationVariables = Exact<{
  payload: TransferTransitionalRegistryItemsPayload;
}>;


export type TransferTransitionalRegistryItemsMutation = { __typename?: 'Mutation', transferTransitionalRegistryItems: { __typename?: 'Registry', id: string } };

export type TransitionalRegistryFragment = { __typename?: 'TransitionalRegistry', id: string, name?: string | null, url: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null };

export type TransitionalRegistriesForEventQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type TransitionalRegistriesForEventQuery = { __typename?: 'Query', transitionalRegistriesForEvent: Array<{ __typename?: 'TransitionalRegistry', id: string, name?: string | null, url: string, status: TransitionalRegistryStatus, scannedAt?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null }> };

export type DeleteTransitionalRegistryMutationVariables = Exact<{
  deleteTransitionalRegistryId: Scalars['ID'];
}>;


export type DeleteTransitionalRegistryMutation = { __typename?: 'Mutation', deleteTransitionalRegistry?: any | null };

export type ChecklistProgressFragment = { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number };

export type ChecklistItemFragment = { __typename?: 'RegistryChecklistItem', id: string, isCheckable: boolean, isChecked: boolean, subTitle?: string | null, sortKey: number, title: string, completeCTAUrlPath: string, type: string, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null };

export type RegistryChecklistSectionFragment = { __typename?: 'RegistryChecklistSection', id: string, sectionTitle: string, sectionProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null };

export type RegistryChecklistFragment = { __typename?: 'RegistryChecklist', id: string, checklistTemplate: string, checklistProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, checklistSections: Array<{ __typename?: 'RegistryChecklistSection', id: string, sectionTitle: string, sectionProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null }> };

export type GetRegistryChecklistQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistryChecklistQuery = { __typename?: 'Query', getRegistryChecklist?: { __typename?: 'RegistryChecklist', id: string, checklistTemplate: string, checklistProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, checklistSections: Array<{ __typename?: 'RegistryChecklistSection', id: string, sectionTitle: string, sectionProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null }> } | null };

export type GetRegistryChecklistSectionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetRegistryChecklistSectionByIdQuery = { __typename?: 'Query', getRegistryChecklistSectionById?: { __typename?: 'RegistryChecklistSection', id: string, checklistItems: Array<{ __typename?: 'RegistryChecklistItem', id: string, isCheckable: boolean, isChecked: boolean, subTitle?: string | null, sortKey: number, title: string, completeCTAUrlPath: string, type: string, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null }> } | null };

export type CreateRegistryChecklistFromTemplateMutationVariables = Exact<{
  payload: CreateRegistryChecklistPayload;
}>;


export type CreateRegistryChecklistFromTemplateMutation = { __typename?: 'Mutation', createRegistryChecklistFromTemplate: { __typename?: 'RegistryChecklist', id: string, checklistTemplate: string, checklistProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, checklistSections: Array<{ __typename?: 'RegistryChecklistSection', id: string, sectionTitle: string, sectionProgress: { __typename?: 'RegistryChecklistProgressResult', checkedCount: number, totalCount: number }, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null }> } };

export type UpdateRegistryChecklistItemMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateRegistryChecklistItemPayload;
}>;


export type UpdateRegistryChecklistItemMutation = { __typename?: 'Mutation', updateRegistryChecklistItem: { __typename?: 'RegistryChecklistItem', id: string, isChecked: boolean, isCheckable: boolean } };

export type RegistryGiftBasketCountByEventNameQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type RegistryGiftBasketCountByEventNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, website: string, registry: { __typename?: 'EventData', id: string, checklist?: { __typename?: 'RegistryChecklist', id: string } | null, items: Array<{ __typename?: 'RegistryItem', id: string, totalRequested?: number | null, isGroupGiftingEnabled?: boolean | null, isHidden: boolean, fpIndex: number, productData: { __typename?: 'RegistryItemProductData', price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, registryItem: { __typename?: 'RegistryItem', id: string } }, createAt: { __typename?: 'Date', milliseconds: number } }>, orders?: Array<{ __typename?: 'RegistryOrder', id: string, orderedAt: { __typename?: 'Date', timestamp: any, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, registryItem?: { __typename?: 'RegistryItem', id: string } | null }> }> | null } } | null };

export type RegistryGiftBasketOrdersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RegistryGiftBasketOrdersByIdsQuery = { __typename?: 'Query', registryOrdersByIds: Array<{ __typename?: 'RegistryOrder', id: string, isDropship: boolean, isPurchased: boolean, email: string, name: string, orderedAt: { __typename?: 'Date', timestamp: any, milliseconds: number }, fulfillment?: { __typename?: 'RegistryFulfillment', status: string } | null, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', correctedQuantity: number }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string } | null } } }> } | null> };

export type RegistryGiftBasketItemsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RegistryGiftBasketItemsByIdsQuery = { __typename?: 'Query', registryItemsByIds: Array<{ __typename?: 'RegistryItem', id: string, fpIndex: number, storeName?: string | null, totalRequested?: number | null, externallyOwned: boolean, donationFund?: { __typename?: 'DonationFund', id: string, goalMonetaryValue?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number } | null, currency: { __typename?: 'RegistryCurrency', id: string, code: string } } | null, productData: { __typename?: 'RegistryItemProductData', title: string, customType?: CustomItemDataType | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string } | null } | null } } | null> };

export type CalculatedPriceRangeFragment = { __typename?: 'CalculatedPriceRange', targetGiftCount: number, currentGiftCount: number, startPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, endPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null };

export type RegistryAdvisorFragment = { __typename?: 'RecommendRegistryAdvisorData', guestCount: number, targetGiftCount: number, currentGiftCount: number, priceRanges: Array<{ __typename?: 'CalculatedPriceRange', targetGiftCount: number, currentGiftCount: number, startPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, endPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null }> };

export type SetGuestCountMutationVariables = Exact<{
  eventId: Scalars['String'];
  payload: RecommendRegistryOnboardingSurveyPayload;
}>;


export type SetGuestCountMutation = { __typename?: 'Mutation', updateRecommendRegistryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, guestCount?: number | null, lastUpdatedAt?: { __typename?: 'Date', milliseconds: number } | null } };

export type GetRegistryRecommendationResultsQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type GetRegistryRecommendationResultsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, recommendation: { __typename?: 'RecommendEvent', registryAdvisor?: { __typename?: 'RecommendRegistryAdvisorData', guestCount: number, targetGiftCount: number, currentGiftCount: number, priceRanges: Array<{ __typename?: 'CalculatedPriceRange', targetGiftCount: number, currentGiftCount: number, startPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, endPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null }> } | null } } | null };

export type GetRegistryGuideCompletionPercentageQueryVariables = Exact<{
  handle: Scalars['String'];
}>;


export type GetRegistryGuideCompletionPercentageQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, recommendation: { __typename?: 'RecommendEvent', registryAdvisor?: { __typename?: 'RecommendRegistryAdvisorData', targetGiftCount: number, currentGiftCount: number } | null } } | null };

export type GetRegistryDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  withGuestSiteData: Scalars['Boolean'];
  eventDesignPurpose: EventDesignPurpose;
}>;


export type GetRegistryDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId?: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, timezone?: string | null, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, welcomePage: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null }>, registry: { __typename?: 'EventData', id: string, event: { __typename?: 'Event', id: string }, summary?: { __typename?: 'EventRegistriesSummary', cannotSync: boolean, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null } | null, currency?: { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null } | null, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null, donationFundInfo: { __typename?: 'DonationFundInfo', defaultPlatform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null } | null, defaultSuggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, platforms: Array<{ __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null, link?: string | null }>, items: Array<{ __typename?: 'DonationFund', id: string, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum } | null }> } }, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus }> } | null };

export type GuestEventDetailsByNameQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  pageType?: InputMaybe<EventPageType>;
  eventDesignPurpose: EventDesignPurpose;
}>;


export type GuestEventDetailsByNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, photoV2Url?: string | null, website: string, info: { __typename?: 'EventInfo', id: string, eventType: EventType, fianceeFirstName?: string | null, eventDisplayName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null }, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null, pages: Array<{ __typename?: 'EventPage', id: string, disabled: boolean, type: EventPageType, pageSlug: string }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, pageInfo?: { __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string } | { __typename?: 'Photo', id: string, url: string } | null } } | null } | null };

export type GetCheckoutDialogDataQueryVariables = Exact<{
  registryItemId: Scalars['ID'];
  registryOrderId: Scalars['ID'];
  skipDonationOrder: Scalars['Boolean'];
  skipOrderQuery: Scalars['Boolean'];
  isAffiliate: Scalars['Boolean'];
}>;


export type GetCheckoutDialogDataQuery = { __typename?: 'Query', registryItem?: { __typename?: 'RegistryItem', id: string, note?: string | null, storeName?: string | null, isGroupGiftingEnabled?: boolean | null, stillNeeded: number, mustHave: boolean, totalRequested?: number | null, createAt: { __typename?: 'Date', milliseconds: number }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, customType?: CustomItemDataType | null, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', url: string, id: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, description?: string | null, fundType: CustomItemDataType, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, enforceSuggestedDonationAmount: boolean, donationsAreCapped: boolean, hideFundingGoal: boolean, suggestedQuantityStillNeeded?: number | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, name: string, username?: string | null, link?: string | null, type: DonationFundPlatformTypeEnum } | null, currency: { __typename?: 'RegistryCurrency', id: string, code: string, places: number }, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, donations: Array<{ __typename?: 'DonationFundDonation', id: string, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number } }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string } | null } | null } | null, orderMetadata?: { __typename?: 'RegistryOrder', id: string, isPurchased: boolean } | null, order?: { __typename?: 'DonationFundDonation', id: string, platformType?: DonationFundPaymentMethodEnum | null, name: string, email: string, note?: string | null, fund: { __typename?: 'DonationFund', id: string }, amount: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number } } | null, registryOrder?: { __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, lineItems: Array<{ __typename?: 'LineItem', quantity: number, locator: string }> } | null };

export type GuestSiteNavBarQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  eventDesignPurpose: EventDesignPurpose;
}>;


export type GuestSiteNavBarQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string }>, activeSession: { __typename?: 'EventSession', id: string, hasUnlocked: boolean, hasIdentity: boolean, person?: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, avatarName?: string | null } | null }, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null } | null };

export type GetEventRegistriesAndOrdersQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventRegistriesAndOrdersQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null }> }, registry: { __typename?: 'EventData', id: string, event: { __typename?: 'Event', id: string }, orders?: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null }> | null } } | null };

export type GetRegistryPageIdQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryPageIdQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registryPage: Array<{ __typename?: 'EventPage', id: string }> } | null };

export type AccommodationsConsolePropertiesQueryVariables = Exact<{
  payload: AccommodationContentSearchInput;
}>;


export type AccommodationsConsolePropertiesQuery = { __typename?: 'Query', searchAccommodationProperties: { __typename?: 'AccommodationContentSearchResult', properties: Array<{ __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, name: string, propertyType: AccommodationCatalogPropertyType, accommodationCategory?: AccommodationCategory | null, starRating?: number | null, url?: string | null, id: string, facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string }>, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, photo?: { __typename?: 'Photo', id: string, assetId: string } | null }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null }> } };

export type AccommodationConsoleListingPricingFragment = { __typename?: 'PricingForAccommodationPlace', nightlyBaseRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode }, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency: TravelCurrencyCode } | null, totalRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } };

export type AccommodationConsoleListingPropertyFragment = { __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, name: string, propertyType: AccommodationCatalogPropertyType, accommodationCategory?: AccommodationCategory | null, starRating?: number | null, url?: string | null, id: string, facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string }>, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, photo?: { __typename?: 'Photo', id: string, assetId: string } | null }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null };

export type AccommodationPlacesByCoupleQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type AccommodationPlacesByCoupleQuery = { __typename?: 'Query', eventByName?: { __typename: 'Event', id: string, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, joyPlaceId?: string | null, isFromAccommodationCatalog: boolean, isFavorite?: boolean | null, isHostStayingHere?: boolean | null, userNote?: string | null, phone?: string | null, lat?: number | null, long?: number | null, name?: string | null, customName?: string | null, address?: string | null, city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, starRating?: number | null, url?: string | null, description?: string | null, type?: AccommodationPlaceType | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, currencyCode?: string | null, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, interestedGuestCount: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null }> } | null };

export type AccommodationsConsoleStateInitializationQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type AccommodationsConsoleStateInitializationQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, travelSettings?: { __typename?: 'TravelSettings', checkInDate?: string | null, checkOutDate?: string | null } | null, info: { __typename?: 'EventInfo', id: string, finalizedDate?: { __typename?: 'Date', dateString: string } | null }, bestLocationAnchor?: { __typename?: 'LocationAnchor', friendlyName: string, latitude: string, longitude: string, source: LocationAnchorSource } | null } | null };

export type AccommodationCatalogConsoleListingPropertyFragment = { __typename?: 'ExtendedAccommodationCatalogProperty', joyPlaceId: string, name: string, propertyType: AccommodationCatalogPropertyType, accommodationCategory?: AccommodationCategory | null, otaProvider: string, starRating?: number | null, url?: string | null, id: string, facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string }>, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, photo?: { __typename?: 'Photo', id: string, assetId: string } | null }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null };

export type AccommodationCatalogConsoleListingRedirectMechanismsFragment = { __typename?: 'RedirectMechanism', type: RedirectMechanismType, url: string, telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null };

export type AccommodationCatalogConsoleListingPricingFragment = { __typename?: 'AccommodationCatalogPropertyPricingInfo', nightlyBaseRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode }, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency: TravelCurrencyCode } | null, totalRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } };

export type AccommodationsConsolePropertiesV2QueryVariables = Exact<{
  payload: SearchExtendedAccommodationPropertiesV2Payload;
}>;


export type AccommodationsConsolePropertiesV2Query = { __typename?: 'Query', searchExtendedAccommodationProperties: { __typename?: 'ExtendedAccommodationContentSearchResult', properties: Array<{ __typename?: 'ExtendedAccommodationCatalogProperty', score: number, joyPlaceId: string, name: string, propertyType: AccommodationCatalogPropertyType, accommodationCategory?: AccommodationCategory | null, otaProvider: string, starRating?: number | null, url?: string | null, id: string, pricingInfo?: { __typename?: 'AccommodationCatalogPropertyPricingInfo', nightlyBaseRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode }, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency: TravelCurrencyCode } | null, totalRate: { __typename?: 'TravelMonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, digits: number, currency: TravelCurrencyCode } } | null, redirectMechanisms?: Array<{ __typename?: 'RedirectMechanism', type: RedirectMechanismType, url: string, telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null }> | null, facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string }>, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, photo?: { __typename?: 'Photo', id: string, assetId: string } | null }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null }> } };

export type AccommodationsConsoleHotelsSortOrderQueryVariables = Exact<{
  payload: PageContainerBySlugPayload;
}>;


export type AccommodationsConsoleHotelsSortOrderQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent' } | { __typename?: 'TravelMapComponent', id: string, type: ComponentType, sortOrder: number, blockOrdering?: Array<string> | null } | { __typename?: 'VideoComponent' }> | null } | null };

export type AccommodationPlacesPricingAndBookingDetailsQueryVariables = Exact<{
  payload: TravelPlacePricingAndBookingDetailsPayload;
}>;


export type AccommodationPlacesPricingAndBookingDetailsQuery = { __typename?: 'Query', travelPlacesPricingAndBookingDetails: { __typename?: 'TravelPlacePricingAndBookingDetailsResult', accommodationPlaces: Array<{ __typename: 'AccommodationPlacePricingAndBookingDetails', accommodationPlace: { __typename: 'AccommodationPlaceV2', id: string, lat?: number | null, long?: number | null, googlePlaceId?: string | null, joyPlaceId?: string | null, name?: string | null, address?: string | null, zhId?: string | null, url?: string | null, customUrl?: string | null, starRating?: number | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }, pricingInfo?: { __typename?: 'PricingForAccommodationPlace', strikeoutRateProvider?: StrikeoutRateProvider | null, baseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyBaseRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, nightlyTotalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, strikeoutBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyBaseRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutNightlyTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, totalRate: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } } | null, redirectMechanisms?: Array<{ __typename: 'RedirectMechanism', telemetryDestinationName: string, trackingQueryStringKey?: TrackingQueryStringKey | null, type: RedirectMechanismType, url: string }> | null }> } };

export type TravelOfferFragment = { __typename: 'TravelOffer', offerToken: string, checkIn: string, checkOut: string, offerGroupId?: string | null, providerName?: string | null, components: Array<{ __typename: 'TravelOfferAccommodationUnitsComponent', distributionType?: TravelOfferDistributionType | null, componentType: string, refundability: TravelOfferRefundability, policies: Array<{ __typename?: 'TravelOfferPolicyField', title: string, description: string }>, boardBasis?: { __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string } | null, occupancies: Array<{ __typename?: 'TravelOfferAccommodationUnitsComponentOccupancy', adults: number, children: number, childrenAges?: Array<number> | null }>, unit: { __typename: 'AccommodationCatalogPropertyUnit', id: string, name: string, plainTextLongDescription: string, facilities: Array<{ __typename: 'AccommodationCatalogFacilityOrAmenity', label: string }>, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }>, property: { __typename?: 'AccommodationCatalogProperty', name: string, joyPlaceId: string, starRating?: number | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, subject: { __typename?: 'AccommodationCatalogPhotoSubject', label: string, type: AccommodationCatalogPhotoSubjectType } }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null } } }>, onsiteCharges: Array<{ __typename?: 'TravelOfferOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, fees: Array<{ __typename?: 'TravelOfferFee', isIncludedInTotal: boolean, rate: number, type: FeeType, visibility: string, amount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }>, baseAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, totalAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, originalBaseAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, originalTotalAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null };

export type TravelOfferReservationForCheckoutFragment = { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } } } | null, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null }> }> };

export type HotelImagesQueryVariables = Exact<{
  payload: HotelInventoryByIdsRequest;
}>;


export type HotelImagesQuery = { __typename?: 'Query', hotelImages: Array<{ __typename: 'HotelInventoryImages', hotelId: string, images: Array<{ __typename: 'HotelInventoryImage', imageName: string, thumbnailUrl?: string | null, url: string }> }> };

export type HotelRoomsAndRatesQueryVariables = Exact<{
  payload: HotelRoomsAndRatesRequest;
}>;


export type HotelRoomsAndRatesQuery = { __typename?: 'Query', hotelRoomsAndRates: { __typename: 'HotelRoomsAndRates', hotelId: string, rates: Array<{ __typename?: 'HotelRoomsAndRatesRate', currency: string, rateId: string, occupancies: Array<{ __typename?: 'HotelRoomsAndRatesOccupancy', numOfAdults: number, roomId: string, numOfChildren?: number | null, childAges?: Array<number> | null }>, totalRateWithTax: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, publishedRateWithTax?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null }>, rooms: Array<{ __typename?: 'HotelRoomsAndRatesRoom', id: string, name: string, description?: string | null, facilities: Array<string>, roomSquareFeet?: string | null, roomSquareMeters?: string | null, beds: Array<{ __typename?: 'HotelRoomsAndRatesBed', count: string, type: string }>, images?: Array<{ __typename?: 'HotelInventoryImage', imageName: string, thumbnailUrl?: string | null, url: string }> | null }> } };

export type HotelInventoryByIdsQueryVariables = Exact<{
  payload: HotelInventoryByIdsRequest;
}>;


export type HotelInventoryByIdsQuery = { __typename?: 'Query', hotelInventoryByIds: Array<{ __typename: 'HotelInventory', address?: string | null, city?: string | null, country?: string | null, description?: string | null, displayName?: string | null, distance?: number | null, hotelUrl?: string | null, isPreferredHotel: boolean, photo?: string | null, postalCode?: string | null, starRating?: number | null, state?: string | null, userRating?: number | null, zhId?: string | null, facilityGroups: Array<{ __typename: 'FacilityGroup', id: number, name: string }>, location?: { __typename: 'InventoryLocation', lat: number, lon: number } | null }> };

export type EventInfoForAccommodationPropertyQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type EventInfoForAccommodationPropertyQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type PropertiesWithAccommodationPlaceQueryVariables = Exact<{
  idObject: AccommodationCatalogPropertyIdentifierInput;
  accommodationPlaceId: Scalars['ID'];
  pageContainerBySlugPayload2: PageContainerBySlugPayload;
}>;


export type PropertiesWithAccommodationPlaceQuery = { __typename?: 'Query', accommodationCatalogPropertyById: { __typename: 'AccommodationCatalogProperty', name: string, plainTextLongDescription: string, starRating?: number | null, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string }>, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }>, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null }, accommodationPlaceV2ById?: { __typename?: 'AccommodationPlaceV2', id: string, isPhotoHidden?: boolean | null, name?: string | null, customName?: string | null, userNote?: string | null, description?: string | null, lat?: number | null, long?: number | null, city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, address?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, altTag?: string | null } | null, customPhoto?: { __typename?: 'Photo', id: string, altTag?: string | null, url: string } | null } | null, pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent', id: string } | { __typename?: 'TravelMapComponent' } | { __typename?: 'VideoComponent' }> | null } | null };

export type TravelOffersForAccommodationPropertiesQueryVariables = Exact<{
  payload: TravelOffersForAccommodationForPropertiesPayload;
}>;


export type TravelOffersForAccommodationPropertiesQuery = { __typename?: 'Query', travelOffersForAccommodationProperties: { __typename?: 'TravelOffersResult', someOffers: Array<{ __typename: 'TravelOffer', offerToken: string, checkIn: string, checkOut: string, offerGroupId?: string | null, providerName?: string | null, components: Array<{ __typename: 'TravelOfferAccommodationUnitsComponent', distributionType?: TravelOfferDistributionType | null, componentType: string, refundability: TravelOfferRefundability, policies: Array<{ __typename?: 'TravelOfferPolicyField', title: string, description: string }>, boardBasis?: { __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string } | null, occupancies: Array<{ __typename?: 'TravelOfferAccommodationUnitsComponentOccupancy', adults: number, children: number, childrenAges?: Array<number> | null }>, unit: { __typename: 'AccommodationCatalogPropertyUnit', id: string, name: string, plainTextLongDescription: string, facilities: Array<{ __typename: 'AccommodationCatalogFacilityOrAmenity', label: string }>, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }>, property: { __typename?: 'AccommodationCatalogProperty', name: string, joyPlaceId: string, starRating?: number | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, subject: { __typename?: 'AccommodationCatalogPhotoSubject', label: string, type: AccommodationCatalogPhotoSubjectType } }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null } } }>, onsiteCharges: Array<{ __typename?: 'TravelOfferOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, fees: Array<{ __typename?: 'TravelOfferFee', isIncludedInTotal: boolean, rate: number, type: FeeType, visibility: string, amount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }>, baseAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, totalAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, originalBaseAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, originalTotalAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null }> } };

export type PricingsForAccommodationByRegionQueryVariables = Exact<{
  payload: TravelPricingsForAccommodationByRegionPayload;
}>;


export type PricingsForAccommodationByRegionQuery = { __typename?: 'Query', pricingsForAccommodationByRegion: { __typename?: 'TravelPricingsResult', pricings: Array<{ __typename?: 'TravelPricing', property: { __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, relevanceScore?: number | null, starRating?: number | null, name: string, plainTextLongDescription: string, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null, timezone?: string | null }, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, subject: { __typename?: 'AccommodationCatalogPhotoSubject', label: string, type: AccommodationCatalogPhotoSubjectType } }> }, totalAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }> } };

export type ServiceCenterAccommodationPlaceFragment = { __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, zhId?: string | null, joyPlaceId?: string | null, googlePlaceId?: string | null };

export type ServiceCenterAddAccommodationPlaceV2MutationVariables = Exact<{
  payload: AddAccommodationPlaceV2Request;
}>;


export type ServiceCenterAddAccommodationPlaceV2Mutation = { __typename?: 'Mutation', addAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, zhId?: string | null, joyPlaceId?: string | null, googlePlaceId?: string | null } };

export type ServiceCenterDeleteAccommodationPlaceV2MutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ServiceCenterDeleteAccommodationPlaceV2Mutation = { __typename?: 'Mutation', deleteAccommodationPlaceV2: { __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, zhId?: string | null, joyPlaceId?: string | null, googlePlaceId?: string | null } };

export type TravelOfferReservationUpdateMutationVariables = Exact<{
  payload: TravelOfferReservationUpdatePayload;
}>;


export type TravelOfferReservationUpdateMutation = { __typename?: 'Mutation', travelOfferReservationUpdate: { __typename?: 'TravelOfferReservation', id: string, status: TravelOfferReservationStatus } };

export type ServiceCenterAccommodationPlacesQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type ServiceCenterAccommodationPlacesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, zhId?: string | null, joyPlaceId?: string | null, googlePlaceId?: string | null }> } | null };

export type TravelOfferFromOfferTokenQueryVariables = Exact<{
  payload: Scalars['String'];
  params?: InputMaybe<TravelOfferFromOfferTokenParams>;
  useCache?: InputMaybe<Scalars['Boolean']>;
}>;


export type TravelOfferFromOfferTokenQuery = { __typename?: 'Query', travelOfferFromOfferToken: { __typename: 'TravelOffer', offerToken: string, checkIn: string, checkOut: string, offerGroupId?: string | null, providerName?: string | null, components: Array<{ __typename: 'TravelOfferAccommodationUnitsComponent', distributionType?: TravelOfferDistributionType | null, componentType: string, refundability: TravelOfferRefundability, policies: Array<{ __typename?: 'TravelOfferPolicyField', title: string, description: string }>, boardBasis?: { __typename?: 'AccommodationCatalogFacilityOrAmenity', label: string } | null, occupancies: Array<{ __typename?: 'TravelOfferAccommodationUnitsComponentOccupancy', adults: number, children: number, childrenAges?: Array<number> | null }>, unit: { __typename: 'AccommodationCatalogPropertyUnit', id: string, name: string, plainTextLongDescription: string, facilities: Array<{ __typename: 'AccommodationCatalogFacilityOrAmenity', label: string }>, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string }>, property: { __typename?: 'AccommodationCatalogProperty', name: string, joyPlaceId: string, starRating?: number | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, subject: { __typename?: 'AccommodationCatalogPhotoSubject', label: string, type: AccommodationCatalogPhotoSubjectType } }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null } } }>, onsiteCharges: Array<{ __typename?: 'TravelOfferOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, fees: Array<{ __typename?: 'TravelOfferFee', isIncludedInTotal: boolean, rate: number, type: FeeType, visibility: string, amount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }>, baseAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, totalAmount: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, originalBaseAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null, originalTotalAmount?: { __typename?: 'TravelMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } | null } };

export type TravelOfferReservationCreateMutationVariables = Exact<{
  payload: TravelOfferReservationCreatePayload;
}>;


export type TravelOfferReservationCreateMutation = { __typename?: 'Mutation', travelOfferReservationCreate: { __typename?: 'TravelOfferReservationCreateStripeNativeResult', paymentIntentClientSecret: string, reservation: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } } } | null, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null }> }> } } | { __typename?: 'TravelOfferReservationCreateVaulteraVaultResult', vaulteraToken?: string | null, reservation: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } } } | null, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null }> }> } } };

export type TravelOfferReservationConfirmMutationVariables = Exact<{
  payload: TravelOfferReservationConfirmPayload;
}>;


export type TravelOfferReservationConfirmMutation = { __typename?: 'Mutation', travelOfferReservationConfirm: { __typename?: 'TravelOfferReservationConfirmFailure', errorMessage: string } | { __typename?: 'TravelOfferReservationConfirmSuccess', reservation: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus } } };

export type TravelOfferReservationFullDetailsFragment = { __typename?: 'TravelOfferReservation', id: string, offerToken: string, email?: string | null, status: TravelOfferReservationStatus, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null, phoneNumber?: string | null }> }>, cancellationFees?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', provider?: string | null, propertyConfirmationCode?: string | null, checkIn: string, checkOut: string, externalOrderId: string, baseAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } }, onsiteCharges: Array<{ __typename?: 'TravelOfferReservationOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, propertyInfo: { __typename?: 'TravelOfferReservationConfirmationPropertyInfo', heroImageUrl: string, name: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null }, policies?: Array<{ __typename?: 'OfferPolicy', title?: string | null, description?: string | null }> | null }, reservationItems: Array<{ __typename?: 'TravelOfferReservationItem', refundability: TravelOfferReservationRefundability, occupancy: { __typename?: 'TravelOfferReservationItemOccupancy', adults: number, children: number }, unit: { __typename?: 'TravelOfferReservationUnit', id: string, name: string, description?: string | null } }>, totalAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, discountAmount?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, fees: Array<{ __typename?: 'TravelOfferReservationFee', isIncludedInTotal: boolean, rate: number, type: string, visibility: string, amount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }> } | null };

export type TravelOfferReservationStatusDetailsFragment = { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus };

export type TravelOfferReservationByIdQueryVariables = Exact<{
  travelOfferReservationByIdId: Scalars['String'];
}>;


export type TravelOfferReservationByIdQuery = { __typename?: 'Query', travelOfferReservationById?: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, email?: string | null, status: TravelOfferReservationStatus, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null, phoneNumber?: string | null }> }>, cancellationFees?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', provider?: string | null, propertyConfirmationCode?: string | null, checkIn: string, checkOut: string, externalOrderId: string, baseAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } }, onsiteCharges: Array<{ __typename?: 'TravelOfferReservationOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, propertyInfo: { __typename?: 'TravelOfferReservationConfirmationPropertyInfo', heroImageUrl: string, name: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null }, policies?: Array<{ __typename?: 'OfferPolicy', title?: string | null, description?: string | null }> | null }, reservationItems: Array<{ __typename?: 'TravelOfferReservationItem', refundability: TravelOfferReservationRefundability, occupancy: { __typename?: 'TravelOfferReservationItemOccupancy', adults: number, children: number }, unit: { __typename?: 'TravelOfferReservationUnit', id: string, name: string, description?: string | null } }>, totalAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, discountAmount?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, fees: Array<{ __typename?: 'TravelOfferReservationFee', isIncludedInTotal: boolean, rate: number, type: string, visibility: string, amount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }> } | null } | null };

export type TravelOfferReservationStatusByIdQueryVariables = Exact<{
  travelOfferReservationStatusById: Scalars['String'];
}>;


export type TravelOfferReservationStatusByIdQuery = { __typename?: 'Query', travelOfferReservationById?: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus } | null };

export type TravelOfferReservationByIdOrOrderIdQueryVariables = Exact<{
  travelOfferReservationByIdOrOrderIdId: Scalars['String'];
}>;


export type TravelOfferReservationByIdOrOrderIdQuery = { __typename?: 'Query', travelOfferReservationByIdOrOrderId?: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, email?: string | null, status: TravelOfferReservationStatus, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null, phoneNumber?: string | null }> }>, cancellationFees?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', provider?: string | null, propertyConfirmationCode?: string | null, checkIn: string, checkOut: string, externalOrderId: string, baseAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } }, onsiteCharges: Array<{ __typename?: 'TravelOfferReservationOnsiteCharge', title: string, units?: Array<string> | null, unitPrice: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number } }>, propertyInfo: { __typename?: 'TravelOfferReservationConfirmationPropertyInfo', heroImageUrl: string, name: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null }, policies?: Array<{ __typename?: 'OfferPolicy', title?: string | null, description?: string | null }> | null }, reservationItems: Array<{ __typename?: 'TravelOfferReservationItem', refundability: TravelOfferReservationRefundability, occupancy: { __typename?: 'TravelOfferReservationItemOccupancy', adults: number, children: number }, unit: { __typename?: 'TravelOfferReservationUnit', id: string, name: string, description?: string | null } }>, totalAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnits: number }, discountAmount?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, fees: Array<{ __typename?: 'TravelOfferReservationFee', isIncludedInTotal: boolean, rate: number, type: string, visibility: string, amount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, digits: number, floatingPointDecimalString: string, valueInMinorUnitsBigInt: any } }> } | null } | null };

export type TravelOfferReservationStatusByIdOrOrderIdQueryVariables = Exact<{
  travelOfferReservationStatusByIdOrOrderId: Scalars['String'];
}>;


export type TravelOfferReservationStatusByIdOrOrderIdQuery = { __typename?: 'Query', travelOfferReservationByIdOrOrderId?: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus } | null };

export type GetEventByIdForReservationStatusPageQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventByIdForReservationStatusPageQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string } | null };

export type CurrentEventGuestQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type CurrentEventGuestQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, activeSession: { __typename?: 'EventSession', id: string, person?: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneDisplay?: string | null } | null } } | null };

export type CancelReservationMutationVariables = Exact<{
  payload: TravelOfferReservationCancelPayload;
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', travelOfferReservationCancel: { __typename?: 'TravelOfferReservationCancelFailure', errorMessage: string } | { __typename?: 'TravelOfferReservationCancelSuccess', reservation: { __typename?: 'TravelOfferReservation', id: string, status: TravelOfferReservationStatus, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', externalOrderId: string, checkIn: string, checkOut: string, propertyConfirmationCode?: string | null, propertyInfo: { __typename?: 'TravelOfferReservationConfirmationPropertyInfo', name: string, address: { __typename?: 'TravelReservationAddress', line1: string, line2?: string | null, city: string, state?: string | null, country: string, postalCode?: string | null } }, baseAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, floatingPointDecimalString: string }, totalAmount: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, floatingPointDecimalString: string }, discountAmount?: { __typename?: 'TravelReservationMonetaryValue', currency: TravelCurrencyCode, valueInMinorUnits: number, floatingPointDecimalString: string, digits: number } | null, billingContact: { __typename?: 'TravelOfferReservationContactInfo', title: string, firstName: string, lastName: string, email: string, phone: string } } | null } } };

export type TravelOfferReservationByIdForCheckoutQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TravelOfferReservationByIdForCheckoutQuery = { __typename?: 'Query', travelOfferReservationById?: { __typename?: 'TravelOfferReservation', id: string, offerToken: string, status: TravelOfferReservationStatus, confirmation?: { __typename?: 'TravelOfferReservationConfirmation', billingContact: { __typename?: 'TravelOfferReservationContactInfo', email: string, firstName: string, lastName: string, middleName?: string | null, phone: string, title: string, address: { __typename?: 'TravelReservationAddress', city: string, country: string, line1: string, line2?: string | null, postalCode?: string | null, state?: string | null } } } | null, roomGuests: Array<{ __typename?: 'TravelOfferReservationRoomGuests', unitId: string, guests: Array<{ __typename?: 'TravelOfferReservationGuestInformation', ageClassification: TravelReservationGuestAgeClassification, firstName: string, lastName: string, title?: TravelReservationGuestTitle | null }> }> } | null };

export type SearchTravelOfferReservationsQueryVariables = Exact<{
  payload: SearchTravelOfferReservationsPayload;
}>;


export type SearchTravelOfferReservationsQuery = { __typename?: 'Query', searchTravelOfferReservations?: Array<{ __typename?: 'TravelOfferReservation', id: string }> | null };

export type GetThingsToDoContainersQueryVariables = Exact<{
  payload: GetThingsToDoContainersPayload;
}>;


export type GetThingsToDoContainersQuery = { __typename?: 'Query', getThingsToDoContainers: Array<{ __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, schemaUrl: string, type: string }> };

export type UpdateThingsToDoContainersMutationVariables = Exact<{
  payload: UpdateThingsToDoContainersPayload;
}>;


export type UpdateThingsToDoContainersMutation = { __typename?: 'Mutation', updateThingsToDoContainers: Array<{ __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, schemaUrl: string, type: string }> };

export type GetEventDetailsInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventDetailsInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, timezone?: string | null, eventDateIsFinalized: boolean, locationInfo?: { __typename?: 'EventLocation', id?: string | null, name?: string | null, placeId?: string | null } | null, finalizedDate?: { __typename?: 'Date', dateString: string } | null, tentativeDate?: { __typename?: 'Date', dateString: string } | null } } | null };

export type FormCustomComponentFormListByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type FormCustomComponentFormListByEventIdQuery = { __typename?: 'Query', formListByEventId: Array<{ __typename?: 'Form', id: string, title: string, description: string }> };

export type FormCustomComponentFormByIdQueryVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type FormCustomComponentFormByIdQuery = { __typename?: 'Query', formById?: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, eventId?: string | null, type?: FormType | null } | null };

export type FormCustomComponentSubmitFormAnswersMutationVariables = Exact<{
  input: SubmitFormAnswersInput;
}>;


export type FormCustomComponentSubmitFormAnswersMutation = { __typename?: 'Mutation', submitFormAnswers: { __typename?: 'Form', id: string, eventId?: string | null, title: string } };

export type GeneralScheduleComponentScheduleForEventQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GeneralScheduleComponentScheduleForEventQuery = { __typename?: 'Query', getGuestGeneralEventScheduleForEvent: { __typename?: 'GeneralEventScheduleInfo', formattedSchedules: Array<{ __typename?: 'FormattedSchedule', dateISO8601TZ: string, items: Array<{ __typename?: 'EventSchedule', description?: string | null, id: string, name: string, timezone?: string | null, startTimeISO8601TZ?: string | null, endTimeISO8601TZ?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null }> }>, tbaSchedules: Array<{ __typename?: 'EventSchedule', description?: string | null, id: string, name: string, timezone?: string | null }> } };

export type JsonDataContainerByIdQueryVariables = Exact<{
  payload: JsonDataContainerByIdPayload;
}>;


export type JsonDataContainerByIdQuery = { __typename?: 'Query', jsonDataContainerById?: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } | null };

export type EventIDByHandleQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type EventIDByHandleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string } | null };

export type UpdateJsonDataContainerMutationVariables = Exact<{
  payload: UpdateJsonDataContainerPayload;
}>;


export type UpdateJsonDataContainerMutation = { __typename?: 'Mutation', updateJsonDataContainer: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } };

export type DeleteJsonDataContainerMutationVariables = Exact<{
  payload: DeleteJsonDataContainerPayload;
}>;


export type DeleteJsonDataContainerMutation = { __typename?: 'Mutation', deleteJsonDataContainer: boolean };

export type AddJsonDataBlobComponentMutationVariables = Exact<{
  payload: AddJsonDataBlobComponentPayload;
}>;


export type AddJsonDataBlobComponentMutation = { __typename?: 'Mutation', addJsonDataBlobComponent: { __typename?: 'JsonDataBlobComponent', id: string, type: ComponentType, sortOrder: number, jsonDataContainerId: string } };

export type CreateJsonDataContainerMutationVariables = Exact<{
  payload: CreateJsonDataContainerPayload;
}>;


export type CreateJsonDataContainerMutation = { __typename?: 'Mutation', createJsonDataContainer: { __typename?: 'JsonDataContainer', id: string, eventId: string, content: any, type: string, schemaUrl: string } };

export type PlaceToStayAccommodationPlaceV2Fragment = { __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, userNote?: string | null, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, url?: string | null, lat?: number | null, long?: number | null, zhId?: string | null, starRating?: number | null, googlePlaceId?: string | null, joyPlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, isCustomLinkEnabled?: boolean | null, displayLocation?: AccommodationPlaceDisplayLocation | null, layoutType?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', km: number, mi: number, durationMinutes?: number | null, type: DistancesBetweenPointsType }> } | null };

export type PlaceToStayAccommodationsQueryVariables = Exact<{
  eventId: Scalars['ID'];
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
}>;


export type PlaceToStayAccommodationsQuery = { __typename?: 'Query', event?: { __typename: 'Event', id: string, accommodationPlacesForDisplayLocation: Array<{ __typename: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, userNote?: string | null, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, url?: string | null, lat?: number | null, long?: number | null, zhId?: string | null, starRating?: number | null, googlePlaceId?: string | null, joyPlaceId?: string | null, customName?: string | null, customAddress?: string | null, customUrl?: string | null, isCustomLinkEnabled?: boolean | null, displayLocation?: AccommodationPlaceDisplayLocation | null, layoutType?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, distances?: { __typename?: 'TravelDistancesBetweenPointsResponse', commonDistance: Array<{ __typename?: 'TravelDistanceBetweenPoints', km: number, mi: number, durationMinutes?: number | null, type: DistancesBetweenPointsType }> } | null }> } | null };

export type GetUrlMetadataQueryVariables = Exact<{
  input: UrlMetadataInput;
}>;


export type GetUrlMetadataQuery = { __typename?: 'Query', urlMetadata: { __typename?: 'UrlMetadataResponse', finalUrl: string, error?: { __typename?: 'UrlMetadataError', code: number, message: string, type: string } | null, metadata?: { __typename?: 'UrlMetadata', title?: string | null, description?: string | null, imageUrl?: string | null, author?: string | null, publisher?: string | null, logoUrl?: string | null } | null } };

export type VIPEditGetVipsForEventByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VIPEditGetVipsForEventByIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, vips: Array<{ __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null }> } | null };

export type VIPEditDeleteVIPMutationVariables = Exact<{
  payload: DeleteVipPayload;
}>;


export type VIPEditDeleteVIPMutation = { __typename?: 'Mutation', deleteVip: boolean };

export type VIPEditGetEventVipsForEventByIdQueryVariables = Exact<{
  payload: EventVipsPayload;
}>;


export type VIPEditGetEventVipsForEventByIdQuery = { __typename?: 'Query', eventVips: Array<{ __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null }> };

export type ProductUniversalProductSummaryFragment = { __typename?: 'UniversalProduct', id: string, title: string, description?: string | null, url: string, storeName: string, salePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, listPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, rating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, photos: Array<{ __typename?: 'PhotoSummary', url: string }> };

export type ProductExternalSummaryFragment = { __typename?: 'ProductExternal', id: string, title: string, description?: string | null, photos: Array<{ __typename?: 'PhotoSummary', url: string }>, rating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, sellers: Array<{ __typename?: 'ProductExternalSeller', id: string, name: string, url: string, fullPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, salePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null }> };

export type ProductExternalOfferSummaryFragment = { __typename?: 'ProductExternalOffer', id: string, productId: string, productTitle: string, sellerName: string, sellerUrl?: string | null, productThumbnail: { __typename?: 'PhotoSummary', url: string }, productRating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, sellerFullPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, sellerSalePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null };

export type ProductCatalogItemSearchSummaryFragment = { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo', id: string, displayInfoId: string, pdpSectionType?: PDPSectionType | null }>, tilePresentation: { __typename?: 'ProductCatalogItemTilePresentation', presentationType: ProductCatalogItemTilePresentationType, title: string, shortDescription?: string | null, longDescription?: string | null, isFullPrice: boolean, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, priceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null, fullPriceRange?: { __typename?: 'ProductMonetaryValueRange', isSinglePrice: boolean, upperPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lowerPrice: { __typename?: 'MonetaryValue', floatingPointDecimalString: string, valueInMinorUnits: number, currency?: { __typename?: 'Currency', code: string, places: number } | null } } | null }, group?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchColor?: { __typename?: 'Color', hex: string, isLight: boolean } | null }> } | null, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null }> } | null, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean }, rating?: { __typename?: 'RatingProduct', id: string, stats: { __typename?: 'RatingStats', id: string, averageRating: number, totalReviewCount: number } } | null };

export type ProductCatalogCategorySummaryFragment = { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductCatalogCategoryDetailsFragment = { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductCatalogCategoryTreeRootFragment = { __typename?: 'ProductCatalogCategory', heroText?: string | null, id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', heroText?: string | null, id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductCatalogDepartmentFragment = { __typename?: 'ProductCatalogCategory', heroText?: string | null, id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductCatalogCategoryFragment = { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductCatalogSubcategoryFragment = { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null };

export type ProductTileViewDimensionFragment = { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType }, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }> };

export type ProductCatalogItemSummaryFragment = { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, parentCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string }>, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, groupTileViewDimension?: { __typename?: 'ProductCatalogItemGroup', tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType }, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }> } | null } | null };

export type ProductCatalogItemFragment = { __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean } };

export type ProductCatalogItemDimensionsFragment = { __typename?: 'ProductCatalogItem', groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }>, group?: { __typename?: 'ProductCatalogItemGroup', id: string, tileViewDimension?: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, groupDimension: { __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, swatchType: GroupDimensionSwatchType }, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }> } | null, groupDimensions: Array<{ __typename?: 'ProductCatalogItemGroupDimension', id: string, title: string, options: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }> }>, items: Array<{ __typename?: 'ProductCatalogItem', id: string, title: string, itemType: string, whyWeLoveIt?: string | null, shortDescription?: string | null, longDescription?: string | null, productUrl?: string | null, isFullPrice: boolean, tags: Array<string>, groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption', id: string, displayString: string, swatchType: GroupDimensionSwatchType, swatchUrl?: string | null, swatchColor?: { __typename?: 'Color', hex: string, rgba: Array<number>, isLight: boolean } | null }>, brand?: { __typename?: 'ProductCatalogBrand', id: string, name: string, publicUrlPath: string } | null, retailer?: { __typename?: 'ProductCatalogRetailer', name: string } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, subCategories: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }>, curationData?: { __typename?: 'ProductCatalogCuration', id: string, description?: string | null } | null }>, price?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo', storefrontStatus: ProductCatalogStorefrontStatus, canAddToCart: boolean, canAddToRegistry: boolean } }> } | null };

export type ProductCategoryBreadcrumbsFragment = { __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, lineage: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string }> };

export type BlogArticleFragment = { __typename?: 'BlogArticle', title: string, eyebrow?: string | null, description?: string | null, url: string, imageUrl?: string | null };

export type CatalogCategoryChildrenSummaryFragment = { __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string };

export type ProductCatalogSearchPageInfoFragment = { __typename?: 'ProductCatalogSearchPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any, endCursor: any, totalCount: number };

export type CollectionFragment = { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } };

export type CollectionWithMetatagsFragment = { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } };

export type CollectionWithMetatagsPaginatedFragment = { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } };

export type SyntheticCollectionWithMetatagsPaginatedFragment = { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', cursor: string, node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null, collection?: { __typename?: 'Collection', name: string, id: string } | null } }> } };

export type SyntheticCollectionWithMetatagsFragment = { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } };

export type CollectionSlimFragment = { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } };

export type ColorFragment = { __typename?: 'Color', hex: string, isLight: boolean };

export type ColorSetFragment = { __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } };

export type DateFragment = { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number };

export type TimezoneDateFragment = { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string };

export type RegistryCurrencyCodesFragment = { __typename?: 'RegistryCurrency', id: string, displayName: string, code: string, rank?: number | null };

export type EventRegistryCurrencyFragment = { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null };

export type CustomThemeFragment = { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null };

export type DesignBucketFragment = { __typename?: 'DesignBucket', id: string, bucketId: string, display: string, fonts: Array<{ __typename?: 'Font', id: string }>, themes: Array<{ __typename?: 'Theme', id: string }> };

export type DesignLayoutFragment = { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string };

export type DesignPreferenceColorFragment = { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } };

export type DesignPreferenceBooleanFragment = { __typename?: 'DesignPreferenceBoolean', id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean };

export type DesignPreferenceRangeFragment = { __typename?: 'DesignPreferenceRange', id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number, supportsCustomization: boolean };

export type DonationFundInfoFragmentFragment = { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, donationFundInfo: { __typename?: 'DonationFundInfo', defaultPlatform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null } | null, defaultSuggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number } | null, platforms: Array<{ __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, username?: string | null, link?: string | null }>, items: Array<{ __typename?: 'DonationFund', id: string, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum } | null }> } } };

export type RegistryMonetaryValueFragment = { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number };

export type EventPayoutAccountFragment = { __typename?: 'EventData', id: string, payoutAccount?: { __typename?: 'RegistryPayoutAccount', status: string, statusDetails?: string | null, onboardingUrl?: string | null, serviceDashboardUrl?: string | null, externalAccountLast4?: string | null, balance?: { __typename?: 'RegistryPayoutAccountBalance', availablePending: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, available: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, withdrawnPending: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, withdrawn: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, received: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number } } | null, withdrawals: Array<{ __typename?: 'RegistryPayoutAccountWithdrawal', id: string, status: string, totalValue: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, createdAt: { __typename?: 'Date', timestamp: any } }> } | null };

export type EventInfoFragmentFragment = { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null };

export type EventInfoSansDateFragment = { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, location?: string | null, greeting?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null } | null };

export type EventMatchFragment = { __typename?: 'EventMatch', id: string, vendorState?: VendorState | null, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }> };

export type EventPageFragment = { __typename?: 'EventPage', id: string, type: EventPageType, pageSlug: string, pageTitle: string, disabled: boolean, visibility: EventPageVisibility, isPageContainer: boolean, subTitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } } | { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, mobilePhoto?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null };

export type EventQandaFragment = { __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string };

export type EventScheduleFragment = { __typename?: 'EventSchedule', id: string, description?: string | null, dressCode?: string | null, isMain: boolean, isPublic: boolean, location?: string | null, name: string, placeId?: string | null, showMap: boolean, timezone?: string | null, unplugged: boolean, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', provider: VirtualEventProvider, linkText: string, isLinkValid: boolean, isPasswordDetected: boolean, passwordText?: string | null, passwordUrlEmbed?: string | null, streamId?: string | null, urlLinkText?: string | null, urlApp?: string | null, urlBrowser?: string | null } | null };

export type FormattedEventScheduleFragment = { __typename?: 'FormattedSchedule', date: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string }, items: Array<{ __typename?: 'EventSchedule', id: string, description?: string | null, dressCode?: string | null, isMain: boolean, isPublic: boolean, location?: string | null, name: string, placeId?: string | null, showMap: boolean, timezone?: string | null, unplugged: boolean, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', provider: VirtualEventProvider, linkText: string, isLinkValid: boolean, isPasswordDetected: boolean, passwordText?: string | null, passwordUrlEmbed?: string | null, streamId?: string | null, urlLinkText?: string | null, urlApp?: string | null, urlBrowser?: string | null } | null }> };

export type EventScheduleItemStreamFragment = { __typename?: 'EventSchedule', id: string, startTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, milliseconds: number, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', linkText: string, urlLinkText?: string | null, provider: VirtualEventProvider, urlBrowser?: string | null, isLinkValid: boolean } | null };

export type EventSessionCtaGuestSiteFragment = { __typename?: 'EventSessionCTA', rsvpIsEnabled: boolean, rsvpIsCompleted: boolean, scheduleHasInviteOnlyItems: boolean, label: string, requiresPassword: boolean, rsvpAttendanceStatus: EventRSVPAttendanceStatus };

export type EventSessionGuestSiteFragment = { __typename?: 'EventSession', id: string, hasUnlocked: boolean, hasIdentity: boolean, person?: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, avatarName?: string | null } | null };

export type EventShowcaseVendorFragment = { __typename?: 'Vendor', id: string, name: string, type: Array<{ __typename?: 'VendorType', id: string, display: string }>, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type EventSuggestionFragment = { __typename?: 'EventSuggestion', id: string, identifier: string, stateJSON?: any | null, createdAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, offeredAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null };

type EventTravelShared_EventTravelBookingType_Fragment = { __typename?: 'EventTravelBookingType', id: string, type: TravelType, name: string };

type EventTravelShared_EventTravelList_Fragment = { __typename?: 'EventTravelList', id: string, type: TravelType, name: string };

type EventTravelShared_EventTravelNote_Fragment = { __typename?: 'EventTravelNote', id: string, type: TravelType, name: string };

type EventTravelShared_Ferry_Fragment = { __typename?: 'Ferry', id: string, type: TravelType, name: string };

type EventTravelShared_Flight_Fragment = { __typename?: 'Flight', id: string, type: TravelType, name: string };

type EventTravelShared_Hotel_Fragment = { __typename?: 'Hotel', id: string, type: TravelType, name: string };

type EventTravelShared_RentalCar_Fragment = { __typename?: 'RentalCar', id: string, type: TravelType, name: string };

type EventTravelShared_RentalHome_Fragment = { __typename?: 'RentalHome', id: string, type: TravelType, name: string };

type EventTravelShared_Shuttle_Fragment = { __typename?: 'Shuttle', id: string, type: TravelType, name: string };

type EventTravelShared_Taxi_Fragment = { __typename?: 'Taxi', id: string, type: TravelType, name: string };

type EventTravelShared_Tent_Fragment = { __typename?: 'Tent', id: string, type: TravelType, name: string };

type EventTravelShared_Train_Fragment = { __typename?: 'Train', id: string, type: TravelType, name: string };

export type EventTravelSharedFragment = EventTravelShared_EventTravelBookingType_Fragment | EventTravelShared_EventTravelList_Fragment | EventTravelShared_EventTravelNote_Fragment | EventTravelShared_Ferry_Fragment | EventTravelShared_Flight_Fragment | EventTravelShared_Hotel_Fragment | EventTravelShared_RentalCar_Fragment | EventTravelShared_RentalHome_Fragment | EventTravelShared_Shuttle_Fragment | EventTravelShared_Taxi_Fragment | EventTravelShared_Tent_Fragment | EventTravelShared_Train_Fragment;

export type EventTravelBookingTypeFragment = { __typename?: 'EventTravelBookingType', address?: string | null, bookingType?: string | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null, id: string, type: TravelType, name: string, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null };

export type EventTravelNoteFragment = { __typename?: 'EventTravelNote', notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type EventTravelListItemFragment = { __typename?: 'EventTravelListItem', id: string, title?: string | null, url?: string | null };

export type EventTravelListFragment = { __typename?: 'EventTravelList', id: string, type: TravelType, name: string, items: Array<{ __typename?: 'EventTravelListItem', id: string, title?: string | null, url?: string | null }> };

export type FlightFragment = { __typename?: 'Flight', url?: string | null, code?: string | null, notes?: string | null, id: string, type: TravelType, name: string };

export type RentalCarFragment = { __typename?: 'RentalCar', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type TaxiFragment = { __typename?: 'Taxi', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type TrainFragment = { __typename?: 'Train', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type FerryFragment = { __typename?: 'Ferry', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type ShuttleItemFragment = { __typename?: 'ShuttleItem', id: string, note?: string | null, timezone?: string | null, url?: string | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null };

export type ShuttleFragment = { __typename?: 'Shuttle', id: string, type: TravelType, name: string, notes?: string | null, items: Array<{ __typename?: 'ShuttleItem', id: string, note?: string | null, timezone?: string | null, url?: string | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null }> };

export type HotelFragment = { __typename?: 'Hotel', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type TentFragment = { __typename?: 'Tent', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type RentalHomeFragment = { __typename?: 'RentalHome', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_EventTravelBookingType_Fragment = { __typename?: 'EventTravelBookingType', address?: string | null, bookingType?: string | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null, id: string, type: TravelType, name: string, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null };

type EventTravel_EventTravelList_Fragment = { __typename?: 'EventTravelList', id: string, type: TravelType, name: string, items: Array<{ __typename?: 'EventTravelListItem', id: string, title?: string | null, url?: string | null }> };

type EventTravel_EventTravelNote_Fragment = { __typename?: 'EventTravelNote', notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Ferry_Fragment = { __typename?: 'Ferry', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Flight_Fragment = { __typename?: 'Flight', url?: string | null, code?: string | null, notes?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Hotel_Fragment = { __typename?: 'Hotel', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_RentalCar_Fragment = { __typename?: 'RentalCar', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_RentalHome_Fragment = { __typename?: 'RentalHome', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Shuttle_Fragment = { __typename?: 'Shuttle', id: string, type: TravelType, name: string, notes?: string | null, items: Array<{ __typename?: 'ShuttleItem', id: string, note?: string | null, timezone?: string | null, url?: string | null, startTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null, endTime?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number, hostTimeString: string, hostDateString: string } | null }> };

type EventTravel_Taxi_Fragment = { __typename?: 'Taxi', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Tent_Fragment = { __typename?: 'Tent', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

type EventTravel_Train_Fragment = { __typename?: 'Train', address?: string | null, telephone?: string | null, notes?: string | null, url?: string | null, id: string, type: TravelType, name: string };

export type EventTravelFragment = EventTravel_EventTravelBookingType_Fragment | EventTravel_EventTravelList_Fragment | EventTravel_EventTravelNote_Fragment | EventTravel_Ferry_Fragment | EventTravel_Flight_Fragment | EventTravel_Hotel_Fragment | EventTravel_RentalCar_Fragment | EventTravel_RentalHome_Fragment | EventTravel_Shuttle_Fragment | EventTravel_Taxi_Fragment | EventTravel_Tent_Fragment | EventTravel_Train_Fragment;

export type EventFragmentCommonFragment = { __typename?: 'Event', id: string, firebaseId: string, website: string, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null };

export type EventFragmentFragment = { __typename?: 'Event', id: string, firebaseId: string, website: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null };

export type EventFragmentForAdminFragment = { __typename?: 'Event', id: string, firebaseId: string, website: string, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null };

export type ActiveEventUserFragment = { __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, superAdmin: boolean, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null }, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string } | null };

export type EventUserForEventsListFragment = { __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, activeSession: { __typename?: 'EventSession', id: string, eventCTA: { __typename?: 'EventSessionCTA', rsvpAttendanceStatus: EventRSVPAttendanceStatus } }, pages: Array<{ __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility, photo?: { __typename?: 'Photo', id: string, url: string } | null }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, style: { __typename?: 'EventStyle', id: string, primaryColorV0918: { __typename?: 'Color', hex: string } }, info: { __typename?: 'EventInfo', eventType: EventType, timezone?: string | null, eventPassword?: string | null, id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, location?: string | null, greeting?: string | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null } | null } | null };

export type EventDesignFragment = { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> };

export type EventDesignPreferenceColorFragment = { __typename?: 'EventDesignPreferenceColor', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } };

export type EventDesignPreferenceBooleanFragment = { __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean };

export type EventDesignPreferenceRangeFragment = { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number };

export type EventDesignPreferenceColorPointerFragment = { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null };

export type FontFragment = { __typename?: 'Font', id: string, display: string, typeface: Typeface, textTransform: FontWeight, fontSize: number, fontFamily: string, fontWeight: number, firebaseFontKey: string, designBuckets: Array<{ __typename?: 'DesignBucket', display: string, id: string, bucketId: string }> };

export type LocationFragment = { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null };

export type MatchFragment = { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type MatchWithVendorCollectionsFragment = { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }>, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type MatchForEventFragment = { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, matchForEvent?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type PersonFragment = { __typename?: 'Person', id: string, personIdTag: string, firstName?: string | null, lastName?: string | null, email?: string | null, hasEmail: boolean, phoneDisplay?: string | null, avatarName?: string | null, household?: { __typename?: 'Household', id: string } | null };

export type PhotoLayoutV2Fragment = { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string };

type PhotoV2WithoutBlurHash_DefaultPagePhoto_Fragment = { __typename?: 'DefaultPagePhoto', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'DefaultPagePhotoLayout', alignX: string, alignY: string } };

type PhotoV2WithoutBlurHash_Photo_Fragment = { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null };

export type PhotoV2WithoutBlurHashFragment = PhotoV2WithoutBlurHash_DefaultPagePhoto_Fragment | PhotoV2WithoutBlurHash_Photo_Fragment;

export type PhotoLayoutFragment = { __typename?: 'PhotoLayout', alignX: string, alignY: string };

export type PhotoTransformFragment = { __typename?: 'PhotoTransform', x?: number | null, y?: number | null };

export type PhotoFragment = { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null };

export type LikedPhotoFragment = { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null };

export type PhotoWithMetatagsFragment = { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> };

export type PhotoWithMetatagsVendorCollectionsFragment = { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }>, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> };

export type PhotoWithoutBlurHashFragment = { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null };

export type PrintProviderFragment = { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null };

export type PrintProviderThemeFragment = { __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } };

export type RegistryPayoutAccountFragment = { __typename?: 'RegistryPayoutAccount', status: string, statusDetails?: string | null, onboardingUrl?: string | null };

export type RegistryErrorResultFragment = { __typename?: 'RegistryErrorResult', error: { __typename?: 'RegistryErrorPayload', code: string, nativeMessage: string } };

export type LineItemFragment = { __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } };

export type RegistryFulfillmentShipmentTrackingInformationFragment = { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null };

export type RegistryFulfillmentShipmentFragment = { __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null };

export type RegistryFulfillmentFragment = { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null };

export type RegistryOrderRefundFragment = { __typename?: 'RegistryOrderRefund', refundStatus: string, items: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, taxes: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, shippingAndHandling: Array<{ __typename?: 'RegistryOrderRefundItem', title: string, currencyCode: string, lineValueInMinorUnits: number }>, totalValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } };

export type RegistryOrderFragment = { __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null };

type SalesOrderLine_SalesOrderCompensationLine_Fragment = { __typename: 'SalesOrderCompensationLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

type SalesOrderLine_SalesOrderChargeLine_Fragment = { __typename: 'SalesOrderChargeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

type SalesOrderLine_SalesOrderPostPurchaseFeeLine_Fragment = { __typename: 'SalesOrderPostPurchaseFeeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

type SalesOrderLine_SalesOrderShippingAndHandlingLine_Fragment = { __typename: 'SalesOrderShippingAndHandlingLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

type SalesOrderLine_SalesOrderItemLine_Fragment = { __typename: 'SalesOrderItemLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

type SalesOrderLine_SalesOrderTaxLine_Fragment = { __typename: 'SalesOrderTaxLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> };

export type SalesOrderLineFragment = SalesOrderLine_SalesOrderCompensationLine_Fragment | SalesOrderLine_SalesOrderChargeLine_Fragment | SalesOrderLine_SalesOrderPostPurchaseFeeLine_Fragment | SalesOrderLine_SalesOrderShippingAndHandlingLine_Fragment | SalesOrderLine_SalesOrderItemLine_Fragment | SalesOrderLine_SalesOrderTaxLine_Fragment;

export type CheckoutMechanismTypeFragment = { __typename?: 'CheckoutMechanism', type: string, hideValueProps: boolean, checkoutFailureCode?: string | null, checkoutWarningCodes: Array<string> };

export type RegistryItemFragment = { __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null };

export type RegistryFragment = { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null };

export type GuestSiteProductDataFragment = { __typename?: 'RegistryItemProductData', title: string, url?: string | null, registryItem: { __typename?: 'RegistryItem', id: string }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> };

export type GuestSiteRegistryItemFragment = { __typename?: 'RegistryItem', id: string, fpIndex: number, productData: { __typename?: 'RegistryItemProductData', title: string, url?: string | null, registryItem: { __typename?: 'RegistryItem', id: string }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } };

export type GuestSiteRegistryFragment = { __typename?: 'Registry', id: string, wantSync?: boolean | null, hasItems: boolean, name?: string | null, url?: string | null, imageUrl?: string | null, items?: Array<{ __typename?: 'RegistryItem', id: string, fpIndex: number, productData: { __typename?: 'RegistryItemProductData', title: string, url?: string | null, registryItem: { __typename?: 'RegistryItem', id: string }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }> | null };

export type DonationFundPlatformFragment = { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null };

export type DonationFundDonationFragment = { __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } };

export type MonetaryValueFragment = { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null };

export type DonationFundFragment = { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } };

export type DonationFundSkipDonationsFragment = { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null };

export type CalculateRegistryPurchaseInfoFragmentFragment = { __typename?: 'CalculateRegistryPurchaseInfo', checkoutWarningCodes: Array<string>, shippingAndHandling: Array<{ __typename: 'SalesOrderShippingAndHandlingLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, orderCharges: Array<{ __typename: 'SalesOrderChargeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, postPurchaseFees: Array<{ __typename: 'SalesOrderPostPurchaseFeeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, compensation: Array<{ __typename: 'SalesOrderCompensationLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, shippingAndHandlingTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } };

export type JoyCreditStatusFragment = { __typename?: 'RegistryJoyCredit', active: boolean, code?: string | null, amount?: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMinorUnits: number } | null };

export type RegistryStoreFragment = { __typename?: 'RegistryStore', id: string, name: string, sectionName: string, shortDescription: string, longDescription: string, createRegistryUrl: string, domain: string, hostname: string, connectAction: RegistryStoreConnectAction, allowCreateBeforeConnect: boolean, onlyForEventTypes?: Array<EventType> | null, isRecommended: boolean, logos: Array<{ __typename?: 'Image', url: string, mimeType: string }>, logosCompact: Array<{ __typename?: 'Image', url: string, mimeType: string }>, valueProps: Array<{ __typename?: 'RegistryStoreValueProposition', text: string, image: { __typename?: 'Image', url: string, mimeType: string } }> };

export type RequestForProposalFragment = { __typename?: 'RequestForProposal', id: string, message: string, locked: boolean, name: string, budget?: number | null, sentByUser: { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null }> }, eventDate?: { __typename?: 'Date', date: string, time: string } | null, requestSentAt: { __typename?: 'Date', date: string, time: string }, collection?: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } | null, venue?: { __typename?: 'Vendor', id: string, name: string, handle?: string | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, vendorUserByUserId?: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type RegistryShippingAddressFragmentFragment = { __typename?: 'Event', id: string, registry: { __typename?: 'EventData', id: string, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null, currency?: { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null } | null } };

export type ShippingAddressFragment = { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null };

export type TestimonyFragment = { __typename?: 'Testimony', id: string, content: string, reviewer?: string | null, match?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null };

export type ThemeFragment = { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> };

export type CharmThemeFragment = { __typename?: 'Theme', id: string, name: string, themeId: string, thumbnailUrl: string, supportsPrints: boolean, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, supportsCustomization: boolean } | null } | null, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }> };

export type ThemeColorSchemeFragment = { __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> };

export type NamePartsFragment = { __typename?: 'User', firstName?: string | null, lastName?: string | null };

export type BabyRegistryUserFragment = { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null }>, vendorUsers: Array<{ __typename?: 'VendorUser', id: string, displayFirstName?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, handle?: string | null } }> };

export type UserFragment = { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null }> };

export type UserForMePageFragment = { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, aliases: Array<{ __typename?: 'UserAlias', id: string, auth0Id: string }>, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, activeSession: { __typename?: 'EventSession', id: string, eventCTA: { __typename?: 'EventSessionCTA', rsvpAttendanceStatus: EventRSVPAttendanceStatus } }, pages: Array<{ __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility, photo?: { __typename?: 'Photo', id: string, url: string } | null }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, style: { __typename?: 'EventStyle', id: string, primaryColorV0918: { __typename?: 'Color', hex: string } }, info: { __typename?: 'EventInfo', eventType: EventType, timezone?: string | null, eventPassword?: string | null, id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, location?: string | null, greeting?: string | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null } | null } | null }>, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, vendorUsers: Array<{ __typename?: 'VendorUser', id: string, displayFirstName?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, handle?: string | null } }> };

export type VendorFragment = { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null };

export type VendorSlimFragment = { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null };

export type VendorSlimEventMatchFragment = { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, matchForEvent?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null };

export type VendorTypeFragment = { __typename?: 'VendorType', id: string, display: string, type: VendorTypeEnum };

export type VendorUserFragment = { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type VideoFragment = { __typename?: 'Video', id: string, url: string, title?: string | null };

export type VipFragment = { __typename?: 'Vip', id: string, title: string, alias?: string | null, description?: string | null, photoUrl?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null };

export type VirtualEventLinkParseResultFragment = { __typename?: 'VirtualEventLinkParseResult', provider: VirtualEventProvider, linkText: string, isLinkValid: boolean, isPasswordDetected: boolean, passwordText?: string | null, passwordUrlEmbed?: string | null, streamId?: string | null, urlLinkText?: string | null, urlApp?: string | null, urlBrowser?: string | null };

export type WebsiteLayoutAlohaPreferencesFragment = { __typename?: 'WebsiteLayoutAlohaPreferences', alohaColorPreference?: { __typename?: 'EventDesignPreferenceColor', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null };

export type WebsiteLayoutBrannanPreferencesFragment = { __typename?: 'WebsiteLayoutBrannanPreferences', brannanTextColorPreference?: { __typename?: 'EventDesignPreferenceColor', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanColorPreference?: { __typename?: 'EventDesignPreferenceColor', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number } | null };

export type SetRegistryAddressMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload?: InputMaybe<ShippingAddressInput>;
}>;


export type SetRegistryAddressMutation = { __typename?: 'Mutation', setRegistryAddress: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, city: string, state: string, phone?: string | null, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean } };

export type OfferEventSuggestionsMutationVariables = Exact<{
  eventId: Scalars['ID'];
  identifiers: Array<Scalars['String']> | Scalars['String'];
}>;


export type OfferEventSuggestionsMutation = { __typename?: 'Mutation', offerEventSuggestions: Array<{ __typename?: 'EventSuggestion', id: string, identifier: string, stateJSON?: any | null, createdAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, offeredAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }> };

export type UpdateEventSuggestionMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateEventSuggestionPayload;
}>;


export type UpdateEventSuggestionMutation = { __typename?: 'Mutation', updateEventSuggestion: { __typename?: 'EventSuggestion', id: string, identifier: string, stateJSON?: any | null, createdAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, offeredAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null } };

export type CreateRegistryItemFromCatalogItemMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryItemFromCatalogItemPayload;
}>;


export type CreateRegistryItemFromCatalogItemMutation = { __typename?: 'Mutation', createRegistryItemFromCatalogItem: { __typename?: 'RegistryItemResult', model?: { __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null } | null, status: { __typename?: 'ResultStatus', id: string } } };

export type CreateRegistryItemsFromCatalogCategoryMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryItemsFromCatalogCategoryPayload;
}>;


export type CreateRegistryItemsFromCatalogCategoryMutation = { __typename?: 'Mutation', createRegistryItemsFromCatalogCategory: { __typename?: 'RegistryItemsResult', models: Array<{ __typename?: 'RegistryItem', id: string }> } };

export type CreateMatchMutationVariables = Exact<{
  payload: CreateMatchPayload;
}>;


export type CreateMatchMutation = { __typename?: 'Mutation', createMatch: { __typename?: 'Match', id: string } };

export type SetRegistryCurrencyMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: EventCurrencyInput;
}>;


export type SetRegistryCurrencyMutation = { __typename?: 'Mutation', setRegistryCurrency: { __typename?: 'RegistryCurrency', id: string, code: string, displayName: string, rank?: number | null, isDefault: boolean } };

export type CreateDonationFundDonationMutationVariables = Exact<{
  fundId: Scalars['ID'];
  amountMonetaryMinorValue: Scalars['Int'];
  name: Scalars['String'];
  email: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type CreateDonationFundDonationMutation = { __typename?: 'Mutation', createDonationFundDonation: { __typename?: 'DonationFund', id: string } };

export type CreateDonationFundDonationWithResultMutationVariables = Exact<{
  payload: CreateDonationFundDonationInput;
}>;


export type CreateDonationFundDonationWithResultMutation = { __typename?: 'Mutation', createDonationFundDonationWithResult: { __typename?: 'DonationFundResult', alreadyExists: boolean, model?: { __typename?: 'DonationFund', id: string } | null, registryOrder?: { __typename?: 'RegistryOrder', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, id: string } | null } };

export type UpdateDonationFundDonationMutationVariables = Exact<{
  payload: UpdateDonationFundDonationInput;
}>;


export type UpdateDonationFundDonationMutation = { __typename?: 'Mutation', updateDonationFundDonation: { __typename?: 'DonationFundDonation', id: string, platformType?: DonationFundPaymentMethodEnum | null, note?: string | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number } } };

export type CreateNewAdminInviteMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateNewEventAdminInvitePayload;
}>;


export type CreateNewAdminInviteMutation = { __typename?: 'Mutation', createNewEventAdminInvite: { __typename?: 'EventAdminInvite', emailId: string, id: string, name: string, status?: string | null } };

export type ResendEventAdminInviteMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventAdminInviteId: Scalars['String'];
}>;


export type ResendEventAdminInviteMutation = { __typename?: 'Mutation', resendEventAdminInvite: boolean };

export type CancelEventAdminInviteMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventAdminInviteId: Scalars['String'];
}>;


export type CancelEventAdminInviteMutation = { __typename?: 'Mutation', cancelEventAdminInvite: boolean };

export type ResendWithNewEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  toEmail: Scalars['String'];
}>;


export type ResendWithNewEmailMutation = { __typename?: 'Mutation', resendWithNewEmail?: { __typename?: 'Email', id: string, toEmail: string } | null };

export type RemoveEventAdminUserMutationVariables = Exact<{
  eventId: Scalars['ID'];
  auth0Id: Scalars['String'];
}>;


export type RemoveEventAdminUserMutation = { __typename?: 'Mutation', removeEventAdminUser: boolean };

export type TransferEventOwnershipMutationVariables = Exact<{
  eventId: Scalars['ID'];
  auth0Id: Scalars['String'];
}>;


export type TransferEventOwnershipMutation = { __typename?: 'Mutation', transferEventOwnership: boolean };

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: any | null };

export type CreateCollectionOnEventMatchMutationVariables = Exact<{
  payload: CreateCollectionOnEventMatchPayload;
}>;


export type CreateCollectionOnEventMatchMutation = { __typename?: 'Mutation', createCollectionOnEventMatch: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type TrackImpactRadiusMutationVariables = Exact<{
  payload: ImpactRadiusTrackingPayload;
}>;


export type TrackImpactRadiusMutation = { __typename?: 'Mutation', trackImpactRadius?: boolean | null };

export type InstagramSyncMutationVariables = Exact<{
  code: Scalars['String'];
  vendorId: Scalars['String'];
}>;


export type InstagramSyncMutation = { __typename?: 'Mutation', instagramAuthorization: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type JoinEventAsPersonWithPasswordMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: JoinEventAsPersonWithPasswordPayload;
}>;


export type JoinEventAsPersonWithPasswordMutation = { __typename?: 'Mutation', joinEventAsPersonWithPassword: { __typename?: 'EventSession', id: string, hasUnlocked: boolean, sessionId: string } };

export type DeliverRequestForPasswordMutationVariables = Exact<{
  payload: DeliverRequestForPasswordPayload;
}>;


export type DeliverRequestForPasswordMutation = { __typename?: 'Mutation', deliverRequestForPassword?: boolean | null };

export type SendMessageToVendorMutationVariables = Exact<{
  payload: MessageToVendorPayload;
}>;


export type SendMessageToVendorMutation = { __typename?: 'Mutation', sendMessageToVendor: string };

export type SendMessageToMultipleVendorsMutationVariables = Exact<{
  payload: MessageToMultipleVendorsPayload;
}>;


export type SendMessageToMultipleVendorsMutation = { __typename?: 'Mutation', sendMessageToMultipleVendors: string };

export type CreateSingleRegistryItemOrderMutationVariables = Exact<{
  payload?: InputMaybe<CreateSingleRegistryItemOrderInput>;
}>;


export type CreateSingleRegistryItemOrderMutation = { __typename?: 'Mutation', createSingleRegistryItemOrder: { __typename?: 'RegistryOrderResult', alreadyExists: boolean, model?: { __typename?: 'RegistryOrder', id: string } | null } };

export type DeleteRegistryOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRegistryOrderMutation = { __typename?: 'Mutation', deleteRegistryOrder: { __typename?: 'RegistryOrderResult', model?: { __typename?: 'RegistryOrder', id: string } | null } };

export type SendRegistryOrderConfirmationMutationVariables = Exact<{
  payload: SendRegistryOrderConfirmationInput;
}>;


export type SendRegistryOrderConfirmationMutation = { __typename?: 'Mutation', sendRegistryOrderConfirmation: boolean };

export type SendTrackingInfoRequestEmailMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SendTrackingInfoRequestEmailMutation = { __typename?: 'Mutation', sendTrackingInfoRequestEmail: boolean };

export type CreateRegistryPurchaseContextMutationVariables = Exact<{
  payload: CreateRegistryPurchaseContextInput;
}>;


export type CreateRegistryPurchaseContextMutation = { __typename?: 'Mutation', createRegistryPurchaseContext: { __typename?: 'RegistryPurchaseContextEnvelope', checkoutUrl?: string | null, checkoutFailureCode?: string | null, checkoutWarningCodes: Array<string> } };

export type CreateRegistryPaymentIntentMutationVariables = Exact<{
  payload: CreateRegistryPaymentIntentInput;
}>;


export type CreateRegistryPaymentIntentMutation = { __typename?: 'Mutation', createRegistryPaymentIntent: { __typename?: 'RegistryPaymentIntent', status: string, clientSecret?: string | null, returnUrl: string } | { __typename?: 'RegistryPaymentIntentError', checkoutFailureCode?: string | null, checkoutWarningCodes: Array<string> } };

export type AuthenticateRegistryReservationMutationVariables = Exact<{
  payload: AuthenticateRegistryReservationInput;
}>;


export type AuthenticateRegistryReservationMutation = { __typename?: 'Mutation', authenticateRegistryReservation?: { __typename?: 'ActiveRegistrySession', isAuthenticated: boolean } | null };

export type PurchaseRegistryOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PurchaseRegistryOrderMutation = { __typename?: 'Mutation', purchaseRegistryOrder?: { __typename?: 'RegistryOrderResult', alreadyExists: boolean, model?: { __typename?: 'RegistryOrder', id: string } | null } | null };

export type ReserveRegistryOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReserveRegistryOrderMutation = { __typename?: 'Mutation', reserveRegistryOrder?: { __typename?: 'RegistryOrderResult', alreadyExists: boolean, model?: { __typename?: 'RegistryOrder', id: string } | null } | null };

export type AnnotateRegistryOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: AnnotateRegistryOrderPayload;
}>;


export type AnnotateRegistryOrderMutation = { __typename?: 'Mutation', annotateRegistryOrder?: { __typename?: 'RegistryOrderResult', status: { __typename?: 'ResultStatus', id: string, modified?: boolean | null }, model?: { __typename?: 'RegistryOrder', id: string, note?: string | null, annotations: { __typename?: 'RegistryOrderAnnotations', giftNote?: string | null } } | null } | null };

export type CreateRegistryMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryPayload;
}>;


export type CreateRegistryMutation = { __typename?: 'Mutation', createRegistry: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } };

export type CreateRegistryWithResultMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryPayload;
  options?: InputMaybe<CreateRegistryOptions>;
}>;


export type CreateRegistryWithResultMutation = { __typename?: 'Mutation', createRegistryWithResult: { __typename?: 'RegistryResult', model?: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } | null, summary?: { __typename?: 'EventRegistriesSummary', cannotSync: boolean, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null } | null } };

export type UpdateRegistryMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateRegistryPayload;
}>;


export type UpdateRegistryMutation = { __typename?: 'Mutation', updateRegistry: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } };

export type UpdateRegistryWithResultMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateRegistryPayload;
}>;


export type UpdateRegistryWithResultMutation = { __typename?: 'Mutation', updateRegistryWithResult: { __typename?: 'RegistryResult', model?: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } | null, summary?: { __typename?: 'EventRegistriesSummary', cannotSync: boolean, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null } | null } };

export type DeleteRegistryWithResultMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRegistryWithResultMutation = { __typename?: 'Mutation', deleteRegistryWithResult: { __typename?: 'RegistryResult', status: { __typename?: 'ResultStatus', id: string, modified?: boolean | null }, summary?: { __typename?: 'EventRegistriesSummary', cannotSync: boolean, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null } | null } };

export type UpdateRegistryNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateEventPagePayload;
}>;


export type UpdateRegistryNoteMutation = { __typename?: 'Mutation', updateEventPage: { __typename?: 'EventPage', id: string, pageSubTitleV0918?: string | null } };

export type ReorderRegistryMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payloads: Array<ModelReorderPayload> | ModelReorderPayload;
}>;


export type ReorderRegistryMutation = { __typename?: 'Mutation', reorderRegistries: Array<{ __typename?: 'Registry', id: string }> };

export type UpdatePublishRegistryMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateEventPagePayload;
}>;


export type UpdatePublishRegistryMutation = { __typename?: 'Mutation', updateEventPage: { __typename?: 'EventPage', id: string, disabled: boolean } };

export type RemoveRegistryPagePhotoMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type RemoveRegistryPagePhotoMutation = { __typename?: 'Mutation', removeRegistryPagePhoto?: { __typename?: 'RegistryPage', event?: { __typename?: 'Event', id: string } | null } | null };

export type AddRegistryPagePhotoMutationVariables = Exact<{
  eventId: Scalars['ID'];
  assetId: Scalars['String'];
}>;


export type AddRegistryPagePhotoMutation = { __typename?: 'Mutation', addRegistryPagePhoto?: { __typename?: 'RegistryPage', event?: { __typename?: 'Event', id: string } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type AddRegistryItemPhotoMutationVariables = Exact<{
  id: Scalars['ID'];
  assetId: Scalars['String'];
}>;


export type AddRegistryItemPhotoMutation = { __typename?: 'Mutation', addRegistryItemPhoto?: { __typename?: 'RegistryItem', id: string, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type UpdateRegistryItemMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateRegistryItemPayload;
}>;


export type UpdateRegistryItemMutation = { __typename?: 'Mutation', updateRegistryItem: { __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null } };

export type updateRegistryItemQuantityMutationVariables = Exact<{
  id: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type updateRegistryItemQuantityMutation = { __typename?: 'Mutation', updateRegistryItemQuantity: { __typename?: 'RegistryItemResult', model?: { __typename?: 'RegistryItem', id: string } | null } };

export type DeleteRegistryItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRegistryItemMutation = { __typename?: 'Mutation', deleteRegistryItem?: boolean | null };

export type CreateRegistryItemMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryItemPayload;
}>;


export type CreateRegistryItemMutation = { __typename?: 'Mutation', createRegistryItem: { __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null } };

export type CreateDonationFundPlatformMutationVariables = Exact<{
  eventId: Scalars['ID'];
  type: DonationFundPlatformTypeEnum;
  link?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
}>;


export type CreateDonationFundPlatformMutation = { __typename?: 'Mutation', createDonationFundPlatform: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } };

export type UpdateDonationFundPlatformMutationVariables = Exact<{
  id: Scalars['ID'];
  type: DonationFundPlatformTypeEnum;
  name?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDonationFundPlatformMutation = { __typename?: 'Mutation', updateDonationFundPlatform: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } };

export type CreateDonationFundMutationVariables = Exact<{
  eventId: Scalars['ID'];
  fundType: CustomItemDataType;
  goalMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  suggestedDonationMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  platformId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  url: Scalars['String'];
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enforceSuggestedDonationAmount?: InputMaybe<Scalars['Boolean']>;
  donationsAreCapped?: InputMaybe<Scalars['Boolean']>;
  hideFundingGoal?: InputMaybe<Scalars['Boolean']>;
  enableCashOrCheck: Scalars['Boolean'];
  enableJoyCredit: Scalars['Boolean'];
  enableAppPlatform: Scalars['Boolean'];
  metadata?: InputMaybe<RegistryItemMetadata>;
}>;


export type CreateDonationFundMutation = { __typename?: 'Mutation', createDonationFund: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } };

export type UpdateDonationFundMutationVariables = Exact<{
  id: Scalars['ID'];
  fundType?: InputMaybe<CustomItemDataType>;
  goalMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  suggestedDonationMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  platformId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  url: Scalars['String'];
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enforceSuggestedDonationAmount?: InputMaybe<Scalars['Boolean']>;
  donationsAreCapped?: InputMaybe<Scalars['Boolean']>;
  hideFundingGoal?: InputMaybe<Scalars['Boolean']>;
  enableCashOrCheck: Scalars['Boolean'];
  enableAppPlatform: Scalars['Boolean'];
  enableJoyCredit: Scalars['Boolean'];
  mustHave: Scalars['Boolean'];
}>;


export type UpdateDonationFundMutation = { __typename?: 'Mutation', updateDonationFund: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null } };

export type AddDonationFundPhotoMutationVariables = Exact<{
  id: Scalars['ID'];
  assetId: Scalars['String'];
}>;


export type AddDonationFundPhotoMutation = { __typename?: 'Mutation', addDonationFundPhoto: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } };

export type DeleteDonationFundMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDonationFundMutation = { __typename?: 'Mutation', deleteDonationFund: boolean };

export type CreateTransferredRegistryMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: CreateRegistryPayload;
  options?: InputMaybe<TransferRegistryOptions>;
}>;


export type CreateTransferredRegistryMutation = { __typename?: 'Mutation', createTransferredRegistry: { __typename?: 'TransferRegistryResult', completed: boolean, registry?: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } | null, registryEventData: { __typename?: 'EventData', id: string, registries: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null }>, summary?: { __typename?: 'EventRegistriesSummary', lastSyncAt?: { __typename?: 'Date', dateString: string } | null } | null } } };

export type ConvertRegistryToTransferredMutationVariables = Exact<{
  id: Scalars['ID'];
  options?: InputMaybe<TransferRegistryOptions>;
}>;


export type ConvertRegistryToTransferredMutation = { __typename?: 'Mutation', convertRegistryToTransferred: { __typename?: 'TransferRegistryResult', completed: boolean, registry?: { __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null } | null, registryEventData: { __typename?: 'EventData', id: string, registries: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, recommendationStatus: RegistryRecommendationStatus, type: RegistryType, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string }> | null }>, summary?: { __typename?: 'EventRegistriesSummary', lastSyncAt?: { __typename?: 'Date', dateString: string } | null } | null } } };

export type EndRegistrySessionMutationVariables = Exact<{ [key: string]: never; }>;


export type EndRegistrySessionMutation = { __typename?: 'Mutation', endRegistrySession?: boolean | null };

export type UpdateDonationFundHideGiftMutationVariables = Exact<{
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
}>;


export type UpdateDonationFundHideGiftMutation = { __typename?: 'Mutation', updateDonationFund: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null } };

export type UpdateRegistrySettingsDialogDataMutationVariables = Exact<{
  eventId: Scalars['ID'];
  updateEventSettingsPayload: UpdateEventSettingsPayload;
  updateEventInfoPayload: UpdateEventInfoPayload;
  website: Scalars['String'];
}>;


export type UpdateRegistrySettingsDialogDataMutation = { __typename?: 'Mutation', updateEventSettings: { __typename?: 'EventSettings', id: string, hideFromJoySearch: boolean }, updateEventInfo: { __typename?: 'EventInfo', id: string, fianceeFirstName?: string | null, fianceeLastName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, timezone?: string | null, eventDateIsFinalized: boolean, finalizedDate?: { __typename?: 'Date', dateString: string, milliseconds: number, timezone: string, timestamp: any } | null }, updateWebsiteHandle: { __typename?: 'Event', id: string, website: string } };

export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutationVariables = Exact<{
  eventId: Scalars['ID'];
  updateEventSettingsPayload: UpdateEventSettingsPayload;
  updateEventInfoPayload: UpdateEventInfoPayload;
}>;


export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutation = { __typename?: 'Mutation', updateEventSettings: { __typename?: 'EventSettings', id: string, hideFromJoySearch: boolean }, updateEventInfo: { __typename?: 'EventInfo', id: string, fianceeFirstName?: string | null, fianceeLastName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, timezone?: string | null, eventDateIsFinalized: boolean, finalizedDate?: { __typename?: 'Date', dateString: string, milliseconds: number, timezone: string, timestamp: any } | null } };

export type UpdatePageVisibilityMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateEventPagePayload;
}>;


export type UpdatePageVisibilityMutation = { __typename?: 'Mutation', updateEventPage: { __typename?: 'EventPage', id: string, disabled: boolean, private: boolean, visibility: EventPageVisibility } };

export type UpdateEventPasswordMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventPassword?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEventPasswordMutation = { __typename?: 'Mutation', updateEventPassword?: any | null };

export type SetEventPageAssetMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: SetAssetPayload;
}>;


export type SetEventPageAssetMutation = { __typename?: 'Mutation', setEventPageAsset: { __typename?: 'EventPage', id: string, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string } | { __typename?: 'Photo', id: string, url: string } | null } };

export type RemoveEventPagePhotoMutationVariables = Exact<{
  eventPageId: Scalars['ID'];
}>;


export type RemoveEventPagePhotoMutation = { __typename?: 'Mutation', removeEventPagePhoto?: any | null };

export type CreateRegistryPayoutAccountMutationVariables = Exact<{
  eventId: Scalars['ID'];
  returnRoute?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<CreateRegistryPayoutAccountInput>;
}>;


export type CreateRegistryPayoutAccountMutation = { __typename?: 'Mutation', createRegistryPayoutAccount: { __typename?: 'RegistryErrorResult', error: { __typename?: 'RegistryErrorPayload', code: string, nativeMessage: string } } | { __typename?: 'RegistryPayoutAccount', status: string, statusDetails?: string | null, onboardingUrl?: string | null } };

export type WithdrawFromPayoutAccountMutationVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type WithdrawFromPayoutAccountMutation = { __typename?: 'Mutation', withdrawFromPayoutAccount: { __typename?: 'RegistryPayoutWithdrawal', url: string, status: string } };

export type ResetRegistryOrderShippingAddressMutationVariables = Exact<{
  orders: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ResetRegistryOrderShippingAddressMutation = { __typename?: 'Mutation', resetRegistryOrderShippingAddress?: any | null };

export type CancelRegistryOrdersMutationVariables = Exact<{
  orders: Array<RegistryOrderCancelInput> | RegistryOrderCancelInput;
}>;


export type CancelRegistryOrdersMutation = { __typename?: 'Mutation', cancelRegistryOrders?: any | null };

export type SetPhotoAlignmentMutationVariables = Exact<{
  eventId: Scalars['String'];
  photoAlignmentPayload: SetPhotoAlignmentPayload;
  photoPresentationPayload: websiteCreateOrUpdatePagePhotoPresentationPayload;
}>;


export type SetPhotoAlignmentMutation = { __typename?: 'Mutation', setPhotoAlignment?: { __typename?: 'Photo', id: string, assetId: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, websiteCreateOrUpdatePagePhotoPresentation?: { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponse', message: string, success: boolean, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, photo?: { __typename?: 'Photo', id: string, assetId: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null } | { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponseError', id?: string | null, message: string, pageId?: string | null, success: boolean } | null };

export type SetPageContainerPhotoAlignmentMutationVariables = Exact<{
  photoAlignmentPayload: PageContainerUpdatePayload;
}>;


export type SetPageContainerPhotoAlignmentMutation = { __typename?: 'Mutation', updatePageContainer: { __typename?: 'PageContainer', id: string, mainPhotoPresentationLayout?: string | null, mainPhotoV2?: { __typename?: 'DefaultPagePhoto', id: string, height: number, width: number, url: string, assetId: string } | { __typename?: 'Photo', id: string, height: number, width: number, url: string, assetId: string } | null, mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue', x: PhotoXPosition, y: PhotoYPosition } | null, mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo', unit: string, height: number, width: number, x: number, y: number } | null } };

export type SetPresetTemplateAndPublishMutationVariables = Exact<{
  themeAndLayoutPayload: SetThemeAndLayoutPayload;
  fontPayload: SetFontPayload;
  eventDesignId: Scalars['ID'];
}>;


export type SetPresetTemplateAndPublishMutation = { __typename?: 'Mutation', setThemeAndLayout: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, theme: { __typename?: 'Theme', id: string, themeId: string } }, setFont: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, font: { __typename?: 'Font', id: string } }, publishEventDesignDraft: { __typename?: 'EventDesign', id: string } };

export type UpdateTravelSettingsMutationVariables = Exact<{
  payload: UpdateTravelSettingsRequest;
}>;


export type UpdateTravelSettingsMutation = { __typename?: 'Mutation', updateTravelSettings: { __typename?: 'TravelSettings', currencyCode?: TravelCurrencyCode | null, checkInDate?: string | null, checkOutDate?: string | null, datesMatchingReminder?: boolean | null } };

export type UpdateEventDomainMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateEventDomainPayload;
}>;


export type UpdateEventDomainMutation = { __typename?: 'Mutation', updateEventDomain?: { __typename?: 'EventDomain', id: string, domainName: string } | null };

export type UpdateVendorMutationVariables = Exact<{
  payload: UpdateVendor;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type UploadPhotoToCollectionMutationVariables = Exact<{
  containerId: Scalars['String'];
  assetId: Scalars['String'];
  collectionId: Scalars['String'];
  vendorIdsToTag?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UploadPhotoToCollectionMutation = { __typename?: 'Mutation', uploadPhotoToCollection: { __typename?: 'Photo', id: string, url: string, width: number, height: number } };

export type UploadPhotosToCollectionMutationVariables = Exact<{
  containerId: Scalars['String'];
  assetIds: Array<Scalars['String']> | Scalars['String'];
  collectionId: Scalars['String'];
  vendorIdsToTag?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UploadPhotosToCollectionMutation = { __typename?: 'Mutation', uploadPhotosToCollection: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type AddVendorProfilePhotoMutationVariables = Exact<{
  vendorId: Scalars['ID'];
  containerId: Scalars['String'];
  assetId: Scalars['String'];
}>;


export type AddVendorProfilePhotoMutation = { __typename?: 'Mutation', addVendorProfilePhoto: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } };

export type VerifyAccountEmailMutationVariables = Exact<{
  payload?: InputMaybe<VerifyEmailPayload>;
}>;


export type VerifyAccountEmailMutation = { __typename?: 'Mutation', verifyAccountEmail?: any | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  payload: UpdateUserPayload;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null }> } | null };

export type RequestChangePasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestChangePasswordMutation = { __typename?: 'Mutation', changePassword?: any | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: any | null };

export type LeaveEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LeaveEventMutation = { __typename?: 'Mutation', leaveEvent?: any | null };

export type MarkUserForMFAEnrollmentMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkUserForMFAEnrollmentMutation = { __typename?: 'Mutation', markUserForMFAEnrollment?: any | null };

export type ResetUserMfaMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetUserMfaMutation = { __typename?: 'Mutation', resetUserMFA?: any | null };

export type CreateVendorMutationVariables = Exact<{
  payload: CreateVendor;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } };

export type AddTestimonyMutationVariables = Exact<{
  payload: AddTestimonyPayload;
}>;


export type AddTestimonyMutation = { __typename?: 'Mutation', addTestimony: { __typename?: 'Testimony', id: string, content: string, reviewer?: string | null, match?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null } };

export type UpdateTestimonyMutationVariables = Exact<{
  payload: UpdateTestimonyPayload;
}>;


export type UpdateTestimonyMutation = { __typename?: 'Mutation', updateTestimony: { __typename?: 'Testimony', id: string, content: string, reviewer?: string | null, match?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null } };

export type DeleteTestimonyMutationVariables = Exact<{
  testimonyId: Scalars['String'];
}>;


export type DeleteTestimonyMutation = { __typename?: 'Mutation', deleteTestimony: string };

export type CreateVendorUserOnVendorMutationVariables = Exact<{
  payload: CreateVendorUserOnVendor;
}>;


export type CreateVendorUserOnVendorMutation = { __typename?: 'Mutation', createVendorUserOnVendor: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } };

export type UpdateVendorUserMutationVariables = Exact<{
  payload: UpdateVendorUserPayload;
}>;


export type UpdateVendorUserMutation = { __typename?: 'Mutation', updateVendorUser: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } };

export type CreateCollectionOnVendorMutationVariables = Exact<{
  payload: CreateCollectionOnVendorPayload;
}>;


export type CreateCollectionOnVendorMutation = { __typename?: 'Mutation', createCollectionOnVendor: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type MoveCollectionItemsMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  payloads: Array<ModelReorderPayload> | ModelReorderPayload;
}>;


export type MoveCollectionItemsMutation = { __typename?: 'Mutation', moveCollectionItems: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type RemovePhotosFromCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  photoIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemovePhotosFromCollectionMutation = { __typename?: 'Mutation', removePhotosFromCollection: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type RemovePhotoFromCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  photoIds: Array<Scalars['ID']> | Scalars['ID'];
  photoId: Scalars['ID'];
}>;


export type RemovePhotoFromCollectionMutation = { __typename?: 'Mutation', removePhotosFromCollection: { __typename?: 'Collection', isPhotoInCollection: boolean, id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type AddPhotosToCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  photoIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddPhotosToCollectionMutation = { __typename?: 'Mutation', addPhotosToCollection: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type AddPhotoToCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  photoIds: Array<Scalars['ID']> | Scalars['ID'];
  photoId: Scalars['ID'];
}>;


export type AddPhotoToCollectionMutation = { __typename?: 'Mutation', addPhotosToCollection: { __typename?: 'Collection', isPhotoInCollection: boolean, id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type editCollectionInfoMutationVariables = Exact<{
  payload: EditCollectionInfoPayload;
}>;


export type editCollectionInfoMutation = { __typename?: 'Mutation', editCollectionInfo: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type refreshVendorUserClaimTokenMutationVariables = Exact<{
  payload: RefreshVendorUserTokenPayload;
}>;


export type refreshVendorUserClaimTokenMutation = { __typename?: 'Mutation', refreshVendorUserClaimToken: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } };

export type ArchiveCollectionMutationVariables = Exact<{
  payload: ArchiveCollectionPayload;
}>;


export type ArchiveCollectionMutation = { __typename?: 'Mutation', archiveCollection: string };

export type claimVendorUserWithTokenMutationVariables = Exact<{
  payload: ClaimVendorUserWithToken;
}>;


export type claimVendorUserWithTokenMutation = { __typename?: 'Mutation', claimVendorUserWithToken: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } };

export type unlockRequestForProposalMutationVariables = Exact<{
  payload: UnlockRequestForProposalPayload;
  userId: Scalars['String'];
}>;


export type unlockRequestForProposalMutation = { __typename?: 'Mutation', unlockRequestForProposal?: { __typename?: 'RequestForProposal', id: string, message: string, locked: boolean, name: string, budget?: number | null, sentByUser: { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string } | null }> }, eventDate?: { __typename?: 'Date', date: string, time: string } | null, requestSentAt: { __typename?: 'Date', date: string, time: string }, collection?: { __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } | null, venue?: { __typename?: 'Vendor', id: string, name: string, handle?: string | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, vendorUserByUserId?: { __typename?: 'VendorUser', id: string, status?: string | null, claimToken?: string | null, title?: string | null, email?: string | null, phone?: string | null, displayFirstName?: string | null, displayLastName?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null };

export type LikePhotoMutationVariables = Exact<{
  photoId: Scalars['ID'];
}>;


export type LikePhotoMutation = { __typename?: 'Mutation', likePhoto: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } };

export type LikeMultiplePhotosMutationVariables = Exact<{
  photoIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LikeMultiplePhotosMutation = { __typename?: 'Mutation', likeMultiplePhotos: Array<{ __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null }> };

export type UnLikePhotoMutationVariables = Exact<{
  photoId: Scalars['ID'];
}>;


export type UnLikePhotoMutation = { __typename?: 'Mutation', unLikePhoto: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } };

export type ShortlistVendorMutationVariables = Exact<{
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
}>;


export type ShortlistVendorMutation = { __typename?: 'Mutation', saveVendorToShortlist: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, matchForEvent?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } };

export type ShortlistVendorAndCreateEventMutationVariables = Exact<{
  vendorId: Scalars['String'];
}>;


export type ShortlistVendorAndCreateEventMutation = { __typename?: 'Mutation', saveVendorToShortListAndCreateEvent: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } };

export type UnShortlistVendorMutationVariables = Exact<{
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
}>;


export type UnShortlistVendorMutation = { __typename?: 'Mutation', unsaveVendorFromShortlist: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, matchForEvent?: { __typename?: 'Match', id: string, status: MatchStatus, archived: ArchivedStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } };

export type SetThemeAndLayoutMutationVariables = Exact<{
  payload: SetThemeAndLayoutPayload;
}>;


export type SetThemeAndLayoutMutation = { __typename?: 'Mutation', setThemeAndLayout: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, brannanNavigation: BrannanNavigation, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, theme: { __typename?: 'Theme', id: string, themeId: string } } };

export type SetBrannanInnerFrameBorderPreferenceMutationVariables = Exact<{
  payload: DesignPreferenceBooleanInput;
}>;


export type SetBrannanInnerFrameBorderPreferenceMutation = { __typename?: 'Mutation', setBrannanInnerFrameBorder: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean } };

export type SetBrannanBackgroundTransparencyPreferenceMutationVariables = Exact<{
  payload: DesignPreferenceRangeInput;
}>;


export type SetBrannanBackgroundTransparencyPreferenceMutation = { __typename?: 'Mutation', setBrannanBackgroundTransparency: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean } };

export type SetAccentMutationVariables = Exact<{
  payload: SetAccentPayload;
}>;


export type SetAccentMutation = { __typename?: 'Mutation', setAccent: { __typename?: 'EventDesign', id: string, accent?: string | null } };

export type SetCustomCssMutationVariables = Exact<{
  payload: SetCustomCssPayload;
}>;


export type SetCustomCssMutation = { __typename?: 'Mutation', setCustomCss: { __typename?: 'EventDesign', id: string, customCss: string } };

export type SetFontMutationVariables = Exact<{
  payload: SetFontPayload;
}>;


export type SetFontMutation = { __typename?: 'Mutation', setFont: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, font: { __typename?: 'Font', id: string } } };

export type PublishEventDesignDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublishEventDesignDraftMutation = { __typename?: 'Mutation', publishEventDesignDraft: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } };

export type SetHasVisitedDesignPageMutationVariables = Exact<{
  payload: SetHasVisitedDesignPagePayload;
}>;


export type SetHasVisitedDesignPageMutation = { __typename?: 'Mutation', setHasVisitedDesignPage: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null } };

export type SetPresetTemplateMutationVariables = Exact<{
  themeAndLayoutPayload: SetThemeAndLayoutPayload;
  fontPayload: SetFontPayload;
}>;


export type SetPresetTemplateMutation = { __typename?: 'Mutation', setThemeAndLayout: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType }, theme: { __typename?: 'Theme', id: string, themeId: string } }, setFont: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, font: { __typename?: 'Font', id: string } } };

export type AdminDashboardPreviewPanelQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type AdminDashboardPreviewPanelQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, emailIsVerified: boolean } | null, eventByName?: { __typename?: 'Event', id: string, firebaseId: string, firebaseCreateAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null, style: { __typename?: 'EventStyle', id: string, theme: string, layout: Layout, primaryColor: { __typename?: 'Color', rgba: Array<number> } }, suggestion: { __typename?: 'EventSuggestionInfo', items: Array<{ __typename?: 'EventSuggestion', id: string, identifier: string, stateJSON?: any | null, createdAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, offeredAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }> }, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null }, checklist?: { __typename?: 'EventChecklist', id: string } | null } | null };

export type CatalogCurationHeaderFragment = { __typename?: 'ProductCatalogCurationHeader', textColor?: string | null, gradientColor?: string | null, gradient1?: string | null, gradient2?: string | null, title?: string | null, eyebrow?: string | null, description?: string | null, video?: string | null, backgroundImage?: { __typename?: 'Photo', id: string, url: string, blurHash?: string | null } | null, logoImage?: { __typename?: 'Photo', id: string, url: string, blurHash?: string | null } | null };

export type CatalogCurationFieldsFragment = { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, heroText?: string | null, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }> };

export type CatalogCurationsTreeRootQueryVariables = Exact<{
  types?: InputMaybe<Array<CatalogTreeRootInput> | CatalogTreeRootInput>;
  storefront?: InputMaybe<CatalogStorefront>;
}>;


export type CatalogCurationsTreeRootQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, heroText?: string | null, isParentType: boolean, directItemCount: number, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, heroText?: string | null, isParentType: boolean, directItemCount: number, curationData?: { __typename?: 'ProductCatalogCuration', id: string, videoUrl?: string | null, description?: string | null, header?: { __typename?: 'ProductCatalogCurationHeader', id: string, textColor?: string | null, gradientColor?: string | null, gradient1?: string | null, gradient2?: string | null, title?: string | null, eyebrow?: string | null, description?: string | null, video?: string | null, backgroundImage?: { __typename?: 'Photo', id: string, url: string, blurHash?: string | null } | null, logoImage?: { __typename?: 'Photo', id: string, url: string, blurHash?: string | null } | null } | null } | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, publicUrlPath: string, title: string, heroText?: string | null, isParentType: boolean, directItemCount: number, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }> }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }> }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, tileItemImages: Array<{ __typename?: 'Photo', id: string, url: string }> } };

export type CatalogCurationThemeQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CatalogCurationThemeQuery = { __typename?: 'Query', productCatalogCategoryByLocator?: { __typename?: 'ProductCatalogCategory', id: string, curationData?: { __typename?: 'ProductCatalogCuration', id: string, header?: { __typename?: 'ProductCatalogCurationHeader', id: string, textColor?: string | null, gradientColor?: string | null } | null } | null } | null };

export type ProductExternalSearchQueryVariables = Exact<{
  query: ProductExternalSearchQueryInput;
}>;


export type ProductExternalSearchQuery = { __typename?: 'Query', productExternalSearch: { __typename?: 'ProductExternalSearchResult', offers: Array<{ __typename?: 'ProductExternalOffer', id: string, productId: string, productTitle: string, sellerName: string, sellerUrl?: string | null, productThumbnail: { __typename?: 'PhotoSummary', url: string }, productRating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, sellerFullPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, sellerSalePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null }> } };

export type ProductExternalByIdQueryVariables = Exact<{
  productId: Scalars['String'];
}>;


export type ProductExternalByIdQuery = { __typename?: 'Query', productExternalById: { __typename?: 'ProductExternal', id: string, title: string, description?: string | null, photos: Array<{ __typename?: 'PhotoSummary', url: string }>, rating?: { __typename?: 'ProductRating', id: string, averageRating: number, reviewsCount: number } | null, sellers: Array<{ __typename?: 'ProductExternalSeller', id: string, name: string, url: string, fullPrice: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, salePrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null }> } };

export type CatalogCategoryChildrenQueryVariables = Exact<{
  type?: InputMaybe<CatalogTreeRootInput>;
}>;


export type CatalogCategoryChildrenQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, publicUrlPath: string }> }> } };

export type SeoRedirectByLocatorQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type SeoRedirectByLocatorQuery = { __typename?: 'Query', productCatalogCategoryByLocator?: { __typename?: 'ProductCatalogCategory', id: string, seoRedirectPath?: string | null } | null };

export type CoreCatalogCategoryFieldsFragment = { __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type CoreCatalogCategoryFieldsWithChildrenFragment = { __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type ProductCatalogByLocatorQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ProductCatalogByLocatorQuery = { __typename?: 'Query', productCatalogCategoryByLocator?: { __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null } | null };

export type ProductCatalogDepartmentsQueryVariables = Exact<{
  storefront?: InputMaybe<CatalogStorefront>;
  types: Array<CatalogTreeRootInput> | CatalogTreeRootInput;
}>;


export type ProductCatalogDepartmentsQuery = { __typename?: 'Query', productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, children: Array<{ __typename?: 'ProductCatalogCategory', id: string, title: string, heroText?: string | null, publicUrlPath: string, isFeatured?: boolean | null, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null }>, thumbnail?: { __typename?: 'PhotoSummary', url: string } | null, showcase?: { __typename?: 'ProductCatalogCategoryShowcase', title?: string | null, image?: { __typename?: 'Photo', id: string, url: string } | null } | null } };

export type GetCurrencyCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyCodesQuery = { __typename?: 'Query', getRegistryStaticData?: { __typename?: 'RegistryStaticData', currencies?: { __typename?: 'RegistryCurrencyResults', topRanked: Array<{ __typename?: 'RegistryCurrency', id: string, displayName: string, code: string, rank?: number | null }>, ordered: Array<{ __typename?: 'RegistryCurrency', id: string, displayName: string, code: string, rank?: number | null }> } | null } | null };

export type VendorDiscoveryNodeCollectionByUrlQueryVariables = Exact<{
  url: Scalars['String'];
  collectionsPerPage: Scalars['Int'];
  collectionPage: Scalars['Int'];
}>;


export type VendorDiscoveryNodeCollectionByUrlQuery = { __typename?: 'Query', vendorDiscoveryNodeByUrl?: { __typename?: 'VendorDiscoveryNode', id: string, title?: string | null, metaPageTitle?: string | null, description?: string | null, metaPageDescription?: string | null, breadcrumbs?: string | null, urls: Array<string>, canonicalUrl?: string | null, collectionListTitle?: string | null, collectionIds: Array<string>, photo: { __typename?: 'Photo', id: string, url: string }, collectionGroups: Array<{ __typename?: 'VendorCollectionGroup', id: string, title: string, urlSlug: string, photo: { __typename?: 'Photo', id: string, url: string } }>, collectionGroupCollections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }> } | null };

export type DiscoveryNodeListQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoveryNodeListQuery = { __typename?: 'Query', vendorDiscoveryNodes: Array<{ __typename?: 'VendorDiscoveryNode', id: string, title?: string | null, description?: string | null, breadcrumbs?: string | null, urls: Array<string>, canonicalUrl?: string | null, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } }> };

export type AllVendorCollectionPhotosQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type AllVendorCollectionPhotosQuery = { __typename?: 'Query', allVendorCollectionPhotos: { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } } };

export type VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery = { __typename?: 'Query', vendorDiscoveryNodeByUrl?: { __typename?: 'VendorDiscoveryNode', id: string, title?: string | null, description?: string | null, breadcrumbs?: string | null, urls: Array<string>, canonicalUrl?: string | null, photoListTitle?: string | null, photo: { __typename?: 'Photo', id: string, url: string }, collectionGroups: Array<{ __typename?: 'VendorCollectionGroup', id: string, title: string, urlSlug: string, photo: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } }> } | null };

export type VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables = Exact<{
  url: Scalars['String'];
  urlSlug: Scalars['String'];
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery = { __typename?: 'Query', vendorDiscoveryNodeByUrl?: { __typename?: 'VendorDiscoveryNode', id: string, aggregateSyntheticCollectionGroupsCollection: { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', cursor: string, node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null, collection?: { __typename?: 'Collection', name: string, id: string } | null } }> } } } | null };

export type GetEventByNameQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GetEventByNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, eventMatch?: { __typename?: 'EventMatch', id: string, showcase: Array<{ __typename?: 'Match', id: string, testimony?: { __typename?: 'Testimony', id: string, content: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string, vendorUserByUserId?: { __typename?: 'VendorUser', id: string } | null, type: Array<{ __typename?: 'VendorType', id: string, display: string }>, photo?: { __typename?: 'Photo', id: string, url: string } | null } }> } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null } | null };

export type GetEventWithChecklistByNameQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventWithChecklistByNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null } | null };

export type GetEventInfoByNameQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventInfoByNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null } | null };

export type GetEventByNameForDomainQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventByNameForDomainQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, fianceeFirstName?: string | null }, domain?: { __typename?: 'EventDomain', id: string, domainName: string } | null } | null };

export type GetEventByNameForIdeabookQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventByNameForIdeabookQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, eventMatch?: { __typename?: 'EventMatch', id: string, vendorState?: VendorState | null, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }> } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null } | null };

export type CheckCanAccessPageQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  type: EventPageType;
}>;


export type CheckCanAccessPageQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null, activeSession: { __typename?: 'EventSession', id: string, canAccessPage: boolean }, pageInfo?: { __typename?: 'EventPageInfo', id: string, private: boolean, disabled: boolean, page: { __typename?: 'EventPage', id: string, pageTitle: string } } | null } | null };

export type GetEventByEventIdForEventRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEventByEventIdForEventRedirectQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, firebaseId: string, website: string } | null };

export type GetEventForAdminMenuQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventForAdminMenuQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, photo?: { __typename?: 'Photo', id: string, url: string, altTag?: string | null } | null } | null, me?: { __typename?: 'User', id: string, avatar?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type GetEventFeatureFlagsByEventHandleQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventFeatureFlagsByEventHandleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null } | null };

export type GetEventForAdminMenuV2QueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventForAdminMenuV2Query = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null, info: { __typename?: 'EventInfo', eventPassword?: string | null, id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, eventOnboarding?: { __typename?: 'EventOnboarding', shouldShowOnboardingSurvey?: boolean | null } | null, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null, pages: Array<{ __typename?: 'EventPage', visibility: EventPageVisibility, isPageContainer: boolean, pageSlug: string, id: string, type: EventPageType, pageTitle: string, createdAt: { __typename?: 'Date', timestamp: any }, photo?: { __typename?: 'Photo', id: string, url: string } | null }>, photo?: { __typename?: 'Photo', id: string, url: string, altTag?: string | null } | null, recommendation: { __typename?: 'RecommendEvent', registryOnboardingSurvey: { __typename?: 'RecommendRegistryOnboardingSurveyResults', id: string, lastUpdatedAt?: { __typename?: 'Date', dateString: string } | null } }, checklist?: { __typename?: 'EventChecklist', id: string } | null, eventDesign?: { __typename?: 'EventDesign', id: string, font: { __typename?: 'Font', id: string, fontFamily: string }, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null } | null } | null, me?: { __typename?: 'User', id: string, avatar?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type SaveEventProductVerticalsMutationVariables = Exact<{
  eventId: Scalars['ID'];
  payload: UpdateEventProductVerticalsPayload;
}>;


export type SaveEventProductVerticalsMutation = { __typename?: 'Mutation', saveEventProductVerticals: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } };

export type GetEventAdminsAndInviteesQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventAdminsAndInviteesQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, eventUsers: Array<{ __typename?: 'EventUser', id: string, auth0Id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, emailIsVerified: boolean } }> } | null, eventAdminInvites?: Array<{ __typename?: 'EventAdminInvite', emailId: string, id: string, name: string, status?: string | null } | null> | null };

export type GetEventHandleAvailabilityQueryVariables = Exact<{
  eventId: Scalars['ID'];
  websiteHandle: Scalars['String'];
}>;


export type GetEventHandleAvailabilityQuery = { __typename?: 'Query', isWebsiteHandleAvailable: boolean };

export type GetUrlVerificationStatusQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetUrlVerificationStatusQuery = { __typename?: 'Query', verifyUrl?: UrlVerificationStatus | null };

export type FindDefaultThingsToDoPageQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type FindDefaultThingsToDoPageQuery = { __typename?: 'Query', findDefaultThingsToDoPage?: { __typename?: 'PageContainer', id: string, slug: string } | null };

export type LoginEventSessionMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type LoginEventSessionMutation = { __typename?: 'Mutation', loginEventSession?: boolean | null };

export type LogoutEventSessionMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type LogoutEventSessionMutation = { __typename?: 'Mutation', logoutEventSession?: boolean | null };

export type GetEventSessionQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventSessionQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, activeSession: { __typename?: 'EventSession', id: string, hasUnlocked: boolean, hasIdentity: boolean, eventCTA: { __typename?: 'EventSessionCTA', rsvpIsEnabled: boolean, rsvpIsCompleted: boolean, scheduleHasInviteOnlyItems: boolean, label: string, requiresPassword: boolean, rsvpAttendanceStatus: EventRSVPAttendanceStatus }, person?: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, avatarName?: string | null } | null } } | null };

export type GetFeatureSetQueryVariables = Exact<{
  eventName: Scalars['String'];
}>;


export type GetFeatureSetQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, registryPage?: { __typename?: 'EventPageInfo', id: string, disabled: boolean } | null, rsvpPage?: { __typename?: 'EventPageInfo', id: string, disabled: boolean } | null, welcomePage?: { __typename?: 'EventPageInfo', id: string, disabled: boolean } | null, pages: Array<{ __typename?: 'EventPage', id: string, pageSlug: string, type: EventPageType, visibility: EventPageVisibility }> } | null };

export type FilestackQueryVariables = Exact<{ [key: string]: never; }>;


export type FilestackQuery = { __typename?: 'Query', filestack: { __typename?: 'Filestack', apiKey: string, policy: string, signature: string } };

export type GetFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFontsQuery = { __typename?: 'Query', fonts: Array<{ __typename?: 'Font', id: string, display: string, typeface: Typeface, textTransform: FontWeight, fontSize: number, fontFamily: string, fontWeight: number, firebaseFontKey: string, designBuckets: Array<{ __typename?: 'DesignBucket', display: string, id: string, bucketId: string }> }> };

export type GetFontPacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFontPacksQuery = { __typename?: 'Query', fontPacks?: Array<{ __typename?: 'FontPack', id: string, name: string, configuration?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, typeface: Typeface, firebaseFontKey: string } | null }> | null }> | null };

export type GetFontPackByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetFontPackByNameQuery = { __typename?: 'Query', fontPackByName?: { __typename?: 'FontPack', id: string, name: string, configuration?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, typeface: Typeface, firebaseFontKey: string } | null }> | null } | null };

export type ApplyFontPackMutationVariables = Exact<{
  eventDesignId: Scalars['ID'];
  fontPackId: Scalars['ID'];
}>;


export type ApplyFontPackMutation = { __typename?: 'Mutation', applyFontPack?: Array<{ __typename?: 'FontPackConfiguration', id: string }> | null };

export type EditFontConfigurationMutationVariables = Exact<{
  eventDesignId: Scalars['ID'];
  input: SetConfigurationInput;
}>;


export type EditFontConfigurationMutation = { __typename?: 'Mutation', editFontConfiguration?: { __typename?: 'FontPackConfiguration', id: string } | null };

export type ResetFontConfigurationMutationVariables = Exact<{
  eventDesignId: Scalars['ID'];
}>;


export type ResetFontConfigurationMutation = { __typename?: 'Mutation', resetFontConfiguration?: Array<{ __typename?: 'FontPackConfiguration', id: string, size?: number | null, sizePercent?: number | null, category: Category, font?: { __typename?: 'Font', id: string, fontWeight: number, fontSize: number, fontFamily: string, firebaseFontKey: string } | null }> | null };

export type SearchAccommodationPropertiesQueryVariables = Exact<{
  payload: AccommodationContentSearchInput;
}>;


export type SearchAccommodationPropertiesQuery = { __typename?: 'Query', searchAccommodationProperties: { __typename?: 'AccommodationContentSearchResult', properties: Array<{ __typename?: 'AccommodationCatalogProperty', joyPlaceId: string, name: string, plainTextLongDescription: string, propertyType: AccommodationCatalogPropertyType, starRating?: number | null, location: { __typename?: 'AccommodationCatalogLocation', latitude?: number | null, longitude?: number | null }, address?: { __typename?: 'AccommodationCatalogPropertyAddress', city?: string | null, country?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null, photos: Array<{ __typename?: 'AccommodationCatalogPhoto', url: string, photo?: { __typename?: 'Photo', id: string, assetId: string } | null }>, userRating?: { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null } | null }> } };

export type GetPageIdsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetPageIdsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, pages: Array<{ __typename?: 'EventPage', id: string, type: EventPageType }> } | null };

export type GetWebsiteLayoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteLayoutsQuery = { __typename?: 'Query', layouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }> };

export type MatchByIdQueryVariables = Exact<{
  matchId: Scalars['ID'];
}>;


export type MatchByIdQuery = { __typename?: 'Query', match?: { __typename?: 'Match', id: string, status: MatchStatus, matchNote?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }>, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } } | null };

export type PhotoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PhotoByIdQuery = { __typename?: 'Query', photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null };

export type PhotosByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PhotosByIdQuery = { __typename?: 'Query', photos: Array<{ __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> }> };

export type PhotosByIdWithVendorCollectionsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PhotosByIdWithVendorCollectionsQuery = { __typename?: 'Query', photos: Array<{ __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }>, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> }> };

export type LikedPhotsByUserIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LikedPhotsByUserIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, likedPhotos: Array<{ __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> }>, vendorsOnLikedPhotos: Array<{ __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null }> } | null };

export type CollectionIdsByPhotoIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CollectionIdsByPhotoIdQuery = { __typename?: 'Query', photo?: { __typename?: 'Photo', id: string, collectionItems: Array<{ __typename?: 'CollectionItem', id: string, collection?: { __typename?: 'Collection', id: string } | null }> } | null };

export type PhotosByGeneratedSimpleTagQueryVariables = Exact<{
  include: Array<Scalars['String']> | Scalars['String'];
  exclude?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type PhotosByGeneratedSimpleTagQuery = { __typename?: 'Query', photosByGeneratedSimpleTags: { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', cursor: string, node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null, collection?: { __typename?: 'Collection', name: string, id: string } | null } }> } } };

export type PublicShopRootQueryVariables = Exact<{
  eventId: Scalars['ID'];
  includeEvent: Scalars['Boolean'];
}>;


export type PublicShopRootQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, eventType: EventType, registry: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null }>, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }, registry: { __typename?: 'EventData', id: string, orders?: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null }> | null, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null, currency?: { __typename?: 'RegistryCurrency', isDefault: boolean, id: string, displayName: string, code: string, rank?: number | null } | null } } | null };

export type GetRegistryStoreSectionsQueryVariables = Exact<{
  names?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRegistryStoreSectionsQuery = { __typename?: 'Query', registryStoreSections: Array<{ __typename?: 'RegistryStoreSection', name: string, stores: Array<{ __typename?: 'RegistryStore', id: string, name: string, sectionName: string, shortDescription: string, longDescription: string, createRegistryUrl: string, domain: string, hostname: string, connectAction: RegistryStoreConnectAction, allowCreateBeforeConnect: boolean, onlyForEventTypes?: Array<EventType> | null, isRecommended: boolean, logos: Array<{ __typename?: 'Image', url: string, mimeType: string }>, logosCompact: Array<{ __typename?: 'Image', url: string, mimeType: string }>, valueProps: Array<{ __typename?: 'RegistryStoreValueProposition', text: string, image: { __typename?: 'Image', url: string, mimeType: string } }> }> }> };

export type GetRegistryProductsDataQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryProductsDataQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, nameV0204?: string | null, urlV0204?: string | null, imageUrlV0204?: string | null, wantSync?: boolean | null, type: RegistryType, isStandalonesType: boolean, isSyncingType: boolean, isTransferredType: boolean, storeName?: string | null, cannotSync: boolean, hasItems: boolean, transferredRegistryData?: { __typename?: 'TransferredRegistryData', transferredAt: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number }, lastPublicCheck?: { __typename?: 'ExternalRegistryStatusData', isPublic: boolean, checkedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null } | null, lastSyncAt?: { __typename?: 'Date', timestamp: any } | null, items?: Array<{ __typename?: 'RegistryItem', id: string, isGroupGiftingEnabled?: boolean | null, isGetCashEquivalent?: boolean | null, note?: string | null, externallyOwned: boolean, canEditProductData: boolean, storeName?: string | null, fpIndex: number, stillNeeded: number, alreadyPurchased?: number | null, alreadyReserved?: number | null, totalRequested?: number | null, isHidden: boolean, mustHave: boolean, createAt: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string }, productData: { __typename?: 'RegistryItemProductData', brand?: string | null, customType?: CustomItemDataType | null, title: string, externalUrl?: string | null, checkoutUrl?: string | null, pdpUrl?: string | null, description?: string | null, isFullPrice: boolean, legacyType: LegacyRegistryItemType, registryItem: { __typename?: 'RegistryItem', id: string }, price?: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null } | null, fullPrice?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }> }, donationFund?: { __typename?: 'DonationFund', id: string, fundType: CustomItemDataType, suggestedQuantityStillNeeded?: number | null, donationsAreCapped: boolean, enforceSuggestedDonationAmount: boolean, hideFundingGoal: boolean, progressToGoalPercent?: number | null, fpIndex?: number | null, title: string, url?: string | null, description?: string | null, enableCashOrCheck?: boolean | null, enableAppPlatform: boolean, enableJoyCredit: boolean, mustHave: boolean, donations: Array<{ __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } }>, goalMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, suggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, platform?: { __typename?: 'DonationFundPlatform', id?: string | null, type: DonationFundPlatformTypeEnum, name: string, link?: string | null, username?: string | null } | null, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, progressToGoal?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, amountTillGoalIsReached?: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } | null, currency: { __typename?: 'RegistryCurrency', code: string, id: string, displayName: string } } | null }> | null, myReservedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, myPurchasedOrders: Array<{ __typename?: 'RegistryOrder', id: string, name: string, email: string, note?: string | null, isPurchased: boolean, isDropship: boolean, status?: string | null, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }>, fulfillment?: { __typename?: 'RegistryFulfillment', status: string, statusPageUrl?: string | null, orderNumber: string, shipments?: Array<{ __typename?: 'RegistryFulfillmentShipment', trackingInformation?: { __typename?: 'RegistryFulfillmentShipmentTrackingInformation', url?: string | null, company?: string | null, trackingNumber?: string | null } | null }> | null } | null, shippingAddress?: { __typename?: 'RegistryOrderShippingAddress', hash?: string | null, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null>, mySession?: { __typename?: 'RegistrySession', email: string } | null }> } } | null };

export type GetRegistryPageQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistryPageQuery = { __typename?: 'Query', registryPage?: { __typename?: 'RegistryPage', photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null };

export type CheckRegistryUrlCanSyncQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CheckRegistryUrlCanSyncQuery = { __typename?: 'Query', checkRegistryUrlCanSync?: boolean | null };

export type CheckRegistryUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CheckRegistryUrlQuery = { __typename?: 'Query', checkRegistryUrl: { __typename?: 'CheckRegistryUrlResult', canSync: boolean, canTransfer: boolean } };

export type RegistryOrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegistryOrderByIdQuery = { __typename?: 'Query', registryOrderById?: { __typename?: 'RegistryOrder', id: string, email: string, name: string, isPurchased: boolean, isDropship: boolean, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, isGetCashEquivalent: boolean, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, registryItem?: { __typename?: 'RegistryItem', id: string } | null, lineItemData: { __typename?: 'RegistryOrderLineItemData', donationFundPlatformType?: DonationFundPaymentMethodEnum | null, correctedQuantity: number }, annotations: { __typename?: 'RegistryOrderLineItemAnnotations', isEdelivery?: boolean | null }, frozenProductData: { __typename?: 'RegistrySummaryProductData', title: string, customType: CustomItemDataType, price: { __typename?: 'RegistryMonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } }> } | null };

export type GetRegistryOrdersCheckoutMechanismsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
}>;


export type GetRegistryOrdersCheckoutMechanismsQuery = { __typename?: 'Query', registryOrdersByIds: Array<{ __typename?: 'RegistryOrder', id: string, lineItems: Array<{ __typename?: 'LineItem', locator: string, quantity: number, registryItem?: { __typename?: 'RegistryItem', id: string, productData: { __typename?: 'RegistryItemProductData', title: string, registryItem: { __typename?: 'RegistryItem', id: string }, checkoutMechanisms: Array<{ __typename?: 'CheckoutMechanism', type: string, hideValueProps: boolean, checkoutFailureCode?: string | null, checkoutWarningCodes: Array<string> }> } } | null }> } | null> };

export type GetItemCheckoutMechanismsQueryVariables = Exact<{
  id: Scalars['ID'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
  requestedQty?: InputMaybe<Scalars['Int']>;
}>;


export type GetItemCheckoutMechanismsQuery = { __typename?: 'Query', registryItem?: { __typename?: 'RegistryItem', id: string, productData: { __typename?: 'RegistryItemProductData', registryItem: { __typename?: 'RegistryItem', id: string }, checkoutMechanisms: Array<{ __typename?: 'CheckoutMechanism', type: string, hideValueProps: boolean, checkoutFailureCode?: string | null, checkoutWarningCodes: Array<string> }> } } | null };

export type CardPaymentMethodFragment = { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentCard', brand: string, last4: string } | null };

export type GetRegistryPurchaseConfirmationDetailsQueryVariables = Exact<{
  purchaseContextId: Scalars['ID'];
}>;


export type GetRegistryPurchaseConfirmationDetailsQuery = { __typename?: 'Query', registryPurchaseConfirmationDetailsByPurchaseContextId?: { __typename?: 'RegistryPurchaseConfirmationDetails', salesOrder?: { __typename?: 'SalesOrder', id: string, sender?: { __typename?: 'RegistryCustomer', email: string, name: string } | null, subtotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, total: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, taxesTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, shippingAndHandlingTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderChargesTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, postPurchaseFeesTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, compensationTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }>, items: Array<{ __typename: 'SalesOrderItemLine', isEdelivery: boolean, quantity: number, isCashFund: boolean, title: string, unitValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, photos: Array<{ __typename?: 'Photo', id: string, url: string }>, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, taxes: Array<{ __typename: 'SalesOrderTaxLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, shippingAndHandling: Array<{ __typename: 'SalesOrderShippingAndHandlingLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, orderCharges: Array<{ __typename: 'SalesOrderChargeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, postPurchaseFees: Array<{ __typename: 'SalesOrderPostPurchaseFeeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, compensation: Array<{ __typename: 'SalesOrderCompensationLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, paymentMethod?: { __typename?: 'PaymentMethod', card?: { __typename?: 'PaymentCard', brand: string, last4: string } | null } | null } | null } | null };

export type GetRegistryStaticDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistryStaticDataQuery = { __typename?: 'Query', getRegistryStaticData?: { __typename?: 'RegistryStaticData', countries?: { __typename?: 'RegistryCountryResults', topRanked: Array<{ __typename?: 'RegistryCountry', name: string, code: string }>, ordered: Array<{ __typename?: 'RegistryCountry', name: string, code: string }> } | null } | null };

export type GetRegistryOrderByIdQueryVariables = Exact<{
  registryOrderId: Scalars['ID'];
}>;


export type GetRegistryOrderByIdQuery = { __typename?: 'Query', registryOrderById?: { __typename?: 'RegistryOrder', id: string, name: string, email: string, lineItems: Array<{ __typename?: 'LineItem', quantity: number, registryItem?: { __typename?: 'RegistryItem', id: string, alreadyReserved?: number | null, alreadyPurchased?: number | null, productData: { __typename?: 'RegistryItemProductData', title: string, registryItem: { __typename?: 'RegistryItem', id: string }, photos: Array<{ __typename?: 'Photo', id: string, url: string }> } } | null }> } | null };

export type GetDonationFundDonationByIdQueryVariables = Exact<{
  registryOrderId: Scalars['ID'];
}>;


export type GetDonationFundDonationByIdQuery = { __typename?: 'Query', getDonationFundDonationById?: { __typename?: 'DonationFundDonation', id: string, name: string, email: string, note?: string | null, platformType?: DonationFundPaymentMethodEnum | null, amount: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, orderedAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } } | null };

export type GetRegistryOnboardingSuggestionsQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistryOnboardingSuggestionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, emailIsVerified: boolean } | null, eventById?: { __typename?: 'Event', id: string, website: string, suggestion: { __typename?: 'EventSuggestionInfo', items: Array<{ __typename?: 'EventSuggestion', id: string, identifier: string, stateJSON?: any | null, createdAt: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number }, offeredAt?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null }> }, eventUsers: Array<{ __typename?: 'EventUser', id: string }>, info: { __typename?: 'EventInfo', id: string, greeting?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, country?: string | null } | null, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null, registry: Array<{ __typename?: 'Registry', id: string, storeName?: string | null, items?: Array<{ __typename?: 'RegistryItem', id: string, externallyOwned: boolean, productData: { __typename?: 'RegistryItemProductData', customType?: CustomItemDataType | null, registryItem: { __typename?: 'RegistryItem', id: string } } }> | null }> }, registryPageInfo?: { __typename?: 'EventPageInfo', id: string, page: { __typename?: 'EventPage', id: string, disabled: boolean, pageSubtitle?: string | null, photoV2?: { __typename?: 'DefaultPagePhoto', id: string, url: string } | { __typename?: 'Photo', id: string, url: string } | null } } | null, registry: { __typename?: 'EventData', id: string, currency?: { __typename?: 'RegistryCurrency', id: string, code: string, isDefault: boolean, displayName: string, rank?: number | null } | null, shippingAddress?: { __typename?: 'ShippingAddress', name?: string | null, address1: string, address2?: string | null, phone?: string | null, city: string, state: string, postalCode?: string | null, country: string, countryCode?: string | null, validated: boolean, hash?: string | null } | null } } | null, registryPage?: { __typename?: 'RegistryPage', photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type GetRegistrySettingsDialogDataQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistrySettingsDialogDataQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventDateIsFinalized: boolean, tentativeDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', timestamp: any, timezone: string, milliseconds: number } | null } } | null };

export type GetProductVerticalConfigQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetProductVerticalConfigQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null } | null };

export type GetVisibilityConfigQueryVariables = Exact<{
  eventPageId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type GetVisibilityConfigQuery = { __typename?: 'Query', eventPage?: { __typename?: 'EventPage', id: string, disabled: boolean, private: boolean } | null, event?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventPassword?: string | null } } | null };

export type GetPayoutAccountInfoQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetPayoutAccountInfoQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, payoutAccount?: { __typename?: 'RegistryPayoutAccount', status: string, statusDetails?: string | null, onboardingUrl?: string | null, serviceDashboardUrl?: string | null, externalAccountLast4?: string | null, balance?: { __typename?: 'RegistryPayoutAccountBalance', availablePending: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, available: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, withdrawnPending: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, withdrawn: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, received: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number } } | null, withdrawals: Array<{ __typename?: 'RegistryPayoutAccountWithdrawal', id: string, status: string, totalValue: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMajorUnits: number, valueInMinorUnits: number }, createdAt: { __typename?: 'Date', timestamp: any } }> } | null } | null };

export type GetCalculateRegistryPurchaseInfoQueryVariables = Exact<{
  payload: CalculateRegistryPurchaseInfoInput;
}>;


export type GetCalculateRegistryPurchaseInfoQuery = { __typename?: 'Query', calculateRegistryPurchaseInfo: { __typename?: 'CalculateRegistryPurchaseInfo', checkoutWarningCodes: Array<string>, shippingAndHandling: Array<{ __typename: 'SalesOrderShippingAndHandlingLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, orderCharges: Array<{ __typename: 'SalesOrderChargeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, postPurchaseFees: Array<{ __typename: 'SalesOrderPostPurchaseFeeLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, compensation: Array<{ __typename: 'SalesOrderCompensationLine', title: string, lineValue: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null }, lineTags: Array<{ __typename?: 'CommerceTag', key: string, value: string }> }>, shippingAndHandlingTotal: { __typename?: 'MonetaryValue', valueInMinorUnits: number, floatingPointDecimalString: string, currency?: { __typename?: 'Currency', code: string, places: number } | null } } };

export type GetRegistryTransferredSyncInformationQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetRegistryTransferredSyncInformationQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, registry: Array<{ __typename?: 'Registry', id: string, isSyncingType: boolean, isTransferredType: boolean }> } } | null };

export type GetRegistryJoyCreditStatusQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetRegistryJoyCreditStatusQuery = { __typename?: 'Query', getRegistryEventData?: { __typename?: 'EventData', id: string, joyCreditStatus: { __typename?: 'RegistryJoyCreditStatus', joyCredit?: { __typename?: 'RegistryJoyCredit', active: boolean, code?: string | null, amount?: { __typename?: 'CommerceMonetaryValue', currencyCode: string, valueInMinorUnits: number } | null } | null } } | null };

export type GetMeEventUsersEventInfoForMePageQueryVariables = Exact<{
  filterEventTypes?: InputMaybe<Array<EventType> | EventType>;
}>;


export type GetMeEventUsersEventInfoForMePageQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, firstName?: string | null, lastName?: string | null, aliases: Array<{ __typename?: 'UserAlias', id: string, auth0Id: string }>, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, activeSession: { __typename?: 'EventSession', id: string, eventCTA: { __typename?: 'EventSessionCTA', rsvpAttendanceStatus: EventRSVPAttendanceStatus } }, pages: Array<{ __typename?: 'EventPage', id: string, pageSlug: string, visibility: EventPageVisibility, photo?: { __typename?: 'Photo', id: string, url: string } | null }>, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null } | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, style: { __typename?: 'EventStyle', id: string, primaryColorV0918: { __typename?: 'Color', hex: string } }, info: { __typename?: 'EventInfo', eventType: EventType, timezone?: string | null, eventPassword?: string | null, id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, location?: string | null, greeting?: string | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null } | null }, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null } | null } | null }>, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, vendorUsers: Array<{ __typename?: 'VendorUser', id: string, displayFirstName?: string | null, vendor: { __typename?: 'Vendor', id: string, name: string, handle?: string | null } }> } | null };

export type VendorCollectionGroupByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VendorCollectionGroupByIdQuery = { __typename?: 'Query', vendorCollectionGroup?: { __typename?: 'VendorCollectionGroup', id: string, title: string, collectionIds: Array<string>, collections: Array<{ __typename?: 'Collection', id: string, description?: string | null, name: string, itemCount: number, vendor?: { __typename?: 'Vendor', id: string, handle?: string | null, name: string, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null } | null, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', likedByCurrentUser: boolean, id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null } }> } }> } | null };

export type VendorCollectionGroupSyntheticCollectionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type VendorCollectionGroupSyntheticCollectionByIdQuery = { __typename?: 'Query', vendorCollectionGroup?: { __typename?: 'VendorCollectionGroup', id: string, title: string, collectionIds: Array<string>, aggregateSyntheticCollection: { __typename?: 'SyntheticCollection', id: string, description?: string | null, name: string, itemCount: number, items: { __typename?: 'CollectionItemsConnection', edges: Array<{ __typename?: 'CollectionItemsEdge', cursor: string, node: { __typename?: 'CollectionItem', id: string, description?: string | null, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, likedByCurrentUser: boolean, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null, metaTags: Array<{ __typename?: 'MetaTag', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, startingPrice?: number | null, typicalSpend?: number | null, type: Array<{ __typename?: 'VendorType', id: string, type: VendorTypeEnum }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } | null }> } | null, video?: { __typename?: 'Video', id: string, url: string, title?: string | null } | null, collection?: { __typename?: 'Collection', name: string, id: string } | null } }> } } } | null };

export type VendorSuggestionsQueryVariables = Exact<{
  vendorType: VendorTypeEnum;
}>;


export type VendorSuggestionsQuery = { __typename?: 'Query', suggestionGroupByVendorType?: { __typename?: 'SuggestionGroup', id: string, title: string, description: string, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, suggestions: Array<{ __typename?: 'VendorSuggestion', id: string, title: string, description: string, photo?: { __typename?: 'Photo', id: string, url: string, width: number, height: number, blurHash?: string | null, altTag?: string | null, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string }, transform?: { __typename?: 'PhotoTransform', x?: number | null, y?: number | null } | null } | null, vendor: { __typename?: 'Vendor', id: string, name: string, description?: string | null, handle?: string | null, phone?: string | null, email?: string | null, website?: string | null, instagramAuthLink: string, instagramHandle?: string | null, startingPrice?: number | null, typicalSpend?: number | null, locked: boolean, testimony: Array<{ __typename?: 'Testimony', id: string, content: string, reviewer?: string | null }>, photo?: { __typename?: 'Photo', id: string, url: string } | null, location?: { __typename?: 'Location', name?: string | null, address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, placeId?: string | null } | null } }> } | null };

export type GetVendorTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorTypesQuery = { __typename?: 'Query', vendorTypes: Array<{ __typename?: 'VendorType', id: string, display: string, type: VendorTypeEnum }> };

export type GetWebsiteDesignQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  purpose?: InputMaybe<EventDesignPurpose>;
}>;


export type GetWebsiteDesignQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean, hasVisitedDesignPage?: boolean | null, guestSiteTarget: GuestSiteTargetEnum, brannanNavigation: BrannanNavigation, useCustomTheme: boolean, accent?: string | null, customCss: string, linkAndButtonColor?: string | null, artFontColor?: string | null, artBackgroundColor?: string | null, pageBackgroundColor?: string | null, pageFontColor?: string | null, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }, font: { __typename?: 'Font', id: string, display: string, fontFamily: string, textTransform: FontWeight }, fonts?: Array<{ __typename?: 'FontPackConfiguration', id: string, category: Category, size?: number | null, sizePercent?: number | null, font?: { __typename?: 'Font', id: string, fontFamily: string, fontSize: number, fontWeight: number, firebaseFontKey: string } | null }> | null, theme: { __typename?: 'Theme', id: string, themeId: string, name: string, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, designLayouts: Array<{ __typename?: 'DesignLayout', id: string }>, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, alohaTextColorPreference?: { __typename?: 'DesignPreferenceColor', id: string, featureName: string, featureValueType: FeatureValueType, supportsCustomization: boolean, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null }, colorPalette: Array<{ __typename?: 'ColorSet', id: string, color: { __typename?: 'Color', hex: string, isLight: boolean } }>, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', dataJSON: any, schemaURL: string, websiteLayout: string, id: string } | null, customTheme?: { __typename?: 'CustomTheme', id: string, desktopThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null, mobileThemeAsset?: { __typename?: 'CustomThemeAsset', id: string, assetURL: string } | null } | null, designPreferences: Array<{ __typename?: 'EventDesignPreferenceBoolean', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, booleanValue: boolean } | { __typename?: 'EventDesignPreferenceColorPointer', id: string, featureName: string, featureType: DesignFeatureType, colorPointer?: number | null, colorPointerPosition?: ColorPointerLocation | null } | { __typename?: 'EventDesignPreferenceRange', id: string, featureId: string, featureName: string, featureType: DesignFeatureType, featureValueType: FeatureValueType, rangeValue: number }> } | null } | null };

export type GetHasUnpublishedWebsiteDesignQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetHasUnpublishedWebsiteDesignQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventDesign?: { __typename?: 'EventDesign', id: string, hasUnpublishedChanges: boolean } | null } | null };

export type GetThemesQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetThemesQuery = { __typename?: 'Query', designBuckets: Array<{ __typename?: 'DesignBucket', id: string, bucketId: string, display: string, fonts: Array<{ __typename?: 'Font', id: string }>, themes: Array<{ __typename?: 'Theme', id: string }> }>, eventByName?: { __typename?: 'Event', id: string, themes: Array<{ __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> }> } | null };

export type GetThemeByThemeIdQueryVariables = Exact<{
  themeId: Scalars['String'];
}>;


export type GetThemeByThemeIdQuery = { __typename?: 'Query', themeByThemeId?: { __typename?: 'Theme', id: string, name: string, themeId: string, description: string, supportsPrints: boolean, supportsEcards: boolean, thumbnailUrl: string, expiration?: { __typename?: 'Date', unixTimestamp: number } | null, designLayouts: Array<{ __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType, name: string }>, colorSchemes: Array<{ __typename?: 'ThemeColorScheme', id: string, colors: Array<{ __typename?: 'Color', hex: string, isLight: boolean }> }>, printProviders: Array<{ __typename?: 'PrintProviderTheme', id: string, stockPreviewUrl: string, printUrl: string, provider: { __typename?: 'PrintProvider', id: string, name: string, website: string, logoUrl?: string | null } }>, websiteLayoutAlohaSettings?: { __typename?: 'WebsiteLayoutAlohaSettings', alohaColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null } | null, websiteLayoutBrannanSettings?: { __typename?: 'WebsiteLayoutBrannanSettings', brannanColorPreference?: { __typename?: 'DesignPreferenceColor', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, colorValue: { __typename?: 'Color', hex: string, isLight: boolean } } | null, brannanInnerFrameBorder?: { __typename?: 'DesignPreferenceBoolean', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, booleanValue: boolean } | null, brannanBackgroundTransparency?: { __typename?: 'DesignPreferenceRange', supportsCustomization: boolean, id: string, featureName: string, featureValueType: FeatureValueType, rangeValue: number, rangeMax: number, rangeMin: number, rangeStep: number } | null } | null, marketingData: Array<{ __typename?: 'ThemeMarketingData', vendor: string, variationType: ThemeVariationType, tags: Array<string> }> } | null };

export type HotelInventoryByRadiusQueryVariables = Exact<{
  payload: HotelInventoryByRadiusRequest;
}>;


export type HotelInventoryByRadiusQuery = { __typename?: 'Query', hotelInventoryByRadius: Array<{ __typename?: 'HotelInventory', zhId?: string | null, userRating?: number | null, state?: string | null, starRating?: number | null, ratingCount?: number | null, postalCode?: string | null, photo?: string | null, distance?: number | null, displayName?: string | null, description?: string | null, country?: string | null, city?: string | null, address?: string | null, isPreferredHotel: boolean, hotelUrl?: string | null, hotelType: HotelTypeEnum, location?: { __typename?: 'InventoryLocation', lat: number, lon: number } | null }> };

export type HotelSuggestionsQueryVariables = Exact<{
  payload: HotelSuggestionRequest;
}>;


export type HotelSuggestionsQuery = { __typename?: 'Query', hotelSuggestions: Array<{ __typename?: 'HotelInventory', displayName?: string | null, zhId?: string | null, distance?: number | null, starRating?: number | null, userRating?: number | null, ratingCount?: number | null, address?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, photo?: string | null, description?: string | null, isPreferredHotel: boolean, hotelUrl?: string | null, hotelType: HotelTypeEnum, location?: { __typename?: 'InventoryLocation', lat: number, lon: number } | null }> };

export type EventSessionFindEventByFirebaseIdQueryVariables = Exact<{
  id: Scalars['String'];
  skipEventSession?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventSessionFindEventByFirebaseIdQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string } | null };

export type EventSessionGetEventByNameQueryVariables = Exact<{
  name: Scalars['String'];
  skipEventSession?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventSessionGetEventByNameQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string } | null };

export type EventSessionGetInviteeSessionQueryVariables = Exact<{
  eventId: Scalars['ID'];
  inviteeId: Scalars['String'];
}>;


export type EventSessionGetInviteeSessionQuery = { __typename?: 'Query', getRecipientSessionByInviteePID: string };

export type EventSessionGetGuestKeySessionQueryVariables = Exact<{
  eventId: Scalars['ID'];
  guestKey: Scalars['String'];
}>;


export type EventSessionGetGuestKeySessionQuery = { __typename?: 'Query', getRecipientSessionByGuestKey?: string | null };

export type FindEventByFirebaseIdQueryVariables = Exact<{
  id: Scalars['String'];
  skipEventSession?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindEventByFirebaseIdQuery = { __typename?: 'Query', eventByFirebaseId?: { __typename?: 'Event', id: string, website: string } | null };

export type FindEventByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  skipEventSession?: InputMaybe<Scalars['Boolean']>;
}>;


export type FindEventByIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, website: string } | null };

export type FeatureFlagByEventNameQueryVariables = Exact<{
  name: Scalars['String'];
  skipEventSession?: InputMaybe<Scalars['Boolean']>;
}>;


export type FeatureFlagByEventNameQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, featureFlags?: Array<string | null> | null, useLegacyGuestSite?: boolean | null } | null };

export type ImproveTextForAiReviewQueryVariables = Exact<{
  input: ImproveTextInput;
}>;


export type ImproveTextForAiReviewQuery = { __typename?: 'Query', improveText: { __typename?: 'ImprovedTextResponse', originalText: string, improvedText: string } };

export type GetMeQueryVariables = Exact<{
  eventName?: InputMaybe<Scalars['String']>;
  withActiveEventUser: Scalars['Boolean'];
  refreshMfa?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, superAdmin: boolean, emailIsVerified: boolean, avatar?: { __typename?: 'Photo', id: string, url: string } | null, activeAlias?: { __typename?: 'UserAlias', id: string, auth0Id: string, provider: string, mfaEnabled?: boolean | null } | null, activeEventUserForEvent?: { __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, superAdmin: boolean, firstName?: string | null, lastName?: string | null, email?: string | null, avatar?: { __typename?: 'Photo', id: string, url: string } | null }, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string } | null } | null } | null };

export type GetEventMembershipsQueryVariables = Exact<{
  filterEventTypes?: InputMaybe<Array<EventType> | EventType>;
}>;


export type GetEventMembershipsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, eventMemberships: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, event?: { __typename?: 'Event', id: string, firebaseId: string, website: string, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string } | null, info: { __typename?: 'EventInfo', id: string, eventType: EventType, eventDisplayName?: string | null, eventMonogram?: string | null, ownerFirstName?: string | null, fianceeFirstName?: string | null, location?: string | null, timezone?: string | null, finalizedDate?: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string } | null, tentativeDate?: { __typename?: 'Date', milliseconds: number, timestamp: any, timezone: string } | null } } | null }> } | null };

export type GetValidSendersQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetValidSendersQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, eventUsers: Array<{ __typename?: 'EventUser', id: string, status: EventUserStatus, user: { __typename?: 'User', id: string, email?: string | null, emailIsVerified: boolean } }> } | null };

export type EventFormDataWrapperFormFragment = { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, type?: FormType | null, enabled: boolean };

export type EventFormDataWrapperFormByIdQueryVariables = Exact<{
  formByIdId: Scalars['ID'];
}>;


export type EventFormDataWrapperFormByIdQuery = { __typename?: 'Query', formById?: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, type?: FormType | null, enabled: boolean } | null };

export type EventFormFunctionalWrapperActiveSessionQueryVariables = Exact<{
  eventByIdId: Scalars['ID'];
}>;


export type EventFormFunctionalWrapperActiveSessionQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, activeSession: { __typename?: 'EventSession', guestKey?: string | null, id: string } } | null };

export type EventFormFunctionalWrapperAnswerFragment = { __typename?: 'Answer', id: string, answerValue: string, guestKey?: string | null, questionValue?: { __typename?: 'QuestionValue', stepName?: string | null, stepTitle?: string | null, field?: any | null, placeholder?: string | null, stepDescription?: string | null } | null, contact?: { __typename?: 'FormContactItem', firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type EventFormFormByIdQueryVariables = Exact<{
  formByIdId: Scalars['ID'];
}>;


export type EventFormFormByIdQuery = { __typename?: 'Query', formById?: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, type?: FormType | null, enabled: boolean } | null };

export type EventFormGetGuestFormQueryVariables = Exact<{
  formId: Scalars['ID'];
}>;


export type EventFormGetGuestFormQuery = { __typename?: 'Query', getGuestForm: { __typename?: 'GuestFormView', hiddenQuestionIds: Array<string>, form: { __typename?: 'Form', id: string, title: string, description: string, schemaUrl: string, config: any, settings?: any | null, eventId?: string | null, type?: FormType | null, enabled: boolean } } };

export type EventFormFunctionalWrapperGuestAnswersQueryVariables = Exact<{
  formId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type EventFormFunctionalWrapperGuestAnswersQuery = { __typename?: 'Query', guestAnswersByFormId?: Array<{ __typename?: 'Answer', id: string, answerValue: string, guestKey?: string | null, questionValue?: { __typename?: 'QuestionValue', stepName?: string | null, stepTitle?: string | null, field?: any | null, placeholder?: string | null, stepDescription?: string | null } | null, contact?: { __typename?: 'FormContactItem', firstName?: string | null, lastName?: string | null, email?: string | null } | null }> | null };

export type EventFormFunctionalWrapperGuestAttendanceStateQueryVariables = Exact<{
  eventId: Scalars['ID'];
  guestKey: Scalars['String'];
}>;


export type EventFormFunctionalWrapperGuestAttendanceStateQuery = { __typename?: 'Query', guestAttendanceByEventId?: { __typename?: 'Attendance', id: string, attendanceState: AttendanceState, contact?: { __typename?: 'FormContactItem', firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type RegistrationFormSaveEventRegistrationMutationVariables = Exact<{
  input: EventRegistrationInput;
}>;


export type RegistrationFormSaveEventRegistrationMutation = { __typename?: 'Mutation', saveEventRegistration: { __typename?: 'EventRegistrationResponse', guestKey?: string | null } };

export type RegistrationFormSetAttendanceByGuestKeyMutationVariables = Exact<{
  input: AttendanceInput;
}>;


export type RegistrationFormSetAttendanceByGuestKeyMutation = { __typename?: 'Mutation', setAttendanceByGuestKey: { __typename?: 'Attendance', id: string, attendanceState: AttendanceState } };

export type EventPhotoByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventPhotoByEventIdQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, photo?: { __typename?: 'Photo', id: string, url: string } | null } | null };

export type EventScheduleByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type EventScheduleByEventIdQuery = { __typename?: 'Query', getGuestGeneralEventScheduleForEvent: { __typename?: 'GeneralEventScheduleInfo', formattedSchedules: Array<{ __typename?: 'FormattedSchedule', dateISO8601TZ: string, items: Array<{ __typename?: 'EventSchedule', description?: string | null, id: string, name: string, timezone?: string | null, startTimeISO8601TZ?: string | null, endTimeISO8601TZ?: string | null }> }> } };

export type PhotoDataFragment = { __typename?: 'Photo', id: string, assetId: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } };

export type WebsiteCreateOrUpdatePagePhotoPresentationMutationVariables = Exact<{
  payload: websiteCreateOrUpdatePagePhotoPresentationPayload;
}>;


export type WebsiteCreateOrUpdatePagePhotoPresentationMutation = { __typename?: 'Mutation', websiteCreateOrUpdatePagePhotoPresentation?: { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponse', message: string, success: boolean, photoPresentation?: { __typename?: 'WebsitePagePhotoPresentation', id: string, presentationLayout: string, photo?: { __typename?: 'Photo', id: string, assetId: string, height: number, width: number, url: string, layout: { __typename?: 'PhotoLayout', alignX: string, alignY: string } } | null, cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo', x: number, y: number, width: number, height: number, unit: string } | null } | null } | { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponseError', id?: string | null, message: string, pageId?: string | null, success: boolean } | null };

export type UserRatingFragment = { __typename?: 'UserRating', ratingCount?: number | null, ratingValue?: number | null };

export type GetEventByNameForPeoplePickerQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventByNameForPeoplePickerQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, website: string, labels: Array<{ __typename?: 'EventLabel', id: string, display: string, people: Array<{ __typename?: 'Person', id: string, personIdTag: string }> }>, guests: { __typename?: 'EventGuests', households: Array<{ __typename?: 'Household', id: string, members: Array<{ __typename?: 'Person', id: string, personIdTag: string, firstName?: string | null, lastName?: string | null, email?: string | null, hasEmail: boolean, phoneDisplay?: string | null, avatarName?: string | null, household?: { __typename?: 'Household', id: string } | null }> }> }, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null, info: { __typename?: 'EventInfo', id: string, ownerFirstName?: string | null, ownerLastName?: string | null, fianceeFirstName?: string | null, fianceeLastName?: string | null, eventDisplayName?: string | null, eventType: EventType, location?: string | null, greeting?: string | null, timezone?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, city?: string | null, state?: string | null, country?: string | null, address1?: string | null, address2?: string | null, latitude?: number | null, longitude?: number | null } | null, tentativeDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number } | null, finalizedDate?: { __typename?: 'Date', dateString: string, timestamp: any, timezone: string, milliseconds: number, timeString: string } | null, dateV0918?: { __typename?: 'Date', milliseconds: number } | null }, firebaseCreateAt?: { __typename?: 'Date', milliseconds: number } | null } | null };

export type UploadPhotoFromUrlMutationVariables = Exact<{
  payload: UploadPhotoFromUrlPayload;
}>;


export type UploadPhotoFromUrlMutation = { __typename?: 'Mutation', uploadPhotoFromUrl?: { __typename?: 'Photo', id: string, url: string } | null };

export type CreateRemindMeLaterEmailMutationVariables = Exact<{
  data: CreateRemindMeLaterEmailInput;
}>;


export type CreateRemindMeLaterEmailMutation = { __typename?: 'Mutation', createRemindMeLaterEmail?: any | null };

export type FindHotelMatchQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type FindHotelMatchQuery = { __typename?: 'Query', findHotelMatch?: { __typename?: 'HotelMatchResponse', name: string, link: string, rate?: number | null, rating: number, mainPhotoUrl?: string | null, thumbnailUrl?: string | null, address: { __typename?: 'HotelMatchAddress', address: string, city: string } } | null };

export type ScheduleItemFragment = { __typename?: 'EventSchedule', id: string, name: string, description?: string | null, timezone?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, startTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', urlLinkText?: string | null } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, address1?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type ScheduleEditorDeleteItemMutationVariables = Exact<{
  payload?: InputMaybe<EventScheduleDeleteItemPayload>;
}>;


export type ScheduleEditorDeleteItemMutation = { __typename?: 'Mutation', deleteEventScheduleItem: { __typename?: 'EventSchedule', id: string, name: string, description?: string | null, timezone?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, startTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', urlLinkText?: string | null } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, address1?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type ScheduleEditorCreateItemMutationVariables = Exact<{
  payload?: InputMaybe<EventScheduleCreateItemPayload>;
}>;


export type ScheduleEditorCreateItemMutation = { __typename?: 'Mutation', createEventScheduleItem: { __typename?: 'EventSchedule', id: string, name: string, description?: string | null, timezone?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, startTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', urlLinkText?: string | null } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, address1?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type ScheduleEditorUpdateItemMutationVariables = Exact<{
  payload?: InputMaybe<EventScheduleUpdateItemPayload>;
}>;


export type ScheduleEditorUpdateItemMutation = { __typename?: 'Mutation', updateEventScheduleItem: { __typename?: 'EventSchedule', id: string, name: string, description?: string | null, timezone?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, startTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', urlLinkText?: string | null } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, address1?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type ScheduleEditorGetItemByIdQueryVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type ScheduleEditorGetItemByIdQuery = { __typename?: 'Query', getAdminEventScheduleItemById: { __typename?: 'EventSchedule', id: string, name: string, description?: string | null, timezone?: string | null, dressCode?: string | null, location?: string | null, showMap: boolean, placeId?: string | null, startTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, endTime?: { __typename?: 'Date', dateString: string, timestamp: any } | null, virtualEventLink?: { __typename?: 'VirtualEventLinkParseResult', urlLinkText?: string | null } | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, placeId?: string | null, name?: string | null, address1?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type EventAccommodationPublicDataFragment = { __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, isFromAccommodationCatalog: boolean, joyPlaceId?: string | null, zhId?: string | null, isFavorite?: boolean | null, userNote?: string | null, description?: string | null, customName?: string | null, name?: string | null, email?: string | null, customPhone?: string | null, phone?: string | null, customUrl?: string | null, url?: string | null, isPhotoHidden?: boolean | null, customAddress?: string | null, address?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null };

export type EventAccommodationsCheckQueryVariables = Exact<{
  name: Scalars['String'];
  pageContainerBySlugPayload: PageContainerBySlugPayload;
}>;


export type EventAccommodationsCheckQuery = { __typename?: 'Query', pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent' } | { __typename: 'TravelMapComponent', id: string, blockOrdering?: Array<string> | null, type: ComponentType } | { __typename?: 'VideoComponent' }> | null } | null, eventByName?: { __typename?: 'Event', id: string, accommodationPlacesV2: Array<{ __typename?: 'AccommodationPlaceV2', id: string, type?: AccommodationPlaceType | null, isFromAccommodationCatalog: boolean, joyPlaceId?: string | null, zhId?: string | null, isFavorite?: boolean | null, userNote?: string | null, description?: string | null, customName?: string | null, name?: string | null, email?: string | null, customPhone?: string | null, phone?: string | null, customUrl?: string | null, url?: string | null, isPhotoHidden?: boolean | null, customAddress?: string | null, address?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, latitude?: number | null, longitude?: number | null, accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock', bookingUrl: string, checkInDate: string, checkOutDate: string, cutoffDate: string, isJoyManagedRoomBlock: boolean, numberOfRoomsReserved: number, status: AccommodationPlaceRoomBlockStatus, pricePerNight?: number | null, strikeoutPricePerNight?: number | null } | null, customPhoto?: { __typename?: 'Photo', id: string, url: string } | null, photo?: { __typename?: 'Photo', id: string, url: string } | null }>, places: Array<{ __typename?: 'EventPlace', id?: string | null, googlePlaceId?: string | null, type: EventPlaceType, name: string, displayAddress: string, latitude?: number | null, longitude?: number | null }>, info: { __typename?: 'EventInfo', id: string, placeId?: string | null, eventDisplayName?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null } | null, finalizedDate?: { __typename?: 'Date', milliseconds: number, timezone: string } | null, travel: Array<{ __typename?: 'EventTravelBookingType' } | { __typename?: 'EventTravelList' } | { __typename?: 'EventTravelNote' } | { __typename?: 'Ferry' } | { __typename?: 'Flight' } | { __typename: 'Hotel', id: string, type: TravelType } | { __typename?: 'RentalCar' } | { __typename: 'RentalHome', id: string, type: TravelType } | { __typename?: 'Shuttle' } | { __typename?: 'Taxi' } | { __typename: 'Tent', id: string, type: TravelType } | { __typename?: 'Train' }> }, pagesInfo?: Array<{ __typename?: 'EventPageInfo', id: string, visibility: EventPageVisibility, type: EventPageType, page: { __typename?: 'EventPage', id: string, pageSlug: string } }> | null } | null };

export type GetEventFeatureFlagsQueryVariables = Exact<{
  eventHandle: Scalars['String'];
}>;


export type GetEventFeatureFlagsQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, featureFlags?: Array<string | null> | null } | null };

export type EventSafetyRatingQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type EventSafetyRatingQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, safetyRating?: SafetyRating | null } } | null };

export type AutoPopulateAccommodationPlacesV5MutationVariables = Exact<{
  payload: AutoPopulateAccommodationPlacesPayloadV5;
}>;


export type AutoPopulateAccommodationPlacesV5Mutation = { __typename?: 'Mutation', autoPopulateAccommodationPlacesV5: { __typename?: 'AutoPopulateResponseV5', error?: string | null, idempotentId: string, status: AutopopulateJobStatusV5, result?: Array<{ __typename?: 'AutoPopulateResultItemV4', accommodationPlaceId: string, proposedNoteFromHostToGuest?: string | null, whyThisHotelIsAGreatPick?: string | null }> | null } };

export type AutopopulateOperationFragment = { __typename?: 'AutopopulateOperationItemV20251203', error?: string | null, eventId: string, idempotentId: string, status: AutopopulateJobStatusV5, result?: { __typename?: 'AutoPopulateResultV20251203', algoTag?: string | null, items: Array<{ __typename?: 'AutoPopulateResultItemV4', accommodationPlaceId: string, proposedNoteFromHostToGuest?: string | null, whyThisHotelIsAGreatPick?: string | null }> } | null };

export type AutopopulateOperationsByEventIdQueryVariables = Exact<{
  payload: AutopopulateOperationsByEventIdPayload;
}>;


export type AutopopulateOperationsByEventIdQuery = { __typename?: 'Query', autopopulateOperationsByEventIdV20251203: { __typename?: 'AutopopulateOperationsByEventIdResponseV20251203', operations: Array<{ __typename?: 'AutopopulateOperationItemV20251203', error?: string | null, eventId: string, idempotentId: string, status: AutopopulateJobStatusV5, result?: { __typename?: 'AutoPopulateResultV20251203', algoTag?: string | null, items: Array<{ __typename?: 'AutoPopulateResultItemV4', accommodationPlaceId: string, proposedNoteFromHostToGuest?: string | null, whyThisHotelIsAGreatPick?: string | null }> } | null }> } };

export type BasicEventInfoQueryVariables = Exact<{
  eventHandle: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type BasicEventInfoQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, firebaseId: string, published: boolean, websiteState: EventWebsiteState, featureFlags?: Array<string | null> | null, eventDesign?: { __typename?: 'EventDesign', id: string, websiteLayout: { __typename?: 'DesignLayout', id: string, layoutType: DesignLayoutType } } | null, info: { __typename?: 'EventInfo', id: string, eventDisplayName?: string | null, eventType: EventType, fianceeFirstName?: string | null, fianceeLastName?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, locale: string, story?: string | null, locationInfo?: { __typename?: 'EventLocation', id?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, placeId?: string | null, state?: string | null, address1?: string | null, address2?: string | null, postalCode?: string | null } | null, finalizedDate?: { __typename?: 'Date', milliseconds: number, dateString: string, timestamp: any, timezone: string } | null, tentativeDate?: { __typename?: 'Date', milliseconds: number, dateString: string, timestamp: any, timezone: string } | null, qanda: Array<{ __typename?: 'EventQanda', id: string, type: QandaType, question: string, answer: string }> }, firebaseCreateAt?: { __typename?: 'Date', timestamp: any } | null, productVerticals?: { __typename?: 'EventProductVerticals', optOutOfGuestList?: boolean | null, optOutOfInvites?: boolean | null, optOutOfRegistry?: boolean | null, optOutOfWebsite?: boolean | null } | null, settings: { __typename?: 'EventSettings', id: string, hideEventCountdown: boolean, hideDownloadAppPage: boolean, hideFromSearchEngines: boolean, hideFromJoySearch: boolean, requirePasswordForEventDate: boolean, requirePasswordForEventLocation: boolean, requirePasswordToUploadPhotos: boolean, requirePasswordToViewEngagementPhotos: boolean, privacyMode: PrivacyModeType, optOutOfCharm: boolean, allowFacebookAndInstagramSharingOnApp: boolean, allowGuestsNotInGuestListToRSVP: boolean, allowGuestsToInviteOtherGuestsOnApp: boolean, allowGuestsToRSVPPlusOne: boolean, allowGuestsToViewOtherGuestsOnApp: boolean } } | null };

export type GetEventPhotoByEventHandleQueryVariables = Exact<{
  website: Scalars['String'];
}>;


export type GetEventPhotoByEventHandleQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, photoV2Url?: string | null, photo?: { __typename?: 'Photo', id: string, url: string } | null, info: { __typename?: 'EventInfo', id: string, eventType: EventType }, eventDesign?: { __typename?: 'EventDesign', id: string, activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings', schemaURL: string, websiteLayout: string, dataJSON: any, id: string } | null } | null } | null };

export type EventPlacesQueryVariables = Exact<{
  name: Scalars['String'];
  payload: PageContainerBySlugPayload;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventPlacesQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, places: Array<{ __typename?: 'EventPlace', id?: string | null, googlePlaceId?: string | null, type: EventPlaceType, name: string, displayAddress: string, latitude?: number | null, longitude?: number | null, city?: string | null, stateProvince?: string | null, country?: string | null, countryCode?: string | null }>, bestLocationAnchor?: { __typename?: 'LocationAnchor', friendlyName: string, latitude: string, longitude: string, googlePlaceID: string } | null } | null, pageContainerBySlug?: { __typename?: 'PageContainer', id: string, components?: Array<{ __typename?: 'EventCountdownComponent' } | { __typename?: 'EventDetailsComponent' } | { __typename?: 'EventDisplayNameComponent' } | { __typename?: 'GreetingMessageComponent' } | { __typename?: 'JsonDataBlobComponent' } | { __typename?: 'MediaGalleryComponent' } | { __typename?: 'PhotoComponent' } | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' } | { __typename?: 'TextComponent' } | { __typename?: 'TravelMapComponent', id: string, pointsOnMap?: Array<{ __typename?: 'PointsOnMap', id: string, type: PointOnMapType } | null> | null } | { __typename?: 'VideoComponent' }> | null } | null };

export type GetEventTypeQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetEventTypeQuery = { __typename?: 'Query', eventByName?: { __typename?: 'Event', id: string, info: { __typename?: 'EventInfo', id: string, eventType: EventType } } | null };

export type StationeryProductPricingsFragment = { __typename?: 'StationeryProduct', id: string, priceCurrency: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } };

export type StationeryProductAttributePricingsFragment = { __typename?: 'StationeryProductAttributeOption', pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } };

export type StationeryProductAttributesFragment = { __typename?: 'StationeryProduct', id: string, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }> };

export type StationeryProductVariantGroupsFragment = { __typename?: 'StationeryProduct', id: string, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> };

export type StationeryShippingOptionsPricingFragment = { __typename?: 'StationeryProductShippingOptionV1', pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } };

export type StationeryShippingConstraintsFragment = { __typename?: 'StationeryProductShippingOptionV1', constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> };

export type ShippingOptionV1Fragment = { __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> };

export type StationeryShippingOptionsFragment = { __typename?: 'StationeryProduct', id: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null };

export type StationeryProductsFragment = { __typename?: 'StationeryTemplate', products: Array<{ __typename?: 'StationeryProduct', id: string, priceConfigId: string, vendor: StationeryPrintOrderVendorEnum, productType: string, vendorBaseSKU: string, priceCurrency: string, shippingOptions?: Array<{ __typename?: 'StationeryProductShippingOptionV1', id: string, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, constraints: Array<{ __typename?: 'StationeryAllowPoBoxShippingConstraint', allowPoBox: boolean } | { __typename?: 'StationeryCountryShippingConstraint', includedCountries?: Array<string> | null, excludedCountries?: Array<string> | null } | { __typename?: 'StationeryQuantityShippingConstraint', minQuantity: number, maxQuantity?: number | null }> }> | null, attributes: Array<{ __typename?: 'StationeryProductAttribute', attributeId: string, attributeOptions: Array<{ __typename?: 'StationeryProductAttributeOption', attributeOption: { __typename?: 'StationeryAttributeOption', attributeId: string, id: string }, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> } }> }>, pricing: { __typename?: 'StationeryFlatFeePricing', priceInMinorUnits: number } | { __typename?: 'StationeryTieredFlatFeePricing', priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice', minQuantity: number, totalPriceInMinorUnits: number }> } | { __typename?: 'StationeryTieredPricing', priceTiers: Array<{ __typename?: 'StationeryTieredPrice', minQuantity: number, unitPriceInMinorUnits: number }> }, variantGroups: Array<{ __typename?: 'StationeryProductVariantGroup', vendorSKU: string, id: string, options: Array<{ __typename?: 'StationeryAttributeOption', id: string, attributeId: string }> }> }> };

export type AutoPopulateStayAreasMutationVariables = Exact<{
  payload: AutoPopulateStayAreasPayload;
}>;


export type AutoPopulateStayAreasMutation = { __typename?: 'Mutation', autoPopulateStayAreas: { __typename?: 'AutoPopulateStayAreasResponse', error?: string | null, idempotentId: string, status: DeferredOperationJobStatus, result?: Array<{ __typename?: 'JoyStayArea', id: string, name: string }> | null } };

export type AutopopulateStayAreaOperationFragment = { __typename?: 'AutopopulateStayAreaOperationItem', eventId: string, operationType: IdempotentOperationType, status: AutopopulateJobStatusV5, error?: string | null, result?: Array<{ __typename?: 'JoyStayArea', id: string, name: string }> | null };

export type AutopopulateStayAreaOperationsByEventIdQueryVariables = Exact<{
  payload: AutopopulateStayAreaOperationsByEventIdPayload;
}>;


export type AutopopulateStayAreaOperationsByEventIdQuery = { __typename?: 'Query', autopopulateStayAreaOperationsByEventId: { __typename?: 'AutopopulateStayAreaOperationsByEventIdResponse', operations: Array<{ __typename?: 'AutopopulateStayAreaOperationItem', eventId: string, operationType: IdempotentOperationType, status: AutopopulateJobStatusV5, error?: string | null, result?: Array<{ __typename?: 'JoyStayArea', id: string, name: string }> | null }> } };

export type StayAreaFragment = { __typename?: 'JoyStayArea', id: string, name: string, areaType?: string | null, bestForTags?: Array<string> | null, address?: string | null, description?: string | null, proposedNoteFromHostToGuest?: string | null, watchOuts?: string | null, whyThisAreaIsAGreatPick?: string | null, bounds?: { __typename?: 'LocationBoundsOutput', ne: { __typename?: 'LocationCoordinates', lng: number }, sw: { __typename?: 'LocationCoordinates', lat: number, lng: number } } | null, center?: { __typename?: 'LocationCoordinates', lat: number, lng: number } | null, photos?: Array<{ __typename?: 'Photo', id: string, url: string }> | null, distances?: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> | null };

export type StayAreasQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type StayAreasQuery = { __typename?: 'Query', stayAreas: Array<{ __typename?: 'JoyStayArea', id: string, name: string, areaType?: string | null, bestForTags?: Array<string> | null, address?: string | null, description?: string | null, proposedNoteFromHostToGuest?: string | null, watchOuts?: string | null, whyThisAreaIsAGreatPick?: string | null, bounds?: { __typename?: 'LocationBoundsOutput', ne: { __typename?: 'LocationCoordinates', lng: number }, sw: { __typename?: 'LocationCoordinates', lat: number, lng: number } } | null, center?: { __typename?: 'LocationCoordinates', lat: number, lng: number } | null, photos?: Array<{ __typename?: 'Photo', id: string, url: string }> | null, distances?: Array<{ __typename?: 'TravelDistanceBetweenPoints', durationMinutes?: number | null, km: number, mi: number, type: DistancesBetweenPointsType }> | null }> };

export type RemoveStayAreaMutationVariables = Exact<{
  payload: RemoveStayAreaPayload;
}>;


export type RemoveStayAreaMutation = { __typename?: 'Mutation', removeStayArea: { __typename?: 'JoyStayArea', id: string } };

export type UserPublicConsentKeysForEventQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type UserPublicConsentKeysForEventQuery = { __typename?: 'Query', userPublicConsentKeysForEvent?: Array<{ __typename?: 'PublicUserConsent', consentAnswer: boolean, consentKey: string, createdAt: any, eventId: string, id: string }> | null };

export const GeneralEventTypeFragmentDoc = gql`
    fragment GeneralEventType on EventTypesConfig {
  id
  enabled
  deleted
  title
  description
  category
  categorySubtype
  configJson
  schemaUrl
}
    `;
export const PhotoLayoutFragmentDoc = gql`
    fragment PhotoLayout on PhotoLayout {
  alignX
  alignY
}
    `;
export const PhotoTransformFragmentDoc = gql`
    fragment PhotoTransform on PhotoTransform {
  x
  y
}
    `;
export const PhotoLayoutV2FragmentDoc = gql`
    fragment PhotoLayoutV2 on DefaultPagePhotoLayout {
  alignX
  alignY
}
    `;
export const PhotoV2WithoutBlurHashFragmentDoc = gql`
    fragment PhotoV2WithoutBlurHash on PagePhoto {
  ... on Photo {
    id
    url
    width
    height
    altTag
    layout {
      ...PhotoLayout
    }
    transform {
      ...PhotoTransform
    }
  }
  ... on DefaultPagePhoto {
    id
    url
    width
    height
    altTag
    layout {
      ...PhotoLayoutV2
    }
  }
}
    ${PhotoLayoutFragmentDoc}
${PhotoTransformFragmentDoc}
${PhotoLayoutV2FragmentDoc}`;
export const PhotoWithoutBlurHashFragmentDoc = gql`
    fragment PhotoWithoutBlurHash on Photo {
  id
  url
  width
  height
  altTag
  layout {
    ...PhotoLayout
  }
  transform {
    ...PhotoTransform
  }
}
    ${PhotoLayoutFragmentDoc}
${PhotoTransformFragmentDoc}`;
export const WebsitePagePhotoPresentationCropInfoFragmentDoc = gql`
    fragment WebsitePagePhotoPresentationCropInfo on WebsitePagePhotoPresentationCropInfo {
  x
  y
  width
  height
  unit
}
    `;
export const WebsitePagePhotoPresentationFragmentDoc = gql`
    fragment WebsitePagePhotoPresentation on WebsitePagePhotoPresentation {
  id
  presentationLayout
  cropInfo {
    ...WebsitePagePhotoPresentationCropInfo
  }
}
    ${WebsitePagePhotoPresentationCropInfoFragmentDoc}`;
export const EventPageFragmentDoc = gql`
    fragment EventPage on EventPage {
  id
  type
  pageSlug
  pageTitle
  subTitle: pageSubTitleV0918
  disabled
  visibility
  isPageContainer
  photoV2 {
    ...PhotoV2WithoutBlurHash
  }
  mobilePhoto {
    ...PhotoWithoutBlurHash
  }
  photoPresentation {
    ...WebsitePagePhotoPresentation
  }
}
    ${PhotoV2WithoutBlurHashFragmentDoc}
${PhotoWithoutBlurHashFragmentDoc}
${WebsitePagePhotoPresentationFragmentDoc}`;
export const ContactCollectionEventFragmentDoc = gql`
    fragment ContactCollectionEvent on Event {
  id
  pages {
    ...EventPage
  }
  info {
    id
    dateV0918 {
      dateString(dateFormat: long)
    }
    ownerFirstName
    fianceeFirstName
  }
}
    ${EventPageFragmentDoc}`;
export const GuestFragmentDoc = gql`
    fragment Guest on Contact {
  id
  householdId
  firstName
  lastName
  email
  household {
    id
    displayName
    address {
      id
      address1
      address2
      country
      countryCode
      region
      city
      postalCode
      validated
    }
  }
  phoneNumber {
    id
    number
  }
  legacyAddressString
}
    `;
export const PostOfficeGenericEmailDraftFragmentDoc = gql`
    fragment PostOfficeGenericEmailDraft on PostOfficeGenericEmailDraft {
  id
  eventId
  subject
  replyToEmail
  message
  imageUrl
  includeAppInstructions
  includeWebsiteDetails
  includeEventPassword
  personIds
  salutation
  includeGuestNames
}
    `;
export const PostOfficeReminderEmailDraftFragmentDoc = gql`
    fragment PostOfficeReminderEmailDraft on PostOfficeReminderEmailDraft {
  id
  eventId
  subject
  replyToEmail
  message
  imageUrl
  includeAppInstructions
  includeWebsiteDetails
  includeEventPassword
  personIds
  salutation
  includeGuestNames
}
    `;
export const PostOfficeThankYouEmailDraftFragmentDoc = gql`
    fragment PostOfficeThankYouEmailDraft on PostOfficeThankYouEmailDraft {
  id
  eventId
  subject
  replyToEmail
  message
  imageUrl
  personIds
  personEmails
  assetId
  containerId
}
    `;
export const PostOfficeDraftFragmentDoc = gql`
    fragment PostOfficeDraft on PostOfficeDraft {
  ...PostOfficeGenericEmailDraft
  ...PostOfficeReminderEmailDraft
  ...PostOfficeThankYouEmailDraft
}
    ${PostOfficeGenericEmailDraftFragmentDoc}
${PostOfficeReminderEmailDraftFragmentDoc}
${PostOfficeThankYouEmailDraftFragmentDoc}`;
export const CashFundGeneralErrorFragmentDoc = gql`
    fragment CashFundGeneralError on CashFundGeneralError {
  code
  nativeMessage
}
    `;
export const MonetaryValueFragmentDoc = gql`
    fragment MonetaryValue on MonetaryValue {
  valueInMinorUnits
  floatingPointDecimalString
  currency {
    code
    places
  }
}
    `;
export const CashFundOrderFragmentDoc = gql`
    fragment CashFundOrder on CashFundOrder {
  id
  status
  contributionAmount {
    ...MonetaryValue
  }
  totalTaxes {
    ...MonetaryValue
  }
  totalFees {
    ...MonetaryValue
  }
  total {
    ...MonetaryValue
  }
}
    ${MonetaryValueFragmentDoc}`;
export const PublicCashFundsHostFragmentDoc = gql`
    fragment PublicCashFundsHost on CashFundsHost {
  id
  firstName
  lastName
}
    `;
export const CashFundsPayoutAccountFragmentDoc = gql`
    fragment CashFundsPayoutAccount on CashFundsPayoutAccount {
  status
  onboardingUrl(params: {returnRoute: $returnRoute})
  balance {
    received {
      ...MonetaryValue
    }
    availablePending {
      ...MonetaryValue
    }
    available {
      ...MonetaryValue
    }
    withdrawnPending {
      ...MonetaryValue
    }
    withdrawn {
      ...MonetaryValue
    }
  }
  withdrawals {
    id
    status
  }
}
    ${MonetaryValueFragmentDoc}`;
export const CashFundPhotoFragmentDoc = gql`
    fragment CashFundPhoto on Photo {
  id
  url
}
    `;
export const PublicCashFundFragmentDoc = gql`
    fragment PublicCashFund on CashFund {
  id
  name
  note
  currencyCode
  publicTotalContributedAmount {
    ...MonetaryValue
  }
  publicTotalGoal {
    ...MonetaryValue
  }
  fixedContributionAmount {
    ...MonetaryValue
  }
  archived
  photo {
    ...CashFundPhoto
  }
}
    ${MonetaryValueFragmentDoc}
${CashFundPhotoFragmentDoc}`;
export const CashFundContributorFragmentDoc = gql`
    fragment CashFundContributor on CashFundContributor {
  id
  fullName
  email
}
    `;
export const CashFundContributionFragmentDoc = gql`
    fragment CashFundContribution on CashFundContribution {
  id
  amount {
    ...MonetaryValue
  }
  message
  status
  createdAt
  contributor {
    ...CashFundContributor
  }
  createdAt
}
    ${MonetaryValueFragmentDoc}
${CashFundContributorFragmentDoc}`;
export const AdminCashFundFragmentDoc = gql`
    fragment AdminCashFund on CashFund {
  ...PublicCashFund
  hideGoal
  totalGoal {
    ...MonetaryValue
  }
  totalContributedAmount {
    ...MonetaryValue
  }
  contributions {
    ...CashFundContribution
  }
}
    ${PublicCashFundFragmentDoc}
${MonetaryValueFragmentDoc}
${CashFundContributionFragmentDoc}`;
export const AdminCashFundsHostFragmentDoc = gql`
    fragment AdminCashFundsHost on CashFundsHost {
  ...PublicCashFundsHost
  payoutAccount {
    ...CashFundsPayoutAccount
  }
  cashFunds {
    ...AdminCashFund
  }
}
    ${PublicCashFundsHostFragmentDoc}
${CashFundsPayoutAccountFragmentDoc}
${AdminCashFundFragmentDoc}`;
export const CashFundInviteFragmentDoc = gql`
    fragment CashFundInvite on CashFundSolicitationInvite {
  id
  email
  fullName
  guestKey
}
    `;
export const CashFundSolicitationFragmentDoc = gql`
    fragment CashFundSolicitation on CashFundSolicitation {
  id
  name
  status
  inviteSubject
  inviteMessage
  config {
    photo {
      ...CashFundPhoto
    }
    buttonText
    salutation
    includeRecipientNames
  }
  invites {
    ...CashFundInvite
  }
}
    ${CashFundPhotoFragmentDoc}
${CashFundInviteFragmentDoc}`;
export const DashboardChecklistItemFragmentDoc = gql`
    fragment DashboardChecklistItem on ChecklistItem {
  id
  title
  subtitle
  action
  reminderAt
  completedAt
  subItems {
    id
    title
    action
    completedAt
  }
}
    `;
export const RegistryDataForResetFragmentDoc = gql`
    fragment RegistryDataForReset on Registry {
  id
  items {
    id
  }
  purchasedOrders {
    id
  }
  reservedOrders {
    id
  }
}
    `;
export const TransferredRegistryFragmentDoc = gql`
    fragment TransferredRegistry on Registry {
  id
  isTransferredType
}
    `;
export const PageDetailsFragmentDoc = gql`
    fragment PageDetails on EventPage {
  id
  pageTitle
  disabled
  photoV2 {
    ... on Photo {
      id
      height
      width
      url
      layout {
        alignX
        alignY
      }
    }
    ... on DefaultPagePhoto {
      id
      height
      width
      url
      layout {
        alignX
        alignY
      }
    }
  }
  type
  createdAt {
    timestamp
  }
  pageSlug
  visibility
  private
  isPageContainer
  photoPresentation {
    id
    cropInfo {
      height
      unit
      width
      x
      y
    }
    presentationLayout
  }
}
    `;
export const TravelSettingsMapComponentFragmentDoc = gql`
    fragment TravelSettingsMapComponent on TravelMapComponent {
  id
  __typename
  sortOrder
  hideExploreCTA
}
    `;
export const UsersV2UserFragmentDoc = gql`
    fragment UsersV2User on EventUser {
  id
  status
  user {
    id
    avatar {
      id
      url
    }
    email
    firstName
    lastName
  }
}
    `;
export const UsersV2PendingInviteFragmentDoc = gql`
    fragment UsersV2PendingInvite on CollaborationInvite {
  id
  eventId
  inviteeEmailAddress
  inviteeFirstName
  inviteeLastName
  senderUserId
  state
}
    `;
export const UserRatingFragmentDoc = gql`
    fragment UserRating on UserRating {
  ratingCount
  ratingValue
}
    `;
export const TravelDistanceBetweenPointsFragmentDoc = gql`
    fragment TravelDistanceBetweenPoints on TravelDistanceBetweenPoints {
  durationMinutes
  km
  mi
  type
}
    `;
export const TravelDistancesBetweenPointsResponseFragmentDoc = gql`
    fragment TravelDistancesBetweenPointsResponse on TravelDistancesBetweenPointsResponse {
  commonDistance {
    ...TravelDistanceBetweenPoints
  }
}
    ${TravelDistanceBetweenPointsFragmentDoc}`;
export const AccommodationRoomBlockFragmentDoc = gql`
    fragment AccommodationRoomBlock on AccommodationPlaceRoomBlock {
  bookingUrl
  checkInDate
  checkOutDate
  cutoffDate
  isJoyManagedRoomBlock
  numberOfRoomsReserved
  status
  pricePerNight
  strikeoutPricePerNight
}
    `;
export const AccommodationPlaceRecommendationFragmentDoc = gql`
    fragment AccommodationPlaceRecommendation on AccommodationPlaceRecommendation {
  id
  status
  whyThisHotelIsAGreatPick
  proposedNoteFromHostToGuest
  highlightTags
  venueGooglePlaceId
}
    `;
export const AccommodationPlaceV2FragmentDoc = gql`
    fragment AccommodationPlaceV2 on AccommodationPlaceV2 {
  id
  type
  userNote
  name
  description
  address
  city
  state
  postalCode
  country
  email
  phone
  url
  lat
  long
  photo {
    id
    url
  }
  isPhotoHidden
  zhId
  starRating
  userRating {
    ...UserRating
  }
  googlePlaceId
  isFavorite
  category
  isHostStayingHere
  createdByType
  joyPlaceId
  customPhoto {
    id
    url
  }
  customName
  customAddress
  customUrl
  customPhone
  isFromAccommodationCatalog
  isCustomLinkEnabled
  distances {
    ...TravelDistancesBetweenPointsResponse
  }
  accommodationRoomBlock {
    ...AccommodationRoomBlock
  }
  autoSuggestionRecommendation {
    ...AccommodationPlaceRecommendation
  }
  __typename
}
    ${UserRatingFragmentDoc}
${TravelDistancesBetweenPointsResponseFragmentDoc}
${AccommodationRoomBlockFragmentDoc}
${AccommodationPlaceRecommendationFragmentDoc}`;
export const AccommodationsInfoFragmentDoc = gql`
    fragment AccommodationsInfo on Event {
  id
  accommodationPlacesV2 {
    id
    ...AccommodationPlaceV2
  }
  info {
    id
    eventDisplayName
    ownerFirstName
    fianceeFirstName
    finalizedDate {
      dateString
    }
  }
  photo {
    id
    url
  }
  travelSettings {
    currencyCode
  }
  hotelRoomBlocks {
    id
    submittedDateTime
    eventDisplayName
    AnyOtherDetails
    PreferredContactMethod
    bookingLink
    leadStateV2
    leadStateV2UpdatedAt
    checkIn
    checkOut
    email
    numberOfRooms
    concierge {
      name
      email
      photo {
        id
        url
      }
    }
    destination {
      name
      lat
      long
      postalCode
      address
    }
  }
}
    ${AccommodationPlaceV2FragmentDoc}`;
export const DesignLayoutFragmentDoc = gql`
    fragment DesignLayout on DesignLayout {
  id
  layoutType
  name
}
    `;
export const ColorFragmentDoc = gql`
    fragment Color on Color {
  hex
  isLight
}
    `;
export const ThemeColorSchemeFragmentDoc = gql`
    fragment ThemeColorScheme on ThemeColorScheme {
  id
  colors {
    ...Color
  }
}
    ${ColorFragmentDoc}`;
export const DesignPreferenceRangeFragmentDoc = gql`
    fragment DesignPreferenceRange on DesignPreferenceRange {
  id
  featureName
  featureValueType
  rangeValue
  rangeMax
  rangeMin
  rangeStep
  supportsCustomization
}
    `;
export const DesignPreferenceColorFragmentDoc = gql`
    fragment DesignPreferenceColor on DesignPreferenceColor {
  id
  featureName
  featureValueType
  supportsCustomization
  colorValue {
    ...Color
  }
}
    ${ColorFragmentDoc}`;
export const ColorSetFragmentDoc = gql`
    fragment ColorSet on ColorSet {
  id
  color {
    ...Color
  }
}
    ${ColorFragmentDoc}`;
export const WebsiteEventColorsFragmentDoc = gql`
    fragment WebsiteEventColors on EventDesign {
  linkAndButtonColor
  artFontColor
  artBackgroundColor
  pageBackgroundColor
  pageFontColor
}
    `;
export const WebsiteHeaderPresentationSettingsFragmentDoc = gql`
    fragment WebsiteHeaderPresentationSettings on WebsiteHeaderPresentationSettings {
  id: eventId
  dataJSON
  schemaURL
  websiteLayout
}
    `;
export const CustomThemeFragmentDoc = gql`
    fragment CustomTheme on CustomTheme {
  id
  desktopThemeAsset {
    id
    assetURL
  }
  mobileThemeAsset {
    id
    assetURL
  }
}
    `;
export const EventDesignPreferenceColorPointerFragmentDoc = gql`
    fragment EventDesignPreferenceColorPointer on EventDesignPreferenceColorPointer {
  id
  featureName
  featureType
  colorPointer
  colorPointerPosition
}
    `;
export const EventDesignPreferenceRangeFragmentDoc = gql`
    fragment EventDesignPreferenceRange on EventDesignPreferenceRange {
  id
  featureId
  featureName
  featureType
  featureValueType
  rangeValue
}
    `;
export const EventDesignPreferenceBooleanFragmentDoc = gql`
    fragment EventDesignPreferenceBoolean on EventDesignPreferenceBoolean {
  id
  featureId
  featureName
  featureType
  featureValueType
  booleanValue
}
    `;
export const EventDesignFragmentDoc = gql`
    fragment EventDesign on EventDesign {
  id
  hasUnpublishedChanges
  hasVisitedDesignPage
  guestSiteTarget
  brannanNavigation
  useCustomTheme
  websiteLayout {
    ...DesignLayout
  }
  font {
    id
    display
    fontFamily
    textTransform
  }
  fonts {
    id
    category
    font {
      id
      fontFamily
      fontSize
      fontWeight
      firebaseFontKey
    }
    size
    sizePercent
  }
  theme {
    id
    themeId
    name
    colorSchemes {
      ...ThemeColorScheme
    }
    designLayouts {
      id
    }
    websiteLayoutBrannanSettings {
      brannanBackgroundTransparency {
        ...DesignPreferenceRange
        supportsCustomization
      }
    }
    websiteLayoutAlohaSettings {
      alohaColorPreference {
        ...DesignPreferenceColor
      }
      alohaTextColorPreference {
        ...DesignPreferenceColor
      }
    }
  }
  accent
  customCss
  colorPalette {
    ...ColorSet
  }
  ...WebsiteEventColors
  activeWebsiteHeaderPresentationLayout {
    ...WebsiteHeaderPresentationSettings
  }
  useCustomTheme
  customTheme {
    ...CustomTheme
  }
  designPreferences {
    ... on EventDesignPreferenceColorPointer {
      ...EventDesignPreferenceColorPointer
    }
    ... on EventDesignPreferenceRange {
      ...EventDesignPreferenceRange
    }
    ... on EventDesignPreferenceBoolean {
      ...EventDesignPreferenceBoolean
    }
  }
}
    ${DesignLayoutFragmentDoc}
${ThemeColorSchemeFragmentDoc}
${DesignPreferenceRangeFragmentDoc}
${DesignPreferenceColorFragmentDoc}
${ColorSetFragmentDoc}
${WebsiteEventColorsFragmentDoc}
${WebsiteHeaderPresentationSettingsFragmentDoc}
${CustomThemeFragmentDoc}
${EventDesignPreferenceColorPointerFragmentDoc}
${EventDesignPreferenceRangeFragmentDoc}
${EventDesignPreferenceBooleanFragmentDoc}`;
export const CustomPageThemeFragmentDoc = gql`
    fragment CustomPageTheme on Theme {
  id
  themeId
  supportsPrints
  printProviders {
    id
    printUrl
    stockPreviewUrl
    provider {
      id
      name
    }
  }
  marketingData {
    imageUrl
    variationType
  }
}
    `;
export const CustomPageEventDesignFragmentDoc = gql`
    fragment CustomPageEventDesign on EventDesign {
  ...EventDesign
  theme {
    ...CustomPageTheme
  }
}
    ${EventDesignFragmentDoc}
${CustomPageThemeFragmentDoc}`;
export const CustomPageMainPhotoFragmentDoc = gql`
    fragment CustomPageMainPhoto on Photo {
  id
  height
  width
  url
  assetId
}
    `;
export const CustomPageMainPhotoV2FragmentDoc = gql`
    fragment CustomPageMainPhotoV2 on PagePhoto {
  ... on Photo {
    id
    height
    width
    url
    assetId
  }
  ... on DefaultPagePhoto {
    id
    height
    width
    url
    assetId
  }
}
    `;
export const CustomPageMainPhotoAlignmentFragmentDoc = gql`
    fragment CustomPageMainPhotoAlignment on PhotoAlignmentValue {
  x
  y
}
    `;
export const CustomPagePhotoPresentationInfoFragmentDoc = gql`
    fragment CustomPagePhotoPresentationInfo on PageContainer {
  id
  mainPhotoCropInfo {
    unit
    height
    width
    x
    y
  }
  mainPhotoPresentationLayout
}
    `;
export const TextComponentFragmentDoc = gql`
    fragment TextComponent on TextComponent {
  id
  __typename
  type
  sortOrder
  text
}
    `;
export const TravelMapComponentFragmentDoc = gql`
    fragment TravelMapComponent on TravelMapComponent {
  id
  __typename
  type
  sortOrder
  blockOrdering
  hideExploreCTA
}
    `;
export const WebsiteEditorPhotoComponentFragmentDoc = gql`
    fragment WebsiteEditorPhotoComponent on PhotoComponent {
  id
  __typename
  type
  sortOrder
  photo {
    id
    url
    width
    height
  }
}
    `;
export const WebsiteEditorVideoComponentFragmentDoc = gql`
    fragment WebsiteEditorVideoComponent on VideoComponent {
  id
  __typename
  sortOrder
  type
  videoUrl
  caption
}
    `;
export const WebsiteEditorMediaGalleryComponentFragmentDoc = gql`
    fragment WebsiteEditorMediaGalleryComponent on MediaGalleryComponent {
  id
  __typename
  sortOrder
  type
  mediaCollection {
    id
    name
    thumbnails {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          width
          height
        }
      }
    }
  }
}
    `;
export const EventCountdownComponentFragmentDoc = gql`
    fragment EventCountdownComponent on EventCountdownComponent {
  id
  __typename
  type
  sortOrder
}
    `;
export const EventDetailsComponentFragmentDoc = gql`
    fragment EventDetailsComponent on EventDetailsComponent {
  id
  __typename
  type
  sortOrder
}
    `;
export const RsvpAndUnlockGuestDetailsButtonComponentFragmentDoc = gql`
    fragment RsvpAndUnlockGuestDetailsButtonComponent on RsvpAndUnlockGuestDetailsButtonComponent {
  id
  __typename
  type
  sortOrder
}
    `;
export const JsonDataContainerFragmentDoc = gql`
    fragment JsonDataContainer on JsonDataContainer {
  id
  eventId
  content
  type
  schemaUrl
}
    `;
export const JsonDataBlobComponentFragmentDoc = gql`
    fragment JsonDataBlobComponent on JsonDataBlobComponent {
  id
  __typename
  type
  sortOrder
  jsonDataContainerId
  containerContent {
    ...JsonDataContainer
  }
}
    ${JsonDataContainerFragmentDoc}`;
export const CustomPageContainerFragmentDoc = gql`
    fragment CustomPageContainer on PageContainer {
  id
  title
  slug
  note
  visibility
  sortOrder
  contentType
  mainPhotoV2 {
    ...CustomPageMainPhotoV2
  }
  mainPhotoAlignment {
    ...CustomPageMainPhotoAlignment
  }
  ...CustomPagePhotoPresentationInfo
  components {
    ...TextComponent
    ...TravelMapComponent
    ...WebsiteEditorPhotoComponent
    ...WebsiteEditorVideoComponent
    ...WebsiteEditorMediaGalleryComponent
    ...EventCountdownComponent
    ...EventDetailsComponent
    ...RsvpAndUnlockGuestDetailsButtonComponent
    ...JsonDataBlobComponent
  }
}
    ${CustomPageMainPhotoV2FragmentDoc}
${CustomPageMainPhotoAlignmentFragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}
${TextComponentFragmentDoc}
${TravelMapComponentFragmentDoc}
${WebsiteEditorPhotoComponentFragmentDoc}
${WebsiteEditorVideoComponentFragmentDoc}
${WebsiteEditorMediaGalleryComponentFragmentDoc}
${EventCountdownComponentFragmentDoc}
${EventDetailsComponentFragmentDoc}
${RsvpAndUnlockGuestDetailsButtonComponentFragmentDoc}
${JsonDataBlobComponentFragmentDoc}`;
export const TravelItemIdsFragmentDoc = gql`
    fragment TravelItemIds on EventTravel {
  ... on Flight {
    id
  }
  ... on EventTravelList {
    id
  }
  ... on EventTravelNote {
    id
  }
  ... on EventTravelBookingType {
    id
  }
  ... on RentalCar {
    id
  }
  ... on Taxi {
    id
  }
  ... on Train {
    id
  }
  ... on Ferry {
    id
  }
  ... on Shuttle {
    id
  }
  ... on Hotel {
    id
  }
  ... on Tent {
    id
  }
  ... on RentalHome {
    id
  }
}
    `;
export const WebsiteOverviewChecklistItemFragmentDoc = gql`
    fragment WebsiteOverviewChecklistItem on ChecklistItem {
  id
  title
  action
  subItems {
    id
    title
    action
    completedAt
  }
}
    `;
export const FormFieldsFragmentDoc = gql`
    fragment FormFields on Form {
  id
  title
  description
  schemaUrl
  config
  settings
  eventId
  enabled
}
    `;
export const SaveTheDateGuestElectronicCardFragmentDoc = gql`
    fragment SaveTheDateGuestElectronicCard on ElectronicCard {
  id
  title
  subTitle
  message
  linkOptionPrimary
  linkOptionSecondary
  locationStringFormat
  displayDateFormat
  coupleNameFormat
  displayEventLink
  eventId
  householdDisplayName
  type
  guidId
  photoEcardTheme
  photo {
    id
    url
    assetId
    width
    height
  }
  photoEcardThemePositionX
  photoEcardThemePositionY
  photoEcardThemeScale
}
    `;
export const SaveTheDateElectronicCardFragmentDoc = gql`
    fragment SaveTheDateElectronicCard on ElectronicCard {
  ...SaveTheDateGuestElectronicCard
  additionalMessage
  locationString
  displayDateString
}
    ${SaveTheDateGuestElectronicCardFragmentDoc}`;
export const SaveTheDateEcardEmailDraftFragmentDoc = gql`
    fragment SaveTheDateEcardEmailDraft on ElectronicCardEcardEmailDraft {
  id
  replyToEmail
  salutation
  includeGuestNames
  includeDate
  includeAddToCalendar
  message
  subject
  buttonText
  title
  subTitle
  imageUrl
}
    `;
export const DomainDataFragmentDoc = gql`
    fragment DomainData on Event {
  id
  domain {
    id
    domainName
  }
  website
}
    `;
export const SaveTheDateGuestEventByIdDataFragmentDoc = gql`
    fragment SaveTheDateGuestEventByIdData on Event {
  id
  info {
    id
    date
    eventPassword
    location
    ownerFirstName
    ownerFullName
    fianceeFirstName
    fianceeFullName
    eventDisplayName
    locationInfo {
      id
      city
      state
      country
    }
  }
  eventDesign {
    id
    accent
  }
  settings {
    id
    privacyMode
  }
  pages(admin: true, filterStoryTidbitsOnAloha: true) {
    ...EventPage
  }
  ...DomainData
}
    ${EventPageFragmentDoc}
${DomainDataFragmentDoc}`;
export const SaveTheDateEventByIdDataFragmentDoc = gql`
    fragment SaveTheDateEventByIdData on Event {
  ...SaveTheDateGuestEventByIdData
  photo {
    id
    url
  }
  pages(admin: true, filterStoryTidbitsOnAloha: true) {
    ...EventPage
  }
}
    ${SaveTheDateGuestEventByIdDataFragmentDoc}
${EventPageFragmentDoc}`;
export const StationeryPrintOrderShippingAddressFragmentDoc = gql`
    fragment StationeryPrintOrderShippingAddress on StationeryPrintOrderShippingAddress {
  address1
  address2
  city
  country
  countryCode
  name
  postalCode
  region
}
    `;
export const CardThemeMarketingDataFragmentDoc = gql`
    fragment CardThemeMarketingData on ThemeMarketingData {
  id: variantThemeId
  themeId: variantThemeId
  thumbnailUrl: imageUrl
  name: variantName
  variationType
  theme {
    id
    themeId
    name
  }
}
    `;
export const StationeryPageInfoFragmentDoc = gql`
    fragment StationeryPageInfo on StationeryPageInfo {
  hasNextPage
  hasPreviousPage
  endCursor
  startCursor
}
    `;
export const StationeryDesignGalleryTemplateFragmentDoc = gql`
    fragment StationeryDesignGalleryTemplate on StationeryTemplate {
  id
  category
  approved
  enabled
  name
  themeId
  thumbnailUrl
  premium
  tags
  isFavorite
  widthInches
  heightInches
  themeJSON
}
    `;
export const StationeryDesignGalleryFilterTagsFragmentDoc = gql`
    fragment StationeryDesignGalleryFilterTags on StationeryTag {
  category
  displayLabel
  name
  thumbnailUrl
}
    `;
export const EventScheduleForStationeryFragmentDoc = gql`
    fragment EventScheduleForStationery on EventSchedule {
  id
  placeId
  location
  startTime {
    milliseconds
    timezone
  }
}
    `;
export const StationeryShippingOptionsPricingFragmentDoc = gql`
    fragment StationeryShippingOptionsPricing on StationeryProductShippingOptionV1 {
  pricing {
    ... on StationeryFlatFeePricing {
      priceInMinorUnits
    }
    ... on StationeryTieredFlatFeePricing {
      priceTiers {
        minQuantity
        totalPriceInMinorUnits
      }
    }
    ... on StationeryTieredPricing {
      priceTiers {
        minQuantity
        unitPriceInMinorUnits
      }
    }
  }
}
    `;
export const StationeryShippingConstraintsFragmentDoc = gql`
    fragment StationeryShippingConstraints on StationeryProductShippingOptionV1 {
  constraints {
    ... on StationeryAllowPoBoxShippingConstraint {
      allowPoBox
    }
    ... on StationeryCountryShippingConstraint {
      includedCountries
      excludedCountries
    }
    ... on StationeryQuantityShippingConstraint {
      minQuantity
      maxQuantity
    }
  }
}
    `;
export const ShippingOptionV1FragmentDoc = gql`
    fragment ShippingOptionV1 on StationeryProductShippingOptionV1 {
  id
  ...StationeryShippingOptionsPricing
  ...StationeryShippingConstraints
}
    ${StationeryShippingOptionsPricingFragmentDoc}
${StationeryShippingConstraintsFragmentDoc}`;
export const StationeryShippingOptionsFragmentDoc = gql`
    fragment StationeryShippingOptions on StationeryProduct {
  id
  shippingOptions {
    ... on StationeryProductShippingOptionV1 {
      ...ShippingOptionV1
    }
  }
}
    ${ShippingOptionV1FragmentDoc}`;
export const StationeryProductAttributePricingsFragmentDoc = gql`
    fragment StationeryProductAttributePricings on StationeryProductAttributeOption {
  pricing {
    ... on StationeryTieredPricing {
      priceTiers {
        minQuantity
        unitPriceInMinorUnits
      }
    }
    ... on StationeryTieredFlatFeePricing {
      priceTiers {
        minQuantity
        totalPriceInMinorUnits
      }
    }
    ... on StationeryFlatFeePricing {
      priceInMinorUnits
    }
  }
}
    `;
export const StationeryProductAttributesFragmentDoc = gql`
    fragment StationeryProductAttributes on StationeryProduct {
  id
  attributes {
    attributeId
    attributeOptions {
      ...StationeryProductAttributePricings
      attributeOption {
        attributeId
        id
      }
    }
  }
}
    ${StationeryProductAttributePricingsFragmentDoc}`;
export const StationeryProductPricingsFragmentDoc = gql`
    fragment StationeryProductPricings on StationeryProduct {
  id
  priceCurrency
  pricing {
    ... on StationeryTieredPricing {
      priceTiers {
        minQuantity
        unitPriceInMinorUnits
      }
    }
    ... on StationeryTieredFlatFeePricing {
      priceTiers {
        minQuantity
        totalPriceInMinorUnits
      }
    }
    ... on StationeryFlatFeePricing {
      priceInMinorUnits
    }
  }
}
    `;
export const StationeryProductVariantGroupsFragmentDoc = gql`
    fragment StationeryProductVariantGroups on StationeryProduct {
  id
  variantGroups {
    vendorSKU
    options {
      id
      attributeId
    }
    id
  }
}
    `;
export const OrderProductDetailsFragmentDoc = gql`
    fragment OrderProductDetails on StationeryPrintOrder {
  product {
    id
    priceConfigId
    vendor
    productType
    vendorBaseSKU
    ...StationeryShippingOptions
    ...StationeryProductAttributes
    ...StationeryProductPricings
    ...StationeryProductVariantGroups
  }
}
    ${StationeryShippingOptionsFragmentDoc}
${StationeryProductAttributesFragmentDoc}
${StationeryProductPricingsFragmentDoc}
${StationeryProductVariantGroupsFragmentDoc}`;
export const OrderSelectedProductInfoFragmentDoc = gql`
    fragment OrderSelectedProductInfo on StationeryPrintOrder {
  id
  selectedProduct {
    attributes {
      attributeId
      optionId
    }
  }
}
    `;
export const StationeryPrintOrderDetailsFragmentDoc = gql`
    fragment StationeryPrintOrderDetails on StationeryPrintOrder {
  id
  eventId
  ownerId
  createdAt
  vendor
  ...OrderProductDetails
  ...OrderSelectedProductInfo
  currentStatus
  statusHistory {
    id
    orderId
    status
    date
  }
  deliveryMethod
  quantity
  priceInMinorUnits
  taxInMinorUnits
  currencyConversionData
  currencyISO4217
  shippingAddress {
    name
    address1
    address2
    city
    postalCode
    region
    country
    countryCode
  }
  printPayment {
    id
    paid
    paidAt
    paymentInfo {
      creditCardBrand
      creditCardLast4
    }
  }
  cardDraft {
    id
    format
    stationeryTemplate {
      id
      name
      themeId
      category
    }
  }
  cardDraftJSONBlob
  digitalFeatures
  orderNumber
  trackingNumbers {
    trackingUrl
  }
  printCardFrontPreviewUrl
  printCardBackPreviewUrl
  envelopeFrontImageUrl
  envelopeBackImageUrl
  stationeryPDFUrl
  envelopePDFUrl
  state
  refunds {
    refundAmountInMinorUnits
  }
  discount {
    code
    discountAmountInMinorUnits: amountInMinorUnits
    discountPercentage: percentage
  }
  designSetName
  magnetCard
  issues {
    id
    resolvedAt
    issueType
    issueTarget
    additionalUserFacingDescription
  }
}
    ${OrderProductDetailsFragmentDoc}
${OrderSelectedProductInfoFragmentDoc}`;
export const StationeryPrintOrderFieldsFragmentDoc = gql`
    fragment StationeryPrintOrderFields on StationeryPrintOrder {
  id
  createdAt
  priceInMinorUnits
  quantity
  cardDraft {
    id
    ownerId
    eventId
    stationeryTemplate {
      id
      themeId
      category
    }
  }
  deliveryMethod
  printPayment {
    id
    stationeryPrintOrderId
    salesOrderId
    paid
    paidAt
  }
  currentStatus
  shippingAddress {
    name
    address1
    address2
    city
    region
    postalCode
    country
    countryCode
  }
  orderNumber
  ownerId
  eventId
  designSetName
  issues {
    id
    resolvedAt
    issueType
    issueTarget
    additionalUserFacingDescription
  }
  printCardFrontPreviewUrl
  printCardBackPreviewUrl
  vendor
}
    `;
export const MessageInfoFragmentDoc = gql`
    fragment MessageInfo on ContactQuarantinedMessageBatchDetails {
  id
  createdAt
  updatedAt
  messageBatchType
  messageBatchId
  eventId
  messageBatchPayload
  spamIndicatorsPayload
  quarantineStatus
  reviewedAt
  reviewedByUserId
}
    `;
export const MessageInfoCursorFragmentDoc = gql`
    fragment MessageInfoCursor on ContactQuarantinedMessageBatchEdge {
  cursor
}
    `;
export const ElectronicCardCardLinkOptionFragmentDoc = gql`
    fragment ElectronicCardCardLinkOption on ElectronicCardCardLinkOption {
  name
  label
}
    `;
export const PrintProviderFragmentDoc = gql`
    fragment PrintProvider on PrintProvider {
  id
  name
  website
  logoUrl
}
    `;
export const PrintProviderThemeFragmentDoc = gql`
    fragment PrintProviderTheme on PrintProviderTheme {
  id
  provider {
    ...PrintProvider
  }
  stockPreviewUrl
  printUrl
}
    ${PrintProviderFragmentDoc}`;
export const DesignPreferenceBooleanFragmentDoc = gql`
    fragment DesignPreferenceBoolean on DesignPreferenceBoolean {
  id
  featureName
  featureValueType
  booleanValue
}
    `;
export const ThemeFragmentDoc = gql`
    fragment Theme on Theme {
  id
  name
  themeId
  description
  expiration {
    unixTimestamp
  }
  supportsPrints
  supportsEcards
  thumbnailUrl
  designLayouts {
    ...DesignLayout
  }
  colorSchemes {
    ...ThemeColorScheme
  }
  printProviders {
    ...PrintProviderTheme
  }
  websiteLayoutAlohaSettings {
    alohaColorPreference {
      ...DesignPreferenceColor
      supportsCustomization
    }
  }
  websiteLayoutBrannanSettings {
    brannanColorPreference {
      ...DesignPreferenceColor
      supportsCustomization
    }
    brannanInnerFrameBorder {
      ...DesignPreferenceBoolean
      supportsCustomization
    }
    brannanBackgroundTransparency {
      ...DesignPreferenceRange
      supportsCustomization
    }
  }
  marketingData {
    vendor
    variationType
    tags
  }
}
    ${DesignLayoutFragmentDoc}
${ThemeColorSchemeFragmentDoc}
${PrintProviderThemeFragmentDoc}
${DesignPreferenceColorFragmentDoc}
${DesignPreferenceBooleanFragmentDoc}
${DesignPreferenceRangeFragmentDoc}`;
export const EcardEventDesignFragmentDoc = gql`
    fragment EcardEventDesign on EventDesign {
  ...EventDesign
  theme {
    ...Theme
  }
}
    ${EventDesignFragmentDoc}
${ThemeFragmentDoc}`;
export const EcardDesignFragmentDoc = gql`
    fragment EcardDesign on EcardDesign {
  theme {
    ...Theme
  }
}
    ${ThemeFragmentDoc}`;
export const ElectronicCardFragmentDoc = gql`
    fragment ElectronicCard on ElectronicCard {
  id
  title
  subTitle
  message
  additionalMessage
  linkOptionPrimary
  linkOptionSecondary
  locationString
  displayDateFormat
  displayDateString
  displayEventLink
  eventId
  event {
    id
  }
  householdDisplayName
  type
  design {
    ...EcardDesign
    shouldUseEventDesign
  }
  guidId
  photoEcardTheme
  photo {
    id
    url
    assetId
    width
    height
  }
  photoEcardThemePositionX
  photoEcardThemePositionY
  photoEcardThemeScale
}
    ${EcardDesignFragmentDoc}`;
export const EcardEmailDraftFragmentDoc = gql`
    fragment EcardEmailDraft on ElectronicCardEcardEmailDraft {
  id
  ecardId
  ecardType
  replyToEmail
  salutation
  includeGuestNames
  includeDate
  includeAddToCalendar
  message
  subject
  buttonText
  title
  subTitle
  imageUrl
}
    `;
export const GetEventCTAPageInfoFragmentDoc = gql`
    fragment GetEventCTAPageInfo on EventPageInfo {
  id
  private
  disabled
  type
}
    `;
export const GetEventCTASessionFragmentDoc = gql`
    fragment GetEventCTASession on EventSession {
  id
  hasUnlocked
  hasIdentity
  eventCTA {
    rsvpIsEnabled
    scheduleHasInviteOnlyItems
    requiresPassword
    label
    rsvpIsCompleted
    rsvpAttendanceStatus
  }
  person {
    id
    fullName
    firstName
    avatarName
    email
  }
}
    `;
export const GuestTextComponentFragmentDoc = gql`
    fragment GuestTextComponent on TextComponent {
  id
  text
  sortOrder
  type
}
    `;
export const GuestEventDetailsComponentFragmentDoc = gql`
    fragment GuestEventDetailsComponent on EventDetailsComponent {
  id
  sortOrder
  type
}
    `;
export const GuestRsvpAndUnlockGuestDetailsButtonComponentFragmentDoc = gql`
    fragment GuestRsvpAndUnlockGuestDetailsButtonComponent on RsvpAndUnlockGuestDetailsButtonComponent {
  id
  sortOrder
  type
}
    `;
export const GuestPhotoComponentFragmentDoc = gql`
    fragment GuestPhotoComponent on PhotoComponent {
  id
  type
  sortOrder
  photo {
    id
    url
  }
}
    `;
export const GuestVideoComponentFragmentDoc = gql`
    fragment GuestVideoComponent on VideoComponent {
  id
  sortOrder
  type
  videoUrl
  caption
}
    `;
export const GuestTravelMapComponentFragmentDoc = gql`
    fragment GuestTravelMapComponent on TravelMapComponent {
  id
  sortOrder
  blockOrdering
  hideExploreCTA
}
    `;
export const GuestMediaGalleryComponentFragmentDoc = gql`
    fragment GuestMediaGalleryComponent on MediaGalleryComponent {
  id
  sortOrder
  type
  mediaCollection {
    id
    name
    magicTokenPermissions
    media {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          width
          height
        }
      }
    }
  }
}
    `;
export const GuestJsonDataBlobComponentFragmentDoc = gql`
    fragment GuestJsonDataBlobComponent on JsonDataBlobComponent {
  id
  __typename
  type
  sortOrder
  jsonDataContainerId
  containerContent {
    ...JsonDataContainer
  }
}
    ${JsonDataContainerFragmentDoc}`;
export const PricingByPropertyIdFragmentDoc = gql`
    fragment PricingByPropertyId on TravelPricingByPropertyIdItem {
  __typename
  property {
    __typename
    joyPlaceId
  }
  pricingData {
    __typename
    perNightOriginalAmountBeforeTaxesAndFees {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    perNightFinalAmountBeforeTaxesAndFees {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    originalAmount {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
}
    `;
export const TravelPlacePricingAndBookingDetailsFragmentDoc = gql`
    fragment TravelPlacePricingAndBookingDetails on AccommodationPlacePricingAndBookingDetails {
  __typename
  accommodationPlace {
    __typename
    id
    lat
    long
    googlePlaceId
    joyPlaceId
    name
    address
    zhId
    url
    customUrl
    starRating
    photo {
      id
      url
    }
  }
  pricingInfo {
    baseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    nightlyBaseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    nightlyTotalRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    strikeoutBaseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    strikeoutNightlyBaseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    strikeoutNightlyTotalRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    strikeoutRateProvider
    strikeoutTotalRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    totalRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
  redirectMechanisms {
    __typename
    telemetryDestinationName
    trackingQueryStringKey
    type
    url
  }
}
    `;
export const TravelJoyPlacePricingAndBookingDetailsFragmentDoc = gql`
    fragment TravelJoyPlacePricingAndBookingDetails on JoyPlacePricingAndBookingDetails {
  __typename
  joyPlace {
    __typename
    id
    lat
    long
    googlePlaceId
    name
    address
    zhId
    url
  }
  pricingInfo {
    __typename
    nightlyBaseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    strikeoutNightlyBaseRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    totalRate {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
  redirectMechanisms {
    __typename
    telemetryDestinationName
    trackingQueryStringKey
    type
    url
  }
}
    `;
export const PriceComparisonFragmentDoc = gql`
    fragment PriceComparison on TravelPlaceComparison {
  id: joyPlaceId
  joyPlaceId
  providers {
    providerFQDN
    providerSearchURL
    nightlyBaseRate {
      currency
      valueInMinorUnits
      floatingPointDecimalString
      digits
    }
  }
}
    `;
export const GetGuestSiteScheduleCTASessionFragmentDoc = gql`
    fragment GetGuestSiteScheduleCTASession on EventSession {
  id
  hasUnlocked
  eventCTA {
    scheduleHasInviteOnlyItems
  }
  person {
    id
    fullName
  }
}
    `;
export const CashFundPayerFragmentDoc = gql`
    fragment CashFundPayer on CashFundPayer {
  email
  fullName
  message
}
    `;
export const CashFundPaymentAttemptFragmentDoc = gql`
    fragment CashFundPaymentAttempt on CashFundPaymentAttempt {
  id
  amount {
    ...MonetaryValue
  }
  payer {
    ...CashFundPayer
  }
  createdAt
}
    ${MonetaryValueFragmentDoc}
${CashFundPayerFragmentDoc}`;
export const GetCustomPagesVisibilitiesFragmentDoc = gql`
    fragment GetCustomPagesVisibilities on EventPageInfo {
  id
  page {
    id
    pageSlug
    visibility
  }
}
    `;
export const DateFragmentDoc = gql`
    fragment Date on Date {
  timestamp
  timezone
  milliseconds
}
    `;
export const DonationFundDonationFragmentDoc = gql`
    fragment DonationFundDonation on DonationFundDonation {
  id
  name
  email
  note
  amount {
    ...MonetaryValue
  }
  orderedAt {
    ...Date
  }
  platformType
}
    ${MonetaryValueFragmentDoc}
${DateFragmentDoc}`;
export const DonationFundPlatformFragmentDoc = gql`
    fragment DonationFundPlatform on DonationFundPlatform {
  id
  type
  name
  link
  username
}
    `;
export const DonationFundFragmentDoc = gql`
    fragment DonationFund on DonationFund {
  id
  donations {
    ...DonationFundDonation
  }
  fundType
  goalMonetaryValue {
    ...MonetaryValue
  }
  suggestedDonationMonetaryValue {
    ...MonetaryValue
  }
  suggestedQuantityStillNeeded
  donationsAreCapped
  enforceSuggestedDonationAmount
  hideFundingGoal
  platform {
    ...DonationFundPlatform
  }
  photos {
    id
    url
  }
  progressToGoal {
    ...MonetaryValue
  }
  amountTillGoalIsReached {
    ...MonetaryValue
  }
  progressToGoalPercent
  fpIndex
  title
  url
  description
  enableCashOrCheck
  enableAppPlatform
  enableJoyCredit
  currency {
    code
    id
    displayName
  }
  mustHave
}
    ${DonationFundDonationFragmentDoc}
${MonetaryValueFragmentDoc}
${DonationFundPlatformFragmentDoc}`;
export const RegistryItemFragmentDoc = gql`
    fragment RegistryItem on RegistryItem {
  id
  isGroupGiftingEnabled
  isGetCashEquivalent
  createAt {
    milliseconds
    timestamp
    timezone
  }
  note
  externallyOwned
  canEditProductData
  storeName
  productData {
    registryItem {
      id
    }
    brand
    customType
    title
    externalUrl
    checkoutUrl
    pdpUrl
    description
    price: priceAugmented {
      currency {
        id
        code
        places
      }
      valueInMinorUnits
      floatingPointDecimalString
    }
    fullPrice {
      ...MonetaryValue
    }
    isFullPrice
    photos {
      id
      url
    }
    legacyType
  }
  fpIndex
  stillNeeded
  alreadyPurchased
  alreadyReserved
  totalRequested
  donationFund {
    ...DonationFund
  }
  isHidden
  mustHave
}
    ${MonetaryValueFragmentDoc}
${DonationFundFragmentDoc}`;
export const LineItemFragmentDoc = gql`
    fragment LineItem on LineItem {
  locator
  quantity
  lineTags {
    key
    value
  }
  registryItem {
    id
  }
  lineItemData {
    donationFundPlatformType
    correctedQuantity
  }
  annotations {
    isEdelivery
  }
  frozenProductData {
    title
    customType
    price {
      currency {
        id
        code
        places
      }
      valueInMinorUnits
      floatingPointDecimalString
    }
    photos {
      id
      url
    }
  }
  isGetCashEquivalent
}
    `;
export const RegistryFulfillmentShipmentTrackingInformationFragmentDoc = gql`
    fragment RegistryFulfillmentShipmentTrackingInformation on RegistryFulfillmentShipmentTrackingInformation {
  url
  company
  trackingNumber
}
    `;
export const RegistryFulfillmentShipmentFragmentDoc = gql`
    fragment RegistryFulfillmentShipment on RegistryFulfillmentShipment {
  trackingInformation {
    ...RegistryFulfillmentShipmentTrackingInformation
  }
}
    ${RegistryFulfillmentShipmentTrackingInformationFragmentDoc}`;
export const RegistryFulfillmentFragmentDoc = gql`
    fragment RegistryFulfillment on RegistryFulfillment {
  status
  statusPageUrl
  orderNumber
  shipments {
    ...RegistryFulfillmentShipment
  }
}
    ${RegistryFulfillmentShipmentFragmentDoc}`;
export const RegistryOrderFragmentDoc = gql`
    fragment RegistryOrder on RegistryOrder {
  id
  name
  email
  note
  isPurchased
  isDropship
  orderTags {
    key
    value
  }
  orderedAt {
    ...Date
  }
  lineItems {
    ...LineItem
  }
  fulfillment {
    ...RegistryFulfillment
  }
  status
  shippingAddress {
    hash
    name
    address1
    address2
    city
    state
    postalCode
    country
    countryCode
  }
}
    ${DateFragmentDoc}
${LineItemFragmentDoc}
${RegistryFulfillmentFragmentDoc}`;
export const RegistryFragmentDoc = gql`
    fragment Registry on Registry {
  id
  nameV0204
  urlV0204
  imageUrlV0204
  wantSync
  type
  isStandalonesType
  isSyncingType
  isTransferredType
  transferredRegistryData {
    transferredAt {
      ...Date
      dateString
    }
    lastPublicCheck {
      checkedAt {
        ...Date
      }
      isPublic
    }
  }
  storeName
  cannotSync
  hasItems
  lastSyncAt {
    timestamp
  }
  items {
    ...RegistryItem
  }
  myReservedOrders {
    ...RegistryOrder
  }
  myPurchasedOrders {
    ...RegistryOrder
  }
  mySession {
    email
  }
}
    ${DateFragmentDoc}
${RegistryItemFragmentDoc}
${RegistryOrderFragmentDoc}`;
export const AdminRegistryFragmentDoc = gql`
    fragment AdminRegistry on Registry {
  ...Registry
  recommendationStatus
  orders {
    ...RegistryOrder
  }
}
    ${RegistryFragmentDoc}
${RegistryOrderFragmentDoc}`;
export const DraftItemFragmentDoc = gql`
    fragment DraftItem on RegistryItem {
  id
  storeName
  totalRequested
  productData {
    title
    price {
      currency {
        code
        places
      }
      floatingPointDecimalString
    }
    photos {
      id
      url
    }
    registryItem {
      id
    }
  }
}
    `;
export const RegistryWithDraftItemsFragmentDoc = gql`
    fragment RegistryWithDraftItems on Registry {
  id
  storeName
  draftItems {
    ...DraftItem
  }
}
    ${DraftItemFragmentDoc}`;
export const CatalogBrandPromoFragmentDoc = gql`
    fragment CatalogBrandPromo on ProductCatalogBrandPromo {
  brand {
    id
    name
    publicUrlPath
  }
  customRedirectUrl
  mobileImage {
    id
    url
  }
  image {
    id
    url
  }
}
    `;
export const CompletionDiscountItemFragmentDoc = gql`
    fragment CompletionDiscountItem on DiscountedRegistryItem {
  __typename
  registryItem {
    id
    stillNeeded
    productData {
      title
      price {
        valueInMinorUnits
        currency {
          code
        }
        floatingPointDecimalString
      }
      photos {
        id
        url
      }
      registryItem {
        id
      }
    }
  }
  discountDetails {
    eligible
    discountedPrice {
      valueInMinorUnits
    }
  }
}
    `;
export const AdminExternalRegistriesToSetTransferredToPrivateFragmentDoc = gql`
    fragment AdminExternalRegistriesToSetTransferredToPrivate on Registry {
  id
  urlV0204
  isTransferredType
  transferredRegistryData {
    lastPublicCheck {
      checkedAt {
        ...Date
      }
      isPublic
    }
  }
  storeName
}
    ${DateFragmentDoc}`;
export const AdminExternalRegistryFragmentDoc = gql`
    fragment AdminExternalRegistry on Registry {
  id
  nameV0204
  urlV0204
  imageUrlV0204
  wantSync
  isStandalonesType
  isSyncingType
  isTransferredType
  transferredRegistryData {
    transferredAt {
      ...Date
      dateString
    }
    lastPublicCheck {
      checkedAt {
        ...Date
      }
      isPublic
    }
  }
  storeName
  lastSyncAt {
    timestamp
  }
  cannotSync
  hasItems
  recommendationStatus
  items {
    id
  }
  type
}
    ${DateFragmentDoc}`;
export const ProductCatalogCollectionMembersFragmentDoc = gql`
    fragment ProductCatalogCollectionMembers on ProductCatalogEntityItem {
  id
  catalogItemData {
    id
    brand {
      id
      name
    }
    photos {
      id
      url
    }
    price {
      valueInMinorUnits
      floatingPointDecimalString
      currency {
        code
      }
    }
    title
    itemType
    productUrl
    rating {
      id
      stats {
        totalReviewCount
        averageRating
      }
    }
  }
}
    `;
export const CatalogProductSharedDisplayFieldsFragmentDoc = gql`
    fragment CatalogProductSharedDisplayFields on ProductCatalogItem {
  id
  title
  itemType
  brand {
    id
    name
    publicUrlPath
  }
  photos {
    id
    url
  }
  productUrl
  price {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  fullPrice {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  storefrontInfo {
    storefrontStatus
    canAddToCart
    canAddToRegistry
  }
  rating {
    id
    stats {
      id
      averageRating
      totalReviewCount
    }
  }
  isFullPrice
  tags
}
    `;
export const CatalogPdpDisplayFieldsFragmentDoc = gql`
    fragment CatalogPdpDisplayFields on ProductCatalogItem {
  ...CatalogProductSharedDisplayFields
  retailer {
    name
  }
  whyWeLoveIt
  shortDescription
  longDescription
  subCategories {
    id
    publicUrlPath
    title
  }
}
    ${CatalogProductSharedDisplayFieldsFragmentDoc}`;
export const CatalogPdpCollectionDisplayInfosFragmentDoc = gql`
    fragment CatalogPdpCollectionDisplayInfos on ProductCatalogItem {
  collectionDisplayInfos {
    id
    displayInfoId
    pdpSectionType
  }
}
    `;
export const CatalogPdpDimensionsFragmentDoc = gql`
    fragment CatalogPdpDimensions on ProductCatalogItem {
  groupDimensionOptions {
    id
    displayString
    swatchType
    swatchColor {
      hex
      rgba
      isLight
    }
    swatchUrl
    groupDimension {
      id
      title
    }
  }
  group {
    id
    groupDimensions {
      id
      title
      options {
        id
        displayString
        swatchType
        swatchColor {
          hex
          rgba
          isLight
        }
        swatchUrl
        groupDimension {
          id
          title
        }
      }
    }
    items {
      ...CatalogPdpDisplayFields
      ...CatalogPdpCollectionDisplayInfos
      rating @include(if: $withProductRating) {
        id
        stats {
          id
          averageRating
          totalReviewCount
        }
      }
      groupDimensionOptions {
        id
        displayString
        swatchType
        swatchColor {
          hex
          rgba
          isLight
        }
        swatchUrl
        groupDimension {
          id
          title
        }
      }
    }
  }
}
    ${CatalogPdpDisplayFieldsFragmentDoc}
${CatalogPdpCollectionDisplayInfosFragmentDoc}`;
export const ProductCatalogPhotoAssetFragmentDoc = gql`
    fragment ProductCatalogPhotoAsset on ProductCatalogPhotoAsset {
  __typename
  type
  photo {
    id
    url
  }
}
    `;
export const ProductCatalogVideoAssetFragmentDoc = gql`
    fragment ProductCatalogVideoAsset on ProductCatalogVideoAsset {
  __typename
  type
  video {
    url
    thumbnail {
      id
      url
    }
    fallbackImage {
      id
      url
    }
  }
}
    `;
export const CustomerReviewStatsFragmentDoc = gql`
    fragment CustomerReviewStats on RatingStats {
  __typename
  traits {
    id
    label
    averageRating
  }
  totalReviewCount
  averageRating
  distribution {
    id
    count
    ratingBucket
    percentage
  }
}
    `;
export const CustomerProductReviewFragmentDoc = gql`
    fragment CustomerProductReview on RatingReview {
  __typename
  id
  title
  description
  submittedAt {
    milliseconds
  }
  ratingBucket
  authorName
  syndicationSource: syndicationSourceV2 {
    id
    logoImage {
      id
      url
    }
    name
  }
  mediaAssets {
    ... on RatingReviewPhotoAsset {
      __typename
      photo {
        thumbnail {
          id
          url
        }
        normal {
          id
          url
        }
      }
    }
  }
}
    `;
export const ProductHeroContentFieldsFragmentDoc = gql`
    fragment ProductHeroContentFields on ProductHeroContent {
  id
  title
  eyebrow
  description
  watchVideoUrl
  gradientCustomColorValue
  textCustomColorValue
  storefront
  horizontalAlignment
  gradientMode
  textColorMode
  cta {
    text
    publicUrlPath
    redirectUrlType
  }
  desktopMedia {
    ... on ProductHeroImage {
      photo {
        image {
          id
          url
        }
      }
    }
    ... on ProductHeroVideo {
      video {
        videoUrl
        fallbackImage {
          id
          url
        }
      }
    }
  }
  tabletMedia {
    ... on ProductHeroImage {
      photo {
        image {
          id
          url
        }
      }
    }
    ... on ProductHeroVideo {
      video {
        videoUrl
        fallbackImage {
          id
          url
        }
      }
    }
  }
  mobileMedia {
    ... on ProductHeroImage {
      photo {
        image {
          id
          url
        }
      }
    }
    ... on ProductHeroVideo {
      video {
        videoUrl
        fallbackImage {
          id
          url
        }
      }
    }
  }
}
    `;
export const ScannedTransitionalRegistryStatusFragmentDoc = gql`
    fragment ScannedTransitionalRegistryStatus on TransitionalRegistry {
  id
  status
  scannedAt {
    dateString(dateFormat: long)
  }
}
    `;
export const TransitionalRegistryProductDataFragmentDoc = gql`
    fragment TransitionalRegistryProductData on TransitionalRegistryProductData {
  price {
    currency {
      code
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
}
    `;
export const TransitionalRegistryFundDataFragmentDoc = gql`
    fragment TransitionalRegistryFundData on TransitionalRegistryFundData {
  goal {
    currency {
      code
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
}
    `;
export const TransitionalRegistryItemFragmentDoc = gql`
    fragment TransitionalRegistryItem on TransitionalRegistryItem {
  __typename
  id
  title
  photo {
    id
    url
  }
  ... on TransitionalRegistryProduct {
    productData {
      ...TransitionalRegistryProductData
    }
  }
  ... on TransitionalRegistryFund {
    fundData {
      ...TransitionalRegistryFundData
    }
  }
}
    ${TransitionalRegistryProductDataFragmentDoc}
${TransitionalRegistryFundDataFragmentDoc}`;
export const TransitionalRegistryDetailsFieldsFragmentDoc = gql`
    fragment TransitionalRegistryDetailsFields on TransitionalRegistry {
  id
  name
  url
  status
  scannedAt {
    ...Date
    dateString(dateFormat: long)
  }
  items {
    ...TransitionalRegistryItem
  }
}
    ${DateFragmentDoc}
${TransitionalRegistryItemFragmentDoc}`;
export const TransitionalRegistryFragmentDoc = gql`
    fragment TransitionalRegistry on TransitionalRegistry {
  id
  name
  url
  scannedAt {
    ...Date
    dateString(dateFormat: long)
  }
  status
}
    ${DateFragmentDoc}`;
export const ChecklistItemFragmentDoc = gql`
    fragment ChecklistItem on RegistryChecklistItem {
  id
  isCheckable
  isChecked
  thumbnail {
    url
  }
  subTitle
  sortKey
  title
  completeCTAUrlPath
  type
}
    `;
export const ChecklistProgressFragmentDoc = gql`
    fragment ChecklistProgress on RegistryChecklistProgressResult {
  checkedCount
  totalCount
}
    `;
export const RegistryChecklistSectionFragmentDoc = gql`
    fragment RegistryChecklistSection on RegistryChecklistSection {
  id
  sectionTitle
  sectionProgress {
    ...ChecklistProgress
  }
  thumbnail {
    url
  }
}
    ${ChecklistProgressFragmentDoc}`;
export const RegistryChecklistFragmentDoc = gql`
    fragment RegistryChecklist on RegistryChecklist {
  id
  checklistProgress {
    ...ChecklistProgress
  }
  checklistSections {
    ...RegistryChecklistSection
  }
  checklistTemplate
}
    ${ChecklistProgressFragmentDoc}
${RegistryChecklistSectionFragmentDoc}`;
export const CalculatedPriceRangeFragmentDoc = gql`
    fragment CalculatedPriceRange on CalculatedPriceRange {
  targetGiftCount
  currentGiftCount
  startPrice {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  endPrice {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
}
    `;
export const RegistryAdvisorFragmentDoc = gql`
    fragment RegistryAdvisor on RecommendRegistryAdvisorData {
  guestCount
  targetGiftCount
  currentGiftCount
  priceRanges {
    ...CalculatedPriceRange
  }
}
    ${CalculatedPriceRangeFragmentDoc}`;
export const AccommodationConsoleListingPricingFragmentDoc = gql`
    fragment AccommodationConsoleListingPricing on PricingForAccommodationPlace {
  nightlyBaseRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
  strikeoutNightlyBaseRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
  strikeoutTotalRate {
    floatingPointDecimalString
    valueInMinorUnits
    currency
  }
  totalRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
}
    `;
export const AccommodationConsoleListingPropertyFragmentDoc = gql`
    fragment AccommodationConsoleListingProperty on AccommodationCatalogProperty {
  id: joyPlaceId
  joyPlaceId
  name
  propertyType
  accommodationCategory
  facilities {
    label
  }
  location {
    latitude
    longitude
  }
  address {
    city
    country
    postalCode
    state
    street
  }
  photos {
    photo {
      id
      assetId
    }
    url
  }
  starRating
  userRating {
    ...UserRating
  }
  url
}
    ${UserRatingFragmentDoc}`;
export const AccommodationCatalogConsoleListingPropertyFragmentDoc = gql`
    fragment AccommodationCatalogConsoleListingProperty on ExtendedAccommodationCatalogProperty {
  id: joyPlaceId
  joyPlaceId
  name
  propertyType
  accommodationCategory
  otaProvider
  facilities {
    label
  }
  location {
    latitude
    longitude
  }
  address {
    city
    country
    postalCode
    state
    street
  }
  photos {
    photo {
      id
      assetId
    }
    url
  }
  starRating
  userRating {
    ...UserRating
  }
  url
}
    ${UserRatingFragmentDoc}`;
export const AccommodationCatalogConsoleListingRedirectMechanismsFragmentDoc = gql`
    fragment AccommodationCatalogConsoleListingRedirectMechanisms on RedirectMechanism {
  type
  url
  telemetryDestinationName
  trackingQueryStringKey
}
    `;
export const AccommodationCatalogConsoleListingPricingFragmentDoc = gql`
    fragment AccommodationCatalogConsoleListingPricing on AccommodationCatalogPropertyPricingInfo {
  nightlyBaseRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
  strikeoutNightlyBaseRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
  strikeoutTotalRate {
    floatingPointDecimalString
    valueInMinorUnits
    currency
  }
  totalRate {
    floatingPointDecimalString
    valueInMinorUnits
    digits
    currency
  }
}
    `;
export const TravelOfferFragmentDoc = gql`
    fragment TravelOffer on TravelOffer {
  __typename
  offerToken
  checkIn
  checkOut
  offerGroupId
  providerName
  components {
    policies {
      description
      title
    }
    refundability
    ... on TravelOfferAccommodationUnitsComponent {
      __typename
      distributionType
      policies {
        title
        description
      }
      boardBasis {
        label
      }
      componentType
      occupancies {
        adults
        children
        childrenAges
      }
      unit {
        __typename
        id
        name
        plainTextLongDescription
        facilities {
          __typename
          label
        }
        photos {
          url
        }
        property {
          name
          joyPlaceId
          starRating
          photos {
            url
            subject {
              label
              type
            }
          }
          userRating {
            ...UserRating
          }
        }
      }
    }
  }
  onsiteCharges {
    title
    unitPrice {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    units
  }
  fees {
    isIncludedInTotal
    rate
    type
    visibility
    amount {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnitsBigInt
    }
  }
  baseAmount {
    currency
    digits
    floatingPointDecimalString
    valueInMinorUnits
  }
  totalAmount {
    currency
    digits
    floatingPointDecimalString
    valueInMinorUnits
  }
  originalBaseAmount {
    currency
    digits
    floatingPointDecimalString
    valueInMinorUnits
  }
  originalTotalAmount {
    currency
    digits
    floatingPointDecimalString
    valueInMinorUnits
  }
}
    ${UserRatingFragmentDoc}`;
export const TravelOfferReservationForCheckoutFragmentDoc = gql`
    fragment TravelOfferReservationForCheckout on TravelOfferReservation {
  id
  offerToken
  status
  confirmation {
    billingContact {
      address {
        city
        country
        line1
        line2
        postalCode
        state
      }
      email
      firstName
      lastName
      middleName
      phone
      title
    }
  }
  roomGuests {
    guests {
      ageClassification
      firstName
      lastName
      title
    }
    unitId
  }
}
    `;
export const ServiceCenterAccommodationPlaceFragmentDoc = gql`
    fragment ServiceCenterAccommodationPlace on AccommodationPlaceV2 {
  id
  type
  zhId
  joyPlaceId
  googlePlaceId
}
    `;
export const TravelOfferReservationFullDetailsFragmentDoc = gql`
    fragment TravelOfferReservationFullDetails on TravelOfferReservation {
  id
  offerToken
  roomGuests {
    guests {
      ageClassification
      firstName
      lastName
      title
      phoneNumber
    }
    unitId
  }
  email
  status
  cancellationFees {
    currency
    valueInMinorUnits
    floatingPointDecimalString
    digits
  }
  confirmation {
    provider
    propertyConfirmationCode
    baseAmount {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    billingContact {
      address {
        city
        country
        line1
        line2
        postalCode
        state
      }
      email
      firstName
      lastName
      middleName
      phone
      title
    }
    checkIn
    checkOut
    externalOrderId
    onsiteCharges {
      title
      unitPrice {
        currency
        digits
        floatingPointDecimalString
        valueInMinorUnits
      }
      units
    }
    propertyInfo {
      address {
        city
        country
        line1
        line2
        postalCode
        state
      }
      heroImageUrl
      name
      policies {
        title
        description
      }
    }
    reservationItems {
      occupancy {
        adults
        children
      }
      refundability
      unit {
        id
        name
        description
      }
    }
    totalAmount {
      currency
      digits
      floatingPointDecimalString
      valueInMinorUnits
    }
    discountAmount {
      currency
      valueInMinorUnits
      floatingPointDecimalString
      digits
    }
    fees {
      isIncludedInTotal
      rate
      type
      visibility
      amount {
        currency
        digits
        floatingPointDecimalString
        valueInMinorUnitsBigInt
      }
    }
  }
}
    `;
export const TravelOfferReservationStatusDetailsFragmentDoc = gql`
    fragment TravelOfferReservationStatusDetails on TravelOfferReservation {
  id
  offerToken
  status
}
    `;
export const PlaceToStayAccommodationPlaceV2FragmentDoc = gql`
    fragment PlaceToStayAccommodationPlaceV2 on AccommodationPlaceV2 {
  id
  type
  userNote
  name
  address
  city
  state
  postalCode
  country
  url
  lat
  long
  photo {
    id
    url
  }
  zhId
  starRating
  googlePlaceId
  joyPlaceId
  customPhoto {
    id
    url
  }
  customName
  customAddress
  customUrl
  isCustomLinkEnabled
  displayLocation
  layoutType
  distances {
    commonDistance {
      km
      mi
      durationMinutes
      type
    }
  }
  __typename
}
    `;
export const ProductUniversalProductSummaryFragmentDoc = gql`
    fragment ProductUniversalProductSummary on UniversalProduct {
  id
  title
  description
  url
  storeName
  salePrice {
    valueInMinorUnits
    floatingPointDecimalString
    currency {
      code
      places
    }
  }
  listPrice {
    valueInMinorUnits
    floatingPointDecimalString
    currency {
      code
      places
    }
  }
  rating {
    id
    averageRating
    reviewsCount
  }
  photos {
    url
  }
}
    `;
export const ProductExternalSummaryFragmentDoc = gql`
    fragment ProductExternalSummary on ProductExternal {
  id
  title
  description
  photos {
    url
  }
  rating {
    id
    averageRating
    reviewsCount
  }
  sellers {
    id
    name
    url
    fullPrice {
      valueInMinorUnits
      floatingPointDecimalString
      currency {
        code
        places
      }
    }
    salePrice {
      valueInMinorUnits
      floatingPointDecimalString
      currency {
        code
        places
      }
    }
  }
}
    `;
export const ProductExternalOfferSummaryFragmentDoc = gql`
    fragment ProductExternalOfferSummary on ProductExternalOffer {
  id
  productId
  productTitle
  productThumbnail {
    url
  }
  productRating {
    id
    averageRating
    reviewsCount
  }
  sellerName
  sellerUrl
  sellerFullPrice {
    valueInMinorUnits
    floatingPointDecimalString
    currency {
      code
      places
    }
  }
  sellerSalePrice {
    valueInMinorUnits
    floatingPointDecimalString
    currency {
      code
      places
    }
  }
}
    `;
export const ProductCatalogItemTilePresentationFragmentDoc = gql`
    fragment ProductCatalogItemTilePresentation on ProductCatalogItemTilePresentation {
  presentationType
  title
  shortDescription
  longDescription
  photos {
    id
    url
  }
  priceRange {
    isSinglePrice
    upperPrice {
      currency {
        code
        places
      }
      floatingPointDecimalString
      valueInMinorUnits
    }
    lowerPrice {
      currency {
        code
        places
      }
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
  fullPriceRange {
    isSinglePrice
    upperPrice {
      currency {
        code
        places
      }
      floatingPointDecimalString
      valueInMinorUnits
    }
    lowerPrice {
      currency {
        code
        places
      }
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
  isFullPrice
}
    `;
export const CatalogProductTileViewDimensionsFragmentDoc = gql`
    fragment CatalogProductTileViewDimensions on ProductCatalogItemGroup {
  tileViewDimension {
    id
    title
    swatchType
    options {
      id
      displayString
      swatchColor {
        ...Color
      }
    }
  }
  items {
    ...CatalogProductSharedDisplayFields
    groupDimensionOptions {
      id
    }
  }
}
    ${ColorFragmentDoc}
${CatalogProductSharedDisplayFieldsFragmentDoc}`;
export const ProductCatalogItemSearchSummaryFragmentDoc = gql`
    fragment ProductCatalogItemSearchSummary on ProductCatalogItem {
  ...CatalogProductSharedDisplayFields
  collectionDisplayInfos {
    id
    displayInfoId
    pdpSectionType
  }
  tilePresentation {
    ...ProductCatalogItemTilePresentation
  }
  group {
    id
    ...CatalogProductTileViewDimensions
  }
}
    ${CatalogProductSharedDisplayFieldsFragmentDoc}
${ProductCatalogItemTilePresentationFragmentDoc}
${CatalogProductTileViewDimensionsFragmentDoc}`;
export const ProductCatalogCategorySummaryFragmentDoc = gql`
    fragment ProductCatalogCategorySummary on ProductCatalogCategory {
  id
  publicUrlPath
  title
  isParentType
  thumbnail {
    url
  }
  directItemCount
  tileItemImages {
    id
    url
  }
  curationData {
    id
    description
  }
}
    `;
export const ProductCatalogCategoryDetailsFragmentDoc = gql`
    fragment ProductCatalogCategoryDetails on ProductCatalogCategory {
  ...ProductCatalogCategorySummary
  children {
    ...ProductCatalogCategorySummary
  }
  lineage {
    ...ProductCatalogCategorySummary
  }
}
    ${ProductCatalogCategorySummaryFragmentDoc}`;
export const ProductCatalogSubcategoryFragmentDoc = gql`
    fragment ProductCatalogSubcategory on ProductCatalogCategory {
  ...ProductCatalogCategorySummary
  children {
    ...ProductCatalogCategoryDetails
  }
}
    ${ProductCatalogCategorySummaryFragmentDoc}
${ProductCatalogCategoryDetailsFragmentDoc}`;
export const ProductCatalogCategoryFragmentDoc = gql`
    fragment ProductCatalogCategory on ProductCatalogCategory {
  ...ProductCatalogCategorySummary
  children {
    ...ProductCatalogSubcategory
  }
}
    ${ProductCatalogCategorySummaryFragmentDoc}
${ProductCatalogSubcategoryFragmentDoc}`;
export const ProductCatalogDepartmentFragmentDoc = gql`
    fragment ProductCatalogDepartment on ProductCatalogCategory {
  ...ProductCatalogCategorySummary
  heroText
  children {
    ...ProductCatalogCategory
  }
}
    ${ProductCatalogCategorySummaryFragmentDoc}
${ProductCatalogCategoryFragmentDoc}`;
export const ProductCatalogCategoryTreeRootFragmentDoc = gql`
    fragment ProductCatalogCategoryTreeRoot on ProductCatalogCategory {
  ...ProductCatalogCategorySummary
  heroText
  children {
    ...ProductCatalogDepartment
  }
}
    ${ProductCatalogCategorySummaryFragmentDoc}
${ProductCatalogDepartmentFragmentDoc}`;
export const ProductTileViewDimensionFragmentDoc = gql`
    fragment ProductTileViewDimension on ProductCatalogItemGroupDimension {
  id
  title
  options {
    id
    groupDimension {
      id
      title
      swatchType
    }
    displayString
    swatchType
    swatchUrl
    swatchColor {
      hex
      rgba
      isLight
    }
  }
  swatchType
}
    `;
export const ProductCatalogItemSummaryFragmentDoc = gql`
    fragment ProductCatalogItemSummary on ProductCatalogItem {
  id
  title
  itemType
  brand {
    id
    name
  }
  photos {
    id
    url
  }
  parentCategories {
    id
  }
  subCategories {
    ...ProductCatalogCategorySummary
  }
  productUrl
  price {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  fullPrice {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  isFullPrice
  groupTileViewDimension: group {
    tileViewDimension {
      ...ProductTileViewDimension
    }
  }
  tags
}
    ${ProductCatalogCategorySummaryFragmentDoc}
${ProductTileViewDimensionFragmentDoc}`;
export const ProductCatalogItemFragmentDoc = gql`
    fragment ProductCatalogItem on ProductCatalogItem {
  id
  title
  itemType
  brand {
    id
    name
    publicUrlPath
  }
  retailer {
    name
  }
  whyWeLoveIt
  shortDescription
  longDescription
  productUrl
  photos {
    id
    url
  }
  subCategories {
    ...ProductCatalogCategoryDetails
  }
  price {
    currency {
      code
      places
    }
    valueInMinorUnits
    floatingPointDecimalString
  }
  storefrontInfo {
    storefrontStatus
    canAddToCart
    canAddToRegistry
  }
  isFullPrice
  tags
}
    ${ProductCatalogCategoryDetailsFragmentDoc}`;
export const ProductCatalogItemDimensionsFragmentDoc = gql`
    fragment ProductCatalogItemDimensions on ProductCatalogItem {
  groupDimensionOptions {
    id
    displayString
    swatchType
    swatchColor {
      hex
      rgba
      isLight
    }
    swatchUrl
  }
  group {
    id
    tileViewDimension {
      ...ProductTileViewDimension
    }
    groupDimensions {
      id
      title
      options {
        id
        displayString
        swatchType
        swatchColor {
          hex
          rgba
          isLight
        }
        swatchUrl
      }
    }
    items {
      ...ProductCatalogItem
      groupDimensionOptions {
        id
        displayString
        swatchType
        swatchColor {
          hex
          rgba
          isLight
        }
        swatchUrl
      }
    }
  }
}
    ${ProductTileViewDimensionFragmentDoc}
${ProductCatalogItemFragmentDoc}`;
export const ProductCategoryBreadcrumbsFragmentDoc = gql`
    fragment ProductCategoryBreadcrumbs on ProductCatalogCategory {
  id
  title
  publicUrlPath
  lineage {
    id
    title
  }
}
    `;
export const BlogArticleFragmentDoc = gql`
    fragment BlogArticle on BlogArticle {
  title
  eyebrow
  description
  url
  imageUrl
}
    `;
export const CatalogCategoryChildrenSummaryFragmentDoc = gql`
    fragment CatalogCategoryChildrenSummary on ProductCatalogCategory {
  id
  title
  publicUrlPath
}
    `;
export const ProductCatalogSearchPageInfoFragmentDoc = gql`
    fragment ProductCatalogSearchPageInfo on ProductCatalogSearchPageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
  totalCount
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  name
  address1
  address2
  country
  city
  state
  postalCode
  latitude
  longitude
  placeId
}
    `;
export const VendorSlimFragmentDoc = gql`
    fragment VendorSlim on Vendor {
  id
  type {
    id
    type
  }
  name
  description
  handle
  phone
  email
  website
  startingPrice
  typicalSpend
  photo {
    id
    url
  }
  location {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export const PhotoWithMetatagsFragmentDoc = gql`
    fragment PhotoWithMetatags on Photo {
  id
  url
  width
  height
  blurHash
  altTag
  layout {
    ...PhotoLayout
  }
  transform {
    ...PhotoTransform
  }
  likedByCurrentUser
  metaTags {
    id
    vendor {
      ...VendorSlim
    }
  }
}
    ${PhotoLayoutFragmentDoc}
${PhotoTransformFragmentDoc}
${VendorSlimFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  id
  url
  title
}
    `;
export const CollectionWithMetatagsPaginatedFragmentDoc = gql`
    fragment CollectionWithMetatagsPaginated on Collection {
  id
  description
  name
  itemCount
  items(perPage: $perPage, page: $page, cursor: $cursor) {
    edges {
      node {
        id
        description
        photo {
          ...PhotoWithMetatags
        }
        video {
          ...Video
        }
      }
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VideoFragmentDoc}`;
export const SyntheticCollectionWithMetatagsPaginatedFragmentDoc = gql`
    fragment SyntheticCollectionWithMetatagsPaginated on SyntheticCollection {
  id
  description
  name
  itemCount
  items(perPage: $perPage, page: $page, cursor: $cursor) {
    edges {
      cursor
      node {
        id
        description
        photo {
          ...PhotoWithMetatags
        }
        video {
          ...Video
        }
        collection {
          name
          id
        }
      }
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VideoFragmentDoc}`;
export const SyntheticCollectionWithMetatagsFragmentDoc = gql`
    fragment SyntheticCollectionWithMetatags on SyntheticCollection {
  id
  description
  name
  itemCount
  items {
    edges {
      node {
        id
        description
        photo {
          ...PhotoWithMetatags
        }
        video {
          ...Video
        }
      }
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VideoFragmentDoc}`;
export const DesignBucketFragmentDoc = gql`
    fragment DesignBucket on DesignBucket {
  id
  bucketId
  display
  fonts {
    id
  }
  themes {
    id
  }
}
    `;
export const DonationFundInfoFragmentFragmentDoc = gql`
    fragment DonationFundInfoFragment on Event {
  id
  registry {
    id
    donationFundInfo {
      defaultPlatform {
        id
        type
        username
      }
      defaultSuggestedDonationMonetaryValue {
        valueInMinorUnits
      }
      platforms {
        id
        type
        username
        link
      }
      items {
        id
        platform {
          id
          type
        }
      }
    }
  }
}
    `;
export const RegistryMonetaryValueFragmentDoc = gql`
    fragment RegistryMonetaryValue on CommerceMonetaryValue {
  currencyCode
  valueInMajorUnits
  valueInMinorUnits
}
    `;
export const EventPayoutAccountFragmentDoc = gql`
    fragment EventPayoutAccount on EventData {
  id
  payoutAccount {
    status
    statusDetails
    onboardingUrl
    serviceDashboardUrl
    externalAccountLast4
    balance {
      availablePending {
        ...RegistryMonetaryValue
      }
      available {
        ...RegistryMonetaryValue
      }
      withdrawnPending {
        ...RegistryMonetaryValue
      }
      withdrawn {
        ...RegistryMonetaryValue
      }
      received {
        ...RegistryMonetaryValue
      }
    }
    withdrawals {
      id
      status
      totalValue {
        ...RegistryMonetaryValue
      }
      createdAt {
        timestamp
      }
    }
  }
}
    ${RegistryMonetaryValueFragmentDoc}`;
export const PhotoFragmentDoc = gql`
    fragment Photo on Photo {
  id
  url
  width
  height
  blurHash
  altTag
  layout {
    ...PhotoLayout
  }
  transform {
    ...PhotoTransform
  }
}
    ${PhotoLayoutFragmentDoc}
${PhotoTransformFragmentDoc}`;
export const LikedPhotoFragmentDoc = gql`
    fragment LikedPhoto on Photo {
  ...Photo
  likedByCurrentUser
}
    ${PhotoFragmentDoc}`;
export const CollectionFragmentDoc = gql`
    fragment Collection on Collection {
  id
  description
  name
  itemCount
  items {
    edges {
      node {
        id
        description
        photo {
          ...LikedPhoto
        }
        video {
          ...Video
        }
      }
    }
  }
}
    ${LikedPhotoFragmentDoc}
${VideoFragmentDoc}`;
export const EventMatchFragmentDoc = gql`
    fragment EventMatch on EventMatch {
  id
  vendorState
  collections {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export const EventQandaFragmentDoc = gql`
    fragment EventQanda on EventQanda {
  id
  type
  question
  answer
}
    `;
export const TimezoneDateFragmentDoc = gql`
    fragment TimezoneDate on Date {
  ...Date
  hostTimeString: dateString(timeFormat: time)
  hostDateString: dateString(dateFormat: full)
}
    ${DateFragmentDoc}`;
export const VirtualEventLinkParseResultFragmentDoc = gql`
    fragment VirtualEventLinkParseResult on VirtualEventLinkParseResult {
  provider
  linkText
  isLinkValid
  isPasswordDetected
  passwordText
  passwordUrlEmbed
  streamId
  urlLinkText
  urlApp
  urlBrowser
}
    `;
export const EventScheduleFragmentDoc = gql`
    fragment EventSchedule on EventSchedule {
  id
  description
  dressCode
  endTime: endTimeV0918 {
    ...TimezoneDate
  }
  isMain
  isPublic
  location
  name
  placeId
  showMap
  startTime: startTimeV0918 {
    ...TimezoneDate
  }
  timezone
  unplugged
  virtualEventLink {
    ...VirtualEventLinkParseResult
  }
}
    ${TimezoneDateFragmentDoc}
${VirtualEventLinkParseResultFragmentDoc}`;
export const FormattedEventScheduleFragmentDoc = gql`
    fragment FormattedEventSchedule on FormattedSchedule {
  date: dateV0918 {
    ...TimezoneDate
  }
  items {
    ...EventSchedule
  }
}
    ${TimezoneDateFragmentDoc}
${EventScheduleFragmentDoc}`;
export const EventScheduleItemStreamFragmentDoc = gql`
    fragment EventScheduleItemStream on EventSchedule {
  id
  startTime {
    dateString(timeFormat: time)
    milliseconds
    timestamp
  }
  endTime {
    dateString(timeFormat: time)
    milliseconds
    timestamp
  }
  virtualEventLink {
    linkText
    urlLinkText
    provider
    urlBrowser
    isLinkValid
  }
}
    `;
export const EventSessionCtaGuestSiteFragmentDoc = gql`
    fragment EventSessionCtaGuestSite on EventSessionCTA {
  rsvpIsEnabled
  rsvpIsCompleted
  scheduleHasInviteOnlyItems
  label
  requiresPassword
  rsvpAttendanceStatus
}
    `;
export const EventSessionGuestSiteFragmentDoc = gql`
    fragment EventSessionGuestSite on EventSession {
  id
  hasUnlocked
  hasIdentity
  person {
    id
    firstName
    lastName
    fullName
    email
    avatarName
  }
}
    `;
export const EventShowcaseVendorFragmentDoc = gql`
    fragment EventShowcaseVendor on Vendor {
  id
  name
  type {
    id
    display
  }
  photo {
    id
    url
  }
}
    `;
export const EventSuggestionFragmentDoc = gql`
    fragment EventSuggestion on EventSuggestion {
  id
  identifier
  createdAt {
    ...Date
  }
  offeredAt {
    ...Date
  }
  stateJSON
}
    ${DateFragmentDoc}`;
export const ShuttleItemFragmentDoc = gql`
    fragment ShuttleItem on ShuttleItem {
  id
  note
  startTime: startTimeV0918 {
    ...TimezoneDate
  }
  endTime: endTimeV0918 {
    ...TimezoneDate
  }
  timezone
  url
}
    ${TimezoneDateFragmentDoc}`;
export const EventTravelSharedFragmentDoc = gql`
    fragment EventTravelShared on EventTravelShared {
  id
  type
  name
}
    `;
export const EventTravelBookingTypeFragmentDoc = gql`
    fragment EventTravelBookingType on EventTravelBookingType {
  ...EventTravelShared
  address
  bookingType
  startTime: startTimeV0918 {
    ...TimezoneDate
  }
  endTime: endTimeV0918 {
    ...TimezoneDate
  }
  timezone
  latitude
  longitude
  placeId
}
    ${EventTravelSharedFragmentDoc}
${TimezoneDateFragmentDoc}`;
export const EventTravelNoteFragmentDoc = gql`
    fragment EventTravelNote on EventTravelNote {
  ...EventTravelShared
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const EventTravelListItemFragmentDoc = gql`
    fragment EventTravelListItem on EventTravelListItem {
  id
  title
  url
}
    `;
export const EventTravelListFragmentDoc = gql`
    fragment EventTravelList on EventTravelList {
  ...EventTravelShared
  items {
    ...EventTravelListItem
  }
}
    ${EventTravelSharedFragmentDoc}
${EventTravelListItemFragmentDoc}`;
export const FlightFragmentDoc = gql`
    fragment Flight on Flight {
  ...EventTravelShared
  url
  code
  notes
}
    ${EventTravelSharedFragmentDoc}`;
export const RentalCarFragmentDoc = gql`
    fragment RentalCar on RentalCar {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const TaxiFragmentDoc = gql`
    fragment Taxi on Taxi {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const TrainFragmentDoc = gql`
    fragment Train on Train {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const FerryFragmentDoc = gql`
    fragment Ferry on Ferry {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const ShuttleFragmentDoc = gql`
    fragment Shuttle on Shuttle {
  id
  type
  name
  notes
  items {
    id
    note
    startTime: startTimeV0918 {
      ...TimezoneDate
    }
    endTime: endTimeV0918 {
      ...TimezoneDate
    }
    timezone
    url
  }
}
    ${TimezoneDateFragmentDoc}`;
export const HotelFragmentDoc = gql`
    fragment Hotel on Hotel {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const TentFragmentDoc = gql`
    fragment Tent on Tent {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const RentalHomeFragmentDoc = gql`
    fragment RentalHome on RentalHome {
  ...EventTravelShared
  address
  telephone
  notes
  url
}
    ${EventTravelSharedFragmentDoc}`;
export const EventTravelFragmentDoc = gql`
    fragment EventTravel on EventTravel {
  ... on EventTravelBookingType {
    ...EventTravelBookingType
  }
  ... on EventTravelNote {
    ...EventTravelNote
  }
  ... on EventTravelList {
    ...EventTravelList
  }
  ... on Flight {
    ...Flight
  }
  ... on RentalCar {
    ...RentalCar
  }
  ... on Taxi {
    ...Taxi
  }
  ... on Train {
    ...Train
  }
  ... on Ferry {
    ...Ferry
  }
  ... on Shuttle {
    ...Shuttle
  }
  ... on Hotel {
    ...Hotel
  }
  ... on Tent {
    ...Tent
  }
  ... on RentalHome {
    ...RentalHome
  }
}
    ${EventTravelBookingTypeFragmentDoc}
${EventTravelNoteFragmentDoc}
${EventTravelListFragmentDoc}
${FlightFragmentDoc}
${RentalCarFragmentDoc}
${TaxiFragmentDoc}
${TrainFragmentDoc}
${FerryFragmentDoc}
${ShuttleFragmentDoc}
${HotelFragmentDoc}
${TentFragmentDoc}
${RentalHomeFragmentDoc}`;
export const EventFragmentCommonFragmentDoc = gql`
    fragment EventFragmentCommon on Event {
  id
  firebaseId
  website
  firebaseCreateAt {
    milliseconds
  }
}
    `;
export const EventInfoFragmentFragmentDoc = gql`
    fragment EventInfoFragment on EventInfo {
  id
  ownerFirstName
  ownerLastName
  fianceeFirstName
  fianceeLastName
  eventDisplayName
  eventType
  location
  locationInfo {
    id
    placeId
    name
    city
    state
    country
    address1
    address2
    latitude
    longitude
  }
  greeting
  timezone
  tentativeDate {
    ...Date
    dateString(dateFormat: full)
  }
  finalizedDate {
    ...Date
    timeString: dateString(timeFormat: time)
    dateString(dateFormat: full)
  }
  dateV0918 {
    milliseconds
  }
}
    ${DateFragmentDoc}`;
export const EventFragmentFragmentDoc = gql`
    fragment EventFragment on Event {
  ...EventFragmentCommon
  info {
    ...EventInfoFragment
  }
}
    ${EventFragmentCommonFragmentDoc}
${EventInfoFragmentFragmentDoc}`;
export const EventFragmentForAdminFragmentDoc = gql`
    fragment EventFragmentForAdmin on Event {
  ...EventFragmentCommon
  productVerticals {
    optOutOfGuestList
    optOutOfInvites
    optOutOfRegistry
    optOutOfWebsite
  }
  info: info(admin: true) {
    ...EventInfoFragment
  }
}
    ${EventFragmentCommonFragmentDoc}
${EventInfoFragmentFragmentDoc}`;
export const ActiveEventUserFragmentDoc = gql`
    fragment ActiveEventUser on EventUser {
  id
  status
  user {
    id
    superAdmin
    firstName
    lastName
    avatar {
      id
      url
    }
    email
  }
  event: eventV0918 {
    id
    firebaseId
    website
  }
}
    `;
export const FontFragmentDoc = gql`
    fragment Font on Font {
  id
  display
  designBuckets {
    display
    id
    bucketId
  }
  typeface
  textTransform
  fontSize
  fontFamily
  fontWeight
  firebaseFontKey
}
    `;
export const CollectionSlimFragmentDoc = gql`
    fragment CollectionSlim on Collection {
  id
  description
  name
  itemCount
  vendor {
    id
    handle
    name
    photo {
      ...LikedPhoto
    }
  }
  items(perPage: 8) {
    edges {
      node {
        id
        description
        photo {
          ...LikedPhoto
        }
        video {
          ...Video
        }
      }
    }
  }
}
    ${LikedPhotoFragmentDoc}
${VideoFragmentDoc}`;
export const MatchWithVendorCollectionsFragmentDoc = gql`
    fragment MatchWithVendorCollections on Match {
  id
  status
  archived
  matchNote
  vendor {
    ...VendorSlim
    collections {
      ...CollectionSlim
    }
  }
}
    ${VendorSlimFragmentDoc}
${CollectionSlimFragmentDoc}`;
export const MatchFragmentDoc = gql`
    fragment Match on Match {
  id
  status
  archived
  matchNote
  vendor {
    ...VendorSlim
  }
}
    ${VendorSlimFragmentDoc}`;
export const MatchForEventFragmentDoc = gql`
    fragment MatchForEvent on Match {
  id
  status
  archived
  matchNote
  vendor {
    ...VendorSlim
    matchForEvent(eventId: $eventId) {
      ...Match
    }
  }
}
    ${VendorSlimFragmentDoc}
${MatchFragmentDoc}`;
export const PersonFragmentDoc = gql`
    fragment Person on Person {
  id
  personIdTag
  firstName
  lastName
  email
  hasEmail
  phoneDisplay
  avatarName
  household {
    id
  }
}
    `;
export const PhotoWithMetatagsVendorCollectionsFragmentDoc = gql`
    fragment PhotoWithMetatagsVendorCollections on Photo {
  id
  url
  width
  height
  blurHash
  altTag
  layout {
    ...PhotoLayout
  }
  transform {
    ...PhotoTransform
  }
  likedByCurrentUser
  metaTags {
    id
    vendor {
      ...VendorSlim
      collections {
        ...CollectionSlim
      }
    }
  }
}
    ${PhotoLayoutFragmentDoc}
${PhotoTransformFragmentDoc}
${VendorSlimFragmentDoc}
${CollectionSlimFragmentDoc}`;
export const RegistryPayoutAccountFragmentDoc = gql`
    fragment RegistryPayoutAccount on RegistryPayoutAccount {
  status
  statusDetails
  onboardingUrl
}
    `;
export const RegistryErrorResultFragmentDoc = gql`
    fragment RegistryErrorResult on RegistryErrorResult {
  error {
    code
    nativeMessage
  }
}
    `;
export const RegistryOrderRefundFragmentDoc = gql`
    fragment RegistryOrderRefund on RegistryOrderRefund {
  items {
    title
    currencyCode
    lineValueInMinorUnits
  }
  taxes {
    title
    currencyCode
    lineValueInMinorUnits
  }
  shippingAndHandling {
    title
    currencyCode
    lineValueInMinorUnits
  }
  refundStatus
  totalValue {
    ...MonetaryValue
  }
}
    ${MonetaryValueFragmentDoc}`;
export const CheckoutMechanismTypeFragmentDoc = gql`
    fragment CheckoutMechanismType on CheckoutMechanism {
  type
  hideValueProps
  checkoutFailureCode
  checkoutWarningCodes
}
    `;
export const GuestSiteProductDataFragmentDoc = gql`
    fragment GuestSiteProductData on RegistryItemProductData {
  registryItem {
    id
  }
  title
  url
  photos {
    id
    url
  }
}
    `;
export const GuestSiteRegistryItemFragmentDoc = gql`
    fragment GuestSiteRegistryItem on RegistryItem {
  id
  fpIndex
  productData {
    ...GuestSiteProductData
  }
}
    ${GuestSiteProductDataFragmentDoc}`;
export const GuestSiteRegistryFragmentDoc = gql`
    fragment GuestSiteRegistry on Registry {
  id
  name: nameV0204
  url: urlV0204
  imageUrl: imageUrlV0204
  wantSync
  hasItems
  items {
    ...GuestSiteRegistryItem
  }
}
    ${GuestSiteRegistryItemFragmentDoc}`;
export const DonationFundSkipDonationsFragmentDoc = gql`
    fragment DonationFundSkipDonations on DonationFund {
  id
  fundType
  goalMonetaryValue {
    ...MonetaryValue
  }
  suggestedDonationMonetaryValue {
    ...MonetaryValue
  }
  suggestedQuantityStillNeeded
  donationsAreCapped
  enforceSuggestedDonationAmount
  hideFundingGoal
  platform {
    ...DonationFundPlatform
  }
  photos {
    id
    url
  }
  progressToGoal {
    ...MonetaryValue
  }
  amountTillGoalIsReached {
    ...MonetaryValue
  }
  progressToGoalPercent
  fpIndex
  title
  url
  description
  enableCashOrCheck
  enableAppPlatform
  enableJoyCredit
  mustHave
}
    ${MonetaryValueFragmentDoc}
${DonationFundPlatformFragmentDoc}`;
export const SalesOrderLineFragmentDoc = gql`
    fragment SalesOrderLine on SalesOrderLine {
  __typename
  title
  lineValue {
    ...MonetaryValue
  }
  lineTags {
    key
    value
  }
}
    ${MonetaryValueFragmentDoc}`;
export const CalculateRegistryPurchaseInfoFragmentFragmentDoc = gql`
    fragment CalculateRegistryPurchaseInfoFragment on CalculateRegistryPurchaseInfo {
  shippingAndHandling {
    ...SalesOrderLine
  }
  orderCharges {
    ...SalesOrderLine
  }
  postPurchaseFees {
    ...SalesOrderLine
  }
  compensation {
    ...SalesOrderLine
  }
  shippingAndHandlingTotal {
    ...MonetaryValue
  }
  checkoutWarningCodes
}
    ${SalesOrderLineFragmentDoc}
${MonetaryValueFragmentDoc}`;
export const JoyCreditStatusFragmentDoc = gql`
    fragment JoyCreditStatus on RegistryJoyCredit {
  active
  amount {
    currencyCode
    valueInMinorUnits
  }
  code
}
    `;
export const RegistryStoreFragmentDoc = gql`
    fragment RegistryStore on RegistryStore {
  id
  name
  sectionName
  shortDescription
  longDescription
  createRegistryUrl
  domain
  hostname
  connectAction
  allowCreateBeforeConnect
  onlyForEventTypes
  isRecommended
  logos {
    url
    mimeType
  }
  logosCompact {
    url
    mimeType
  }
  valueProps {
    text
    image {
      url
      mimeType
    }
  }
}
    `;
export const NamePartsFragmentDoc = gql`
    fragment NameParts on User {
  firstName
  lastName
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  ...NameParts
  avatar {
    id
    url
  }
  email
  superAdmin
  activeAlias {
    id
    auth0Id
    provider
    mfaEnabled
  }
  eventUsers {
    id
    status
    event {
      id
    }
  }
  emailIsVerified(liveQuery: true)
}
    ${NamePartsFragmentDoc}`;
export const CollectionWithMetatagsFragmentDoc = gql`
    fragment CollectionWithMetatags on Collection {
  id
  description
  name
  itemCount
  items {
    edges {
      node {
        id
        description
        photo {
          ...PhotoWithMetatags
        }
        video {
          ...Video
        }
      }
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VideoFragmentDoc}`;
export const VendorUserFragmentDoc = gql`
    fragment VendorUser on VendorUser {
  id
  status
  claimToken
  title
  email
  phone
  displayFirstName
  displayLastName
  photo {
    id
    url
  }
}
    `;
export const RequestForProposalFragmentDoc = gql`
    fragment RequestForProposal on RequestForProposal {
  id
  message
  locked
  name
  locked
  sentByUser {
    ...User
  }
  eventDate {
    date: dateString(dateFormat: long)
    time: dateString(timeFormat: time)
  }
  requestSentAt {
    date: dateString(dateFormat: long)
    time: dateString(timeFormat: time)
  }
  budget
  collection {
    ...CollectionWithMetatags
  }
  venue {
    id
    name
    handle
    location {
      ...Location
    }
  }
  vendor {
    ...VendorSlim
    vendorUserByUserId(userId: $userId) {
      ...VendorUser
    }
  }
}
    ${UserFragmentDoc}
${CollectionWithMetatagsFragmentDoc}
${LocationFragmentDoc}
${VendorSlimFragmentDoc}
${VendorUserFragmentDoc}`;
export const RegistryCurrencyCodesFragmentDoc = gql`
    fragment RegistryCurrencyCodes on RegistryCurrency {
  id
  displayName
  code
  rank
}
    `;
export const EventRegistryCurrencyFragmentDoc = gql`
    fragment EventRegistryCurrency on RegistryCurrency {
  ...RegistryCurrencyCodes
  isDefault
}
    ${RegistryCurrencyCodesFragmentDoc}`;
export const RegistryShippingAddressFragmentFragmentDoc = gql`
    fragment RegistryShippingAddressFragment on Event {
  id
  registry {
    id
    shippingAddress {
      name
      address1
      address2
      phone
      city
      state
      postalCode
      country
      countryCode
      validated
      hash
    }
    currency {
      ...EventRegistryCurrency
    }
  }
}
    ${EventRegistryCurrencyFragmentDoc}`;
export const ShippingAddressFragmentDoc = gql`
    fragment ShippingAddress on ShippingAddress {
  name
  address1
  address2
  city
  state
  postalCode
  country
  countryCode
  validated
  hash
}
    `;
export const TestimonyFragmentDoc = gql`
    fragment Testimony on Testimony {
  id
  content
  reviewer
  match {
    ...Match
  }
}
    ${MatchFragmentDoc}`;
export const CharmThemeFragmentDoc = gql`
    fragment CharmTheme on Theme {
  id
  name
  themeId
  thumbnailUrl
  supportsPrints
  websiteLayoutAlohaSettings {
    alohaColorPreference {
      id
      supportsCustomization
    }
  }
  printProviders {
    ...PrintProviderTheme
  }
}
    ${PrintProviderThemeFragmentDoc}`;
export const BabyRegistryUserFragmentDoc = gql`
    fragment BabyRegistryUser on User {
  id
  ...NameParts
  avatar {
    id
    url
  }
  email
  superAdmin
  activeAlias {
    id
    auth0Id
    provider
    mfaEnabled
  }
  eventUsers(filter: {types: $filterEventTypes}) {
    id
    status
    event {
      id
    }
  }
  vendorUsers {
    id
    displayFirstName
    vendor {
      id
      name
      handle
    }
  }
  emailIsVerified(liveQuery: true)
}
    ${NamePartsFragmentDoc}`;
export const EventInfoSansDateFragmentDoc = gql`
    fragment EventInfoSansDate on EventInfo {
  id
  ownerFirstName
  ownerLastName
  fianceeFirstName
  fianceeLastName
  eventDisplayName
  location
  locationInfo {
    id
    placeId
    name
    city
    state
  }
  greeting
}
    `;
export const EventUserForEventsListFragmentDoc = gql`
    fragment EventUserForEventsList on EventUser {
  id
  status
  event {
    id
    firebaseId
    website
    activeSession {
      id
      eventCTA {
        rsvpAttendanceStatus
      }
    }
    pages {
      id
      pageSlug
      visibility
      photo {
        id
        url
      }
    }
    productVerticals {
      optOutOfGuestList
    }
    photo {
      ...PhotoWithoutBlurHash
    }
    style {
      id
      primaryColorV0918 {
        hex
      }
    }
    info {
      ...EventInfoSansDate
      eventType
      timezone
      eventPassword
      tentativeDate {
        ...Date
        dateString(dateFormat: long)
      }
      finalizedDate {
        ...Date
        timeString: dateString(timeFormat: time)
        dateString(dateFormat: long)
      }
    }
    eventDesign(purpose: live) {
      id
      activeWebsiteHeaderPresentationLayout {
        ...WebsiteHeaderPresentationSettings
      }
    }
    featureFlags
  }
}
    ${PhotoWithoutBlurHashFragmentDoc}
${EventInfoSansDateFragmentDoc}
${DateFragmentDoc}
${WebsiteHeaderPresentationSettingsFragmentDoc}`;
export const UserForMePageFragmentDoc = gql`
    fragment UserForMePage on User {
  id
  ...BabyRegistryUser
  aliases {
    id
    auth0Id
  }
  eventUsers(filter: {types: $filterEventTypes}) {
    ...EventUserForEventsList
  }
}
    ${BabyRegistryUserFragmentDoc}
${EventUserForEventsListFragmentDoc}`;
export const VendorFragmentDoc = gql`
    fragment Vendor on Vendor {
  id
  name
  description
  handle
  phone
  email
  website
  instagramAuthLink
  instagramHandle
  startingPrice
  typicalSpend
  testimony {
    id
    content
    reviewer
  }
  photo {
    id
    url
  }
  location {
    ...Location
  }
  locked
}
    ${LocationFragmentDoc}`;
export const VendorSlimEventMatchFragmentDoc = gql`
    fragment VendorSlimEventMatch on Vendor {
  ...VendorSlim
  matchForEvent(eventId: $eventId) @include(if: $includeMatchForEvent) {
    ...Match
  }
}
    ${VendorSlimFragmentDoc}
${MatchFragmentDoc}`;
export const VendorTypeFragmentDoc = gql`
    fragment VendorType on VendorType {
  id
  display
  type
}
    `;
export const VipFragmentDoc = gql`
    fragment Vip on Vip {
  id
  title
  alias
  description
  photoUrl
  photo {
    ...PhotoWithoutBlurHash
  }
}
    ${PhotoWithoutBlurHashFragmentDoc}`;
export const EventDesignPreferenceColorFragmentDoc = gql`
    fragment EventDesignPreferenceColor on EventDesignPreferenceColor {
  id
  featureId
  featureName
  featureType
  featureValueType
  colorValue {
    ...Color
  }
}
    ${ColorFragmentDoc}`;
export const WebsiteLayoutAlohaPreferencesFragmentDoc = gql`
    fragment WebsiteLayoutAlohaPreferences on WebsiteLayoutAlohaPreferences {
  alohaColorPreference {
    ...EventDesignPreferenceColor
  }
}
    ${EventDesignPreferenceColorFragmentDoc}`;
export const WebsiteLayoutBrannanPreferencesFragmentDoc = gql`
    fragment WebsiteLayoutBrannanPreferences on WebsiteLayoutBrannanPreferences {
  brannanTextColorPreference {
    ...EventDesignPreferenceColor
  }
  brannanColorPreference {
    ...EventDesignPreferenceColor
  }
  brannanInnerFrameBorder {
    ...EventDesignPreferenceBoolean
  }
  brannanBackgroundTransparency {
    ...EventDesignPreferenceRange
  }
}
    ${EventDesignPreferenceColorFragmentDoc}
${EventDesignPreferenceBooleanFragmentDoc}
${EventDesignPreferenceRangeFragmentDoc}`;
export const CatalogCurationHeaderFragmentDoc = gql`
    fragment CatalogCurationHeader on ProductCatalogCurationHeader {
  backgroundImage {
    id
    url
    blurHash
  }
  logoImage {
    id
    url
    blurHash
  }
  textColor
  gradientColor
  gradient1
  gradient2
  title
  eyebrow
  description
  video
}
    `;
export const CatalogCurationFieldsFragmentDoc = gql`
    fragment CatalogCurationFields on ProductCatalogCategory {
  id
  publicUrlPath
  title
  heroText
  thumbnail {
    url
  }
  isParentType
  directItemCount
  tileItemImages {
    id
    url
  }
}
    `;
export const CoreCatalogCategoryFieldsFragmentDoc = gql`
    fragment CoreCatalogCategoryFields on ProductCatalogCategory {
  id
  title
  heroText
  publicUrlPath
  isFeatured
  thumbnail {
    url
  }
  showcase {
    title
    image {
      id
      url
    }
  }
}
    `;
export const CoreCatalogCategoryFieldsWithChildrenFragmentDoc = gql`
    fragment CoreCatalogCategoryFieldsWithChildren on ProductCatalogCategory {
  ...CoreCatalogCategoryFields
  children {
    ...CoreCatalogCategoryFields
    children {
      ...CoreCatalogCategoryFields
      children {
        ...CoreCatalogCategoryFields
      }
    }
  }
}
    ${CoreCatalogCategoryFieldsFragmentDoc}`;
export const CardPaymentMethodFragmentDoc = gql`
    fragment CardPaymentMethod on PaymentMethod {
  card {
    brand
    last4
  }
}
    `;
export const EventFormDataWrapperFormFragmentDoc = gql`
    fragment EventFormDataWrapperForm on Form {
  id
  title
  description
  schemaUrl
  config
  settings
  eventId
  type
  enabled
}
    `;
export const EventFormFunctionalWrapperAnswerFragmentDoc = gql`
    fragment EventFormFunctionalWrapperAnswer on Answer {
  id
  questionValue {
    stepName
    stepTitle
    field
    placeholder
    stepDescription
  }
  contact {
    firstName
    lastName
    email
  }
  answerValue
  guestKey
}
    `;
export const PhotoDataFragmentDoc = gql`
    fragment PhotoData on Photo {
  id
  assetId
  height
  width
  url
  layout {
    alignX
    alignY
  }
}
    `;
export const ScheduleItemFragmentDoc = gql`
    fragment ScheduleItem on EventSchedule {
  id
  name
  description
  startTime {
    dateString
    timestamp
  }
  endTime {
    dateString
    timestamp
  }
  timezone
  virtualEventLink {
    urlLinkText
  }
  dressCode
  location
  showMap
  placeId
  locationInfo {
    id
    placeId
    name
    address1
    city
    state
    latitude
    longitude
  }
}
    `;
export const EventAccommodationPublicDataFragmentDoc = gql`
    fragment EventAccommodationPublicData on AccommodationPlaceV2 {
  id
  type
  isFromAccommodationCatalog
  joyPlaceId
  zhId
  isFavorite
  userNote
  description
  accommodationRoomBlock {
    ...AccommodationRoomBlock
  }
  customName
  name
  email
  customPhone
  phone
  customUrl
  url
  isPhotoHidden
  customPhoto {
    id
    url
  }
  photo {
    id
    url
  }
  customAddress
  address
  city
  country
  state
  postalCode
  latitude: lat
  longitude: long
}
    ${AccommodationRoomBlockFragmentDoc}`;
export const AutopopulateOperationFragmentDoc = gql`
    fragment AutopopulateOperation on AutopopulateOperationItemV20251203 {
  error
  eventId
  idempotentId
  result {
    algoTag
    items {
      accommodationPlaceId
      proposedNoteFromHostToGuest
      whyThisHotelIsAGreatPick
    }
  }
  status
}
    `;
export const StationeryProductsFragmentDoc = gql`
    fragment StationeryProducts on StationeryTemplate {
  products {
    id
    priceConfigId
    vendor
    productType
    vendorBaseSKU
    ...StationeryShippingOptions
    ...StationeryProductAttributes
    ...StationeryProductPricings
    ...StationeryProductVariantGroups
  }
}
    ${StationeryShippingOptionsFragmentDoc}
${StationeryProductAttributesFragmentDoc}
${StationeryProductPricingsFragmentDoc}
${StationeryProductVariantGroupsFragmentDoc}`;
export const AutopopulateStayAreaOperationFragmentDoc = gql`
    fragment AutopopulateStayAreaOperation on AutopopulateStayAreaOperationItem {
  eventId
  operationType
  status
  error
  result {
    id
    name
  }
}
    `;
export const StayAreaFragmentDoc = gql`
    fragment StayArea on JoyStayArea {
  id
  name
  areaType
  bestForTags
  address
  bounds {
    ne {
      lng
    }
    sw {
      lat
      lng
    }
  }
  center {
    lat
    lng
  }
  description
  proposedNoteFromHostToGuest
  watchOuts
  whyThisAreaIsAGreatPick
  photos {
    id
    url
  }
  distances {
    durationMinutes
    km
    mi
    type
  }
}
    `;
export const CreateGeneralEventLandingCategoriesDocument = gql`
    query CreateGeneralEventLandingCategories {
  eventTypeCategories
}
    `;

/**
 * __useCreateGeneralEventLandingCategoriesQuery__
 *
 * To run a query within a React component, call `useCreateGeneralEventLandingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralEventLandingCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateGeneralEventLandingCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateGeneralEventLandingCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateGeneralEventLandingCategoriesQuery, CreateGeneralEventLandingCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<CreateGeneralEventLandingCategoriesQuery, CreateGeneralEventLandingCategoriesQueryVariables>(CreateGeneralEventLandingCategoriesDocument, baseOptions);
      }
export function useCreateGeneralEventLandingCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateGeneralEventLandingCategoriesQuery, CreateGeneralEventLandingCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CreateGeneralEventLandingCategoriesQuery, CreateGeneralEventLandingCategoriesQueryVariables>(CreateGeneralEventLandingCategoriesDocument, baseOptions);
        }
export type CreateGeneralEventLandingCategoriesQueryHookResult = ReturnType<typeof useCreateGeneralEventLandingCategoriesQuery>;
export type CreateGeneralEventLandingCategoriesLazyQueryHookResult = ReturnType<typeof useCreateGeneralEventLandingCategoriesLazyQuery>;
export type CreateGeneralEventLandingCategoriesQueryResult = Apollo.QueryResult<CreateGeneralEventLandingCategoriesQuery, CreateGeneralEventLandingCategoriesQueryVariables>;
export const CreateGeneralEventEventTypesByCategoryDocument = gql`
    query CreateGeneralEventEventTypesByCategory($filters: EventTypesByCategoryFilters!) {
  eventTypesByCategory(filters: $filters) {
    ...GeneralEventType
  }
}
    ${GeneralEventTypeFragmentDoc}`;

/**
 * __useCreateGeneralEventEventTypesByCategoryQuery__
 *
 * To run a query within a React component, call `useCreateGeneralEventEventTypesByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralEventEventTypesByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateGeneralEventEventTypesByCategoryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateGeneralEventEventTypesByCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateGeneralEventEventTypesByCategoryQuery, CreateGeneralEventEventTypesByCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<CreateGeneralEventEventTypesByCategoryQuery, CreateGeneralEventEventTypesByCategoryQueryVariables>(CreateGeneralEventEventTypesByCategoryDocument, baseOptions);
      }
export function useCreateGeneralEventEventTypesByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateGeneralEventEventTypesByCategoryQuery, CreateGeneralEventEventTypesByCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CreateGeneralEventEventTypesByCategoryQuery, CreateGeneralEventEventTypesByCategoryQueryVariables>(CreateGeneralEventEventTypesByCategoryDocument, baseOptions);
        }
export type CreateGeneralEventEventTypesByCategoryQueryHookResult = ReturnType<typeof useCreateGeneralEventEventTypesByCategoryQuery>;
export type CreateGeneralEventEventTypesByCategoryLazyQueryHookResult = ReturnType<typeof useCreateGeneralEventEventTypesByCategoryLazyQuery>;
export type CreateGeneralEventEventTypesByCategoryQueryResult = Apollo.QueryResult<CreateGeneralEventEventTypesByCategoryQuery, CreateGeneralEventEventTypesByCategoryQueryVariables>;
export const GetAllowedDesignParamsDocument = gql`
    query GetAllowedDesignParams {
  themes {
    id
    themeId
  }
  fonts {
    id
    display
  }
}
    `;

/**
 * __useGetAllowedDesignParamsQuery__
 *
 * To run a query within a React component, call `useGetAllowedDesignParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedDesignParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedDesignParamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllowedDesignParamsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllowedDesignParamsQuery, GetAllowedDesignParamsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllowedDesignParamsQuery, GetAllowedDesignParamsQueryVariables>(GetAllowedDesignParamsDocument, baseOptions);
      }
export function useGetAllowedDesignParamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllowedDesignParamsQuery, GetAllowedDesignParamsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllowedDesignParamsQuery, GetAllowedDesignParamsQueryVariables>(GetAllowedDesignParamsDocument, baseOptions);
        }
export type GetAllowedDesignParamsQueryHookResult = ReturnType<typeof useGetAllowedDesignParamsQuery>;
export type GetAllowedDesignParamsLazyQueryHookResult = ReturnType<typeof useGetAllowedDesignParamsLazyQuery>;
export type GetAllowedDesignParamsQueryResult = Apollo.QueryResult<GetAllowedDesignParamsQuery, GetAllowedDesignParamsQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($payload: CreateEventPayload0301!) {
  createEventV0301(payload: $payload) {
    __typename
    website
    eventId
    firebaseId
    id
    firebaseCreateAt {
      ...Date
    }
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      eventType
      finalizedDate {
        ...Date
      }
    }
    eventDesign {
      id
      websiteLayout {
        id
      }
    }
  }
}
    ${DateFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, baseOptions);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateGeneralEventDocument = gql`
    mutation CreateGeneralEvent($payload: CreateGeneralEventPayload!) {
  createGeneralEvent(payload: $payload) {
    __typename
    website
    eventId
    firebaseId
    id
    firebaseCreateAt {
      ...Date
    }
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      eventType
      finalizedDate {
        ...Date
      }
    }
    eventDesign {
      id
      websiteLayout {
        id
      }
    }
  }
}
    ${DateFragmentDoc}`;
export type CreateGeneralEventMutationFn = Apollo.MutationFunction<CreateGeneralEventMutation, CreateGeneralEventMutationVariables>;

/**
 * __useCreateGeneralEventMutation__
 *
 * To run a mutation, you first call `useCreateGeneralEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeneralEventMutation, { data, loading, error }] = useCreateGeneralEventMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateGeneralEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGeneralEventMutation, CreateGeneralEventMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateGeneralEventMutation, CreateGeneralEventMutationVariables>(CreateGeneralEventDocument, baseOptions);
      }
export type CreateGeneralEventMutationHookResult = ReturnType<typeof useCreateGeneralEventMutation>;
export type CreateGeneralEventMutationResult = Apollo.MutationResult<CreateGeneralEventMutation>;
export type CreateGeneralEventMutationOptions = Apollo.BaseMutationOptions<CreateGeneralEventMutation, CreateGeneralEventMutationVariables>;
export const SetAndPublishThemeLayoutForCreateSurveyDocument = gql`
    mutation SetAndPublishThemeLayoutForCreateSurvey($themeAndLayoutPayload: SetThemeAndLayoutPayload!, $eventDesignId: ID!) {
  setThemeAndLayout(payload: $themeAndLayoutPayload) {
    id
  }
  publishEventDesignDraft(id: $eventDesignId) {
    id
    hasUnpublishedChanges
    websiteLayout {
      id
      layoutType
    }
    theme {
      id
      themeId
    }
  }
}
    `;
export type SetAndPublishThemeLayoutForCreateSurveyMutationFn = Apollo.MutationFunction<SetAndPublishThemeLayoutForCreateSurveyMutation, SetAndPublishThemeLayoutForCreateSurveyMutationVariables>;

/**
 * __useSetAndPublishThemeLayoutForCreateSurveyMutation__
 *
 * To run a mutation, you first call `useSetAndPublishThemeLayoutForCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAndPublishThemeLayoutForCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAndPublishThemeLayoutForCreateSurveyMutation, { data, loading, error }] = useSetAndPublishThemeLayoutForCreateSurveyMutation({
 *   variables: {
 *      themeAndLayoutPayload: // value for 'themeAndLayoutPayload'
 *      eventDesignId: // value for 'eventDesignId'
 *   },
 * });
 */
export function useSetAndPublishThemeLayoutForCreateSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAndPublishThemeLayoutForCreateSurveyMutation, SetAndPublishThemeLayoutForCreateSurveyMutationVariables>) {
        return ApolloReactHooks.useMutation<SetAndPublishThemeLayoutForCreateSurveyMutation, SetAndPublishThemeLayoutForCreateSurveyMutationVariables>(SetAndPublishThemeLayoutForCreateSurveyDocument, baseOptions);
      }
export type SetAndPublishThemeLayoutForCreateSurveyMutationHookResult = ReturnType<typeof useSetAndPublishThemeLayoutForCreateSurveyMutation>;
export type SetAndPublishThemeLayoutForCreateSurveyMutationResult = Apollo.MutationResult<SetAndPublishThemeLayoutForCreateSurveyMutation>;
export type SetAndPublishThemeLayoutForCreateSurveyMutationOptions = Apollo.BaseMutationOptions<SetAndPublishThemeLayoutForCreateSurveyMutation, SetAndPublishThemeLayoutForCreateSurveyMutationVariables>;
export const RegistryPhotoByEventIdDocument = gql`
    query RegistryPhotoByEventId($eventId: ID!) {
  eventById(id: $eventId) {
    id
    pages(type: registry) {
      id
      photo {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useRegistryPhotoByEventIdQuery__
 *
 * To run a query within a React component, call `useRegistryPhotoByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryPhotoByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryPhotoByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRegistryPhotoByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryPhotoByEventIdQuery, RegistryPhotoByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryPhotoByEventIdQuery, RegistryPhotoByEventIdQueryVariables>(RegistryPhotoByEventIdDocument, baseOptions);
      }
export function useRegistryPhotoByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryPhotoByEventIdQuery, RegistryPhotoByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryPhotoByEventIdQuery, RegistryPhotoByEventIdQueryVariables>(RegistryPhotoByEventIdDocument, baseOptions);
        }
export type RegistryPhotoByEventIdQueryHookResult = ReturnType<typeof useRegistryPhotoByEventIdQuery>;
export type RegistryPhotoByEventIdLazyQueryHookResult = ReturnType<typeof useRegistryPhotoByEventIdLazyQuery>;
export type RegistryPhotoByEventIdQueryResult = Apollo.QueryResult<RegistryPhotoByEventIdQuery, RegistryPhotoByEventIdQueryVariables>;
export const GetInlineEditEventInfoDocument = gql`
    query GetInlineEditEventInfo($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventPassword
    }
  }
}
    `;

/**
 * __useGetInlineEditEventInfoQuery__
 *
 * To run a query within a React component, call `useGetInlineEditEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInlineEditEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInlineEditEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetInlineEditEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>(GetInlineEditEventInfoDocument, baseOptions);
      }
export function useGetInlineEditEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>(GetInlineEditEventInfoDocument, baseOptions);
        }
export type GetInlineEditEventInfoQueryHookResult = ReturnType<typeof useGetInlineEditEventInfoQuery>;
export type GetInlineEditEventInfoLazyQueryHookResult = ReturnType<typeof useGetInlineEditEventInfoLazyQuery>;
export type GetInlineEditEventInfoQueryResult = Apollo.QueryResult<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>;
export const GetPagePhotoInfoDocument = gql`
    query GetPagePhotoInfo($eventHandle: String!, $type: EventPageType, $eventDesignPurpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    pagesInfo(type: $type) {
      id
      page {
        id
        type
        pageSlug
        photoV2 {
          ... on Photo {
            id
            url
            width
            height
            layout {
              alignX
              alignY
            }
          }
          ... on DefaultPagePhoto {
            id
            url
            width
            height
            layout {
              alignX
              alignY
            }
          }
        }
        photoPresentation {
          id
          presentationLayout
          cropInfo {
            x
            y
            width
            height
            unit
          }
        }
      }
    }
    eventDesign(purpose: $eventDesignPurpose) {
      id
      websiteLayout {
        id
        layoutType
      }
    }
  }
}
    `;

/**
 * __useGetPagePhotoInfoQuery__
 *
 * To run a query within a React component, call `useGetPagePhotoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePhotoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePhotoInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      type: // value for 'type'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGetPagePhotoInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>(GetPagePhotoInfoDocument, baseOptions);
      }
export function useGetPagePhotoInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>(GetPagePhotoInfoDocument, baseOptions);
        }
export type GetPagePhotoInfoQueryHookResult = ReturnType<typeof useGetPagePhotoInfoQuery>;
export type GetPagePhotoInfoLazyQueryHookResult = ReturnType<typeof useGetPagePhotoInfoLazyQuery>;
export type GetPagePhotoInfoQueryResult = Apollo.QueryResult<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>;
export const EventWebsitePagesDocument = gql`
    query EventWebsitePages($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true) {
      visibility
      pageSlug
      id
      type
      pageTitle
      createdAt {
        timestamp
      }
    }
  }
}
    `;

/**
 * __useEventWebsitePagesQuery__
 *
 * To run a query within a React component, call `useEventWebsitePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsitePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsitePagesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventWebsitePagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsitePagesQuery, EventWebsitePagesQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWebsitePagesQuery, EventWebsitePagesQueryVariables>(EventWebsitePagesDocument, baseOptions);
      }
export function useEventWebsitePagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsitePagesQuery, EventWebsitePagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWebsitePagesQuery, EventWebsitePagesQueryVariables>(EventWebsitePagesDocument, baseOptions);
        }
export type EventWebsitePagesQueryHookResult = ReturnType<typeof useEventWebsitePagesQuery>;
export type EventWebsitePagesLazyQueryHookResult = ReturnType<typeof useEventWebsitePagesLazyQuery>;
export type EventWebsitePagesQueryResult = Apollo.QueryResult<EventWebsitePagesQuery, EventWebsitePagesQueryVariables>;
export const EventWebsitePagesVisibilityDocument = gql`
    query EventWebsitePagesVisibility($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true) {
      visibility
      id
      type
      pageSlug
    }
  }
}
    `;

/**
 * __useEventWebsitePagesVisibilityQuery__
 *
 * To run a query within a React component, call `useEventWebsitePagesVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsitePagesVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsitePagesVisibilityQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventWebsitePagesVisibilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsitePagesVisibilityQuery, EventWebsitePagesVisibilityQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWebsitePagesVisibilityQuery, EventWebsitePagesVisibilityQueryVariables>(EventWebsitePagesVisibilityDocument, baseOptions);
      }
export function useEventWebsitePagesVisibilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsitePagesVisibilityQuery, EventWebsitePagesVisibilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWebsitePagesVisibilityQuery, EventWebsitePagesVisibilityQueryVariables>(EventWebsitePagesVisibilityDocument, baseOptions);
        }
export type EventWebsitePagesVisibilityQueryHookResult = ReturnType<typeof useEventWebsitePagesVisibilityQuery>;
export type EventWebsitePagesVisibilityLazyQueryHookResult = ReturnType<typeof useEventWebsitePagesVisibilityLazyQuery>;
export type EventWebsitePagesVisibilityQueryResult = Apollo.QueryResult<EventWebsitePagesVisibilityQuery, EventWebsitePagesVisibilityQueryVariables>;
export const UpdateAccommodationsSortOrderDataDocument = gql`
    query UpdateAccommodationsSortOrderData($payload: PageContainerBySlugPayload!, $options: PageContainerBySlugOptions, $name: String!) {
  pageContainerBySlug(payload: $payload, options: $options) {
    id
    components {
      ... on TravelMapComponent {
        id
        sortOrder
        blockOrdering
      }
    }
  }
  eventByName(name: $name) {
    id
    accommodationPlacesV2 {
      id
    }
  }
}
    `;

/**
 * __useUpdateAccommodationsSortOrderDataQuery__
 *
 * To run a query within a React component, call `useUpdateAccommodationsSortOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationsSortOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateAccommodationsSortOrderDataQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      options: // value for 'options'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateAccommodationsSortOrderDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UpdateAccommodationsSortOrderDataQuery, UpdateAccommodationsSortOrderDataQueryVariables>) {
        return ApolloReactHooks.useQuery<UpdateAccommodationsSortOrderDataQuery, UpdateAccommodationsSortOrderDataQueryVariables>(UpdateAccommodationsSortOrderDataDocument, baseOptions);
      }
export function useUpdateAccommodationsSortOrderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UpdateAccommodationsSortOrderDataQuery, UpdateAccommodationsSortOrderDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UpdateAccommodationsSortOrderDataQuery, UpdateAccommodationsSortOrderDataQueryVariables>(UpdateAccommodationsSortOrderDataDocument, baseOptions);
        }
export type UpdateAccommodationsSortOrderDataQueryHookResult = ReturnType<typeof useUpdateAccommodationsSortOrderDataQuery>;
export type UpdateAccommodationsSortOrderDataLazyQueryHookResult = ReturnType<typeof useUpdateAccommodationsSortOrderDataLazyQuery>;
export type UpdateAccommodationsSortOrderDataQueryResult = Apollo.QueryResult<UpdateAccommodationsSortOrderDataQuery, UpdateAccommodationsSortOrderDataQueryVariables>;
export const GetTagsByEventDocument = gql`
    query GetTagsByEvent($eventId: String!) {
  getTagsByEvent(eventId: $eventId) {
    id
    label
    createdAt
  }
}
    `;

/**
 * __useGetTagsByEventQuery__
 *
 * To run a query within a React component, call `useGetTagsByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTagsByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsByEventQuery, GetTagsByEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTagsByEventQuery, GetTagsByEventQueryVariables>(GetTagsByEventDocument, baseOptions);
      }
export function useGetTagsByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsByEventQuery, GetTagsByEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTagsByEventQuery, GetTagsByEventQueryVariables>(GetTagsByEventDocument, baseOptions);
        }
export type GetTagsByEventQueryHookResult = ReturnType<typeof useGetTagsByEventQuery>;
export type GetTagsByEventLazyQueryHookResult = ReturnType<typeof useGetTagsByEventLazyQuery>;
export type GetTagsByEventQueryResult = Apollo.QueryResult<GetTagsByEventQuery, GetTagsByEventQueryVariables>;
export const GetTagsByResourceDocument = gql`
    query GetTagsByResource($eventId: String!, $resourceId: String!) {
  getTagsByResource(eventId: $eventId, resourceId: $resourceId) {
    id
    label
  }
}
    `;

/**
 * __useGetTagsByResourceQuery__
 *
 * To run a query within a React component, call `useGetTagsByResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByResourceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetTagsByResourceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsByResourceQuery, GetTagsByResourceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTagsByResourceQuery, GetTagsByResourceQueryVariables>(GetTagsByResourceDocument, baseOptions);
      }
export function useGetTagsByResourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsByResourceQuery, GetTagsByResourceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTagsByResourceQuery, GetTagsByResourceQueryVariables>(GetTagsByResourceDocument, baseOptions);
        }
export type GetTagsByResourceQueryHookResult = ReturnType<typeof useGetTagsByResourceQuery>;
export type GetTagsByResourceLazyQueryHookResult = ReturnType<typeof useGetTagsByResourceLazyQuery>;
export type GetTagsByResourceQueryResult = Apollo.QueryResult<GetTagsByResourceQuery, GetTagsByResourceQueryVariables>;
export const GetGuestListMembersByTagIdsDocument = gql`
    query GetGuestListMembersByTagIds($eventId: String!, $tagIds: [ID!]!) {
  getGuestListMembersByTagIds(eventId: $eventId, tagIds: $tagIds) {
    id
    tags {
      tagDefinitionId
    }
  }
}
    `;

/**
 * __useGetGuestListMembersByTagIdsQuery__
 *
 * To run a query within a React component, call `useGetGuestListMembersByTagIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestListMembersByTagIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestListMembersByTagIdsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useGetGuestListMembersByTagIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestListMembersByTagIdsQuery, GetGuestListMembersByTagIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestListMembersByTagIdsQuery, GetGuestListMembersByTagIdsQueryVariables>(GetGuestListMembersByTagIdsDocument, baseOptions);
      }
export function useGetGuestListMembersByTagIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestListMembersByTagIdsQuery, GetGuestListMembersByTagIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestListMembersByTagIdsQuery, GetGuestListMembersByTagIdsQueryVariables>(GetGuestListMembersByTagIdsDocument, baseOptions);
        }
export type GetGuestListMembersByTagIdsQueryHookResult = ReturnType<typeof useGetGuestListMembersByTagIdsQuery>;
export type GetGuestListMembersByTagIdsLazyQueryHookResult = ReturnType<typeof useGetGuestListMembersByTagIdsLazyQuery>;
export type GetGuestListMembersByTagIdsQueryResult = Apollo.QueryResult<GetGuestListMembersByTagIdsQuery, GetGuestListMembersByTagIdsQueryVariables>;
export const GetTagsByResourcesDocument = gql`
    query GetTagsByResources($eventId: String!, $resourceIds: [String!]!) {
  getTagsByResources(eventId: $eventId, resourceIds: $resourceIds) {
    resourceId
    tags {
      id
      label
    }
  }
}
    `;

/**
 * __useGetTagsByResourcesQuery__
 *
 * To run a query within a React component, call `useGetTagsByResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByResourcesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      resourceIds: // value for 'resourceIds'
 *   },
 * });
 */
export function useGetTagsByResourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsByResourcesQuery, GetTagsByResourcesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTagsByResourcesQuery, GetTagsByResourcesQueryVariables>(GetTagsByResourcesDocument, baseOptions);
      }
export function useGetTagsByResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsByResourcesQuery, GetTagsByResourcesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTagsByResourcesQuery, GetTagsByResourcesQueryVariables>(GetTagsByResourcesDocument, baseOptions);
        }
export type GetTagsByResourcesQueryHookResult = ReturnType<typeof useGetTagsByResourcesQuery>;
export type GetTagsByResourcesLazyQueryHookResult = ReturnType<typeof useGetTagsByResourcesLazyQuery>;
export type GetTagsByResourcesQueryResult = Apollo.QueryResult<GetTagsByResourcesQuery, GetTagsByResourcesQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($eventId: String!, $label: String!) {
  createTag(eventId: $eventId, label: $label) {
    id
    label
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, baseOptions);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const SetTagsForResourceDocument = gql`
    mutation SetTagsForResource($eventId: String!, $resourceId: String!, $resourceType: String!, $tagIds: [ID!]!) {
  setTagsForResource(eventId: $eventId, resourceId: $resourceId, resourceType: $resourceType, tagIds: $tagIds)
}
    `;
export type SetTagsForResourceMutationFn = Apollo.MutationFunction<SetTagsForResourceMutation, SetTagsForResourceMutationVariables>;

/**
 * __useSetTagsForResourceMutation__
 *
 * To run a mutation, you first call `useSetTagsForResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTagsForResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTagsForResourceMutation, { data, loading, error }] = useSetTagsForResourceMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      resourceId: // value for 'resourceId'
 *      resourceType: // value for 'resourceType'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useSetTagsForResourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetTagsForResourceMutation, SetTagsForResourceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetTagsForResourceMutation, SetTagsForResourceMutationVariables>(SetTagsForResourceDocument, baseOptions);
      }
export type SetTagsForResourceMutationHookResult = ReturnType<typeof useSetTagsForResourceMutation>;
export type SetTagsForResourceMutationResult = Apollo.MutationResult<SetTagsForResourceMutation>;
export type SetTagsForResourceMutationOptions = Apollo.BaseMutationOptions<SetTagsForResourceMutation, SetTagsForResourceMutationVariables>;
export const GetUniversalBurgerMenuDataDocument = gql`
    query GetUniversalBurgerMenuData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      tentativeDate {
        timestamp
      }
      location
    }
    photo {
      id
      url
    }
    pages(admin: true) {
      visibility
      pageSlug
      id
      type
      pageTitle
    }
    productVerticals {
      optOutOfGuestList
      optOutOfInvites
      optOutOfRegistry
      optOutOfWebsite
    }
  }
}
    `;

/**
 * __useGetUniversalBurgerMenuDataQuery__
 *
 * To run a query within a React component, call `useGetUniversalBurgerMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversalBurgerMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversalBurgerMenuDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetUniversalBurgerMenuDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>(GetUniversalBurgerMenuDataDocument, baseOptions);
      }
export function useGetUniversalBurgerMenuDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>(GetUniversalBurgerMenuDataDocument, baseOptions);
        }
export type GetUniversalBurgerMenuDataQueryHookResult = ReturnType<typeof useGetUniversalBurgerMenuDataQuery>;
export type GetUniversalBurgerMenuDataLazyQueryHookResult = ReturnType<typeof useGetUniversalBurgerMenuDataLazyQuery>;
export type GetUniversalBurgerMenuDataQueryResult = Apollo.QueryResult<GetUniversalBurgerMenuDataQuery, GetUniversalBurgerMenuDataQueryVariables>;
export const VIPEditorCreateVIPDocument = gql`
    mutation VIPEditorCreateVIP($payload: CreateVipPayload!) {
  createVip(payload: $payload) {
    ...Vip
  }
}
    ${VipFragmentDoc}`;
export type VIPEditorCreateVIPMutationFn = Apollo.MutationFunction<VIPEditorCreateVIPMutation, VIPEditorCreateVIPMutationVariables>;

/**
 * __useVIPEditorCreateVIPMutation__
 *
 * To run a mutation, you first call `useVIPEditorCreateVIPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVIPEditorCreateVIPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipEditorCreateVipMutation, { data, loading, error }] = useVIPEditorCreateVIPMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useVIPEditorCreateVIPMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VIPEditorCreateVIPMutation, VIPEditorCreateVIPMutationVariables>) {
        return ApolloReactHooks.useMutation<VIPEditorCreateVIPMutation, VIPEditorCreateVIPMutationVariables>(VIPEditorCreateVIPDocument, baseOptions);
      }
export type VIPEditorCreateVIPMutationHookResult = ReturnType<typeof useVIPEditorCreateVIPMutation>;
export type VIPEditorCreateVIPMutationResult = Apollo.MutationResult<VIPEditorCreateVIPMutation>;
export type VIPEditorCreateVIPMutationOptions = Apollo.BaseMutationOptions<VIPEditorCreateVIPMutation, VIPEditorCreateVIPMutationVariables>;
export const VIPEditorUpdateVIPDocument = gql`
    mutation VIPEditorUpdateVIP($payload: UpdateVipPayload!) {
  updateVip(payload: $payload) {
    ...Vip
  }
}
    ${VipFragmentDoc}`;
export type VIPEditorUpdateVIPMutationFn = Apollo.MutationFunction<VIPEditorUpdateVIPMutation, VIPEditorUpdateVIPMutationVariables>;

/**
 * __useVIPEditorUpdateVIPMutation__
 *
 * To run a mutation, you first call `useVIPEditorUpdateVIPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVIPEditorUpdateVIPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipEditorUpdateVipMutation, { data, loading, error }] = useVIPEditorUpdateVIPMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useVIPEditorUpdateVIPMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VIPEditorUpdateVIPMutation, VIPEditorUpdateVIPMutationVariables>) {
        return ApolloReactHooks.useMutation<VIPEditorUpdateVIPMutation, VIPEditorUpdateVIPMutationVariables>(VIPEditorUpdateVIPDocument, baseOptions);
      }
export type VIPEditorUpdateVIPMutationHookResult = ReturnType<typeof useVIPEditorUpdateVIPMutation>;
export type VIPEditorUpdateVIPMutationResult = Apollo.MutationResult<VIPEditorUpdateVIPMutation>;
export type VIPEditorUpdateVIPMutationOptions = Apollo.BaseMutationOptions<VIPEditorUpdateVIPMutation, VIPEditorUpdateVIPMutationVariables>;
export const VIPEditorVIPByIdDocument = gql`
    query VIPEditorVIPById($id: ID!) {
  vip(id: $id) {
    ...Vip
  }
}
    ${VipFragmentDoc}`;

/**
 * __useVIPEditorVIPByIdQuery__
 *
 * To run a query within a React component, call `useVIPEditorVIPByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVIPEditorVIPByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVIPEditorVIPByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVIPEditorVIPByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VIPEditorVIPByIdQuery, VIPEditorVIPByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<VIPEditorVIPByIdQuery, VIPEditorVIPByIdQueryVariables>(VIPEditorVIPByIdDocument, baseOptions);
      }
export function useVIPEditorVIPByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VIPEditorVIPByIdQuery, VIPEditorVIPByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VIPEditorVIPByIdQuery, VIPEditorVIPByIdQueryVariables>(VIPEditorVIPByIdDocument, baseOptions);
        }
export type VIPEditorVIPByIdQueryHookResult = ReturnType<typeof useVIPEditorVIPByIdQuery>;
export type VIPEditorVIPByIdLazyQueryHookResult = ReturnType<typeof useVIPEditorVIPByIdLazyQuery>;
export type VIPEditorVIPByIdQueryResult = Apollo.QueryResult<VIPEditorVIPByIdQuery, VIPEditorVIPByIdQueryVariables>;
export const GetContactCollectionByEventIdAndNamesByEventHandleDocument = gql`
    query GetContactCollectionByEventIdAndNamesByEventHandle($eventId: String!, $eventHandle: String!) {
  getContactCollectionByEventId(eventId: $eventId) {
    id
    eventDateDisplayEnabled
    websiteLinkEnabled
    mediaSource
    mediaType
    message
    magicLink
    contacts {
      id
      firstName
      lastName
      createdAt
    }
    active
    collectHousehold
  }
  eventByName(name: $eventHandle) {
    ...ContactCollectionEvent
  }
}
    ${ContactCollectionEventFragmentDoc}`;

/**
 * __useGetContactCollectionByEventIdAndNamesByEventHandleQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByEventIdAndNamesByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByEventIdAndNamesByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByEventIdAndNamesByEventHandleQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetContactCollectionByEventIdAndNamesByEventHandleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>(GetContactCollectionByEventIdAndNamesByEventHandleDocument, baseOptions);
      }
export function useGetContactCollectionByEventIdAndNamesByEventHandleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>(GetContactCollectionByEventIdAndNamesByEventHandleDocument, baseOptions);
        }
export type GetContactCollectionByEventIdAndNamesByEventHandleQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdAndNamesByEventHandleQuery>;
export type GetContactCollectionByEventIdAndNamesByEventHandleLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdAndNamesByEventHandleLazyQuery>;
export type GetContactCollectionByEventIdAndNamesByEventHandleQueryResult = Apollo.QueryResult<GetContactCollectionByEventIdAndNamesByEventHandleQuery, GetContactCollectionByEventIdAndNamesByEventHandleQueryVariables>;
export const GetContactCollectionByMagicLinkDocument = gql`
    query GetContactCollectionByMagicLink($magicLink: String!) {
  getContactCollectionByMagicLink(magicLink: $magicLink) {
    id
    eventId
    eventDateDisplayEnabled
    mediaSource
    mediaType
    message
    websiteLinkEnabled
    active
    collectHousehold
  }
}
    `;

/**
 * __useGetContactCollectionByMagicLinkQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByMagicLinkQuery({
 *   variables: {
 *      magicLink: // value for 'magicLink'
 *   },
 * });
 */
export function useGetContactCollectionByMagicLinkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>(GetContactCollectionByMagicLinkDocument, baseOptions);
      }
export function useGetContactCollectionByMagicLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>(GetContactCollectionByMagicLinkDocument, baseOptions);
        }
export type GetContactCollectionByMagicLinkQueryHookResult = ReturnType<typeof useGetContactCollectionByMagicLinkQuery>;
export type GetContactCollectionByMagicLinkLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByMagicLinkLazyQuery>;
export type GetContactCollectionByMagicLinkQueryResult = Apollo.QueryResult<GetContactCollectionByMagicLinkQuery, GetContactCollectionByMagicLinkQueryVariables>;
export const GetDataForContactCollectionGuestDocument = gql`
    query GetDataForContactCollectionGuest($eventId: ID!) {
  eventById(id: $eventId) {
    id
    firebaseId
    website
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      dateV0918 {
        dateString(dateFormat: full)
      }
    }
    eventDesign(purpose: live) {
      ...EventDesign
    }
  }
}
    ${EventDesignFragmentDoc}`;

/**
 * __useGetDataForContactCollectionGuestQuery__
 *
 * To run a query within a React component, call `useGetDataForContactCollectionGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForContactCollectionGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForContactCollectionGuestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetDataForContactCollectionGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>(GetDataForContactCollectionGuestDocument, baseOptions);
      }
export function useGetDataForContactCollectionGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>(GetDataForContactCollectionGuestDocument, baseOptions);
        }
export type GetDataForContactCollectionGuestQueryHookResult = ReturnType<typeof useGetDataForContactCollectionGuestQuery>;
export type GetDataForContactCollectionGuestLazyQueryHookResult = ReturnType<typeof useGetDataForContactCollectionGuestLazyQuery>;
export type GetDataForContactCollectionGuestQueryResult = Apollo.QueryResult<GetDataForContactCollectionGuestQuery, GetDataForContactCollectionGuestQueryVariables>;
export const GetTelemetryDataForContactCollectionGuestDocument = gql`
    query GetTelemetryDataForContactCollectionGuest($eventId: ID!) {
  eventById(id: $eventId) {
    id
    firebaseId
    info {
      id
      eventType
    }
    website
  }
}
    `;

/**
 * __useGetTelemetryDataForContactCollectionGuestQuery__
 *
 * To run a query within a React component, call `useGetTelemetryDataForContactCollectionGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTelemetryDataForContactCollectionGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTelemetryDataForContactCollectionGuestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTelemetryDataForContactCollectionGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>(GetTelemetryDataForContactCollectionGuestDocument, baseOptions);
      }
export function useGetTelemetryDataForContactCollectionGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>(GetTelemetryDataForContactCollectionGuestDocument, baseOptions);
        }
export type GetTelemetryDataForContactCollectionGuestQueryHookResult = ReturnType<typeof useGetTelemetryDataForContactCollectionGuestQuery>;
export type GetTelemetryDataForContactCollectionGuestLazyQueryHookResult = ReturnType<typeof useGetTelemetryDataForContactCollectionGuestLazyQuery>;
export type GetTelemetryDataForContactCollectionGuestQueryResult = Apollo.QueryResult<GetTelemetryDataForContactCollectionGuestQuery, GetTelemetryDataForContactCollectionGuestQueryVariables>;
export const GetContactsByContactCollectionDocument = gql`
    query GetContactsByContactCollection($contactCollectionId: ID!) {
  getContactsByContactCollection(contactCollectionId: $contactCollectionId) {
    id
  }
}
    `;

/**
 * __useGetContactsByContactCollectionQuery__
 *
 * To run a query within a React component, call `useGetContactsByContactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByContactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByContactCollectionQuery({
 *   variables: {
 *      contactCollectionId: // value for 'contactCollectionId'
 *   },
 * });
 */
export function useGetContactsByContactCollectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>(GetContactsByContactCollectionDocument, baseOptions);
      }
export function useGetContactsByContactCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>(GetContactsByContactCollectionDocument, baseOptions);
        }
export type GetContactsByContactCollectionQueryHookResult = ReturnType<typeof useGetContactsByContactCollectionQuery>;
export type GetContactsByContactCollectionLazyQueryHookResult = ReturnType<typeof useGetContactsByContactCollectionLazyQuery>;
export type GetContactsByContactCollectionQueryResult = Apollo.QueryResult<GetContactsByContactCollectionQuery, GetContactsByContactCollectionQueryVariables>;
export const AuthenticateUserDocument = gql`
    query AuthenticateUser($authToken: String!) {
  authenticateUser(authToken: $authToken) {
    userJWT
  }
}
    `;

/**
 * __useAuthenticateUserQuery__
 *
 * To run a query within a React component, call `useAuthenticateUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticateUserQuery({
 *   variables: {
 *      authToken: // value for 'authToken'
 *   },
 * });
 */
export function useAuthenticateUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AuthenticateUserQuery, AuthenticateUserQueryVariables>) {
        return ApolloReactHooks.useQuery<AuthenticateUserQuery, AuthenticateUserQueryVariables>(AuthenticateUserDocument, baseOptions);
      }
export function useAuthenticateUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthenticateUserQuery, AuthenticateUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AuthenticateUserQuery, AuthenticateUserQueryVariables>(AuthenticateUserDocument, baseOptions);
        }
export type AuthenticateUserQueryHookResult = ReturnType<typeof useAuthenticateUserQuery>;
export type AuthenticateUserLazyQueryHookResult = ReturnType<typeof useAuthenticateUserLazyQuery>;
export type AuthenticateUserQueryResult = Apollo.QueryResult<AuthenticateUserQuery, AuthenticateUserQueryVariables>;
export const GetContactCollectionByFirebaseEventIdOrCreateOneDocument = gql`
    query GetContactCollectionByFirebaseEventIdOrCreateOne($firebaseEventId: ID!) {
  getContactCollectionByFirebaseEventIdOrCreateOne(firebaseEventId: $firebaseEventId) {
    id
    eventId
  }
}
    `;

/**
 * __useGetContactCollectionByFirebaseEventIdOrCreateOneQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByFirebaseEventIdOrCreateOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByFirebaseEventIdOrCreateOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByFirebaseEventIdOrCreateOneQuery({
 *   variables: {
 *      firebaseEventId: // value for 'firebaseEventId'
 *   },
 * });
 */
export function useGetContactCollectionByFirebaseEventIdOrCreateOneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>(GetContactCollectionByFirebaseEventIdOrCreateOneDocument, baseOptions);
      }
export function useGetContactCollectionByFirebaseEventIdOrCreateOneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>(GetContactCollectionByFirebaseEventIdOrCreateOneDocument, baseOptions);
        }
export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryHookResult = ReturnType<typeof useGetContactCollectionByFirebaseEventIdOrCreateOneQuery>;
export type GetContactCollectionByFirebaseEventIdOrCreateOneLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByFirebaseEventIdOrCreateOneLazyQuery>;
export type GetContactCollectionByFirebaseEventIdOrCreateOneQueryResult = Apollo.QueryResult<GetContactCollectionByFirebaseEventIdOrCreateOneQuery, GetContactCollectionByFirebaseEventIdOrCreateOneQueryVariables>;
export const CreateContactCollectionDocument = gql`
    mutation CreateContactCollection($data: ContactCollectionInput!) {
  createContactCollection(data: $data) {
    id
    magicLink
  }
}
    `;
export type CreateContactCollectionMutationFn = Apollo.MutationFunction<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>;

/**
 * __useCreateContactCollectionMutation__
 *
 * To run a mutation, you first call `useCreateContactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactCollectionMutation, { data, loading, error }] = useCreateContactCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>(CreateContactCollectionDocument, baseOptions);
      }
export type CreateContactCollectionMutationHookResult = ReturnType<typeof useCreateContactCollectionMutation>;
export type CreateContactCollectionMutationResult = Apollo.MutationResult<CreateContactCollectionMutation>;
export type CreateContactCollectionMutationOptions = Apollo.BaseMutationOptions<CreateContactCollectionMutation, CreateContactCollectionMutationVariables>;
export const UpdateContactCollectionDocument = gql`
    mutation UpdateContactCollection($id: ID!, $data: ContactCollectionInput!) {
  updateContactCollection(id: $id, data: $data) {
    id
    magicLink
  }
}
    `;
export type UpdateContactCollectionMutationFn = Apollo.MutationFunction<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>;

/**
 * __useUpdateContactCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateContactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCollectionMutation, { data, loading, error }] = useUpdateContactCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>(UpdateContactCollectionDocument, baseOptions);
      }
export type UpdateContactCollectionMutationHookResult = ReturnType<typeof useUpdateContactCollectionMutation>;
export type UpdateContactCollectionMutationResult = Apollo.MutationResult<UpdateContactCollectionMutation>;
export type UpdateContactCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateContactCollectionMutation, UpdateContactCollectionMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($data: ContactInput!) {
  createContact(data: $data) {
    id
    householdId
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, baseOptions);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateContactsWithoutTagsDocument = gql`
    mutation CreateContactsWithoutTags($data: [ContactInputWithoutTags!]!) {
  createContactsWithoutTags(data: $data) {
    id
  }
}
    `;
export type CreateContactsWithoutTagsMutationFn = Apollo.MutationFunction<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>;

/**
 * __useCreateContactsWithoutTagsMutation__
 *
 * To run a mutation, you first call `useCreateContactsWithoutTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsWithoutTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsWithoutTagsMutation, { data, loading, error }] = useCreateContactsWithoutTagsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactsWithoutTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>(CreateContactsWithoutTagsDocument, baseOptions);
      }
export type CreateContactsWithoutTagsMutationHookResult = ReturnType<typeof useCreateContactsWithoutTagsMutation>;
export type CreateContactsWithoutTagsMutationResult = Apollo.MutationResult<CreateContactsWithoutTagsMutation>;
export type CreateContactsWithoutTagsMutationOptions = Apollo.BaseMutationOptions<CreateContactsWithoutTagsMutation, CreateContactsWithoutTagsMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($id: ID!, $data: ContactInput!) {
  updateContact(id: $id, data: $data) {
    id
    householdId
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, baseOptions);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactsByContactIdsDocument = gql`
    mutation DeleteContactsByContactIds($contactIds: [ID!]!) {
  deleteContactsByContactIds(contactIds: $contactIds) {
    id
  }
}
    `;
export type DeleteContactsByContactIdsMutationFn = Apollo.MutationFunction<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>;

/**
 * __useDeleteContactsByContactIdsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsByContactIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsByContactIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsByContactIdsMutation, { data, loading, error }] = useDeleteContactsByContactIdsMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useDeleteContactsByContactIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>(DeleteContactsByContactIdsDocument, baseOptions);
      }
export type DeleteContactsByContactIdsMutationHookResult = ReturnType<typeof useDeleteContactsByContactIdsMutation>;
export type DeleteContactsByContactIdsMutationResult = Apollo.MutationResult<DeleteContactsByContactIdsMutation>;
export type DeleteContactsByContactIdsMutationOptions = Apollo.BaseMutationOptions<DeleteContactsByContactIdsMutation, DeleteContactsByContactIdsMutationVariables>;
export const GetContactsByIdsGuestListDocument = gql`
    query GetContactsByIdsGuestList($ids: [ID!]!) {
  getContactsByIds(ids: $ids) {
    ...Guest
  }
}
    ${GuestFragmentDoc}`;

/**
 * __useGetContactsByIdsGuestListQuery__
 *
 * To run a query within a React component, call `useGetContactsByIdsGuestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByIdsGuestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByIdsGuestListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContactsByIdsGuestListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>(GetContactsByIdsGuestListDocument, baseOptions);
      }
export function useGetContactsByIdsGuestListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>(GetContactsByIdsGuestListDocument, baseOptions);
        }
export type GetContactsByIdsGuestListQueryHookResult = ReturnType<typeof useGetContactsByIdsGuestListQuery>;
export type GetContactsByIdsGuestListLazyQueryHookResult = ReturnType<typeof useGetContactsByIdsGuestListLazyQuery>;
export type GetContactsByIdsGuestListQueryResult = Apollo.QueryResult<GetContactsByIdsGuestListQuery, GetContactsByIdsGuestListQueryVariables>;
export const GetContactCollectionByEventIdOrCreateOneDocument = gql`
    query GetContactCollectionByEventIdOrCreateOne($eventId: ID!) {
  getContactCollectionByEventIdOrCreateOne(eventId: $eventId) {
    id
  }
}
    `;

/**
 * __useGetContactCollectionByEventIdOrCreateOneQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByEventIdOrCreateOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByEventIdOrCreateOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByEventIdOrCreateOneQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetContactCollectionByEventIdOrCreateOneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>(GetContactCollectionByEventIdOrCreateOneDocument, baseOptions);
      }
export function useGetContactCollectionByEventIdOrCreateOneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>(GetContactCollectionByEventIdOrCreateOneDocument, baseOptions);
        }
export type GetContactCollectionByEventIdOrCreateOneQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdOrCreateOneQuery>;
export type GetContactCollectionByEventIdOrCreateOneLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdOrCreateOneLazyQuery>;
export type GetContactCollectionByEventIdOrCreateOneQueryResult = Apollo.QueryResult<GetContactCollectionByEventIdOrCreateOneQuery, GetContactCollectionByEventIdOrCreateOneQueryVariables>;
export const CreateContactsWithoutTagsGuestListDocument = gql`
    mutation CreateContactsWithoutTagsGuestList($data: [ContactInputWithoutTags!]!) {
  createContactsWithoutTags(data: $data) {
    ...Guest
  }
}
    ${GuestFragmentDoc}`;
export type CreateContactsWithoutTagsGuestListMutationFn = Apollo.MutationFunction<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>;

/**
 * __useCreateContactsWithoutTagsGuestListMutation__
 *
 * To run a mutation, you first call `useCreateContactsWithoutTagsGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsWithoutTagsGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsWithoutTagsGuestListMutation, { data, loading, error }] = useCreateContactsWithoutTagsGuestListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactsWithoutTagsGuestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>(CreateContactsWithoutTagsGuestListDocument, baseOptions);
      }
export type CreateContactsWithoutTagsGuestListMutationHookResult = ReturnType<typeof useCreateContactsWithoutTagsGuestListMutation>;
export type CreateContactsWithoutTagsGuestListMutationResult = Apollo.MutationResult<CreateContactsWithoutTagsGuestListMutation>;
export type CreateContactsWithoutTagsGuestListMutationOptions = Apollo.BaseMutationOptions<CreateContactsWithoutTagsGuestListMutation, CreateContactsWithoutTagsGuestListMutationVariables>;
export const UpdateContactGuestListDocument = gql`
    mutation UpdateContactGuestList($id: ID!, $data: ContactInput!) {
  updateContact(id: $id, data: $data) {
    ...Guest
  }
}
    ${GuestFragmentDoc}`;
export type UpdateContactGuestListMutationFn = Apollo.MutationFunction<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>;

/**
 * __useUpdateContactGuestListMutation__
 *
 * To run a mutation, you first call `useUpdateContactGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactGuestListMutation, { data, loading, error }] = useUpdateContactGuestListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactGuestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>(UpdateContactGuestListDocument, baseOptions);
      }
export type UpdateContactGuestListMutationHookResult = ReturnType<typeof useUpdateContactGuestListMutation>;
export type UpdateContactGuestListMutationResult = Apollo.MutationResult<UpdateContactGuestListMutation>;
export type UpdateContactGuestListMutationOptions = Apollo.BaseMutationOptions<UpdateContactGuestListMutation, UpdateContactGuestListMutationVariables>;
export const DeleteContactsByContactIdsGuestListDocument = gql`
    mutation DeleteContactsByContactIdsGuestList($contactIds: [ID!]!, $firebaseEventId: String) {
  deleteContactsByContactIds(contactIds: $contactIds, firebaseEventId: $firebaseEventId) {
    id
  }
}
    `;
export type DeleteContactsByContactIdsGuestListMutationFn = Apollo.MutationFunction<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>;

/**
 * __useDeleteContactsByContactIdsGuestListMutation__
 *
 * To run a mutation, you first call `useDeleteContactsByContactIdsGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsByContactIdsGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsByContactIdsGuestListMutation, { data, loading, error }] = useDeleteContactsByContactIdsGuestListMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      firebaseEventId: // value for 'firebaseEventId'
 *   },
 * });
 */
export function useDeleteContactsByContactIdsGuestListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>(DeleteContactsByContactIdsGuestListDocument, baseOptions);
      }
export type DeleteContactsByContactIdsGuestListMutationHookResult = ReturnType<typeof useDeleteContactsByContactIdsGuestListMutation>;
export type DeleteContactsByContactIdsGuestListMutationResult = Apollo.MutationResult<DeleteContactsByContactIdsGuestListMutation>;
export type DeleteContactsByContactIdsGuestListMutationOptions = Apollo.BaseMutationOptions<DeleteContactsByContactIdsGuestListMutation, DeleteContactsByContactIdsGuestListMutationVariables>;
export const AttendanceByEventIdDocument = gql`
    query AttendanceByEventId($eventId: ID!) {
  attendanceByEventId(eventId: $eventId) {
    id
    guestKey
    attendanceState
    createdAt
    __typename
  }
}
    `;

/**
 * __useAttendanceByEventIdQuery__
 *
 * To run a query within a React component, call `useAttendanceByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAttendanceByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>(AttendanceByEventIdDocument, baseOptions);
      }
export function useAttendanceByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>(AttendanceByEventIdDocument, baseOptions);
        }
export type AttendanceByEventIdQueryHookResult = ReturnType<typeof useAttendanceByEventIdQuery>;
export type AttendanceByEventIdLazyQueryHookResult = ReturnType<typeof useAttendanceByEventIdLazyQuery>;
export type AttendanceByEventIdQueryResult = Apollo.QueryResult<AttendanceByEventIdQuery, AttendanceByEventIdQueryVariables>;
export const SetAttendanceByGuestKeyDocument = gql`
    mutation SetAttendanceByGuestKey($input: AttendanceInput!) {
  setAttendanceByGuestKey(input: $input) {
    id
    guestKey
    attendanceState
    createdAt
    __typename
  }
}
    `;
export type SetAttendanceByGuestKeyMutationFn = Apollo.MutationFunction<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>;

/**
 * __useSetAttendanceByGuestKeyMutation__
 *
 * To run a mutation, you first call `useSetAttendanceByGuestKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAttendanceByGuestKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAttendanceByGuestKeyMutation, { data, loading, error }] = useSetAttendanceByGuestKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAttendanceByGuestKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>) {
        return ApolloReactHooks.useMutation<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>(SetAttendanceByGuestKeyDocument, baseOptions);
      }
export type SetAttendanceByGuestKeyMutationHookResult = ReturnType<typeof useSetAttendanceByGuestKeyMutation>;
export type SetAttendanceByGuestKeyMutationResult = Apollo.MutationResult<SetAttendanceByGuestKeyMutation>;
export type SetAttendanceByGuestKeyMutationOptions = Apollo.BaseMutationOptions<SetAttendanceByGuestKeyMutation, SetAttendanceByGuestKeyMutationVariables>;
export const SendHotelBlockReminderDocument = gql`
    mutation SendHotelBlockReminder($payload: SendHotelReminderEmailV2Input!) {
  sendHotelBlockReminderEmailV2(input: $payload)
}
    `;
export type SendHotelBlockReminderMutationFn = Apollo.MutationFunction<SendHotelBlockReminderMutation, SendHotelBlockReminderMutationVariables>;

/**
 * __useSendHotelBlockReminderMutation__
 *
 * To run a mutation, you first call `useSendHotelBlockReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHotelBlockReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHotelBlockReminderMutation, { data, loading, error }] = useSendHotelBlockReminderMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendHotelBlockReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendHotelBlockReminderMutation, SendHotelBlockReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<SendHotelBlockReminderMutation, SendHotelBlockReminderMutationVariables>(SendHotelBlockReminderDocument, baseOptions);
      }
export type SendHotelBlockReminderMutationHookResult = ReturnType<typeof useSendHotelBlockReminderMutation>;
export type SendHotelBlockReminderMutationResult = Apollo.MutationResult<SendHotelBlockReminderMutation>;
export type SendHotelBlockReminderMutationOptions = Apollo.BaseMutationOptions<SendHotelBlockReminderMutation, SendHotelBlockReminderMutationVariables>;
export const SendHotelBlockReminderEmailDocument = gql`
    mutation SendHotelBlockReminderEmail($payload: SendHotelReminderEmailV2Input!) {
  sendHotelBlockReminderEmailV2(input: $payload)
}
    `;
export type SendHotelBlockReminderEmailMutationFn = Apollo.MutationFunction<SendHotelBlockReminderEmailMutation, SendHotelBlockReminderEmailMutationVariables>;

/**
 * __useSendHotelBlockReminderEmailMutation__
 *
 * To run a mutation, you first call `useSendHotelBlockReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHotelBlockReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHotelBlockReminderEmailMutation, { data, loading, error }] = useSendHotelBlockReminderEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendHotelBlockReminderEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendHotelBlockReminderEmailMutation, SendHotelBlockReminderEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendHotelBlockReminderEmailMutation, SendHotelBlockReminderEmailMutationVariables>(SendHotelBlockReminderEmailDocument, baseOptions);
      }
export type SendHotelBlockReminderEmailMutationHookResult = ReturnType<typeof useSendHotelBlockReminderEmailMutation>;
export type SendHotelBlockReminderEmailMutationResult = Apollo.MutationResult<SendHotelBlockReminderEmailMutation>;
export type SendHotelBlockReminderEmailMutationOptions = Apollo.BaseMutationOptions<SendHotelBlockReminderEmailMutation, SendHotelBlockReminderEmailMutationVariables>;
export const SendGeneralMessageDocument = gql`
    mutation SendGeneralMessage($data: SendJoyJsonMessageEmailInput!) {
  sendJoyJsonMessageEmail(data: $data)
}
    `;
export type SendGeneralMessageMutationFn = Apollo.MutationFunction<SendGeneralMessageMutation, SendGeneralMessageMutationVariables>;

/**
 * __useSendGeneralMessageMutation__
 *
 * To run a mutation, you first call `useSendGeneralMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralMessageMutation, { data, loading, error }] = useSendGeneralMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendGeneralMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendGeneralMessageMutation, SendGeneralMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<SendGeneralMessageMutation, SendGeneralMessageMutationVariables>(SendGeneralMessageDocument, baseOptions);
      }
export type SendGeneralMessageMutationHookResult = ReturnType<typeof useSendGeneralMessageMutation>;
export type SendGeneralMessageMutationResult = Apollo.MutationResult<SendGeneralMessageMutation>;
export type SendGeneralMessageMutationOptions = Apollo.BaseMutationOptions<SendGeneralMessageMutation, SendGeneralMessageMutationVariables>;
export const SendTestGeneralMessageDocument = gql`
    mutation SendTestGeneralMessage($data: SendTestJoyJsonMessageEmailInput!) {
  sendTestJoyJsonMessageEmail(data: $data)
}
    `;
export type SendTestGeneralMessageMutationFn = Apollo.MutationFunction<SendTestGeneralMessageMutation, SendTestGeneralMessageMutationVariables>;

/**
 * __useSendTestGeneralMessageMutation__
 *
 * To run a mutation, you first call `useSendTestGeneralMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestGeneralMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestGeneralMessageMutation, { data, loading, error }] = useSendTestGeneralMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendTestGeneralMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestGeneralMessageMutation, SendTestGeneralMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<SendTestGeneralMessageMutation, SendTestGeneralMessageMutationVariables>(SendTestGeneralMessageDocument, baseOptions);
      }
export type SendTestGeneralMessageMutationHookResult = ReturnType<typeof useSendTestGeneralMessageMutation>;
export type SendTestGeneralMessageMutationResult = Apollo.MutationResult<SendTestGeneralMessageMutation>;
export type SendTestGeneralMessageMutationOptions = Apollo.BaseMutationOptions<SendTestGeneralMessageMutation, SendTestGeneralMessageMutationVariables>;
export const SendGeneralMessageByPeopleIdsDocument = gql`
    mutation SendGeneralMessageByPeopleIds($data: SendJoyJsonMessageEmailByPeopleIdsInput!) {
  sendJoyJsonMessageEmailByPeopleIds(data: $data)
}
    `;
export type SendGeneralMessageByPeopleIdsMutationFn = Apollo.MutationFunction<SendGeneralMessageByPeopleIdsMutation, SendGeneralMessageByPeopleIdsMutationVariables>;

/**
 * __useSendGeneralMessageByPeopleIdsMutation__
 *
 * To run a mutation, you first call `useSendGeneralMessageByPeopleIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralMessageByPeopleIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralMessageByPeopleIdsMutation, { data, loading, error }] = useSendGeneralMessageByPeopleIdsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendGeneralMessageByPeopleIdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendGeneralMessageByPeopleIdsMutation, SendGeneralMessageByPeopleIdsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendGeneralMessageByPeopleIdsMutation, SendGeneralMessageByPeopleIdsMutationVariables>(SendGeneralMessageByPeopleIdsDocument, baseOptions);
      }
export type SendGeneralMessageByPeopleIdsMutationHookResult = ReturnType<typeof useSendGeneralMessageByPeopleIdsMutation>;
export type SendGeneralMessageByPeopleIdsMutationResult = Apollo.MutationResult<SendGeneralMessageByPeopleIdsMutation>;
export type SendGeneralMessageByPeopleIdsMutationOptions = Apollo.BaseMutationOptions<SendGeneralMessageByPeopleIdsMutation, SendGeneralMessageByPeopleIdsMutationVariables>;
export const GetMessageBatchesByEventIdDocument = gql`
    query GetMessageBatchesByEventId($eventId: ID!) {
  getMessageBatchesByEventId(eventId: $eventId) {
    displayLabel
    messageType
    id
    sentOn {
      milliseconds
    }
  }
}
    `;

/**
 * __useGetMessageBatchesByEventIdQuery__
 *
 * To run a query within a React component, call `useGetMessageBatchesByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageBatchesByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageBatchesByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessageBatchesByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessageBatchesByEventIdQuery, GetMessageBatchesByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessageBatchesByEventIdQuery, GetMessageBatchesByEventIdQueryVariables>(GetMessageBatchesByEventIdDocument, baseOptions);
      }
export function useGetMessageBatchesByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessageBatchesByEventIdQuery, GetMessageBatchesByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessageBatchesByEventIdQuery, GetMessageBatchesByEventIdQueryVariables>(GetMessageBatchesByEventIdDocument, baseOptions);
        }
export type GetMessageBatchesByEventIdQueryHookResult = ReturnType<typeof useGetMessageBatchesByEventIdQuery>;
export type GetMessageBatchesByEventIdLazyQueryHookResult = ReturnType<typeof useGetMessageBatchesByEventIdLazyQuery>;
export type GetMessageBatchesByEventIdQueryResult = Apollo.QueryResult<GetMessageBatchesByEventIdQuery, GetMessageBatchesByEventIdQueryVariables>;
export const GetQuarantinedMessagesByEventIdDocument = gql`
    query GetQuarantinedMessagesByEventId($eventId: ID!) {
  contactQuarantinedMessageBatchesByEventId(eventId: $eventId) {
    id
    createdAt
    messageBatchType
    messageBatchId
    eventId
    messageBatchPayload
  }
}
    `;

/**
 * __useGetQuarantinedMessagesByEventIdQuery__
 *
 * To run a query within a React component, call `useGetQuarantinedMessagesByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuarantinedMessagesByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuarantinedMessagesByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetQuarantinedMessagesByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuarantinedMessagesByEventIdQuery, GetQuarantinedMessagesByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuarantinedMessagesByEventIdQuery, GetQuarantinedMessagesByEventIdQueryVariables>(GetQuarantinedMessagesByEventIdDocument, baseOptions);
      }
export function useGetQuarantinedMessagesByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuarantinedMessagesByEventIdQuery, GetQuarantinedMessagesByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuarantinedMessagesByEventIdQuery, GetQuarantinedMessagesByEventIdQueryVariables>(GetQuarantinedMessagesByEventIdDocument, baseOptions);
        }
export type GetQuarantinedMessagesByEventIdQueryHookResult = ReturnType<typeof useGetQuarantinedMessagesByEventIdQuery>;
export type GetQuarantinedMessagesByEventIdLazyQueryHookResult = ReturnType<typeof useGetQuarantinedMessagesByEventIdLazyQuery>;
export type GetQuarantinedMessagesByEventIdQueryResult = Apollo.QueryResult<GetQuarantinedMessagesByEventIdQuery, GetQuarantinedMessagesByEventIdQueryVariables>;
export const GetMessageStatusesDocument = gql`
    query GetMessageStatuses($eventId: String, $criteria: MessageSearchQueryCriteria) {
  messageSearchResults(eventId: $eventId, criteria: $criteria) {
    allResult {
      messages {
        status
        id
      }
    }
  }
}
    `;

/**
 * __useGetMessageStatusesQuery__
 *
 * To run a query within a React component, call `useGetMessageStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageStatusesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetMessageStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessageStatusesQuery, GetMessageStatusesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessageStatusesQuery, GetMessageStatusesQueryVariables>(GetMessageStatusesDocument, baseOptions);
      }
export function useGetMessageStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessageStatusesQuery, GetMessageStatusesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessageStatusesQuery, GetMessageStatusesQueryVariables>(GetMessageStatusesDocument, baseOptions);
        }
export type GetMessageStatusesQueryHookResult = ReturnType<typeof useGetMessageStatusesQuery>;
export type GetMessageStatusesLazyQueryHookResult = ReturnType<typeof useGetMessageStatusesLazyQuery>;
export type GetMessageStatusesQueryResult = Apollo.QueryResult<GetMessageStatusesQuery, GetMessageStatusesQueryVariables>;
export const EventByNameForGuestNameDocument = gql`
    query EventByNameForGuestName($name: String!, $admin: Boolean) {
  eventByName(name: $name) {
    id
    guests(admin: $admin) {
      people {
        id
        fullName
        firstName
        phoneNumber: phoneDisplay
        email
      }
    }
  }
}
    `;

/**
 * __useEventByNameForGuestNameQuery__
 *
 * To run a query within a React component, call `useEventByNameForGuestNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByNameForGuestNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByNameForGuestNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useEventByNameForGuestNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventByNameForGuestNameQuery, EventByNameForGuestNameQueryVariables>) {
        return ApolloReactHooks.useQuery<EventByNameForGuestNameQuery, EventByNameForGuestNameQueryVariables>(EventByNameForGuestNameDocument, baseOptions);
      }
export function useEventByNameForGuestNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventByNameForGuestNameQuery, EventByNameForGuestNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventByNameForGuestNameQuery, EventByNameForGuestNameQueryVariables>(EventByNameForGuestNameDocument, baseOptions);
        }
export type EventByNameForGuestNameQueryHookResult = ReturnType<typeof useEventByNameForGuestNameQuery>;
export type EventByNameForGuestNameLazyQueryHookResult = ReturnType<typeof useEventByNameForGuestNameLazyQuery>;
export type EventByNameForGuestNameQueryResult = Apollo.QueryResult<EventByNameForGuestNameQuery, EventByNameForGuestNameQueryVariables>;
export const MessageSearchResultsDocument = gql`
    query MessageSearchResults($criteria: MessageSearchQueryCriteria, $eventId: String) {
  messageSearchResults(criteria: $criteria, eventId: $eventId) {
    allResult {
      messages {
        id
        type
        status
        sentOn {
          milliseconds
        }
        lastStatusUpdate {
          milliseconds
        }
        statusHistory {
          date {
            milliseconds
          }
          status
        }
        recipient {
          personId
          email
          phoneNumber
          guestKey
        }
        messageBatch {
          id
          displayLabel
          messageType
        }
        messageId
      }
    }
  }
}
    `;

/**
 * __useMessageSearchResultsQuery__
 *
 * To run a query within a React component, call `useMessageSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageSearchResultsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMessageSearchResultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>) {
        return ApolloReactHooks.useQuery<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>(MessageSearchResultsDocument, baseOptions);
      }
export function useMessageSearchResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>(MessageSearchResultsDocument, baseOptions);
        }
export type MessageSearchResultsQueryHookResult = ReturnType<typeof useMessageSearchResultsQuery>;
export type MessageSearchResultsLazyQueryHookResult = ReturnType<typeof useMessageSearchResultsLazyQuery>;
export type MessageSearchResultsQueryResult = Apollo.QueryResult<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>;
export const GetContactsByGuestKeyListDocument = gql`
    query GetContactsByGuestKeyList($eventId: ID!, $guestKeys: [ID!]!) {
  getContactsByGuestKeyList(eventId: $eventId, guestKeys: $guestKeys) {
    id
    firstName
    lastName
    guestKey
    phoneNumber {
      id
      number
    }
    email
  }
}
    `;

/**
 * __useGetContactsByGuestKeyListQuery__
 *
 * To run a query within a React component, call `useGetContactsByGuestKeyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByGuestKeyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByGuestKeyListQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestKeys: // value for 'guestKeys'
 *   },
 * });
 */
export function useGetContactsByGuestKeyListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>(GetContactsByGuestKeyListDocument, baseOptions);
      }
export function useGetContactsByGuestKeyListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>(GetContactsByGuestKeyListDocument, baseOptions);
        }
export type GetContactsByGuestKeyListQueryHookResult = ReturnType<typeof useGetContactsByGuestKeyListQuery>;
export type GetContactsByGuestKeyListLazyQueryHookResult = ReturnType<typeof useGetContactsByGuestKeyListLazyQuery>;
export type GetContactsByGuestKeyListQueryResult = Apollo.QueryResult<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>;
export const StationeryPrintOrderByIdDocument = gql`
    query StationeryPrintOrderById($orderId: ID!) {
  stationeryPrintOrderById(id: $orderId) {
    id
    orderNumber
    printCardFrontPreviewUrl
    cardDraftJSONBlob
    cardDraft {
      id
      stationeryTemplate {
        id
        themeId
        category
        name
      }
    }
  }
}
    `;

/**
 * __useStationeryPrintOrderByIdQuery__
 *
 * To run a query within a React component, call `useStationeryPrintOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryPrintOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryPrintOrderByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStationeryPrintOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>(StationeryPrintOrderByIdDocument, baseOptions);
      }
export function useStationeryPrintOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>(StationeryPrintOrderByIdDocument, baseOptions);
        }
export type StationeryPrintOrderByIdQueryHookResult = ReturnType<typeof useStationeryPrintOrderByIdQuery>;
export type StationeryPrintOrderByIdLazyQueryHookResult = ReturnType<typeof useStationeryPrintOrderByIdLazyQuery>;
export type StationeryPrintOrderByIdQueryResult = Apollo.QueryResult<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>;
export const StationeryDigitalCardViewByOrderIdDocument = gql`
    query StationeryDigitalCardViewByOrderId($cardViewInput: GetStationeryDigitalViewInput) {
  stationeryDigitalCardView(data: $cardViewInput) {
    id
    personId
    src
  }
}
    `;

/**
 * __useStationeryDigitalCardViewByOrderIdQuery__
 *
 * To run a query within a React component, call `useStationeryDigitalCardViewByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryDigitalCardViewByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryDigitalCardViewByOrderIdQuery({
 *   variables: {
 *      cardViewInput: // value for 'cardViewInput'
 *   },
 * });
 */
export function useStationeryDigitalCardViewByOrderIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>(StationeryDigitalCardViewByOrderIdDocument, baseOptions);
      }
export function useStationeryDigitalCardViewByOrderIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>(StationeryDigitalCardViewByOrderIdDocument, baseOptions);
        }
export type StationeryDigitalCardViewByOrderIdQueryHookResult = ReturnType<typeof useStationeryDigitalCardViewByOrderIdQuery>;
export type StationeryDigitalCardViewByOrderIdLazyQueryHookResult = ReturnType<typeof useStationeryDigitalCardViewByOrderIdLazyQuery>;
export type StationeryDigitalCardViewByOrderIdQueryResult = Apollo.QueryResult<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>;
export const SmsByIdDocument = gql`
    query SmsById($id: ID!) {
  sms(id: $id) {
    id
    smsContent
    status
  }
}
    `;

/**
 * __useSmsByIdQuery__
 *
 * To run a query within a React component, call `useSmsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmsByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SmsByIdQuery, SmsByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<SmsByIdQuery, SmsByIdQueryVariables>(SmsByIdDocument, baseOptions);
      }
export function useSmsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SmsByIdQuery, SmsByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SmsByIdQuery, SmsByIdQueryVariables>(SmsByIdDocument, baseOptions);
        }
export type SmsByIdQueryHookResult = ReturnType<typeof useSmsByIdQuery>;
export type SmsByIdLazyQueryHookResult = ReturnType<typeof useSmsByIdLazyQuery>;
export type SmsByIdQueryResult = Apollo.QueryResult<SmsByIdQuery, SmsByIdQueryVariables>;
export const GetMessagingTierByEventIdDocument = gql`
    query GetMessagingTierByEventId($eventId: ID!) {
  getMessagingSettingsByEventId(eventId: $eventId) {
    id
    eventId
    messagingTier
  }
}
    `;

/**
 * __useGetMessagingTierByEventIdQuery__
 *
 * To run a query within a React component, call `useGetMessagingTierByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingTierByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingTierByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingTierByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingTierByEventIdQuery, GetMessagingTierByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagingTierByEventIdQuery, GetMessagingTierByEventIdQueryVariables>(GetMessagingTierByEventIdDocument, baseOptions);
      }
export function useGetMessagingTierByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingTierByEventIdQuery, GetMessagingTierByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagingTierByEventIdQuery, GetMessagingTierByEventIdQueryVariables>(GetMessagingTierByEventIdDocument, baseOptions);
        }
export type GetMessagingTierByEventIdQueryHookResult = ReturnType<typeof useGetMessagingTierByEventIdQuery>;
export type GetMessagingTierByEventIdLazyQueryHookResult = ReturnType<typeof useGetMessagingTierByEventIdLazyQuery>;
export type GetMessagingTierByEventIdQueryResult = Apollo.QueryResult<GetMessagingTierByEventIdQuery, GetMessagingTierByEventIdQueryVariables>;
export const UpdatePaidMessagingSettingsDocument = gql`
    mutation UpdatePaidMessagingSettings($input: UpdatePaidMessagingSettingsInput!) {
  updatePaidMessagingSettings(input: $input) {
    id
    eventId
    messagingTier
  }
}
    `;
export type UpdatePaidMessagingSettingsMutationFn = Apollo.MutationFunction<UpdatePaidMessagingSettingsMutation, UpdatePaidMessagingSettingsMutationVariables>;

/**
 * __useUpdatePaidMessagingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePaidMessagingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaidMessagingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaidMessagingSettingsMutation, { data, loading, error }] = useUpdatePaidMessagingSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaidMessagingSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePaidMessagingSettingsMutation, UpdatePaidMessagingSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePaidMessagingSettingsMutation, UpdatePaidMessagingSettingsMutationVariables>(UpdatePaidMessagingSettingsDocument, baseOptions);
      }
export type UpdatePaidMessagingSettingsMutationHookResult = ReturnType<typeof useUpdatePaidMessagingSettingsMutation>;
export type UpdatePaidMessagingSettingsMutationResult = Apollo.MutationResult<UpdatePaidMessagingSettingsMutation>;
export type UpdatePaidMessagingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePaidMessagingSettingsMutation, UpdatePaidMessagingSettingsMutationVariables>;
export const PostOfficeDraftByIdDocument = gql`
    query PostOfficeDraftById($id: ID!) {
  getPostOfficeDraft(id: $id) {
    ...PostOfficeDraft
  }
}
    ${PostOfficeDraftFragmentDoc}`;

/**
 * __usePostOfficeDraftByIdQuery__
 *
 * To run a query within a React component, call `usePostOfficeDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostOfficeDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostOfficeDraftByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostOfficeDraftByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>(PostOfficeDraftByIdDocument, baseOptions);
      }
export function usePostOfficeDraftByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>(PostOfficeDraftByIdDocument, baseOptions);
        }
export type PostOfficeDraftByIdQueryHookResult = ReturnType<typeof usePostOfficeDraftByIdQuery>;
export type PostOfficeDraftByIdLazyQueryHookResult = ReturnType<typeof usePostOfficeDraftByIdLazyQuery>;
export type PostOfficeDraftByIdQueryResult = Apollo.QueryResult<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>;
export const PostOfficeDraftsByEventIdDocument = gql`
    query PostOfficeDraftsByEventId($eventId: ID!, $messageType: PostOfficeMessageType) {
  eventById(id: $eventId) {
    id
    info {
      id
      eventPassword
      ownerFirstName
      fianceeFirstName
    }
    photo {
      id
      url
    }
    photoV2Url
    settings {
      id
      privacyMode
    }
    pages {
      ...EventPage
    }
  }
  getPostOfficeDraftsByEventId(eventId: $eventId, messageType: $messageType) {
    ...PostOfficeDraft
  }
}
    ${EventPageFragmentDoc}
${PostOfficeDraftFragmentDoc}`;

/**
 * __usePostOfficeDraftsByEventIdQuery__
 *
 * To run a query within a React component, call `usePostOfficeDraftsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostOfficeDraftsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostOfficeDraftsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageType: // value for 'messageType'
 *   },
 * });
 */
export function usePostOfficeDraftsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>(PostOfficeDraftsByEventIdDocument, baseOptions);
      }
export function usePostOfficeDraftsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>(PostOfficeDraftsByEventIdDocument, baseOptions);
        }
export type PostOfficeDraftsByEventIdQueryHookResult = ReturnType<typeof usePostOfficeDraftsByEventIdQuery>;
export type PostOfficeDraftsByEventIdLazyQueryHookResult = ReturnType<typeof usePostOfficeDraftsByEventIdLazyQuery>;
export type PostOfficeDraftsByEventIdQueryResult = Apollo.QueryResult<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>;
export const SavePostOfficeGenericEmailDraftDocument = gql`
    mutation SavePostOfficeGenericEmailDraft($imageUrl: String, $draftId: ID, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $includeAppInstructions: Boolean!, $includeWebsiteDetails: Boolean!, $includeEventPassword: Boolean!, $personIds: [ID!]!, $salutation: String, $includeGuestNames: Boolean!) {
  savePostOfficeGenericEmailDraft(payload: {draftId: $draftId, eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, includeAppInstructions: $includeAppInstructions, includeWebsiteDetails: $includeWebsiteDetails, includeEventPassword: $includeEventPassword, personIds: $personIds, salutation: $salutation, includeGuestNames: $includeGuestNames, imageUrl: $imageUrl}) {
    ...PostOfficeGenericEmailDraft
  }
}
    ${PostOfficeGenericEmailDraftFragmentDoc}`;
export type SavePostOfficeGenericEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeGenericEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeGenericEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeGenericEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeGenericEmailDraftMutation, { data, loading, error }] = useSavePostOfficeGenericEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSavePostOfficeGenericEmailDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>(SavePostOfficeGenericEmailDraftDocument, baseOptions);
      }
export type SavePostOfficeGenericEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeGenericEmailDraftMutation>;
export type SavePostOfficeGenericEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeGenericEmailDraftMutation>;
export type SavePostOfficeGenericEmailDraftMutationOptions = Apollo.BaseMutationOptions<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>;
export const SendPostOfficeGenericEmailDocument = gql`
    mutation SendPostOfficeGenericEmail($imageUrl: String, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $includeAppInstructions: Boolean!, $includeWebsiteDetails: Boolean!, $includeEventPassword: Boolean!, $personIds: [ID!]!, $testName: String, $testEmail: String, $footerText: String, $salutation: String, $includeGuestNames: Boolean!) {
  sendPostOfficeGenericEmail(payload: {eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, includeAppInstructions: $includeAppInstructions, includeWebsiteDetails: $includeWebsiteDetails, includeEventPassword: $includeEventPassword, personIds: $personIds, testName: $testName, testEmail: $testEmail, footerText: $footerText, salutation: $salutation, includeGuestNames: $includeGuestNames, imageUrl: $imageUrl})
}
    `;
export type SendPostOfficeGenericEmailMutationFn = Apollo.MutationFunction<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>;

/**
 * __useSendPostOfficeGenericEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeGenericEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeGenericEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeGenericEmailMutation, { data, loading, error }] = useSendPostOfficeGenericEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      footerText: // value for 'footerText'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSendPostOfficeGenericEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>(SendPostOfficeGenericEmailDocument, baseOptions);
      }
export type SendPostOfficeGenericEmailMutationHookResult = ReturnType<typeof useSendPostOfficeGenericEmailMutation>;
export type SendPostOfficeGenericEmailMutationResult = Apollo.MutationResult<SendPostOfficeGenericEmailMutation>;
export type SendPostOfficeGenericEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>;
export const SavePostOfficeReminderEmailDraftDocument = gql`
    mutation SavePostOfficeReminderEmailDraft($imageUrl: String, $draftId: ID, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $includeAppInstructions: Boolean!, $includeWebsiteDetails: Boolean!, $includeEventPassword: Boolean!, $personIds: [ID!]!, $salutation: String, $includeGuestNames: Boolean!) {
  savePostOfficeReminderEmailDraft(payload: {draftId: $draftId, eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, includeAppInstructions: $includeAppInstructions, includeWebsiteDetails: $includeWebsiteDetails, includeEventPassword: $includeEventPassword, personIds: $personIds, salutation: $salutation, includeGuestNames: $includeGuestNames, imageUrl: $imageUrl}) {
    ...PostOfficeReminderEmailDraft
  }
}
    ${PostOfficeReminderEmailDraftFragmentDoc}`;
export type SavePostOfficeReminderEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeReminderEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeReminderEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeReminderEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeReminderEmailDraftMutation, { data, loading, error }] = useSavePostOfficeReminderEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSavePostOfficeReminderEmailDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>(SavePostOfficeReminderEmailDraftDocument, baseOptions);
      }
export type SavePostOfficeReminderEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeReminderEmailDraftMutation>;
export type SavePostOfficeReminderEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeReminderEmailDraftMutation>;
export type SavePostOfficeReminderEmailDraftMutationOptions = Apollo.BaseMutationOptions<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>;
export const SendPostOfficeReminderEmailDocument = gql`
    mutation SendPostOfficeReminderEmail($imageUrl: String, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $includeAppInstructions: Boolean!, $includeWebsiteDetails: Boolean!, $includeEventPassword: Boolean!, $personIds: [ID!]!, $testName: String, $testEmail: String, $footerText: String, $salutation: String, $includeGuestNames: Boolean!) {
  sendPostOfficeReminderEmail(payload: {eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, includeAppInstructions: $includeAppInstructions, includeWebsiteDetails: $includeWebsiteDetails, includeEventPassword: $includeEventPassword, personIds: $personIds, testName: $testName, testEmail: $testEmail, footerText: $footerText, salutation: $salutation, includeGuestNames: $includeGuestNames, imageUrl: $imageUrl})
}
    `;
export type SendPostOfficeReminderEmailMutationFn = Apollo.MutationFunction<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>;

/**
 * __useSendPostOfficeReminderEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeReminderEmailMutation, { data, loading, error }] = useSendPostOfficeReminderEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      footerText: // value for 'footerText'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSendPostOfficeReminderEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>(SendPostOfficeReminderEmailDocument, baseOptions);
      }
export type SendPostOfficeReminderEmailMutationHookResult = ReturnType<typeof useSendPostOfficeReminderEmailMutation>;
export type SendPostOfficeReminderEmailMutationResult = Apollo.MutationResult<SendPostOfficeReminderEmailMutation>;
export type SendPostOfficeReminderEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>;
export const SavePostOfficeThankYouEmailDraftDocument = gql`
    mutation SavePostOfficeThankYouEmailDraft($imageUrl: String, $draftId: ID, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $personIds: [ID!], $personEmails: [String!], $assetId: String, $containerId: String) {
  savePostOfficeThankYouEmailDraft(payload: {draftId: $draftId, eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, personIds: $personIds, personEmails: $personEmails, imageUrl: $imageUrl, assetId: $assetId, containerId: $containerId}) {
    ...PostOfficeThankYouEmailDraft
  }
}
    ${PostOfficeThankYouEmailDraftFragmentDoc}`;
export type SavePostOfficeThankYouEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeThankYouEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeThankYouEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeThankYouEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeThankYouEmailDraftMutation, { data, loading, error }] = useSavePostOfficeThankYouEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      personIds: // value for 'personIds'
 *      personEmails: // value for 'personEmails'
 *      assetId: // value for 'assetId'
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useSavePostOfficeThankYouEmailDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>(SavePostOfficeThankYouEmailDraftDocument, baseOptions);
      }
export type SavePostOfficeThankYouEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeThankYouEmailDraftMutation>;
export type SavePostOfficeThankYouEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeThankYouEmailDraftMutation>;
export type SavePostOfficeThankYouEmailDraftMutationOptions = Apollo.BaseMutationOptions<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>;
export const SendPostOfficeThankYouEmailDocument = gql`
    mutation SendPostOfficeThankYouEmail($imageUrl: String, $eventId: ID!, $subject: String!, $replyToEmail: String!, $message: String!, $personIds: [ID!], $personEmails: [String!], $testName: String, $testEmail: String, $relation: EmailRelationInput, $footerText: String, $assetId: String, $containerId: String) {
  sendPostOfficeThankYouEmail(payload: {eventId: $eventId, subject: $subject, replyToEmail: $replyToEmail, message: $message, personIds: $personIds, personEmails: $personEmails, testName: $testName, testEmail: $testEmail, imageUrl: $imageUrl, footerText: $footerText, assetId: $assetId, containerId: $containerId}, relation: $relation)
}
    `;
export type SendPostOfficeThankYouEmailMutationFn = Apollo.MutationFunction<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>;

/**
 * __useSendPostOfficeThankYouEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeThankYouEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeThankYouEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeThankYouEmailMutation, { data, loading, error }] = useSendPostOfficeThankYouEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      personIds: // value for 'personIds'
 *      personEmails: // value for 'personEmails'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      relation: // value for 'relation'
 *      footerText: // value for 'footerText'
 *      assetId: // value for 'assetId'
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useSendPostOfficeThankYouEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>(SendPostOfficeThankYouEmailDocument, baseOptions);
      }
export type SendPostOfficeThankYouEmailMutationHookResult = ReturnType<typeof useSendPostOfficeThankYouEmailMutation>;
export type SendPostOfficeThankYouEmailMutationResult = Apollo.MutationResult<SendPostOfficeThankYouEmailMutation>;
export type SendPostOfficeThankYouEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>;
export const ChatGPTTextCompletionDocument = gql`
    query ChatGPTTextCompletion($prompt: String!, $modelVersion: AiModelVersion) {
  textCompletion(prompt: $prompt, modelVersion: $modelVersion)
}
    `;

/**
 * __useChatGPTTextCompletionQuery__
 *
 * To run a query within a React component, call `useChatGPTTextCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGPTTextCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGPTTextCompletionQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      modelVersion: // value for 'modelVersion'
 *   },
 * });
 */
export function useChatGPTTextCompletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>) {
        return ApolloReactHooks.useQuery<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>(ChatGPTTextCompletionDocument, baseOptions);
      }
export function useChatGPTTextCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>(ChatGPTTextCompletionDocument, baseOptions);
        }
export type ChatGPTTextCompletionQueryHookResult = ReturnType<typeof useChatGPTTextCompletionQuery>;
export type ChatGPTTextCompletionLazyQueryHookResult = ReturnType<typeof useChatGPTTextCompletionLazyQuery>;
export type ChatGPTTextCompletionQueryResult = Apollo.QueryResult<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>;
export const FindCashFundsHostByEventIdDocument = gql`
    query FindCashFundsHostByEventId($eventId: ID!, $returnRoute: String) {
  findCashFundsHostByEventId(eventId: $eventId) {
    ...AdminCashFundsHost
  }
}
    ${AdminCashFundsHostFragmentDoc}`;

/**
 * __useFindCashFundsHostByEventIdQuery__
 *
 * To run a query within a React component, call `useFindCashFundsHostByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCashFundsHostByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCashFundsHostByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      returnRoute: // value for 'returnRoute'
 *   },
 * });
 */
export function useFindCashFundsHostByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindCashFundsHostByEventIdQuery, FindCashFundsHostByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FindCashFundsHostByEventIdQuery, FindCashFundsHostByEventIdQueryVariables>(FindCashFundsHostByEventIdDocument, baseOptions);
      }
export function useFindCashFundsHostByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindCashFundsHostByEventIdQuery, FindCashFundsHostByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindCashFundsHostByEventIdQuery, FindCashFundsHostByEventIdQueryVariables>(FindCashFundsHostByEventIdDocument, baseOptions);
        }
export type FindCashFundsHostByEventIdQueryHookResult = ReturnType<typeof useFindCashFundsHostByEventIdQuery>;
export type FindCashFundsHostByEventIdLazyQueryHookResult = ReturnType<typeof useFindCashFundsHostByEventIdLazyQuery>;
export type FindCashFundsHostByEventIdQueryResult = Apollo.QueryResult<FindCashFundsHostByEventIdQuery, FindCashFundsHostByEventIdQueryVariables>;
export const GetCashFundsByEventIdDocument = gql`
    query GetCashFundsByEventId($eventId: ID!) {
  getCashFundsByEventId(eventId: $eventId) {
    ...AdminCashFund
  }
}
    ${AdminCashFundFragmentDoc}`;

/**
 * __useGetCashFundsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetCashFundsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundsByEventIdQuery, GetCashFundsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCashFundsByEventIdQuery, GetCashFundsByEventIdQueryVariables>(GetCashFundsByEventIdDocument, baseOptions);
      }
export function useGetCashFundsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundsByEventIdQuery, GetCashFundsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCashFundsByEventIdQuery, GetCashFundsByEventIdQueryVariables>(GetCashFundsByEventIdDocument, baseOptions);
        }
export type GetCashFundsByEventIdQueryHookResult = ReturnType<typeof useGetCashFundsByEventIdQuery>;
export type GetCashFundsByEventIdLazyQueryHookResult = ReturnType<typeof useGetCashFundsByEventIdLazyQuery>;
export type GetCashFundsByEventIdQueryResult = Apollo.QueryResult<GetCashFundsByEventIdQuery, GetCashFundsByEventIdQueryVariables>;
export const GetCashFundByIdDocument = gql`
    query GetCashFundById($id: ID!) {
  getCashFundById(id: $id) {
    ...AdminCashFund
  }
}
    ${AdminCashFundFragmentDoc}`;

/**
 * __useGetCashFundByIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCashFundByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundByIdQuery, GetCashFundByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCashFundByIdQuery, GetCashFundByIdQueryVariables>(GetCashFundByIdDocument, baseOptions);
      }
export function useGetCashFundByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundByIdQuery, GetCashFundByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCashFundByIdQuery, GetCashFundByIdQueryVariables>(GetCashFundByIdDocument, baseOptions);
        }
export type GetCashFundByIdQueryHookResult = ReturnType<typeof useGetCashFundByIdQuery>;
export type GetCashFundByIdLazyQueryHookResult = ReturnType<typeof useGetCashFundByIdLazyQuery>;
export type GetCashFundByIdQueryResult = Apollo.QueryResult<GetCashFundByIdQuery, GetCashFundByIdQueryVariables>;
export const InitCashFundsHostDocument = gql`
    mutation InitCashFundsHost($input: CreateCashFundsHostInput!, $returnRoute: String) {
  initCashFundsHost(input: $input) {
    ... on CashFundsHost {
      ...AdminCashFundsHost
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${AdminCashFundsHostFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type InitCashFundsHostMutationFn = Apollo.MutationFunction<InitCashFundsHostMutation, InitCashFundsHostMutationVariables>;

/**
 * __useInitCashFundsHostMutation__
 *
 * To run a mutation, you first call `useInitCashFundsHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitCashFundsHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initCashFundsHostMutation, { data, loading, error }] = useInitCashFundsHostMutation({
 *   variables: {
 *      input: // value for 'input'
 *      returnRoute: // value for 'returnRoute'
 *   },
 * });
 */
export function useInitCashFundsHostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitCashFundsHostMutation, InitCashFundsHostMutationVariables>) {
        return ApolloReactHooks.useMutation<InitCashFundsHostMutation, InitCashFundsHostMutationVariables>(InitCashFundsHostDocument, baseOptions);
      }
export type InitCashFundsHostMutationHookResult = ReturnType<typeof useInitCashFundsHostMutation>;
export type InitCashFundsHostMutationResult = Apollo.MutationResult<InitCashFundsHostMutation>;
export type InitCashFundsHostMutationOptions = Apollo.BaseMutationOptions<InitCashFundsHostMutation, InitCashFundsHostMutationVariables>;
export const CreateCashFundDocument = gql`
    mutation CreateCashFund($input: CreateCashFundInput!) {
  createCashFund(input: $input) {
    ... on CashFund {
      ...AdminCashFund
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${AdminCashFundFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type CreateCashFundMutationFn = Apollo.MutationFunction<CreateCashFundMutation, CreateCashFundMutationVariables>;

/**
 * __useCreateCashFundMutation__
 *
 * To run a mutation, you first call `useCreateCashFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundMutation, { data, loading, error }] = useCreateCashFundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundMutation, CreateCashFundMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCashFundMutation, CreateCashFundMutationVariables>(CreateCashFundDocument, baseOptions);
      }
export type CreateCashFundMutationHookResult = ReturnType<typeof useCreateCashFundMutation>;
export type CreateCashFundMutationResult = Apollo.MutationResult<CreateCashFundMutation>;
export type CreateCashFundMutationOptions = Apollo.BaseMutationOptions<CreateCashFundMutation, CreateCashFundMutationVariables>;
export const UpdateCashFundDocument = gql`
    mutation UpdateCashFund($input: UpdateCashFundInput!) {
  updateCashFund(input: $input) {
    ... on CashFund {
      ...AdminCashFund
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${AdminCashFundFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type UpdateCashFundMutationFn = Apollo.MutationFunction<UpdateCashFundMutation, UpdateCashFundMutationVariables>;

/**
 * __useUpdateCashFundMutation__
 *
 * To run a mutation, you first call `useUpdateCashFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashFundMutation, { data, loading, error }] = useUpdateCashFundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCashFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCashFundMutation, UpdateCashFundMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCashFundMutation, UpdateCashFundMutationVariables>(UpdateCashFundDocument, baseOptions);
      }
export type UpdateCashFundMutationHookResult = ReturnType<typeof useUpdateCashFundMutation>;
export type UpdateCashFundMutationResult = Apollo.MutationResult<UpdateCashFundMutation>;
export type UpdateCashFundMutationOptions = Apollo.BaseMutationOptions<UpdateCashFundMutation, UpdateCashFundMutationVariables>;
export const DuplicateCashFundDocument = gql`
    mutation DuplicateCashFund($input: DuplicateCashFundInput!) {
  duplicateCashFund(input: $input) {
    ... on CashFund {
      ...AdminCashFund
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${AdminCashFundFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type DuplicateCashFundMutationFn = Apollo.MutationFunction<DuplicateCashFundMutation, DuplicateCashFundMutationVariables>;

/**
 * __useDuplicateCashFundMutation__
 *
 * To run a mutation, you first call `useDuplicateCashFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCashFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCashFundMutation, { data, loading, error }] = useDuplicateCashFundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCashFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateCashFundMutation, DuplicateCashFundMutationVariables>) {
        return ApolloReactHooks.useMutation<DuplicateCashFundMutation, DuplicateCashFundMutationVariables>(DuplicateCashFundDocument, baseOptions);
      }
export type DuplicateCashFundMutationHookResult = ReturnType<typeof useDuplicateCashFundMutation>;
export type DuplicateCashFundMutationResult = Apollo.MutationResult<DuplicateCashFundMutation>;
export type DuplicateCashFundMutationOptions = Apollo.BaseMutationOptions<DuplicateCashFundMutation, DuplicateCashFundMutationVariables>;
export const ArchiveCashFundDocument = gql`
    mutation ArchiveCashFund($cashFundId: ID!) {
  archiveCashFund(cashFundId: $cashFundId) {
    ... on ArchiveCashFundSuccess {
      id
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundGeneralErrorFragmentDoc}`;
export type ArchiveCashFundMutationFn = Apollo.MutationFunction<ArchiveCashFundMutation, ArchiveCashFundMutationVariables>;

/**
 * __useArchiveCashFundMutation__
 *
 * To run a mutation, you first call `useArchiveCashFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCashFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCashFundMutation, { data, loading, error }] = useArchiveCashFundMutation({
 *   variables: {
 *      cashFundId: // value for 'cashFundId'
 *   },
 * });
 */
export function useArchiveCashFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveCashFundMutation, ArchiveCashFundMutationVariables>) {
        return ApolloReactHooks.useMutation<ArchiveCashFundMutation, ArchiveCashFundMutationVariables>(ArchiveCashFundDocument, baseOptions);
      }
export type ArchiveCashFundMutationHookResult = ReturnType<typeof useArchiveCashFundMutation>;
export type ArchiveCashFundMutationResult = Apollo.MutationResult<ArchiveCashFundMutation>;
export type ArchiveCashFundMutationOptions = Apollo.BaseMutationOptions<ArchiveCashFundMutation, ArchiveCashFundMutationVariables>;
export const ReactivateCashFundDocument = gql`
    mutation ReactivateCashFund($cashFundId: ID!) {
  reactivateCashFund(cashFundId: $cashFundId) {
    ... on CashFund {
      id
      archived
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundGeneralErrorFragmentDoc}`;
export type ReactivateCashFundMutationFn = Apollo.MutationFunction<ReactivateCashFundMutation, ReactivateCashFundMutationVariables>;

/**
 * __useReactivateCashFundMutation__
 *
 * To run a mutation, you first call `useReactivateCashFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCashFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateCashFundMutation, { data, loading, error }] = useReactivateCashFundMutation({
 *   variables: {
 *      cashFundId: // value for 'cashFundId'
 *   },
 * });
 */
export function useReactivateCashFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateCashFundMutation, ReactivateCashFundMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactivateCashFundMutation, ReactivateCashFundMutationVariables>(ReactivateCashFundDocument, baseOptions);
      }
export type ReactivateCashFundMutationHookResult = ReturnType<typeof useReactivateCashFundMutation>;
export type ReactivateCashFundMutationResult = Apollo.MutationResult<ReactivateCashFundMutation>;
export type ReactivateCashFundMutationOptions = Apollo.BaseMutationOptions<ReactivateCashFundMutation, ReactivateCashFundMutationVariables>;
export const CreateCashFundSolicitationDocument = gql`
    mutation CreateCashFundSolicitation($input: CreateCashFundSolicitationInput!) {
  createCashFundSolicitation(input: $input) {
    ... on CashFundSolicitation {
      ...CashFundSolicitation
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundSolicitationFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type CreateCashFundSolicitationMutationFn = Apollo.MutationFunction<CreateCashFundSolicitationMutation, CreateCashFundSolicitationMutationVariables>;

/**
 * __useCreateCashFundSolicitationMutation__
 *
 * To run a mutation, you first call `useCreateCashFundSolicitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundSolicitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundSolicitationMutation, { data, loading, error }] = useCreateCashFundSolicitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundSolicitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundSolicitationMutation, CreateCashFundSolicitationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCashFundSolicitationMutation, CreateCashFundSolicitationMutationVariables>(CreateCashFundSolicitationDocument, baseOptions);
      }
export type CreateCashFundSolicitationMutationHookResult = ReturnType<typeof useCreateCashFundSolicitationMutation>;
export type CreateCashFundSolicitationMutationResult = Apollo.MutationResult<CreateCashFundSolicitationMutation>;
export type CreateCashFundSolicitationMutationOptions = Apollo.BaseMutationOptions<CreateCashFundSolicitationMutation, CreateCashFundSolicitationMutationVariables>;
export const UpdateCashFundSolicitationDocument = gql`
    mutation UpdateCashFundSolicitation($input: UpdateCashFundSolicitationInput!) {
  updateCashFundSolicitation(input: $input) {
    ... on CashFundSolicitation {
      ...CashFundSolicitation
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundSolicitationFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type UpdateCashFundSolicitationMutationFn = Apollo.MutationFunction<UpdateCashFundSolicitationMutation, UpdateCashFundSolicitationMutationVariables>;

/**
 * __useUpdateCashFundSolicitationMutation__
 *
 * To run a mutation, you first call `useUpdateCashFundSolicitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashFundSolicitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashFundSolicitationMutation, { data, loading, error }] = useUpdateCashFundSolicitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCashFundSolicitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCashFundSolicitationMutation, UpdateCashFundSolicitationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCashFundSolicitationMutation, UpdateCashFundSolicitationMutationVariables>(UpdateCashFundSolicitationDocument, baseOptions);
      }
export type UpdateCashFundSolicitationMutationHookResult = ReturnType<typeof useUpdateCashFundSolicitationMutation>;
export type UpdateCashFundSolicitationMutationResult = Apollo.MutationResult<UpdateCashFundSolicitationMutation>;
export type UpdateCashFundSolicitationMutationOptions = Apollo.BaseMutationOptions<UpdateCashFundSolicitationMutation, UpdateCashFundSolicitationMutationVariables>;
export const ManageCashFundSolicitationRecipientsDocument = gql`
    mutation ManageCashFundSolicitationRecipients($input: ManageCashFundSolicitationRecipientsInput!) {
  manageCashFundSolicitationRecipients(input: $input) {
    ... on CashFundSolicitation {
      ...CashFundSolicitation
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundSolicitationFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type ManageCashFundSolicitationRecipientsMutationFn = Apollo.MutationFunction<ManageCashFundSolicitationRecipientsMutation, ManageCashFundSolicitationRecipientsMutationVariables>;

/**
 * __useManageCashFundSolicitationRecipientsMutation__
 *
 * To run a mutation, you first call `useManageCashFundSolicitationRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageCashFundSolicitationRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageCashFundSolicitationRecipientsMutation, { data, loading, error }] = useManageCashFundSolicitationRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageCashFundSolicitationRecipientsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ManageCashFundSolicitationRecipientsMutation, ManageCashFundSolicitationRecipientsMutationVariables>) {
        return ApolloReactHooks.useMutation<ManageCashFundSolicitationRecipientsMutation, ManageCashFundSolicitationRecipientsMutationVariables>(ManageCashFundSolicitationRecipientsDocument, baseOptions);
      }
export type ManageCashFundSolicitationRecipientsMutationHookResult = ReturnType<typeof useManageCashFundSolicitationRecipientsMutation>;
export type ManageCashFundSolicitationRecipientsMutationResult = Apollo.MutationResult<ManageCashFundSolicitationRecipientsMutation>;
export type ManageCashFundSolicitationRecipientsMutationOptions = Apollo.BaseMutationOptions<ManageCashFundSolicitationRecipientsMutation, ManageCashFundSolicitationRecipientsMutationVariables>;
export const SendCashFundSolicitationEmailsDocument = gql`
    mutation SendCashFundSolicitationEmails($solicitationId: ID!) {
  sendCashFundSolicitationEmails(solicitationId: $solicitationId) {
    ... on SendCashFundSolicitationEmailsSuccess {
      id
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundGeneralErrorFragmentDoc}`;
export type SendCashFundSolicitationEmailsMutationFn = Apollo.MutationFunction<SendCashFundSolicitationEmailsMutation, SendCashFundSolicitationEmailsMutationVariables>;

/**
 * __useSendCashFundSolicitationEmailsMutation__
 *
 * To run a mutation, you first call `useSendCashFundSolicitationEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCashFundSolicitationEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCashFundSolicitationEmailsMutation, { data, loading, error }] = useSendCashFundSolicitationEmailsMutation({
 *   variables: {
 *      solicitationId: // value for 'solicitationId'
 *   },
 * });
 */
export function useSendCashFundSolicitationEmailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCashFundSolicitationEmailsMutation, SendCashFundSolicitationEmailsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCashFundSolicitationEmailsMutation, SendCashFundSolicitationEmailsMutationVariables>(SendCashFundSolicitationEmailsDocument, baseOptions);
      }
export type SendCashFundSolicitationEmailsMutationHookResult = ReturnType<typeof useSendCashFundSolicitationEmailsMutation>;
export type SendCashFundSolicitationEmailsMutationResult = Apollo.MutationResult<SendCashFundSolicitationEmailsMutation>;
export type SendCashFundSolicitationEmailsMutationOptions = Apollo.BaseMutationOptions<SendCashFundSolicitationEmailsMutation, SendCashFundSolicitationEmailsMutationVariables>;
export const SendCashFundSolicitationTestEmailDocument = gql`
    mutation SendCashFundSolicitationTestEmail($input: SendCashFundSolicitationTestEmailInput!) {
  sendCashFundSolicitationTestEmail(input: $input) {
    ... on SendCashFundSolicitationTestEmailSuccess {
      id
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundGeneralErrorFragmentDoc}`;
export type SendCashFundSolicitationTestEmailMutationFn = Apollo.MutationFunction<SendCashFundSolicitationTestEmailMutation, SendCashFundSolicitationTestEmailMutationVariables>;

/**
 * __useSendCashFundSolicitationTestEmailMutation__
 *
 * To run a mutation, you first call `useSendCashFundSolicitationTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCashFundSolicitationTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCashFundSolicitationTestEmailMutation, { data, loading, error }] = useSendCashFundSolicitationTestEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCashFundSolicitationTestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCashFundSolicitationTestEmailMutation, SendCashFundSolicitationTestEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCashFundSolicitationTestEmailMutation, SendCashFundSolicitationTestEmailMutationVariables>(SendCashFundSolicitationTestEmailDocument, baseOptions);
      }
export type SendCashFundSolicitationTestEmailMutationHookResult = ReturnType<typeof useSendCashFundSolicitationTestEmailMutation>;
export type SendCashFundSolicitationTestEmailMutationResult = Apollo.MutationResult<SendCashFundSolicitationTestEmailMutation>;
export type SendCashFundSolicitationTestEmailMutationOptions = Apollo.BaseMutationOptions<SendCashFundSolicitationTestEmailMutation, SendCashFundSolicitationTestEmailMutationVariables>;
export const AcceptCashFundContributionDocument = gql`
    mutation AcceptCashFundContribution($contributionId: ID!) {
  acceptCashFundContribution(contributionId: $contributionId) {
    ... on CashFundContribution {
      ...CashFundContribution
      order {
        ...CashFundOrder
      }
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundContributionFragmentDoc}
${CashFundOrderFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type AcceptCashFundContributionMutationFn = Apollo.MutationFunction<AcceptCashFundContributionMutation, AcceptCashFundContributionMutationVariables>;

/**
 * __useAcceptCashFundContributionMutation__
 *
 * To run a mutation, you first call `useAcceptCashFundContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCashFundContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCashFundContributionMutation, { data, loading, error }] = useAcceptCashFundContributionMutation({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useAcceptCashFundContributionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptCashFundContributionMutation, AcceptCashFundContributionMutationVariables>) {
        return ApolloReactHooks.useMutation<AcceptCashFundContributionMutation, AcceptCashFundContributionMutationVariables>(AcceptCashFundContributionDocument, baseOptions);
      }
export type AcceptCashFundContributionMutationHookResult = ReturnType<typeof useAcceptCashFundContributionMutation>;
export type AcceptCashFundContributionMutationResult = Apollo.MutationResult<AcceptCashFundContributionMutation>;
export type AcceptCashFundContributionMutationOptions = Apollo.BaseMutationOptions<AcceptCashFundContributionMutation, AcceptCashFundContributionMutationVariables>;
export const RefundCashFundContributionDocument = gql`
    mutation RefundCashFundContribution($contributionId: ID!) {
  refundCashFundContribution(contributionId: $contributionId) {
    ... on CashFundContribution {
      ...CashFundContribution
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundContributionFragmentDoc}
${CashFundGeneralErrorFragmentDoc}`;
export type RefundCashFundContributionMutationFn = Apollo.MutationFunction<RefundCashFundContributionMutation, RefundCashFundContributionMutationVariables>;

/**
 * __useRefundCashFundContributionMutation__
 *
 * To run a mutation, you first call `useRefundCashFundContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundCashFundContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundCashFundContributionMutation, { data, loading, error }] = useRefundCashFundContributionMutation({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useRefundCashFundContributionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefundCashFundContributionMutation, RefundCashFundContributionMutationVariables>) {
        return ApolloReactHooks.useMutation<RefundCashFundContributionMutation, RefundCashFundContributionMutationVariables>(RefundCashFundContributionDocument, baseOptions);
      }
export type RefundCashFundContributionMutationHookResult = ReturnType<typeof useRefundCashFundContributionMutation>;
export type RefundCashFundContributionMutationResult = Apollo.MutationResult<RefundCashFundContributionMutation>;
export type RefundCashFundContributionMutationOptions = Apollo.BaseMutationOptions<RefundCashFundContributionMutation, RefundCashFundContributionMutationVariables>;
export const WithdrawCashFundsPayoutAccountDocument = gql`
    mutation WithdrawCashFundsPayoutAccount($eventId: ID!) {
  withdrawCashFundsPayoutAccount(eventId: $eventId) {
    ... on CashFundsPayoutAccountWithdrawal {
      id
      status
    }
    ... on CashFundGeneralError {
      ...CashFundGeneralError
    }
  }
}
    ${CashFundGeneralErrorFragmentDoc}`;
export type WithdrawCashFundsPayoutAccountMutationFn = Apollo.MutationFunction<WithdrawCashFundsPayoutAccountMutation, WithdrawCashFundsPayoutAccountMutationVariables>;

/**
 * __useWithdrawCashFundsPayoutAccountMutation__
 *
 * To run a mutation, you first call `useWithdrawCashFundsPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawCashFundsPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawCashFundsPayoutAccountMutation, { data, loading, error }] = useWithdrawCashFundsPayoutAccountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWithdrawCashFundsPayoutAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WithdrawCashFundsPayoutAccountMutation, WithdrawCashFundsPayoutAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<WithdrawCashFundsPayoutAccountMutation, WithdrawCashFundsPayoutAccountMutationVariables>(WithdrawCashFundsPayoutAccountDocument, baseOptions);
      }
export type WithdrawCashFundsPayoutAccountMutationHookResult = ReturnType<typeof useWithdrawCashFundsPayoutAccountMutation>;
export type WithdrawCashFundsPayoutAccountMutationResult = Apollo.MutationResult<WithdrawCashFundsPayoutAccountMutation>;
export type WithdrawCashFundsPayoutAccountMutationOptions = Apollo.BaseMutationOptions<WithdrawCashFundsPayoutAccountMutation, WithdrawCashFundsPayoutAccountMutationVariables>;
export const GetEventInfoByIdForDashboardDocument = gql`
    query GetEventInfoByIdForDashboard($eventId: ID!) {
  eventById(id: $eventId) {
    id
    featureFlags
  }
}
    `;

/**
 * __useGetEventInfoByIdForDashboardQuery__
 *
 * To run a query within a React component, call `useGetEventInfoByIdForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInfoByIdForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInfoByIdForDashboardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventInfoByIdForDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventInfoByIdForDashboardQuery, GetEventInfoByIdForDashboardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventInfoByIdForDashboardQuery, GetEventInfoByIdForDashboardQueryVariables>(GetEventInfoByIdForDashboardDocument, baseOptions);
      }
export function useGetEventInfoByIdForDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventInfoByIdForDashboardQuery, GetEventInfoByIdForDashboardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventInfoByIdForDashboardQuery, GetEventInfoByIdForDashboardQueryVariables>(GetEventInfoByIdForDashboardDocument, baseOptions);
        }
export type GetEventInfoByIdForDashboardQueryHookResult = ReturnType<typeof useGetEventInfoByIdForDashboardQuery>;
export type GetEventInfoByIdForDashboardLazyQueryHookResult = ReturnType<typeof useGetEventInfoByIdForDashboardLazyQuery>;
export type GetEventInfoByIdForDashboardQueryResult = Apollo.QueryResult<GetEventInfoByIdForDashboardQuery, GetEventInfoByIdForDashboardQueryVariables>;
export const GetWebsiteDesignerVisitStatusDocument = gql`
    query GetWebsiteDesignerVisitStatus($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    eventDesign(purpose: $purpose) {
      id
      hasVisitedDesignPage
    }
  }
}
    `;

/**
 * __useGetWebsiteDesignerVisitStatusQuery__
 *
 * To run a query within a React component, call `useGetWebsiteDesignerVisitStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteDesignerVisitStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteDesignerVisitStatusQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetWebsiteDesignerVisitStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>(GetWebsiteDesignerVisitStatusDocument, baseOptions);
      }
export function useGetWebsiteDesignerVisitStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>(GetWebsiteDesignerVisitStatusDocument, baseOptions);
        }
export type GetWebsiteDesignerVisitStatusQueryHookResult = ReturnType<typeof useGetWebsiteDesignerVisitStatusQuery>;
export type GetWebsiteDesignerVisitStatusLazyQueryHookResult = ReturnType<typeof useGetWebsiteDesignerVisitStatusLazyQuery>;
export type GetWebsiteDesignerVisitStatusQueryResult = Apollo.QueryResult<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>;
export const GetUserConsentForEventDocument = gql`
    query GetUserConsentForEvent($consentKey: String!, $eventId: ID!) {
  userConsentKeyForEvent(consentKey: $consentKey, eventId: $eventId) {
    id
    consentAnswer
    consentKey
    eventId
  }
}
    `;

/**
 * __useGetUserConsentForEventQuery__
 *
 * To run a query within a React component, call `useGetUserConsentForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConsentForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConsentForEventQuery({
 *   variables: {
 *      consentKey: // value for 'consentKey'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetUserConsentForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserConsentForEventQuery, GetUserConsentForEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserConsentForEventQuery, GetUserConsentForEventQueryVariables>(GetUserConsentForEventDocument, baseOptions);
      }
export function useGetUserConsentForEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserConsentForEventQuery, GetUserConsentForEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserConsentForEventQuery, GetUserConsentForEventQueryVariables>(GetUserConsentForEventDocument, baseOptions);
        }
export type GetUserConsentForEventQueryHookResult = ReturnType<typeof useGetUserConsentForEventQuery>;
export type GetUserConsentForEventLazyQueryHookResult = ReturnType<typeof useGetUserConsentForEventLazyQuery>;
export type GetUserConsentForEventQueryResult = Apollo.QueryResult<GetUserConsentForEventQuery, GetUserConsentForEventQueryVariables>;
export const SetUserConsentForEventDocument = gql`
    mutation SetUserConsentForEvent($data: SaveUserConsentForEventInput!) {
  saveUserConsentKeyForEvent(data: $data) {
    id
    consentAnswer
    consentKey
    eventId
  }
}
    `;
export type SetUserConsentForEventMutationFn = Apollo.MutationFunction<SetUserConsentForEventMutation, SetUserConsentForEventMutationVariables>;

/**
 * __useSetUserConsentForEventMutation__
 *
 * To run a mutation, you first call `useSetUserConsentForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserConsentForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserConsentForEventMutation, { data, loading, error }] = useSetUserConsentForEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserConsentForEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserConsentForEventMutation, SetUserConsentForEventMutationVariables>) {
        return ApolloReactHooks.useMutation<SetUserConsentForEventMutation, SetUserConsentForEventMutationVariables>(SetUserConsentForEventDocument, baseOptions);
      }
export type SetUserConsentForEventMutationHookResult = ReturnType<typeof useSetUserConsentForEventMutation>;
export type SetUserConsentForEventMutationResult = Apollo.MutationResult<SetUserConsentForEventMutation>;
export type SetUserConsentForEventMutationOptions = Apollo.BaseMutationOptions<SetUserConsentForEventMutation, SetUserConsentForEventMutationVariables>;
export const GetEventCreationDataDocument = gql`
    query GetEventCreationData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventDisplayName
    }
    firebaseCreateAt {
      timestamp
    }
    eventDesign {
      id
      font {
        id
        fontFamily
      }
    }
  }
}
    `;

/**
 * __useGetEventCreationDataQuery__
 *
 * To run a query within a React component, call `useGetEventCreationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCreationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCreationDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventCreationDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventCreationDataQuery, GetEventCreationDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventCreationDataQuery, GetEventCreationDataQueryVariables>(GetEventCreationDataDocument, baseOptions);
      }
export function useGetEventCreationDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventCreationDataQuery, GetEventCreationDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventCreationDataQuery, GetEventCreationDataQueryVariables>(GetEventCreationDataDocument, baseOptions);
        }
export type GetEventCreationDataQueryHookResult = ReturnType<typeof useGetEventCreationDataQuery>;
export type GetEventCreationDataLazyQueryHookResult = ReturnType<typeof useGetEventCreationDataLazyQuery>;
export type GetEventCreationDataQueryResult = Apollo.QueryResult<GetEventCreationDataQuery, GetEventCreationDataQueryVariables>;
export const GetDashboardV3BaseEventInfoDocument = gql`
    query GetDashboardV3BaseEventInfo($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true) {
      id
      visibility
      pageSlug
      type
      pageTitle
    }
    productVerticals {
      optOutOfGuestList
      optOutOfRegistry
      optOutOfInvites
      optOutOfWebsite
    }
  }
}
    `;

/**
 * __useGetDashboardV3BaseEventInfoQuery__
 *
 * To run a query within a React component, call `useGetDashboardV3BaseEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardV3BaseEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardV3BaseEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDashboardV3BaseEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardV3BaseEventInfoQuery, GetDashboardV3BaseEventInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardV3BaseEventInfoQuery, GetDashboardV3BaseEventInfoQueryVariables>(GetDashboardV3BaseEventInfoDocument, baseOptions);
      }
export function useGetDashboardV3BaseEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardV3BaseEventInfoQuery, GetDashboardV3BaseEventInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardV3BaseEventInfoQuery, GetDashboardV3BaseEventInfoQueryVariables>(GetDashboardV3BaseEventInfoDocument, baseOptions);
        }
export type GetDashboardV3BaseEventInfoQueryHookResult = ReturnType<typeof useGetDashboardV3BaseEventInfoQuery>;
export type GetDashboardV3BaseEventInfoLazyQueryHookResult = ReturnType<typeof useGetDashboardV3BaseEventInfoLazyQuery>;
export type GetDashboardV3BaseEventInfoQueryResult = Apollo.QueryResult<GetDashboardV3BaseEventInfoQuery, GetDashboardV3BaseEventInfoQueryVariables>;
export const GetWebsitePreviewDataDocument = gql`
    query GetWebsitePreviewData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      ownerFirstName
      fianceeFirstName
      finalizedDate {
        dateString(dateFormat: long)
      }
      location
    }
    guests(admin: true) {
      peopleCount
      people {
        id
        legacyRsvpAnswers {
          answer
          questionId
        }
      }
    }
    registry {
      id
      itemCount {
        available
      }
    }
    eventDesign {
      id
      font {
        id
        fontFamily
      }
    }
  }
}
    `;

/**
 * __useGetWebsitePreviewDataQuery__
 *
 * To run a query within a React component, call `useGetWebsitePreviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsitePreviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsitePreviewDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetWebsitePreviewDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsitePreviewDataQuery, GetWebsitePreviewDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsitePreviewDataQuery, GetWebsitePreviewDataQueryVariables>(GetWebsitePreviewDataDocument, baseOptions);
      }
export function useGetWebsitePreviewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsitePreviewDataQuery, GetWebsitePreviewDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsitePreviewDataQuery, GetWebsitePreviewDataQueryVariables>(GetWebsitePreviewDataDocument, baseOptions);
        }
export type GetWebsitePreviewDataQueryHookResult = ReturnType<typeof useGetWebsitePreviewDataQuery>;
export type GetWebsitePreviewDataLazyQueryHookResult = ReturnType<typeof useGetWebsitePreviewDataLazyQuery>;
export type GetWebsitePreviewDataQueryResult = Apollo.QueryResult<GetWebsitePreviewDataQuery, GetWebsitePreviewDataQueryVariables>;
export const GetRegistryOrdersIdsForAccordionDocument = gql`
    query GetRegistryOrdersIdsForAccordion($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      orders {
        id
      }
    }
  }
}
    `;

/**
 * __useGetRegistryOrdersIdsForAccordionQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrdersIdsForAccordionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrdersIdsForAccordionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrdersIdsForAccordionQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryOrdersIdsForAccordionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrdersIdsForAccordionQuery, GetRegistryOrdersIdsForAccordionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOrdersIdsForAccordionQuery, GetRegistryOrdersIdsForAccordionQueryVariables>(GetRegistryOrdersIdsForAccordionDocument, baseOptions);
      }
export function useGetRegistryOrdersIdsForAccordionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrdersIdsForAccordionQuery, GetRegistryOrdersIdsForAccordionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOrdersIdsForAccordionQuery, GetRegistryOrdersIdsForAccordionQueryVariables>(GetRegistryOrdersIdsForAccordionDocument, baseOptions);
        }
export type GetRegistryOrdersIdsForAccordionQueryHookResult = ReturnType<typeof useGetRegistryOrdersIdsForAccordionQuery>;
export type GetRegistryOrdersIdsForAccordionLazyQueryHookResult = ReturnType<typeof useGetRegistryOrdersIdsForAccordionLazyQuery>;
export type GetRegistryOrdersIdsForAccordionQueryResult = Apollo.QueryResult<GetRegistryOrdersIdsForAccordionQuery, GetRegistryOrdersIdsForAccordionQueryVariables>;
export const GetDashboardAccordionDataDocument = gql`
    query GetDashboardAccordionData($eventHandle: String!, $eventId: String!, $getEcardsByEventIdId: ID!, $args: MessageRelationshipCriteria) {
  eventByName(name: $eventHandle) {
    id
    guests(admin: true) {
      peopleCount
      people {
        id
        legacyRsvpAnswers {
          answer
          questionId
        }
      }
    }
    registry {
      id
      currency {
        id
        code
        places
      }
      itemCount {
        available
        purchasedOrReserved
      }
      items {
        id
        donationFund {
          id
          goalMonetaryValue {
            valueInMinorUnits
          }
          donations {
            id
            amount {
              valueInMinorUnits
            }
          }
        }
      }
    }
    hotelRoomBlocks {
      id
      numberOfRooms
    }
  }
  getMessageRelationships(args: $args) {
    id
  }
  getContactCollectionByEventId(eventId: $eventId) {
    id
    contacts {
      id
    }
  }
  saveTheDatesECards: getEcardsByEventId(id: $getEcardsByEventIdId, ecardType: savethedate) {
    id
  }
  invitationsECards: getEcardsByEventId(id: $getEcardsByEventIdId, ecardType: invitation) {
    id
  }
  stationeryPrintOrdersByEvent(input: {eventId: $eventId}) {
    orders {
      id
      quantity
      cardDraft {
        id
        stationeryTemplate {
          id
          category
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardAccordionDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardAccordionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardAccordionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardAccordionDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventId: // value for 'eventId'
 *      getEcardsByEventIdId: // value for 'getEcardsByEventIdId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetDashboardAccordionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardAccordionDataQuery, GetDashboardAccordionDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardAccordionDataQuery, GetDashboardAccordionDataQueryVariables>(GetDashboardAccordionDataDocument, baseOptions);
      }
export function useGetDashboardAccordionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardAccordionDataQuery, GetDashboardAccordionDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardAccordionDataQuery, GetDashboardAccordionDataQueryVariables>(GetDashboardAccordionDataDocument, baseOptions);
        }
export type GetDashboardAccordionDataQueryHookResult = ReturnType<typeof useGetDashboardAccordionDataQuery>;
export type GetDashboardAccordionDataLazyQueryHookResult = ReturnType<typeof useGetDashboardAccordionDataLazyQuery>;
export type GetDashboardAccordionDataQueryResult = Apollo.QueryResult<GetDashboardAccordionDataQuery, GetDashboardAccordionDataQueryVariables>;
export const GetDashboardChecklistDataDocument = gql`
    query GetDashboardChecklistData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      finalizedDate {
        milliseconds
      }
    }
    checklist {
      id
      title
      items {
        ...DashboardChecklistItem
      }
    }
  }
}
    ${DashboardChecklistItemFragmentDoc}`;

/**
 * __useGetDashboardChecklistDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardChecklistDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardChecklistDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardChecklistDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDashboardChecklistDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardChecklistDataQuery, GetDashboardChecklistDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardChecklistDataQuery, GetDashboardChecklistDataQueryVariables>(GetDashboardChecklistDataDocument, baseOptions);
      }
export function useGetDashboardChecklistDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardChecklistDataQuery, GetDashboardChecklistDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardChecklistDataQuery, GetDashboardChecklistDataQueryVariables>(GetDashboardChecklistDataDocument, baseOptions);
        }
export type GetDashboardChecklistDataQueryHookResult = ReturnType<typeof useGetDashboardChecklistDataQuery>;
export type GetDashboardChecklistDataLazyQueryHookResult = ReturnType<typeof useGetDashboardChecklistDataLazyQuery>;
export type GetDashboardChecklistDataQueryResult = Apollo.QueryResult<GetDashboardChecklistDataQuery, GetDashboardChecklistDataQueryVariables>;
export const CompleteChecklistItemDocument = gql`
    mutation CompleteChecklistItem($id: String!, $input: ChecklistItemUpdateInput!) {
  updateChecklistItem(id: $id, input: $input) {
    ... on ChecklistItem {
      id
      completedAt
    }
  }
}
    `;
export type CompleteChecklistItemMutationFn = Apollo.MutationFunction<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;

/**
 * __useCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistItemMutation, { data, loading, error }] = useCompleteChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteChecklistItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>(CompleteChecklistItemDocument, baseOptions);
      }
export type CompleteChecklistItemMutationHookResult = ReturnType<typeof useCompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationResult = Apollo.MutationResult<CompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;
export const CompleteChecklistSubItemDocument = gql`
    mutation CompleteChecklistSubItem($id: String!, $input: ChecklistSubItemUpdateInput!) {
  updateChecklistSubItem(id: $id, input: $input) {
    ... on ChecklistSubItem {
      id
      completedAt
    }
  }
}
    `;
export type CompleteChecklistSubItemMutationFn = Apollo.MutationFunction<CompleteChecklistSubItemMutation, CompleteChecklistSubItemMutationVariables>;

/**
 * __useCompleteChecklistSubItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistSubItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistSubItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistSubItemMutation, { data, loading, error }] = useCompleteChecklistSubItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteChecklistSubItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteChecklistSubItemMutation, CompleteChecklistSubItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CompleteChecklistSubItemMutation, CompleteChecklistSubItemMutationVariables>(CompleteChecklistSubItemDocument, baseOptions);
      }
export type CompleteChecklistSubItemMutationHookResult = ReturnType<typeof useCompleteChecklistSubItemMutation>;
export type CompleteChecklistSubItemMutationResult = Apollo.MutationResult<CompleteChecklistSubItemMutation>;
export type CompleteChecklistSubItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistSubItemMutation, CompleteChecklistSubItemMutationVariables>;
export const ReminderChecklistItemDocument = gql`
    mutation ReminderChecklistItem($id: String!, $input: ChecklistItemUpdateInput!) {
  updateChecklistItem(id: $id, input: $input) {
    ... on ChecklistItem {
      id
      reminderAt
    }
  }
}
    `;
export type ReminderChecklistItemMutationFn = Apollo.MutationFunction<ReminderChecklistItemMutation, ReminderChecklistItemMutationVariables>;

/**
 * __useReminderChecklistItemMutation__
 *
 * To run a mutation, you first call `useReminderChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReminderChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reminderChecklistItemMutation, { data, loading, error }] = useReminderChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReminderChecklistItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReminderChecklistItemMutation, ReminderChecklistItemMutationVariables>) {
        return ApolloReactHooks.useMutation<ReminderChecklistItemMutation, ReminderChecklistItemMutationVariables>(ReminderChecklistItemDocument, baseOptions);
      }
export type ReminderChecklistItemMutationHookResult = ReturnType<typeof useReminderChecklistItemMutation>;
export type ReminderChecklistItemMutationResult = Apollo.MutationResult<ReminderChecklistItemMutation>;
export type ReminderChecklistItemMutationOptions = Apollo.BaseMutationOptions<ReminderChecklistItemMutation, ReminderChecklistItemMutationVariables>;
export const GetRegistryOrdersIdsDocument = gql`
    query GetRegistryOrdersIds($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      orders {
        id
      }
    }
  }
}
    `;

/**
 * __useGetRegistryOrdersIdsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrdersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrdersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrdersIdsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryOrdersIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrdersIdsQuery, GetRegistryOrdersIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOrdersIdsQuery, GetRegistryOrdersIdsQueryVariables>(GetRegistryOrdersIdsDocument, baseOptions);
      }
export function useGetRegistryOrdersIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrdersIdsQuery, GetRegistryOrdersIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOrdersIdsQuery, GetRegistryOrdersIdsQueryVariables>(GetRegistryOrdersIdsDocument, baseOptions);
        }
export type GetRegistryOrdersIdsQueryHookResult = ReturnType<typeof useGetRegistryOrdersIdsQuery>;
export type GetRegistryOrdersIdsLazyQueryHookResult = ReturnType<typeof useGetRegistryOrdersIdsLazyQuery>;
export type GetRegistryOrdersIdsQueryResult = Apollo.QueryResult<GetRegistryOrdersIdsQuery, GetRegistryOrdersIdsQueryVariables>;
export const GetDashboardStatsDataDocument = gql`
    query GetDashboardStatsData($eventHandle: String!, $eventId: String!, $getEcardsByEventIdId: ID!, $args: MessageRelationshipCriteria) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true) {
      id
      visibility
      pageSlug
    }
    productVerticals {
      optOutOfGuestList
      optOutOfRegistry
      optOutOfInvites
      optOutOfWebsite
    }
    guests(admin: true) {
      peopleCount
      people {
        id
        legacyRsvpAnswers {
          answer
          questionId
        }
      }
    }
    registry {
      id
      currency {
        id
        code
        places
      }
      itemCount {
        available
        purchasedOrReserved
      }
      items {
        id
        donationFund {
          id
          goalMonetaryValue {
            valueInMinorUnits
          }
          donations {
            id
            amount {
              valueInMinorUnits
            }
          }
        }
      }
    }
    hotelRoomBlocks {
      id
      numberOfRooms
    }
  }
  getMessageRelationships(args: $args) {
    id
  }
  getContactCollectionByEventId(eventId: $eventId) {
    id
    contacts {
      id
    }
  }
  saveTheDatesECards: getEcardsByEventId(id: $getEcardsByEventIdId, ecardType: savethedate) {
    id
  }
  invitationsECards: getEcardsByEventId(id: $getEcardsByEventIdId, ecardType: invitation) {
    id
  }
  stationeryPrintOrdersByEvent(input: {eventId: $eventId}) {
    orders {
      id
      quantity
      cardDraft {
        id
        stationeryTemplate {
          id
          category
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardStatsDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardStatsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardStatsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardStatsDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventId: // value for 'eventId'
 *      getEcardsByEventIdId: // value for 'getEcardsByEventIdId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetDashboardStatsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardStatsDataQuery, GetDashboardStatsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardStatsDataQuery, GetDashboardStatsDataQueryVariables>(GetDashboardStatsDataDocument, baseOptions);
      }
export function useGetDashboardStatsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardStatsDataQuery, GetDashboardStatsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardStatsDataQuery, GetDashboardStatsDataQueryVariables>(GetDashboardStatsDataDocument, baseOptions);
        }
export type GetDashboardStatsDataQueryHookResult = ReturnType<typeof useGetDashboardStatsDataQuery>;
export type GetDashboardStatsDataLazyQueryHookResult = ReturnType<typeof useGetDashboardStatsDataLazyQuery>;
export type GetDashboardStatsDataQueryResult = Apollo.QueryResult<GetDashboardStatsDataQuery, GetDashboardStatsDataQueryVariables>;
export const GetDashboardPreviewPagesDocument = gql`
    query GetDashboardPreviewPages($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true) {
      id
      visibility
    }
  }
}
    `;

/**
 * __useGetDashboardPreviewPagesQuery__
 *
 * To run a query within a React component, call `useGetDashboardPreviewPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPreviewPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPreviewPagesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDashboardPreviewPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardPreviewPagesQuery, GetDashboardPreviewPagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardPreviewPagesQuery, GetDashboardPreviewPagesQueryVariables>(GetDashboardPreviewPagesDocument, baseOptions);
      }
export function useGetDashboardPreviewPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardPreviewPagesQuery, GetDashboardPreviewPagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardPreviewPagesQuery, GetDashboardPreviewPagesQueryVariables>(GetDashboardPreviewPagesDocument, baseOptions);
        }
export type GetDashboardPreviewPagesQueryHookResult = ReturnType<typeof useGetDashboardPreviewPagesQuery>;
export type GetDashboardPreviewPagesLazyQueryHookResult = ReturnType<typeof useGetDashboardPreviewPagesLazyQuery>;
export type GetDashboardPreviewPagesQueryResult = Apollo.QueryResult<GetDashboardPreviewPagesQuery, GetDashboardPreviewPagesQueryVariables>;
export const DashboardPreviewStationeryTemplatesDocument = gql`
    query DashboardPreviewStationeryTemplates($themeId: String!) {
  stationeryTemplates: stationeryTemplatesByThemeId(themeId: $themeId) {
    id
    themeId
    thumbnailUrl
    category
  }
}
    `;

/**
 * __useDashboardPreviewStationeryTemplatesQuery__
 *
 * To run a query within a React component, call `useDashboardPreviewStationeryTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPreviewStationeryTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPreviewStationeryTemplatesQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useDashboardPreviewStationeryTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DashboardPreviewStationeryTemplatesQuery, DashboardPreviewStationeryTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<DashboardPreviewStationeryTemplatesQuery, DashboardPreviewStationeryTemplatesQueryVariables>(DashboardPreviewStationeryTemplatesDocument, baseOptions);
      }
export function useDashboardPreviewStationeryTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardPreviewStationeryTemplatesQuery, DashboardPreviewStationeryTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DashboardPreviewStationeryTemplatesQuery, DashboardPreviewStationeryTemplatesQueryVariables>(DashboardPreviewStationeryTemplatesDocument, baseOptions);
        }
export type DashboardPreviewStationeryTemplatesQueryHookResult = ReturnType<typeof useDashboardPreviewStationeryTemplatesQuery>;
export type DashboardPreviewStationeryTemplatesLazyQueryHookResult = ReturnType<typeof useDashboardPreviewStationeryTemplatesLazyQuery>;
export type DashboardPreviewStationeryTemplatesQueryResult = Apollo.QueryResult<DashboardPreviewStationeryTemplatesQuery, DashboardPreviewStationeryTemplatesQueryVariables>;
export const EventRedirectEventMembershipsDocument = gql`
    query EventRedirectEventMemberships {
  me {
    id
    activeEventUsers(filter: {types: [wedding, babyRegistry, general]}) {
      id
      status
      event {
        id
        firebaseId
        website
        info {
          id
          eventType
          eventDisplayName
          finalizedDate {
            milliseconds
            dateString(dateFormat: long)
          }
          location
        }
        style {
          id
          primaryColorV0918 {
            hex
          }
        }
        photo {
          id
          url
        }
        featureFlags
      }
    }
  }
}
    `;

/**
 * __useEventRedirectEventMembershipsQuery__
 *
 * To run a query within a React component, call `useEventRedirectEventMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRedirectEventMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRedirectEventMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventRedirectEventMembershipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventRedirectEventMembershipsQuery, EventRedirectEventMembershipsQueryVariables>) {
        return ApolloReactHooks.useQuery<EventRedirectEventMembershipsQuery, EventRedirectEventMembershipsQueryVariables>(EventRedirectEventMembershipsDocument, baseOptions);
      }
export function useEventRedirectEventMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventRedirectEventMembershipsQuery, EventRedirectEventMembershipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventRedirectEventMembershipsQuery, EventRedirectEventMembershipsQueryVariables>(EventRedirectEventMembershipsDocument, baseOptions);
        }
export type EventRedirectEventMembershipsQueryHookResult = ReturnType<typeof useEventRedirectEventMembershipsQuery>;
export type EventRedirectEventMembershipsLazyQueryHookResult = ReturnType<typeof useEventRedirectEventMembershipsLazyQuery>;
export type EventRedirectEventMembershipsQueryResult = Apollo.QueryResult<EventRedirectEventMembershipsQuery, EventRedirectEventMembershipsQueryVariables>;
export const ServiceCenterInfoByEventNameDocument = gql`
    query ServiceCenterInfoByEventName($eventName: String!) {
  eventByName(name: $eventName) {
    id
    firebaseId
    featureFlags
    firebaseCreateAt {
      dateString
    }
  }
}
    `;

/**
 * __useServiceCenterInfoByEventNameQuery__
 *
 * To run a query within a React component, call `useServiceCenterInfoByEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCenterInfoByEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCenterInfoByEventNameQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *   },
 * });
 */
export function useServiceCenterInfoByEventNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServiceCenterInfoByEventNameQuery, ServiceCenterInfoByEventNameQueryVariables>) {
        return ApolloReactHooks.useQuery<ServiceCenterInfoByEventNameQuery, ServiceCenterInfoByEventNameQueryVariables>(ServiceCenterInfoByEventNameDocument, baseOptions);
      }
export function useServiceCenterInfoByEventNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceCenterInfoByEventNameQuery, ServiceCenterInfoByEventNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ServiceCenterInfoByEventNameQuery, ServiceCenterInfoByEventNameQueryVariables>(ServiceCenterInfoByEventNameDocument, baseOptions);
        }
export type ServiceCenterInfoByEventNameQueryHookResult = ReturnType<typeof useServiceCenterInfoByEventNameQuery>;
export type ServiceCenterInfoByEventNameLazyQueryHookResult = ReturnType<typeof useServiceCenterInfoByEventNameLazyQuery>;
export type ServiceCenterInfoByEventNameQueryResult = Apollo.QueryResult<ServiceCenterInfoByEventNameQuery, ServiceCenterInfoByEventNameQueryVariables>;
export const CreateEventFeatureFlagDocument = gql`
    mutation CreateEventFeatureFlag($eventId: ID!, $flag: String!) {
  createEventFeatureFlag(eventId: $eventId, flag: $flag) {
    id
    flag
  }
}
    `;
export type CreateEventFeatureFlagMutationFn = Apollo.MutationFunction<CreateEventFeatureFlagMutation, CreateEventFeatureFlagMutationVariables>;

/**
 * __useCreateEventFeatureFlagMutation__
 *
 * To run a mutation, you first call `useCreateEventFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventFeatureFlagMutation, { data, loading, error }] = useCreateEventFeatureFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useCreateEventFeatureFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventFeatureFlagMutation, CreateEventFeatureFlagMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEventFeatureFlagMutation, CreateEventFeatureFlagMutationVariables>(CreateEventFeatureFlagDocument, baseOptions);
      }
export type CreateEventFeatureFlagMutationHookResult = ReturnType<typeof useCreateEventFeatureFlagMutation>;
export type CreateEventFeatureFlagMutationResult = Apollo.MutationResult<CreateEventFeatureFlagMutation>;
export type CreateEventFeatureFlagMutationOptions = Apollo.BaseMutationOptions<CreateEventFeatureFlagMutation, CreateEventFeatureFlagMutationVariables>;
export const DeleteEventFeatureFlagDocument = gql`
    mutation DeleteEventFeatureFlag($eventId: ID!, $flag: String!) {
  deleteEventFeatureFlag(eventId: $eventId, flag: $flag)
}
    `;
export type DeleteEventFeatureFlagMutationFn = Apollo.MutationFunction<DeleteEventFeatureFlagMutation, DeleteEventFeatureFlagMutationVariables>;

/**
 * __useDeleteEventFeatureFlagMutation__
 *
 * To run a mutation, you first call `useDeleteEventFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventFeatureFlagMutation, { data, loading, error }] = useDeleteEventFeatureFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useDeleteEventFeatureFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventFeatureFlagMutation, DeleteEventFeatureFlagMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEventFeatureFlagMutation, DeleteEventFeatureFlagMutationVariables>(DeleteEventFeatureFlagDocument, baseOptions);
      }
export type DeleteEventFeatureFlagMutationHookResult = ReturnType<typeof useDeleteEventFeatureFlagMutation>;
export type DeleteEventFeatureFlagMutationResult = Apollo.MutationResult<DeleteEventFeatureFlagMutation>;
export type DeleteEventFeatureFlagMutationOptions = Apollo.BaseMutationOptions<DeleteEventFeatureFlagMutation, DeleteEventFeatureFlagMutationVariables>;
export const ResetOnboardingSurveyResponsesDocument = gql`
    mutation ResetOnboardingSurveyResponses($eventId: String!) {
  updateRecommendRegistryOnboardingSurvey(eventId: $eventId) {
    id
  }
}
    `;
export type ResetOnboardingSurveyResponsesMutationFn = Apollo.MutationFunction<ResetOnboardingSurveyResponsesMutation, ResetOnboardingSurveyResponsesMutationVariables>;

/**
 * __useResetOnboardingSurveyResponsesMutation__
 *
 * To run a mutation, you first call `useResetOnboardingSurveyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOnboardingSurveyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOnboardingSurveyResponsesMutation, { data, loading, error }] = useResetOnboardingSurveyResponsesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useResetOnboardingSurveyResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetOnboardingSurveyResponsesMutation, ResetOnboardingSurveyResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetOnboardingSurveyResponsesMutation, ResetOnboardingSurveyResponsesMutationVariables>(ResetOnboardingSurveyResponsesDocument, baseOptions);
      }
export type ResetOnboardingSurveyResponsesMutationHookResult = ReturnType<typeof useResetOnboardingSurveyResponsesMutation>;
export type ResetOnboardingSurveyResponsesMutationResult = Apollo.MutationResult<ResetOnboardingSurveyResponsesMutation>;
export type ResetOnboardingSurveyResponsesMutationOptions = Apollo.BaseMutationOptions<ResetOnboardingSurveyResponsesMutation, ResetOnboardingSurveyResponsesMutationVariables>;
export const ResetShippingAddressDocument = gql`
    mutation ResetShippingAddress($eventId: ID!) {
  removeRegistryAddress(eventId: $eventId)
}
    `;
export type ResetShippingAddressMutationFn = Apollo.MutationFunction<ResetShippingAddressMutation, ResetShippingAddressMutationVariables>;

/**
 * __useResetShippingAddressMutation__
 *
 * To run a mutation, you first call `useResetShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetShippingAddressMutation, { data, loading, error }] = useResetShippingAddressMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useResetShippingAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetShippingAddressMutation, ResetShippingAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetShippingAddressMutation, ResetShippingAddressMutationVariables>(ResetShippingAddressDocument, baseOptions);
      }
export type ResetShippingAddressMutationHookResult = ReturnType<typeof useResetShippingAddressMutation>;
export type ResetShippingAddressMutationResult = Apollo.MutationResult<ResetShippingAddressMutation>;
export type ResetShippingAddressMutationOptions = Apollo.BaseMutationOptions<ResetShippingAddressMutation, ResetShippingAddressMutationVariables>;
export const ResetChecklistDocument = gql`
    mutation ResetChecklist($eventId: ID!) {
  deleteRegistryChecklist(eventId: $eventId)
}
    `;
export type ResetChecklistMutationFn = Apollo.MutationFunction<ResetChecklistMutation, ResetChecklistMutationVariables>;

/**
 * __useResetChecklistMutation__
 *
 * To run a mutation, you first call `useResetChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetChecklistMutation, { data, loading, error }] = useResetChecklistMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useResetChecklistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetChecklistMutation, ResetChecklistMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetChecklistMutation, ResetChecklistMutationVariables>(ResetChecklistDocument, baseOptions);
      }
export type ResetChecklistMutationHookResult = ReturnType<typeof useResetChecklistMutation>;
export type ResetChecklistMutationResult = Apollo.MutationResult<ResetChecklistMutation>;
export type ResetChecklistMutationOptions = Apollo.BaseMutationOptions<ResetChecklistMutation, ResetChecklistMutationVariables>;
export const GetRegistriesForDeletionDocument = gql`
    query GetRegistriesForDeletion($id: ID!) {
  eventById(id: $id) {
    id
    info {
      id
      registry {
        ...RegistryDataForReset
      }
    }
  }
}
    ${RegistryDataForResetFragmentDoc}`;

/**
 * __useGetRegistriesForDeletionQuery__
 *
 * To run a query within a React component, call `useGetRegistriesForDeletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistriesForDeletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistriesForDeletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegistriesForDeletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistriesForDeletionQuery, GetRegistriesForDeletionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistriesForDeletionQuery, GetRegistriesForDeletionQueryVariables>(GetRegistriesForDeletionDocument, baseOptions);
      }
export function useGetRegistriesForDeletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistriesForDeletionQuery, GetRegistriesForDeletionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistriesForDeletionQuery, GetRegistriesForDeletionQueryVariables>(GetRegistriesForDeletionDocument, baseOptions);
        }
export type GetRegistriesForDeletionQueryHookResult = ReturnType<typeof useGetRegistriesForDeletionQuery>;
export type GetRegistriesForDeletionLazyQueryHookResult = ReturnType<typeof useGetRegistriesForDeletionLazyQuery>;
export type GetRegistriesForDeletionQueryResult = Apollo.QueryResult<GetRegistriesForDeletionQuery, GetRegistriesForDeletionQueryVariables>;
export const GetTransferredRegistriesDocument = gql`
    query GetTransferredRegistries($eventId: ID!) {
  eventById(id: $eventId) {
    id
    info {
      id
      registry {
        ...TransferredRegistry
      }
    }
  }
}
    ${TransferredRegistryFragmentDoc}`;

/**
 * __useGetTransferredRegistriesQuery__
 *
 * To run a query within a React component, call `useGetTransferredRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferredRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferredRegistriesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTransferredRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTransferredRegistriesQuery, GetTransferredRegistriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTransferredRegistriesQuery, GetTransferredRegistriesQueryVariables>(GetTransferredRegistriesDocument, baseOptions);
      }
export function useGetTransferredRegistriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTransferredRegistriesQuery, GetTransferredRegistriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTransferredRegistriesQuery, GetTransferredRegistriesQueryVariables>(GetTransferredRegistriesDocument, baseOptions);
        }
export type GetTransferredRegistriesQueryHookResult = ReturnType<typeof useGetTransferredRegistriesQuery>;
export type GetTransferredRegistriesLazyQueryHookResult = ReturnType<typeof useGetTransferredRegistriesLazyQuery>;
export type GetTransferredRegistriesQueryResult = Apollo.QueryResult<GetTransferredRegistriesQuery, GetTransferredRegistriesQueryVariables>;
export const RefreshDraftItemsDocument = gql`
    mutation RefreshDraftItems($id: ID!) {
  refreshRegistryDrafts(id: $id) {
    id
    draftItems {
      id
    }
  }
}
    `;
export type RefreshDraftItemsMutationFn = Apollo.MutationFunction<RefreshDraftItemsMutation, RefreshDraftItemsMutationVariables>;

/**
 * __useRefreshDraftItemsMutation__
 *
 * To run a mutation, you first call `useRefreshDraftItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDraftItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDraftItemsMutation, { data, loading, error }] = useRefreshDraftItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshDraftItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshDraftItemsMutation, RefreshDraftItemsMutationVariables>) {
        return ApolloReactHooks.useMutation<RefreshDraftItemsMutation, RefreshDraftItemsMutationVariables>(RefreshDraftItemsDocument, baseOptions);
      }
export type RefreshDraftItemsMutationHookResult = ReturnType<typeof useRefreshDraftItemsMutation>;
export type RefreshDraftItemsMutationResult = Apollo.MutationResult<RefreshDraftItemsMutation>;
export type RefreshDraftItemsMutationOptions = Apollo.BaseMutationOptions<RefreshDraftItemsMutation, RefreshDraftItemsMutationVariables>;
export const GetCatalogItemCountDocument = gql`
    query GetCatalogItemCount($eventId: ID!) {
  eventById(id: $eventId) {
    id
    registry {
      id
      itemCount {
        shippable
      }
    }
  }
}
    `;

/**
 * __useGetCatalogItemCountQuery__
 *
 * To run a query within a React component, call `useGetCatalogItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogItemCountQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetCatalogItemCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogItemCountQuery, GetCatalogItemCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCatalogItemCountQuery, GetCatalogItemCountQueryVariables>(GetCatalogItemCountDocument, baseOptions);
      }
export function useGetCatalogItemCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogItemCountQuery, GetCatalogItemCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCatalogItemCountQuery, GetCatalogItemCountQueryVariables>(GetCatalogItemCountDocument, baseOptions);
        }
export type GetCatalogItemCountQueryHookResult = ReturnType<typeof useGetCatalogItemCountQuery>;
export type GetCatalogItemCountLazyQueryHookResult = ReturnType<typeof useGetCatalogItemCountLazyQuery>;
export type GetCatalogItemCountQueryResult = Apollo.QueryResult<GetCatalogItemCountQuery, GetCatalogItemCountQueryVariables>;
export const SubmitEventHotelRoomBlocksDocument = gql`
    mutation SubmitEventHotelRoomBlocks($eventId: String!) {
  hotelRoomBlocksSubmitted(eventId: $eventId) {
    id
    submittedDateTime
  }
}
    `;
export type SubmitEventHotelRoomBlocksMutationFn = Apollo.MutationFunction<SubmitEventHotelRoomBlocksMutation, SubmitEventHotelRoomBlocksMutationVariables>;

/**
 * __useSubmitEventHotelRoomBlocksMutation__
 *
 * To run a mutation, you first call `useSubmitEventHotelRoomBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEventHotelRoomBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEventHotelRoomBlocksMutation, { data, loading, error }] = useSubmitEventHotelRoomBlocksMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSubmitEventHotelRoomBlocksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitEventHotelRoomBlocksMutation, SubmitEventHotelRoomBlocksMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitEventHotelRoomBlocksMutation, SubmitEventHotelRoomBlocksMutationVariables>(SubmitEventHotelRoomBlocksDocument, baseOptions);
      }
export type SubmitEventHotelRoomBlocksMutationHookResult = ReturnType<typeof useSubmitEventHotelRoomBlocksMutation>;
export type SubmitEventHotelRoomBlocksMutationResult = Apollo.MutationResult<SubmitEventHotelRoomBlocksMutation>;
export type SubmitEventHotelRoomBlocksMutationOptions = Apollo.BaseMutationOptions<SubmitEventHotelRoomBlocksMutation, SubmitEventHotelRoomBlocksMutationVariables>;
export const EventHotelRoomBlocksDocument = gql`
    query EventHotelRoomBlocks($eventId: ID!) {
  event(id: $eventId) {
    id
    featureFlags
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      finalizedDate {
        dateString
      }
    }
    hotelRoomBlocks {
      id
      submittedDateTime
      eventDisplayName
      AnyOtherDetails
      PreferredContactMethod
      bookingLink
      leadStateV2
      leadStateV2UpdatedAt
      checkIn
      checkOut
      email
      numberOfRooms
      destination {
        name
        lat
        long
        postalCode
        address
      }
      concierge {
        name
        email
        photo {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useEventHotelRoomBlocksQuery__
 *
 * To run a query within a React component, call `useEventHotelRoomBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventHotelRoomBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventHotelRoomBlocksQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventHotelRoomBlocksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventHotelRoomBlocksQuery, EventHotelRoomBlocksQueryVariables>) {
        return ApolloReactHooks.useQuery<EventHotelRoomBlocksQuery, EventHotelRoomBlocksQueryVariables>(EventHotelRoomBlocksDocument, baseOptions);
      }
export function useEventHotelRoomBlocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventHotelRoomBlocksQuery, EventHotelRoomBlocksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventHotelRoomBlocksQuery, EventHotelRoomBlocksQueryVariables>(EventHotelRoomBlocksDocument, baseOptions);
        }
export type EventHotelRoomBlocksQueryHookResult = ReturnType<typeof useEventHotelRoomBlocksQuery>;
export type EventHotelRoomBlocksLazyQueryHookResult = ReturnType<typeof useEventHotelRoomBlocksLazyQuery>;
export type EventHotelRoomBlocksQueryResult = Apollo.QueryResult<EventHotelRoomBlocksQuery, EventHotelRoomBlocksQueryVariables>;
export const SubmitLeadDocument = gql`
    mutation SubmitLead($payload: HotelRoomBlockLeadInfoSubmittedRequest!) {
  submitLead(payload: $payload) {
    id
    submittedDateTime
  }
}
    `;
export type SubmitLeadMutationFn = Apollo.MutationFunction<SubmitLeadMutation, SubmitLeadMutationVariables>;

/**
 * __useSubmitLeadMutation__
 *
 * To run a mutation, you first call `useSubmitLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLeadMutation, { data, loading, error }] = useSubmitLeadMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitLeadMutation, SubmitLeadMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitLeadMutation, SubmitLeadMutationVariables>(SubmitLeadDocument, baseOptions);
      }
export type SubmitLeadMutationHookResult = ReturnType<typeof useSubmitLeadMutation>;
export type SubmitLeadMutationResult = Apollo.MutationResult<SubmitLeadMutation>;
export type SubmitLeadMutationOptions = Apollo.BaseMutationOptions<SubmitLeadMutation, SubmitLeadMutationVariables>;
export const EventHotelRoomBlocksRoomBlockManagerDocument = gql`
    query EventHotelRoomBlocksRoomBlockManager($eventId: ID!) {
  event(id: $eventId) {
    id
    accommodationPlacesV2 {
      id
      __typename
      type
      customName
      address
      name
      lat
      long
      isFavorite
      isPhotoHidden
      starRating
      joyPlaceId
      isFromAccommodationCatalog
      createdByType
      customPhoto {
        id
        url
      }
      photo {
        id
        url
      }
      accommodationRoomBlock {
        bookingUrl
        cutoffDate
        checkInDate
        checkOutDate
        pricePerNight
        isJoyManagedRoomBlock
        strikeoutPricePerNight
        numberOfRoomsReserved
        status
      }
    }
    hotelRoomBlocks {
      id
      availablePerks
    }
  }
}
    `;

/**
 * __useEventHotelRoomBlocksRoomBlockManagerQuery__
 *
 * To run a query within a React component, call `useEventHotelRoomBlocksRoomBlockManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventHotelRoomBlocksRoomBlockManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventHotelRoomBlocksRoomBlockManagerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventHotelRoomBlocksRoomBlockManagerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventHotelRoomBlocksRoomBlockManagerQuery, EventHotelRoomBlocksRoomBlockManagerQueryVariables>) {
        return ApolloReactHooks.useQuery<EventHotelRoomBlocksRoomBlockManagerQuery, EventHotelRoomBlocksRoomBlockManagerQueryVariables>(EventHotelRoomBlocksRoomBlockManagerDocument, baseOptions);
      }
export function useEventHotelRoomBlocksRoomBlockManagerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventHotelRoomBlocksRoomBlockManagerQuery, EventHotelRoomBlocksRoomBlockManagerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventHotelRoomBlocksRoomBlockManagerQuery, EventHotelRoomBlocksRoomBlockManagerQueryVariables>(EventHotelRoomBlocksRoomBlockManagerDocument, baseOptions);
        }
export type EventHotelRoomBlocksRoomBlockManagerQueryHookResult = ReturnType<typeof useEventHotelRoomBlocksRoomBlockManagerQuery>;
export type EventHotelRoomBlocksRoomBlockManagerLazyQueryHookResult = ReturnType<typeof useEventHotelRoomBlocksRoomBlockManagerLazyQuery>;
export type EventHotelRoomBlocksRoomBlockManagerQueryResult = Apollo.QueryResult<EventHotelRoomBlocksRoomBlockManagerQuery, EventHotelRoomBlocksRoomBlockManagerQueryVariables>;
export const WebsiteInfoDocument = gql`
    query WebsiteInfo($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    photoV2Url
    photo {
      id
      url
    }
    eventDesign(purpose: $purpose) {
      id
      websiteLayout {
        id
        layoutType
      }
    }
    liveEventDesign: eventDesign(purpose: live) {
      id
      theme {
        id
        themeId
      }
      websiteLayout {
        id
        layoutType
      }
      activeWebsiteHeaderPresentationLayout {
        id: eventId
        schemaURL
        websiteLayout
        dataJSON
      }
      brannanNavigation
    }
    info(admin: true) {
      id
      eventPassword
      safetyRating
      announcementBanner {
        title
        message
        active
      }
      schedule {
        items {
          id
          name
          startTime {
            timestamp
            timezone
          }
          isMain
        }
      }
      finalizedDate {
        timezone
        milliseconds
        dateString
      }
    }
    pages(admin: true) {
      ...PageDetails
    }
    firebaseId
    hasMobilePhoto
    photoV2UrlMobile
    mobilePhoto {
      id
      container
      url
    }
    pageContainers {
      id
      mainPhotoAlignment {
        x
        y
      }
      ...CustomPagePhotoPresentationInfo
    }
    websiteState
  }
  me {
    id
    emailIsVerified(liveQuery: true)
  }
}
    ${PageDetailsFragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}`;

/**
 * __useWebsiteInfoQuery__
 *
 * To run a query within a React component, call `useWebsiteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteInfoQuery, WebsiteInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<WebsiteInfoQuery, WebsiteInfoQueryVariables>(WebsiteInfoDocument, baseOptions);
      }
export function useWebsiteInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteInfoQuery, WebsiteInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WebsiteInfoQuery, WebsiteInfoQueryVariables>(WebsiteInfoDocument, baseOptions);
        }
export type WebsiteInfoQueryHookResult = ReturnType<typeof useWebsiteInfoQuery>;
export type WebsiteInfoLazyQueryHookResult = ReturnType<typeof useWebsiteInfoLazyQuery>;
export type WebsiteInfoQueryResult = Apollo.QueryResult<WebsiteInfoQuery, WebsiteInfoQueryVariables>;
export const UpdateEventSettingsDocument = gql`
    mutation UpdateEventSettings($eventId: ID!, $payload: UpdateEventSettingsPayload!) {
  updateEventSettings(eventId: $eventId, payload: $payload) {
    id
    requirePasswordForEventDate
    requirePasswordForEventLocation
    hideDownloadAppPage
    hideEventCountdown
    hideFromJoySearch
    hideFromSearchEngines
  }
}
    `;
export type UpdateEventSettingsMutationFn = Apollo.MutationFunction<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>;

/**
 * __useUpdateEventSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEventSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSettingsMutation, { data, loading, error }] = useUpdateEventSettingsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>(UpdateEventSettingsDocument, baseOptions);
      }
export type UpdateEventSettingsMutationHookResult = ReturnType<typeof useUpdateEventSettingsMutation>;
export type UpdateEventSettingsMutationResult = Apollo.MutationResult<UpdateEventSettingsMutation>;
export type UpdateEventSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>;
export const ReorderEventPagesDocument = gql`
    mutation ReorderEventPages($eventId: ID!, $payload: [ModelReorderPayload!]!) {
  reorderEventPages(eventId: $eventId, payloads: $payload) {
    ...PageDetails
  }
}
    ${PageDetailsFragmentDoc}`;
export type ReorderEventPagesMutationFn = Apollo.MutationFunction<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>;

/**
 * __useReorderEventPagesMutation__
 *
 * To run a mutation, you first call `useReorderEventPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEventPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEventPagesMutation, { data, loading, error }] = useReorderEventPagesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useReorderEventPagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>) {
        return ApolloReactHooks.useMutation<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>(ReorderEventPagesDocument, baseOptions);
      }
export type ReorderEventPagesMutationHookResult = ReturnType<typeof useReorderEventPagesMutation>;
export type ReorderEventPagesMutationResult = Apollo.MutationResult<ReorderEventPagesMutation>;
export type ReorderEventPagesMutationOptions = Apollo.BaseMutationOptions<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>;
export const BatchUpdateEventPagesVisibilityDocument = gql`
    mutation BatchUpdateEventPagesVisibility($eventId: ID!, $payloads: [BatchUpdateEventPagesPayload!]!) {
  batchUpdateEventPages(eventId: $eventId, payloads: $payloads) {
    id
    visibility
    type
    pageTitle
  }
}
    `;
export type BatchUpdateEventPagesVisibilityMutationFn = Apollo.MutationFunction<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>;

/**
 * __useBatchUpdateEventPagesVisibilityMutation__
 *
 * To run a mutation, you first call `useBatchUpdateEventPagesVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateEventPagesVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateEventPagesVisibilityMutation, { data, loading, error }] = useBatchUpdateEventPagesVisibilityMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payloads: // value for 'payloads'
 *   },
 * });
 */
export function useBatchUpdateEventPagesVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>) {
        return ApolloReactHooks.useMutation<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>(BatchUpdateEventPagesVisibilityDocument, baseOptions);
      }
export type BatchUpdateEventPagesVisibilityMutationHookResult = ReturnType<typeof useBatchUpdateEventPagesVisibilityMutation>;
export type BatchUpdateEventPagesVisibilityMutationResult = Apollo.MutationResult<BatchUpdateEventPagesVisibilityMutation>;
export type BatchUpdateEventPagesVisibilityMutationOptions = Apollo.BaseMutationOptions<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>;
export const UpdateEventInfoSettingsDocument = gql`
    mutation UpdateEventInfoSettings($eventId: ID!, $payload: UpdateEventInfoPayload!) {
  updateEventInfo(eventId: $eventId, payload: $payload) {
    id
    announcementBanner {
      active
      message
      title
    }
    fianceeFirstName
    fianceeLastName
    eventDisplayName
    ownerFirstName
    ownerLastName
    eventDateIsFinalized
    timezone
    locale
    tentativeDate {
      timezone
      milliseconds
      dateString
    }
    finalizedDate {
      timezone
      milliseconds
      dateString
    }
    locationInfo {
      id
      placeId
      name
      latitude
      longitude
      state
      city
      country
    }
  }
}
    `;
export type UpdateEventInfoSettingsMutationFn = Apollo.MutationFunction<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>;

/**
 * __useUpdateEventInfoSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEventInfoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventInfoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventInfoSettingsMutation, { data, loading, error }] = useUpdateEventInfoSettingsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventInfoSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>(UpdateEventInfoSettingsDocument, baseOptions);
      }
export type UpdateEventInfoSettingsMutationHookResult = ReturnType<typeof useUpdateEventInfoSettingsMutation>;
export type UpdateEventInfoSettingsMutationResult = Apollo.MutationResult<UpdateEventInfoSettingsMutation>;
export type UpdateEventInfoSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>;
export const GeneralSettingsInfoDocument = gql`
    query GeneralSettingsInfo($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    domain {
      id
      domainName
    }
    info(admin: true) {
      id
      fianceeFirstName
      fianceeLastName
      ownerFirstName
      ownerLastName
      eventDisplayName
      eventDateIsFinalized
      timezone
      locale
      finalizedDate {
        timezone
        milliseconds
        dateString
      }
      tentativeDate {
        timezone
        milliseconds
        dateString
      }
      locationInfo {
        id
        placeId
        name
        latitude
        longitude
        state
        city
        country
      }
    }
  }
}
    `;

/**
 * __useGeneralSettingsInfoQuery__
 *
 * To run a query within a React component, call `useGeneralSettingsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSettingsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSettingsInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGeneralSettingsInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>(GeneralSettingsInfoDocument, baseOptions);
      }
export function useGeneralSettingsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>(GeneralSettingsInfoDocument, baseOptions);
        }
export type GeneralSettingsInfoQueryHookResult = ReturnType<typeof useGeneralSettingsInfoQuery>;
export type GeneralSettingsInfoLazyQueryHookResult = ReturnType<typeof useGeneralSettingsInfoLazyQuery>;
export type GeneralSettingsInfoQueryResult = Apollo.QueryResult<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>;
export const SetEventAssetDocument = gql`
    mutation SetEventAsset($setEventAssetId: ID!, $payload: SetAssetPayload!, $isMobile: Boolean) {
  setEventAsset(id: $setEventAssetId, payload: $payload, isMobile: $isMobile) {
    id
    hasMobilePhoto
    mobilePhoto {
      id
      url
      container
    }
  }
}
    `;
export type SetEventAssetMutationFn = Apollo.MutationFunction<SetEventAssetMutation, SetEventAssetMutationVariables>;

/**
 * __useSetEventAssetMutation__
 *
 * To run a mutation, you first call `useSetEventAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventAssetMutation, { data, loading, error }] = useSetEventAssetMutation({
 *   variables: {
 *      setEventAssetId: // value for 'setEventAssetId'
 *      payload: // value for 'payload'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useSetEventAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventAssetMutation, SetEventAssetMutationVariables>) {
        return ApolloReactHooks.useMutation<SetEventAssetMutation, SetEventAssetMutationVariables>(SetEventAssetDocument, baseOptions);
      }
export type SetEventAssetMutationHookResult = ReturnType<typeof useSetEventAssetMutation>;
export type SetEventAssetMutationResult = Apollo.MutationResult<SetEventAssetMutation>;
export type SetEventAssetMutationOptions = Apollo.BaseMutationOptions<SetEventAssetMutation, SetEventAssetMutationVariables>;
export const DeleteEventAssetDocument = gql`
    mutation DeleteEventAsset($deleteEventAssetId: ID!, $isMobile: Boolean) {
  deleteEventAsset(id: $deleteEventAssetId, isMobile: $isMobile) {
    id
    hasMobilePhoto
    mobilePhoto {
      id
      url
      container
    }
  }
}
    `;
export type DeleteEventAssetMutationFn = Apollo.MutationFunction<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>;

/**
 * __useDeleteEventAssetMutation__
 *
 * To run a mutation, you first call `useDeleteEventAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAssetMutation, { data, loading, error }] = useDeleteEventAssetMutation({
 *   variables: {
 *      deleteEventAssetId: // value for 'deleteEventAssetId'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useDeleteEventAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>(DeleteEventAssetDocument, baseOptions);
      }
export type DeleteEventAssetMutationHookResult = ReturnType<typeof useDeleteEventAssetMutation>;
export type DeleteEventAssetMutationResult = Apollo.MutationResult<DeleteEventAssetMutation>;
export type DeleteEventAssetMutationOptions = Apollo.BaseMutationOptions<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>;
export const UpdateMainEventScheduleDocument = gql`
    mutation UpdateMainEventSchedule($eventId: ID!, $eventInfoPayload: UpdateEventInfoPayload!, $scheduleId: ID!, $updateSettings: Boolean!, $eventSettingsPayload: UpdateEventSettingsPayload!) {
  updateEventInfo(eventId: $eventId, payload: $eventInfoPayload) {
    id
    eventDateIsFinalized
    tentativeDate {
      milliseconds
      timezone
      dateString
    }
    finalizedDate {
      timezone
      milliseconds
      dateString
    }
  }
  setMainEventSchedule(scheduleId: $scheduleId) {
    id
    name
  }
  updateEventSettings(eventId: $eventId, payload: $eventSettingsPayload) @include(if: $updateSettings) {
    id
    hideEventCountdown
  }
}
    `;
export type UpdateMainEventScheduleMutationFn = Apollo.MutationFunction<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>;

/**
 * __useUpdateMainEventScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateMainEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainEventScheduleMutation, { data, loading, error }] = useUpdateMainEventScheduleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventInfoPayload: // value for 'eventInfoPayload'
 *      scheduleId: // value for 'scheduleId'
 *      updateSettings: // value for 'updateSettings'
 *      eventSettingsPayload: // value for 'eventSettingsPayload'
 *   },
 * });
 */
export function useUpdateMainEventScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>(UpdateMainEventScheduleDocument, baseOptions);
      }
export type UpdateMainEventScheduleMutationHookResult = ReturnType<typeof useUpdateMainEventScheduleMutation>;
export type UpdateMainEventScheduleMutationResult = Apollo.MutationResult<UpdateMainEventScheduleMutation>;
export type UpdateMainEventScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>;
export const UpdateEventDateDocument = gql`
    mutation UpdateEventDate($eventId: ID!, $payload: UpdateEventInfoPayload!) {
  updateEventInfo(eventId: $eventId, payload: $payload) {
    id
    eventDateIsFinalized
    timezone
    tentativeDate {
      timezone
      milliseconds
      dateString
    }
    finalizedDate {
      timezone
      milliseconds
      dateString
      timeString: dateString(timeFormat: time)
    }
  }
  unsetMainEventSchedule(eventId: $eventId) {
    id
  }
}
    `;
export type UpdateEventDateMutationFn = Apollo.MutationFunction<UpdateEventDateMutation, UpdateEventDateMutationVariables>;

/**
 * __useUpdateEventDateMutation__
 *
 * To run a mutation, you first call `useUpdateEventDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDateMutation, { data, loading, error }] = useUpdateEventDateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDateMutation, UpdateEventDateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventDateMutation, UpdateEventDateMutationVariables>(UpdateEventDateDocument, baseOptions);
      }
export type UpdateEventDateMutationHookResult = ReturnType<typeof useUpdateEventDateMutation>;
export type UpdateEventDateMutationResult = Apollo.MutationResult<UpdateEventDateMutation>;
export type UpdateEventDateMutationOptions = Apollo.BaseMutationOptions<UpdateEventDateMutation, UpdateEventDateMutationVariables>;
export const SettingsPageContainerBySlugDocument = gql`
    query SettingsPageContainerBySlug($eventName: String!, $pageSlug: String!) {
  pageContainerBySlug(payload: {eventName: $eventName, pageSlug: $pageSlug}, options: {admin: true}) {
    id
    components {
      ...TravelSettingsMapComponent
    }
  }
  eventByName(name: $eventName) {
    id
    travelSettings {
      currencyCode
      checkInDate
      checkOutDate
      datesMatchingReminder
    }
  }
}
    ${TravelSettingsMapComponentFragmentDoc}`;

/**
 * __useSettingsPageContainerBySlugQuery__
 *
 * To run a query within a React component, call `useSettingsPageContainerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageContainerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageContainerBySlugQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      pageSlug: // value for 'pageSlug'
 *   },
 * });
 */
export function useSettingsPageContainerBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>(SettingsPageContainerBySlugDocument, baseOptions);
      }
export function useSettingsPageContainerBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>(SettingsPageContainerBySlugDocument, baseOptions);
        }
export type SettingsPageContainerBySlugQueryHookResult = ReturnType<typeof useSettingsPageContainerBySlugQuery>;
export type SettingsPageContainerBySlugLazyQueryHookResult = ReturnType<typeof useSettingsPageContainerBySlugLazyQuery>;
export type SettingsPageContainerBySlugQueryResult = Apollo.QueryResult<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>;
export const SetEventPhotoV2UrlMobileDocument = gql`
    mutation SetEventPhotoV2UrlMobile($payload: SetEventPhotoV2MobilePayload!) {
  setEventPhotoV2UrlMobile(payload: $payload) {
    id
    photoV2UrlMobile
  }
}
    `;
export type SetEventPhotoV2UrlMobileMutationFn = Apollo.MutationFunction<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>;

/**
 * __useSetEventPhotoV2UrlMobileMutation__
 *
 * To run a mutation, you first call `useSetEventPhotoV2UrlMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPhotoV2UrlMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPhotoV2UrlMobileMutation, { data, loading, error }] = useSetEventPhotoV2UrlMobileMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPhotoV2UrlMobileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>) {
        return ApolloReactHooks.useMutation<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>(SetEventPhotoV2UrlMobileDocument, baseOptions);
      }
export type SetEventPhotoV2UrlMobileMutationHookResult = ReturnType<typeof useSetEventPhotoV2UrlMobileMutation>;
export type SetEventPhotoV2UrlMobileMutationResult = Apollo.MutationResult<SetEventPhotoV2UrlMobileMutation>;
export type SetEventPhotoV2UrlMobileMutationOptions = Apollo.BaseMutationOptions<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>;
export const SettingsUsersV2EventUsersDocument = gql`
    query SettingsUsersV2EventUsers($name: String!) {
  eventByName(name: $name) {
    id
    eventUsers {
      ...UsersV2User
    }
  }
}
    ${UsersV2UserFragmentDoc}`;

/**
 * __useSettingsUsersV2EventUsersQuery__
 *
 * To run a query within a React component, call `useSettingsUsersV2EventUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2EventUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsUsersV2EventUsersQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSettingsUsersV2EventUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingsUsersV2EventUsersQuery, SettingsUsersV2EventUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingsUsersV2EventUsersQuery, SettingsUsersV2EventUsersQueryVariables>(SettingsUsersV2EventUsersDocument, baseOptions);
      }
export function useSettingsUsersV2EventUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingsUsersV2EventUsersQuery, SettingsUsersV2EventUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingsUsersV2EventUsersQuery, SettingsUsersV2EventUsersQueryVariables>(SettingsUsersV2EventUsersDocument, baseOptions);
        }
export type SettingsUsersV2EventUsersQueryHookResult = ReturnType<typeof useSettingsUsersV2EventUsersQuery>;
export type SettingsUsersV2EventUsersLazyQueryHookResult = ReturnType<typeof useSettingsUsersV2EventUsersLazyQuery>;
export type SettingsUsersV2EventUsersQueryResult = Apollo.QueryResult<SettingsUsersV2EventUsersQuery, SettingsUsersV2EventUsersQueryVariables>;
export const SettingsUsersV2PendingInvitesDocument = gql`
    query SettingsUsersV2PendingInvites($name: String!) {
  getPendingCollaborationInvitesByEventHandle(eventHandle: $name) {
    ...UsersV2PendingInvite
  }
}
    ${UsersV2PendingInviteFragmentDoc}`;

/**
 * __useSettingsUsersV2PendingInvitesQuery__
 *
 * To run a query within a React component, call `useSettingsUsersV2PendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2PendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsUsersV2PendingInvitesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSettingsUsersV2PendingInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingsUsersV2PendingInvitesQuery, SettingsUsersV2PendingInvitesQueryVariables>) {
        return ApolloReactHooks.useQuery<SettingsUsersV2PendingInvitesQuery, SettingsUsersV2PendingInvitesQueryVariables>(SettingsUsersV2PendingInvitesDocument, baseOptions);
      }
export function useSettingsUsersV2PendingInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingsUsersV2PendingInvitesQuery, SettingsUsersV2PendingInvitesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SettingsUsersV2PendingInvitesQuery, SettingsUsersV2PendingInvitesQueryVariables>(SettingsUsersV2PendingInvitesDocument, baseOptions);
        }
export type SettingsUsersV2PendingInvitesQueryHookResult = ReturnType<typeof useSettingsUsersV2PendingInvitesQuery>;
export type SettingsUsersV2PendingInvitesLazyQueryHookResult = ReturnType<typeof useSettingsUsersV2PendingInvitesLazyQuery>;
export type SettingsUsersV2PendingInvitesQueryResult = Apollo.QueryResult<SettingsUsersV2PendingInvitesQuery, SettingsUsersV2PendingInvitesQueryVariables>;
export const SettingsUsersV2SendInviteDocument = gql`
    mutation SettingsUsersV2SendInvite($eventId: ID!, $firstName: String!, $lastName: String!, $email: String!) {
  sendCollaborationInvite(eventId: $eventId, inviteeFirstName: $firstName, inviteeLastName: $lastName, inviteeEmailAddress: $email) {
    ...UsersV2PendingInvite
  }
}
    ${UsersV2PendingInviteFragmentDoc}`;
export type SettingsUsersV2SendInviteMutationFn = Apollo.MutationFunction<SettingsUsersV2SendInviteMutation, SettingsUsersV2SendInviteMutationVariables>;

/**
 * __useSettingsUsersV2SendInviteMutation__
 *
 * To run a mutation, you first call `useSettingsUsersV2SendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2SendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsUsersV2SendInviteMutation, { data, loading, error }] = useSettingsUsersV2SendInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSettingsUsersV2SendInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SettingsUsersV2SendInviteMutation, SettingsUsersV2SendInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<SettingsUsersV2SendInviteMutation, SettingsUsersV2SendInviteMutationVariables>(SettingsUsersV2SendInviteDocument, baseOptions);
      }
export type SettingsUsersV2SendInviteMutationHookResult = ReturnType<typeof useSettingsUsersV2SendInviteMutation>;
export type SettingsUsersV2SendInviteMutationResult = Apollo.MutationResult<SettingsUsersV2SendInviteMutation>;
export type SettingsUsersV2SendInviteMutationOptions = Apollo.BaseMutationOptions<SettingsUsersV2SendInviteMutation, SettingsUsersV2SendInviteMutationVariables>;
export const SettingsUsersV2ResendInviteDocument = gql`
    mutation SettingsUsersV2ResendInvite($id: ID!) {
  resendCollaborationInvite(id: $id) {
    ...UsersV2PendingInvite
  }
}
    ${UsersV2PendingInviteFragmentDoc}`;
export type SettingsUsersV2ResendInviteMutationFn = Apollo.MutationFunction<SettingsUsersV2ResendInviteMutation, SettingsUsersV2ResendInviteMutationVariables>;

/**
 * __useSettingsUsersV2ResendInviteMutation__
 *
 * To run a mutation, you first call `useSettingsUsersV2ResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2ResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsUsersV2ResendInviteMutation, { data, loading, error }] = useSettingsUsersV2ResendInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettingsUsersV2ResendInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SettingsUsersV2ResendInviteMutation, SettingsUsersV2ResendInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<SettingsUsersV2ResendInviteMutation, SettingsUsersV2ResendInviteMutationVariables>(SettingsUsersV2ResendInviteDocument, baseOptions);
      }
export type SettingsUsersV2ResendInviteMutationHookResult = ReturnType<typeof useSettingsUsersV2ResendInviteMutation>;
export type SettingsUsersV2ResendInviteMutationResult = Apollo.MutationResult<SettingsUsersV2ResendInviteMutation>;
export type SettingsUsersV2ResendInviteMutationOptions = Apollo.BaseMutationOptions<SettingsUsersV2ResendInviteMutation, SettingsUsersV2ResendInviteMutationVariables>;
export const SettingsUsersV2RevokeInviteDocument = gql`
    mutation SettingsUsersV2RevokeInvite($id: ID!) {
  revokeCollaborationInvite(id: $id)
}
    `;
export type SettingsUsersV2RevokeInviteMutationFn = Apollo.MutationFunction<SettingsUsersV2RevokeInviteMutation, SettingsUsersV2RevokeInviteMutationVariables>;

/**
 * __useSettingsUsersV2RevokeInviteMutation__
 *
 * To run a mutation, you first call `useSettingsUsersV2RevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2RevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsUsersV2RevokeInviteMutation, { data, loading, error }] = useSettingsUsersV2RevokeInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettingsUsersV2RevokeInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SettingsUsersV2RevokeInviteMutation, SettingsUsersV2RevokeInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<SettingsUsersV2RevokeInviteMutation, SettingsUsersV2RevokeInviteMutationVariables>(SettingsUsersV2RevokeInviteDocument, baseOptions);
      }
export type SettingsUsersV2RevokeInviteMutationHookResult = ReturnType<typeof useSettingsUsersV2RevokeInviteMutation>;
export type SettingsUsersV2RevokeInviteMutationResult = Apollo.MutationResult<SettingsUsersV2RevokeInviteMutation>;
export type SettingsUsersV2RevokeInviteMutationOptions = Apollo.BaseMutationOptions<SettingsUsersV2RevokeInviteMutation, SettingsUsersV2RevokeInviteMutationVariables>;
export const SetttingsUsersV2RevokeAccessDocument = gql`
    mutation SetttingsUsersV2RevokeAccess($eventId: ID!, $eventUserId: ID!) {
  revokeCollaboratorAdminPermissions(eventId: $eventId, eventUserId: $eventUserId)
}
    `;
export type SetttingsUsersV2RevokeAccessMutationFn = Apollo.MutationFunction<SetttingsUsersV2RevokeAccessMutation, SetttingsUsersV2RevokeAccessMutationVariables>;

/**
 * __useSetttingsUsersV2RevokeAccessMutation__
 *
 * To run a mutation, you first call `useSetttingsUsersV2RevokeAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetttingsUsersV2RevokeAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setttingsUsersV2RevokeAccessMutation, { data, loading, error }] = useSetttingsUsersV2RevokeAccessMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventUserId: // value for 'eventUserId'
 *   },
 * });
 */
export function useSetttingsUsersV2RevokeAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetttingsUsersV2RevokeAccessMutation, SetttingsUsersV2RevokeAccessMutationVariables>) {
        return ApolloReactHooks.useMutation<SetttingsUsersV2RevokeAccessMutation, SetttingsUsersV2RevokeAccessMutationVariables>(SetttingsUsersV2RevokeAccessDocument, baseOptions);
      }
export type SetttingsUsersV2RevokeAccessMutationHookResult = ReturnType<typeof useSetttingsUsersV2RevokeAccessMutation>;
export type SetttingsUsersV2RevokeAccessMutationResult = Apollo.MutationResult<SetttingsUsersV2RevokeAccessMutation>;
export type SetttingsUsersV2RevokeAccessMutationOptions = Apollo.BaseMutationOptions<SetttingsUsersV2RevokeAccessMutation, SetttingsUsersV2RevokeAccessMutationVariables>;
export const SettingsUsersV2TransferEventOwnershipDocument = gql`
    mutation SettingsUsersV2TransferEventOwnership($eventId: ID!, $newOwnerEventUserId: ID!) {
  transferEventOwnershipV2(eventId: $eventId, newOwnerEventUserId: $newOwnerEventUserId) {
    id
    auth0Id
    status
  }
}
    `;
export type SettingsUsersV2TransferEventOwnershipMutationFn = Apollo.MutationFunction<SettingsUsersV2TransferEventOwnershipMutation, SettingsUsersV2TransferEventOwnershipMutationVariables>;

/**
 * __useSettingsUsersV2TransferEventOwnershipMutation__
 *
 * To run a mutation, you first call `useSettingsUsersV2TransferEventOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsUsersV2TransferEventOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsUsersV2TransferEventOwnershipMutation, { data, loading, error }] = useSettingsUsersV2TransferEventOwnershipMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      newOwnerEventUserId: // value for 'newOwnerEventUserId'
 *   },
 * });
 */
export function useSettingsUsersV2TransferEventOwnershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SettingsUsersV2TransferEventOwnershipMutation, SettingsUsersV2TransferEventOwnershipMutationVariables>) {
        return ApolloReactHooks.useMutation<SettingsUsersV2TransferEventOwnershipMutation, SettingsUsersV2TransferEventOwnershipMutationVariables>(SettingsUsersV2TransferEventOwnershipDocument, baseOptions);
      }
export type SettingsUsersV2TransferEventOwnershipMutationHookResult = ReturnType<typeof useSettingsUsersV2TransferEventOwnershipMutation>;
export type SettingsUsersV2TransferEventOwnershipMutationResult = Apollo.MutationResult<SettingsUsersV2TransferEventOwnershipMutation>;
export type SettingsUsersV2TransferEventOwnershipMutationOptions = Apollo.BaseMutationOptions<SettingsUsersV2TransferEventOwnershipMutation, SettingsUsersV2TransferEventOwnershipMutationVariables>;
export const CreateEventDesignDocument = gql`
    mutation CreateEventDesign($payload: CreateEventDesignPayload!) {
  createEventDesign(payload: $payload) {
    purpose
    id
  }
}
    `;
export type CreateEventDesignMutationFn = Apollo.MutationFunction<CreateEventDesignMutation, CreateEventDesignMutationVariables>;

/**
 * __useCreateEventDesignMutation__
 *
 * To run a mutation, you first call `useCreateEventDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventDesignMutation, { data, loading, error }] = useCreateEventDesignMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEventDesignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventDesignMutation, CreateEventDesignMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEventDesignMutation, CreateEventDesignMutationVariables>(CreateEventDesignDocument, baseOptions);
      }
export type CreateEventDesignMutationHookResult = ReturnType<typeof useCreateEventDesignMutation>;
export type CreateEventDesignMutationResult = Apollo.MutationResult<CreateEventDesignMutation>;
export type CreateEventDesignMutationOptions = Apollo.BaseMutationOptions<CreateEventDesignMutation, CreateEventDesignMutationVariables>;
export const DesignFavoriteDocument = gql`
    query DesignFavorite($eventId: ID!, $type: FavoriteType) {
  event(id: $eventId) {
    id
    designFavorite(type: $type) {
      id
      resource {
        ... on Font {
          id
        }
        ... on Theme {
          id
          themeId
        }
        ... on DesignLayout {
          id
        }
      }
      secondaryResource {
        ... on Font {
          id
        }
        ... on Theme {
          id
          themeId
        }
        ... on DesignLayout {
          id
          layoutType
        }
      }
    }
  }
}
    `;

/**
 * __useDesignFavoriteQuery__
 *
 * To run a query within a React component, call `useDesignFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignFavoriteQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDesignFavoriteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DesignFavoriteQuery, DesignFavoriteQueryVariables>) {
        return ApolloReactHooks.useQuery<DesignFavoriteQuery, DesignFavoriteQueryVariables>(DesignFavoriteDocument, baseOptions);
      }
export function useDesignFavoriteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignFavoriteQuery, DesignFavoriteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DesignFavoriteQuery, DesignFavoriteQueryVariables>(DesignFavoriteDocument, baseOptions);
        }
export type DesignFavoriteQueryHookResult = ReturnType<typeof useDesignFavoriteQuery>;
export type DesignFavoriteLazyQueryHookResult = ReturnType<typeof useDesignFavoriteLazyQuery>;
export type DesignFavoriteQueryResult = Apollo.QueryResult<DesignFavoriteQuery, DesignFavoriteQueryVariables>;
export const ToggleDesignFavoritesDocument = gql`
    mutation ToggleDesignFavorites($payload: [ToggleDesignFavoriteInput!]!) {
  toggleDesignFavorites(payload: $payload) {
    id
  }
}
    `;
export type ToggleDesignFavoritesMutationFn = Apollo.MutationFunction<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>;

/**
 * __useToggleDesignFavoritesMutation__
 *
 * To run a mutation, you first call `useToggleDesignFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDesignFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDesignFavoritesMutation, { data, loading, error }] = useToggleDesignFavoritesMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useToggleDesignFavoritesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>(ToggleDesignFavoritesDocument, baseOptions);
      }
export type ToggleDesignFavoritesMutationHookResult = ReturnType<typeof useToggleDesignFavoritesMutation>;
export type ToggleDesignFavoritesMutationResult = Apollo.MutationResult<ToggleDesignFavoritesMutation>;
export type ToggleDesignFavoritesMutationOptions = Apollo.BaseMutationOptions<ToggleDesignFavoritesMutation, ToggleDesignFavoritesMutationVariables>;
export const CreatePaletteColorDocument = gql`
    mutation CreatePaletteColor($payload: CreateColorPayload!) {
  createPaletteColor(payload: $payload) {
    id
    color {
      hex
    }
  }
}
    `;
export type CreatePaletteColorMutationFn = Apollo.MutationFunction<CreatePaletteColorMutation, CreatePaletteColorMutationVariables>;

/**
 * __useCreatePaletteColorMutation__
 *
 * To run a mutation, you first call `useCreatePaletteColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaletteColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaletteColorMutation, { data, loading, error }] = useCreatePaletteColorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePaletteColorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaletteColorMutation, CreatePaletteColorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePaletteColorMutation, CreatePaletteColorMutationVariables>(CreatePaletteColorDocument, baseOptions);
      }
export type CreatePaletteColorMutationHookResult = ReturnType<typeof useCreatePaletteColorMutation>;
export type CreatePaletteColorMutationResult = Apollo.MutationResult<CreatePaletteColorMutation>;
export type CreatePaletteColorMutationOptions = Apollo.BaseMutationOptions<CreatePaletteColorMutation, CreatePaletteColorMutationVariables>;
export const CreateArtBackgroundAndPageColorsDocument = gql`
    mutation CreateArtBackgroundAndPageColors($artBackgroundPayload: CreateColorPayload!, $pageColorPayload: CreateColorPayload!, $pageFontColorPayload: CreateColorPayload!) {
  createArtBackgroundColor: createPaletteColor(payload: $artBackgroundPayload) {
    id
    color {
      hex
    }
  }
  createPageColor: createPaletteColor(payload: $pageColorPayload) {
    id
    color {
      hex
    }
  }
  createPageFontColor: createPaletteColor(payload: $pageFontColorPayload) {
    id
    color {
      hex
    }
  }
}
    `;
export type CreateArtBackgroundAndPageColorsMutationFn = Apollo.MutationFunction<CreateArtBackgroundAndPageColorsMutation, CreateArtBackgroundAndPageColorsMutationVariables>;

/**
 * __useCreateArtBackgroundAndPageColorsMutation__
 *
 * To run a mutation, you first call `useCreateArtBackgroundAndPageColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtBackgroundAndPageColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtBackgroundAndPageColorsMutation, { data, loading, error }] = useCreateArtBackgroundAndPageColorsMutation({
 *   variables: {
 *      artBackgroundPayload: // value for 'artBackgroundPayload'
 *      pageColorPayload: // value for 'pageColorPayload'
 *      pageFontColorPayload: // value for 'pageFontColorPayload'
 *   },
 * });
 */
export function useCreateArtBackgroundAndPageColorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtBackgroundAndPageColorsMutation, CreateArtBackgroundAndPageColorsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateArtBackgroundAndPageColorsMutation, CreateArtBackgroundAndPageColorsMutationVariables>(CreateArtBackgroundAndPageColorsDocument, baseOptions);
      }
export type CreateArtBackgroundAndPageColorsMutationHookResult = ReturnType<typeof useCreateArtBackgroundAndPageColorsMutation>;
export type CreateArtBackgroundAndPageColorsMutationResult = Apollo.MutationResult<CreateArtBackgroundAndPageColorsMutation>;
export type CreateArtBackgroundAndPageColorsMutationOptions = Apollo.BaseMutationOptions<CreateArtBackgroundAndPageColorsMutation, CreateArtBackgroundAndPageColorsMutationVariables>;
export const CreatePageColorsDocument = gql`
    mutation CreatePageColors($pageColorPayload: CreateColorPayload!, $pageFontColorPayload: CreateColorPayload!) {
  createPageColor: createPaletteColor(payload: $pageColorPayload) {
    id
    color {
      hex
    }
  }
  createPageFontColor: createPaletteColor(payload: $pageFontColorPayload) {
    id
    color {
      hex
    }
  }
}
    `;
export type CreatePageColorsMutationFn = Apollo.MutationFunction<CreatePageColorsMutation, CreatePageColorsMutationVariables>;

/**
 * __useCreatePageColorsMutation__
 *
 * To run a mutation, you first call `useCreatePageColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageColorsMutation, { data, loading, error }] = useCreatePageColorsMutation({
 *   variables: {
 *      pageColorPayload: // value for 'pageColorPayload'
 *      pageFontColorPayload: // value for 'pageFontColorPayload'
 *   },
 * });
 */
export function useCreatePageColorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePageColorsMutation, CreatePageColorsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePageColorsMutation, CreatePageColorsMutationVariables>(CreatePageColorsDocument, baseOptions);
      }
export type CreatePageColorsMutationHookResult = ReturnType<typeof useCreatePageColorsMutation>;
export type CreatePageColorsMutationResult = Apollo.MutationResult<CreatePageColorsMutation>;
export type CreatePageColorsMutationOptions = Apollo.BaseMutationOptions<CreatePageColorsMutation, CreatePageColorsMutationVariables>;
export const WebsiteApplyWebsiteColorsDocument = gql`
    mutation WebsiteApplyWebsiteColors($payload: ApplyWebsiteColorsPayload!) {
  applyWebsiteColors(payload: $payload) {
    id
    ...WebsiteEventColors
  }
}
    ${WebsiteEventColorsFragmentDoc}`;
export type WebsiteApplyWebsiteColorsMutationFn = Apollo.MutationFunction<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>;

/**
 * __useWebsiteApplyWebsiteColorsMutation__
 *
 * To run a mutation, you first call `useWebsiteApplyWebsiteColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteApplyWebsiteColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteApplyWebsiteColorsMutation, { data, loading, error }] = useWebsiteApplyWebsiteColorsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteApplyWebsiteColorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>(WebsiteApplyWebsiteColorsDocument, baseOptions);
      }
export type WebsiteApplyWebsiteColorsMutationHookResult = ReturnType<typeof useWebsiteApplyWebsiteColorsMutation>;
export type WebsiteApplyWebsiteColorsMutationResult = Apollo.MutationResult<WebsiteApplyWebsiteColorsMutation>;
export type WebsiteApplyWebsiteColorsMutationOptions = Apollo.BaseMutationOptions<WebsiteApplyWebsiteColorsMutation, WebsiteApplyWebsiteColorsMutationVariables>;
export const UpdateEventWebsiteStateDocument = gql`
    mutation UpdateEventWebsiteState($payload: EventSetWebsiteStatePayload!) {
  eventSetWebsiteState(payload: $payload) {
    id
    websiteState
  }
}
    `;
export type UpdateEventWebsiteStateMutationFn = Apollo.MutationFunction<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>;

/**
 * __useUpdateEventWebsiteStateMutation__
 *
 * To run a mutation, you first call `useUpdateEventWebsiteStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventWebsiteStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventWebsiteStateMutation, { data, loading, error }] = useUpdateEventWebsiteStateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventWebsiteStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>(UpdateEventWebsiteStateDocument, baseOptions);
      }
export type UpdateEventWebsiteStateMutationHookResult = ReturnType<typeof useUpdateEventWebsiteStateMutation>;
export type UpdateEventWebsiteStateMutationResult = Apollo.MutationResult<UpdateEventWebsiteStateMutation>;
export type UpdateEventWebsiteStateMutationOptions = Apollo.BaseMutationOptions<UpdateEventWebsiteStateMutation, UpdateEventWebsiteStateMutationVariables>;
export const EnableVideoBackgroundFeatureDocument = gql`
    mutation EnableVideoBackgroundFeature($eventId: ID!) {
  websiteEnableVideoBackgroundFeature(eventId: $eventId) {
    id
  }
}
    `;
export type EnableVideoBackgroundFeatureMutationFn = Apollo.MutationFunction<EnableVideoBackgroundFeatureMutation, EnableVideoBackgroundFeatureMutationVariables>;

/**
 * __useEnableVideoBackgroundFeatureMutation__
 *
 * To run a mutation, you first call `useEnableVideoBackgroundFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableVideoBackgroundFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableVideoBackgroundFeatureMutation, { data, loading, error }] = useEnableVideoBackgroundFeatureMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEnableVideoBackgroundFeatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableVideoBackgroundFeatureMutation, EnableVideoBackgroundFeatureMutationVariables>) {
        return ApolloReactHooks.useMutation<EnableVideoBackgroundFeatureMutation, EnableVideoBackgroundFeatureMutationVariables>(EnableVideoBackgroundFeatureDocument, baseOptions);
      }
export type EnableVideoBackgroundFeatureMutationHookResult = ReturnType<typeof useEnableVideoBackgroundFeatureMutation>;
export type EnableVideoBackgroundFeatureMutationResult = Apollo.MutationResult<EnableVideoBackgroundFeatureMutation>;
export type EnableVideoBackgroundFeatureMutationOptions = Apollo.BaseMutationOptions<EnableVideoBackgroundFeatureMutation, EnableVideoBackgroundFeatureMutationVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  themeVariants(variantTypes: [aloha, brannan]) {
    variationType
    imageUrl
    printUrl
    vendor
    tags
    colors
    font
    variantColor
    variantName
    variantThemeId
    theme {
      id
      name
      themeId
      designLayouts {
        id
        layoutType
      }
      colorSchemes {
        id
        colors {
          hex
        }
      }
      websiteLayoutBrannanSettings {
        brannanBackgroundTransparency {
          id
          featureName
          rangeValue
        }
        brannanInnerFrameBorder {
          id
          featureName
          booleanValue
        }
      }
    }
  }
  previews: themeVariants(variantTypes: [savethedate, invite]) {
    variationType
    imageUrl
    variantThemeId
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
      }
export function useGetTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const ThemesListStationeryTemplatesDocument = gql`
    query ThemesListStationeryTemplates($filter: StationeryTemplateFilter!) {
  stationeryTemplatesContainer(filter: $filter) {
    pagedResults {
      edges {
        node {
          id
          themeId
          category
          thumbnailUrl
        }
      }
    }
  }
}
    `;

/**
 * __useThemesListStationeryTemplatesQuery__
 *
 * To run a query within a React component, call `useThemesListStationeryTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemesListStationeryTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemesListStationeryTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useThemesListStationeryTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ThemesListStationeryTemplatesQuery, ThemesListStationeryTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<ThemesListStationeryTemplatesQuery, ThemesListStationeryTemplatesQueryVariables>(ThemesListStationeryTemplatesDocument, baseOptions);
      }
export function useThemesListStationeryTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ThemesListStationeryTemplatesQuery, ThemesListStationeryTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ThemesListStationeryTemplatesQuery, ThemesListStationeryTemplatesQueryVariables>(ThemesListStationeryTemplatesDocument, baseOptions);
        }
export type ThemesListStationeryTemplatesQueryHookResult = ReturnType<typeof useThemesListStationeryTemplatesQuery>;
export type ThemesListStationeryTemplatesLazyQueryHookResult = ReturnType<typeof useThemesListStationeryTemplatesLazyQuery>;
export type ThemesListStationeryTemplatesQueryResult = Apollo.QueryResult<ThemesListStationeryTemplatesQuery, ThemesListStationeryTemplatesQueryVariables>;
export const UploadCustomThemeAssetDocument = gql`
    mutation UploadCustomThemeAsset($payload: UploadCustomThemeAssetPayload!) {
  uploadCustomThemeAsset(payload: $payload) {
    id
    assetURL
  }
}
    `;
export type UploadCustomThemeAssetMutationFn = Apollo.MutationFunction<UploadCustomThemeAssetMutation, UploadCustomThemeAssetMutationVariables>;

/**
 * __useUploadCustomThemeAssetMutation__
 *
 * To run a mutation, you first call `useUploadCustomThemeAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomThemeAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomThemeAssetMutation, { data, loading, error }] = useUploadCustomThemeAssetMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadCustomThemeAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadCustomThemeAssetMutation, UploadCustomThemeAssetMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadCustomThemeAssetMutation, UploadCustomThemeAssetMutationVariables>(UploadCustomThemeAssetDocument, baseOptions);
      }
export type UploadCustomThemeAssetMutationHookResult = ReturnType<typeof useUploadCustomThemeAssetMutation>;
export type UploadCustomThemeAssetMutationResult = Apollo.MutationResult<UploadCustomThemeAssetMutation>;
export type UploadCustomThemeAssetMutationOptions = Apollo.BaseMutationOptions<UploadCustomThemeAssetMutation, UploadCustomThemeAssetMutationVariables>;
export const UpsertCustomThemeDocument = gql`
    mutation UpsertCustomTheme($payload: UpsertCustomThemePayload!) {
  upsertCustomTheme(payload: $payload) {
    id
    desktopThemeAsset {
      id
      assetURL
    }
    mobileThemeAsset {
      id
      assetURL
    }
  }
}
    `;
export type UpsertCustomThemeMutationFn = Apollo.MutationFunction<UpsertCustomThemeMutation, UpsertCustomThemeMutationVariables>;

/**
 * __useUpsertCustomThemeMutation__
 *
 * To run a mutation, you first call `useUpsertCustomThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomThemeMutation, { data, loading, error }] = useUpsertCustomThemeMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpsertCustomThemeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertCustomThemeMutation, UpsertCustomThemeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpsertCustomThemeMutation, UpsertCustomThemeMutationVariables>(UpsertCustomThemeDocument, baseOptions);
      }
export type UpsertCustomThemeMutationHookResult = ReturnType<typeof useUpsertCustomThemeMutation>;
export type UpsertCustomThemeMutationResult = Apollo.MutationResult<UpsertCustomThemeMutation>;
export type UpsertCustomThemeMutationOptions = Apollo.BaseMutationOptions<UpsertCustomThemeMutation, UpsertCustomThemeMutationVariables>;
export const CustomThemeAssetsByEventIdDocument = gql`
    query CustomThemeAssetsByEventId($eventId: ID!) {
  customThemeAssetsByEventId(eventId: $eventId) {
    id
    assetURL
  }
}
    `;

/**
 * __useCustomThemeAssetsByEventIdQuery__
 *
 * To run a query within a React component, call `useCustomThemeAssetsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomThemeAssetsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomThemeAssetsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCustomThemeAssetsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomThemeAssetsByEventIdQuery, CustomThemeAssetsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<CustomThemeAssetsByEventIdQuery, CustomThemeAssetsByEventIdQueryVariables>(CustomThemeAssetsByEventIdDocument, baseOptions);
      }
export function useCustomThemeAssetsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomThemeAssetsByEventIdQuery, CustomThemeAssetsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CustomThemeAssetsByEventIdQuery, CustomThemeAssetsByEventIdQueryVariables>(CustomThemeAssetsByEventIdDocument, baseOptions);
        }
export type CustomThemeAssetsByEventIdQueryHookResult = ReturnType<typeof useCustomThemeAssetsByEventIdQuery>;
export type CustomThemeAssetsByEventIdLazyQueryHookResult = ReturnType<typeof useCustomThemeAssetsByEventIdLazyQuery>;
export type CustomThemeAssetsByEventIdQueryResult = Apollo.QueryResult<CustomThemeAssetsByEventIdQuery, CustomThemeAssetsByEventIdQueryVariables>;
export const GetWebsiteHeaderInfoDocument = gql`
    query GetWebsiteHeaderInfo($name: String!) {
  eventByName(name: $name) {
    id
    info {
      id
      eventDisplayName
      greeting
    }
  }
}
    `;

/**
 * __useGetWebsiteHeaderInfoQuery__
 *
 * To run a query within a React component, call `useGetWebsiteHeaderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteHeaderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteHeaderInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetWebsiteHeaderInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteHeaderInfoQuery, GetWebsiteHeaderInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsiteHeaderInfoQuery, GetWebsiteHeaderInfoQueryVariables>(GetWebsiteHeaderInfoDocument, baseOptions);
      }
export function useGetWebsiteHeaderInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteHeaderInfoQuery, GetWebsiteHeaderInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsiteHeaderInfoQuery, GetWebsiteHeaderInfoQueryVariables>(GetWebsiteHeaderInfoDocument, baseOptions);
        }
export type GetWebsiteHeaderInfoQueryHookResult = ReturnType<typeof useGetWebsiteHeaderInfoQuery>;
export type GetWebsiteHeaderInfoLazyQueryHookResult = ReturnType<typeof useGetWebsiteHeaderInfoLazyQuery>;
export type GetWebsiteHeaderInfoQueryResult = Apollo.QueryResult<GetWebsiteHeaderInfoQuery, GetWebsiteHeaderInfoQueryVariables>;
export const GetEventPhotoV2Document = gql`
    query GetEventPhotoV2($eventId: ID!) {
  event(id: $eventId) {
    id
    photoV2Url
    photo {
      id
      url
    }
    photoV2UrlMobile
    mobilePhoto {
      id
      url
    }
  }
}
    `;

/**
 * __useGetEventPhotoV2Query__
 *
 * To run a query within a React component, call `useGetEventPhotoV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPhotoV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPhotoV2Query({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventPhotoV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPhotoV2Query, GetEventPhotoV2QueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventPhotoV2Query, GetEventPhotoV2QueryVariables>(GetEventPhotoV2Document, baseOptions);
      }
export function useGetEventPhotoV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPhotoV2Query, GetEventPhotoV2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventPhotoV2Query, GetEventPhotoV2QueryVariables>(GetEventPhotoV2Document, baseOptions);
        }
export type GetEventPhotoV2QueryHookResult = ReturnType<typeof useGetEventPhotoV2Query>;
export type GetEventPhotoV2LazyQueryHookResult = ReturnType<typeof useGetEventPhotoV2LazyQuery>;
export type GetEventPhotoV2QueryResult = Apollo.QueryResult<GetEventPhotoV2Query, GetEventPhotoV2QueryVariables>;
export const SetEventPhotoV2UrlDocument = gql`
    mutation SetEventPhotoV2Url($payload: SetEventPhotoV2Payload!) {
  setEventPhotoV2Url(payload: $payload) {
    id
    photoV2Url
  }
}
    `;
export type SetEventPhotoV2UrlMutationFn = Apollo.MutationFunction<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>;

/**
 * __useSetEventPhotoV2UrlMutation__
 *
 * To run a mutation, you first call `useSetEventPhotoV2UrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPhotoV2UrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPhotoV2UrlMutation, { data, loading, error }] = useSetEventPhotoV2UrlMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPhotoV2UrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>) {
        return ApolloReactHooks.useMutation<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>(SetEventPhotoV2UrlDocument, baseOptions);
      }
export type SetEventPhotoV2UrlMutationHookResult = ReturnType<typeof useSetEventPhotoV2UrlMutation>;
export type SetEventPhotoV2UrlMutationResult = Apollo.MutationResult<SetEventPhotoV2UrlMutation>;
export type SetEventPhotoV2UrlMutationOptions = Apollo.BaseMutationOptions<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>;
export const WebsiteHeaderPresentationLayoutBySchemaDocument = gql`
    query WebsiteHeaderPresentationLayoutBySchema($payload: WebsiteHeaderPresentationLayoutBySchemaInput!) {
  websiteHeaderPresentationLayoutBySchema(payload: $payload) {
    id: eventId
    dataJSON
    schemaURL
    websiteLayout
  }
}
    `;

/**
 * __useWebsiteHeaderPresentationLayoutBySchemaQuery__
 *
 * To run a query within a React component, call `useWebsiteHeaderPresentationLayoutBySchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteHeaderPresentationLayoutBySchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteHeaderPresentationLayoutBySchemaQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteHeaderPresentationLayoutBySchemaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteHeaderPresentationLayoutBySchemaQuery, WebsiteHeaderPresentationLayoutBySchemaQueryVariables>) {
        return ApolloReactHooks.useQuery<WebsiteHeaderPresentationLayoutBySchemaQuery, WebsiteHeaderPresentationLayoutBySchemaQueryVariables>(WebsiteHeaderPresentationLayoutBySchemaDocument, baseOptions);
      }
export function useWebsiteHeaderPresentationLayoutBySchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteHeaderPresentationLayoutBySchemaQuery, WebsiteHeaderPresentationLayoutBySchemaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WebsiteHeaderPresentationLayoutBySchemaQuery, WebsiteHeaderPresentationLayoutBySchemaQueryVariables>(WebsiteHeaderPresentationLayoutBySchemaDocument, baseOptions);
        }
export type WebsiteHeaderPresentationLayoutBySchemaQueryHookResult = ReturnType<typeof useWebsiteHeaderPresentationLayoutBySchemaQuery>;
export type WebsiteHeaderPresentationLayoutBySchemaLazyQueryHookResult = ReturnType<typeof useWebsiteHeaderPresentationLayoutBySchemaLazyQuery>;
export type WebsiteHeaderPresentationLayoutBySchemaQueryResult = Apollo.QueryResult<WebsiteHeaderPresentationLayoutBySchemaQuery, WebsiteHeaderPresentationLayoutBySchemaQueryVariables>;
export const ActiveWebsiteHeaderPresentationLayoutDocument = gql`
    query ActiveWebsiteHeaderPresentationLayout($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    eventDesign(purpose: $purpose) {
      id
      activeWebsiteHeaderPresentationLayout {
        id: eventId
        schemaURL
        websiteLayout
        dataJSON
      }
    }
    welcomePageInfo: pageInfo(type: welcome) {
      id
      type
      page {
        id
        photoV2 {
          ... on Photo {
            id
            url
            height
            width
            layout {
              alignX
              alignY
            }
          }
          ... on DefaultPagePhoto {
            id
            url
            height
            width
            layout {
              alignX
              alignY
            }
          }
        }
        photoPresentation {
          id
          cropInfo {
            x
            y
            width
            height
            unit
          }
          presentationLayout
        }
      }
    }
  }
}
    `;

/**
 * __useActiveWebsiteHeaderPresentationLayoutQuery__
 *
 * To run a query within a React component, call `useActiveWebsiteHeaderPresentationLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveWebsiteHeaderPresentationLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveWebsiteHeaderPresentationLayoutQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useActiveWebsiteHeaderPresentationLayoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveWebsiteHeaderPresentationLayoutQuery, ActiveWebsiteHeaderPresentationLayoutQueryVariables>) {
        return ApolloReactHooks.useQuery<ActiveWebsiteHeaderPresentationLayoutQuery, ActiveWebsiteHeaderPresentationLayoutQueryVariables>(ActiveWebsiteHeaderPresentationLayoutDocument, baseOptions);
      }
export function useActiveWebsiteHeaderPresentationLayoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveWebsiteHeaderPresentationLayoutQuery, ActiveWebsiteHeaderPresentationLayoutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActiveWebsiteHeaderPresentationLayoutQuery, ActiveWebsiteHeaderPresentationLayoutQueryVariables>(ActiveWebsiteHeaderPresentationLayoutDocument, baseOptions);
        }
export type ActiveWebsiteHeaderPresentationLayoutQueryHookResult = ReturnType<typeof useActiveWebsiteHeaderPresentationLayoutQuery>;
export type ActiveWebsiteHeaderPresentationLayoutLazyQueryHookResult = ReturnType<typeof useActiveWebsiteHeaderPresentationLayoutLazyQuery>;
export type ActiveWebsiteHeaderPresentationLayoutQueryResult = Apollo.QueryResult<ActiveWebsiteHeaderPresentationLayoutQuery, ActiveWebsiteHeaderPresentationLayoutQueryVariables>;
export const WebsiteApplyHeaderPresentationSettingsDocument = gql`
    mutation WebsiteApplyHeaderPresentationSettings($payload: WebsiteApplyHeaderPresentationSettingsInput!) {
  websiteApplyHeaderPresentationSettings(payload: $payload) {
    id: eventId
    schemaURL
    dataJSON
    websiteLayout
  }
}
    `;
export type WebsiteApplyHeaderPresentationSettingsMutationFn = Apollo.MutationFunction<WebsiteApplyHeaderPresentationSettingsMutation, WebsiteApplyHeaderPresentationSettingsMutationVariables>;

/**
 * __useWebsiteApplyHeaderPresentationSettingsMutation__
 *
 * To run a mutation, you first call `useWebsiteApplyHeaderPresentationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteApplyHeaderPresentationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteApplyHeaderPresentationSettingsMutation, { data, loading, error }] = useWebsiteApplyHeaderPresentationSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteApplyHeaderPresentationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteApplyHeaderPresentationSettingsMutation, WebsiteApplyHeaderPresentationSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteApplyHeaderPresentationSettingsMutation, WebsiteApplyHeaderPresentationSettingsMutationVariables>(WebsiteApplyHeaderPresentationSettingsDocument, baseOptions);
      }
export type WebsiteApplyHeaderPresentationSettingsMutationHookResult = ReturnType<typeof useWebsiteApplyHeaderPresentationSettingsMutation>;
export type WebsiteApplyHeaderPresentationSettingsMutationResult = Apollo.MutationResult<WebsiteApplyHeaderPresentationSettingsMutation>;
export type WebsiteApplyHeaderPresentationSettingsMutationOptions = Apollo.BaseMutationOptions<WebsiteApplyHeaderPresentationSettingsMutation, WebsiteApplyHeaderPresentationSettingsMutationVariables>;
export const WebsiteActivateHeaderLayoutDocument = gql`
    mutation WebsiteActivateHeaderLayout($payload: WebsiteActivateHeaderForDesignInput!) {
  websiteActivateHeaderLayout(payload: $payload) {
    id: eventId
    schemaURL
    dataJSON
    websiteLayout
  }
}
    `;
export type WebsiteActivateHeaderLayoutMutationFn = Apollo.MutationFunction<WebsiteActivateHeaderLayoutMutation, WebsiteActivateHeaderLayoutMutationVariables>;

/**
 * __useWebsiteActivateHeaderLayoutMutation__
 *
 * To run a mutation, you first call `useWebsiteActivateHeaderLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteActivateHeaderLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteActivateHeaderLayoutMutation, { data, loading, error }] = useWebsiteActivateHeaderLayoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteActivateHeaderLayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteActivateHeaderLayoutMutation, WebsiteActivateHeaderLayoutMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteActivateHeaderLayoutMutation, WebsiteActivateHeaderLayoutMutationVariables>(WebsiteActivateHeaderLayoutDocument, baseOptions);
      }
export type WebsiteActivateHeaderLayoutMutationHookResult = ReturnType<typeof useWebsiteActivateHeaderLayoutMutation>;
export type WebsiteActivateHeaderLayoutMutationResult = Apollo.MutationResult<WebsiteActivateHeaderLayoutMutation>;
export type WebsiteActivateHeaderLayoutMutationOptions = Apollo.BaseMutationOptions<WebsiteActivateHeaderLayoutMutation, WebsiteActivateHeaderLayoutMutationVariables>;
export const WebsiteActivateHeaderLayoutForEventDocument = gql`
    mutation WebsiteActivateHeaderLayoutForEvent($payload: WebsiteActivateHeaderForEventInput!) {
  websiteActivateHeaderLayoutForEvent(payload: $payload) {
    id: eventId
    schemaURL
    dataJSON
    websiteLayout
  }
}
    `;
export type WebsiteActivateHeaderLayoutForEventMutationFn = Apollo.MutationFunction<WebsiteActivateHeaderLayoutForEventMutation, WebsiteActivateHeaderLayoutForEventMutationVariables>;

/**
 * __useWebsiteActivateHeaderLayoutForEventMutation__
 *
 * To run a mutation, you first call `useWebsiteActivateHeaderLayoutForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteActivateHeaderLayoutForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteActivateHeaderLayoutForEventMutation, { data, loading, error }] = useWebsiteActivateHeaderLayoutForEventMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteActivateHeaderLayoutForEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteActivateHeaderLayoutForEventMutation, WebsiteActivateHeaderLayoutForEventMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteActivateHeaderLayoutForEventMutation, WebsiteActivateHeaderLayoutForEventMutationVariables>(WebsiteActivateHeaderLayoutForEventDocument, baseOptions);
      }
export type WebsiteActivateHeaderLayoutForEventMutationHookResult = ReturnType<typeof useWebsiteActivateHeaderLayoutForEventMutation>;
export type WebsiteActivateHeaderLayoutForEventMutationResult = Apollo.MutationResult<WebsiteActivateHeaderLayoutForEventMutation>;
export type WebsiteActivateHeaderLayoutForEventMutationOptions = Apollo.BaseMutationOptions<WebsiteActivateHeaderLayoutForEventMutation, WebsiteActivateHeaderLayoutForEventMutationVariables>;
export const WebsiteRemoveActiveHeaderLayoutForEventDocument = gql`
    mutation WebsiteRemoveActiveHeaderLayoutForEvent($payload: WebsiteRemoveActiveHeaderForEventInput) {
  websiteRemoveActiveHeaderLayoutForEvent(payload: $payload)
}
    `;
export type WebsiteRemoveActiveHeaderLayoutForEventMutationFn = Apollo.MutationFunction<WebsiteRemoveActiveHeaderLayoutForEventMutation, WebsiteRemoveActiveHeaderLayoutForEventMutationVariables>;

/**
 * __useWebsiteRemoveActiveHeaderLayoutForEventMutation__
 *
 * To run a mutation, you first call `useWebsiteRemoveActiveHeaderLayoutForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteRemoveActiveHeaderLayoutForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteRemoveActiveHeaderLayoutForEventMutation, { data, loading, error }] = useWebsiteRemoveActiveHeaderLayoutForEventMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteRemoveActiveHeaderLayoutForEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteRemoveActiveHeaderLayoutForEventMutation, WebsiteRemoveActiveHeaderLayoutForEventMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteRemoveActiveHeaderLayoutForEventMutation, WebsiteRemoveActiveHeaderLayoutForEventMutationVariables>(WebsiteRemoveActiveHeaderLayoutForEventDocument, baseOptions);
      }
export type WebsiteRemoveActiveHeaderLayoutForEventMutationHookResult = ReturnType<typeof useWebsiteRemoveActiveHeaderLayoutForEventMutation>;
export type WebsiteRemoveActiveHeaderLayoutForEventMutationResult = Apollo.MutationResult<WebsiteRemoveActiveHeaderLayoutForEventMutation>;
export type WebsiteRemoveActiveHeaderLayoutForEventMutationOptions = Apollo.BaseMutationOptions<WebsiteRemoveActiveHeaderLayoutForEventMutation, WebsiteRemoveActiveHeaderLayoutForEventMutationVariables>;
export const MonogramLayoutTemplatesDocument = gql`
    query MonogramLayoutTemplates {
  stationeryTemplatesContainer(filter: {categories: [monogram]}) {
    pagedResults {
      totalCount
      edges {
        cursor
        node {
          id
          name
          themeJSON
          themeId
          thumbnailUrl
        }
      }
    }
  }
}
    `;

/**
 * __useMonogramLayoutTemplatesQuery__
 *
 * To run a query within a React component, call `useMonogramLayoutTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonogramLayoutTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonogramLayoutTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonogramLayoutTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MonogramLayoutTemplatesQuery, MonogramLayoutTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<MonogramLayoutTemplatesQuery, MonogramLayoutTemplatesQueryVariables>(MonogramLayoutTemplatesDocument, baseOptions);
      }
export function useMonogramLayoutTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MonogramLayoutTemplatesQuery, MonogramLayoutTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MonogramLayoutTemplatesQuery, MonogramLayoutTemplatesQueryVariables>(MonogramLayoutTemplatesDocument, baseOptions);
        }
export type MonogramLayoutTemplatesQueryHookResult = ReturnType<typeof useMonogramLayoutTemplatesQuery>;
export type MonogramLayoutTemplatesLazyQueryHookResult = ReturnType<typeof useMonogramLayoutTemplatesLazyQuery>;
export type MonogramLayoutTemplatesQueryResult = Apollo.QueryResult<MonogramLayoutTemplatesQuery, MonogramLayoutTemplatesQueryVariables>;
export const UpdateEventDisplayNameDocument = gql`
    mutation UpdateEventDisplayName($eventId: ID!, $eventDisplayName: String!) {
  updateEventInfo(eventId: $eventId, payload: {eventDisplayName: $eventDisplayName}) {
    id
    eventDisplayName
  }
}
    `;
export type UpdateEventDisplayNameMutationFn = Apollo.MutationFunction<UpdateEventDisplayNameMutation, UpdateEventDisplayNameMutationVariables>;

/**
 * __useUpdateEventDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateEventDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDisplayNameMutation, { data, loading, error }] = useUpdateEventDisplayNameMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventDisplayName: // value for 'eventDisplayName'
 *   },
 * });
 */
export function useUpdateEventDisplayNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDisplayNameMutation, UpdateEventDisplayNameMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventDisplayNameMutation, UpdateEventDisplayNameMutationVariables>(UpdateEventDisplayNameDocument, baseOptions);
      }
export type UpdateEventDisplayNameMutationHookResult = ReturnType<typeof useUpdateEventDisplayNameMutation>;
export type UpdateEventDisplayNameMutationResult = Apollo.MutationResult<UpdateEventDisplayNameMutation>;
export type UpdateEventDisplayNameMutationOptions = Apollo.BaseMutationOptions<UpdateEventDisplayNameMutation, UpdateEventDisplayNameMutationVariables>;
export const GetGreetingMessageDocument = gql`
    query GetGreetingMessage($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      greeting
    }
  }
}
    `;

/**
 * __useGetGreetingMessageQuery__
 *
 * To run a query within a React component, call `useGetGreetingMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGreetingMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGreetingMessageQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetGreetingMessageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGreetingMessageQuery, GetGreetingMessageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGreetingMessageQuery, GetGreetingMessageQueryVariables>(GetGreetingMessageDocument, baseOptions);
      }
export function useGetGreetingMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGreetingMessageQuery, GetGreetingMessageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGreetingMessageQuery, GetGreetingMessageQueryVariables>(GetGreetingMessageDocument, baseOptions);
        }
export type GetGreetingMessageQueryHookResult = ReturnType<typeof useGetGreetingMessageQuery>;
export type GetGreetingMessageLazyQueryHookResult = ReturnType<typeof useGetGreetingMessageLazyQuery>;
export type GetGreetingMessageQueryResult = Apollo.QueryResult<GetGreetingMessageQuery, GetGreetingMessageQueryVariables>;
export const UpdateWebsiteEventGreetingDocument = gql`
    mutation UpdateWebsiteEventGreeting($eventId: ID!, $payload: UpdateGreetingInput!) {
  updateWebsiteEventGreeting(eventId: $eventId, payload: $payload) {
    eventId
    greeting
  }
}
    `;
export type UpdateWebsiteEventGreetingMutationFn = Apollo.MutationFunction<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>;

/**
 * __useUpdateWebsiteEventGreetingMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEventGreetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEventGreetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEventGreetingMutation, { data, loading, error }] = useUpdateWebsiteEventGreetingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWebsiteEventGreetingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>(UpdateWebsiteEventGreetingDocument, baseOptions);
      }
export type UpdateWebsiteEventGreetingMutationHookResult = ReturnType<typeof useUpdateWebsiteEventGreetingMutation>;
export type UpdateWebsiteEventGreetingMutationResult = Apollo.MutationResult<UpdateWebsiteEventGreetingMutation>;
export type UpdateWebsiteEventGreetingMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEventGreetingMutation, UpdateWebsiteEventGreetingMutationVariables>;
export const ApplyFontPackByNameDocument = gql`
    mutation ApplyFontPackByName($eventDesignId: ID!, $fontPackName: String!) {
  applyFontPackByName(eventDesignId: $eventDesignId, fontPackName: $fontPackName) {
    id
    category
    font {
      id
      fontFamily
      fontSize
      fontWeight
      firebaseFontKey
    }
    size
    sizePercent
  }
}
    `;
export type ApplyFontPackByNameMutationFn = Apollo.MutationFunction<ApplyFontPackByNameMutation, ApplyFontPackByNameMutationVariables>;

/**
 * __useApplyFontPackByNameMutation__
 *
 * To run a mutation, you first call `useApplyFontPackByNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFontPackByNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFontPackByNameMutation, { data, loading, error }] = useApplyFontPackByNameMutation({
 *   variables: {
 *      eventDesignId: // value for 'eventDesignId'
 *      fontPackName: // value for 'fontPackName'
 *   },
 * });
 */
export function useApplyFontPackByNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyFontPackByNameMutation, ApplyFontPackByNameMutationVariables>) {
        return ApolloReactHooks.useMutation<ApplyFontPackByNameMutation, ApplyFontPackByNameMutationVariables>(ApplyFontPackByNameDocument, baseOptions);
      }
export type ApplyFontPackByNameMutationHookResult = ReturnType<typeof useApplyFontPackByNameMutation>;
export type ApplyFontPackByNameMutationResult = Apollo.MutationResult<ApplyFontPackByNameMutation>;
export type ApplyFontPackByNameMutationOptions = Apollo.BaseMutationOptions<ApplyFontPackByNameMutation, ApplyFontPackByNameMutationVariables>;
export const EventThemesForTemplatesDocument = gql`
    query EventThemesForTemplates($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    themes {
      id
      themeId
      websiteLayoutBrannanSettings {
        brannanBackgroundTransparency {
          id
          rangeValue
        }
        brannanInnerFrameBorder {
          id
          booleanValue
        }
      }
    }
  }
}
    `;

/**
 * __useEventThemesForTemplatesQuery__
 *
 * To run a query within a React component, call `useEventThemesForTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventThemesForTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventThemesForTemplatesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventThemesForTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventThemesForTemplatesQuery, EventThemesForTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<EventThemesForTemplatesQuery, EventThemesForTemplatesQueryVariables>(EventThemesForTemplatesDocument, baseOptions);
      }
export function useEventThemesForTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventThemesForTemplatesQuery, EventThemesForTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventThemesForTemplatesQuery, EventThemesForTemplatesQueryVariables>(EventThemesForTemplatesDocument, baseOptions);
        }
export type EventThemesForTemplatesQueryHookResult = ReturnType<typeof useEventThemesForTemplatesQuery>;
export type EventThemesForTemplatesLazyQueryHookResult = ReturnType<typeof useEventThemesForTemplatesLazyQuery>;
export type EventThemesForTemplatesQueryResult = Apollo.QueryResult<EventThemesForTemplatesQuery, EventThemesForTemplatesQueryVariables>;
export const GetWelcomePageInfoForWebsiteTemplateDocument = gql`
    query GetWelcomePageInfoForWebsiteTemplate($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    welcomePageInfo: pageInfo(type: welcome) {
      id
      type
      page {
        id
        photoV2 {
          ... on Photo {
            id
            url
            assetId
            width
            height
            layout {
              alignX
              alignY
            }
          }
          ... on DefaultPagePhoto {
            id
            url
            assetId
            width
            height
            layout {
              alignX
              alignY
            }
          }
        }
        photoPresentation {
          id
          cropInfo {
            height
            width
            unit
            x
            y
          }
          photo {
            id
            url
            assetId
            width
            height
            layout {
              alignX
              alignY
            }
          }
          presentationLayout
        }
      }
    }
  }
}
    `;

/**
 * __useGetWelcomePageInfoForWebsiteTemplateQuery__
 *
 * To run a query within a React component, call `useGetWelcomePageInfoForWebsiteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomePageInfoForWebsiteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomePageInfoForWebsiteTemplateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetWelcomePageInfoForWebsiteTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>(GetWelcomePageInfoForWebsiteTemplateDocument, baseOptions);
      }
export function useGetWelcomePageInfoForWebsiteTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>(GetWelcomePageInfoForWebsiteTemplateDocument, baseOptions);
        }
export type GetWelcomePageInfoForWebsiteTemplateQueryHookResult = ReturnType<typeof useGetWelcomePageInfoForWebsiteTemplateQuery>;
export type GetWelcomePageInfoForWebsiteTemplateLazyQueryHookResult = ReturnType<typeof useGetWelcomePageInfoForWebsiteTemplateLazyQuery>;
export type GetWelcomePageInfoForWebsiteTemplateQueryResult = Apollo.QueryResult<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>;
export const UpdateWelcomePagePhotoPresentationLayoutDocument = gql`
    mutation UpdateWelcomePagePhotoPresentationLayout($payload: websiteCreateOrUpdatePagePhotoPresentationPayload!) {
  websiteCreateOrUpdatePagePhotoPresentation(payload: $payload) {
    ... on websiteCreateOrUpdatePagePhotoPresentationResponse {
      success
      message
    }
    ... on websiteCreateOrUpdatePagePhotoPresentationResponseError {
      id
      message
      success
    }
  }
}
    `;
export type UpdateWelcomePagePhotoPresentationLayoutMutationFn = Apollo.MutationFunction<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>;

/**
 * __useUpdateWelcomePagePhotoPresentationLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateWelcomePagePhotoPresentationLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelcomePagePhotoPresentationLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWelcomePagePhotoPresentationLayoutMutation, { data, loading, error }] = useUpdateWelcomePagePhotoPresentationLayoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWelcomePagePhotoPresentationLayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>(UpdateWelcomePagePhotoPresentationLayoutDocument, baseOptions);
      }
export type UpdateWelcomePagePhotoPresentationLayoutMutationHookResult = ReturnType<typeof useUpdateWelcomePagePhotoPresentationLayoutMutation>;
export type UpdateWelcomePagePhotoPresentationLayoutMutationResult = Apollo.MutationResult<UpdateWelcomePagePhotoPresentationLayoutMutation>;
export type UpdateWelcomePagePhotoPresentationLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>;
export const CreateEventPlaceDocument = gql`
    mutation CreateEventPlace($payload: EventPlaceCreatePayload!) {
  createEventPlace(payload: $payload) {
    id
    googlePlaceId
    type
    name
    displayAddress
    latitude
    longitude
    city
    stateProvince
    country
    countryCode
  }
}
    `;
export type CreateEventPlaceMutationFn = Apollo.MutationFunction<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>;

/**
 * __useCreateEventPlaceMutation__
 *
 * To run a mutation, you first call `useCreateEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventPlaceMutation, { data, loading, error }] = useCreateEventPlaceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>(CreateEventPlaceDocument, baseOptions);
      }
export type CreateEventPlaceMutationHookResult = ReturnType<typeof useCreateEventPlaceMutation>;
export type CreateEventPlaceMutationResult = Apollo.MutationResult<CreateEventPlaceMutation>;
export type CreateEventPlaceMutationOptions = Apollo.BaseMutationOptions<CreateEventPlaceMutation, CreateEventPlaceMutationVariables>;
export const UpdateEventPlaceDocument = gql`
    mutation UpdateEventPlace($payload: EventPlaceUpdatePayload!) {
  updateEventPlace(payload: $payload) {
    id
    googlePlaceId
    type
    name
    displayAddress
    latitude
    longitude
    city
    stateProvince
    country
    countryCode
  }
}
    `;
export type UpdateEventPlaceMutationFn = Apollo.MutationFunction<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>;

/**
 * __useUpdateEventPlaceMutation__
 *
 * To run a mutation, you first call `useUpdateEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventPlaceMutation, { data, loading, error }] = useUpdateEventPlaceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>(UpdateEventPlaceDocument, baseOptions);
      }
export type UpdateEventPlaceMutationHookResult = ReturnType<typeof useUpdateEventPlaceMutation>;
export type UpdateEventPlaceMutationResult = Apollo.MutationResult<UpdateEventPlaceMutation>;
export type UpdateEventPlaceMutationOptions = Apollo.BaseMutationOptions<UpdateEventPlaceMutation, UpdateEventPlaceMutationVariables>;
export const DeleteEventPlaceDocument = gql`
    mutation DeleteEventPlace($deleteEventPlaceId: ID!) {
  deleteEventPlace(id: $deleteEventPlaceId) {
    id
    googlePlaceId
    type
    name
    displayAddress
    latitude
    longitude
  }
}
    `;
export type DeleteEventPlaceMutationFn = Apollo.MutationFunction<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>;

/**
 * __useDeleteEventPlaceMutation__
 *
 * To run a mutation, you first call `useDeleteEventPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventPlaceMutation, { data, loading, error }] = useDeleteEventPlaceMutation({
 *   variables: {
 *      deleteEventPlaceId: // value for 'deleteEventPlaceId'
 *   },
 * });
 */
export function useDeleteEventPlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>(DeleteEventPlaceDocument, baseOptions);
      }
export type DeleteEventPlaceMutationHookResult = ReturnType<typeof useDeleteEventPlaceMutation>;
export type DeleteEventPlaceMutationResult = Apollo.MutationResult<DeleteEventPlaceMutation>;
export type DeleteEventPlaceMutationOptions = Apollo.BaseMutationOptions<DeleteEventPlaceMutation, DeleteEventPlaceMutationVariables>;
export const DeletePointOnMapDocument = gql`
    mutation DeletePointOnMap($payload: PointsOnMapDeletePayload) {
  deletePointOnMap(payload: $payload) {
    id
  }
}
    `;
export type DeletePointOnMapMutationFn = Apollo.MutationFunction<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>;

/**
 * __useDeletePointOnMapMutation__
 *
 * To run a mutation, you first call `useDeletePointOnMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOnMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOnMapMutation, { data, loading, error }] = useDeletePointOnMapMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeletePointOnMapMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>(DeletePointOnMapDocument, baseOptions);
      }
export type DeletePointOnMapMutationHookResult = ReturnType<typeof useDeletePointOnMapMutation>;
export type DeletePointOnMapMutationResult = Apollo.MutationResult<DeletePointOnMapMutation>;
export type DeletePointOnMapMutationOptions = Apollo.BaseMutationOptions<DeletePointOnMapMutation, DeletePointOnMapMutationVariables>;
export const AddAccommodationPlaceV2Document = gql`
    mutation AddAccommodationPlaceV2($payload: AddAccommodationPlaceV2Request!) {
  addAccommodationPlaceV2(payload: $payload) {
    id
  }
}
    `;
export type AddAccommodationPlaceV2MutationFn = Apollo.MutationFunction<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>;

/**
 * __useAddAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useAddAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccommodationPlaceV2Mutation, { data, loading, error }] = useAddAccommodationPlaceV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>) {
        return ApolloReactHooks.useMutation<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>(AddAccommodationPlaceV2Document, baseOptions);
      }
export type AddAccommodationPlaceV2MutationHookResult = ReturnType<typeof useAddAccommodationPlaceV2Mutation>;
export type AddAccommodationPlaceV2MutationResult = Apollo.MutationResult<AddAccommodationPlaceV2Mutation>;
export type AddAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<AddAccommodationPlaceV2Mutation, AddAccommodationPlaceV2MutationVariables>;
export const UpdateAccommodationPlaceV2Document = gql`
    mutation UpdateAccommodationPlaceV2($payload: UpdateAccommodationPlaceV2Request!) {
  updateAccommodationPlaceV2(payload: $payload) {
    id
  }
}
    `;
export type UpdateAccommodationPlaceV2MutationFn = Apollo.MutationFunction<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>;

/**
 * __useUpdateAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationPlaceV2Mutation, { data, loading, error }] = useUpdateAccommodationPlaceV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>(UpdateAccommodationPlaceV2Document, baseOptions);
      }
export type UpdateAccommodationPlaceV2MutationHookResult = ReturnType<typeof useUpdateAccommodationPlaceV2Mutation>;
export type UpdateAccommodationPlaceV2MutationResult = Apollo.MutationResult<UpdateAccommodationPlaceV2Mutation>;
export type UpdateAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<UpdateAccommodationPlaceV2Mutation, UpdateAccommodationPlaceV2MutationVariables>;
export const DeleteAccommodationPlaceV2Document = gql`
    mutation DeleteAccommodationPlaceV2($id: String!) {
  deleteAccommodationPlaceV2(id: $id) {
    id
  }
}
    `;
export type DeleteAccommodationPlaceV2MutationFn = Apollo.MutationFunction<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>;

/**
 * __useDeleteAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationPlaceV2Mutation, { data, loading, error }] = useDeleteAccommodationPlaceV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>(DeleteAccommodationPlaceV2Document, baseOptions);
      }
export type DeleteAccommodationPlaceV2MutationHookResult = ReturnType<typeof useDeleteAccommodationPlaceV2Mutation>;
export type DeleteAccommodationPlaceV2MutationResult = Apollo.MutationResult<DeleteAccommodationPlaceV2Mutation>;
export type DeleteAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<DeleteAccommodationPlaceV2Mutation, DeleteAccommodationPlaceV2MutationVariables>;
export const AccommodationHotelsDocument = gql`
    query AccommodationHotels($name: String!) {
  eventByName(name: $name) {
    id
    ...AccommodationsInfo
  }
}
    ${AccommodationsInfoFragmentDoc}`;

/**
 * __useAccommodationHotelsQuery__
 *
 * To run a query within a React component, call `useAccommodationHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationHotelsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationHotelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>(AccommodationHotelsDocument, baseOptions);
      }
export function useAccommodationHotelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>(AccommodationHotelsDocument, baseOptions);
        }
export type AccommodationHotelsQueryHookResult = ReturnType<typeof useAccommodationHotelsQuery>;
export type AccommodationHotelsLazyQueryHookResult = ReturnType<typeof useAccommodationHotelsLazyQuery>;
export type AccommodationHotelsQueryResult = Apollo.QueryResult<AccommodationHotelsQuery, AccommodationHotelsQueryVariables>;
export const UpdateTravelMapComponentDocument = gql`
    mutation UpdateTravelMapComponent($payload: TravelMapComponentUpdatePayload) {
  updateTravelMapComponent(payload: $payload) {
    id
  }
}
    `;
export type UpdateTravelMapComponentMutationFn = Apollo.MutationFunction<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>;

/**
 * __useUpdateTravelMapComponentMutation__
 *
 * To run a mutation, you first call `useUpdateTravelMapComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelMapComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelMapComponentMutation, { data, loading, error }] = useUpdateTravelMapComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTravelMapComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>(UpdateTravelMapComponentDocument, baseOptions);
      }
export type UpdateTravelMapComponentMutationHookResult = ReturnType<typeof useUpdateTravelMapComponentMutation>;
export type UpdateTravelMapComponentMutationResult = Apollo.MutationResult<UpdateTravelMapComponentMutation>;
export type UpdateTravelMapComponentMutationOptions = Apollo.BaseMutationOptions<UpdateTravelMapComponentMutation, UpdateTravelMapComponentMutationVariables>;
export const AccommodationsEditorLeadStateDocument = gql`
    query AccommodationsEditorLeadState($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
    hotelRoomBlocks {
      id
      bookingLink
      leadStateV2
    }
  }
}
    `;

/**
 * __useAccommodationsEditorLeadStateQuery__
 *
 * To run a query within a React component, call `useAccommodationsEditorLeadStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsEditorLeadStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsEditorLeadStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useAccommodationsEditorLeadStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>(AccommodationsEditorLeadStateDocument, baseOptions);
      }
export function useAccommodationsEditorLeadStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>(AccommodationsEditorLeadStateDocument, baseOptions);
        }
export type AccommodationsEditorLeadStateQueryHookResult = ReturnType<typeof useAccommodationsEditorLeadStateQuery>;
export type AccommodationsEditorLeadStateLazyQueryHookResult = ReturnType<typeof useAccommodationsEditorLeadStateLazyQuery>;
export type AccommodationsEditorLeadStateQueryResult = Apollo.QueryResult<AccommodationsEditorLeadStateQuery, AccommodationsEditorLeadStateQueryVariables>;
export const AccommodationPropertyPhotosDocument = gql`
    query AccommodationPropertyPhotos($payload: AccommodationContentSearchInput!) {
  searchAccommodationProperties(payload: $payload) {
    properties {
      joyPlaceId
      photos {
        url
      }
    }
  }
}
    `;

/**
 * __useAccommodationPropertyPhotosQuery__
 *
 * To run a query within a React component, call `useAccommodationPropertyPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPropertyPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPropertyPhotosQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPropertyPhotosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>(AccommodationPropertyPhotosDocument, baseOptions);
      }
export function useAccommodationPropertyPhotosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>(AccommodationPropertyPhotosDocument, baseOptions);
        }
export type AccommodationPropertyPhotosQueryHookResult = ReturnType<typeof useAccommodationPropertyPhotosQuery>;
export type AccommodationPropertyPhotosLazyQueryHookResult = ReturnType<typeof useAccommodationPropertyPhotosLazyQuery>;
export type AccommodationPropertyPhotosQueryResult = Apollo.QueryResult<AccommodationPropertyPhotosQuery, AccommodationPropertyPhotosQueryVariables>;
export const RoomBlockLeadStateDocument = gql`
    query RoomBlockLeadState($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    hotelRoomBlocks {
      id
      bookingLink
      leadStateV2
    }
  }
}
    `;

/**
 * __useRoomBlockLeadStateQuery__
 *
 * To run a query within a React component, call `useRoomBlockLeadStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomBlockLeadStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomBlockLeadStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useRoomBlockLeadStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoomBlockLeadStateQuery, RoomBlockLeadStateQueryVariables>) {
        return ApolloReactHooks.useQuery<RoomBlockLeadStateQuery, RoomBlockLeadStateQueryVariables>(RoomBlockLeadStateDocument, baseOptions);
      }
export function useRoomBlockLeadStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoomBlockLeadStateQuery, RoomBlockLeadStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RoomBlockLeadStateQuery, RoomBlockLeadStateQueryVariables>(RoomBlockLeadStateDocument, baseOptions);
        }
export type RoomBlockLeadStateQueryHookResult = ReturnType<typeof useRoomBlockLeadStateQuery>;
export type RoomBlockLeadStateLazyQueryHookResult = ReturnType<typeof useRoomBlockLeadStateLazyQuery>;
export type RoomBlockLeadStateQueryResult = Apollo.QueryResult<RoomBlockLeadStateQuery, RoomBlockLeadStateQueryVariables>;
export const FindMatchingAccommodationCatalogPropertyDocument = gql`
    query FindMatchingAccommodationCatalogProperty($payload: FindMatchingAccommodationCatalogPropertyPayload!) {
  findMatchingAccommodationCatalogProperty(payload: $payload) {
    accommodationCatalogProperty {
      joyPlaceId
      name
      starRating
      userRating {
        ...UserRating
      }
      plainTextLongDescription
      location {
        latitude
        longitude
      }
      address {
        city
        country
        postalCode
        state
        street
      }
      photos {
        url
      }
    }
  }
}
    ${UserRatingFragmentDoc}`;

/**
 * __useFindMatchingAccommodationCatalogPropertyQuery__
 *
 * To run a query within a React component, call `useFindMatchingAccommodationCatalogPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMatchingAccommodationCatalogPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMatchingAccommodationCatalogPropertyQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useFindMatchingAccommodationCatalogPropertyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>) {
        return ApolloReactHooks.useQuery<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>(FindMatchingAccommodationCatalogPropertyDocument, baseOptions);
      }
export function useFindMatchingAccommodationCatalogPropertyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>(FindMatchingAccommodationCatalogPropertyDocument, baseOptions);
        }
export type FindMatchingAccommodationCatalogPropertyQueryHookResult = ReturnType<typeof useFindMatchingAccommodationCatalogPropertyQuery>;
export type FindMatchingAccommodationCatalogPropertyLazyQueryHookResult = ReturnType<typeof useFindMatchingAccommodationCatalogPropertyLazyQuery>;
export type FindMatchingAccommodationCatalogPropertyQueryResult = Apollo.QueryResult<FindMatchingAccommodationCatalogPropertyQuery, FindMatchingAccommodationCatalogPropertyQueryVariables>;
export const TravelReservationBookingDetailsDocument = gql`
    query TravelReservationBookingDetails($payload: TravelReservationBookingDetailsPayload!) {
  travelReservationBookingDetails(payload: $payload) {
    bookingInfo {
      id
      checkInDate
      checkOutDate
      email
      status
      bookingDate
      firstName
      lastName
      occupancy {
        adults
        children
      }
      roomTypes
    }
    joyPlace {
      id
      starRating
      name
      lat
      long
      photo {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useTravelReservationBookingDetailsQuery__
 *
 * To run a query within a React component, call `useTravelReservationBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelReservationBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelReservationBookingDetailsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelReservationBookingDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelReservationBookingDetailsQuery, TravelReservationBookingDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelReservationBookingDetailsQuery, TravelReservationBookingDetailsQueryVariables>(TravelReservationBookingDetailsDocument, baseOptions);
      }
export function useTravelReservationBookingDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelReservationBookingDetailsQuery, TravelReservationBookingDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelReservationBookingDetailsQuery, TravelReservationBookingDetailsQueryVariables>(TravelReservationBookingDetailsDocument, baseOptions);
        }
export type TravelReservationBookingDetailsQueryHookResult = ReturnType<typeof useTravelReservationBookingDetailsQuery>;
export type TravelReservationBookingDetailsLazyQueryHookResult = ReturnType<typeof useTravelReservationBookingDetailsLazyQuery>;
export type TravelReservationBookingDetailsQueryResult = Apollo.QueryResult<TravelReservationBookingDetailsQuery, TravelReservationBookingDetailsQueryVariables>;
export const AddPhotoComponentDocument = gql`
    mutation AddPhotoComponent($payload: PhotoComponentAddPayload!) {
  addPhotoComponent(payload: $payload) {
    id
    sortOrder
    photo {
      id
      url
      width
      height
    }
  }
}
    `;
export type AddPhotoComponentMutationFn = Apollo.MutationFunction<AddPhotoComponentMutation, AddPhotoComponentMutationVariables>;

/**
 * __useAddPhotoComponentMutation__
 *
 * To run a mutation, you first call `useAddPhotoComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhotoComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhotoComponentMutation, { data, loading, error }] = useAddPhotoComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPhotoComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPhotoComponentMutation, AddPhotoComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPhotoComponentMutation, AddPhotoComponentMutationVariables>(AddPhotoComponentDocument, baseOptions);
      }
export type AddPhotoComponentMutationHookResult = ReturnType<typeof useAddPhotoComponentMutation>;
export type AddPhotoComponentMutationResult = Apollo.MutationResult<AddPhotoComponentMutation>;
export type AddPhotoComponentMutationOptions = Apollo.BaseMutationOptions<AddPhotoComponentMutation, AddPhotoComponentMutationVariables>;
export const UpdatePhotoComponentDocument = gql`
    mutation UpdatePhotoComponent($payload: PhotoComponentUpdatePayload!) {
  updatePhotoComponent(payload: $payload) {
    id
  }
}
    `;
export type UpdatePhotoComponentMutationFn = Apollo.MutationFunction<UpdatePhotoComponentMutation, UpdatePhotoComponentMutationVariables>;

/**
 * __useUpdatePhotoComponentMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoComponentMutation, { data, loading, error }] = useUpdatePhotoComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePhotoComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhotoComponentMutation, UpdatePhotoComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhotoComponentMutation, UpdatePhotoComponentMutationVariables>(UpdatePhotoComponentDocument, baseOptions);
      }
export type UpdatePhotoComponentMutationHookResult = ReturnType<typeof useUpdatePhotoComponentMutation>;
export type UpdatePhotoComponentMutationResult = Apollo.MutationResult<UpdatePhotoComponentMutation>;
export type UpdatePhotoComponentMutationOptions = Apollo.BaseMutationOptions<UpdatePhotoComponentMutation, UpdatePhotoComponentMutationVariables>;
export const AddMediaGalleryComponentDocument = gql`
    mutation AddMediaGalleryComponent($payload: AddMediaGalleryComponentPayload) {
  addMediaGalleryComponent(payload: $payload) {
    id
    type
    sortOrder
    mediaCollection {
      id
      name
    }
  }
}
    `;
export type AddMediaGalleryComponentMutationFn = Apollo.MutationFunction<AddMediaGalleryComponentMutation, AddMediaGalleryComponentMutationVariables>;

/**
 * __useAddMediaGalleryComponentMutation__
 *
 * To run a mutation, you first call `useAddMediaGalleryComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaGalleryComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaGalleryComponentMutation, { data, loading, error }] = useAddMediaGalleryComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddMediaGalleryComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMediaGalleryComponentMutation, AddMediaGalleryComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddMediaGalleryComponentMutation, AddMediaGalleryComponentMutationVariables>(AddMediaGalleryComponentDocument, baseOptions);
      }
export type AddMediaGalleryComponentMutationHookResult = ReturnType<typeof useAddMediaGalleryComponentMutation>;
export type AddMediaGalleryComponentMutationResult = Apollo.MutationResult<AddMediaGalleryComponentMutation>;
export type AddMediaGalleryComponentMutationOptions = Apollo.BaseMutationOptions<AddMediaGalleryComponentMutation, AddMediaGalleryComponentMutationVariables>;
export const UpdateMediaGalleryComponentDocument = gql`
    mutation UpdateMediaGalleryComponent($payload: UpdateMediaGalleryComponentPayload) {
  updateMediaGalleryComponent(payload: $payload) {
    id
    type
  }
}
    `;
export type UpdateMediaGalleryComponentMutationFn = Apollo.MutationFunction<UpdateMediaGalleryComponentMutation, UpdateMediaGalleryComponentMutationVariables>;

/**
 * __useUpdateMediaGalleryComponentMutation__
 *
 * To run a mutation, you first call `useUpdateMediaGalleryComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaGalleryComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaGalleryComponentMutation, { data, loading, error }] = useUpdateMediaGalleryComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateMediaGalleryComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMediaGalleryComponentMutation, UpdateMediaGalleryComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMediaGalleryComponentMutation, UpdateMediaGalleryComponentMutationVariables>(UpdateMediaGalleryComponentDocument, baseOptions);
      }
export type UpdateMediaGalleryComponentMutationHookResult = ReturnType<typeof useUpdateMediaGalleryComponentMutation>;
export type UpdateMediaGalleryComponentMutationResult = Apollo.MutationResult<UpdateMediaGalleryComponentMutation>;
export type UpdateMediaGalleryComponentMutationOptions = Apollo.BaseMutationOptions<UpdateMediaGalleryComponentMutation, UpdateMediaGalleryComponentMutationVariables>;
export const AddTextComponentDocument = gql`
    mutation AddTextComponent($payload: TextComponentAddPayload) {
  addTextComponent(payload: $payload) {
    id
    sortOrder
    text
  }
}
    `;
export type AddTextComponentMutationFn = Apollo.MutationFunction<AddTextComponentMutation, AddTextComponentMutationVariables>;

/**
 * __useAddTextComponentMutation__
 *
 * To run a mutation, you first call `useAddTextComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTextComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTextComponentMutation, { data, loading, error }] = useAddTextComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddTextComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTextComponentMutation, AddTextComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddTextComponentMutation, AddTextComponentMutationVariables>(AddTextComponentDocument, baseOptions);
      }
export type AddTextComponentMutationHookResult = ReturnType<typeof useAddTextComponentMutation>;
export type AddTextComponentMutationResult = Apollo.MutationResult<AddTextComponentMutation>;
export type AddTextComponentMutationOptions = Apollo.BaseMutationOptions<AddTextComponentMutation, AddTextComponentMutationVariables>;
export const UpdateTextComponentDocument = gql`
    mutation UpdateTextComponent($payload: TextComponentUpdatePayload) {
  updateTextComponent(payload: $payload) {
    id
  }
}
    `;
export type UpdateTextComponentMutationFn = Apollo.MutationFunction<UpdateTextComponentMutation, UpdateTextComponentMutationVariables>;

/**
 * __useUpdateTextComponentMutation__
 *
 * To run a mutation, you first call `useUpdateTextComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTextComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTextComponentMutation, { data, loading, error }] = useUpdateTextComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTextComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTextComponentMutation, UpdateTextComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTextComponentMutation, UpdateTextComponentMutationVariables>(UpdateTextComponentDocument, baseOptions);
      }
export type UpdateTextComponentMutationHookResult = ReturnType<typeof useUpdateTextComponentMutation>;
export type UpdateTextComponentMutationResult = Apollo.MutationResult<UpdateTextComponentMutation>;
export type UpdateTextComponentMutationOptions = Apollo.BaseMutationOptions<UpdateTextComponentMutation, UpdateTextComponentMutationVariables>;
export const AddVideoComponentDocument = gql`
    mutation AddVideoComponent($payload: VideoComponentAddPayload!) {
  addVideoComponent(payload: $payload) {
    id
    sortOrder
    videoUrl
    caption
  }
}
    `;
export type AddVideoComponentMutationFn = Apollo.MutationFunction<AddVideoComponentMutation, AddVideoComponentMutationVariables>;

/**
 * __useAddVideoComponentMutation__
 *
 * To run a mutation, you first call `useAddVideoComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVideoComponentMutation, { data, loading, error }] = useAddVideoComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddVideoComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddVideoComponentMutation, AddVideoComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddVideoComponentMutation, AddVideoComponentMutationVariables>(AddVideoComponentDocument, baseOptions);
      }
export type AddVideoComponentMutationHookResult = ReturnType<typeof useAddVideoComponentMutation>;
export type AddVideoComponentMutationResult = Apollo.MutationResult<AddVideoComponentMutation>;
export type AddVideoComponentMutationOptions = Apollo.BaseMutationOptions<AddVideoComponentMutation, AddVideoComponentMutationVariables>;
export const UpdateVideoComponentDocument = gql`
    mutation UpdateVideoComponent($payload: VideoComponentUpdatePayload!) {
  updateVideoComponent(payload: $payload) {
    id
  }
}
    `;
export type UpdateVideoComponentMutationFn = Apollo.MutationFunction<UpdateVideoComponentMutation, UpdateVideoComponentMutationVariables>;

/**
 * __useUpdateVideoComponentMutation__
 *
 * To run a mutation, you first call `useUpdateVideoComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoComponentMutation, { data, loading, error }] = useUpdateVideoComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateVideoComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVideoComponentMutation, UpdateVideoComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateVideoComponentMutation, UpdateVideoComponentMutationVariables>(UpdateVideoComponentDocument, baseOptions);
      }
export type UpdateVideoComponentMutationHookResult = ReturnType<typeof useUpdateVideoComponentMutation>;
export type UpdateVideoComponentMutationResult = Apollo.MutationResult<UpdateVideoComponentMutation>;
export type UpdateVideoComponentMutationOptions = Apollo.BaseMutationOptions<UpdateVideoComponentMutation, UpdateVideoComponentMutationVariables>;
export const GetWebsitePreviewDesignDocument = gql`
    query GetWebsitePreviewDesign($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
    eventDesign(purpose: $purpose) {
      ...CustomPageEventDesign
    }
  }
}
    ${CustomPageEventDesignFragmentDoc}`;

/**
 * __useGetWebsitePreviewDesignQuery__
 *
 * To run a query within a React component, call `useGetWebsitePreviewDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsitePreviewDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsitePreviewDesignQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetWebsitePreviewDesignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsitePreviewDesignQuery, GetWebsitePreviewDesignQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsitePreviewDesignQuery, GetWebsitePreviewDesignQueryVariables>(GetWebsitePreviewDesignDocument, baseOptions);
      }
export function useGetWebsitePreviewDesignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsitePreviewDesignQuery, GetWebsitePreviewDesignQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsitePreviewDesignQuery, GetWebsitePreviewDesignQueryVariables>(GetWebsitePreviewDesignDocument, baseOptions);
        }
export type GetWebsitePreviewDesignQueryHookResult = ReturnType<typeof useGetWebsitePreviewDesignQuery>;
export type GetWebsitePreviewDesignLazyQueryHookResult = ReturnType<typeof useGetWebsitePreviewDesignLazyQuery>;
export type GetWebsitePreviewDesignQueryResult = Apollo.QueryResult<GetWebsitePreviewDesignQuery, GetWebsitePreviewDesignQueryVariables>;
export const PageContainerBySlugDocument = gql`
    query PageContainerBySlug($payload: PageContainerBySlugPayload!, $eventId: ID!) {
  pageContainerBySlug(payload: $payload, options: {admin: true}) {
    ...CustomPageContainer
  }
  event(id: $eventId) {
    id
    featureFlags
    info {
      id
      eventPassword
    }
    pages(admin: true) {
      id
      pageSlug
      createdAt {
        timestamp
      }
      visibility
    }
  }
}
    ${CustomPageContainerFragmentDoc}`;

/**
 * __usePageContainerBySlugQuery__
 *
 * To run a query within a React component, call `usePageContainerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageContainerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageContainerBySlugQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function usePageContainerBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PageContainerBySlugQuery, PageContainerBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<PageContainerBySlugQuery, PageContainerBySlugQueryVariables>(PageContainerBySlugDocument, baseOptions);
      }
export function usePageContainerBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PageContainerBySlugQuery, PageContainerBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PageContainerBySlugQuery, PageContainerBySlugQueryVariables>(PageContainerBySlugDocument, baseOptions);
        }
export type PageContainerBySlugQueryHookResult = ReturnType<typeof usePageContainerBySlugQuery>;
export type PageContainerBySlugLazyQueryHookResult = ReturnType<typeof usePageContainerBySlugLazyQuery>;
export type PageContainerBySlugQueryResult = Apollo.QueryResult<PageContainerBySlugQuery, PageContainerBySlugQueryVariables>;
export const CreatePageContainerDocument = gql`
    mutation CreatePageContainer($payload: PageContainerCreatePayload!) {
  createPageContainer(payload: $payload) {
    id
  }
}
    `;
export type CreatePageContainerMutationFn = Apollo.MutationFunction<CreatePageContainerMutation, CreatePageContainerMutationVariables>;

/**
 * __useCreatePageContainerMutation__
 *
 * To run a mutation, you first call `useCreatePageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageContainerMutation, { data, loading, error }] = useCreatePageContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePageContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePageContainerMutation, CreatePageContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePageContainerMutation, CreatePageContainerMutationVariables>(CreatePageContainerDocument, baseOptions);
      }
export type CreatePageContainerMutationHookResult = ReturnType<typeof useCreatePageContainerMutation>;
export type CreatePageContainerMutationResult = Apollo.MutationResult<CreatePageContainerMutation>;
export type CreatePageContainerMutationOptions = Apollo.BaseMutationOptions<CreatePageContainerMutation, CreatePageContainerMutationVariables>;
export const UpdatePageContainerDocument = gql`
    mutation UpdatePageContainer($payload: PageContainerUpdatePayload!) {
  updatePageContainer(payload: $payload) {
    id
    mainPhotoV2 {
      ...CustomPageMainPhotoV2
    }
    mainPhotoAlignment {
      x
      y
    }
    ...CustomPagePhotoPresentationInfo
  }
}
    ${CustomPageMainPhotoV2FragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}`;
export type UpdatePageContainerMutationFn = Apollo.MutationFunction<UpdatePageContainerMutation, UpdatePageContainerMutationVariables>;

/**
 * __useUpdatePageContainerMutation__
 *
 * To run a mutation, you first call `useUpdatePageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageContainerMutation, { data, loading, error }] = useUpdatePageContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePageContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageContainerMutation, UpdatePageContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePageContainerMutation, UpdatePageContainerMutationVariables>(UpdatePageContainerDocument, baseOptions);
      }
export type UpdatePageContainerMutationHookResult = ReturnType<typeof useUpdatePageContainerMutation>;
export type UpdatePageContainerMutationResult = Apollo.MutationResult<UpdatePageContainerMutation>;
export type UpdatePageContainerMutationOptions = Apollo.BaseMutationOptions<UpdatePageContainerMutation, UpdatePageContainerMutationVariables>;
export const AddTravelMapComponentDocument = gql`
    mutation AddTravelMapComponent($payload: TravelMapComponentAddPayload) {
  addTravelMapComponent(payload: $payload) {
    id
  }
}
    `;
export type AddTravelMapComponentMutationFn = Apollo.MutationFunction<AddTravelMapComponentMutation, AddTravelMapComponentMutationVariables>;

/**
 * __useAddTravelMapComponentMutation__
 *
 * To run a mutation, you first call `useAddTravelMapComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTravelMapComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTravelMapComponentMutation, { data, loading, error }] = useAddTravelMapComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddTravelMapComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTravelMapComponentMutation, AddTravelMapComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddTravelMapComponentMutation, AddTravelMapComponentMutationVariables>(AddTravelMapComponentDocument, baseOptions);
      }
export type AddTravelMapComponentMutationHookResult = ReturnType<typeof useAddTravelMapComponentMutation>;
export type AddTravelMapComponentMutationResult = Apollo.MutationResult<AddTravelMapComponentMutation>;
export type AddTravelMapComponentMutationOptions = Apollo.BaseMutationOptions<AddTravelMapComponentMutation, AddTravelMapComponentMutationVariables>;
export const DeletePageComponentV2Document = gql`
    mutation DeletePageComponentV2($payload: PageComponentDeletePayload) {
  deletePageComponentV2(payload: $payload)
}
    `;
export type DeletePageComponentV2MutationFn = Apollo.MutationFunction<DeletePageComponentV2Mutation, DeletePageComponentV2MutationVariables>;

/**
 * __useDeletePageComponentV2Mutation__
 *
 * To run a mutation, you first call `useDeletePageComponentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageComponentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageComponentV2Mutation, { data, loading, error }] = useDeletePageComponentV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeletePageComponentV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePageComponentV2Mutation, DeletePageComponentV2MutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePageComponentV2Mutation, DeletePageComponentV2MutationVariables>(DeletePageComponentV2Document, baseOptions);
      }
export type DeletePageComponentV2MutationHookResult = ReturnType<typeof useDeletePageComponentV2Mutation>;
export type DeletePageComponentV2MutationResult = Apollo.MutationResult<DeletePageComponentV2Mutation>;
export type DeletePageComponentV2MutationOptions = Apollo.BaseMutationOptions<DeletePageComponentV2Mutation, DeletePageComponentV2MutationVariables>;
export const ReorderPageComponentsDocument = gql`
    mutation ReorderPageComponents($pageContainerId: ID!, $components: [ReorderPageComponent!]!) {
  reorderPageComponents(pageContainerId: $pageContainerId, components: $components) {
    id
    sortOrder
  }
}
    `;
export type ReorderPageComponentsMutationFn = Apollo.MutationFunction<ReorderPageComponentsMutation, ReorderPageComponentsMutationVariables>;

/**
 * __useReorderPageComponentsMutation__
 *
 * To run a mutation, you first call `useReorderPageComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPageComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPageComponentsMutation, { data, loading, error }] = useReorderPageComponentsMutation({
 *   variables: {
 *      pageContainerId: // value for 'pageContainerId'
 *      components: // value for 'components'
 *   },
 * });
 */
export function useReorderPageComponentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderPageComponentsMutation, ReorderPageComponentsMutationVariables>) {
        return ApolloReactHooks.useMutation<ReorderPageComponentsMutation, ReorderPageComponentsMutationVariables>(ReorderPageComponentsDocument, baseOptions);
      }
export type ReorderPageComponentsMutationHookResult = ReturnType<typeof useReorderPageComponentsMutation>;
export type ReorderPageComponentsMutationResult = Apollo.MutationResult<ReorderPageComponentsMutation>;
export type ReorderPageComponentsMutationOptions = Apollo.BaseMutationOptions<ReorderPageComponentsMutation, ReorderPageComponentsMutationVariables>;
export const DeletePageContainerDocument = gql`
    mutation DeletePageContainer($payload: PageContainerDeletePayload!) {
  deletePageContainer(payload: $payload) {
    id
  }
}
    `;
export type DeletePageContainerMutationFn = Apollo.MutationFunction<DeletePageContainerMutation, DeletePageContainerMutationVariables>;

/**
 * __useDeletePageContainerMutation__
 *
 * To run a mutation, you first call `useDeletePageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageContainerMutation, { data, loading, error }] = useDeletePageContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeletePageContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePageContainerMutation, DeletePageContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePageContainerMutation, DeletePageContainerMutationVariables>(DeletePageContainerDocument, baseOptions);
      }
export type DeletePageContainerMutationHookResult = ReturnType<typeof useDeletePageContainerMutation>;
export type DeletePageContainerMutationResult = Apollo.MutationResult<DeletePageContainerMutation>;
export type DeletePageContainerMutationOptions = Apollo.BaseMutationOptions<DeletePageContainerMutation, DeletePageContainerMutationVariables>;
export const IsPageContainerSlugAvailableDocument = gql`
    query IsPageContainerSlugAvailable($payload: IsPageContainerSlugAvailablePayload!) {
  isPageContainerSlugAvailable(payload: $payload)
}
    `;

/**
 * __useIsPageContainerSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsPageContainerSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPageContainerSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPageContainerSlugAvailableQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useIsPageContainerSlugAvailableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsPageContainerSlugAvailableQuery, IsPageContainerSlugAvailableQueryVariables>) {
        return ApolloReactHooks.useQuery<IsPageContainerSlugAvailableQuery, IsPageContainerSlugAvailableQueryVariables>(IsPageContainerSlugAvailableDocument, baseOptions);
      }
export function useIsPageContainerSlugAvailableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsPageContainerSlugAvailableQuery, IsPageContainerSlugAvailableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IsPageContainerSlugAvailableQuery, IsPageContainerSlugAvailableQueryVariables>(IsPageContainerSlugAvailableDocument, baseOptions);
        }
export type IsPageContainerSlugAvailableQueryHookResult = ReturnType<typeof useIsPageContainerSlugAvailableQuery>;
export type IsPageContainerSlugAvailableLazyQueryHookResult = ReturnType<typeof useIsPageContainerSlugAvailableLazyQuery>;
export type IsPageContainerSlugAvailableQueryResult = Apollo.QueryResult<IsPageContainerSlugAvailableQuery, IsPageContainerSlugAvailableQueryVariables>;
export const GetPageContainersOrderDocument = gql`
    query GetPageContainersOrder($name: String!, $admin: Boolean) {
  eventByName(name: $name) {
    id
    pageContainers(admin: $admin) {
      id
      sortOrder
    }
    pages(admin: $admin) {
      id
      type
    }
    info {
      id
      eventPassword
    }
  }
}
    `;

/**
 * __useGetPageContainersOrderQuery__
 *
 * To run a query within a React component, call `useGetPageContainersOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageContainersOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageContainersOrderQuery({
 *   variables: {
 *      name: // value for 'name'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useGetPageContainersOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPageContainersOrderQuery, GetPageContainersOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPageContainersOrderQuery, GetPageContainersOrderQueryVariables>(GetPageContainersOrderDocument, baseOptions);
      }
export function useGetPageContainersOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPageContainersOrderQuery, GetPageContainersOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPageContainersOrderQuery, GetPageContainersOrderQueryVariables>(GetPageContainersOrderDocument, baseOptions);
        }
export type GetPageContainersOrderQueryHookResult = ReturnType<typeof useGetPageContainersOrderQuery>;
export type GetPageContainersOrderLazyQueryHookResult = ReturnType<typeof useGetPageContainersOrderLazyQuery>;
export type GetPageContainersOrderQueryResult = Apollo.QueryResult<GetPageContainersOrderQuery, GetPageContainersOrderQueryVariables>;
export const GetWebsiteEditorRegistryLinksPageDocument = gql`
    query GetWebsiteEditorRegistryLinksPage($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: true, type: registry) {
      id
      pageSubTitleV0918
    }
  }
}
    `;

/**
 * __useGetWebsiteEditorRegistryLinksPageQuery__
 *
 * To run a query within a React component, call `useGetWebsiteEditorRegistryLinksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteEditorRegistryLinksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteEditorRegistryLinksPageQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetWebsiteEditorRegistryLinksPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteEditorRegistryLinksPageQuery, GetWebsiteEditorRegistryLinksPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsiteEditorRegistryLinksPageQuery, GetWebsiteEditorRegistryLinksPageQueryVariables>(GetWebsiteEditorRegistryLinksPageDocument, baseOptions);
      }
export function useGetWebsiteEditorRegistryLinksPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteEditorRegistryLinksPageQuery, GetWebsiteEditorRegistryLinksPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsiteEditorRegistryLinksPageQuery, GetWebsiteEditorRegistryLinksPageQueryVariables>(GetWebsiteEditorRegistryLinksPageDocument, baseOptions);
        }
export type GetWebsiteEditorRegistryLinksPageQueryHookResult = ReturnType<typeof useGetWebsiteEditorRegistryLinksPageQuery>;
export type GetWebsiteEditorRegistryLinksPageLazyQueryHookResult = ReturnType<typeof useGetWebsiteEditorRegistryLinksPageLazyQuery>;
export type GetWebsiteEditorRegistryLinksPageQueryResult = Apollo.QueryResult<GetWebsiteEditorRegistryLinksPageQuery, GetWebsiteEditorRegistryLinksPageQueryVariables>;
export const SortTravelItemsDocument = gql`
    mutation SortTravelItems($payload: SortItemsPayload) {
  sortTravelItems(payload: $payload) {
    ...TravelItemIds
  }
}
    ${TravelItemIdsFragmentDoc}`;
export type SortTravelItemsMutationFn = Apollo.MutationFunction<SortTravelItemsMutation, SortTravelItemsMutationVariables>;

/**
 * __useSortTravelItemsMutation__
 *
 * To run a mutation, you first call `useSortTravelItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortTravelItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortTravelItemsMutation, { data, loading, error }] = useSortTravelItemsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSortTravelItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SortTravelItemsMutation, SortTravelItemsMutationVariables>) {
        return ApolloReactHooks.useMutation<SortTravelItemsMutation, SortTravelItemsMutationVariables>(SortTravelItemsDocument, baseOptions);
      }
export type SortTravelItemsMutationHookResult = ReturnType<typeof useSortTravelItemsMutation>;
export type SortTravelItemsMutationResult = Apollo.MutationResult<SortTravelItemsMutation>;
export type SortTravelItemsMutationOptions = Apollo.BaseMutationOptions<SortTravelItemsMutation, SortTravelItemsMutationVariables>;
export const DeleteTravelItemDocument = gql`
    mutation DeleteTravelItem($deleteTravelItemId: ID!) {
  deleteTravelItem(id: $deleteTravelItemId) {
    ...TravelItemIds
  }
}
    ${TravelItemIdsFragmentDoc}`;
export type DeleteTravelItemMutationFn = Apollo.MutationFunction<DeleteTravelItemMutation, DeleteTravelItemMutationVariables>;

/**
 * __useDeleteTravelItemMutation__
 *
 * To run a mutation, you first call `useDeleteTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTravelItemMutation, { data, loading, error }] = useDeleteTravelItemMutation({
 *   variables: {
 *      deleteTravelItemId: // value for 'deleteTravelItemId'
 *   },
 * });
 */
export function useDeleteTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTravelItemMutation, DeleteTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTravelItemMutation, DeleteTravelItemMutationVariables>(DeleteTravelItemDocument, baseOptions);
      }
export type DeleteTravelItemMutationHookResult = ReturnType<typeof useDeleteTravelItemMutation>;
export type DeleteTravelItemMutationResult = Apollo.MutationResult<DeleteTravelItemMutation>;
export type DeleteTravelItemMutationOptions = Apollo.BaseMutationOptions<DeleteTravelItemMutation, DeleteTravelItemMutationVariables>;
export const CreateBookingTravelItemDocument = gql`
    mutation CreateBookingTravelItem($payload: CreateBookingTravelItemPayload!) {
  createBookingTravelItem(payload: $payload) {
    address
    bookingType
    endTime {
      dateString
    }
    id
    name
    placeId
    type
    startTime {
      dateString
    }
    timezone
  }
}
    `;
export type CreateBookingTravelItemMutationFn = Apollo.MutationFunction<CreateBookingTravelItemMutation, CreateBookingTravelItemMutationVariables>;

/**
 * __useCreateBookingTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateBookingTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingTravelItemMutation, { data, loading, error }] = useCreateBookingTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateBookingTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingTravelItemMutation, CreateBookingTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBookingTravelItemMutation, CreateBookingTravelItemMutationVariables>(CreateBookingTravelItemDocument, baseOptions);
      }
export type CreateBookingTravelItemMutationHookResult = ReturnType<typeof useCreateBookingTravelItemMutation>;
export type CreateBookingTravelItemMutationResult = Apollo.MutationResult<CreateBookingTravelItemMutation>;
export type CreateBookingTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateBookingTravelItemMutation, CreateBookingTravelItemMutationVariables>;
export const CreateListTravelItemDocument = gql`
    mutation CreateListTravelItem($payload: CreateListTravelItemPayload!) {
  createListTravelItem(payload: $payload) {
    items {
      title
      url
      id
    }
    id
    name
    type
  }
}
    `;
export type CreateListTravelItemMutationFn = Apollo.MutationFunction<CreateListTravelItemMutation, CreateListTravelItemMutationVariables>;

/**
 * __useCreateListTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateListTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListTravelItemMutation, { data, loading, error }] = useCreateListTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateListTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateListTravelItemMutation, CreateListTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateListTravelItemMutation, CreateListTravelItemMutationVariables>(CreateListTravelItemDocument, baseOptions);
      }
export type CreateListTravelItemMutationHookResult = ReturnType<typeof useCreateListTravelItemMutation>;
export type CreateListTravelItemMutationResult = Apollo.MutationResult<CreateListTravelItemMutation>;
export type CreateListTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateListTravelItemMutation, CreateListTravelItemMutationVariables>;
export const CreateNoteTravelItemDocument = gql`
    mutation CreateNoteTravelItem($payload: CreateNoteTravelItemPayload!) {
  createNoteTravelItem(payload: $payload) {
    id
    name
    notes
    type
    url
  }
}
    `;
export type CreateNoteTravelItemMutationFn = Apollo.MutationFunction<CreateNoteTravelItemMutation, CreateNoteTravelItemMutationVariables>;

/**
 * __useCreateNoteTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateNoteTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteTravelItemMutation, { data, loading, error }] = useCreateNoteTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateNoteTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNoteTravelItemMutation, CreateNoteTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNoteTravelItemMutation, CreateNoteTravelItemMutationVariables>(CreateNoteTravelItemDocument, baseOptions);
      }
export type CreateNoteTravelItemMutationHookResult = ReturnType<typeof useCreateNoteTravelItemMutation>;
export type CreateNoteTravelItemMutationResult = Apollo.MutationResult<CreateNoteTravelItemMutation>;
export type CreateNoteTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateNoteTravelItemMutation, CreateNoteTravelItemMutationVariables>;
export const CreateFlightTravelItemDocument = gql`
    mutation CreateFlightTravelItem($payload: CreateFlightTravelItemPayload!) {
  createFlightTravelItem(payload: $payload) {
    code
    id
    name
    notes
    type
    url
  }
}
    `;
export type CreateFlightTravelItemMutationFn = Apollo.MutationFunction<CreateFlightTravelItemMutation, CreateFlightTravelItemMutationVariables>;

/**
 * __useCreateFlightTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateFlightTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFlightTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFlightTravelItemMutation, { data, loading, error }] = useCreateFlightTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateFlightTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFlightTravelItemMutation, CreateFlightTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFlightTravelItemMutation, CreateFlightTravelItemMutationVariables>(CreateFlightTravelItemDocument, baseOptions);
      }
export type CreateFlightTravelItemMutationHookResult = ReturnType<typeof useCreateFlightTravelItemMutation>;
export type CreateFlightTravelItemMutationResult = Apollo.MutationResult<CreateFlightTravelItemMutation>;
export type CreateFlightTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateFlightTravelItemMutation, CreateFlightTravelItemMutationVariables>;
export const CreateRentalCarTravelItemDocument = gql`
    mutation CreateRentalCarTravelItem($payload: CreateRentalCarTravelItemPayload!) {
  createRentalCarTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateRentalCarTravelItemMutationFn = Apollo.MutationFunction<CreateRentalCarTravelItemMutation, CreateRentalCarTravelItemMutationVariables>;

/**
 * __useCreateRentalCarTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateRentalCarTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentalCarTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentalCarTravelItemMutation, { data, loading, error }] = useCreateRentalCarTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRentalCarTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRentalCarTravelItemMutation, CreateRentalCarTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRentalCarTravelItemMutation, CreateRentalCarTravelItemMutationVariables>(CreateRentalCarTravelItemDocument, baseOptions);
      }
export type CreateRentalCarTravelItemMutationHookResult = ReturnType<typeof useCreateRentalCarTravelItemMutation>;
export type CreateRentalCarTravelItemMutationResult = Apollo.MutationResult<CreateRentalCarTravelItemMutation>;
export type CreateRentalCarTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateRentalCarTravelItemMutation, CreateRentalCarTravelItemMutationVariables>;
export const CreateTaxiTravelItemDocument = gql`
    mutation CreateTaxiTravelItem($payload: CreateTaxiTravelItemPayload!) {
  createTaxiTravelItem(payload: $payload) {
    address
    id
    name
    placeId
    notes
    telephone
    type
    url
  }
}
    `;
export type CreateTaxiTravelItemMutationFn = Apollo.MutationFunction<CreateTaxiTravelItemMutation, CreateTaxiTravelItemMutationVariables>;

/**
 * __useCreateTaxiTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateTaxiTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxiTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxiTravelItemMutation, { data, loading, error }] = useCreateTaxiTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateTaxiTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaxiTravelItemMutation, CreateTaxiTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTaxiTravelItemMutation, CreateTaxiTravelItemMutationVariables>(CreateTaxiTravelItemDocument, baseOptions);
      }
export type CreateTaxiTravelItemMutationHookResult = ReturnType<typeof useCreateTaxiTravelItemMutation>;
export type CreateTaxiTravelItemMutationResult = Apollo.MutationResult<CreateTaxiTravelItemMutation>;
export type CreateTaxiTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateTaxiTravelItemMutation, CreateTaxiTravelItemMutationVariables>;
export const CreateFerryTravelItemDocument = gql`
    mutation CreateFerryTravelItem($payload: CreateFerryTravelItemPayload!) {
  createFerryTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateFerryTravelItemMutationFn = Apollo.MutationFunction<CreateFerryTravelItemMutation, CreateFerryTravelItemMutationVariables>;

/**
 * __useCreateFerryTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateFerryTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFerryTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFerryTravelItemMutation, { data, loading, error }] = useCreateFerryTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateFerryTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFerryTravelItemMutation, CreateFerryTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFerryTravelItemMutation, CreateFerryTravelItemMutationVariables>(CreateFerryTravelItemDocument, baseOptions);
      }
export type CreateFerryTravelItemMutationHookResult = ReturnType<typeof useCreateFerryTravelItemMutation>;
export type CreateFerryTravelItemMutationResult = Apollo.MutationResult<CreateFerryTravelItemMutation>;
export type CreateFerryTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateFerryTravelItemMutation, CreateFerryTravelItemMutationVariables>;
export const CreateTrainTravelItemDocument = gql`
    mutation CreateTrainTravelItem($payload: CreateTrainTravelItemPayload!) {
  createTrainTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateTrainTravelItemMutationFn = Apollo.MutationFunction<CreateTrainTravelItemMutation, CreateTrainTravelItemMutationVariables>;

/**
 * __useCreateTrainTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateTrainTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainTravelItemMutation, { data, loading, error }] = useCreateTrainTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateTrainTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTrainTravelItemMutation, CreateTrainTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTrainTravelItemMutation, CreateTrainTravelItemMutationVariables>(CreateTrainTravelItemDocument, baseOptions);
      }
export type CreateTrainTravelItemMutationHookResult = ReturnType<typeof useCreateTrainTravelItemMutation>;
export type CreateTrainTravelItemMutationResult = Apollo.MutationResult<CreateTrainTravelItemMutation>;
export type CreateTrainTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateTrainTravelItemMutation, CreateTrainTravelItemMutationVariables>;
export const CreateHotelTravelItemDocument = gql`
    mutation CreateHotelTravelItem($payload: CreateHotelTravelItemPayload!) {
  createHotelTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateHotelTravelItemMutationFn = Apollo.MutationFunction<CreateHotelTravelItemMutation, CreateHotelTravelItemMutationVariables>;

/**
 * __useCreateHotelTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateHotelTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotelTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHotelTravelItemMutation, { data, loading, error }] = useCreateHotelTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateHotelTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHotelTravelItemMutation, CreateHotelTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateHotelTravelItemMutation, CreateHotelTravelItemMutationVariables>(CreateHotelTravelItemDocument, baseOptions);
      }
export type CreateHotelTravelItemMutationHookResult = ReturnType<typeof useCreateHotelTravelItemMutation>;
export type CreateHotelTravelItemMutationResult = Apollo.MutationResult<CreateHotelTravelItemMutation>;
export type CreateHotelTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateHotelTravelItemMutation, CreateHotelTravelItemMutationVariables>;
export const CreateTentTravelItemDocument = gql`
    mutation CreateTentTravelItem($payload: CreateTentTravelItemPayload!) {
  createTentTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateTentTravelItemMutationFn = Apollo.MutationFunction<CreateTentTravelItemMutation, CreateTentTravelItemMutationVariables>;

/**
 * __useCreateTentTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateTentTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTentTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTentTravelItemMutation, { data, loading, error }] = useCreateTentTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateTentTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTentTravelItemMutation, CreateTentTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTentTravelItemMutation, CreateTentTravelItemMutationVariables>(CreateTentTravelItemDocument, baseOptions);
      }
export type CreateTentTravelItemMutationHookResult = ReturnType<typeof useCreateTentTravelItemMutation>;
export type CreateTentTravelItemMutationResult = Apollo.MutationResult<CreateTentTravelItemMutation>;
export type CreateTentTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateTentTravelItemMutation, CreateTentTravelItemMutationVariables>;
export const CreateRentalHomeTravelItemDocument = gql`
    mutation CreateRentalHomeTravelItem($payload: CreateRentalHomeTravelItemPayload!) {
  createRentalHomeTravelItem(payload: $payload) {
    address
    id
    name
    notes
    placeId
    telephone
    type
    url
  }
}
    `;
export type CreateRentalHomeTravelItemMutationFn = Apollo.MutationFunction<CreateRentalHomeTravelItemMutation, CreateRentalHomeTravelItemMutationVariables>;

/**
 * __useCreateRentalHomeTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateRentalHomeTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentalHomeTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentalHomeTravelItemMutation, { data, loading, error }] = useCreateRentalHomeTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRentalHomeTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRentalHomeTravelItemMutation, CreateRentalHomeTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRentalHomeTravelItemMutation, CreateRentalHomeTravelItemMutationVariables>(CreateRentalHomeTravelItemDocument, baseOptions);
      }
export type CreateRentalHomeTravelItemMutationHookResult = ReturnType<typeof useCreateRentalHomeTravelItemMutation>;
export type CreateRentalHomeTravelItemMutationResult = Apollo.MutationResult<CreateRentalHomeTravelItemMutation>;
export type CreateRentalHomeTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateRentalHomeTravelItemMutation, CreateRentalHomeTravelItemMutationVariables>;
export const CreateShuttleTravelItemDocument = gql`
    mutation CreateShuttleTravelItem($payload: CreateShuttleTravelItemPayload!) {
  createShuttleTravelItem(payload: $payload) {
    id
    items {
      endTime {
        dateString
        timezone
        timestamp
      }
      note
      timezone
      url
      title
      id
      startTime {
        timezone
        dateString
        timestamp
      }
    }
  }
}
    `;
export type CreateShuttleTravelItemMutationFn = Apollo.MutationFunction<CreateShuttleTravelItemMutation, CreateShuttleTravelItemMutationVariables>;

/**
 * __useCreateShuttleTravelItemMutation__
 *
 * To run a mutation, you first call `useCreateShuttleTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShuttleTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShuttleTravelItemMutation, { data, loading, error }] = useCreateShuttleTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateShuttleTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShuttleTravelItemMutation, CreateShuttleTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateShuttleTravelItemMutation, CreateShuttleTravelItemMutationVariables>(CreateShuttleTravelItemDocument, baseOptions);
      }
export type CreateShuttleTravelItemMutationHookResult = ReturnType<typeof useCreateShuttleTravelItemMutation>;
export type CreateShuttleTravelItemMutationResult = Apollo.MutationResult<CreateShuttleTravelItemMutation>;
export type CreateShuttleTravelItemMutationOptions = Apollo.BaseMutationOptions<CreateShuttleTravelItemMutation, CreateShuttleTravelItemMutationVariables>;
export const UpdateBookingTravelItemDocument = gql`
    mutation UpdateBookingTravelItem($payload: UpdateBookingTravelItemPayload!) {
  updateBookingTravelItem(payload: $payload) {
    id
    type
    name
  }
}
    `;
export type UpdateBookingTravelItemMutationFn = Apollo.MutationFunction<UpdateBookingTravelItemMutation, UpdateBookingTravelItemMutationVariables>;

/**
 * __useUpdateBookingTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateBookingTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingTravelItemMutation, { data, loading, error }] = useUpdateBookingTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateBookingTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookingTravelItemMutation, UpdateBookingTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookingTravelItemMutation, UpdateBookingTravelItemMutationVariables>(UpdateBookingTravelItemDocument, baseOptions);
      }
export type UpdateBookingTravelItemMutationHookResult = ReturnType<typeof useUpdateBookingTravelItemMutation>;
export type UpdateBookingTravelItemMutationResult = Apollo.MutationResult<UpdateBookingTravelItemMutation>;
export type UpdateBookingTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateBookingTravelItemMutation, UpdateBookingTravelItemMutationVariables>;
export const UpdateListTravelItemDocument = gql`
    mutation UpdateListTravelItem($payload: UpdateListTravelItemPayload!) {
  updateListTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateListTravelItemMutationFn = Apollo.MutationFunction<UpdateListTravelItemMutation, UpdateListTravelItemMutationVariables>;

/**
 * __useUpdateListTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateListTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListTravelItemMutation, { data, loading, error }] = useUpdateListTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateListTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateListTravelItemMutation, UpdateListTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateListTravelItemMutation, UpdateListTravelItemMutationVariables>(UpdateListTravelItemDocument, baseOptions);
      }
export type UpdateListTravelItemMutationHookResult = ReturnType<typeof useUpdateListTravelItemMutation>;
export type UpdateListTravelItemMutationResult = Apollo.MutationResult<UpdateListTravelItemMutation>;
export type UpdateListTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateListTravelItemMutation, UpdateListTravelItemMutationVariables>;
export const UpdateNoteTravelItemDocument = gql`
    mutation UpdateNoteTravelItem($payload: UpdateNoteTravelItemPayload!) {
  updateNoteTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateNoteTravelItemMutationFn = Apollo.MutationFunction<UpdateNoteTravelItemMutation, UpdateNoteTravelItemMutationVariables>;

/**
 * __useUpdateNoteTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateNoteTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteTravelItemMutation, { data, loading, error }] = useUpdateNoteTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateNoteTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNoteTravelItemMutation, UpdateNoteTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateNoteTravelItemMutation, UpdateNoteTravelItemMutationVariables>(UpdateNoteTravelItemDocument, baseOptions);
      }
export type UpdateNoteTravelItemMutationHookResult = ReturnType<typeof useUpdateNoteTravelItemMutation>;
export type UpdateNoteTravelItemMutationResult = Apollo.MutationResult<UpdateNoteTravelItemMutation>;
export type UpdateNoteTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateNoteTravelItemMutation, UpdateNoteTravelItemMutationVariables>;
export const UpdateFlightTravelItemDocument = gql`
    mutation UpdateFlightTravelItem($payload: UpdateFlightTravelItemPayload!) {
  updateFlightTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateFlightTravelItemMutationFn = Apollo.MutationFunction<UpdateFlightTravelItemMutation, UpdateFlightTravelItemMutationVariables>;

/**
 * __useUpdateFlightTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateFlightTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlightTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFlightTravelItemMutation, { data, loading, error }] = useUpdateFlightTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateFlightTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFlightTravelItemMutation, UpdateFlightTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFlightTravelItemMutation, UpdateFlightTravelItemMutationVariables>(UpdateFlightTravelItemDocument, baseOptions);
      }
export type UpdateFlightTravelItemMutationHookResult = ReturnType<typeof useUpdateFlightTravelItemMutation>;
export type UpdateFlightTravelItemMutationResult = Apollo.MutationResult<UpdateFlightTravelItemMutation>;
export type UpdateFlightTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateFlightTravelItemMutation, UpdateFlightTravelItemMutationVariables>;
export const UpdateRentalCarTravelItemDocument = gql`
    mutation UpdateRentalCarTravelItem($payload: UpdateRentalCarTravelItemPayload!) {
  updateRentalCarTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateRentalCarTravelItemMutationFn = Apollo.MutationFunction<UpdateRentalCarTravelItemMutation, UpdateRentalCarTravelItemMutationVariables>;

/**
 * __useUpdateRentalCarTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateRentalCarTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentalCarTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentalCarTravelItemMutation, { data, loading, error }] = useUpdateRentalCarTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRentalCarTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRentalCarTravelItemMutation, UpdateRentalCarTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRentalCarTravelItemMutation, UpdateRentalCarTravelItemMutationVariables>(UpdateRentalCarTravelItemDocument, baseOptions);
      }
export type UpdateRentalCarTravelItemMutationHookResult = ReturnType<typeof useUpdateRentalCarTravelItemMutation>;
export type UpdateRentalCarTravelItemMutationResult = Apollo.MutationResult<UpdateRentalCarTravelItemMutation>;
export type UpdateRentalCarTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateRentalCarTravelItemMutation, UpdateRentalCarTravelItemMutationVariables>;
export const UpdateTaxiTravelItemDocument = gql`
    mutation UpdateTaxiTravelItem($payload: UpdateTaxiTravelItemPayload!) {
  updateTaxiTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateTaxiTravelItemMutationFn = Apollo.MutationFunction<UpdateTaxiTravelItemMutation, UpdateTaxiTravelItemMutationVariables>;

/**
 * __useUpdateTaxiTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateTaxiTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxiTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxiTravelItemMutation, { data, loading, error }] = useUpdateTaxiTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTaxiTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaxiTravelItemMutation, UpdateTaxiTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTaxiTravelItemMutation, UpdateTaxiTravelItemMutationVariables>(UpdateTaxiTravelItemDocument, baseOptions);
      }
export type UpdateTaxiTravelItemMutationHookResult = ReturnType<typeof useUpdateTaxiTravelItemMutation>;
export type UpdateTaxiTravelItemMutationResult = Apollo.MutationResult<UpdateTaxiTravelItemMutation>;
export type UpdateTaxiTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateTaxiTravelItemMutation, UpdateTaxiTravelItemMutationVariables>;
export const UpdateFerryTravelItemDocument = gql`
    mutation UpdateFerryTravelItem($payload: UpdateFerryTravelItemPayload!) {
  updateFerryTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateFerryTravelItemMutationFn = Apollo.MutationFunction<UpdateFerryTravelItemMutation, UpdateFerryTravelItemMutationVariables>;

/**
 * __useUpdateFerryTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateFerryTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFerryTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFerryTravelItemMutation, { data, loading, error }] = useUpdateFerryTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateFerryTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFerryTravelItemMutation, UpdateFerryTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFerryTravelItemMutation, UpdateFerryTravelItemMutationVariables>(UpdateFerryTravelItemDocument, baseOptions);
      }
export type UpdateFerryTravelItemMutationHookResult = ReturnType<typeof useUpdateFerryTravelItemMutation>;
export type UpdateFerryTravelItemMutationResult = Apollo.MutationResult<UpdateFerryTravelItemMutation>;
export type UpdateFerryTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateFerryTravelItemMutation, UpdateFerryTravelItemMutationVariables>;
export const UpdateTrainTravelItemDocument = gql`
    mutation UpdateTrainTravelItem($payload: UpdateTrainTravelItemPayload!) {
  updateTrainTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateTrainTravelItemMutationFn = Apollo.MutationFunction<UpdateTrainTravelItemMutation, UpdateTrainTravelItemMutationVariables>;

/**
 * __useUpdateTrainTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateTrainTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainTravelItemMutation, { data, loading, error }] = useUpdateTrainTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTrainTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTrainTravelItemMutation, UpdateTrainTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTrainTravelItemMutation, UpdateTrainTravelItemMutationVariables>(UpdateTrainTravelItemDocument, baseOptions);
      }
export type UpdateTrainTravelItemMutationHookResult = ReturnType<typeof useUpdateTrainTravelItemMutation>;
export type UpdateTrainTravelItemMutationResult = Apollo.MutationResult<UpdateTrainTravelItemMutation>;
export type UpdateTrainTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateTrainTravelItemMutation, UpdateTrainTravelItemMutationVariables>;
export const UpdateHotelTravelItemDocument = gql`
    mutation UpdateHotelTravelItem($payload: UpdateHotelTravelItemPayload!) {
  updateHotelTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateHotelTravelItemMutationFn = Apollo.MutationFunction<UpdateHotelTravelItemMutation, UpdateHotelTravelItemMutationVariables>;

/**
 * __useUpdateHotelTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateHotelTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotelTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHotelTravelItemMutation, { data, loading, error }] = useUpdateHotelTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateHotelTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHotelTravelItemMutation, UpdateHotelTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateHotelTravelItemMutation, UpdateHotelTravelItemMutationVariables>(UpdateHotelTravelItemDocument, baseOptions);
      }
export type UpdateHotelTravelItemMutationHookResult = ReturnType<typeof useUpdateHotelTravelItemMutation>;
export type UpdateHotelTravelItemMutationResult = Apollo.MutationResult<UpdateHotelTravelItemMutation>;
export type UpdateHotelTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateHotelTravelItemMutation, UpdateHotelTravelItemMutationVariables>;
export const UpdateTentTravelItemDocument = gql`
    mutation UpdateTentTravelItem($payload: UpdateTentTravelItemPayload!) {
  updateTentTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateTentTravelItemMutationFn = Apollo.MutationFunction<UpdateTentTravelItemMutation, UpdateTentTravelItemMutationVariables>;

/**
 * __useUpdateTentTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateTentTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTentTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTentTravelItemMutation, { data, loading, error }] = useUpdateTentTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTentTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTentTravelItemMutation, UpdateTentTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTentTravelItemMutation, UpdateTentTravelItemMutationVariables>(UpdateTentTravelItemDocument, baseOptions);
      }
export type UpdateTentTravelItemMutationHookResult = ReturnType<typeof useUpdateTentTravelItemMutation>;
export type UpdateTentTravelItemMutationResult = Apollo.MutationResult<UpdateTentTravelItemMutation>;
export type UpdateTentTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateTentTravelItemMutation, UpdateTentTravelItemMutationVariables>;
export const UpdateRentalHomeTravelItemDocument = gql`
    mutation UpdateRentalHomeTravelItem($payload: UpdateRentalHomeTravelItemPayload!) {
  updateRentalHomeTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateRentalHomeTravelItemMutationFn = Apollo.MutationFunction<UpdateRentalHomeTravelItemMutation, UpdateRentalHomeTravelItemMutationVariables>;

/**
 * __useUpdateRentalHomeTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateRentalHomeTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentalHomeTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentalHomeTravelItemMutation, { data, loading, error }] = useUpdateRentalHomeTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRentalHomeTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRentalHomeTravelItemMutation, UpdateRentalHomeTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRentalHomeTravelItemMutation, UpdateRentalHomeTravelItemMutationVariables>(UpdateRentalHomeTravelItemDocument, baseOptions);
      }
export type UpdateRentalHomeTravelItemMutationHookResult = ReturnType<typeof useUpdateRentalHomeTravelItemMutation>;
export type UpdateRentalHomeTravelItemMutationResult = Apollo.MutationResult<UpdateRentalHomeTravelItemMutation>;
export type UpdateRentalHomeTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateRentalHomeTravelItemMutation, UpdateRentalHomeTravelItemMutationVariables>;
export const UpdateShuttleTravelItemDocument = gql`
    mutation UpdateShuttleTravelItem($payload: UpdateShuttleTravelItemPayload!) {
  updateShuttleTravelItem(payload: $payload) {
    id
    name
    type
  }
}
    `;
export type UpdateShuttleTravelItemMutationFn = Apollo.MutationFunction<UpdateShuttleTravelItemMutation, UpdateShuttleTravelItemMutationVariables>;

/**
 * __useUpdateShuttleTravelItemMutation__
 *
 * To run a mutation, you first call `useUpdateShuttleTravelItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShuttleTravelItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShuttleTravelItemMutation, { data, loading, error }] = useUpdateShuttleTravelItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateShuttleTravelItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShuttleTravelItemMutation, UpdateShuttleTravelItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateShuttleTravelItemMutation, UpdateShuttleTravelItemMutationVariables>(UpdateShuttleTravelItemDocument, baseOptions);
      }
export type UpdateShuttleTravelItemMutationHookResult = ReturnType<typeof useUpdateShuttleTravelItemMutation>;
export type UpdateShuttleTravelItemMutationResult = Apollo.MutationResult<UpdateShuttleTravelItemMutation>;
export type UpdateShuttleTravelItemMutationOptions = Apollo.BaseMutationOptions<UpdateShuttleTravelItemMutation, UpdateShuttleTravelItemMutationVariables>;
export const EventVenueAccommodationPlacesV2PhotosDocument = gql`
    query EventVenueAccommodationPlacesV2Photos($name: String!) {
  eventByName(name: $name) {
    id
    accommodationPlacesV2 {
      id
      photo {
        id
        url
        altTag
      }
    }
  }
}
    `;

/**
 * __useEventVenueAccommodationPlacesV2PhotosQuery__
 *
 * To run a query within a React component, call `useEventVenueAccommodationPlacesV2PhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventVenueAccommodationPlacesV2PhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventVenueAccommodationPlacesV2PhotosQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEventVenueAccommodationPlacesV2PhotosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventVenueAccommodationPlacesV2PhotosQuery, EventVenueAccommodationPlacesV2PhotosQueryVariables>) {
        return ApolloReactHooks.useQuery<EventVenueAccommodationPlacesV2PhotosQuery, EventVenueAccommodationPlacesV2PhotosQueryVariables>(EventVenueAccommodationPlacesV2PhotosDocument, baseOptions);
      }
export function useEventVenueAccommodationPlacesV2PhotosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventVenueAccommodationPlacesV2PhotosQuery, EventVenueAccommodationPlacesV2PhotosQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventVenueAccommodationPlacesV2PhotosQuery, EventVenueAccommodationPlacesV2PhotosQueryVariables>(EventVenueAccommodationPlacesV2PhotosDocument, baseOptions);
        }
export type EventVenueAccommodationPlacesV2PhotosQueryHookResult = ReturnType<typeof useEventVenueAccommodationPlacesV2PhotosQuery>;
export type EventVenueAccommodationPlacesV2PhotosLazyQueryHookResult = ReturnType<typeof useEventVenueAccommodationPlacesV2PhotosLazyQuery>;
export type EventVenueAccommodationPlacesV2PhotosQueryResult = Apollo.QueryResult<EventVenueAccommodationPlacesV2PhotosQuery, EventVenueAccommodationPlacesV2PhotosQueryVariables>;
export const WebsiteEditorOldPagesDocument = gql`
    query WebsiteEditorOldPages($name: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $name) {
    id
    firebaseId
    info {
      id
      eventPassword
    }
    eventDesign(purpose: $purpose) {
      id
      websiteLayout {
        id
        layoutType
      }
    }
    pages(admin: true) {
      ...EventPage
      visibility
    }
  }
}
    ${EventPageFragmentDoc}`;

/**
 * __useWebsiteEditorOldPagesQuery__
 *
 * To run a query within a React component, call `useWebsiteEditorOldPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteEditorOldPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteEditorOldPagesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteEditorOldPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteEditorOldPagesQuery, WebsiteEditorOldPagesQueryVariables>) {
        return ApolloReactHooks.useQuery<WebsiteEditorOldPagesQuery, WebsiteEditorOldPagesQueryVariables>(WebsiteEditorOldPagesDocument, baseOptions);
      }
export function useWebsiteEditorOldPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteEditorOldPagesQuery, WebsiteEditorOldPagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WebsiteEditorOldPagesQuery, WebsiteEditorOldPagesQueryVariables>(WebsiteEditorOldPagesDocument, baseOptions);
        }
export type WebsiteEditorOldPagesQueryHookResult = ReturnType<typeof useWebsiteEditorOldPagesQuery>;
export type WebsiteEditorOldPagesLazyQueryHookResult = ReturnType<typeof useWebsiteEditorOldPagesLazyQuery>;
export type WebsiteEditorOldPagesQueryResult = Apollo.QueryResult<WebsiteEditorOldPagesQuery, WebsiteEditorOldPagesQueryVariables>;
export const UpdateWebsiteEditorOldPageDocument = gql`
    mutation UpdateWebsiteEditorOldPage($updateEventPagePayload: UpdateEventPagePayload!, $pageId: ID!) {
  updateEventPage(id: $pageId, payload: $updateEventPagePayload) {
    id
    pageSubTitleV0918
  }
}
    `;
export type UpdateWebsiteEditorOldPageMutationFn = Apollo.MutationFunction<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>;

/**
 * __useUpdateWebsiteEditorOldPageMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEditorOldPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEditorOldPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEditorOldPageMutation, { data, loading, error }] = useUpdateWebsiteEditorOldPageMutation({
 *   variables: {
 *      updateEventPagePayload: // value for 'updateEventPagePayload'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useUpdateWebsiteEditorOldPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>(UpdateWebsiteEditorOldPageDocument, baseOptions);
      }
export type UpdateWebsiteEditorOldPageMutationHookResult = ReturnType<typeof useUpdateWebsiteEditorOldPageMutation>;
export type UpdateWebsiteEditorOldPageMutationResult = Apollo.MutationResult<UpdateWebsiteEditorOldPageMutation>;
export type UpdateWebsiteEditorOldPageMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>;
export const WebsiteOverviewInfoDocument = gql`
    query WebsiteOverviewInfo($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    photoV2Url
    photo {
      id
      url
    }
    info(admin: true) {
      id
      eventPassword
    }
    productVerticals {
      optOutOfGuestList
    }
    pages(admin: true) {
      ...PageDetails
    }
    eventDesign(purpose: $purpose) {
      id
      websiteLayout {
        id
        layoutType
      }
      activeWebsiteHeaderPresentationLayout {
        id: eventId
        schemaURL
        websiteLayout
        dataJSON
      }
    }
    pageContainers {
      id
      mainPhotoAlignment {
        x
        y
      }
      ...CustomPagePhotoPresentationInfo
    }
    checklist {
      id
      title
      items {
        ...WebsiteOverviewChecklistItem
      }
    }
  }
}
    ${PageDetailsFragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}
${WebsiteOverviewChecklistItemFragmentDoc}`;

/**
 * __useWebsiteOverviewInfoQuery__
 *
 * To run a query within a React component, call `useWebsiteOverviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteOverviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteOverviewInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteOverviewInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>(WebsiteOverviewInfoDocument, baseOptions);
      }
export function useWebsiteOverviewInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>(WebsiteOverviewInfoDocument, baseOptions);
        }
export type WebsiteOverviewInfoQueryHookResult = ReturnType<typeof useWebsiteOverviewInfoQuery>;
export type WebsiteOverviewInfoLazyQueryHookResult = ReturnType<typeof useWebsiteOverviewInfoLazyQuery>;
export type WebsiteOverviewInfoQueryResult = Apollo.QueryResult<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>;
export const MediaCollectionsDocument = gql`
    query MediaCollections($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    mediaInfo {
      mediaCount
      thumbnails {
        ... on MediaPhoto {
          id
          photo {
            id
            url
            height
            width
          }
        }
      }
    }
    mediaCollections {
      id
      createdAt {
        dateString(dateFormat: long)
        timestamp
      }
      name
      magicTokenPermissions
      mediaCount
      thumbnails {
        ... on MediaPhoto {
          id
          photo {
            id
            url
            height
            width
          }
          createdAt {
            dateString(dateFormat: long)
            timestamp
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMediaCollectionsQuery__
 *
 * To run a query within a React component, call `useMediaCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useMediaCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionsQuery, MediaCollectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<MediaCollectionsQuery, MediaCollectionsQueryVariables>(MediaCollectionsDocument, baseOptions);
      }
export function useMediaCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionsQuery, MediaCollectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MediaCollectionsQuery, MediaCollectionsQueryVariables>(MediaCollectionsDocument, baseOptions);
        }
export type MediaCollectionsQueryHookResult = ReturnType<typeof useMediaCollectionsQuery>;
export type MediaCollectionsLazyQueryHookResult = ReturnType<typeof useMediaCollectionsLazyQuery>;
export type MediaCollectionsQueryResult = Apollo.QueryResult<MediaCollectionsQuery, MediaCollectionsQueryVariables>;
export const MediaCollectionByIdDocument = gql`
    query MediaCollectionById($mediaCollectionById: ID!) {
  mediaCollectionById(id: $mediaCollectionById) {
    id
    name
    mediaCount
    sortBy
    sortDirection
    media {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          height
          width
        }
      }
    }
    thumbnails {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          height
          width
        }
        createdAt {
          dateString(dateFormat: long)
          timestamp
        }
      }
    }
    createdAt {
      dateString(dateFormat: long)
      timestamp
    }
  }
}
    `;

/**
 * __useMediaCollectionByIdQuery__
 *
 * To run a query within a React component, call `useMediaCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionByIdQuery({
 *   variables: {
 *      mediaCollectionById: // value for 'mediaCollectionById'
 *   },
 * });
 */
export function useMediaCollectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>(MediaCollectionByIdDocument, baseOptions);
      }
export function useMediaCollectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>(MediaCollectionByIdDocument, baseOptions);
        }
export type MediaCollectionByIdQueryHookResult = ReturnType<typeof useMediaCollectionByIdQuery>;
export type MediaCollectionByIdLazyQueryHookResult = ReturnType<typeof useMediaCollectionByIdLazyQuery>;
export type MediaCollectionByIdQueryResult = Apollo.QueryResult<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>;
export const CreateMediaCollectionDocument = gql`
    mutation CreateMediaCollection($payload: CreateMediaCollectionInput!) {
  createMediaCollection(payload: $payload) {
    id
    name
  }
}
    `;
export type CreateMediaCollectionMutationFn = Apollo.MutationFunction<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>;

/**
 * __useCreateMediaCollectionMutation__
 *
 * To run a mutation, you first call `useCreateMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaCollectionMutation, { data, loading, error }] = useCreateMediaCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>(CreateMediaCollectionDocument, baseOptions);
      }
export type CreateMediaCollectionMutationHookResult = ReturnType<typeof useCreateMediaCollectionMutation>;
export type CreateMediaCollectionMutationResult = Apollo.MutationResult<CreateMediaCollectionMutation>;
export type CreateMediaCollectionMutationOptions = Apollo.BaseMutationOptions<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>;
export const UpdateMediaCollectionDocument = gql`
    mutation UpdateMediaCollection($payload: UpdateMediaCollectionInput!) {
  updateMediaCollection(payload: $payload) {
    id
    name
    sortBy
    sortDirection
  }
}
    `;
export type UpdateMediaCollectionMutationFn = Apollo.MutationFunction<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>;

/**
 * __useUpdateMediaCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaCollectionMutation, { data, loading, error }] = useUpdateMediaCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>(UpdateMediaCollectionDocument, baseOptions);
      }
export type UpdateMediaCollectionMutationHookResult = ReturnType<typeof useUpdateMediaCollectionMutation>;
export type UpdateMediaCollectionMutationResult = Apollo.MutationResult<UpdateMediaCollectionMutation>;
export type UpdateMediaCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>;
export const DeleteMediaCollectionDocument = gql`
    mutation DeleteMediaCollection($deleteMediaCollectionId: ID!) {
  deleteMediaCollection(id: $deleteMediaCollectionId)
}
    `;
export type DeleteMediaCollectionMutationFn = Apollo.MutationFunction<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>;

/**
 * __useDeleteMediaCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaCollectionMutation, { data, loading, error }] = useDeleteMediaCollectionMutation({
 *   variables: {
 *      deleteMediaCollectionId: // value for 'deleteMediaCollectionId'
 *   },
 * });
 */
export function useDeleteMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>(DeleteMediaCollectionDocument, baseOptions);
      }
export type DeleteMediaCollectionMutationHookResult = ReturnType<typeof useDeleteMediaCollectionMutation>;
export type DeleteMediaCollectionMutationResult = Apollo.MutationResult<DeleteMediaCollectionMutation>;
export type DeleteMediaCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>;
export const CreateMediaPhotoDocument = gql`
    mutation CreateMediaPhoto($payload: createMediaPhotoInput!) {
  createMediaPhoto(payload: $payload) {
    id
    photo {
      id
      url
      height
      width
    }
  }
}
    `;
export type CreateMediaPhotoMutationFn = Apollo.MutationFunction<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>;

/**
 * __useCreateMediaPhotoMutation__
 *
 * To run a mutation, you first call `useCreateMediaPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaPhotoMutation, { data, loading, error }] = useCreateMediaPhotoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMediaPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>(CreateMediaPhotoDocument, baseOptions);
      }
export type CreateMediaPhotoMutationHookResult = ReturnType<typeof useCreateMediaPhotoMutation>;
export type CreateMediaPhotoMutationResult = Apollo.MutationResult<CreateMediaPhotoMutation>;
export type CreateMediaPhotoMutationOptions = Apollo.BaseMutationOptions<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>;
export const AddMediaToCollectionDocument = gql`
    mutation AddMediaToCollection($payload: addMediaToCollectionInput) {
  addMediaToCollection(payload: $payload) {
    id
    name
    media {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          height
          width
        }
      }
    }
  }
}
    `;
export type AddMediaToCollectionMutationFn = Apollo.MutationFunction<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>;

/**
 * __useAddMediaToCollectionMutation__
 *
 * To run a mutation, you first call `useAddMediaToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaToCollectionMutation, { data, loading, error }] = useAddMediaToCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddMediaToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>(AddMediaToCollectionDocument, baseOptions);
      }
export type AddMediaToCollectionMutationHookResult = ReturnType<typeof useAddMediaToCollectionMutation>;
export type AddMediaToCollectionMutationResult = Apollo.MutationResult<AddMediaToCollectionMutation>;
export type AddMediaToCollectionMutationOptions = Apollo.BaseMutationOptions<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>;
export const AddMediaToCollectionV2Document = gql`
    mutation AddMediaToCollectionV2($payload: addMediaToCollectionInputV2) {
  addMediaToCollectionV2(payload: $payload) {
    ... on addMediaToCollectionResponse {
      mediaCollection {
        id
      }
      newMedia {
        ... on MediaPhoto {
          id
        }
      }
    }
    ... on addMediaToCollectionResponseError {
      failedMediaIds
      newMedia {
        ... on MediaPhoto {
          id
        }
      }
    }
    ... on MutationResponse {
      success
      message
    }
  }
}
    `;
export type AddMediaToCollectionV2MutationFn = Apollo.MutationFunction<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>;

/**
 * __useAddMediaToCollectionV2Mutation__
 *
 * To run a mutation, you first call `useAddMediaToCollectionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaToCollectionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaToCollectionV2Mutation, { data, loading, error }] = useAddMediaToCollectionV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddMediaToCollectionV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>) {
        return ApolloReactHooks.useMutation<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>(AddMediaToCollectionV2Document, baseOptions);
      }
export type AddMediaToCollectionV2MutationHookResult = ReturnType<typeof useAddMediaToCollectionV2Mutation>;
export type AddMediaToCollectionV2MutationResult = Apollo.MutationResult<AddMediaToCollectionV2Mutation>;
export type AddMediaToCollectionV2MutationOptions = Apollo.BaseMutationOptions<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>;
export const RemoveMediaFromCollectionDocument = gql`
    mutation RemoveMediaFromCollection($payload: removeMediaFromCollectionInput) {
  removeMediaFromCollection(payload: $payload) {
    id
    name
  }
}
    `;
export type RemoveMediaFromCollectionMutationFn = Apollo.MutationFunction<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>;

/**
 * __useRemoveMediaFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveMediaFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMediaFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMediaFromCollectionMutation, { data, loading, error }] = useRemoveMediaFromCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRemoveMediaFromCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>(RemoveMediaFromCollectionDocument, baseOptions);
      }
export type RemoveMediaFromCollectionMutationHookResult = ReturnType<typeof useRemoveMediaFromCollectionMutation>;
export type RemoveMediaFromCollectionMutationResult = Apollo.MutationResult<RemoveMediaFromCollectionMutation>;
export type RemoveMediaFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($mediaId: ID!) {
  deleteMedia(id: $mediaId)
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<DeleteMediaMutation, DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMediaMutation, DeleteMediaMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, baseOptions);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const GetMediaCollectionMagicTokenDocument = gql`
    query GetMediaCollectionMagicToken($collectionId: ID!) {
  mediaCollectionMagicToken(id: $collectionId)
}
    `;

/**
 * __useGetMediaCollectionMagicTokenQuery__
 *
 * To run a query within a React component, call `useGetMediaCollectionMagicTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaCollectionMagicTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaCollectionMagicTokenQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetMediaCollectionMagicTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>(GetMediaCollectionMagicTokenDocument, baseOptions);
      }
export function useGetMediaCollectionMagicTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>(GetMediaCollectionMagicTokenDocument, baseOptions);
        }
export type GetMediaCollectionMagicTokenQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenQuery>;
export type GetMediaCollectionMagicTokenLazyQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenLazyQuery>;
export type GetMediaCollectionMagicTokenQueryResult = Apollo.QueryResult<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>;
export const GetMediaCollectionMagicTokenV2Document = gql`
    query GetMediaCollectionMagicTokenV2($collectionId: ID!) {
  mediaCollectionMagicTokenV2(id: $collectionId) {
    token
    permissions
    disabled
  }
}
    `;

/**
 * __useGetMediaCollectionMagicTokenV2Query__
 *
 * To run a query within a React component, call `useGetMediaCollectionMagicTokenV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaCollectionMagicTokenV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaCollectionMagicTokenV2Query({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetMediaCollectionMagicTokenV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>) {
        return ApolloReactHooks.useQuery<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>(GetMediaCollectionMagicTokenV2Document, baseOptions);
      }
export function useGetMediaCollectionMagicTokenV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>(GetMediaCollectionMagicTokenV2Document, baseOptions);
        }
export type GetMediaCollectionMagicTokenV2QueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenV2Query>;
export type GetMediaCollectionMagicTokenV2LazyQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenV2LazyQuery>;
export type GetMediaCollectionMagicTokenV2QueryResult = Apollo.QueryResult<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>;
export const GenerateMagicTokenForMediaCollectionDocument = gql`
    mutation GenerateMagicTokenForMediaCollection($collectionId: ID!) {
  generateMagicTokenForMediaCollection(collectionId: $collectionId)
}
    `;
export type GenerateMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>;

/**
 * __useGenerateMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useGenerateMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMagicTokenForMediaCollectionMutation, { data, loading, error }] = useGenerateMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGenerateMagicTokenForMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>(GenerateMagicTokenForMediaCollectionDocument, baseOptions);
      }
export type GenerateMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useGenerateMagicTokenForMediaCollectionMutation>;
export type GenerateMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<GenerateMagicTokenForMediaCollectionMutation>;
export type GenerateMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>;
export const RemoveMagicTokenFromMediaCollectionDocument = gql`
    mutation RemoveMagicTokenFromMediaCollection($collectionId: ID!) {
  removeMagicTokenFromMediaCollection(collectionId: $collectionId)
}
    `;
export type RemoveMagicTokenFromMediaCollectionMutationFn = Apollo.MutationFunction<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>;

/**
 * __useRemoveMagicTokenFromMediaCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveMagicTokenFromMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMagicTokenFromMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMagicTokenFromMediaCollectionMutation, { data, loading, error }] = useRemoveMagicTokenFromMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useRemoveMagicTokenFromMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>(RemoveMagicTokenFromMediaCollectionDocument, baseOptions);
      }
export type RemoveMagicTokenFromMediaCollectionMutationHookResult = ReturnType<typeof useRemoveMagicTokenFromMediaCollectionMutation>;
export type RemoveMagicTokenFromMediaCollectionMutationResult = Apollo.MutationResult<RemoveMagicTokenFromMediaCollectionMutation>;
export type RemoveMagicTokenFromMediaCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>;
export const DisableMagicTokenForMediaCollectionDocument = gql`
    mutation DisableMagicTokenForMediaCollection($collectionId: ID!) {
  disableMagicTokenForMediaCollection(collectionId: $collectionId)
}
    `;
export type DisableMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>;

/**
 * __useDisableMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useDisableMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMagicTokenForMediaCollectionMutation, { data, loading, error }] = useDisableMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDisableMagicTokenForMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>(DisableMagicTokenForMediaCollectionDocument, baseOptions);
      }
export type DisableMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useDisableMagicTokenForMediaCollectionMutation>;
export type DisableMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<DisableMagicTokenForMediaCollectionMutation>;
export type DisableMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>;
export const EnableMagicTokenForMediaCollectionDocument = gql`
    mutation EnableMagicTokenForMediaCollection($collectionId: ID!) {
  enableMagicTokenForMediaCollection(collectionId: $collectionId)
}
    `;
export type EnableMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>;

/**
 * __useEnableMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useEnableMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMagicTokenForMediaCollectionMutation, { data, loading, error }] = useEnableMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useEnableMagicTokenForMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>(EnableMagicTokenForMediaCollectionDocument, baseOptions);
      }
export type EnableMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useEnableMagicTokenForMediaCollectionMutation>;
export type EnableMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<EnableMagicTokenForMediaCollectionMutation>;
export type EnableMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>;
export const SetMediaTokenPermissionsDocument = gql`
    mutation SetMediaTokenPermissions($payload: setMediaTokenPermissionsInput) {
  setMediaTokenPermissions(payload: $payload)
}
    `;
export type SetMediaTokenPermissionsMutationFn = Apollo.MutationFunction<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>;

/**
 * __useSetMediaTokenPermissionsMutation__
 *
 * To run a mutation, you first call `useSetMediaTokenPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMediaTokenPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMediaTokenPermissionsMutation, { data, loading, error }] = useSetMediaTokenPermissionsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetMediaTokenPermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>) {
        return ApolloReactHooks.useMutation<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>(SetMediaTokenPermissionsDocument, baseOptions);
      }
export type SetMediaTokenPermissionsMutationHookResult = ReturnType<typeof useSetMediaTokenPermissionsMutation>;
export type SetMediaTokenPermissionsMutationResult = Apollo.MutationResult<SetMediaTokenPermissionsMutation>;
export type SetMediaTokenPermissionsMutationOptions = Apollo.BaseMutationOptions<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>;
export const UploadPhotosFromUrlsDocument = gql`
    mutation UploadPhotosFromUrls($payload: [UploadPhotoFromUrlPayload!]!) {
  uploadPhotosFromUrls(payload: $payload) {
    id
  }
}
    `;
export type UploadPhotosFromUrlsMutationFn = Apollo.MutationFunction<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>;

/**
 * __useUploadPhotosFromUrlsMutation__
 *
 * To run a mutation, you first call `useUploadPhotosFromUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotosFromUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotosFromUrlsMutation, { data, loading, error }] = useUploadPhotosFromUrlsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadPhotosFromUrlsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>(UploadPhotosFromUrlsDocument, baseOptions);
      }
export type UploadPhotosFromUrlsMutationHookResult = ReturnType<typeof useUploadPhotosFromUrlsMutation>;
export type UploadPhotosFromUrlsMutationResult = Apollo.MutationResult<UploadPhotosFromUrlsMutation>;
export type UploadPhotosFromUrlsMutationOptions = Apollo.BaseMutationOptions<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>;
export const GetEventMediaDocument = gql`
    query GetEventMedia($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    media {
      ... on MediaPhoto {
        id
        createdAt {
          milliseconds
        }
        photo {
          id
          url
          height
          width
          assetId
          mimeType
          fileSize
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventMediaQuery__
 *
 * To run a query within a React component, call `useGetEventMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMediaQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
      }
export function useGetEventMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
        }
export type GetEventMediaQueryHookResult = ReturnType<typeof useGetEventMediaQuery>;
export type GetEventMediaLazyQueryHookResult = ReturnType<typeof useGetEventMediaLazyQuery>;
export type GetEventMediaQueryResult = Apollo.QueryResult<GetEventMediaQuery, GetEventMediaQueryVariables>;
export const UploadMediaFromUrlsDocument = gql`
    mutation UploadMediaFromUrls($payload: createMediaFromUrlsInput!) {
  uploadMediaFromUrls(payload: $payload) {
    id
    uploadId
    name
    status
    attemptInMs
    uploads {
      id
      assetId
      status
      photo {
        id
        url
        height
        width
      }
    }
  }
}
    `;
export type UploadMediaFromUrlsMutationFn = Apollo.MutationFunction<UploadMediaFromUrlsMutation, UploadMediaFromUrlsMutationVariables>;

/**
 * __useUploadMediaFromUrlsMutation__
 *
 * To run a mutation, you first call `useUploadMediaFromUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaFromUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaFromUrlsMutation, { data, loading, error }] = useUploadMediaFromUrlsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadMediaFromUrlsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadMediaFromUrlsMutation, UploadMediaFromUrlsMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadMediaFromUrlsMutation, UploadMediaFromUrlsMutationVariables>(UploadMediaFromUrlsDocument, baseOptions);
      }
export type UploadMediaFromUrlsMutationHookResult = ReturnType<typeof useUploadMediaFromUrlsMutation>;
export type UploadMediaFromUrlsMutationResult = Apollo.MutationResult<UploadMediaFromUrlsMutation>;
export type UploadMediaFromUrlsMutationOptions = Apollo.BaseMutationOptions<UploadMediaFromUrlsMutation, UploadMediaFromUrlsMutationVariables>;
export const UploadMediaStatusDocument = gql`
    query UploadMediaStatus($eventId: ID!, $uploadId: ID!) {
  uploadMediaStatus(eventId: $eventId, uploadId: $uploadId) {
    id
    uploadId
    name
    status
    attemptInMs
    uploads {
      id
      assetId
      status
      photo {
        id
        url
        height
        width
      }
    }
  }
}
    `;

/**
 * __useUploadMediaStatusQuery__
 *
 * To run a query within a React component, call `useUploadMediaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadMediaStatusQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUploadMediaStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>(UploadMediaStatusDocument, baseOptions);
      }
export function useUploadMediaStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>(UploadMediaStatusDocument, baseOptions);
        }
export type UploadMediaStatusQueryHookResult = ReturnType<typeof useUploadMediaStatusQuery>;
export type UploadMediaStatusLazyQueryHookResult = ReturnType<typeof useUploadMediaStatusLazyQuery>;
export type UploadMediaStatusQueryResult = Apollo.QueryResult<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>;
export const SendContactCollectorMessagesDocument = gql`
    mutation SendContactCollectorMessages($input: SendContactCollectorMessagesInput!) {
  sendContactCollectorMessages(input: $input) {
    messageBatchId
    sentEmails
    sentSms
    skippedEmails
    skippedSms
    quarantined
  }
}
    `;
export type SendContactCollectorMessagesMutationFn = Apollo.MutationFunction<SendContactCollectorMessagesMutation, SendContactCollectorMessagesMutationVariables>;

/**
 * __useSendContactCollectorMessagesMutation__
 *
 * To run a mutation, you first call `useSendContactCollectorMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactCollectorMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactCollectorMessagesMutation, { data, loading, error }] = useSendContactCollectorMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactCollectorMessagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendContactCollectorMessagesMutation, SendContactCollectorMessagesMutationVariables>) {
        return ApolloReactHooks.useMutation<SendContactCollectorMessagesMutation, SendContactCollectorMessagesMutationVariables>(SendContactCollectorMessagesDocument, baseOptions);
      }
export type SendContactCollectorMessagesMutationHookResult = ReturnType<typeof useSendContactCollectorMessagesMutation>;
export type SendContactCollectorMessagesMutationResult = Apollo.MutationResult<SendContactCollectorMessagesMutation>;
export type SendContactCollectorMessagesMutationOptions = Apollo.BaseMutationOptions<SendContactCollectorMessagesMutation, SendContactCollectorMessagesMutationVariables>;
export const GetMessagingTierDocument = gql`
    query GetMessagingTier($eventId: ID!) {
  getMessagingSettingsByEventId(eventId: $eventId) {
    id
    messagingTier
  }
}
    `;

/**
 * __useGetMessagingTierQuery__
 *
 * To run a query within a React component, call `useGetMessagingTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingTierQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingTierQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingTierQuery, GetMessagingTierQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagingTierQuery, GetMessagingTierQueryVariables>(GetMessagingTierDocument, baseOptions);
      }
export function useGetMessagingTierLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingTierQuery, GetMessagingTierQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagingTierQuery, GetMessagingTierQueryVariables>(GetMessagingTierDocument, baseOptions);
        }
export type GetMessagingTierQueryHookResult = ReturnType<typeof useGetMessagingTierQuery>;
export type GetMessagingTierLazyQueryHookResult = ReturnType<typeof useGetMessagingTierLazyQuery>;
export type GetMessagingTierQueryResult = Apollo.QueryResult<GetMessagingTierQuery, GetMessagingTierQueryVariables>;
export const CreateMessagingPlusCheckoutDocument = gql`
    mutation CreateMessagingPlusCheckout($data: CreateJoyFeatureCheckoutInput!) {
  createJoyFeatureCheckout(data: $data) {
    checkoutUrl
  }
}
    `;
export type CreateMessagingPlusCheckoutMutationFn = Apollo.MutationFunction<CreateMessagingPlusCheckoutMutation, CreateMessagingPlusCheckoutMutationVariables>;

/**
 * __useCreateMessagingPlusCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateMessagingPlusCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessagingPlusCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessagingPlusCheckoutMutation, { data, loading, error }] = useCreateMessagingPlusCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMessagingPlusCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMessagingPlusCheckoutMutation, CreateMessagingPlusCheckoutMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMessagingPlusCheckoutMutation, CreateMessagingPlusCheckoutMutationVariables>(CreateMessagingPlusCheckoutDocument, baseOptions);
      }
export type CreateMessagingPlusCheckoutMutationHookResult = ReturnType<typeof useCreateMessagingPlusCheckoutMutation>;
export type CreateMessagingPlusCheckoutMutationResult = Apollo.MutationResult<CreateMessagingPlusCheckoutMutation>;
export type CreateMessagingPlusCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateMessagingPlusCheckoutMutation, CreateMessagingPlusCheckoutMutationVariables>;
export const GetUserStationeryOrdersDocument = gql`
    query GetUserStationeryOrders($ownerId: ID!, $eventId: ID) {
  stationeryPrintOrders(filters: {ownerId: $ownerId, eventId: $eventId}) {
    count
    orders {
      id
      orderNumber
      currentStatus
      ownerId
      shippingAddress {
        name
        address1
        address2
        city
        region
        postalCode
        country
        countryCode
      }
    }
  }
}
    `;

/**
 * __useGetUserStationeryOrdersQuery__
 *
 * To run a query within a React component, call `useGetUserStationeryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStationeryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStationeryOrdersQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetUserStationeryOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserStationeryOrdersQuery, GetUserStationeryOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserStationeryOrdersQuery, GetUserStationeryOrdersQueryVariables>(GetUserStationeryOrdersDocument, baseOptions);
      }
export function useGetUserStationeryOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserStationeryOrdersQuery, GetUserStationeryOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserStationeryOrdersQuery, GetUserStationeryOrdersQueryVariables>(GetUserStationeryOrdersDocument, baseOptions);
        }
export type GetUserStationeryOrdersQueryHookResult = ReturnType<typeof useGetUserStationeryOrdersQuery>;
export type GetUserStationeryOrdersLazyQueryHookResult = ReturnType<typeof useGetUserStationeryOrdersLazyQuery>;
export type GetUserStationeryOrdersQueryResult = Apollo.QueryResult<GetUserStationeryOrdersQuery, GetUserStationeryOrdersQueryVariables>;
export const GetMessagingPlusOrdersByEventDocument = gql`
    query GetMessagingPlusOrdersByEvent($eventId: String!) {
  stationeryPrintOrdersByEvent(input: {eventId: $eventId}) {
    orders {
      id
      currentStatus
      vendor
    }
    count
  }
}
    `;

/**
 * __useGetMessagingPlusOrdersByEventQuery__
 *
 * To run a query within a React component, call `useGetMessagingPlusOrdersByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingPlusOrdersByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingPlusOrdersByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingPlusOrdersByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingPlusOrdersByEventQuery, GetMessagingPlusOrdersByEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagingPlusOrdersByEventQuery, GetMessagingPlusOrdersByEventQueryVariables>(GetMessagingPlusOrdersByEventDocument, baseOptions);
      }
export function useGetMessagingPlusOrdersByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingPlusOrdersByEventQuery, GetMessagingPlusOrdersByEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagingPlusOrdersByEventQuery, GetMessagingPlusOrdersByEventQueryVariables>(GetMessagingPlusOrdersByEventDocument, baseOptions);
        }
export type GetMessagingPlusOrdersByEventQueryHookResult = ReturnType<typeof useGetMessagingPlusOrdersByEventQuery>;
export type GetMessagingPlusOrdersByEventLazyQueryHookResult = ReturnType<typeof useGetMessagingPlusOrdersByEventLazyQuery>;
export type GetMessagingPlusOrdersByEventQueryResult = Apollo.QueryResult<GetMessagingPlusOrdersByEventQuery, GetMessagingPlusOrdersByEventQueryVariables>;
export const FormTemplateListDocument = gql`
    query FormTemplateList {
  formTemplateList {
    id
    title
    description
    schemaUrl
    config
    eventCategoryTags
    eventSubTypeTags
    tags
  }
}
    `;

/**
 * __useFormTemplateListQuery__
 *
 * To run a query within a React component, call `useFormTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormTemplateListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormTemplateListQuery, FormTemplateListQueryVariables>) {
        return ApolloReactHooks.useQuery<FormTemplateListQuery, FormTemplateListQueryVariables>(FormTemplateListDocument, baseOptions);
      }
export function useFormTemplateListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormTemplateListQuery, FormTemplateListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormTemplateListQuery, FormTemplateListQueryVariables>(FormTemplateListDocument, baseOptions);
        }
export type FormTemplateListQueryHookResult = ReturnType<typeof useFormTemplateListQuery>;
export type FormTemplateListLazyQueryHookResult = ReturnType<typeof useFormTemplateListLazyQuery>;
export type FormTemplateListQueryResult = Apollo.QueryResult<FormTemplateListQuery, FormTemplateListQueryVariables>;
export const FormByIdDocument = gql`
    query FormById($formByIdId: ID!) {
  formById(id: $formByIdId) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useFormByIdQuery__
 *
 * To run a query within a React component, call `useFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormByIdQuery({
 *   variables: {
 *      formByIdId: // value for 'formByIdId'
 *   },
 * });
 */
export function useFormByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormByIdQuery, FormByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FormByIdQuery, FormByIdQueryVariables>(FormByIdDocument, baseOptions);
      }
export function useFormByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormByIdQuery, FormByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormByIdQuery, FormByIdQueryVariables>(FormByIdDocument, baseOptions);
        }
export type FormByIdQueryHookResult = ReturnType<typeof useFormByIdQuery>;
export type FormByIdLazyQueryHookResult = ReturnType<typeof useFormByIdLazyQuery>;
export type FormByIdQueryResult = Apollo.QueryResult<FormByIdQuery, FormByIdQueryVariables>;
export const FormListByEventIdDocument = gql`
    query FormListByEventId($eventId: ID!) {
  formListByEventId(eventId: $eventId) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useFormListByEventIdQuery__
 *
 * To run a query within a React component, call `useFormListByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormListByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormListByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFormListByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormListByEventIdQuery, FormListByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FormListByEventIdQuery, FormListByEventIdQueryVariables>(FormListByEventIdDocument, baseOptions);
      }
export function useFormListByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormListByEventIdQuery, FormListByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormListByEventIdQuery, FormListByEventIdQueryVariables>(FormListByEventIdDocument, baseOptions);
        }
export type FormListByEventIdQueryHookResult = ReturnType<typeof useFormListByEventIdQuery>;
export type FormListByEventIdLazyQueryHookResult = ReturnType<typeof useFormListByEventIdLazyQuery>;
export type FormListByEventIdQueryResult = Apollo.QueryResult<FormListByEventIdQuery, FormListByEventIdQueryVariables>;
export const FormAnswerListByFormIdDocument = gql`
    query FormAnswerListByFormId($formId: ID!) {
  formAnswerListByFormId(formId: $formId) {
    id
    guestKey
    formId
    questionId
    answerValue
    contact {
      guestKey
      firstName
      lastName
      email
      tags
    }
    questionValue {
      stepName
      stepTitle
      stepDescription
      placeholder
      field
    }
  }
}
    `;

/**
 * __useFormAnswerListByFormIdQuery__
 *
 * To run a query within a React component, call `useFormAnswerListByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormAnswerListByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormAnswerListByFormIdQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormAnswerListByFormIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormAnswerListByFormIdQuery, FormAnswerListByFormIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FormAnswerListByFormIdQuery, FormAnswerListByFormIdQueryVariables>(FormAnswerListByFormIdDocument, baseOptions);
      }
export function useFormAnswerListByFormIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormAnswerListByFormIdQuery, FormAnswerListByFormIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormAnswerListByFormIdQuery, FormAnswerListByFormIdQueryVariables>(FormAnswerListByFormIdDocument, baseOptions);
        }
export type FormAnswerListByFormIdQueryHookResult = ReturnType<typeof useFormAnswerListByFormIdQuery>;
export type FormAnswerListByFormIdLazyQueryHookResult = ReturnType<typeof useFormAnswerListByFormIdLazyQuery>;
export type FormAnswerListByFormIdQueryResult = Apollo.QueryResult<FormAnswerListByFormIdQuery, FormAnswerListByFormIdQueryVariables>;
export const RegistrationFormByEventIdDocument = gql`
    query RegistrationFormByEventId($eventId: ID!) {
  registrationFormByEventId(eventId: $eventId) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useRegistrationFormByEventIdQuery__
 *
 * To run a query within a React component, call `useRegistrationFormByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationFormByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationFormByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRegistrationFormByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistrationFormByEventIdQuery, RegistrationFormByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistrationFormByEventIdQuery, RegistrationFormByEventIdQueryVariables>(RegistrationFormByEventIdDocument, baseOptions);
      }
export function useRegistrationFormByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistrationFormByEventIdQuery, RegistrationFormByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistrationFormByEventIdQuery, RegistrationFormByEventIdQueryVariables>(RegistrationFormByEventIdDocument, baseOptions);
        }
export type RegistrationFormByEventIdQueryHookResult = ReturnType<typeof useRegistrationFormByEventIdQuery>;
export type RegistrationFormByEventIdLazyQueryHookResult = ReturnType<typeof useRegistrationFormByEventIdLazyQuery>;
export type RegistrationFormByEventIdQueryResult = Apollo.QueryResult<RegistrationFormByEventIdQuery, RegistrationFormByEventIdQueryVariables>;
export const SetFormEnabledDocument = gql`
    mutation SetFormEnabled($formId: ID!, $enabled: Boolean!) {
  setFormEnabled(id: $formId, enabled: $enabled) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type SetFormEnabledMutationFn = Apollo.MutationFunction<SetFormEnabledMutation, SetFormEnabledMutationVariables>;

/**
 * __useSetFormEnabledMutation__
 *
 * To run a mutation, you first call `useSetFormEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFormEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFormEnabledMutation, { data, loading, error }] = useSetFormEnabledMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetFormEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFormEnabledMutation, SetFormEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<SetFormEnabledMutation, SetFormEnabledMutationVariables>(SetFormEnabledDocument, baseOptions);
      }
export type SetFormEnabledMutationHookResult = ReturnType<typeof useSetFormEnabledMutation>;
export type SetFormEnabledMutationResult = Apollo.MutationResult<SetFormEnabledMutation>;
export type SetFormEnabledMutationOptions = Apollo.BaseMutationOptions<SetFormEnabledMutation, SetFormEnabledMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($input: CreateFormInput!) {
  createForm(input: $input) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, baseOptions);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($input: UpdateFormInput!) {
  updateForm(input: $input) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, baseOptions);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const SubmitFormAnswersDocument = gql`
    mutation SubmitFormAnswers($input: SubmitFormAnswersInput!) {
  submitFormAnswers(input: $input) {
    id
  }
}
    `;
export type SubmitFormAnswersMutationFn = Apollo.MutationFunction<SubmitFormAnswersMutation, SubmitFormAnswersMutationVariables>;

/**
 * __useSubmitFormAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitFormAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormAnswersMutation, { data, loading, error }] = useSubmitFormAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFormAnswersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitFormAnswersMutation, SubmitFormAnswersMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitFormAnswersMutation, SubmitFormAnswersMutationVariables>(SubmitFormAnswersDocument, baseOptions);
      }
export type SubmitFormAnswersMutationHookResult = ReturnType<typeof useSubmitFormAnswersMutation>;
export type SubmitFormAnswersMutationResult = Apollo.MutationResult<SubmitFormAnswersMutation>;
export type SubmitFormAnswersMutationOptions = Apollo.BaseMutationOptions<SubmitFormAnswersMutation, SubmitFormAnswersMutationVariables>;
export const GetGuestsRsvpAnswersDocument = gql`
    query GetGuestsRsvpAnswers($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    guests(admin: true) {
      people {
        id
        personIdTag
        legacyRsvpAnswers {
          answer
          questionId
        }
        email
      }
    }
  }
}
    `;

/**
 * __useGetGuestsRsvpAnswersQuery__
 *
 * To run a query within a React component, call `useGetGuestsRsvpAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsRsvpAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsRsvpAnswersQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetGuestsRsvpAnswersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsRsvpAnswersQuery, GetGuestsRsvpAnswersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsRsvpAnswersQuery, GetGuestsRsvpAnswersQueryVariables>(GetGuestsRsvpAnswersDocument, baseOptions);
      }
export function useGetGuestsRsvpAnswersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsRsvpAnswersQuery, GetGuestsRsvpAnswersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsRsvpAnswersQuery, GetGuestsRsvpAnswersQueryVariables>(GetGuestsRsvpAnswersDocument, baseOptions);
        }
export type GetGuestsRsvpAnswersQueryHookResult = ReturnType<typeof useGetGuestsRsvpAnswersQuery>;
export type GetGuestsRsvpAnswersLazyQueryHookResult = ReturnType<typeof useGetGuestsRsvpAnswersLazyQuery>;
export type GetGuestsRsvpAnswersQueryResult = Apollo.QueryResult<GetGuestsRsvpAnswersQuery, GetGuestsRsvpAnswersQueryVariables>;
export const SendRsvpReminderDocument = gql`
    mutation SendRsvpReminder($data: SendRsvpReminderV2Input!) {
  sendRsvpReminderV2(data: $data)
}
    `;
export type SendRsvpReminderMutationFn = Apollo.MutationFunction<SendRsvpReminderMutation, SendRsvpReminderMutationVariables>;

/**
 * __useSendRsvpReminderMutation__
 *
 * To run a mutation, you first call `useSendRsvpReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRsvpReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRsvpReminderMutation, { data, loading, error }] = useSendRsvpReminderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendRsvpReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRsvpReminderMutation, SendRsvpReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRsvpReminderMutation, SendRsvpReminderMutationVariables>(SendRsvpReminderDocument, baseOptions);
      }
export type SendRsvpReminderMutationHookResult = ReturnType<typeof useSendRsvpReminderMutation>;
export type SendRsvpReminderMutationResult = Apollo.MutationResult<SendRsvpReminderMutation>;
export type SendRsvpReminderMutationOptions = Apollo.BaseMutationOptions<SendRsvpReminderMutation, SendRsvpReminderMutationVariables>;
export const SendTestRsvpReminderDocument = gql`
    mutation SendTestRsvpReminder($data: SendTestRsvpReminderV2Input!) {
  sendTestRsvpReminderV2(data: $data)
}
    `;
export type SendTestRsvpReminderMutationFn = Apollo.MutationFunction<SendTestRsvpReminderMutation, SendTestRsvpReminderMutationVariables>;

/**
 * __useSendTestRsvpReminderMutation__
 *
 * To run a mutation, you first call `useSendTestRsvpReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestRsvpReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestRsvpReminderMutation, { data, loading, error }] = useSendTestRsvpReminderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendTestRsvpReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestRsvpReminderMutation, SendTestRsvpReminderMutationVariables>) {
        return ApolloReactHooks.useMutation<SendTestRsvpReminderMutation, SendTestRsvpReminderMutationVariables>(SendTestRsvpReminderDocument, baseOptions);
      }
export type SendTestRsvpReminderMutationHookResult = ReturnType<typeof useSendTestRsvpReminderMutation>;
export type SendTestRsvpReminderMutationResult = Apollo.MutationResult<SendTestRsvpReminderMutation>;
export type SendTestRsvpReminderMutationOptions = Apollo.BaseMutationOptions<SendTestRsvpReminderMutation, SendTestRsvpReminderMutationVariables>;
export const SaveTheDateGetEcardDataDocument = gql`
    query SaveTheDateGetEcardData($eventId: ID!, $ecardType: EcardType) {
  eventById(id: $eventId) {
    ...SaveTheDateEventByIdData
  }
  getMostRecentEcardByEventId(id: $eventId, ecardType: $ecardType) {
    ...SaveTheDateElectronicCard
  }
  getEcardEmailDraftsByEventId(eventId: $eventId, ecardType: $ecardType) {
    ...SaveTheDateEcardEmailDraft
  }
  getEcardLinkOptionsByEventId(id: $eventId) {
    ...ElectronicCardCardLinkOption
  }
}
    ${SaveTheDateEventByIdDataFragmentDoc}
${SaveTheDateElectronicCardFragmentDoc}
${SaveTheDateEcardEmailDraftFragmentDoc}
${ElectronicCardCardLinkOptionFragmentDoc}`;

/**
 * __useSaveTheDateGetEcardDataQuery__
 *
 * To run a query within a React component, call `useSaveTheDateGetEcardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateGetEcardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveTheDateGetEcardDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ecardType: // value for 'ecardType'
 *   },
 * });
 */
export function useSaveTheDateGetEcardDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SaveTheDateGetEcardDataQuery, SaveTheDateGetEcardDataQueryVariables>) {
        return ApolloReactHooks.useQuery<SaveTheDateGetEcardDataQuery, SaveTheDateGetEcardDataQueryVariables>(SaveTheDateGetEcardDataDocument, baseOptions);
      }
export function useSaveTheDateGetEcardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SaveTheDateGetEcardDataQuery, SaveTheDateGetEcardDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SaveTheDateGetEcardDataQuery, SaveTheDateGetEcardDataQueryVariables>(SaveTheDateGetEcardDataDocument, baseOptions);
        }
export type SaveTheDateGetEcardDataQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardDataQuery>;
export type SaveTheDateGetEcardDataLazyQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardDataLazyQuery>;
export type SaveTheDateGetEcardDataQueryResult = Apollo.QueryResult<SaveTheDateGetEcardDataQuery, SaveTheDateGetEcardDataQueryVariables>;
export const SaveTheDateGetEcardByGuidDocument = gql`
    query SaveTheDateGetEcardByGuid($lookupId: ID!) {
  getEcardRecepientDisplayByLookupId(lookupId: $lookupId) {
    ...SaveTheDateGuestElectronicCard
  }
}
    ${SaveTheDateGuestElectronicCardFragmentDoc}`;

/**
 * __useSaveTheDateGetEcardByGuidQuery__
 *
 * To run a query within a React component, call `useSaveTheDateGetEcardByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateGetEcardByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveTheDateGetEcardByGuidQuery({
 *   variables: {
 *      lookupId: // value for 'lookupId'
 *   },
 * });
 */
export function useSaveTheDateGetEcardByGuidQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SaveTheDateGetEcardByGuidQuery, SaveTheDateGetEcardByGuidQueryVariables>) {
        return ApolloReactHooks.useQuery<SaveTheDateGetEcardByGuidQuery, SaveTheDateGetEcardByGuidQueryVariables>(SaveTheDateGetEcardByGuidDocument, baseOptions);
      }
export function useSaveTheDateGetEcardByGuidLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SaveTheDateGetEcardByGuidQuery, SaveTheDateGetEcardByGuidQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SaveTheDateGetEcardByGuidQuery, SaveTheDateGetEcardByGuidQueryVariables>(SaveTheDateGetEcardByGuidDocument, baseOptions);
        }
export type SaveTheDateGetEcardByGuidQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardByGuidQuery>;
export type SaveTheDateGetEcardByGuidLazyQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardByGuidLazyQuery>;
export type SaveTheDateGetEcardByGuidQueryResult = Apollo.QueryResult<SaveTheDateGetEcardByGuidQuery, SaveTheDateGetEcardByGuidQueryVariables>;
export const SaveTheDateGetEcardGuestExtraDataDocument = gql`
    query SaveTheDateGetEcardGuestExtraData($eventId: ID!) {
  eventById(id: $eventId) {
    ...SaveTheDateGuestEventByIdData
  }
  getEcardLinkOptionsByEventId(id: $eventId) {
    ...ElectronicCardCardLinkOption
  }
}
    ${SaveTheDateGuestEventByIdDataFragmentDoc}
${ElectronicCardCardLinkOptionFragmentDoc}`;

/**
 * __useSaveTheDateGetEcardGuestExtraDataQuery__
 *
 * To run a query within a React component, call `useSaveTheDateGetEcardGuestExtraDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateGetEcardGuestExtraDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveTheDateGetEcardGuestExtraDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSaveTheDateGetEcardGuestExtraDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SaveTheDateGetEcardGuestExtraDataQuery, SaveTheDateGetEcardGuestExtraDataQueryVariables>) {
        return ApolloReactHooks.useQuery<SaveTheDateGetEcardGuestExtraDataQuery, SaveTheDateGetEcardGuestExtraDataQueryVariables>(SaveTheDateGetEcardGuestExtraDataDocument, baseOptions);
      }
export function useSaveTheDateGetEcardGuestExtraDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SaveTheDateGetEcardGuestExtraDataQuery, SaveTheDateGetEcardGuestExtraDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SaveTheDateGetEcardGuestExtraDataQuery, SaveTheDateGetEcardGuestExtraDataQueryVariables>(SaveTheDateGetEcardGuestExtraDataDocument, baseOptions);
        }
export type SaveTheDateGetEcardGuestExtraDataQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardGuestExtraDataQuery>;
export type SaveTheDateGetEcardGuestExtraDataLazyQueryHookResult = ReturnType<typeof useSaveTheDateGetEcardGuestExtraDataLazyQuery>;
export type SaveTheDateGetEcardGuestExtraDataQueryResult = Apollo.QueryResult<SaveTheDateGetEcardGuestExtraDataQuery, SaveTheDateGetEcardGuestExtraDataQueryVariables>;
export const SaveTheDateSaveEcardDocument = gql`
    mutation SaveTheDateSaveEcard($payload: ElectronicCardInput!) {
  saveEcard(payload: $payload) {
    id
  }
}
    `;
export type SaveTheDateSaveEcardMutationFn = Apollo.MutationFunction<SaveTheDateSaveEcardMutation, SaveTheDateSaveEcardMutationVariables>;

/**
 * __useSaveTheDateSaveEcardMutation__
 *
 * To run a mutation, you first call `useSaveTheDateSaveEcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateSaveEcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTheDateSaveEcardMutation, { data, loading, error }] = useSaveTheDateSaveEcardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveTheDateSaveEcardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTheDateSaveEcardMutation, SaveTheDateSaveEcardMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveTheDateSaveEcardMutation, SaveTheDateSaveEcardMutationVariables>(SaveTheDateSaveEcardDocument, baseOptions);
      }
export type SaveTheDateSaveEcardMutationHookResult = ReturnType<typeof useSaveTheDateSaveEcardMutation>;
export type SaveTheDateSaveEcardMutationResult = Apollo.MutationResult<SaveTheDateSaveEcardMutation>;
export type SaveTheDateSaveEcardMutationOptions = Apollo.BaseMutationOptions<SaveTheDateSaveEcardMutation, SaveTheDateSaveEcardMutationVariables>;
export const SaveTheDateSaveEcardPhotoDocument = gql`
    mutation SaveTheDateSaveEcardPhoto($payload: ElectronicCardPhotoPayloadInput!) {
  saveEcardPhoto(payload: $payload) {
    id
  }
}
    `;
export type SaveTheDateSaveEcardPhotoMutationFn = Apollo.MutationFunction<SaveTheDateSaveEcardPhotoMutation, SaveTheDateSaveEcardPhotoMutationVariables>;

/**
 * __useSaveTheDateSaveEcardPhotoMutation__
 *
 * To run a mutation, you first call `useSaveTheDateSaveEcardPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateSaveEcardPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTheDateSaveEcardPhotoMutation, { data, loading, error }] = useSaveTheDateSaveEcardPhotoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveTheDateSaveEcardPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTheDateSaveEcardPhotoMutation, SaveTheDateSaveEcardPhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveTheDateSaveEcardPhotoMutation, SaveTheDateSaveEcardPhotoMutationVariables>(SaveTheDateSaveEcardPhotoDocument, baseOptions);
      }
export type SaveTheDateSaveEcardPhotoMutationHookResult = ReturnType<typeof useSaveTheDateSaveEcardPhotoMutation>;
export type SaveTheDateSaveEcardPhotoMutationResult = Apollo.MutationResult<SaveTheDateSaveEcardPhotoMutation>;
export type SaveTheDateSaveEcardPhotoMutationOptions = Apollo.BaseMutationOptions<SaveTheDateSaveEcardPhotoMutation, SaveTheDateSaveEcardPhotoMutationVariables>;
export const SaveTheDateSaveEcardEmailDocument = gql`
    mutation SaveTheDateSaveEcardEmail($payload: ElectronicCardEmailDraftInput) {
  saveEcardEmailDraft(payload: $payload)
}
    `;
export type SaveTheDateSaveEcardEmailMutationFn = Apollo.MutationFunction<SaveTheDateSaveEcardEmailMutation, SaveTheDateSaveEcardEmailMutationVariables>;

/**
 * __useSaveTheDateSaveEcardEmailMutation__
 *
 * To run a mutation, you first call `useSaveTheDateSaveEcardEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateSaveEcardEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTheDateSaveEcardEmailMutation, { data, loading, error }] = useSaveTheDateSaveEcardEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveTheDateSaveEcardEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTheDateSaveEcardEmailMutation, SaveTheDateSaveEcardEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveTheDateSaveEcardEmailMutation, SaveTheDateSaveEcardEmailMutationVariables>(SaveTheDateSaveEcardEmailDocument, baseOptions);
      }
export type SaveTheDateSaveEcardEmailMutationHookResult = ReturnType<typeof useSaveTheDateSaveEcardEmailMutation>;
export type SaveTheDateSaveEcardEmailMutationResult = Apollo.MutationResult<SaveTheDateSaveEcardEmailMutation>;
export type SaveTheDateSaveEcardEmailMutationOptions = Apollo.BaseMutationOptions<SaveTheDateSaveEcardEmailMutation, SaveTheDateSaveEcardEmailMutationVariables>;
export const SaveTheDateSendEcardGuestEmailDocument = gql`
    mutation SaveTheDateSendEcardGuestEmail($payload: ElectronicCardEmailMessageInput) {
  sendEcardGuestEmail(payload: $payload)
}
    `;
export type SaveTheDateSendEcardGuestEmailMutationFn = Apollo.MutationFunction<SaveTheDateSendEcardGuestEmailMutation, SaveTheDateSendEcardGuestEmailMutationVariables>;

/**
 * __useSaveTheDateSendEcardGuestEmailMutation__
 *
 * To run a mutation, you first call `useSaveTheDateSendEcardGuestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTheDateSendEcardGuestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTheDateSendEcardGuestEmailMutation, { data, loading, error }] = useSaveTheDateSendEcardGuestEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveTheDateSendEcardGuestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTheDateSendEcardGuestEmailMutation, SaveTheDateSendEcardGuestEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveTheDateSendEcardGuestEmailMutation, SaveTheDateSendEcardGuestEmailMutationVariables>(SaveTheDateSendEcardGuestEmailDocument, baseOptions);
      }
export type SaveTheDateSendEcardGuestEmailMutationHookResult = ReturnType<typeof useSaveTheDateSendEcardGuestEmailMutation>;
export type SaveTheDateSendEcardGuestEmailMutationResult = Apollo.MutationResult<SaveTheDateSendEcardGuestEmailMutation>;
export type SaveTheDateSendEcardGuestEmailMutationOptions = Apollo.BaseMutationOptions<SaveTheDateSendEcardGuestEmailMutation, SaveTheDateSendEcardGuestEmailMutationVariables>;
export const CreateStationeryDraftFromPrintOrderDocument = gql`
    mutation CreateStationeryDraftFromPrintOrder($data: CreateStationeryDraftFromPrintOrderInput!) {
  createStationeryDraftFromPrintOrder(data: $data) {
    id
    priceConfigId
    stationeryTemplate {
      id
      premium
      themeId
    }
  }
}
    `;
export type CreateStationeryDraftFromPrintOrderMutationFn = Apollo.MutationFunction<CreateStationeryDraftFromPrintOrderMutation, CreateStationeryDraftFromPrintOrderMutationVariables>;

/**
 * __useCreateStationeryDraftFromPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDraftFromPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDraftFromPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDraftFromPrintOrderMutation, { data, loading, error }] = useCreateStationeryDraftFromPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryDraftFromPrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDraftFromPrintOrderMutation, CreateStationeryDraftFromPrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStationeryDraftFromPrintOrderMutation, CreateStationeryDraftFromPrintOrderMutationVariables>(CreateStationeryDraftFromPrintOrderDocument, baseOptions);
      }
export type CreateStationeryDraftFromPrintOrderMutationHookResult = ReturnType<typeof useCreateStationeryDraftFromPrintOrderMutation>;
export type CreateStationeryDraftFromPrintOrderMutationResult = Apollo.MutationResult<CreateStationeryDraftFromPrintOrderMutation>;
export type CreateStationeryDraftFromPrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateStationeryDraftFromPrintOrderMutation, CreateStationeryDraftFromPrintOrderMutationVariables>;
export const SetRecipientSessionIDDocument = gql`
    query SetRecipientSessionID($eventID: ID!, $inviteeID: String!) {
  getRecipientSessionByInviteePID(eventId: $eventID, inviteePID: $inviteeID)
}
    `;

/**
 * __useSetRecipientSessionIDQuery__
 *
 * To run a query within a React component, call `useSetRecipientSessionIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetRecipientSessionIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetRecipientSessionIDQuery({
 *   variables: {
 *      eventID: // value for 'eventID'
 *      inviteeID: // value for 'inviteeID'
 *   },
 * });
 */
export function useSetRecipientSessionIDQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SetRecipientSessionIDQuery, SetRecipientSessionIDQueryVariables>) {
        return ApolloReactHooks.useQuery<SetRecipientSessionIDQuery, SetRecipientSessionIDQueryVariables>(SetRecipientSessionIDDocument, baseOptions);
      }
export function useSetRecipientSessionIDLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SetRecipientSessionIDQuery, SetRecipientSessionIDQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SetRecipientSessionIDQuery, SetRecipientSessionIDQueryVariables>(SetRecipientSessionIDDocument, baseOptions);
        }
export type SetRecipientSessionIDQueryHookResult = ReturnType<typeof useSetRecipientSessionIDQuery>;
export type SetRecipientSessionIDLazyQueryHookResult = ReturnType<typeof useSetRecipientSessionIDLazyQuery>;
export type SetRecipientSessionIDQueryResult = Apollo.QueryResult<SetRecipientSessionIDQuery, SetRecipientSessionIDQueryVariables>;
export const GetStationaryPrintOrderCardDetailsByOrderNumberDocument = gql`
    query GetStationaryPrintOrderCardDetailsByOrderNumber($orderNumber: String!) {
  stationeryPrintOrderCardDetailsByOrderNumber(orderNumber: $orderNumber) {
    detailsJSONBlob
    digitalEnvelopeImageUrl
    orderId
    eventId
  }
}
    `;

/**
 * __useGetStationaryPrintOrderCardDetailsByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetStationaryPrintOrderCardDetailsByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationaryPrintOrderCardDetailsByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationaryPrintOrderCardDetailsByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetStationaryPrintOrderCardDetailsByOrderNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationaryPrintOrderCardDetailsByOrderNumberQuery, GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationaryPrintOrderCardDetailsByOrderNumberQuery, GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables>(GetStationaryPrintOrderCardDetailsByOrderNumberDocument, baseOptions);
      }
export function useGetStationaryPrintOrderCardDetailsByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationaryPrintOrderCardDetailsByOrderNumberQuery, GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationaryPrintOrderCardDetailsByOrderNumberQuery, GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables>(GetStationaryPrintOrderCardDetailsByOrderNumberDocument, baseOptions);
        }
export type GetStationaryPrintOrderCardDetailsByOrderNumberQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderCardDetailsByOrderNumberQuery>;
export type GetStationaryPrintOrderCardDetailsByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderCardDetailsByOrderNumberLazyQuery>;
export type GetStationaryPrintOrderCardDetailsByOrderNumberQueryResult = Apollo.QueryResult<GetStationaryPrintOrderCardDetailsByOrderNumberQuery, GetStationaryPrintOrderCardDetailsByOrderNumberQueryVariables>;
export const GetStationeryEntitiesCountForNavigationByEventIdDocument = gql`
    query GetStationeryEntitiesCountForNavigationByEventId($eventId: ID!, $input: StationeryDraftsByEventInput!) {
  stationeryDraftsCount: stationeryDraftsByEvent(input: $input) {
    id
    cardJSON
  }
  digitalInvitationDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: invitation) {
    id
  }
  digitalSaveTheDateDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: savethedate) {
    id
  }
  digitalPhotoSaveTheDateDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: savethedatephoto) {
    id
  }
  digitalCustomDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: custom) {
    id
  }
  stationeryFavoritesCount: stationeryTemplatesContainer(filter: {eventIdsFavorites: [$eventId]}, includeOptions: {includeFavoritesByEventIds: [$eventId]}) {
    pagedResults(first: 99999) {
      totalCount
    }
  }
}
    `;

/**
 * __useGetStationeryEntitiesCountForNavigationByEventIdQuery__
 *
 * To run a query within a React component, call `useGetStationeryEntitiesCountForNavigationByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryEntitiesCountForNavigationByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryEntitiesCountForNavigationByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStationeryEntitiesCountForNavigationByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryEntitiesCountForNavigationByEventIdQuery, GetStationeryEntitiesCountForNavigationByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationeryEntitiesCountForNavigationByEventIdQuery, GetStationeryEntitiesCountForNavigationByEventIdQueryVariables>(GetStationeryEntitiesCountForNavigationByEventIdDocument, baseOptions);
      }
export function useGetStationeryEntitiesCountForNavigationByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryEntitiesCountForNavigationByEventIdQuery, GetStationeryEntitiesCountForNavigationByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationeryEntitiesCountForNavigationByEventIdQuery, GetStationeryEntitiesCountForNavigationByEventIdQueryVariables>(GetStationeryEntitiesCountForNavigationByEventIdDocument, baseOptions);
        }
export type GetStationeryEntitiesCountForNavigationByEventIdQueryHookResult = ReturnType<typeof useGetStationeryEntitiesCountForNavigationByEventIdQuery>;
export type GetStationeryEntitiesCountForNavigationByEventIdLazyQueryHookResult = ReturnType<typeof useGetStationeryEntitiesCountForNavigationByEventIdLazyQuery>;
export type GetStationeryEntitiesCountForNavigationByEventIdQueryResult = Apollo.QueryResult<GetStationeryEntitiesCountForNavigationByEventIdQuery, GetStationeryEntitiesCountForNavigationByEventIdQueryVariables>;
export const StationeryTrackDigitalCardViewDocument = gql`
    mutation StationeryTrackDigitalCardView($data: CreateStationeryDigitalViewInput!) {
  stationeryTrackDigitalCardView(data: $data)
}
    `;
export type StationeryTrackDigitalCardViewMutationFn = Apollo.MutationFunction<StationeryTrackDigitalCardViewMutation, StationeryTrackDigitalCardViewMutationVariables>;

/**
 * __useStationeryTrackDigitalCardViewMutation__
 *
 * To run a mutation, you first call `useStationeryTrackDigitalCardViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationeryTrackDigitalCardViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationeryTrackDigitalCardViewMutation, { data, loading, error }] = useStationeryTrackDigitalCardViewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationeryTrackDigitalCardViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StationeryTrackDigitalCardViewMutation, StationeryTrackDigitalCardViewMutationVariables>) {
        return ApolloReactHooks.useMutation<StationeryTrackDigitalCardViewMutation, StationeryTrackDigitalCardViewMutationVariables>(StationeryTrackDigitalCardViewDocument, baseOptions);
      }
export type StationeryTrackDigitalCardViewMutationHookResult = ReturnType<typeof useStationeryTrackDigitalCardViewMutation>;
export type StationeryTrackDigitalCardViewMutationResult = Apollo.MutationResult<StationeryTrackDigitalCardViewMutation>;
export type StationeryTrackDigitalCardViewMutationOptions = Apollo.BaseMutationOptions<StationeryTrackDigitalCardViewMutation, StationeryTrackDigitalCardViewMutationVariables>;
export const GetCurrencyConversionsDocument = gql`
    query GetCurrencyConversions {
  currencyConversions {
    currencyCode
    exchangeRate
    taxesAndFeesMultiplier
    precision
    fixedCostPerCardInMinorUnits
  }
}
    `;

/**
 * __useGetCurrencyConversionsQuery__
 *
 * To run a query within a React component, call `useGetCurrencyConversionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyConversionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyConversionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyConversionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrencyConversionsQuery, GetCurrencyConversionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrencyConversionsQuery, GetCurrencyConversionsQueryVariables>(GetCurrencyConversionsDocument, baseOptions);
      }
export function useGetCurrencyConversionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrencyConversionsQuery, GetCurrencyConversionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrencyConversionsQuery, GetCurrencyConversionsQueryVariables>(GetCurrencyConversionsDocument, baseOptions);
        }
export type GetCurrencyConversionsQueryHookResult = ReturnType<typeof useGetCurrencyConversionsQuery>;
export type GetCurrencyConversionsLazyQueryHookResult = ReturnType<typeof useGetCurrencyConversionsLazyQuery>;
export type GetCurrencyConversionsQueryResult = Apollo.QueryResult<GetCurrencyConversionsQuery, GetCurrencyConversionsQueryVariables>;
export const GetCurrencyConversionByCodeDocument = gql`
    query GetCurrencyConversionByCode($currencyCode: String!) {
  currencyConversionByCode(currencyCode: $currencyCode) {
    currencyCode
    exchangeRate
    taxesAndFeesMultiplier
    precision
    fixedCostPerCardInMinorUnits
  }
}
    `;

/**
 * __useGetCurrencyConversionByCodeQuery__
 *
 * To run a query within a React component, call `useGetCurrencyConversionByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyConversionByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyConversionByCodeQuery({
 *   variables: {
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useGetCurrencyConversionByCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrencyConversionByCodeQuery, GetCurrencyConversionByCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrencyConversionByCodeQuery, GetCurrencyConversionByCodeQueryVariables>(GetCurrencyConversionByCodeDocument, baseOptions);
      }
export function useGetCurrencyConversionByCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrencyConversionByCodeQuery, GetCurrencyConversionByCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrencyConversionByCodeQuery, GetCurrencyConversionByCodeQueryVariables>(GetCurrencyConversionByCodeDocument, baseOptions);
        }
export type GetCurrencyConversionByCodeQueryHookResult = ReturnType<typeof useGetCurrencyConversionByCodeQuery>;
export type GetCurrencyConversionByCodeLazyQueryHookResult = ReturnType<typeof useGetCurrencyConversionByCodeLazyQuery>;
export type GetCurrencyConversionByCodeQueryResult = Apollo.QueryResult<GetCurrencyConversionByCodeQuery, GetCurrencyConversionByCodeQueryVariables>;
export const GetDataForGreetingCardDocument = gql`
    query GetDataForGreetingCard($ecardId: ID!) {
  getGreetingCardById(id: $ecardId) {
    id
    type
    theme
    cardDetails
    eventId
  }
}
    `;

/**
 * __useGetDataForGreetingCardQuery__
 *
 * To run a query within a React component, call `useGetDataForGreetingCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForGreetingCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForGreetingCardQuery({
 *   variables: {
 *      ecardId: // value for 'ecardId'
 *   },
 * });
 */
export function useGetDataForGreetingCardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>(GetDataForGreetingCardDocument, baseOptions);
      }
export function useGetDataForGreetingCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>(GetDataForGreetingCardDocument, baseOptions);
        }
export type GetDataForGreetingCardQueryHookResult = ReturnType<typeof useGetDataForGreetingCardQuery>;
export type GetDataForGreetingCardLazyQueryHookResult = ReturnType<typeof useGetDataForGreetingCardLazyQuery>;
export type GetDataForGreetingCardQueryResult = Apollo.QueryResult<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>;
export const SaveGreetingCardAndEmailDraftDocument = gql`
    mutation SaveGreetingCardAndEmailDraft($payload: GreetingCardInputWithUrl!) {
  saveGreetingCardAndEmailDraft(payload: $payload) {
    id
  }
}
    `;
export type SaveGreetingCardAndEmailDraftMutationFn = Apollo.MutationFunction<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>;

/**
 * __useSaveGreetingCardAndEmailDraftMutation__
 *
 * To run a mutation, you first call `useSaveGreetingCardAndEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGreetingCardAndEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGreetingCardAndEmailDraftMutation, { data, loading, error }] = useSaveGreetingCardAndEmailDraftMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveGreetingCardAndEmailDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>(SaveGreetingCardAndEmailDraftDocument, baseOptions);
      }
export type SaveGreetingCardAndEmailDraftMutationHookResult = ReturnType<typeof useSaveGreetingCardAndEmailDraftMutation>;
export type SaveGreetingCardAndEmailDraftMutationResult = Apollo.MutationResult<SaveGreetingCardAndEmailDraftMutation>;
export type SaveGreetingCardAndEmailDraftMutationOptions = Apollo.BaseMutationOptions<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>;
export const SaveGreetingCardDocument = gql`
    mutation SaveGreetingCard($payload: GreetingCardInput!) {
  saveGreetingCard(payload: $payload) {
    id
  }
}
    `;
export type SaveGreetingCardMutationFn = Apollo.MutationFunction<SaveGreetingCardMutation, SaveGreetingCardMutationVariables>;

/**
 * __useSaveGreetingCardMutation__
 *
 * To run a mutation, you first call `useSaveGreetingCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGreetingCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGreetingCardMutation, { data, loading, error }] = useSaveGreetingCardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveGreetingCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGreetingCardMutation, SaveGreetingCardMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveGreetingCardMutation, SaveGreetingCardMutationVariables>(SaveGreetingCardDocument, baseOptions);
      }
export type SaveGreetingCardMutationHookResult = ReturnType<typeof useSaveGreetingCardMutation>;
export type SaveGreetingCardMutationResult = Apollo.MutationResult<SaveGreetingCardMutation>;
export type SaveGreetingCardMutationOptions = Apollo.BaseMutationOptions<SaveGreetingCardMutation, SaveGreetingCardMutationVariables>;
export const getCardDataForImagineDocument = gql`
    query getCardDataForImagine($filter: StationeryTemplateFilter!) {
  stationeryTemplatesContainer(filter: $filter, includeOptions: {includeProducts: true}) {
    pagedResults {
      edges {
        node {
          ...StationeryDesignGalleryTemplate
          ...StationeryProducts
          themeJSON
        }
      }
    }
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}
${StationeryProductsFragmentDoc}`;

/**
 * __usegetCardDataForImagineQuery__
 *
 * To run a query within a React component, call `usegetCardDataForImagineQuery` and pass it any options that fit your needs.
 * When your component renders, `usegetCardDataForImagineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usegetCardDataForImagineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usegetCardDataForImagineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<getCardDataForImagineQuery, getCardDataForImagineQueryVariables>) {
        return ApolloReactHooks.useQuery<getCardDataForImagineQuery, getCardDataForImagineQueryVariables>(getCardDataForImagineDocument, baseOptions);
      }
export function usegetCardDataForImagineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getCardDataForImagineQuery, getCardDataForImagineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<getCardDataForImagineQuery, getCardDataForImagineQueryVariables>(getCardDataForImagineDocument, baseOptions);
        }
export type getCardDataForImagineQueryHookResult = ReturnType<typeof usegetCardDataForImagineQuery>;
export type getCardDataForImagineLazyQueryHookResult = ReturnType<typeof usegetCardDataForImagineLazyQuery>;
export type getCardDataForImagineQueryResult = Apollo.QueryResult<getCardDataForImagineQuery, getCardDataForImagineQueryVariables>;
export const addAIBackgroundDocument = gql`
    mutation addAIBackground($promptPayload: AIBackgroundPromptPayload!, $templateId: String!, $m: String, $oomph: Float) {
  stationeryDraftAddAIBackground(promptPayload: $promptPayload, templateId: $templateId, m: $m, oomph: $oomph) {
    type
    promptPayload {
      prompt
      style
    }
    baseUrl
    url
    resourceID
  }
}
    `;
export type addAIBackgroundMutationFn = Apollo.MutationFunction<addAIBackgroundMutation, addAIBackgroundMutationVariables>;

/**
 * __useaddAIBackgroundMutation__
 *
 * To run a mutation, you first call `useaddAIBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useaddAIBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiBackgroundMutation, { data, loading, error }] = useaddAIBackgroundMutation({
 *   variables: {
 *      promptPayload: // value for 'promptPayload'
 *      templateId: // value for 'templateId'
 *      m: // value for 'm'
 *      oomph: // value for 'oomph'
 *   },
 * });
 */
export function useaddAIBackgroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<addAIBackgroundMutation, addAIBackgroundMutationVariables>) {
        return ApolloReactHooks.useMutation<addAIBackgroundMutation, addAIBackgroundMutationVariables>(addAIBackgroundDocument, baseOptions);
      }
export type addAIBackgroundMutationHookResult = ReturnType<typeof useaddAIBackgroundMutation>;
export type addAIBackgroundMutationResult = Apollo.MutationResult<addAIBackgroundMutation>;
export type addAIBackgroundMutationOptions = Apollo.BaseMutationOptions<addAIBackgroundMutation, addAIBackgroundMutationVariables>;
export const modifyAIBackgroundDocument = gql`
    mutation modifyAIBackground($promptPayload: AIBackgroundPromptPayload!, $resourceID: String!, $oomph: Float, $m: String) {
  stationeryDraftModifyAIBackground(promptPayload: $promptPayload, resourceID: $resourceID, oomph: $oomph, m: $m) {
    type
    promptPayload {
      prompt
      style
    }
    baseUrl
    url
    resourceID
  }
}
    `;
export type modifyAIBackgroundMutationFn = Apollo.MutationFunction<modifyAIBackgroundMutation, modifyAIBackgroundMutationVariables>;

/**
 * __usemodifyAIBackgroundMutation__
 *
 * To run a mutation, you first call `usemodifyAIBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usemodifyAIBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyAiBackgroundMutation, { data, loading, error }] = usemodifyAIBackgroundMutation({
 *   variables: {
 *      promptPayload: // value for 'promptPayload'
 *      resourceID: // value for 'resourceID'
 *      oomph: // value for 'oomph'
 *      m: // value for 'm'
 *   },
 * });
 */
export function usemodifyAIBackgroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<modifyAIBackgroundMutation, modifyAIBackgroundMutationVariables>) {
        return ApolloReactHooks.useMutation<modifyAIBackgroundMutation, modifyAIBackgroundMutationVariables>(modifyAIBackgroundDocument, baseOptions);
      }
export type modifyAIBackgroundMutationHookResult = ReturnType<typeof usemodifyAIBackgroundMutation>;
export type modifyAIBackgroundMutationResult = Apollo.MutationResult<modifyAIBackgroundMutation>;
export type modifyAIBackgroundMutationOptions = Apollo.BaseMutationOptions<modifyAIBackgroundMutation, modifyAIBackgroundMutationVariables>;
export const GetRegistryShippingAddressDocument = gql`
    query GetRegistryShippingAddress($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      shippingAddress {
        name
        address1
        address2
        postalCode
        city
        state
        countryCode
        country
        validated
      }
    }
  }
}
    `;

/**
 * __useGetRegistryShippingAddressQuery__
 *
 * To run a query within a React component, call `useGetRegistryShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryShippingAddressQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryShippingAddressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>(GetRegistryShippingAddressDocument, baseOptions);
      }
export function useGetRegistryShippingAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>(GetRegistryShippingAddressDocument, baseOptions);
        }
export type GetRegistryShippingAddressQueryHookResult = ReturnType<typeof useGetRegistryShippingAddressQuery>;
export type GetRegistryShippingAddressLazyQueryHookResult = ReturnType<typeof useGetRegistryShippingAddressLazyQuery>;
export type GetRegistryShippingAddressQueryResult = Apollo.QueryResult<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>;
export const GetStationeryCardDraftByIdDocument = gql`
    query GetStationeryCardDraftById($id: String!) {
  stationeryDraftById(id: $id) {
    cardJSON
    eventId
    format
    stationeryTemplate {
      id
      category
      name
      themeId
      ...StationeryProducts
    }
    product {
      id
    }
    id
  }
}
    ${StationeryProductsFragmentDoc}`;

/**
 * __useGetStationeryCardDraftByIdQuery__
 *
 * To run a query within a React component, call `useGetStationeryCardDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryCardDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryCardDraftByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStationeryCardDraftByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>(GetStationeryCardDraftByIdDocument, baseOptions);
      }
export function useGetStationeryCardDraftByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>(GetStationeryCardDraftByIdDocument, baseOptions);
        }
export type GetStationeryCardDraftByIdQueryHookResult = ReturnType<typeof useGetStationeryCardDraftByIdQuery>;
export type GetStationeryCardDraftByIdLazyQueryHookResult = ReturnType<typeof useGetStationeryCardDraftByIdLazyQuery>;
export type GetStationeryCardDraftByIdQueryResult = Apollo.QueryResult<GetStationeryCardDraftByIdQuery, GetStationeryCardDraftByIdQueryVariables>;
export const GetStationaryPrintOrderByOrderNumberDocument = gql`
    query GetStationaryPrintOrderByOrderNumber($orderNumber: String!) {
  stationeryPrintOrderByOrderNumber(orderNumber: $orderNumber) {
    id
    ...OrderProductDetails
    priceInMinorUnits
    deliveryMethod
    orderNumber
    formLink
    magnetCard
    quantity
    taxInMinorUnits
    printCardFrontPreviewUrl
    printCardBackPreviewUrl
    envelopeBackImageUrl
    envelopeFrontImageUrl
    cardDraftJSONBlob
    cardDraft {
      id
      cardJSON
      format
      stationeryTemplate {
        id
        category
        themeId
        ...StationeryProducts
      }
    }
    statusHistory {
      id
      date
      status
    }
    shippingAddress {
      ...StationeryPrintOrderShippingAddress
    }
    discount {
      code
      discountPercentage: percentage
      discountAmountInMinorUnits: amountInMinorUnits
    }
    issues {
      id
      resolvedAt
      issueType
      issueTarget
    }
  }
}
    ${OrderProductDetailsFragmentDoc}
${StationeryProductsFragmentDoc}
${StationeryPrintOrderShippingAddressFragmentDoc}`;

/**
 * __useGetStationaryPrintOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetStationaryPrintOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationaryPrintOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationaryPrintOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetStationaryPrintOrderByOrderNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>(GetStationaryPrintOrderByOrderNumberDocument, baseOptions);
      }
export function useGetStationaryPrintOrderByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>(GetStationaryPrintOrderByOrderNumberDocument, baseOptions);
        }
export type GetStationaryPrintOrderByOrderNumberQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderByOrderNumberQuery>;
export type GetStationaryPrintOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetStationaryPrintOrderByOrderNumberLazyQuery>;
export type GetStationaryPrintOrderByOrderNumberQueryResult = Apollo.QueryResult<GetStationaryPrintOrderByOrderNumberQuery, GetStationaryPrintOrderByOrderNumberQueryVariables>;
export const GetEventPrivacyForCardCustomizerDocument = gql`
    query GetEventPrivacyForCardCustomizer($eventId: ID!) {
  eventById(id: $eventId) {
    id
    info {
      id
      eventPassword
    }
    settings {
      id
      privacyMode
    }
  }
}
    `;

/**
 * __useGetEventPrivacyForCardCustomizerQuery__
 *
 * To run a query within a React component, call `useGetEventPrivacyForCardCustomizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPrivacyForCardCustomizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPrivacyForCardCustomizerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventPrivacyForCardCustomizerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>(GetEventPrivacyForCardCustomizerDocument, baseOptions);
      }
export function useGetEventPrivacyForCardCustomizerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>(GetEventPrivacyForCardCustomizerDocument, baseOptions);
        }
export type GetEventPrivacyForCardCustomizerQueryHookResult = ReturnType<typeof useGetEventPrivacyForCardCustomizerQuery>;
export type GetEventPrivacyForCardCustomizerLazyQueryHookResult = ReturnType<typeof useGetEventPrivacyForCardCustomizerLazyQuery>;
export type GetEventPrivacyForCardCustomizerQueryResult = Apollo.QueryResult<GetEventPrivacyForCardCustomizerQuery, GetEventPrivacyForCardCustomizerQueryVariables>;
export const EventPagesForCardCustomizerDocument = gql`
    query EventPagesForCardCustomizer($eventId: ID!) {
  eventById(id: $eventId) {
    id
    pages(admin: true) {
      ...EventPage
    }
  }
}
    ${EventPageFragmentDoc}`;

/**
 * __useEventPagesForCardCustomizerQuery__
 *
 * To run a query within a React component, call `useEventPagesForCardCustomizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPagesForCardCustomizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPagesForCardCustomizerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventPagesForCardCustomizerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventPagesForCardCustomizerQuery, EventPagesForCardCustomizerQueryVariables>) {
        return ApolloReactHooks.useQuery<EventPagesForCardCustomizerQuery, EventPagesForCardCustomizerQueryVariables>(EventPagesForCardCustomizerDocument, baseOptions);
      }
export function useEventPagesForCardCustomizerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventPagesForCardCustomizerQuery, EventPagesForCardCustomizerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventPagesForCardCustomizerQuery, EventPagesForCardCustomizerQueryVariables>(EventPagesForCardCustomizerDocument, baseOptions);
        }
export type EventPagesForCardCustomizerQueryHookResult = ReturnType<typeof useEventPagesForCardCustomizerQuery>;
export type EventPagesForCardCustomizerLazyQueryHookResult = ReturnType<typeof useEventPagesForCardCustomizerLazyQuery>;
export type EventPagesForCardCustomizerQueryResult = Apollo.QueryResult<EventPagesForCardCustomizerQuery, EventPagesForCardCustomizerQueryVariables>;
export const CreateStationeryDraftPreviewDocument = gql`
    mutation CreateStationeryDraftPreview($data: CreateStationeryDraftPreviewInput!) {
  createStationeryDraftPreview(data: $data) {
    stationeryPDF
    stationeryFrontImage
    stationeryBackImage
    envelopePDF
    envelopeFrontImage
    envelopeBackImage
  }
}
    `;
export type CreateStationeryDraftPreviewMutationFn = Apollo.MutationFunction<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>;

/**
 * __useCreateStationeryDraftPreviewMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDraftPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDraftPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDraftPreviewMutation, { data, loading, error }] = useCreateStationeryDraftPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryDraftPreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>(CreateStationeryDraftPreviewDocument, baseOptions);
      }
export type CreateStationeryDraftPreviewMutationHookResult = ReturnType<typeof useCreateStationeryDraftPreviewMutation>;
export type CreateStationeryDraftPreviewMutationResult = Apollo.MutationResult<CreateStationeryDraftPreviewMutation>;
export type CreateStationeryDraftPreviewMutationOptions = Apollo.BaseMutationOptions<CreateStationeryDraftPreviewMutation, CreateStationeryDraftPreviewMutationVariables>;
export const CreateStationeryDigitalDraftPreviewDocument = gql`
    mutation CreateStationeryDigitalDraftPreview($data: CreateStationeryDraftPreviewInput!) {
  createStationeryDigitalDraftPreview(data: $data) {
    stationeryFrontImage
    stationeryBackImage
    digitalEnvelopeImage
  }
}
    `;
export type CreateStationeryDigitalDraftPreviewMutationFn = Apollo.MutationFunction<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>;

/**
 * __useCreateStationeryDigitalDraftPreviewMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDigitalDraftPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDigitalDraftPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDigitalDraftPreviewMutation, { data, loading, error }] = useCreateStationeryDigitalDraftPreviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryDigitalDraftPreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>(CreateStationeryDigitalDraftPreviewDocument, baseOptions);
      }
export type CreateStationeryDigitalDraftPreviewMutationHookResult = ReturnType<typeof useCreateStationeryDigitalDraftPreviewMutation>;
export type CreateStationeryDigitalDraftPreviewMutationResult = Apollo.MutationResult<CreateStationeryDigitalDraftPreviewMutation>;
export type CreateStationeryDigitalDraftPreviewMutationOptions = Apollo.BaseMutationOptions<CreateStationeryDigitalDraftPreviewMutation, CreateStationeryDigitalDraftPreviewMutationVariables>;
export const UpdateStationeryDraftDocument = gql`
    mutation UpdateStationeryDraft($payload: UpdateStationeryDraftInput!) {
  updateStationeryDraft(data: $payload) {
    id
    cardJSON
    eventId
    ownerId
    updatedAt
  }
}
    `;
export type UpdateStationeryDraftMutationFn = Apollo.MutationFunction<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>;

/**
 * __useUpdateStationeryDraftMutation__
 *
 * To run a mutation, you first call `useUpdateStationeryDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStationeryDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStationeryDraftMutation, { data, loading, error }] = useUpdateStationeryDraftMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateStationeryDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>(UpdateStationeryDraftDocument, baseOptions);
      }
export type UpdateStationeryDraftMutationHookResult = ReturnType<typeof useUpdateStationeryDraftMutation>;
export type UpdateStationeryDraftMutationResult = Apollo.MutationResult<UpdateStationeryDraftMutation>;
export type UpdateStationeryDraftMutationOptions = Apollo.BaseMutationOptions<UpdateStationeryDraftMutation, UpdateStationeryDraftMutationVariables>;
export const CreateStationeryPrintOrderDocument = gql`
    mutation CreateStationeryPrintOrder($data: CreateStationeryPrintOrderInput!) {
  createStationeryPrintOrder(data: $data) {
    id
    orderNumber
  }
}
    `;
export type CreateStationeryPrintOrderMutationFn = Apollo.MutationFunction<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>;

/**
 * __useCreateStationeryPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateStationeryPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryPrintOrderMutation, { data, loading, error }] = useCreateStationeryPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStationeryPrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>(CreateStationeryPrintOrderDocument, baseOptions);
      }
export type CreateStationeryPrintOrderMutationHookResult = ReturnType<typeof useCreateStationeryPrintOrderMutation>;
export type CreateStationeryPrintOrderMutationResult = Apollo.MutationResult<CreateStationeryPrintOrderMutation>;
export type CreateStationeryPrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateStationeryPrintOrderMutation, CreateStationeryPrintOrderMutationVariables>;
export const StartStationeryCheckoutDocument = gql`
    mutation StartStationeryCheckout($payload: StartStationeryCheckoutInput!) {
  startStationeryCheckout(data: $payload) {
    checkoutUrl
  }
}
    `;
export type StartStationeryCheckoutMutationFn = Apollo.MutationFunction<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>;

/**
 * __useStartStationeryCheckoutMutation__
 *
 * To run a mutation, you first call `useStartStationeryCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStationeryCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStationeryCheckoutMutation, { data, loading, error }] = useStartStationeryCheckoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useStartStationeryCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>) {
        return ApolloReactHooks.useMutation<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>(StartStationeryCheckoutDocument, baseOptions);
      }
export type StartStationeryCheckoutMutationHookResult = ReturnType<typeof useStartStationeryCheckoutMutation>;
export type StartStationeryCheckoutMutationResult = Apollo.MutationResult<StartStationeryCheckoutMutation>;
export type StartStationeryCheckoutMutationOptions = Apollo.BaseMutationOptions<StartStationeryCheckoutMutation, StartStationeryCheckoutMutationVariables>;
export const StartStationeryInternationalCheckoutDocument = gql`
    mutation StartStationeryInternationalCheckout($payload: StartStationeryInternationalCheckoutInput!) {
  startStationeryInternationalCheckout(data: $payload) {
    checkoutUrl
  }
}
    `;
export type StartStationeryInternationalCheckoutMutationFn = Apollo.MutationFunction<StartStationeryInternationalCheckoutMutation, StartStationeryInternationalCheckoutMutationVariables>;

/**
 * __useStartStationeryInternationalCheckoutMutation__
 *
 * To run a mutation, you first call `useStartStationeryInternationalCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStationeryInternationalCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStationeryInternationalCheckoutMutation, { data, loading, error }] = useStartStationeryInternationalCheckoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useStartStationeryInternationalCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartStationeryInternationalCheckoutMutation, StartStationeryInternationalCheckoutMutationVariables>) {
        return ApolloReactHooks.useMutation<StartStationeryInternationalCheckoutMutation, StartStationeryInternationalCheckoutMutationVariables>(StartStationeryInternationalCheckoutDocument, baseOptions);
      }
export type StartStationeryInternationalCheckoutMutationHookResult = ReturnType<typeof useStartStationeryInternationalCheckoutMutation>;
export type StartStationeryInternationalCheckoutMutationResult = Apollo.MutationResult<StartStationeryInternationalCheckoutMutation>;
export type StartStationeryInternationalCheckoutMutationOptions = Apollo.BaseMutationOptions<StartStationeryInternationalCheckoutMutation, StartStationeryInternationalCheckoutMutationVariables>;
export const DeleteStationeryPrintOrderForFailedCheckoutUrlDocument = gql`
    mutation DeleteStationeryPrintOrderForFailedCheckoutUrl($id: ID!) {
  deleteStationeryPrintOrderForFailedCheckoutUrl(id: $id) {
    id
  }
}
    `;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationFn = Apollo.MutationFunction<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>;

/**
 * __useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation__
 *
 * To run a mutation, you first call `useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStationeryPrintOrderForFailedCheckoutUrlMutation, { data, loading, error }] = useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>(DeleteStationeryPrintOrderForFailedCheckoutUrlDocument, baseOptions);
      }
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationHookResult = ReturnType<typeof useDeleteStationeryPrintOrderForFailedCheckoutUrlMutation>;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationResult = Apollo.MutationResult<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation>;
export type DeleteStationeryPrintOrderForFailedCheckoutUrlMutationOptions = Apollo.BaseMutationOptions<DeleteStationeryPrintOrderForFailedCheckoutUrlMutation, DeleteStationeryPrintOrderForFailedCheckoutUrlMutationVariables>;
export const UpdateWebsiteHandleDocument = gql`
    mutation UpdateWebsiteHandle($eventId: ID!, $website: String!) {
  updateWebsiteHandle(id: $eventId, website: $website) {
    id
    website
  }
}
    `;
export type UpdateWebsiteHandleMutationFn = Apollo.MutationFunction<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>;

/**
 * __useUpdateWebsiteHandleMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteHandleMutation, { data, loading, error }] = useUpdateWebsiteHandleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUpdateWebsiteHandleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>(UpdateWebsiteHandleDocument, baseOptions);
      }
export type UpdateWebsiteHandleMutationHookResult = ReturnType<typeof useUpdateWebsiteHandleMutation>;
export type UpdateWebsiteHandleMutationResult = Apollo.MutationResult<UpdateWebsiteHandleMutation>;
export type UpdateWebsiteHandleMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteHandleMutation, UpdateWebsiteHandleMutationVariables>;
export const CreateQRCodeDocument = gql`
    mutation CreateQRCode($data: CreateQRCodeInput!) {
  createQRCode(data: $data)
}
    `;
export type CreateQRCodeMutationFn = Apollo.MutationFunction<CreateQRCodeMutation, CreateQRCodeMutationVariables>;

/**
 * __useCreateQRCodeMutation__
 *
 * To run a mutation, you first call `useCreateQRCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQRCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrCodeMutation, { data, loading, error }] = useCreateQRCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQRCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQRCodeMutation, CreateQRCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateQRCodeMutation, CreateQRCodeMutationVariables>(CreateQRCodeDocument, baseOptions);
      }
export type CreateQRCodeMutationHookResult = ReturnType<typeof useCreateQRCodeMutation>;
export type CreateQRCodeMutationResult = Apollo.MutationResult<CreateQRCodeMutation>;
export type CreateQRCodeMutationOptions = Apollo.BaseMutationOptions<CreateQRCodeMutation, CreateQRCodeMutationVariables>;
export const EditStationeryPrintOrderDocument = gql`
    mutation EditStationeryPrintOrder($data: EditStationeryPrintOrderInput!) {
  editStationeryPrintOrder(data: $data) {
    ...StationeryPrintOrderDetails
  }
}
    ${StationeryPrintOrderDetailsFragmentDoc}`;
export type EditStationeryPrintOrderMutationFn = Apollo.MutationFunction<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>;

/**
 * __useEditStationeryPrintOrderMutation__
 *
 * To run a mutation, you first call `useEditStationeryPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStationeryPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStationeryPrintOrderMutation, { data, loading, error }] = useEditStationeryPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditStationeryPrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>(EditStationeryPrintOrderDocument, baseOptions);
      }
export type EditStationeryPrintOrderMutationHookResult = ReturnType<typeof useEditStationeryPrintOrderMutation>;
export type EditStationeryPrintOrderMutationResult = Apollo.MutationResult<EditStationeryPrintOrderMutation>;
export type EditStationeryPrintOrderMutationOptions = Apollo.BaseMutationOptions<EditStationeryPrintOrderMutation, EditStationeryPrintOrderMutationVariables>;
export const CreateAndStartCheckoutDigitalPrintOrderDocument = gql`
    mutation CreateAndStartCheckoutDigitalPrintOrder($data: CreateDigitalPrintOrderInput!) {
  createAndStartCheckoutDigitalPrintOrder(data: $data) {
    checkoutUrl
  }
}
    `;
export type CreateAndStartCheckoutDigitalPrintOrderMutationFn = Apollo.MutationFunction<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>;

/**
 * __useCreateAndStartCheckoutDigitalPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateAndStartCheckoutDigitalPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndStartCheckoutDigitalPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndStartCheckoutDigitalPrintOrderMutation, { data, loading, error }] = useCreateAndStartCheckoutDigitalPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAndStartCheckoutDigitalPrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>(CreateAndStartCheckoutDigitalPrintOrderDocument, baseOptions);
      }
export type CreateAndStartCheckoutDigitalPrintOrderMutationHookResult = ReturnType<typeof useCreateAndStartCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartCheckoutDigitalPrintOrderMutationResult = Apollo.MutationResult<CreateAndStartCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartCheckoutDigitalPrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateAndStartCheckoutDigitalPrintOrderMutation, CreateAndStartCheckoutDigitalPrintOrderMutationVariables>;
export const CreateAndStartInternationalCheckoutDigitalPrintOrderDocument = gql`
    mutation CreateAndStartInternationalCheckoutDigitalPrintOrder($data: CreateDigitalPrintOrderInput!) {
  createAndStartInternationalCheckoutDigitalPrintOrder(data: $data) {
    checkoutUrl
  }
}
    `;
export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutationFn = Apollo.MutationFunction<CreateAndStartInternationalCheckoutDigitalPrintOrderMutation, CreateAndStartInternationalCheckoutDigitalPrintOrderMutationVariables>;

/**
 * __useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndStartInternationalCheckoutDigitalPrintOrderMutation, { data, loading, error }] = useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndStartInternationalCheckoutDigitalPrintOrderMutation, CreateAndStartInternationalCheckoutDigitalPrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndStartInternationalCheckoutDigitalPrintOrderMutation, CreateAndStartInternationalCheckoutDigitalPrintOrderMutationVariables>(CreateAndStartInternationalCheckoutDigitalPrintOrderDocument, baseOptions);
      }
export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutationHookResult = ReturnType<typeof useCreateAndStartInternationalCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutationResult = Apollo.MutationResult<CreateAndStartInternationalCheckoutDigitalPrintOrderMutation>;
export type CreateAndStartInternationalCheckoutDigitalPrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateAndStartInternationalCheckoutDigitalPrintOrderMutation, CreateAndStartInternationalCheckoutDigitalPrintOrderMutationVariables>;
export const AddStationeryPrintOrderIssuesDocument = gql`
    mutation AddStationeryPrintOrderIssues($stationeryPrintOrderId: ID!, $data: [CreateStationeryPrintOrderIssueInput!]!) {
  addStationeryPrintOrderIssues(stationeryPrintOrderId: $stationeryPrintOrderId, data: $data) {
    id
    issues {
      id
      resolvedAt
      issueType
      issueTarget
    }
  }
}
    `;
export type AddStationeryPrintOrderIssuesMutationFn = Apollo.MutationFunction<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>;

/**
 * __useAddStationeryPrintOrderIssuesMutation__
 *
 * To run a mutation, you first call `useAddStationeryPrintOrderIssuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStationeryPrintOrderIssuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStationeryPrintOrderIssuesMutation, { data, loading, error }] = useAddStationeryPrintOrderIssuesMutation({
 *   variables: {
 *      stationeryPrintOrderId: // value for 'stationeryPrintOrderId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddStationeryPrintOrderIssuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>) {
        return ApolloReactHooks.useMutation<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>(AddStationeryPrintOrderIssuesDocument, baseOptions);
      }
export type AddStationeryPrintOrderIssuesMutationHookResult = ReturnType<typeof useAddStationeryPrintOrderIssuesMutation>;
export type AddStationeryPrintOrderIssuesMutationResult = Apollo.MutationResult<AddStationeryPrintOrderIssuesMutation>;
export type AddStationeryPrintOrderIssuesMutationOptions = Apollo.BaseMutationOptions<AddStationeryPrintOrderIssuesMutation, AddStationeryPrintOrderIssuesMutationVariables>;
export const ResolveStationeryPrintOrderIssueDocument = gql`
    mutation ResolveStationeryPrintOrderIssue($stationeryPrintOrderId: ID!, $issueId: ID!) {
  resolveStationeryPrintOrderIssue(stationeryPrintOrderId: $stationeryPrintOrderId, issueId: $issueId) {
    id
    issues {
      id
      resolvedAt
      issueType
      issueTarget
      additionalUserFacingDescription
    }
  }
}
    `;
export type ResolveStationeryPrintOrderIssueMutationFn = Apollo.MutationFunction<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>;

/**
 * __useResolveStationeryPrintOrderIssueMutation__
 *
 * To run a mutation, you first call `useResolveStationeryPrintOrderIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveStationeryPrintOrderIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveStationeryPrintOrderIssueMutation, { data, loading, error }] = useResolveStationeryPrintOrderIssueMutation({
 *   variables: {
 *      stationeryPrintOrderId: // value for 'stationeryPrintOrderId'
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useResolveStationeryPrintOrderIssueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>) {
        return ApolloReactHooks.useMutation<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>(ResolveStationeryPrintOrderIssueDocument, baseOptions);
      }
export type ResolveStationeryPrintOrderIssueMutationHookResult = ReturnType<typeof useResolveStationeryPrintOrderIssueMutation>;
export type ResolveStationeryPrintOrderIssueMutationResult = Apollo.MutationResult<ResolveStationeryPrintOrderIssueMutation>;
export type ResolveStationeryPrintOrderIssueMutationOptions = Apollo.BaseMutationOptions<ResolveStationeryPrintOrderIssueMutation, ResolveStationeryPrintOrderIssueMutationVariables>;
export const CardBackTemplatesByCategoryAndDimensionsDocument = gql`
    query CardBackTemplatesByCategoryAndDimensions($filter: StationeryTemplateFilter!) {
  stationeryTemplatesContainer(filter: $filter) {
    pagedResults {
      edges {
        node {
          id
          name
          themeId
          themeJSON
          thumbnailUrl
        }
      }
    }
  }
}
    `;

/**
 * __useCardBackTemplatesByCategoryAndDimensionsQuery__
 *
 * To run a query within a React component, call `useCardBackTemplatesByCategoryAndDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardBackTemplatesByCategoryAndDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardBackTemplatesByCategoryAndDimensionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCardBackTemplatesByCategoryAndDimensionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardBackTemplatesByCategoryAndDimensionsQuery, CardBackTemplatesByCategoryAndDimensionsQueryVariables>) {
        return ApolloReactHooks.useQuery<CardBackTemplatesByCategoryAndDimensionsQuery, CardBackTemplatesByCategoryAndDimensionsQueryVariables>(CardBackTemplatesByCategoryAndDimensionsDocument, baseOptions);
      }
export function useCardBackTemplatesByCategoryAndDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardBackTemplatesByCategoryAndDimensionsQuery, CardBackTemplatesByCategoryAndDimensionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardBackTemplatesByCategoryAndDimensionsQuery, CardBackTemplatesByCategoryAndDimensionsQueryVariables>(CardBackTemplatesByCategoryAndDimensionsDocument, baseOptions);
        }
export type CardBackTemplatesByCategoryAndDimensionsQueryHookResult = ReturnType<typeof useCardBackTemplatesByCategoryAndDimensionsQuery>;
export type CardBackTemplatesByCategoryAndDimensionsLazyQueryHookResult = ReturnType<typeof useCardBackTemplatesByCategoryAndDimensionsLazyQuery>;
export type CardBackTemplatesByCategoryAndDimensionsQueryResult = Apollo.QueryResult<CardBackTemplatesByCategoryAndDimensionsQuery, CardBackTemplatesByCategoryAndDimensionsQueryVariables>;
export const GetEventContactsDocument = gql`
    query GetEventContacts($eventId: ID!, $forceGuestListSynch: Boolean, $firebaseEventId: ID) {
  getEventContacts(eventId: $eventId, forceGuestListSynch: $forceGuestListSynch, firebaseEventId: $firebaseEventId)
}
    `;

/**
 * __useGetEventContactsQuery__
 *
 * To run a query within a React component, call `useGetEventContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventContactsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      forceGuestListSynch: // value for 'forceGuestListSynch'
 *      firebaseEventId: // value for 'firebaseEventId'
 *   },
 * });
 */
export function useGetEventContactsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventContactsQuery, GetEventContactsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventContactsQuery, GetEventContactsQueryVariables>(GetEventContactsDocument, baseOptions);
      }
export function useGetEventContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventContactsQuery, GetEventContactsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventContactsQuery, GetEventContactsQueryVariables>(GetEventContactsDocument, baseOptions);
        }
export type GetEventContactsQueryHookResult = ReturnType<typeof useGetEventContactsQuery>;
export type GetEventContactsLazyQueryHookResult = ReturnType<typeof useGetEventContactsLazyQuery>;
export type GetEventContactsQueryResult = Apollo.QueryResult<GetEventContactsQuery, GetEventContactsQueryVariables>;
export const GetContactCollectionByEventIdDocument = gql`
    query GetContactCollectionByEventId($eventId: String!) {
  getContactCollectionByEventId(eventId: $eventId) {
    id
    magicLink
    active
  }
}
    `;

/**
 * __useGetContactCollectionByEventIdQuery__
 *
 * To run a query within a React component, call `useGetContactCollectionByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectionByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectionByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetContactCollectionByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectionByEventIdQuery, GetContactCollectionByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetContactCollectionByEventIdQuery, GetContactCollectionByEventIdQueryVariables>(GetContactCollectionByEventIdDocument, baseOptions);
      }
export function useGetContactCollectionByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectionByEventIdQuery, GetContactCollectionByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetContactCollectionByEventIdQuery, GetContactCollectionByEventIdQueryVariables>(GetContactCollectionByEventIdDocument, baseOptions);
        }
export type GetContactCollectionByEventIdQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdQuery>;
export type GetContactCollectionByEventIdLazyQueryHookResult = ReturnType<typeof useGetContactCollectionByEventIdLazyQuery>;
export type GetContactCollectionByEventIdQueryResult = Apollo.QueryResult<GetContactCollectionByEventIdQuery, GetContactCollectionByEventIdQueryVariables>;
export const CreateAndStartCheckoutConciergePrintOrderDocument = gql`
    mutation CreateAndStartCheckoutConciergePrintOrder($payload: CreateConciergePrintOrderInput!) {
  createAndStartCheckoutConciergePrintOrder(data: $payload) {
    checkoutUrl
  }
}
    `;
export type CreateAndStartCheckoutConciergePrintOrderMutationFn = Apollo.MutationFunction<CreateAndStartCheckoutConciergePrintOrderMutation, CreateAndStartCheckoutConciergePrintOrderMutationVariables>;

/**
 * __useCreateAndStartCheckoutConciergePrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateAndStartCheckoutConciergePrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndStartCheckoutConciergePrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndStartCheckoutConciergePrintOrderMutation, { data, loading, error }] = useCreateAndStartCheckoutConciergePrintOrderMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateAndStartCheckoutConciergePrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndStartCheckoutConciergePrintOrderMutation, CreateAndStartCheckoutConciergePrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndStartCheckoutConciergePrintOrderMutation, CreateAndStartCheckoutConciergePrintOrderMutationVariables>(CreateAndStartCheckoutConciergePrintOrderDocument, baseOptions);
      }
export type CreateAndStartCheckoutConciergePrintOrderMutationHookResult = ReturnType<typeof useCreateAndStartCheckoutConciergePrintOrderMutation>;
export type CreateAndStartCheckoutConciergePrintOrderMutationResult = Apollo.MutationResult<CreateAndStartCheckoutConciergePrintOrderMutation>;
export type CreateAndStartCheckoutConciergePrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateAndStartCheckoutConciergePrintOrderMutation, CreateAndStartCheckoutConciergePrintOrderMutationVariables>;
export const CreateAndStartInternationalCheckoutConciergePrintOrderDocument = gql`
    mutation CreateAndStartInternationalCheckoutConciergePrintOrder($payload: CreateConciergePrintOrderInput!) {
  createAndStartInternationalCheckoutConciergePrintOrder(data: $payload) {
    checkoutUrl
  }
}
    `;
export type CreateAndStartInternationalCheckoutConciergePrintOrderMutationFn = Apollo.MutationFunction<CreateAndStartInternationalCheckoutConciergePrintOrderMutation, CreateAndStartInternationalCheckoutConciergePrintOrderMutationVariables>;

/**
 * __useCreateAndStartInternationalCheckoutConciergePrintOrderMutation__
 *
 * To run a mutation, you first call `useCreateAndStartInternationalCheckoutConciergePrintOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndStartInternationalCheckoutConciergePrintOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndStartInternationalCheckoutConciergePrintOrderMutation, { data, loading, error }] = useCreateAndStartInternationalCheckoutConciergePrintOrderMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateAndStartInternationalCheckoutConciergePrintOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndStartInternationalCheckoutConciergePrintOrderMutation, CreateAndStartInternationalCheckoutConciergePrintOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAndStartInternationalCheckoutConciergePrintOrderMutation, CreateAndStartInternationalCheckoutConciergePrintOrderMutationVariables>(CreateAndStartInternationalCheckoutConciergePrintOrderDocument, baseOptions);
      }
export type CreateAndStartInternationalCheckoutConciergePrintOrderMutationHookResult = ReturnType<typeof useCreateAndStartInternationalCheckoutConciergePrintOrderMutation>;
export type CreateAndStartInternationalCheckoutConciergePrintOrderMutationResult = Apollo.MutationResult<CreateAndStartInternationalCheckoutConciergePrintOrderMutation>;
export type CreateAndStartInternationalCheckoutConciergePrintOrderMutationOptions = Apollo.BaseMutationOptions<CreateAndStartInternationalCheckoutConciergePrintOrderMutation, CreateAndStartInternationalCheckoutConciergePrintOrderMutationVariables>;
export const GetEventDateForConciergeDocument = gql`
    query GetEventDateForConcierge($eventId: ID!) {
  eventById(id: $eventId) {
    id
    info {
      id
      eventPassword
      dateV0918 {
        numericalEventDate: dateString(dateFormat: numerical)
        longEventDate: dateString(dateFormat: long)
      }
      fianceeFirstName
    }
  }
}
    `;

/**
 * __useGetEventDateForConciergeQuery__
 *
 * To run a query within a React component, call `useGetEventDateForConciergeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDateForConciergeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDateForConciergeQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventDateForConciergeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventDateForConciergeQuery, GetEventDateForConciergeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventDateForConciergeQuery, GetEventDateForConciergeQueryVariables>(GetEventDateForConciergeDocument, baseOptions);
      }
export function useGetEventDateForConciergeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventDateForConciergeQuery, GetEventDateForConciergeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventDateForConciergeQuery, GetEventDateForConciergeQueryVariables>(GetEventDateForConciergeDocument, baseOptions);
        }
export type GetEventDateForConciergeQueryHookResult = ReturnType<typeof useGetEventDateForConciergeQuery>;
export type GetEventDateForConciergeLazyQueryHookResult = ReturnType<typeof useGetEventDateForConciergeLazyQuery>;
export type GetEventDateForConciergeQueryResult = Apollo.QueryResult<GetEventDateForConciergeQuery, GetEventDateForConciergeQueryVariables>;
export const SearchTermToTemplatesDocument = gql`
    query SearchTermToTemplates($searchTerm: String!) {
  searchTermToTemplates(searchTerm: $searchTerm) {
    templates {
      templateID
      matchingTags
      allTags
      matchingDescriptionWords
    }
    tags
    query
  }
}
    `;

/**
 * __useSearchTermToTemplatesQuery__
 *
 * To run a query within a React component, call `useSearchTermToTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTermToTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTermToTemplatesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchTermToTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTermToTemplatesQuery, SearchTermToTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchTermToTemplatesQuery, SearchTermToTemplatesQueryVariables>(SearchTermToTemplatesDocument, baseOptions);
      }
export function useSearchTermToTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTermToTemplatesQuery, SearchTermToTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchTermToTemplatesQuery, SearchTermToTemplatesQueryVariables>(SearchTermToTemplatesDocument, baseOptions);
        }
export type SearchTermToTemplatesQueryHookResult = ReturnType<typeof useSearchTermToTemplatesQuery>;
export type SearchTermToTemplatesLazyQueryHookResult = ReturnType<typeof useSearchTermToTemplatesLazyQuery>;
export type SearchTermToTemplatesQueryResult = Apollo.QueryResult<SearchTermToTemplatesQuery, SearchTermToTemplatesQueryVariables>;
export const PrintDesignsGalleryEventInfoByEventHandleDocument = gql`
    query PrintDesignsGalleryEventInfoByEventHandle($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    eventDesign(purpose: live) {
      id
      theme {
        id
        themeId
      }
    }
  }
}
    `;

/**
 * __usePrintDesignsGalleryEventInfoByEventHandleQuery__
 *
 * To run a query within a React component, call `usePrintDesignsGalleryEventInfoByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintDesignsGalleryEventInfoByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintDesignsGalleryEventInfoByEventHandleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function usePrintDesignsGalleryEventInfoByEventHandleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PrintDesignsGalleryEventInfoByEventHandleQuery, PrintDesignsGalleryEventInfoByEventHandleQueryVariables>) {
        return ApolloReactHooks.useQuery<PrintDesignsGalleryEventInfoByEventHandleQuery, PrintDesignsGalleryEventInfoByEventHandleQueryVariables>(PrintDesignsGalleryEventInfoByEventHandleDocument, baseOptions);
      }
export function usePrintDesignsGalleryEventInfoByEventHandleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintDesignsGalleryEventInfoByEventHandleQuery, PrintDesignsGalleryEventInfoByEventHandleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PrintDesignsGalleryEventInfoByEventHandleQuery, PrintDesignsGalleryEventInfoByEventHandleQueryVariables>(PrintDesignsGalleryEventInfoByEventHandleDocument, baseOptions);
        }
export type PrintDesignsGalleryEventInfoByEventHandleQueryHookResult = ReturnType<typeof usePrintDesignsGalleryEventInfoByEventHandleQuery>;
export type PrintDesignsGalleryEventInfoByEventHandleLazyQueryHookResult = ReturnType<typeof usePrintDesignsGalleryEventInfoByEventHandleLazyQuery>;
export type PrintDesignsGalleryEventInfoByEventHandleQueryResult = Apollo.QueryResult<PrintDesignsGalleryEventInfoByEventHandleQuery, PrintDesignsGalleryEventInfoByEventHandleQueryVariables>;
export const StationeryProductsDocument = gql`
    query StationeryProducts {
  stationeryProducts {
    id
    priceConfigId
    vendor
    productType
    vendorBaseSKU
    ...StationeryShippingOptions
    ...StationeryProductAttributes
    ...StationeryProductPricings
    ...StationeryProductVariantGroups
  }
}
    ${StationeryShippingOptionsFragmentDoc}
${StationeryProductAttributesFragmentDoc}
${StationeryProductPricingsFragmentDoc}
${StationeryProductVariantGroupsFragmentDoc}`;

/**
 * __useStationeryProductsQuery__
 *
 * To run a query within a React component, call `useStationeryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStationeryProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryProductsQuery, StationeryProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryProductsQuery, StationeryProductsQueryVariables>(StationeryProductsDocument, baseOptions);
      }
export function useStationeryProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryProductsQuery, StationeryProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryProductsQuery, StationeryProductsQueryVariables>(StationeryProductsDocument, baseOptions);
        }
export type StationeryProductsQueryHookResult = ReturnType<typeof useStationeryProductsQuery>;
export type StationeryProductsLazyQueryHookResult = ReturnType<typeof useStationeryProductsLazyQuery>;
export type StationeryProductsQueryResult = Apollo.QueryResult<StationeryProductsQuery, StationeryProductsQueryVariables>;
export const CardDashboardStationeryTemplatesContainerDocument = gql`
    query CardDashboardStationeryTemplatesContainer($filter: StationeryTemplateFilter!, $includeOptions: StationeryTemplateIncludeOptions, $first: Int, $skipDigitalDesigns: Boolean!) {
  stationeryTemplatesContainer(filter: $filter, includeOptions: $includeOptions) {
    pagedResults(first: $first) {
      totalCount
      edges {
        cursor
        node {
          ...StationeryDesignGalleryTemplate
          productIds
        }
      }
      pageInfo {
        ...StationeryPageInfo
      }
    }
  }
  stationeryTags {
    ...StationeryDesignGalleryFilterTags
  }
  ecardDesigns: themes @skip(if: $skipDigitalDesigns) {
    id
    themeId
    name
    marketingData {
      variantThemeId
      variationType
      imageUrl
      vendor
    }
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}
${StationeryPageInfoFragmentDoc}
${StationeryDesignGalleryFilterTagsFragmentDoc}`;

/**
 * __useCardDashboardStationeryTemplatesContainerQuery__
 *
 * To run a query within a React component, call `useCardDashboardStationeryTemplatesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardDashboardStationeryTemplatesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDashboardStationeryTemplatesContainerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeOptions: // value for 'includeOptions'
 *      first: // value for 'first'
 *      skipDigitalDesigns: // value for 'skipDigitalDesigns'
 *   },
 * });
 */
export function useCardDashboardStationeryTemplatesContainerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>) {
        return ApolloReactHooks.useQuery<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>(CardDashboardStationeryTemplatesContainerDocument, baseOptions);
      }
export function useCardDashboardStationeryTemplatesContainerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>(CardDashboardStationeryTemplatesContainerDocument, baseOptions);
        }
export type CardDashboardStationeryTemplatesContainerQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesContainerQuery>;
export type CardDashboardStationeryTemplatesContainerLazyQueryHookResult = ReturnType<typeof useCardDashboardStationeryTemplatesContainerLazyQuery>;
export type CardDashboardStationeryTemplatesContainerQueryResult = Apollo.QueryResult<CardDashboardStationeryTemplatesContainerQuery, CardDashboardStationeryTemplatesContainerQueryVariables>;
export const MarkStationeryTemplateAsFavoriteDocument = gql`
    mutation MarkStationeryTemplateAsFavorite($templateId: ID!, $eventId: ID) {
  markTemplateAsFavorite(templateId: $templateId, eventId: $eventId) {
    ...StationeryDesignGalleryTemplate
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}`;
export type MarkStationeryTemplateAsFavoriteMutationFn = Apollo.MutationFunction<MarkStationeryTemplateAsFavoriteMutation, MarkStationeryTemplateAsFavoriteMutationVariables>;

/**
 * __useMarkStationeryTemplateAsFavoriteMutation__
 *
 * To run a mutation, you first call `useMarkStationeryTemplateAsFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStationeryTemplateAsFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStationeryTemplateAsFavoriteMutation, { data, loading, error }] = useMarkStationeryTemplateAsFavoriteMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMarkStationeryTemplateAsFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkStationeryTemplateAsFavoriteMutation, MarkStationeryTemplateAsFavoriteMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkStationeryTemplateAsFavoriteMutation, MarkStationeryTemplateAsFavoriteMutationVariables>(MarkStationeryTemplateAsFavoriteDocument, baseOptions);
      }
export type MarkStationeryTemplateAsFavoriteMutationHookResult = ReturnType<typeof useMarkStationeryTemplateAsFavoriteMutation>;
export type MarkStationeryTemplateAsFavoriteMutationResult = Apollo.MutationResult<MarkStationeryTemplateAsFavoriteMutation>;
export type MarkStationeryTemplateAsFavoriteMutationOptions = Apollo.BaseMutationOptions<MarkStationeryTemplateAsFavoriteMutation, MarkStationeryTemplateAsFavoriteMutationVariables>;
export const UnmarkStationeryTemplateAsFavoriteDocument = gql`
    mutation UnmarkStationeryTemplateAsFavorite($templateId: ID!, $eventId: ID) {
  unmarkTemplateAsFavorite(templateId: $templateId, eventId: $eventId) {
    ...StationeryDesignGalleryTemplate
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}`;
export type UnmarkStationeryTemplateAsFavoriteMutationFn = Apollo.MutationFunction<UnmarkStationeryTemplateAsFavoriteMutation, UnmarkStationeryTemplateAsFavoriteMutationVariables>;

/**
 * __useUnmarkStationeryTemplateAsFavoriteMutation__
 *
 * To run a mutation, you first call `useUnmarkStationeryTemplateAsFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkStationeryTemplateAsFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkStationeryTemplateAsFavoriteMutation, { data, loading, error }] = useUnmarkStationeryTemplateAsFavoriteMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUnmarkStationeryTemplateAsFavoriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnmarkStationeryTemplateAsFavoriteMutation, UnmarkStationeryTemplateAsFavoriteMutationVariables>) {
        return ApolloReactHooks.useMutation<UnmarkStationeryTemplateAsFavoriteMutation, UnmarkStationeryTemplateAsFavoriteMutationVariables>(UnmarkStationeryTemplateAsFavoriteDocument, baseOptions);
      }
export type UnmarkStationeryTemplateAsFavoriteMutationHookResult = ReturnType<typeof useUnmarkStationeryTemplateAsFavoriteMutation>;
export type UnmarkStationeryTemplateAsFavoriteMutationResult = Apollo.MutationResult<UnmarkStationeryTemplateAsFavoriteMutation>;
export type UnmarkStationeryTemplateAsFavoriteMutationOptions = Apollo.BaseMutationOptions<UnmarkStationeryTemplateAsFavoriteMutation, UnmarkStationeryTemplateAsFavoriteMutationVariables>;
export const StationeryCreateSamplePackOrderDocument = gql`
    mutation StationeryCreateSamplePackOrder($data: CreateStationerySamplePrintOrderInput!) {
  createAndStartCheckoutSamplePrintOrder(data: $data) {
    checkoutUrl
  }
}
    `;
export type StationeryCreateSamplePackOrderMutationFn = Apollo.MutationFunction<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>;

/**
 * __useStationeryCreateSamplePackOrderMutation__
 *
 * To run a mutation, you first call `useStationeryCreateSamplePackOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationeryCreateSamplePackOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationeryCreateSamplePackOrderMutation, { data, loading, error }] = useStationeryCreateSamplePackOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationeryCreateSamplePackOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>(StationeryCreateSamplePackOrderDocument, baseOptions);
      }
export type StationeryCreateSamplePackOrderMutationHookResult = ReturnType<typeof useStationeryCreateSamplePackOrderMutation>;
export type StationeryCreateSamplePackOrderMutationResult = Apollo.MutationResult<StationeryCreateSamplePackOrderMutation>;
export type StationeryCreateSamplePackOrderMutationOptions = Apollo.BaseMutationOptions<StationeryCreateSamplePackOrderMutation, StationeryCreateSamplePackOrderMutationVariables>;
export const StationeryIsEventEligibleForFreeSampleKitDocument = gql`
    query StationeryIsEventEligibleForFreeSampleKit($eventId: String!) {
  stationeryIsEventEligibleForFreeSampleKit(eventId: $eventId)
}
    `;

/**
 * __useStationeryIsEventEligibleForFreeSampleKitQuery__
 *
 * To run a query within a React component, call `useStationeryIsEventEligibleForFreeSampleKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryIsEventEligibleForFreeSampleKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryIsEventEligibleForFreeSampleKitQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStationeryIsEventEligibleForFreeSampleKitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>(StationeryIsEventEligibleForFreeSampleKitDocument, baseOptions);
      }
export function useStationeryIsEventEligibleForFreeSampleKitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>(StationeryIsEventEligibleForFreeSampleKitDocument, baseOptions);
        }
export type StationeryIsEventEligibleForFreeSampleKitQueryHookResult = ReturnType<typeof useStationeryIsEventEligibleForFreeSampleKitQuery>;
export type StationeryIsEventEligibleForFreeSampleKitLazyQueryHookResult = ReturnType<typeof useStationeryIsEventEligibleForFreeSampleKitLazyQuery>;
export type StationeryIsEventEligibleForFreeSampleKitQueryResult = Apollo.QueryResult<StationeryIsEventEligibleForFreeSampleKitQuery, StationeryIsEventEligibleForFreeSampleKitQueryVariables>;
export const EmbeddingDocument = gql`
    query Embedding($text: String!) {
  embedding(text: $text)
}
    `;

/**
 * __useEmbeddingQuery__
 *
 * To run a query within a React component, call `useEmbeddingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbeddingQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useEmbeddingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmbeddingQuery, EmbeddingQueryVariables>) {
        return ApolloReactHooks.useQuery<EmbeddingQuery, EmbeddingQueryVariables>(EmbeddingDocument, baseOptions);
      }
export function useEmbeddingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmbeddingQuery, EmbeddingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EmbeddingQuery, EmbeddingQueryVariables>(EmbeddingDocument, baseOptions);
        }
export type EmbeddingQueryHookResult = ReturnType<typeof useEmbeddingQuery>;
export type EmbeddingLazyQueryHookResult = ReturnType<typeof useEmbeddingLazyQuery>;
export type EmbeddingQueryResult = Apollo.QueryResult<EmbeddingQuery, EmbeddingQueryVariables>;
export const GetDigitalAndPaperDraftsByEventIdDocument = gql`
    query GetDigitalAndPaperDraftsByEventId($input: StationeryDraftsByEventInput!, $eventId: ID!) {
  stationeryDrafts: stationeryDraftsByEvent(input: $input) {
    stationeryTemplate {
      id
      name
      themeId
      category
      approved
      enabled
      thumbnailUrl
      premium
    }
    format
    cardJSON
    eventId
    id
    ownerId
    updatedAt
  }
  digitalInvitationDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: invitation) {
    id
  }
  digitalSaveTheDateDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: savethedate) {
    id
  }
  digitalPhotoSaveTheDateDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: savethedatephoto) {
    id
  }
  digitalCustomDraft: getMostRecentEcardByEventId(id: $eventId, ecardType: custom) {
    id
  }
}
    `;

/**
 * __useGetDigitalAndPaperDraftsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetDigitalAndPaperDraftsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalAndPaperDraftsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalAndPaperDraftsByEventIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetDigitalAndPaperDraftsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDigitalAndPaperDraftsByEventIdQuery, GetDigitalAndPaperDraftsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDigitalAndPaperDraftsByEventIdQuery, GetDigitalAndPaperDraftsByEventIdQueryVariables>(GetDigitalAndPaperDraftsByEventIdDocument, baseOptions);
      }
export function useGetDigitalAndPaperDraftsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDigitalAndPaperDraftsByEventIdQuery, GetDigitalAndPaperDraftsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDigitalAndPaperDraftsByEventIdQuery, GetDigitalAndPaperDraftsByEventIdQueryVariables>(GetDigitalAndPaperDraftsByEventIdDocument, baseOptions);
        }
export type GetDigitalAndPaperDraftsByEventIdQueryHookResult = ReturnType<typeof useGetDigitalAndPaperDraftsByEventIdQuery>;
export type GetDigitalAndPaperDraftsByEventIdLazyQueryHookResult = ReturnType<typeof useGetDigitalAndPaperDraftsByEventIdLazyQuery>;
export type GetDigitalAndPaperDraftsByEventIdQueryResult = Apollo.QueryResult<GetDigitalAndPaperDraftsByEventIdQuery, GetDigitalAndPaperDraftsByEventIdQueryVariables>;
export const DeleteStationeryDraftByIdDocument = gql`
    mutation DeleteStationeryDraftById($id: ID!) {
  deleteStationeryDraftById(id: $id) {
    id
  }
}
    `;
export type DeleteStationeryDraftByIdMutationFn = Apollo.MutationFunction<DeleteStationeryDraftByIdMutation, DeleteStationeryDraftByIdMutationVariables>;

/**
 * __useDeleteStationeryDraftByIdMutation__
 *
 * To run a mutation, you first call `useDeleteStationeryDraftByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStationeryDraftByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStationeryDraftByIdMutation, { data, loading, error }] = useDeleteStationeryDraftByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStationeryDraftByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStationeryDraftByIdMutation, DeleteStationeryDraftByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteStationeryDraftByIdMutation, DeleteStationeryDraftByIdMutationVariables>(DeleteStationeryDraftByIdDocument, baseOptions);
      }
export type DeleteStationeryDraftByIdMutationHookResult = ReturnType<typeof useDeleteStationeryDraftByIdMutation>;
export type DeleteStationeryDraftByIdMutationResult = Apollo.MutationResult<DeleteStationeryDraftByIdMutation>;
export type DeleteStationeryDraftByIdMutationOptions = Apollo.BaseMutationOptions<DeleteStationeryDraftByIdMutation, DeleteStationeryDraftByIdMutationVariables>;
export const GetExistingEventStationeryDraftsWithTemplateDocument = gql`
    query GetExistingEventStationeryDraftsWithTemplate($input: StationeryDraftsByEventInput!) {
  stationeryDraftsByEvent(input: $input) {
    id
    format
    stationeryTemplate {
      id
      name
      themeId
      category
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useGetExistingEventStationeryDraftsWithTemplateQuery__
 *
 * To run a query within a React component, call `useGetExistingEventStationeryDraftsWithTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingEventStationeryDraftsWithTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingEventStationeryDraftsWithTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExistingEventStationeryDraftsWithTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExistingEventStationeryDraftsWithTemplateQuery, GetExistingEventStationeryDraftsWithTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExistingEventStationeryDraftsWithTemplateQuery, GetExistingEventStationeryDraftsWithTemplateQueryVariables>(GetExistingEventStationeryDraftsWithTemplateDocument, baseOptions);
      }
export function useGetExistingEventStationeryDraftsWithTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExistingEventStationeryDraftsWithTemplateQuery, GetExistingEventStationeryDraftsWithTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExistingEventStationeryDraftsWithTemplateQuery, GetExistingEventStationeryDraftsWithTemplateQueryVariables>(GetExistingEventStationeryDraftsWithTemplateDocument, baseOptions);
        }
export type GetExistingEventStationeryDraftsWithTemplateQueryHookResult = ReturnType<typeof useGetExistingEventStationeryDraftsWithTemplateQuery>;
export type GetExistingEventStationeryDraftsWithTemplateLazyQueryHookResult = ReturnType<typeof useGetExistingEventStationeryDraftsWithTemplateLazyQuery>;
export type GetExistingEventStationeryDraftsWithTemplateQueryResult = Apollo.QueryResult<GetExistingEventStationeryDraftsWithTemplateQuery, GetExistingEventStationeryDraftsWithTemplateQueryVariables>;
export const StationeryPrintOrderHistoryByEventDocument = gql`
    query StationeryPrintOrderHistoryByEvent($input: StationeryPrintOrdersByEventInput!) {
  stationeryPrintOrdersByEvent(input: $input) {
    count
    orders {
      ...StationeryPrintOrderDetails
    }
  }
}
    ${StationeryPrintOrderDetailsFragmentDoc}`;

/**
 * __useStationeryPrintOrderHistoryByEventQuery__
 *
 * To run a query within a React component, call `useStationeryPrintOrderHistoryByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryPrintOrderHistoryByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryPrintOrderHistoryByEventQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStationeryPrintOrderHistoryByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryPrintOrderHistoryByEventQuery, StationeryPrintOrderHistoryByEventQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryPrintOrderHistoryByEventQuery, StationeryPrintOrderHistoryByEventQueryVariables>(StationeryPrintOrderHistoryByEventDocument, baseOptions);
      }
export function useStationeryPrintOrderHistoryByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryPrintOrderHistoryByEventQuery, StationeryPrintOrderHistoryByEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryPrintOrderHistoryByEventQuery, StationeryPrintOrderHistoryByEventQueryVariables>(StationeryPrintOrderHistoryByEventDocument, baseOptions);
        }
export type StationeryPrintOrderHistoryByEventQueryHookResult = ReturnType<typeof useStationeryPrintOrderHistoryByEventQuery>;
export type StationeryPrintOrderHistoryByEventLazyQueryHookResult = ReturnType<typeof useStationeryPrintOrderHistoryByEventLazyQuery>;
export type StationeryPrintOrderHistoryByEventQueryResult = Apollo.QueryResult<StationeryPrintOrderHistoryByEventQuery, StationeryPrintOrderHistoryByEventQueryVariables>;
export const CardPdpDataDocument = gql`
    query CardPdpData($themeId: String!, $category: StationeryTemplateCategoryEnum!, $skipDigitalDesign: Boolean!) {
  stationeryTemplatesByThemeId(themeId: $themeId, categories: [$category]) {
    ...StationeryDesignGalleryTemplate
    ...StationeryProducts
  }
  ecardDesign: themeByThemeId(themeId: $themeId) @skip(if: $skipDigitalDesign) {
    id
    themeId
    name
    marketingData {
      variantThemeId
      variationType
      imageUrl
      vendor
    }
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}
${StationeryProductsFragmentDoc}`;

/**
 * __useCardPdpDataQuery__
 *
 * To run a query within a React component, call `useCardPdpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPdpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPdpDataQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      category: // value for 'category'
 *      skipDigitalDesign: // value for 'skipDigitalDesign'
 *   },
 * });
 */
export function useCardPdpDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardPdpDataQuery, CardPdpDataQueryVariables>) {
        return ApolloReactHooks.useQuery<CardPdpDataQuery, CardPdpDataQueryVariables>(CardPdpDataDocument, baseOptions);
      }
export function useCardPdpDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardPdpDataQuery, CardPdpDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardPdpDataQuery, CardPdpDataQueryVariables>(CardPdpDataDocument, baseOptions);
        }
export type CardPdpDataQueryHookResult = ReturnType<typeof useCardPdpDataQuery>;
export type CardPdpDataLazyQueryHookResult = ReturnType<typeof useCardPdpDataLazyQuery>;
export type CardPdpDataQueryResult = Apollo.QueryResult<CardPdpDataQuery, CardPdpDataQueryVariables>;
export const MatchingFoilTemplateDataDocument = gql`
    query MatchingFoilTemplateData($themeId: String!, $category: StationeryTemplateCategoryEnum!) {
  stationeryTemplatesByThemeId(themeId: $themeId, categories: [$category]) {
    id
    themeId
    category
    thumbnailUrl
    name
  }
}
    `;

/**
 * __useMatchingFoilTemplateDataQuery__
 *
 * To run a query within a React component, call `useMatchingFoilTemplateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingFoilTemplateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingFoilTemplateDataQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useMatchingFoilTemplateDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MatchingFoilTemplateDataQuery, MatchingFoilTemplateDataQueryVariables>) {
        return ApolloReactHooks.useQuery<MatchingFoilTemplateDataQuery, MatchingFoilTemplateDataQueryVariables>(MatchingFoilTemplateDataDocument, baseOptions);
      }
export function useMatchingFoilTemplateDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchingFoilTemplateDataQuery, MatchingFoilTemplateDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MatchingFoilTemplateDataQuery, MatchingFoilTemplateDataQueryVariables>(MatchingFoilTemplateDataDocument, baseOptions);
        }
export type MatchingFoilTemplateDataQueryHookResult = ReturnType<typeof useMatchingFoilTemplateDataQuery>;
export type MatchingFoilTemplateDataLazyQueryHookResult = ReturnType<typeof useMatchingFoilTemplateDataLazyQuery>;
export type MatchingFoilTemplateDataQueryResult = Apollo.QueryResult<MatchingFoilTemplateDataQuery, MatchingFoilTemplateDataQueryVariables>;
export const CreateStationeryDraftDocument = gql`
    mutation CreateStationeryDraft($payload: CreateStationeryDraftInput!) {
  createStationeryDraft(data: $payload) {
    cardJSON
    eventId
    id
    format
    stationeryTemplate {
      id
      themeId
      category
      premium
    }
  }
}
    `;
export type CreateStationeryDraftMutationFn = Apollo.MutationFunction<CreateStationeryDraftMutation, CreateStationeryDraftMutationVariables>;

/**
 * __useCreateStationeryDraftMutation__
 *
 * To run a mutation, you first call `useCreateStationeryDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStationeryDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStationeryDraftMutation, { data, loading, error }] = useCreateStationeryDraftMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateStationeryDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStationeryDraftMutation, CreateStationeryDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStationeryDraftMutation, CreateStationeryDraftMutationVariables>(CreateStationeryDraftDocument, baseOptions);
      }
export type CreateStationeryDraftMutationHookResult = ReturnType<typeof useCreateStationeryDraftMutation>;
export type CreateStationeryDraftMutationResult = Apollo.MutationResult<CreateStationeryDraftMutation>;
export type CreateStationeryDraftMutationOptions = Apollo.BaseMutationOptions<CreateStationeryDraftMutation, CreateStationeryDraftMutationVariables>;
export const CardPdpSeoDataDocument = gql`
    query CardPdpSeoData($themeId: String!, $category: StationeryTemplateCategoryEnum!) {
  stationeryTemplatesByThemeId(themeId: $themeId, categories: [$category]) {
    id
    name
    themeId
    thumbnailUrl
  }
}
    `;

/**
 * __useCardPdpSeoDataQuery__
 *
 * To run a query within a React component, call `useCardPdpSeoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPdpSeoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPdpSeoDataQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCardPdpSeoDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardPdpSeoDataQuery, CardPdpSeoDataQueryVariables>) {
        return ApolloReactHooks.useQuery<CardPdpSeoDataQuery, CardPdpSeoDataQueryVariables>(CardPdpSeoDataDocument, baseOptions);
      }
export function useCardPdpSeoDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardPdpSeoDataQuery, CardPdpSeoDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardPdpSeoDataQuery, CardPdpSeoDataQueryVariables>(CardPdpSeoDataDocument, baseOptions);
        }
export type CardPdpSeoDataQueryHookResult = ReturnType<typeof useCardPdpSeoDataQuery>;
export type CardPdpSeoDataLazyQueryHookResult = ReturnType<typeof useCardPdpSeoDataLazyQuery>;
export type CardPdpSeoDataQueryResult = Apollo.QueryResult<CardPdpSeoDataQuery, CardPdpSeoDataQueryVariables>;
export const StationeryTemplatesBySizeDocument = gql`
    query StationeryTemplatesBySize($filter: StationeryTemplateFilter!) {
  stationeryTemplatesContainer(filter: $filter) {
    pagedResults {
      edges {
        node {
          id
          widthInches
          heightInches
        }
      }
    }
  }
}
    `;

/**
 * __useStationeryTemplatesBySizeQuery__
 *
 * To run a query within a React component, call `useStationeryTemplatesBySizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryTemplatesBySizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryTemplatesBySizeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStationeryTemplatesBySizeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryTemplatesBySizeQuery, StationeryTemplatesBySizeQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryTemplatesBySizeQuery, StationeryTemplatesBySizeQueryVariables>(StationeryTemplatesBySizeDocument, baseOptions);
      }
export function useStationeryTemplatesBySizeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryTemplatesBySizeQuery, StationeryTemplatesBySizeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryTemplatesBySizeQuery, StationeryTemplatesBySizeQueryVariables>(StationeryTemplatesBySizeDocument, baseOptions);
        }
export type StationeryTemplatesBySizeQueryHookResult = ReturnType<typeof useStationeryTemplatesBySizeQuery>;
export type StationeryTemplatesBySizeLazyQueryHookResult = ReturnType<typeof useStationeryTemplatesBySizeLazyQuery>;
export type StationeryTemplatesBySizeQueryResult = Apollo.QueryResult<StationeryTemplatesBySizeQuery, StationeryTemplatesBySizeQueryVariables>;
export const EventWithScheduleDocument = gql`
    query EventWithSchedule($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info(admin: true) {
      id
      schedule {
        items {
          ...EventScheduleForStationery
        }
      }
    }
  }
}
    ${EventScheduleForStationeryFragmentDoc}`;

/**
 * __useEventWithScheduleQuery__
 *
 * To run a query within a React component, call `useEventWithScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWithScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWithScheduleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventWithScheduleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWithScheduleQuery, EventWithScheduleQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWithScheduleQuery, EventWithScheduleQueryVariables>(EventWithScheduleDocument, baseOptions);
      }
export function useEventWithScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWithScheduleQuery, EventWithScheduleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWithScheduleQuery, EventWithScheduleQueryVariables>(EventWithScheduleDocument, baseOptions);
        }
export type EventWithScheduleQueryHookResult = ReturnType<typeof useEventWithScheduleQuery>;
export type EventWithScheduleLazyQueryHookResult = ReturnType<typeof useEventWithScheduleLazyQuery>;
export type EventWithScheduleQueryResult = Apollo.QueryResult<EventWithScheduleQuery, EventWithScheduleQueryVariables>;
export const StationeyDigitalCardCustomizerOrderDataDocument = gql`
    query StationeyDigitalCardCustomizerOrderData($orderNumber: String!, $eventHandle: String!, $skipEventData: Boolean!) {
  stationeryPrintOrderByOrderNumber(orderNumber: $orderNumber) {
    id
    type
    state
    printCardFrontPreviewUrl
    digitalEnvelopeImageUrl
    cardDraftJSONBlob
    eventId
    orderNumber
    digitalFeatures
    cardDraft {
      id
      format
      recipientIdList
      cardJSON
      stationeryTemplate {
        id
        category
      }
    }
  }
  eventByName(name: $eventHandle) @skip(if: $skipEventData) {
    id
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
    }
  }
}
    `;

/**
 * __useStationeyDigitalCardCustomizerOrderDataQuery__
 *
 * To run a query within a React component, call `useStationeyDigitalCardCustomizerOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeyDigitalCardCustomizerOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeyDigitalCardCustomizerOrderDataQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      eventHandle: // value for 'eventHandle'
 *      skipEventData: // value for 'skipEventData'
 *   },
 * });
 */
export function useStationeyDigitalCardCustomizerOrderDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeyDigitalCardCustomizerOrderDataQuery, StationeyDigitalCardCustomizerOrderDataQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeyDigitalCardCustomizerOrderDataQuery, StationeyDigitalCardCustomizerOrderDataQueryVariables>(StationeyDigitalCardCustomizerOrderDataDocument, baseOptions);
      }
export function useStationeyDigitalCardCustomizerOrderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeyDigitalCardCustomizerOrderDataQuery, StationeyDigitalCardCustomizerOrderDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeyDigitalCardCustomizerOrderDataQuery, StationeyDigitalCardCustomizerOrderDataQueryVariables>(StationeyDigitalCardCustomizerOrderDataDocument, baseOptions);
        }
export type StationeyDigitalCardCustomizerOrderDataQueryHookResult = ReturnType<typeof useStationeyDigitalCardCustomizerOrderDataQuery>;
export type StationeyDigitalCardCustomizerOrderDataLazyQueryHookResult = ReturnType<typeof useStationeyDigitalCardCustomizerOrderDataLazyQuery>;
export type StationeyDigitalCardCustomizerOrderDataQueryResult = Apollo.QueryResult<StationeyDigitalCardCustomizerOrderDataQuery, StationeyDigitalCardCustomizerOrderDataQueryVariables>;
export const StationerySendPremiumDigitalOrderToRecipientsDocument = gql`
    mutation StationerySendPremiumDigitalOrderToRecipients($data: SendPremiumDigitalOrderInput!) {
  sendPremiumDigitalOrder(data: $data) {
    id
    orderNumber
    state
    currentStatus
  }
}
    `;
export type StationerySendPremiumDigitalOrderToRecipientsMutationFn = Apollo.MutationFunction<StationerySendPremiumDigitalOrderToRecipientsMutation, StationerySendPremiumDigitalOrderToRecipientsMutationVariables>;

/**
 * __useStationerySendPremiumDigitalOrderToRecipientsMutation__
 *
 * To run a mutation, you first call `useStationerySendPremiumDigitalOrderToRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationerySendPremiumDigitalOrderToRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationerySendPremiumDigitalOrderToRecipientsMutation, { data, loading, error }] = useStationerySendPremiumDigitalOrderToRecipientsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationerySendPremiumDigitalOrderToRecipientsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StationerySendPremiumDigitalOrderToRecipientsMutation, StationerySendPremiumDigitalOrderToRecipientsMutationVariables>) {
        return ApolloReactHooks.useMutation<StationerySendPremiumDigitalOrderToRecipientsMutation, StationerySendPremiumDigitalOrderToRecipientsMutationVariables>(StationerySendPremiumDigitalOrderToRecipientsDocument, baseOptions);
      }
export type StationerySendPremiumDigitalOrderToRecipientsMutationHookResult = ReturnType<typeof useStationerySendPremiumDigitalOrderToRecipientsMutation>;
export type StationerySendPremiumDigitalOrderToRecipientsMutationResult = Apollo.MutationResult<StationerySendPremiumDigitalOrderToRecipientsMutation>;
export type StationerySendPremiumDigitalOrderToRecipientsMutationOptions = Apollo.BaseMutationOptions<StationerySendPremiumDigitalOrderToRecipientsMutation, StationerySendPremiumDigitalOrderToRecipientsMutationVariables>;
export const StationerySendTestPremiumDigitalEmailDocument = gql`
    mutation StationerySendTestPremiumDigitalEmail($data: SendTestPremiumDigitalCardInput!) {
  sendTestPremiumDigitalCard(data: $data)
}
    `;
export type StationerySendTestPremiumDigitalEmailMutationFn = Apollo.MutationFunction<StationerySendTestPremiumDigitalEmailMutation, StationerySendTestPremiumDigitalEmailMutationVariables>;

/**
 * __useStationerySendTestPremiumDigitalEmailMutation__
 *
 * To run a mutation, you first call `useStationerySendTestPremiumDigitalEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStationerySendTestPremiumDigitalEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stationerySendTestPremiumDigitalEmailMutation, { data, loading, error }] = useStationerySendTestPremiumDigitalEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStationerySendTestPremiumDigitalEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StationerySendTestPremiumDigitalEmailMutation, StationerySendTestPremiumDigitalEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<StationerySendTestPremiumDigitalEmailMutation, StationerySendTestPremiumDigitalEmailMutationVariables>(StationerySendTestPremiumDigitalEmailDocument, baseOptions);
      }
export type StationerySendTestPremiumDigitalEmailMutationHookResult = ReturnType<typeof useStationerySendTestPremiumDigitalEmailMutation>;
export type StationerySendTestPremiumDigitalEmailMutationResult = Apollo.MutationResult<StationerySendTestPremiumDigitalEmailMutation>;
export type StationerySendTestPremiumDigitalEmailMutationOptions = Apollo.BaseMutationOptions<StationerySendTestPremiumDigitalEmailMutation, StationerySendTestPremiumDigitalEmailMutationVariables>;
export const CardDashboardStationeryFavoriteTemplatesDocument = gql`
    query CardDashboardStationeryFavoriteTemplates($eventId: ID!) {
  stationeryTemplatesContainer(filter: {eventIdsFavorites: [$eventId], side: "front"}, includeOptions: {includeFavoritesByEventIds: [$eventId], includeProducts: true}) {
    pagedResults(first: 9999) {
      totalCount
      edges {
        cursor
        node {
          ...StationeryDesignGalleryTemplate
          productIds
          favorites {
            id
            createdAt
          }
        }
      }
    }
  }
}
    ${StationeryDesignGalleryTemplateFragmentDoc}`;

/**
 * __useCardDashboardStationeryFavoriteTemplatesQuery__
 *
 * To run a query within a React component, call `useCardDashboardStationeryFavoriteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardDashboardStationeryFavoriteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardDashboardStationeryFavoriteTemplatesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCardDashboardStationeryFavoriteTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardDashboardStationeryFavoriteTemplatesQuery, CardDashboardStationeryFavoriteTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<CardDashboardStationeryFavoriteTemplatesQuery, CardDashboardStationeryFavoriteTemplatesQueryVariables>(CardDashboardStationeryFavoriteTemplatesDocument, baseOptions);
      }
export function useCardDashboardStationeryFavoriteTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardDashboardStationeryFavoriteTemplatesQuery, CardDashboardStationeryFavoriteTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardDashboardStationeryFavoriteTemplatesQuery, CardDashboardStationeryFavoriteTemplatesQueryVariables>(CardDashboardStationeryFavoriteTemplatesDocument, baseOptions);
        }
export type CardDashboardStationeryFavoriteTemplatesQueryHookResult = ReturnType<typeof useCardDashboardStationeryFavoriteTemplatesQuery>;
export type CardDashboardStationeryFavoriteTemplatesLazyQueryHookResult = ReturnType<typeof useCardDashboardStationeryFavoriteTemplatesLazyQuery>;
export type CardDashboardStationeryFavoriteTemplatesQueryResult = Apollo.QueryResult<CardDashboardStationeryFavoriteTemplatesQuery, CardDashboardStationeryFavoriteTemplatesQueryVariables>;
export const StationeryPrintOrderByOrderNumberDocument = gql`
    query StationeryPrintOrderByOrderNumber($orderNumber: String!) {
  stationeryPrintOrderByOrderNumber(orderNumber: $orderNumber) {
    ...StationeryPrintOrderDetails
  }
}
    ${StationeryPrintOrderDetailsFragmentDoc}`;

/**
 * __useStationeryPrintOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useStationeryPrintOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryPrintOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryPrintOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useStationeryPrintOrderByOrderNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryPrintOrderByOrderNumberQuery, StationeryPrintOrderByOrderNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryPrintOrderByOrderNumberQuery, StationeryPrintOrderByOrderNumberQueryVariables>(StationeryPrintOrderByOrderNumberDocument, baseOptions);
      }
export function useStationeryPrintOrderByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryPrintOrderByOrderNumberQuery, StationeryPrintOrderByOrderNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryPrintOrderByOrderNumberQuery, StationeryPrintOrderByOrderNumberQueryVariables>(StationeryPrintOrderByOrderNumberDocument, baseOptions);
        }
export type StationeryPrintOrderByOrderNumberQueryHookResult = ReturnType<typeof useStationeryPrintOrderByOrderNumberQuery>;
export type StationeryPrintOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useStationeryPrintOrderByOrderNumberLazyQuery>;
export type StationeryPrintOrderByOrderNumberQueryResult = Apollo.QueryResult<StationeryPrintOrderByOrderNumberQuery, StationeryPrintOrderByOrderNumberQueryVariables>;
export const StationeryPrintOrderIdByOrderNumberDocument = gql`
    query StationeryPrintOrderIdByOrderNumber($orderNumber: String!, $eventId: ID!) {
  stationeryPrintOrderByOrderNumber(orderNumber: $orderNumber) {
    id
    printCardFrontPreviewUrl
    cardDraftJSONBlob
    cardDraft {
      id
      stationeryTemplate {
        id
        themeId
        category
        name
      }
    }
  }
  event: eventById(id: $eventId) {
    id
    guests(admin: true) {
      people {
        id
        firstName
        fullName
        phoneNumber: phoneDisplay
        email
      }
    }
  }
}
    `;

/**
 * __useStationeryPrintOrderIdByOrderNumberQuery__
 *
 * To run a query within a React component, call `useStationeryPrintOrderIdByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryPrintOrderIdByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryPrintOrderIdByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStationeryPrintOrderIdByOrderNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryPrintOrderIdByOrderNumberQuery, StationeryPrintOrderIdByOrderNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryPrintOrderIdByOrderNumberQuery, StationeryPrintOrderIdByOrderNumberQueryVariables>(StationeryPrintOrderIdByOrderNumberDocument, baseOptions);
      }
export function useStationeryPrintOrderIdByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryPrintOrderIdByOrderNumberQuery, StationeryPrintOrderIdByOrderNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryPrintOrderIdByOrderNumberQuery, StationeryPrintOrderIdByOrderNumberQueryVariables>(StationeryPrintOrderIdByOrderNumberDocument, baseOptions);
        }
export type StationeryPrintOrderIdByOrderNumberQueryHookResult = ReturnType<typeof useStationeryPrintOrderIdByOrderNumberQuery>;
export type StationeryPrintOrderIdByOrderNumberLazyQueryHookResult = ReturnType<typeof useStationeryPrintOrderIdByOrderNumberLazyQuery>;
export type StationeryPrintOrderIdByOrderNumberQueryResult = Apollo.QueryResult<StationeryPrintOrderIdByOrderNumberQuery, StationeryPrintOrderIdByOrderNumberQueryVariables>;
export const StationeryOrderTrackingDocument = gql`
    query StationeryOrderTracking($eventId: String!, $criteria: MessageSearchQueryCriteria, $cardViewInput: GetStationeryDigitalViewInput) {
  messageSearchResults(eventId: $eventId, criteria: $criteria) {
    allResult {
      messages {
        id
        type
        sentOn {
          milliseconds
        }
        status
        recipient {
          personId
          email
          phoneNumber
        }
      }
    }
  }
  stationeryDigitalCardView(data: $cardViewInput) {
    id
    personId
    src
  }
}
    `;

/**
 * __useStationeryOrderTrackingQuery__
 *
 * To run a query within a React component, call `useStationeryOrderTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryOrderTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryOrderTrackingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      criteria: // value for 'criteria'
 *      cardViewInput: // value for 'cardViewInput'
 *   },
 * });
 */
export function useStationeryOrderTrackingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryOrderTrackingQuery, StationeryOrderTrackingQueryVariables>) {
        return ApolloReactHooks.useQuery<StationeryOrderTrackingQuery, StationeryOrderTrackingQueryVariables>(StationeryOrderTrackingDocument, baseOptions);
      }
export function useStationeryOrderTrackingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryOrderTrackingQuery, StationeryOrderTrackingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StationeryOrderTrackingQuery, StationeryOrderTrackingQueryVariables>(StationeryOrderTrackingDocument, baseOptions);
        }
export type StationeryOrderTrackingQueryHookResult = ReturnType<typeof useStationeryOrderTrackingQuery>;
export type StationeryOrderTrackingLazyQueryHookResult = ReturnType<typeof useStationeryOrderTrackingLazyQuery>;
export type StationeryOrderTrackingQueryResult = Apollo.QueryResult<StationeryOrderTrackingQuery, StationeryOrderTrackingQueryVariables>;
export const CreateEcardShortLinkDocument = gql`
    mutation CreateEcardShortLink($data: CreateLinkRedirectInput!) {
  createLinkRedirect(data: $data) {
    id
    joyUrl
  }
}
    `;
export type CreateEcardShortLinkMutationFn = Apollo.MutationFunction<CreateEcardShortLinkMutation, CreateEcardShortLinkMutationVariables>;

/**
 * __useCreateEcardShortLinkMutation__
 *
 * To run a mutation, you first call `useCreateEcardShortLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcardShortLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcardShortLinkMutation, { data, loading, error }] = useCreateEcardShortLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEcardShortLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEcardShortLinkMutation, CreateEcardShortLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEcardShortLinkMutation, CreateEcardShortLinkMutationVariables>(CreateEcardShortLinkDocument, baseOptions);
      }
export type CreateEcardShortLinkMutationHookResult = ReturnType<typeof useCreateEcardShortLinkMutation>;
export type CreateEcardShortLinkMutationResult = Apollo.MutationResult<CreateEcardShortLinkMutation>;
export type CreateEcardShortLinkMutationOptions = Apollo.BaseMutationOptions<CreateEcardShortLinkMutation, CreateEcardShortLinkMutationVariables>;
export const GetPublicCardShopLoginFallbackTemplateDocument = gql`
    query GetPublicCardShopLoginFallbackTemplate($themeId: String!, $categories: [StationeryTemplateCategoryEnum!]) {
  stationeryTemplatesByThemeId(themeId: $themeId, categories: $categories) {
    id
    themeId
    themeJSON
    category
    premium
  }
}
    `;

/**
 * __useGetPublicCardShopLoginFallbackTemplateQuery__
 *
 * To run a query within a React component, call `useGetPublicCardShopLoginFallbackTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCardShopLoginFallbackTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCardShopLoginFallbackTemplateQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useGetPublicCardShopLoginFallbackTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPublicCardShopLoginFallbackTemplateQuery, GetPublicCardShopLoginFallbackTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPublicCardShopLoginFallbackTemplateQuery, GetPublicCardShopLoginFallbackTemplateQueryVariables>(GetPublicCardShopLoginFallbackTemplateDocument, baseOptions);
      }
export function useGetPublicCardShopLoginFallbackTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPublicCardShopLoginFallbackTemplateQuery, GetPublicCardShopLoginFallbackTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPublicCardShopLoginFallbackTemplateQuery, GetPublicCardShopLoginFallbackTemplateQueryVariables>(GetPublicCardShopLoginFallbackTemplateDocument, baseOptions);
        }
export type GetPublicCardShopLoginFallbackTemplateQueryHookResult = ReturnType<typeof useGetPublicCardShopLoginFallbackTemplateQuery>;
export type GetPublicCardShopLoginFallbackTemplateLazyQueryHookResult = ReturnType<typeof useGetPublicCardShopLoginFallbackTemplateLazyQuery>;
export type GetPublicCardShopLoginFallbackTemplateQueryResult = Apollo.QueryResult<GetPublicCardShopLoginFallbackTemplateQuery, GetPublicCardShopLoginFallbackTemplateQueryVariables>;
export const RestoreEventDocument = gql`
    mutation RestoreEvent($id: ID!) {
  restoreEvent(id: $id)
}
    `;
export type RestoreEventMutationFn = Apollo.MutationFunction<RestoreEventMutation, RestoreEventMutationVariables>;

/**
 * __useRestoreEventMutation__
 *
 * To run a mutation, you first call `useRestoreEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEventMutation, { data, loading, error }] = useRestoreEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreEventMutation, RestoreEventMutationVariables>) {
        return ApolloReactHooks.useMutation<RestoreEventMutation, RestoreEventMutationVariables>(RestoreEventDocument, baseOptions);
      }
export type RestoreEventMutationHookResult = ReturnType<typeof useRestoreEventMutation>;
export type RestoreEventMutationResult = Apollo.MutationResult<RestoreEventMutation>;
export type RestoreEventMutationOptions = Apollo.BaseMutationOptions<RestoreEventMutation, RestoreEventMutationVariables>;
export const GetEmailDeliveryDataDocument = gql`
    query GetEmailDeliveryData($args: EmailSearchCriteria) {
  getEmailDeliveryData(args: $args) {
    pageInfo {
      totalPageCount
    }
    edges {
      node {
        eventId
        messageId
        subject
        toEmail
        fromEmail
        status
        emailType
        createdDate
        mainContent
        statusHistory {
          status
          message
          description
        }
        replyToEmail
      }
    }
  }
}
    `;

/**
 * __useGetEmailDeliveryDataQuery__
 *
 * To run a query within a React component, call `useGetEmailDeliveryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDeliveryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDeliveryDataQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetEmailDeliveryDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailDeliveryDataQuery, GetEmailDeliveryDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmailDeliveryDataQuery, GetEmailDeliveryDataQueryVariables>(GetEmailDeliveryDataDocument, baseOptions);
      }
export function useGetEmailDeliveryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailDeliveryDataQuery, GetEmailDeliveryDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmailDeliveryDataQuery, GetEmailDeliveryDataQueryVariables>(GetEmailDeliveryDataDocument, baseOptions);
        }
export type GetEmailDeliveryDataQueryHookResult = ReturnType<typeof useGetEmailDeliveryDataQuery>;
export type GetEmailDeliveryDataLazyQueryHookResult = ReturnType<typeof useGetEmailDeliveryDataLazyQuery>;
export type GetEmailDeliveryDataQueryResult = Apollo.QueryResult<GetEmailDeliveryDataQuery, GetEmailDeliveryDataQueryVariables>;
export const GetEventByNameServiceCenterDocument = gql`
    query GetEventByNameServiceCenter($handle: String!) {
  eventByName(name: $handle) {
    id
    website
    firebaseId
    info {
      id
      safetyRating
    }
  }
}
    `;

/**
 * __useGetEventByNameServiceCenterQuery__
 *
 * To run a query within a React component, call `useGetEventByNameServiceCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameServiceCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameServiceCenterQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetEventByNameServiceCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameServiceCenterQuery, GetEventByNameServiceCenterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByNameServiceCenterQuery, GetEventByNameServiceCenterQueryVariables>(GetEventByNameServiceCenterDocument, baseOptions);
      }
export function useGetEventByNameServiceCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameServiceCenterQuery, GetEventByNameServiceCenterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByNameServiceCenterQuery, GetEventByNameServiceCenterQueryVariables>(GetEventByNameServiceCenterDocument, baseOptions);
        }
export type GetEventByNameServiceCenterQueryHookResult = ReturnType<typeof useGetEventByNameServiceCenterQuery>;
export type GetEventByNameServiceCenterLazyQueryHookResult = ReturnType<typeof useGetEventByNameServiceCenterLazyQuery>;
export type GetEventByNameServiceCenterQueryResult = Apollo.QueryResult<GetEventByNameServiceCenterQuery, GetEventByNameServiceCenterQueryVariables>;
export const GetEventByIdServiceCenterDocument = gql`
    query GetEventByIdServiceCenter($id: ID!) {
  eventById(id: $id) {
    id
    website
    firebaseId
    info {
      id
      safetyRating
    }
    eventUsers {
      id
      status
      user {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetEventByIdServiceCenterQuery__
 *
 * To run a query within a React component, call `useGetEventByIdServiceCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdServiceCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdServiceCenterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByIdServiceCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByIdServiceCenterQuery, GetEventByIdServiceCenterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByIdServiceCenterQuery, GetEventByIdServiceCenterQueryVariables>(GetEventByIdServiceCenterDocument, baseOptions);
      }
export function useGetEventByIdServiceCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByIdServiceCenterQuery, GetEventByIdServiceCenterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByIdServiceCenterQuery, GetEventByIdServiceCenterQueryVariables>(GetEventByIdServiceCenterDocument, baseOptions);
        }
export type GetEventByIdServiceCenterQueryHookResult = ReturnType<typeof useGetEventByIdServiceCenterQuery>;
export type GetEventByIdServiceCenterLazyQueryHookResult = ReturnType<typeof useGetEventByIdServiceCenterLazyQuery>;
export type GetEventByIdServiceCenterQueryResult = Apollo.QueryResult<GetEventByIdServiceCenterQuery, GetEventByIdServiceCenterQueryVariables>;
export const UpdateSafetyRatingDocument = gql`
    mutation UpdateSafetyRating($eventId: ID!, $safetyRating: SafetyRating!) {
  updateSafetyRating(eventId: $eventId, safetyRating: $safetyRating) {
    id
    safetyRating
  }
}
    `;
export type UpdateSafetyRatingMutationFn = Apollo.MutationFunction<UpdateSafetyRatingMutation, UpdateSafetyRatingMutationVariables>;

/**
 * __useUpdateSafetyRatingMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyRatingMutation, { data, loading, error }] = useUpdateSafetyRatingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      safetyRating: // value for 'safetyRating'
 *   },
 * });
 */
export function useUpdateSafetyRatingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSafetyRatingMutation, UpdateSafetyRatingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSafetyRatingMutation, UpdateSafetyRatingMutationVariables>(UpdateSafetyRatingDocument, baseOptions);
      }
export type UpdateSafetyRatingMutationHookResult = ReturnType<typeof useUpdateSafetyRatingMutation>;
export type UpdateSafetyRatingMutationResult = Apollo.MutationResult<UpdateSafetyRatingMutation>;
export type UpdateSafetyRatingMutationOptions = Apollo.BaseMutationOptions<UpdateSafetyRatingMutation, UpdateSafetyRatingMutationVariables>;
export const GetStationeryPrintOrdersDocument = gql`
    query GetStationeryPrintOrders($filters: StationeryPrintOrdersFiltersInput, $pagination: StationeryPrintOrdersPaginationInput) {
  stationeryPrintOrders(filters: $filters, pagination: $pagination) {
    count
    orders {
      ...StationeryPrintOrderFields
    }
  }
}
    ${StationeryPrintOrderFieldsFragmentDoc}`;

/**
 * __useGetStationeryPrintOrdersQuery__
 *
 * To run a query within a React component, call `useGetStationeryPrintOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryPrintOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryPrintOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetStationeryPrintOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>(GetStationeryPrintOrdersDocument, baseOptions);
      }
export function useGetStationeryPrintOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>(GetStationeryPrintOrdersDocument, baseOptions);
        }
export type GetStationeryPrintOrdersQueryHookResult = ReturnType<typeof useGetStationeryPrintOrdersQuery>;
export type GetStationeryPrintOrdersLazyQueryHookResult = ReturnType<typeof useGetStationeryPrintOrdersLazyQuery>;
export type GetStationeryPrintOrdersQueryResult = Apollo.QueryResult<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>;
export const GetStationeryPrintOrderByOrderNumberDocument = gql`
    query GetStationeryPrintOrderByOrderNumber($orderNumber: String!) {
  stationeryPrintOrderByOrderNumber(orderNumber: $orderNumber) {
    ...StationeryPrintOrderFields
  }
}
    ${StationeryPrintOrderFieldsFragmentDoc}`;

/**
 * __useGetStationeryPrintOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetStationeryPrintOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryPrintOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryPrintOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetStationeryPrintOrderByOrderNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>(GetStationeryPrintOrderByOrderNumberDocument, baseOptions);
      }
export function useGetStationeryPrintOrderByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>(GetStationeryPrintOrderByOrderNumberDocument, baseOptions);
        }
export type GetStationeryPrintOrderByOrderNumberQueryHookResult = ReturnType<typeof useGetStationeryPrintOrderByOrderNumberQuery>;
export type GetStationeryPrintOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetStationeryPrintOrderByOrderNumberLazyQuery>;
export type GetStationeryPrintOrderByOrderNumberQueryResult = Apollo.QueryResult<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>;
export const CancelStationeryPrintOrderByIdDocument = gql`
    mutation CancelStationeryPrintOrderById($id: ID!) {
  cancelStationeryPrintOrderById(id: $id) {
    id
  }
}
    `;
export type CancelStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>;

/**
 * __useCancelStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useCancelStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStationeryPrintOrderByIdMutation, { data, loading, error }] = useCancelStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelStationeryPrintOrderByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>(CancelStationeryPrintOrderByIdDocument, baseOptions);
      }
export type CancelStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useCancelStationeryPrintOrderByIdMutation>;
export type CancelStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<CancelStationeryPrintOrderByIdMutation>;
export type CancelStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>;
export const RefundStationeryPrintOrderByIdDocument = gql`
    mutation RefundStationeryPrintOrderById($id: ID!) {
  refundStationeryPrintOrderById(id: $id) {
    id
  }
}
    `;
export type RefundStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>;

/**
 * __useRefundStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useRefundStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundStationeryPrintOrderByIdMutation, { data, loading, error }] = useRefundStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundStationeryPrintOrderByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>(RefundStationeryPrintOrderByIdDocument, baseOptions);
      }
export type RefundStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useRefundStationeryPrintOrderByIdMutation>;
export type RefundStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<RefundStationeryPrintOrderByIdMutation>;
export type RefundStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>;
export const PauseStationeryPrintOrderByIdDocument = gql`
    mutation PauseStationeryPrintOrderById($id: ID!) {
  pauseStationeryPrintOrderById(id: $id) {
    id
  }
}
    `;
export type PauseStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>;

/**
 * __usePauseStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `usePauseStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseStationeryPrintOrderByIdMutation, { data, loading, error }] = usePauseStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseStationeryPrintOrderByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>(PauseStationeryPrintOrderByIdDocument, baseOptions);
      }
export type PauseStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof usePauseStationeryPrintOrderByIdMutation>;
export type PauseStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<PauseStationeryPrintOrderByIdMutation>;
export type PauseStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>;
export const ResumeStationeryPrintOrderByIdDocument = gql`
    mutation ResumeStationeryPrintOrderById($id: ID!) {
  resumeStationeryPrintOrderById(id: $id) {
    id
  }
}
    `;
export type ResumeStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>;

/**
 * __useResumeStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useResumeStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeStationeryPrintOrderByIdMutation, { data, loading, error }] = useResumeStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeStationeryPrintOrderByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>(ResumeStationeryPrintOrderByIdDocument, baseOptions);
      }
export type ResumeStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useResumeStationeryPrintOrderByIdMutation>;
export type ResumeStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<ResumeStationeryPrintOrderByIdMutation>;
export type ResumeStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>;
export const InstantlyProcessStationeryPrintOrderByIdDocument = gql`
    mutation InstantlyProcessStationeryPrintOrderById($id: ID!) {
  instantlyProcessStationeryPrintOrderById(id: $id) {
    id
  }
}
    `;
export type InstantlyProcessStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>;

/**
 * __useInstantlyProcessStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useInstantlyProcessStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantlyProcessStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantlyProcessStationeryPrintOrderByIdMutation, { data, loading, error }] = useInstantlyProcessStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstantlyProcessStationeryPrintOrderByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>) {
        return ApolloReactHooks.useMutation<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>(InstantlyProcessStationeryPrintOrderByIdDocument, baseOptions);
      }
export type InstantlyProcessStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useInstantlyProcessStationeryPrintOrderByIdMutation>;
export type InstantlyProcessStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<InstantlyProcessStationeryPrintOrderByIdMutation>;
export type InstantlyProcessStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>;
export const UpdateStationeryPrintOrderShippingAddressDocument = gql`
    mutation UpdateStationeryPrintOrderShippingAddress($data: UpdateStationeryPrintOrderShippingAddressInput!) {
  updateStationeryPrintOrderShippingAddress(data: $data)
}
    `;
export type UpdateStationeryPrintOrderShippingAddressMutationFn = Apollo.MutationFunction<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>;

/**
 * __useUpdateStationeryPrintOrderShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateStationeryPrintOrderShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStationeryPrintOrderShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStationeryPrintOrderShippingAddressMutation, { data, loading, error }] = useUpdateStationeryPrintOrderShippingAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStationeryPrintOrderShippingAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>(UpdateStationeryPrintOrderShippingAddressDocument, baseOptions);
      }
export type UpdateStationeryPrintOrderShippingAddressMutationHookResult = ReturnType<typeof useUpdateStationeryPrintOrderShippingAddressMutation>;
export type UpdateStationeryPrintOrderShippingAddressMutationResult = Apollo.MutationResult<UpdateStationeryPrintOrderShippingAddressMutation>;
export type UpdateStationeryPrintOrderShippingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>;
export const CombineStationeryPrintOrdersDocument = gql`
    mutation CombineStationeryPrintOrders($data: BundleStationeryPrintOrderInput!) {
  combineStationeryPrintOrders(data: $data)
}
    `;
export type CombineStationeryPrintOrdersMutationFn = Apollo.MutationFunction<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>;

/**
 * __useCombineStationeryPrintOrdersMutation__
 *
 * To run a mutation, you first call `useCombineStationeryPrintOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCombineStationeryPrintOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [combineStationeryPrintOrdersMutation, { data, loading, error }] = useCombineStationeryPrintOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCombineStationeryPrintOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>) {
        return ApolloReactHooks.useMutation<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>(CombineStationeryPrintOrdersDocument, baseOptions);
      }
export type CombineStationeryPrintOrdersMutationHookResult = ReturnType<typeof useCombineStationeryPrintOrdersMutation>;
export type CombineStationeryPrintOrdersMutationResult = Apollo.MutationResult<CombineStationeryPrintOrdersMutation>;
export type CombineStationeryPrintOrdersMutationOptions = Apollo.BaseMutationOptions<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>;
export const SetStationeryDigitalPrintOrderFeatureSmsDocument = gql`
    mutation SetStationeryDigitalPrintOrderFeatureSms($data: SetStationeryDigitalPrintOrderFeatureSmsInput!) {
  setStationeryDigitalPrintOrderFeatureSms(data: $data)
}
    `;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationFn = Apollo.MutationFunction<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>;

/**
 * __useSetStationeryDigitalPrintOrderFeatureSmsMutation__
 *
 * To run a mutation, you first call `useSetStationeryDigitalPrintOrderFeatureSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStationeryDigitalPrintOrderFeatureSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStationeryDigitalPrintOrderFeatureSmsMutation, { data, loading, error }] = useSetStationeryDigitalPrintOrderFeatureSmsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetStationeryDigitalPrintOrderFeatureSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>(SetStationeryDigitalPrintOrderFeatureSmsDocument, baseOptions);
      }
export type SetStationeryDigitalPrintOrderFeatureSmsMutationHookResult = ReturnType<typeof useSetStationeryDigitalPrintOrderFeatureSmsMutation>;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationResult = Apollo.MutationResult<SetStationeryDigitalPrintOrderFeatureSmsMutation>;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationOptions = Apollo.BaseMutationOptions<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>;
export const ServiceCenterStationeryTemplatesContainerDocument = gql`
    query ServiceCenterStationeryTemplatesContainer($filter: StationeryTemplateFilter!, $includeOptions: StationeryTemplateIncludeOptions, $first: Int) {
  stationeryTemplatesContainer(filter: $filter, includeOptions: $includeOptions) {
    pagedResults(first: $first) {
      totalCount
      edges {
        cursor
        node {
          id
          category
          themeId
          themeJSON
          widthInches
          heightInches
          side
        }
      }
      pageInfo {
        ...StationeryPageInfo
      }
    }
  }
}
    ${StationeryPageInfoFragmentDoc}`;

/**
 * __useServiceCenterStationeryTemplatesContainerQuery__
 *
 * To run a query within a React component, call `useServiceCenterStationeryTemplatesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCenterStationeryTemplatesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCenterStationeryTemplatesContainerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeOptions: // value for 'includeOptions'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useServiceCenterStationeryTemplatesContainerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServiceCenterStationeryTemplatesContainerQuery, ServiceCenterStationeryTemplatesContainerQueryVariables>) {
        return ApolloReactHooks.useQuery<ServiceCenterStationeryTemplatesContainerQuery, ServiceCenterStationeryTemplatesContainerQueryVariables>(ServiceCenterStationeryTemplatesContainerDocument, baseOptions);
      }
export function useServiceCenterStationeryTemplatesContainerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceCenterStationeryTemplatesContainerQuery, ServiceCenterStationeryTemplatesContainerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ServiceCenterStationeryTemplatesContainerQuery, ServiceCenterStationeryTemplatesContainerQueryVariables>(ServiceCenterStationeryTemplatesContainerDocument, baseOptions);
        }
export type ServiceCenterStationeryTemplatesContainerQueryHookResult = ReturnType<typeof useServiceCenterStationeryTemplatesContainerQuery>;
export type ServiceCenterStationeryTemplatesContainerLazyQueryHookResult = ReturnType<typeof useServiceCenterStationeryTemplatesContainerLazyQuery>;
export type ServiceCenterStationeryTemplatesContainerQueryResult = Apollo.QueryResult<ServiceCenterStationeryTemplatesContainerQuery, ServiceCenterStationeryTemplatesContainerQueryVariables>;
export const GetQuarantinedMessagesDocument = gql`
    query GetQuarantinedMessages($filter: ContactQuarantinedMessageBatchFilter!, $sort: ContactQuarantinedMessageBatchSort!, $first: Int, $after: ContactQuarantinedMessageBatchCursor) {
  contactQuarantinedMessageBatchContainer(filter: $filter, sort: $sort) {
    pagedResults(first: $first, after: $after) {
      totalCount
      edges {
        node {
          ...MessageInfo
        }
        ...MessageInfoCursor
      }
    }
  }
}
    ${MessageInfoFragmentDoc}
${MessageInfoCursorFragmentDoc}`;

/**
 * __useGetQuarantinedMessagesQuery__
 *
 * To run a query within a React component, call `useGetQuarantinedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuarantinedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuarantinedMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetQuarantinedMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuarantinedMessagesQuery, GetQuarantinedMessagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuarantinedMessagesQuery, GetQuarantinedMessagesQueryVariables>(GetQuarantinedMessagesDocument, baseOptions);
      }
export function useGetQuarantinedMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuarantinedMessagesQuery, GetQuarantinedMessagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuarantinedMessagesQuery, GetQuarantinedMessagesQueryVariables>(GetQuarantinedMessagesDocument, baseOptions);
        }
export type GetQuarantinedMessagesQueryHookResult = ReturnType<typeof useGetQuarantinedMessagesQuery>;
export type GetQuarantinedMessagesLazyQueryHookResult = ReturnType<typeof useGetQuarantinedMessagesLazyQuery>;
export type GetQuarantinedMessagesQueryResult = Apollo.QueryResult<GetQuarantinedMessagesQuery, GetQuarantinedMessagesQueryVariables>;
export const ResolveUserDocument = gql`
    query ResolveUser($userId: ID!) {
  user(id: $userId) {
    id
    lastName
    firstName
    email
  }
}
    `;

/**
 * __useResolveUserQuery__
 *
 * To run a query within a React component, call `useResolveUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResolveUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResolveUserQuery, ResolveUserQueryVariables>) {
        return ApolloReactHooks.useQuery<ResolveUserQuery, ResolveUserQueryVariables>(ResolveUserDocument, baseOptions);
      }
export function useResolveUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResolveUserQuery, ResolveUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ResolveUserQuery, ResolveUserQueryVariables>(ResolveUserDocument, baseOptions);
        }
export type ResolveUserQueryHookResult = ReturnType<typeof useResolveUserQuery>;
export type ResolveUserLazyQueryHookResult = ReturnType<typeof useResolveUserLazyQuery>;
export type ResolveUserQueryResult = Apollo.QueryResult<ResolveUserQuery, ResolveUserQueryVariables>;
export const GetEventInfoForServiceCenterDocument = gql`
    query GetEventInfoForServiceCenter($eventByIdId: ID!) {
  eventById(id: $eventByIdId) {
    id
    website
    info {
      id
      eventDisplayName
    }
  }
}
    `;

/**
 * __useGetEventInfoForServiceCenterQuery__
 *
 * To run a query within a React component, call `useGetEventInfoForServiceCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInfoForServiceCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInfoForServiceCenterQuery({
 *   variables: {
 *      eventByIdId: // value for 'eventByIdId'
 *   },
 * });
 */
export function useGetEventInfoForServiceCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventInfoForServiceCenterQuery, GetEventInfoForServiceCenterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventInfoForServiceCenterQuery, GetEventInfoForServiceCenterQueryVariables>(GetEventInfoForServiceCenterDocument, baseOptions);
      }
export function useGetEventInfoForServiceCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventInfoForServiceCenterQuery, GetEventInfoForServiceCenterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventInfoForServiceCenterQuery, GetEventInfoForServiceCenterQueryVariables>(GetEventInfoForServiceCenterDocument, baseOptions);
        }
export type GetEventInfoForServiceCenterQueryHookResult = ReturnType<typeof useGetEventInfoForServiceCenterQuery>;
export type GetEventInfoForServiceCenterLazyQueryHookResult = ReturnType<typeof useGetEventInfoForServiceCenterLazyQuery>;
export type GetEventInfoForServiceCenterQueryResult = Apollo.QueryResult<GetEventInfoForServiceCenterQuery, GetEventInfoForServiceCenterQueryVariables>;
export const ApproveContactMessageBatchDocument = gql`
    mutation ApproveContactMessageBatch($approveContactMessageBatchId: ID!) {
  approveContactMessageBatch(id: $approveContactMessageBatchId) {
    id
  }
}
    `;
export type ApproveContactMessageBatchMutationFn = Apollo.MutationFunction<ApproveContactMessageBatchMutation, ApproveContactMessageBatchMutationVariables>;

/**
 * __useApproveContactMessageBatchMutation__
 *
 * To run a mutation, you first call `useApproveContactMessageBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveContactMessageBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveContactMessageBatchMutation, { data, loading, error }] = useApproveContactMessageBatchMutation({
 *   variables: {
 *      approveContactMessageBatchId: // value for 'approveContactMessageBatchId'
 *   },
 * });
 */
export function useApproveContactMessageBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveContactMessageBatchMutation, ApproveContactMessageBatchMutationVariables>) {
        return ApolloReactHooks.useMutation<ApproveContactMessageBatchMutation, ApproveContactMessageBatchMutationVariables>(ApproveContactMessageBatchDocument, baseOptions);
      }
export type ApproveContactMessageBatchMutationHookResult = ReturnType<typeof useApproveContactMessageBatchMutation>;
export type ApproveContactMessageBatchMutationResult = Apollo.MutationResult<ApproveContactMessageBatchMutation>;
export type ApproveContactMessageBatchMutationOptions = Apollo.BaseMutationOptions<ApproveContactMessageBatchMutation, ApproveContactMessageBatchMutationVariables>;
export const RejectContactMessageBatchDocument = gql`
    mutation RejectContactMessageBatch($rejectContactMessageBatchId: ID!) {
  rejectContactMessageBatch(id: $rejectContactMessageBatchId) {
    id
  }
}
    `;
export type RejectContactMessageBatchMutationFn = Apollo.MutationFunction<RejectContactMessageBatchMutation, RejectContactMessageBatchMutationVariables>;

/**
 * __useRejectContactMessageBatchMutation__
 *
 * To run a mutation, you first call `useRejectContactMessageBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectContactMessageBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectContactMessageBatchMutation, { data, loading, error }] = useRejectContactMessageBatchMutation({
 *   variables: {
 *      rejectContactMessageBatchId: // value for 'rejectContactMessageBatchId'
 *   },
 * });
 */
export function useRejectContactMessageBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectContactMessageBatchMutation, RejectContactMessageBatchMutationVariables>) {
        return ApolloReactHooks.useMutation<RejectContactMessageBatchMutation, RejectContactMessageBatchMutationVariables>(RejectContactMessageBatchDocument, baseOptions);
      }
export type RejectContactMessageBatchMutationHookResult = ReturnType<typeof useRejectContactMessageBatchMutation>;
export type RejectContactMessageBatchMutationResult = Apollo.MutationResult<RejectContactMessageBatchMutation>;
export type RejectContactMessageBatchMutationOptions = Apollo.BaseMutationOptions<RejectContactMessageBatchMutation, RejectContactMessageBatchMutationVariables>;
export const GetEcardDataDocument = gql`
    query GetEcardData($eventId: ID!, $ecardType: EcardType) {
  eventById(id: $eventId) {
    id
    info {
      id
      date
      eventPassword
      location
      ownerFirstName
      fianceeFirstName
      finalizedDate {
        timestamp
      }
    }
    eventDesign {
      ...EcardEventDesign
    }
    photo {
      id
      url
    }
    photoV2Url
    settings {
      id
      privacyMode
    }
    pages(admin: true) {
      ...EventPage
    }
    ...DomainData
  }
  getMostRecentEcardByEventId(id: $eventId, ecardType: $ecardType) {
    ...ElectronicCard
  }
  getEcardEmailDraftsByEventId(eventId: $eventId, ecardType: $ecardType) {
    ...EcardEmailDraft
  }
  getEcardLinkOptionsByEventId(id: $eventId) {
    ...ElectronicCardCardLinkOption
  }
}
    ${EcardEventDesignFragmentDoc}
${EventPageFragmentDoc}
${DomainDataFragmentDoc}
${ElectronicCardFragmentDoc}
${EcardEmailDraftFragmentDoc}
${ElectronicCardCardLinkOptionFragmentDoc}`;

/**
 * __useGetEcardDataQuery__
 *
 * To run a query within a React component, call `useGetEcardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcardDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ecardType: // value for 'ecardType'
 *   },
 * });
 */
export function useGetEcardDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEcardDataQuery, GetEcardDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEcardDataQuery, GetEcardDataQueryVariables>(GetEcardDataDocument, baseOptions);
      }
export function useGetEcardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEcardDataQuery, GetEcardDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEcardDataQuery, GetEcardDataQueryVariables>(GetEcardDataDocument, baseOptions);
        }
export type GetEcardDataQueryHookResult = ReturnType<typeof useGetEcardDataQuery>;
export type GetEcardDataLazyQueryHookResult = ReturnType<typeof useGetEcardDataLazyQuery>;
export type GetEcardDataQueryResult = Apollo.QueryResult<GetEcardDataQuery, GetEcardDataQueryVariables>;
export const SaveEcardDocument = gql`
    mutation SaveEcard($payload: ElectronicCardInput!) {
  saveEcard(payload: $payload) {
    id
  }
}
    `;
export type SaveEcardMutationFn = Apollo.MutationFunction<SaveEcardMutation, SaveEcardMutationVariables>;

/**
 * __useSaveEcardMutation__
 *
 * To run a mutation, you first call `useSaveEcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEcardMutation, { data, loading, error }] = useSaveEcardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveEcardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEcardMutation, SaveEcardMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveEcardMutation, SaveEcardMutationVariables>(SaveEcardDocument, baseOptions);
      }
export type SaveEcardMutationHookResult = ReturnType<typeof useSaveEcardMutation>;
export type SaveEcardMutationResult = Apollo.MutationResult<SaveEcardMutation>;
export type SaveEcardMutationOptions = Apollo.BaseMutationOptions<SaveEcardMutation, SaveEcardMutationVariables>;
export const SaveEcardDesignDocument = gql`
    mutation SaveEcardDesign($payload: EcardDesignInput!) {
  saveEcardDesign(payload: $payload)
}
    `;
export type SaveEcardDesignMutationFn = Apollo.MutationFunction<SaveEcardDesignMutation, SaveEcardDesignMutationVariables>;

/**
 * __useSaveEcardDesignMutation__
 *
 * To run a mutation, you first call `useSaveEcardDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEcardDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEcardDesignMutation, { data, loading, error }] = useSaveEcardDesignMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveEcardDesignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEcardDesignMutation, SaveEcardDesignMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveEcardDesignMutation, SaveEcardDesignMutationVariables>(SaveEcardDesignDocument, baseOptions);
      }
export type SaveEcardDesignMutationHookResult = ReturnType<typeof useSaveEcardDesignMutation>;
export type SaveEcardDesignMutationResult = Apollo.MutationResult<SaveEcardDesignMutation>;
export type SaveEcardDesignMutationOptions = Apollo.BaseMutationOptions<SaveEcardDesignMutation, SaveEcardDesignMutationVariables>;
export const SendEcardGuestEmailDocument = gql`
    mutation SendEcardGuestEmail($payload: ElectronicCardEmailMessageInput) {
  sendEcardGuestEmail(payload: $payload)
}
    `;
export type SendEcardGuestEmailMutationFn = Apollo.MutationFunction<SendEcardGuestEmailMutation, SendEcardGuestEmailMutationVariables>;

/**
 * __useSendEcardGuestEmailMutation__
 *
 * To run a mutation, you first call `useSendEcardGuestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEcardGuestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEcardGuestEmailMutation, { data, loading, error }] = useSendEcardGuestEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendEcardGuestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEcardGuestEmailMutation, SendEcardGuestEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendEcardGuestEmailMutation, SendEcardGuestEmailMutationVariables>(SendEcardGuestEmailDocument, baseOptions);
      }
export type SendEcardGuestEmailMutationHookResult = ReturnType<typeof useSendEcardGuestEmailMutation>;
export type SendEcardGuestEmailMutationResult = Apollo.MutationResult<SendEcardGuestEmailMutation>;
export type SendEcardGuestEmailMutationOptions = Apollo.BaseMutationOptions<SendEcardGuestEmailMutation, SendEcardGuestEmailMutationVariables>;
export const EcardThemesDocument = gql`
    query EcardThemes {
  themes {
    ...Theme
  }
}
    ${ThemeFragmentDoc}`;

/**
 * __useEcardThemesQuery__
 *
 * To run a query within a React component, call `useEcardThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcardThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcardThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEcardThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EcardThemesQuery, EcardThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<EcardThemesQuery, EcardThemesQueryVariables>(EcardThemesDocument, baseOptions);
      }
export function useEcardThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EcardThemesQuery, EcardThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EcardThemesQuery, EcardThemesQueryVariables>(EcardThemesDocument, baseOptions);
        }
export type EcardThemesQueryHookResult = ReturnType<typeof useEcardThemesQuery>;
export type EcardThemesLazyQueryHookResult = ReturnType<typeof useEcardThemesLazyQuery>;
export type EcardThemesQueryResult = Apollo.QueryResult<EcardThemesQuery, EcardThemesQueryVariables>;
export const CharmEditorThemesDocument = gql`
    query CharmEditorThemes {
  themes {
    ...CharmTheme
  }
}
    ${CharmThemeFragmentDoc}`;

/**
 * __useCharmEditorThemesQuery__
 *
 * To run a query within a React component, call `useCharmEditorThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharmEditorThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharmEditorThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCharmEditorThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CharmEditorThemesQuery, CharmEditorThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<CharmEditorThemesQuery, CharmEditorThemesQueryVariables>(CharmEditorThemesDocument, baseOptions);
      }
export function useCharmEditorThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CharmEditorThemesQuery, CharmEditorThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CharmEditorThemesQuery, CharmEditorThemesQueryVariables>(CharmEditorThemesDocument, baseOptions);
        }
export type CharmEditorThemesQueryHookResult = ReturnType<typeof useCharmEditorThemesQuery>;
export type CharmEditorThemesLazyQueryHookResult = ReturnType<typeof useCharmEditorThemesLazyQuery>;
export type CharmEditorThemesQueryResult = Apollo.QueryResult<CharmEditorThemesQuery, CharmEditorThemesQueryVariables>;
export const EcardThemeByThemeIdDocument = gql`
    query EcardThemeByThemeId($themeId: String!) {
  themeByThemeId(themeId: $themeId) {
    ...Theme
  }
}
    ${ThemeFragmentDoc}`;

/**
 * __useEcardThemeByThemeIdQuery__
 *
 * To run a query within a React component, call `useEcardThemeByThemeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcardThemeByThemeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcardThemeByThemeIdQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useEcardThemeByThemeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EcardThemeByThemeIdQuery, EcardThemeByThemeIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EcardThemeByThemeIdQuery, EcardThemeByThemeIdQueryVariables>(EcardThemeByThemeIdDocument, baseOptions);
      }
export function useEcardThemeByThemeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EcardThemeByThemeIdQuery, EcardThemeByThemeIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EcardThemeByThemeIdQuery, EcardThemeByThemeIdQueryVariables>(EcardThemeByThemeIdDocument, baseOptions);
        }
export type EcardThemeByThemeIdQueryHookResult = ReturnType<typeof useEcardThemeByThemeIdQuery>;
export type EcardThemeByThemeIdLazyQueryHookResult = ReturnType<typeof useEcardThemeByThemeIdLazyQuery>;
export type EcardThemeByThemeIdQueryResult = Apollo.QueryResult<EcardThemeByThemeIdQuery, EcardThemeByThemeIdQueryVariables>;
export const SaveEcardEmailDocument = gql`
    mutation SaveEcardEmail($payload: ElectronicCardEmailDraftInput) {
  saveEcardEmailDraft(payload: $payload)
}
    `;
export type SaveEcardEmailMutationFn = Apollo.MutationFunction<SaveEcardEmailMutation, SaveEcardEmailMutationVariables>;

/**
 * __useSaveEcardEmailMutation__
 *
 * To run a mutation, you first call `useSaveEcardEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEcardEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEcardEmailMutation, { data, loading, error }] = useSaveEcardEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveEcardEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEcardEmailMutation, SaveEcardEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveEcardEmailMutation, SaveEcardEmailMutationVariables>(SaveEcardEmailDocument, baseOptions);
      }
export type SaveEcardEmailMutationHookResult = ReturnType<typeof useSaveEcardEmailMutation>;
export type SaveEcardEmailMutationResult = Apollo.MutationResult<SaveEcardEmailMutation>;
export type SaveEcardEmailMutationOptions = Apollo.BaseMutationOptions<SaveEcardEmailMutation, SaveEcardEmailMutationVariables>;
export const GetEcardByGuidDocument = gql`
    query GetEcardByGuid($lookupId: ID!) {
  getEcardRecepientDisplayByLookupId(lookupId: $lookupId) {
    ...ElectronicCard
  }
}
    ${ElectronicCardFragmentDoc}`;

/**
 * __useGetEcardByGuidQuery__
 *
 * To run a query within a React component, call `useGetEcardByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcardByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcardByGuidQuery({
 *   variables: {
 *      lookupId: // value for 'lookupId'
 *   },
 * });
 */
export function useGetEcardByGuidQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEcardByGuidQuery, GetEcardByGuidQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEcardByGuidQuery, GetEcardByGuidQueryVariables>(GetEcardByGuidDocument, baseOptions);
      }
export function useGetEcardByGuidLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEcardByGuidQuery, GetEcardByGuidQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEcardByGuidQuery, GetEcardByGuidQueryVariables>(GetEcardByGuidDocument, baseOptions);
        }
export type GetEcardByGuidQueryHookResult = ReturnType<typeof useGetEcardByGuidQuery>;
export type GetEcardByGuidLazyQueryHookResult = ReturnType<typeof useGetEcardByGuidLazyQuery>;
export type GetEcardByGuidQueryResult = Apollo.QueryResult<GetEcardByGuidQuery, GetEcardByGuidQueryVariables>;
export const GetEcardGuestExtraDataDocument = gql`
    query GetEcardGuestExtraData($eventId: ID!) {
  eventById(id: $eventId) {
    id
    eventDesign {
      ...EventDesign
    }
    info {
      id
      eventPassword
      eventDisplayName
      finalizedDate {
        timestamp
      }
      locale
    }
    settings {
      id
      privacyMode
    }
    ...DomainData
  }
  getEcardLinkOptionsByEventId(id: $eventId) {
    ...ElectronicCardCardLinkOption
  }
}
    ${EventDesignFragmentDoc}
${DomainDataFragmentDoc}
${ElectronicCardCardLinkOptionFragmentDoc}`;

/**
 * __useGetEcardGuestExtraDataQuery__
 *
 * To run a query within a React component, call `useGetEcardGuestExtraDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcardGuestExtraDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcardGuestExtraDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEcardGuestExtraDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEcardGuestExtraDataQuery, GetEcardGuestExtraDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEcardGuestExtraDataQuery, GetEcardGuestExtraDataQueryVariables>(GetEcardGuestExtraDataDocument, baseOptions);
      }
export function useGetEcardGuestExtraDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEcardGuestExtraDataQuery, GetEcardGuestExtraDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEcardGuestExtraDataQuery, GetEcardGuestExtraDataQueryVariables>(GetEcardGuestExtraDataDocument, baseOptions);
        }
export type GetEcardGuestExtraDataQueryHookResult = ReturnType<typeof useGetEcardGuestExtraDataQuery>;
export type GetEcardGuestExtraDataLazyQueryHookResult = ReturnType<typeof useGetEcardGuestExtraDataLazyQuery>;
export type GetEcardGuestExtraDataQueryResult = Apollo.QueryResult<GetEcardGuestExtraDataQuery, GetEcardGuestExtraDataQueryVariables>;
export const GuestCanGetAccessEventByNameActionBarDocument = gql`
    query GuestCanGetAccessEventByNameActionBar($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info(admin: true) {
      id
      location
      eventDateIsFinalized
      dateV0918 {
        dateString(dateFormat: full)
        milliseconds
      }
      schedule {
        items {
          ...EventScheduleItemStream
        }
        virtualScheduleItemNow {
          ...EventScheduleItemStream
        }
      }
    }
  }
}
    ${EventScheduleItemStreamFragmentDoc}`;

/**
 * __useGuestCanGetAccessEventByNameActionBarQuery__
 *
 * To run a query within a React component, call `useGuestCanGetAccessEventByNameActionBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestCanGetAccessEventByNameActionBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestCanGetAccessEventByNameActionBarQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGuestCanGetAccessEventByNameActionBarQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestCanGetAccessEventByNameActionBarQuery, GuestCanGetAccessEventByNameActionBarQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestCanGetAccessEventByNameActionBarQuery, GuestCanGetAccessEventByNameActionBarQueryVariables>(GuestCanGetAccessEventByNameActionBarDocument, baseOptions);
      }
export function useGuestCanGetAccessEventByNameActionBarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestCanGetAccessEventByNameActionBarQuery, GuestCanGetAccessEventByNameActionBarQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestCanGetAccessEventByNameActionBarQuery, GuestCanGetAccessEventByNameActionBarQueryVariables>(GuestCanGetAccessEventByNameActionBarDocument, baseOptions);
        }
export type GuestCanGetAccessEventByNameActionBarQueryHookResult = ReturnType<typeof useGuestCanGetAccessEventByNameActionBarQuery>;
export type GuestCanGetAccessEventByNameActionBarLazyQueryHookResult = ReturnType<typeof useGuestCanGetAccessEventByNameActionBarLazyQuery>;
export type GuestCanGetAccessEventByNameActionBarQueryResult = Apollo.QueryResult<GuestCanGetAccessEventByNameActionBarQuery, GuestCanGetAccessEventByNameActionBarQueryVariables>;
export const EventWebsiteGuestDocument = gql`
    query EventWebsiteGuest($eventHandle: String!, $eventDesignPurpose: EventDesignPurpose!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    website
    featureFlags
    useLegacyGuestSite
    eventDesign(purpose: $eventDesignPurpose) {
      ...EventDesign
    }
    photo {
      id
      url
      width
      height
      layout {
        alignX
        alignY
      }
    }
    photoV2Url
    photoV2UrlMobile
    mobilePhoto {
      id
      url
      width
      height
      layout {
        alignX
        alignY
      }
    }
    video {
      id
      url
      title
      thumbnailUrl
      mimeType
      caption
    }
    info(admin: true) {
      ...EventInfoFragment
      announcementBanner {
        title
        message
        active
      }
    }
    settings {
      id
      hideFromSearchEngines
    }
    pages(admin: $isAdminDashboard) {
      ...EventPage
    }
    pageContainers {
      id
      mainPhotoAlignment {
        x
        y
      }
      ...CustomPagePhotoPresentationInfo
    }
  }
}
    ${EventDesignFragmentDoc}
${EventInfoFragmentFragmentDoc}
${EventPageFragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}`;

/**
 * __useEventWebsiteGuestQuery__
 *
 * To run a query within a React component, call `useEventWebsiteGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteGuestQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useEventWebsiteGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>(EventWebsiteGuestDocument, baseOptions);
      }
export function useEventWebsiteGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>(EventWebsiteGuestDocument, baseOptions);
        }
export type EventWebsiteGuestQueryHookResult = ReturnType<typeof useEventWebsiteGuestQuery>;
export type EventWebsiteGuestLazyQueryHookResult = ReturnType<typeof useEventWebsiteGuestLazyQuery>;
export type EventWebsiteGuestQueryResult = Apollo.QueryResult<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>;
export const EventWebsiteGuestTelemetryDocument = gql`
    query EventWebsiteGuestTelemetry($eventHandle: String!, $eventDesignPurpose: EventDesignPurpose!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    eventDesign(purpose: $eventDesignPurpose) {
      id
      websiteLayout {
        id
        layoutType
      }
    }
    info {
      id
      finalizedDate {
        dateString
      }
    }
    activeSession {
      id
      hasUnlocked
    }
    pages(admin: $isAdminDashboard) {
      id
      pageTitle
      pageSlug
      visibility
      disabled
      private
    }
  }
}
    `;

/**
 * __useEventWebsiteGuestTelemetryQuery__
 *
 * To run a query within a React component, call `useEventWebsiteGuestTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteGuestTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteGuestTelemetryQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useEventWebsiteGuestTelemetryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteGuestTelemetryQuery, EventWebsiteGuestTelemetryQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWebsiteGuestTelemetryQuery, EventWebsiteGuestTelemetryQueryVariables>(EventWebsiteGuestTelemetryDocument, baseOptions);
      }
export function useEventWebsiteGuestTelemetryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteGuestTelemetryQuery, EventWebsiteGuestTelemetryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWebsiteGuestTelemetryQuery, EventWebsiteGuestTelemetryQueryVariables>(EventWebsiteGuestTelemetryDocument, baseOptions);
        }
export type EventWebsiteGuestTelemetryQueryHookResult = ReturnType<typeof useEventWebsiteGuestTelemetryQuery>;
export type EventWebsiteGuestTelemetryLazyQueryHookResult = ReturnType<typeof useEventWebsiteGuestTelemetryLazyQuery>;
export type EventWebsiteGuestTelemetryQueryResult = Apollo.QueryResult<EventWebsiteGuestTelemetryQuery, EventWebsiteGuestTelemetryQueryVariables>;
export const GetGuestsiteDataForPagesDocument = gql`
    query GetGuestsiteDataForPages($eventHandle: String!, $isAdminDashboard: Boolean, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    id
    eventDesign(purpose: $eventDesignPurpose) {
      id
      websiteLayout {
        id
        layoutType
      }
    }
    info(admin: $isAdminDashboard) {
      id
      story
      tidbits: qanda(type: tidbit) {
        ...EventQanda
      }
    }
  }
}
    ${EventQandaFragmentDoc}`;

/**
 * __useGetGuestsiteDataForPagesQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteDataForPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteDataForPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteDataForPagesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGetGuestsiteDataForPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteDataForPagesQuery, GetGuestsiteDataForPagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteDataForPagesQuery, GetGuestsiteDataForPagesQueryVariables>(GetGuestsiteDataForPagesDocument, baseOptions);
      }
export function useGetGuestsiteDataForPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteDataForPagesQuery, GetGuestsiteDataForPagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteDataForPagesQuery, GetGuestsiteDataForPagesQueryVariables>(GetGuestsiteDataForPagesDocument, baseOptions);
        }
export type GetGuestsiteDataForPagesQueryHookResult = ReturnType<typeof useGetGuestsiteDataForPagesQuery>;
export type GetGuestsiteDataForPagesLazyQueryHookResult = ReturnType<typeof useGetGuestsiteDataForPagesLazyQuery>;
export type GetGuestsiteDataForPagesQueryResult = Apollo.QueryResult<GetGuestsiteDataForPagesQuery, GetGuestsiteDataForPagesQueryVariables>;
export const GetEventCTAButtonsDataDocument = gql`
    query GetEventCTAButtonsData($name: String!) {
  eventByName(name: $name) {
    id
    info {
      id
      eventType
    }
    activeSession {
      ...GetEventCTASession
    }
    welcomePage: pageInfo(type: welcome) {
      ...GetEventCTAPageInfo
    }
    storyPage: pageInfo(type: story) {
      ...GetEventCTAPageInfo
    }
    tidbitsPage: pageInfo(type: tidbits) {
      ...GetEventCTAPageInfo
    }
    schedulePage: pageInfo(type: schedule) {
      ...GetEventCTAPageInfo
    }
    travelPage: pageInfo(type: travel) {
      ...GetEventCTAPageInfo
    }
    faqPage: pageInfo(type: faq) {
      ...GetEventCTAPageInfo
    }
    weddingPage: pageInfo(type: vip) {
      ...GetEventCTAPageInfo
    }
    registryPage: pageInfo(type: registry) {
      ...GetEventCTAPageInfo
    }
    momentsPage: pageInfo(type: moments) {
      ...GetEventCTAPageInfo
    }
    rsvpPage: pageInfo(type: rsvp) {
      ...GetEventCTAPageInfo
    }
    customPages: pagesInfo(type: custom) {
      ...GetEventCTAPageInfo
      page {
        id
        pageSlug
      }
    }
  }
}
    ${GetEventCTASessionFragmentDoc}
${GetEventCTAPageInfoFragmentDoc}`;

/**
 * __useGetEventCTAButtonsDataQuery__
 *
 * To run a query within a React component, call `useGetEventCTAButtonsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCTAButtonsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCTAButtonsDataQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventCTAButtonsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventCTAButtonsDataQuery, GetEventCTAButtonsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventCTAButtonsDataQuery, GetEventCTAButtonsDataQueryVariables>(GetEventCTAButtonsDataDocument, baseOptions);
      }
export function useGetEventCTAButtonsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventCTAButtonsDataQuery, GetEventCTAButtonsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventCTAButtonsDataQuery, GetEventCTAButtonsDataQueryVariables>(GetEventCTAButtonsDataDocument, baseOptions);
        }
export type GetEventCTAButtonsDataQueryHookResult = ReturnType<typeof useGetEventCTAButtonsDataQuery>;
export type GetEventCTAButtonsDataLazyQueryHookResult = ReturnType<typeof useGetEventCTAButtonsDataLazyQuery>;
export type GetEventCTAButtonsDataQueryResult = Apollo.QueryResult<GetEventCTAButtonsDataQuery, GetEventCTAButtonsDataQueryVariables>;
export const GetRsvpPropertiesDocument = gql`
    query GetRsvpProperties($eventName: String!) {
  eventByName(name: $eventName) {
    id
    rsvpPage: pageInfo(type: rsvp) {
      id
      disabled
      private
      visibility
    }
  }
}
    `;

/**
 * __useGetRsvpPropertiesQuery__
 *
 * To run a query within a React component, call `useGetRsvpPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRsvpPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRsvpPropertiesQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *   },
 * });
 */
export function useGetRsvpPropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRsvpPropertiesQuery, GetRsvpPropertiesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRsvpPropertiesQuery, GetRsvpPropertiesQueryVariables>(GetRsvpPropertiesDocument, baseOptions);
      }
export function useGetRsvpPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRsvpPropertiesQuery, GetRsvpPropertiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRsvpPropertiesQuery, GetRsvpPropertiesQueryVariables>(GetRsvpPropertiesDocument, baseOptions);
        }
export type GetRsvpPropertiesQueryHookResult = ReturnType<typeof useGetRsvpPropertiesQuery>;
export type GetRsvpPropertiesLazyQueryHookResult = ReturnType<typeof useGetRsvpPropertiesLazyQuery>;
export type GetRsvpPropertiesQueryResult = Apollo.QueryResult<GetRsvpPropertiesQuery, GetRsvpPropertiesQueryVariables>;
export const FindInviteDocument = gql`
    query FindInvite($eventId: ID!, $firstName: String, $lastName: String, $email: String) {
  event(id: $eventId) {
    id
    activeSession {
      id
      sessionId
    }
    findPeople(criteria: {firstName: $firstName, lastName: $lastName, email: $email}, options: {allGuestStates: true, strategy: myInvite}) {
      resultCount
      results {
        person {
          id
          personIdTag
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useFindInviteQuery__
 *
 * To run a query within a React component, call `useFindInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindInviteQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFindInviteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindInviteQuery, FindInviteQueryVariables>) {
        return ApolloReactHooks.useQuery<FindInviteQuery, FindInviteQueryVariables>(FindInviteDocument, baseOptions);
      }
export function useFindInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindInviteQuery, FindInviteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindInviteQuery, FindInviteQueryVariables>(FindInviteDocument, baseOptions);
        }
export type FindInviteQueryHookResult = ReturnType<typeof useFindInviteQuery>;
export type FindInviteLazyQueryHookResult = ReturnType<typeof useFindInviteLazyQuery>;
export type FindInviteQueryResult = Apollo.QueryResult<FindInviteQuery, FindInviteQueryVariables>;
export const GuestSiteWebsiteHeaderSettingsDocument = gql`
    query GuestSiteWebsiteHeaderSettings($eventHandle: String!, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventDisplayName
      greeting
    }
    eventDesign(purpose: $eventDesignPurpose) {
      id
      websiteLayout {
        id
        layoutType
      }
      activeWebsiteHeaderPresentationLayout {
        ...WebsiteHeaderPresentationSettings
      }
    }
  }
}
    ${WebsiteHeaderPresentationSettingsFragmentDoc}`;

/**
 * __useGuestSiteWebsiteHeaderSettingsQuery__
 *
 * To run a query within a React component, call `useGuestSiteWebsiteHeaderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestSiteWebsiteHeaderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestSiteWebsiteHeaderSettingsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGuestSiteWebsiteHeaderSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestSiteWebsiteHeaderSettingsQuery, GuestSiteWebsiteHeaderSettingsQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestSiteWebsiteHeaderSettingsQuery, GuestSiteWebsiteHeaderSettingsQueryVariables>(GuestSiteWebsiteHeaderSettingsDocument, baseOptions);
      }
export function useGuestSiteWebsiteHeaderSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestSiteWebsiteHeaderSettingsQuery, GuestSiteWebsiteHeaderSettingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestSiteWebsiteHeaderSettingsQuery, GuestSiteWebsiteHeaderSettingsQueryVariables>(GuestSiteWebsiteHeaderSettingsDocument, baseOptions);
        }
export type GuestSiteWebsiteHeaderSettingsQueryHookResult = ReturnType<typeof useGuestSiteWebsiteHeaderSettingsQuery>;
export type GuestSiteWebsiteHeaderSettingsLazyQueryHookResult = ReturnType<typeof useGuestSiteWebsiteHeaderSettingsLazyQuery>;
export type GuestSiteWebsiteHeaderSettingsQueryResult = Apollo.QueryResult<GuestSiteWebsiteHeaderSettingsQuery, GuestSiteWebsiteHeaderSettingsQueryVariables>;
export const WebsitePageListDocument = gql`
    query WebsitePageList($eventHandle: String!, $admin: Boolean!) {
  eventByName(name: $eventHandle) {
    id
    pages(admin: $admin) {
      createdAt {
        timestamp
      }
      pageTitle
      pageSlug
      visibility
      subTitle: pageSubTitleV0918
      id
      isPageContainer
      type
    }
  }
}
    `;

/**
 * __useWebsitePageListQuery__
 *
 * To run a query within a React component, call `useWebsitePageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePageListQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useWebsitePageListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsitePageListQuery, WebsitePageListQueryVariables>) {
        return ApolloReactHooks.useQuery<WebsitePageListQuery, WebsitePageListQueryVariables>(WebsitePageListDocument, baseOptions);
      }
export function useWebsitePageListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsitePageListQuery, WebsitePageListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WebsitePageListQuery, WebsitePageListQueryVariables>(WebsitePageListDocument, baseOptions);
        }
export type WebsitePageListQueryHookResult = ReturnType<typeof useWebsitePageListQuery>;
export type WebsitePageListLazyQueryHookResult = ReturnType<typeof useWebsitePageListLazyQuery>;
export type WebsitePageListQueryResult = Apollo.QueryResult<WebsitePageListQuery, WebsitePageListQueryVariables>;
export const GetGuestsiteCoupleStoryAndQandasDocument = gql`
    query GetGuestsiteCoupleStoryAndQandas($eventHandle: String!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    info(admin: $isAdminDashboard) {
      id
      story
      tidbits: qanda(type: tidbit) {
        ...EventQanda
      }
    }
  }
}
    ${EventQandaFragmentDoc}`;

/**
 * __useGetGuestsiteCoupleStoryAndQandasQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteCoupleStoryAndQandasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteCoupleStoryAndQandasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteCoupleStoryAndQandasQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteCoupleStoryAndQandasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteCoupleStoryAndQandasQuery, GetGuestsiteCoupleStoryAndQandasQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteCoupleStoryAndQandasQuery, GetGuestsiteCoupleStoryAndQandasQueryVariables>(GetGuestsiteCoupleStoryAndQandasDocument, baseOptions);
      }
export function useGetGuestsiteCoupleStoryAndQandasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteCoupleStoryAndQandasQuery, GetGuestsiteCoupleStoryAndQandasQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteCoupleStoryAndQandasQuery, GetGuestsiteCoupleStoryAndQandasQueryVariables>(GetGuestsiteCoupleStoryAndQandasDocument, baseOptions);
        }
export type GetGuestsiteCoupleStoryAndQandasQueryHookResult = ReturnType<typeof useGetGuestsiteCoupleStoryAndQandasQuery>;
export type GetGuestsiteCoupleStoryAndQandasLazyQueryHookResult = ReturnType<typeof useGetGuestsiteCoupleStoryAndQandasLazyQuery>;
export type GetGuestsiteCoupleStoryAndQandasQueryResult = Apollo.QueryResult<GetGuestsiteCoupleStoryAndQandasQuery, GetGuestsiteCoupleStoryAndQandasQueryVariables>;
export const GuestPageDataContainerByIdDocument = gql`
    query GuestPageDataContainerById($payload: JsonDataContainerByIdPayload!) {
  jsonDataContainerById(payload: $payload) {
    ...JsonDataContainer
  }
}
    ${JsonDataContainerFragmentDoc}`;

/**
 * __useGuestPageDataContainerByIdQuery__
 *
 * To run a query within a React component, call `useGuestPageDataContainerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPageDataContainerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPageDataContainerByIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGuestPageDataContainerByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>(GuestPageDataContainerByIdDocument, baseOptions);
      }
export function useGuestPageDataContainerByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>(GuestPageDataContainerByIdDocument, baseOptions);
        }
export type GuestPageDataContainerByIdQueryHookResult = ReturnType<typeof useGuestPageDataContainerByIdQuery>;
export type GuestPageDataContainerByIdLazyQueryHookResult = ReturnType<typeof useGuestPageDataContainerByIdLazyQuery>;
export type GuestPageDataContainerByIdQueryResult = Apollo.QueryResult<GuestPageDataContainerByIdQuery, GuestPageDataContainerByIdQueryVariables>;
export const GuestPageContainerBySlugDocument = gql`
    query GuestPageContainerBySlug($payload: PageContainerBySlugPayload!, $isAdminDashboard: Boolean) {
  pageContainerBySlug(payload: $payload, options: {admin: $isAdminDashboard}) {
    id
    slug
    createdAt {
      timestamp
    }
    components {
      ...GuestTextComponent
      ...GuestTravelMapComponent
      ...GuestPhotoComponent
      ...GuestVideoComponent
      ...GuestMediaGalleryComponent
      ...GuestEventDetailsComponent
      ...GuestRsvpAndUnlockGuestDetailsButtonComponent
      ...GuestJsonDataBlobComponent
    }
  }
}
    ${GuestTextComponentFragmentDoc}
${GuestTravelMapComponentFragmentDoc}
${GuestPhotoComponentFragmentDoc}
${GuestVideoComponentFragmentDoc}
${GuestMediaGalleryComponentFragmentDoc}
${GuestEventDetailsComponentFragmentDoc}
${GuestRsvpAndUnlockGuestDetailsButtonComponentFragmentDoc}
${GuestJsonDataBlobComponentFragmentDoc}`;

/**
 * __useGuestPageContainerBySlugQuery__
 *
 * To run a query within a React component, call `useGuestPageContainerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPageContainerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPageContainerBySlugQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGuestPageContainerBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>(GuestPageContainerBySlugDocument, baseOptions);
      }
export function useGuestPageContainerBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>(GuestPageContainerBySlugDocument, baseOptions);
        }
export type GuestPageContainerBySlugQueryHookResult = ReturnType<typeof useGuestPageContainerBySlugQuery>;
export type GuestPageContainerBySlugLazyQueryHookResult = ReturnType<typeof useGuestPageContainerBySlugLazyQuery>;
export type GuestPageContainerBySlugQueryResult = Apollo.QueryResult<GuestPageContainerBySlugQuery, GuestPageContainerBySlugQueryVariables>;
export const GuestEventHotelRoomBlocksDocument = gql`
    query GuestEventHotelRoomBlocks($eventId: ID!) {
  event(id: $eventId) {
    id
    travelSettings {
      currencyCode
    }
    info {
      id
      timezone
    }
    photo {
      id
      url
    }
    accommodationPlacesV2 {
      id
      type
      isFavorite
      userNote
      name
      description
      address
      city
      state
      postalCode
      starRating
      country
      email
      phone
      url
      lat
      long
      photo {
        id
        url
      }
      isPhotoHidden
      zhId
      googlePlaceId
      customPhoto {
        id
        url
      }
      customName
      customAddress
      customUrl
      customPhone
      createdByType
      accommodationRoomBlock {
        ...AccommodationRoomBlock
      }
      isFromAccommodationCatalog
      isHostStayingHere
      joyPlaceId
      isCustomLinkEnabled
      distances {
        ...TravelDistancesBetweenPointsResponse
      }
    }
  }
}
    ${AccommodationRoomBlockFragmentDoc}
${TravelDistancesBetweenPointsResponseFragmentDoc}`;

/**
 * __useGuestEventHotelRoomBlocksQuery__
 *
 * To run a query within a React component, call `useGuestEventHotelRoomBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestEventHotelRoomBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestEventHotelRoomBlocksQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGuestEventHotelRoomBlocksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>(GuestEventHotelRoomBlocksDocument, baseOptions);
      }
export function useGuestEventHotelRoomBlocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>(GuestEventHotelRoomBlocksDocument, baseOptions);
        }
export type GuestEventHotelRoomBlocksQueryHookResult = ReturnType<typeof useGuestEventHotelRoomBlocksQuery>;
export type GuestEventHotelRoomBlocksLazyQueryHookResult = ReturnType<typeof useGuestEventHotelRoomBlocksLazyQuery>;
export type GuestEventHotelRoomBlocksQueryResult = Apollo.QueryResult<GuestEventHotelRoomBlocksQuery, GuestEventHotelRoomBlocksQueryVariables>;
export const AccommodationPagePricingDocument = gql`
    query AccommodationPagePricing($payload: TravelPricingsForAccommodationByPropertyIdPayload!) {
  travelPricingsForAccommodationByPropertyId(payload: $payload) {
    pricings {
      ...PricingByPropertyId
    }
  }
}
    ${PricingByPropertyIdFragmentDoc}`;

/**
 * __useAccommodationPagePricingQuery__
 *
 * To run a query within a React component, call `useAccommodationPagePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPagePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPagePricingQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPagePricingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>(AccommodationPagePricingDocument, baseOptions);
      }
export function useAccommodationPagePricingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>(AccommodationPagePricingDocument, baseOptions);
        }
export type AccommodationPagePricingQueryHookResult = ReturnType<typeof useAccommodationPagePricingQuery>;
export type AccommodationPagePricingLazyQueryHookResult = ReturnType<typeof useAccommodationPagePricingLazyQuery>;
export type AccommodationPagePricingQueryResult = Apollo.QueryResult<AccommodationPagePricingQuery, AccommodationPagePricingQueryVariables>;
export const TravelPlacesPricingAndBookingDetailsDocument = gql`
    query TravelPlacesPricingAndBookingDetails($payload: TravelPlacePricingAndBookingDetailsPayload!) {
  travelPlacesPricingAndBookingDetails(payload: $payload) {
    accommodationPlaces {
      ...TravelPlacePricingAndBookingDetails
    }
    joyPlaces {
      ...TravelJoyPlacePricingAndBookingDetails
    }
  }
}
    ${TravelPlacePricingAndBookingDetailsFragmentDoc}
${TravelJoyPlacePricingAndBookingDetailsFragmentDoc}`;

/**
 * __useTravelPlacesPricingAndBookingDetailsQuery__
 *
 * To run a query within a React component, call `useTravelPlacesPricingAndBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelPlacesPricingAndBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelPlacesPricingAndBookingDetailsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelPlacesPricingAndBookingDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>(TravelPlacesPricingAndBookingDetailsDocument, baseOptions);
      }
export function useTravelPlacesPricingAndBookingDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>(TravelPlacesPricingAndBookingDetailsDocument, baseOptions);
        }
export type TravelPlacesPricingAndBookingDetailsQueryHookResult = ReturnType<typeof useTravelPlacesPricingAndBookingDetailsQuery>;
export type TravelPlacesPricingAndBookingDetailsLazyQueryHookResult = ReturnType<typeof useTravelPlacesPricingAndBookingDetailsLazyQuery>;
export type TravelPlacesPricingAndBookingDetailsQueryResult = Apollo.QueryResult<TravelPlacesPricingAndBookingDetailsQuery, TravelPlacesPricingAndBookingDetailsQueryVariables>;
export const IncrementInterestedGuestCountDocument = gql`
    mutation IncrementInterestedGuestCount($reservedRoomBlockId: ID!) {
  incrementInterestedGuestCount(reservedRoomBlockId: $reservedRoomBlockId)
}
    `;
export type IncrementInterestedGuestCountMutationFn = Apollo.MutationFunction<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>;

/**
 * __useIncrementInterestedGuestCountMutation__
 *
 * To run a mutation, you first call `useIncrementInterestedGuestCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementInterestedGuestCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementInterestedGuestCountMutation, { data, loading, error }] = useIncrementInterestedGuestCountMutation({
 *   variables: {
 *      reservedRoomBlockId: // value for 'reservedRoomBlockId'
 *   },
 * });
 */
export function useIncrementInterestedGuestCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>) {
        return ApolloReactHooks.useMutation<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>(IncrementInterestedGuestCountDocument, baseOptions);
      }
export type IncrementInterestedGuestCountMutationHookResult = ReturnType<typeof useIncrementInterestedGuestCountMutation>;
export type IncrementInterestedGuestCountMutationResult = Apollo.MutationResult<IncrementInterestedGuestCountMutation>;
export type IncrementInterestedGuestCountMutationOptions = Apollo.BaseMutationOptions<IncrementInterestedGuestCountMutation, IncrementInterestedGuestCountMutationVariables>;
export const TravelReservationSummariesByPropertyIdentifiersDocument = gql`
    query TravelReservationSummariesByPropertyIdentifiers($payload: TravelReservationSummariesByPropertyIdentifiersPayload!) {
  travelReservationSummariesByPropertyIdentifiers(payload: $payload) {
    reservationSummaries {
      identifier {
        id
        type
      }
      reservationsCount
    }
  }
}
    `;

/**
 * __useTravelReservationSummariesByPropertyIdentifiersQuery__
 *
 * To run a query within a React component, call `useTravelReservationSummariesByPropertyIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelReservationSummariesByPropertyIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelReservationSummariesByPropertyIdentifiersQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelReservationSummariesByPropertyIdentifiersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>(TravelReservationSummariesByPropertyIdentifiersDocument, baseOptions);
      }
export function useTravelReservationSummariesByPropertyIdentifiersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>(TravelReservationSummariesByPropertyIdentifiersDocument, baseOptions);
        }
export type TravelReservationSummariesByPropertyIdentifiersQueryHookResult = ReturnType<typeof useTravelReservationSummariesByPropertyIdentifiersQuery>;
export type TravelReservationSummariesByPropertyIdentifiersLazyQueryHookResult = ReturnType<typeof useTravelReservationSummariesByPropertyIdentifiersLazyQuery>;
export type TravelReservationSummariesByPropertyIdentifiersQueryResult = Apollo.QueryResult<TravelReservationSummariesByPropertyIdentifiersQuery, TravelReservationSummariesByPropertyIdentifiersQueryVariables>;
export const TravelRateComparisonsForTravelPlacesDocument = gql`
    query TravelRateComparisonsForTravelPlaces($payload: ComparisonsForTravelPlaceIdPayload!) {
  travelRateComparisonsForTravelPlaces(payload: $payload) {
    ...PriceComparison
  }
}
    ${PriceComparisonFragmentDoc}`;

/**
 * __useTravelRateComparisonsForTravelPlacesQuery__
 *
 * To run a query within a React component, call `useTravelRateComparisonsForTravelPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRateComparisonsForTravelPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRateComparisonsForTravelPlacesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelRateComparisonsForTravelPlacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>(TravelRateComparisonsForTravelPlacesDocument, baseOptions);
      }
export function useTravelRateComparisonsForTravelPlacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>(TravelRateComparisonsForTravelPlacesDocument, baseOptions);
        }
export type TravelRateComparisonsForTravelPlacesQueryHookResult = ReturnType<typeof useTravelRateComparisonsForTravelPlacesQuery>;
export type TravelRateComparisonsForTravelPlacesLazyQueryHookResult = ReturnType<typeof useTravelRateComparisonsForTravelPlacesLazyQuery>;
export type TravelRateComparisonsForTravelPlacesQueryResult = Apollo.QueryResult<TravelRateComparisonsForTravelPlacesQuery, TravelRateComparisonsForTravelPlacesQueryVariables>;
export const GetGuestsiteFaqDocument = gql`
    query GetGuestsiteFaq($eventHandle: String!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    info(admin: $isAdminDashboard) {
      id
      faq: qanda(type: faq) {
        ...EventQanda
      }
    }
  }
}
    ${EventQandaFragmentDoc}`;

/**
 * __useGetGuestsiteFaqQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteFaqQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteFaqQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>(GetGuestsiteFaqDocument, baseOptions);
      }
export function useGetGuestsiteFaqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>(GetGuestsiteFaqDocument, baseOptions);
        }
export type GetGuestsiteFaqQueryHookResult = ReturnType<typeof useGetGuestsiteFaqQuery>;
export type GetGuestsiteFaqLazyQueryHookResult = ReturnType<typeof useGetGuestsiteFaqLazyQuery>;
export type GetGuestsiteFaqQueryResult = Apollo.QueryResult<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>;
export const GetGuestsiteRegistryDocument = gql`
    query GetGuestsiteRegistry($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      registry {
        ...GuestSiteRegistry
      }
    }
  }
}
    ${GuestSiteRegistryFragmentDoc}`;

/**
 * __useGetGuestsiteRegistryQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteRegistryQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetGuestsiteRegistryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteRegistryQuery, GetGuestsiteRegistryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteRegistryQuery, GetGuestsiteRegistryQueryVariables>(GetGuestsiteRegistryDocument, baseOptions);
      }
export function useGetGuestsiteRegistryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteRegistryQuery, GetGuestsiteRegistryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteRegistryQuery, GetGuestsiteRegistryQueryVariables>(GetGuestsiteRegistryDocument, baseOptions);
        }
export type GetGuestsiteRegistryQueryHookResult = ReturnType<typeof useGetGuestsiteRegistryQuery>;
export type GetGuestsiteRegistryLazyQueryHookResult = ReturnType<typeof useGetGuestsiteRegistryLazyQuery>;
export type GetGuestsiteRegistryQueryResult = Apollo.QueryResult<GetGuestsiteRegistryQuery, GetGuestsiteRegistryQueryVariables>;
export const GetGuestSiteScheduleDocument = gql`
    query GetGuestSiteSchedule($eventHandle: String!, $isAdmin: Boolean) {
  eventByName(name: $eventHandle) {
    id
    activeSession {
      ...GetGuestSiteScheduleCTASession
    }
    info(admin: $isAdmin) {
      id
      schedule {
        formattedSchedules {
          ...FormattedEventSchedule
        }
        toBeAnnouncedItems {
          ...EventSchedule
        }
      }
    }
  }
}
    ${GetGuestSiteScheduleCTASessionFragmentDoc}
${FormattedEventScheduleFragmentDoc}
${EventScheduleFragmentDoc}`;

/**
 * __useGetGuestSiteScheduleQuery__
 *
 * To run a query within a React component, call `useGetGuestSiteScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestSiteScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestSiteScheduleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetGuestSiteScheduleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>(GetGuestSiteScheduleDocument, baseOptions);
      }
export function useGetGuestSiteScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>(GetGuestSiteScheduleDocument, baseOptions);
        }
export type GetGuestSiteScheduleQueryHookResult = ReturnType<typeof useGetGuestSiteScheduleQuery>;
export type GetGuestSiteScheduleLazyQueryHookResult = ReturnType<typeof useGetGuestSiteScheduleLazyQuery>;
export type GetGuestSiteScheduleQueryResult = Apollo.QueryResult<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>;
export const GetGuestsiteTidbitsDocument = gql`
    query GetGuestsiteTidbits($eventHandle: String!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    info(admin: $isAdminDashboard) {
      id
      tidbits: qanda(type: tidbit) {
        ...EventQanda
      }
    }
  }
}
    ${EventQandaFragmentDoc}`;

/**
 * __useGetGuestsiteTidbitsQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteTidbitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteTidbitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteTidbitsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteTidbitsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteTidbitsQuery, GetGuestsiteTidbitsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteTidbitsQuery, GetGuestsiteTidbitsQueryVariables>(GetGuestsiteTidbitsDocument, baseOptions);
      }
export function useGetGuestsiteTidbitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteTidbitsQuery, GetGuestsiteTidbitsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteTidbitsQuery, GetGuestsiteTidbitsQueryVariables>(GetGuestsiteTidbitsDocument, baseOptions);
        }
export type GetGuestsiteTidbitsQueryHookResult = ReturnType<typeof useGetGuestsiteTidbitsQuery>;
export type GetGuestsiteTidbitsLazyQueryHookResult = ReturnType<typeof useGetGuestsiteTidbitsLazyQuery>;
export type GetGuestsiteTidbitsQueryResult = Apollo.QueryResult<GetGuestsiteTidbitsQuery, GetGuestsiteTidbitsQueryVariables>;
export const GetGuestsiteTravelListDocument = gql`
    query GetGuestsiteTravelList($eventHandle: String!, $isAdminDashboard: Boolean) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
    hotelRoomBlocks {
      id
      submittedDateTime
    }
    info(admin: $isAdminDashboard) {
      id
      travel {
        ...EventTravel
      }
    }
  }
}
    ${EventTravelFragmentDoc}`;

/**
 * __useGetGuestsiteTravelListQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteTravelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteTravelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteTravelListQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteTravelListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>(GetGuestsiteTravelListDocument, baseOptions);
      }
export function useGetGuestsiteTravelListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>(GetGuestsiteTravelListDocument, baseOptions);
        }
export type GetGuestsiteTravelListQueryHookResult = ReturnType<typeof useGetGuestsiteTravelListQuery>;
export type GetGuestsiteTravelListLazyQueryHookResult = ReturnType<typeof useGetGuestsiteTravelListLazyQuery>;
export type GetGuestsiteTravelListQueryResult = Apollo.QueryResult<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>;
export const GetGuestsiteVipsDocument = gql`
    query GetGuestsiteVips($eventId: ID!, $isAdminDashboard: Boolean) {
  eventById(id: $eventId) {
    id
    vips(admin: $isAdminDashboard) {
      ...Vip
    }
  }
}
    ${VipFragmentDoc}`;

/**
 * __useGetGuestsiteVipsQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteVipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteVipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteVipsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteVipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteVipsQuery, GetGuestsiteVipsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteVipsQuery, GetGuestsiteVipsQueryVariables>(GetGuestsiteVipsDocument, baseOptions);
      }
export function useGetGuestsiteVipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteVipsQuery, GetGuestsiteVipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteVipsQuery, GetGuestsiteVipsQueryVariables>(GetGuestsiteVipsDocument, baseOptions);
        }
export type GetGuestsiteVipsQueryHookResult = ReturnType<typeof useGetGuestsiteVipsQuery>;
export type GetGuestsiteVipsLazyQueryHookResult = ReturnType<typeof useGetGuestsiteVipsLazyQuery>;
export type GetGuestsiteVipsQueryResult = Apollo.QueryResult<GetGuestsiteVipsQuery, GetGuestsiteVipsQueryVariables>;
export const GetGuestsiteEventVipsDocument = gql`
    query GetGuestsiteEventVips($payload: EventVipsPayload!) {
  eventVips(payload: $payload) {
    ...Vip
  }
}
    ${VipFragmentDoc}`;

/**
 * __useGetGuestsiteEventVipsQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteEventVipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteEventVipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteEventVipsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetGuestsiteEventVipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteEventVipsQuery, GetGuestsiteEventVipsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGuestsiteEventVipsQuery, GetGuestsiteEventVipsQueryVariables>(GetGuestsiteEventVipsDocument, baseOptions);
      }
export function useGetGuestsiteEventVipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteEventVipsQuery, GetGuestsiteEventVipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGuestsiteEventVipsQuery, GetGuestsiteEventVipsQueryVariables>(GetGuestsiteEventVipsDocument, baseOptions);
        }
export type GetGuestsiteEventVipsQueryHookResult = ReturnType<typeof useGetGuestsiteEventVipsQuery>;
export type GetGuestsiteEventVipsLazyQueryHookResult = ReturnType<typeof useGetGuestsiteEventVipsLazyQuery>;
export type GetGuestsiteEventVipsQueryResult = Apollo.QueryResult<GetGuestsiteEventVipsQuery, GetGuestsiteEventVipsQueryVariables>;
export const GetCashFundForContributionDocument = gql`
    query GetCashFundForContribution($input: GetCashFundForContributionInput!) {
  getCashFundForContribution(input: $input) {
    cashFund {
      ...PublicCashFund
    }
    host {
      ...PublicCashFundsHost
    }
    invite {
      ...CashFundInvite
    }
  }
}
    ${PublicCashFundFragmentDoc}
${PublicCashFundsHostFragmentDoc}
${CashFundInviteFragmentDoc}`;

/**
 * __useGetCashFundForContributionQuery__
 *
 * To run a query within a React component, call `useGetCashFundForContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundForContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundForContributionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCashFundForContributionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>(GetCashFundForContributionDocument, baseOptions);
      }
export function useGetCashFundForContributionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>(GetCashFundForContributionDocument, baseOptions);
        }
export type GetCashFundForContributionQueryHookResult = ReturnType<typeof useGetCashFundForContributionQuery>;
export type GetCashFundForContributionLazyQueryHookResult = ReturnType<typeof useGetCashFundForContributionLazyQuery>;
export type GetCashFundForContributionQueryResult = Apollo.QueryResult<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>;
export const GetCashFundPaymentAttemptByIdDocument = gql`
    query GetCashFundPaymentAttemptById($id: ID!) {
  getCashFundPaymentAttemptById(id: $id) {
    ...CashFundPaymentAttempt
    order {
      ...CashFundOrder
    }
    cashFund {
      ...PublicCashFund
    }
  }
}
    ${CashFundPaymentAttemptFragmentDoc}
${CashFundOrderFragmentDoc}
${PublicCashFundFragmentDoc}`;

/**
 * __useGetCashFundPaymentAttemptByIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundPaymentAttemptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundPaymentAttemptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundPaymentAttemptByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCashFundPaymentAttemptByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>(GetCashFundPaymentAttemptByIdDocument, baseOptions);
      }
export function useGetCashFundPaymentAttemptByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>(GetCashFundPaymentAttemptByIdDocument, baseOptions);
        }
export type GetCashFundPaymentAttemptByIdQueryHookResult = ReturnType<typeof useGetCashFundPaymentAttemptByIdQuery>;
export type GetCashFundPaymentAttemptByIdLazyQueryHookResult = ReturnType<typeof useGetCashFundPaymentAttemptByIdLazyQuery>;
export type GetCashFundPaymentAttemptByIdQueryResult = Apollo.QueryResult<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>;
export const GetCashFundContributorByIdDocument = gql`
    query GetCashFundContributorById($id: ID!) {
  getCashFundContributorById(id: $id) {
    ...CashFundContributor
  }
}
    ${CashFundContributorFragmentDoc}`;

/**
 * __useGetCashFundContributorByIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundContributorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundContributorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundContributorByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCashFundContributorByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>(GetCashFundContributorByIdDocument, baseOptions);
      }
export function useGetCashFundContributorByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>(GetCashFundContributorByIdDocument, baseOptions);
        }
export type GetCashFundContributorByIdQueryHookResult = ReturnType<typeof useGetCashFundContributorByIdQuery>;
export type GetCashFundContributorByIdLazyQueryHookResult = ReturnType<typeof useGetCashFundContributorByIdLazyQuery>;
export type GetCashFundContributorByIdQueryResult = Apollo.QueryResult<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>;
export const CalculateCashFundContributionReceiptDocument = gql`
    query CalculateCashFundContributionReceipt($input: CalculateCashFundContributionReceiptInput!) {
  calculateCashFundContributionReceipt(input: $input) {
    contributionAmount {
      ...MonetaryValue
    }
    fees {
      amount {
        ...MonetaryValue
      }
    }
    total {
      ...MonetaryValue
    }
    totalFees {
      ...MonetaryValue
    }
  }
}
    ${MonetaryValueFragmentDoc}`;

/**
 * __useCalculateCashFundContributionReceiptQuery__
 *
 * To run a query within a React component, call `useCalculateCashFundContributionReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateCashFundContributionReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateCashFundContributionReceiptQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateCashFundContributionReceiptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>) {
        return ApolloReactHooks.useQuery<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>(CalculateCashFundContributionReceiptDocument, baseOptions);
      }
export function useCalculateCashFundContributionReceiptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>(CalculateCashFundContributionReceiptDocument, baseOptions);
        }
export type CalculateCashFundContributionReceiptQueryHookResult = ReturnType<typeof useCalculateCashFundContributionReceiptQuery>;
export type CalculateCashFundContributionReceiptLazyQueryHookResult = ReturnType<typeof useCalculateCashFundContributionReceiptLazyQuery>;
export type CalculateCashFundContributionReceiptQueryResult = Apollo.QueryResult<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>;
export const CreateCashFundPaymentIntentDocument = gql`
    mutation CreateCashFundPaymentIntent($input: CreateCashFundPaymentIntentInput!) {
  createCashFundPaymentIntent(input: $input) {
    ... on CashFundPaymentIntent {
      id
      clientSecret
      paymentAttempt {
        id
      }
    }
    ... on CashFundGeneralError {
      code
    }
  }
}
    `;
export type CreateCashFundPaymentIntentMutationFn = Apollo.MutationFunction<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>;

/**
 * __useCreateCashFundPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateCashFundPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundPaymentIntentMutation, { data, loading, error }] = useCreateCashFundPaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundPaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>(CreateCashFundPaymentIntentDocument, baseOptions);
      }
export type CreateCashFundPaymentIntentMutationHookResult = ReturnType<typeof useCreateCashFundPaymentIntentMutation>;
export type CreateCashFundPaymentIntentMutationResult = Apollo.MutationResult<CreateCashFundPaymentIntentMutation>;
export type CreateCashFundPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>;
export const CreateCashFundCheckoutSessionDocument = gql`
    mutation CreateCashFundCheckoutSession($input: CreateCashFundCheckoutSessionInput!) {
  createCashFundCheckoutSession(input: $input) {
    ... on CashFundCheckoutSession {
      id
      redirectUrl
    }
    ... on CashFundGeneralError {
      code
    }
  }
}
    `;
export type CreateCashFundCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>;

/**
 * __useCreateCashFundCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCashFundCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundCheckoutSessionMutation, { data, loading, error }] = useCreateCashFundCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundCheckoutSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>(CreateCashFundCheckoutSessionDocument, baseOptions);
      }
export type CreateCashFundCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCashFundCheckoutSessionMutation>;
export type CreateCashFundCheckoutSessionMutationResult = Apollo.MutationResult<CreateCashFundCheckoutSessionMutation>;
export type CreateCashFundCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>;
export const CollaboratorsGetCollaborationInviteByIdDocument = gql`
    query CollaboratorsGetCollaborationInviteById($getCollaborationInviteByIdId: ID!) {
  getCollaborationInviteById(id: $getCollaborationInviteByIdId) {
    state
    id
    eventId
    inviteeEmailAddress
    inviteeFirstName
    inviteeLastName
    senderUserId
  }
}
    `;

/**
 * __useCollaboratorsGetCollaborationInviteByIdQuery__
 *
 * To run a query within a React component, call `useCollaboratorsGetCollaborationInviteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorsGetCollaborationInviteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaboratorsGetCollaborationInviteByIdQuery({
 *   variables: {
 *      getCollaborationInviteByIdId: // value for 'getCollaborationInviteByIdId'
 *   },
 * });
 */
export function useCollaboratorsGetCollaborationInviteByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CollaboratorsGetCollaborationInviteByIdQuery, CollaboratorsGetCollaborationInviteByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<CollaboratorsGetCollaborationInviteByIdQuery, CollaboratorsGetCollaborationInviteByIdQueryVariables>(CollaboratorsGetCollaborationInviteByIdDocument, baseOptions);
      }
export function useCollaboratorsGetCollaborationInviteByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CollaboratorsGetCollaborationInviteByIdQuery, CollaboratorsGetCollaborationInviteByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CollaboratorsGetCollaborationInviteByIdQuery, CollaboratorsGetCollaborationInviteByIdQueryVariables>(CollaboratorsGetCollaborationInviteByIdDocument, baseOptions);
        }
export type CollaboratorsGetCollaborationInviteByIdQueryHookResult = ReturnType<typeof useCollaboratorsGetCollaborationInviteByIdQuery>;
export type CollaboratorsGetCollaborationInviteByIdLazyQueryHookResult = ReturnType<typeof useCollaboratorsGetCollaborationInviteByIdLazyQuery>;
export type CollaboratorsGetCollaborationInviteByIdQueryResult = Apollo.QueryResult<CollaboratorsGetCollaborationInviteByIdQuery, CollaboratorsGetCollaborationInviteByIdQueryVariables>;
export const CollaboratorsAcceptEventAdminInviteDocument = gql`
    mutation CollaboratorsAcceptEventAdminInvite($acceptCollaborationInviteId: ID!) {
  acceptCollaborationInvite(id: $acceptCollaborationInviteId) {
    id
    status
    event {
      id
    }
  }
}
    `;
export type CollaboratorsAcceptEventAdminInviteMutationFn = Apollo.MutationFunction<CollaboratorsAcceptEventAdminInviteMutation, CollaboratorsAcceptEventAdminInviteMutationVariables>;

/**
 * __useCollaboratorsAcceptEventAdminInviteMutation__
 *
 * To run a mutation, you first call `useCollaboratorsAcceptEventAdminInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorsAcceptEventAdminInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collaboratorsAcceptEventAdminInviteMutation, { data, loading, error }] = useCollaboratorsAcceptEventAdminInviteMutation({
 *   variables: {
 *      acceptCollaborationInviteId: // value for 'acceptCollaborationInviteId'
 *   },
 * });
 */
export function useCollaboratorsAcceptEventAdminInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CollaboratorsAcceptEventAdminInviteMutation, CollaboratorsAcceptEventAdminInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<CollaboratorsAcceptEventAdminInviteMutation, CollaboratorsAcceptEventAdminInviteMutationVariables>(CollaboratorsAcceptEventAdminInviteDocument, baseOptions);
      }
export type CollaboratorsAcceptEventAdminInviteMutationHookResult = ReturnType<typeof useCollaboratorsAcceptEventAdminInviteMutation>;
export type CollaboratorsAcceptEventAdminInviteMutationResult = Apollo.MutationResult<CollaboratorsAcceptEventAdminInviteMutation>;
export type CollaboratorsAcceptEventAdminInviteMutationOptions = Apollo.BaseMutationOptions<CollaboratorsAcceptEventAdminInviteMutation, CollaboratorsAcceptEventAdminInviteMutationVariables>;
export const EventWebsiteGuestHeadDocument = gql`
    query EventWebsiteGuestHead($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    website
    photo {
      id
      url
    }
    eventDesign {
      id
      activeWebsiteHeaderPresentationLayout {
        id: eventId
        schemaURL
        websiteLayout
        dataJSON
      }
    }
    photoV2Url
    info {
      id
      ownerFirstName
      ownerLastName
      fianceeFirstName
      eventDisplayName
      eventType
    }
    settings {
      id
      hideFromSearchEngines
    }
    pages {
      id
      pageTitle
      pageSlug
      type
      disabled
      visibility
      private
      isPageContainer
    }
  }
}
    `;

/**
 * __useEventWebsiteGuestHeadQuery__
 *
 * To run a query within a React component, call `useEventWebsiteGuestHeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteGuestHeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteGuestHeadQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventWebsiteGuestHeadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteGuestHeadQuery, EventWebsiteGuestHeadQueryVariables>) {
        return ApolloReactHooks.useQuery<EventWebsiteGuestHeadQuery, EventWebsiteGuestHeadQueryVariables>(EventWebsiteGuestHeadDocument, baseOptions);
      }
export function useEventWebsiteGuestHeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteGuestHeadQuery, EventWebsiteGuestHeadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventWebsiteGuestHeadQuery, EventWebsiteGuestHeadQueryVariables>(EventWebsiteGuestHeadDocument, baseOptions);
        }
export type EventWebsiteGuestHeadQueryHookResult = ReturnType<typeof useEventWebsiteGuestHeadQuery>;
export type EventWebsiteGuestHeadLazyQueryHookResult = ReturnType<typeof useEventWebsiteGuestHeadLazyQuery>;
export type EventWebsiteGuestHeadQueryResult = Apollo.QueryResult<EventWebsiteGuestHeadQuery, EventWebsiteGuestHeadQueryVariables>;
export const GuestHotelRoomBlocksLinkDocument = gql`
    query GuestHotelRoomBlocksLink($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    website
    hotelRoomBlocks {
      id
      bookingLink
    }
  }
}
    `;

/**
 * __useGuestHotelRoomBlocksLinkQuery__
 *
 * To run a query within a React component, call `useGuestHotelRoomBlocksLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestHotelRoomBlocksLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestHotelRoomBlocksLinkQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGuestHotelRoomBlocksLinkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestHotelRoomBlocksLinkQuery, GuestHotelRoomBlocksLinkQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestHotelRoomBlocksLinkQuery, GuestHotelRoomBlocksLinkQueryVariables>(GuestHotelRoomBlocksLinkDocument, baseOptions);
      }
export function useGuestHotelRoomBlocksLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestHotelRoomBlocksLinkQuery, GuestHotelRoomBlocksLinkQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestHotelRoomBlocksLinkQuery, GuestHotelRoomBlocksLinkQueryVariables>(GuestHotelRoomBlocksLinkDocument, baseOptions);
        }
export type GuestHotelRoomBlocksLinkQueryHookResult = ReturnType<typeof useGuestHotelRoomBlocksLinkQuery>;
export type GuestHotelRoomBlocksLinkLazyQueryHookResult = ReturnType<typeof useGuestHotelRoomBlocksLinkLazyQuery>;
export type GuestHotelRoomBlocksLinkQueryResult = Apollo.QueryResult<GuestHotelRoomBlocksLinkQuery, GuestHotelRoomBlocksLinkQueryVariables>;
export const AccommodationPlaceV2ByIdDocument = gql`
    query AccommodationPlaceV2ById($accommodationPlaceV2ByIdId: ID!) {
  accommodationPlaceV2ById(id: $accommodationPlaceV2ByIdId) {
    id
    joyPlaceId
    name
    address
    url
    customUrl
    lat
    long
    zhId
    googlePlaceId
    accommodationRoomBlock {
      ...AccommodationRoomBlock
    }
  }
}
    ${AccommodationRoomBlockFragmentDoc}`;

/**
 * __useAccommodationPlaceV2ByIdQuery__
 *
 * To run a query within a React component, call `useAccommodationPlaceV2ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPlaceV2ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPlaceV2ByIdQuery({
 *   variables: {
 *      accommodationPlaceV2ByIdId: // value for 'accommodationPlaceV2ByIdId'
 *   },
 * });
 */
export function useAccommodationPlaceV2ByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPlaceV2ByIdQuery, AccommodationPlaceV2ByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationPlaceV2ByIdQuery, AccommodationPlaceV2ByIdQueryVariables>(AccommodationPlaceV2ByIdDocument, baseOptions);
      }
export function useAccommodationPlaceV2ByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPlaceV2ByIdQuery, AccommodationPlaceV2ByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationPlaceV2ByIdQuery, AccommodationPlaceV2ByIdQueryVariables>(AccommodationPlaceV2ByIdDocument, baseOptions);
        }
export type AccommodationPlaceV2ByIdQueryHookResult = ReturnType<typeof useAccommodationPlaceV2ByIdQuery>;
export type AccommodationPlaceV2ByIdLazyQueryHookResult = ReturnType<typeof useAccommodationPlaceV2ByIdLazyQuery>;
export type AccommodationPlaceV2ByIdQueryResult = Apollo.QueryResult<AccommodationPlaceV2ByIdQuery, AccommodationPlaceV2ByIdQueryVariables>;
export const HotelBookingPartnerSearchJoyPlaceByIdDocument = gql`
    query HotelBookingPartnerSearchJoyPlaceById($joyPlaceByIdId: ID!) {
  joyPlaceById(id: $joyPlaceByIdId) {
    id
    name
    googlePlaceId
  }
}
    `;

/**
 * __useHotelBookingPartnerSearchJoyPlaceByIdQuery__
 *
 * To run a query within a React component, call `useHotelBookingPartnerSearchJoyPlaceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelBookingPartnerSearchJoyPlaceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelBookingPartnerSearchJoyPlaceByIdQuery({
 *   variables: {
 *      joyPlaceByIdId: // value for 'joyPlaceByIdId'
 *   },
 * });
 */
export function useHotelBookingPartnerSearchJoyPlaceByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelBookingPartnerSearchJoyPlaceByIdQuery, HotelBookingPartnerSearchJoyPlaceByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelBookingPartnerSearchJoyPlaceByIdQuery, HotelBookingPartnerSearchJoyPlaceByIdQueryVariables>(HotelBookingPartnerSearchJoyPlaceByIdDocument, baseOptions);
      }
export function useHotelBookingPartnerSearchJoyPlaceByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelBookingPartnerSearchJoyPlaceByIdQuery, HotelBookingPartnerSearchJoyPlaceByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelBookingPartnerSearchJoyPlaceByIdQuery, HotelBookingPartnerSearchJoyPlaceByIdQueryVariables>(HotelBookingPartnerSearchJoyPlaceByIdDocument, baseOptions);
        }
export type HotelBookingPartnerSearchJoyPlaceByIdQueryHookResult = ReturnType<typeof useHotelBookingPartnerSearchJoyPlaceByIdQuery>;
export type HotelBookingPartnerSearchJoyPlaceByIdLazyQueryHookResult = ReturnType<typeof useHotelBookingPartnerSearchJoyPlaceByIdLazyQuery>;
export type HotelBookingPartnerSearchJoyPlaceByIdQueryResult = Apollo.QueryResult<HotelBookingPartnerSearchJoyPlaceByIdQuery, HotelBookingPartnerSearchJoyPlaceByIdQueryVariables>;
export const HotelJoyPlaceDeprecatedDocument = gql`
    query HotelJoyPlaceDeprecated($joyPlaceByIdId: ID!, $eventId: ID) {
  joyPlaceById(id: $joyPlaceByIdId, eventId: $eventId) {
    id
    name
    address
    lat
    long
    googlePlaceId
    url
  }
}
    `;

/**
 * __useHotelJoyPlaceDeprecatedQuery__
 *
 * To run a query within a React component, call `useHotelJoyPlaceDeprecatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelJoyPlaceDeprecatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelJoyPlaceDeprecatedQuery({
 *   variables: {
 *      joyPlaceByIdId: // value for 'joyPlaceByIdId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useHotelJoyPlaceDeprecatedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelJoyPlaceDeprecatedQuery, HotelJoyPlaceDeprecatedQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelJoyPlaceDeprecatedQuery, HotelJoyPlaceDeprecatedQueryVariables>(HotelJoyPlaceDeprecatedDocument, baseOptions);
      }
export function useHotelJoyPlaceDeprecatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelJoyPlaceDeprecatedQuery, HotelJoyPlaceDeprecatedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelJoyPlaceDeprecatedQuery, HotelJoyPlaceDeprecatedQueryVariables>(HotelJoyPlaceDeprecatedDocument, baseOptions);
        }
export type HotelJoyPlaceDeprecatedQueryHookResult = ReturnType<typeof useHotelJoyPlaceDeprecatedQuery>;
export type HotelJoyPlaceDeprecatedLazyQueryHookResult = ReturnType<typeof useHotelJoyPlaceDeprecatedLazyQuery>;
export type HotelJoyPlaceDeprecatedQueryResult = Apollo.QueryResult<HotelJoyPlaceDeprecatedQuery, HotelJoyPlaceDeprecatedQueryVariables>;
export const JoyPlaceIdBySourceIdDocument = gql`
    query JoyPlaceIdBySourceId($payload: JoyPlaceBySourceIdRequest!) {
  joyPlaceBySourceId(payload: $payload) {
    id
    zhId
  }
}
    `;

/**
 * __useJoyPlaceIdBySourceIdQuery__
 *
 * To run a query within a React component, call `useJoyPlaceIdBySourceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyPlaceIdBySourceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyPlaceIdBySourceIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useJoyPlaceIdBySourceIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<JoyPlaceIdBySourceIdQuery, JoyPlaceIdBySourceIdQueryVariables>) {
        return ApolloReactHooks.useQuery<JoyPlaceIdBySourceIdQuery, JoyPlaceIdBySourceIdQueryVariables>(JoyPlaceIdBySourceIdDocument, baseOptions);
      }
export function useJoyPlaceIdBySourceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyPlaceIdBySourceIdQuery, JoyPlaceIdBySourceIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<JoyPlaceIdBySourceIdQuery, JoyPlaceIdBySourceIdQueryVariables>(JoyPlaceIdBySourceIdDocument, baseOptions);
        }
export type JoyPlaceIdBySourceIdQueryHookResult = ReturnType<typeof useJoyPlaceIdBySourceIdQuery>;
export type JoyPlaceIdBySourceIdLazyQueryHookResult = ReturnType<typeof useJoyPlaceIdBySourceIdLazyQuery>;
export type JoyPlaceIdBySourceIdQueryResult = Apollo.QueryResult<JoyPlaceIdBySourceIdQuery, JoyPlaceIdBySourceIdQueryVariables>;
export const JoyPlaceBySourceIdDocument = gql`
    query JoyPlaceBySourceId($payload: JoyPlaceBySourceIdRequest!) {
  joyPlaceBySourceId(payload: $payload) {
    address
    id
    name
    lat
    long
    googlePlaceId
    url
  }
}
    `;

/**
 * __useJoyPlaceBySourceIdQuery__
 *
 * To run a query within a React component, call `useJoyPlaceBySourceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyPlaceBySourceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyPlaceBySourceIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useJoyPlaceBySourceIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<JoyPlaceBySourceIdQuery, JoyPlaceBySourceIdQueryVariables>) {
        return ApolloReactHooks.useQuery<JoyPlaceBySourceIdQuery, JoyPlaceBySourceIdQueryVariables>(JoyPlaceBySourceIdDocument, baseOptions);
      }
export function useJoyPlaceBySourceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyPlaceBySourceIdQuery, JoyPlaceBySourceIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<JoyPlaceBySourceIdQuery, JoyPlaceBySourceIdQueryVariables>(JoyPlaceBySourceIdDocument, baseOptions);
        }
export type JoyPlaceBySourceIdQueryHookResult = ReturnType<typeof useJoyPlaceBySourceIdQuery>;
export type JoyPlaceBySourceIdLazyQueryHookResult = ReturnType<typeof useJoyPlaceBySourceIdLazyQuery>;
export type JoyPlaceBySourceIdQueryResult = Apollo.QueryResult<JoyPlaceBySourceIdQuery, JoyPlaceBySourceIdQueryVariables>;
export const HotelAllLocationAnchorsDeprecatedDocument = gql`
    query HotelAllLocationAnchorsDeprecated($eventByIdId: ID!) {
  eventById(id: $eventByIdId) {
    id
    info {
      id
      finalizedDate {
        dateString
      }
    }
    allLocationAnchors {
      friendlyName
      googlePlaceID
      latitude
      longitude
      source
    }
  }
}
    `;

/**
 * __useHotelAllLocationAnchorsDeprecatedQuery__
 *
 * To run a query within a React component, call `useHotelAllLocationAnchorsDeprecatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelAllLocationAnchorsDeprecatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelAllLocationAnchorsDeprecatedQuery({
 *   variables: {
 *      eventByIdId: // value for 'eventByIdId'
 *   },
 * });
 */
export function useHotelAllLocationAnchorsDeprecatedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelAllLocationAnchorsDeprecatedQuery, HotelAllLocationAnchorsDeprecatedQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelAllLocationAnchorsDeprecatedQuery, HotelAllLocationAnchorsDeprecatedQueryVariables>(HotelAllLocationAnchorsDeprecatedDocument, baseOptions);
      }
export function useHotelAllLocationAnchorsDeprecatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelAllLocationAnchorsDeprecatedQuery, HotelAllLocationAnchorsDeprecatedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelAllLocationAnchorsDeprecatedQuery, HotelAllLocationAnchorsDeprecatedQueryVariables>(HotelAllLocationAnchorsDeprecatedDocument, baseOptions);
        }
export type HotelAllLocationAnchorsDeprecatedQueryHookResult = ReturnType<typeof useHotelAllLocationAnchorsDeprecatedQuery>;
export type HotelAllLocationAnchorsDeprecatedLazyQueryHookResult = ReturnType<typeof useHotelAllLocationAnchorsDeprecatedLazyQuery>;
export type HotelAllLocationAnchorsDeprecatedQueryResult = Apollo.QueryResult<HotelAllLocationAnchorsDeprecatedQuery, HotelAllLocationAnchorsDeprecatedQueryVariables>;
export const HotelAllLocationAnchorsDocument = gql`
    query HotelAllLocationAnchors($name: String!) {
  eventByName(name: $name) {
    id
    info {
      id
      finalizedDate {
        dateString
      }
    }
    allLocationAnchors {
      friendlyName
      googlePlaceID
      latitude
      longitude
      source
    }
  }
}
    `;

/**
 * __useHotelAllLocationAnchorsQuery__
 *
 * To run a query within a React component, call `useHotelAllLocationAnchorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelAllLocationAnchorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelAllLocationAnchorsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHotelAllLocationAnchorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelAllLocationAnchorsQuery, HotelAllLocationAnchorsQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelAllLocationAnchorsQuery, HotelAllLocationAnchorsQueryVariables>(HotelAllLocationAnchorsDocument, baseOptions);
      }
export function useHotelAllLocationAnchorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelAllLocationAnchorsQuery, HotelAllLocationAnchorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelAllLocationAnchorsQuery, HotelAllLocationAnchorsQueryVariables>(HotelAllLocationAnchorsDocument, baseOptions);
        }
export type HotelAllLocationAnchorsQueryHookResult = ReturnType<typeof useHotelAllLocationAnchorsQuery>;
export type HotelAllLocationAnchorsLazyQueryHookResult = ReturnType<typeof useHotelAllLocationAnchorsLazyQuery>;
export type HotelAllLocationAnchorsQueryResult = Apollo.QueryResult<HotelAllLocationAnchorsQuery, HotelAllLocationAnchorsQueryVariables>;
export const MediaCollectionEventInfoDocument = gql`
    query MediaCollectionEventInfo($eventHandle: String!, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    eventDesign(purpose: $eventDesignPurpose) {
      ...EventDesign
    }
    info {
      id
      eventDisplayName
      ownerFirstName
      ownerLastName
      fianceeFirstName
      eventType
    }
    photo {
      id
      url
    }
  }
}
    ${EventDesignFragmentDoc}`;

/**
 * __useMediaCollectionEventInfoQuery__
 *
 * To run a query within a React component, call `useMediaCollectionEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useMediaCollectionEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionEventInfoQuery, MediaCollectionEventInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<MediaCollectionEventInfoQuery, MediaCollectionEventInfoQueryVariables>(MediaCollectionEventInfoDocument, baseOptions);
      }
export function useMediaCollectionEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionEventInfoQuery, MediaCollectionEventInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MediaCollectionEventInfoQuery, MediaCollectionEventInfoQueryVariables>(MediaCollectionEventInfoDocument, baseOptions);
        }
export type MediaCollectionEventInfoQueryHookResult = ReturnType<typeof useMediaCollectionEventInfoQuery>;
export type MediaCollectionEventInfoLazyQueryHookResult = ReturnType<typeof useMediaCollectionEventInfoLazyQuery>;
export type MediaCollectionEventInfoQueryResult = Apollo.QueryResult<MediaCollectionEventInfoQuery, MediaCollectionEventInfoQueryVariables>;
export const MediaCollectionByMagicTokenDocument = gql`
    query MediaCollectionByMagicToken($token: String!) {
  mediaCollectionByMagicToken(token: $token) {
    id
    name
    magicTokenPermissions
    createdAt {
      dateString(dateFormat: long)
      timestamp
    }
    media {
      ... on MediaPhoto {
        id
        photo {
          id
          url
          width
          height
        }
      }
    }
  }
}
    `;

/**
 * __useMediaCollectionByMagicTokenQuery__
 *
 * To run a query within a React component, call `useMediaCollectionByMagicTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionByMagicTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionByMagicTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMediaCollectionByMagicTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionByMagicTokenQuery, MediaCollectionByMagicTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<MediaCollectionByMagicTokenQuery, MediaCollectionByMagicTokenQueryVariables>(MediaCollectionByMagicTokenDocument, baseOptions);
      }
export function useMediaCollectionByMagicTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionByMagicTokenQuery, MediaCollectionByMagicTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MediaCollectionByMagicTokenQuery, MediaCollectionByMagicTokenQueryVariables>(MediaCollectionByMagicTokenDocument, baseOptions);
        }
export type MediaCollectionByMagicTokenQueryHookResult = ReturnType<typeof useMediaCollectionByMagicTokenQuery>;
export type MediaCollectionByMagicTokenLazyQueryHookResult = ReturnType<typeof useMediaCollectionByMagicTokenLazyQuery>;
export type MediaCollectionByMagicTokenQueryResult = Apollo.QueryResult<MediaCollectionByMagicTokenQuery, MediaCollectionByMagicTokenQueryVariables>;
export const GetDataForThanksForRSVPDocument = gql`
    query GetDataForThanksForRSVP($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      event {
        id
        pagesInfo(type: custom) {
          ...GetCustomPagesVisibilities
        }
        registryPages: pagesInfo(type: registry) {
          ...GetCustomPagesVisibilities
        }
      }
    }
    featureFlags
    eventDesign {
      id
      font {
        id
        fontFamily
        textTransform
      }
    }
    registryPage: pages(type: registry, admin: true) {
      id
      disabled
    }
    hotelRoomBlocks {
      id
      bookingLink
    }
  }
}
    ${GetCustomPagesVisibilitiesFragmentDoc}`;

/**
 * __useGetDataForThanksForRSVPQuery__
 *
 * To run a query within a React component, call `useGetDataForThanksForRSVPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForThanksForRSVPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForThanksForRSVPQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDataForThanksForRSVPQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForThanksForRSVPQuery, GetDataForThanksForRSVPQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataForThanksForRSVPQuery, GetDataForThanksForRSVPQueryVariables>(GetDataForThanksForRSVPDocument, baseOptions);
      }
export function useGetDataForThanksForRSVPLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForThanksForRSVPQuery, GetDataForThanksForRSVPQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataForThanksForRSVPQuery, GetDataForThanksForRSVPQueryVariables>(GetDataForThanksForRSVPDocument, baseOptions);
        }
export type GetDataForThanksForRSVPQueryHookResult = ReturnType<typeof useGetDataForThanksForRSVPQuery>;
export type GetDataForThanksForRSVPLazyQueryHookResult = ReturnType<typeof useGetDataForThanksForRSVPLazyQuery>;
export type GetDataForThanksForRSVPQueryResult = Apollo.QueryResult<GetDataForThanksForRSVPQuery, GetDataForThanksForRSVPQueryVariables>;
export const GetDataForTravelThanksForRSVPDocument = gql`
    query GetDataForTravelThanksForRSVP($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventDisplayName
      ownerFirstName
      fianceeFirstName
      event {
        id
        pagesInfo(type: travel) {
          id
          visibility
        }
      }
    }
  }
}
    `;

/**
 * __useGetDataForTravelThanksForRSVPQuery__
 *
 * To run a query within a React component, call `useGetDataForTravelThanksForRSVPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForTravelThanksForRSVPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForTravelThanksForRSVPQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDataForTravelThanksForRSVPQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForTravelThanksForRSVPQuery, GetDataForTravelThanksForRSVPQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataForTravelThanksForRSVPQuery, GetDataForTravelThanksForRSVPQueryVariables>(GetDataForTravelThanksForRSVPDocument, baseOptions);
      }
export function useGetDataForTravelThanksForRSVPLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForTravelThanksForRSVPQuery, GetDataForTravelThanksForRSVPQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataForTravelThanksForRSVPQuery, GetDataForTravelThanksForRSVPQueryVariables>(GetDataForTravelThanksForRSVPDocument, baseOptions);
        }
export type GetDataForTravelThanksForRSVPQueryHookResult = ReturnType<typeof useGetDataForTravelThanksForRSVPQuery>;
export type GetDataForTravelThanksForRSVPLazyQueryHookResult = ReturnType<typeof useGetDataForTravelThanksForRSVPLazyQuery>;
export type GetDataForTravelThanksForRSVPQueryResult = Apollo.QueryResult<GetDataForTravelThanksForRSVPQuery, GetDataForTravelThanksForRSVPQueryVariables>;
export const GetDataForAccommodationsThanksForRSVPDocument = gql`
    query GetDataForAccommodationsThanksForRSVP($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      locationInfo {
        id
        latitude
        longitude
      }
    }
    hotelRoomBlocks {
      id
      bookingLink
    }
    accommodationPlacesV2 {
      id
      customName
      customPhoto {
        id
        url
      }
      isPhotoHidden
      photo {
        id
        url
      }
      type
      lat
      long
      name
      joyPlaceId
      customUrl
    }
  }
}
    `;

/**
 * __useGetDataForAccommodationsThanksForRSVPQuery__
 *
 * To run a query within a React component, call `useGetDataForAccommodationsThanksForRSVPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForAccommodationsThanksForRSVPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForAccommodationsThanksForRSVPQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetDataForAccommodationsThanksForRSVPQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForAccommodationsThanksForRSVPQuery, GetDataForAccommodationsThanksForRSVPQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataForAccommodationsThanksForRSVPQuery, GetDataForAccommodationsThanksForRSVPQueryVariables>(GetDataForAccommodationsThanksForRSVPDocument, baseOptions);
      }
export function useGetDataForAccommodationsThanksForRSVPLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForAccommodationsThanksForRSVPQuery, GetDataForAccommodationsThanksForRSVPQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataForAccommodationsThanksForRSVPQuery, GetDataForAccommodationsThanksForRSVPQueryVariables>(GetDataForAccommodationsThanksForRSVPDocument, baseOptions);
        }
export type GetDataForAccommodationsThanksForRSVPQueryHookResult = ReturnType<typeof useGetDataForAccommodationsThanksForRSVPQuery>;
export type GetDataForAccommodationsThanksForRSVPLazyQueryHookResult = ReturnType<typeof useGetDataForAccommodationsThanksForRSVPLazyQuery>;
export type GetDataForAccommodationsThanksForRSVPQueryResult = Apollo.QueryResult<GetDataForAccommodationsThanksForRSVPQuery, GetDataForAccommodationsThanksForRSVPQueryVariables>;
export const SendRSVPBasicNoteDocument = gql`
    mutation SendRSVPBasicNote($payload: PostOfficeGreetingCardEmailInput) {
  sendPostOfficeGreetingCardEmail(payload: $payload)
}
    `;
export type SendRSVPBasicNoteMutationFn = Apollo.MutationFunction<SendRSVPBasicNoteMutation, SendRSVPBasicNoteMutationVariables>;

/**
 * __useSendRSVPBasicNoteMutation__
 *
 * To run a mutation, you first call `useSendRSVPBasicNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRSVPBasicNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRsvpBasicNoteMutation, { data, loading, error }] = useSendRSVPBasicNoteMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendRSVPBasicNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRSVPBasicNoteMutation, SendRSVPBasicNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRSVPBasicNoteMutation, SendRSVPBasicNoteMutationVariables>(SendRSVPBasicNoteDocument, baseOptions);
      }
export type SendRSVPBasicNoteMutationHookResult = ReturnType<typeof useSendRSVPBasicNoteMutation>;
export type SendRSVPBasicNoteMutationResult = Apollo.MutationResult<SendRSVPBasicNoteMutation>;
export type SendRSVPBasicNoteMutationOptions = Apollo.BaseMutationOptions<SendRSVPBasicNoteMutation, SendRSVPBasicNoteMutationVariables>;
export const GetRegistrySettingForRsvpDocument = gql`
    query GetRegistrySettingForRsvp($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    hideRegistryInMessaging
  }
}
    `;

/**
 * __useGetRegistrySettingForRsvpQuery__
 *
 * To run a query within a React component, call `useGetRegistrySettingForRsvpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrySettingForRsvpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrySettingForRsvpQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistrySettingForRsvpQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistrySettingForRsvpQuery, GetRegistrySettingForRsvpQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistrySettingForRsvpQuery, GetRegistrySettingForRsvpQueryVariables>(GetRegistrySettingForRsvpDocument, baseOptions);
      }
export function useGetRegistrySettingForRsvpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistrySettingForRsvpQuery, GetRegistrySettingForRsvpQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistrySettingForRsvpQuery, GetRegistrySettingForRsvpQueryVariables>(GetRegistrySettingForRsvpDocument, baseOptions);
        }
export type GetRegistrySettingForRsvpQueryHookResult = ReturnType<typeof useGetRegistrySettingForRsvpQuery>;
export type GetRegistrySettingForRsvpLazyQueryHookResult = ReturnType<typeof useGetRegistrySettingForRsvpLazyQuery>;
export type GetRegistrySettingForRsvpQueryResult = Apollo.QueryResult<GetRegistrySettingForRsvpQuery, GetRegistrySettingForRsvpQueryVariables>;
export const GetMessagingSettingsByEventIdDocument = gql`
    query GetMessagingSettingsByEventId($eventId: ID!) {
  getMessagingSettingsByEventId(eventId: $eventId) {
    id
    eventId
    eventDetailsMessagingEnabled
    eventDetailsAutomaticRemindersEnabled
    rsvpNoCustomRedirectEnabled
    rsvpYesCustomRedirectEnabled
    rsvpYesCustomRedirectUrl
    rsvpNoCustomRedirectUrl
  }
}
    `;

/**
 * __useGetMessagingSettingsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetMessagingSettingsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingSettingsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingSettingsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingSettingsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>(GetMessagingSettingsByEventIdDocument, baseOptions);
      }
export function useGetMessagingSettingsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>(GetMessagingSettingsByEventIdDocument, baseOptions);
        }
export type GetMessagingSettingsByEventIdQueryHookResult = ReturnType<typeof useGetMessagingSettingsByEventIdQuery>;
export type GetMessagingSettingsByEventIdLazyQueryHookResult = ReturnType<typeof useGetMessagingSettingsByEventIdLazyQuery>;
export type GetMessagingSettingsByEventIdQueryResult = Apollo.QueryResult<GetMessagingSettingsByEventIdQuery, GetMessagingSettingsByEventIdQueryVariables>;
export const UpdateEventDetailsMessagingDocument = gql`
    mutation UpdateEventDetailsMessaging($payload: UpdateEventDetailsMessagingPayload!) {
  updateEventDetailsMessaging(payload: $payload) {
    id
    eventDetailsMessagingEnabled
    eventDetailsAutomaticRemindersEnabled
    rsvpNoCustomRedirectEnabled
    rsvpYesCustomRedirectEnabled
    rsvpYesCustomRedirectUrl
    rsvpNoCustomRedirectUrl
  }
}
    `;
export type UpdateEventDetailsMessagingMutationFn = Apollo.MutationFunction<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>;

/**
 * __useUpdateEventDetailsMessagingMutation__
 *
 * To run a mutation, you first call `useUpdateEventDetailsMessagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDetailsMessagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDetailsMessagingMutation, { data, loading, error }] = useUpdateEventDetailsMessagingMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventDetailsMessagingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>(UpdateEventDetailsMessagingDocument, baseOptions);
      }
export type UpdateEventDetailsMessagingMutationHookResult = ReturnType<typeof useUpdateEventDetailsMessagingMutation>;
export type UpdateEventDetailsMessagingMutationResult = Apollo.MutationResult<UpdateEventDetailsMessagingMutation>;
export type UpdateEventDetailsMessagingMutationOptions = Apollo.BaseMutationOptions<UpdateEventDetailsMessagingMutation, UpdateEventDetailsMessagingMutationVariables>;
export const EventAccommodationOffersDocument = gql`
    query EventAccommodationOffers($payload: TravelOffersForAccommodationForPropertiesPayload!) {
  travelOffersForAccommodationProperties(payload: $payload) {
    someOffers {
      totalAmount {
        valueInMinorUnits
        currency
      }
    }
  }
}
    `;

/**
 * __useEventAccommodationOffersQuery__
 *
 * To run a query within a React component, call `useEventAccommodationOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventAccommodationOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventAccommodationOffersQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useEventAccommodationOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventAccommodationOffersQuery, EventAccommodationOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<EventAccommodationOffersQuery, EventAccommodationOffersQueryVariables>(EventAccommodationOffersDocument, baseOptions);
      }
export function useEventAccommodationOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventAccommodationOffersQuery, EventAccommodationOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventAccommodationOffersQuery, EventAccommodationOffersQueryVariables>(EventAccommodationOffersDocument, baseOptions);
        }
export type EventAccommodationOffersQueryHookResult = ReturnType<typeof useEventAccommodationOffersQuery>;
export type EventAccommodationOffersLazyQueryHookResult = ReturnType<typeof useEventAccommodationOffersLazyQuery>;
export type EventAccommodationOffersQueryResult = Apollo.QueryResult<EventAccommodationOffersQuery, EventAccommodationOffersQueryVariables>;
export const GetRecommendedRegistryOnboardingSurveyResultsDocument = gql`
    query GetRecommendedRegistryOnboardingSurveyResults($handle: String!) {
  eventByName(name: $handle) {
    id
    firebaseCreateAt {
      milliseconds
    }
    info {
      id
      eventType
    }
    recommendation {
      registryOnboardingSurvey {
        id
        lastUpdatedAt {
          milliseconds
        }
        registryTypes
        registeringAtOtherStores
        coupleInterests
        interestedInBrowserButton
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedRegistryOnboardingSurveyResultsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedRegistryOnboardingSurveyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedRegistryOnboardingSurveyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedRegistryOnboardingSurveyResultsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetRecommendedRegistryOnboardingSurveyResultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>(GetRecommendedRegistryOnboardingSurveyResultsDocument, baseOptions);
      }
export function useGetRecommendedRegistryOnboardingSurveyResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>(GetRecommendedRegistryOnboardingSurveyResultsDocument, baseOptions);
        }
export type GetRecommendedRegistryOnboardingSurveyResultsQueryHookResult = ReturnType<typeof useGetRecommendedRegistryOnboardingSurveyResultsQuery>;
export type GetRecommendedRegistryOnboardingSurveyResultsLazyQueryHookResult = ReturnType<typeof useGetRecommendedRegistryOnboardingSurveyResultsLazyQuery>;
export type GetRecommendedRegistryOnboardingSurveyResultsQueryResult = Apollo.QueryResult<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>;
export const GetAdminRegistryRegistriesDocument = gql`
    query GetAdminRegistryRegistries($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      disableWhiteGloveforSyncedItems
      disableWhiteGloveforTransferredItems
    }
    info {
      id
      registry {
        ...AdminRegistry
      }
    }
  }
}
    ${AdminRegistryFragmentDoc}`;

/**
 * __useGetAdminRegistryRegistriesQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryRegistriesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>(GetAdminRegistryRegistriesDocument, baseOptions);
      }
export function useGetAdminRegistryRegistriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>(GetAdminRegistryRegistriesDocument, baseOptions);
        }
export type GetAdminRegistryRegistriesQueryHookResult = ReturnType<typeof useGetAdminRegistryRegistriesQuery>;
export type GetAdminRegistryRegistriesLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryRegistriesLazyQuery>;
export type GetAdminRegistryRegistriesQueryResult = Apollo.QueryResult<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>;
export const GetAdminRegistryOrdersDocument = gql`
    query GetAdminRegistryOrders($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      orders {
        id
        ...RegistryOrder
      }
    }
  }
}
    ${RegistryOrderFragmentDoc}`;

/**
 * __useGetAdminRegistryOrdersQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryOrdersQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>(GetAdminRegistryOrdersDocument, baseOptions);
      }
export function useGetAdminRegistryOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>(GetAdminRegistryOrdersDocument, baseOptions);
        }
export type GetAdminRegistryOrdersQueryHookResult = ReturnType<typeof useGetAdminRegistryOrdersQuery>;
export type GetAdminRegistryOrdersLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryOrdersLazyQuery>;
export type GetAdminRegistryOrdersQueryResult = Apollo.QueryResult<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>;
export const GetAdminRegistryDataDocument = gql`
    query GetAdminRegistryData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventDisplayName
      eventType
      finalizedDate {
        ...Date
      }
    }
    ...RegistryShippingAddressFragment
    ...DonationFundInfoFragment
    registry {
      id
      itemCount {
        everything
      }
      checklist {
        id
      }
      summary {
        lastSyncAt {
          timestamp
        }
        cannotSync
      }
      currency {
        ...EventRegistryCurrency
      }
    }
    registryPage: pages(type: registry, admin: true) {
      id
      subTitle: pageSubTitleV0918
      disabled
    }
    eventUsers {
      id
      status
    }
  }
}
    ${DateFragmentDoc}
${RegistryShippingAddressFragmentFragmentDoc}
${DonationFundInfoFragmentFragmentDoc}
${EventRegistryCurrencyFragmentDoc}`;

/**
 * __useGetAdminRegistryDataQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>(GetAdminRegistryDataDocument, baseOptions);
      }
export function useGetAdminRegistryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>(GetAdminRegistryDataDocument, baseOptions);
        }
export type GetAdminRegistryDataQueryHookResult = ReturnType<typeof useGetAdminRegistryDataQuery>;
export type GetAdminRegistryDataLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryDataLazyQuery>;
export type GetAdminRegistryDataQueryResult = Apollo.QueryResult<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>;
export const GetGiftTransactionThankYouAssociationsDocument = gql`
    query GetGiftTransactionThankYouAssociations($args: MessageRelationshipCriteria) {
  getMessageRelationships(args: $args) {
    id
    relationshipTag
    externalMessageId
    status
    redirectUri
  }
}
    `;

/**
 * __useGetGiftTransactionThankYouAssociationsQuery__
 *
 * To run a query within a React component, call `useGetGiftTransactionThankYouAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftTransactionThankYouAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftTransactionThankYouAssociationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetGiftTransactionThankYouAssociationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>(GetGiftTransactionThankYouAssociationsDocument, baseOptions);
      }
export function useGetGiftTransactionThankYouAssociationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>(GetGiftTransactionThankYouAssociationsDocument, baseOptions);
        }
export type GetGiftTransactionThankYouAssociationsQueryHookResult = ReturnType<typeof useGetGiftTransactionThankYouAssociationsQuery>;
export type GetGiftTransactionThankYouAssociationsLazyQueryHookResult = ReturnType<typeof useGetGiftTransactionThankYouAssociationsLazyQuery>;
export type GetGiftTransactionThankYouAssociationsQueryResult = Apollo.QueryResult<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>;
export const SetRegistryEventDataDocument = gql`
    mutation SetRegistryEventData($eventId: ID!, $payload: RegistryEventDataInput!) {
  setRegistryEventData(eventId: $eventId, payload: $payload) {
    id
    disableWhiteGloveforSyncedItems
    disableWhiteGloveforTransferredItems
    disableWhiteGloveforPartnerItems
  }
}
    `;
export type SetRegistryEventDataMutationFn = Apollo.MutationFunction<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>;

/**
 * __useSetRegistryEventDataMutation__
 *
 * To run a mutation, you first call `useSetRegistryEventDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRegistryEventDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRegistryEventDataMutation, { data, loading, error }] = useSetRegistryEventDataMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetRegistryEventDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>) {
        return ApolloReactHooks.useMutation<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>(SetRegistryEventDataDocument, baseOptions);
      }
export type SetRegistryEventDataMutationHookResult = ReturnType<typeof useSetRegistryEventDataMutation>;
export type SetRegistryEventDataMutationResult = Apollo.MutationResult<SetRegistryEventDataMutation>;
export type SetRegistryEventDataMutationOptions = Apollo.BaseMutationOptions<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>;
export const GetRegistryEventDataDocument = gql`
    query GetRegistryEventData($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    disableWhiteGloveforSyncedItems
    disableWhiteGloveforTransferredItems
    disableWhiteGloveforPartnerItems
  }
}
    `;

/**
 * __useGetRegistryEventDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryEventDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryEventDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>(GetRegistryEventDataDocument, baseOptions);
      }
export function useGetRegistryEventDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>(GetRegistryEventDataDocument, baseOptions);
        }
export type GetRegistryEventDataQueryHookResult = ReturnType<typeof useGetRegistryEventDataQuery>;
export type GetRegistryEventDataLazyQueryHookResult = ReturnType<typeof useGetRegistryEventDataLazyQuery>;
export type GetRegistryEventDataQueryResult = Apollo.QueryResult<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>;
export const SetHideRegistryInMessagingSettingDocument = gql`
    mutation SetHideRegistryInMessagingSetting($eventId: ID!, $payload: RegistryEventDataInput!) {
  setRegistryEventData(eventId: $eventId, payload: $payload) {
    id
    hideRegistryInMessaging
  }
}
    `;
export type SetHideRegistryInMessagingSettingMutationFn = Apollo.MutationFunction<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>;

/**
 * __useSetHideRegistryInMessagingSettingMutation__
 *
 * To run a mutation, you first call `useSetHideRegistryInMessagingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHideRegistryInMessagingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHideRegistryInMessagingSettingMutation, { data, loading, error }] = useSetHideRegistryInMessagingSettingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetHideRegistryInMessagingSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>) {
        return ApolloReactHooks.useMutation<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>(SetHideRegistryInMessagingSettingDocument, baseOptions);
      }
export type SetHideRegistryInMessagingSettingMutationHookResult = ReturnType<typeof useSetHideRegistryInMessagingSettingMutation>;
export type SetHideRegistryInMessagingSettingMutationResult = Apollo.MutationResult<SetHideRegistryInMessagingSettingMutation>;
export type SetHideRegistryInMessagingSettingMutationOptions = Apollo.BaseMutationOptions<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>;
export const GetHideRegistryInMessagingSettingDocument = gql`
    query GetHideRegistryInMessagingSetting($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    hideRegistryInMessaging
  }
}
    `;

/**
 * __useGetHideRegistryInMessagingSettingQuery__
 *
 * To run a query within a React component, call `useGetHideRegistryInMessagingSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHideRegistryInMessagingSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHideRegistryInMessagingSettingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetHideRegistryInMessagingSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>(GetHideRegistryInMessagingSettingDocument, baseOptions);
      }
export function useGetHideRegistryInMessagingSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>(GetHideRegistryInMessagingSettingDocument, baseOptions);
        }
export type GetHideRegistryInMessagingSettingQueryHookResult = ReturnType<typeof useGetHideRegistryInMessagingSettingQuery>;
export type GetHideRegistryInMessagingSettingLazyQueryHookResult = ReturnType<typeof useGetHideRegistryInMessagingSettingLazyQuery>;
export type GetHideRegistryInMessagingSettingQueryResult = Apollo.QueryResult<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>;
export const StartRefundDocument = gql`
    mutation StartRefund($registryOrderId: ID!, $refundMethod: SalesOrderRefundMethod!) {
  startRefund(registryOrderId: $registryOrderId, refundMethod: $refundMethod)
}
    `;
export type StartRefundMutationFn = Apollo.MutationFunction<StartRefundMutation, StartRefundMutationVariables>;

/**
 * __useStartRefundMutation__
 *
 * To run a mutation, you first call `useStartRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRefundMutation, { data, loading, error }] = useStartRefundMutation({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *      refundMethod: // value for 'refundMethod'
 *   },
 * });
 */
export function useStartRefundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartRefundMutation, StartRefundMutationVariables>) {
        return ApolloReactHooks.useMutation<StartRefundMutation, StartRefundMutationVariables>(StartRefundDocument, baseOptions);
      }
export type StartRefundMutationHookResult = ReturnType<typeof useStartRefundMutation>;
export type StartRefundMutationResult = Apollo.MutationResult<StartRefundMutation>;
export type StartRefundMutationOptions = Apollo.BaseMutationOptions<StartRefundMutation, StartRefundMutationVariables>;
export const GetEventPreviewDataDocument = gql`
    query GetEventPreviewData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    eventDesign(purpose: live) {
      ...EventDesign
    }
    registry {
      id
      itemCount {
        everything
      }
    }
    registryPage: pages(type: registry, admin: true) {
      id
      photoV2 {
        ... on Photo {
          id
          url
        }
        ... on DefaultPagePhoto {
          id
          url
        }
      }
    }
  }
}
    ${EventDesignFragmentDoc}`;

/**
 * __useGetEventPreviewDataQuery__
 *
 * To run a query within a React component, call `useGetEventPreviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPreviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPreviewDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventPreviewDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>(GetEventPreviewDataDocument, baseOptions);
      }
export function useGetEventPreviewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>(GetEventPreviewDataDocument, baseOptions);
        }
export type GetEventPreviewDataQueryHookResult = ReturnType<typeof useGetEventPreviewDataQuery>;
export type GetEventPreviewDataLazyQueryHookResult = ReturnType<typeof useGetEventPreviewDataLazyQuery>;
export type GetEventPreviewDataQueryResult = Apollo.QueryResult<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>;
export const GetEventDelayShipSettingDocument = gql`
    query GetEventDelayShipSetting($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    hideDelayShipSetting
  }
}
    `;

/**
 * __useGetEventDelayShipSettingQuery__
 *
 * To run a query within a React component, call `useGetEventDelayShipSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDelayShipSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDelayShipSettingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventDelayShipSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>(GetEventDelayShipSettingDocument, baseOptions);
      }
export function useGetEventDelayShipSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>(GetEventDelayShipSettingDocument, baseOptions);
        }
export type GetEventDelayShipSettingQueryHookResult = ReturnType<typeof useGetEventDelayShipSettingQuery>;
export type GetEventDelayShipSettingLazyQueryHookResult = ReturnType<typeof useGetEventDelayShipSettingLazyQuery>;
export type GetEventDelayShipSettingQueryResult = Apollo.QueryResult<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>;
export const GetRegistriesWithDraftItemsDocument = gql`
    query GetRegistriesWithDraftItems($eventId: ID!) {
  eventById(id: $eventId) {
    id
    info {
      id
      registry {
        ...RegistryWithDraftItems
      }
    }
  }
}
    ${RegistryWithDraftItemsFragmentDoc}`;

/**
 * __useGetRegistriesWithDraftItemsQuery__
 *
 * To run a query within a React component, call `useGetRegistriesWithDraftItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistriesWithDraftItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistriesWithDraftItemsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistriesWithDraftItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistriesWithDraftItemsQuery, GetRegistriesWithDraftItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistriesWithDraftItemsQuery, GetRegistriesWithDraftItemsQueryVariables>(GetRegistriesWithDraftItemsDocument, baseOptions);
      }
export function useGetRegistriesWithDraftItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistriesWithDraftItemsQuery, GetRegistriesWithDraftItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistriesWithDraftItemsQuery, GetRegistriesWithDraftItemsQueryVariables>(GetRegistriesWithDraftItemsDocument, baseOptions);
        }
export type GetRegistriesWithDraftItemsQueryHookResult = ReturnType<typeof useGetRegistriesWithDraftItemsQuery>;
export type GetRegistriesWithDraftItemsLazyQueryHookResult = ReturnType<typeof useGetRegistriesWithDraftItemsLazyQuery>;
export type GetRegistriesWithDraftItemsQueryResult = Apollo.QueryResult<GetRegistriesWithDraftItemsQuery, GetRegistriesWithDraftItemsQueryVariables>;
export const MovePostTransferItemsToJoyDocument = gql`
    mutation MovePostTransferItemsToJoy($registryId: ID!) {
  convertRegistryDrafts(id: $registryId) {
    id
    storeName
  }
}
    `;
export type MovePostTransferItemsToJoyMutationFn = Apollo.MutationFunction<MovePostTransferItemsToJoyMutation, MovePostTransferItemsToJoyMutationVariables>;

/**
 * __useMovePostTransferItemsToJoyMutation__
 *
 * To run a mutation, you first call `useMovePostTransferItemsToJoyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePostTransferItemsToJoyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePostTransferItemsToJoyMutation, { data, loading, error }] = useMovePostTransferItemsToJoyMutation({
 *   variables: {
 *      registryId: // value for 'registryId'
 *   },
 * });
 */
export function useMovePostTransferItemsToJoyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MovePostTransferItemsToJoyMutation, MovePostTransferItemsToJoyMutationVariables>) {
        return ApolloReactHooks.useMutation<MovePostTransferItemsToJoyMutation, MovePostTransferItemsToJoyMutationVariables>(MovePostTransferItemsToJoyDocument, baseOptions);
      }
export type MovePostTransferItemsToJoyMutationHookResult = ReturnType<typeof useMovePostTransferItemsToJoyMutation>;
export type MovePostTransferItemsToJoyMutationResult = Apollo.MutationResult<MovePostTransferItemsToJoyMutation>;
export type MovePostTransferItemsToJoyMutationOptions = Apollo.BaseMutationOptions<MovePostTransferItemsToJoyMutation, MovePostTransferItemsToJoyMutationVariables>;
export const ProductCatalogAdsDocument = gql`
    query ProductCatalogAds {
  productCatalogAds {
    brandPromoMosaic {
      tiles {
        ...CatalogBrandPromo
      }
    }
    departmentBrandPromos {
      department {
        id
        title
      }
      categoryCarousel {
        ...CatalogBrandPromo
      }
      navBar {
        ...CatalogBrandPromo
      }
      productGrid {
        ...CatalogBrandPromo
      }
    }
  }
}
    ${CatalogBrandPromoFragmentDoc}`;

/**
 * __useProductCatalogAdsQuery__
 *
 * To run a query within a React component, call `useProductCatalogAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogAdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCatalogAdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>(ProductCatalogAdsDocument, baseOptions);
      }
export function useProductCatalogAdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>(ProductCatalogAdsDocument, baseOptions);
        }
export type ProductCatalogAdsQueryHookResult = ReturnType<typeof useProductCatalogAdsQuery>;
export type ProductCatalogAdsLazyQueryHookResult = ReturnType<typeof useProductCatalogAdsLazyQuery>;
export type ProductCatalogAdsQueryResult = Apollo.QueryResult<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>;
export const GetCompletionDiscountItemsDocument = gql`
    query GetCompletionDiscountItems($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      completionDiscount {
        items {
          ...CompletionDiscountItem
        }
      }
    }
  }
}
    ${CompletionDiscountItemFragmentDoc}`;

/**
 * __useGetCompletionDiscountItemsQuery__
 *
 * To run a query within a React component, call `useGetCompletionDiscountItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionDiscountItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionDiscountItemsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetCompletionDiscountItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompletionDiscountItemsQuery, GetCompletionDiscountItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCompletionDiscountItemsQuery, GetCompletionDiscountItemsQueryVariables>(GetCompletionDiscountItemsDocument, baseOptions);
      }
export function useGetCompletionDiscountItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompletionDiscountItemsQuery, GetCompletionDiscountItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCompletionDiscountItemsQuery, GetCompletionDiscountItemsQueryVariables>(GetCompletionDiscountItemsDocument, baseOptions);
        }
export type GetCompletionDiscountItemsQueryHookResult = ReturnType<typeof useGetCompletionDiscountItemsQuery>;
export type GetCompletionDiscountItemsLazyQueryHookResult = ReturnType<typeof useGetCompletionDiscountItemsLazyQuery>;
export type GetCompletionDiscountItemsQueryResult = Apollo.QueryResult<GetCompletionDiscountItemsQuery, GetCompletionDiscountItemsQueryVariables>;
export const GetFinalizedDateAndGiftCountDocument = gql`
    query GetFinalizedDateAndGiftCount($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      finalizedDate {
        milliseconds
      }
    }
    registry {
      id
      itemCount {
        everything
        purchasedOrReserved
      }
    }
  }
}
    `;

/**
 * __useGetFinalizedDateAndGiftCountQuery__
 *
 * To run a query within a React component, call `useGetFinalizedDateAndGiftCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinalizedDateAndGiftCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinalizedDateAndGiftCountQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetFinalizedDateAndGiftCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinalizedDateAndGiftCountQuery, GetFinalizedDateAndGiftCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFinalizedDateAndGiftCountQuery, GetFinalizedDateAndGiftCountQueryVariables>(GetFinalizedDateAndGiftCountDocument, baseOptions);
      }
export function useGetFinalizedDateAndGiftCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinalizedDateAndGiftCountQuery, GetFinalizedDateAndGiftCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFinalizedDateAndGiftCountQuery, GetFinalizedDateAndGiftCountQueryVariables>(GetFinalizedDateAndGiftCountDocument, baseOptions);
        }
export type GetFinalizedDateAndGiftCountQueryHookResult = ReturnType<typeof useGetFinalizedDateAndGiftCountQuery>;
export type GetFinalizedDateAndGiftCountLazyQueryHookResult = ReturnType<typeof useGetFinalizedDateAndGiftCountLazyQuery>;
export type GetFinalizedDateAndGiftCountQueryResult = Apollo.QueryResult<GetFinalizedDateAndGiftCountQuery, GetFinalizedDateAndGiftCountQueryVariables>;
export const RegistryDelayOrderFulfillmentDocument = gql`
    query RegistryDelayOrderFulfillment($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      delayOrderFulfillment
    }
  }
}
    `;

/**
 * __useRegistryDelayOrderFulfillmentQuery__
 *
 * To run a query within a React component, call `useRegistryDelayOrderFulfillmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryDelayOrderFulfillmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryDelayOrderFulfillmentQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useRegistryDelayOrderFulfillmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryDelayOrderFulfillmentQuery, RegistryDelayOrderFulfillmentQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryDelayOrderFulfillmentQuery, RegistryDelayOrderFulfillmentQueryVariables>(RegistryDelayOrderFulfillmentDocument, baseOptions);
      }
export function useRegistryDelayOrderFulfillmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryDelayOrderFulfillmentQuery, RegistryDelayOrderFulfillmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryDelayOrderFulfillmentQuery, RegistryDelayOrderFulfillmentQueryVariables>(RegistryDelayOrderFulfillmentDocument, baseOptions);
        }
export type RegistryDelayOrderFulfillmentQueryHookResult = ReturnType<typeof useRegistryDelayOrderFulfillmentQuery>;
export type RegistryDelayOrderFulfillmentLazyQueryHookResult = ReturnType<typeof useRegistryDelayOrderFulfillmentLazyQuery>;
export type RegistryDelayOrderFulfillmentQueryResult = Apollo.QueryResult<RegistryDelayOrderFulfillmentQuery, RegistryDelayOrderFulfillmentQueryVariables>;
export const SetDelayOrderFulfillmentDocument = gql`
    mutation SetDelayOrderFulfillment($eventId: ID!, $payload: RegistryEventDataInput!) {
  setRegistryEventData(eventId: $eventId, payload: $payload) {
    id
    delayOrderFulfillment
  }
}
    `;
export type SetDelayOrderFulfillmentMutationFn = Apollo.MutationFunction<SetDelayOrderFulfillmentMutation, SetDelayOrderFulfillmentMutationVariables>;

/**
 * __useSetDelayOrderFulfillmentMutation__
 *
 * To run a mutation, you first call `useSetDelayOrderFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDelayOrderFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDelayOrderFulfillmentMutation, { data, loading, error }] = useSetDelayOrderFulfillmentMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetDelayOrderFulfillmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDelayOrderFulfillmentMutation, SetDelayOrderFulfillmentMutationVariables>) {
        return ApolloReactHooks.useMutation<SetDelayOrderFulfillmentMutation, SetDelayOrderFulfillmentMutationVariables>(SetDelayOrderFulfillmentDocument, baseOptions);
      }
export type SetDelayOrderFulfillmentMutationHookResult = ReturnType<typeof useSetDelayOrderFulfillmentMutation>;
export type SetDelayOrderFulfillmentMutationResult = Apollo.MutationResult<SetDelayOrderFulfillmentMutation>;
export type SetDelayOrderFulfillmentMutationOptions = Apollo.BaseMutationOptions<SetDelayOrderFulfillmentMutation, SetDelayOrderFulfillmentMutationVariables>;
export const StartOrdersFulfillmentDocument = gql`
    mutation StartOrdersFulfillment($registryOrderIds: [ID!]!) {
  startFulfillment(registryOrderIds: $registryOrderIds) {
    registryOrderId
    salesOrderId
    status
    failedStatusDetails
  }
}
    `;
export type StartOrdersFulfillmentMutationFn = Apollo.MutationFunction<StartOrdersFulfillmentMutation, StartOrdersFulfillmentMutationVariables>;

/**
 * __useStartOrdersFulfillmentMutation__
 *
 * To run a mutation, you first call `useStartOrdersFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOrdersFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOrdersFulfillmentMutation, { data, loading, error }] = useStartOrdersFulfillmentMutation({
 *   variables: {
 *      registryOrderIds: // value for 'registryOrderIds'
 *   },
 * });
 */
export function useStartOrdersFulfillmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartOrdersFulfillmentMutation, StartOrdersFulfillmentMutationVariables>) {
        return ApolloReactHooks.useMutation<StartOrdersFulfillmentMutation, StartOrdersFulfillmentMutationVariables>(StartOrdersFulfillmentDocument, baseOptions);
      }
export type StartOrdersFulfillmentMutationHookResult = ReturnType<typeof useStartOrdersFulfillmentMutation>;
export type StartOrdersFulfillmentMutationResult = Apollo.MutationResult<StartOrdersFulfillmentMutation>;
export type StartOrdersFulfillmentMutationOptions = Apollo.BaseMutationOptions<StartOrdersFulfillmentMutation, StartOrdersFulfillmentMutationVariables>;
export const GetRegistryVisibilityDocument = gql`
    query GetRegistryVisibility($name: String!) {
  eventByName(name: $name) {
    id
    pages(type: registry, admin: true) {
      id
      private
      disabled
    }
  }
}
    `;

/**
 * __useGetRegistryVisibilityQuery__
 *
 * To run a query within a React component, call `useGetRegistryVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryVisibilityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRegistryVisibilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryVisibilityQuery, GetRegistryVisibilityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryVisibilityQuery, GetRegistryVisibilityQueryVariables>(GetRegistryVisibilityDocument, baseOptions);
      }
export function useGetRegistryVisibilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryVisibilityQuery, GetRegistryVisibilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryVisibilityQuery, GetRegistryVisibilityQueryVariables>(GetRegistryVisibilityDocument, baseOptions);
        }
export type GetRegistryVisibilityQueryHookResult = ReturnType<typeof useGetRegistryVisibilityQuery>;
export type GetRegistryVisibilityLazyQueryHookResult = ReturnType<typeof useGetRegistryVisibilityLazyQuery>;
export type GetRegistryVisibilityQueryResult = Apollo.QueryResult<GetRegistryVisibilityQuery, GetRegistryVisibilityQueryVariables>;
export const GetShippingAddressDocument = gql`
    query GetShippingAddress($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    shippingAddress {
      address1
    }
  }
}
    `;

/**
 * __useGetShippingAddressQuery__
 *
 * To run a query within a React component, call `useGetShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingAddressQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetShippingAddressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShippingAddressQuery, GetShippingAddressQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShippingAddressQuery, GetShippingAddressQueryVariables>(GetShippingAddressDocument, baseOptions);
      }
export function useGetShippingAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShippingAddressQuery, GetShippingAddressQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShippingAddressQuery, GetShippingAddressQueryVariables>(GetShippingAddressDocument, baseOptions);
        }
export type GetShippingAddressQueryHookResult = ReturnType<typeof useGetShippingAddressQuery>;
export type GetShippingAddressLazyQueryHookResult = ReturnType<typeof useGetShippingAddressLazyQuery>;
export type GetShippingAddressQueryResult = Apollo.QueryResult<GetShippingAddressQuery, GetShippingAddressQueryVariables>;
export const GetRegistryCurrencyDocument = gql`
    query GetRegistryCurrency($name: String!) {
  eventByName(name: $name) {
    id
    registry {
      id
      currency {
        id
        displayName
        rank
        code
        isDefault
      }
    }
  }
}
    `;

/**
 * __useGetRegistryCurrencyQuery__
 *
 * To run a query within a React component, call `useGetRegistryCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryCurrencyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRegistryCurrencyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryCurrencyQuery, GetRegistryCurrencyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryCurrencyQuery, GetRegistryCurrencyQueryVariables>(GetRegistryCurrencyDocument, baseOptions);
      }
export function useGetRegistryCurrencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryCurrencyQuery, GetRegistryCurrencyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryCurrencyQuery, GetRegistryCurrencyQueryVariables>(GetRegistryCurrencyDocument, baseOptions);
        }
export type GetRegistryCurrencyQueryHookResult = ReturnType<typeof useGetRegistryCurrencyQuery>;
export type GetRegistryCurrencyLazyQueryHookResult = ReturnType<typeof useGetRegistryCurrencyLazyQuery>;
export type GetRegistryCurrencyQueryResult = Apollo.QueryResult<GetRegistryCurrencyQuery, GetRegistryCurrencyQueryVariables>;
export const GetRegistryPageNoteDocument = gql`
    query GetRegistryPageNote($name: String!) {
  eventByName(name: $name) {
    id
    registryPage: pages(type: registry, admin: true) {
      id
      subTitle: pageSubTitleV0918
    }
  }
}
    `;

/**
 * __useGetRegistryPageNoteQuery__
 *
 * To run a query within a React component, call `useGetRegistryPageNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPageNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPageNoteQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRegistryPageNoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPageNoteQuery, GetRegistryPageNoteQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryPageNoteQuery, GetRegistryPageNoteQueryVariables>(GetRegistryPageNoteDocument, baseOptions);
      }
export function useGetRegistryPageNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPageNoteQuery, GetRegistryPageNoteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryPageNoteQuery, GetRegistryPageNoteQueryVariables>(GetRegistryPageNoteDocument, baseOptions);
        }
export type GetRegistryPageNoteQueryHookResult = ReturnType<typeof useGetRegistryPageNoteQuery>;
export type GetRegistryPageNoteLazyQueryHookResult = ReturnType<typeof useGetRegistryPageNoteLazyQuery>;
export type GetRegistryPageNoteQueryResult = Apollo.QueryResult<GetRegistryPageNoteQuery, GetRegistryPageNoteQueryVariables>;
export const GetRecommendCatalogHomeSectionsDocument = gql`
    query GetRecommendCatalogHomeSections($eventId: ID!) {
  recommendCatalogHomeSections(eventId: $eventId) {
    id
    sections(limit: 1, offset: 1) {
      id
      displayType
      catalogEntities {
        ... on ProductCatalogEntityItemGroup {
          id
          __typename
          catalogItemGroupData {
            id
            tileViewItem {
              ...ProductCatalogItem
              tilePresentation {
                ...ProductCatalogItemTilePresentation
              }
            }
          }
        }
      }
    }
  }
}
    ${ProductCatalogItemFragmentDoc}
${ProductCatalogItemTilePresentationFragmentDoc}`;

/**
 * __useGetRecommendCatalogHomeSectionsQuery__
 *
 * To run a query within a React component, call `useGetRecommendCatalogHomeSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendCatalogHomeSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendCatalogHomeSectionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRecommendCatalogHomeSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendCatalogHomeSectionsQuery, GetRecommendCatalogHomeSectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendCatalogHomeSectionsQuery, GetRecommendCatalogHomeSectionsQueryVariables>(GetRecommendCatalogHomeSectionsDocument, baseOptions);
      }
export function useGetRecommendCatalogHomeSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendCatalogHomeSectionsQuery, GetRecommendCatalogHomeSectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendCatalogHomeSectionsQuery, GetRecommendCatalogHomeSectionsQueryVariables>(GetRecommendCatalogHomeSectionsDocument, baseOptions);
        }
export type GetRecommendCatalogHomeSectionsQueryHookResult = ReturnType<typeof useGetRecommendCatalogHomeSectionsQuery>;
export type GetRecommendCatalogHomeSectionsLazyQueryHookResult = ReturnType<typeof useGetRecommendCatalogHomeSectionsLazyQuery>;
export type GetRecommendCatalogHomeSectionsQueryResult = Apollo.QueryResult<GetRecommendCatalogHomeSectionsQuery, GetRecommendCatalogHomeSectionsQueryVariables>;
export const GetRegistryOrderRefundsDocument = gql`
    query GetRegistryOrderRefunds($registryOrderIds: [ID!]!) {
  registryOrdersByIds(ids: $registryOrderIds) {
    id
    refunds {
      ...RegistryOrderRefund
    }
  }
}
    ${RegistryOrderRefundFragmentDoc}`;

/**
 * __useGetRegistryOrderRefundsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrderRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrderRefundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrderRefundsQuery({
 *   variables: {
 *      registryOrderIds: // value for 'registryOrderIds'
 *   },
 * });
 */
export function useGetRegistryOrderRefundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrderRefundsQuery, GetRegistryOrderRefundsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOrderRefundsQuery, GetRegistryOrderRefundsQueryVariables>(GetRegistryOrderRefundsDocument, baseOptions);
      }
export function useGetRegistryOrderRefundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrderRefundsQuery, GetRegistryOrderRefundsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOrderRefundsQuery, GetRegistryOrderRefundsQueryVariables>(GetRegistryOrderRefundsDocument, baseOptions);
        }
export type GetRegistryOrderRefundsQueryHookResult = ReturnType<typeof useGetRegistryOrderRefundsQuery>;
export type GetRegistryOrderRefundsLazyQueryHookResult = ReturnType<typeof useGetRegistryOrderRefundsLazyQuery>;
export type GetRegistryOrderRefundsQueryResult = Apollo.QueryResult<GetRegistryOrderRefundsQuery, GetRegistryOrderRefundsQueryVariables>;
export const GetAdminExternalRegistriesToSetTransferredToPrivateDocument = gql`
    query GetAdminExternalRegistriesToSetTransferredToPrivate($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      registries {
        ...AdminExternalRegistriesToSetTransferredToPrivate
      }
    }
  }
}
    ${AdminExternalRegistriesToSetTransferredToPrivateFragmentDoc}`;

/**
 * __useGetAdminExternalRegistriesToSetTransferredToPrivateQuery__
 *
 * To run a query within a React component, call `useGetAdminExternalRegistriesToSetTransferredToPrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminExternalRegistriesToSetTransferredToPrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminExternalRegistriesToSetTransferredToPrivateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminExternalRegistriesToSetTransferredToPrivateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminExternalRegistriesToSetTransferredToPrivateQuery, GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminExternalRegistriesToSetTransferredToPrivateQuery, GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables>(GetAdminExternalRegistriesToSetTransferredToPrivateDocument, baseOptions);
      }
export function useGetAdminExternalRegistriesToSetTransferredToPrivateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminExternalRegistriesToSetTransferredToPrivateQuery, GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminExternalRegistriesToSetTransferredToPrivateQuery, GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables>(GetAdminExternalRegistriesToSetTransferredToPrivateDocument, baseOptions);
        }
export type GetAdminExternalRegistriesToSetTransferredToPrivateQueryHookResult = ReturnType<typeof useGetAdminExternalRegistriesToSetTransferredToPrivateQuery>;
export type GetAdminExternalRegistriesToSetTransferredToPrivateLazyQueryHookResult = ReturnType<typeof useGetAdminExternalRegistriesToSetTransferredToPrivateLazyQuery>;
export type GetAdminExternalRegistriesToSetTransferredToPrivateQueryResult = Apollo.QueryResult<GetAdminExternalRegistriesToSetTransferredToPrivateQuery, GetAdminExternalRegistriesToSetTransferredToPrivateQueryVariables>;
export const GetRegistryGiftListForCountDocument = gql`
    query GetRegistryGiftListForCount($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      items {
        id
        alreadyPurchased
        alreadyReserved
        externallyOwned
        stillNeeded
        donationFund {
          id
          donations {
            id
            amount {
              valueInMinorUnits
            }
          }
          goalMonetaryValue {
            valueInMinorUnits
            currency {
              places
            }
          }
          suggestedDonationMonetaryValue {
            valueInMinorUnits
          }
          enforceSuggestedDonationAmount
          progressToGoalPercent
        }
      }
    }
  }
}
    `;

/**
 * __useGetRegistryGiftListForCountQuery__
 *
 * To run a query within a React component, call `useGetRegistryGiftListForCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryGiftListForCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryGiftListForCountQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryGiftListForCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryGiftListForCountQuery, GetRegistryGiftListForCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryGiftListForCountQuery, GetRegistryGiftListForCountQueryVariables>(GetRegistryGiftListForCountDocument, baseOptions);
      }
export function useGetRegistryGiftListForCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryGiftListForCountQuery, GetRegistryGiftListForCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryGiftListForCountQuery, GetRegistryGiftListForCountQueryVariables>(GetRegistryGiftListForCountDocument, baseOptions);
        }
export type GetRegistryGiftListForCountQueryHookResult = ReturnType<typeof useGetRegistryGiftListForCountQuery>;
export type GetRegistryGiftListForCountLazyQueryHookResult = ReturnType<typeof useGetRegistryGiftListForCountLazyQuery>;
export type GetRegistryGiftListForCountQueryResult = Apollo.QueryResult<GetRegistryGiftListForCountQuery, GetRegistryGiftListForCountQueryVariables>;
export const GetBookmarkletEventDataDocument = gql`
    query GetBookmarkletEventData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      id
      info {
        id
        finalizedDate {
          ...Date
        }
      }
      ...RegistryShippingAddressFragment
    }
  }
}
    ${DateFragmentDoc}
${RegistryShippingAddressFragmentFragmentDoc}`;

/**
 * __useGetBookmarkletEventDataQuery__
 *
 * To run a query within a React component, call `useGetBookmarkletEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkletEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkletEventDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetBookmarkletEventDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookmarkletEventDataQuery, GetBookmarkletEventDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookmarkletEventDataQuery, GetBookmarkletEventDataQueryVariables>(GetBookmarkletEventDataDocument, baseOptions);
      }
export function useGetBookmarkletEventDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookmarkletEventDataQuery, GetBookmarkletEventDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookmarkletEventDataQuery, GetBookmarkletEventDataQueryVariables>(GetBookmarkletEventDataDocument, baseOptions);
        }
export type GetBookmarkletEventDataQueryHookResult = ReturnType<typeof useGetBookmarkletEventDataQuery>;
export type GetBookmarkletEventDataLazyQueryHookResult = ReturnType<typeof useGetBookmarkletEventDataLazyQuery>;
export type GetBookmarkletEventDataQueryResult = Apollo.QueryResult<GetBookmarkletEventDataQuery, GetBookmarkletEventDataQueryVariables>;
export const SubmitRecommendRegistryOnboardingSurveyResponsesDocument = gql`
    mutation SubmitRecommendRegistryOnboardingSurveyResponses($eventId: String!, $payload: RecommendRegistryOnboardingSurveyPayload!) {
  updateRecommendRegistryOnboardingSurvey(eventId: $eventId, payload: $payload) {
    id
    lastUpdatedAt {
      milliseconds
    }
    registryTypes
    registeringAtOtherStores
    coupleInterests
    interestedInBrowserButton
  }
}
    `;
export type SubmitRecommendRegistryOnboardingSurveyResponsesMutationFn = Apollo.MutationFunction<SubmitRecommendRegistryOnboardingSurveyResponsesMutation, SubmitRecommendRegistryOnboardingSurveyResponsesMutationVariables>;

/**
 * __useSubmitRecommendRegistryOnboardingSurveyResponsesMutation__
 *
 * To run a mutation, you first call `useSubmitRecommendRegistryOnboardingSurveyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRecommendRegistryOnboardingSurveyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRecommendRegistryOnboardingSurveyResponsesMutation, { data, loading, error }] = useSubmitRecommendRegistryOnboardingSurveyResponsesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitRecommendRegistryOnboardingSurveyResponsesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitRecommendRegistryOnboardingSurveyResponsesMutation, SubmitRecommendRegistryOnboardingSurveyResponsesMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitRecommendRegistryOnboardingSurveyResponsesMutation, SubmitRecommendRegistryOnboardingSurveyResponsesMutationVariables>(SubmitRecommendRegistryOnboardingSurveyResponsesDocument, baseOptions);
      }
export type SubmitRecommendRegistryOnboardingSurveyResponsesMutationHookResult = ReturnType<typeof useSubmitRecommendRegistryOnboardingSurveyResponsesMutation>;
export type SubmitRecommendRegistryOnboardingSurveyResponsesMutationResult = Apollo.MutationResult<SubmitRecommendRegistryOnboardingSurveyResponsesMutation>;
export type SubmitRecommendRegistryOnboardingSurveyResponsesMutationOptions = Apollo.BaseMutationOptions<SubmitRecommendRegistryOnboardingSurveyResponsesMutation, SubmitRecommendRegistryOnboardingSurveyResponsesMutationVariables>;
export const GetOverviewProgressStateDocument = gql`
    query GetOverviewProgressState($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      checklist {
        id
      }
      itemCount {
        everything
      }
    }
  }
}
    `;

/**
 * __useGetOverviewProgressStateQuery__
 *
 * To run a query within a React component, call `useGetOverviewProgressStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewProgressStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewProgressStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetOverviewProgressStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOverviewProgressStateQuery, GetOverviewProgressStateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOverviewProgressStateQuery, GetOverviewProgressStateQueryVariables>(GetOverviewProgressStateDocument, baseOptions);
      }
export function useGetOverviewProgressStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOverviewProgressStateQuery, GetOverviewProgressStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOverviewProgressStateQuery, GetOverviewProgressStateQueryVariables>(GetOverviewProgressStateDocument, baseOptions);
        }
export type GetOverviewProgressStateQueryHookResult = ReturnType<typeof useGetOverviewProgressStateQuery>;
export type GetOverviewProgressStateLazyQueryHookResult = ReturnType<typeof useGetOverviewProgressStateLazyQuery>;
export type GetOverviewProgressStateQueryResult = Apollo.QueryResult<GetOverviewProgressStateQuery, GetOverviewProgressStateQueryVariables>;
export const GetProductCatalogCategoriesByIdsForProductRecommendationsDocument = gql`
    query GetProductCatalogCategoriesByIdsForProductRecommendations($ids: [ID!]!) {
  productCatalogCategoriesByIds(ids: $ids) {
    id
    title
    publicUrlPath
    totalItemCount
  }
}
    `;

/**
 * __useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogCategoriesByIdsForProductRecommendationsQuery, GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductCatalogCategoriesByIdsForProductRecommendationsQuery, GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables>(GetProductCatalogCategoriesByIdsForProductRecommendationsDocument, baseOptions);
      }
export function useGetProductCatalogCategoriesByIdsForProductRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogCategoriesByIdsForProductRecommendationsQuery, GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductCatalogCategoriesByIdsForProductRecommendationsQuery, GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables>(GetProductCatalogCategoriesByIdsForProductRecommendationsDocument, baseOptions);
        }
export type GetProductCatalogCategoriesByIdsForProductRecommendationsQueryHookResult = ReturnType<typeof useGetProductCatalogCategoriesByIdsForProductRecommendationsQuery>;
export type GetProductCatalogCategoriesByIdsForProductRecommendationsLazyQueryHookResult = ReturnType<typeof useGetProductCatalogCategoriesByIdsForProductRecommendationsLazyQuery>;
export type GetProductCatalogCategoriesByIdsForProductRecommendationsQueryResult = Apollo.QueryResult<GetProductCatalogCategoriesByIdsForProductRecommendationsQuery, GetProductCatalogCategoriesByIdsForProductRecommendationsQueryVariables>;
export const GetCoupleInterestsForProductRecommendationsDocument = gql`
    query GetCoupleInterestsForProductRecommendations($handle: String!) {
  eventByName(name: $handle) {
    id
    recommendation {
      registryOnboardingSurvey {
        id
        coupleInterests
      }
    }
  }
}
    `;

/**
 * __useGetCoupleInterestsForProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetCoupleInterestsForProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoupleInterestsForProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoupleInterestsForProductRecommendationsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetCoupleInterestsForProductRecommendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoupleInterestsForProductRecommendationsQuery, GetCoupleInterestsForProductRecommendationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCoupleInterestsForProductRecommendationsQuery, GetCoupleInterestsForProductRecommendationsQueryVariables>(GetCoupleInterestsForProductRecommendationsDocument, baseOptions);
      }
export function useGetCoupleInterestsForProductRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoupleInterestsForProductRecommendationsQuery, GetCoupleInterestsForProductRecommendationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCoupleInterestsForProductRecommendationsQuery, GetCoupleInterestsForProductRecommendationsQueryVariables>(GetCoupleInterestsForProductRecommendationsDocument, baseOptions);
        }
export type GetCoupleInterestsForProductRecommendationsQueryHookResult = ReturnType<typeof useGetCoupleInterestsForProductRecommendationsQuery>;
export type GetCoupleInterestsForProductRecommendationsLazyQueryHookResult = ReturnType<typeof useGetCoupleInterestsForProductRecommendationsLazyQuery>;
export type GetCoupleInterestsForProductRecommendationsQueryResult = Apollo.QueryResult<GetCoupleInterestsForProductRecommendationsQuery, GetCoupleInterestsForProductRecommendationsQueryVariables>;
export const UpdateCoupleInterestsForProductRecommendationsDocument = gql`
    mutation UpdateCoupleInterestsForProductRecommendations($eventId: String!, $payload: RecommendRegistryOnboardingSurveyPayload!) {
  updateRecommendRegistryOnboardingSurvey(eventId: $eventId, payload: $payload) {
    id
    coupleInterests
  }
}
    `;
export type UpdateCoupleInterestsForProductRecommendationsMutationFn = Apollo.MutationFunction<UpdateCoupleInterestsForProductRecommendationsMutation, UpdateCoupleInterestsForProductRecommendationsMutationVariables>;

/**
 * __useUpdateCoupleInterestsForProductRecommendationsMutation__
 *
 * To run a mutation, you first call `useUpdateCoupleInterestsForProductRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoupleInterestsForProductRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoupleInterestsForProductRecommendationsMutation, { data, loading, error }] = useUpdateCoupleInterestsForProductRecommendationsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateCoupleInterestsForProductRecommendationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCoupleInterestsForProductRecommendationsMutation, UpdateCoupleInterestsForProductRecommendationsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCoupleInterestsForProductRecommendationsMutation, UpdateCoupleInterestsForProductRecommendationsMutationVariables>(UpdateCoupleInterestsForProductRecommendationsDocument, baseOptions);
      }
export type UpdateCoupleInterestsForProductRecommendationsMutationHookResult = ReturnType<typeof useUpdateCoupleInterestsForProductRecommendationsMutation>;
export type UpdateCoupleInterestsForProductRecommendationsMutationResult = Apollo.MutationResult<UpdateCoupleInterestsForProductRecommendationsMutation>;
export type UpdateCoupleInterestsForProductRecommendationsMutationOptions = Apollo.BaseMutationOptions<UpdateCoupleInterestsForProductRecommendationsMutation, UpdateCoupleInterestsForProductRecommendationsMutationVariables>;
export const GetAdminExternalRegistriesDocument = gql`
    query GetAdminExternalRegistries($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registry {
      id
      registries {
        ...AdminExternalRegistry
      }
    }
  }
}
    ${AdminExternalRegistryFragmentDoc}`;

/**
 * __useGetAdminExternalRegistriesQuery__
 *
 * To run a query within a React component, call `useGetAdminExternalRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminExternalRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminExternalRegistriesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminExternalRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminExternalRegistriesQuery, GetAdminExternalRegistriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAdminExternalRegistriesQuery, GetAdminExternalRegistriesQueryVariables>(GetAdminExternalRegistriesDocument, baseOptions);
      }
export function useGetAdminExternalRegistriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminExternalRegistriesQuery, GetAdminExternalRegistriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAdminExternalRegistriesQuery, GetAdminExternalRegistriesQueryVariables>(GetAdminExternalRegistriesDocument, baseOptions);
        }
export type GetAdminExternalRegistriesQueryHookResult = ReturnType<typeof useGetAdminExternalRegistriesQuery>;
export type GetAdminExternalRegistriesLazyQueryHookResult = ReturnType<typeof useGetAdminExternalRegistriesLazyQuery>;
export type GetAdminExternalRegistriesQueryResult = Apollo.QueryResult<GetAdminExternalRegistriesQuery, GetAdminExternalRegistriesQueryVariables>;
export const GetRecommendableProductsByRegistryIdDocument = gql`
    query GetRecommendableProductsByRegistryId($registryId: ID!) {
  recommendableItemsByRegistryId(registryId: $registryId) {
    id
    recommendationStatus
    productData {
      title
      brand
      description
      pdpUrl
      photos {
        id
        url
      }
      price {
        valueInMinorUnits
        floatingPointDecimalString
        currency {
          code
        }
      }
      registryItem {
        id
        recommendationStatus
      }
    }
  }
}
    `;

/**
 * __useGetRecommendableProductsByRegistryIdQuery__
 *
 * To run a query within a React component, call `useGetRecommendableProductsByRegistryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendableProductsByRegistryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendableProductsByRegistryIdQuery({
 *   variables: {
 *      registryId: // value for 'registryId'
 *   },
 * });
 */
export function useGetRecommendableProductsByRegistryIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendableProductsByRegistryIdQuery, GetRecommendableProductsByRegistryIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendableProductsByRegistryIdQuery, GetRecommendableProductsByRegistryIdQueryVariables>(GetRecommendableProductsByRegistryIdDocument, baseOptions);
      }
export function useGetRecommendableProductsByRegistryIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendableProductsByRegistryIdQuery, GetRecommendableProductsByRegistryIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendableProductsByRegistryIdQuery, GetRecommendableProductsByRegistryIdQueryVariables>(GetRecommendableProductsByRegistryIdDocument, baseOptions);
        }
export type GetRecommendableProductsByRegistryIdQueryHookResult = ReturnType<typeof useGetRecommendableProductsByRegistryIdQuery>;
export type GetRecommendableProductsByRegistryIdLazyQueryHookResult = ReturnType<typeof useGetRecommendableProductsByRegistryIdLazyQuery>;
export type GetRecommendableProductsByRegistryIdQueryResult = Apollo.QueryResult<GetRecommendableProductsByRegistryIdQuery, GetRecommendableProductsByRegistryIdQueryVariables>;
export const GetRecommendedProductsByProductUrlDocument = gql`
    query GetRecommendedProductsByProductUrl($recommendationInputs: [ProductCatalogItemRecommendationInput!]!) {
  productCatalogItemRecommendations(recommendationInputs: $recommendationInputs) {
    productUrl
    recommendations {
      reason
      catalogItem {
        brand {
          name
          id
        }
        id
        title
        mediaAssets {
          ... on ProductCatalogPhotoAsset {
            ...ProductCatalogPhotoAsset
          }
        }
        group {
          id
          tileViewDimension {
            id
            options {
              swatchColor {
                hex
              }
              id
              displayString
            }
          }
        }
        rating {
          id
          stats {
            id
            averageRating
            totalReviewCount
          }
        }
        price {
          valueInMinorUnits
          floatingPointDecimalString
          currency {
            code
          }
        }
        productUrl
      }
    }
  }
}
    ${ProductCatalogPhotoAssetFragmentDoc}`;

/**
 * __useGetRecommendedProductsByProductUrlQuery__
 *
 * To run a query within a React component, call `useGetRecommendedProductsByProductUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedProductsByProductUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedProductsByProductUrlQuery({
 *   variables: {
 *      recommendationInputs: // value for 'recommendationInputs'
 *   },
 * });
 */
export function useGetRecommendedProductsByProductUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedProductsByProductUrlQuery, GetRecommendedProductsByProductUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendedProductsByProductUrlQuery, GetRecommendedProductsByProductUrlQueryVariables>(GetRecommendedProductsByProductUrlDocument, baseOptions);
      }
export function useGetRecommendedProductsByProductUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedProductsByProductUrlQuery, GetRecommendedProductsByProductUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendedProductsByProductUrlQuery, GetRecommendedProductsByProductUrlQueryVariables>(GetRecommendedProductsByProductUrlDocument, baseOptions);
        }
export type GetRecommendedProductsByProductUrlQueryHookResult = ReturnType<typeof useGetRecommendedProductsByProductUrlQuery>;
export type GetRecommendedProductsByProductUrlLazyQueryHookResult = ReturnType<typeof useGetRecommendedProductsByProductUrlLazyQuery>;
export type GetRecommendedProductsByProductUrlQueryResult = Apollo.QueryResult<GetRecommendedProductsByProductUrlQuery, GetRecommendedProductsByProductUrlQueryVariables>;
export const updateItemrecommendayionStatusDocument = gql`
    mutation updateItemrecommendayionStatus($eventId: ID!, $action: ProcessRecommendationAction!, $catalogItemId: ID!, $registryItemId: ID!) {
  processRecommendations(eventId: $eventId, payloads: {action: $action, catalogItemId: $catalogItemId, registryItemId: $registryItemId}) {
    models {
      id
      recommendationStatus
    }
  }
}
    `;
export type updateItemrecommendayionStatusMutationFn = Apollo.MutationFunction<updateItemrecommendayionStatusMutation, updateItemrecommendayionStatusMutationVariables>;

/**
 * __useupdateItemrecommendayionStatusMutation__
 *
 * To run a mutation, you first call `useupdateItemrecommendayionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateItemrecommendayionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemrecommendayionStatusMutation, { data, loading, error }] = useupdateItemrecommendayionStatusMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      action: // value for 'action'
 *      catalogItemId: // value for 'catalogItemId'
 *      registryItemId: // value for 'registryItemId'
 *   },
 * });
 */
export function useupdateItemrecommendayionStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateItemrecommendayionStatusMutation, updateItemrecommendayionStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<updateItemrecommendayionStatusMutation, updateItemrecommendayionStatusMutationVariables>(updateItemrecommendayionStatusDocument, baseOptions);
      }
export type updateItemrecommendayionStatusMutationHookResult = ReturnType<typeof useupdateItemrecommendayionStatusMutation>;
export type updateItemrecommendayionStatusMutationResult = Apollo.MutationResult<updateItemrecommendayionStatusMutation>;
export type updateItemrecommendayionStatusMutationOptions = Apollo.BaseMutationOptions<updateItemrecommendayionStatusMutation, updateItemrecommendayionStatusMutationVariables>;
export const UpdateRegistryRecommendationStatusDocument = gql`
    mutation UpdateRegistryRecommendationStatus($registryId: ID!, $status: RegistryRecommendationStatus!) {
  updateRegistryWithResult(id: $registryId, payload: {recommendationStatus: $status}) {
    status {
      id
    }
  }
}
    `;
export type UpdateRegistryRecommendationStatusMutationFn = Apollo.MutationFunction<UpdateRegistryRecommendationStatusMutation, UpdateRegistryRecommendationStatusMutationVariables>;

/**
 * __useUpdateRegistryRecommendationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryRecommendationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryRecommendationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryRecommendationStatusMutation, { data, loading, error }] = useUpdateRegistryRecommendationStatusMutation({
 *   variables: {
 *      registryId: // value for 'registryId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateRegistryRecommendationStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryRecommendationStatusMutation, UpdateRegistryRecommendationStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryRecommendationStatusMutation, UpdateRegistryRecommendationStatusMutationVariables>(UpdateRegistryRecommendationStatusDocument, baseOptions);
      }
export type UpdateRegistryRecommendationStatusMutationHookResult = ReturnType<typeof useUpdateRegistryRecommendationStatusMutation>;
export type UpdateRegistryRecommendationStatusMutationResult = Apollo.MutationResult<UpdateRegistryRecommendationStatusMutation>;
export type UpdateRegistryRecommendationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryRecommendationStatusMutation, UpdateRegistryRecommendationStatusMutationVariables>;
export const GetProductCatalogCollectionMembersDocument = gql`
    query GetProductCatalogCollectionMembers($collectionsRefList: [ProductCatalogDisplayInfoRef!]!) {
  productCatalogCollectionDisplayInfosByRefs(refs: $collectionsRefList) {
    id
    collection {
      id
      members {
        ...ProductCatalogCollectionMembers
      }
    }
  }
}
    ${ProductCatalogCollectionMembersFragmentDoc}`;

/**
 * __useGetProductCatalogCollectionMembersQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogCollectionMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogCollectionMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogCollectionMembersQuery({
 *   variables: {
 *      collectionsRefList: // value for 'collectionsRefList'
 *   },
 * });
 */
export function useGetProductCatalogCollectionMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogCollectionMembersQuery, GetProductCatalogCollectionMembersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductCatalogCollectionMembersQuery, GetProductCatalogCollectionMembersQueryVariables>(GetProductCatalogCollectionMembersDocument, baseOptions);
      }
export function useGetProductCatalogCollectionMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogCollectionMembersQuery, GetProductCatalogCollectionMembersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductCatalogCollectionMembersQuery, GetProductCatalogCollectionMembersQueryVariables>(GetProductCatalogCollectionMembersDocument, baseOptions);
        }
export type GetProductCatalogCollectionMembersQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionMembersQuery>;
export type GetProductCatalogCollectionMembersLazyQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionMembersLazyQuery>;
export type GetProductCatalogCollectionMembersQueryResult = Apollo.QueryResult<GetProductCatalogCollectionMembersQuery, GetProductCatalogCollectionMembersQueryVariables>;
export const ProductCatalogBrandsListDocument = gql`
    query ProductCatalogBrandsList($args: ProductCatalogBrandsDirectoryQueryInput) {
  productCatalogBrandsDirectory(args: $args) {
    categories {
      title
      id
    }
    brands {
      name
      id
      publicUrlPath
    }
  }
}
    `;

/**
 * __useProductCatalogBrandsListQuery__
 *
 * To run a query within a React component, call `useProductCatalogBrandsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogBrandsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogBrandsListQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useProductCatalogBrandsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogBrandsListQuery, ProductCatalogBrandsListQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductCatalogBrandsListQuery, ProductCatalogBrandsListQueryVariables>(ProductCatalogBrandsListDocument, baseOptions);
      }
export function useProductCatalogBrandsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogBrandsListQuery, ProductCatalogBrandsListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductCatalogBrandsListQuery, ProductCatalogBrandsListQueryVariables>(ProductCatalogBrandsListDocument, baseOptions);
        }
export type ProductCatalogBrandsListQueryHookResult = ReturnType<typeof useProductCatalogBrandsListQuery>;
export type ProductCatalogBrandsListLazyQueryHookResult = ReturnType<typeof useProductCatalogBrandsListLazyQuery>;
export type ProductCatalogBrandsListQueryResult = Apollo.QueryResult<ProductCatalogBrandsListQuery, ProductCatalogBrandsListQueryVariables>;
export const GetAllCatalogProductGridItemsDocument = gql`
    query GetAllCatalogProductGridItems($query: ProductCatalogSearchQueryInput!, $first: Int!, $endCursor: ProductCatalogSearchCursor, $type: CatalogTreeRootInput, $withFilters: Boolean!) {
  productCatalogCategoryTreeRoot(type: $type) {
    id
    heroText
  }
  productCatalogSearchResults(query: $query) {
    pagedResults(first: $first, after: $endCursor) {
      pageInfo {
        ...ProductCatalogSearchPageInfo
      }
      edges {
        cursor
        node {
          catalogItem {
            ...ProductCatalogItemSearchSummary
          }
        }
      }
    }
    allFilters @include(if: $withFilters) {
      attributes {
        id
        compositeCode
        isActive @client
        matchingItemsCount
        value {
          id
          title
          code
        }
      }
      attributeGroup {
        id
        title
        code
        valueType
        filterSelectionType
      }
      selectedPriceRange @client {
        maxValueInMinorUnits
        minValueInMinorUnits
      }
    }
    orderedBy @client
  }
}
    ${ProductCatalogSearchPageInfoFragmentDoc}
${ProductCatalogItemSearchSummaryFragmentDoc}`;

/**
 * __useGetAllCatalogProductGridItemsQuery__
 *
 * To run a query within a React component, call `useGetAllCatalogProductGridItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCatalogProductGridItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCatalogProductGridItemsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      type: // value for 'type'
 *      withFilters: // value for 'withFilters'
 *   },
 * });
 */
export function useGetAllCatalogProductGridItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCatalogProductGridItemsQuery, GetAllCatalogProductGridItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllCatalogProductGridItemsQuery, GetAllCatalogProductGridItemsQueryVariables>(GetAllCatalogProductGridItemsDocument, baseOptions);
      }
export function useGetAllCatalogProductGridItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCatalogProductGridItemsQuery, GetAllCatalogProductGridItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllCatalogProductGridItemsQuery, GetAllCatalogProductGridItemsQueryVariables>(GetAllCatalogProductGridItemsDocument, baseOptions);
        }
export type GetAllCatalogProductGridItemsQueryHookResult = ReturnType<typeof useGetAllCatalogProductGridItemsQuery>;
export type GetAllCatalogProductGridItemsLazyQueryHookResult = ReturnType<typeof useGetAllCatalogProductGridItemsLazyQuery>;
export type GetAllCatalogProductGridItemsQueryResult = Apollo.QueryResult<GetAllCatalogProductGridItemsQuery, GetAllCatalogProductGridItemsQueryVariables>;
export const GetAllUniversalGridItemsDocument = gql`
    query GetAllUniversalGridItems($query: ProductCatalogSearchQueryInput!, $first: Int!, $endCursor: ProductCatalogSearchCursor, $type: CatalogTreeRootInput, $withFilters: Boolean!, $sourceLimits: [ProductUniversalSearchSourceLimit!]) {
  productCatalogCategoryTreeRoot(type: $type) {
    id
    heroText
  }
  productUniversalSearchResults(query: $query, sourceLimits: $sourceLimits) {
    pagedResults(first: $first, after: $endCursor) {
      pageInfo {
        ...ProductCatalogSearchPageInfo
      }
      edges {
        cursor
        node {
          source
          item {
            __typename
            ... on ProductUniversalCatalogItemContainer {
              catalogItem {
                ...ProductCatalogItemSearchSummary
              }
            }
            ... on ProductExternalOfferContainer {
              offer {
                ...ProductExternalOfferSummary
              }
            }
          }
        }
      }
    }
    allFilters @include(if: $withFilters) {
      attributes {
        id
        compositeCode
        isActive @client
        matchingItemsCount
        value {
          id
          title
          code
        }
      }
      attributeGroup {
        id
        title
        code
        valueType
        filterSelectionType
      }
      selectedPriceRange @client {
        maxValueInMinorUnits
        minValueInMinorUnits
      }
    }
  }
}
    ${ProductCatalogSearchPageInfoFragmentDoc}
${ProductCatalogItemSearchSummaryFragmentDoc}
${ProductExternalOfferSummaryFragmentDoc}`;

/**
 * __useGetAllUniversalGridItemsQuery__
 *
 * To run a query within a React component, call `useGetAllUniversalGridItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUniversalGridItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUniversalGridItemsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      type: // value for 'type'
 *      withFilters: // value for 'withFilters'
 *      sourceLimits: // value for 'sourceLimits'
 *   },
 * });
 */
export function useGetAllUniversalGridItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>(GetAllUniversalGridItemsDocument, baseOptions);
      }
export function useGetAllUniversalGridItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>(GetAllUniversalGridItemsDocument, baseOptions);
        }
export type GetAllUniversalGridItemsQueryHookResult = ReturnType<typeof useGetAllUniversalGridItemsQuery>;
export type GetAllUniversalGridItemsLazyQueryHookResult = ReturnType<typeof useGetAllUniversalGridItemsLazyQuery>;
export type GetAllUniversalGridItemsQueryResult = Apollo.QueryResult<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>;
export const GetProductCatalogBrandsByCriteriaDocument = gql`
    query GetProductCatalogBrandsByCriteria($brandsUrlsList: [String!]!) {
  productCatalogBrandsByCriteria(urls: $brandsUrlsList) {
    id
    name
    publicUrlPath
    description
    logoImage {
      id
      url
      altTag
    }
    header {
      id
      title
      description
      backgroundImage {
        id
        url
      }
      logoImage {
        id
        url
      }
      videoUrl
      textColor
      gradientColor
      gradientMarkup
    }
  }
}
    `;

/**
 * __useGetProductCatalogBrandsByCriteriaQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogBrandsByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogBrandsByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogBrandsByCriteriaQuery({
 *   variables: {
 *      brandsUrlsList: // value for 'brandsUrlsList'
 *   },
 * });
 */
export function useGetProductCatalogBrandsByCriteriaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogBrandsByCriteriaQuery, GetProductCatalogBrandsByCriteriaQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductCatalogBrandsByCriteriaQuery, GetProductCatalogBrandsByCriteriaQueryVariables>(GetProductCatalogBrandsByCriteriaDocument, baseOptions);
      }
export function useGetProductCatalogBrandsByCriteriaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogBrandsByCriteriaQuery, GetProductCatalogBrandsByCriteriaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductCatalogBrandsByCriteriaQuery, GetProductCatalogBrandsByCriteriaQueryVariables>(GetProductCatalogBrandsByCriteriaDocument, baseOptions);
        }
export type GetProductCatalogBrandsByCriteriaQueryHookResult = ReturnType<typeof useGetProductCatalogBrandsByCriteriaQuery>;
export type GetProductCatalogBrandsByCriteriaLazyQueryHookResult = ReturnType<typeof useGetProductCatalogBrandsByCriteriaLazyQuery>;
export type GetProductCatalogBrandsByCriteriaQueryResult = Apollo.QueryResult<GetProductCatalogBrandsByCriteriaQuery, GetProductCatalogBrandsByCriteriaQueryVariables>;
export const GetCatalogProductDetailsDocument = gql`
    query GetCatalogProductDetails($catalogItemId: ID!, $eventId: ID, $withPdpSections: Boolean!, $withProductRating: Boolean!, $withInventory: Boolean!) {
  productCatalogItemById(id: $catalogItemId) {
    ...CatalogPdpDisplayFields
    ...CatalogPdpDimensions
    ...CatalogPdpCollectionDisplayInfos
    mediaAssets {
      ... on ProductCatalogPhotoAsset {
        ...ProductCatalogPhotoAsset
      }
      ... on ProductCatalogVideoAsset {
        ...ProductCatalogVideoAsset
      }
    }
    storefrontInfo {
      storefrontStatus
      canAddToCart
      canAddToRegistry
    }
    rating @include(if: $withProductRating) {
      id
      stats {
        id
        averageRating
        totalReviewCount
      }
    }
    parentCategories {
      id
      publicUrlPath
      lineage {
        id
        publicUrlPath
      }
    }
    pdpSections @include(if: $withPdpSections) {
      sectionType
      collectionType
      sectionTree {
        rootElementKey
        elements {
          key
          elementType
          childrenKeys
          html
          text
          photo {
            id
            url
          }
        }
      }
    }
  }
  registryCatalogInventoryById(payload: {catalogItemId: $catalogItemId, eventId: $eventId}) @include(if: $withInventory) {
    maxQty
  }
}
    ${CatalogPdpDisplayFieldsFragmentDoc}
${CatalogPdpDimensionsFragmentDoc}
${CatalogPdpCollectionDisplayInfosFragmentDoc}
${ProductCatalogPhotoAssetFragmentDoc}
${ProductCatalogVideoAssetFragmentDoc}`;

/**
 * __useGetCatalogProductDetailsQuery__
 *
 * To run a query within a React component, call `useGetCatalogProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogProductDetailsQuery({
 *   variables: {
 *      catalogItemId: // value for 'catalogItemId'
 *      eventId: // value for 'eventId'
 *      withPdpSections: // value for 'withPdpSections'
 *      withProductRating: // value for 'withProductRating'
 *      withInventory: // value for 'withInventory'
 *   },
 * });
 */
export function useGetCatalogProductDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>(GetCatalogProductDetailsDocument, baseOptions);
      }
export function useGetCatalogProductDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>(GetCatalogProductDetailsDocument, baseOptions);
        }
export type GetCatalogProductDetailsQueryHookResult = ReturnType<typeof useGetCatalogProductDetailsQuery>;
export type GetCatalogProductDetailsLazyQueryHookResult = ReturnType<typeof useGetCatalogProductDetailsLazyQuery>;
export type GetCatalogProductDetailsQueryResult = Apollo.QueryResult<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>;
export const GetDepartmentDocument = gql`
    query GetDepartment($storefront: CatalogStorefront) {
  productCatalogCategoryTreeRoot(storefront: $storefront) {
    id
    children {
      id
      title
      locator
    }
  }
}
    `;

/**
 * __useGetDepartmentQuery__
 *
 * To run a query within a React component, call `useGetDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentQuery({
 *   variables: {
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetDepartmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, baseOptions);
      }
export function useGetDepartmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, baseOptions);
        }
export type GetDepartmentQueryHookResult = ReturnType<typeof useGetDepartmentQuery>;
export type GetDepartmentLazyQueryHookResult = ReturnType<typeof useGetDepartmentLazyQuery>;
export type GetDepartmentQueryResult = Apollo.QueryResult<GetDepartmentQuery, GetDepartmentQueryVariables>;
export const GetProductCatalogCollectionDisplayInfosByRefsDocument = gql`
    query GetProductCatalogCollectionDisplayInfosByRefs($collectionsRefList: [ProductCatalogDisplayInfoRef!]!) {
  productCatalogCollectionDisplayInfosByRefs(refs: $collectionsRefList) {
    id
    displayInfoId
    pdpSectionType
    title
    collection {
      id
      collectionType
      members {
        ... on ProductCatalogEntityItem {
          id
          catalogItemData {
            ...CatalogPdpDisplayFields
            group {
              id
              groupDimensions {
                id
                title
              }
            }
          }
        }
      }
    }
  }
}
    ${CatalogPdpDisplayFieldsFragmentDoc}`;

/**
 * __useGetProductCatalogCollectionDisplayInfosByRefsQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogCollectionDisplayInfosByRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogCollectionDisplayInfosByRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogCollectionDisplayInfosByRefsQuery({
 *   variables: {
 *      collectionsRefList: // value for 'collectionsRefList'
 *   },
 * });
 */
export function useGetProductCatalogCollectionDisplayInfosByRefsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>(GetProductCatalogCollectionDisplayInfosByRefsDocument, baseOptions);
      }
export function useGetProductCatalogCollectionDisplayInfosByRefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>(GetProductCatalogCollectionDisplayInfosByRefsDocument, baseOptions);
        }
export type GetProductCatalogCollectionDisplayInfosByRefsQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionDisplayInfosByRefsQuery>;
export type GetProductCatalogCollectionDisplayInfosByRefsLazyQueryHookResult = ReturnType<typeof useGetProductCatalogCollectionDisplayInfosByRefsLazyQuery>;
export type GetProductCatalogCollectionDisplayInfosByRefsQueryResult = Apollo.QueryResult<GetProductCatalogCollectionDisplayInfosByRefsQuery, GetProductCatalogCollectionDisplayInfosByRefsQueryVariables>;
export const GetCatalogProductReviewsDocument = gql`
    query GetCatalogProductReviews($catalogItemId: ID!, $orderBy: RatingReviewOrderBy, $first: Int, $after: RatingReviewCursor) {
  productCatalogItemById(id: $catalogItemId) {
    id
    rating {
      id
      stats {
        id
        ...CustomerReviewStats
      }
      reviews(query: {orderBy: $orderBy}) {
        __typename
        pagedResults(first: $first, after: $after) {
          __typename
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
            totalCount
          }
          edges {
            cursor
            node {
              ...CustomerProductReview
            }
          }
        }
      }
    }
  }
}
    ${CustomerReviewStatsFragmentDoc}
${CustomerProductReviewFragmentDoc}`;

/**
 * __useGetCatalogProductReviewsQuery__
 *
 * To run a query within a React component, call `useGetCatalogProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogProductReviewsQuery({
 *   variables: {
 *      catalogItemId: // value for 'catalogItemId'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCatalogProductReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogProductReviewsQuery, GetCatalogProductReviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCatalogProductReviewsQuery, GetCatalogProductReviewsQueryVariables>(GetCatalogProductReviewsDocument, baseOptions);
      }
export function useGetCatalogProductReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogProductReviewsQuery, GetCatalogProductReviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCatalogProductReviewsQuery, GetCatalogProductReviewsQueryVariables>(GetCatalogProductReviewsDocument, baseOptions);
        }
export type GetCatalogProductReviewsQueryHookResult = ReturnType<typeof useGetCatalogProductReviewsQuery>;
export type GetCatalogProductReviewsLazyQueryHookResult = ReturnType<typeof useGetCatalogProductReviewsLazyQuery>;
export type GetCatalogProductReviewsQueryResult = Apollo.QueryResult<GetCatalogProductReviewsQuery, GetCatalogProductReviewsQueryVariables>;
export const GetCatalogProductRatingDocument = gql`
    query GetCatalogProductRating($catalogItemId: ID!) {
  productCatalogItemById(id: $catalogItemId) {
    id
    rating {
      id
      stats {
        id
        totalReviewCount
        averageRating
      }
    }
  }
}
    `;

/**
 * __useGetCatalogProductRatingQuery__
 *
 * To run a query within a React component, call `useGetCatalogProductRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogProductRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogProductRatingQuery({
 *   variables: {
 *      catalogItemId: // value for 'catalogItemId'
 *   },
 * });
 */
export function useGetCatalogProductRatingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogProductRatingQuery, GetCatalogProductRatingQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCatalogProductRatingQuery, GetCatalogProductRatingQueryVariables>(GetCatalogProductRatingDocument, baseOptions);
      }
export function useGetCatalogProductRatingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogProductRatingQuery, GetCatalogProductRatingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCatalogProductRatingQuery, GetCatalogProductRatingQueryVariables>(GetCatalogProductRatingDocument, baseOptions);
        }
export type GetCatalogProductRatingQueryHookResult = ReturnType<typeof useGetCatalogProductRatingQuery>;
export type GetCatalogProductRatingLazyQueryHookResult = ReturnType<typeof useGetCatalogProductRatingLazyQuery>;
export type GetCatalogProductRatingQueryResult = Apollo.QueryResult<GetCatalogProductRatingQuery, GetCatalogProductRatingQueryVariables>;
export const GetProductCatalogHighlightedProductsByIdDocument = gql`
    query GetProductCatalogHighlightedProductsById($ids: [ID!]!) {
  productCatalogItemsByIds(ids: $ids) {
    id
    title
    publicUrlPath
    itemType
    price {
      currency {
        code
      }
      floatingPointDecimalString
      valueInMinorUnits
    }
    brand {
      id
      name
    }
    rating {
      id
      stats {
        id
        averageRating
        totalReviewCount
      }
    }
    photos {
      id
      url
    }
  }
}
    `;

/**
 * __useGetProductCatalogHighlightedProductsByIdQuery__
 *
 * To run a query within a React component, call `useGetProductCatalogHighlightedProductsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCatalogHighlightedProductsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCatalogHighlightedProductsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProductCatalogHighlightedProductsByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductCatalogHighlightedProductsByIdQuery, GetProductCatalogHighlightedProductsByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductCatalogHighlightedProductsByIdQuery, GetProductCatalogHighlightedProductsByIdQueryVariables>(GetProductCatalogHighlightedProductsByIdDocument, baseOptions);
      }
export function useGetProductCatalogHighlightedProductsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductCatalogHighlightedProductsByIdQuery, GetProductCatalogHighlightedProductsByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductCatalogHighlightedProductsByIdQuery, GetProductCatalogHighlightedProductsByIdQueryVariables>(GetProductCatalogHighlightedProductsByIdDocument, baseOptions);
        }
export type GetProductCatalogHighlightedProductsByIdQueryHookResult = ReturnType<typeof useGetProductCatalogHighlightedProductsByIdQuery>;
export type GetProductCatalogHighlightedProductsByIdLazyQueryHookResult = ReturnType<typeof useGetProductCatalogHighlightedProductsByIdLazyQuery>;
export type GetProductCatalogHighlightedProductsByIdQueryResult = Apollo.QueryResult<GetProductCatalogHighlightedProductsByIdQuery, GetProductCatalogHighlightedProductsByIdQueryVariables>;
export const AddProductConfirmationDrawerUpdatesDocument = gql`
    mutation AddProductConfirmationDrawerUpdates($registryItemId: ID!, $payload: UpdateRegistryItemPayload!) {
  updateRegistryItem(id: $registryItemId, payload: $payload) {
    ...RegistryItem
  }
}
    ${RegistryItemFragmentDoc}`;
export type AddProductConfirmationDrawerUpdatesMutationFn = Apollo.MutationFunction<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>;

/**
 * __useAddProductConfirmationDrawerUpdatesMutation__
 *
 * To run a mutation, you first call `useAddProductConfirmationDrawerUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductConfirmationDrawerUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductConfirmationDrawerUpdatesMutation, { data, loading, error }] = useAddProductConfirmationDrawerUpdatesMutation({
 *   variables: {
 *      registryItemId: // value for 'registryItemId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddProductConfirmationDrawerUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>) {
        return ApolloReactHooks.useMutation<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>(AddProductConfirmationDrawerUpdatesDocument, baseOptions);
      }
export type AddProductConfirmationDrawerUpdatesMutationHookResult = ReturnType<typeof useAddProductConfirmationDrawerUpdatesMutation>;
export type AddProductConfirmationDrawerUpdatesMutationResult = Apollo.MutationResult<AddProductConfirmationDrawerUpdatesMutation>;
export type AddProductConfirmationDrawerUpdatesMutationOptions = Apollo.BaseMutationOptions<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>;
export const ProductCatalogCategoryByIdDocument = gql`
    query ProductCatalogCategoryById($productCatalogCategoryByIdId: ID!) {
  productCatalogCategoryById(id: $productCatalogCategoryByIdId) {
    title
    parent {
      id
      title
      children {
        title
        showcase {
          title
          image {
            id
            url
          }
        }
        id
        isFeatured
        publicUrlPath
      }
    }
    id
  }
}
    `;

/**
 * __useProductCatalogCategoryByIdQuery__
 *
 * To run a query within a React component, call `useProductCatalogCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogCategoryByIdQuery({
 *   variables: {
 *      productCatalogCategoryByIdId: // value for 'productCatalogCategoryByIdId'
 *   },
 * });
 */
export function useProductCatalogCategoryByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogCategoryByIdQuery, ProductCatalogCategoryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductCatalogCategoryByIdQuery, ProductCatalogCategoryByIdQueryVariables>(ProductCatalogCategoryByIdDocument, baseOptions);
      }
export function useProductCatalogCategoryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogCategoryByIdQuery, ProductCatalogCategoryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductCatalogCategoryByIdQuery, ProductCatalogCategoryByIdQueryVariables>(ProductCatalogCategoryByIdDocument, baseOptions);
        }
export type ProductCatalogCategoryByIdQueryHookResult = ReturnType<typeof useProductCatalogCategoryByIdQuery>;
export type ProductCatalogCategoryByIdLazyQueryHookResult = ReturnType<typeof useProductCatalogCategoryByIdLazyQuery>;
export type ProductCatalogCategoryByIdQueryResult = Apollo.QueryResult<ProductCatalogCategoryByIdQuery, ProductCatalogCategoryByIdQueryVariables>;
export const GetCurationCatalogProductsDocument = gql`
    query GetCurationCatalogProducts($query: ProductCatalogSearchQueryInput!, $first: Int!, $endCursor: ProductCatalogSearchCursor, $type: CatalogTreeRootInput) {
  productCatalogCategoryTreeRoot(type: $type) {
    id
    title
    heroText
    __typename
  }
  productCatalogSearchResults(query: $query) {
    pagedResults(first: $first, after: $endCursor) {
      pageInfo {
        ...ProductCatalogSearchPageInfo
        __typename
      }
      edges {
        cursor
        node {
          catalogItem {
            ...CatalogProductSharedDisplayFields
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    ${ProductCatalogSearchPageInfoFragmentDoc}
${CatalogProductSharedDisplayFieldsFragmentDoc}`;

/**
 * __useGetCurationCatalogProductsQuery__
 *
 * To run a query within a React component, call `useGetCurationCatalogProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurationCatalogProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurationCatalogProductsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCurationCatalogProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurationCatalogProductsQuery, GetCurationCatalogProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurationCatalogProductsQuery, GetCurationCatalogProductsQueryVariables>(GetCurationCatalogProductsDocument, baseOptions);
      }
export function useGetCurationCatalogProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurationCatalogProductsQuery, GetCurationCatalogProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurationCatalogProductsQuery, GetCurationCatalogProductsQueryVariables>(GetCurationCatalogProductsDocument, baseOptions);
        }
export type GetCurationCatalogProductsQueryHookResult = ReturnType<typeof useGetCurationCatalogProductsQuery>;
export type GetCurationCatalogProductsLazyQueryHookResult = ReturnType<typeof useGetCurationCatalogProductsLazyQuery>;
export type GetCurationCatalogProductsQueryResult = Apollo.QueryResult<GetCurationCatalogProductsQuery, GetCurationCatalogProductsQueryVariables>;
export const GetRecommendedCatalogCategoriesDocument = gql`
    query GetRecommendedCatalogCategories($eventId: ID, $storefront: CatalogStorefront) {
  recommendCatalogHomeSections(eventId: $eventId, storefront: $storefront) {
    id
    sections(limit: 1, offset: 2) {
      id
      displayType
      catalogEntities {
        ... on ProductCatalogEntityCategory {
          id
          __typename
          catalogCategoryData {
            id
            browseMoreBanner {
              image {
                id
                url
              }
            }
            title
            publicUrlPath
            isFeatured
            subCategories: children {
              id
              title
              publicUrlPath
              directItemCount
              isFeatured
              spotlight {
                title
                image {
                  id
                  url
                }
                videoUrl
                videoPlaceholder {
                  id
                  url
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedCatalogCategoriesQuery__
 *
 * To run a query within a React component, call `useGetRecommendedCatalogCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedCatalogCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedCatalogCategoriesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetRecommendedCatalogCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>(GetRecommendedCatalogCategoriesDocument, baseOptions);
      }
export function useGetRecommendedCatalogCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>(GetRecommendedCatalogCategoriesDocument, baseOptions);
        }
export type GetRecommendedCatalogCategoriesQueryHookResult = ReturnType<typeof useGetRecommendedCatalogCategoriesQuery>;
export type GetRecommendedCatalogCategoriesLazyQueryHookResult = ReturnType<typeof useGetRecommendedCatalogCategoriesLazyQuery>;
export type GetRecommendedCatalogCategoriesQueryResult = Apollo.QueryResult<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>;
export const GetRecommendedCatalogProductsDocument = gql`
    query GetRecommendedCatalogProducts($eventId: ID, $first: Int!, $endCursor: ProductCatalogEntityCursor, $storefront: CatalogStorefront) {
  recommendCatalogHomeSections(eventId: $eventId, storefront: $storefront) {
    id
    __typename
    sections(offset: 1, limit: 1) {
      id
      displayType
      __typename
      paginatedCatalogEntities(first: $first, after: $endCursor) {
        __typename
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
          totalCount
        }
        edges {
          cursor
          node {
            id
            __typename
            __typename
            ... on ProductCatalogEntityItemGroup {
              __typename
              catalogItemGroupData {
                id
                tileViewItem {
                  __typename
                  ...CatalogProductSharedDisplayFields
                  group {
                    id
                    __typename
                    ...CatalogProductTileViewDimensions
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CatalogProductSharedDisplayFieldsFragmentDoc}
${CatalogProductTileViewDimensionsFragmentDoc}`;

/**
 * __useGetRecommendedCatalogProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedCatalogProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedCatalogProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedCatalogProductsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetRecommendedCatalogProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>(GetRecommendedCatalogProductsDocument, baseOptions);
      }
export function useGetRecommendedCatalogProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>(GetRecommendedCatalogProductsDocument, baseOptions);
        }
export type GetRecommendedCatalogProductsQueryHookResult = ReturnType<typeof useGetRecommendedCatalogProductsQuery>;
export type GetRecommendedCatalogProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedCatalogProductsLazyQuery>;
export type GetRecommendedCatalogProductsQueryResult = Apollo.QueryResult<GetRecommendedCatalogProductsQuery, GetRecommendedCatalogProductsQueryVariables>;
export const ProductHeroContentByCriteriaDocument = gql`
    query ProductHeroContentByCriteria($criteria: ProductHeroContentInputCriteria!) {
  productHeroContentByCriteria(criteria: $criteria) {
    ...ProductHeroContentFields
  }
}
    ${ProductHeroContentFieldsFragmentDoc}`;

/**
 * __useProductHeroContentByCriteriaQuery__
 *
 * To run a query within a React component, call `useProductHeroContentByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductHeroContentByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductHeroContentByCriteriaQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useProductHeroContentByCriteriaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>(ProductHeroContentByCriteriaDocument, baseOptions);
      }
export function useProductHeroContentByCriteriaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>(ProductHeroContentByCriteriaDocument, baseOptions);
        }
export type ProductHeroContentByCriteriaQueryHookResult = ReturnType<typeof useProductHeroContentByCriteriaQuery>;
export type ProductHeroContentByCriteriaLazyQueryHookResult = ReturnType<typeof useProductHeroContentByCriteriaLazyQuery>;
export type ProductHeroContentByCriteriaQueryResult = Apollo.QueryResult<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>;
export const GetCatalogRootCurationHeroHeaderDocument = gql`
    query GetCatalogRootCurationHeroHeader($eventId: ID, $storefront: CatalogStorefront) {
  recommendCatalogHomeSections(eventId: $eventId, storefront: $storefront) {
    id
    sections(limit: 1, offset: 0) {
      id
      displayType
      catalogEntities {
        ... on ProductCatalogEntityCuration {
          id
          __typename
          catalogCurationData {
            id
            videoUrl
            header {
              backgroundImage {
                id
                url
              }
              logoImage {
                id
                url
              }
              title
              eyebrow
              description
              video
              videoThumbnail {
                id
                url
              }
            }
            category {
              id
              title
              publicUrlPath
              thumbnail {
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCatalogRootCurationHeroHeaderQuery__
 *
 * To run a query within a React component, call `useGetCatalogRootCurationHeroHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogRootCurationHeroHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogRootCurationHeroHeaderQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetCatalogRootCurationHeroHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogRootCurationHeroHeaderQuery, GetCatalogRootCurationHeroHeaderQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCatalogRootCurationHeroHeaderQuery, GetCatalogRootCurationHeroHeaderQueryVariables>(GetCatalogRootCurationHeroHeaderDocument, baseOptions);
      }
export function useGetCatalogRootCurationHeroHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogRootCurationHeroHeaderQuery, GetCatalogRootCurationHeroHeaderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCatalogRootCurationHeroHeaderQuery, GetCatalogRootCurationHeroHeaderQueryVariables>(GetCatalogRootCurationHeroHeaderDocument, baseOptions);
        }
export type GetCatalogRootCurationHeroHeaderQueryHookResult = ReturnType<typeof useGetCatalogRootCurationHeroHeaderQuery>;
export type GetCatalogRootCurationHeroHeaderLazyQueryHookResult = ReturnType<typeof useGetCatalogRootCurationHeroHeaderLazyQuery>;
export type GetCatalogRootCurationHeroHeaderQueryResult = Apollo.QueryResult<GetCatalogRootCurationHeroHeaderQuery, GetCatalogRootCurationHeroHeaderQueryVariables>;
export const TransitionalRegistryDocument = gql`
    query TransitionalRegistry($id: ID!) {
  transitionalRegistry(id: $id) {
    ...ScannedTransitionalRegistryStatus
  }
}
    ${ScannedTransitionalRegistryStatusFragmentDoc}`;

/**
 * __useTransitionalRegistryQuery__
 *
 * To run a query within a React component, call `useTransitionalRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitionalRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitionalRegistryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransitionalRegistryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransitionalRegistryQuery, TransitionalRegistryQueryVariables>) {
        return ApolloReactHooks.useQuery<TransitionalRegistryQuery, TransitionalRegistryQueryVariables>(TransitionalRegistryDocument, baseOptions);
      }
export function useTransitionalRegistryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransitionalRegistryQuery, TransitionalRegistryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransitionalRegistryQuery, TransitionalRegistryQueryVariables>(TransitionalRegistryDocument, baseOptions);
        }
export type TransitionalRegistryQueryHookResult = ReturnType<typeof useTransitionalRegistryQuery>;
export type TransitionalRegistryLazyQueryHookResult = ReturnType<typeof useTransitionalRegistryLazyQuery>;
export type TransitionalRegistryQueryResult = Apollo.QueryResult<TransitionalRegistryQuery, TransitionalRegistryQueryVariables>;
export const CreateTransitionalRegistryDocument = gql`
    mutation CreateTransitionalRegistry($payload: CreateTransitionalRegistryPayload!) {
  createTransitionalRegistry(payload: $payload) {
    id
    name
    status
    scannedAt {
      dateString(dateFormat: long)
    }
  }
}
    `;
export type CreateTransitionalRegistryMutationFn = Apollo.MutationFunction<CreateTransitionalRegistryMutation, CreateTransitionalRegistryMutationVariables>;

/**
 * __useCreateTransitionalRegistryMutation__
 *
 * To run a mutation, you first call `useCreateTransitionalRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransitionalRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransitionalRegistryMutation, { data, loading, error }] = useCreateTransitionalRegistryMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateTransitionalRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTransitionalRegistryMutation, CreateTransitionalRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTransitionalRegistryMutation, CreateTransitionalRegistryMutationVariables>(CreateTransitionalRegistryDocument, baseOptions);
      }
export type CreateTransitionalRegistryMutationHookResult = ReturnType<typeof useCreateTransitionalRegistryMutation>;
export type CreateTransitionalRegistryMutationResult = Apollo.MutationResult<CreateTransitionalRegistryMutation>;
export type CreateTransitionalRegistryMutationOptions = Apollo.BaseMutationOptions<CreateTransitionalRegistryMutation, CreateTransitionalRegistryMutationVariables>;
export const CheckTransitionalRegistryUrlDocument = gql`
    query CheckTransitionalRegistryUrl($url: String!) {
  checkTransitionalRegistryUrl(url: $url) {
    ... on ValidTransitionalRegistryUrlResult {
      canonicalUrl
    }
    ... on InvalidTransitionalRegistryUrlResult {
      reasonCode
      message
    }
  }
}
    `;

/**
 * __useCheckTransitionalRegistryUrlQuery__
 *
 * To run a query within a React component, call `useCheckTransitionalRegistryUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTransitionalRegistryUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTransitionalRegistryUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckTransitionalRegistryUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckTransitionalRegistryUrlQuery, CheckTransitionalRegistryUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckTransitionalRegistryUrlQuery, CheckTransitionalRegistryUrlQueryVariables>(CheckTransitionalRegistryUrlDocument, baseOptions);
      }
export function useCheckTransitionalRegistryUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckTransitionalRegistryUrlQuery, CheckTransitionalRegistryUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckTransitionalRegistryUrlQuery, CheckTransitionalRegistryUrlQueryVariables>(CheckTransitionalRegistryUrlDocument, baseOptions);
        }
export type CheckTransitionalRegistryUrlQueryHookResult = ReturnType<typeof useCheckTransitionalRegistryUrlQuery>;
export type CheckTransitionalRegistryUrlLazyQueryHookResult = ReturnType<typeof useCheckTransitionalRegistryUrlLazyQuery>;
export type CheckTransitionalRegistryUrlQueryResult = Apollo.QueryResult<CheckTransitionalRegistryUrlQuery, CheckTransitionalRegistryUrlQueryVariables>;
export const TransitionalRegistryDetailsDocument = gql`
    query TransitionalRegistryDetails($id: ID!) {
  transitionalRegistry(id: $id) {
    ...TransitionalRegistryDetailsFields
  }
}
    ${TransitionalRegistryDetailsFieldsFragmentDoc}`;

/**
 * __useTransitionalRegistryDetailsQuery__
 *
 * To run a query within a React component, call `useTransitionalRegistryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitionalRegistryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitionalRegistryDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransitionalRegistryDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransitionalRegistryDetailsQuery, TransitionalRegistryDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<TransitionalRegistryDetailsQuery, TransitionalRegistryDetailsQueryVariables>(TransitionalRegistryDetailsDocument, baseOptions);
      }
export function useTransitionalRegistryDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransitionalRegistryDetailsQuery, TransitionalRegistryDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransitionalRegistryDetailsQuery, TransitionalRegistryDetailsQueryVariables>(TransitionalRegistryDetailsDocument, baseOptions);
        }
export type TransitionalRegistryDetailsQueryHookResult = ReturnType<typeof useTransitionalRegistryDetailsQuery>;
export type TransitionalRegistryDetailsLazyQueryHookResult = ReturnType<typeof useTransitionalRegistryDetailsLazyQuery>;
export type TransitionalRegistryDetailsQueryResult = Apollo.QueryResult<TransitionalRegistryDetailsQuery, TransitionalRegistryDetailsQueryVariables>;
export const TransferTransitionalRegistryItemsDocument = gql`
    mutation TransferTransitionalRegistryItems($payload: TransferTransitionalRegistryItemsPayload!) {
  transferTransitionalRegistryItems(payload: $payload) {
    id
  }
}
    `;
export type TransferTransitionalRegistryItemsMutationFn = Apollo.MutationFunction<TransferTransitionalRegistryItemsMutation, TransferTransitionalRegistryItemsMutationVariables>;

/**
 * __useTransferTransitionalRegistryItemsMutation__
 *
 * To run a mutation, you first call `useTransferTransitionalRegistryItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTransitionalRegistryItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTransitionalRegistryItemsMutation, { data, loading, error }] = useTransferTransitionalRegistryItemsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTransferTransitionalRegistryItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferTransitionalRegistryItemsMutation, TransferTransitionalRegistryItemsMutationVariables>) {
        return ApolloReactHooks.useMutation<TransferTransitionalRegistryItemsMutation, TransferTransitionalRegistryItemsMutationVariables>(TransferTransitionalRegistryItemsDocument, baseOptions);
      }
export type TransferTransitionalRegistryItemsMutationHookResult = ReturnType<typeof useTransferTransitionalRegistryItemsMutation>;
export type TransferTransitionalRegistryItemsMutationResult = Apollo.MutationResult<TransferTransitionalRegistryItemsMutation>;
export type TransferTransitionalRegistryItemsMutationOptions = Apollo.BaseMutationOptions<TransferTransitionalRegistryItemsMutation, TransferTransitionalRegistryItemsMutationVariables>;
export const TransitionalRegistriesForEventDocument = gql`
    query TransitionalRegistriesForEvent($eventId: String!) {
  transitionalRegistriesForEvent(eventId: $eventId) {
    ...TransitionalRegistry
  }
}
    ${TransitionalRegistryFragmentDoc}`;

/**
 * __useTransitionalRegistriesForEventQuery__
 *
 * To run a query within a React component, call `useTransitionalRegistriesForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitionalRegistriesForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitionalRegistriesForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useTransitionalRegistriesForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransitionalRegistriesForEventQuery, TransitionalRegistriesForEventQueryVariables>) {
        return ApolloReactHooks.useQuery<TransitionalRegistriesForEventQuery, TransitionalRegistriesForEventQueryVariables>(TransitionalRegistriesForEventDocument, baseOptions);
      }
export function useTransitionalRegistriesForEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransitionalRegistriesForEventQuery, TransitionalRegistriesForEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransitionalRegistriesForEventQuery, TransitionalRegistriesForEventQueryVariables>(TransitionalRegistriesForEventDocument, baseOptions);
        }
export type TransitionalRegistriesForEventQueryHookResult = ReturnType<typeof useTransitionalRegistriesForEventQuery>;
export type TransitionalRegistriesForEventLazyQueryHookResult = ReturnType<typeof useTransitionalRegistriesForEventLazyQuery>;
export type TransitionalRegistriesForEventQueryResult = Apollo.QueryResult<TransitionalRegistriesForEventQuery, TransitionalRegistriesForEventQueryVariables>;
export const DeleteTransitionalRegistryDocument = gql`
    mutation DeleteTransitionalRegistry($deleteTransitionalRegistryId: ID!) {
  deleteTransitionalRegistry(id: $deleteTransitionalRegistryId)
}
    `;
export type DeleteTransitionalRegistryMutationFn = Apollo.MutationFunction<DeleteTransitionalRegistryMutation, DeleteTransitionalRegistryMutationVariables>;

/**
 * __useDeleteTransitionalRegistryMutation__
 *
 * To run a mutation, you first call `useDeleteTransitionalRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransitionalRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransitionalRegistryMutation, { data, loading, error }] = useDeleteTransitionalRegistryMutation({
 *   variables: {
 *      deleteTransitionalRegistryId: // value for 'deleteTransitionalRegistryId'
 *   },
 * });
 */
export function useDeleteTransitionalRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTransitionalRegistryMutation, DeleteTransitionalRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTransitionalRegistryMutation, DeleteTransitionalRegistryMutationVariables>(DeleteTransitionalRegistryDocument, baseOptions);
      }
export type DeleteTransitionalRegistryMutationHookResult = ReturnType<typeof useDeleteTransitionalRegistryMutation>;
export type DeleteTransitionalRegistryMutationResult = Apollo.MutationResult<DeleteTransitionalRegistryMutation>;
export type DeleteTransitionalRegistryMutationOptions = Apollo.BaseMutationOptions<DeleteTransitionalRegistryMutation, DeleteTransitionalRegistryMutationVariables>;
export const GetRegistryChecklistDocument = gql`
    query GetRegistryChecklist($eventId: ID!) {
  getRegistryChecklist(eventId: $eventId) {
    ...RegistryChecklist
  }
}
    ${RegistryChecklistFragmentDoc}`;

/**
 * __useGetRegistryChecklistQuery__
 *
 * To run a query within a React component, call `useGetRegistryChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryChecklistQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryChecklistQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryChecklistQuery, GetRegistryChecklistQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryChecklistQuery, GetRegistryChecklistQueryVariables>(GetRegistryChecklistDocument, baseOptions);
      }
export function useGetRegistryChecklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryChecklistQuery, GetRegistryChecklistQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryChecklistQuery, GetRegistryChecklistQueryVariables>(GetRegistryChecklistDocument, baseOptions);
        }
export type GetRegistryChecklistQueryHookResult = ReturnType<typeof useGetRegistryChecklistQuery>;
export type GetRegistryChecklistLazyQueryHookResult = ReturnType<typeof useGetRegistryChecklistLazyQuery>;
export type GetRegistryChecklistQueryResult = Apollo.QueryResult<GetRegistryChecklistQuery, GetRegistryChecklistQueryVariables>;
export const GetRegistryChecklistSectionByIdDocument = gql`
    query GetRegistryChecklistSectionById($id: ID!) {
  getRegistryChecklistSectionById(id: $id) {
    id
    checklistItems {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;

/**
 * __useGetRegistryChecklistSectionByIdQuery__
 *
 * To run a query within a React component, call `useGetRegistryChecklistSectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryChecklistSectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryChecklistSectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegistryChecklistSectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryChecklistSectionByIdQuery, GetRegistryChecklistSectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryChecklistSectionByIdQuery, GetRegistryChecklistSectionByIdQueryVariables>(GetRegistryChecklistSectionByIdDocument, baseOptions);
      }
export function useGetRegistryChecklistSectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryChecklistSectionByIdQuery, GetRegistryChecklistSectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryChecklistSectionByIdQuery, GetRegistryChecklistSectionByIdQueryVariables>(GetRegistryChecklistSectionByIdDocument, baseOptions);
        }
export type GetRegistryChecklistSectionByIdQueryHookResult = ReturnType<typeof useGetRegistryChecklistSectionByIdQuery>;
export type GetRegistryChecklistSectionByIdLazyQueryHookResult = ReturnType<typeof useGetRegistryChecklistSectionByIdLazyQuery>;
export type GetRegistryChecklistSectionByIdQueryResult = Apollo.QueryResult<GetRegistryChecklistSectionByIdQuery, GetRegistryChecklistSectionByIdQueryVariables>;
export const CreateRegistryChecklistFromTemplateDocument = gql`
    mutation CreateRegistryChecklistFromTemplate($payload: CreateRegistryChecklistPayload!) {
  createRegistryChecklistFromTemplate(payload: $payload) {
    ...RegistryChecklist
  }
}
    ${RegistryChecklistFragmentDoc}`;
export type CreateRegistryChecklistFromTemplateMutationFn = Apollo.MutationFunction<CreateRegistryChecklistFromTemplateMutation, CreateRegistryChecklistFromTemplateMutationVariables>;

/**
 * __useCreateRegistryChecklistFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateRegistryChecklistFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryChecklistFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryChecklistFromTemplateMutation, { data, loading, error }] = useCreateRegistryChecklistFromTemplateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryChecklistFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryChecklistFromTemplateMutation, CreateRegistryChecklistFromTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryChecklistFromTemplateMutation, CreateRegistryChecklistFromTemplateMutationVariables>(CreateRegistryChecklistFromTemplateDocument, baseOptions);
      }
export type CreateRegistryChecklistFromTemplateMutationHookResult = ReturnType<typeof useCreateRegistryChecklistFromTemplateMutation>;
export type CreateRegistryChecklistFromTemplateMutationResult = Apollo.MutationResult<CreateRegistryChecklistFromTemplateMutation>;
export type CreateRegistryChecklistFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateRegistryChecklistFromTemplateMutation, CreateRegistryChecklistFromTemplateMutationVariables>;
export const UpdateRegistryChecklistItemDocument = gql`
    mutation UpdateRegistryChecklistItem($id: ID!, $payload: UpdateRegistryChecklistItemPayload!) {
  updateRegistryChecklistItem(id: $id, payload: $payload) {
    id
    isChecked
    isCheckable
  }
}
    `;
export type UpdateRegistryChecklistItemMutationFn = Apollo.MutationFunction<UpdateRegistryChecklistItemMutation, UpdateRegistryChecklistItemMutationVariables>;

/**
 * __useUpdateRegistryChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryChecklistItemMutation, { data, loading, error }] = useUpdateRegistryChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryChecklistItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryChecklistItemMutation, UpdateRegistryChecklistItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryChecklistItemMutation, UpdateRegistryChecklistItemMutationVariables>(UpdateRegistryChecklistItemDocument, baseOptions);
      }
export type UpdateRegistryChecklistItemMutationHookResult = ReturnType<typeof useUpdateRegistryChecklistItemMutation>;
export type UpdateRegistryChecklistItemMutationResult = Apollo.MutationResult<UpdateRegistryChecklistItemMutation>;
export type UpdateRegistryChecklistItemMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryChecklistItemMutation, UpdateRegistryChecklistItemMutationVariables>;
export const RegistryGiftBasketCountByEventNameDocument = gql`
    query RegistryGiftBasketCountByEventName($handle: String!) {
  eventByName(name: $handle) {
    id
    website
    registry {
      id
      checklist {
        id
      }
      items {
        id
        totalRequested
        isGroupGiftingEnabled
        isHidden
        productData {
          price {
            valueInMinorUnits
          }
          registryItem {
            id
          }
        }
        fpIndex
        createAt {
          milliseconds
        }
      }
      orders {
        id
        orderedAt {
          timestamp
          milliseconds
        }
        lineItems {
          locator
          registryItem {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryGiftBasketCountByEventNameQuery__
 *
 * To run a query within a React component, call `useRegistryGiftBasketCountByEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryGiftBasketCountByEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryGiftBasketCountByEventNameQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useRegistryGiftBasketCountByEventNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryGiftBasketCountByEventNameQuery, RegistryGiftBasketCountByEventNameQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryGiftBasketCountByEventNameQuery, RegistryGiftBasketCountByEventNameQueryVariables>(RegistryGiftBasketCountByEventNameDocument, baseOptions);
      }
export function useRegistryGiftBasketCountByEventNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryGiftBasketCountByEventNameQuery, RegistryGiftBasketCountByEventNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryGiftBasketCountByEventNameQuery, RegistryGiftBasketCountByEventNameQueryVariables>(RegistryGiftBasketCountByEventNameDocument, baseOptions);
        }
export type RegistryGiftBasketCountByEventNameQueryHookResult = ReturnType<typeof useRegistryGiftBasketCountByEventNameQuery>;
export type RegistryGiftBasketCountByEventNameLazyQueryHookResult = ReturnType<typeof useRegistryGiftBasketCountByEventNameLazyQuery>;
export type RegistryGiftBasketCountByEventNameQueryResult = Apollo.QueryResult<RegistryGiftBasketCountByEventNameQuery, RegistryGiftBasketCountByEventNameQueryVariables>;
export const RegistryGiftBasketOrdersByIdsDocument = gql`
    query RegistryGiftBasketOrdersByIds($ids: [ID!]!) {
  registryOrdersByIds(ids: $ids) {
    id
    isDropship
    isPurchased
    email
    name
    orderedAt {
      timestamp
      milliseconds
    }
    fulfillment {
      status
    }
    lineItems {
      locator
      quantity
      registryItem {
        id
      }
      lineItemData {
        correctedQuantity
      }
      frozenProductData {
        title
        photos {
          id
          url
        }
        customType
        price {
          currency {
            id
            code
          }
          valueInMinorUnits
          floatingPointDecimalString
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryGiftBasketOrdersByIdsQuery__
 *
 * To run a query within a React component, call `useRegistryGiftBasketOrdersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryGiftBasketOrdersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryGiftBasketOrdersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRegistryGiftBasketOrdersByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryGiftBasketOrdersByIdsQuery, RegistryGiftBasketOrdersByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryGiftBasketOrdersByIdsQuery, RegistryGiftBasketOrdersByIdsQueryVariables>(RegistryGiftBasketOrdersByIdsDocument, baseOptions);
      }
export function useRegistryGiftBasketOrdersByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryGiftBasketOrdersByIdsQuery, RegistryGiftBasketOrdersByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryGiftBasketOrdersByIdsQuery, RegistryGiftBasketOrdersByIdsQueryVariables>(RegistryGiftBasketOrdersByIdsDocument, baseOptions);
        }
export type RegistryGiftBasketOrdersByIdsQueryHookResult = ReturnType<typeof useRegistryGiftBasketOrdersByIdsQuery>;
export type RegistryGiftBasketOrdersByIdsLazyQueryHookResult = ReturnType<typeof useRegistryGiftBasketOrdersByIdsLazyQuery>;
export type RegistryGiftBasketOrdersByIdsQueryResult = Apollo.QueryResult<RegistryGiftBasketOrdersByIdsQuery, RegistryGiftBasketOrdersByIdsQueryVariables>;
export const RegistryGiftBasketItemsByIdsDocument = gql`
    query RegistryGiftBasketItemsByIds($ids: [ID!]!) {
  registryItemsByIds(ids: $ids) {
    id
    fpIndex
    storeName
    totalRequested
    externallyOwned
    donationFund {
      id
      goalMonetaryValue {
        floatingPointDecimalString
        valueInMinorUnits
      }
      currency {
        id
        code
      }
    }
    productData {
      title
      customType
      photos {
        id
        url
      }
      registryItem {
        id
      }
      price: priceAugmented {
        currency {
          id
          code
        }
        valueInMinorUnits
        floatingPointDecimalString
      }
    }
  }
}
    `;

/**
 * __useRegistryGiftBasketItemsByIdsQuery__
 *
 * To run a query within a React component, call `useRegistryGiftBasketItemsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryGiftBasketItemsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryGiftBasketItemsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRegistryGiftBasketItemsByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryGiftBasketItemsByIdsQuery, RegistryGiftBasketItemsByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryGiftBasketItemsByIdsQuery, RegistryGiftBasketItemsByIdsQueryVariables>(RegistryGiftBasketItemsByIdsDocument, baseOptions);
      }
export function useRegistryGiftBasketItemsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryGiftBasketItemsByIdsQuery, RegistryGiftBasketItemsByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryGiftBasketItemsByIdsQuery, RegistryGiftBasketItemsByIdsQueryVariables>(RegistryGiftBasketItemsByIdsDocument, baseOptions);
        }
export type RegistryGiftBasketItemsByIdsQueryHookResult = ReturnType<typeof useRegistryGiftBasketItemsByIdsQuery>;
export type RegistryGiftBasketItemsByIdsLazyQueryHookResult = ReturnType<typeof useRegistryGiftBasketItemsByIdsLazyQuery>;
export type RegistryGiftBasketItemsByIdsQueryResult = Apollo.QueryResult<RegistryGiftBasketItemsByIdsQuery, RegistryGiftBasketItemsByIdsQueryVariables>;
export const SetGuestCountDocument = gql`
    mutation SetGuestCount($eventId: String!, $payload: RecommendRegistryOnboardingSurveyPayload!) {
  updateRecommendRegistryOnboardingSurvey(eventId: $eventId, payload: $payload) {
    id
    lastUpdatedAt {
      milliseconds
    }
    guestCount
  }
}
    `;
export type SetGuestCountMutationFn = Apollo.MutationFunction<SetGuestCountMutation, SetGuestCountMutationVariables>;

/**
 * __useSetGuestCountMutation__
 *
 * To run a mutation, you first call `useSetGuestCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGuestCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGuestCountMutation, { data, loading, error }] = useSetGuestCountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetGuestCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetGuestCountMutation, SetGuestCountMutationVariables>) {
        return ApolloReactHooks.useMutation<SetGuestCountMutation, SetGuestCountMutationVariables>(SetGuestCountDocument, baseOptions);
      }
export type SetGuestCountMutationHookResult = ReturnType<typeof useSetGuestCountMutation>;
export type SetGuestCountMutationResult = Apollo.MutationResult<SetGuestCountMutation>;
export type SetGuestCountMutationOptions = Apollo.BaseMutationOptions<SetGuestCountMutation, SetGuestCountMutationVariables>;
export const GetRegistryRecommendationResultsDocument = gql`
    query GetRegistryRecommendationResults($handle: String!) {
  eventByName(name: $handle) {
    id
    recommendation {
      registryAdvisor {
        ...RegistryAdvisor
      }
    }
  }
}
    ${RegistryAdvisorFragmentDoc}`;

/**
 * __useGetRegistryRecommendationResultsQuery__
 *
 * To run a query within a React component, call `useGetRegistryRecommendationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryRecommendationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryRecommendationResultsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetRegistryRecommendationResultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryRecommendationResultsQuery, GetRegistryRecommendationResultsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryRecommendationResultsQuery, GetRegistryRecommendationResultsQueryVariables>(GetRegistryRecommendationResultsDocument, baseOptions);
      }
export function useGetRegistryRecommendationResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryRecommendationResultsQuery, GetRegistryRecommendationResultsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryRecommendationResultsQuery, GetRegistryRecommendationResultsQueryVariables>(GetRegistryRecommendationResultsDocument, baseOptions);
        }
export type GetRegistryRecommendationResultsQueryHookResult = ReturnType<typeof useGetRegistryRecommendationResultsQuery>;
export type GetRegistryRecommendationResultsLazyQueryHookResult = ReturnType<typeof useGetRegistryRecommendationResultsLazyQuery>;
export type GetRegistryRecommendationResultsQueryResult = Apollo.QueryResult<GetRegistryRecommendationResultsQuery, GetRegistryRecommendationResultsQueryVariables>;
export const GetRegistryGuideCompletionPercentageDocument = gql`
    query GetRegistryGuideCompletionPercentage($handle: String!) {
  eventByName(name: $handle) {
    id
    recommendation {
      registryAdvisor {
        targetGiftCount
        currentGiftCount
      }
    }
  }
}
    `;

/**
 * __useGetRegistryGuideCompletionPercentageQuery__
 *
 * To run a query within a React component, call `useGetRegistryGuideCompletionPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryGuideCompletionPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryGuideCompletionPercentageQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetRegistryGuideCompletionPercentageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryGuideCompletionPercentageQuery, GetRegistryGuideCompletionPercentageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryGuideCompletionPercentageQuery, GetRegistryGuideCompletionPercentageQueryVariables>(GetRegistryGuideCompletionPercentageDocument, baseOptions);
      }
export function useGetRegistryGuideCompletionPercentageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryGuideCompletionPercentageQuery, GetRegistryGuideCompletionPercentageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryGuideCompletionPercentageQuery, GetRegistryGuideCompletionPercentageQueryVariables>(GetRegistryGuideCompletionPercentageDocument, baseOptions);
        }
export type GetRegistryGuideCompletionPercentageQueryHookResult = ReturnType<typeof useGetRegistryGuideCompletionPercentageQuery>;
export type GetRegistryGuideCompletionPercentageLazyQueryHookResult = ReturnType<typeof useGetRegistryGuideCompletionPercentageLazyQuery>;
export type GetRegistryGuideCompletionPercentageQueryResult = Apollo.QueryResult<GetRegistryGuideCompletionPercentageQuery, GetRegistryGuideCompletionPercentageQueryVariables>;
export const GetRegistryDataDocument = gql`
    query GetRegistryData($eventHandle: String!, $withGuestSiteData: Boolean!, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      id
      firebaseId @include(if: $withGuestSiteData)
      eventDesign(purpose: $eventDesignPurpose) {
        ...EventDesign
      }
      info {
        id
        eventDisplayName
        timezone
        finalizedDate {
          ...Date
        }
      }
      ...RegistryShippingAddressFragment
      ...DonationFundInfoFragment
      pages: pages(admin: true) {
        ...EventPage
      }
      welcomePage: pages(type: welcome) {
        ...EventPage
      }
      registry {
        id
        event {
          id
        }
        summary {
          lastSyncAt {
            timestamp
          }
          cannotSync
        }
        currency {
          ...EventRegistryCurrency
        }
      }
      eventUsers {
        id
        status
      }
    }
  }
}
    ${EventDesignFragmentDoc}
${DateFragmentDoc}
${RegistryShippingAddressFragmentFragmentDoc}
${DonationFundInfoFragmentFragmentDoc}
${EventPageFragmentDoc}
${EventRegistryCurrencyFragmentDoc}`;

/**
 * __useGetRegistryDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      withGuestSiteData: // value for 'withGuestSiteData'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGetRegistryDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryDataQuery, GetRegistryDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryDataQuery, GetRegistryDataQueryVariables>(GetRegistryDataDocument, baseOptions);
      }
export function useGetRegistryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryDataQuery, GetRegistryDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryDataQuery, GetRegistryDataQueryVariables>(GetRegistryDataDocument, baseOptions);
        }
export type GetRegistryDataQueryHookResult = ReturnType<typeof useGetRegistryDataQuery>;
export type GetRegistryDataLazyQueryHookResult = ReturnType<typeof useGetRegistryDataLazyQuery>;
export type GetRegistryDataQueryResult = Apollo.QueryResult<GetRegistryDataQuery, GetRegistryDataQueryVariables>;
export const GuestEventDetailsByNameDocument = gql`
    query GuestEventDetailsByName($eventHandle: String!, $pageType: EventPageType, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      eventType
      fianceeFirstName
      eventDisplayName
      ownerFirstName
      ownerLastName
    }
    eventDesign(purpose: $eventDesignPurpose) {
      ...EventDesign
    }
    pages {
      id
      disabled
      type
      pageSlug
    }
    photo {
      id
      url
    }
    photoV2Url
    pageInfo(type: $pageType) {
      id
      page {
        id
        photoV2 {
          ... on Photo {
            id
            url
          }
          ... on DefaultPagePhoto {
            id
            url
          }
        }
      }
    }
    website
  }
}
    ${EventDesignFragmentDoc}`;

/**
 * __useGuestEventDetailsByNameQuery__
 *
 * To run a query within a React component, call `useGuestEventDetailsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestEventDetailsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestEventDetailsByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      pageType: // value for 'pageType'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGuestEventDetailsByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestEventDetailsByNameQuery, GuestEventDetailsByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestEventDetailsByNameQuery, GuestEventDetailsByNameQueryVariables>(GuestEventDetailsByNameDocument, baseOptions);
      }
export function useGuestEventDetailsByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestEventDetailsByNameQuery, GuestEventDetailsByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestEventDetailsByNameQuery, GuestEventDetailsByNameQueryVariables>(GuestEventDetailsByNameDocument, baseOptions);
        }
export type GuestEventDetailsByNameQueryHookResult = ReturnType<typeof useGuestEventDetailsByNameQuery>;
export type GuestEventDetailsByNameLazyQueryHookResult = ReturnType<typeof useGuestEventDetailsByNameLazyQuery>;
export type GuestEventDetailsByNameQueryResult = Apollo.QueryResult<GuestEventDetailsByNameQuery, GuestEventDetailsByNameQueryVariables>;
export const GetCheckoutDialogDataDocument = gql`
    query GetCheckoutDialogData($registryItemId: ID!, $registryOrderId: ID!, $skipDonationOrder: Boolean!, $skipOrderQuery: Boolean!, $isAffiliate: Boolean!) {
  registryItem(id: $registryItemId) {
    id
    note
    storeName
    isGroupGiftingEnabled
    createAt {
      milliseconds
    }
    stillNeeded
    mustHave
    totalRequested
    productData {
      brand
      registryItem {
        id
      }
      title
      externalUrl
      checkoutUrl
      price {
        floatingPointDecimalString
        valueInMinorUnits
        currency {
          code
          places
        }
      }
      photos {
        url
        id
      }
      customType
    }
    donationFund @skip(if: $isAffiliate) {
      id
      description
      fundType
      platform {
        id
        name
        username
        link
        type
      }
      currency {
        id
        code
        places
      }
      enableCashOrCheck
      enableAppPlatform
      enableJoyCredit
      enforceSuggestedDonationAmount
      donationsAreCapped
      hideFundingGoal
      suggestedDonationMonetaryValue {
        currency {
          code
          places
        }
        valueInMinorUnits
        floatingPointDecimalString
      }
      suggestedQuantityStillNeeded
      goalMonetaryValue {
        valueInMinorUnits
        floatingPointDecimalString
        currency {
          code
          places
        }
      }
      donations {
        id
        amount {
          valueInMinorUnits
        }
      }
      progressToGoal {
        valueInMinorUnits
        floatingPointDecimalString
      }
    }
  }
  orderMetadata: registryOrderById(id: $registryOrderId) @skip(if: $skipOrderQuery) {
    id
    isPurchased
  }
  order: getDonationFundDonationById(id: $registryOrderId) @skip(if: $skipDonationOrder) {
    id
    fund {
      id
    }
    platformType
    name
    email
    note
    amount {
      floatingPointDecimalString
      valueInMinorUnits
    }
  }
  registryOrder: registryOrderById(id: $registryOrderId) @skip(if: $skipOrderQuery) {
    id
    name
    email
    note
    lineItems {
      quantity
      locator
    }
  }
}
    `;

/**
 * __useGetCheckoutDialogDataQuery__
 *
 * To run a query within a React component, call `useGetCheckoutDialogDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutDialogDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutDialogDataQuery({
 *   variables: {
 *      registryItemId: // value for 'registryItemId'
 *      registryOrderId: // value for 'registryOrderId'
 *      skipDonationOrder: // value for 'skipDonationOrder'
 *      skipOrderQuery: // value for 'skipOrderQuery'
 *      isAffiliate: // value for 'isAffiliate'
 *   },
 * });
 */
export function useGetCheckoutDialogDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCheckoutDialogDataQuery, GetCheckoutDialogDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCheckoutDialogDataQuery, GetCheckoutDialogDataQueryVariables>(GetCheckoutDialogDataDocument, baseOptions);
      }
export function useGetCheckoutDialogDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCheckoutDialogDataQuery, GetCheckoutDialogDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCheckoutDialogDataQuery, GetCheckoutDialogDataQueryVariables>(GetCheckoutDialogDataDocument, baseOptions);
        }
export type GetCheckoutDialogDataQueryHookResult = ReturnType<typeof useGetCheckoutDialogDataQuery>;
export type GetCheckoutDialogDataLazyQueryHookResult = ReturnType<typeof useGetCheckoutDialogDataLazyQuery>;
export type GetCheckoutDialogDataQueryResult = Apollo.QueryResult<GetCheckoutDialogDataQuery, GetCheckoutDialogDataQueryVariables>;
export const GuestSiteNavBarDocument = gql`
    query GuestSiteNavBar($eventHandle: String!, $eventDesignPurpose: EventDesignPurpose!) {
  eventByName(name: $eventHandle) {
    id
    pages {
      id
      type
      pageSlug
      pageTitle
    }
    activeSession {
      ...EventSessionGuestSite
    }
    info(admin: true) {
      ...EventInfoFragment
    }
    eventDesign(purpose: $eventDesignPurpose) {
      ...EventDesign
    }
  }
}
    ${EventSessionGuestSiteFragmentDoc}
${EventInfoFragmentFragmentDoc}
${EventDesignFragmentDoc}`;

/**
 * __useGuestSiteNavBarQuery__
 *
 * To run a query within a React component, call `useGuestSiteNavBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestSiteNavBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestSiteNavBarQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGuestSiteNavBarQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestSiteNavBarQuery, GuestSiteNavBarQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestSiteNavBarQuery, GuestSiteNavBarQueryVariables>(GuestSiteNavBarDocument, baseOptions);
      }
export function useGuestSiteNavBarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestSiteNavBarQuery, GuestSiteNavBarQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestSiteNavBarQuery, GuestSiteNavBarQueryVariables>(GuestSiteNavBarDocument, baseOptions);
        }
export type GuestSiteNavBarQueryHookResult = ReturnType<typeof useGuestSiteNavBarQuery>;
export type GuestSiteNavBarLazyQueryHookResult = ReturnType<typeof useGuestSiteNavBarLazyQuery>;
export type GuestSiteNavBarQueryResult = Apollo.QueryResult<GuestSiteNavBarQuery, GuestSiteNavBarQueryVariables>;
export const GetEventRegistriesAndOrdersDocument = gql`
    query GetEventRegistriesAndOrders($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      id
      info {
        id
        registry {
          ...Registry
        }
      }
      registry {
        id
        event {
          id
        }
        orders {
          ...RegistryOrder
        }
      }
    }
  }
}
    ${RegistryFragmentDoc}
${RegistryOrderFragmentDoc}`;

/**
 * __useGetEventRegistriesAndOrdersQuery__
 *
 * To run a query within a React component, call `useGetEventRegistriesAndOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventRegistriesAndOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventRegistriesAndOrdersQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventRegistriesAndOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventRegistriesAndOrdersQuery, GetEventRegistriesAndOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventRegistriesAndOrdersQuery, GetEventRegistriesAndOrdersQueryVariables>(GetEventRegistriesAndOrdersDocument, baseOptions);
      }
export function useGetEventRegistriesAndOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventRegistriesAndOrdersQuery, GetEventRegistriesAndOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventRegistriesAndOrdersQuery, GetEventRegistriesAndOrdersQueryVariables>(GetEventRegistriesAndOrdersDocument, baseOptions);
        }
export type GetEventRegistriesAndOrdersQueryHookResult = ReturnType<typeof useGetEventRegistriesAndOrdersQuery>;
export type GetEventRegistriesAndOrdersLazyQueryHookResult = ReturnType<typeof useGetEventRegistriesAndOrdersLazyQuery>;
export type GetEventRegistriesAndOrdersQueryResult = Apollo.QueryResult<GetEventRegistriesAndOrdersQuery, GetEventRegistriesAndOrdersQueryVariables>;
export const GetRegistryPageIdDocument = gql`
    query GetRegistryPageId($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    registryPage: pages(type: registry, admin: true) {
      id
    }
  }
}
    `;

/**
 * __useGetRegistryPageIdQuery__
 *
 * To run a query within a React component, call `useGetRegistryPageIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPageIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPageIdQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryPageIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPageIdQuery, GetRegistryPageIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryPageIdQuery, GetRegistryPageIdQueryVariables>(GetRegistryPageIdDocument, baseOptions);
      }
export function useGetRegistryPageIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPageIdQuery, GetRegistryPageIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryPageIdQuery, GetRegistryPageIdQueryVariables>(GetRegistryPageIdDocument, baseOptions);
        }
export type GetRegistryPageIdQueryHookResult = ReturnType<typeof useGetRegistryPageIdQuery>;
export type GetRegistryPageIdLazyQueryHookResult = ReturnType<typeof useGetRegistryPageIdLazyQuery>;
export type GetRegistryPageIdQueryResult = Apollo.QueryResult<GetRegistryPageIdQuery, GetRegistryPageIdQueryVariables>;
export const AccommodationsConsolePropertiesDocument = gql`
    query AccommodationsConsoleProperties($payload: AccommodationContentSearchInput!) {
  searchAccommodationProperties(payload: $payload) {
    properties {
      ...AccommodationConsoleListingProperty
    }
  }
}
    ${AccommodationConsoleListingPropertyFragmentDoc}`;

/**
 * __useAccommodationsConsolePropertiesQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsolePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsolePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsolePropertiesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsolePropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>(AccommodationsConsolePropertiesDocument, baseOptions);
      }
export function useAccommodationsConsolePropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>(AccommodationsConsolePropertiesDocument, baseOptions);
        }
export type AccommodationsConsolePropertiesQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesQuery>;
export type AccommodationsConsolePropertiesLazyQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesLazyQuery>;
export type AccommodationsConsolePropertiesQueryResult = Apollo.QueryResult<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>;
export const AccommodationPlacesByCoupleDocument = gql`
    query AccommodationPlacesByCouple($name: String!) {
  eventByName(name: $name) {
    __typename
    id
    accommodationPlacesV2 {
      id
      joyPlaceId
      isFromAccommodationCatalog
      isFavorite
      isHostStayingHere
      userNote
      phone
      lat
      long
      name
      customName
      address
      city
      country
      postalCode
      state
      starRating
      url
      description
      type
      photo {
        id
        url
      }
      customPhoto {
        id
        url
      }
      accommodationRoomBlock {
        bookingUrl
        checkInDate
        checkOutDate
        cutoffDate
        currencyCode
        isJoyManagedRoomBlock
        numberOfRoomsReserved
        interestedGuestCount
        status
        pricePerNight
        strikeoutPricePerNight
      }
    }
  }
}
    `;

/**
 * __useAccommodationPlacesByCoupleQuery__
 *
 * To run a query within a React component, call `useAccommodationPlacesByCoupleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPlacesByCoupleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPlacesByCoupleQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationPlacesByCoupleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>(AccommodationPlacesByCoupleDocument, baseOptions);
      }
export function useAccommodationPlacesByCoupleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>(AccommodationPlacesByCoupleDocument, baseOptions);
        }
export type AccommodationPlacesByCoupleQueryHookResult = ReturnType<typeof useAccommodationPlacesByCoupleQuery>;
export type AccommodationPlacesByCoupleLazyQueryHookResult = ReturnType<typeof useAccommodationPlacesByCoupleLazyQuery>;
export type AccommodationPlacesByCoupleQueryResult = Apollo.QueryResult<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>;
export const AccommodationsConsoleStateInitializationDocument = gql`
    query AccommodationsConsoleStateInitialization($name: String!) {
  eventByName(name: $name) {
    id
    travelSettings {
      checkInDate
      checkOutDate
    }
    info {
      id
      finalizedDate {
        dateString
      }
    }
    bestLocationAnchor {
      friendlyName
      latitude
      longitude
      source
    }
  }
}
    `;

/**
 * __useAccommodationsConsoleStateInitializationQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsoleStateInitializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsoleStateInitializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsoleStateInitializationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationsConsoleStateInitializationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>(AccommodationsConsoleStateInitializationDocument, baseOptions);
      }
export function useAccommodationsConsoleStateInitializationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>(AccommodationsConsoleStateInitializationDocument, baseOptions);
        }
export type AccommodationsConsoleStateInitializationQueryHookResult = ReturnType<typeof useAccommodationsConsoleStateInitializationQuery>;
export type AccommodationsConsoleStateInitializationLazyQueryHookResult = ReturnType<typeof useAccommodationsConsoleStateInitializationLazyQuery>;
export type AccommodationsConsoleStateInitializationQueryResult = Apollo.QueryResult<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>;
export const AccommodationsConsolePropertiesV2Document = gql`
    query AccommodationsConsolePropertiesV2($payload: SearchExtendedAccommodationPropertiesV2Payload!) {
  searchExtendedAccommodationProperties: searchExtendedAccommodationPropertiesV2(payload: $payload) {
    properties {
      ...AccommodationCatalogConsoleListingProperty
      score
      pricingInfo {
        ...AccommodationCatalogConsoleListingPricing
      }
      redirectMechanisms {
        ...AccommodationCatalogConsoleListingRedirectMechanisms
      }
    }
  }
}
    ${AccommodationCatalogConsoleListingPropertyFragmentDoc}
${AccommodationCatalogConsoleListingPricingFragmentDoc}
${AccommodationCatalogConsoleListingRedirectMechanismsFragmentDoc}`;

/**
 * __useAccommodationsConsolePropertiesV2Query__
 *
 * To run a query within a React component, call `useAccommodationsConsolePropertiesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsolePropertiesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsolePropertiesV2Query({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsolePropertiesV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>(AccommodationsConsolePropertiesV2Document, baseOptions);
      }
export function useAccommodationsConsolePropertiesV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>(AccommodationsConsolePropertiesV2Document, baseOptions);
        }
export type AccommodationsConsolePropertiesV2QueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesV2Query>;
export type AccommodationsConsolePropertiesV2LazyQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesV2LazyQuery>;
export type AccommodationsConsolePropertiesV2QueryResult = Apollo.QueryResult<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>;
export const AccommodationsConsoleHotelsSortOrderDocument = gql`
    query AccommodationsConsoleHotelsSortOrder($payload: PageContainerBySlugPayload!) {
  pageContainerBySlug(payload: $payload) {
    components {
      ... on TravelMapComponent {
        id
        type
        sortOrder
        blockOrdering
      }
    }
    id
  }
}
    `;

/**
 * __useAccommodationsConsoleHotelsSortOrderQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsoleHotelsSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsoleHotelsSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsoleHotelsSortOrderQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsoleHotelsSortOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>(AccommodationsConsoleHotelsSortOrderDocument, baseOptions);
      }
export function useAccommodationsConsoleHotelsSortOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>(AccommodationsConsoleHotelsSortOrderDocument, baseOptions);
        }
export type AccommodationsConsoleHotelsSortOrderQueryHookResult = ReturnType<typeof useAccommodationsConsoleHotelsSortOrderQuery>;
export type AccommodationsConsoleHotelsSortOrderLazyQueryHookResult = ReturnType<typeof useAccommodationsConsoleHotelsSortOrderLazyQuery>;
export type AccommodationsConsoleHotelsSortOrderQueryResult = Apollo.QueryResult<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>;
export const AccommodationPlacesPricingAndBookingDetailsDocument = gql`
    query AccommodationPlacesPricingAndBookingDetails($payload: TravelPlacePricingAndBookingDetailsPayload!) {
  travelPlacesPricingAndBookingDetails(payload: $payload) {
    accommodationPlaces {
      ...TravelPlacePricingAndBookingDetails
    }
  }
}
    ${TravelPlacePricingAndBookingDetailsFragmentDoc}`;

/**
 * __useAccommodationPlacesPricingAndBookingDetailsQuery__
 *
 * To run a query within a React component, call `useAccommodationPlacesPricingAndBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPlacesPricingAndBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPlacesPricingAndBookingDetailsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPlacesPricingAndBookingDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>(AccommodationPlacesPricingAndBookingDetailsDocument, baseOptions);
      }
export function useAccommodationPlacesPricingAndBookingDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>(AccommodationPlacesPricingAndBookingDetailsDocument, baseOptions);
        }
export type AccommodationPlacesPricingAndBookingDetailsQueryHookResult = ReturnType<typeof useAccommodationPlacesPricingAndBookingDetailsQuery>;
export type AccommodationPlacesPricingAndBookingDetailsLazyQueryHookResult = ReturnType<typeof useAccommodationPlacesPricingAndBookingDetailsLazyQuery>;
export type AccommodationPlacesPricingAndBookingDetailsQueryResult = Apollo.QueryResult<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>;
export const HotelImagesDocument = gql`
    query HotelImages($payload: HotelInventoryByIdsRequest!) {
  hotelImages(payload: $payload) {
    __typename
    hotelId
    images {
      __typename
      imageName
      thumbnailUrl
      url
    }
  }
}
    `;

/**
 * __useHotelImagesQuery__
 *
 * To run a query within a React component, call `useHotelImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelImagesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useHotelImagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelImagesQuery, HotelImagesQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelImagesQuery, HotelImagesQueryVariables>(HotelImagesDocument, baseOptions);
      }
export function useHotelImagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelImagesQuery, HotelImagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelImagesQuery, HotelImagesQueryVariables>(HotelImagesDocument, baseOptions);
        }
export type HotelImagesQueryHookResult = ReturnType<typeof useHotelImagesQuery>;
export type HotelImagesLazyQueryHookResult = ReturnType<typeof useHotelImagesLazyQuery>;
export type HotelImagesQueryResult = Apollo.QueryResult<HotelImagesQuery, HotelImagesQueryVariables>;
export const HotelRoomsAndRatesDocument = gql`
    query HotelRoomsAndRates($payload: HotelRoomsAndRatesRequest!) {
  hotelRoomsAndRates(payload: $payload) {
    __typename
    hotelId
    rates {
      currency
      occupancies {
        numOfAdults
        roomId
        numOfChildren
        childAges
      }
      rateId
      totalRateWithTax {
        currency
        digits
        floatingPointDecimalString
        valueInMinorUnits
      }
      publishedRateWithTax {
        currency
        digits
        floatingPointDecimalString
        valueInMinorUnits
      }
    }
    rooms {
      beds {
        count
        type
      }
      id
      name
      description
      facilities
      roomSquareFeet
      roomSquareMeters
      facilities
      images {
        imageName
        thumbnailUrl
        url
      }
    }
  }
}
    `;

/**
 * __useHotelRoomsAndRatesQuery__
 *
 * To run a query within a React component, call `useHotelRoomsAndRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelRoomsAndRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelRoomsAndRatesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useHotelRoomsAndRatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelRoomsAndRatesQuery, HotelRoomsAndRatesQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelRoomsAndRatesQuery, HotelRoomsAndRatesQueryVariables>(HotelRoomsAndRatesDocument, baseOptions);
      }
export function useHotelRoomsAndRatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelRoomsAndRatesQuery, HotelRoomsAndRatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelRoomsAndRatesQuery, HotelRoomsAndRatesQueryVariables>(HotelRoomsAndRatesDocument, baseOptions);
        }
export type HotelRoomsAndRatesQueryHookResult = ReturnType<typeof useHotelRoomsAndRatesQuery>;
export type HotelRoomsAndRatesLazyQueryHookResult = ReturnType<typeof useHotelRoomsAndRatesLazyQuery>;
export type HotelRoomsAndRatesQueryResult = Apollo.QueryResult<HotelRoomsAndRatesQuery, HotelRoomsAndRatesQueryVariables>;
export const HotelInventoryByIdsDocument = gql`
    query HotelInventoryByIds($payload: HotelInventoryByIdsRequest!) {
  hotelInventoryByIds(payload: $payload) {
    __typename
    address
    city
    country
    description
    displayName
    distance
    facilityGroups {
      __typename
      id
      name
    }
    hotelUrl
    isPreferredHotel
    location {
      __typename
      lat
      lon
    }
    photo
    postalCode
    starRating
    state
    userRating
    zhId
  }
}
    `;

/**
 * __useHotelInventoryByIdsQuery__
 *
 * To run a query within a React component, call `useHotelInventoryByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelInventoryByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelInventoryByIdsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useHotelInventoryByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelInventoryByIdsQuery, HotelInventoryByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelInventoryByIdsQuery, HotelInventoryByIdsQueryVariables>(HotelInventoryByIdsDocument, baseOptions);
      }
export function useHotelInventoryByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelInventoryByIdsQuery, HotelInventoryByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelInventoryByIdsQuery, HotelInventoryByIdsQueryVariables>(HotelInventoryByIdsDocument, baseOptions);
        }
export type HotelInventoryByIdsQueryHookResult = ReturnType<typeof useHotelInventoryByIdsQuery>;
export type HotelInventoryByIdsLazyQueryHookResult = ReturnType<typeof useHotelInventoryByIdsLazyQuery>;
export type HotelInventoryByIdsQueryResult = Apollo.QueryResult<HotelInventoryByIdsQuery, HotelInventoryByIdsQueryVariables>;
export const EventInfoForAccommodationPropertyDocument = gql`
    query EventInfoForAccommodationProperty($name: String!) {
  eventByName(name: $name) {
    id
    photo {
      id
      url
    }
  }
}
    `;

/**
 * __useEventInfoForAccommodationPropertyQuery__
 *
 * To run a query within a React component, call `useEventInfoForAccommodationPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInfoForAccommodationPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInfoForAccommodationPropertyQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEventInfoForAccommodationPropertyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventInfoForAccommodationPropertyQuery, EventInfoForAccommodationPropertyQueryVariables>) {
        return ApolloReactHooks.useQuery<EventInfoForAccommodationPropertyQuery, EventInfoForAccommodationPropertyQueryVariables>(EventInfoForAccommodationPropertyDocument, baseOptions);
      }
export function useEventInfoForAccommodationPropertyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventInfoForAccommodationPropertyQuery, EventInfoForAccommodationPropertyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventInfoForAccommodationPropertyQuery, EventInfoForAccommodationPropertyQueryVariables>(EventInfoForAccommodationPropertyDocument, baseOptions);
        }
export type EventInfoForAccommodationPropertyQueryHookResult = ReturnType<typeof useEventInfoForAccommodationPropertyQuery>;
export type EventInfoForAccommodationPropertyLazyQueryHookResult = ReturnType<typeof useEventInfoForAccommodationPropertyLazyQuery>;
export type EventInfoForAccommodationPropertyQueryResult = Apollo.QueryResult<EventInfoForAccommodationPropertyQuery, EventInfoForAccommodationPropertyQueryVariables>;
export const PropertiesWithAccommodationPlaceDocument = gql`
    query PropertiesWithAccommodationPlace($idObject: AccommodationCatalogPropertyIdentifierInput!, $accommodationPlaceId: ID!, $pageContainerBySlugPayload2: PageContainerBySlugPayload!) {
  accommodationCatalogPropertyById(idObject: $idObject) {
    __typename
    name
    plainTextLongDescription
    starRating
    userRating {
      ...UserRating
    }
    facilities {
      label
    }
    photos {
      url
    }
    location {
      latitude
      longitude
    }
    address {
      city
      country
      postalCode
      state
      street
    }
  }
  accommodationPlaceV2ById(id: $accommodationPlaceId) {
    id
    isPhotoHidden
    photo {
      id
      url
      altTag
    }
    customPhoto {
      id
      altTag
      url
    }
    name
    customName
    userNote
    description
    lat
    long
    city
    country
    postalCode
    state
    address
  }
  pageContainerBySlug(payload: $pageContainerBySlugPayload2) {
    id
    components {
      ... on TextComponent {
        id
      }
    }
  }
}
    ${UserRatingFragmentDoc}`;

/**
 * __usePropertiesWithAccommodationPlaceQuery__
 *
 * To run a query within a React component, call `usePropertiesWithAccommodationPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesWithAccommodationPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesWithAccommodationPlaceQuery({
 *   variables: {
 *      idObject: // value for 'idObject'
 *      accommodationPlaceId: // value for 'accommodationPlaceId'
 *      pageContainerBySlugPayload2: // value for 'pageContainerBySlugPayload2'
 *   },
 * });
 */
export function usePropertiesWithAccommodationPlaceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PropertiesWithAccommodationPlaceQuery, PropertiesWithAccommodationPlaceQueryVariables>) {
        return ApolloReactHooks.useQuery<PropertiesWithAccommodationPlaceQuery, PropertiesWithAccommodationPlaceQueryVariables>(PropertiesWithAccommodationPlaceDocument, baseOptions);
      }
export function usePropertiesWithAccommodationPlaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PropertiesWithAccommodationPlaceQuery, PropertiesWithAccommodationPlaceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PropertiesWithAccommodationPlaceQuery, PropertiesWithAccommodationPlaceQueryVariables>(PropertiesWithAccommodationPlaceDocument, baseOptions);
        }
export type PropertiesWithAccommodationPlaceQueryHookResult = ReturnType<typeof usePropertiesWithAccommodationPlaceQuery>;
export type PropertiesWithAccommodationPlaceLazyQueryHookResult = ReturnType<typeof usePropertiesWithAccommodationPlaceLazyQuery>;
export type PropertiesWithAccommodationPlaceQueryResult = Apollo.QueryResult<PropertiesWithAccommodationPlaceQuery, PropertiesWithAccommodationPlaceQueryVariables>;
export const TravelOffersForAccommodationPropertiesDocument = gql`
    query TravelOffersForAccommodationProperties($payload: TravelOffersForAccommodationForPropertiesPayload!) {
  travelOffersForAccommodationProperties(payload: $payload) {
    someOffers {
      ...TravelOffer
    }
  }
}
    ${TravelOfferFragmentDoc}`;

/**
 * __useTravelOffersForAccommodationPropertiesQuery__
 *
 * To run a query within a React component, call `useTravelOffersForAccommodationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOffersForAccommodationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOffersForAccommodationPropertiesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelOffersForAccommodationPropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOffersForAccommodationPropertiesQuery, TravelOffersForAccommodationPropertiesQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOffersForAccommodationPropertiesQuery, TravelOffersForAccommodationPropertiesQueryVariables>(TravelOffersForAccommodationPropertiesDocument, baseOptions);
      }
export function useTravelOffersForAccommodationPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOffersForAccommodationPropertiesQuery, TravelOffersForAccommodationPropertiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOffersForAccommodationPropertiesQuery, TravelOffersForAccommodationPropertiesQueryVariables>(TravelOffersForAccommodationPropertiesDocument, baseOptions);
        }
export type TravelOffersForAccommodationPropertiesQueryHookResult = ReturnType<typeof useTravelOffersForAccommodationPropertiesQuery>;
export type TravelOffersForAccommodationPropertiesLazyQueryHookResult = ReturnType<typeof useTravelOffersForAccommodationPropertiesLazyQuery>;
export type TravelOffersForAccommodationPropertiesQueryResult = Apollo.QueryResult<TravelOffersForAccommodationPropertiesQuery, TravelOffersForAccommodationPropertiesQueryVariables>;
export const PricingsForAccommodationByRegionDocument = gql`
    query PricingsForAccommodationByRegion($payload: TravelPricingsForAccommodationByRegionPayload!) {
  pricingsForAccommodationByRegion(payload: $payload) {
    pricings {
      property {
        joyPlaceId
        relevanceScore
        starRating
        userRating {
          ...UserRating
        }
        location {
          latitude
          longitude
          timezone
        }
        photos {
          url
          subject {
            label
            type
          }
        }
        name
        plainTextLongDescription
      }
      totalAmount {
        currency
        digits
        floatingPointDecimalString
        valueInMinorUnits
      }
    }
  }
}
    ${UserRatingFragmentDoc}`;

/**
 * __usePricingsForAccommodationByRegionQuery__
 *
 * To run a query within a React component, call `usePricingsForAccommodationByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingsForAccommodationByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingsForAccommodationByRegionQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function usePricingsForAccommodationByRegionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PricingsForAccommodationByRegionQuery, PricingsForAccommodationByRegionQueryVariables>) {
        return ApolloReactHooks.useQuery<PricingsForAccommodationByRegionQuery, PricingsForAccommodationByRegionQueryVariables>(PricingsForAccommodationByRegionDocument, baseOptions);
      }
export function usePricingsForAccommodationByRegionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PricingsForAccommodationByRegionQuery, PricingsForAccommodationByRegionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PricingsForAccommodationByRegionQuery, PricingsForAccommodationByRegionQueryVariables>(PricingsForAccommodationByRegionDocument, baseOptions);
        }
export type PricingsForAccommodationByRegionQueryHookResult = ReturnType<typeof usePricingsForAccommodationByRegionQuery>;
export type PricingsForAccommodationByRegionLazyQueryHookResult = ReturnType<typeof usePricingsForAccommodationByRegionLazyQuery>;
export type PricingsForAccommodationByRegionQueryResult = Apollo.QueryResult<PricingsForAccommodationByRegionQuery, PricingsForAccommodationByRegionQueryVariables>;
export const ServiceCenterAddAccommodationPlaceV2Document = gql`
    mutation ServiceCenterAddAccommodationPlaceV2($payload: AddAccommodationPlaceV2Request!) {
  addAccommodationPlaceV2(payload: $payload) {
    ...ServiceCenterAccommodationPlace
  }
}
    ${ServiceCenterAccommodationPlaceFragmentDoc}`;
export type ServiceCenterAddAccommodationPlaceV2MutationFn = Apollo.MutationFunction<ServiceCenterAddAccommodationPlaceV2Mutation, ServiceCenterAddAccommodationPlaceV2MutationVariables>;

/**
 * __useServiceCenterAddAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useServiceCenterAddAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceCenterAddAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceCenterAddAccommodationPlaceV2Mutation, { data, loading, error }] = useServiceCenterAddAccommodationPlaceV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useServiceCenterAddAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceCenterAddAccommodationPlaceV2Mutation, ServiceCenterAddAccommodationPlaceV2MutationVariables>) {
        return ApolloReactHooks.useMutation<ServiceCenterAddAccommodationPlaceV2Mutation, ServiceCenterAddAccommodationPlaceV2MutationVariables>(ServiceCenterAddAccommodationPlaceV2Document, baseOptions);
      }
export type ServiceCenterAddAccommodationPlaceV2MutationHookResult = ReturnType<typeof useServiceCenterAddAccommodationPlaceV2Mutation>;
export type ServiceCenterAddAccommodationPlaceV2MutationResult = Apollo.MutationResult<ServiceCenterAddAccommodationPlaceV2Mutation>;
export type ServiceCenterAddAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<ServiceCenterAddAccommodationPlaceV2Mutation, ServiceCenterAddAccommodationPlaceV2MutationVariables>;
export const ServiceCenterDeleteAccommodationPlaceV2Document = gql`
    mutation ServiceCenterDeleteAccommodationPlaceV2($id: String!) {
  deleteAccommodationPlaceV2(id: $id) {
    ...ServiceCenterAccommodationPlace
  }
}
    ${ServiceCenterAccommodationPlaceFragmentDoc}`;
export type ServiceCenterDeleteAccommodationPlaceV2MutationFn = Apollo.MutationFunction<ServiceCenterDeleteAccommodationPlaceV2Mutation, ServiceCenterDeleteAccommodationPlaceV2MutationVariables>;

/**
 * __useServiceCenterDeleteAccommodationPlaceV2Mutation__
 *
 * To run a mutation, you first call `useServiceCenterDeleteAccommodationPlaceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceCenterDeleteAccommodationPlaceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceCenterDeleteAccommodationPlaceV2Mutation, { data, loading, error }] = useServiceCenterDeleteAccommodationPlaceV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceCenterDeleteAccommodationPlaceV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceCenterDeleteAccommodationPlaceV2Mutation, ServiceCenterDeleteAccommodationPlaceV2MutationVariables>) {
        return ApolloReactHooks.useMutation<ServiceCenterDeleteAccommodationPlaceV2Mutation, ServiceCenterDeleteAccommodationPlaceV2MutationVariables>(ServiceCenterDeleteAccommodationPlaceV2Document, baseOptions);
      }
export type ServiceCenterDeleteAccommodationPlaceV2MutationHookResult = ReturnType<typeof useServiceCenterDeleteAccommodationPlaceV2Mutation>;
export type ServiceCenterDeleteAccommodationPlaceV2MutationResult = Apollo.MutationResult<ServiceCenterDeleteAccommodationPlaceV2Mutation>;
export type ServiceCenterDeleteAccommodationPlaceV2MutationOptions = Apollo.BaseMutationOptions<ServiceCenterDeleteAccommodationPlaceV2Mutation, ServiceCenterDeleteAccommodationPlaceV2MutationVariables>;
export const TravelOfferReservationUpdateDocument = gql`
    mutation TravelOfferReservationUpdate($payload: TravelOfferReservationUpdatePayload!) {
  travelOfferReservationUpdate(payload: $payload) {
    id
    status
  }
}
    `;
export type TravelOfferReservationUpdateMutationFn = Apollo.MutationFunction<TravelOfferReservationUpdateMutation, TravelOfferReservationUpdateMutationVariables>;

/**
 * __useTravelOfferReservationUpdateMutation__
 *
 * To run a mutation, you first call `useTravelOfferReservationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelOfferReservationUpdateMutation, { data, loading, error }] = useTravelOfferReservationUpdateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelOfferReservationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TravelOfferReservationUpdateMutation, TravelOfferReservationUpdateMutationVariables>) {
        return ApolloReactHooks.useMutation<TravelOfferReservationUpdateMutation, TravelOfferReservationUpdateMutationVariables>(TravelOfferReservationUpdateDocument, baseOptions);
      }
export type TravelOfferReservationUpdateMutationHookResult = ReturnType<typeof useTravelOfferReservationUpdateMutation>;
export type TravelOfferReservationUpdateMutationResult = Apollo.MutationResult<TravelOfferReservationUpdateMutation>;
export type TravelOfferReservationUpdateMutationOptions = Apollo.BaseMutationOptions<TravelOfferReservationUpdateMutation, TravelOfferReservationUpdateMutationVariables>;
export const ServiceCenterAccommodationPlacesDocument = gql`
    query ServiceCenterAccommodationPlaces($name: String!) {
  eventByName(name: $name) {
    id
    accommodationPlacesV2 {
      ...ServiceCenterAccommodationPlace
    }
  }
}
    ${ServiceCenterAccommodationPlaceFragmentDoc}`;

/**
 * __useServiceCenterAccommodationPlacesQuery__
 *
 * To run a query within a React component, call `useServiceCenterAccommodationPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCenterAccommodationPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCenterAccommodationPlacesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useServiceCenterAccommodationPlacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServiceCenterAccommodationPlacesQuery, ServiceCenterAccommodationPlacesQueryVariables>) {
        return ApolloReactHooks.useQuery<ServiceCenterAccommodationPlacesQuery, ServiceCenterAccommodationPlacesQueryVariables>(ServiceCenterAccommodationPlacesDocument, baseOptions);
      }
export function useServiceCenterAccommodationPlacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceCenterAccommodationPlacesQuery, ServiceCenterAccommodationPlacesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ServiceCenterAccommodationPlacesQuery, ServiceCenterAccommodationPlacesQueryVariables>(ServiceCenterAccommodationPlacesDocument, baseOptions);
        }
export type ServiceCenterAccommodationPlacesQueryHookResult = ReturnType<typeof useServiceCenterAccommodationPlacesQuery>;
export type ServiceCenterAccommodationPlacesLazyQueryHookResult = ReturnType<typeof useServiceCenterAccommodationPlacesLazyQuery>;
export type ServiceCenterAccommodationPlacesQueryResult = Apollo.QueryResult<ServiceCenterAccommodationPlacesQuery, ServiceCenterAccommodationPlacesQueryVariables>;
export const TravelOfferFromOfferTokenDocument = gql`
    query TravelOfferFromOfferToken($payload: String!, $params: TravelOfferFromOfferTokenParams, $useCache: Boolean) {
  travelOfferFromOfferToken(payload: $payload, params: $params, useCache: $useCache) {
    ...TravelOffer
  }
}
    ${TravelOfferFragmentDoc}`;

/**
 * __useTravelOfferFromOfferTokenQuery__
 *
 * To run a query within a React component, call `useTravelOfferFromOfferTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferFromOfferTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferFromOfferTokenQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *      params: // value for 'params'
 *      useCache: // value for 'useCache'
 *   },
 * });
 */
export function useTravelOfferFromOfferTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferFromOfferTokenQuery, TravelOfferFromOfferTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferFromOfferTokenQuery, TravelOfferFromOfferTokenQueryVariables>(TravelOfferFromOfferTokenDocument, baseOptions);
      }
export function useTravelOfferFromOfferTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferFromOfferTokenQuery, TravelOfferFromOfferTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferFromOfferTokenQuery, TravelOfferFromOfferTokenQueryVariables>(TravelOfferFromOfferTokenDocument, baseOptions);
        }
export type TravelOfferFromOfferTokenQueryHookResult = ReturnType<typeof useTravelOfferFromOfferTokenQuery>;
export type TravelOfferFromOfferTokenLazyQueryHookResult = ReturnType<typeof useTravelOfferFromOfferTokenLazyQuery>;
export type TravelOfferFromOfferTokenQueryResult = Apollo.QueryResult<TravelOfferFromOfferTokenQuery, TravelOfferFromOfferTokenQueryVariables>;
export const TravelOfferReservationCreateDocument = gql`
    mutation TravelOfferReservationCreate($payload: TravelOfferReservationCreatePayload!) {
  travelOfferReservationCreate(payload: $payload) {
    ... on TravelOfferReservationCreateVaulteraVaultResult {
      reservation {
        ...TravelOfferReservationForCheckout
      }
      vaulteraToken
    }
    ... on TravelOfferReservationCreateStripeNativeResult {
      reservation {
        ...TravelOfferReservationForCheckout
      }
      paymentIntentClientSecret
    }
  }
}
    ${TravelOfferReservationForCheckoutFragmentDoc}`;
export type TravelOfferReservationCreateMutationFn = Apollo.MutationFunction<TravelOfferReservationCreateMutation, TravelOfferReservationCreateMutationVariables>;

/**
 * __useTravelOfferReservationCreateMutation__
 *
 * To run a mutation, you first call `useTravelOfferReservationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelOfferReservationCreateMutation, { data, loading, error }] = useTravelOfferReservationCreateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelOfferReservationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TravelOfferReservationCreateMutation, TravelOfferReservationCreateMutationVariables>) {
        return ApolloReactHooks.useMutation<TravelOfferReservationCreateMutation, TravelOfferReservationCreateMutationVariables>(TravelOfferReservationCreateDocument, baseOptions);
      }
export type TravelOfferReservationCreateMutationHookResult = ReturnType<typeof useTravelOfferReservationCreateMutation>;
export type TravelOfferReservationCreateMutationResult = Apollo.MutationResult<TravelOfferReservationCreateMutation>;
export type TravelOfferReservationCreateMutationOptions = Apollo.BaseMutationOptions<TravelOfferReservationCreateMutation, TravelOfferReservationCreateMutationVariables>;
export const TravelOfferReservationConfirmDocument = gql`
    mutation TravelOfferReservationConfirm($payload: TravelOfferReservationConfirmPayload!) {
  travelOfferReservationConfirm(payload: $payload) {
    ... on TravelOfferReservationConfirmSuccess {
      reservation {
        id
        offerToken
        status
      }
    }
    ... on TravelOfferReservationConfirmFailure {
      errorMessage
    }
  }
}
    `;
export type TravelOfferReservationConfirmMutationFn = Apollo.MutationFunction<TravelOfferReservationConfirmMutation, TravelOfferReservationConfirmMutationVariables>;

/**
 * __useTravelOfferReservationConfirmMutation__
 *
 * To run a mutation, you first call `useTravelOfferReservationConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelOfferReservationConfirmMutation, { data, loading, error }] = useTravelOfferReservationConfirmMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTravelOfferReservationConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TravelOfferReservationConfirmMutation, TravelOfferReservationConfirmMutationVariables>) {
        return ApolloReactHooks.useMutation<TravelOfferReservationConfirmMutation, TravelOfferReservationConfirmMutationVariables>(TravelOfferReservationConfirmDocument, baseOptions);
      }
export type TravelOfferReservationConfirmMutationHookResult = ReturnType<typeof useTravelOfferReservationConfirmMutation>;
export type TravelOfferReservationConfirmMutationResult = Apollo.MutationResult<TravelOfferReservationConfirmMutation>;
export type TravelOfferReservationConfirmMutationOptions = Apollo.BaseMutationOptions<TravelOfferReservationConfirmMutation, TravelOfferReservationConfirmMutationVariables>;
export const TravelOfferReservationByIdDocument = gql`
    query TravelOfferReservationById($travelOfferReservationByIdId: String!) {
  travelOfferReservationById(id: $travelOfferReservationByIdId) {
    ...TravelOfferReservationFullDetails
  }
}
    ${TravelOfferReservationFullDetailsFragmentDoc}`;

/**
 * __useTravelOfferReservationByIdQuery__
 *
 * To run a query within a React component, call `useTravelOfferReservationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferReservationByIdQuery({
 *   variables: {
 *      travelOfferReservationByIdId: // value for 'travelOfferReservationByIdId'
 *   },
 * });
 */
export function useTravelOfferReservationByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferReservationByIdQuery, TravelOfferReservationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferReservationByIdQuery, TravelOfferReservationByIdQueryVariables>(TravelOfferReservationByIdDocument, baseOptions);
      }
export function useTravelOfferReservationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferReservationByIdQuery, TravelOfferReservationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferReservationByIdQuery, TravelOfferReservationByIdQueryVariables>(TravelOfferReservationByIdDocument, baseOptions);
        }
export type TravelOfferReservationByIdQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdQuery>;
export type TravelOfferReservationByIdLazyQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdLazyQuery>;
export type TravelOfferReservationByIdQueryResult = Apollo.QueryResult<TravelOfferReservationByIdQuery, TravelOfferReservationByIdQueryVariables>;
export const TravelOfferReservationStatusByIdDocument = gql`
    query TravelOfferReservationStatusById($travelOfferReservationStatusById: String!) {
  travelOfferReservationById(id: $travelOfferReservationStatusById) {
    ...TravelOfferReservationStatusDetails
  }
}
    ${TravelOfferReservationStatusDetailsFragmentDoc}`;

/**
 * __useTravelOfferReservationStatusByIdQuery__
 *
 * To run a query within a React component, call `useTravelOfferReservationStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferReservationStatusByIdQuery({
 *   variables: {
 *      travelOfferReservationStatusById: // value for 'travelOfferReservationStatusById'
 *   },
 * });
 */
export function useTravelOfferReservationStatusByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferReservationStatusByIdQuery, TravelOfferReservationStatusByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferReservationStatusByIdQuery, TravelOfferReservationStatusByIdQueryVariables>(TravelOfferReservationStatusByIdDocument, baseOptions);
      }
export function useTravelOfferReservationStatusByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferReservationStatusByIdQuery, TravelOfferReservationStatusByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferReservationStatusByIdQuery, TravelOfferReservationStatusByIdQueryVariables>(TravelOfferReservationStatusByIdDocument, baseOptions);
        }
export type TravelOfferReservationStatusByIdQueryHookResult = ReturnType<typeof useTravelOfferReservationStatusByIdQuery>;
export type TravelOfferReservationStatusByIdLazyQueryHookResult = ReturnType<typeof useTravelOfferReservationStatusByIdLazyQuery>;
export type TravelOfferReservationStatusByIdQueryResult = Apollo.QueryResult<TravelOfferReservationStatusByIdQuery, TravelOfferReservationStatusByIdQueryVariables>;
export const TravelOfferReservationByIdOrOrderIdDocument = gql`
    query TravelOfferReservationByIdOrOrderId($travelOfferReservationByIdOrOrderIdId: String!) {
  travelOfferReservationByIdOrOrderId(id: $travelOfferReservationByIdOrOrderIdId) {
    ...TravelOfferReservationFullDetails
  }
}
    ${TravelOfferReservationFullDetailsFragmentDoc}`;

/**
 * __useTravelOfferReservationByIdOrOrderIdQuery__
 *
 * To run a query within a React component, call `useTravelOfferReservationByIdOrOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationByIdOrOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferReservationByIdOrOrderIdQuery({
 *   variables: {
 *      travelOfferReservationByIdOrOrderIdId: // value for 'travelOfferReservationByIdOrOrderIdId'
 *   },
 * });
 */
export function useTravelOfferReservationByIdOrOrderIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferReservationByIdOrOrderIdQuery, TravelOfferReservationByIdOrOrderIdQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferReservationByIdOrOrderIdQuery, TravelOfferReservationByIdOrOrderIdQueryVariables>(TravelOfferReservationByIdOrOrderIdDocument, baseOptions);
      }
export function useTravelOfferReservationByIdOrOrderIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferReservationByIdOrOrderIdQuery, TravelOfferReservationByIdOrOrderIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferReservationByIdOrOrderIdQuery, TravelOfferReservationByIdOrOrderIdQueryVariables>(TravelOfferReservationByIdOrOrderIdDocument, baseOptions);
        }
export type TravelOfferReservationByIdOrOrderIdQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdOrOrderIdQuery>;
export type TravelOfferReservationByIdOrOrderIdLazyQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdOrOrderIdLazyQuery>;
export type TravelOfferReservationByIdOrOrderIdQueryResult = Apollo.QueryResult<TravelOfferReservationByIdOrOrderIdQuery, TravelOfferReservationByIdOrOrderIdQueryVariables>;
export const TravelOfferReservationStatusByIdOrOrderIdDocument = gql`
    query TravelOfferReservationStatusByIdOrOrderId($travelOfferReservationStatusByIdOrOrderId: String!) {
  travelOfferReservationByIdOrOrderId(id: $travelOfferReservationStatusByIdOrOrderId) {
    ...TravelOfferReservationStatusDetails
  }
}
    ${TravelOfferReservationStatusDetailsFragmentDoc}`;

/**
 * __useTravelOfferReservationStatusByIdOrOrderIdQuery__
 *
 * To run a query within a React component, call `useTravelOfferReservationStatusByIdOrOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationStatusByIdOrOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferReservationStatusByIdOrOrderIdQuery({
 *   variables: {
 *      travelOfferReservationStatusByIdOrOrderId: // value for 'travelOfferReservationStatusByIdOrOrderId'
 *   },
 * });
 */
export function useTravelOfferReservationStatusByIdOrOrderIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferReservationStatusByIdOrOrderIdQuery, TravelOfferReservationStatusByIdOrOrderIdQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferReservationStatusByIdOrOrderIdQuery, TravelOfferReservationStatusByIdOrOrderIdQueryVariables>(TravelOfferReservationStatusByIdOrOrderIdDocument, baseOptions);
      }
export function useTravelOfferReservationStatusByIdOrOrderIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferReservationStatusByIdOrOrderIdQuery, TravelOfferReservationStatusByIdOrOrderIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferReservationStatusByIdOrOrderIdQuery, TravelOfferReservationStatusByIdOrOrderIdQueryVariables>(TravelOfferReservationStatusByIdOrOrderIdDocument, baseOptions);
        }
export type TravelOfferReservationStatusByIdOrOrderIdQueryHookResult = ReturnType<typeof useTravelOfferReservationStatusByIdOrOrderIdQuery>;
export type TravelOfferReservationStatusByIdOrOrderIdLazyQueryHookResult = ReturnType<typeof useTravelOfferReservationStatusByIdOrOrderIdLazyQuery>;
export type TravelOfferReservationStatusByIdOrOrderIdQueryResult = Apollo.QueryResult<TravelOfferReservationStatusByIdOrOrderIdQuery, TravelOfferReservationStatusByIdOrOrderIdQueryVariables>;
export const GetEventByIdForReservationStatusPageDocument = gql`
    query GetEventByIdForReservationStatusPage($eventId: ID!) {
  eventById(id: $eventId) {
    id
    website
  }
}
    `;

/**
 * __useGetEventByIdForReservationStatusPageQuery__
 *
 * To run a query within a React component, call `useGetEventByIdForReservationStatusPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdForReservationStatusPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdForReservationStatusPageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventByIdForReservationStatusPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByIdForReservationStatusPageQuery, GetEventByIdForReservationStatusPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByIdForReservationStatusPageQuery, GetEventByIdForReservationStatusPageQueryVariables>(GetEventByIdForReservationStatusPageDocument, baseOptions);
      }
export function useGetEventByIdForReservationStatusPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByIdForReservationStatusPageQuery, GetEventByIdForReservationStatusPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByIdForReservationStatusPageQuery, GetEventByIdForReservationStatusPageQueryVariables>(GetEventByIdForReservationStatusPageDocument, baseOptions);
        }
export type GetEventByIdForReservationStatusPageQueryHookResult = ReturnType<typeof useGetEventByIdForReservationStatusPageQuery>;
export type GetEventByIdForReservationStatusPageLazyQueryHookResult = ReturnType<typeof useGetEventByIdForReservationStatusPageLazyQuery>;
export type GetEventByIdForReservationStatusPageQueryResult = Apollo.QueryResult<GetEventByIdForReservationStatusPageQuery, GetEventByIdForReservationStatusPageQueryVariables>;
export const CurrentEventGuestDocument = gql`
    query CurrentEventGuest($eventId: ID!) {
  eventById(id: $eventId) {
    id
    activeSession {
      id
      person {
        id
        firstName
        lastName
        email
        phoneDisplay
      }
    }
  }
}
    `;

/**
 * __useCurrentEventGuestQuery__
 *
 * To run a query within a React component, call `useCurrentEventGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentEventGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentEventGuestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCurrentEventGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentEventGuestQuery, CurrentEventGuestQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentEventGuestQuery, CurrentEventGuestQueryVariables>(CurrentEventGuestDocument, baseOptions);
      }
export function useCurrentEventGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentEventGuestQuery, CurrentEventGuestQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentEventGuestQuery, CurrentEventGuestQueryVariables>(CurrentEventGuestDocument, baseOptions);
        }
export type CurrentEventGuestQueryHookResult = ReturnType<typeof useCurrentEventGuestQuery>;
export type CurrentEventGuestLazyQueryHookResult = ReturnType<typeof useCurrentEventGuestLazyQuery>;
export type CurrentEventGuestQueryResult = Apollo.QueryResult<CurrentEventGuestQuery, CurrentEventGuestQueryVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($payload: TravelOfferReservationCancelPayload!) {
  travelOfferReservationCancel(payload: $payload) {
    ... on TravelOfferReservationCancelSuccess {
      reservation {
        id
        status
        confirmation {
          externalOrderId
          propertyInfo {
            name
            address {
              line1
              line2
              city
              state
              country
              postalCode
            }
          }
          checkIn
          checkOut
          baseAmount {
            currency
            floatingPointDecimalString
          }
          totalAmount {
            currency
            floatingPointDecimalString
          }
          discountAmount {
            currency
            valueInMinorUnits
            floatingPointDecimalString
            digits
          }
          billingContact {
            title
            firstName
            lastName
            email
            phone
          }
          propertyConfirmationCode
        }
      }
    }
    ... on TravelOfferReservationCancelFailure {
      errorMessage
    }
  }
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, baseOptions);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const TravelOfferReservationByIdForCheckoutDocument = gql`
    query TravelOfferReservationByIdForCheckout($id: String!) {
  travelOfferReservationById(id: $id) {
    ...TravelOfferReservationForCheckout
  }
}
    ${TravelOfferReservationForCheckoutFragmentDoc}`;

/**
 * __useTravelOfferReservationByIdForCheckoutQuery__
 *
 * To run a query within a React component, call `useTravelOfferReservationByIdForCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelOfferReservationByIdForCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelOfferReservationByIdForCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelOfferReservationByIdForCheckoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelOfferReservationByIdForCheckoutQuery, TravelOfferReservationByIdForCheckoutQueryVariables>) {
        return ApolloReactHooks.useQuery<TravelOfferReservationByIdForCheckoutQuery, TravelOfferReservationByIdForCheckoutQueryVariables>(TravelOfferReservationByIdForCheckoutDocument, baseOptions);
      }
export function useTravelOfferReservationByIdForCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelOfferReservationByIdForCheckoutQuery, TravelOfferReservationByIdForCheckoutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TravelOfferReservationByIdForCheckoutQuery, TravelOfferReservationByIdForCheckoutQueryVariables>(TravelOfferReservationByIdForCheckoutDocument, baseOptions);
        }
export type TravelOfferReservationByIdForCheckoutQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdForCheckoutQuery>;
export type TravelOfferReservationByIdForCheckoutLazyQueryHookResult = ReturnType<typeof useTravelOfferReservationByIdForCheckoutLazyQuery>;
export type TravelOfferReservationByIdForCheckoutQueryResult = Apollo.QueryResult<TravelOfferReservationByIdForCheckoutQuery, TravelOfferReservationByIdForCheckoutQueryVariables>;
export const SearchTravelOfferReservationsDocument = gql`
    query SearchTravelOfferReservations($payload: SearchTravelOfferReservationsPayload!) {
  searchTravelOfferReservations(payload: $payload) {
    id
  }
}
    `;

/**
 * __useSearchTravelOfferReservationsQuery__
 *
 * To run a query within a React component, call `useSearchTravelOfferReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTravelOfferReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTravelOfferReservationsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSearchTravelOfferReservationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTravelOfferReservationsQuery, SearchTravelOfferReservationsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchTravelOfferReservationsQuery, SearchTravelOfferReservationsQueryVariables>(SearchTravelOfferReservationsDocument, baseOptions);
      }
export function useSearchTravelOfferReservationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTravelOfferReservationsQuery, SearchTravelOfferReservationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchTravelOfferReservationsQuery, SearchTravelOfferReservationsQueryVariables>(SearchTravelOfferReservationsDocument, baseOptions);
        }
export type SearchTravelOfferReservationsQueryHookResult = ReturnType<typeof useSearchTravelOfferReservationsQuery>;
export type SearchTravelOfferReservationsLazyQueryHookResult = ReturnType<typeof useSearchTravelOfferReservationsLazyQuery>;
export type SearchTravelOfferReservationsQueryResult = Apollo.QueryResult<SearchTravelOfferReservationsQuery, SearchTravelOfferReservationsQueryVariables>;
export const GetThingsToDoContainersDocument = gql`
    query GetThingsToDoContainers($payload: GetThingsToDoContainersPayload!) {
  getThingsToDoContainers(payload: $payload) {
    id
    eventId
    content
    schemaUrl
    type
  }
}
    `;

/**
 * __useGetThingsToDoContainersQuery__
 *
 * To run a query within a React component, call `useGetThingsToDoContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThingsToDoContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThingsToDoContainersQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetThingsToDoContainersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetThingsToDoContainersQuery, GetThingsToDoContainersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetThingsToDoContainersQuery, GetThingsToDoContainersQueryVariables>(GetThingsToDoContainersDocument, baseOptions);
      }
export function useGetThingsToDoContainersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetThingsToDoContainersQuery, GetThingsToDoContainersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetThingsToDoContainersQuery, GetThingsToDoContainersQueryVariables>(GetThingsToDoContainersDocument, baseOptions);
        }
export type GetThingsToDoContainersQueryHookResult = ReturnType<typeof useGetThingsToDoContainersQuery>;
export type GetThingsToDoContainersLazyQueryHookResult = ReturnType<typeof useGetThingsToDoContainersLazyQuery>;
export type GetThingsToDoContainersQueryResult = Apollo.QueryResult<GetThingsToDoContainersQuery, GetThingsToDoContainersQueryVariables>;
export const UpdateThingsToDoContainersDocument = gql`
    mutation UpdateThingsToDoContainers($payload: UpdateThingsToDoContainersPayload!) {
  updateThingsToDoContainers(payload: $payload) {
    id
    eventId
    content
    schemaUrl
    type
  }
}
    `;
export type UpdateThingsToDoContainersMutationFn = Apollo.MutationFunction<UpdateThingsToDoContainersMutation, UpdateThingsToDoContainersMutationVariables>;

/**
 * __useUpdateThingsToDoContainersMutation__
 *
 * To run a mutation, you first call `useUpdateThingsToDoContainersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThingsToDoContainersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThingsToDoContainersMutation, { data, loading, error }] = useUpdateThingsToDoContainersMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateThingsToDoContainersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateThingsToDoContainersMutation, UpdateThingsToDoContainersMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateThingsToDoContainersMutation, UpdateThingsToDoContainersMutationVariables>(UpdateThingsToDoContainersDocument, baseOptions);
      }
export type UpdateThingsToDoContainersMutationHookResult = ReturnType<typeof useUpdateThingsToDoContainersMutation>;
export type UpdateThingsToDoContainersMutationResult = Apollo.MutationResult<UpdateThingsToDoContainersMutation>;
export type UpdateThingsToDoContainersMutationOptions = Apollo.BaseMutationOptions<UpdateThingsToDoContainersMutation, UpdateThingsToDoContainersMutationVariables>;
export const GetEventDetailsInfoDocument = gql`
    query GetEventDetailsInfo($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      timezone
      eventDateIsFinalized
      locationInfo {
        id
        name
        placeId
      }
      finalizedDate {
        dateString
      }
      tentativeDate {
        dateString
      }
    }
  }
}
    `;

/**
 * __useGetEventDetailsInfoQuery__
 *
 * To run a query within a React component, call `useGetEventDetailsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailsInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventDetailsInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventDetailsInfoQuery, GetEventDetailsInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventDetailsInfoQuery, GetEventDetailsInfoQueryVariables>(GetEventDetailsInfoDocument, baseOptions);
      }
export function useGetEventDetailsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventDetailsInfoQuery, GetEventDetailsInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventDetailsInfoQuery, GetEventDetailsInfoQueryVariables>(GetEventDetailsInfoDocument, baseOptions);
        }
export type GetEventDetailsInfoQueryHookResult = ReturnType<typeof useGetEventDetailsInfoQuery>;
export type GetEventDetailsInfoLazyQueryHookResult = ReturnType<typeof useGetEventDetailsInfoLazyQuery>;
export type GetEventDetailsInfoQueryResult = Apollo.QueryResult<GetEventDetailsInfoQuery, GetEventDetailsInfoQueryVariables>;
export const FormCustomComponentFormListByEventIdDocument = gql`
    query FormCustomComponentFormListByEventId($eventId: ID!) {
  formListByEventId(eventId: $eventId) {
    id
    title
    description
  }
}
    `;

/**
 * __useFormCustomComponentFormListByEventIdQuery__
 *
 * To run a query within a React component, call `useFormCustomComponentFormListByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentFormListByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCustomComponentFormListByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFormCustomComponentFormListByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>(FormCustomComponentFormListByEventIdDocument, baseOptions);
      }
export function useFormCustomComponentFormListByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>(FormCustomComponentFormListByEventIdDocument, baseOptions);
        }
export type FormCustomComponentFormListByEventIdQueryHookResult = ReturnType<typeof useFormCustomComponentFormListByEventIdQuery>;
export type FormCustomComponentFormListByEventIdLazyQueryHookResult = ReturnType<typeof useFormCustomComponentFormListByEventIdLazyQuery>;
export type FormCustomComponentFormListByEventIdQueryResult = Apollo.QueryResult<FormCustomComponentFormListByEventIdQuery, FormCustomComponentFormListByEventIdQueryVariables>;
export const FormCustomComponentFormByIdDocument = gql`
    query FormCustomComponentFormById($formId: ID!) {
  formById(id: $formId) {
    id
    title
    description
    schemaUrl
    config
    eventId
    type
  }
}
    `;

/**
 * __useFormCustomComponentFormByIdQuery__
 *
 * To run a query within a React component, call `useFormCustomComponentFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCustomComponentFormByIdQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormCustomComponentFormByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>(FormCustomComponentFormByIdDocument, baseOptions);
      }
export function useFormCustomComponentFormByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>(FormCustomComponentFormByIdDocument, baseOptions);
        }
export type FormCustomComponentFormByIdQueryHookResult = ReturnType<typeof useFormCustomComponentFormByIdQuery>;
export type FormCustomComponentFormByIdLazyQueryHookResult = ReturnType<typeof useFormCustomComponentFormByIdLazyQuery>;
export type FormCustomComponentFormByIdQueryResult = Apollo.QueryResult<FormCustomComponentFormByIdQuery, FormCustomComponentFormByIdQueryVariables>;
export const FormCustomComponentSubmitFormAnswersDocument = gql`
    mutation FormCustomComponentSubmitFormAnswers($input: SubmitFormAnswersInput!) {
  submitFormAnswers(input: $input) {
    id
    eventId
    title
  }
}
    `;
export type FormCustomComponentSubmitFormAnswersMutationFn = Apollo.MutationFunction<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>;

/**
 * __useFormCustomComponentSubmitFormAnswersMutation__
 *
 * To run a mutation, you first call `useFormCustomComponentSubmitFormAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCustomComponentSubmitFormAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCustomComponentSubmitFormAnswersMutation, { data, loading, error }] = useFormCustomComponentSubmitFormAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormCustomComponentSubmitFormAnswersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>) {
        return ApolloReactHooks.useMutation<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>(FormCustomComponentSubmitFormAnswersDocument, baseOptions);
      }
export type FormCustomComponentSubmitFormAnswersMutationHookResult = ReturnType<typeof useFormCustomComponentSubmitFormAnswersMutation>;
export type FormCustomComponentSubmitFormAnswersMutationResult = Apollo.MutationResult<FormCustomComponentSubmitFormAnswersMutation>;
export type FormCustomComponentSubmitFormAnswersMutationOptions = Apollo.BaseMutationOptions<FormCustomComponentSubmitFormAnswersMutation, FormCustomComponentSubmitFormAnswersMutationVariables>;
export const GeneralScheduleComponentScheduleForEventDocument = gql`
    query GeneralScheduleComponentScheduleForEvent($eventId: ID!) {
  getGuestGeneralEventScheduleForEvent(eventId: $eventId) {
    formattedSchedules {
      dateISO8601TZ
      items {
        description
        id
        name
        timezone
        startTimeISO8601TZ
        endTimeISO8601TZ
        dressCode
        location
        showMap
        placeId
        locationInfo {
          id
          placeId
          latitude
          longitude
          name
          address1
          address2
          city
          state
          country
          postalCode
        }
      }
    }
    tbaSchedules {
      description
      id
      name
      timezone
    }
  }
}
    `;

/**
 * __useGeneralScheduleComponentScheduleForEventQuery__
 *
 * To run a query within a React component, call `useGeneralScheduleComponentScheduleForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralScheduleComponentScheduleForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralScheduleComponentScheduleForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGeneralScheduleComponentScheduleForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>(GeneralScheduleComponentScheduleForEventDocument, baseOptions);
      }
export function useGeneralScheduleComponentScheduleForEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>(GeneralScheduleComponentScheduleForEventDocument, baseOptions);
        }
export type GeneralScheduleComponentScheduleForEventQueryHookResult = ReturnType<typeof useGeneralScheduleComponentScheduleForEventQuery>;
export type GeneralScheduleComponentScheduleForEventLazyQueryHookResult = ReturnType<typeof useGeneralScheduleComponentScheduleForEventLazyQuery>;
export type GeneralScheduleComponentScheduleForEventQueryResult = Apollo.QueryResult<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>;
export const JsonDataContainerByIdDocument = gql`
    query JsonDataContainerById($payload: JsonDataContainerByIdPayload!) {
  jsonDataContainerById(payload: $payload) {
    ...JsonDataContainer
  }
}
    ${JsonDataContainerFragmentDoc}`;

/**
 * __useJsonDataContainerByIdQuery__
 *
 * To run a query within a React component, call `useJsonDataContainerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJsonDataContainerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJsonDataContainerByIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useJsonDataContainerByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<JsonDataContainerByIdQuery, JsonDataContainerByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<JsonDataContainerByIdQuery, JsonDataContainerByIdQueryVariables>(JsonDataContainerByIdDocument, baseOptions);
      }
export function useJsonDataContainerByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JsonDataContainerByIdQuery, JsonDataContainerByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<JsonDataContainerByIdQuery, JsonDataContainerByIdQueryVariables>(JsonDataContainerByIdDocument, baseOptions);
        }
export type JsonDataContainerByIdQueryHookResult = ReturnType<typeof useJsonDataContainerByIdQuery>;
export type JsonDataContainerByIdLazyQueryHookResult = ReturnType<typeof useJsonDataContainerByIdLazyQuery>;
export type JsonDataContainerByIdQueryResult = Apollo.QueryResult<JsonDataContainerByIdQuery, JsonDataContainerByIdQueryVariables>;
export const EventIDByHandleDocument = gql`
    query EventIDByHandle($name: String!) {
  eventByName(name: $name) {
    id
  }
}
    `;

/**
 * __useEventIDByHandleQuery__
 *
 * To run a query within a React component, call `useEventIDByHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventIDByHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventIDByHandleQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEventIDByHandleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventIDByHandleQuery, EventIDByHandleQueryVariables>) {
        return ApolloReactHooks.useQuery<EventIDByHandleQuery, EventIDByHandleQueryVariables>(EventIDByHandleDocument, baseOptions);
      }
export function useEventIDByHandleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventIDByHandleQuery, EventIDByHandleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventIDByHandleQuery, EventIDByHandleQueryVariables>(EventIDByHandleDocument, baseOptions);
        }
export type EventIDByHandleQueryHookResult = ReturnType<typeof useEventIDByHandleQuery>;
export type EventIDByHandleLazyQueryHookResult = ReturnType<typeof useEventIDByHandleLazyQuery>;
export type EventIDByHandleQueryResult = Apollo.QueryResult<EventIDByHandleQuery, EventIDByHandleQueryVariables>;
export const UpdateJsonDataContainerDocument = gql`
    mutation UpdateJsonDataContainer($payload: UpdateJsonDataContainerPayload!) {
  updateJsonDataContainer(payload: $payload) {
    id
    eventId
    content
    type
    schemaUrl
  }
}
    `;
export type UpdateJsonDataContainerMutationFn = Apollo.MutationFunction<UpdateJsonDataContainerMutation, UpdateJsonDataContainerMutationVariables>;

/**
 * __useUpdateJsonDataContainerMutation__
 *
 * To run a mutation, you first call `useUpdateJsonDataContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJsonDataContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJsonDataContainerMutation, { data, loading, error }] = useUpdateJsonDataContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateJsonDataContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateJsonDataContainerMutation, UpdateJsonDataContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateJsonDataContainerMutation, UpdateJsonDataContainerMutationVariables>(UpdateJsonDataContainerDocument, baseOptions);
      }
export type UpdateJsonDataContainerMutationHookResult = ReturnType<typeof useUpdateJsonDataContainerMutation>;
export type UpdateJsonDataContainerMutationResult = Apollo.MutationResult<UpdateJsonDataContainerMutation>;
export type UpdateJsonDataContainerMutationOptions = Apollo.BaseMutationOptions<UpdateJsonDataContainerMutation, UpdateJsonDataContainerMutationVariables>;
export const DeleteJsonDataContainerDocument = gql`
    mutation DeleteJsonDataContainer($payload: DeleteJsonDataContainerPayload!) {
  deleteJsonDataContainer(payload: $payload)
}
    `;
export type DeleteJsonDataContainerMutationFn = Apollo.MutationFunction<DeleteJsonDataContainerMutation, DeleteJsonDataContainerMutationVariables>;

/**
 * __useDeleteJsonDataContainerMutation__
 *
 * To run a mutation, you first call `useDeleteJsonDataContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJsonDataContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJsonDataContainerMutation, { data, loading, error }] = useDeleteJsonDataContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeleteJsonDataContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteJsonDataContainerMutation, DeleteJsonDataContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteJsonDataContainerMutation, DeleteJsonDataContainerMutationVariables>(DeleteJsonDataContainerDocument, baseOptions);
      }
export type DeleteJsonDataContainerMutationHookResult = ReturnType<typeof useDeleteJsonDataContainerMutation>;
export type DeleteJsonDataContainerMutationResult = Apollo.MutationResult<DeleteJsonDataContainerMutation>;
export type DeleteJsonDataContainerMutationOptions = Apollo.BaseMutationOptions<DeleteJsonDataContainerMutation, DeleteJsonDataContainerMutationVariables>;
export const AddJsonDataBlobComponentDocument = gql`
    mutation AddJsonDataBlobComponent($payload: AddJsonDataBlobComponentPayload!) {
  addJsonDataBlobComponent(payload: $payload) {
    id
    type
    sortOrder
    jsonDataContainerId
  }
}
    `;
export type AddJsonDataBlobComponentMutationFn = Apollo.MutationFunction<AddJsonDataBlobComponentMutation, AddJsonDataBlobComponentMutationVariables>;

/**
 * __useAddJsonDataBlobComponentMutation__
 *
 * To run a mutation, you first call `useAddJsonDataBlobComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJsonDataBlobComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJsonDataBlobComponentMutation, { data, loading, error }] = useAddJsonDataBlobComponentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddJsonDataBlobComponentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddJsonDataBlobComponentMutation, AddJsonDataBlobComponentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddJsonDataBlobComponentMutation, AddJsonDataBlobComponentMutationVariables>(AddJsonDataBlobComponentDocument, baseOptions);
      }
export type AddJsonDataBlobComponentMutationHookResult = ReturnType<typeof useAddJsonDataBlobComponentMutation>;
export type AddJsonDataBlobComponentMutationResult = Apollo.MutationResult<AddJsonDataBlobComponentMutation>;
export type AddJsonDataBlobComponentMutationOptions = Apollo.BaseMutationOptions<AddJsonDataBlobComponentMutation, AddJsonDataBlobComponentMutationVariables>;
export const CreateJsonDataContainerDocument = gql`
    mutation CreateJsonDataContainer($payload: CreateJsonDataContainerPayload!) {
  createJsonDataContainer(payload: $payload) {
    id
    eventId
    content
    type
    schemaUrl
  }
}
    `;
export type CreateJsonDataContainerMutationFn = Apollo.MutationFunction<CreateJsonDataContainerMutation, CreateJsonDataContainerMutationVariables>;

/**
 * __useCreateJsonDataContainerMutation__
 *
 * To run a mutation, you first call `useCreateJsonDataContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJsonDataContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJsonDataContainerMutation, { data, loading, error }] = useCreateJsonDataContainerMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateJsonDataContainerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateJsonDataContainerMutation, CreateJsonDataContainerMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateJsonDataContainerMutation, CreateJsonDataContainerMutationVariables>(CreateJsonDataContainerDocument, baseOptions);
      }
export type CreateJsonDataContainerMutationHookResult = ReturnType<typeof useCreateJsonDataContainerMutation>;
export type CreateJsonDataContainerMutationResult = Apollo.MutationResult<CreateJsonDataContainerMutation>;
export type CreateJsonDataContainerMutationOptions = Apollo.BaseMutationOptions<CreateJsonDataContainerMutation, CreateJsonDataContainerMutationVariables>;
export const PlaceToStayAccommodationsDocument = gql`
    query PlaceToStayAccommodations($eventId: ID!, $displayLocation: AccommodationPlaceDisplayLocation) {
  event(id: $eventId) {
    __typename
    id
    accommodationPlacesForDisplayLocation(displayLocation: $displayLocation) {
      ...PlaceToStayAccommodationPlaceV2
    }
  }
}
    ${PlaceToStayAccommodationPlaceV2FragmentDoc}`;

/**
 * __usePlaceToStayAccommodationsQuery__
 *
 * To run a query within a React component, call `usePlaceToStayAccommodationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceToStayAccommodationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceToStayAccommodationsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      displayLocation: // value for 'displayLocation'
 *   },
 * });
 */
export function usePlaceToStayAccommodationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlaceToStayAccommodationsQuery, PlaceToStayAccommodationsQueryVariables>) {
        return ApolloReactHooks.useQuery<PlaceToStayAccommodationsQuery, PlaceToStayAccommodationsQueryVariables>(PlaceToStayAccommodationsDocument, baseOptions);
      }
export function usePlaceToStayAccommodationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlaceToStayAccommodationsQuery, PlaceToStayAccommodationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PlaceToStayAccommodationsQuery, PlaceToStayAccommodationsQueryVariables>(PlaceToStayAccommodationsDocument, baseOptions);
        }
export type PlaceToStayAccommodationsQueryHookResult = ReturnType<typeof usePlaceToStayAccommodationsQuery>;
export type PlaceToStayAccommodationsLazyQueryHookResult = ReturnType<typeof usePlaceToStayAccommodationsLazyQuery>;
export type PlaceToStayAccommodationsQueryResult = Apollo.QueryResult<PlaceToStayAccommodationsQuery, PlaceToStayAccommodationsQueryVariables>;
export const GetUrlMetadataDocument = gql`
    query GetUrlMetadata($input: UrlMetadataInput!) {
  urlMetadata(input: $input) {
    error {
      code
      message
      type
    }
    finalUrl
    metadata {
      title
      description
      imageUrl
      author
      publisher
      logoUrl
    }
  }
}
    `;

/**
 * __useGetUrlMetadataQuery__
 *
 * To run a query within a React component, call `useGetUrlMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlMetadataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUrlMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUrlMetadataQuery, GetUrlMetadataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUrlMetadataQuery, GetUrlMetadataQueryVariables>(GetUrlMetadataDocument, baseOptions);
      }
export function useGetUrlMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUrlMetadataQuery, GetUrlMetadataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUrlMetadataQuery, GetUrlMetadataQueryVariables>(GetUrlMetadataDocument, baseOptions);
        }
export type GetUrlMetadataQueryHookResult = ReturnType<typeof useGetUrlMetadataQuery>;
export type GetUrlMetadataLazyQueryHookResult = ReturnType<typeof useGetUrlMetadataLazyQuery>;
export type GetUrlMetadataQueryResult = Apollo.QueryResult<GetUrlMetadataQuery, GetUrlMetadataQueryVariables>;
export const VIPEditGetVipsForEventByIdDocument = gql`
    query VIPEditGetVipsForEventById($id: ID!) {
  eventById(id: $id) {
    id
    vips {
      ...Vip
    }
  }
}
    ${VipFragmentDoc}`;

/**
 * __useVIPEditGetVipsForEventByIdQuery__
 *
 * To run a query within a React component, call `useVIPEditGetVipsForEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVIPEditGetVipsForEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVIPEditGetVipsForEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVIPEditGetVipsForEventByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VIPEditGetVipsForEventByIdQuery, VIPEditGetVipsForEventByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<VIPEditGetVipsForEventByIdQuery, VIPEditGetVipsForEventByIdQueryVariables>(VIPEditGetVipsForEventByIdDocument, baseOptions);
      }
export function useVIPEditGetVipsForEventByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VIPEditGetVipsForEventByIdQuery, VIPEditGetVipsForEventByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VIPEditGetVipsForEventByIdQuery, VIPEditGetVipsForEventByIdQueryVariables>(VIPEditGetVipsForEventByIdDocument, baseOptions);
        }
export type VIPEditGetVipsForEventByIdQueryHookResult = ReturnType<typeof useVIPEditGetVipsForEventByIdQuery>;
export type VIPEditGetVipsForEventByIdLazyQueryHookResult = ReturnType<typeof useVIPEditGetVipsForEventByIdLazyQuery>;
export type VIPEditGetVipsForEventByIdQueryResult = Apollo.QueryResult<VIPEditGetVipsForEventByIdQuery, VIPEditGetVipsForEventByIdQueryVariables>;
export const VIPEditDeleteVIPDocument = gql`
    mutation VIPEditDeleteVIP($payload: DeleteVipPayload!) {
  deleteVip(payload: $payload)
}
    `;
export type VIPEditDeleteVIPMutationFn = Apollo.MutationFunction<VIPEditDeleteVIPMutation, VIPEditDeleteVIPMutationVariables>;

/**
 * __useVIPEditDeleteVIPMutation__
 *
 * To run a mutation, you first call `useVIPEditDeleteVIPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVIPEditDeleteVIPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipEditDeleteVipMutation, { data, loading, error }] = useVIPEditDeleteVIPMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useVIPEditDeleteVIPMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VIPEditDeleteVIPMutation, VIPEditDeleteVIPMutationVariables>) {
        return ApolloReactHooks.useMutation<VIPEditDeleteVIPMutation, VIPEditDeleteVIPMutationVariables>(VIPEditDeleteVIPDocument, baseOptions);
      }
export type VIPEditDeleteVIPMutationHookResult = ReturnType<typeof useVIPEditDeleteVIPMutation>;
export type VIPEditDeleteVIPMutationResult = Apollo.MutationResult<VIPEditDeleteVIPMutation>;
export type VIPEditDeleteVIPMutationOptions = Apollo.BaseMutationOptions<VIPEditDeleteVIPMutation, VIPEditDeleteVIPMutationVariables>;
export const VIPEditGetEventVipsForEventByIdDocument = gql`
    query VIPEditGetEventVipsForEventById($payload: EventVipsPayload!) {
  eventVips(payload: $payload) {
    ...Vip
  }
}
    ${VipFragmentDoc}`;

/**
 * __useVIPEditGetEventVipsForEventByIdQuery__
 *
 * To run a query within a React component, call `useVIPEditGetEventVipsForEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVIPEditGetEventVipsForEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVIPEditGetEventVipsForEventByIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useVIPEditGetEventVipsForEventByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VIPEditGetEventVipsForEventByIdQuery, VIPEditGetEventVipsForEventByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<VIPEditGetEventVipsForEventByIdQuery, VIPEditGetEventVipsForEventByIdQueryVariables>(VIPEditGetEventVipsForEventByIdDocument, baseOptions);
      }
export function useVIPEditGetEventVipsForEventByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VIPEditGetEventVipsForEventByIdQuery, VIPEditGetEventVipsForEventByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VIPEditGetEventVipsForEventByIdQuery, VIPEditGetEventVipsForEventByIdQueryVariables>(VIPEditGetEventVipsForEventByIdDocument, baseOptions);
        }
export type VIPEditGetEventVipsForEventByIdQueryHookResult = ReturnType<typeof useVIPEditGetEventVipsForEventByIdQuery>;
export type VIPEditGetEventVipsForEventByIdLazyQueryHookResult = ReturnType<typeof useVIPEditGetEventVipsForEventByIdLazyQuery>;
export type VIPEditGetEventVipsForEventByIdQueryResult = Apollo.QueryResult<VIPEditGetEventVipsForEventByIdQuery, VIPEditGetEventVipsForEventByIdQueryVariables>;
export const SetRegistryAddressDocument = gql`
    mutation SetRegistryAddress($eventId: ID!, $payload: ShippingAddressInput) {
  setRegistryAddress(eventId: $eventId, payload: $payload) {
    name
    address1
    address2
    city
    state
    phone
    postalCode
    country
    countryCode
    validated
  }
}
    `;
export type SetRegistryAddressMutationFn = Apollo.MutationFunction<SetRegistryAddressMutation, SetRegistryAddressMutationVariables>;

/**
 * __useSetRegistryAddressMutation__
 *
 * To run a mutation, you first call `useSetRegistryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRegistryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRegistryAddressMutation, { data, loading, error }] = useSetRegistryAddressMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetRegistryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRegistryAddressMutation, SetRegistryAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<SetRegistryAddressMutation, SetRegistryAddressMutationVariables>(SetRegistryAddressDocument, baseOptions);
      }
export type SetRegistryAddressMutationHookResult = ReturnType<typeof useSetRegistryAddressMutation>;
export type SetRegistryAddressMutationResult = Apollo.MutationResult<SetRegistryAddressMutation>;
export type SetRegistryAddressMutationOptions = Apollo.BaseMutationOptions<SetRegistryAddressMutation, SetRegistryAddressMutationVariables>;
export const OfferEventSuggestionsDocument = gql`
    mutation OfferEventSuggestions($eventId: ID!, $identifiers: [String!]!) {
  offerEventSuggestions(eventId: $eventId, identifiers: $identifiers) {
    ...EventSuggestion
  }
}
    ${EventSuggestionFragmentDoc}`;
export type OfferEventSuggestionsMutationFn = Apollo.MutationFunction<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>;

/**
 * __useOfferEventSuggestionsMutation__
 *
 * To run a mutation, you first call `useOfferEventSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferEventSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerEventSuggestionsMutation, { data, loading, error }] = useOfferEventSuggestionsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useOfferEventSuggestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>) {
        return ApolloReactHooks.useMutation<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>(OfferEventSuggestionsDocument, baseOptions);
      }
export type OfferEventSuggestionsMutationHookResult = ReturnType<typeof useOfferEventSuggestionsMutation>;
export type OfferEventSuggestionsMutationResult = Apollo.MutationResult<OfferEventSuggestionsMutation>;
export type OfferEventSuggestionsMutationOptions = Apollo.BaseMutationOptions<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>;
export const UpdateEventSuggestionDocument = gql`
    mutation UpdateEventSuggestion($id: ID!, $payload: UpdateEventSuggestionPayload!) {
  updateEventSuggestion(id: $id, payload: $payload) {
    ...EventSuggestion
  }
}
    ${EventSuggestionFragmentDoc}`;
export type UpdateEventSuggestionMutationFn = Apollo.MutationFunction<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>;

/**
 * __useUpdateEventSuggestionMutation__
 *
 * To run a mutation, you first call `useUpdateEventSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSuggestionMutation, { data, loading, error }] = useUpdateEventSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>(UpdateEventSuggestionDocument, baseOptions);
      }
export type UpdateEventSuggestionMutationHookResult = ReturnType<typeof useUpdateEventSuggestionMutation>;
export type UpdateEventSuggestionMutationResult = Apollo.MutationResult<UpdateEventSuggestionMutation>;
export type UpdateEventSuggestionMutationOptions = Apollo.BaseMutationOptions<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>;
export const CreateRegistryItemFromCatalogItemDocument = gql`
    mutation CreateRegistryItemFromCatalogItem($eventId: ID!, $payload: CreateRegistryItemFromCatalogItemPayload!) {
  createRegistryItemFromCatalogItem(eventId: $eventId, payload: $payload) {
    model {
      ...RegistryItem
    }
    status {
      id
    }
  }
}
    ${RegistryItemFragmentDoc}`;
export type CreateRegistryItemFromCatalogItemMutationFn = Apollo.MutationFunction<CreateRegistryItemFromCatalogItemMutation, CreateRegistryItemFromCatalogItemMutationVariables>;

/**
 * __useCreateRegistryItemFromCatalogItemMutation__
 *
 * To run a mutation, you first call `useCreateRegistryItemFromCatalogItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryItemFromCatalogItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryItemFromCatalogItemMutation, { data, loading, error }] = useCreateRegistryItemFromCatalogItemMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryItemFromCatalogItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryItemFromCatalogItemMutation, CreateRegistryItemFromCatalogItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryItemFromCatalogItemMutation, CreateRegistryItemFromCatalogItemMutationVariables>(CreateRegistryItemFromCatalogItemDocument, baseOptions);
      }
export type CreateRegistryItemFromCatalogItemMutationHookResult = ReturnType<typeof useCreateRegistryItemFromCatalogItemMutation>;
export type CreateRegistryItemFromCatalogItemMutationResult = Apollo.MutationResult<CreateRegistryItemFromCatalogItemMutation>;
export type CreateRegistryItemFromCatalogItemMutationOptions = Apollo.BaseMutationOptions<CreateRegistryItemFromCatalogItemMutation, CreateRegistryItemFromCatalogItemMutationVariables>;
export const CreateRegistryItemsFromCatalogCategoryDocument = gql`
    mutation CreateRegistryItemsFromCatalogCategory($eventId: ID!, $payload: CreateRegistryItemsFromCatalogCategoryPayload!) {
  createRegistryItemsFromCatalogCategory(eventId: $eventId, payload: $payload) {
    models {
      id
    }
  }
}
    `;
export type CreateRegistryItemsFromCatalogCategoryMutationFn = Apollo.MutationFunction<CreateRegistryItemsFromCatalogCategoryMutation, CreateRegistryItemsFromCatalogCategoryMutationVariables>;

/**
 * __useCreateRegistryItemsFromCatalogCategoryMutation__
 *
 * To run a mutation, you first call `useCreateRegistryItemsFromCatalogCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryItemsFromCatalogCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryItemsFromCatalogCategoryMutation, { data, loading, error }] = useCreateRegistryItemsFromCatalogCategoryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryItemsFromCatalogCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryItemsFromCatalogCategoryMutation, CreateRegistryItemsFromCatalogCategoryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryItemsFromCatalogCategoryMutation, CreateRegistryItemsFromCatalogCategoryMutationVariables>(CreateRegistryItemsFromCatalogCategoryDocument, baseOptions);
      }
export type CreateRegistryItemsFromCatalogCategoryMutationHookResult = ReturnType<typeof useCreateRegistryItemsFromCatalogCategoryMutation>;
export type CreateRegistryItemsFromCatalogCategoryMutationResult = Apollo.MutationResult<CreateRegistryItemsFromCatalogCategoryMutation>;
export type CreateRegistryItemsFromCatalogCategoryMutationOptions = Apollo.BaseMutationOptions<CreateRegistryItemsFromCatalogCategoryMutation, CreateRegistryItemsFromCatalogCategoryMutationVariables>;
export const CreateMatchDocument = gql`
    mutation CreateMatch($payload: CreateMatchPayload!) {
  createMatch(payload: $payload) {
    id
  }
}
    `;
export type CreateMatchMutationFn = Apollo.MutationFunction<CreateMatchMutation, CreateMatchMutationVariables>;

/**
 * __useCreateMatchMutation__
 *
 * To run a mutation, you first call `useCreateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchMutation, { data, loading, error }] = useCreateMatchMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMatchMutation, CreateMatchMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMatchMutation, CreateMatchMutationVariables>(CreateMatchDocument, baseOptions);
      }
export type CreateMatchMutationHookResult = ReturnType<typeof useCreateMatchMutation>;
export type CreateMatchMutationResult = Apollo.MutationResult<CreateMatchMutation>;
export type CreateMatchMutationOptions = Apollo.BaseMutationOptions<CreateMatchMutation, CreateMatchMutationVariables>;
export const SetRegistryCurrencyDocument = gql`
    mutation SetRegistryCurrency($eventId: ID!, $payload: EventCurrencyInput!) {
  setRegistryCurrency(eventId: $eventId, payload: $payload) {
    id
    code
    displayName
    rank
    isDefault
  }
}
    `;
export type SetRegistryCurrencyMutationFn = Apollo.MutationFunction<SetRegistryCurrencyMutation, SetRegistryCurrencyMutationVariables>;

/**
 * __useSetRegistryCurrencyMutation__
 *
 * To run a mutation, you first call `useSetRegistryCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRegistryCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRegistryCurrencyMutation, { data, loading, error }] = useSetRegistryCurrencyMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetRegistryCurrencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRegistryCurrencyMutation, SetRegistryCurrencyMutationVariables>) {
        return ApolloReactHooks.useMutation<SetRegistryCurrencyMutation, SetRegistryCurrencyMutationVariables>(SetRegistryCurrencyDocument, baseOptions);
      }
export type SetRegistryCurrencyMutationHookResult = ReturnType<typeof useSetRegistryCurrencyMutation>;
export type SetRegistryCurrencyMutationResult = Apollo.MutationResult<SetRegistryCurrencyMutation>;
export type SetRegistryCurrencyMutationOptions = Apollo.BaseMutationOptions<SetRegistryCurrencyMutation, SetRegistryCurrencyMutationVariables>;
export const CreateDonationFundDonationDocument = gql`
    mutation CreateDonationFundDonation($fundId: ID!, $amountMonetaryMinorValue: Int!, $name: String!, $email: String!, $note: String) {
  createDonationFundDonation(fundId: $fundId, amountMonetaryMinorValue: $amountMonetaryMinorValue, name: $name, email: $email, note: $note) {
    id
  }
}
    `;
export type CreateDonationFundDonationMutationFn = Apollo.MutationFunction<CreateDonationFundDonationMutation, CreateDonationFundDonationMutationVariables>;

/**
 * __useCreateDonationFundDonationMutation__
 *
 * To run a mutation, you first call `useCreateDonationFundDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationFundDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationFundDonationMutation, { data, loading, error }] = useCreateDonationFundDonationMutation({
 *   variables: {
 *      fundId: // value for 'fundId'
 *      amountMonetaryMinorValue: // value for 'amountMonetaryMinorValue'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateDonationFundDonationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDonationFundDonationMutation, CreateDonationFundDonationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDonationFundDonationMutation, CreateDonationFundDonationMutationVariables>(CreateDonationFundDonationDocument, baseOptions);
      }
export type CreateDonationFundDonationMutationHookResult = ReturnType<typeof useCreateDonationFundDonationMutation>;
export type CreateDonationFundDonationMutationResult = Apollo.MutationResult<CreateDonationFundDonationMutation>;
export type CreateDonationFundDonationMutationOptions = Apollo.BaseMutationOptions<CreateDonationFundDonationMutation, CreateDonationFundDonationMutationVariables>;
export const CreateDonationFundDonationWithResultDocument = gql`
    mutation CreateDonationFundDonationWithResult($payload: CreateDonationFundDonationInput!) {
  createDonationFundDonationWithResult(payload: $payload) {
    model {
      id
    }
    alreadyExists
    registryOrder {
      donationFundPlatformType
      id
    }
  }
}
    `;
export type CreateDonationFundDonationWithResultMutationFn = Apollo.MutationFunction<CreateDonationFundDonationWithResultMutation, CreateDonationFundDonationWithResultMutationVariables>;

/**
 * __useCreateDonationFundDonationWithResultMutation__
 *
 * To run a mutation, you first call `useCreateDonationFundDonationWithResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationFundDonationWithResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationFundDonationWithResultMutation, { data, loading, error }] = useCreateDonationFundDonationWithResultMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateDonationFundDonationWithResultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDonationFundDonationWithResultMutation, CreateDonationFundDonationWithResultMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDonationFundDonationWithResultMutation, CreateDonationFundDonationWithResultMutationVariables>(CreateDonationFundDonationWithResultDocument, baseOptions);
      }
export type CreateDonationFundDonationWithResultMutationHookResult = ReturnType<typeof useCreateDonationFundDonationWithResultMutation>;
export type CreateDonationFundDonationWithResultMutationResult = Apollo.MutationResult<CreateDonationFundDonationWithResultMutation>;
export type CreateDonationFundDonationWithResultMutationOptions = Apollo.BaseMutationOptions<CreateDonationFundDonationWithResultMutation, CreateDonationFundDonationWithResultMutationVariables>;
export const UpdateDonationFundDonationDocument = gql`
    mutation UpdateDonationFundDonation($payload: UpdateDonationFundDonationInput!) {
  updateDonationFundDonation(payload: $payload) {
    id
    platformType
    note
    amount {
      valueInMinorUnits
    }
  }
}
    `;
export type UpdateDonationFundDonationMutationFn = Apollo.MutationFunction<UpdateDonationFundDonationMutation, UpdateDonationFundDonationMutationVariables>;

/**
 * __useUpdateDonationFundDonationMutation__
 *
 * To run a mutation, you first call `useUpdateDonationFundDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationFundDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationFundDonationMutation, { data, loading, error }] = useUpdateDonationFundDonationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateDonationFundDonationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDonationFundDonationMutation, UpdateDonationFundDonationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDonationFundDonationMutation, UpdateDonationFundDonationMutationVariables>(UpdateDonationFundDonationDocument, baseOptions);
      }
export type UpdateDonationFundDonationMutationHookResult = ReturnType<typeof useUpdateDonationFundDonationMutation>;
export type UpdateDonationFundDonationMutationResult = Apollo.MutationResult<UpdateDonationFundDonationMutation>;
export type UpdateDonationFundDonationMutationOptions = Apollo.BaseMutationOptions<UpdateDonationFundDonationMutation, UpdateDonationFundDonationMutationVariables>;
export const CreateNewAdminInviteDocument = gql`
    mutation CreateNewAdminInvite($eventId: ID!, $payload: CreateNewEventAdminInvitePayload!) {
  createNewEventAdminInvite(eventId: $eventId, payload: $payload) {
    emailId
    id
    name
    status
  }
}
    `;
export type CreateNewAdminInviteMutationFn = Apollo.MutationFunction<CreateNewAdminInviteMutation, CreateNewAdminInviteMutationVariables>;

/**
 * __useCreateNewAdminInviteMutation__
 *
 * To run a mutation, you first call `useCreateNewAdminInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewAdminInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewAdminInviteMutation, { data, loading, error }] = useCreateNewAdminInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateNewAdminInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewAdminInviteMutation, CreateNewAdminInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNewAdminInviteMutation, CreateNewAdminInviteMutationVariables>(CreateNewAdminInviteDocument, baseOptions);
      }
export type CreateNewAdminInviteMutationHookResult = ReturnType<typeof useCreateNewAdminInviteMutation>;
export type CreateNewAdminInviteMutationResult = Apollo.MutationResult<CreateNewAdminInviteMutation>;
export type CreateNewAdminInviteMutationOptions = Apollo.BaseMutationOptions<CreateNewAdminInviteMutation, CreateNewAdminInviteMutationVariables>;
export const ResendEventAdminInviteDocument = gql`
    mutation ResendEventAdminInvite($eventId: ID!, $eventAdminInviteId: String!) {
  resendEventAdminInvite(eventId: $eventId, eventAdminInviteId: $eventAdminInviteId)
}
    `;
export type ResendEventAdminInviteMutationFn = Apollo.MutationFunction<ResendEventAdminInviteMutation, ResendEventAdminInviteMutationVariables>;

/**
 * __useResendEventAdminInviteMutation__
 *
 * To run a mutation, you first call `useResendEventAdminInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEventAdminInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEventAdminInviteMutation, { data, loading, error }] = useResendEventAdminInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventAdminInviteId: // value for 'eventAdminInviteId'
 *   },
 * });
 */
export function useResendEventAdminInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendEventAdminInviteMutation, ResendEventAdminInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendEventAdminInviteMutation, ResendEventAdminInviteMutationVariables>(ResendEventAdminInviteDocument, baseOptions);
      }
export type ResendEventAdminInviteMutationHookResult = ReturnType<typeof useResendEventAdminInviteMutation>;
export type ResendEventAdminInviteMutationResult = Apollo.MutationResult<ResendEventAdminInviteMutation>;
export type ResendEventAdminInviteMutationOptions = Apollo.BaseMutationOptions<ResendEventAdminInviteMutation, ResendEventAdminInviteMutationVariables>;
export const CancelEventAdminInviteDocument = gql`
    mutation CancelEventAdminInvite($eventId: ID!, $eventAdminInviteId: String!) {
  cancelEventAdminInvite(eventId: $eventId, eventAdminInviteId: $eventAdminInviteId)
}
    `;
export type CancelEventAdminInviteMutationFn = Apollo.MutationFunction<CancelEventAdminInviteMutation, CancelEventAdminInviteMutationVariables>;

/**
 * __useCancelEventAdminInviteMutation__
 *
 * To run a mutation, you first call `useCancelEventAdminInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEventAdminInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEventAdminInviteMutation, { data, loading, error }] = useCancelEventAdminInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventAdminInviteId: // value for 'eventAdminInviteId'
 *   },
 * });
 */
export function useCancelEventAdminInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelEventAdminInviteMutation, CancelEventAdminInviteMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelEventAdminInviteMutation, CancelEventAdminInviteMutationVariables>(CancelEventAdminInviteDocument, baseOptions);
      }
export type CancelEventAdminInviteMutationHookResult = ReturnType<typeof useCancelEventAdminInviteMutation>;
export type CancelEventAdminInviteMutationResult = Apollo.MutationResult<CancelEventAdminInviteMutation>;
export type CancelEventAdminInviteMutationOptions = Apollo.BaseMutationOptions<CancelEventAdminInviteMutation, CancelEventAdminInviteMutationVariables>;
export const ResendWithNewEmailDocument = gql`
    mutation ResendWithNewEmail($id: ID!, $toEmail: String!) {
  resendWithNewEmail(id: $id, toEmail: $toEmail) {
    id
    toEmail
  }
}
    `;
export type ResendWithNewEmailMutationFn = Apollo.MutationFunction<ResendWithNewEmailMutation, ResendWithNewEmailMutationVariables>;

/**
 * __useResendWithNewEmailMutation__
 *
 * To run a mutation, you first call `useResendWithNewEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWithNewEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWithNewEmailMutation, { data, loading, error }] = useResendWithNewEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      toEmail: // value for 'toEmail'
 *   },
 * });
 */
export function useResendWithNewEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendWithNewEmailMutation, ResendWithNewEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<ResendWithNewEmailMutation, ResendWithNewEmailMutationVariables>(ResendWithNewEmailDocument, baseOptions);
      }
export type ResendWithNewEmailMutationHookResult = ReturnType<typeof useResendWithNewEmailMutation>;
export type ResendWithNewEmailMutationResult = Apollo.MutationResult<ResendWithNewEmailMutation>;
export type ResendWithNewEmailMutationOptions = Apollo.BaseMutationOptions<ResendWithNewEmailMutation, ResendWithNewEmailMutationVariables>;
export const RemoveEventAdminUserDocument = gql`
    mutation RemoveEventAdminUser($eventId: ID!, $auth0Id: String!) {
  removeEventAdminUser(eventId: $eventId, auth0Id: $auth0Id)
}
    `;
export type RemoveEventAdminUserMutationFn = Apollo.MutationFunction<RemoveEventAdminUserMutation, RemoveEventAdminUserMutationVariables>;

/**
 * __useRemoveEventAdminUserMutation__
 *
 * To run a mutation, you first call `useRemoveEventAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventAdminUserMutation, { data, loading, error }] = useRemoveEventAdminUserMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      auth0Id: // value for 'auth0Id'
 *   },
 * });
 */
export function useRemoveEventAdminUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveEventAdminUserMutation, RemoveEventAdminUserMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveEventAdminUserMutation, RemoveEventAdminUserMutationVariables>(RemoveEventAdminUserDocument, baseOptions);
      }
export type RemoveEventAdminUserMutationHookResult = ReturnType<typeof useRemoveEventAdminUserMutation>;
export type RemoveEventAdminUserMutationResult = Apollo.MutationResult<RemoveEventAdminUserMutation>;
export type RemoveEventAdminUserMutationOptions = Apollo.BaseMutationOptions<RemoveEventAdminUserMutation, RemoveEventAdminUserMutationVariables>;
export const TransferEventOwnershipDocument = gql`
    mutation TransferEventOwnership($eventId: ID!, $auth0Id: String!) {
  transferEventOwnership(eventId: $eventId, auth0Id: $auth0Id)
}
    `;
export type TransferEventOwnershipMutationFn = Apollo.MutationFunction<TransferEventOwnershipMutation, TransferEventOwnershipMutationVariables>;

/**
 * __useTransferEventOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferEventOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferEventOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferEventOwnershipMutation, { data, loading, error }] = useTransferEventOwnershipMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      auth0Id: // value for 'auth0Id'
 *   },
 * });
 */
export function useTransferEventOwnershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferEventOwnershipMutation, TransferEventOwnershipMutationVariables>) {
        return ApolloReactHooks.useMutation<TransferEventOwnershipMutation, TransferEventOwnershipMutationVariables>(TransferEventOwnershipDocument, baseOptions);
      }
export type TransferEventOwnershipMutationHookResult = ReturnType<typeof useTransferEventOwnershipMutation>;
export type TransferEventOwnershipMutationResult = Apollo.MutationResult<TransferEventOwnershipMutation>;
export type TransferEventOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferEventOwnershipMutation, TransferEventOwnershipMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($eventId: ID!) {
  deleteEvent(id: $eventId)
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, baseOptions);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const CreateCollectionOnEventMatchDocument = gql`
    mutation CreateCollectionOnEventMatch($payload: CreateCollectionOnEventMatchPayload!) {
  createCollectionOnEventMatch(payload: $payload) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type CreateCollectionOnEventMatchMutationFn = Apollo.MutationFunction<CreateCollectionOnEventMatchMutation, CreateCollectionOnEventMatchMutationVariables>;

/**
 * __useCreateCollectionOnEventMatchMutation__
 *
 * To run a mutation, you first call `useCreateCollectionOnEventMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionOnEventMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionOnEventMatchMutation, { data, loading, error }] = useCreateCollectionOnEventMatchMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateCollectionOnEventMatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCollectionOnEventMatchMutation, CreateCollectionOnEventMatchMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCollectionOnEventMatchMutation, CreateCollectionOnEventMatchMutationVariables>(CreateCollectionOnEventMatchDocument, baseOptions);
      }
export type CreateCollectionOnEventMatchMutationHookResult = ReturnType<typeof useCreateCollectionOnEventMatchMutation>;
export type CreateCollectionOnEventMatchMutationResult = Apollo.MutationResult<CreateCollectionOnEventMatchMutation>;
export type CreateCollectionOnEventMatchMutationOptions = Apollo.BaseMutationOptions<CreateCollectionOnEventMatchMutation, CreateCollectionOnEventMatchMutationVariables>;
export const TrackImpactRadiusDocument = gql`
    mutation TrackImpactRadius($payload: ImpactRadiusTrackingPayload!) {
  trackImpactRadius(payload: $payload)
}
    `;
export type TrackImpactRadiusMutationFn = Apollo.MutationFunction<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>;

/**
 * __useTrackImpactRadiusMutation__
 *
 * To run a mutation, you first call `useTrackImpactRadiusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackImpactRadiusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackImpactRadiusMutation, { data, loading, error }] = useTrackImpactRadiusMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTrackImpactRadiusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>) {
        return ApolloReactHooks.useMutation<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>(TrackImpactRadiusDocument, baseOptions);
      }
export type TrackImpactRadiusMutationHookResult = ReturnType<typeof useTrackImpactRadiusMutation>;
export type TrackImpactRadiusMutationResult = Apollo.MutationResult<TrackImpactRadiusMutation>;
export type TrackImpactRadiusMutationOptions = Apollo.BaseMutationOptions<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>;
export const InstagramSyncDocument = gql`
    mutation InstagramSync($code: String!, $vendorId: String!) {
  instagramAuthorization(payload: {code: $code, vendorId: $vendorId}) {
    ...Vendor
  }
}
    ${VendorFragmentDoc}`;
export type InstagramSyncMutationFn = Apollo.MutationFunction<InstagramSyncMutation, InstagramSyncMutationVariables>;

/**
 * __useInstagramSyncMutation__
 *
 * To run a mutation, you first call `useInstagramSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstagramSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instagramSyncMutation, { data, loading, error }] = useInstagramSyncMutation({
 *   variables: {
 *      code: // value for 'code'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useInstagramSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InstagramSyncMutation, InstagramSyncMutationVariables>) {
        return ApolloReactHooks.useMutation<InstagramSyncMutation, InstagramSyncMutationVariables>(InstagramSyncDocument, baseOptions);
      }
export type InstagramSyncMutationHookResult = ReturnType<typeof useInstagramSyncMutation>;
export type InstagramSyncMutationResult = Apollo.MutationResult<InstagramSyncMutation>;
export type InstagramSyncMutationOptions = Apollo.BaseMutationOptions<InstagramSyncMutation, InstagramSyncMutationVariables>;
export const JoinEventAsPersonWithPasswordDocument = gql`
    mutation JoinEventAsPersonWithPassword($eventId: ID!, $payload: JoinEventAsPersonWithPasswordPayload!) {
  joinEventAsPersonWithPassword(eventId: $eventId, payload: $payload) {
    id
    hasUnlocked
    sessionId
  }
}
    `;
export type JoinEventAsPersonWithPasswordMutationFn = Apollo.MutationFunction<JoinEventAsPersonWithPasswordMutation, JoinEventAsPersonWithPasswordMutationVariables>;

/**
 * __useJoinEventAsPersonWithPasswordMutation__
 *
 * To run a mutation, you first call `useJoinEventAsPersonWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinEventAsPersonWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinEventAsPersonWithPasswordMutation, { data, loading, error }] = useJoinEventAsPersonWithPasswordMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useJoinEventAsPersonWithPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinEventAsPersonWithPasswordMutation, JoinEventAsPersonWithPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<JoinEventAsPersonWithPasswordMutation, JoinEventAsPersonWithPasswordMutationVariables>(JoinEventAsPersonWithPasswordDocument, baseOptions);
      }
export type JoinEventAsPersonWithPasswordMutationHookResult = ReturnType<typeof useJoinEventAsPersonWithPasswordMutation>;
export type JoinEventAsPersonWithPasswordMutationResult = Apollo.MutationResult<JoinEventAsPersonWithPasswordMutation>;
export type JoinEventAsPersonWithPasswordMutationOptions = Apollo.BaseMutationOptions<JoinEventAsPersonWithPasswordMutation, JoinEventAsPersonWithPasswordMutationVariables>;
export const DeliverRequestForPasswordDocument = gql`
    mutation DeliverRequestForPassword($payload: DeliverRequestForPasswordPayload!) {
  deliverRequestForPassword(payload: $payload)
}
    `;
export type DeliverRequestForPasswordMutationFn = Apollo.MutationFunction<DeliverRequestForPasswordMutation, DeliverRequestForPasswordMutationVariables>;

/**
 * __useDeliverRequestForPasswordMutation__
 *
 * To run a mutation, you first call `useDeliverRequestForPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverRequestForPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverRequestForPasswordMutation, { data, loading, error }] = useDeliverRequestForPasswordMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeliverRequestForPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeliverRequestForPasswordMutation, DeliverRequestForPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<DeliverRequestForPasswordMutation, DeliverRequestForPasswordMutationVariables>(DeliverRequestForPasswordDocument, baseOptions);
      }
export type DeliverRequestForPasswordMutationHookResult = ReturnType<typeof useDeliverRequestForPasswordMutation>;
export type DeliverRequestForPasswordMutationResult = Apollo.MutationResult<DeliverRequestForPasswordMutation>;
export type DeliverRequestForPasswordMutationOptions = Apollo.BaseMutationOptions<DeliverRequestForPasswordMutation, DeliverRequestForPasswordMutationVariables>;
export const SendMessageToVendorDocument = gql`
    mutation SendMessageToVendor($payload: MessageToVendorPayload!) {
  sendMessageToVendor(payload: $payload)
}
    `;
export type SendMessageToVendorMutationFn = Apollo.MutationFunction<SendMessageToVendorMutation, SendMessageToVendorMutationVariables>;

/**
 * __useSendMessageToVendorMutation__
 *
 * To run a mutation, you first call `useSendMessageToVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageToVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageToVendorMutation, { data, loading, error }] = useSendMessageToVendorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendMessageToVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMessageToVendorMutation, SendMessageToVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<SendMessageToVendorMutation, SendMessageToVendorMutationVariables>(SendMessageToVendorDocument, baseOptions);
      }
export type SendMessageToVendorMutationHookResult = ReturnType<typeof useSendMessageToVendorMutation>;
export type SendMessageToVendorMutationResult = Apollo.MutationResult<SendMessageToVendorMutation>;
export type SendMessageToVendorMutationOptions = Apollo.BaseMutationOptions<SendMessageToVendorMutation, SendMessageToVendorMutationVariables>;
export const SendMessageToMultipleVendorsDocument = gql`
    mutation SendMessageToMultipleVendors($payload: MessageToMultipleVendorsPayload!) {
  sendMessageToMultipleVendors(payload: $payload)
}
    `;
export type SendMessageToMultipleVendorsMutationFn = Apollo.MutationFunction<SendMessageToMultipleVendorsMutation, SendMessageToMultipleVendorsMutationVariables>;

/**
 * __useSendMessageToMultipleVendorsMutation__
 *
 * To run a mutation, you first call `useSendMessageToMultipleVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageToMultipleVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageToMultipleVendorsMutation, { data, loading, error }] = useSendMessageToMultipleVendorsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendMessageToMultipleVendorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMessageToMultipleVendorsMutation, SendMessageToMultipleVendorsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendMessageToMultipleVendorsMutation, SendMessageToMultipleVendorsMutationVariables>(SendMessageToMultipleVendorsDocument, baseOptions);
      }
export type SendMessageToMultipleVendorsMutationHookResult = ReturnType<typeof useSendMessageToMultipleVendorsMutation>;
export type SendMessageToMultipleVendorsMutationResult = Apollo.MutationResult<SendMessageToMultipleVendorsMutation>;
export type SendMessageToMultipleVendorsMutationOptions = Apollo.BaseMutationOptions<SendMessageToMultipleVendorsMutation, SendMessageToMultipleVendorsMutationVariables>;
export const CreateSingleRegistryItemOrderDocument = gql`
    mutation CreateSingleRegistryItemOrder($payload: CreateSingleRegistryItemOrderInput) {
  createSingleRegistryItemOrder(payload: $payload) {
    model {
      id
    }
    alreadyExists
  }
}
    `;
export type CreateSingleRegistryItemOrderMutationFn = Apollo.MutationFunction<CreateSingleRegistryItemOrderMutation, CreateSingleRegistryItemOrderMutationVariables>;

/**
 * __useCreateSingleRegistryItemOrderMutation__
 *
 * To run a mutation, you first call `useCreateSingleRegistryItemOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleRegistryItemOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleRegistryItemOrderMutation, { data, loading, error }] = useCreateSingleRegistryItemOrderMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateSingleRegistryItemOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSingleRegistryItemOrderMutation, CreateSingleRegistryItemOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSingleRegistryItemOrderMutation, CreateSingleRegistryItemOrderMutationVariables>(CreateSingleRegistryItemOrderDocument, baseOptions);
      }
export type CreateSingleRegistryItemOrderMutationHookResult = ReturnType<typeof useCreateSingleRegistryItemOrderMutation>;
export type CreateSingleRegistryItemOrderMutationResult = Apollo.MutationResult<CreateSingleRegistryItemOrderMutation>;
export type CreateSingleRegistryItemOrderMutationOptions = Apollo.BaseMutationOptions<CreateSingleRegistryItemOrderMutation, CreateSingleRegistryItemOrderMutationVariables>;
export const DeleteRegistryOrderDocument = gql`
    mutation DeleteRegistryOrder($id: ID!) {
  deleteRegistryOrder(id: $id) {
    model {
      id
    }
  }
}
    `;
export type DeleteRegistryOrderMutationFn = Apollo.MutationFunction<DeleteRegistryOrderMutation, DeleteRegistryOrderMutationVariables>;

/**
 * __useDeleteRegistryOrderMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryOrderMutation, { data, loading, error }] = useDeleteRegistryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRegistryOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRegistryOrderMutation, DeleteRegistryOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteRegistryOrderMutation, DeleteRegistryOrderMutationVariables>(DeleteRegistryOrderDocument, baseOptions);
      }
export type DeleteRegistryOrderMutationHookResult = ReturnType<typeof useDeleteRegistryOrderMutation>;
export type DeleteRegistryOrderMutationResult = Apollo.MutationResult<DeleteRegistryOrderMutation>;
export type DeleteRegistryOrderMutationOptions = Apollo.BaseMutationOptions<DeleteRegistryOrderMutation, DeleteRegistryOrderMutationVariables>;
export const SendRegistryOrderConfirmationDocument = gql`
    mutation SendRegistryOrderConfirmation($payload: SendRegistryOrderConfirmationInput!) {
  sendRegistryOrderConfirmation(payload: $payload)
}
    `;
export type SendRegistryOrderConfirmationMutationFn = Apollo.MutationFunction<SendRegistryOrderConfirmationMutation, SendRegistryOrderConfirmationMutationVariables>;

/**
 * __useSendRegistryOrderConfirmationMutation__
 *
 * To run a mutation, you first call `useSendRegistryOrderConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRegistryOrderConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRegistryOrderConfirmationMutation, { data, loading, error }] = useSendRegistryOrderConfirmationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSendRegistryOrderConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRegistryOrderConfirmationMutation, SendRegistryOrderConfirmationMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRegistryOrderConfirmationMutation, SendRegistryOrderConfirmationMutationVariables>(SendRegistryOrderConfirmationDocument, baseOptions);
      }
export type SendRegistryOrderConfirmationMutationHookResult = ReturnType<typeof useSendRegistryOrderConfirmationMutation>;
export type SendRegistryOrderConfirmationMutationResult = Apollo.MutationResult<SendRegistryOrderConfirmationMutation>;
export type SendRegistryOrderConfirmationMutationOptions = Apollo.BaseMutationOptions<SendRegistryOrderConfirmationMutation, SendRegistryOrderConfirmationMutationVariables>;
export const SendTrackingInfoRequestEmailDocument = gql`
    mutation SendTrackingInfoRequestEmail($orderId: ID!) {
  sendTrackingInfoRequestEmail(orderId: $orderId)
}
    `;
export type SendTrackingInfoRequestEmailMutationFn = Apollo.MutationFunction<SendTrackingInfoRequestEmailMutation, SendTrackingInfoRequestEmailMutationVariables>;

/**
 * __useSendTrackingInfoRequestEmailMutation__
 *
 * To run a mutation, you first call `useSendTrackingInfoRequestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTrackingInfoRequestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTrackingInfoRequestEmailMutation, { data, loading, error }] = useSendTrackingInfoRequestEmailMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendTrackingInfoRequestEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTrackingInfoRequestEmailMutation, SendTrackingInfoRequestEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendTrackingInfoRequestEmailMutation, SendTrackingInfoRequestEmailMutationVariables>(SendTrackingInfoRequestEmailDocument, baseOptions);
      }
export type SendTrackingInfoRequestEmailMutationHookResult = ReturnType<typeof useSendTrackingInfoRequestEmailMutation>;
export type SendTrackingInfoRequestEmailMutationResult = Apollo.MutationResult<SendTrackingInfoRequestEmailMutation>;
export type SendTrackingInfoRequestEmailMutationOptions = Apollo.BaseMutationOptions<SendTrackingInfoRequestEmailMutation, SendTrackingInfoRequestEmailMutationVariables>;
export const CreateRegistryPurchaseContextDocument = gql`
    mutation CreateRegistryPurchaseContext($payload: CreateRegistryPurchaseContextInput!) {
  createRegistryPurchaseContext(payload: $payload) {
    checkoutUrl
    checkoutFailureCode
    checkoutWarningCodes
  }
}
    `;
export type CreateRegistryPurchaseContextMutationFn = Apollo.MutationFunction<CreateRegistryPurchaseContextMutation, CreateRegistryPurchaseContextMutationVariables>;

/**
 * __useCreateRegistryPurchaseContextMutation__
 *
 * To run a mutation, you first call `useCreateRegistryPurchaseContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryPurchaseContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryPurchaseContextMutation, { data, loading, error }] = useCreateRegistryPurchaseContextMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryPurchaseContextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryPurchaseContextMutation, CreateRegistryPurchaseContextMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryPurchaseContextMutation, CreateRegistryPurchaseContextMutationVariables>(CreateRegistryPurchaseContextDocument, baseOptions);
      }
export type CreateRegistryPurchaseContextMutationHookResult = ReturnType<typeof useCreateRegistryPurchaseContextMutation>;
export type CreateRegistryPurchaseContextMutationResult = Apollo.MutationResult<CreateRegistryPurchaseContextMutation>;
export type CreateRegistryPurchaseContextMutationOptions = Apollo.BaseMutationOptions<CreateRegistryPurchaseContextMutation, CreateRegistryPurchaseContextMutationVariables>;
export const CreateRegistryPaymentIntentDocument = gql`
    mutation CreateRegistryPaymentIntent($payload: CreateRegistryPaymentIntentInput!) {
  createRegistryPaymentIntent(payload: $payload) {
    ... on RegistryPaymentIntent {
      status
      clientSecret
      returnUrl
    }
    ... on RegistryPaymentIntentError {
      checkoutFailureCode
      checkoutWarningCodes
    }
  }
}
    `;
export type CreateRegistryPaymentIntentMutationFn = Apollo.MutationFunction<CreateRegistryPaymentIntentMutation, CreateRegistryPaymentIntentMutationVariables>;

/**
 * __useCreateRegistryPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateRegistryPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryPaymentIntentMutation, { data, loading, error }] = useCreateRegistryPaymentIntentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryPaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryPaymentIntentMutation, CreateRegistryPaymentIntentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryPaymentIntentMutation, CreateRegistryPaymentIntentMutationVariables>(CreateRegistryPaymentIntentDocument, baseOptions);
      }
export type CreateRegistryPaymentIntentMutationHookResult = ReturnType<typeof useCreateRegistryPaymentIntentMutation>;
export type CreateRegistryPaymentIntentMutationResult = Apollo.MutationResult<CreateRegistryPaymentIntentMutation>;
export type CreateRegistryPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateRegistryPaymentIntentMutation, CreateRegistryPaymentIntentMutationVariables>;
export const AuthenticateRegistryReservationDocument = gql`
    mutation AuthenticateRegistryReservation($payload: AuthenticateRegistryReservationInput!) {
  authenticateRegistryReservation(payload: $payload) {
    isAuthenticated
  }
}
    `;
export type AuthenticateRegistryReservationMutationFn = Apollo.MutationFunction<AuthenticateRegistryReservationMutation, AuthenticateRegistryReservationMutationVariables>;

/**
 * __useAuthenticateRegistryReservationMutation__
 *
 * To run a mutation, you first call `useAuthenticateRegistryReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateRegistryReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateRegistryReservationMutation, { data, loading, error }] = useAuthenticateRegistryReservationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAuthenticateRegistryReservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateRegistryReservationMutation, AuthenticateRegistryReservationMutationVariables>) {
        return ApolloReactHooks.useMutation<AuthenticateRegistryReservationMutation, AuthenticateRegistryReservationMutationVariables>(AuthenticateRegistryReservationDocument, baseOptions);
      }
export type AuthenticateRegistryReservationMutationHookResult = ReturnType<typeof useAuthenticateRegistryReservationMutation>;
export type AuthenticateRegistryReservationMutationResult = Apollo.MutationResult<AuthenticateRegistryReservationMutation>;
export type AuthenticateRegistryReservationMutationOptions = Apollo.BaseMutationOptions<AuthenticateRegistryReservationMutation, AuthenticateRegistryReservationMutationVariables>;
export const PurchaseRegistryOrderDocument = gql`
    mutation PurchaseRegistryOrder($id: ID!) {
  purchaseRegistryOrder(id: $id) {
    model {
      id
    }
    alreadyExists
  }
}
    `;
export type PurchaseRegistryOrderMutationFn = Apollo.MutationFunction<PurchaseRegistryOrderMutation, PurchaseRegistryOrderMutationVariables>;

/**
 * __usePurchaseRegistryOrderMutation__
 *
 * To run a mutation, you first call `usePurchaseRegistryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseRegistryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseRegistryOrderMutation, { data, loading, error }] = usePurchaseRegistryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePurchaseRegistryOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PurchaseRegistryOrderMutation, PurchaseRegistryOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<PurchaseRegistryOrderMutation, PurchaseRegistryOrderMutationVariables>(PurchaseRegistryOrderDocument, baseOptions);
      }
export type PurchaseRegistryOrderMutationHookResult = ReturnType<typeof usePurchaseRegistryOrderMutation>;
export type PurchaseRegistryOrderMutationResult = Apollo.MutationResult<PurchaseRegistryOrderMutation>;
export type PurchaseRegistryOrderMutationOptions = Apollo.BaseMutationOptions<PurchaseRegistryOrderMutation, PurchaseRegistryOrderMutationVariables>;
export const ReserveRegistryOrderDocument = gql`
    mutation ReserveRegistryOrder($id: ID!) {
  reserveRegistryOrder(id: $id) {
    model {
      id
    }
    alreadyExists
  }
}
    `;
export type ReserveRegistryOrderMutationFn = Apollo.MutationFunction<ReserveRegistryOrderMutation, ReserveRegistryOrderMutationVariables>;

/**
 * __useReserveRegistryOrderMutation__
 *
 * To run a mutation, you first call `useReserveRegistryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveRegistryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveRegistryOrderMutation, { data, loading, error }] = useReserveRegistryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReserveRegistryOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReserveRegistryOrderMutation, ReserveRegistryOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<ReserveRegistryOrderMutation, ReserveRegistryOrderMutationVariables>(ReserveRegistryOrderDocument, baseOptions);
      }
export type ReserveRegistryOrderMutationHookResult = ReturnType<typeof useReserveRegistryOrderMutation>;
export type ReserveRegistryOrderMutationResult = Apollo.MutationResult<ReserveRegistryOrderMutation>;
export type ReserveRegistryOrderMutationOptions = Apollo.BaseMutationOptions<ReserveRegistryOrderMutation, ReserveRegistryOrderMutationVariables>;
export const AnnotateRegistryOrderDocument = gql`
    mutation AnnotateRegistryOrder($id: ID!, $payload: AnnotateRegistryOrderPayload!) {
  annotateRegistryOrder(id: $id, payload: $payload) {
    status {
      id
      modified
    }
    model {
      id
      note
      annotations {
        giftNote
      }
    }
  }
}
    `;
export type AnnotateRegistryOrderMutationFn = Apollo.MutationFunction<AnnotateRegistryOrderMutation, AnnotateRegistryOrderMutationVariables>;

/**
 * __useAnnotateRegistryOrderMutation__
 *
 * To run a mutation, you first call `useAnnotateRegistryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnotateRegistryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annotateRegistryOrderMutation, { data, loading, error }] = useAnnotateRegistryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAnnotateRegistryOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnnotateRegistryOrderMutation, AnnotateRegistryOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<AnnotateRegistryOrderMutation, AnnotateRegistryOrderMutationVariables>(AnnotateRegistryOrderDocument, baseOptions);
      }
export type AnnotateRegistryOrderMutationHookResult = ReturnType<typeof useAnnotateRegistryOrderMutation>;
export type AnnotateRegistryOrderMutationResult = Apollo.MutationResult<AnnotateRegistryOrderMutation>;
export type AnnotateRegistryOrderMutationOptions = Apollo.BaseMutationOptions<AnnotateRegistryOrderMutation, AnnotateRegistryOrderMutationVariables>;
export const CreateRegistryDocument = gql`
    mutation CreateRegistry($eventId: ID!, $payload: CreateRegistryPayload!) {
  createRegistry(eventId: $eventId, payload: $payload) {
    ...AdminExternalRegistry
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type CreateRegistryMutationFn = Apollo.MutationFunction<CreateRegistryMutation, CreateRegistryMutationVariables>;

/**
 * __useCreateRegistryMutation__
 *
 * To run a mutation, you first call `useCreateRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryMutation, { data, loading, error }] = useCreateRegistryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryMutation, CreateRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryMutation, CreateRegistryMutationVariables>(CreateRegistryDocument, baseOptions);
      }
export type CreateRegistryMutationHookResult = ReturnType<typeof useCreateRegistryMutation>;
export type CreateRegistryMutationResult = Apollo.MutationResult<CreateRegistryMutation>;
export type CreateRegistryMutationOptions = Apollo.BaseMutationOptions<CreateRegistryMutation, CreateRegistryMutationVariables>;
export const CreateRegistryWithResultDocument = gql`
    mutation CreateRegistryWithResult($eventId: ID!, $payload: CreateRegistryPayload!, $options: CreateRegistryOptions) {
  createRegistryWithResult(eventId: $eventId, payload: $payload, options: $options) {
    model {
      ...AdminExternalRegistry
    }
    summary {
      cannotSync
      lastSyncAt {
        timestamp
      }
    }
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type CreateRegistryWithResultMutationFn = Apollo.MutationFunction<CreateRegistryWithResultMutation, CreateRegistryWithResultMutationVariables>;

/**
 * __useCreateRegistryWithResultMutation__
 *
 * To run a mutation, you first call `useCreateRegistryWithResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryWithResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryWithResultMutation, { data, loading, error }] = useCreateRegistryWithResultMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateRegistryWithResultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryWithResultMutation, CreateRegistryWithResultMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryWithResultMutation, CreateRegistryWithResultMutationVariables>(CreateRegistryWithResultDocument, baseOptions);
      }
export type CreateRegistryWithResultMutationHookResult = ReturnType<typeof useCreateRegistryWithResultMutation>;
export type CreateRegistryWithResultMutationResult = Apollo.MutationResult<CreateRegistryWithResultMutation>;
export type CreateRegistryWithResultMutationOptions = Apollo.BaseMutationOptions<CreateRegistryWithResultMutation, CreateRegistryWithResultMutationVariables>;
export const UpdateRegistryDocument = gql`
    mutation UpdateRegistry($id: ID!, $payload: UpdateRegistryPayload!) {
  updateRegistry(id: $id, payload: $payload) {
    ...AdminExternalRegistry
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type UpdateRegistryMutationFn = Apollo.MutationFunction<UpdateRegistryMutation, UpdateRegistryMutationVariables>;

/**
 * __useUpdateRegistryMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryMutation, { data, loading, error }] = useUpdateRegistryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryMutation, UpdateRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryMutation, UpdateRegistryMutationVariables>(UpdateRegistryDocument, baseOptions);
      }
export type UpdateRegistryMutationHookResult = ReturnType<typeof useUpdateRegistryMutation>;
export type UpdateRegistryMutationResult = Apollo.MutationResult<UpdateRegistryMutation>;
export type UpdateRegistryMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryMutation, UpdateRegistryMutationVariables>;
export const UpdateRegistryWithResultDocument = gql`
    mutation UpdateRegistryWithResult($id: ID!, $payload: UpdateRegistryPayload!) {
  updateRegistryWithResult(id: $id, payload: $payload) {
    model {
      ...AdminExternalRegistry
    }
    summary {
      cannotSync
      lastSyncAt {
        timestamp
      }
    }
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type UpdateRegistryWithResultMutationFn = Apollo.MutationFunction<UpdateRegistryWithResultMutation, UpdateRegistryWithResultMutationVariables>;

/**
 * __useUpdateRegistryWithResultMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryWithResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryWithResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryWithResultMutation, { data, loading, error }] = useUpdateRegistryWithResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryWithResultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryWithResultMutation, UpdateRegistryWithResultMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryWithResultMutation, UpdateRegistryWithResultMutationVariables>(UpdateRegistryWithResultDocument, baseOptions);
      }
export type UpdateRegistryWithResultMutationHookResult = ReturnType<typeof useUpdateRegistryWithResultMutation>;
export type UpdateRegistryWithResultMutationResult = Apollo.MutationResult<UpdateRegistryWithResultMutation>;
export type UpdateRegistryWithResultMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryWithResultMutation, UpdateRegistryWithResultMutationVariables>;
export const DeleteRegistryWithResultDocument = gql`
    mutation DeleteRegistryWithResult($id: ID!) {
  deleteRegistryWithResult(id: $id) {
    status {
      id
      modified
    }
    summary {
      cannotSync
      lastSyncAt {
        timestamp
      }
    }
  }
}
    `;
export type DeleteRegistryWithResultMutationFn = Apollo.MutationFunction<DeleteRegistryWithResultMutation, DeleteRegistryWithResultMutationVariables>;

/**
 * __useDeleteRegistryWithResultMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryWithResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryWithResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryWithResultMutation, { data, loading, error }] = useDeleteRegistryWithResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRegistryWithResultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRegistryWithResultMutation, DeleteRegistryWithResultMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteRegistryWithResultMutation, DeleteRegistryWithResultMutationVariables>(DeleteRegistryWithResultDocument, baseOptions);
      }
export type DeleteRegistryWithResultMutationHookResult = ReturnType<typeof useDeleteRegistryWithResultMutation>;
export type DeleteRegistryWithResultMutationResult = Apollo.MutationResult<DeleteRegistryWithResultMutation>;
export type DeleteRegistryWithResultMutationOptions = Apollo.BaseMutationOptions<DeleteRegistryWithResultMutation, DeleteRegistryWithResultMutationVariables>;
export const UpdateRegistryNoteDocument = gql`
    mutation UpdateRegistryNote($id: ID!, $payload: UpdateEventPagePayload!) {
  updateEventPage(id: $id, payload: $payload) {
    id
    pageSubTitleV0918
  }
}
    `;
export type UpdateRegistryNoteMutationFn = Apollo.MutationFunction<UpdateRegistryNoteMutation, UpdateRegistryNoteMutationVariables>;

/**
 * __useUpdateRegistryNoteMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryNoteMutation, { data, loading, error }] = useUpdateRegistryNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryNoteMutation, UpdateRegistryNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryNoteMutation, UpdateRegistryNoteMutationVariables>(UpdateRegistryNoteDocument, baseOptions);
      }
export type UpdateRegistryNoteMutationHookResult = ReturnType<typeof useUpdateRegistryNoteMutation>;
export type UpdateRegistryNoteMutationResult = Apollo.MutationResult<UpdateRegistryNoteMutation>;
export type UpdateRegistryNoteMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryNoteMutation, UpdateRegistryNoteMutationVariables>;
export const ReorderRegistryDocument = gql`
    mutation ReorderRegistry($eventId: ID!, $payloads: [ModelReorderPayload!]!) {
  reorderRegistries(eventId: $eventId, payloads: $payloads) {
    id
  }
}
    `;
export type ReorderRegistryMutationFn = Apollo.MutationFunction<ReorderRegistryMutation, ReorderRegistryMutationVariables>;

/**
 * __useReorderRegistryMutation__
 *
 * To run a mutation, you first call `useReorderRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderRegistryMutation, { data, loading, error }] = useReorderRegistryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payloads: // value for 'payloads'
 *   },
 * });
 */
export function useReorderRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderRegistryMutation, ReorderRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<ReorderRegistryMutation, ReorderRegistryMutationVariables>(ReorderRegistryDocument, baseOptions);
      }
export type ReorderRegistryMutationHookResult = ReturnType<typeof useReorderRegistryMutation>;
export type ReorderRegistryMutationResult = Apollo.MutationResult<ReorderRegistryMutation>;
export type ReorderRegistryMutationOptions = Apollo.BaseMutationOptions<ReorderRegistryMutation, ReorderRegistryMutationVariables>;
export const UpdatePublishRegistryDocument = gql`
    mutation UpdatePublishRegistry($id: ID!, $payload: UpdateEventPagePayload!) {
  updateEventPage(id: $id, payload: $payload) {
    id
    disabled
  }
}
    `;
export type UpdatePublishRegistryMutationFn = Apollo.MutationFunction<UpdatePublishRegistryMutation, UpdatePublishRegistryMutationVariables>;

/**
 * __useUpdatePublishRegistryMutation__
 *
 * To run a mutation, you first call `useUpdatePublishRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishRegistryMutation, { data, loading, error }] = useUpdatePublishRegistryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePublishRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublishRegistryMutation, UpdatePublishRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePublishRegistryMutation, UpdatePublishRegistryMutationVariables>(UpdatePublishRegistryDocument, baseOptions);
      }
export type UpdatePublishRegistryMutationHookResult = ReturnType<typeof useUpdatePublishRegistryMutation>;
export type UpdatePublishRegistryMutationResult = Apollo.MutationResult<UpdatePublishRegistryMutation>;
export type UpdatePublishRegistryMutationOptions = Apollo.BaseMutationOptions<UpdatePublishRegistryMutation, UpdatePublishRegistryMutationVariables>;
export const RemoveRegistryPagePhotoDocument = gql`
    mutation RemoveRegistryPagePhoto($eventId: ID!) {
  removeRegistryPagePhoto(eventId: $eventId) {
    event {
      id
    }
  }
}
    `;
export type RemoveRegistryPagePhotoMutationFn = Apollo.MutationFunction<RemoveRegistryPagePhotoMutation, RemoveRegistryPagePhotoMutationVariables>;

/**
 * __useRemoveRegistryPagePhotoMutation__
 *
 * To run a mutation, you first call `useRemoveRegistryPagePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRegistryPagePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRegistryPagePhotoMutation, { data, loading, error }] = useRemoveRegistryPagePhotoMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRemoveRegistryPagePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveRegistryPagePhotoMutation, RemoveRegistryPagePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveRegistryPagePhotoMutation, RemoveRegistryPagePhotoMutationVariables>(RemoveRegistryPagePhotoDocument, baseOptions);
      }
export type RemoveRegistryPagePhotoMutationHookResult = ReturnType<typeof useRemoveRegistryPagePhotoMutation>;
export type RemoveRegistryPagePhotoMutationResult = Apollo.MutationResult<RemoveRegistryPagePhotoMutation>;
export type RemoveRegistryPagePhotoMutationOptions = Apollo.BaseMutationOptions<RemoveRegistryPagePhotoMutation, RemoveRegistryPagePhotoMutationVariables>;
export const AddRegistryPagePhotoDocument = gql`
    mutation AddRegistryPagePhoto($eventId: ID!, $assetId: String!) {
  addRegistryPagePhoto(eventId: $eventId, assetId: $assetId) {
    event {
      id
    }
    photo {
      id
      url
    }
  }
}
    `;
export type AddRegistryPagePhotoMutationFn = Apollo.MutationFunction<AddRegistryPagePhotoMutation, AddRegistryPagePhotoMutationVariables>;

/**
 * __useAddRegistryPagePhotoMutation__
 *
 * To run a mutation, you first call `useAddRegistryPagePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRegistryPagePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRegistryPagePhotoMutation, { data, loading, error }] = useAddRegistryPagePhotoMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAddRegistryPagePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRegistryPagePhotoMutation, AddRegistryPagePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddRegistryPagePhotoMutation, AddRegistryPagePhotoMutationVariables>(AddRegistryPagePhotoDocument, baseOptions);
      }
export type AddRegistryPagePhotoMutationHookResult = ReturnType<typeof useAddRegistryPagePhotoMutation>;
export type AddRegistryPagePhotoMutationResult = Apollo.MutationResult<AddRegistryPagePhotoMutation>;
export type AddRegistryPagePhotoMutationOptions = Apollo.BaseMutationOptions<AddRegistryPagePhotoMutation, AddRegistryPagePhotoMutationVariables>;
export const AddRegistryItemPhotoDocument = gql`
    mutation AddRegistryItemPhoto($id: ID!, $assetId: String!) {
  addRegistryItemPhoto(id: $id, assetId: $assetId) {
    id
    photo {
      id
      url
    }
  }
}
    `;
export type AddRegistryItemPhotoMutationFn = Apollo.MutationFunction<AddRegistryItemPhotoMutation, AddRegistryItemPhotoMutationVariables>;

/**
 * __useAddRegistryItemPhotoMutation__
 *
 * To run a mutation, you first call `useAddRegistryItemPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRegistryItemPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRegistryItemPhotoMutation, { data, loading, error }] = useAddRegistryItemPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAddRegistryItemPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRegistryItemPhotoMutation, AddRegistryItemPhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddRegistryItemPhotoMutation, AddRegistryItemPhotoMutationVariables>(AddRegistryItemPhotoDocument, baseOptions);
      }
export type AddRegistryItemPhotoMutationHookResult = ReturnType<typeof useAddRegistryItemPhotoMutation>;
export type AddRegistryItemPhotoMutationResult = Apollo.MutationResult<AddRegistryItemPhotoMutation>;
export type AddRegistryItemPhotoMutationOptions = Apollo.BaseMutationOptions<AddRegistryItemPhotoMutation, AddRegistryItemPhotoMutationVariables>;
export const UpdateRegistryItemDocument = gql`
    mutation UpdateRegistryItem($id: ID!, $payload: UpdateRegistryItemPayload!) {
  updateRegistryItem(id: $id, payload: $payload) {
    ...RegistryItem
  }
}
    ${RegistryItemFragmentDoc}`;
export type UpdateRegistryItemMutationFn = Apollo.MutationFunction<UpdateRegistryItemMutation, UpdateRegistryItemMutationVariables>;

/**
 * __useUpdateRegistryItemMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryItemMutation, { data, loading, error }] = useUpdateRegistryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryItemMutation, UpdateRegistryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryItemMutation, UpdateRegistryItemMutationVariables>(UpdateRegistryItemDocument, baseOptions);
      }
export type UpdateRegistryItemMutationHookResult = ReturnType<typeof useUpdateRegistryItemMutation>;
export type UpdateRegistryItemMutationResult = Apollo.MutationResult<UpdateRegistryItemMutation>;
export type UpdateRegistryItemMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryItemMutation, UpdateRegistryItemMutationVariables>;
export const updateRegistryItemQuantityDocument = gql`
    mutation updateRegistryItemQuantity($id: ID!, $quantity: Int!) {
  updateRegistryItemQuantity(id: $id, quantity: $quantity) {
    model {
      id
    }
  }
}
    `;
export type updateRegistryItemQuantityMutationFn = Apollo.MutationFunction<updateRegistryItemQuantityMutation, updateRegistryItemQuantityMutationVariables>;

/**
 * __useupdateRegistryItemQuantityMutation__
 *
 * To run a mutation, you first call `useupdateRegistryItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateRegistryItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryItemQuantityMutation, { data, loading, error }] = useupdateRegistryItemQuantityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useupdateRegistryItemQuantityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateRegistryItemQuantityMutation, updateRegistryItemQuantityMutationVariables>) {
        return ApolloReactHooks.useMutation<updateRegistryItemQuantityMutation, updateRegistryItemQuantityMutationVariables>(updateRegistryItemQuantityDocument, baseOptions);
      }
export type updateRegistryItemQuantityMutationHookResult = ReturnType<typeof useupdateRegistryItemQuantityMutation>;
export type updateRegistryItemQuantityMutationResult = Apollo.MutationResult<updateRegistryItemQuantityMutation>;
export type updateRegistryItemQuantityMutationOptions = Apollo.BaseMutationOptions<updateRegistryItemQuantityMutation, updateRegistryItemQuantityMutationVariables>;
export const DeleteRegistryItemDocument = gql`
    mutation DeleteRegistryItem($id: ID!) {
  deleteRegistryItem(id: $id)
}
    `;
export type DeleteRegistryItemMutationFn = Apollo.MutationFunction<DeleteRegistryItemMutation, DeleteRegistryItemMutationVariables>;

/**
 * __useDeleteRegistryItemMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryItemMutation, { data, loading, error }] = useDeleteRegistryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRegistryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRegistryItemMutation, DeleteRegistryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteRegistryItemMutation, DeleteRegistryItemMutationVariables>(DeleteRegistryItemDocument, baseOptions);
      }
export type DeleteRegistryItemMutationHookResult = ReturnType<typeof useDeleteRegistryItemMutation>;
export type DeleteRegistryItemMutationResult = Apollo.MutationResult<DeleteRegistryItemMutation>;
export type DeleteRegistryItemMutationOptions = Apollo.BaseMutationOptions<DeleteRegistryItemMutation, DeleteRegistryItemMutationVariables>;
export const CreateRegistryItemDocument = gql`
    mutation CreateRegistryItem($eventId: ID!, $payload: CreateRegistryItemPayload!) {
  createRegistryItem(eventId: $eventId, payload: $payload) {
    ...RegistryItem
  }
}
    ${RegistryItemFragmentDoc}`;
export type CreateRegistryItemMutationFn = Apollo.MutationFunction<CreateRegistryItemMutation, CreateRegistryItemMutationVariables>;

/**
 * __useCreateRegistryItemMutation__
 *
 * To run a mutation, you first call `useCreateRegistryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryItemMutation, { data, loading, error }] = useCreateRegistryItemMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryItemMutation, CreateRegistryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryItemMutation, CreateRegistryItemMutationVariables>(CreateRegistryItemDocument, baseOptions);
      }
export type CreateRegistryItemMutationHookResult = ReturnType<typeof useCreateRegistryItemMutation>;
export type CreateRegistryItemMutationResult = Apollo.MutationResult<CreateRegistryItemMutation>;
export type CreateRegistryItemMutationOptions = Apollo.BaseMutationOptions<CreateRegistryItemMutation, CreateRegistryItemMutationVariables>;
export const CreateDonationFundPlatformDocument = gql`
    mutation CreateDonationFundPlatform($eventId: ID!, $type: DonationFundPlatformTypeEnum!, $link: String, $username: String) {
  createDonationFundPlatform(eventId: $eventId, type: $type, link: $link, username: $username) {
    id
    type
    name
    link
    username
  }
}
    `;
export type CreateDonationFundPlatformMutationFn = Apollo.MutationFunction<CreateDonationFundPlatformMutation, CreateDonationFundPlatformMutationVariables>;

/**
 * __useCreateDonationFundPlatformMutation__
 *
 * To run a mutation, you first call `useCreateDonationFundPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationFundPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationFundPlatformMutation, { data, loading, error }] = useCreateDonationFundPlatformMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      type: // value for 'type'
 *      link: // value for 'link'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCreateDonationFundPlatformMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDonationFundPlatformMutation, CreateDonationFundPlatformMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDonationFundPlatformMutation, CreateDonationFundPlatformMutationVariables>(CreateDonationFundPlatformDocument, baseOptions);
      }
export type CreateDonationFundPlatformMutationHookResult = ReturnType<typeof useCreateDonationFundPlatformMutation>;
export type CreateDonationFundPlatformMutationResult = Apollo.MutationResult<CreateDonationFundPlatformMutation>;
export type CreateDonationFundPlatformMutationOptions = Apollo.BaseMutationOptions<CreateDonationFundPlatformMutation, CreateDonationFundPlatformMutationVariables>;
export const UpdateDonationFundPlatformDocument = gql`
    mutation UpdateDonationFundPlatform($id: ID!, $type: DonationFundPlatformTypeEnum!, $name: String, $link: String, $username: String) {
  updateDonationFundPlatform(id: $id, type: $type, name: $name, link: $link, username: $username) {
    id
    type
    name
    link
    username
  }
}
    `;
export type UpdateDonationFundPlatformMutationFn = Apollo.MutationFunction<UpdateDonationFundPlatformMutation, UpdateDonationFundPlatformMutationVariables>;

/**
 * __useUpdateDonationFundPlatformMutation__
 *
 * To run a mutation, you first call `useUpdateDonationFundPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationFundPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationFundPlatformMutation, { data, loading, error }] = useUpdateDonationFundPlatformMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      link: // value for 'link'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUpdateDonationFundPlatformMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDonationFundPlatformMutation, UpdateDonationFundPlatformMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDonationFundPlatformMutation, UpdateDonationFundPlatformMutationVariables>(UpdateDonationFundPlatformDocument, baseOptions);
      }
export type UpdateDonationFundPlatformMutationHookResult = ReturnType<typeof useUpdateDonationFundPlatformMutation>;
export type UpdateDonationFundPlatformMutationResult = Apollo.MutationResult<UpdateDonationFundPlatformMutation>;
export type UpdateDonationFundPlatformMutationOptions = Apollo.BaseMutationOptions<UpdateDonationFundPlatformMutation, UpdateDonationFundPlatformMutationVariables>;
export const CreateDonationFundDocument = gql`
    mutation CreateDonationFund($eventId: ID!, $fundType: CustomItemDataType!, $goalMonetaryMinorValue: Int, $suggestedDonationMonetaryMinorValue: Int, $platformId: ID, $title: String!, $url: String!, $imageUrlForImport: String, $description: String, $enforceSuggestedDonationAmount: Boolean, $donationsAreCapped: Boolean, $hideFundingGoal: Boolean, $enableCashOrCheck: Boolean!, $enableJoyCredit: Boolean!, $enableAppPlatform: Boolean!, $metadata: RegistryItemMetadata) {
  createDonationFund(eventId: $eventId, fundType: $fundType, goalMonetaryMinorValue: $goalMonetaryMinorValue, suggestedDonationMonetaryMinorValue: $suggestedDonationMonetaryMinorValue, platformId: $platformId, title: $title, url: $url, imageUrlForImport: $imageUrlForImport, description: $description, enforceSuggestedDonationAmount: $enforceSuggestedDonationAmount, donationsAreCapped: $donationsAreCapped, hideFundingGoal: $hideFundingGoal, enableCashOrCheck: $enableCashOrCheck, enableAppPlatform: $enableAppPlatform, enableJoyCredit: $enableJoyCredit, metadata: $metadata) {
    ...DonationFund
  }
}
    ${DonationFundFragmentDoc}`;
export type CreateDonationFundMutationFn = Apollo.MutationFunction<CreateDonationFundMutation, CreateDonationFundMutationVariables>;

/**
 * __useCreateDonationFundMutation__
 *
 * To run a mutation, you first call `useCreateDonationFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationFundMutation, { data, loading, error }] = useCreateDonationFundMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      fundType: // value for 'fundType'
 *      goalMonetaryMinorValue: // value for 'goalMonetaryMinorValue'
 *      suggestedDonationMonetaryMinorValue: // value for 'suggestedDonationMonetaryMinorValue'
 *      platformId: // value for 'platformId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      imageUrlForImport: // value for 'imageUrlForImport'
 *      description: // value for 'description'
 *      enforceSuggestedDonationAmount: // value for 'enforceSuggestedDonationAmount'
 *      donationsAreCapped: // value for 'donationsAreCapped'
 *      hideFundingGoal: // value for 'hideFundingGoal'
 *      enableCashOrCheck: // value for 'enableCashOrCheck'
 *      enableJoyCredit: // value for 'enableJoyCredit'
 *      enableAppPlatform: // value for 'enableAppPlatform'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateDonationFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDonationFundMutation, CreateDonationFundMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDonationFundMutation, CreateDonationFundMutationVariables>(CreateDonationFundDocument, baseOptions);
      }
export type CreateDonationFundMutationHookResult = ReturnType<typeof useCreateDonationFundMutation>;
export type CreateDonationFundMutationResult = Apollo.MutationResult<CreateDonationFundMutation>;
export type CreateDonationFundMutationOptions = Apollo.BaseMutationOptions<CreateDonationFundMutation, CreateDonationFundMutationVariables>;
export const UpdateDonationFundDocument = gql`
    mutation UpdateDonationFund($id: ID!, $fundType: CustomItemDataType, $goalMonetaryMinorValue: Int, $suggestedDonationMonetaryMinorValue: Int, $platformId: ID, $title: String!, $url: String!, $imageUrlForImport: String, $description: String, $enforceSuggestedDonationAmount: Boolean, $donationsAreCapped: Boolean, $hideFundingGoal: Boolean, $enableCashOrCheck: Boolean!, $enableAppPlatform: Boolean!, $enableJoyCredit: Boolean!, $mustHave: Boolean!) {
  updateDonationFund(id: $id, fundType: $fundType, goalMonetaryMinorValue: $goalMonetaryMinorValue, suggestedDonationMonetaryMinorValue: $suggestedDonationMonetaryMinorValue, platformId: $platformId, title: $title, url: $url, imageUrlForImport: $imageUrlForImport, description: $description, enforceSuggestedDonationAmount: $enforceSuggestedDonationAmount, donationsAreCapped: $donationsAreCapped, hideFundingGoal: $hideFundingGoal, enableCashOrCheck: $enableCashOrCheck, enableAppPlatform: $enableAppPlatform, enableJoyCredit: $enableJoyCredit, mustHave: $mustHave) {
    ...DonationFundSkipDonations
  }
}
    ${DonationFundSkipDonationsFragmentDoc}`;
export type UpdateDonationFundMutationFn = Apollo.MutationFunction<UpdateDonationFundMutation, UpdateDonationFundMutationVariables>;

/**
 * __useUpdateDonationFundMutation__
 *
 * To run a mutation, you first call `useUpdateDonationFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationFundMutation, { data, loading, error }] = useUpdateDonationFundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fundType: // value for 'fundType'
 *      goalMonetaryMinorValue: // value for 'goalMonetaryMinorValue'
 *      suggestedDonationMonetaryMinorValue: // value for 'suggestedDonationMonetaryMinorValue'
 *      platformId: // value for 'platformId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      imageUrlForImport: // value for 'imageUrlForImport'
 *      description: // value for 'description'
 *      enforceSuggestedDonationAmount: // value for 'enforceSuggestedDonationAmount'
 *      donationsAreCapped: // value for 'donationsAreCapped'
 *      hideFundingGoal: // value for 'hideFundingGoal'
 *      enableCashOrCheck: // value for 'enableCashOrCheck'
 *      enableAppPlatform: // value for 'enableAppPlatform'
 *      enableJoyCredit: // value for 'enableJoyCredit'
 *      mustHave: // value for 'mustHave'
 *   },
 * });
 */
export function useUpdateDonationFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDonationFundMutation, UpdateDonationFundMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDonationFundMutation, UpdateDonationFundMutationVariables>(UpdateDonationFundDocument, baseOptions);
      }
export type UpdateDonationFundMutationHookResult = ReturnType<typeof useUpdateDonationFundMutation>;
export type UpdateDonationFundMutationResult = Apollo.MutationResult<UpdateDonationFundMutation>;
export type UpdateDonationFundMutationOptions = Apollo.BaseMutationOptions<UpdateDonationFundMutation, UpdateDonationFundMutationVariables>;
export const AddDonationFundPhotoDocument = gql`
    mutation AddDonationFundPhoto($id: ID!, $assetId: String!) {
  addDonationFundPhoto(id: $id, assetId: $assetId) {
    ...DonationFund
  }
}
    ${DonationFundFragmentDoc}`;
export type AddDonationFundPhotoMutationFn = Apollo.MutationFunction<AddDonationFundPhotoMutation, AddDonationFundPhotoMutationVariables>;

/**
 * __useAddDonationFundPhotoMutation__
 *
 * To run a mutation, you first call `useAddDonationFundPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDonationFundPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDonationFundPhotoMutation, { data, loading, error }] = useAddDonationFundPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAddDonationFundPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDonationFundPhotoMutation, AddDonationFundPhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddDonationFundPhotoMutation, AddDonationFundPhotoMutationVariables>(AddDonationFundPhotoDocument, baseOptions);
      }
export type AddDonationFundPhotoMutationHookResult = ReturnType<typeof useAddDonationFundPhotoMutation>;
export type AddDonationFundPhotoMutationResult = Apollo.MutationResult<AddDonationFundPhotoMutation>;
export type AddDonationFundPhotoMutationOptions = Apollo.BaseMutationOptions<AddDonationFundPhotoMutation, AddDonationFundPhotoMutationVariables>;
export const DeleteDonationFundDocument = gql`
    mutation DeleteDonationFund($id: ID!) {
  deleteDonationFund(id: $id)
}
    `;
export type DeleteDonationFundMutationFn = Apollo.MutationFunction<DeleteDonationFundMutation, DeleteDonationFundMutationVariables>;

/**
 * __useDeleteDonationFundMutation__
 *
 * To run a mutation, you first call `useDeleteDonationFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDonationFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDonationFundMutation, { data, loading, error }] = useDeleteDonationFundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDonationFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDonationFundMutation, DeleteDonationFundMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDonationFundMutation, DeleteDonationFundMutationVariables>(DeleteDonationFundDocument, baseOptions);
      }
export type DeleteDonationFundMutationHookResult = ReturnType<typeof useDeleteDonationFundMutation>;
export type DeleteDonationFundMutationResult = Apollo.MutationResult<DeleteDonationFundMutation>;
export type DeleteDonationFundMutationOptions = Apollo.BaseMutationOptions<DeleteDonationFundMutation, DeleteDonationFundMutationVariables>;
export const CreateTransferredRegistryDocument = gql`
    mutation CreateTransferredRegistry($eventId: ID!, $payload: CreateRegistryPayload!, $options: TransferRegistryOptions) {
  createTransferredRegistry(eventId: $eventId, payload: $payload, options: $options) {
    registry {
      ...AdminExternalRegistry
    }
    completed
    registryEventData {
      id
      registries {
        ...AdminExternalRegistry
      }
      summary {
        lastSyncAt {
          dateString
        }
      }
    }
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type CreateTransferredRegistryMutationFn = Apollo.MutationFunction<CreateTransferredRegistryMutation, CreateTransferredRegistryMutationVariables>;

/**
 * __useCreateTransferredRegistryMutation__
 *
 * To run a mutation, you first call `useCreateTransferredRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferredRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferredRegistryMutation, { data, loading, error }] = useCreateTransferredRegistryMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateTransferredRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTransferredRegistryMutation, CreateTransferredRegistryMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTransferredRegistryMutation, CreateTransferredRegistryMutationVariables>(CreateTransferredRegistryDocument, baseOptions);
      }
export type CreateTransferredRegistryMutationHookResult = ReturnType<typeof useCreateTransferredRegistryMutation>;
export type CreateTransferredRegistryMutationResult = Apollo.MutationResult<CreateTransferredRegistryMutation>;
export type CreateTransferredRegistryMutationOptions = Apollo.BaseMutationOptions<CreateTransferredRegistryMutation, CreateTransferredRegistryMutationVariables>;
export const ConvertRegistryToTransferredDocument = gql`
    mutation ConvertRegistryToTransferred($id: ID!, $options: TransferRegistryOptions) {
  convertRegistryToTransferred(id: $id, options: $options) {
    registry {
      ...AdminExternalRegistry
    }
    completed
    registryEventData {
      id
      registries {
        ...AdminExternalRegistry
      }
      summary {
        lastSyncAt {
          dateString
        }
      }
    }
  }
}
    ${AdminExternalRegistryFragmentDoc}`;
export type ConvertRegistryToTransferredMutationFn = Apollo.MutationFunction<ConvertRegistryToTransferredMutation, ConvertRegistryToTransferredMutationVariables>;

/**
 * __useConvertRegistryToTransferredMutation__
 *
 * To run a mutation, you first call `useConvertRegistryToTransferredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertRegistryToTransferredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertRegistryToTransferredMutation, { data, loading, error }] = useConvertRegistryToTransferredMutation({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useConvertRegistryToTransferredMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertRegistryToTransferredMutation, ConvertRegistryToTransferredMutationVariables>) {
        return ApolloReactHooks.useMutation<ConvertRegistryToTransferredMutation, ConvertRegistryToTransferredMutationVariables>(ConvertRegistryToTransferredDocument, baseOptions);
      }
export type ConvertRegistryToTransferredMutationHookResult = ReturnType<typeof useConvertRegistryToTransferredMutation>;
export type ConvertRegistryToTransferredMutationResult = Apollo.MutationResult<ConvertRegistryToTransferredMutation>;
export type ConvertRegistryToTransferredMutationOptions = Apollo.BaseMutationOptions<ConvertRegistryToTransferredMutation, ConvertRegistryToTransferredMutationVariables>;
export const EndRegistrySessionDocument = gql`
    mutation EndRegistrySession {
  endRegistrySession
}
    `;
export type EndRegistrySessionMutationFn = Apollo.MutationFunction<EndRegistrySessionMutation, EndRegistrySessionMutationVariables>;

/**
 * __useEndRegistrySessionMutation__
 *
 * To run a mutation, you first call `useEndRegistrySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndRegistrySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endRegistrySessionMutation, { data, loading, error }] = useEndRegistrySessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndRegistrySessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EndRegistrySessionMutation, EndRegistrySessionMutationVariables>) {
        return ApolloReactHooks.useMutation<EndRegistrySessionMutation, EndRegistrySessionMutationVariables>(EndRegistrySessionDocument, baseOptions);
      }
export type EndRegistrySessionMutationHookResult = ReturnType<typeof useEndRegistrySessionMutation>;
export type EndRegistrySessionMutationResult = Apollo.MutationResult<EndRegistrySessionMutation>;
export type EndRegistrySessionMutationOptions = Apollo.BaseMutationOptions<EndRegistrySessionMutation, EndRegistrySessionMutationVariables>;
export const UpdateDonationFundHideGiftDocument = gql`
    mutation UpdateDonationFundHideGift($id: ID!, $isHidden: Boolean!) {
  updateDonationFund(id: $id, isHidden: $isHidden) {
    ...DonationFundSkipDonations
  }
}
    ${DonationFundSkipDonationsFragmentDoc}`;
export type UpdateDonationFundHideGiftMutationFn = Apollo.MutationFunction<UpdateDonationFundHideGiftMutation, UpdateDonationFundHideGiftMutationVariables>;

/**
 * __useUpdateDonationFundHideGiftMutation__
 *
 * To run a mutation, you first call `useUpdateDonationFundHideGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationFundHideGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationFundHideGiftMutation, { data, loading, error }] = useUpdateDonationFundHideGiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useUpdateDonationFundHideGiftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDonationFundHideGiftMutation, UpdateDonationFundHideGiftMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDonationFundHideGiftMutation, UpdateDonationFundHideGiftMutationVariables>(UpdateDonationFundHideGiftDocument, baseOptions);
      }
export type UpdateDonationFundHideGiftMutationHookResult = ReturnType<typeof useUpdateDonationFundHideGiftMutation>;
export type UpdateDonationFundHideGiftMutationResult = Apollo.MutationResult<UpdateDonationFundHideGiftMutation>;
export type UpdateDonationFundHideGiftMutationOptions = Apollo.BaseMutationOptions<UpdateDonationFundHideGiftMutation, UpdateDonationFundHideGiftMutationVariables>;
export const UpdateRegistrySettingsDialogDataDocument = gql`
    mutation UpdateRegistrySettingsDialogData($eventId: ID!, $updateEventSettingsPayload: UpdateEventSettingsPayload!, $updateEventInfoPayload: UpdateEventInfoPayload!, $website: String!) {
  updateEventSettings(eventId: $eventId, payload: $updateEventSettingsPayload) {
    id
    hideFromJoySearch
  }
  updateEventInfo(eventId: $eventId, payload: $updateEventInfoPayload) {
    id
    fianceeFirstName
    fianceeLastName
    ownerFirstName
    ownerLastName
    timezone
    finalizedDate {
      dateString
      milliseconds
      timezone
      timestamp
    }
    eventDateIsFinalized
  }
  updateWebsiteHandle(id: $eventId, website: $website) {
    id
    website
  }
}
    `;
export type UpdateRegistrySettingsDialogDataMutationFn = Apollo.MutationFunction<UpdateRegistrySettingsDialogDataMutation, UpdateRegistrySettingsDialogDataMutationVariables>;

/**
 * __useUpdateRegistrySettingsDialogDataMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrySettingsDialogDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrySettingsDialogDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistrySettingsDialogDataMutation, { data, loading, error }] = useUpdateRegistrySettingsDialogDataMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      updateEventSettingsPayload: // value for 'updateEventSettingsPayload'
 *      updateEventInfoPayload: // value for 'updateEventInfoPayload'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUpdateRegistrySettingsDialogDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistrySettingsDialogDataMutation, UpdateRegistrySettingsDialogDataMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistrySettingsDialogDataMutation, UpdateRegistrySettingsDialogDataMutationVariables>(UpdateRegistrySettingsDialogDataDocument, baseOptions);
      }
export type UpdateRegistrySettingsDialogDataMutationHookResult = ReturnType<typeof useUpdateRegistrySettingsDialogDataMutation>;
export type UpdateRegistrySettingsDialogDataMutationResult = Apollo.MutationResult<UpdateRegistrySettingsDialogDataMutation>;
export type UpdateRegistrySettingsDialogDataMutationOptions = Apollo.BaseMutationOptions<UpdateRegistrySettingsDialogDataMutation, UpdateRegistrySettingsDialogDataMutationVariables>;
export const UpdateRegistrySettingsDialogDataWithoutWebsiteDocument = gql`
    mutation UpdateRegistrySettingsDialogDataWithoutWebsite($eventId: ID!, $updateEventSettingsPayload: UpdateEventSettingsPayload!, $updateEventInfoPayload: UpdateEventInfoPayload!) {
  updateEventSettings(eventId: $eventId, payload: $updateEventSettingsPayload) {
    id
    hideFromJoySearch
  }
  updateEventInfo(eventId: $eventId, payload: $updateEventInfoPayload) {
    id
    fianceeFirstName
    fianceeLastName
    ownerFirstName
    ownerLastName
    timezone
    finalizedDate {
      dateString
      milliseconds
      timezone
      timestamp
    }
    eventDateIsFinalized
  }
}
    `;
export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutationFn = Apollo.MutationFunction<UpdateRegistrySettingsDialogDataWithoutWebsiteMutation, UpdateRegistrySettingsDialogDataWithoutWebsiteMutationVariables>;

/**
 * __useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistrySettingsDialogDataWithoutWebsiteMutation, { data, loading, error }] = useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      updateEventSettingsPayload: // value for 'updateEventSettingsPayload'
 *      updateEventInfoPayload: // value for 'updateEventInfoPayload'
 *   },
 * });
 */
export function useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistrySettingsDialogDataWithoutWebsiteMutation, UpdateRegistrySettingsDialogDataWithoutWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistrySettingsDialogDataWithoutWebsiteMutation, UpdateRegistrySettingsDialogDataWithoutWebsiteMutationVariables>(UpdateRegistrySettingsDialogDataWithoutWebsiteDocument, baseOptions);
      }
export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutationHookResult = ReturnType<typeof useUpdateRegistrySettingsDialogDataWithoutWebsiteMutation>;
export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutationResult = Apollo.MutationResult<UpdateRegistrySettingsDialogDataWithoutWebsiteMutation>;
export type UpdateRegistrySettingsDialogDataWithoutWebsiteMutationOptions = Apollo.BaseMutationOptions<UpdateRegistrySettingsDialogDataWithoutWebsiteMutation, UpdateRegistrySettingsDialogDataWithoutWebsiteMutationVariables>;
export const UpdatePageVisibilityDocument = gql`
    mutation UpdatePageVisibility($id: ID!, $payload: UpdateEventPagePayload!) {
  updateEventPage(id: $id, payload: $payload) {
    id
    disabled
    private
    visibility
  }
}
    `;
export type UpdatePageVisibilityMutationFn = Apollo.MutationFunction<UpdatePageVisibilityMutation, UpdatePageVisibilityMutationVariables>;

/**
 * __useUpdatePageVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdatePageVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageVisibilityMutation, { data, loading, error }] = useUpdatePageVisibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePageVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageVisibilityMutation, UpdatePageVisibilityMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePageVisibilityMutation, UpdatePageVisibilityMutationVariables>(UpdatePageVisibilityDocument, baseOptions);
      }
export type UpdatePageVisibilityMutationHookResult = ReturnType<typeof useUpdatePageVisibilityMutation>;
export type UpdatePageVisibilityMutationResult = Apollo.MutationResult<UpdatePageVisibilityMutation>;
export type UpdatePageVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdatePageVisibilityMutation, UpdatePageVisibilityMutationVariables>;
export const UpdateEventPasswordDocument = gql`
    mutation UpdateEventPassword($eventId: ID!, $eventPassword: String) {
  updateEventPassword(eventId: $eventId, eventPassword: $eventPassword)
}
    `;
export type UpdateEventPasswordMutationFn = Apollo.MutationFunction<UpdateEventPasswordMutation, UpdateEventPasswordMutationVariables>;

/**
 * __useUpdateEventPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateEventPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventPasswordMutation, { data, loading, error }] = useUpdateEventPasswordMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventPassword: // value for 'eventPassword'
 *   },
 * });
 */
export function useUpdateEventPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventPasswordMutation, UpdateEventPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventPasswordMutation, UpdateEventPasswordMutationVariables>(UpdateEventPasswordDocument, baseOptions);
      }
export type UpdateEventPasswordMutationHookResult = ReturnType<typeof useUpdateEventPasswordMutation>;
export type UpdateEventPasswordMutationResult = Apollo.MutationResult<UpdateEventPasswordMutation>;
export type UpdateEventPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateEventPasswordMutation, UpdateEventPasswordMutationVariables>;
export const SetEventPageAssetDocument = gql`
    mutation SetEventPageAsset($id: ID!, $payload: SetAssetPayload!) {
  setEventPageAsset(id: $id, payload: $payload) {
    id
    photoV2 {
      ... on Photo {
        id
        url
      }
      ... on DefaultPagePhoto {
        id
        url
      }
    }
  }
}
    `;
export type SetEventPageAssetMutationFn = Apollo.MutationFunction<SetEventPageAssetMutation, SetEventPageAssetMutationVariables>;

/**
 * __useSetEventPageAssetMutation__
 *
 * To run a mutation, you first call `useSetEventPageAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPageAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPageAssetMutation, { data, loading, error }] = useSetEventPageAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPageAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPageAssetMutation, SetEventPageAssetMutationVariables>) {
        return ApolloReactHooks.useMutation<SetEventPageAssetMutation, SetEventPageAssetMutationVariables>(SetEventPageAssetDocument, baseOptions);
      }
export type SetEventPageAssetMutationHookResult = ReturnType<typeof useSetEventPageAssetMutation>;
export type SetEventPageAssetMutationResult = Apollo.MutationResult<SetEventPageAssetMutation>;
export type SetEventPageAssetMutationOptions = Apollo.BaseMutationOptions<SetEventPageAssetMutation, SetEventPageAssetMutationVariables>;
export const RemoveEventPagePhotoDocument = gql`
    mutation RemoveEventPagePhoto($eventPageId: ID!) {
  removeEventPagePhoto(eventPageId: $eventPageId)
}
    `;
export type RemoveEventPagePhotoMutationFn = Apollo.MutationFunction<RemoveEventPagePhotoMutation, RemoveEventPagePhotoMutationVariables>;

/**
 * __useRemoveEventPagePhotoMutation__
 *
 * To run a mutation, you first call `useRemoveEventPagePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventPagePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventPagePhotoMutation, { data, loading, error }] = useRemoveEventPagePhotoMutation({
 *   variables: {
 *      eventPageId: // value for 'eventPageId'
 *   },
 * });
 */
export function useRemoveEventPagePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveEventPagePhotoMutation, RemoveEventPagePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveEventPagePhotoMutation, RemoveEventPagePhotoMutationVariables>(RemoveEventPagePhotoDocument, baseOptions);
      }
export type RemoveEventPagePhotoMutationHookResult = ReturnType<typeof useRemoveEventPagePhotoMutation>;
export type RemoveEventPagePhotoMutationResult = Apollo.MutationResult<RemoveEventPagePhotoMutation>;
export type RemoveEventPagePhotoMutationOptions = Apollo.BaseMutationOptions<RemoveEventPagePhotoMutation, RemoveEventPagePhotoMutationVariables>;
export const CreateRegistryPayoutAccountDocument = gql`
    mutation CreateRegistryPayoutAccount($eventId: ID!, $returnRoute: String, $payload: CreateRegistryPayoutAccountInput) {
  createRegistryPayoutAccount(eventId: $eventId, payload: $payload) {
    ... on RegistryPayoutAccount {
      status
      statusDetails
      onboardingUrl(params: {returnRoute: $returnRoute})
    }
    ... on RegistryErrorResult {
      ...RegistryErrorResult
    }
  }
}
    ${RegistryErrorResultFragmentDoc}`;
export type CreateRegistryPayoutAccountMutationFn = Apollo.MutationFunction<CreateRegistryPayoutAccountMutation, CreateRegistryPayoutAccountMutationVariables>;

/**
 * __useCreateRegistryPayoutAccountMutation__
 *
 * To run a mutation, you first call `useCreateRegistryPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryPayoutAccountMutation, { data, loading, error }] = useCreateRegistryPayoutAccountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      returnRoute: // value for 'returnRoute'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateRegistryPayoutAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryPayoutAccountMutation, CreateRegistryPayoutAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRegistryPayoutAccountMutation, CreateRegistryPayoutAccountMutationVariables>(CreateRegistryPayoutAccountDocument, baseOptions);
      }
export type CreateRegistryPayoutAccountMutationHookResult = ReturnType<typeof useCreateRegistryPayoutAccountMutation>;
export type CreateRegistryPayoutAccountMutationResult = Apollo.MutationResult<CreateRegistryPayoutAccountMutation>;
export type CreateRegistryPayoutAccountMutationOptions = Apollo.BaseMutationOptions<CreateRegistryPayoutAccountMutation, CreateRegistryPayoutAccountMutationVariables>;
export const WithdrawFromPayoutAccountDocument = gql`
    mutation WithdrawFromPayoutAccount($eventId: ID!) {
  withdrawFromPayoutAccount(eventId: $eventId) {
    url
    status
  }
}
    `;
export type WithdrawFromPayoutAccountMutationFn = Apollo.MutationFunction<WithdrawFromPayoutAccountMutation, WithdrawFromPayoutAccountMutationVariables>;

/**
 * __useWithdrawFromPayoutAccountMutation__
 *
 * To run a mutation, you first call `useWithdrawFromPayoutAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFromPayoutAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawFromPayoutAccountMutation, { data, loading, error }] = useWithdrawFromPayoutAccountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWithdrawFromPayoutAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WithdrawFromPayoutAccountMutation, WithdrawFromPayoutAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<WithdrawFromPayoutAccountMutation, WithdrawFromPayoutAccountMutationVariables>(WithdrawFromPayoutAccountDocument, baseOptions);
      }
export type WithdrawFromPayoutAccountMutationHookResult = ReturnType<typeof useWithdrawFromPayoutAccountMutation>;
export type WithdrawFromPayoutAccountMutationResult = Apollo.MutationResult<WithdrawFromPayoutAccountMutation>;
export type WithdrawFromPayoutAccountMutationOptions = Apollo.BaseMutationOptions<WithdrawFromPayoutAccountMutation, WithdrawFromPayoutAccountMutationVariables>;
export const ResetRegistryOrderShippingAddressDocument = gql`
    mutation ResetRegistryOrderShippingAddress($orders: [ID!]!) {
  resetRegistryOrderShippingAddress(registryOrderIds: $orders)
}
    `;
export type ResetRegistryOrderShippingAddressMutationFn = Apollo.MutationFunction<ResetRegistryOrderShippingAddressMutation, ResetRegistryOrderShippingAddressMutationVariables>;

/**
 * __useResetRegistryOrderShippingAddressMutation__
 *
 * To run a mutation, you first call `useResetRegistryOrderShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRegistryOrderShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRegistryOrderShippingAddressMutation, { data, loading, error }] = useResetRegistryOrderShippingAddressMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useResetRegistryOrderShippingAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetRegistryOrderShippingAddressMutation, ResetRegistryOrderShippingAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetRegistryOrderShippingAddressMutation, ResetRegistryOrderShippingAddressMutationVariables>(ResetRegistryOrderShippingAddressDocument, baseOptions);
      }
export type ResetRegistryOrderShippingAddressMutationHookResult = ReturnType<typeof useResetRegistryOrderShippingAddressMutation>;
export type ResetRegistryOrderShippingAddressMutationResult = Apollo.MutationResult<ResetRegistryOrderShippingAddressMutation>;
export type ResetRegistryOrderShippingAddressMutationOptions = Apollo.BaseMutationOptions<ResetRegistryOrderShippingAddressMutation, ResetRegistryOrderShippingAddressMutationVariables>;
export const CancelRegistryOrdersDocument = gql`
    mutation CancelRegistryOrders($orders: [RegistryOrderCancelInput!]!) {
  cancelRegistryOrders(ordersToCancel: $orders)
}
    `;
export type CancelRegistryOrdersMutationFn = Apollo.MutationFunction<CancelRegistryOrdersMutation, CancelRegistryOrdersMutationVariables>;

/**
 * __useCancelRegistryOrdersMutation__
 *
 * To run a mutation, you first call `useCancelRegistryOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRegistryOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRegistryOrdersMutation, { data, loading, error }] = useCancelRegistryOrdersMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useCancelRegistryOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelRegistryOrdersMutation, CancelRegistryOrdersMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelRegistryOrdersMutation, CancelRegistryOrdersMutationVariables>(CancelRegistryOrdersDocument, baseOptions);
      }
export type CancelRegistryOrdersMutationHookResult = ReturnType<typeof useCancelRegistryOrdersMutation>;
export type CancelRegistryOrdersMutationResult = Apollo.MutationResult<CancelRegistryOrdersMutation>;
export type CancelRegistryOrdersMutationOptions = Apollo.BaseMutationOptions<CancelRegistryOrdersMutation, CancelRegistryOrdersMutationVariables>;
export const SetPhotoAlignmentDocument = gql`
    mutation SetPhotoAlignment($eventId: String!, $photoAlignmentPayload: SetPhotoAlignmentPayload!, $photoPresentationPayload: websiteCreateOrUpdatePagePhotoPresentationPayload!) {
  setPhotoAlignment(eventId: $eventId, payload: $photoAlignmentPayload) {
    ...PhotoData
  }
  websiteCreateOrUpdatePagePhotoPresentation(payload: $photoPresentationPayload) {
    ... on websiteCreateOrUpdatePagePhotoPresentationResponse {
      message
      photoPresentation {
        ...WebsitePagePhotoPresentation
        photo {
          ...PhotoData
        }
      }
      success
    }
    ... on websiteCreateOrUpdatePagePhotoPresentationResponseError {
      id
      message
      pageId
      success
    }
  }
}
    ${PhotoDataFragmentDoc}
${WebsitePagePhotoPresentationFragmentDoc}`;
export type SetPhotoAlignmentMutationFn = Apollo.MutationFunction<SetPhotoAlignmentMutation, SetPhotoAlignmentMutationVariables>;

/**
 * __useSetPhotoAlignmentMutation__
 *
 * To run a mutation, you first call `useSetPhotoAlignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPhotoAlignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPhotoAlignmentMutation, { data, loading, error }] = useSetPhotoAlignmentMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      photoAlignmentPayload: // value for 'photoAlignmentPayload'
 *      photoPresentationPayload: // value for 'photoPresentationPayload'
 *   },
 * });
 */
export function useSetPhotoAlignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPhotoAlignmentMutation, SetPhotoAlignmentMutationVariables>) {
        return ApolloReactHooks.useMutation<SetPhotoAlignmentMutation, SetPhotoAlignmentMutationVariables>(SetPhotoAlignmentDocument, baseOptions);
      }
export type SetPhotoAlignmentMutationHookResult = ReturnType<typeof useSetPhotoAlignmentMutation>;
export type SetPhotoAlignmentMutationResult = Apollo.MutationResult<SetPhotoAlignmentMutation>;
export type SetPhotoAlignmentMutationOptions = Apollo.BaseMutationOptions<SetPhotoAlignmentMutation, SetPhotoAlignmentMutationVariables>;
export const SetPageContainerPhotoAlignmentDocument = gql`
    mutation SetPageContainerPhotoAlignment($photoAlignmentPayload: PageContainerUpdatePayload!) {
  updatePageContainer(payload: $photoAlignmentPayload) {
    id
    mainPhotoV2 {
      ...CustomPageMainPhotoV2
    }
    mainPhotoAlignment {
      x
      y
    }
    ...CustomPagePhotoPresentationInfo
  }
}
    ${CustomPageMainPhotoV2FragmentDoc}
${CustomPagePhotoPresentationInfoFragmentDoc}`;
export type SetPageContainerPhotoAlignmentMutationFn = Apollo.MutationFunction<SetPageContainerPhotoAlignmentMutation, SetPageContainerPhotoAlignmentMutationVariables>;

/**
 * __useSetPageContainerPhotoAlignmentMutation__
 *
 * To run a mutation, you first call `useSetPageContainerPhotoAlignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPageContainerPhotoAlignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPageContainerPhotoAlignmentMutation, { data, loading, error }] = useSetPageContainerPhotoAlignmentMutation({
 *   variables: {
 *      photoAlignmentPayload: // value for 'photoAlignmentPayload'
 *   },
 * });
 */
export function useSetPageContainerPhotoAlignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPageContainerPhotoAlignmentMutation, SetPageContainerPhotoAlignmentMutationVariables>) {
        return ApolloReactHooks.useMutation<SetPageContainerPhotoAlignmentMutation, SetPageContainerPhotoAlignmentMutationVariables>(SetPageContainerPhotoAlignmentDocument, baseOptions);
      }
export type SetPageContainerPhotoAlignmentMutationHookResult = ReturnType<typeof useSetPageContainerPhotoAlignmentMutation>;
export type SetPageContainerPhotoAlignmentMutationResult = Apollo.MutationResult<SetPageContainerPhotoAlignmentMutation>;
export type SetPageContainerPhotoAlignmentMutationOptions = Apollo.BaseMutationOptions<SetPageContainerPhotoAlignmentMutation, SetPageContainerPhotoAlignmentMutationVariables>;
export const SetPresetTemplateAndPublishDocument = gql`
    mutation SetPresetTemplateAndPublish($themeAndLayoutPayload: SetThemeAndLayoutPayload!, $fontPayload: SetFontPayload!, $eventDesignId: ID!) {
  setThemeAndLayout(payload: $themeAndLayoutPayload) {
    id
    hasUnpublishedChanges
    websiteLayout {
      id
      layoutType
    }
    theme {
      id
      themeId
    }
  }
  setFont(payload: $fontPayload) {
    id
    hasUnpublishedChanges
    font {
      id
    }
  }
  publishEventDesignDraft(id: $eventDesignId) {
    id
  }
}
    `;
export type SetPresetTemplateAndPublishMutationFn = Apollo.MutationFunction<SetPresetTemplateAndPublishMutation, SetPresetTemplateAndPublishMutationVariables>;

/**
 * __useSetPresetTemplateAndPublishMutation__
 *
 * To run a mutation, you first call `useSetPresetTemplateAndPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPresetTemplateAndPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPresetTemplateAndPublishMutation, { data, loading, error }] = useSetPresetTemplateAndPublishMutation({
 *   variables: {
 *      themeAndLayoutPayload: // value for 'themeAndLayoutPayload'
 *      fontPayload: // value for 'fontPayload'
 *      eventDesignId: // value for 'eventDesignId'
 *   },
 * });
 */
export function useSetPresetTemplateAndPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPresetTemplateAndPublishMutation, SetPresetTemplateAndPublishMutationVariables>) {
        return ApolloReactHooks.useMutation<SetPresetTemplateAndPublishMutation, SetPresetTemplateAndPublishMutationVariables>(SetPresetTemplateAndPublishDocument, baseOptions);
      }
export type SetPresetTemplateAndPublishMutationHookResult = ReturnType<typeof useSetPresetTemplateAndPublishMutation>;
export type SetPresetTemplateAndPublishMutationResult = Apollo.MutationResult<SetPresetTemplateAndPublishMutation>;
export type SetPresetTemplateAndPublishMutationOptions = Apollo.BaseMutationOptions<SetPresetTemplateAndPublishMutation, SetPresetTemplateAndPublishMutationVariables>;
export const UpdateTravelSettingsDocument = gql`
    mutation UpdateTravelSettings($payload: UpdateTravelSettingsRequest!) {
  updateTravelSettings(payload: $payload) {
    currencyCode
    checkInDate
    checkOutDate
    datesMatchingReminder
  }
}
    `;
export type UpdateTravelSettingsMutationFn = Apollo.MutationFunction<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>;

/**
 * __useUpdateTravelSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTravelSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelSettingsMutation, { data, loading, error }] = useUpdateTravelSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTravelSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>(UpdateTravelSettingsDocument, baseOptions);
      }
export type UpdateTravelSettingsMutationHookResult = ReturnType<typeof useUpdateTravelSettingsMutation>;
export type UpdateTravelSettingsMutationResult = Apollo.MutationResult<UpdateTravelSettingsMutation>;
export type UpdateTravelSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>;
export const UpdateEventDomainDocument = gql`
    mutation UpdateEventDomain($eventId: ID!, $payload: UpdateEventDomainPayload!) {
  updateEventDomain(eventId: $eventId, payload: $payload) {
    id
    domainName
  }
}
    `;
export type UpdateEventDomainMutationFn = Apollo.MutationFunction<UpdateEventDomainMutation, UpdateEventDomainMutationVariables>;

/**
 * __useUpdateEventDomainMutation__
 *
 * To run a mutation, you first call `useUpdateEventDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDomainMutation, { data, loading, error }] = useUpdateEventDomainMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDomainMutation, UpdateEventDomainMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventDomainMutation, UpdateEventDomainMutationVariables>(UpdateEventDomainDocument, baseOptions);
      }
export type UpdateEventDomainMutationHookResult = ReturnType<typeof useUpdateEventDomainMutation>;
export type UpdateEventDomainMutationResult = Apollo.MutationResult<UpdateEventDomainMutation>;
export type UpdateEventDomainMutationOptions = Apollo.BaseMutationOptions<UpdateEventDomainMutation, UpdateEventDomainMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($payload: UpdateVendor!) {
  updateVendor(payload: $payload) {
    ...Vendor
  }
}
    ${VendorFragmentDoc}`;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, baseOptions);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const UploadPhotoToCollectionDocument = gql`
    mutation UploadPhotoToCollection($containerId: String!, $assetId: String!, $collectionId: String!, $vendorIdsToTag: [String!]) {
  uploadPhotoToCollection(containerId: $containerId, assetId: $assetId, collectionId: $collectionId, vendorIdsToTag: $vendorIdsToTag) {
    id
    url
    width
    height
  }
}
    `;
export type UploadPhotoToCollectionMutationFn = Apollo.MutationFunction<UploadPhotoToCollectionMutation, UploadPhotoToCollectionMutationVariables>;

/**
 * __useUploadPhotoToCollectionMutation__
 *
 * To run a mutation, you first call `useUploadPhotoToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotoToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotoToCollectionMutation, { data, loading, error }] = useUploadPhotoToCollectionMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *      assetId: // value for 'assetId'
 *      collectionId: // value for 'collectionId'
 *      vendorIdsToTag: // value for 'vendorIdsToTag'
 *   },
 * });
 */
export function useUploadPhotoToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadPhotoToCollectionMutation, UploadPhotoToCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadPhotoToCollectionMutation, UploadPhotoToCollectionMutationVariables>(UploadPhotoToCollectionDocument, baseOptions);
      }
export type UploadPhotoToCollectionMutationHookResult = ReturnType<typeof useUploadPhotoToCollectionMutation>;
export type UploadPhotoToCollectionMutationResult = Apollo.MutationResult<UploadPhotoToCollectionMutation>;
export type UploadPhotoToCollectionMutationOptions = Apollo.BaseMutationOptions<UploadPhotoToCollectionMutation, UploadPhotoToCollectionMutationVariables>;
export const UploadPhotosToCollectionDocument = gql`
    mutation UploadPhotosToCollection($containerId: String!, $assetIds: [String!]!, $collectionId: String!, $vendorIdsToTag: [String!]) {
  uploadPhotosToCollection(containerId: $containerId, assetIds: $assetIds, collectionId: $collectionId, vendorIdsToTag: $vendorIdsToTag) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type UploadPhotosToCollectionMutationFn = Apollo.MutationFunction<UploadPhotosToCollectionMutation, UploadPhotosToCollectionMutationVariables>;

/**
 * __useUploadPhotosToCollectionMutation__
 *
 * To run a mutation, you first call `useUploadPhotosToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotosToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotosToCollectionMutation, { data, loading, error }] = useUploadPhotosToCollectionMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *      assetIds: // value for 'assetIds'
 *      collectionId: // value for 'collectionId'
 *      vendorIdsToTag: // value for 'vendorIdsToTag'
 *   },
 * });
 */
export function useUploadPhotosToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadPhotosToCollectionMutation, UploadPhotosToCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadPhotosToCollectionMutation, UploadPhotosToCollectionMutationVariables>(UploadPhotosToCollectionDocument, baseOptions);
      }
export type UploadPhotosToCollectionMutationHookResult = ReturnType<typeof useUploadPhotosToCollectionMutation>;
export type UploadPhotosToCollectionMutationResult = Apollo.MutationResult<UploadPhotosToCollectionMutation>;
export type UploadPhotosToCollectionMutationOptions = Apollo.BaseMutationOptions<UploadPhotosToCollectionMutation, UploadPhotosToCollectionMutationVariables>;
export const AddVendorProfilePhotoDocument = gql`
    mutation AddVendorProfilePhoto($vendorId: ID!, $containerId: String!, $assetId: String!) {
  addVendorProfilePhoto(payload: {containerId: $containerId, assetId: $assetId, vendorId: $vendorId}) {
    ...Photo
  }
}
    ${PhotoFragmentDoc}`;
export type AddVendorProfilePhotoMutationFn = Apollo.MutationFunction<AddVendorProfilePhotoMutation, AddVendorProfilePhotoMutationVariables>;

/**
 * __useAddVendorProfilePhotoMutation__
 *
 * To run a mutation, you first call `useAddVendorProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVendorProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVendorProfilePhotoMutation, { data, loading, error }] = useAddVendorProfilePhotoMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      containerId: // value for 'containerId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAddVendorProfilePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddVendorProfilePhotoMutation, AddVendorProfilePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<AddVendorProfilePhotoMutation, AddVendorProfilePhotoMutationVariables>(AddVendorProfilePhotoDocument, baseOptions);
      }
export type AddVendorProfilePhotoMutationHookResult = ReturnType<typeof useAddVendorProfilePhotoMutation>;
export type AddVendorProfilePhotoMutationResult = Apollo.MutationResult<AddVendorProfilePhotoMutation>;
export type AddVendorProfilePhotoMutationOptions = Apollo.BaseMutationOptions<AddVendorProfilePhotoMutation, AddVendorProfilePhotoMutationVariables>;
export const VerifyAccountEmailDocument = gql`
    mutation VerifyAccountEmail($payload: VerifyEmailPayload) {
  verifyAccountEmail(payload: $payload)
}
    `;
export type VerifyAccountEmailMutationFn = Apollo.MutationFunction<VerifyAccountEmailMutation, VerifyAccountEmailMutationVariables>;

/**
 * __useVerifyAccountEmailMutation__
 *
 * To run a mutation, you first call `useVerifyAccountEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountEmailMutation, { data, loading, error }] = useVerifyAccountEmailMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useVerifyAccountEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyAccountEmailMutation, VerifyAccountEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<VerifyAccountEmailMutation, VerifyAccountEmailMutationVariables>(VerifyAccountEmailDocument, baseOptions);
      }
export type VerifyAccountEmailMutationHookResult = ReturnType<typeof useVerifyAccountEmailMutation>;
export type VerifyAccountEmailMutationResult = Apollo.MutationResult<VerifyAccountEmailMutation>;
export type VerifyAccountEmailMutationOptions = Apollo.BaseMutationOptions<VerifyAccountEmailMutation, VerifyAccountEmailMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $payload: UpdateUserPayload!) {
  updateUser(id: $id, payload: $payload) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RequestChangePasswordDocument = gql`
    mutation RequestChangePassword {
  changePassword
}
    `;
export type RequestChangePasswordMutationFn = Apollo.MutationFunction<RequestChangePasswordMutation, RequestChangePasswordMutationVariables>;

/**
 * __useRequestChangePasswordMutation__
 *
 * To run a mutation, you first call `useRequestChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangePasswordMutation, { data, loading, error }] = useRequestChangePasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestChangePasswordMutation, RequestChangePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<RequestChangePasswordMutation, RequestChangePasswordMutationVariables>(RequestChangePasswordDocument, baseOptions);
      }
export type RequestChangePasswordMutationHookResult = ReturnType<typeof useRequestChangePasswordMutation>;
export type RequestChangePasswordMutationResult = Apollo.MutationResult<RequestChangePasswordMutation>;
export type RequestChangePasswordMutationOptions = Apollo.BaseMutationOptions<RequestChangePasswordMutation, RequestChangePasswordMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, baseOptions);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const LeaveEventDocument = gql`
    mutation LeaveEvent($id: ID!) {
  leaveEvent(id: $id)
}
    `;
export type LeaveEventMutationFn = Apollo.MutationFunction<LeaveEventMutation, LeaveEventMutationVariables>;

/**
 * __useLeaveEventMutation__
 *
 * To run a mutation, you first call `useLeaveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveEventMutation, { data, loading, error }] = useLeaveEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaveEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveEventMutation, LeaveEventMutationVariables>) {
        return ApolloReactHooks.useMutation<LeaveEventMutation, LeaveEventMutationVariables>(LeaveEventDocument, baseOptions);
      }
export type LeaveEventMutationHookResult = ReturnType<typeof useLeaveEventMutation>;
export type LeaveEventMutationResult = Apollo.MutationResult<LeaveEventMutation>;
export type LeaveEventMutationOptions = Apollo.BaseMutationOptions<LeaveEventMutation, LeaveEventMutationVariables>;
export const MarkUserForMFAEnrollmentDocument = gql`
    mutation MarkUserForMFAEnrollment {
  markUserForMFAEnrollment
}
    `;
export type MarkUserForMFAEnrollmentMutationFn = Apollo.MutationFunction<MarkUserForMFAEnrollmentMutation, MarkUserForMFAEnrollmentMutationVariables>;

/**
 * __useMarkUserForMFAEnrollmentMutation__
 *
 * To run a mutation, you first call `useMarkUserForMFAEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserForMFAEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserForMfaEnrollmentMutation, { data, loading, error }] = useMarkUserForMFAEnrollmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkUserForMFAEnrollmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkUserForMFAEnrollmentMutation, MarkUserForMFAEnrollmentMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkUserForMFAEnrollmentMutation, MarkUserForMFAEnrollmentMutationVariables>(MarkUserForMFAEnrollmentDocument, baseOptions);
      }
export type MarkUserForMFAEnrollmentMutationHookResult = ReturnType<typeof useMarkUserForMFAEnrollmentMutation>;
export type MarkUserForMFAEnrollmentMutationResult = Apollo.MutationResult<MarkUserForMFAEnrollmentMutation>;
export type MarkUserForMFAEnrollmentMutationOptions = Apollo.BaseMutationOptions<MarkUserForMFAEnrollmentMutation, MarkUserForMFAEnrollmentMutationVariables>;
export const ResetUserMfaDocument = gql`
    mutation ResetUserMfa {
  resetUserMFA
}
    `;
export type ResetUserMfaMutationFn = Apollo.MutationFunction<ResetUserMfaMutation, ResetUserMfaMutationVariables>;

/**
 * __useResetUserMfaMutation__
 *
 * To run a mutation, you first call `useResetUserMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserMfaMutation, { data, loading, error }] = useResetUserMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetUserMfaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetUserMfaMutation, ResetUserMfaMutationVariables>(ResetUserMfaDocument, baseOptions);
      }
export type ResetUserMfaMutationHookResult = ReturnType<typeof useResetUserMfaMutation>;
export type ResetUserMfaMutationResult = Apollo.MutationResult<ResetUserMfaMutation>;
export type ResetUserMfaMutationOptions = Apollo.BaseMutationOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>;
export const CreateVendorDocument = gql`
    mutation CreateVendor($payload: CreateVendor!) {
  createVendor(payload: $payload) {
    ...Vendor
  }
}
    ${VendorFragmentDoc}`;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, baseOptions);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const AddTestimonyDocument = gql`
    mutation AddTestimony($payload: AddTestimonyPayload!) {
  addTestimony(payload: $payload) {
    ...Testimony
  }
}
    ${TestimonyFragmentDoc}`;
export type AddTestimonyMutationFn = Apollo.MutationFunction<AddTestimonyMutation, AddTestimonyMutationVariables>;

/**
 * __useAddTestimonyMutation__
 *
 * To run a mutation, you first call `useAddTestimonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTestimonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTestimonyMutation, { data, loading, error }] = useAddTestimonyMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddTestimonyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTestimonyMutation, AddTestimonyMutationVariables>) {
        return ApolloReactHooks.useMutation<AddTestimonyMutation, AddTestimonyMutationVariables>(AddTestimonyDocument, baseOptions);
      }
export type AddTestimonyMutationHookResult = ReturnType<typeof useAddTestimonyMutation>;
export type AddTestimonyMutationResult = Apollo.MutationResult<AddTestimonyMutation>;
export type AddTestimonyMutationOptions = Apollo.BaseMutationOptions<AddTestimonyMutation, AddTestimonyMutationVariables>;
export const UpdateTestimonyDocument = gql`
    mutation UpdateTestimony($payload: UpdateTestimonyPayload!) {
  updateTestimony(payload: $payload) {
    ...Testimony
  }
}
    ${TestimonyFragmentDoc}`;
export type UpdateTestimonyMutationFn = Apollo.MutationFunction<UpdateTestimonyMutation, UpdateTestimonyMutationVariables>;

/**
 * __useUpdateTestimonyMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonyMutation, { data, loading, error }] = useUpdateTestimonyMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTestimonyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTestimonyMutation, UpdateTestimonyMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTestimonyMutation, UpdateTestimonyMutationVariables>(UpdateTestimonyDocument, baseOptions);
      }
export type UpdateTestimonyMutationHookResult = ReturnType<typeof useUpdateTestimonyMutation>;
export type UpdateTestimonyMutationResult = Apollo.MutationResult<UpdateTestimonyMutation>;
export type UpdateTestimonyMutationOptions = Apollo.BaseMutationOptions<UpdateTestimonyMutation, UpdateTestimonyMutationVariables>;
export const DeleteTestimonyDocument = gql`
    mutation DeleteTestimony($testimonyId: String!) {
  deleteTestimony(testimonyId: $testimonyId)
}
    `;
export type DeleteTestimonyMutationFn = Apollo.MutationFunction<DeleteTestimonyMutation, DeleteTestimonyMutationVariables>;

/**
 * __useDeleteTestimonyMutation__
 *
 * To run a mutation, you first call `useDeleteTestimonyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestimonyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestimonyMutation, { data, loading, error }] = useDeleteTestimonyMutation({
 *   variables: {
 *      testimonyId: // value for 'testimonyId'
 *   },
 * });
 */
export function useDeleteTestimonyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTestimonyMutation, DeleteTestimonyMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTestimonyMutation, DeleteTestimonyMutationVariables>(DeleteTestimonyDocument, baseOptions);
      }
export type DeleteTestimonyMutationHookResult = ReturnType<typeof useDeleteTestimonyMutation>;
export type DeleteTestimonyMutationResult = Apollo.MutationResult<DeleteTestimonyMutation>;
export type DeleteTestimonyMutationOptions = Apollo.BaseMutationOptions<DeleteTestimonyMutation, DeleteTestimonyMutationVariables>;
export const CreateVendorUserOnVendorDocument = gql`
    mutation CreateVendorUserOnVendor($payload: CreateVendorUserOnVendor!) {
  createVendorUserOnVendor(payload: $payload) {
    ...VendorUser
  }
}
    ${VendorUserFragmentDoc}`;
export type CreateVendorUserOnVendorMutationFn = Apollo.MutationFunction<CreateVendorUserOnVendorMutation, CreateVendorUserOnVendorMutationVariables>;

/**
 * __useCreateVendorUserOnVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorUserOnVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorUserOnVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorUserOnVendorMutation, { data, loading, error }] = useCreateVendorUserOnVendorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateVendorUserOnVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateVendorUserOnVendorMutation, CreateVendorUserOnVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateVendorUserOnVendorMutation, CreateVendorUserOnVendorMutationVariables>(CreateVendorUserOnVendorDocument, baseOptions);
      }
export type CreateVendorUserOnVendorMutationHookResult = ReturnType<typeof useCreateVendorUserOnVendorMutation>;
export type CreateVendorUserOnVendorMutationResult = Apollo.MutationResult<CreateVendorUserOnVendorMutation>;
export type CreateVendorUserOnVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorUserOnVendorMutation, CreateVendorUserOnVendorMutationVariables>;
export const UpdateVendorUserDocument = gql`
    mutation UpdateVendorUser($payload: UpdateVendorUserPayload!) {
  updateVendorUser(payload: $payload) {
    ...VendorUser
  }
}
    ${VendorUserFragmentDoc}`;
export type UpdateVendorUserMutationFn = Apollo.MutationFunction<UpdateVendorUserMutation, UpdateVendorUserMutationVariables>;

/**
 * __useUpdateVendorUserMutation__
 *
 * To run a mutation, you first call `useUpdateVendorUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorUserMutation, { data, loading, error }] = useUpdateVendorUserMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateVendorUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVendorUserMutation, UpdateVendorUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateVendorUserMutation, UpdateVendorUserMutationVariables>(UpdateVendorUserDocument, baseOptions);
      }
export type UpdateVendorUserMutationHookResult = ReturnType<typeof useUpdateVendorUserMutation>;
export type UpdateVendorUserMutationResult = Apollo.MutationResult<UpdateVendorUserMutation>;
export type UpdateVendorUserMutationOptions = Apollo.BaseMutationOptions<UpdateVendorUserMutation, UpdateVendorUserMutationVariables>;
export const CreateCollectionOnVendorDocument = gql`
    mutation CreateCollectionOnVendor($payload: CreateCollectionOnVendorPayload!) {
  createCollectionOnVendor(payload: $payload) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type CreateCollectionOnVendorMutationFn = Apollo.MutationFunction<CreateCollectionOnVendorMutation, CreateCollectionOnVendorMutationVariables>;

/**
 * __useCreateCollectionOnVendorMutation__
 *
 * To run a mutation, you first call `useCreateCollectionOnVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionOnVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionOnVendorMutation, { data, loading, error }] = useCreateCollectionOnVendorMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateCollectionOnVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCollectionOnVendorMutation, CreateCollectionOnVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCollectionOnVendorMutation, CreateCollectionOnVendorMutationVariables>(CreateCollectionOnVendorDocument, baseOptions);
      }
export type CreateCollectionOnVendorMutationHookResult = ReturnType<typeof useCreateCollectionOnVendorMutation>;
export type CreateCollectionOnVendorMutationResult = Apollo.MutationResult<CreateCollectionOnVendorMutation>;
export type CreateCollectionOnVendorMutationOptions = Apollo.BaseMutationOptions<CreateCollectionOnVendorMutation, CreateCollectionOnVendorMutationVariables>;
export const MoveCollectionItemsDocument = gql`
    mutation MoveCollectionItems($collectionId: ID!, $payloads: [ModelReorderPayload!]!) {
  moveCollectionItems(collectionId: $collectionId, payloads: $payloads) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type MoveCollectionItemsMutationFn = Apollo.MutationFunction<MoveCollectionItemsMutation, MoveCollectionItemsMutationVariables>;

/**
 * __useMoveCollectionItemsMutation__
 *
 * To run a mutation, you first call `useMoveCollectionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCollectionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCollectionItemsMutation, { data, loading, error }] = useMoveCollectionItemsMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      payloads: // value for 'payloads'
 *   },
 * });
 */
export function useMoveCollectionItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveCollectionItemsMutation, MoveCollectionItemsMutationVariables>) {
        return ApolloReactHooks.useMutation<MoveCollectionItemsMutation, MoveCollectionItemsMutationVariables>(MoveCollectionItemsDocument, baseOptions);
      }
export type MoveCollectionItemsMutationHookResult = ReturnType<typeof useMoveCollectionItemsMutation>;
export type MoveCollectionItemsMutationResult = Apollo.MutationResult<MoveCollectionItemsMutation>;
export type MoveCollectionItemsMutationOptions = Apollo.BaseMutationOptions<MoveCollectionItemsMutation, MoveCollectionItemsMutationVariables>;
export const RemovePhotosFromCollectionDocument = gql`
    mutation RemovePhotosFromCollection($collectionId: ID!, $photoIds: [ID!]!) {
  removePhotosFromCollection(collectionId: $collectionId, photoIds: $photoIds) {
    ...CollectionSlim
  }
}
    ${CollectionSlimFragmentDoc}`;
export type RemovePhotosFromCollectionMutationFn = Apollo.MutationFunction<RemovePhotosFromCollectionMutation, RemovePhotosFromCollectionMutationVariables>;

/**
 * __useRemovePhotosFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemovePhotosFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePhotosFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePhotosFromCollectionMutation, { data, loading, error }] = useRemovePhotosFromCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      photoIds: // value for 'photoIds'
 *   },
 * });
 */
export function useRemovePhotosFromCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePhotosFromCollectionMutation, RemovePhotosFromCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<RemovePhotosFromCollectionMutation, RemovePhotosFromCollectionMutationVariables>(RemovePhotosFromCollectionDocument, baseOptions);
      }
export type RemovePhotosFromCollectionMutationHookResult = ReturnType<typeof useRemovePhotosFromCollectionMutation>;
export type RemovePhotosFromCollectionMutationResult = Apollo.MutationResult<RemovePhotosFromCollectionMutation>;
export type RemovePhotosFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemovePhotosFromCollectionMutation, RemovePhotosFromCollectionMutationVariables>;
export const RemovePhotoFromCollectionDocument = gql`
    mutation RemovePhotoFromCollection($collectionId: ID!, $photoIds: [ID!]!, $photoId: ID!) {
  removePhotosFromCollection(collectionId: $collectionId, photoIds: $photoIds) {
    ...CollectionSlim
    isPhotoInCollection(photoId: $photoId)
  }
}
    ${CollectionSlimFragmentDoc}`;
export type RemovePhotoFromCollectionMutationFn = Apollo.MutationFunction<RemovePhotoFromCollectionMutation, RemovePhotoFromCollectionMutationVariables>;

/**
 * __useRemovePhotoFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemovePhotoFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePhotoFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePhotoFromCollectionMutation, { data, loading, error }] = useRemovePhotoFromCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      photoIds: // value for 'photoIds'
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useRemovePhotoFromCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePhotoFromCollectionMutation, RemovePhotoFromCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<RemovePhotoFromCollectionMutation, RemovePhotoFromCollectionMutationVariables>(RemovePhotoFromCollectionDocument, baseOptions);
      }
export type RemovePhotoFromCollectionMutationHookResult = ReturnType<typeof useRemovePhotoFromCollectionMutation>;
export type RemovePhotoFromCollectionMutationResult = Apollo.MutationResult<RemovePhotoFromCollectionMutation>;
export type RemovePhotoFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemovePhotoFromCollectionMutation, RemovePhotoFromCollectionMutationVariables>;
export const AddPhotosToCollectionDocument = gql`
    mutation AddPhotosToCollection($collectionId: ID!, $photoIds: [ID!]!) {
  addPhotosToCollection(collectionId: $collectionId, photoIds: $photoIds) {
    ...CollectionSlim
  }
}
    ${CollectionSlimFragmentDoc}`;
export type AddPhotosToCollectionMutationFn = Apollo.MutationFunction<AddPhotosToCollectionMutation, AddPhotosToCollectionMutationVariables>;

/**
 * __useAddPhotosToCollectionMutation__
 *
 * To run a mutation, you first call `useAddPhotosToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhotosToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhotosToCollectionMutation, { data, loading, error }] = useAddPhotosToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      photoIds: // value for 'photoIds'
 *   },
 * });
 */
export function useAddPhotosToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPhotosToCollectionMutation, AddPhotosToCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPhotosToCollectionMutation, AddPhotosToCollectionMutationVariables>(AddPhotosToCollectionDocument, baseOptions);
      }
export type AddPhotosToCollectionMutationHookResult = ReturnType<typeof useAddPhotosToCollectionMutation>;
export type AddPhotosToCollectionMutationResult = Apollo.MutationResult<AddPhotosToCollectionMutation>;
export type AddPhotosToCollectionMutationOptions = Apollo.BaseMutationOptions<AddPhotosToCollectionMutation, AddPhotosToCollectionMutationVariables>;
export const AddPhotoToCollectionDocument = gql`
    mutation AddPhotoToCollection($collectionId: ID!, $photoIds: [ID!]!, $photoId: ID!) {
  addPhotosToCollection(collectionId: $collectionId, photoIds: $photoIds) {
    ...CollectionSlim
    isPhotoInCollection(photoId: $photoId)
  }
}
    ${CollectionSlimFragmentDoc}`;
export type AddPhotoToCollectionMutationFn = Apollo.MutationFunction<AddPhotoToCollectionMutation, AddPhotoToCollectionMutationVariables>;

/**
 * __useAddPhotoToCollectionMutation__
 *
 * To run a mutation, you first call `useAddPhotoToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhotoToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhotoToCollectionMutation, { data, loading, error }] = useAddPhotoToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      photoIds: // value for 'photoIds'
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useAddPhotoToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPhotoToCollectionMutation, AddPhotoToCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<AddPhotoToCollectionMutation, AddPhotoToCollectionMutationVariables>(AddPhotoToCollectionDocument, baseOptions);
      }
export type AddPhotoToCollectionMutationHookResult = ReturnType<typeof useAddPhotoToCollectionMutation>;
export type AddPhotoToCollectionMutationResult = Apollo.MutationResult<AddPhotoToCollectionMutation>;
export type AddPhotoToCollectionMutationOptions = Apollo.BaseMutationOptions<AddPhotoToCollectionMutation, AddPhotoToCollectionMutationVariables>;
export const editCollectionInfoDocument = gql`
    mutation editCollectionInfo($payload: EditCollectionInfoPayload!) {
  editCollectionInfo(payload: $payload) {
    ...CollectionSlim
  }
}
    ${CollectionSlimFragmentDoc}`;
export type editCollectionInfoMutationFn = Apollo.MutationFunction<editCollectionInfoMutation, editCollectionInfoMutationVariables>;

/**
 * __useeditCollectionInfoMutation__
 *
 * To run a mutation, you first call `useeditCollectionInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useeditCollectionInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollectionInfoMutation, { data, loading, error }] = useeditCollectionInfoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useeditCollectionInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<editCollectionInfoMutation, editCollectionInfoMutationVariables>) {
        return ApolloReactHooks.useMutation<editCollectionInfoMutation, editCollectionInfoMutationVariables>(editCollectionInfoDocument, baseOptions);
      }
export type editCollectionInfoMutationHookResult = ReturnType<typeof useeditCollectionInfoMutation>;
export type editCollectionInfoMutationResult = Apollo.MutationResult<editCollectionInfoMutation>;
export type editCollectionInfoMutationOptions = Apollo.BaseMutationOptions<editCollectionInfoMutation, editCollectionInfoMutationVariables>;
export const refreshVendorUserClaimTokenDocument = gql`
    mutation refreshVendorUserClaimToken($payload: RefreshVendorUserTokenPayload!) {
  refreshVendorUserClaimToken(payload: $payload) {
    ...VendorUser
  }
}
    ${VendorUserFragmentDoc}`;
export type refreshVendorUserClaimTokenMutationFn = Apollo.MutationFunction<refreshVendorUserClaimTokenMutation, refreshVendorUserClaimTokenMutationVariables>;

/**
 * __userefreshVendorUserClaimTokenMutation__
 *
 * To run a mutation, you first call `userefreshVendorUserClaimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `userefreshVendorUserClaimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshVendorUserClaimTokenMutation, { data, loading, error }] = userefreshVendorUserClaimTokenMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function userefreshVendorUserClaimTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<refreshVendorUserClaimTokenMutation, refreshVendorUserClaimTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<refreshVendorUserClaimTokenMutation, refreshVendorUserClaimTokenMutationVariables>(refreshVendorUserClaimTokenDocument, baseOptions);
      }
export type refreshVendorUserClaimTokenMutationHookResult = ReturnType<typeof userefreshVendorUserClaimTokenMutation>;
export type refreshVendorUserClaimTokenMutationResult = Apollo.MutationResult<refreshVendorUserClaimTokenMutation>;
export type refreshVendorUserClaimTokenMutationOptions = Apollo.BaseMutationOptions<refreshVendorUserClaimTokenMutation, refreshVendorUserClaimTokenMutationVariables>;
export const ArchiveCollectionDocument = gql`
    mutation ArchiveCollection($payload: ArchiveCollectionPayload!) {
  archiveCollection(payload: $payload)
}
    `;
export type ArchiveCollectionMutationFn = Apollo.MutationFunction<ArchiveCollectionMutation, ArchiveCollectionMutationVariables>;

/**
 * __useArchiveCollectionMutation__
 *
 * To run a mutation, you first call `useArchiveCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCollectionMutation, { data, loading, error }] = useArchiveCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useArchiveCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveCollectionMutation, ArchiveCollectionMutationVariables>) {
        return ApolloReactHooks.useMutation<ArchiveCollectionMutation, ArchiveCollectionMutationVariables>(ArchiveCollectionDocument, baseOptions);
      }
export type ArchiveCollectionMutationHookResult = ReturnType<typeof useArchiveCollectionMutation>;
export type ArchiveCollectionMutationResult = Apollo.MutationResult<ArchiveCollectionMutation>;
export type ArchiveCollectionMutationOptions = Apollo.BaseMutationOptions<ArchiveCollectionMutation, ArchiveCollectionMutationVariables>;
export const claimVendorUserWithTokenDocument = gql`
    mutation claimVendorUserWithToken($payload: ClaimVendorUserWithToken!) {
  claimVendorUserWithToken(payload: $payload) {
    ...VendorUser
  }
}
    ${VendorUserFragmentDoc}`;
export type claimVendorUserWithTokenMutationFn = Apollo.MutationFunction<claimVendorUserWithTokenMutation, claimVendorUserWithTokenMutationVariables>;

/**
 * __useclaimVendorUserWithTokenMutation__
 *
 * To run a mutation, you first call `useclaimVendorUserWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useclaimVendorUserWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimVendorUserWithTokenMutation, { data, loading, error }] = useclaimVendorUserWithTokenMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useclaimVendorUserWithTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<claimVendorUserWithTokenMutation, claimVendorUserWithTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<claimVendorUserWithTokenMutation, claimVendorUserWithTokenMutationVariables>(claimVendorUserWithTokenDocument, baseOptions);
      }
export type claimVendorUserWithTokenMutationHookResult = ReturnType<typeof useclaimVendorUserWithTokenMutation>;
export type claimVendorUserWithTokenMutationResult = Apollo.MutationResult<claimVendorUserWithTokenMutation>;
export type claimVendorUserWithTokenMutationOptions = Apollo.BaseMutationOptions<claimVendorUserWithTokenMutation, claimVendorUserWithTokenMutationVariables>;
export const unlockRequestForProposalDocument = gql`
    mutation unlockRequestForProposal($payload: UnlockRequestForProposalPayload!, $userId: String!) {
  unlockRequestForProposal(payload: $payload) {
    ...RequestForProposal
  }
}
    ${RequestForProposalFragmentDoc}`;
export type unlockRequestForProposalMutationFn = Apollo.MutationFunction<unlockRequestForProposalMutation, unlockRequestForProposalMutationVariables>;

/**
 * __useunlockRequestForProposalMutation__
 *
 * To run a mutation, you first call `useunlockRequestForProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useunlockRequestForProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockRequestForProposalMutation, { data, loading, error }] = useunlockRequestForProposalMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useunlockRequestForProposalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<unlockRequestForProposalMutation, unlockRequestForProposalMutationVariables>) {
        return ApolloReactHooks.useMutation<unlockRequestForProposalMutation, unlockRequestForProposalMutationVariables>(unlockRequestForProposalDocument, baseOptions);
      }
export type unlockRequestForProposalMutationHookResult = ReturnType<typeof useunlockRequestForProposalMutation>;
export type unlockRequestForProposalMutationResult = Apollo.MutationResult<unlockRequestForProposalMutation>;
export type unlockRequestForProposalMutationOptions = Apollo.BaseMutationOptions<unlockRequestForProposalMutation, unlockRequestForProposalMutationVariables>;
export const LikePhotoDocument = gql`
    mutation LikePhoto($photoId: ID!) {
  likePhoto(photoId: $photoId) {
    ...LikedPhoto
  }
}
    ${LikedPhotoFragmentDoc}`;
export type LikePhotoMutationFn = Apollo.MutationFunction<LikePhotoMutation, LikePhotoMutationVariables>;

/**
 * __useLikePhotoMutation__
 *
 * To run a mutation, you first call `useLikePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePhotoMutation, { data, loading, error }] = useLikePhotoMutation({
 *   variables: {
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useLikePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LikePhotoMutation, LikePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<LikePhotoMutation, LikePhotoMutationVariables>(LikePhotoDocument, baseOptions);
      }
export type LikePhotoMutationHookResult = ReturnType<typeof useLikePhotoMutation>;
export type LikePhotoMutationResult = Apollo.MutationResult<LikePhotoMutation>;
export type LikePhotoMutationOptions = Apollo.BaseMutationOptions<LikePhotoMutation, LikePhotoMutationVariables>;
export const LikeMultiplePhotosDocument = gql`
    mutation LikeMultiplePhotos($photoIds: [ID!]!) {
  likeMultiplePhotos(photoIds: $photoIds) {
    ...LikedPhoto
  }
}
    ${LikedPhotoFragmentDoc}`;
export type LikeMultiplePhotosMutationFn = Apollo.MutationFunction<LikeMultiplePhotosMutation, LikeMultiplePhotosMutationVariables>;

/**
 * __useLikeMultiplePhotosMutation__
 *
 * To run a mutation, you first call `useLikeMultiplePhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeMultiplePhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeMultiplePhotosMutation, { data, loading, error }] = useLikeMultiplePhotosMutation({
 *   variables: {
 *      photoIds: // value for 'photoIds'
 *   },
 * });
 */
export function useLikeMultiplePhotosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LikeMultiplePhotosMutation, LikeMultiplePhotosMutationVariables>) {
        return ApolloReactHooks.useMutation<LikeMultiplePhotosMutation, LikeMultiplePhotosMutationVariables>(LikeMultiplePhotosDocument, baseOptions);
      }
export type LikeMultiplePhotosMutationHookResult = ReturnType<typeof useLikeMultiplePhotosMutation>;
export type LikeMultiplePhotosMutationResult = Apollo.MutationResult<LikeMultiplePhotosMutation>;
export type LikeMultiplePhotosMutationOptions = Apollo.BaseMutationOptions<LikeMultiplePhotosMutation, LikeMultiplePhotosMutationVariables>;
export const UnLikePhotoDocument = gql`
    mutation UnLikePhoto($photoId: ID!) {
  unLikePhoto(photoId: $photoId) {
    ...LikedPhoto
  }
}
    ${LikedPhotoFragmentDoc}`;
export type UnLikePhotoMutationFn = Apollo.MutationFunction<UnLikePhotoMutation, UnLikePhotoMutationVariables>;

/**
 * __useUnLikePhotoMutation__
 *
 * To run a mutation, you first call `useUnLikePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnLikePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unLikePhotoMutation, { data, loading, error }] = useUnLikePhotoMutation({
 *   variables: {
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useUnLikePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnLikePhotoMutation, UnLikePhotoMutationVariables>) {
        return ApolloReactHooks.useMutation<UnLikePhotoMutation, UnLikePhotoMutationVariables>(UnLikePhotoDocument, baseOptions);
      }
export type UnLikePhotoMutationHookResult = ReturnType<typeof useUnLikePhotoMutation>;
export type UnLikePhotoMutationResult = Apollo.MutationResult<UnLikePhotoMutation>;
export type UnLikePhotoMutationOptions = Apollo.BaseMutationOptions<UnLikePhotoMutation, UnLikePhotoMutationVariables>;
export const ShortlistVendorDocument = gql`
    mutation ShortlistVendor($eventId: String!, $vendorId: String!) {
  saveVendorToShortlist(payload: {eventId: $eventId, vendorId: $vendorId}) {
    ...MatchForEvent
  }
}
    ${MatchForEventFragmentDoc}`;
export type ShortlistVendorMutationFn = Apollo.MutationFunction<ShortlistVendorMutation, ShortlistVendorMutationVariables>;

/**
 * __useShortlistVendorMutation__
 *
 * To run a mutation, you first call `useShortlistVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortlistVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortlistVendorMutation, { data, loading, error }] = useShortlistVendorMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useShortlistVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShortlistVendorMutation, ShortlistVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<ShortlistVendorMutation, ShortlistVendorMutationVariables>(ShortlistVendorDocument, baseOptions);
      }
export type ShortlistVendorMutationHookResult = ReturnType<typeof useShortlistVendorMutation>;
export type ShortlistVendorMutationResult = Apollo.MutationResult<ShortlistVendorMutation>;
export type ShortlistVendorMutationOptions = Apollo.BaseMutationOptions<ShortlistVendorMutation, ShortlistVendorMutationVariables>;
export const ShortlistVendorAndCreateEventDocument = gql`
    mutation ShortlistVendorAndCreateEvent($vendorId: String!) {
  saveVendorToShortListAndCreateEvent(payload: {vendorId: $vendorId}) {
    ...Match
  }
}
    ${MatchFragmentDoc}`;
export type ShortlistVendorAndCreateEventMutationFn = Apollo.MutationFunction<ShortlistVendorAndCreateEventMutation, ShortlistVendorAndCreateEventMutationVariables>;

/**
 * __useShortlistVendorAndCreateEventMutation__
 *
 * To run a mutation, you first call `useShortlistVendorAndCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortlistVendorAndCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortlistVendorAndCreateEventMutation, { data, loading, error }] = useShortlistVendorAndCreateEventMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useShortlistVendorAndCreateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShortlistVendorAndCreateEventMutation, ShortlistVendorAndCreateEventMutationVariables>) {
        return ApolloReactHooks.useMutation<ShortlistVendorAndCreateEventMutation, ShortlistVendorAndCreateEventMutationVariables>(ShortlistVendorAndCreateEventDocument, baseOptions);
      }
export type ShortlistVendorAndCreateEventMutationHookResult = ReturnType<typeof useShortlistVendorAndCreateEventMutation>;
export type ShortlistVendorAndCreateEventMutationResult = Apollo.MutationResult<ShortlistVendorAndCreateEventMutation>;
export type ShortlistVendorAndCreateEventMutationOptions = Apollo.BaseMutationOptions<ShortlistVendorAndCreateEventMutation, ShortlistVendorAndCreateEventMutationVariables>;
export const UnShortlistVendorDocument = gql`
    mutation UnShortlistVendor($eventId: String!, $vendorId: String!) {
  unsaveVendorFromShortlist(payload: {eventId: $eventId, vendorId: $vendorId}) {
    ...MatchForEvent
  }
}
    ${MatchForEventFragmentDoc}`;
export type UnShortlistVendorMutationFn = Apollo.MutationFunction<UnShortlistVendorMutation, UnShortlistVendorMutationVariables>;

/**
 * __useUnShortlistVendorMutation__
 *
 * To run a mutation, you first call `useUnShortlistVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnShortlistVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unShortlistVendorMutation, { data, loading, error }] = useUnShortlistVendorMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useUnShortlistVendorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnShortlistVendorMutation, UnShortlistVendorMutationVariables>) {
        return ApolloReactHooks.useMutation<UnShortlistVendorMutation, UnShortlistVendorMutationVariables>(UnShortlistVendorDocument, baseOptions);
      }
export type UnShortlistVendorMutationHookResult = ReturnType<typeof useUnShortlistVendorMutation>;
export type UnShortlistVendorMutationResult = Apollo.MutationResult<UnShortlistVendorMutation>;
export type UnShortlistVendorMutationOptions = Apollo.BaseMutationOptions<UnShortlistVendorMutation, UnShortlistVendorMutationVariables>;
export const SetThemeAndLayoutDocument = gql`
    mutation SetThemeAndLayout($payload: SetThemeAndLayoutPayload!) {
  setThemeAndLayout(payload: $payload) {
    id
    hasUnpublishedChanges
    id
    brannanNavigation
    websiteLayout {
      id
      layoutType
    }
    activeWebsiteHeaderPresentationLayout {
      ...WebsiteHeaderPresentationSettings
    }
    theme {
      id
      themeId
    }
  }
}
    ${WebsiteHeaderPresentationSettingsFragmentDoc}`;
export type SetThemeAndLayoutMutationFn = Apollo.MutationFunction<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>;

/**
 * __useSetThemeAndLayoutMutation__
 *
 * To run a mutation, you first call `useSetThemeAndLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetThemeAndLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setThemeAndLayoutMutation, { data, loading, error }] = useSetThemeAndLayoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetThemeAndLayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>) {
        return ApolloReactHooks.useMutation<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>(SetThemeAndLayoutDocument, baseOptions);
      }
export type SetThemeAndLayoutMutationHookResult = ReturnType<typeof useSetThemeAndLayoutMutation>;
export type SetThemeAndLayoutMutationResult = Apollo.MutationResult<SetThemeAndLayoutMutation>;
export type SetThemeAndLayoutMutationOptions = Apollo.BaseMutationOptions<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>;
export const SetBrannanInnerFrameBorderPreferenceDocument = gql`
    mutation SetBrannanInnerFrameBorderPreference($payload: DesignPreferenceBooleanInput!) {
  setBrannanInnerFrameBorder(payload: $payload) {
    id
    hasUnpublishedChanges
  }
}
    `;
export type SetBrannanInnerFrameBorderPreferenceMutationFn = Apollo.MutationFunction<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>;

/**
 * __useSetBrannanInnerFrameBorderPreferenceMutation__
 *
 * To run a mutation, you first call `useSetBrannanInnerFrameBorderPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrannanInnerFrameBorderPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrannanInnerFrameBorderPreferenceMutation, { data, loading, error }] = useSetBrannanInnerFrameBorderPreferenceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetBrannanInnerFrameBorderPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>(SetBrannanInnerFrameBorderPreferenceDocument, baseOptions);
      }
export type SetBrannanInnerFrameBorderPreferenceMutationHookResult = ReturnType<typeof useSetBrannanInnerFrameBorderPreferenceMutation>;
export type SetBrannanInnerFrameBorderPreferenceMutationResult = Apollo.MutationResult<SetBrannanInnerFrameBorderPreferenceMutation>;
export type SetBrannanInnerFrameBorderPreferenceMutationOptions = Apollo.BaseMutationOptions<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>;
export const SetBrannanBackgroundTransparencyPreferenceDocument = gql`
    mutation SetBrannanBackgroundTransparencyPreference($payload: DesignPreferenceRangeInput!) {
  setBrannanBackgroundTransparency(payload: $payload) {
    id
    hasUnpublishedChanges
  }
}
    `;
export type SetBrannanBackgroundTransparencyPreferenceMutationFn = Apollo.MutationFunction<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>;

/**
 * __useSetBrannanBackgroundTransparencyPreferenceMutation__
 *
 * To run a mutation, you first call `useSetBrannanBackgroundTransparencyPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrannanBackgroundTransparencyPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrannanBackgroundTransparencyPreferenceMutation, { data, loading, error }] = useSetBrannanBackgroundTransparencyPreferenceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetBrannanBackgroundTransparencyPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>(SetBrannanBackgroundTransparencyPreferenceDocument, baseOptions);
      }
export type SetBrannanBackgroundTransparencyPreferenceMutationHookResult = ReturnType<typeof useSetBrannanBackgroundTransparencyPreferenceMutation>;
export type SetBrannanBackgroundTransparencyPreferenceMutationResult = Apollo.MutationResult<SetBrannanBackgroundTransparencyPreferenceMutation>;
export type SetBrannanBackgroundTransparencyPreferenceMutationOptions = Apollo.BaseMutationOptions<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>;
export const SetAccentDocument = gql`
    mutation SetAccent($payload: SetAccentPayload!) {
  setAccent(payload: $payload) {
    id
    accent
  }
}
    `;
export type SetAccentMutationFn = Apollo.MutationFunction<SetAccentMutation, SetAccentMutationVariables>;

/**
 * __useSetAccentMutation__
 *
 * To run a mutation, you first call `useSetAccentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccentMutation, { data, loading, error }] = useSetAccentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetAccentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAccentMutation, SetAccentMutationVariables>) {
        return ApolloReactHooks.useMutation<SetAccentMutation, SetAccentMutationVariables>(SetAccentDocument, baseOptions);
      }
export type SetAccentMutationHookResult = ReturnType<typeof useSetAccentMutation>;
export type SetAccentMutationResult = Apollo.MutationResult<SetAccentMutation>;
export type SetAccentMutationOptions = Apollo.BaseMutationOptions<SetAccentMutation, SetAccentMutationVariables>;
export const SetCustomCssDocument = gql`
    mutation SetCustomCss($payload: SetCustomCssPayload!) {
  setCustomCss(payload: $payload) {
    id
    customCss
  }
}
    `;
export type SetCustomCssMutationFn = Apollo.MutationFunction<SetCustomCssMutation, SetCustomCssMutationVariables>;

/**
 * __useSetCustomCssMutation__
 *
 * To run a mutation, you first call `useSetCustomCssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomCssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomCssMutation, { data, loading, error }] = useSetCustomCssMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetCustomCssMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCustomCssMutation, SetCustomCssMutationVariables>) {
        return ApolloReactHooks.useMutation<SetCustomCssMutation, SetCustomCssMutationVariables>(SetCustomCssDocument, baseOptions);
      }
export type SetCustomCssMutationHookResult = ReturnType<typeof useSetCustomCssMutation>;
export type SetCustomCssMutationResult = Apollo.MutationResult<SetCustomCssMutation>;
export type SetCustomCssMutationOptions = Apollo.BaseMutationOptions<SetCustomCssMutation, SetCustomCssMutationVariables>;
export const SetFontDocument = gql`
    mutation SetFont($payload: SetFontPayload!) {
  setFont(payload: $payload) {
    id
    hasUnpublishedChanges
    font {
      id
    }
  }
}
    `;
export type SetFontMutationFn = Apollo.MutationFunction<SetFontMutation, SetFontMutationVariables>;

/**
 * __useSetFontMutation__
 *
 * To run a mutation, you first call `useSetFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFontMutation, { data, loading, error }] = useSetFontMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetFontMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFontMutation, SetFontMutationVariables>) {
        return ApolloReactHooks.useMutation<SetFontMutation, SetFontMutationVariables>(SetFontDocument, baseOptions);
      }
export type SetFontMutationHookResult = ReturnType<typeof useSetFontMutation>;
export type SetFontMutationResult = Apollo.MutationResult<SetFontMutation>;
export type SetFontMutationOptions = Apollo.BaseMutationOptions<SetFontMutation, SetFontMutationVariables>;
export const PublishEventDesignDraftDocument = gql`
    mutation PublishEventDesignDraft($id: ID!) {
  publishEventDesignDraft(id: $id) {
    ...EventDesign
  }
}
    ${EventDesignFragmentDoc}`;
export type PublishEventDesignDraftMutationFn = Apollo.MutationFunction<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>;

/**
 * __usePublishEventDesignDraftMutation__
 *
 * To run a mutation, you first call `usePublishEventDesignDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventDesignDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventDesignDraftMutation, { data, loading, error }] = usePublishEventDesignDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventDesignDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>) {
        return ApolloReactHooks.useMutation<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>(PublishEventDesignDraftDocument, baseOptions);
      }
export type PublishEventDesignDraftMutationHookResult = ReturnType<typeof usePublishEventDesignDraftMutation>;
export type PublishEventDesignDraftMutationResult = Apollo.MutationResult<PublishEventDesignDraftMutation>;
export type PublishEventDesignDraftMutationOptions = Apollo.BaseMutationOptions<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>;
export const SetHasVisitedDesignPageDocument = gql`
    mutation SetHasVisitedDesignPage($payload: SetHasVisitedDesignPagePayload!) {
  setHasVisitedDesignPage(payload: $payload) {
    id
    hasUnpublishedChanges
    hasVisitedDesignPage
  }
}
    `;
export type SetHasVisitedDesignPageMutationFn = Apollo.MutationFunction<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>;

/**
 * __useSetHasVisitedDesignPageMutation__
 *
 * To run a mutation, you first call `useSetHasVisitedDesignPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasVisitedDesignPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasVisitedDesignPageMutation, { data, loading, error }] = useSetHasVisitedDesignPageMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetHasVisitedDesignPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>) {
        return ApolloReactHooks.useMutation<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>(SetHasVisitedDesignPageDocument, baseOptions);
      }
export type SetHasVisitedDesignPageMutationHookResult = ReturnType<typeof useSetHasVisitedDesignPageMutation>;
export type SetHasVisitedDesignPageMutationResult = Apollo.MutationResult<SetHasVisitedDesignPageMutation>;
export type SetHasVisitedDesignPageMutationOptions = Apollo.BaseMutationOptions<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>;
export const SetPresetTemplateDocument = gql`
    mutation SetPresetTemplate($themeAndLayoutPayload: SetThemeAndLayoutPayload!, $fontPayload: SetFontPayload!) {
  setThemeAndLayout(payload: $themeAndLayoutPayload) {
    id
    hasUnpublishedChanges
    websiteLayout {
      id
      layoutType
    }
    theme {
      id
      themeId
    }
  }
  setFont(payload: $fontPayload) {
    id
    hasUnpublishedChanges
    font {
      id
    }
  }
}
    `;
export type SetPresetTemplateMutationFn = Apollo.MutationFunction<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>;

/**
 * __useSetPresetTemplateMutation__
 *
 * To run a mutation, you first call `useSetPresetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPresetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPresetTemplateMutation, { data, loading, error }] = useSetPresetTemplateMutation({
 *   variables: {
 *      themeAndLayoutPayload: // value for 'themeAndLayoutPayload'
 *      fontPayload: // value for 'fontPayload'
 *   },
 * });
 */
export function useSetPresetTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>(SetPresetTemplateDocument, baseOptions);
      }
export type SetPresetTemplateMutationHookResult = ReturnType<typeof useSetPresetTemplateMutation>;
export type SetPresetTemplateMutationResult = Apollo.MutationResult<SetPresetTemplateMutation>;
export type SetPresetTemplateMutationOptions = Apollo.BaseMutationOptions<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>;
export const AdminDashboardPreviewPanelDocument = gql`
    query AdminDashboardPreviewPanel($eventHandle: String!) {
  me {
    id
    emailIsVerified(liveQuery: true)
  }
  eventByName(name: $eventHandle) {
    id
    firebaseId
    firebaseCreateAt {
      ...Date
    }
    style {
      id
      primaryColor: primaryColorV0918 {
        rgba
      }
      theme
      layout
    }
    suggestion {
      items {
        ...EventSuggestion
      }
    }
    info {
      id
      eventPassword
    }
    checklist {
      id
    }
  }
}
    ${DateFragmentDoc}
${EventSuggestionFragmentDoc}`;

/**
 * __useAdminDashboardPreviewPanelQuery__
 *
 * To run a query within a React component, call `useAdminDashboardPreviewPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDashboardPreviewPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDashboardPreviewPanelQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useAdminDashboardPreviewPanelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminDashboardPreviewPanelQuery, AdminDashboardPreviewPanelQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminDashboardPreviewPanelQuery, AdminDashboardPreviewPanelQueryVariables>(AdminDashboardPreviewPanelDocument, baseOptions);
      }
export function useAdminDashboardPreviewPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminDashboardPreviewPanelQuery, AdminDashboardPreviewPanelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminDashboardPreviewPanelQuery, AdminDashboardPreviewPanelQueryVariables>(AdminDashboardPreviewPanelDocument, baseOptions);
        }
export type AdminDashboardPreviewPanelQueryHookResult = ReturnType<typeof useAdminDashboardPreviewPanelQuery>;
export type AdminDashboardPreviewPanelLazyQueryHookResult = ReturnType<typeof useAdminDashboardPreviewPanelLazyQuery>;
export type AdminDashboardPreviewPanelQueryResult = Apollo.QueryResult<AdminDashboardPreviewPanelQuery, AdminDashboardPreviewPanelQueryVariables>;
export const CatalogCurationsTreeRootDocument = gql`
    query CatalogCurationsTreeRoot($types: [CatalogTreeRootInput!], $storefront: CatalogStorefront) {
  productCatalogCategoryTreeRoot(types: $types, storefront: $storefront) {
    ...CatalogCurationFields
    children {
      ...CatalogCurationFields
      curationData {
        id
        videoUrl
        header {
          id
          ...CatalogCurationHeader
        }
        description
      }
      children {
        ...CatalogCurationFields
      }
    }
  }
}
    ${CatalogCurationFieldsFragmentDoc}
${CatalogCurationHeaderFragmentDoc}`;

/**
 * __useCatalogCurationsTreeRootQuery__
 *
 * To run a query within a React component, call `useCatalogCurationsTreeRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCurationsTreeRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCurationsTreeRootQuery({
 *   variables: {
 *      types: // value for 'types'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useCatalogCurationsTreeRootQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>) {
        return ApolloReactHooks.useQuery<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>(CatalogCurationsTreeRootDocument, baseOptions);
      }
export function useCatalogCurationsTreeRootLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>(CatalogCurationsTreeRootDocument, baseOptions);
        }
export type CatalogCurationsTreeRootQueryHookResult = ReturnType<typeof useCatalogCurationsTreeRootQuery>;
export type CatalogCurationsTreeRootLazyQueryHookResult = ReturnType<typeof useCatalogCurationsTreeRootLazyQuery>;
export type CatalogCurationsTreeRootQueryResult = Apollo.QueryResult<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>;
export const CatalogCurationThemeDocument = gql`
    query CatalogCurationTheme($url: String!) {
  productCatalogCategoryByLocator(url: $url) {
    id
    curationData {
      id
      header {
        id
        textColor
        gradientColor
      }
    }
  }
}
    `;

/**
 * __useCatalogCurationThemeQuery__
 *
 * To run a query within a React component, call `useCatalogCurationThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCurationThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCurationThemeQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCatalogCurationThemeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>) {
        return ApolloReactHooks.useQuery<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>(CatalogCurationThemeDocument, baseOptions);
      }
export function useCatalogCurationThemeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>(CatalogCurationThemeDocument, baseOptions);
        }
export type CatalogCurationThemeQueryHookResult = ReturnType<typeof useCatalogCurationThemeQuery>;
export type CatalogCurationThemeLazyQueryHookResult = ReturnType<typeof useCatalogCurationThemeLazyQuery>;
export type CatalogCurationThemeQueryResult = Apollo.QueryResult<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>;
export const ProductExternalSearchDocument = gql`
    query ProductExternalSearch($query: ProductExternalSearchQueryInput!) {
  productExternalSearch(query: $query) {
    offers {
      id
      ...ProductExternalOfferSummary
    }
  }
}
    ${ProductExternalOfferSummaryFragmentDoc}`;

/**
 * __useProductExternalSearchQuery__
 *
 * To run a query within a React component, call `useProductExternalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExternalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExternalSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useProductExternalSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>(ProductExternalSearchDocument, baseOptions);
      }
export function useProductExternalSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>(ProductExternalSearchDocument, baseOptions);
        }
export type ProductExternalSearchQueryHookResult = ReturnType<typeof useProductExternalSearchQuery>;
export type ProductExternalSearchLazyQueryHookResult = ReturnType<typeof useProductExternalSearchLazyQuery>;
export type ProductExternalSearchQueryResult = Apollo.QueryResult<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>;
export const ProductExternalByIdDocument = gql`
    query ProductExternalById($productId: String!) {
  productExternalById(productId: $productId) {
    ...ProductExternalSummary
  }
}
    ${ProductExternalSummaryFragmentDoc}`;

/**
 * __useProductExternalByIdQuery__
 *
 * To run a query within a React component, call `useProductExternalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExternalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExternalByIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductExternalByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>(ProductExternalByIdDocument, baseOptions);
      }
export function useProductExternalByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>(ProductExternalByIdDocument, baseOptions);
        }
export type ProductExternalByIdQueryHookResult = ReturnType<typeof useProductExternalByIdQuery>;
export type ProductExternalByIdLazyQueryHookResult = ReturnType<typeof useProductExternalByIdLazyQuery>;
export type ProductExternalByIdQueryResult = Apollo.QueryResult<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>;
export const CatalogCategoryChildrenDocument = gql`
    query CatalogCategoryChildren($type: CatalogTreeRootInput) {
  productCatalogCategoryTreeRoot(type: $type) {
    id
    children {
      ...CatalogCategoryChildrenSummary
      children {
        ...CatalogCategoryChildrenSummary
      }
    }
  }
}
    ${CatalogCategoryChildrenSummaryFragmentDoc}`;

/**
 * __useCatalogCategoryChildrenQuery__
 *
 * To run a query within a React component, call `useCatalogCategoryChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCategoryChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCategoryChildrenQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCatalogCategoryChildrenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogCategoryChildrenQuery, CatalogCategoryChildrenQueryVariables>) {
        return ApolloReactHooks.useQuery<CatalogCategoryChildrenQuery, CatalogCategoryChildrenQueryVariables>(CatalogCategoryChildrenDocument, baseOptions);
      }
export function useCatalogCategoryChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogCategoryChildrenQuery, CatalogCategoryChildrenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CatalogCategoryChildrenQuery, CatalogCategoryChildrenQueryVariables>(CatalogCategoryChildrenDocument, baseOptions);
        }
export type CatalogCategoryChildrenQueryHookResult = ReturnType<typeof useCatalogCategoryChildrenQuery>;
export type CatalogCategoryChildrenLazyQueryHookResult = ReturnType<typeof useCatalogCategoryChildrenLazyQuery>;
export type CatalogCategoryChildrenQueryResult = Apollo.QueryResult<CatalogCategoryChildrenQuery, CatalogCategoryChildrenQueryVariables>;
export const SeoRedirectByLocatorDocument = gql`
    query SeoRedirectByLocator($url: String!) {
  productCatalogCategoryByLocator(url: $url) {
    id
    seoRedirectPath
  }
}
    `;

/**
 * __useSeoRedirectByLocatorQuery__
 *
 * To run a query within a React component, call `useSeoRedirectByLocatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoRedirectByLocatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoRedirectByLocatorQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSeoRedirectByLocatorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>) {
        return ApolloReactHooks.useQuery<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>(SeoRedirectByLocatorDocument, baseOptions);
      }
export function useSeoRedirectByLocatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>(SeoRedirectByLocatorDocument, baseOptions);
        }
export type SeoRedirectByLocatorQueryHookResult = ReturnType<typeof useSeoRedirectByLocatorQuery>;
export type SeoRedirectByLocatorLazyQueryHookResult = ReturnType<typeof useSeoRedirectByLocatorLazyQuery>;
export type SeoRedirectByLocatorQueryResult = Apollo.QueryResult<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>;
export const ProductCatalogByLocatorDocument = gql`
    query ProductCatalogByLocator($url: String!) {
  productCatalogCategoryByLocator(url: $url) {
    ...CoreCatalogCategoryFieldsWithChildren
  }
}
    ${CoreCatalogCategoryFieldsWithChildrenFragmentDoc}`;

/**
 * __useProductCatalogByLocatorQuery__
 *
 * To run a query within a React component, call `useProductCatalogByLocatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogByLocatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogByLocatorQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useProductCatalogByLocatorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>(ProductCatalogByLocatorDocument, baseOptions);
      }
export function useProductCatalogByLocatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>(ProductCatalogByLocatorDocument, baseOptions);
        }
export type ProductCatalogByLocatorQueryHookResult = ReturnType<typeof useProductCatalogByLocatorQuery>;
export type ProductCatalogByLocatorLazyQueryHookResult = ReturnType<typeof useProductCatalogByLocatorLazyQuery>;
export type ProductCatalogByLocatorQueryResult = Apollo.QueryResult<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>;
export const ProductCatalogDepartmentsDocument = gql`
    query ProductCatalogDepartments($storefront: CatalogStorefront, $types: [CatalogTreeRootInput!]!) {
  productCatalogCategoryTreeRoot(types: $types, storefront: $storefront) {
    ...CoreCatalogCategoryFieldsWithChildren
  }
}
    ${CoreCatalogCategoryFieldsWithChildrenFragmentDoc}`;

/**
 * __useProductCatalogDepartmentsQuery__
 *
 * To run a query within a React component, call `useProductCatalogDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogDepartmentsQuery({
 *   variables: {
 *      storefront: // value for 'storefront'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useProductCatalogDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>) {
        return ApolloReactHooks.useQuery<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>(ProductCatalogDepartmentsDocument, baseOptions);
      }
export function useProductCatalogDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>(ProductCatalogDepartmentsDocument, baseOptions);
        }
export type ProductCatalogDepartmentsQueryHookResult = ReturnType<typeof useProductCatalogDepartmentsQuery>;
export type ProductCatalogDepartmentsLazyQueryHookResult = ReturnType<typeof useProductCatalogDepartmentsLazyQuery>;
export type ProductCatalogDepartmentsQueryResult = Apollo.QueryResult<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>;
export const GetCurrencyCodesDocument = gql`
    query GetCurrencyCodes {
  getRegistryStaticData {
    currencies {
      topRanked {
        ...RegistryCurrencyCodes
      }
      ordered {
        ...RegistryCurrencyCodes
      }
    }
  }
}
    ${RegistryCurrencyCodesFragmentDoc}`;

/**
 * __useGetCurrencyCodesQuery__
 *
 * To run a query within a React component, call `useGetCurrencyCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>(GetCurrencyCodesDocument, baseOptions);
      }
export function useGetCurrencyCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>(GetCurrencyCodesDocument, baseOptions);
        }
export type GetCurrencyCodesQueryHookResult = ReturnType<typeof useGetCurrencyCodesQuery>;
export type GetCurrencyCodesLazyQueryHookResult = ReturnType<typeof useGetCurrencyCodesLazyQuery>;
export type GetCurrencyCodesQueryResult = Apollo.QueryResult<GetCurrencyCodesQuery, GetCurrencyCodesQueryVariables>;
export const VendorDiscoveryNodeCollectionByUrlDocument = gql`
    query VendorDiscoveryNodeCollectionByUrl($url: String!, $collectionsPerPage: Int!, $collectionPage: Int!) {
  vendorDiscoveryNodeByUrl(url: $url) {
    id
    title
    metaPageTitle
    description
    metaPageDescription
    breadcrumbs
    urls
    canonicalUrl
    collectionListTitle
    photo {
      id
      url
    }
    collectionIds
    collectionGroups {
      id
      title
      urlSlug
      photo {
        id
        url
      }
    }
    collectionGroupCollections(perPage: $collectionsPerPage, page: $collectionPage) {
      ...CollectionSlim
    }
  }
}
    ${CollectionSlimFragmentDoc}`;

/**
 * __useVendorDiscoveryNodeCollectionByUrlQuery__
 *
 * To run a query within a React component, call `useVendorDiscoveryNodeCollectionByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDiscoveryNodeCollectionByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDiscoveryNodeCollectionByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      collectionsPerPage: // value for 'collectionsPerPage'
 *      collectionPage: // value for 'collectionPage'
 *   },
 * });
 */
export function useVendorDiscoveryNodeCollectionByUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorDiscoveryNodeCollectionByUrlQuery, VendorDiscoveryNodeCollectionByUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorDiscoveryNodeCollectionByUrlQuery, VendorDiscoveryNodeCollectionByUrlQueryVariables>(VendorDiscoveryNodeCollectionByUrlDocument, baseOptions);
      }
export function useVendorDiscoveryNodeCollectionByUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorDiscoveryNodeCollectionByUrlQuery, VendorDiscoveryNodeCollectionByUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorDiscoveryNodeCollectionByUrlQuery, VendorDiscoveryNodeCollectionByUrlQueryVariables>(VendorDiscoveryNodeCollectionByUrlDocument, baseOptions);
        }
export type VendorDiscoveryNodeCollectionByUrlQueryHookResult = ReturnType<typeof useVendorDiscoveryNodeCollectionByUrlQuery>;
export type VendorDiscoveryNodeCollectionByUrlLazyQueryHookResult = ReturnType<typeof useVendorDiscoveryNodeCollectionByUrlLazyQuery>;
export type VendorDiscoveryNodeCollectionByUrlQueryResult = Apollo.QueryResult<VendorDiscoveryNodeCollectionByUrlQuery, VendorDiscoveryNodeCollectionByUrlQueryVariables>;
export const DiscoveryNodeListDocument = gql`
    query DiscoveryNodeList {
  vendorDiscoveryNodes {
    id
    title
    description
    breadcrumbs
    urls
    canonicalUrl
    photo {
      ...PhotoWithMetatags
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}`;

/**
 * __useDiscoveryNodeListQuery__
 *
 * To run a query within a React component, call `useDiscoveryNodeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoveryNodeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoveryNodeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscoveryNodeListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DiscoveryNodeListQuery, DiscoveryNodeListQueryVariables>) {
        return ApolloReactHooks.useQuery<DiscoveryNodeListQuery, DiscoveryNodeListQueryVariables>(DiscoveryNodeListDocument, baseOptions);
      }
export function useDiscoveryNodeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DiscoveryNodeListQuery, DiscoveryNodeListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DiscoveryNodeListQuery, DiscoveryNodeListQueryVariables>(DiscoveryNodeListDocument, baseOptions);
        }
export type DiscoveryNodeListQueryHookResult = ReturnType<typeof useDiscoveryNodeListQuery>;
export type DiscoveryNodeListLazyQueryHookResult = ReturnType<typeof useDiscoveryNodeListLazyQuery>;
export type DiscoveryNodeListQueryResult = Apollo.QueryResult<DiscoveryNodeListQuery, DiscoveryNodeListQueryVariables>;
export const AllVendorCollectionPhotosDocument = gql`
    query AllVendorCollectionPhotos($perPage: Int, $page: Int) {
  allVendorCollectionPhotos {
    id
    description
    name
    itemCount
    items(perPage: $perPage, page: $page) {
      edges {
        node {
          id
          description
          photo {
            ...PhotoWithMetatags
          }
          video {
            ...Video
          }
        }
      }
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VideoFragmentDoc}`;

/**
 * __useAllVendorCollectionPhotosQuery__
 *
 * To run a query within a React component, call `useAllVendorCollectionPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVendorCollectionPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVendorCollectionPhotosQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAllVendorCollectionPhotosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllVendorCollectionPhotosQuery, AllVendorCollectionPhotosQueryVariables>) {
        return ApolloReactHooks.useQuery<AllVendorCollectionPhotosQuery, AllVendorCollectionPhotosQueryVariables>(AllVendorCollectionPhotosDocument, baseOptions);
      }
export function useAllVendorCollectionPhotosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllVendorCollectionPhotosQuery, AllVendorCollectionPhotosQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllVendorCollectionPhotosQuery, AllVendorCollectionPhotosQueryVariables>(AllVendorCollectionPhotosDocument, baseOptions);
        }
export type AllVendorCollectionPhotosQueryHookResult = ReturnType<typeof useAllVendorCollectionPhotosQuery>;
export type AllVendorCollectionPhotosLazyQueryHookResult = ReturnType<typeof useAllVendorCollectionPhotosLazyQuery>;
export type AllVendorCollectionPhotosQueryResult = Apollo.QueryResult<AllVendorCollectionPhotosQuery, AllVendorCollectionPhotosQueryVariables>;
export const VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlDocument = gql`
    query VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrl($url: String!) {
  vendorDiscoveryNodeByUrl(url: $url) {
    id
    title
    description
    breadcrumbs
    urls
    canonicalUrl
    photoListTitle
    photo {
      id
      url
    }
    collectionGroups {
      id
      title
      urlSlug
      photo {
        ...Photo
      }
    }
  }
}
    ${PhotoFragmentDoc}`;

/**
 * __useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery__
 *
 * To run a query within a React component, call `useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables>(VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlDocument, baseOptions);
      }
export function useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables>(VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlDocument, baseOptions);
        }
export type VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryHookResult = ReturnType<typeof useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery>;
export type VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlLazyQueryHookResult = ReturnType<typeof useVendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlLazyQuery>;
export type VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryResult = Apollo.QueryResult<VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsInfoByUrlQueryVariables>;
export const VendorDiscoveryNodePhotosAndCollectionGroupsByUrlDocument = gql`
    query VendorDiscoveryNodePhotosAndCollectionGroupsByUrl($url: String!, $urlSlug: String!, $perPage: Int, $page: Int, $cursor: String) {
  vendorDiscoveryNodeByUrl(url: $url) {
    id
    aggregateSyntheticCollectionGroupsCollection(urlSlug: $urlSlug) {
      ...SyntheticCollectionWithMetatagsPaginated
    }
  }
}
    ${SyntheticCollectionWithMetatagsPaginatedFragmentDoc}`;

/**
 * __useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery__
 *
 * To run a query within a React component, call `useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      urlSlug: // value for 'urlSlug'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables>(VendorDiscoveryNodePhotosAndCollectionGroupsByUrlDocument, baseOptions);
      }
export function useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables>(VendorDiscoveryNodePhotosAndCollectionGroupsByUrlDocument, baseOptions);
        }
export type VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryHookResult = ReturnType<typeof useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery>;
export type VendorDiscoveryNodePhotosAndCollectionGroupsByUrlLazyQueryHookResult = ReturnType<typeof useVendorDiscoveryNodePhotosAndCollectionGroupsByUrlLazyQuery>;
export type VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryResult = Apollo.QueryResult<VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQuery, VendorDiscoveryNodePhotosAndCollectionGroupsByUrlQueryVariables>;
export const GetEventByNameDocument = gql`
    query GetEventByName($eventHandle: String!, $userId: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      ...EventFragment
      eventMatch {
        id
        showcase {
          id
          testimony {
            id
            content
          }
          vendor {
            vendorUserByUserId(userId: $userId) {
              id
            }
            ...EventShowcaseVendor
          }
        }
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventShowcaseVendorFragmentDoc}`;

/**
 * __useGetEventByNameQuery__
 *
 * To run a query within a React component, call `useGetEventByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEventByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameQuery, GetEventByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByNameQuery, GetEventByNameQueryVariables>(GetEventByNameDocument, baseOptions);
      }
export function useGetEventByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameQuery, GetEventByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByNameQuery, GetEventByNameQueryVariables>(GetEventByNameDocument, baseOptions);
        }
export type GetEventByNameQueryHookResult = ReturnType<typeof useGetEventByNameQuery>;
export type GetEventByNameLazyQueryHookResult = ReturnType<typeof useGetEventByNameLazyQuery>;
export type GetEventByNameQueryResult = Apollo.QueryResult<GetEventByNameQuery, GetEventByNameQueryVariables>;
export const GetEventWithChecklistByNameDocument = gql`
    query GetEventWithChecklistByName($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      ...EventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;

/**
 * __useGetEventWithChecklistByNameQuery__
 *
 * To run a query within a React component, call `useGetEventWithChecklistByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventWithChecklistByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventWithChecklistByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventWithChecklistByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>(GetEventWithChecklistByNameDocument, baseOptions);
      }
export function useGetEventWithChecklistByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>(GetEventWithChecklistByNameDocument, baseOptions);
        }
export type GetEventWithChecklistByNameQueryHookResult = ReturnType<typeof useGetEventWithChecklistByNameQuery>;
export type GetEventWithChecklistByNameLazyQueryHookResult = ReturnType<typeof useGetEventWithChecklistByNameLazyQuery>;
export type GetEventWithChecklistByNameQueryResult = Apollo.QueryResult<GetEventWithChecklistByNameQuery, GetEventWithChecklistByNameQueryVariables>;
export const GetEventInfoByNameDocument = gql`
    query GetEventInfoByName($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      ...EventFragmentForAdmin
    }
  }
}
    ${EventFragmentForAdminFragmentDoc}`;

/**
 * __useGetEventInfoByNameQuery__
 *
 * To run a query within a React component, call `useGetEventInfoByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInfoByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInfoByNameQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventInfoByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>(GetEventInfoByNameDocument, baseOptions);
      }
export function useGetEventInfoByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>(GetEventInfoByNameDocument, baseOptions);
        }
export type GetEventInfoByNameQueryHookResult = ReturnType<typeof useGetEventInfoByNameQuery>;
export type GetEventInfoByNameLazyQueryHookResult = ReturnType<typeof useGetEventInfoByNameLazyQuery>;
export type GetEventInfoByNameQueryResult = Apollo.QueryResult<GetEventInfoByNameQuery, GetEventInfoByNameQueryVariables>;
export const GetEventByNameForDomainDocument = gql`
    query GetEventByNameForDomain($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    info {
      id
      ownerFirstName
      fianceeFirstName
    }
    id
    website
    domain {
      id
      domainName
    }
  }
}
    `;

/**
 * __useGetEventByNameForDomainQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForDomainQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForDomainQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>(GetEventByNameForDomainDocument, baseOptions);
      }
export function useGetEventByNameForDomainLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>(GetEventByNameForDomainDocument, baseOptions);
        }
export type GetEventByNameForDomainQueryHookResult = ReturnType<typeof useGetEventByNameForDomainQuery>;
export type GetEventByNameForDomainLazyQueryHookResult = ReturnType<typeof useGetEventByNameForDomainLazyQuery>;
export type GetEventByNameForDomainQueryResult = Apollo.QueryResult<GetEventByNameForDomainQuery, GetEventByNameForDomainQueryVariables>;
export const GetEventByNameForIdeabookDocument = gql`
    query GetEventByNameForIdeabook($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      ...EventFragment
      eventMatch {
        ...EventMatch
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventMatchFragmentDoc}`;

/**
 * __useGetEventByNameForIdeabookQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForIdeabookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForIdeabookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForIdeabookQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForIdeabookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>(GetEventByNameForIdeabookDocument, baseOptions);
      }
export function useGetEventByNameForIdeabookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>(GetEventByNameForIdeabookDocument, baseOptions);
        }
export type GetEventByNameForIdeabookQueryHookResult = ReturnType<typeof useGetEventByNameForIdeabookQuery>;
export type GetEventByNameForIdeabookLazyQueryHookResult = ReturnType<typeof useGetEventByNameForIdeabookLazyQuery>;
export type GetEventByNameForIdeabookQueryResult = Apollo.QueryResult<GetEventByNameForIdeabookQuery, GetEventByNameForIdeabookQueryVariables>;
export const CheckCanAccessPageDocument = gql`
    query CheckCanAccessPage($eventHandle: String!, $type: EventPageType!) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    firebaseCreateAt {
      milliseconds
    }
    activeSession {
      id
      canAccessPage(type: $type)
    }
    pageInfo(type: $type, normalized: false) {
      id
      private
      disabled
      page {
        id
        pageTitle
      }
    }
  }
}
    `;

/**
 * __useCheckCanAccessPageQuery__
 *
 * To run a query within a React component, call `useCheckCanAccessPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCanAccessPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCanAccessPageQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCheckCanAccessPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>(CheckCanAccessPageDocument, baseOptions);
      }
export function useCheckCanAccessPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>(CheckCanAccessPageDocument, baseOptions);
        }
export type CheckCanAccessPageQueryHookResult = ReturnType<typeof useCheckCanAccessPageQuery>;
export type CheckCanAccessPageLazyQueryHookResult = ReturnType<typeof useCheckCanAccessPageLazyQuery>;
export type CheckCanAccessPageQueryResult = Apollo.QueryResult<CheckCanAccessPageQuery, CheckCanAccessPageQueryVariables>;
export const GetEventByEventIdForEventRedirectDocument = gql`
    query GetEventByEventIdForEventRedirect($id: ID!) {
  eventById(id: $id) {
    id
    firebaseId
    website
  }
}
    `;

/**
 * __useGetEventByEventIdForEventRedirectQuery__
 *
 * To run a query within a React component, call `useGetEventByEventIdForEventRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByEventIdForEventRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByEventIdForEventRedirectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByEventIdForEventRedirectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>(GetEventByEventIdForEventRedirectDocument, baseOptions);
      }
export function useGetEventByEventIdForEventRedirectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>(GetEventByEventIdForEventRedirectDocument, baseOptions);
        }
export type GetEventByEventIdForEventRedirectQueryHookResult = ReturnType<typeof useGetEventByEventIdForEventRedirectQuery>;
export type GetEventByEventIdForEventRedirectLazyQueryHookResult = ReturnType<typeof useGetEventByEventIdForEventRedirectLazyQuery>;
export type GetEventByEventIdForEventRedirectQueryResult = Apollo.QueryResult<GetEventByEventIdForEventRedirectQuery, GetEventByEventIdForEventRedirectQueryVariables>;
export const GetEventForAdminMenuDocument = gql`
    query GetEventForAdminMenu($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      ...EventInfoFragment
    }
    photo {
      id
      url
      altTag
    }
  }
  me {
    id
    avatar {
      id
      url
    }
  }
}
    ${EventInfoFragmentFragmentDoc}`;

/**
 * __useGetEventForAdminMenuQuery__
 *
 * To run a query within a React component, call `useGetEventForAdminMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForAdminMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForAdminMenuQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventForAdminMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>(GetEventForAdminMenuDocument, baseOptions);
      }
export function useGetEventForAdminMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>(GetEventForAdminMenuDocument, baseOptions);
        }
export type GetEventForAdminMenuQueryHookResult = ReturnType<typeof useGetEventForAdminMenuQuery>;
export type GetEventForAdminMenuLazyQueryHookResult = ReturnType<typeof useGetEventForAdminMenuLazyQuery>;
export type GetEventForAdminMenuQueryResult = Apollo.QueryResult<GetEventForAdminMenuQuery, GetEventForAdminMenuQueryVariables>;
export const GetEventFeatureFlagsByEventHandleDocument = gql`
    query GetEventFeatureFlagsByEventHandle($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
  }
}
    `;

/**
 * __useGetEventFeatureFlagsByEventHandleQuery__
 *
 * To run a query within a React component, call `useGetEventFeatureFlagsByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFeatureFlagsByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFeatureFlagsByEventHandleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventFeatureFlagsByEventHandleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>(GetEventFeatureFlagsByEventHandleDocument, baseOptions);
      }
export function useGetEventFeatureFlagsByEventHandleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>(GetEventFeatureFlagsByEventHandleDocument, baseOptions);
        }
export type GetEventFeatureFlagsByEventHandleQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsByEventHandleQuery>;
export type GetEventFeatureFlagsByEventHandleLazyQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsByEventHandleLazyQuery>;
export type GetEventFeatureFlagsByEventHandleQueryResult = Apollo.QueryResult<GetEventFeatureFlagsByEventHandleQuery, GetEventFeatureFlagsByEventHandleQueryVariables>;
export const GetEventForAdminMenuV2Document = gql`
    query GetEventForAdminMenuV2($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    firebaseCreateAt {
      milliseconds
    }
    info {
      ...EventInfoFragment
      eventPassword
    }
    eventOnboarding {
      shouldShowOnboardingSurvey
    }
    productVerticals {
      optOutOfGuestList
      optOutOfInvites
      optOutOfRegistry
      optOutOfWebsite
    }
    pages(admin: true) {
      visibility
      isPageContainer
      createdAt {
        timestamp
      }
      pageSlug
      id
      type
      pageTitle
      photo {
        id
        url
      }
    }
    photo {
      id
      url
      altTag
    }
    recommendation {
      registryOnboardingSurvey {
        id
        lastUpdatedAt {
          dateString
        }
      }
    }
    checklist {
      id
    }
    eventDesign(purpose: live) {
      id
      font {
        id
        fontFamily
      }
      activeWebsiteHeaderPresentationLayout {
        ...WebsiteHeaderPresentationSettings
      }
    }
  }
  me {
    id
    avatar {
      id
      url
    }
  }
}
    ${EventInfoFragmentFragmentDoc}
${WebsiteHeaderPresentationSettingsFragmentDoc}`;

/**
 * __useGetEventForAdminMenuV2Query__
 *
 * To run a query within a React component, call `useGetEventForAdminMenuV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForAdminMenuV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForAdminMenuV2Query({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventForAdminMenuV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>(GetEventForAdminMenuV2Document, baseOptions);
      }
export function useGetEventForAdminMenuV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>(GetEventForAdminMenuV2Document, baseOptions);
        }
export type GetEventForAdminMenuV2QueryHookResult = ReturnType<typeof useGetEventForAdminMenuV2Query>;
export type GetEventForAdminMenuV2LazyQueryHookResult = ReturnType<typeof useGetEventForAdminMenuV2LazyQuery>;
export type GetEventForAdminMenuV2QueryResult = Apollo.QueryResult<GetEventForAdminMenuV2Query, GetEventForAdminMenuV2QueryVariables>;
export const SaveEventProductVerticalsDocument = gql`
    mutation SaveEventProductVerticals($eventId: ID!, $payload: UpdateEventProductVerticalsPayload!) {
  saveEventProductVerticals(eventId: $eventId, payload: $payload) {
    optOutOfGuestList
    optOutOfInvites
    optOutOfRegistry
    optOutOfWebsite
  }
}
    `;
export type SaveEventProductVerticalsMutationFn = Apollo.MutationFunction<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>;

/**
 * __useSaveEventProductVerticalsMutation__
 *
 * To run a mutation, you first call `useSaveEventProductVerticalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventProductVerticalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventProductVerticalsMutation, { data, loading, error }] = useSaveEventProductVerticalsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveEventProductVerticalsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>(SaveEventProductVerticalsDocument, baseOptions);
      }
export type SaveEventProductVerticalsMutationHookResult = ReturnType<typeof useSaveEventProductVerticalsMutation>;
export type SaveEventProductVerticalsMutationResult = Apollo.MutationResult<SaveEventProductVerticalsMutation>;
export type SaveEventProductVerticalsMutationOptions = Apollo.BaseMutationOptions<SaveEventProductVerticalsMutation, SaveEventProductVerticalsMutationVariables>;
export const GetEventAdminsAndInviteesDocument = gql`
    query GetEventAdminsAndInvitees($eventId: ID!) {
  eventById(id: $eventId) {
    id
    eventUsers {
      id
      auth0Id
      status
      user {
        id
        firstName
        lastName
        email
        emailIsVerified
      }
    }
  }
  eventAdminInvites(eventId: $eventId) {
    emailId
    id
    name
    status
  }
}
    `;

/**
 * __useGetEventAdminsAndInviteesQuery__
 *
 * To run a query within a React component, call `useGetEventAdminsAndInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAdminsAndInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAdminsAndInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventAdminsAndInviteesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>(GetEventAdminsAndInviteesDocument, baseOptions);
      }
export function useGetEventAdminsAndInviteesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>(GetEventAdminsAndInviteesDocument, baseOptions);
        }
export type GetEventAdminsAndInviteesQueryHookResult = ReturnType<typeof useGetEventAdminsAndInviteesQuery>;
export type GetEventAdminsAndInviteesLazyQueryHookResult = ReturnType<typeof useGetEventAdminsAndInviteesLazyQuery>;
export type GetEventAdminsAndInviteesQueryResult = Apollo.QueryResult<GetEventAdminsAndInviteesQuery, GetEventAdminsAndInviteesQueryVariables>;
export const GetEventHandleAvailabilityDocument = gql`
    query GetEventHandleAvailability($eventId: ID!, $websiteHandle: String!) {
  isWebsiteHandleAvailable(eventId: $eventId, websiteHandle: $websiteHandle)
}
    `;

/**
 * __useGetEventHandleAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetEventHandleAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventHandleAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventHandleAvailabilityQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      websiteHandle: // value for 'websiteHandle'
 *   },
 * });
 */
export function useGetEventHandleAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>(GetEventHandleAvailabilityDocument, baseOptions);
      }
export function useGetEventHandleAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>(GetEventHandleAvailabilityDocument, baseOptions);
        }
export type GetEventHandleAvailabilityQueryHookResult = ReturnType<typeof useGetEventHandleAvailabilityQuery>;
export type GetEventHandleAvailabilityLazyQueryHookResult = ReturnType<typeof useGetEventHandleAvailabilityLazyQuery>;
export type GetEventHandleAvailabilityQueryResult = Apollo.QueryResult<GetEventHandleAvailabilityQuery, GetEventHandleAvailabilityQueryVariables>;
export const GetUrlVerificationStatusDocument = gql`
    query GetUrlVerificationStatus($url: String!) {
  verifyUrl(url: $url)
}
    `;

/**
 * __useGetUrlVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetUrlVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlVerificationStatusQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetUrlVerificationStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>(GetUrlVerificationStatusDocument, baseOptions);
      }
export function useGetUrlVerificationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>(GetUrlVerificationStatusDocument, baseOptions);
        }
export type GetUrlVerificationStatusQueryHookResult = ReturnType<typeof useGetUrlVerificationStatusQuery>;
export type GetUrlVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetUrlVerificationStatusLazyQuery>;
export type GetUrlVerificationStatusQueryResult = Apollo.QueryResult<GetUrlVerificationStatusQuery, GetUrlVerificationStatusQueryVariables>;
export const FindDefaultThingsToDoPageDocument = gql`
    query FindDefaultThingsToDoPage($eventId: ID!) {
  findDefaultThingsToDoPage(payload: {eventId: $eventId}) {
    id
    slug
  }
}
    `;

/**
 * __useFindDefaultThingsToDoPageQuery__
 *
 * To run a query within a React component, call `useFindDefaultThingsToDoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDefaultThingsToDoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDefaultThingsToDoPageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFindDefaultThingsToDoPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>) {
        return ApolloReactHooks.useQuery<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>(FindDefaultThingsToDoPageDocument, baseOptions);
      }
export function useFindDefaultThingsToDoPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>(FindDefaultThingsToDoPageDocument, baseOptions);
        }
export type FindDefaultThingsToDoPageQueryHookResult = ReturnType<typeof useFindDefaultThingsToDoPageQuery>;
export type FindDefaultThingsToDoPageLazyQueryHookResult = ReturnType<typeof useFindDefaultThingsToDoPageLazyQuery>;
export type FindDefaultThingsToDoPageQueryResult = Apollo.QueryResult<FindDefaultThingsToDoPageQuery, FindDefaultThingsToDoPageQueryVariables>;
export const LoginEventSessionDocument = gql`
    mutation LoginEventSession($eventId: ID) {
  loginEventSession(eventId: $eventId)
}
    `;
export type LoginEventSessionMutationFn = Apollo.MutationFunction<LoginEventSessionMutation, LoginEventSessionMutationVariables>;

/**
 * __useLoginEventSessionMutation__
 *
 * To run a mutation, you first call `useLoginEventSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEventSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEventSessionMutation, { data, loading, error }] = useLoginEventSessionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLoginEventSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginEventSessionMutation, LoginEventSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginEventSessionMutation, LoginEventSessionMutationVariables>(LoginEventSessionDocument, baseOptions);
      }
export type LoginEventSessionMutationHookResult = ReturnType<typeof useLoginEventSessionMutation>;
export type LoginEventSessionMutationResult = Apollo.MutationResult<LoginEventSessionMutation>;
export type LoginEventSessionMutationOptions = Apollo.BaseMutationOptions<LoginEventSessionMutation, LoginEventSessionMutationVariables>;
export const LogoutEventSessionDocument = gql`
    mutation LogoutEventSession($eventId: ID) {
  logoutEventSession(eventId: $eventId)
}
    `;
export type LogoutEventSessionMutationFn = Apollo.MutationFunction<LogoutEventSessionMutation, LogoutEventSessionMutationVariables>;

/**
 * __useLogoutEventSessionMutation__
 *
 * To run a mutation, you first call `useLogoutEventSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutEventSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutEventSessionMutation, { data, loading, error }] = useLogoutEventSessionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLogoutEventSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutEventSessionMutation, LogoutEventSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutEventSessionMutation, LogoutEventSessionMutationVariables>(LogoutEventSessionDocument, baseOptions);
      }
export type LogoutEventSessionMutationHookResult = ReturnType<typeof useLogoutEventSessionMutation>;
export type LogoutEventSessionMutationResult = Apollo.MutationResult<LogoutEventSessionMutation>;
export type LogoutEventSessionMutationOptions = Apollo.BaseMutationOptions<LogoutEventSessionMutation, LogoutEventSessionMutationVariables>;
export const GetEventSessionDocument = gql`
    query GetEventSession($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    activeSession {
      ...EventSessionGuestSite
      eventCTA {
        ...EventSessionCtaGuestSite
      }
    }
  }
}
    ${EventSessionGuestSiteFragmentDoc}
${EventSessionCtaGuestSiteFragmentDoc}`;

/**
 * __useGetEventSessionQuery__
 *
 * To run a query within a React component, call `useGetEventSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSessionQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventSessionQuery, GetEventSessionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventSessionQuery, GetEventSessionQueryVariables>(GetEventSessionDocument, baseOptions);
      }
export function useGetEventSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventSessionQuery, GetEventSessionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventSessionQuery, GetEventSessionQueryVariables>(GetEventSessionDocument, baseOptions);
        }
export type GetEventSessionQueryHookResult = ReturnType<typeof useGetEventSessionQuery>;
export type GetEventSessionLazyQueryHookResult = ReturnType<typeof useGetEventSessionLazyQuery>;
export type GetEventSessionQueryResult = Apollo.QueryResult<GetEventSessionQuery, GetEventSessionQueryVariables>;
export const GetFeatureSetDocument = gql`
    query GetFeatureSet($eventName: String!) {
  eventByName(name: $eventName) {
    id
    registryPage: pageInfo(type: registry) {
      id
      disabled
    }
    rsvpPage: pageInfo(type: rsvp) {
      id
      disabled
    }
    welcomePage: pageInfo(type: welcome) {
      id
      disabled
    }
    pages {
      id
      pageSlug
      type
      visibility
    }
  }
}
    `;

/**
 * __useGetFeatureSetQuery__
 *
 * To run a query within a React component, call `useGetFeatureSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureSetQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *   },
 * });
 */
export function useGetFeatureSetQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureSetQuery, GetFeatureSetQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFeatureSetQuery, GetFeatureSetQueryVariables>(GetFeatureSetDocument, baseOptions);
      }
export function useGetFeatureSetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureSetQuery, GetFeatureSetQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFeatureSetQuery, GetFeatureSetQueryVariables>(GetFeatureSetDocument, baseOptions);
        }
export type GetFeatureSetQueryHookResult = ReturnType<typeof useGetFeatureSetQuery>;
export type GetFeatureSetLazyQueryHookResult = ReturnType<typeof useGetFeatureSetLazyQuery>;
export type GetFeatureSetQueryResult = Apollo.QueryResult<GetFeatureSetQuery, GetFeatureSetQueryVariables>;
export const FilestackDocument = gql`
    query Filestack {
  filestack {
    apiKey
    policy
    signature
  }
}
    `;

/**
 * __useFilestackQuery__
 *
 * To run a query within a React component, call `useFilestackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilestackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilestackQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilestackQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FilestackQuery, FilestackQueryVariables>) {
        return ApolloReactHooks.useQuery<FilestackQuery, FilestackQueryVariables>(FilestackDocument, baseOptions);
      }
export function useFilestackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilestackQuery, FilestackQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FilestackQuery, FilestackQueryVariables>(FilestackDocument, baseOptions);
        }
export type FilestackQueryHookResult = ReturnType<typeof useFilestackQuery>;
export type FilestackLazyQueryHookResult = ReturnType<typeof useFilestackLazyQuery>;
export type FilestackQueryResult = Apollo.QueryResult<FilestackQuery, FilestackQueryVariables>;
export const GetFontsDocument = gql`
    query GetFonts {
  fonts {
    ...Font
  }
}
    ${FontFragmentDoc}`;

/**
 * __useGetFontsQuery__
 *
 * To run a query within a React component, call `useGetFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFontsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFontsQuery, GetFontsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFontsQuery, GetFontsQueryVariables>(GetFontsDocument, baseOptions);
      }
export function useGetFontsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFontsQuery, GetFontsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFontsQuery, GetFontsQueryVariables>(GetFontsDocument, baseOptions);
        }
export type GetFontsQueryHookResult = ReturnType<typeof useGetFontsQuery>;
export type GetFontsLazyQueryHookResult = ReturnType<typeof useGetFontsLazyQuery>;
export type GetFontsQueryResult = Apollo.QueryResult<GetFontsQuery, GetFontsQueryVariables>;
export const GetFontPacksDocument = gql`
    query GetFontPacks {
  fontPacks {
    id
    name
    configuration {
      id
      category
      size
      sizePercent
      font {
        id
        fontFamily
        fontSize
        fontWeight
        typeface
        firebaseFontKey
      }
    }
  }
}
    `;

/**
 * __useGetFontPacksQuery__
 *
 * To run a query within a React component, call `useGetFontPacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFontPacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFontPacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFontPacksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFontPacksQuery, GetFontPacksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFontPacksQuery, GetFontPacksQueryVariables>(GetFontPacksDocument, baseOptions);
      }
export function useGetFontPacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFontPacksQuery, GetFontPacksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFontPacksQuery, GetFontPacksQueryVariables>(GetFontPacksDocument, baseOptions);
        }
export type GetFontPacksQueryHookResult = ReturnType<typeof useGetFontPacksQuery>;
export type GetFontPacksLazyQueryHookResult = ReturnType<typeof useGetFontPacksLazyQuery>;
export type GetFontPacksQueryResult = Apollo.QueryResult<GetFontPacksQuery, GetFontPacksQueryVariables>;
export const GetFontPackByNameDocument = gql`
    query GetFontPackByName($name: String!) {
  fontPackByName(name: $name) {
    id
    name
    configuration {
      id
      category
      sizePercent
      font {
        id
        fontFamily
        fontSize
        fontWeight
        typeface
        firebaseFontKey
      }
    }
  }
}
    `;

/**
 * __useGetFontPackByNameQuery__
 *
 * To run a query within a React component, call `useGetFontPackByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFontPackByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFontPackByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFontPackByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFontPackByNameQuery, GetFontPackByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFontPackByNameQuery, GetFontPackByNameQueryVariables>(GetFontPackByNameDocument, baseOptions);
      }
export function useGetFontPackByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFontPackByNameQuery, GetFontPackByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFontPackByNameQuery, GetFontPackByNameQueryVariables>(GetFontPackByNameDocument, baseOptions);
        }
export type GetFontPackByNameQueryHookResult = ReturnType<typeof useGetFontPackByNameQuery>;
export type GetFontPackByNameLazyQueryHookResult = ReturnType<typeof useGetFontPackByNameLazyQuery>;
export type GetFontPackByNameQueryResult = Apollo.QueryResult<GetFontPackByNameQuery, GetFontPackByNameQueryVariables>;
export const ApplyFontPackDocument = gql`
    mutation ApplyFontPack($eventDesignId: ID!, $fontPackId: ID!) {
  applyFontPack(eventDesignId: $eventDesignId, fontPackId: $fontPackId) {
    id
  }
}
    `;
export type ApplyFontPackMutationFn = Apollo.MutationFunction<ApplyFontPackMutation, ApplyFontPackMutationVariables>;

/**
 * __useApplyFontPackMutation__
 *
 * To run a mutation, you first call `useApplyFontPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFontPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFontPackMutation, { data, loading, error }] = useApplyFontPackMutation({
 *   variables: {
 *      eventDesignId: // value for 'eventDesignId'
 *      fontPackId: // value for 'fontPackId'
 *   },
 * });
 */
export function useApplyFontPackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyFontPackMutation, ApplyFontPackMutationVariables>) {
        return ApolloReactHooks.useMutation<ApplyFontPackMutation, ApplyFontPackMutationVariables>(ApplyFontPackDocument, baseOptions);
      }
export type ApplyFontPackMutationHookResult = ReturnType<typeof useApplyFontPackMutation>;
export type ApplyFontPackMutationResult = Apollo.MutationResult<ApplyFontPackMutation>;
export type ApplyFontPackMutationOptions = Apollo.BaseMutationOptions<ApplyFontPackMutation, ApplyFontPackMutationVariables>;
export const EditFontConfigurationDocument = gql`
    mutation EditFontConfiguration($eventDesignId: ID!, $input: SetConfigurationInput!) {
  editFontConfiguration(eventDesignId: $eventDesignId, input: $input) {
    id
  }
}
    `;
export type EditFontConfigurationMutationFn = Apollo.MutationFunction<EditFontConfigurationMutation, EditFontConfigurationMutationVariables>;

/**
 * __useEditFontConfigurationMutation__
 *
 * To run a mutation, you first call `useEditFontConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFontConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFontConfigurationMutation, { data, loading, error }] = useEditFontConfigurationMutation({
 *   variables: {
 *      eventDesignId: // value for 'eventDesignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFontConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditFontConfigurationMutation, EditFontConfigurationMutationVariables>) {
        return ApolloReactHooks.useMutation<EditFontConfigurationMutation, EditFontConfigurationMutationVariables>(EditFontConfigurationDocument, baseOptions);
      }
export type EditFontConfigurationMutationHookResult = ReturnType<typeof useEditFontConfigurationMutation>;
export type EditFontConfigurationMutationResult = Apollo.MutationResult<EditFontConfigurationMutation>;
export type EditFontConfigurationMutationOptions = Apollo.BaseMutationOptions<EditFontConfigurationMutation, EditFontConfigurationMutationVariables>;
export const ResetFontConfigurationDocument = gql`
    mutation ResetFontConfiguration($eventDesignId: ID!) {
  resetFontConfiguration(eventDesignId: $eventDesignId) {
    id
    font {
      id
      fontWeight
      fontSize
      fontFamily
      firebaseFontKey
    }
    size
    sizePercent
    category
  }
}
    `;
export type ResetFontConfigurationMutationFn = Apollo.MutationFunction<ResetFontConfigurationMutation, ResetFontConfigurationMutationVariables>;

/**
 * __useResetFontConfigurationMutation__
 *
 * To run a mutation, you first call `useResetFontConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFontConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFontConfigurationMutation, { data, loading, error }] = useResetFontConfigurationMutation({
 *   variables: {
 *      eventDesignId: // value for 'eventDesignId'
 *   },
 * });
 */
export function useResetFontConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetFontConfigurationMutation, ResetFontConfigurationMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetFontConfigurationMutation, ResetFontConfigurationMutationVariables>(ResetFontConfigurationDocument, baseOptions);
      }
export type ResetFontConfigurationMutationHookResult = ReturnType<typeof useResetFontConfigurationMutation>;
export type ResetFontConfigurationMutationResult = Apollo.MutationResult<ResetFontConfigurationMutation>;
export type ResetFontConfigurationMutationOptions = Apollo.BaseMutationOptions<ResetFontConfigurationMutation, ResetFontConfigurationMutationVariables>;
export const SearchAccommodationPropertiesDocument = gql`
    query SearchAccommodationProperties($payload: AccommodationContentSearchInput!) {
  searchAccommodationProperties(payload: $payload) {
    properties {
      joyPlaceId
      name
      plainTextLongDescription
      propertyType
      location {
        latitude
        longitude
      }
      address {
        city
        country
        postalCode
        state
        street
      }
      photos {
        photo {
          id
          assetId
        }
        url
      }
      starRating
      userRating {
        ratingCount
        ratingValue
      }
    }
  }
}
    `;

/**
 * __useSearchAccommodationPropertiesQuery__
 *
 * To run a query within a React component, call `useSearchAccommodationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccommodationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccommodationPropertiesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSearchAccommodationPropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchAccommodationPropertiesQuery, SearchAccommodationPropertiesQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchAccommodationPropertiesQuery, SearchAccommodationPropertiesQueryVariables>(SearchAccommodationPropertiesDocument, baseOptions);
      }
export function useSearchAccommodationPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAccommodationPropertiesQuery, SearchAccommodationPropertiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchAccommodationPropertiesQuery, SearchAccommodationPropertiesQueryVariables>(SearchAccommodationPropertiesDocument, baseOptions);
        }
export type SearchAccommodationPropertiesQueryHookResult = ReturnType<typeof useSearchAccommodationPropertiesQuery>;
export type SearchAccommodationPropertiesLazyQueryHookResult = ReturnType<typeof useSearchAccommodationPropertiesLazyQuery>;
export type SearchAccommodationPropertiesQueryResult = Apollo.QueryResult<SearchAccommodationPropertiesQuery, SearchAccommodationPropertiesQueryVariables>;
export const GetPageIdsDocument = gql`
    query GetPageIds($name: String!) {
  eventByName(name: $name) {
    id
    pages {
      id
      type
    }
  }
}
    `;

/**
 * __useGetPageIdsQuery__
 *
 * To run a query within a React component, call `useGetPageIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageIdsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPageIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPageIdsQuery, GetPageIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPageIdsQuery, GetPageIdsQueryVariables>(GetPageIdsDocument, baseOptions);
      }
export function useGetPageIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPageIdsQuery, GetPageIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPageIdsQuery, GetPageIdsQueryVariables>(GetPageIdsDocument, baseOptions);
        }
export type GetPageIdsQueryHookResult = ReturnType<typeof useGetPageIdsQuery>;
export type GetPageIdsLazyQueryHookResult = ReturnType<typeof useGetPageIdsLazyQuery>;
export type GetPageIdsQueryResult = Apollo.QueryResult<GetPageIdsQuery, GetPageIdsQueryVariables>;
export const GetWebsiteLayoutsDocument = gql`
    query GetWebsiteLayouts {
  layouts {
    ...DesignLayout
  }
}
    ${DesignLayoutFragmentDoc}`;

/**
 * __useGetWebsiteLayoutsQuery__
 *
 * To run a query within a React component, call `useGetWebsiteLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteLayoutsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteLayoutsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteLayoutsQuery, GetWebsiteLayoutsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsiteLayoutsQuery, GetWebsiteLayoutsQueryVariables>(GetWebsiteLayoutsDocument, baseOptions);
      }
export function useGetWebsiteLayoutsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteLayoutsQuery, GetWebsiteLayoutsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsiteLayoutsQuery, GetWebsiteLayoutsQueryVariables>(GetWebsiteLayoutsDocument, baseOptions);
        }
export type GetWebsiteLayoutsQueryHookResult = ReturnType<typeof useGetWebsiteLayoutsQuery>;
export type GetWebsiteLayoutsLazyQueryHookResult = ReturnType<typeof useGetWebsiteLayoutsLazyQuery>;
export type GetWebsiteLayoutsQueryResult = Apollo.QueryResult<GetWebsiteLayoutsQuery, GetWebsiteLayoutsQueryVariables>;
export const MatchByIdDocument = gql`
    query MatchById($matchId: ID!) {
  match(id: $matchId) {
    id
    status
    matchNote
    vendor {
      ...Vendor
      collections {
        ...Collection
      }
      photo {
        ...Photo
      }
    }
  }
}
    ${VendorFragmentDoc}
${CollectionFragmentDoc}
${PhotoFragmentDoc}`;

/**
 * __useMatchByIdQuery__
 *
 * To run a query within a React component, call `useMatchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchByIdQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MatchByIdQuery, MatchByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<MatchByIdQuery, MatchByIdQueryVariables>(MatchByIdDocument, baseOptions);
      }
export function useMatchByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchByIdQuery, MatchByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MatchByIdQuery, MatchByIdQueryVariables>(MatchByIdDocument, baseOptions);
        }
export type MatchByIdQueryHookResult = ReturnType<typeof useMatchByIdQuery>;
export type MatchByIdLazyQueryHookResult = ReturnType<typeof useMatchByIdLazyQuery>;
export type MatchByIdQueryResult = Apollo.QueryResult<MatchByIdQuery, MatchByIdQueryVariables>;
export const PhotoByIdDocument = gql`
    query PhotoById($id: ID!) {
  photo(id: $id) {
    ...PhotoWithMetatags
  }
}
    ${PhotoWithMetatagsFragmentDoc}`;

/**
 * __usePhotoByIdQuery__
 *
 * To run a query within a React component, call `usePhotoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePhotoByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotoByIdQuery, PhotoByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotoByIdQuery, PhotoByIdQueryVariables>(PhotoByIdDocument, baseOptions);
      }
export function usePhotoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoByIdQuery, PhotoByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotoByIdQuery, PhotoByIdQueryVariables>(PhotoByIdDocument, baseOptions);
        }
export type PhotoByIdQueryHookResult = ReturnType<typeof usePhotoByIdQuery>;
export type PhotoByIdLazyQueryHookResult = ReturnType<typeof usePhotoByIdLazyQuery>;
export type PhotoByIdQueryResult = Apollo.QueryResult<PhotoByIdQuery, PhotoByIdQueryVariables>;
export const PhotosByIdDocument = gql`
    query PhotosById($ids: [ID!]!) {
  photos(ids: $ids) {
    ...PhotoWithMetatags
  }
}
    ${PhotoWithMetatagsFragmentDoc}`;

/**
 * __usePhotosByIdQuery__
 *
 * To run a query within a React component, call `usePhotosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotosByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePhotosByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotosByIdQuery, PhotosByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotosByIdQuery, PhotosByIdQueryVariables>(PhotosByIdDocument, baseOptions);
      }
export function usePhotosByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotosByIdQuery, PhotosByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotosByIdQuery, PhotosByIdQueryVariables>(PhotosByIdDocument, baseOptions);
        }
export type PhotosByIdQueryHookResult = ReturnType<typeof usePhotosByIdQuery>;
export type PhotosByIdLazyQueryHookResult = ReturnType<typeof usePhotosByIdLazyQuery>;
export type PhotosByIdQueryResult = Apollo.QueryResult<PhotosByIdQuery, PhotosByIdQueryVariables>;
export const PhotosByIdWithVendorCollectionsDocument = gql`
    query PhotosByIdWithVendorCollections($ids: [ID!]!) {
  photos(ids: $ids) {
    ...PhotoWithMetatagsVendorCollections
  }
}
    ${PhotoWithMetatagsVendorCollectionsFragmentDoc}`;

/**
 * __usePhotosByIdWithVendorCollectionsQuery__
 *
 * To run a query within a React component, call `usePhotosByIdWithVendorCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotosByIdWithVendorCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotosByIdWithVendorCollectionsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePhotosByIdWithVendorCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotosByIdWithVendorCollectionsQuery, PhotosByIdWithVendorCollectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotosByIdWithVendorCollectionsQuery, PhotosByIdWithVendorCollectionsQueryVariables>(PhotosByIdWithVendorCollectionsDocument, baseOptions);
      }
export function usePhotosByIdWithVendorCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotosByIdWithVendorCollectionsQuery, PhotosByIdWithVendorCollectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotosByIdWithVendorCollectionsQuery, PhotosByIdWithVendorCollectionsQueryVariables>(PhotosByIdWithVendorCollectionsDocument, baseOptions);
        }
export type PhotosByIdWithVendorCollectionsQueryHookResult = ReturnType<typeof usePhotosByIdWithVendorCollectionsQuery>;
export type PhotosByIdWithVendorCollectionsLazyQueryHookResult = ReturnType<typeof usePhotosByIdWithVendorCollectionsLazyQuery>;
export type PhotosByIdWithVendorCollectionsQueryResult = Apollo.QueryResult<PhotosByIdWithVendorCollectionsQuery, PhotosByIdWithVendorCollectionsQueryVariables>;
export const LikedPhotsByUserIdDocument = gql`
    query LikedPhotsByUserId($id: ID!) {
  user(id: $id) {
    id
    likedPhotos {
      ...PhotoWithMetatags
    }
    vendorsOnLikedPhotos {
      ...VendorSlim
    }
  }
}
    ${PhotoWithMetatagsFragmentDoc}
${VendorSlimFragmentDoc}`;

/**
 * __useLikedPhotsByUserIdQuery__
 *
 * To run a query within a React component, call `useLikedPhotsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLikedPhotsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLikedPhotsByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLikedPhotsByUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LikedPhotsByUserIdQuery, LikedPhotsByUserIdQueryVariables>) {
        return ApolloReactHooks.useQuery<LikedPhotsByUserIdQuery, LikedPhotsByUserIdQueryVariables>(LikedPhotsByUserIdDocument, baseOptions);
      }
export function useLikedPhotsByUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LikedPhotsByUserIdQuery, LikedPhotsByUserIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LikedPhotsByUserIdQuery, LikedPhotsByUserIdQueryVariables>(LikedPhotsByUserIdDocument, baseOptions);
        }
export type LikedPhotsByUserIdQueryHookResult = ReturnType<typeof useLikedPhotsByUserIdQuery>;
export type LikedPhotsByUserIdLazyQueryHookResult = ReturnType<typeof useLikedPhotsByUserIdLazyQuery>;
export type LikedPhotsByUserIdQueryResult = Apollo.QueryResult<LikedPhotsByUserIdQuery, LikedPhotsByUserIdQueryVariables>;
export const CollectionIdsByPhotoIdDocument = gql`
    query CollectionIdsByPhotoId($id: ID!) {
  photo(id: $id) {
    id
    collectionItems {
      id
      collection {
        id
      }
    }
  }
}
    `;

/**
 * __useCollectionIdsByPhotoIdQuery__
 *
 * To run a query within a React component, call `useCollectionIdsByPhotoIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionIdsByPhotoIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionIdsByPhotoIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionIdsByPhotoIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CollectionIdsByPhotoIdQuery, CollectionIdsByPhotoIdQueryVariables>) {
        return ApolloReactHooks.useQuery<CollectionIdsByPhotoIdQuery, CollectionIdsByPhotoIdQueryVariables>(CollectionIdsByPhotoIdDocument, baseOptions);
      }
export function useCollectionIdsByPhotoIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CollectionIdsByPhotoIdQuery, CollectionIdsByPhotoIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CollectionIdsByPhotoIdQuery, CollectionIdsByPhotoIdQueryVariables>(CollectionIdsByPhotoIdDocument, baseOptions);
        }
export type CollectionIdsByPhotoIdQueryHookResult = ReturnType<typeof useCollectionIdsByPhotoIdQuery>;
export type CollectionIdsByPhotoIdLazyQueryHookResult = ReturnType<typeof useCollectionIdsByPhotoIdLazyQuery>;
export type CollectionIdsByPhotoIdQueryResult = Apollo.QueryResult<CollectionIdsByPhotoIdQuery, CollectionIdsByPhotoIdQueryVariables>;
export const PhotosByGeneratedSimpleTagDocument = gql`
    query PhotosByGeneratedSimpleTag($include: [String!]!, $exclude: [String!], $page: Int, $perPage: Int, $cursor: String) {
  photosByGeneratedSimpleTags(payload: {include: $include, exclude: $exclude, page: $page, perPage: $perPage}) {
    ...SyntheticCollectionWithMetatagsPaginated
  }
}
    ${SyntheticCollectionWithMetatagsPaginatedFragmentDoc}`;

/**
 * __usePhotosByGeneratedSimpleTagQuery__
 *
 * To run a query within a React component, call `usePhotosByGeneratedSimpleTagQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotosByGeneratedSimpleTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotosByGeneratedSimpleTagQuery({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePhotosByGeneratedSimpleTagQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotosByGeneratedSimpleTagQuery, PhotosByGeneratedSimpleTagQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotosByGeneratedSimpleTagQuery, PhotosByGeneratedSimpleTagQueryVariables>(PhotosByGeneratedSimpleTagDocument, baseOptions);
      }
export function usePhotosByGeneratedSimpleTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotosByGeneratedSimpleTagQuery, PhotosByGeneratedSimpleTagQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotosByGeneratedSimpleTagQuery, PhotosByGeneratedSimpleTagQueryVariables>(PhotosByGeneratedSimpleTagDocument, baseOptions);
        }
export type PhotosByGeneratedSimpleTagQueryHookResult = ReturnType<typeof usePhotosByGeneratedSimpleTagQuery>;
export type PhotosByGeneratedSimpleTagLazyQueryHookResult = ReturnType<typeof usePhotosByGeneratedSimpleTagLazyQuery>;
export type PhotosByGeneratedSimpleTagQueryResult = Apollo.QueryResult<PhotosByGeneratedSimpleTagQuery, PhotosByGeneratedSimpleTagQueryVariables>;
export const PublicShopRootDocument = gql`
    query PublicShopRoot($eventId: ID!, $includeEvent: Boolean!) {
  eventById(id: $eventId) @include(if: $includeEvent) {
    id
    website
    ...RegistryShippingAddressFragment
    info {
      id
      eventType
      registry {
        ...Registry
      }
      finalizedDate {
        ...Date
      }
    }
    registry {
      id
      orders {
        ...RegistryOrder
      }
    }
  }
}
    ${RegistryShippingAddressFragmentFragmentDoc}
${RegistryFragmentDoc}
${DateFragmentDoc}
${RegistryOrderFragmentDoc}`;

/**
 * __usePublicShopRootQuery__
 *
 * To run a query within a React component, call `usePublicShopRootQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicShopRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicShopRootQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      includeEvent: // value for 'includeEvent'
 *   },
 * });
 */
export function usePublicShopRootQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicShopRootQuery, PublicShopRootQueryVariables>) {
        return ApolloReactHooks.useQuery<PublicShopRootQuery, PublicShopRootQueryVariables>(PublicShopRootDocument, baseOptions);
      }
export function usePublicShopRootLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicShopRootQuery, PublicShopRootQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PublicShopRootQuery, PublicShopRootQueryVariables>(PublicShopRootDocument, baseOptions);
        }
export type PublicShopRootQueryHookResult = ReturnType<typeof usePublicShopRootQuery>;
export type PublicShopRootLazyQueryHookResult = ReturnType<typeof usePublicShopRootLazyQuery>;
export type PublicShopRootQueryResult = Apollo.QueryResult<PublicShopRootQuery, PublicShopRootQueryVariables>;
export const GetRegistryStoreSectionsDocument = gql`
    query GetRegistryStoreSections($names: [String!]) {
  registryStoreSections(names: $names) {
    name
    stores {
      ...RegistryStore
    }
  }
}
    ${RegistryStoreFragmentDoc}`;

/**
 * __useGetRegistryStoreSectionsQuery__
 *
 * To run a query within a React component, call `useGetRegistryStoreSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryStoreSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryStoreSectionsQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useGetRegistryStoreSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>(GetRegistryStoreSectionsDocument, baseOptions);
      }
export function useGetRegistryStoreSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>(GetRegistryStoreSectionsDocument, baseOptions);
        }
export type GetRegistryStoreSectionsQueryHookResult = ReturnType<typeof useGetRegistryStoreSectionsQuery>;
export type GetRegistryStoreSectionsLazyQueryHookResult = ReturnType<typeof useGetRegistryStoreSectionsLazyQuery>;
export type GetRegistryStoreSectionsQueryResult = Apollo.QueryResult<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>;
export const GetRegistryProductsDataDocument = gql`
    query GetRegistryProductsData($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    ... on Event {
      id
      info {
        id
        registry {
          ...Registry
        }
      }
    }
  }
}
    ${RegistryFragmentDoc}`;

/**
 * __useGetRegistryProductsDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryProductsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryProductsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryProductsDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryProductsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>(GetRegistryProductsDataDocument, baseOptions);
      }
export function useGetRegistryProductsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>(GetRegistryProductsDataDocument, baseOptions);
        }
export type GetRegistryProductsDataQueryHookResult = ReturnType<typeof useGetRegistryProductsDataQuery>;
export type GetRegistryProductsDataLazyQueryHookResult = ReturnType<typeof useGetRegistryProductsDataLazyQuery>;
export type GetRegistryProductsDataQueryResult = Apollo.QueryResult<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>;
export const GetRegistryPageDocument = gql`
    query GetRegistryPage($eventId: ID!) {
  registryPage(eventId: $eventId) {
    photo {
      ...Photo
    }
  }
}
    ${PhotoFragmentDoc}`;

/**
 * __useGetRegistryPageQuery__
 *
 * To run a query within a React component, call `useGetRegistryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPageQuery, GetRegistryPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryPageQuery, GetRegistryPageQueryVariables>(GetRegistryPageDocument, baseOptions);
      }
export function useGetRegistryPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPageQuery, GetRegistryPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryPageQuery, GetRegistryPageQueryVariables>(GetRegistryPageDocument, baseOptions);
        }
export type GetRegistryPageQueryHookResult = ReturnType<typeof useGetRegistryPageQuery>;
export type GetRegistryPageLazyQueryHookResult = ReturnType<typeof useGetRegistryPageLazyQuery>;
export type GetRegistryPageQueryResult = Apollo.QueryResult<GetRegistryPageQuery, GetRegistryPageQueryVariables>;
export const CheckRegistryUrlCanSyncDocument = gql`
    query CheckRegistryUrlCanSync($url: String!) {
  checkRegistryUrlCanSync(url: $url)
}
    `;

/**
 * __useCheckRegistryUrlCanSyncQuery__
 *
 * To run a query within a React component, call `useCheckRegistryUrlCanSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegistryUrlCanSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegistryUrlCanSyncQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckRegistryUrlCanSyncQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>(CheckRegistryUrlCanSyncDocument, baseOptions);
      }
export function useCheckRegistryUrlCanSyncLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>(CheckRegistryUrlCanSyncDocument, baseOptions);
        }
export type CheckRegistryUrlCanSyncQueryHookResult = ReturnType<typeof useCheckRegistryUrlCanSyncQuery>;
export type CheckRegistryUrlCanSyncLazyQueryHookResult = ReturnType<typeof useCheckRegistryUrlCanSyncLazyQuery>;
export type CheckRegistryUrlCanSyncQueryResult = Apollo.QueryResult<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>;
export const CheckRegistryUrlDocument = gql`
    query CheckRegistryUrl($url: String!) {
  checkRegistryUrl(url: $url) {
    canSync
    canTransfer
  }
}
    `;

/**
 * __useCheckRegistryUrlQuery__
 *
 * To run a query within a React component, call `useCheckRegistryUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegistryUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegistryUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckRegistryUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>(CheckRegistryUrlDocument, baseOptions);
      }
export function useCheckRegistryUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>(CheckRegistryUrlDocument, baseOptions);
        }
export type CheckRegistryUrlQueryHookResult = ReturnType<typeof useCheckRegistryUrlQuery>;
export type CheckRegistryUrlLazyQueryHookResult = ReturnType<typeof useCheckRegistryUrlLazyQuery>;
export type CheckRegistryUrlQueryResult = Apollo.QueryResult<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>;
export const RegistryOrderByIdDocument = gql`
    query RegistryOrderById($id: ID!) {
  registryOrderById(id: $id) {
    id
    email
    name
    isPurchased
    isDropship
    lineItems {
      ...LineItem
    }
  }
}
    ${LineItemFragmentDoc}`;

/**
 * __useRegistryOrderByIdQuery__
 *
 * To run a query within a React component, call `useRegistryOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistryOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>(RegistryOrderByIdDocument, baseOptions);
      }
export function useRegistryOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>(RegistryOrderByIdDocument, baseOptions);
        }
export type RegistryOrderByIdQueryHookResult = ReturnType<typeof useRegistryOrderByIdQuery>;
export type RegistryOrderByIdLazyQueryHookResult = ReturnType<typeof useRegistryOrderByIdLazyQuery>;
export type RegistryOrderByIdQueryResult = Apollo.QueryResult<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>;
export const GetRegistryOrdersCheckoutMechanismsDocument = gql`
    query GetRegistryOrdersCheckoutMechanisms($ids: [ID!]!, $shippingAddress: ShippingAddressInput) {
  registryOrdersByIds(ids: $ids) {
    id
    lineItems {
      locator
      quantity
      registryItem {
        id
        productData {
          registryItem {
            id
          }
          title
          checkoutMechanisms(shippingAddress: $shippingAddress) {
            ...CheckoutMechanismType
          }
        }
      }
    }
  }
}
    ${CheckoutMechanismTypeFragmentDoc}`;

/**
 * __useGetRegistryOrdersCheckoutMechanismsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrdersCheckoutMechanismsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrdersCheckoutMechanismsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrdersCheckoutMechanismsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useGetRegistryOrdersCheckoutMechanismsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>(GetRegistryOrdersCheckoutMechanismsDocument, baseOptions);
      }
export function useGetRegistryOrdersCheckoutMechanismsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>(GetRegistryOrdersCheckoutMechanismsDocument, baseOptions);
        }
export type GetRegistryOrdersCheckoutMechanismsQueryHookResult = ReturnType<typeof useGetRegistryOrdersCheckoutMechanismsQuery>;
export type GetRegistryOrdersCheckoutMechanismsLazyQueryHookResult = ReturnType<typeof useGetRegistryOrdersCheckoutMechanismsLazyQuery>;
export type GetRegistryOrdersCheckoutMechanismsQueryResult = Apollo.QueryResult<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>;
export const GetItemCheckoutMechanismsDocument = gql`
    query GetItemCheckoutMechanisms($id: ID!, $shippingAddress: ShippingAddressInput, $requestedQty: Int) {
  registryItem(id: $id) {
    id
    productData {
      registryItem {
        id
      }
      checkoutMechanisms(shippingAddress: $shippingAddress, requestedQty: $requestedQty) {
        ...CheckoutMechanismType
      }
    }
  }
}
    ${CheckoutMechanismTypeFragmentDoc}`;

/**
 * __useGetItemCheckoutMechanismsQuery__
 *
 * To run a query within a React component, call `useGetItemCheckoutMechanismsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemCheckoutMechanismsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemCheckoutMechanismsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shippingAddress: // value for 'shippingAddress'
 *      requestedQty: // value for 'requestedQty'
 *   },
 * });
 */
export function useGetItemCheckoutMechanismsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>(GetItemCheckoutMechanismsDocument, baseOptions);
      }
export function useGetItemCheckoutMechanismsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>(GetItemCheckoutMechanismsDocument, baseOptions);
        }
export type GetItemCheckoutMechanismsQueryHookResult = ReturnType<typeof useGetItemCheckoutMechanismsQuery>;
export type GetItemCheckoutMechanismsLazyQueryHookResult = ReturnType<typeof useGetItemCheckoutMechanismsLazyQuery>;
export type GetItemCheckoutMechanismsQueryResult = Apollo.QueryResult<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>;
export const GetRegistryPurchaseConfirmationDetailsDocument = gql`
    query GetRegistryPurchaseConfirmationDetails($purchaseContextId: ID!) {
  registryPurchaseConfirmationDetailsByPurchaseContextId(purchaseContextId: $purchaseContextId) {
    salesOrder {
      id
      sender {
        email
        name
      }
      subtotal {
        ...MonetaryValue
      }
      total {
        ...MonetaryValue
      }
      taxesTotal {
        ...MonetaryValue
      }
      shippingAndHandlingTotal {
        ...MonetaryValue
      }
      orderChargesTotal {
        ...MonetaryValue
      }
      postPurchaseFeesTotal {
        ...MonetaryValue
      }
      compensationTotal {
        ...MonetaryValue
      }
      orderTags {
        key
        value
      }
      items {
        ...SalesOrderLine
        isEdelivery
        unitValue {
          ...MonetaryValue
        }
        quantity
        photos {
          id
          url
        }
        isEdelivery
        isCashFund
      }
      taxes {
        ...SalesOrderLine
      }
      shippingAndHandling {
        ...SalesOrderLine
      }
      orderCharges {
        ...SalesOrderLine
      }
      postPurchaseFees {
        ...SalesOrderLine
      }
      compensation {
        ...SalesOrderLine
      }
      paymentMethod {
        ...CardPaymentMethod
      }
    }
  }
}
    ${MonetaryValueFragmentDoc}
${SalesOrderLineFragmentDoc}
${CardPaymentMethodFragmentDoc}`;

/**
 * __useGetRegistryPurchaseConfirmationDetailsQuery__
 *
 * To run a query within a React component, call `useGetRegistryPurchaseConfirmationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPurchaseConfirmationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPurchaseConfirmationDetailsQuery({
 *   variables: {
 *      purchaseContextId: // value for 'purchaseContextId'
 *   },
 * });
 */
export function useGetRegistryPurchaseConfirmationDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>(GetRegistryPurchaseConfirmationDetailsDocument, baseOptions);
      }
export function useGetRegistryPurchaseConfirmationDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>(GetRegistryPurchaseConfirmationDetailsDocument, baseOptions);
        }
export type GetRegistryPurchaseConfirmationDetailsQueryHookResult = ReturnType<typeof useGetRegistryPurchaseConfirmationDetailsQuery>;
export type GetRegistryPurchaseConfirmationDetailsLazyQueryHookResult = ReturnType<typeof useGetRegistryPurchaseConfirmationDetailsLazyQuery>;
export type GetRegistryPurchaseConfirmationDetailsQueryResult = Apollo.QueryResult<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>;
export const GetRegistryStaticDataDocument = gql`
    query GetRegistryStaticData {
  getRegistryStaticData {
    countries {
      topRanked {
        name
        code
      }
      ordered {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetRegistryStaticDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryStaticDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryStaticDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryStaticDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegistryStaticDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>(GetRegistryStaticDataDocument, baseOptions);
      }
export function useGetRegistryStaticDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>(GetRegistryStaticDataDocument, baseOptions);
        }
export type GetRegistryStaticDataQueryHookResult = ReturnType<typeof useGetRegistryStaticDataQuery>;
export type GetRegistryStaticDataLazyQueryHookResult = ReturnType<typeof useGetRegistryStaticDataLazyQuery>;
export type GetRegistryStaticDataQueryResult = Apollo.QueryResult<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>;
export const GetRegistryOrderByIdDocument = gql`
    query GetRegistryOrderById($registryOrderId: ID!) {
  registryOrderById(id: $registryOrderId) {
    id
    name
    email
    lineItems {
      quantity
      registryItem {
        id
        alreadyReserved
        alreadyPurchased
        productData {
          registryItem {
            id
          }
          title
          photos {
            id
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRegistryOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrderByIdQuery({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *   },
 * });
 */
export function useGetRegistryOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>(GetRegistryOrderByIdDocument, baseOptions);
      }
export function useGetRegistryOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>(GetRegistryOrderByIdDocument, baseOptions);
        }
export type GetRegistryOrderByIdQueryHookResult = ReturnType<typeof useGetRegistryOrderByIdQuery>;
export type GetRegistryOrderByIdLazyQueryHookResult = ReturnType<typeof useGetRegistryOrderByIdLazyQuery>;
export type GetRegistryOrderByIdQueryResult = Apollo.QueryResult<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>;
export const GetDonationFundDonationByIdDocument = gql`
    query GetDonationFundDonationById($registryOrderId: ID!) {
  getDonationFundDonationById(id: $registryOrderId) {
    ...DonationFundDonation
  }
}
    ${DonationFundDonationFragmentDoc}`;

/**
 * __useGetDonationFundDonationByIdQuery__
 *
 * To run a query within a React component, call `useGetDonationFundDonationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationFundDonationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationFundDonationByIdQuery({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *   },
 * });
 */
export function useGetDonationFundDonationByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>(GetDonationFundDonationByIdDocument, baseOptions);
      }
export function useGetDonationFundDonationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>(GetDonationFundDonationByIdDocument, baseOptions);
        }
export type GetDonationFundDonationByIdQueryHookResult = ReturnType<typeof useGetDonationFundDonationByIdQuery>;
export type GetDonationFundDonationByIdLazyQueryHookResult = ReturnType<typeof useGetDonationFundDonationByIdLazyQuery>;
export type GetDonationFundDonationByIdQueryResult = Apollo.QueryResult<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>;
export const GetRegistryOnboardingSuggestionsDocument = gql`
    query GetRegistryOnboardingSuggestions($eventId: ID!) {
  me {
    id
    emailIsVerified(liveQuery: true)
  }
  eventById(id: $eventId) {
    id
    website
    suggestion {
      items {
        ...EventSuggestion
      }
    }
    eventUsers {
      id
    }
    info {
      id
      greeting
      locationInfo {
        id
        country
      }
      finalizedDate {
        ...Date
      }
      registry {
        id
        storeName
        items {
          id
          externallyOwned
          productData {
            registryItem {
              id
            }
            customType
          }
        }
      }
    }
    registryPageInfo: pageInfo(type: registry) {
      id
      page {
        id
        disabled
        pageSubtitle: pageSubTitleV0918
        photoV2 {
          ... on Photo {
            id
            url
          }
          ... on DefaultPagePhoto {
            id
            url
          }
        }
      }
    }
    ...RegistryShippingAddressFragment
    registry {
      id
      currency {
        id
        code
      }
    }
  }
  registryPage(eventId: $eventId) {
    photo {
      id
      url
    }
  }
}
    ${EventSuggestionFragmentDoc}
${DateFragmentDoc}
${RegistryShippingAddressFragmentFragmentDoc}`;

/**
 * __useGetRegistryOnboardingSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOnboardingSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOnboardingSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOnboardingSuggestionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryOnboardingSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>(GetRegistryOnboardingSuggestionsDocument, baseOptions);
      }
export function useGetRegistryOnboardingSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>(GetRegistryOnboardingSuggestionsDocument, baseOptions);
        }
export type GetRegistryOnboardingSuggestionsQueryHookResult = ReturnType<typeof useGetRegistryOnboardingSuggestionsQuery>;
export type GetRegistryOnboardingSuggestionsLazyQueryHookResult = ReturnType<typeof useGetRegistryOnboardingSuggestionsLazyQuery>;
export type GetRegistryOnboardingSuggestionsQueryResult = Apollo.QueryResult<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>;
export const GetRegistrySettingsDialogDataDocument = gql`
    query GetRegistrySettingsDialogData($eventId: ID!) {
  eventById(id: $eventId) {
    id
    website
    info {
      id
      tentativeDate {
        ...Date
      }
      finalizedDate {
        ...Date
      }
      ownerFirstName
      ownerLastName
      fianceeFirstName
      fianceeLastName
      eventDisplayName
      eventDateIsFinalized
    }
  }
}
    ${DateFragmentDoc}`;

/**
 * __useGetRegistrySettingsDialogDataQuery__
 *
 * To run a query within a React component, call `useGetRegistrySettingsDialogDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrySettingsDialogDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrySettingsDialogDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistrySettingsDialogDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>(GetRegistrySettingsDialogDataDocument, baseOptions);
      }
export function useGetRegistrySettingsDialogDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>(GetRegistrySettingsDialogDataDocument, baseOptions);
        }
export type GetRegistrySettingsDialogDataQueryHookResult = ReturnType<typeof useGetRegistrySettingsDialogDataQuery>;
export type GetRegistrySettingsDialogDataLazyQueryHookResult = ReturnType<typeof useGetRegistrySettingsDialogDataLazyQuery>;
export type GetRegistrySettingsDialogDataQueryResult = Apollo.QueryResult<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>;
export const GetProductVerticalConfigDocument = gql`
    query GetProductVerticalConfig($eventId: ID!) {
  eventById(id: $eventId) {
    id
    productVerticals {
      optOutOfGuestList
      optOutOfInvites
      optOutOfRegistry
      optOutOfWebsite
    }
  }
}
    `;

/**
 * __useGetProductVerticalConfigQuery__
 *
 * To run a query within a React component, call `useGetProductVerticalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVerticalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVerticalConfigQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetProductVerticalConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>(GetProductVerticalConfigDocument, baseOptions);
      }
export function useGetProductVerticalConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>(GetProductVerticalConfigDocument, baseOptions);
        }
export type GetProductVerticalConfigQueryHookResult = ReturnType<typeof useGetProductVerticalConfigQuery>;
export type GetProductVerticalConfigLazyQueryHookResult = ReturnType<typeof useGetProductVerticalConfigLazyQuery>;
export type GetProductVerticalConfigQueryResult = Apollo.QueryResult<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>;
export const GetVisibilityConfigDocument = gql`
    query GetVisibilityConfig($eventPageId: ID!, $eventId: ID!) {
  eventPage(id: $eventPageId) {
    id
    disabled
    private
  }
  event(id: $eventId) {
    id
    info {
      id
      eventPassword
    }
  }
}
    `;

/**
 * __useGetVisibilityConfigQuery__
 *
 * To run a query within a React component, call `useGetVisibilityConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibilityConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibilityConfigQuery({
 *   variables: {
 *      eventPageId: // value for 'eventPageId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetVisibilityConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>(GetVisibilityConfigDocument, baseOptions);
      }
export function useGetVisibilityConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>(GetVisibilityConfigDocument, baseOptions);
        }
export type GetVisibilityConfigQueryHookResult = ReturnType<typeof useGetVisibilityConfigQuery>;
export type GetVisibilityConfigLazyQueryHookResult = ReturnType<typeof useGetVisibilityConfigLazyQuery>;
export type GetVisibilityConfigQueryResult = Apollo.QueryResult<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>;
export const GetPayoutAccountInfoDocument = gql`
    query GetPayoutAccountInfo($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    ...EventPayoutAccount
  }
}
    ${EventPayoutAccountFragmentDoc}`;

/**
 * __useGetPayoutAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetPayoutAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutAccountInfoQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPayoutAccountInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>(GetPayoutAccountInfoDocument, baseOptions);
      }
export function useGetPayoutAccountInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>(GetPayoutAccountInfoDocument, baseOptions);
        }
export type GetPayoutAccountInfoQueryHookResult = ReturnType<typeof useGetPayoutAccountInfoQuery>;
export type GetPayoutAccountInfoLazyQueryHookResult = ReturnType<typeof useGetPayoutAccountInfoLazyQuery>;
export type GetPayoutAccountInfoQueryResult = Apollo.QueryResult<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>;
export const GetCalculateRegistryPurchaseInfoDocument = gql`
    query GetCalculateRegistryPurchaseInfo($payload: CalculateRegistryPurchaseInfoInput!) {
  calculateRegistryPurchaseInfo(payload: $payload) {
    ...CalculateRegistryPurchaseInfoFragment
  }
}
    ${CalculateRegistryPurchaseInfoFragmentFragmentDoc}`;

/**
 * __useGetCalculateRegistryPurchaseInfoQuery__
 *
 * To run a query within a React component, call `useGetCalculateRegistryPurchaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculateRegistryPurchaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculateRegistryPurchaseInfoQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCalculateRegistryPurchaseInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>(GetCalculateRegistryPurchaseInfoDocument, baseOptions);
      }
export function useGetCalculateRegistryPurchaseInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>(GetCalculateRegistryPurchaseInfoDocument, baseOptions);
        }
export type GetCalculateRegistryPurchaseInfoQueryHookResult = ReturnType<typeof useGetCalculateRegistryPurchaseInfoQuery>;
export type GetCalculateRegistryPurchaseInfoLazyQueryHookResult = ReturnType<typeof useGetCalculateRegistryPurchaseInfoLazyQuery>;
export type GetCalculateRegistryPurchaseInfoQueryResult = Apollo.QueryResult<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>;
export const GetRegistryTransferredSyncInformationDocument = gql`
    query GetRegistryTransferredSyncInformation($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    info {
      id
      registry {
        id
        isSyncingType
        isTransferredType
      }
    }
  }
}
    `;

/**
 * __useGetRegistryTransferredSyncInformationQuery__
 *
 * To run a query within a React component, call `useGetRegistryTransferredSyncInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryTransferredSyncInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryTransferredSyncInformationQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryTransferredSyncInformationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>(GetRegistryTransferredSyncInformationDocument, baseOptions);
      }
export function useGetRegistryTransferredSyncInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>(GetRegistryTransferredSyncInformationDocument, baseOptions);
        }
export type GetRegistryTransferredSyncInformationQueryHookResult = ReturnType<typeof useGetRegistryTransferredSyncInformationQuery>;
export type GetRegistryTransferredSyncInformationLazyQueryHookResult = ReturnType<typeof useGetRegistryTransferredSyncInformationLazyQuery>;
export type GetRegistryTransferredSyncInformationQueryResult = Apollo.QueryResult<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>;
export const GetRegistryJoyCreditStatusDocument = gql`
    query GetRegistryJoyCreditStatus($eventId: ID!) {
  getRegistryEventData(eventId: $eventId) {
    id
    joyCreditStatus {
      joyCredit {
        ...JoyCreditStatus
      }
    }
  }
}
    ${JoyCreditStatusFragmentDoc}`;

/**
 * __useGetRegistryJoyCreditStatusQuery__
 *
 * To run a query within a React component, call `useGetRegistryJoyCreditStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryJoyCreditStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryJoyCreditStatusQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryJoyCreditStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>(GetRegistryJoyCreditStatusDocument, baseOptions);
      }
export function useGetRegistryJoyCreditStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>(GetRegistryJoyCreditStatusDocument, baseOptions);
        }
export type GetRegistryJoyCreditStatusQueryHookResult = ReturnType<typeof useGetRegistryJoyCreditStatusQuery>;
export type GetRegistryJoyCreditStatusLazyQueryHookResult = ReturnType<typeof useGetRegistryJoyCreditStatusLazyQuery>;
export type GetRegistryJoyCreditStatusQueryResult = Apollo.QueryResult<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>;
export const GetMeEventUsersEventInfoForMePageDocument = gql`
    query GetMeEventUsersEventInfoForMePage($filterEventTypes: [EventType!]) {
  me {
    ...UserForMePage
  }
}
    ${UserForMePageFragmentDoc}`;

/**
 * __useGetMeEventUsersEventInfoForMePageQuery__
 *
 * To run a query within a React component, call `useGetMeEventUsersEventInfoForMePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeEventUsersEventInfoForMePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeEventUsersEventInfoForMePageQuery({
 *   variables: {
 *      filterEventTypes: // value for 'filterEventTypes'
 *   },
 * });
 */
export function useGetMeEventUsersEventInfoForMePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeEventUsersEventInfoForMePageQuery, GetMeEventUsersEventInfoForMePageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMeEventUsersEventInfoForMePageQuery, GetMeEventUsersEventInfoForMePageQueryVariables>(GetMeEventUsersEventInfoForMePageDocument, baseOptions);
      }
export function useGetMeEventUsersEventInfoForMePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeEventUsersEventInfoForMePageQuery, GetMeEventUsersEventInfoForMePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMeEventUsersEventInfoForMePageQuery, GetMeEventUsersEventInfoForMePageQueryVariables>(GetMeEventUsersEventInfoForMePageDocument, baseOptions);
        }
export type GetMeEventUsersEventInfoForMePageQueryHookResult = ReturnType<typeof useGetMeEventUsersEventInfoForMePageQuery>;
export type GetMeEventUsersEventInfoForMePageLazyQueryHookResult = ReturnType<typeof useGetMeEventUsersEventInfoForMePageLazyQuery>;
export type GetMeEventUsersEventInfoForMePageQueryResult = Apollo.QueryResult<GetMeEventUsersEventInfoForMePageQuery, GetMeEventUsersEventInfoForMePageQueryVariables>;
export const VendorCollectionGroupByIdDocument = gql`
    query VendorCollectionGroupById($id: ID!) {
  vendorCollectionGroup(id: $id) {
    id
    title
    collectionIds
    collections {
      ...CollectionSlim
    }
  }
}
    ${CollectionSlimFragmentDoc}`;

/**
 * __useVendorCollectionGroupByIdQuery__
 *
 * To run a query within a React component, call `useVendorCollectionGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCollectionGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCollectionGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorCollectionGroupByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorCollectionGroupByIdQuery, VendorCollectionGroupByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorCollectionGroupByIdQuery, VendorCollectionGroupByIdQueryVariables>(VendorCollectionGroupByIdDocument, baseOptions);
      }
export function useVendorCollectionGroupByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorCollectionGroupByIdQuery, VendorCollectionGroupByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorCollectionGroupByIdQuery, VendorCollectionGroupByIdQueryVariables>(VendorCollectionGroupByIdDocument, baseOptions);
        }
export type VendorCollectionGroupByIdQueryHookResult = ReturnType<typeof useVendorCollectionGroupByIdQuery>;
export type VendorCollectionGroupByIdLazyQueryHookResult = ReturnType<typeof useVendorCollectionGroupByIdLazyQuery>;
export type VendorCollectionGroupByIdQueryResult = Apollo.QueryResult<VendorCollectionGroupByIdQuery, VendorCollectionGroupByIdQueryVariables>;
export const VendorCollectionGroupSyntheticCollectionByIdDocument = gql`
    query VendorCollectionGroupSyntheticCollectionById($id: ID!, $page: Int, $perPage: Int, $cursor: String) {
  vendorCollectionGroup(id: $id) {
    id
    title
    collectionIds
    aggregateSyntheticCollection {
      ...SyntheticCollectionWithMetatagsPaginated
    }
  }
}
    ${SyntheticCollectionWithMetatagsPaginatedFragmentDoc}`;

/**
 * __useVendorCollectionGroupSyntheticCollectionByIdQuery__
 *
 * To run a query within a React component, call `useVendorCollectionGroupSyntheticCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCollectionGroupSyntheticCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCollectionGroupSyntheticCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useVendorCollectionGroupSyntheticCollectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorCollectionGroupSyntheticCollectionByIdQuery, VendorCollectionGroupSyntheticCollectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorCollectionGroupSyntheticCollectionByIdQuery, VendorCollectionGroupSyntheticCollectionByIdQueryVariables>(VendorCollectionGroupSyntheticCollectionByIdDocument, baseOptions);
      }
export function useVendorCollectionGroupSyntheticCollectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorCollectionGroupSyntheticCollectionByIdQuery, VendorCollectionGroupSyntheticCollectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorCollectionGroupSyntheticCollectionByIdQuery, VendorCollectionGroupSyntheticCollectionByIdQueryVariables>(VendorCollectionGroupSyntheticCollectionByIdDocument, baseOptions);
        }
export type VendorCollectionGroupSyntheticCollectionByIdQueryHookResult = ReturnType<typeof useVendorCollectionGroupSyntheticCollectionByIdQuery>;
export type VendorCollectionGroupSyntheticCollectionByIdLazyQueryHookResult = ReturnType<typeof useVendorCollectionGroupSyntheticCollectionByIdLazyQuery>;
export type VendorCollectionGroupSyntheticCollectionByIdQueryResult = Apollo.QueryResult<VendorCollectionGroupSyntheticCollectionByIdQuery, VendorCollectionGroupSyntheticCollectionByIdQueryVariables>;
export const VendorSuggestionsDocument = gql`
    query VendorSuggestions($vendorType: VendorTypeEnum!) {
  suggestionGroupByVendorType(payload: {vendorType: $vendorType}) {
    id
    title
    description
    photo {
      ...Photo
    }
    suggestions {
      id
      title
      description
      photo {
        ...Photo
      }
      vendor {
        ...Vendor
      }
    }
  }
}
    ${PhotoFragmentDoc}
${VendorFragmentDoc}`;

/**
 * __useVendorSuggestionsQuery__
 *
 * To run a query within a React component, call `useVendorSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorSuggestionsQuery({
 *   variables: {
 *      vendorType: // value for 'vendorType'
 *   },
 * });
 */
export function useVendorSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorSuggestionsQuery, VendorSuggestionsQueryVariables>) {
        return ApolloReactHooks.useQuery<VendorSuggestionsQuery, VendorSuggestionsQueryVariables>(VendorSuggestionsDocument, baseOptions);
      }
export function useVendorSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorSuggestionsQuery, VendorSuggestionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VendorSuggestionsQuery, VendorSuggestionsQueryVariables>(VendorSuggestionsDocument, baseOptions);
        }
export type VendorSuggestionsQueryHookResult = ReturnType<typeof useVendorSuggestionsQuery>;
export type VendorSuggestionsLazyQueryHookResult = ReturnType<typeof useVendorSuggestionsLazyQuery>;
export type VendorSuggestionsQueryResult = Apollo.QueryResult<VendorSuggestionsQuery, VendorSuggestionsQueryVariables>;
export const GetVendorTypesDocument = gql`
    query GetVendorTypes {
  vendorTypes {
    ...VendorType
  }
}
    ${VendorTypeFragmentDoc}`;

/**
 * __useGetVendorTypesQuery__
 *
 * To run a query within a React component, call `useGetVendorTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVendorTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorTypesQuery, GetVendorTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVendorTypesQuery, GetVendorTypesQueryVariables>(GetVendorTypesDocument, baseOptions);
      }
export function useGetVendorTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorTypesQuery, GetVendorTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVendorTypesQuery, GetVendorTypesQueryVariables>(GetVendorTypesDocument, baseOptions);
        }
export type GetVendorTypesQueryHookResult = ReturnType<typeof useGetVendorTypesQuery>;
export type GetVendorTypesLazyQueryHookResult = ReturnType<typeof useGetVendorTypesLazyQuery>;
export type GetVendorTypesQueryResult = Apollo.QueryResult<GetVendorTypesQuery, GetVendorTypesQueryVariables>;
export const GetWebsiteDesignDocument = gql`
    query GetWebsiteDesign($eventHandle: String!, $purpose: EventDesignPurpose) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
    eventDesign(purpose: $purpose) {
      ...EventDesign
    }
  }
}
    ${EventDesignFragmentDoc}`;

/**
 * __useGetWebsiteDesignQuery__
 *
 * To run a query within a React component, call `useGetWebsiteDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteDesignQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetWebsiteDesignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteDesignQuery, GetWebsiteDesignQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWebsiteDesignQuery, GetWebsiteDesignQueryVariables>(GetWebsiteDesignDocument, baseOptions);
      }
export function useGetWebsiteDesignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteDesignQuery, GetWebsiteDesignQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWebsiteDesignQuery, GetWebsiteDesignQueryVariables>(GetWebsiteDesignDocument, baseOptions);
        }
export type GetWebsiteDesignQueryHookResult = ReturnType<typeof useGetWebsiteDesignQuery>;
export type GetWebsiteDesignLazyQueryHookResult = ReturnType<typeof useGetWebsiteDesignLazyQuery>;
export type GetWebsiteDesignQueryResult = Apollo.QueryResult<GetWebsiteDesignQuery, GetWebsiteDesignQueryVariables>;
export const GetHasUnpublishedWebsiteDesignDocument = gql`
    query GetHasUnpublishedWebsiteDesign($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    eventDesign {
      id
      hasUnpublishedChanges
    }
  }
}
    `;

/**
 * __useGetHasUnpublishedWebsiteDesignQuery__
 *
 * To run a query within a React component, call `useGetHasUnpublishedWebsiteDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasUnpublishedWebsiteDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasUnpublishedWebsiteDesignQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetHasUnpublishedWebsiteDesignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHasUnpublishedWebsiteDesignQuery, GetHasUnpublishedWebsiteDesignQueryVariables>) {
        return ApolloReactHooks.useQuery<GetHasUnpublishedWebsiteDesignQuery, GetHasUnpublishedWebsiteDesignQueryVariables>(GetHasUnpublishedWebsiteDesignDocument, baseOptions);
      }
export function useGetHasUnpublishedWebsiteDesignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHasUnpublishedWebsiteDesignQuery, GetHasUnpublishedWebsiteDesignQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetHasUnpublishedWebsiteDesignQuery, GetHasUnpublishedWebsiteDesignQueryVariables>(GetHasUnpublishedWebsiteDesignDocument, baseOptions);
        }
export type GetHasUnpublishedWebsiteDesignQueryHookResult = ReturnType<typeof useGetHasUnpublishedWebsiteDesignQuery>;
export type GetHasUnpublishedWebsiteDesignLazyQueryHookResult = ReturnType<typeof useGetHasUnpublishedWebsiteDesignLazyQuery>;
export type GetHasUnpublishedWebsiteDesignQueryResult = Apollo.QueryResult<GetHasUnpublishedWebsiteDesignQuery, GetHasUnpublishedWebsiteDesignQueryVariables>;
export const GetThemesDocument = gql`
    query GetThemes($eventHandle: String!) {
  designBuckets {
    ...DesignBucket
  }
  eventByName(name: $eventHandle) {
    id
    themes {
      ...Theme
    }
  }
}
    ${DesignBucketFragmentDoc}
${ThemeFragmentDoc}`;

/**
 * __useGetThemesQuery__
 *
 * To run a query within a React component, call `useGetThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetThemesQuery, GetThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetThemesQuery, GetThemesQueryVariables>(GetThemesDocument, baseOptions);
      }
export function useGetThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetThemesQuery, GetThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetThemesQuery, GetThemesQueryVariables>(GetThemesDocument, baseOptions);
        }
export type GetThemesQueryHookResult = ReturnType<typeof useGetThemesQuery>;
export type GetThemesLazyQueryHookResult = ReturnType<typeof useGetThemesLazyQuery>;
export type GetThemesQueryResult = Apollo.QueryResult<GetThemesQuery, GetThemesQueryVariables>;
export const GetThemeByThemeIdDocument = gql`
    query GetThemeByThemeId($themeId: String!) {
  themeByThemeId(themeId: $themeId) {
    ...Theme
  }
}
    ${ThemeFragmentDoc}`;

/**
 * __useGetThemeByThemeIdQuery__
 *
 * To run a query within a React component, call `useGetThemeByThemeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeByThemeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeByThemeIdQuery({
 *   variables: {
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useGetThemeByThemeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetThemeByThemeIdQuery, GetThemeByThemeIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetThemeByThemeIdQuery, GetThemeByThemeIdQueryVariables>(GetThemeByThemeIdDocument, baseOptions);
      }
export function useGetThemeByThemeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetThemeByThemeIdQuery, GetThemeByThemeIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetThemeByThemeIdQuery, GetThemeByThemeIdQueryVariables>(GetThemeByThemeIdDocument, baseOptions);
        }
export type GetThemeByThemeIdQueryHookResult = ReturnType<typeof useGetThemeByThemeIdQuery>;
export type GetThemeByThemeIdLazyQueryHookResult = ReturnType<typeof useGetThemeByThemeIdLazyQuery>;
export type GetThemeByThemeIdQueryResult = Apollo.QueryResult<GetThemeByThemeIdQuery, GetThemeByThemeIdQueryVariables>;
export const HotelInventoryByRadiusDocument = gql`
    query HotelInventoryByRadius($payload: HotelInventoryByRadiusRequest!) {
  hotelInventoryByRadius(payload: $payload) {
    zhId
    userRating
    state
    starRating
    ratingCount
    postalCode
    photo
    location {
      lat
      lon
    }
    distance
    displayName
    description
    country
    city
    address
    isPreferredHotel
    hotelUrl
    hotelType: type
  }
}
    `;

/**
 * __useHotelInventoryByRadiusQuery__
 *
 * To run a query within a React component, call `useHotelInventoryByRadiusQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelInventoryByRadiusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelInventoryByRadiusQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useHotelInventoryByRadiusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelInventoryByRadiusQuery, HotelInventoryByRadiusQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelInventoryByRadiusQuery, HotelInventoryByRadiusQueryVariables>(HotelInventoryByRadiusDocument, baseOptions);
      }
export function useHotelInventoryByRadiusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelInventoryByRadiusQuery, HotelInventoryByRadiusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelInventoryByRadiusQuery, HotelInventoryByRadiusQueryVariables>(HotelInventoryByRadiusDocument, baseOptions);
        }
export type HotelInventoryByRadiusQueryHookResult = ReturnType<typeof useHotelInventoryByRadiusQuery>;
export type HotelInventoryByRadiusLazyQueryHookResult = ReturnType<typeof useHotelInventoryByRadiusLazyQuery>;
export type HotelInventoryByRadiusQueryResult = Apollo.QueryResult<HotelInventoryByRadiusQuery, HotelInventoryByRadiusQueryVariables>;
export const HotelSuggestionsDocument = gql`
    query HotelSuggestions($payload: HotelSuggestionRequest!) {
  hotelSuggestions(payload: $payload) {
    displayName
    zhId
    distance
    starRating
    userRating
    ratingCount
    address
    city
    state
    country
    postalCode
    photo
    description
    location {
      lat
      lon
    }
    isPreferredHotel
    hotelUrl
    hotelType: type
  }
}
    `;

/**
 * __useHotelSuggestionsQuery__
 *
 * To run a query within a React component, call `useHotelSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelSuggestionsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useHotelSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelSuggestionsQuery, HotelSuggestionsQueryVariables>) {
        return ApolloReactHooks.useQuery<HotelSuggestionsQuery, HotelSuggestionsQueryVariables>(HotelSuggestionsDocument, baseOptions);
      }
export function useHotelSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelSuggestionsQuery, HotelSuggestionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HotelSuggestionsQuery, HotelSuggestionsQueryVariables>(HotelSuggestionsDocument, baseOptions);
        }
export type HotelSuggestionsQueryHookResult = ReturnType<typeof useHotelSuggestionsQuery>;
export type HotelSuggestionsLazyQueryHookResult = ReturnType<typeof useHotelSuggestionsLazyQuery>;
export type HotelSuggestionsQueryResult = Apollo.QueryResult<HotelSuggestionsQuery, HotelSuggestionsQueryVariables>;
export const EventSessionFindEventByFirebaseIdDocument = gql`
    query EventSessionFindEventByFirebaseId($id: String!, $skipEventSession: Boolean) {
  event: eventByFirebaseId(id: $id, skipEventSession: $skipEventSession) {
    id
  }
}
    `;

/**
 * __useEventSessionFindEventByFirebaseIdQuery__
 *
 * To run a query within a React component, call `useEventSessionFindEventByFirebaseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionFindEventByFirebaseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionFindEventByFirebaseIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skipEventSession: // value for 'skipEventSession'
 *   },
 * });
 */
export function useEventSessionFindEventByFirebaseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventSessionFindEventByFirebaseIdQuery, EventSessionFindEventByFirebaseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EventSessionFindEventByFirebaseIdQuery, EventSessionFindEventByFirebaseIdQueryVariables>(EventSessionFindEventByFirebaseIdDocument, baseOptions);
      }
export function useEventSessionFindEventByFirebaseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventSessionFindEventByFirebaseIdQuery, EventSessionFindEventByFirebaseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventSessionFindEventByFirebaseIdQuery, EventSessionFindEventByFirebaseIdQueryVariables>(EventSessionFindEventByFirebaseIdDocument, baseOptions);
        }
export type EventSessionFindEventByFirebaseIdQueryHookResult = ReturnType<typeof useEventSessionFindEventByFirebaseIdQuery>;
export type EventSessionFindEventByFirebaseIdLazyQueryHookResult = ReturnType<typeof useEventSessionFindEventByFirebaseIdLazyQuery>;
export type EventSessionFindEventByFirebaseIdQueryResult = Apollo.QueryResult<EventSessionFindEventByFirebaseIdQuery, EventSessionFindEventByFirebaseIdQueryVariables>;
export const EventSessionGetEventByNameDocument = gql`
    query EventSessionGetEventByName($name: String!, $skipEventSession: Boolean) {
  event: eventByName(name: $name, skipEventSession: $skipEventSession) {
    id
  }
}
    `;

/**
 * __useEventSessionGetEventByNameQuery__
 *
 * To run a query within a React component, call `useEventSessionGetEventByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionGetEventByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionGetEventByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      skipEventSession: // value for 'skipEventSession'
 *   },
 * });
 */
export function useEventSessionGetEventByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventSessionGetEventByNameQuery, EventSessionGetEventByNameQueryVariables>) {
        return ApolloReactHooks.useQuery<EventSessionGetEventByNameQuery, EventSessionGetEventByNameQueryVariables>(EventSessionGetEventByNameDocument, baseOptions);
      }
export function useEventSessionGetEventByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventSessionGetEventByNameQuery, EventSessionGetEventByNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventSessionGetEventByNameQuery, EventSessionGetEventByNameQueryVariables>(EventSessionGetEventByNameDocument, baseOptions);
        }
export type EventSessionGetEventByNameQueryHookResult = ReturnType<typeof useEventSessionGetEventByNameQuery>;
export type EventSessionGetEventByNameLazyQueryHookResult = ReturnType<typeof useEventSessionGetEventByNameLazyQuery>;
export type EventSessionGetEventByNameQueryResult = Apollo.QueryResult<EventSessionGetEventByNameQuery, EventSessionGetEventByNameQueryVariables>;
export const EventSessionGetInviteeSessionDocument = gql`
    query EventSessionGetInviteeSession($eventId: ID!, $inviteeId: String!) {
  getRecipientSessionByInviteePID(eventId: $eventId, inviteePID: $inviteeId)
}
    `;

/**
 * __useEventSessionGetInviteeSessionQuery__
 *
 * To run a query within a React component, call `useEventSessionGetInviteeSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionGetInviteeSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionGetInviteeSessionQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      inviteeId: // value for 'inviteeId'
 *   },
 * });
 */
export function useEventSessionGetInviteeSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventSessionGetInviteeSessionQuery, EventSessionGetInviteeSessionQueryVariables>) {
        return ApolloReactHooks.useQuery<EventSessionGetInviteeSessionQuery, EventSessionGetInviteeSessionQueryVariables>(EventSessionGetInviteeSessionDocument, baseOptions);
      }
export function useEventSessionGetInviteeSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventSessionGetInviteeSessionQuery, EventSessionGetInviteeSessionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventSessionGetInviteeSessionQuery, EventSessionGetInviteeSessionQueryVariables>(EventSessionGetInviteeSessionDocument, baseOptions);
        }
export type EventSessionGetInviteeSessionQueryHookResult = ReturnType<typeof useEventSessionGetInviteeSessionQuery>;
export type EventSessionGetInviteeSessionLazyQueryHookResult = ReturnType<typeof useEventSessionGetInviteeSessionLazyQuery>;
export type EventSessionGetInviteeSessionQueryResult = Apollo.QueryResult<EventSessionGetInviteeSessionQuery, EventSessionGetInviteeSessionQueryVariables>;
export const EventSessionGetGuestKeySessionDocument = gql`
    query EventSessionGetGuestKeySession($eventId: ID!, $guestKey: String!) {
  getRecipientSessionByGuestKey(eventId: $eventId, guestKey: $guestKey)
}
    `;

/**
 * __useEventSessionGetGuestKeySessionQuery__
 *
 * To run a query within a React component, call `useEventSessionGetGuestKeySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionGetGuestKeySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionGetGuestKeySessionQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestKey: // value for 'guestKey'
 *   },
 * });
 */
export function useEventSessionGetGuestKeySessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventSessionGetGuestKeySessionQuery, EventSessionGetGuestKeySessionQueryVariables>) {
        return ApolloReactHooks.useQuery<EventSessionGetGuestKeySessionQuery, EventSessionGetGuestKeySessionQueryVariables>(EventSessionGetGuestKeySessionDocument, baseOptions);
      }
export function useEventSessionGetGuestKeySessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventSessionGetGuestKeySessionQuery, EventSessionGetGuestKeySessionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventSessionGetGuestKeySessionQuery, EventSessionGetGuestKeySessionQueryVariables>(EventSessionGetGuestKeySessionDocument, baseOptions);
        }
export type EventSessionGetGuestKeySessionQueryHookResult = ReturnType<typeof useEventSessionGetGuestKeySessionQuery>;
export type EventSessionGetGuestKeySessionLazyQueryHookResult = ReturnType<typeof useEventSessionGetGuestKeySessionLazyQuery>;
export type EventSessionGetGuestKeySessionQueryResult = Apollo.QueryResult<EventSessionGetGuestKeySessionQuery, EventSessionGetGuestKeySessionQueryVariables>;
export const FindEventByFirebaseIdDocument = gql`
    query FindEventByFirebaseId($id: String!, $skipEventSession: Boolean) {
  eventByFirebaseId(id: $id, skipEventSession: $skipEventSession) {
    id
    website
  }
}
    `;

/**
 * __useFindEventByFirebaseIdQuery__
 *
 * To run a query within a React component, call `useFindEventByFirebaseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventByFirebaseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventByFirebaseIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skipEventSession: // value for 'skipEventSession'
 *   },
 * });
 */
export function useFindEventByFirebaseIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindEventByFirebaseIdQuery, FindEventByFirebaseIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FindEventByFirebaseIdQuery, FindEventByFirebaseIdQueryVariables>(FindEventByFirebaseIdDocument, baseOptions);
      }
export function useFindEventByFirebaseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindEventByFirebaseIdQuery, FindEventByFirebaseIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindEventByFirebaseIdQuery, FindEventByFirebaseIdQueryVariables>(FindEventByFirebaseIdDocument, baseOptions);
        }
export type FindEventByFirebaseIdQueryHookResult = ReturnType<typeof useFindEventByFirebaseIdQuery>;
export type FindEventByFirebaseIdLazyQueryHookResult = ReturnType<typeof useFindEventByFirebaseIdLazyQuery>;
export type FindEventByFirebaseIdQueryResult = Apollo.QueryResult<FindEventByFirebaseIdQuery, FindEventByFirebaseIdQueryVariables>;
export const FindEventByIdDocument = gql`
    query FindEventById($id: ID!, $skipEventSession: Boolean) {
  eventById(id: $id, skipEventSession: $skipEventSession) {
    id
    website
  }
}
    `;

/**
 * __useFindEventByIdQuery__
 *
 * To run a query within a React component, call `useFindEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skipEventSession: // value for 'skipEventSession'
 *   },
 * });
 */
export function useFindEventByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindEventByIdQuery, FindEventByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FindEventByIdQuery, FindEventByIdQueryVariables>(FindEventByIdDocument, baseOptions);
      }
export function useFindEventByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindEventByIdQuery, FindEventByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindEventByIdQuery, FindEventByIdQueryVariables>(FindEventByIdDocument, baseOptions);
        }
export type FindEventByIdQueryHookResult = ReturnType<typeof useFindEventByIdQuery>;
export type FindEventByIdLazyQueryHookResult = ReturnType<typeof useFindEventByIdLazyQuery>;
export type FindEventByIdQueryResult = Apollo.QueryResult<FindEventByIdQuery, FindEventByIdQueryVariables>;
export const FeatureFlagByEventNameDocument = gql`
    query FeatureFlagByEventName($name: String!, $skipEventSession: Boolean) {
  eventByName(name: $name, skipEventSession: $skipEventSession) {
    id
    firebaseId
    website
    featureFlags
    useLegacyGuestSite
  }
}
    `;

/**
 * __useFeatureFlagByEventNameQuery__
 *
 * To run a query within a React component, call `useFeatureFlagByEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagByEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagByEventNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      skipEventSession: // value for 'skipEventSession'
 *   },
 * });
 */
export function useFeatureFlagByEventNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureFlagByEventNameQuery, FeatureFlagByEventNameQueryVariables>) {
        return ApolloReactHooks.useQuery<FeatureFlagByEventNameQuery, FeatureFlagByEventNameQueryVariables>(FeatureFlagByEventNameDocument, baseOptions);
      }
export function useFeatureFlagByEventNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagByEventNameQuery, FeatureFlagByEventNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeatureFlagByEventNameQuery, FeatureFlagByEventNameQueryVariables>(FeatureFlagByEventNameDocument, baseOptions);
        }
export type FeatureFlagByEventNameQueryHookResult = ReturnType<typeof useFeatureFlagByEventNameQuery>;
export type FeatureFlagByEventNameLazyQueryHookResult = ReturnType<typeof useFeatureFlagByEventNameLazyQuery>;
export type FeatureFlagByEventNameQueryResult = Apollo.QueryResult<FeatureFlagByEventNameQuery, FeatureFlagByEventNameQueryVariables>;
export const ImproveTextForAiReviewDocument = gql`
    query ImproveTextForAiReview($input: ImproveTextInput!) {
  improveText(input: $input) {
    originalText
    improvedText
  }
}
    `;

/**
 * __useImproveTextForAiReviewQuery__
 *
 * To run a query within a React component, call `useImproveTextForAiReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useImproveTextForAiReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImproveTextForAiReviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImproveTextForAiReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ImproveTextForAiReviewQuery, ImproveTextForAiReviewQueryVariables>) {
        return ApolloReactHooks.useQuery<ImproveTextForAiReviewQuery, ImproveTextForAiReviewQueryVariables>(ImproveTextForAiReviewDocument, baseOptions);
      }
export function useImproveTextForAiReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImproveTextForAiReviewQuery, ImproveTextForAiReviewQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ImproveTextForAiReviewQuery, ImproveTextForAiReviewQueryVariables>(ImproveTextForAiReviewDocument, baseOptions);
        }
export type ImproveTextForAiReviewQueryHookResult = ReturnType<typeof useImproveTextForAiReviewQuery>;
export type ImproveTextForAiReviewLazyQueryHookResult = ReturnType<typeof useImproveTextForAiReviewLazyQuery>;
export type ImproveTextForAiReviewQueryResult = Apollo.QueryResult<ImproveTextForAiReviewQuery, ImproveTextForAiReviewQueryVariables>;
export const GetMeDocument = gql`
    query GetMe($eventName: String, $withActiveEventUser: Boolean!, $refreshMfa: Boolean) {
  me(refreshMFA: $refreshMfa) {
    id
    firstName
    lastName
    email
    avatar {
      id
      url
    }
    superAdmin
    activeAlias {
      id
      auth0Id
      provider
      mfaEnabled
    }
    emailIsVerified(liveQuery: true)
    activeEventUserForEvent(eventName: $eventName) @include(if: $withActiveEventUser) {
      ...ActiveEventUser
    }
  }
}
    ${ActiveEventUserFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      withActiveEventUser: // value for 'withActiveEventUser'
 *      refreshMfa: // value for 'refreshMfa'
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetEventMembershipsDocument = gql`
    query GetEventMemberships($filterEventTypes: [EventType!]) {
  me {
    id
    eventMemberships: activeEventUsers(filter: {types: $filterEventTypes}) {
      id
      status
      event {
        id
        firebaseId
        firebaseCreateAt {
          milliseconds
          timestamp
          timezone
        }
        website
        info {
          id
          eventType
          eventDisplayName
          eventMonogram
          ownerFirstName
          fianceeFirstName
          location
          timezone
          finalizedDate {
            milliseconds
            timestamp
            timezone
          }
          tentativeDate {
            milliseconds
            timestamp
            timezone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventMembershipsQuery__
 *
 * To run a query within a React component, call `useGetEventMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMembershipsQuery({
 *   variables: {
 *      filterEventTypes: // value for 'filterEventTypes'
 *   },
 * });
 */
export function useGetEventMembershipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>(GetEventMembershipsDocument, baseOptions);
      }
export function useGetEventMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>(GetEventMembershipsDocument, baseOptions);
        }
export type GetEventMembershipsQueryHookResult = ReturnType<typeof useGetEventMembershipsQuery>;
export type GetEventMembershipsLazyQueryHookResult = ReturnType<typeof useGetEventMembershipsLazyQuery>;
export type GetEventMembershipsQueryResult = Apollo.QueryResult<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>;
export const GetValidSendersDocument = gql`
    query GetValidSenders($name: String!) {
  eventByName(name: $name) {
    id
    eventUsers {
      id
      status
      user {
        id
        email
        emailIsVerified
      }
    }
  }
}
    `;

/**
 * __useGetValidSendersQuery__
 *
 * To run a query within a React component, call `useGetValidSendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidSendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidSendersQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValidSendersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetValidSendersQuery, GetValidSendersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetValidSendersQuery, GetValidSendersQueryVariables>(GetValidSendersDocument, baseOptions);
      }
export function useGetValidSendersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetValidSendersQuery, GetValidSendersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetValidSendersQuery, GetValidSendersQueryVariables>(GetValidSendersDocument, baseOptions);
        }
export type GetValidSendersQueryHookResult = ReturnType<typeof useGetValidSendersQuery>;
export type GetValidSendersLazyQueryHookResult = ReturnType<typeof useGetValidSendersLazyQuery>;
export type GetValidSendersQueryResult = Apollo.QueryResult<GetValidSendersQuery, GetValidSendersQueryVariables>;
export const EventFormDataWrapperFormByIdDocument = gql`
    query EventFormDataWrapperFormById($formByIdId: ID!) {
  formById(id: $formByIdId) {
    ...EventFormDataWrapperForm
  }
}
    ${EventFormDataWrapperFormFragmentDoc}`;

/**
 * __useEventFormDataWrapperFormByIdQuery__
 *
 * To run a query within a React component, call `useEventFormDataWrapperFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormDataWrapperFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormDataWrapperFormByIdQuery({
 *   variables: {
 *      formByIdId: // value for 'formByIdId'
 *   },
 * });
 */
export function useEventFormDataWrapperFormByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormDataWrapperFormByIdQuery, EventFormDataWrapperFormByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormDataWrapperFormByIdQuery, EventFormDataWrapperFormByIdQueryVariables>(EventFormDataWrapperFormByIdDocument, baseOptions);
      }
export function useEventFormDataWrapperFormByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormDataWrapperFormByIdQuery, EventFormDataWrapperFormByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormDataWrapperFormByIdQuery, EventFormDataWrapperFormByIdQueryVariables>(EventFormDataWrapperFormByIdDocument, baseOptions);
        }
export type EventFormDataWrapperFormByIdQueryHookResult = ReturnType<typeof useEventFormDataWrapperFormByIdQuery>;
export type EventFormDataWrapperFormByIdLazyQueryHookResult = ReturnType<typeof useEventFormDataWrapperFormByIdLazyQuery>;
export type EventFormDataWrapperFormByIdQueryResult = Apollo.QueryResult<EventFormDataWrapperFormByIdQuery, EventFormDataWrapperFormByIdQueryVariables>;
export const EventFormFunctionalWrapperActiveSessionDocument = gql`
    query EventFormFunctionalWrapperActiveSession($eventByIdId: ID!) {
  eventById(id: $eventByIdId) {
    id
    activeSession {
      guestKey
      id
    }
  }
}
    `;

/**
 * __useEventFormFunctionalWrapperActiveSessionQuery__
 *
 * To run a query within a React component, call `useEventFormFunctionalWrapperActiveSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormFunctionalWrapperActiveSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormFunctionalWrapperActiveSessionQuery({
 *   variables: {
 *      eventByIdId: // value for 'eventByIdId'
 *   },
 * });
 */
export function useEventFormFunctionalWrapperActiveSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormFunctionalWrapperActiveSessionQuery, EventFormFunctionalWrapperActiveSessionQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormFunctionalWrapperActiveSessionQuery, EventFormFunctionalWrapperActiveSessionQueryVariables>(EventFormFunctionalWrapperActiveSessionDocument, baseOptions);
      }
export function useEventFormFunctionalWrapperActiveSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormFunctionalWrapperActiveSessionQuery, EventFormFunctionalWrapperActiveSessionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormFunctionalWrapperActiveSessionQuery, EventFormFunctionalWrapperActiveSessionQueryVariables>(EventFormFunctionalWrapperActiveSessionDocument, baseOptions);
        }
export type EventFormFunctionalWrapperActiveSessionQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperActiveSessionQuery>;
export type EventFormFunctionalWrapperActiveSessionLazyQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperActiveSessionLazyQuery>;
export type EventFormFunctionalWrapperActiveSessionQueryResult = Apollo.QueryResult<EventFormFunctionalWrapperActiveSessionQuery, EventFormFunctionalWrapperActiveSessionQueryVariables>;
export const EventFormFormByIdDocument = gql`
    query EventFormFormById($formByIdId: ID!) {
  formById(id: $formByIdId) {
    ...EventFormDataWrapperForm
  }
}
    ${EventFormDataWrapperFormFragmentDoc}`;

/**
 * __useEventFormFormByIdQuery__
 *
 * To run a query within a React component, call `useEventFormFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormFormByIdQuery({
 *   variables: {
 *      formByIdId: // value for 'formByIdId'
 *   },
 * });
 */
export function useEventFormFormByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormFormByIdQuery, EventFormFormByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormFormByIdQuery, EventFormFormByIdQueryVariables>(EventFormFormByIdDocument, baseOptions);
      }
export function useEventFormFormByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormFormByIdQuery, EventFormFormByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormFormByIdQuery, EventFormFormByIdQueryVariables>(EventFormFormByIdDocument, baseOptions);
        }
export type EventFormFormByIdQueryHookResult = ReturnType<typeof useEventFormFormByIdQuery>;
export type EventFormFormByIdLazyQueryHookResult = ReturnType<typeof useEventFormFormByIdLazyQuery>;
export type EventFormFormByIdQueryResult = Apollo.QueryResult<EventFormFormByIdQuery, EventFormFormByIdQueryVariables>;
export const EventFormGetGuestFormDocument = gql`
    query EventFormGetGuestForm($formId: ID!) {
  getGuestForm(formId: $formId) {
    form {
      ...EventFormDataWrapperForm
    }
    hiddenQuestionIds
  }
}
    ${EventFormDataWrapperFormFragmentDoc}`;

/**
 * __useEventFormGetGuestFormQuery__
 *
 * To run a query within a React component, call `useEventFormGetGuestFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormGetGuestFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormGetGuestFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useEventFormGetGuestFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormGetGuestFormQuery, EventFormGetGuestFormQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormGetGuestFormQuery, EventFormGetGuestFormQueryVariables>(EventFormGetGuestFormDocument, baseOptions);
      }
export function useEventFormGetGuestFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormGetGuestFormQuery, EventFormGetGuestFormQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormGetGuestFormQuery, EventFormGetGuestFormQueryVariables>(EventFormGetGuestFormDocument, baseOptions);
        }
export type EventFormGetGuestFormQueryHookResult = ReturnType<typeof useEventFormGetGuestFormQuery>;
export type EventFormGetGuestFormLazyQueryHookResult = ReturnType<typeof useEventFormGetGuestFormLazyQuery>;
export type EventFormGetGuestFormQueryResult = Apollo.QueryResult<EventFormGetGuestFormQuery, EventFormGetGuestFormQueryVariables>;
export const EventFormFunctionalWrapperGuestAnswersDocument = gql`
    query EventFormFunctionalWrapperGuestAnswers($formId: ID!, $eventId: ID!) {
  guestAnswersByFormId(formId: $formId, eventId: $eventId) {
    ...EventFormFunctionalWrapperAnswer
  }
}
    ${EventFormFunctionalWrapperAnswerFragmentDoc}`;

/**
 * __useEventFormFunctionalWrapperGuestAnswersQuery__
 *
 * To run a query within a React component, call `useEventFormFunctionalWrapperGuestAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormFunctionalWrapperGuestAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormFunctionalWrapperGuestAnswersQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventFormFunctionalWrapperGuestAnswersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormFunctionalWrapperGuestAnswersQuery, EventFormFunctionalWrapperGuestAnswersQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormFunctionalWrapperGuestAnswersQuery, EventFormFunctionalWrapperGuestAnswersQueryVariables>(EventFormFunctionalWrapperGuestAnswersDocument, baseOptions);
      }
export function useEventFormFunctionalWrapperGuestAnswersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormFunctionalWrapperGuestAnswersQuery, EventFormFunctionalWrapperGuestAnswersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormFunctionalWrapperGuestAnswersQuery, EventFormFunctionalWrapperGuestAnswersQueryVariables>(EventFormFunctionalWrapperGuestAnswersDocument, baseOptions);
        }
export type EventFormFunctionalWrapperGuestAnswersQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperGuestAnswersQuery>;
export type EventFormFunctionalWrapperGuestAnswersLazyQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperGuestAnswersLazyQuery>;
export type EventFormFunctionalWrapperGuestAnswersQueryResult = Apollo.QueryResult<EventFormFunctionalWrapperGuestAnswersQuery, EventFormFunctionalWrapperGuestAnswersQueryVariables>;
export const EventFormFunctionalWrapperGuestAttendanceStateDocument = gql`
    query EventFormFunctionalWrapperGuestAttendanceState($eventId: ID!, $guestKey: String!) {
  guestAttendanceByEventId(eventId: $eventId, guestKey: $guestKey) {
    id
    attendanceState
    contact {
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useEventFormFunctionalWrapperGuestAttendanceStateQuery__
 *
 * To run a query within a React component, call `useEventFormFunctionalWrapperGuestAttendanceStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormFunctionalWrapperGuestAttendanceStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormFunctionalWrapperGuestAttendanceStateQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestKey: // value for 'guestKey'
 *   },
 * });
 */
export function useEventFormFunctionalWrapperGuestAttendanceStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventFormFunctionalWrapperGuestAttendanceStateQuery, EventFormFunctionalWrapperGuestAttendanceStateQueryVariables>) {
        return ApolloReactHooks.useQuery<EventFormFunctionalWrapperGuestAttendanceStateQuery, EventFormFunctionalWrapperGuestAttendanceStateQueryVariables>(EventFormFunctionalWrapperGuestAttendanceStateDocument, baseOptions);
      }
export function useEventFormFunctionalWrapperGuestAttendanceStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventFormFunctionalWrapperGuestAttendanceStateQuery, EventFormFunctionalWrapperGuestAttendanceStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventFormFunctionalWrapperGuestAttendanceStateQuery, EventFormFunctionalWrapperGuestAttendanceStateQueryVariables>(EventFormFunctionalWrapperGuestAttendanceStateDocument, baseOptions);
        }
export type EventFormFunctionalWrapperGuestAttendanceStateQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperGuestAttendanceStateQuery>;
export type EventFormFunctionalWrapperGuestAttendanceStateLazyQueryHookResult = ReturnType<typeof useEventFormFunctionalWrapperGuestAttendanceStateLazyQuery>;
export type EventFormFunctionalWrapperGuestAttendanceStateQueryResult = Apollo.QueryResult<EventFormFunctionalWrapperGuestAttendanceStateQuery, EventFormFunctionalWrapperGuestAttendanceStateQueryVariables>;
export const RegistrationFormSaveEventRegistrationDocument = gql`
    mutation RegistrationFormSaveEventRegistration($input: EventRegistrationInput!) {
  saveEventRegistration(input: $input) {
    guestKey
  }
}
    `;
export type RegistrationFormSaveEventRegistrationMutationFn = Apollo.MutationFunction<RegistrationFormSaveEventRegistrationMutation, RegistrationFormSaveEventRegistrationMutationVariables>;

/**
 * __useRegistrationFormSaveEventRegistrationMutation__
 *
 * To run a mutation, you first call `useRegistrationFormSaveEventRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationFormSaveEventRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationFormSaveEventRegistrationMutation, { data, loading, error }] = useRegistrationFormSaveEventRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationFormSaveEventRegistrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegistrationFormSaveEventRegistrationMutation, RegistrationFormSaveEventRegistrationMutationVariables>) {
        return ApolloReactHooks.useMutation<RegistrationFormSaveEventRegistrationMutation, RegistrationFormSaveEventRegistrationMutationVariables>(RegistrationFormSaveEventRegistrationDocument, baseOptions);
      }
export type RegistrationFormSaveEventRegistrationMutationHookResult = ReturnType<typeof useRegistrationFormSaveEventRegistrationMutation>;
export type RegistrationFormSaveEventRegistrationMutationResult = Apollo.MutationResult<RegistrationFormSaveEventRegistrationMutation>;
export type RegistrationFormSaveEventRegistrationMutationOptions = Apollo.BaseMutationOptions<RegistrationFormSaveEventRegistrationMutation, RegistrationFormSaveEventRegistrationMutationVariables>;
export const RegistrationFormSetAttendanceByGuestKeyDocument = gql`
    mutation RegistrationFormSetAttendanceByGuestKey($input: AttendanceInput!) {
  setAttendanceByGuestKey(input: $input) {
    id
    attendanceState
  }
}
    `;
export type RegistrationFormSetAttendanceByGuestKeyMutationFn = Apollo.MutationFunction<RegistrationFormSetAttendanceByGuestKeyMutation, RegistrationFormSetAttendanceByGuestKeyMutationVariables>;

/**
 * __useRegistrationFormSetAttendanceByGuestKeyMutation__
 *
 * To run a mutation, you first call `useRegistrationFormSetAttendanceByGuestKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationFormSetAttendanceByGuestKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationFormSetAttendanceByGuestKeyMutation, { data, loading, error }] = useRegistrationFormSetAttendanceByGuestKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationFormSetAttendanceByGuestKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegistrationFormSetAttendanceByGuestKeyMutation, RegistrationFormSetAttendanceByGuestKeyMutationVariables>) {
        return ApolloReactHooks.useMutation<RegistrationFormSetAttendanceByGuestKeyMutation, RegistrationFormSetAttendanceByGuestKeyMutationVariables>(RegistrationFormSetAttendanceByGuestKeyDocument, baseOptions);
      }
export type RegistrationFormSetAttendanceByGuestKeyMutationHookResult = ReturnType<typeof useRegistrationFormSetAttendanceByGuestKeyMutation>;
export type RegistrationFormSetAttendanceByGuestKeyMutationResult = Apollo.MutationResult<RegistrationFormSetAttendanceByGuestKeyMutation>;
export type RegistrationFormSetAttendanceByGuestKeyMutationOptions = Apollo.BaseMutationOptions<RegistrationFormSetAttendanceByGuestKeyMutation, RegistrationFormSetAttendanceByGuestKeyMutationVariables>;
export const EventPhotoByEventIdDocument = gql`
    query EventPhotoByEventId($eventId: ID!) {
  event(id: $eventId) {
    id
    photo {
      id
      url
    }
  }
}
    `;

/**
 * __useEventPhotoByEventIdQuery__
 *
 * To run a query within a React component, call `useEventPhotoByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPhotoByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPhotoByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventPhotoByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventPhotoByEventIdQuery, EventPhotoByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EventPhotoByEventIdQuery, EventPhotoByEventIdQueryVariables>(EventPhotoByEventIdDocument, baseOptions);
      }
export function useEventPhotoByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventPhotoByEventIdQuery, EventPhotoByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventPhotoByEventIdQuery, EventPhotoByEventIdQueryVariables>(EventPhotoByEventIdDocument, baseOptions);
        }
export type EventPhotoByEventIdQueryHookResult = ReturnType<typeof useEventPhotoByEventIdQuery>;
export type EventPhotoByEventIdLazyQueryHookResult = ReturnType<typeof useEventPhotoByEventIdLazyQuery>;
export type EventPhotoByEventIdQueryResult = Apollo.QueryResult<EventPhotoByEventIdQuery, EventPhotoByEventIdQueryVariables>;
export const EventScheduleByEventIdDocument = gql`
    query EventScheduleByEventId($eventId: ID!) {
  getGuestGeneralEventScheduleForEvent(eventId: $eventId) {
    formattedSchedules {
      dateISO8601TZ
      items {
        description
        id
        name
        timezone
        startTimeISO8601TZ
        endTimeISO8601TZ
      }
    }
  }
}
    `;

/**
 * __useEventScheduleByEventIdQuery__
 *
 * To run a query within a React component, call `useEventScheduleByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventScheduleByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventScheduleByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventScheduleByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventScheduleByEventIdQuery, EventScheduleByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<EventScheduleByEventIdQuery, EventScheduleByEventIdQueryVariables>(EventScheduleByEventIdDocument, baseOptions);
      }
export function useEventScheduleByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventScheduleByEventIdQuery, EventScheduleByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventScheduleByEventIdQuery, EventScheduleByEventIdQueryVariables>(EventScheduleByEventIdDocument, baseOptions);
        }
export type EventScheduleByEventIdQueryHookResult = ReturnType<typeof useEventScheduleByEventIdQuery>;
export type EventScheduleByEventIdLazyQueryHookResult = ReturnType<typeof useEventScheduleByEventIdLazyQuery>;
export type EventScheduleByEventIdQueryResult = Apollo.QueryResult<EventScheduleByEventIdQuery, EventScheduleByEventIdQueryVariables>;
export const WebsiteCreateOrUpdatePagePhotoPresentationDocument = gql`
    mutation WebsiteCreateOrUpdatePagePhotoPresentation($payload: websiteCreateOrUpdatePagePhotoPresentationPayload!) {
  websiteCreateOrUpdatePagePhotoPresentation(payload: $payload) {
    ... on websiteCreateOrUpdatePagePhotoPresentationResponse {
      message
      photoPresentation {
        ...WebsitePagePhotoPresentation
        photo {
          ...PhotoData
        }
      }
      success
    }
    ... on websiteCreateOrUpdatePagePhotoPresentationResponseError {
      id
      message
      pageId
      success
    }
  }
}
    ${WebsitePagePhotoPresentationFragmentDoc}
${PhotoDataFragmentDoc}`;
export type WebsiteCreateOrUpdatePagePhotoPresentationMutationFn = Apollo.MutationFunction<WebsiteCreateOrUpdatePagePhotoPresentationMutation, WebsiteCreateOrUpdatePagePhotoPresentationMutationVariables>;

/**
 * __useWebsiteCreateOrUpdatePagePhotoPresentationMutation__
 *
 * To run a mutation, you first call `useWebsiteCreateOrUpdatePagePhotoPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteCreateOrUpdatePagePhotoPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteCreateOrUpdatePagePhotoPresentationMutation, { data, loading, error }] = useWebsiteCreateOrUpdatePagePhotoPresentationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteCreateOrUpdatePagePhotoPresentationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteCreateOrUpdatePagePhotoPresentationMutation, WebsiteCreateOrUpdatePagePhotoPresentationMutationVariables>) {
        return ApolloReactHooks.useMutation<WebsiteCreateOrUpdatePagePhotoPresentationMutation, WebsiteCreateOrUpdatePagePhotoPresentationMutationVariables>(WebsiteCreateOrUpdatePagePhotoPresentationDocument, baseOptions);
      }
export type WebsiteCreateOrUpdatePagePhotoPresentationMutationHookResult = ReturnType<typeof useWebsiteCreateOrUpdatePagePhotoPresentationMutation>;
export type WebsiteCreateOrUpdatePagePhotoPresentationMutationResult = Apollo.MutationResult<WebsiteCreateOrUpdatePagePhotoPresentationMutation>;
export type WebsiteCreateOrUpdatePagePhotoPresentationMutationOptions = Apollo.BaseMutationOptions<WebsiteCreateOrUpdatePagePhotoPresentationMutation, WebsiteCreateOrUpdatePagePhotoPresentationMutationVariables>;
export const GetEventByNameForPeoplePickerDocument = gql`
    query GetEventByNameForPeoplePicker($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    labels: labels(admin: true) {
      id
      display
      people {
        id
        personIdTag
      }
    }
    guests: guests(admin: true) {
      households {
        id
        members {
          ...Person
        }
      }
    }
    ...EventFragmentForAdmin
  }
}
    ${PersonFragmentDoc}
${EventFragmentForAdminFragmentDoc}`;

/**
 * __useGetEventByNameForPeoplePickerQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForPeoplePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForPeoplePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForPeoplePickerQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForPeoplePickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>(GetEventByNameForPeoplePickerDocument, baseOptions);
      }
export function useGetEventByNameForPeoplePickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>(GetEventByNameForPeoplePickerDocument, baseOptions);
        }
export type GetEventByNameForPeoplePickerQueryHookResult = ReturnType<typeof useGetEventByNameForPeoplePickerQuery>;
export type GetEventByNameForPeoplePickerLazyQueryHookResult = ReturnType<typeof useGetEventByNameForPeoplePickerLazyQuery>;
export type GetEventByNameForPeoplePickerQueryResult = Apollo.QueryResult<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>;
export const UploadPhotoFromUrlDocument = gql`
    mutation UploadPhotoFromUrl($payload: UploadPhotoFromUrlPayload!) {
  uploadPhotoFromUrl(payload: $payload) {
    id
    url
  }
}
    `;
export type UploadPhotoFromUrlMutationFn = Apollo.MutationFunction<UploadPhotoFromUrlMutation, UploadPhotoFromUrlMutationVariables>;

/**
 * __useUploadPhotoFromUrlMutation__
 *
 * To run a mutation, you first call `useUploadPhotoFromUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotoFromUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotoFromUrlMutation, { data, loading, error }] = useUploadPhotoFromUrlMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadPhotoFromUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadPhotoFromUrlMutation, UploadPhotoFromUrlMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadPhotoFromUrlMutation, UploadPhotoFromUrlMutationVariables>(UploadPhotoFromUrlDocument, baseOptions);
      }
export type UploadPhotoFromUrlMutationHookResult = ReturnType<typeof useUploadPhotoFromUrlMutation>;
export type UploadPhotoFromUrlMutationResult = Apollo.MutationResult<UploadPhotoFromUrlMutation>;
export type UploadPhotoFromUrlMutationOptions = Apollo.BaseMutationOptions<UploadPhotoFromUrlMutation, UploadPhotoFromUrlMutationVariables>;
export const CreateRemindMeLaterEmailDocument = gql`
    mutation CreateRemindMeLaterEmail($data: CreateRemindMeLaterEmailInput!) {
  createRemindMeLaterEmail(data: $data)
}
    `;
export type CreateRemindMeLaterEmailMutationFn = Apollo.MutationFunction<CreateRemindMeLaterEmailMutation, CreateRemindMeLaterEmailMutationVariables>;

/**
 * __useCreateRemindMeLaterEmailMutation__
 *
 * To run a mutation, you first call `useCreateRemindMeLaterEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRemindMeLaterEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRemindMeLaterEmailMutation, { data, loading, error }] = useCreateRemindMeLaterEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRemindMeLaterEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRemindMeLaterEmailMutation, CreateRemindMeLaterEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRemindMeLaterEmailMutation, CreateRemindMeLaterEmailMutationVariables>(CreateRemindMeLaterEmailDocument, baseOptions);
      }
export type CreateRemindMeLaterEmailMutationHookResult = ReturnType<typeof useCreateRemindMeLaterEmailMutation>;
export type CreateRemindMeLaterEmailMutationResult = Apollo.MutationResult<CreateRemindMeLaterEmailMutation>;
export type CreateRemindMeLaterEmailMutationOptions = Apollo.BaseMutationOptions<CreateRemindMeLaterEmailMutation, CreateRemindMeLaterEmailMutationVariables>;
export const FindHotelMatchDocument = gql`
    query FindHotelMatch($url: String!) {
  findHotelMatch(url: $url) {
    name
    link
    rate
    rating
    mainPhotoUrl
    thumbnailUrl
    address {
      address
      city
    }
  }
}
    `;

/**
 * __useFindHotelMatchQuery__
 *
 * To run a query within a React component, call `useFindHotelMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelMatchQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFindHotelMatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindHotelMatchQuery, FindHotelMatchQueryVariables>) {
        return ApolloReactHooks.useQuery<FindHotelMatchQuery, FindHotelMatchQueryVariables>(FindHotelMatchDocument, baseOptions);
      }
export function useFindHotelMatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindHotelMatchQuery, FindHotelMatchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindHotelMatchQuery, FindHotelMatchQueryVariables>(FindHotelMatchDocument, baseOptions);
        }
export type FindHotelMatchQueryHookResult = ReturnType<typeof useFindHotelMatchQuery>;
export type FindHotelMatchLazyQueryHookResult = ReturnType<typeof useFindHotelMatchLazyQuery>;
export type FindHotelMatchQueryResult = Apollo.QueryResult<FindHotelMatchQuery, FindHotelMatchQueryVariables>;
export const ScheduleEditorDeleteItemDocument = gql`
    mutation ScheduleEditorDeleteItem($payload: EventScheduleDeleteItemPayload) {
  deleteEventScheduleItem(payload: $payload) {
    ...ScheduleItem
  }
}
    ${ScheduleItemFragmentDoc}`;
export type ScheduleEditorDeleteItemMutationFn = Apollo.MutationFunction<ScheduleEditorDeleteItemMutation, ScheduleEditorDeleteItemMutationVariables>;

/**
 * __useScheduleEditorDeleteItemMutation__
 *
 * To run a mutation, you first call `useScheduleEditorDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEditorDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEditorDeleteItemMutation, { data, loading, error }] = useScheduleEditorDeleteItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useScheduleEditorDeleteItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleEditorDeleteItemMutation, ScheduleEditorDeleteItemMutationVariables>) {
        return ApolloReactHooks.useMutation<ScheduleEditorDeleteItemMutation, ScheduleEditorDeleteItemMutationVariables>(ScheduleEditorDeleteItemDocument, baseOptions);
      }
export type ScheduleEditorDeleteItemMutationHookResult = ReturnType<typeof useScheduleEditorDeleteItemMutation>;
export type ScheduleEditorDeleteItemMutationResult = Apollo.MutationResult<ScheduleEditorDeleteItemMutation>;
export type ScheduleEditorDeleteItemMutationOptions = Apollo.BaseMutationOptions<ScheduleEditorDeleteItemMutation, ScheduleEditorDeleteItemMutationVariables>;
export const ScheduleEditorCreateItemDocument = gql`
    mutation ScheduleEditorCreateItem($payload: EventScheduleCreateItemPayload) {
  createEventScheduleItem(payload: $payload) {
    ...ScheduleItem
  }
}
    ${ScheduleItemFragmentDoc}`;
export type ScheduleEditorCreateItemMutationFn = Apollo.MutationFunction<ScheduleEditorCreateItemMutation, ScheduleEditorCreateItemMutationVariables>;

/**
 * __useScheduleEditorCreateItemMutation__
 *
 * To run a mutation, you first call `useScheduleEditorCreateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEditorCreateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEditorCreateItemMutation, { data, loading, error }] = useScheduleEditorCreateItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useScheduleEditorCreateItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleEditorCreateItemMutation, ScheduleEditorCreateItemMutationVariables>) {
        return ApolloReactHooks.useMutation<ScheduleEditorCreateItemMutation, ScheduleEditorCreateItemMutationVariables>(ScheduleEditorCreateItemDocument, baseOptions);
      }
export type ScheduleEditorCreateItemMutationHookResult = ReturnType<typeof useScheduleEditorCreateItemMutation>;
export type ScheduleEditorCreateItemMutationResult = Apollo.MutationResult<ScheduleEditorCreateItemMutation>;
export type ScheduleEditorCreateItemMutationOptions = Apollo.BaseMutationOptions<ScheduleEditorCreateItemMutation, ScheduleEditorCreateItemMutationVariables>;
export const ScheduleEditorUpdateItemDocument = gql`
    mutation ScheduleEditorUpdateItem($payload: EventScheduleUpdateItemPayload) {
  updateEventScheduleItem(payload: $payload) {
    ...ScheduleItem
  }
}
    ${ScheduleItemFragmentDoc}`;
export type ScheduleEditorUpdateItemMutationFn = Apollo.MutationFunction<ScheduleEditorUpdateItemMutation, ScheduleEditorUpdateItemMutationVariables>;

/**
 * __useScheduleEditorUpdateItemMutation__
 *
 * To run a mutation, you first call `useScheduleEditorUpdateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEditorUpdateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEditorUpdateItemMutation, { data, loading, error }] = useScheduleEditorUpdateItemMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useScheduleEditorUpdateItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleEditorUpdateItemMutation, ScheduleEditorUpdateItemMutationVariables>) {
        return ApolloReactHooks.useMutation<ScheduleEditorUpdateItemMutation, ScheduleEditorUpdateItemMutationVariables>(ScheduleEditorUpdateItemDocument, baseOptions);
      }
export type ScheduleEditorUpdateItemMutationHookResult = ReturnType<typeof useScheduleEditorUpdateItemMutation>;
export type ScheduleEditorUpdateItemMutationResult = Apollo.MutationResult<ScheduleEditorUpdateItemMutation>;
export type ScheduleEditorUpdateItemMutationOptions = Apollo.BaseMutationOptions<ScheduleEditorUpdateItemMutation, ScheduleEditorUpdateItemMutationVariables>;
export const ScheduleEditorGetItemByIdDocument = gql`
    query ScheduleEditorGetItemById($scheduleId: ID!) {
  getAdminEventScheduleItemById(scheduleId: $scheduleId) {
    ...ScheduleItem
  }
}
    ${ScheduleItemFragmentDoc}`;

/**
 * __useScheduleEditorGetItemByIdQuery__
 *
 * To run a query within a React component, call `useScheduleEditorGetItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleEditorGetItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleEditorGetItemByIdQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useScheduleEditorGetItemByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleEditorGetItemByIdQuery, ScheduleEditorGetItemByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ScheduleEditorGetItemByIdQuery, ScheduleEditorGetItemByIdQueryVariables>(ScheduleEditorGetItemByIdDocument, baseOptions);
      }
export function useScheduleEditorGetItemByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleEditorGetItemByIdQuery, ScheduleEditorGetItemByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ScheduleEditorGetItemByIdQuery, ScheduleEditorGetItemByIdQueryVariables>(ScheduleEditorGetItemByIdDocument, baseOptions);
        }
export type ScheduleEditorGetItemByIdQueryHookResult = ReturnType<typeof useScheduleEditorGetItemByIdQuery>;
export type ScheduleEditorGetItemByIdLazyQueryHookResult = ReturnType<typeof useScheduleEditorGetItemByIdLazyQuery>;
export type ScheduleEditorGetItemByIdQueryResult = Apollo.QueryResult<ScheduleEditorGetItemByIdQuery, ScheduleEditorGetItemByIdQueryVariables>;
export const EventAccommodationsCheckDocument = gql`
    query EventAccommodationsCheck($name: String!, $pageContainerBySlugPayload: PageContainerBySlugPayload!) {
  pageContainerBySlug(payload: $pageContainerBySlugPayload) {
    id
    components {
      ... on TravelMapComponent {
        __typename
        id
        blockOrdering
        type
      }
    }
  }
  eventByName(name: $name) {
    id
    accommodationPlacesV2 {
      ...EventAccommodationPublicData
    }
    places {
      id
      googlePlaceId
      type
      name
      displayAddress
      latitude
      longitude
    }
    info {
      id
      placeId
      eventDisplayName
      locationInfo {
        id
        city
        latitude
        longitude
      }
      finalizedDate {
        milliseconds
        timezone
      }
      travel {
        ... on RentalHome {
          id
          type
          __typename
        }
        ... on Tent {
          id
          type
          __typename
        }
        ... on Hotel {
          id
          type
          __typename
        }
      }
    }
    pagesInfo {
      id
      visibility
      page {
        id
        pageSlug
      }
      type
    }
  }
}
    ${EventAccommodationPublicDataFragmentDoc}`;

/**
 * __useEventAccommodationsCheckQuery__
 *
 * To run a query within a React component, call `useEventAccommodationsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventAccommodationsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventAccommodationsCheckQuery({
 *   variables: {
 *      name: // value for 'name'
 *      pageContainerBySlugPayload: // value for 'pageContainerBySlugPayload'
 *   },
 * });
 */
export function useEventAccommodationsCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventAccommodationsCheckQuery, EventAccommodationsCheckQueryVariables>) {
        return ApolloReactHooks.useQuery<EventAccommodationsCheckQuery, EventAccommodationsCheckQueryVariables>(EventAccommodationsCheckDocument, baseOptions);
      }
export function useEventAccommodationsCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventAccommodationsCheckQuery, EventAccommodationsCheckQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventAccommodationsCheckQuery, EventAccommodationsCheckQueryVariables>(EventAccommodationsCheckDocument, baseOptions);
        }
export type EventAccommodationsCheckQueryHookResult = ReturnType<typeof useEventAccommodationsCheckQuery>;
export type EventAccommodationsCheckLazyQueryHookResult = ReturnType<typeof useEventAccommodationsCheckLazyQuery>;
export type EventAccommodationsCheckQueryResult = Apollo.QueryResult<EventAccommodationsCheckQuery, EventAccommodationsCheckQueryVariables>;
export const GetEventFeatureFlagsDocument = gql`
    query GetEventFeatureFlags($eventHandle: String!) {
  eventByName(name: $eventHandle) {
    id
    featureFlags
  }
}
    `;

/**
 * __useGetEventFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEventFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFeatureFlagsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>(GetEventFeatureFlagsDocument, baseOptions);
      }
export function useGetEventFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>(GetEventFeatureFlagsDocument, baseOptions);
        }
export type GetEventFeatureFlagsQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsQuery>;
export type GetEventFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsLazyQuery>;
export type GetEventFeatureFlagsQueryResult = Apollo.QueryResult<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>;
export const EventSafetyRatingDocument = gql`
    query EventSafetyRating($name: String!) {
  eventByName(name: $name) {
    id
    info {
      id
      safetyRating
    }
  }
}
    `;

/**
 * __useEventSafetyRatingQuery__
 *
 * To run a query within a React component, call `useEventSafetyRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSafetyRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSafetyRatingQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEventSafetyRatingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventSafetyRatingQuery, EventSafetyRatingQueryVariables>) {
        return ApolloReactHooks.useQuery<EventSafetyRatingQuery, EventSafetyRatingQueryVariables>(EventSafetyRatingDocument, baseOptions);
      }
export function useEventSafetyRatingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventSafetyRatingQuery, EventSafetyRatingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventSafetyRatingQuery, EventSafetyRatingQueryVariables>(EventSafetyRatingDocument, baseOptions);
        }
export type EventSafetyRatingQueryHookResult = ReturnType<typeof useEventSafetyRatingQuery>;
export type EventSafetyRatingLazyQueryHookResult = ReturnType<typeof useEventSafetyRatingLazyQuery>;
export type EventSafetyRatingQueryResult = Apollo.QueryResult<EventSafetyRatingQuery, EventSafetyRatingQueryVariables>;
export const AutoPopulateAccommodationPlacesV5Document = gql`
    mutation AutoPopulateAccommodationPlacesV5($payload: AutoPopulateAccommodationPlacesPayloadV5!) {
  autoPopulateAccommodationPlacesV5(payload: $payload) {
    error
    idempotentId
    result {
      accommodationPlaceId
      proposedNoteFromHostToGuest
      whyThisHotelIsAGreatPick
    }
    status
  }
}
    `;
export type AutoPopulateAccommodationPlacesV5MutationFn = Apollo.MutationFunction<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>;

/**
 * __useAutoPopulateAccommodationPlacesV5Mutation__
 *
 * To run a mutation, you first call `useAutoPopulateAccommodationPlacesV5Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoPopulateAccommodationPlacesV5Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoPopulateAccommodationPlacesV5Mutation, { data, loading, error }] = useAutoPopulateAccommodationPlacesV5Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutoPopulateAccommodationPlacesV5Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>) {
        return ApolloReactHooks.useMutation<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>(AutoPopulateAccommodationPlacesV5Document, baseOptions);
      }
export type AutoPopulateAccommodationPlacesV5MutationHookResult = ReturnType<typeof useAutoPopulateAccommodationPlacesV5Mutation>;
export type AutoPopulateAccommodationPlacesV5MutationResult = Apollo.MutationResult<AutoPopulateAccommodationPlacesV5Mutation>;
export type AutoPopulateAccommodationPlacesV5MutationOptions = Apollo.BaseMutationOptions<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>;
export const AutopopulateOperationsByEventIdDocument = gql`
    query AutopopulateOperationsByEventId($payload: AutopopulateOperationsByEventIdPayload!) {
  autopopulateOperationsByEventIdV20251203(payload: $payload) {
    operations {
      ...AutopopulateOperation
    }
  }
}
    ${AutopopulateOperationFragmentDoc}`;

/**
 * __useAutopopulateOperationsByEventIdQuery__
 *
 * To run a query within a React component, call `useAutopopulateOperationsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutopopulateOperationsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutopopulateOperationsByEventIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutopopulateOperationsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>(AutopopulateOperationsByEventIdDocument, baseOptions);
      }
export function useAutopopulateOperationsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>(AutopopulateOperationsByEventIdDocument, baseOptions);
        }
export type AutopopulateOperationsByEventIdQueryHookResult = ReturnType<typeof useAutopopulateOperationsByEventIdQuery>;
export type AutopopulateOperationsByEventIdLazyQueryHookResult = ReturnType<typeof useAutopopulateOperationsByEventIdLazyQuery>;
export type AutopopulateOperationsByEventIdQueryResult = Apollo.QueryResult<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>;
export const BasicEventInfoDocument = gql`
    query BasicEventInfo($eventHandle: String!, $isAdmin: Boolean) {
  eventByName(name: $eventHandle) {
    id
    firebaseId
    eventDesign {
      id
      websiteLayout {
        id
        layoutType
      }
    }
    info(admin: $isAdmin) {
      id
      eventDisplayName
      eventType
      fianceeFirstName
      fianceeLastName
      ownerFirstName
      ownerLastName
      locale
      locationInfo {
        id
        city
        country
        latitude
        longitude
        name
        placeId
        state
        address1
        address2
        postalCode
      }
      finalizedDate {
        milliseconds
        dateString(dateFormat: long)
        timestamp
        timezone
      }
      tentativeDate {
        milliseconds
        dateString(dateFormat: long)
        timestamp
        timezone
      }
      story
      qanda {
        ...EventQanda
      }
    }
    firebaseCreateAt {
      timestamp
    }
    productVerticals {
      optOutOfGuestList
      optOutOfInvites
      optOutOfRegistry
      optOutOfWebsite
    }
    settings {
      id
      hideEventCountdown
      hideDownloadAppPage
      hideFromSearchEngines
      hideFromJoySearch
      requirePasswordForEventDate
      requirePasswordForEventLocation
      requirePasswordToUploadPhotos
      requirePasswordToViewEngagementPhotos
      privacyMode
      optOutOfCharm
      allowFacebookAndInstagramSharingOnApp
      allowGuestsNotInGuestListToRSVP
      allowGuestsToInviteOtherGuestsOnApp
      allowGuestsToRSVPPlusOne
      allowGuestsToViewOtherGuestsOnApp
    }
    published
    websiteState
    featureFlags
  }
}
    ${EventQandaFragmentDoc}`;

/**
 * __useBasicEventInfoQuery__
 *
 * To run a query within a React component, call `useBasicEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useBasicEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicEventInfoQuery, BasicEventInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<BasicEventInfoQuery, BasicEventInfoQueryVariables>(BasicEventInfoDocument, baseOptions);
      }
export function useBasicEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicEventInfoQuery, BasicEventInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BasicEventInfoQuery, BasicEventInfoQueryVariables>(BasicEventInfoDocument, baseOptions);
        }
export type BasicEventInfoQueryHookResult = ReturnType<typeof useBasicEventInfoQuery>;
export type BasicEventInfoLazyQueryHookResult = ReturnType<typeof useBasicEventInfoLazyQuery>;
export type BasicEventInfoQueryResult = Apollo.QueryResult<BasicEventInfoQuery, BasicEventInfoQueryVariables>;
export const GetEventPhotoByEventHandleDocument = gql`
    query GetEventPhotoByEventHandle($website: String!) {
  eventByName(name: $website) {
    id
    photo {
      id
      url
    }
    photoV2Url
    info {
      id
      eventType
    }
    eventDesign {
      id
      activeWebsiteHeaderPresentationLayout {
        id: eventId
        schemaURL
        websiteLayout
        dataJSON
      }
    }
  }
}
    `;

/**
 * __useGetEventPhotoByEventHandleQuery__
 *
 * To run a query within a React component, call `useGetEventPhotoByEventHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPhotoByEventHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPhotoByEventHandleQuery({
 *   variables: {
 *      website: // value for 'website'
 *   },
 * });
 */
export function useGetEventPhotoByEventHandleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPhotoByEventHandleQuery, GetEventPhotoByEventHandleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventPhotoByEventHandleQuery, GetEventPhotoByEventHandleQueryVariables>(GetEventPhotoByEventHandleDocument, baseOptions);
      }
export function useGetEventPhotoByEventHandleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPhotoByEventHandleQuery, GetEventPhotoByEventHandleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventPhotoByEventHandleQuery, GetEventPhotoByEventHandleQueryVariables>(GetEventPhotoByEventHandleDocument, baseOptions);
        }
export type GetEventPhotoByEventHandleQueryHookResult = ReturnType<typeof useGetEventPhotoByEventHandleQuery>;
export type GetEventPhotoByEventHandleLazyQueryHookResult = ReturnType<typeof useGetEventPhotoByEventHandleLazyQuery>;
export type GetEventPhotoByEventHandleQueryResult = Apollo.QueryResult<GetEventPhotoByEventHandleQuery, GetEventPhotoByEventHandleQueryVariables>;
export const EventPlacesDocument = gql`
    query EventPlaces($name: String!, $payload: PageContainerBySlugPayload!, $isAdmin: Boolean) {
  eventByName(name: $name) {
    id
    places(admin: $isAdmin) {
      id
      googlePlaceId
      type
      name
      displayAddress
      latitude
      longitude
      city
      stateProvince
      country
      countryCode
    }
    bestLocationAnchor {
      friendlyName
      latitude
      longitude
      googlePlaceID
    }
  }
  pageContainerBySlug(payload: $payload, options: {admin: $isAdmin}) {
    id
    components {
      ... on TravelMapComponent {
        id
        pointsOnMap {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useEventPlacesQuery__
 *
 * To run a query within a React component, call `useEventPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPlacesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      payload: // value for 'payload'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useEventPlacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventPlacesQuery, EventPlacesQueryVariables>) {
        return ApolloReactHooks.useQuery<EventPlacesQuery, EventPlacesQueryVariables>(EventPlacesDocument, baseOptions);
      }
export function useEventPlacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventPlacesQuery, EventPlacesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventPlacesQuery, EventPlacesQueryVariables>(EventPlacesDocument, baseOptions);
        }
export type EventPlacesQueryHookResult = ReturnType<typeof useEventPlacesQuery>;
export type EventPlacesLazyQueryHookResult = ReturnType<typeof useEventPlacesLazyQuery>;
export type EventPlacesQueryResult = Apollo.QueryResult<EventPlacesQuery, EventPlacesQueryVariables>;
export const GetEventTypeDocument = gql`
    query GetEventType($name: String!) {
  eventByName(name: $name) {
    id
    info {
      id
      eventType
    }
  }
}
    `;

/**
 * __useGetEventTypeQuery__
 *
 * To run a query within a React component, call `useGetEventTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventTypeQuery, GetEventTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventTypeQuery, GetEventTypeQueryVariables>(GetEventTypeDocument, baseOptions);
      }
export function useGetEventTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventTypeQuery, GetEventTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventTypeQuery, GetEventTypeQueryVariables>(GetEventTypeDocument, baseOptions);
        }
export type GetEventTypeQueryHookResult = ReturnType<typeof useGetEventTypeQuery>;
export type GetEventTypeLazyQueryHookResult = ReturnType<typeof useGetEventTypeLazyQuery>;
export type GetEventTypeQueryResult = Apollo.QueryResult<GetEventTypeQuery, GetEventTypeQueryVariables>;
export const AutoPopulateStayAreasDocument = gql`
    mutation AutoPopulateStayAreas($payload: AutoPopulateStayAreasPayload!) {
  autoPopulateStayAreas(payload: $payload) {
    error
    idempotentId
    result {
      id
      name
    }
    status
  }
}
    `;
export type AutoPopulateStayAreasMutationFn = Apollo.MutationFunction<AutoPopulateStayAreasMutation, AutoPopulateStayAreasMutationVariables>;

/**
 * __useAutoPopulateStayAreasMutation__
 *
 * To run a mutation, you first call `useAutoPopulateStayAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoPopulateStayAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoPopulateStayAreasMutation, { data, loading, error }] = useAutoPopulateStayAreasMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutoPopulateStayAreasMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AutoPopulateStayAreasMutation, AutoPopulateStayAreasMutationVariables>) {
        return ApolloReactHooks.useMutation<AutoPopulateStayAreasMutation, AutoPopulateStayAreasMutationVariables>(AutoPopulateStayAreasDocument, baseOptions);
      }
export type AutoPopulateStayAreasMutationHookResult = ReturnType<typeof useAutoPopulateStayAreasMutation>;
export type AutoPopulateStayAreasMutationResult = Apollo.MutationResult<AutoPopulateStayAreasMutation>;
export type AutoPopulateStayAreasMutationOptions = Apollo.BaseMutationOptions<AutoPopulateStayAreasMutation, AutoPopulateStayAreasMutationVariables>;
export const AutopopulateStayAreaOperationsByEventIdDocument = gql`
    query AutopopulateStayAreaOperationsByEventId($payload: AutopopulateStayAreaOperationsByEventIdPayload!) {
  autopopulateStayAreaOperationsByEventId(payload: $payload) {
    operations {
      ...AutopopulateStayAreaOperation
    }
  }
}
    ${AutopopulateStayAreaOperationFragmentDoc}`;

/**
 * __useAutopopulateStayAreaOperationsByEventIdQuery__
 *
 * To run a query within a React component, call `useAutopopulateStayAreaOperationsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutopopulateStayAreaOperationsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutopopulateStayAreaOperationsByEventIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutopopulateStayAreaOperationsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AutopopulateStayAreaOperationsByEventIdQuery, AutopopulateStayAreaOperationsByEventIdQueryVariables>) {
        return ApolloReactHooks.useQuery<AutopopulateStayAreaOperationsByEventIdQuery, AutopopulateStayAreaOperationsByEventIdQueryVariables>(AutopopulateStayAreaOperationsByEventIdDocument, baseOptions);
      }
export function useAutopopulateStayAreaOperationsByEventIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AutopopulateStayAreaOperationsByEventIdQuery, AutopopulateStayAreaOperationsByEventIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AutopopulateStayAreaOperationsByEventIdQuery, AutopopulateStayAreaOperationsByEventIdQueryVariables>(AutopopulateStayAreaOperationsByEventIdDocument, baseOptions);
        }
export type AutopopulateStayAreaOperationsByEventIdQueryHookResult = ReturnType<typeof useAutopopulateStayAreaOperationsByEventIdQuery>;
export type AutopopulateStayAreaOperationsByEventIdLazyQueryHookResult = ReturnType<typeof useAutopopulateStayAreaOperationsByEventIdLazyQuery>;
export type AutopopulateStayAreaOperationsByEventIdQueryResult = Apollo.QueryResult<AutopopulateStayAreaOperationsByEventIdQuery, AutopopulateStayAreaOperationsByEventIdQueryVariables>;
export const StayAreasDocument = gql`
    query StayAreas($eventId: ID!) {
  stayAreas(eventId: $eventId) {
    ...StayArea
  }
}
    ${StayAreaFragmentDoc}`;

/**
 * __useStayAreasQuery__
 *
 * To run a query within a React component, call `useStayAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useStayAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStayAreasQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStayAreasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StayAreasQuery, StayAreasQueryVariables>) {
        return ApolloReactHooks.useQuery<StayAreasQuery, StayAreasQueryVariables>(StayAreasDocument, baseOptions);
      }
export function useStayAreasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StayAreasQuery, StayAreasQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StayAreasQuery, StayAreasQueryVariables>(StayAreasDocument, baseOptions);
        }
export type StayAreasQueryHookResult = ReturnType<typeof useStayAreasQuery>;
export type StayAreasLazyQueryHookResult = ReturnType<typeof useStayAreasLazyQuery>;
export type StayAreasQueryResult = Apollo.QueryResult<StayAreasQuery, StayAreasQueryVariables>;
export const RemoveStayAreaDocument = gql`
    mutation RemoveStayArea($payload: RemoveStayAreaPayload!) {
  removeStayArea(payload: $payload) {
    id
  }
}
    `;
export type RemoveStayAreaMutationFn = Apollo.MutationFunction<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>;

/**
 * __useRemoveStayAreaMutation__
 *
 * To run a mutation, you first call `useRemoveStayAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStayAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStayAreaMutation, { data, loading, error }] = useRemoveStayAreaMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRemoveStayAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>(RemoveStayAreaDocument, baseOptions);
      }
export type RemoveStayAreaMutationHookResult = ReturnType<typeof useRemoveStayAreaMutation>;
export type RemoveStayAreaMutationResult = Apollo.MutationResult<RemoveStayAreaMutation>;
export type RemoveStayAreaMutationOptions = Apollo.BaseMutationOptions<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>;
export const UserPublicConsentKeysForEventDocument = gql`
    query UserPublicConsentKeysForEvent($eventId: ID!) {
  userPublicConsentKeysForEvent(eventId: $eventId) {
    consentAnswer
    consentKey
    createdAt
    eventId
    id
  }
}
    `;

/**
 * __useUserPublicConsentKeysForEventQuery__
 *
 * To run a query within a React component, call `useUserPublicConsentKeysForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPublicConsentKeysForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPublicConsentKeysForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUserPublicConsentKeysForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserPublicConsentKeysForEventQuery, UserPublicConsentKeysForEventQueryVariables>) {
        return ApolloReactHooks.useQuery<UserPublicConsentKeysForEventQuery, UserPublicConsentKeysForEventQueryVariables>(UserPublicConsentKeysForEventDocument, baseOptions);
      }
export function useUserPublicConsentKeysForEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPublicConsentKeysForEventQuery, UserPublicConsentKeysForEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserPublicConsentKeysForEventQuery, UserPublicConsentKeysForEventQueryVariables>(UserPublicConsentKeysForEventDocument, baseOptions);
        }
export type UserPublicConsentKeysForEventQueryHookResult = ReturnType<typeof useUserPublicConsentKeysForEventQuery>;
export type UserPublicConsentKeysForEventLazyQueryHookResult = ReturnType<typeof useUserPublicConsentKeysForEventLazyQuery>;
export type UserPublicConsentKeysForEventQueryResult = Apollo.QueryResult<UserPublicConsentKeysForEventQuery, UserPublicConsentKeysForEventQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "LocationInterface": [
      "EventLocation",
      "Location",
      "VendorLocation"
    ],
    "FavoriteResource": [
      "DesignLayout",
      "Font",
      "Theme"
    ],
    "DesignPreference": [
      "DesignPreferenceColor",
      "DesignPreferenceRange",
      "DesignPreferenceBoolean",
      "EventDesignPreferenceBoolean",
      "EventDesignPreferenceColorPointer",
      "EventDesignPreferenceRange",
      "EventDesignPreferenceColor"
    ],
    "WebsiteLayoutAlohaOptions": [
      "WebsiteLayoutAlohaSettings"
    ],
    "WebsiteLayoutBrannanOptions": [
      "WebsiteLayoutBrannanSettings"
    ],
    "EventDesignPreference": [
      "EventDesignPreferenceBoolean",
      "EventDesignPreferenceColorPointer",
      "EventDesignPreferenceRange"
    ],
    "EventTravel": [
      "EventTravelBookingType",
      "EventTravelList",
      "EventTravelNote",
      "Ferry",
      "Flight",
      "Hotel",
      "RentalCar",
      "RentalHome",
      "Shuttle",
      "Taxi",
      "Tent",
      "Train"
    ],
    "EventTravelShared": [
      "EventTravelBookingType",
      "EventTravelList",
      "EventTravelNote",
      "Ferry",
      "Flight",
      "Hotel",
      "RentalCar",
      "RentalHome",
      "Shuttle",
      "Taxi",
      "Tent",
      "Train"
    ],
    "EventMedia": [
      "MediaPhoto",
      "MediaVideo"
    ],
    "Component": [
      "EventCountdownComponent",
      "EventDetailsComponent",
      "EventDisplayNameComponent",
      "GreetingMessageComponent",
      "JsonDataBlobComponent",
      "MediaGalleryComponent",
      "PhotoComponent",
      "RsvpAndUnlockGuestDetailsButtonComponent",
      "TextComponent",
      "TravelMapComponent",
      "VideoComponent"
    ],
    "PagePhoto": [
      "DefaultPagePhoto",
      "Photo"
    ],
    "Connection": [
      "CollectionItemsConnection"
    ],
    "Edge": [
      "CollectionItemsEdge"
    ],
    "VendorUserDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType",
      "VendorUserV2"
    ],
    "ErrorType": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "BookingSlotDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "BookingSlot",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "SalesOrderLine": [
      "SalesOrderCompensationLine",
      "SalesOrderChargeLine",
      "SalesOrderPostPurchaseFeeLine",
      "SalesOrderShippingAndHandlingLine",
      "SalesOrderItemLine",
      "SalesOrderTaxLine"
    ],
    "CheckTransitionalRegistryUrlResult": [
      "InvalidTransitionalRegistryUrlResult",
      "ValidTransitionalRegistryUrlResult"
    ],
    "ProductCatalogCollectionDisplayInfoInterface": [
      "ProductCatalogCollectionDisplayInfoToCategory",
      "ProductCatalogCollectionDisplayInfo"
    ],
    "ProductCatalogEntity": [
      "ProductCatalogEntityBrand",
      "ProductCatalogEntityCategory",
      "ProductCatalogEntityCuration",
      "ProductCatalogEntityItem",
      "ProductCatalogEntityItemGroup"
    ],
    "ProductCatalogAsset": [
      "ProductCatalogPhotoAsset",
      "ProductCatalogVideoAsset"
    ],
    "RatingReviewAsset": [
      "RatingReviewPhotoAsset",
      "RatingReviewVideoAsset"
    ],
    "CustomerInsightsDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "CustomerInsights",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "EnrichedCustomerInsightsUnion": [
      "EnrichedCompanyInsights",
      "EnrichedCustomerInsights"
    ],
    "EventChecklistDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "EventChecklist",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "Email_Connection": [
      "EmailSearchResultsSummaryView"
    ],
    "Email_Edge": [
      "EmailSearchCollectionItemsEdge"
    ],
    "PostOfficeDraft": [
      "PostOfficeGenericEmailDraft",
      "PostOfficeGiftWrapEmailDraft",
      "PostOfficeGreetingCardEmailDraft",
      "PostOfficeReminderEmailDraft",
      "PostOfficeThankYouEmailDraft"
    ],
    "Handle": [
      "Event"
    ],
    "ProductHeroContentMedia": [
      "ProductHeroImage",
      "ProductHeroVideo"
    ],
    "ProductUniversalItemContainer": [
      "ProductExternalOfferContainer",
      "ProductUniversalCatalogItemContainer",
      "ProductUniversalProductContainer"
    ],
    "StationeryPricing": [
      "StationeryFlatFeePricing",
      "StationeryTieredFlatFeePricing",
      "StationeryTieredPricing"
    ],
    "StationeryProductShippingOption": [
      "StationeryProductShippingOptionV1"
    ],
    "StationeryShippingConstraint": [
      "StationeryAllowPoBoxShippingConstraint",
      "StationeryCountryShippingConstraint",
      "StationeryQuantityShippingConstraint"
    ],
    "TransitionalRegistryItem": [
      "TransitionalRegistryFund",
      "TransitionalRegistryProduct"
    ],
    "TravelOfferComponent": [
      "TravelOfferAccommodationUnitsComponent"
    ],
    "BookingTypeDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "BookingType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "VendorTypeResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType",
      "VendorV2"
    ],
    "AcceptCashFundContributionResult": [
      "CashFundContribution",
      "CashFundGeneralError"
    ],
    "CashFundError": [
      "CashFundGeneralError"
    ],
    "addMediaToCollectionResponses": [
      "addMediaToCollectionResponse",
      "addMediaToCollectionResponseError"
    ],
    "MutationResponse": [
      "addMediaToCollectionResponse",
      "addMediaToCollectionResponseError",
      "createMediaPhotosResponse",
      "websiteCreateOrUpdatePagePhotoPresentationResponse",
      "websiteCreateOrUpdatePagePhotoPresentationResponseError"
    ],
    "ArchiveCashFundResult": [
      "ArchiveCashFundSuccess",
      "CashFundGeneralError"
    ],
    "CreateCashFundResult": [
      "CashFund",
      "CashFundGeneralError"
    ],
    "CreateCashFundCheckoutSessionResult": [
      "CashFundCheckoutSession",
      "CashFundGeneralError"
    ],
    "CreateCashFundPaymentIntentResult": [
      "CashFundGeneralError",
      "CashFundPaymentIntent"
    ],
    "CreateCashFundSolicitationResult": [
      "CashFundGeneralError",
      "CashFundSolicitation"
    ],
    "ChecklistItemDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ChecklistItem",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "ChecklistSubItemDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ChecklistSubItem",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType"
    ],
    "CreateRegistryPaymentIntentResult": [
      "RegistryPaymentIntent",
      "RegistryPaymentIntentError"
    ],
    "CreateRegistryPayoutAccountResult": [
      "RegistryErrorResult",
      "RegistryPayoutAccount"
    ],
    "VendorOrganizationTypeResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType",
      "VendorOrganization"
    ],
    "VendorUserInviteDtoResult": [
      "AuthenticationErrorType",
      "BadRequestErrorType",
      "ForbiddenErrorType",
      "InternalServerErrorType",
      "NotFoundErrorType",
      "VendorUserInvite"
    ],
    "DuplicateCashFundResult": [
      "CashFund",
      "CashFundGeneralError"
    ],
    "GetImageMetadataResult": [
      "FailedImageMetadataResponse",
      "Photo"
    ],
    "InitCashFundsHostResult": [
      "CashFundGeneralError",
      "CashFundsHost"
    ],
    "ManageCashFundSolicitationRecipientsResult": [
      "CashFundGeneralError",
      "CashFundSolicitation"
    ],
    "ReactivateCashFundResult": [
      "CashFund",
      "CashFundGeneralError"
    ],
    "RefundCashFundContributionResult": [
      "CashFundContribution",
      "CashFundGeneralError"
    ],
    "TravelOfferReservationRegenerateTokenResult": [
      "TravelOfferReservationCreateStripeNativeResult",
      "TravelOfferReservationCreateVaulteraVaultResult"
    ],
    "SendCashFundSolicitationEmailsResult": [
      "CashFundGeneralError",
      "SendCashFundSolicitationEmailsSuccess"
    ],
    "SendCashFundSolicitationTestEmailResult": [
      "CashFundGeneralError",
      "SendCashFundSolicitationTestEmailSuccess"
    ],
    "TravelOfferReservationCancelResult": [
      "TravelOfferReservationCancelFailure",
      "TravelOfferReservationCancelSuccess"
    ],
    "TravelOfferReservationConfirmResult": [
      "TravelOfferReservationConfirmFailure",
      "TravelOfferReservationConfirmSuccess"
    ],
    "TravelOfferReservationCreateResult": [
      "TravelOfferReservationCreateStripeNativeResult",
      "TravelOfferReservationCreateVaulteraVaultResult"
    ],
    "UpdateCashFundResult": [
      "CashFund",
      "CashFundGeneralError"
    ],
    "UpdateCashFundSolicitationResult": [
      "CashFundGeneralError",
      "CashFundSolicitation"
    ],
    "uploadPhotosFromUrlsResponse": [
      "uploadPhotosFromUrlsResponseError",
      "uploadPhotosFromUrlsResponseSuccess"
    ],
    "websiteCreateOrUpdatePagePhotoPresentationResponses": [
      "websiteCreateOrUpdatePagePhotoPresentationResponse",
      "websiteCreateOrUpdatePagePhotoPresentationResponseError"
    ],
    "WithdrawCashFundsPayoutAccountResult": [
      "CashFundGeneralError",
      "CashFundsPayoutAccountWithdrawal"
    ],
    "DesignFeature": []
  }
};
      export default result;
    
export type QueryKeySpecifier = ('accommodationCatalogPropertyById' | 'accommodationPlaceV2ById' | 'activeVendorUserByVendorHandle' | 'adminVendorList' | 'allDiscoveryNodeCollectionGroupPhotos' | 'allDiscoveryNodeCollectionPhotos' | 'allDiscoveryNodePhotos' | 'allVendorCollectionPhotos' | 'analyticsCompareBestOfferPrices' | 'analyticsCompareBestOfferPricesBatch' | 'attendanceByEventId' | 'attendanceByGuestKeys' | 'attendanceWithCountByEventId' | 'authenticateUser' | 'autopopulateOperationsByEventId' | 'autopopulateOperationsByEventIdV20251203' | 'autopopulateStayAreaOperationsByEventId' | 'bookingSlotByEmail' | 'bookingSlotById' | 'bookingTypeAvailability' | 'bookingTypeAvailabilityDates' | 'calculateCashFundContributionReceipt' | 'calculateRegistryPurchaseInfo' | 'calendarCredentialsForUserAreExpired' | 'checkHandle' | 'checkRegistryUrl' | 'checkRegistryUrlCanSync' | 'checkTransitionalRegistryUrl' | 'collection' | 'collectionItem' | 'collections' | 'collectionsByVenueId' | 'computeProductsHeuristic' | 'contactQuarantinedMessageBatchContainer' | 'contactQuarantinedMessageBatchDetailsById' | 'contactQuarantinedMessageBatchesByEventId' | 'currencyConversionByCode' | 'currencyConversions' | 'customerInsightsById' | 'customThemeAssetById' | 'customThemeAssetsByEventId' | 'customThemeById' | 'customThemesByEventId' | 'designBucket' | 'designBuckets' | 'designFavorite' | 'designGuestSiteTarget' | 'doesFirebaseAssetExist' | 'email' | 'embedding' | 'event' | 'eventAdminInvites' | 'eventByFirebaseId' | 'eventById' | 'eventByName' | 'eventChecklistByEventId' | 'eventChecklistById' | 'eventDesign' | 'eventMatch' | 'eventMatchByEventId' | 'eventPage' | 'eventTypeCategories' | 'eventTypesByCategory' | 'eventUser' | 'eventUsersByUserId' | 'eventVips' | 'filestack' | 'findCashFundsHostByEventId' | 'findDefaultThingsToDoPage' | 'findEmailDeliveryData' | 'findHotelMatch' | 'findMatchingAccommodationCatalogPropertiesByDetails' | 'findMatchingAccommodationCatalogProperty' | 'firebasePhotoFromPath' | 'firebasePhotoFromPaths' | 'firebaseVideoFromPath' | 'font' | 'fontPack' | 'fontPackByName' | 'fontPacks' | 'fonts' | 'formAnswerById' | 'formAnswerListByFormId' | 'formAnswerListByGuestKeys' | 'formById' | 'formListByEventId' | 'formTemplateById' | 'formTemplateList' | 'generatedSimpleTags' | 'getAdminEventScheduleItemById' | 'getAllSearchTags' | 'getCashFundById' | 'getCashFundContributionById' | 'getCashFundContributorById' | 'getCashFundForContribution' | 'getCashFundPaymentAttemptById' | 'getCashFundsByEventId' | 'getCashFundSolicitationById' | 'getCollaborationInviteById' | 'getContactCollectionByEventId' | 'getContactCollectionByEventIdOrCreateOne' | 'getContactCollectionByFirebaseEventIdOrCreateOne' | 'getContactCollectionByMagicLink' | 'getContactDetailsByGuestIdList' | 'getContactGroup' | 'getContactsByContactCollection' | 'getContactsByGroupId' | 'getContactsByGuestKeyList' | 'getContactsByHousehold' | 'getContactsByIds' | 'getContactsDataAsCSV' | 'getDonationFundById' | 'getDonationFundDonationById' | 'getDonationFundPlatformById' | 'getEcardByGuid' | 'getEcardEmailDraftsByEventId' | 'getEcardLinkOptionsByEventId' | 'getEcardRecepientDisplayByLookupId' | 'getEcardsByEventId' | 'getEmailDeliveryData' | 'getEmailTypeOptions' | 'getEventContacts' | 'getEventsBySearch' | 'getEventSessionByEventAndSessionId' | 'getGreetingCardById' | 'getGroupMembersWithAttendanceAndAnswers' | 'getGuestForm' | 'getGuestGeneralEventScheduleForEvent' | 'getGuestListMembersByEventId' | 'getGuestListMembersByTagIds' | 'getMessageBatchesByEventId' | 'getMessageRelationships' | 'getMessagingSettingsByEventId' | 'getMostRecentEcardByEventId' | 'getPendingCollaborationInvitesByEventHandle' | 'getPendingCollaborationInvitesByEventId' | 'getPhoneNumberInformation' | 'getPostOfficeDraft' | 'getPostOfficeDraftsByEventId' | 'getRecipientSessionByGuestKey' | 'getRecipientSessionByInviteePID' | 'getRecommendRegistryOnboardingSurvey' | 'getRegistrationQuestionsByEventId' | 'getRegistryChecklist' | 'getRegistryChecklistSectionById' | 'getRegistryEventData' | 'getRegistryStaticData' | 'getResourcesByGuestListMemberId' | 'getResourcesByTagIds' | 'getResourcesVisibilityForGuestSession' | 'getRsvpAnswersByFirebaseEventId' | 'getSearchMetadataByID' | 'getTagsByEvent' | 'getTagsByGuest' | 'getTagsByResource' | 'getTagsByResources' | 'getThingsToDoContainers' | 'googleAuthenticationUrl' | 'googleCalendarList' | 'greetings' | 'guestAnswersByFormId' | 'guestAnswersByFormIdForAdmin' | 'guestAnswersHistoryByFormId' | 'guestAttendanceByEventId' | 'handle' | 'hotelImages' | 'hotelInventoryByIds' | 'hotelInventoryByRadius' | 'hotelRoomBlockByBookingLink' | 'hotelRoomBlocksById' | 'hotelRoomsAndRates' | 'hotelRoomsAndRatesByLocation' | 'hotelSuggestions' | 'identifyUser' | 'identifyUsers' | 'improveText' | 'insightRagQuery' | 'internalEventSearchResults' | 'internalMessageSearchResults' | 'internalPeopleByEventId' | 'isPageContainerSlugAvailable' | 'isWebsiteHandleAvailable' | 'joyPlaceById' | 'joyPlaceBySourceId' | 'joyPlaceBySourceIds' | 'joyPlacesByIds' | 'jsonDataContainerById' | 'layout' | 'layouts' | 'linkRedirectBlockContainer' | 'linkRedirectContainer' | 'locationSuggestions' | 'marketingEmailPreferences' | 'match' | 'matches' | 'matchesByEventId' | 'matchesByVendorId' | 'me' | 'mediaCollectionById' | 'mediaCollectionByMagicToken' | 'mediaCollectionMagicToken' | 'mediaCollectionMagicTokenV2' | 'messageSearchResults' | 'metaTag' | 'milestonesActivities' | 'milestonesCalendar' | 'milestonesCategoriesByProjectId' | 'milestonesCategoryById' | 'milestonesGantt' | 'milestonesImportJob' | 'milestonesImportJobs' | 'milestonesKanban' | 'milestonesMilestoneById' | 'milestonesMilestones' | 'milestonesPhasesByProjectId' | 'milestonesProjectByEventId' | 'milestonesProjectById' | 'milestonesUserActivities' | 'nearbyAttractionsSearch' | 'offerDetailsByJoyOfferId' | 'oldBookingTypeAvailability' | 'orderById' | 'ordersByEmail' | 'ordersByEventId' | 'outlookAuthenticationUrl' | 'pageContainerBySlug' | 'parseVirtualEventLink' | 'personById' | 'photo' | 'photos' | 'photosByGeneratedSimpleTags' | 'photosBySimpleTags' | 'photosByToken' | 'previewGuestNotFound' | 'previewMessageToHost' | 'previewRequestCode' | 'pricingsForAccommodationByRegion' | 'pricingsForAccommodationByRegionV20250708' | 'printProvider' | 'printProviders' | 'productById' | 'productCatalogAds' | 'productCatalogBrandsByCriteria' | 'productCatalogBrandsDirectory' | 'productCatalogCategoriesByIds' | 'productCatalogCategoryById' | 'productCatalogCategoryByLocator' | 'productCatalogCategoryTreeRoot' | 'productCatalogCollectionDisplayInfosByRefs' | 'productCatalogItemById' | 'productCatalogItemByLocator' | 'productCatalogItemGroupsByIds' | 'productCatalogItemRecommendations' | 'productCatalogItemsByIds' | 'productCatalogItemsByJoySKUs' | 'productCatalogSearchResults' | 'productExternalById' | 'productExternalSearch' | 'productHeroContentByCriteria' | 'productInventoryByCatalogItemId' | 'productsByIds' | 'productsHeuristicSearch' | 'productStoreSections' | 'productUniversalSearch' | 'productUniversalSearchResults' | 'questionWithAnswers' | 'recentTravelReservationsByEvent' | 'recommendableItemsByRegistryId' | 'recommendCatalogHomeSections' | 'registrationFormByEventId' | 'registrationsByEventId' | 'registry' | 'registryCatalogInventoryById' | 'registryItem' | 'registryItemsByEventId' | 'registryItemsByIds' | 'registryOrderById' | 'registryOrdersByIds' | 'registryPage' | 'registryPurchaseConfirmationDetailsByPurchaseContextId' | 'registryStoreSections' | 'requestForProposal' | 'reservedRoomBlockById' | 'robustEventUsersByUserId' | 'searchAccommodationProperties' | 'searchExtendedAccommodationProperties' | 'searchExtendedAccommodationPropertiesV2' | 'searchForServiceTag' | 'searchForVendor' | 'searchTermToTemplates' | 'searchTravelOfferReservations' | 'serviceTag' | 'simpleTags' | 'sms' | 'stationeryDigitalCardView' | 'stationeryDraftById' | 'stationeryDraftsByEvent' | 'stationeryIsEventEligibleForFreeSampleKit' | 'stationeryPreviewDataUri' | 'stationeryPrintOrderById' | 'stationeryPrintOrderByOrderNumber' | 'stationeryPrintOrderCardDetailsByOrderNumber' | 'stationeryPrintOrderDebuggingInfo' | 'stationeryPrintOrders' | 'stationeryPrintOrdersByEvent' | 'stationeryPrintOrderStatusHistoryByPrintOrderId' | 'stationeryProductById' | 'stationeryProducts' | 'stationeryStalePrintOrders' | 'stationeryTags' | 'stationeryTemplateById' | 'stationeryTemplates' | 'stationeryTemplatesByCategory' | 'stationeryTemplatesByThemeId' | 'stationeryTemplatesContainer' | 'stayAreas' | 'suggestedVendors' | 'suggestionGroup' | 'suggestionGroupByVendorType' | 'syntheticCollection' | 'syntheticCollectionByNames' | 'testimony' | 'textCompletion' | 'textCompletionV2' | 'textTagging' | 'theme' | 'themeAttributes' | 'themeByThemeId' | 'themeCollection' | 'themes' | 'themeVariantByThemeIdAndVariantType' | 'themeVariants' | 'ticketById' | 'ticketsByEventId' | 'ticketsByGuestKey' | 'ticketTypeById' | 'ticketTypesByEventId' | 'transitionalRegistriesForEvent' | 'transitionalRegistry' | 'travelDistancesBetweenPoints' | 'travelDistancesFromOrigin' | 'travelOfferFromOfferToken' | 'travelOfferReservationById' | 'travelOfferReservationByIdOrOrderId' | 'travelOffersForAccommodationByRegion' | 'travelOffersForAccommodationProperties' | 'travelPlacesPricingAndBookingDetails' | 'travelPricingsForAccommodationByPropertyId' | 'travelRateComparisonsForTravelPlaces' | 'travelReservationBookingDetails' | 'travelReservationSummariesByPropertyIdentifiers' | 'uploadMediaStatus' | 'urlMetadata' | 'user' | 'userActivityContainer' | 'userConsentKeyForEvent' | 'userConsentKeysForEvent' | 'userPublicConsentKeyForEvent' | 'userPublicConsentKeysForEvent' | 'validateEmailAddress' | 'vendor' | 'vendorBookingTypeByHandle' | 'vendorBookingTypeByHandleOrId' | 'vendorBookingTypeById' | 'vendorBookingTypesByVendorHandle' | 'vendorByHandleV2' | 'vendorByIdV2' | 'vendorCollectionGroup' | 'vendorDiscoveryNode' | 'vendorDiscoveryNodeByUrl' | 'vendorDiscoveryNodeItem' | 'vendorDiscoveryNodes' | 'vendorHandle' | 'vendorList' | 'vendorsByIds' | 'vendorsOnDiscoveryNodes' | 'vendorSuggestion' | 'vendorType' | 'vendorTypes' | 'vendorUser' | 'vendorUserById' | 'vendorUserInvites' | 'vendorUsersByVendorId' | 'verifyCollectionExistance' | 'verifyUrl' | 'video' | 'vip' | 'visionQuery' | 'visionTaggingQuery' | 'warehouseInventorySearch' | 'warehouseItemByJoySKU' | 'websiteHeaderPresentationLayoutBySchema' | 'zentrumHubHotelIsValid' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	accommodationCatalogPropertyById?: FieldPolicy<any> | FieldReadFunction<any>,
	accommodationPlaceV2ById?: FieldPolicy<any> | FieldReadFunction<any>,
	activeVendorUserByVendorHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	adminVendorList?: FieldPolicy<any> | FieldReadFunction<any>,
	allDiscoveryNodeCollectionGroupPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	allDiscoveryNodeCollectionPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	allDiscoveryNodePhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	allVendorCollectionPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	analyticsCompareBestOfferPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	analyticsCompareBestOfferPricesBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	attendanceByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	attendanceByGuestKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	attendanceWithCountByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	authenticateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	autopopulateOperationsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	autopopulateOperationsByEventIdV20251203?: FieldPolicy<any> | FieldReadFunction<any>,
	autopopulateStayAreaOperationsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingSlotByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingSlotById?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingTypeAvailabilityDates?: FieldPolicy<any> | FieldReadFunction<any>,
	calculateCashFundContributionReceipt?: FieldPolicy<any> | FieldReadFunction<any>,
	calculateRegistryPurchaseInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	calendarCredentialsForUserAreExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	checkHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	checkRegistryUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	checkRegistryUrlCanSync?: FieldPolicy<any> | FieldReadFunction<any>,
	checkTransitionalRegistryUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionsByVenueId?: FieldPolicy<any> | FieldReadFunction<any>,
	computeProductsHeuristic?: FieldPolicy<any> | FieldReadFunction<any>,
	contactQuarantinedMessageBatchContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	contactQuarantinedMessageBatchDetailsById?: FieldPolicy<any> | FieldReadFunction<any>,
	contactQuarantinedMessageBatchesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversionByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversions?: FieldPolicy<any> | FieldReadFunction<any>,
	customerInsightsById?: FieldPolicy<any> | FieldReadFunction<any>,
	customThemeAssetById?: FieldPolicy<any> | FieldReadFunction<any>,
	customThemeAssetsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	customThemeById?: FieldPolicy<any> | FieldReadFunction<any>,
	customThemesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	designBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	designBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	designFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	designGuestSiteTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	doesFirebaseAssetExist?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	embedding?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventAdminInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	eventByFirebaseId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventById?: FieldPolicy<any> | FieldReadFunction<any>,
	eventByName?: FieldPolicy<any> | FieldReadFunction<any>,
	eventChecklistByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventChecklistById?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatchByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventPage?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTypeCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTypesByCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	eventUser?: FieldPolicy<any> | FieldReadFunction<any>,
	eventUsersByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventVips?: FieldPolicy<any> | FieldReadFunction<any>,
	filestack?: FieldPolicy<any> | FieldReadFunction<any>,
	findCashFundsHostByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	findDefaultThingsToDoPage?: FieldPolicy<any> | FieldReadFunction<any>,
	findEmailDeliveryData?: FieldPolicy<any> | FieldReadFunction<any>,
	findHotelMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	findMatchingAccommodationCatalogPropertiesByDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	findMatchingAccommodationCatalogProperty?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePhotoFromPath?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePhotoFromPaths?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseVideoFromPath?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	fontPack?: FieldPolicy<any> | FieldReadFunction<any>,
	fontPackByName?: FieldPolicy<any> | FieldReadFunction<any>,
	fontPacks?: FieldPolicy<any> | FieldReadFunction<any>,
	fonts?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswerById?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswerListByFormId?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswerListByGuestKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	formById?: FieldPolicy<any> | FieldReadFunction<any>,
	formListByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formTemplateById?: FieldPolicy<any> | FieldReadFunction<any>,
	formTemplateList?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedSimpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminEventScheduleItemById?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSearchTags?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundById?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundContributionById?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundContributorById?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundForContribution?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundPaymentAttemptById?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getCashFundSolicitationById?: FieldPolicy<any> | FieldReadFunction<any>,
	getCollaborationInviteById?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactCollectionByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactCollectionByEventIdOrCreateOne?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactCollectionByFirebaseEventIdOrCreateOne?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactCollectionByMagicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactDetailsByGuestIdList?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsByContactCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsByGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsByGuestKeyList?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsByHousehold?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getContactsDataAsCSV?: FieldPolicy<any> | FieldReadFunction<any>,
	getDonationFundById?: FieldPolicy<any> | FieldReadFunction<any>,
	getDonationFundDonationById?: FieldPolicy<any> | FieldReadFunction<any>,
	getDonationFundPlatformById?: FieldPolicy<any> | FieldReadFunction<any>,
	getEcardByGuid?: FieldPolicy<any> | FieldReadFunction<any>,
	getEcardEmailDraftsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getEcardLinkOptionsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getEcardRecepientDisplayByLookupId?: FieldPolicy<any> | FieldReadFunction<any>,
	getEcardsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getEmailDeliveryData?: FieldPolicy<any> | FieldReadFunction<any>,
	getEmailTypeOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	getEventContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	getEventsBySearch?: FieldPolicy<any> | FieldReadFunction<any>,
	getEventSessionByEventAndSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	getGreetingCardById?: FieldPolicy<any> | FieldReadFunction<any>,
	getGroupMembersWithAttendanceAndAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	getGuestForm?: FieldPolicy<any> | FieldReadFunction<any>,
	getGuestGeneralEventScheduleForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getGuestListMembersByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getGuestListMembersByTagIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getMessageBatchesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getMessageRelationships?: FieldPolicy<any> | FieldReadFunction<any>,
	getMessagingSettingsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getMostRecentEcardByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getPendingCollaborationInvitesByEventHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	getPendingCollaborationInvitesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getPhoneNumberInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	getPostOfficeDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	getPostOfficeDraftsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getRecipientSessionByGuestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	getRecipientSessionByInviteePID?: FieldPolicy<any> | FieldReadFunction<any>,
	getRecommendRegistryOnboardingSurvey?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegistrationQuestionsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegistryChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegistryChecklistSectionById?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegistryEventData?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegistryStaticData?: FieldPolicy<any> | FieldReadFunction<any>,
	getResourcesByGuestListMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	getResourcesByTagIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getResourcesVisibilityForGuestSession?: FieldPolicy<any> | FieldReadFunction<any>,
	getRsvpAnswersByFirebaseEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	getSearchMetadataByID?: FieldPolicy<any> | FieldReadFunction<any>,
	getTagsByEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getTagsByGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	getTagsByResource?: FieldPolicy<any> | FieldReadFunction<any>,
	getTagsByResources?: FieldPolicy<any> | FieldReadFunction<any>,
	getThingsToDoContainers?: FieldPolicy<any> | FieldReadFunction<any>,
	googleAuthenticationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	googleCalendarList?: FieldPolicy<any> | FieldReadFunction<any>,
	greetings?: FieldPolicy<any> | FieldReadFunction<any>,
	guestAnswersByFormId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestAnswersByFormIdForAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	guestAnswersHistoryByFormId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestAttendanceByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelImages?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelInventoryByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelInventoryByRadius?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomBlockByBookingLink?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomBlocksById?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomsAndRates?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomsAndRatesByLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	identifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	identifyUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	improveText?: FieldPolicy<any> | FieldReadFunction<any>,
	insightRagQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	internalEventSearchResults?: FieldPolicy<any> | FieldReadFunction<any>,
	internalMessageSearchResults?: FieldPolicy<any> | FieldReadFunction<any>,
	internalPeopleByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	isPageContainerSlugAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	isWebsiteHandleAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceById?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceBySourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceBySourceIds?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlacesByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	jsonDataContainerById?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	layouts?: FieldPolicy<any> | FieldReadFunction<any>,
	linkRedirectBlockContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	linkRedirectContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	locationSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingEmailPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	match?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>,
	matchesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	matchesByVendorId?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollectionById?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollectionByMagicToken?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollectionMagicToken?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollectionMagicTokenV2?: FieldPolicy<any> | FieldReadFunction<any>,
	messageSearchResults?: FieldPolicy<any> | FieldReadFunction<any>,
	metaTag?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCategoriesByProjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCategoryById?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesGantt?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesImportJob?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesImportJobs?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesKanban?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesMilestoneById?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesMilestones?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesPhasesByProjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesProjectByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesProjectById?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUserActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	nearbyAttractionsSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	offerDetailsByJoyOfferId?: FieldPolicy<any> | FieldReadFunction<any>,
	oldBookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	orderById?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	outlookAuthenticationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	pageContainerBySlug?: FieldPolicy<any> | FieldReadFunction<any>,
	parseVirtualEventLink?: FieldPolicy<any> | FieldReadFunction<any>,
	personById?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	photosByGeneratedSimpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	photosBySimpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	photosByToken?: FieldPolicy<any> | FieldReadFunction<any>,
	previewGuestNotFound?: FieldPolicy<any> | FieldReadFunction<any>,
	previewMessageToHost?: FieldPolicy<any> | FieldReadFunction<any>,
	previewRequestCode?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingsForAccommodationByRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingsForAccommodationByRegionV20250708?: FieldPolicy<any> | FieldReadFunction<any>,
	printProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	printProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	productById?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogAds?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogBrandsByCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogBrandsDirectory?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogCategoriesByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogCategoryById?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogCategoryByLocator?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogCategoryTreeRoot?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogCollectionDisplayInfosByRefs?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemById?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemByLocator?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemGroupsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemRecommendations?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogItemsByJoySKUs?: FieldPolicy<any> | FieldReadFunction<any>,
	productCatalogSearchResults?: FieldPolicy<any> | FieldReadFunction<any>,
	productExternalById?: FieldPolicy<any> | FieldReadFunction<any>,
	productExternalSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	productHeroContentByCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	productInventoryByCatalogItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	productsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	productsHeuristicSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	productStoreSections?: FieldPolicy<any> | FieldReadFunction<any>,
	productUniversalSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	productUniversalSearchResults?: FieldPolicy<any> | FieldReadFunction<any>,
	questionWithAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	recentTravelReservationsByEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendableItemsByRegistryId?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendCatalogHomeSections?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationFormByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	registry?: FieldPolicy<any> | FieldReadFunction<any>,
	registryCatalogInventoryById?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItemsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItemsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOrdersByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	registryPage?: FieldPolicy<any> | FieldReadFunction<any>,
	registryPurchaseConfirmationDetailsByPurchaseContextId?: FieldPolicy<any> | FieldReadFunction<any>,
	registryStoreSections?: FieldPolicy<any> | FieldReadFunction<any>,
	requestForProposal?: FieldPolicy<any> | FieldReadFunction<any>,
	reservedRoomBlockById?: FieldPolicy<any> | FieldReadFunction<any>,
	robustEventUsersByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	searchAccommodationProperties?: FieldPolicy<any> | FieldReadFunction<any>,
	searchExtendedAccommodationProperties?: FieldPolicy<any> | FieldReadFunction<any>,
	searchExtendedAccommodationPropertiesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	searchForServiceTag?: FieldPolicy<any> | FieldReadFunction<any>,
	searchForVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	searchTermToTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	searchTravelOfferReservations?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTag?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	sms?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryDigitalCardView?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryDraftById?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryDraftsByEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryIsEventEligibleForFreeSampleKit?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPreviewDataUri?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderByOrderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderCardDetailsByOrderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderDebuggingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrdersByEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderStatusHistoryByPrintOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryProductById?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryStalePrintOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTags?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplateById?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplatesByCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplatesByThemeId?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplatesContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	stayAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestionGroupByVendorType?: FieldPolicy<any> | FieldReadFunction<any>,
	syntheticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	syntheticCollectionByNames?: FieldPolicy<any> | FieldReadFunction<any>,
	testimony?: FieldPolicy<any> | FieldReadFunction<any>,
	textCompletion?: FieldPolicy<any> | FieldReadFunction<any>,
	textCompletionV2?: FieldPolicy<any> | FieldReadFunction<any>,
	textTagging?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>,
	themeAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	themeByThemeId?: FieldPolicy<any> | FieldReadFunction<any>,
	themeCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	themes?: FieldPolicy<any> | FieldReadFunction<any>,
	themeVariantByThemeIdAndVariantType?: FieldPolicy<any> | FieldReadFunction<any>,
	themeVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketById?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketsByGuestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketTypeById?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketTypesByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionalRegistriesForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionalRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	travelDistancesBetweenPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	travelDistancesFromOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferFromOfferToken?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationById?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationByIdOrOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOffersForAccommodationByRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOffersForAccommodationProperties?: FieldPolicy<any> | FieldReadFunction<any>,
	travelPlacesPricingAndBookingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	travelPricingsForAccommodationByPropertyId?: FieldPolicy<any> | FieldReadFunction<any>,
	travelRateComparisonsForTravelPlaces?: FieldPolicy<any> | FieldReadFunction<any>,
	travelReservationBookingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	travelReservationSummariesByPropertyIdentifiers?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadMediaStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userActivityContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	userConsentKeyForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	userConsentKeysForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	userPublicConsentKeyForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	userPublicConsentKeysForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	validateEmailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorBookingTypeByHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorBookingTypeByHandleOrId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorBookingTypeById?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorBookingTypesByVendorHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorByHandleV2?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorByIdV2?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCollectionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorDiscoveryNode?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorDiscoveryNodeByUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorDiscoveryNodeItem?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorDiscoveryNodes?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorList?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsOnDiscoveryNodes?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorSuggestion?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorType?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUser?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUserById?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUserInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUsersByVendorId?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyCollectionExistance?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>,
	vip?: FieldPolicy<any> | FieldReadFunction<any>,
	visionQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	visionTaggingQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseInventorySearch?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseItemByJoySKU?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteHeaderPresentationLayoutBySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	zentrumHubHotelIsValid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyKeySpecifier = ('accommodationCategory' | 'address' | 'chain' | 'checkIn' | 'checkOut' | 'facilities' | 'joyPlaceId' | 'location' | 'name' | 'photos' | 'plainTextLongDescription' | 'policies' | 'propertyType' | 'relevanceScore' | 'starRating' | 'url' | 'userRating' | AccommodationCatalogPropertyKeySpecifier)[];
export type AccommodationCatalogPropertyFieldPolicy = {
	accommodationCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	chain?: FieldPolicy<any> | FieldReadFunction<any>,
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	plainTextLongDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	policies?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyType?: FieldPolicy<any> | FieldReadFunction<any>,
	relevanceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyAddressKeySpecifier = ('city' | 'country' | 'postalCode' | 'state' | 'street' | AccommodationCatalogPropertyAddressKeySpecifier)[];
export type AccommodationCatalogPropertyAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyCheckInOutRangeKeySpecifier = ('fromTime' | 'toTime' | AccommodationCatalogPropertyCheckInOutRangeKeySpecifier)[];
export type AccommodationCatalogPropertyCheckInOutRangeFieldPolicy = {
	fromTime?: FieldPolicy<any> | FieldReadFunction<any>,
	toTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogFacilityOrAmenityKeySpecifier = ('label' | AccommodationCatalogFacilityOrAmenityKeySpecifier)[];
export type AccommodationCatalogFacilityOrAmenityFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogLocationKeySpecifier = ('latitude' | 'longitude' | 'timezone' | AccommodationCatalogLocationKeySpecifier)[];
export type AccommodationCatalogLocationFieldPolicy = {
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPhotoKeySpecifier = ('photo' | 'subject' | 'thumbnailUrl' | 'url' | AccommodationCatalogPhotoKeySpecifier)[];
export type AccommodationCatalogPhotoFieldPolicy = {
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoKeySpecifier = ('altTag' | 'assetId' | 'blurHash' | 'collectionItems' | 'container' | 'currentUserIsOwner' | 'databaseUUID' | 'eventId' | 'exifMetadata' | 'fileSize' | 'firebasePath' | 'generatedSimpleTags' | 'height' | 'id' | 'layout' | 'likedByCurrentUser' | 'likes' | 'metaTags' | 'mimeType' | 'owner' | 'palette' | 'simpleTags' | 'size' | 'taggedVendorIds' | 'transform' | 'url' | 'user' | 'width' | PhotoKeySpecifier)[];
export type PhotoFieldPolicy = {
	altTag?: FieldPolicy<any> | FieldReadFunction<any>,
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	blurHash?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItems?: FieldPolicy<any> | FieldReadFunction<any>,
	container?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUserIsOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	databaseUUID?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	exifMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	fileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePath?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedSimpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	likedByCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	likes?: FieldPolicy<any> | FieldReadFunction<any>,
	metaTags?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	palette?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	taggedVendorIds?: FieldPolicy<any> | FieldReadFunction<any>,
	transform?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemKeySpecifier = ('collection' | 'currentUserIsOwner' | 'description' | 'id' | 'photo' | 'sortKey' | 'video' | CollectionItemKeySpecifier)[];
export type CollectionItemFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUserIsOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionKeySpecifier = ('currentUserIsOwner' | 'default' | 'description' | 'disabled' | 'eventMatch' | 'id' | 'isPhotoInCollection' | 'itemCount' | 'items' | 'name' | 'owner' | 'photoIds' | 'private' | 'vendor' | 'vendorCollectionGroup' | CollectionKeySpecifier)[];
export type CollectionFieldPolicy = {
	currentUserIsOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhotoInCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	photoIds?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCollectionGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventMatchKeySpecifier = ('budget' | 'collections' | 'contactList' | 'event' | 'id' | 'matches' | 'primaryVenue' | 'showcase' | 'vendorsInCollections' | 'vendorState' | EventMatchKeySpecifier)[];
export type EventMatchFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	contactList?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryVenue?: FieldPolicy<any> | FieldReadFunction<any>,
	showcase?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsInCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorState?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchKeySpecifier = ('archived' | 'eventMatch' | 'id' | 'isInContactList' | 'isInShowcase' | 'matchNote' | 'requestForProposal' | 'status' | 'testimony' | 'vendor' | 'vendorType' | MatchKeySpecifier)[];
export type MatchFieldPolicy = {
	archived?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInContactList?: FieldPolicy<any> | FieldReadFunction<any>,
	isInShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	matchNote?: FieldPolicy<any> | FieldReadFunction<any>,
	requestForProposal?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	testimony?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestForProposalKeySpecifier = ('budget' | 'collection' | 'eventDate' | 'fianceeFirstName' | 'id' | 'locked' | 'match' | 'message' | 'name' | 'ownerFirstName' | 'photosOfVendorFromCollections' | 'requestSentAt' | 'sentByUser' | 'vendor' | 'venue' | RequestForProposalKeySpecifier)[];
export type RequestForProposalFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fianceeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	match?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	photosOfVendorFromCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	requestSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sentByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	venue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateKeySpecifier = ('dateString' | 'milliseconds' | 'timestamp' | 'timezone' | 'unixTimestamp' | DateKeySpecifier)[];
export type DateFieldPolicy = {
	dateString?: FieldPolicy<any> | FieldReadFunction<any>,
	milliseconds?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	unixTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('activeAlias' | 'activeEventUserForEvent' | 'activeEventUsers' | 'aliases' | 'auth0Id' | 'avatar' | 'collections' | 'email' | 'emailIsVerified' | 'emailsSentBy' | 'eventUsers' | 'feedMessages' | 'firstName' | 'id' | 'idLegacy' | 'idReproducible' | 'lastName' | 'likedPhotos' | 'ownedEventMatch' | 'ownedPhotos' | 'photosTaggedIn' | 'superAdmin' | 'unreadFeedMessageCount' | 'vendorsOnLikedPhotos' | 'vendorUser' | 'vendorUsers' | 'vendorUsersV2' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	activeAlias?: FieldPolicy<any> | FieldReadFunction<any>,
	activeEventUserForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	activeEventUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	aliases?: FieldPolicy<any> | FieldReadFunction<any>,
	auth0Id?: FieldPolicy<any> | FieldReadFunction<any>,
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailIsVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	emailsSentBy?: FieldPolicy<any> | FieldReadFunction<any>,
	eventUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	feedMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idLegacy?: FieldPolicy<any> | FieldReadFunction<any>,
	idReproducible?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	likedPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	ownedEventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	ownedPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	photosTaggedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	superAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadFeedMessageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorsOnLikedPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUser?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUsersV2?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAliasKeySpecifier = ('auth0' | 'auth0Id' | 'createdAt' | 'email' | 'firstName' | 'id' | 'lastName' | 'mfaEnabled' | 'provider' | UserAliasKeySpecifier)[];
export type UserAliasFieldPolicy = {
	auth0?: FieldPolicy<any> | FieldReadFunction<any>,
	auth0Id?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventUserKeySpecifier = ('auth0Id' | 'event' | 'eventV0918' | 'id' | 'status' | 'user' | 'userId' | EventUserKeySpecifier)[];
export type EventUserFieldPolicy = {
	auth0Id?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventKeySpecifier = ('accommodationPlacesForDisplayLocation' | 'accommodationPlacesV2' | 'activeSession' | 'allLocationAnchors' | 'bestLocationAnchor' | 'checklist' | 'customThemes' | 'designFavorite' | 'domain' | 'emailsAssociatedWithEvent' | 'eventConfigJson' | 'eventConfigSchemaUrl' | 'eventConfigSubtype' | 'eventConfigType' | 'eventDesign' | 'eventId' | 'eventMatch' | 'eventOnboarding' | 'eventUsers' | 'featureFlags' | 'findPeople' | 'firebaseCreateAt' | 'firebaseCreateAtTimestamp' | 'firebaseId' | 'firebaseMobilePhotoPath' | 'firebasePhotoPath' | 'firebaseVideoPath' | 'guests' | 'hasMobilePhoto' | 'hasPhoto' | 'hotelRoomBlocks' | 'id' | 'info' | 'labels' | 'legacyRsvpQuestions' | 'media' | 'mediaCollections' | 'mediaInfo' | 'mobilePhoto' | 'pageContainers' | 'pageInfo' | 'pages' | 'pagesInfo' | 'photo' | 'photosTaggedIn' | 'photoV2Url' | 'photoV2UrlMobile' | 'places' | 'productVerticals' | 'published' | 'recommendation' | 'registry' | 'settings' | 'style' | 'suggestion' | 'themes' | 'travelSettings' | 'useLegacyGuestSite' | 'video' | 'vips' | 'website' | 'websiteState' | EventKeySpecifier)[];
export type EventFieldPolicy = {
	accommodationPlacesForDisplayLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	accommodationPlacesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	activeSession?: FieldPolicy<any> | FieldReadFunction<any>,
	allLocationAnchors?: FieldPolicy<any> | FieldReadFunction<any>,
	bestLocationAnchor?: FieldPolicy<any> | FieldReadFunction<any>,
	checklist?: FieldPolicy<any> | FieldReadFunction<any>,
	customThemes?: FieldPolicy<any> | FieldReadFunction<any>,
	designFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	emailsAssociatedWithEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	eventConfigJson?: FieldPolicy<any> | FieldReadFunction<any>,
	eventConfigSchemaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	eventConfigSubtype?: FieldPolicy<any> | FieldReadFunction<any>,
	eventConfigType?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	eventOnboarding?: FieldPolicy<any> | FieldReadFunction<any>,
	eventUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	featureFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	findPeople?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseCreateAt?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseCreateAtTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseId?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseMobilePhotoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePhotoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseVideoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	guests?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMobilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomBlocks?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>,
	labels?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyRsvpQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	mobilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	pageContainers?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>,
	pagesInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photosTaggedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	photoV2Url?: FieldPolicy<any> | FieldReadFunction<any>,
	photoV2UrlMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	places?: FieldPolicy<any> | FieldReadFunction<any>,
	productVerticals?: FieldPolicy<any> | FieldReadFunction<any>,
	published?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendation?: FieldPolicy<any> | FieldReadFunction<any>,
	registry?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	style?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestion?: FieldPolicy<any> | FieldReadFunction<any>,
	themes?: FieldPolicy<any> | FieldReadFunction<any>,
	travelSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	useLegacyGuestSite?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>,
	vips?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteState?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlaceV2KeySpecifier = ('accommodationRoomBlock' | 'address' | 'autoSuggestionRecommendation' | 'category' | 'city' | 'country' | 'createdByType' | 'customAddress' | 'customName' | 'customPhone' | 'customPhoto' | 'customStarRating' | 'customUrl' | 'description' | 'displayLocation' | 'distances' | 'email' | 'eventId' | 'externalPDP' | 'googlePlaceId' | 'id' | 'isCustomLinkEnabled' | 'isFavorite' | 'isFromAccommodationCatalog' | 'isHostStayingHere' | 'isPhotoHidden' | 'joyPlaceId' | 'lat' | 'layoutType' | 'long' | 'name' | 'nuiteeId' | 'phone' | 'photo' | 'postalCode' | 'redirectMechanism' | 'starRating' | 'state' | 'type' | 'updatedByType' | 'url' | 'userNote' | 'userRating' | 'zhId' | AccommodationPlaceV2KeySpecifier)[];
export type AccommodationPlaceV2FieldPolicy = {
	accommodationRoomBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	autoSuggestionRecommendation?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByType?: FieldPolicy<any> | FieldReadFunction<any>,
	customAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	customName?: FieldPolicy<any> | FieldReadFunction<any>,
	customPhone?: FieldPolicy<any> | FieldReadFunction<any>,
	customPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	customStarRating?: FieldPolicy<any> | FieldReadFunction<any>,
	customUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	distances?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalPDP?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustomLinkEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	isFromAccommodationCatalog?: FieldPolicy<any> | FieldReadFunction<any>,
	isHostStayingHere?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhotoHidden?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutType?: FieldPolicy<any> | FieldReadFunction<any>,
	long?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nuiteeId?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanism?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	userNote?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>,
	zhId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlaceRoomBlockKeySpecifier = ('bookingUrl' | 'checkInDate' | 'checkOutDate' | 'currencyCode' | 'cutoffDate' | 'interestedGuestCount' | 'isJoyManagedRoomBlock' | 'numberOfRoomsReserved' | 'pricePerNight' | 'status' | 'strikeoutPricePerNight' | AccommodationPlaceRoomBlockKeySpecifier)[];
export type AccommodationPlaceRoomBlockFieldPolicy = {
	bookingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	checkInDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOutDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	cutoffDate?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedGuestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isJoyManagedRoomBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRoomsReserved?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerNight?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutPricePerNight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlaceRecommendationKeySpecifier = ('eventId' | 'geoDistanceFromSearchLocation' | 'highlightTags' | 'id' | 'joyPlace' | 'pricingInfoSnapshot' | 'proposedNoteFromHostToGuest' | 'standardRoomPriceDiscountPercent' | 'status' | 'userRating' | 'venueGooglePlaceId' | 'whyThisHotelIsAGreatPick' | AccommodationPlaceRecommendationKeySpecifier)[];
export type AccommodationPlaceRecommendationFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	geoDistanceFromSearchLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	highlightTags?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingInfoSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedNoteFromHostToGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRoomPriceDiscountPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>,
	venueGooglePlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	whyThisHotelIsAGreatPick?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistanceInfoKeySpecifier = ('km' | 'mi' | DistanceInfoKeySpecifier)[];
export type DistanceInfoFieldPolicy = {
	km?: FieldPolicy<any> | FieldReadFunction<any>,
	mi?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JoyPlaceKeySpecifier = ('address' | 'city' | 'country' | 'description' | 'email' | 'googlePlaceId' | 'id' | 'lat' | 'long' | 'name' | 'nuiteeId' | 'phone' | 'photo' | 'postalCode' | 'redirectMechanism' | 'starRating' | 'state' | 'url' | 'userRating' | 'zhId' | JoyPlaceKeySpecifier)[];
export type JoyPlaceFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	long?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nuiteeId?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanism?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>,
	zhId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RedirectMechanismKeySpecifier = ('telemetryDestinationName' | 'trackingQueryStringKey' | 'type' | 'url' | RedirectMechanismKeySpecifier)[];
export type RedirectMechanismFieldPolicy = {
	telemetryDestinationName?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingQueryStringKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRatingKeySpecifier = ('ratingCount' | 'ratingValue' | UserRatingKeySpecifier)[];
export type UserRatingFieldPolicy = {
	ratingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPropertyPricingV2KeySpecifier = ('baseRate' | 'fees' | 'nightlyBaseRate' | 'nightlyTotalRate' | 'perNightPerOccupancyBaseAmount' | 'perNightPerOccupancyStrikeoutBaseAmount' | 'perNightPerOccupancyTotalAmount' | 'strikeoutBaseRate' | 'strikeoutNightlyBaseRate' | 'strikeoutNightlyTotalRate' | 'strikeoutRateProvider' | 'strikeoutTotalRate' | 'totalRate' | TravelPropertyPricingV2KeySpecifier)[];
export type TravelPropertyPricingV2FieldPolicy = {
	baseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyStrikeoutBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutRateProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelMonetaryValueV2KeySpecifier = ('currency' | 'digits' | 'valueInMinorUnits' | TravelMonetaryValueV2KeySpecifier)[];
export type TravelMonetaryValueV2FieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	digits?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferFeeV2KeySpecifier = ('amount' | 'isIncludedInTotal' | 'rate' | 'type' | 'visibility' | TravelOfferFeeV2KeySpecifier)[];
export type TravelOfferFeeV2FieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncludedInTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelDistancesBetweenPointsResponseKeySpecifier = ('commonDistance' | TravelDistancesBetweenPointsResponseKeySpecifier)[];
export type TravelDistancesBetweenPointsResponseFieldPolicy = {
	commonDistance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelDistanceBetweenPointsKeySpecifier = ('durationMinutes' | 'km' | 'mi' | 'type' | TravelDistanceBetweenPointsKeySpecifier)[];
export type TravelDistanceBetweenPointsFieldPolicy = {
	durationMinutes?: FieldPolicy<any> | FieldReadFunction<any>,
	km?: FieldPolicy<any> | FieldReadFunction<any>,
	mi?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalPDPKeySpecifier = ('provider' | 'url' | ExternalPDPKeySpecifier)[];
export type ExternalPDPFieldPolicy = {
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSessionKeySpecifier = ('canAccessPage' | 'event' | 'eventCTA' | 'eventUser' | 'guestKey' | 'hasIdentity' | 'hasUnlocked' | 'id' | 'isLoggedInWithAuth0' | 'isLoggedOut' | 'person' | 'personIdTag' | 'sessionId' | 'status' | EventSessionKeySpecifier)[];
export type EventSessionFieldPolicy = {
	canAccessPage?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCTA?: FieldPolicy<any> | FieldReadFunction<any>,
	eventUser?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	hasIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isLoggedInWithAuth0?: FieldPolicy<any> | FieldReadFunction<any>,
	isLoggedOut?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	personIdTag?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSessionCTAKeySpecifier = ('label' | 'prompt' | 'requiresPassword' | 'rsvpAttendanceStatus' | 'rsvpIsCompleted' | 'rsvpIsEnabled' | 'scheduleHasInviteOnlyItems' | 'virtualScheduleItemNow' | EventSessionCTAKeySpecifier)[];
export type EventSessionCTAFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpAttendanceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpIsCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpIsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleHasInviteOnlyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualScheduleItemNow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventScheduleKeySpecifier = ('description' | 'dressCode' | 'endTime' | 'endTimeISO8601TZ' | 'endTimeV0918' | 'event' | 'guests' | 'id' | 'isHappeningNow' | 'isMain' | 'isPublic' | 'location' | 'locationInfo' | 'name' | 'placeId' | 'showMap' | 'startTime' | 'startTimeISO8601TZ' | 'startTimeV0918' | 'timezone' | 'unplugged' | 'virtualEventLink' | EventScheduleKeySpecifier)[];
export type EventScheduleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dressCode?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endTimeISO8601TZ?: FieldPolicy<any> | FieldReadFunction<any>,
	endTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	guests?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isHappeningNow?: FieldPolicy<any> | FieldReadFunction<any>,
	isMain?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	showMap?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTimeISO8601TZ?: FieldPolicy<any> | FieldReadFunction<any>,
	startTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	unplugged?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualEventLink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventScheduleGuestsKeySpecifier = ('invitedLabelCount' | 'invitedLabels' | 'invitedPeople' | 'invitedPeopleCount' | 'isInviteOnly' | 'item' | 'people' | 'peopleCount' | EventScheduleGuestsKeySpecifier)[];
export type EventScheduleGuestsFieldPolicy = {
	invitedLabelCount?: FieldPolicy<any> | FieldReadFunction<any>,
	invitedLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	invitedPeople?: FieldPolicy<any> | FieldReadFunction<any>,
	invitedPeopleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isInviteOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	people?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventLabelKeySpecifier = ('display' | 'event' | 'id' | 'people' | 'peopleCount' | 'scheduleItemCount' | 'scheduleItems' | EventLabelKeySpecifier)[];
export type EventLabelFieldPolicy = {
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	people?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonKeySpecifier = ('address' | 'auth0Id' | 'avatar' | 'avatarName' | 'email' | 'emailsSentTo' | 'envelopeName' | 'event' | 'firstName' | 'fullName' | 'guestStates' | 'hasEmail' | 'hasName' | 'household' | 'id' | 'isGuest' | 'isHeadOfHousehold' | 'labelCount' | 'labels' | 'lastName' | 'legacyRsvpAnswers' | 'personIdTag' | 'phoneDisplay' | 'phoneE164' | 'scheduleItemCount' | 'scheduleItems' | PersonKeySpecifier)[];
export type PersonFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	auth0Id?: FieldPolicy<any> | FieldReadFunction<any>,
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailsSentTo?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopeName?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	guestStates?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	hasName?: FieldPolicy<any> | FieldReadFunction<any>,
	household?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	isHeadOfHousehold?: FieldPolicy<any> | FieldReadFunction<any>,
	labelCount?: FieldPolicy<any> | FieldReadFunction<any>,
	labels?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyRsvpAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	personIdTag?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneE164?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InviteeLocationOutputKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'postalCode' | 'state' | InviteeLocationOutputKeySpecifier)[];
export type InviteeLocationOutputFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailKeySpecifier = ('createdDate' | 'createdDateV0918' | 'id' | 'mainContent' | 'messageBatchId' | 'messageId' | 'personSentTo' | 'photo' | 'status' | 'statusHistory' | 'subject' | 'toEmail' | EmailKeySpecifier)[];
export type EmailFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDateV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mainContent?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageId?: FieldPolicy<any> | FieldReadFunction<any>,
	personSentTo?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	toEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailStatusKeySpecifier = ('description' | 'message' | 'status' | 'timestamp' | EmailStatusKeySpecifier)[];
export type EmailStatusFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HouseholdKeySpecifier = ('event' | 'headOfHousehold' | 'householdTag' | 'id' | 'memberCount' | 'members' | HouseholdKeySpecifier)[];
export type HouseholdFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	headOfHousehold?: FieldPolicy<any> | FieldReadFunction<any>,
	householdTag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	memberCount?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyRsvpAnswerKeySpecifier = ('answer' | 'questionId' | LegacyRsvpAnswerKeySpecifier)[];
export type LegacyRsvpAnswerFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	questionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventLocationKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'id' | 'latitude' | 'longitude' | 'name' | 'placeId' | 'postalCode' | 'state' | EventLocationKeySpecifier)[];
export type EventLocationFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationInterfaceKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'latitude' | 'longitude' | 'name' | 'placeId' | 'postalCode' | 'state' | LocationInterfaceKeySpecifier)[];
export type LocationInterfaceFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VirtualEventLinkParseResultKeySpecifier = ('isLinkValid' | 'isPasswordDetected' | 'linkText' | 'passwordText' | 'passwordUrlEmbed' | 'provider' | 'streamId' | 'urlApp' | 'urlBrowser' | 'urlLinkText' | VirtualEventLinkParseResultKeySpecifier)[];
export type VirtualEventLinkParseResultFieldPolicy = {
	isLinkValid?: FieldPolicy<any> | FieldReadFunction<any>,
	isPasswordDetected?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordText?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordUrlEmbed?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	streamId?: FieldPolicy<any> | FieldReadFunction<any>,
	urlApp?: FieldPolicy<any> | FieldReadFunction<any>,
	urlBrowser?: FieldPolicy<any> | FieldReadFunction<any>,
	urlLinkText?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationAnchorKeySpecifier = ('friendlyName' | 'googlePlaceID' | 'latitude' | 'longitude' | 'source' | LocationAnchorKeySpecifier)[];
export type LocationAnchorFieldPolicy = {
	friendlyName?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceID?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventChecklistKeySpecifier = ('createdAt' | 'event' | 'eventId' | 'id' | 'items' | 'title' | 'updatedAt' | EventChecklistKeySpecifier)[];
export type EventChecklistFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChecklistItemKeySpecifier = ('action' | 'completedAt' | 'createdAt' | 'id' | 'reminderAt' | 'subItems' | 'subtitle' | 'title' | 'updatedAt' | ChecklistItemKeySpecifier)[];
export type ChecklistItemFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reminderAt?: FieldPolicy<any> | FieldReadFunction<any>,
	subItems?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitle?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChecklistSubItemKeySpecifier = ('action' | 'completedAt' | 'createdAt' | 'icon' | 'id' | 'title' | 'updatedAt' | ChecklistSubItemKeySpecifier)[];
export type ChecklistSubItemFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomThemeKeySpecifier = ('description' | 'desktopThemeAsset' | 'eventId' | 'id' | 'mobileThemeAsset' | 'name' | CustomThemeKeySpecifier)[];
export type CustomThemeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	desktopThemeAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileThemeAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomThemeAssetKeySpecifier = ('assetURL' | 'eventId' | 'id' | 'meta' | CustomThemeAssetKeySpecifier)[];
export type CustomThemeAssetFieldPolicy = {
	assetURL?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignFavoriteKeySpecifier = ('id' | 'resource' | 'resourceId' | 'secondaryResource' | 'secondaryResourceId' | 'type' | DesignFavoriteKeySpecifier)[];
export type DesignFavoriteFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	resource?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryResource?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryResourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignLayoutKeySpecifier = ('id' | 'layoutType' | 'name' | 'themes' | DesignLayoutKeySpecifier)[];
export type DesignLayoutFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	themes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThemeKeySpecifier = ('colorSchemes' | 'description' | 'designBuckets' | 'designLayouts' | 'expiration' | 'id' | 'index' | 'marketingData' | 'name' | 'printProviders' | 'supportsEcards' | 'supportsPrints' | 'themeId' | 'themePreferences' | 'thumbnailUrl' | 'websiteLayoutAlohaSettings' | 'websiteLayoutBrannanSettings' | ThemeKeySpecifier)[];
export type ThemeFieldPolicy = {
	colorSchemes?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	designBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	designLayouts?: FieldPolicy<any> | FieldReadFunction<any>,
	expiration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	printProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsEcards?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsPrints?: FieldPolicy<any> | FieldReadFunction<any>,
	themeId?: FieldPolicy<any> | FieldReadFunction<any>,
	themePreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayoutAlohaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayoutBrannanSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThemeColorSchemeKeySpecifier = ('colors' | 'id' | ThemeColorSchemeKeySpecifier)[];
export type ThemeColorSchemeFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColorKeySpecifier = ('hex' | 'isLight' | 'rgba' | ColorKeySpecifier)[];
export type ColorFieldPolicy = {
	hex?: FieldPolicy<any> | FieldReadFunction<any>,
	isLight?: FieldPolicy<any> | FieldReadFunction<any>,
	rgba?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignBucketKeySpecifier = ('bucketId' | 'display' | 'fonts' | 'id' | 'themes' | DesignBucketKeySpecifier)[];
export type DesignBucketFieldPolicy = {
	bucketId?: FieldPolicy<any> | FieldReadFunction<any>,
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	fonts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	themes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FontKeySpecifier = ('calculatedFontSize' | 'designBuckets' | 'display' | 'firebaseFontKey' | 'fontFamily' | 'fontSize' | 'fontWeight' | 'id' | 'textTransform' | 'typeface' | FontKeySpecifier)[];
export type FontFieldPolicy = {
	calculatedFontSize?: FieldPolicy<any> | FieldReadFunction<any>,
	designBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseFontKey?: FieldPolicy<any> | FieldReadFunction<any>,
	fontFamily?: FieldPolicy<any> | FieldReadFunction<any>,
	fontSize?: FieldPolicy<any> | FieldReadFunction<any>,
	fontWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	textTransform?: FieldPolicy<any> | FieldReadFunction<any>,
	typeface?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThemeMarketingDataKeySpecifier = ('colors' | 'featured' | 'font' | 'imageUrl' | 'printUrl' | 'tags' | 'theme' | 'variantColor' | 'variantName' | 'variantThemeId' | 'variationType' | 'vendor' | ThemeMarketingDataKeySpecifier)[];
export type ThemeMarketingDataFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	printUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>,
	variantColor?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>,
	variantThemeId?: FieldPolicy<any> | FieldReadFunction<any>,
	variationType?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrintProviderThemeKeySpecifier = ('id' | 'printUrl' | 'provider' | 'stockPreviewUrl' | 'theme' | PrintProviderThemeKeySpecifier)[];
export type PrintProviderThemeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	printUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	stockPreviewUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrintProviderKeySpecifier = ('id' | 'logoUrl' | 'name' | 'themes' | 'website' | PrintProviderKeySpecifier)[];
export type PrintProviderFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	themes?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignPreferenceKeySpecifier = ('featureName' | 'featureValueType' | 'id' | DesignPreferenceKeySpecifier)[];
export type DesignPreferenceFieldPolicy = {
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutAlohaSettingsKeySpecifier = ('alohaColorPreference' | 'alohaTextColorPreference' | WebsiteLayoutAlohaSettingsKeySpecifier)[];
export type WebsiteLayoutAlohaSettingsFieldPolicy = {
	alohaColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	alohaTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutAlohaOptionsKeySpecifier = ('alohaColorPreference' | WebsiteLayoutAlohaOptionsKeySpecifier)[];
export type WebsiteLayoutAlohaOptionsFieldPolicy = {
	alohaColorPreference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignPreferenceColorKeySpecifier = ('colorValue' | 'featureName' | 'featureValueType' | 'id' | 'supportsCustomization' | DesignPreferenceColorKeySpecifier)[];
export type DesignPreferenceColorFieldPolicy = {
	colorValue?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsCustomization?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutBrannanSettingsKeySpecifier = ('brannanBackgroundTransparency' | 'brannanColorPreference' | 'brannanInnerFrameBorder' | 'brannanTextColorPreference' | WebsiteLayoutBrannanSettingsKeySpecifier)[];
export type WebsiteLayoutBrannanSettingsFieldPolicy = {
	brannanBackgroundTransparency?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanInnerFrameBorder?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutBrannanOptionsKeySpecifier = ('brannanBackgroundTransparency' | 'brannanColorPreference' | 'brannanInnerFrameBorder' | WebsiteLayoutBrannanOptionsKeySpecifier)[];
export type WebsiteLayoutBrannanOptionsFieldPolicy = {
	brannanBackgroundTransparency?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanInnerFrameBorder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignPreferenceRangeKeySpecifier = ('featureName' | 'featureValueType' | 'id' | 'rangeMax' | 'rangeMin' | 'rangeStep' | 'rangeValue' | 'supportsCustomization' | DesignPreferenceRangeKeySpecifier)[];
export type DesignPreferenceRangeFieldPolicy = {
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeStep?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsCustomization?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignPreferenceBooleanKeySpecifier = ('booleanValue' | 'featureName' | 'featureValueType' | 'id' | 'supportsCustomization' | DesignPreferenceBooleanKeySpecifier)[];
export type DesignPreferenceBooleanFieldPolicy = {
	booleanValue?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsCustomization?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDomainKeySpecifier = ('domainName' | 'event' | 'id' | EventDomainKeySpecifier)[];
export type EventDomainFieldPolicy = {
	domainName?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDesignKeySpecifier = ('accent' | 'activeWebsiteHeaderPresentationLayout' | 'artBackgroundColor' | 'artFontColor' | 'brannanNavigation' | 'colorPalette' | 'customCss' | 'customTheme' | 'designPhoto' | 'designPreferences' | 'event' | 'font' | 'fonts' | 'guestSiteTarget' | 'hasUnpublishedChanges' | 'hasVisitedDesignPage' | 'id' | 'linkAndButtonColor' | 'pageBackgroundColor' | 'pageFontColor' | 'primaryTextColor' | 'purpose' | 'selectedThemeColorScheme' | 'theme' | 'useCustomTheme' | 'websiteLayout' | 'websiteLayoutAlohaPreferences' | 'websiteLayoutBrannanPreferences' | EventDesignKeySpecifier)[];
export type EventDesignFieldPolicy = {
	accent?: FieldPolicy<any> | FieldReadFunction<any>,
	activeWebsiteHeaderPresentationLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	artBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	artFontColor?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanNavigation?: FieldPolicy<any> | FieldReadFunction<any>,
	colorPalette?: FieldPolicy<any> | FieldReadFunction<any>,
	customCss?: FieldPolicy<any> | FieldReadFunction<any>,
	customTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	designPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	designPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	fonts?: FieldPolicy<any> | FieldReadFunction<any>,
	guestSiteTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnpublishedChanges?: FieldPolicy<any> | FieldReadFunction<any>,
	hasVisitedDesignPage?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAndButtonColor?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFontColor?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedThemeColorScheme?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>,
	useCustomTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayoutAlohaPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayoutBrannanPreferences?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteHeaderPresentationSettingsKeySpecifier = ('dataJSON' | 'eventId' | 'schemaURL' | 'websiteLayout' | WebsiteHeaderPresentationSettingsKeySpecifier)[];
export type WebsiteHeaderPresentationSettingsFieldPolicy = {
	dataJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaURL?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLayout?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ColorSetKeySpecifier = ('color' | 'id' | ColorSetKeySpecifier)[];
export type ColorSetFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDesignPreferenceBooleanKeySpecifier = ('booleanValue' | 'featureId' | 'featureName' | 'featureType' | 'featureValueType' | 'id' | EventDesignPreferenceBooleanKeySpecifier)[];
export type EventDesignPreferenceBooleanFieldPolicy = {
	booleanValue?: FieldPolicy<any> | FieldReadFunction<any>,
	featureId?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureType?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDesignPreferenceColorPointerKeySpecifier = ('colorPointer' | 'colorPointerPosition' | 'featureName' | 'featureType' | 'featureValueType' | 'id' | EventDesignPreferenceColorPointerKeySpecifier)[];
export type EventDesignPreferenceColorPointerFieldPolicy = {
	colorPointer?: FieldPolicy<any> | FieldReadFunction<any>,
	colorPointerPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureType?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDesignPreferenceRangeKeySpecifier = ('featureId' | 'featureName' | 'featureType' | 'featureValueType' | 'id' | 'rangeValue' | EventDesignPreferenceRangeKeySpecifier)[];
export type EventDesignPreferenceRangeFieldPolicy = {
	featureId?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureType?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rangeValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FontPackConfigurationKeySpecifier = ('category' | 'font' | 'id' | 'size' | 'sizePercent' | FontPackConfigurationKeySpecifier)[];
export type FontPackConfigurationFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	sizePercent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutAlohaPreferencesKeySpecifier = ('alohaColorPreference' | 'alohaTextColorPreference' | WebsiteLayoutAlohaPreferencesKeySpecifier)[];
export type WebsiteLayoutAlohaPreferencesFieldPolicy = {
	alohaColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	alohaTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDesignPreferenceColorKeySpecifier = ('colorValue' | 'featureId' | 'featureName' | 'featureType' | 'featureValueType' | 'id' | EventDesignPreferenceColorKeySpecifier)[];
export type EventDesignPreferenceColorFieldPolicy = {
	colorValue?: FieldPolicy<any> | FieldReadFunction<any>,
	featureId?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureType?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsiteLayoutBrannanPreferencesKeySpecifier = ('brannanBackgroundTransparency' | 'brannanColorPreference' | 'brannanInnerFrameBorder' | 'brannanTextColorPreference' | WebsiteLayoutBrannanPreferencesKeySpecifier)[];
export type WebsiteLayoutBrannanPreferencesFieldPolicy = {
	brannanBackgroundTransparency?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanInnerFrameBorder?: FieldPolicy<any> | FieldReadFunction<any>,
	brannanTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventOnboardingKeySpecifier = ('event' | 'shouldShowOnboardingSurvey' | EventOnboardingKeySpecifier)[];
export type EventOnboardingFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	shouldShowOnboardingSurvey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PeopleFindResultSetKeySpecifier = ('bestResult' | 'needsMoreCriteria' | 'resultCount' | 'results' | 'strategy' | PeopleFindResultSetKeySpecifier)[];
export type PeopleFindResultSetFieldPolicy = {
	bestResult?: FieldPolicy<any> | FieldReadFunction<any>,
	needsMoreCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	resultCount?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PeopleFindResultKeySpecifier = ('person' | 'score' | PeopleFindResultKeySpecifier)[];
export type PeopleFindResultFieldPolicy = {
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventGuestsKeySpecifier = ('householdCount' | 'households' | 'people' | 'peopleCount' | EventGuestsKeySpecifier)[];
export type EventGuestsFieldPolicy = {
	householdCount?: FieldPolicy<any> | FieldReadFunction<any>,
	households?: FieldPolicy<any> | FieldReadFunction<any>,
	people?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomBlocksKeySpecifier = ('AnyOtherDetails' | 'availablePerks' | 'bookingLink' | 'checkIn' | 'checkOut' | 'concierge' | 'destination' | 'email' | 'event' | 'eventDisplayName' | 'fullName' | 'id' | 'leadState' | 'leadStateV2' | 'leadStateV2UpdatedAt' | 'numberOfRooms' | 'permissionToEmailGuests' | 'PreferredContactMethod' | 'reservedRoomBlocks' | 'secondaryEmail' | 'submittedDateTime' | HotelRoomBlocksKeySpecifier)[];
export type HotelRoomBlocksFieldPolicy = {
	AnyOtherDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	availablePerks?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingLink?: FieldPolicy<any> | FieldReadFunction<any>,
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	concierge?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leadState?: FieldPolicy<any> | FieldReadFunction<any>,
	leadStateV2?: FieldPolicy<any> | FieldReadFunction<any>,
	leadStateV2UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRooms?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionToEmailGuests?: FieldPolicy<any> | FieldReadFunction<any>,
	PreferredContactMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	reservedRoomBlocks?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedDateTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnerDetailsKeySpecifier = ('email' | 'name' | 'photo' | OwnerDetailsKeySpecifier)[];
export type OwnerDetailsFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadDestinationKeySpecifier = ('address' | 'address2' | 'lat' | 'long' | 'name' | 'postalCode' | LeadDestinationKeySpecifier)[];
export type LeadDestinationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	long?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReservedRoomBlocksKeySpecifier = ('address' | 'bookingUrl' | 'checkInDate' | 'checkOutDate' | 'cutoffDate' | 'displayName' | 'hiddenForGuests' | 'hotelMoreInfoUrl' | 'hotelRoomBlocks' | 'id' | 'interestedGuestCount' | 'isFavorite' | 'latitude' | 'longitude' | 'note' | 'numberOfNightsBooked' | 'numberOfNightsGuestBooked' | 'numberOfRoomsBooked' | 'numberOfRoomsGuestBooked' | 'photo' | 'pricePerNight' | 'starRating' | 'status' | 'strikeoutPricePerNight' | ReservedRoomBlocksKeySpecifier)[];
export type ReservedRoomBlocksFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	checkInDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOutDate?: FieldPolicy<any> | FieldReadFunction<any>,
	cutoffDate?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	hiddenForGuests?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelMoreInfoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomBlocks?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedGuestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfNightsBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfNightsGuestBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRoomsBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRoomsGuestBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerNight?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutPricePerNight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventInfoKeySpecifier = ('announcementBanner' | 'date' | 'dateV0918' | 'event' | 'eventDateIsFinalized' | 'eventDisplayName' | 'eventId' | 'eventMonogram' | 'eventPassword' | 'eventSecret' | 'eventType' | 'fianceeFirstName' | 'fianceeFullName' | 'fianceeLastName' | 'finalizedDate' | 'greeting' | 'hasSentEmails' | 'id' | 'locale' | 'location' | 'locationInfo' | 'ownerFirstName' | 'ownerFullName' | 'ownerLastName' | 'placeId' | 'qanda' | 'registry' | 'safetyRating' | 'schedule' | 'story' | 'tentativeDate' | 'timezone' | 'travel' | EventInfoKeySpecifier)[];
export type EventInfoFieldPolicy = {
	announcementBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dateV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDateIsFinalized?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMonogram?: FieldPolicy<any> | FieldReadFunction<any>,
	eventPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	eventSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	fianceeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fianceeFullName?: FieldPolicy<any> | FieldReadFunction<any>,
	fianceeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	finalizedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	greeting?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSentEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerFullName?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	qanda?: FieldPolicy<any> | FieldReadFunction<any>,
	registry?: FieldPolicy<any> | FieldReadFunction<any>,
	safetyRating?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	story?: FieldPolicy<any> | FieldReadFunction<any>,
	tentativeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	travel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventAnnouncementBannerKeySpecifier = ('active' | 'message' | 'title' | EventAnnouncementBannerKeySpecifier)[];
export type EventAnnouncementBannerFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventQandaKeySpecifier = ('answer' | 'category' | 'event' | 'id' | 'question' | 'sampleQuestionId' | 'type' | EventQandaKeySpecifier)[];
export type EventQandaFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryKeySpecifier = ('cannotSync' | 'draftItems' | 'event' | 'hasItems' | 'id' | 'imageUrl' | 'imageUrlV0204' | 'isStandalonesType' | 'isSyncingType' | 'isTransferredType' | 'items' | 'itemsCount' | 'lastSyncAt' | 'myOrders' | 'myPurchasedOrders' | 'myReservedOrders' | 'mySession' | 'name' | 'nameV0204' | 'orders' | 'photo' | 'purchasedOrders' | 'recommendationStatus' | 'reservedOrders' | 'storeName' | 'transferredRegistryData' | 'type' | 'url' | 'urlV0204' | 'wantSync' | RegistryKeySpecifier)[];
export type RegistryFieldPolicy = {
	cannotSync?: FieldPolicy<any> | FieldReadFunction<any>,
	draftItems?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	hasItems?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrlV0204?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandalonesType?: FieldPolicy<any> | FieldReadFunction<any>,
	isSyncingType?: FieldPolicy<any> | FieldReadFunction<any>,
	isTransferredType?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSyncAt?: FieldPolicy<any> | FieldReadFunction<any>,
	myOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	myPurchasedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	myReservedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	mySession?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nameV0204?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	reservedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	storeName?: FieldPolicy<any> | FieldReadFunction<any>,
	transferredRegistryData?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urlV0204?: FieldPolicy<any> | FieldReadFunction<any>,
	wantSync?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemKeySpecifier = ('alreadyPurchased' | 'alreadyReserved' | 'canDelete' | 'canEditProductData' | 'canEditRegistryData' | 'canned' | 'createAt' | 'custom' | 'donationFund' | 'externallyOwned' | 'fpIndex' | 'id' | 'isGetCashEquivalent' | 'isGroupGiftingEnabled' | 'isHidden' | 'mustHave' | 'note' | 'photo' | 'product' | 'productData' | 'productId' | 'recommendationStatus' | 'registry' | 'stillNeeded' | 'storeName' | 'totalRequested' | 'url' | RegistryItemKeySpecifier)[];
export type RegistryItemFieldPolicy = {
	alreadyPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	alreadyReserved?: FieldPolicy<any> | FieldReadFunction<any>,
	canDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	canEditProductData?: FieldPolicy<any> | FieldReadFunction<any>,
	canEditRegistryData?: FieldPolicy<any> | FieldReadFunction<any>,
	canned?: FieldPolicy<any> | FieldReadFunction<any>,
	createAt?: FieldPolicy<any> | FieldReadFunction<any>,
	custom?: FieldPolicy<any> | FieldReadFunction<any>,
	donationFund?: FieldPolicy<any> | FieldReadFunction<any>,
	externallyOwned?: FieldPolicy<any> | FieldReadFunction<any>,
	fpIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGetCashEquivalent?: FieldPolicy<any> | FieldReadFunction<any>,
	isGroupGiftingEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isHidden?: FieldPolicy<any> | FieldReadFunction<any>,
	mustHave?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productData?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	registry?: FieldPolicy<any> | FieldReadFunction<any>,
	stillNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	storeName?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CannedRegistryItemKeySpecifier = ('photos' | 'price' | 'title' | CannedRegistryItemKeySpecifier)[];
export type CannedRegistryItemFieldPolicy = {
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoSummaryKeySpecifier = ('url' | PhotoSummaryKeySpecifier)[];
export type PhotoSummaryFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MonetaryValueKeySpecifier = ('currency' | 'floatingPointDecimalString' | 'valueInMinorUnits' | MonetaryValueKeySpecifier)[];
export type MonetaryValueFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	floatingPointDecimalString?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyKeySpecifier = ('code' | 'places' | CurrencyKeySpecifier)[];
export type CurrencyFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	places?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomItemDataKeySpecifier = ('photos' | 'price' | 'title' | 'type' | 'url' | CustomItemDataKeySpecifier)[];
export type CustomItemDataFieldPolicy = {
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DonationFundKeySpecifier = ('amountTillGoalIsReached' | 'currency' | 'description' | 'donations' | 'donationsAreCapped' | 'enableAppPlatform' | 'enableCashOrCheck' | 'enableJoyCredit' | 'enforceSuggestedDonationAmount' | 'feePaidBy' | 'fpIndex' | 'fundType' | 'goalMonetaryValue' | 'hideFundingGoal' | 'id' | 'isHidden' | 'mustHave' | 'photos' | 'platform' | 'progressToGoal' | 'progressToGoalPercent' | 'registryItem' | 'suggestedDonationMonetaryValue' | 'suggestedQuantity' | 'suggestedQuantityReceived' | 'suggestedQuantityStillNeeded' | 'title' | 'url' | DonationFundKeySpecifier)[];
export type DonationFundFieldPolicy = {
	amountTillGoalIsReached?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	donations?: FieldPolicy<any> | FieldReadFunction<any>,
	donationsAreCapped?: FieldPolicy<any> | FieldReadFunction<any>,
	enableAppPlatform?: FieldPolicy<any> | FieldReadFunction<any>,
	enableCashOrCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	enableJoyCredit?: FieldPolicy<any> | FieldReadFunction<any>,
	enforceSuggestedDonationAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	feePaidBy?: FieldPolicy<any> | FieldReadFunction<any>,
	fpIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	fundType?: FieldPolicy<any> | FieldReadFunction<any>,
	goalMonetaryValue?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFundingGoal?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isHidden?: FieldPolicy<any> | FieldReadFunction<any>,
	mustHave?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	progressToGoal?: FieldPolicy<any> | FieldReadFunction<any>,
	progressToGoalPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedDonationMonetaryValue?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedQuantityReceived?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedQuantityStillNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCurrencyKeySpecifier = ('code' | 'countries' | 'displayName' | 'id' | 'isDefault' | 'places' | 'rank' | RegistryCurrencyKeySpecifier)[];
export type RegistryCurrencyFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	places?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCountryKeySpecifier = ('code' | 'name' | 'rank' | RegistryCountryKeySpecifier)[];
export type RegistryCountryFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	rank?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DonationFundDonationKeySpecifier = ('amount' | 'email' | 'fund' | 'id' | 'name' | 'note' | 'orderedAt' | 'platformType' | DonationFundDonationKeySpecifier)[];
export type DonationFundDonationFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fund?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	platformType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DonationFundPlatformKeySpecifier = ('id' | 'info' | 'link' | 'name' | 'type' | 'username' | DonationFundPlatformKeySpecifier)[];
export type DonationFundPlatformFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DonationFundInfoKeySpecifier = ('defaultPlatform' | 'defaultSuggestedDonationMonetaryValue' | 'event' | 'items' | 'platforms' | DonationFundInfoKeySpecifier)[];
export type DonationFundInfoFieldPolicy = {
	defaultPlatform?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultSuggestedDonationMonetaryValue?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	platforms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('canonicalUrl' | 'description' | 'id' | 'listPrice' | 'photos' | 'photos_march2021' | 'price' | 'title' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	canonicalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	listPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	photos_march2021?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemProductDataKeySpecifier = ('brand' | 'checkoutMechanisms' | 'checkoutUrl' | 'customType' | 'description' | 'externalUrl' | 'fullPrice' | 'fullPriceAugmented' | 'isFullPrice' | 'legacyType' | 'pdpUrl' | 'photos' | 'price' | 'priceAugmented' | 'registryItem' | 'title' | 'url' | RegistryItemProductDataKeySpecifier)[];
export type RegistryItemProductDataFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutMechanisms?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	customType?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	externalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	fullPriceAugmented?: FieldPolicy<any> | FieldReadFunction<any>,
	isFullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyType?: FieldPolicy<any> | FieldReadFunction<any>,
	pdpUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAugmented?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutMechanismKeySpecifier = ('checkoutFailureCode' | 'checkoutWarningCodes' | 'hideValueProps' | 'type' | CheckoutMechanismKeySpecifier)[];
export type CheckoutMechanismFieldPolicy = {
	checkoutFailureCode?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	hideValueProps?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryMonetaryValueKeySpecifier = ('currency' | 'floatingPointDecimalString' | 'valueInMinorUnits' | RegistryMonetaryValueKeySpecifier)[];
export type RegistryMonetaryValueFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	floatingPointDecimalString?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderKeySpecifier = ('annotations' | 'byMe' | 'donationFundPlatformType' | 'email' | 'failedStatusDetails' | 'fulfillment' | 'id' | 'isDropship' | 'isPurchased' | 'isSemiFulfillable' | 'lineItems' | 'name' | 'note' | 'orderedAt' | 'orderTags' | 'recipientNeedsNotification' | 'refunds' | 'shippingAddress' | 'status' | RegistryOrderKeySpecifier)[];
export type RegistryOrderFieldPolicy = {
	annotations?: FieldPolicy<any> | FieldReadFunction<any>,
	byMe?: FieldPolicy<any> | FieldReadFunction<any>,
	donationFundPlatformType?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	failedStatusDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDropship?: FieldPolicy<any> | FieldReadFunction<any>,
	isPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	isSemiFulfillable?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTags?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientNeedsNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderAnnotationsKeySpecifier = ('giftNote' | 'orderNumber' | 'trackingNumber' | RegistryOrderAnnotationsKeySpecifier)[];
export type RegistryOrderAnnotationsFieldPolicy = {
	giftNote?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryFulfillmentKeySpecifier = ('isDelayedShipment' | 'orderNumber' | 'shipments' | 'status' | 'statusPageUrl' | RegistryFulfillmentKeySpecifier)[];
export type RegistryFulfillmentFieldPolicy = {
	isDelayedShipment?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	shipments?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusPageUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryFulfillmentShipmentKeySpecifier = ('trackingInformation' | RegistryFulfillmentShipmentKeySpecifier)[];
export type RegistryFulfillmentShipmentFieldPolicy = {
	trackingInformation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryFulfillmentShipmentTrackingInformationKeySpecifier = ('company' | 'trackingNumber' | 'url' | RegistryFulfillmentShipmentTrackingInformationKeySpecifier)[];
export type RegistryFulfillmentShipmentTrackingInformationFieldPolicy = {
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineItemKeySpecifier = ('annotations' | 'frozenDonationData' | 'frozenProductData' | 'fulfillmentStatus' | 'isGetCashEquivalent' | 'lineItemData' | 'lineTags' | 'locator' | 'quantity' | 'registryItem' | LineItemKeySpecifier)[];
export type LineItemFieldPolicy = {
	annotations?: FieldPolicy<any> | FieldReadFunction<any>,
	frozenDonationData?: FieldPolicy<any> | FieldReadFunction<any>,
	frozenProductData?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillmentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	isGetCashEquivalent?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItemData?: FieldPolicy<any> | FieldReadFunction<any>,
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	locator?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderLineItemAnnotationsKeySpecifier = ('isEdelivery' | 'lineItemNote' | RegistryOrderLineItemAnnotationsKeySpecifier)[];
export type RegistryOrderLineItemAnnotationsFieldPolicy = {
	isEdelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItemNote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryDonationDataKeySpecifier = ('donationsAreCapped' | RegistryDonationDataKeySpecifier)[];
export type RegistryDonationDataFieldPolicy = {
	donationsAreCapped?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistrySummaryProductDataKeySpecifier = ('customType' | 'description' | 'photos' | 'price' | 'title' | 'url' | RegistrySummaryProductDataKeySpecifier)[];
export type RegistrySummaryProductDataFieldPolicy = {
	customType?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderLineItemDataKeySpecifier = ('correctedQuantity' | 'donationFundPlatformType' | RegistryOrderLineItemDataKeySpecifier)[];
export type RegistryOrderLineItemDataFieldPolicy = {
	correctedQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	donationFundPlatformType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommerceTagKeySpecifier = ('key' | 'value' | CommerceTagKeySpecifier)[];
export type CommerceTagFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderRefundKeySpecifier = ('items' | 'refundStatus' | 'shippingAndHandling' | 'taxes' | 'totalValue' | RegistryOrderRefundKeySpecifier)[];
export type RegistryOrderRefundFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	refundStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAndHandling?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderRefundItemKeySpecifier = ('currencyCode' | 'lineValueInMinorUnits' | 'title' | RegistryOrderRefundItemKeySpecifier)[];
export type RegistryOrderRefundItemFieldPolicy = {
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderShippingAddressKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'countryCode' | 'hash' | 'name' | 'phone' | 'postalCode' | 'state' | 'validated' | RegistryOrderShippingAddressKeySpecifier)[];
export type RegistryOrderShippingAddressFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	hash?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	validated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistrySessionKeySpecifier = ('email' | RegistrySessionKeySpecifier)[];
export type RegistrySessionFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransferredRegistryDataKeySpecifier = ('lastPublicCheck' | 'transferredAt' | TransferredRegistryDataKeySpecifier)[];
export type TransferredRegistryDataFieldPolicy = {
	lastPublicCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	transferredAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalRegistryStatusDataKeySpecifier = ('checkedAt' | 'isPublic' | ExternalRegistryStatusDataKeySpecifier)[];
export type ExternalRegistryStatusDataFieldPolicy = {
	checkedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventScheduleInfoKeySpecifier = ('formattedScheduleCount' | 'formattedSchedules' | 'happeningNowItems' | 'hasInviteOnlyItems' | 'itemCount' | 'items' | 'mainItem' | 'toBeAnnouncedItemCount' | 'toBeAnnouncedItems' | 'virtualScheduleItemNow' | EventScheduleInfoKeySpecifier)[];
export type EventScheduleInfoFieldPolicy = {
	formattedScheduleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedSchedules?: FieldPolicy<any> | FieldReadFunction<any>,
	happeningNowItems?: FieldPolicy<any> | FieldReadFunction<any>,
	hasInviteOnlyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	mainItem?: FieldPolicy<any> | FieldReadFunction<any>,
	toBeAnnouncedItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	toBeAnnouncedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualScheduleItemNow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormattedScheduleKeySpecifier = ('date' | 'dateISO8601TZ' | 'dateV0918' | 'day' | 'items' | 'month' | 'timezone' | 'year' | FormattedScheduleKeySpecifier)[];
export type FormattedScheduleFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dateISO8601TZ?: FieldPolicy<any> | FieldReadFunction<any>,
	dateV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	day?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTravelBookingTypeKeySpecifier = ('address' | 'bookingType' | 'endTime' | 'endTimeV0918' | 'event' | 'id' | 'latitude' | 'locationInfo' | 'longitude' | 'name' | 'placeId' | 'sortKey' | 'startTime' | 'startTimeV0918' | 'timezone' | 'type' | EventTravelBookingTypeKeySpecifier)[];
export type EventTravelBookingTypeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	locationInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTravelSharedKeySpecifier = ('event' | 'id' | 'name' | 'sortKey' | 'type' | EventTravelSharedKeySpecifier)[];
export type EventTravelSharedFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTravelListKeySpecifier = ('event' | 'id' | 'items' | 'name' | 'sortKey' | 'type' | EventTravelListKeySpecifier)[];
export type EventTravelListFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTravelListItemKeySpecifier = ('endTime' | 'endTimeV0918' | 'id' | 'note' | 'startTime' | 'startTimeV0918' | 'timezone' | 'title' | 'url' | EventTravelListItemKeySpecifier)[];
export type EventTravelListItemFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTravelNoteKeySpecifier = ('event' | 'id' | 'name' | 'notes' | 'sortKey' | 'type' | 'url' | EventTravelNoteKeySpecifier)[];
export type EventTravelNoteFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FerryKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | FerryKeySpecifier)[];
export type FerryFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FlightKeySpecifier = ('code' | 'event' | 'id' | 'name' | 'notes' | 'sortKey' | 'type' | 'url' | FlightKeySpecifier)[];
export type FlightFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | HotelKeySpecifier)[];
export type HotelFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RentalCarKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | RentalCarKeySpecifier)[];
export type RentalCarFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RentalHomeKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | RentalHomeKeySpecifier)[];
export type RentalHomeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShuttleKeySpecifier = ('event' | 'id' | 'items' | 'name' | 'notes' | 'sortKey' | 'type' | ShuttleKeySpecifier)[];
export type ShuttleFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShuttleItemKeySpecifier = ('endTime' | 'endTimeV0918' | 'id' | 'note' | 'startTime' | 'startTimeV0918' | 'timezone' | 'title' | 'url' | ShuttleItemKeySpecifier)[];
export type ShuttleItemFieldPolicy = {
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTimeV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxiKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | TaxiKeySpecifier)[];
export type TaxiFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TentKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | TentKeySpecifier)[];
export type TentFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrainKeySpecifier = ('address' | 'event' | 'id' | 'name' | 'notes' | 'placeId' | 'sortKey' | 'telephone' | 'type' | 'url' | TrainKeySpecifier)[];
export type TrainFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	telephone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyRsvpQuestionKeySpecifier = ('allDependenciesEnabled' | 'blankAnswersForQuestionCount' | 'canDelete' | 'choices' | 'dependencyDepth' | 'id' | 'isAJoyQuestion' | 'isAskedToPlusOnes' | 'isEnabled' | 'peopleWhoAnsweredDescription' | 'peopleWhoCouldAnswerQuestionCount' | 'peopleWhoHaveAnsweredQuestionCount' | 'peopleWhoHaveNotAnsweredQuestionCount' | 'peopleWhoShouldAnswerQuestionCount' | 'questionText' | 'sortKey' | 'subtype' | 'title' | 'type' | 'valid' | LegacyRsvpQuestionKeySpecifier)[];
export type LegacyRsvpQuestionFieldPolicy = {
	allDependenciesEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	blankAnswersForQuestionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	canDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	dependencyDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAJoyQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	isAskedToPlusOnes?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleWhoAnsweredDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleWhoCouldAnswerQuestionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleWhoHaveAnsweredQuestionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleWhoHaveNotAnsweredQuestionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	peopleWhoShouldAnswerQuestionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	questionText?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	subtype?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoiceKeySpecifier = ('displayValue' | 'storeValue' | ChoiceKeySpecifier)[];
export type ChoiceFieldPolicy = {
	displayValue?: FieldPolicy<any> | FieldReadFunction<any>,
	storeValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaPhotoKeySpecifier = ('createdAt' | 'id' | 'photo' | MediaPhotoKeySpecifier)[];
export type MediaPhotoFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaVideoKeySpecifier = ('caption' | 'createdAt' | 'id' | 'videoUrl' | MediaVideoKeySpecifier)[];
export type MediaVideoFieldPolicy = {
	caption?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaCollectionKeySpecifier = ('createdAt' | 'id' | 'magicTokenDisabled' | 'magicTokenPermissions' | 'media' | 'mediaCount' | 'name' | 'sortBy' | 'sortDirection' | 'thumbnails' | MediaCollectionKeySpecifier)[];
export type MediaCollectionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	magicTokenDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	magicTokenPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sortBy?: FieldPolicy<any> | FieldReadFunction<any>,
	sortDirection?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaInfoKeySpecifier = ('media' | 'mediaCount' | 'thumbnails' | MediaInfoKeySpecifier)[];
export type MediaInfoFieldPolicy = {
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCount?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageContainerKeySpecifier = ('components' | 'contentType' | 'createdAt' | 'id' | 'mainPhoto' | 'mainPhotoAlignment' | 'mainPhotoCropInfo' | 'mainPhotoPresentationLayout' | 'mainPhotoV2' | 'note' | 'slug' | 'sortOrder' | 'title' | 'visibility' | PageContainerKeySpecifier)[];
export type PageContainerFieldPolicy = {
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhotoAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhotoCropInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhotoPresentationLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhotoV2?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventCountdownComponentKeySpecifier = ('id' | 'sortOrder' | 'type' | EventCountdownComponentKeySpecifier)[];
export type EventCountdownComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDetailsComponentKeySpecifier = ('id' | 'sortOrder' | 'type' | EventDetailsComponentKeySpecifier)[];
export type EventDetailsComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDisplayNameComponentKeySpecifier = ('id' | 'sortOrder' | 'type' | EventDisplayNameComponentKeySpecifier)[];
export type EventDisplayNameComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GreetingMessageComponentKeySpecifier = ('id' | 'sortOrder' | 'type' | GreetingMessageComponentKeySpecifier)[];
export type GreetingMessageComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JsonDataBlobComponentKeySpecifier = ('containerContent' | 'id' | 'jsonDataContainerId' | 'sortOrder' | 'type' | JsonDataBlobComponentKeySpecifier)[];
export type JsonDataBlobComponentFieldPolicy = {
	containerContent?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jsonDataContainerId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JsonDataContainerKeySpecifier = ('content' | 'eventId' | 'id' | 'schemaUrl' | 'type' | JsonDataContainerKeySpecifier)[];
export type JsonDataContainerFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaGalleryComponentKeySpecifier = ('id' | 'mediaCollection' | 'sortOrder' | 'type' | MediaGalleryComponentKeySpecifier)[];
export type MediaGalleryComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoComponentKeySpecifier = ('id' | 'photo' | 'sortOrder' | 'type' | PhotoComponentKeySpecifier)[];
export type PhotoComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RsvpAndUnlockGuestDetailsButtonComponentKeySpecifier = ('id' | 'sortOrder' | 'type' | RsvpAndUnlockGuestDetailsButtonComponentKeySpecifier)[];
export type RsvpAndUnlockGuestDetailsButtonComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TextComponentKeySpecifier = ('id' | 'sortOrder' | 'text' | 'type' | TextComponentKeySpecifier)[];
export type TextComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelMapComponentKeySpecifier = ('blockOrdering' | 'event' | 'hideExploreCTA' | 'id' | 'pointsOnMap' | 'sortOrder' | 'type' | TravelMapComponentKeySpecifier)[];
export type TravelMapComponentFieldPolicy = {
	blockOrdering?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	hideExploreCTA?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsOnMap?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PointsOnMapKeySpecifier = ('address' | 'googlePlaceID' | 'id' | 'latitude' | 'longitude' | 'name' | 'postalCode' | 'type' | PointsOnMapKeySpecifier)[];
export type PointsOnMapFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceID?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoComponentKeySpecifier = ('caption' | 'id' | 'sortOrder' | 'type' | 'videoUrl' | VideoComponentKeySpecifier)[];
export type VideoComponentFieldPolicy = {
	caption?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoAlignmentValueKeySpecifier = ('x' | 'y' | PhotoAlignmentValueKeySpecifier)[];
export type PhotoAlignmentValueFieldPolicy = {
	x?: FieldPolicy<any> | FieldReadFunction<any>,
	y?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainPhotoCropInfoKeySpecifier = ('height' | 'unit' | 'width' | 'x' | 'y' | MainPhotoCropInfoKeySpecifier)[];
export type MainPhotoCropInfoFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>,
	x?: FieldPolicy<any> | FieldReadFunction<any>,
	y?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultPagePhotoKeySpecifier = ('altTag' | 'assetId' | 'collectionItems' | 'container' | 'currentUserIsOwner' | 'generatedSimpleTags' | 'height' | 'id' | 'layout' | 'likedByCurrentUser' | 'likes' | 'metaTags' | 'mimeType' | 'simpleTags' | 'taggedVendorIds' | 'url' | 'width' | DefaultPagePhotoKeySpecifier)[];
export type DefaultPagePhotoFieldPolicy = {
	altTag?: FieldPolicy<any> | FieldReadFunction<any>,
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItems?: FieldPolicy<any> | FieldReadFunction<any>,
	container?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUserIsOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedSimpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	likedByCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	likes?: FieldPolicy<any> | FieldReadFunction<any>,
	metaTags?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleTags?: FieldPolicy<any> | FieldReadFunction<any>,
	taggedVendorIds?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultPageCollectionItemKeySpecifier = ('collection' | 'id' | DefaultPageCollectionItemKeySpecifier)[];
export type DefaultPageCollectionItemFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultPageCollectionKeySpecifier = ('id' | DefaultPageCollectionKeySpecifier)[];
export type DefaultPageCollectionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultPagePhotoLayoutKeySpecifier = ('alignX' | 'alignY' | DefaultPagePhotoLayoutKeySpecifier)[];
export type DefaultPagePhotoLayoutFieldPolicy = {
	alignX?: FieldPolicy<any> | FieldReadFunction<any>,
	alignY?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultPageMetaTagKeySpecifier = ('id' | DefaultPageMetaTagKeySpecifier)[];
export type DefaultPageMetaTagFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventPageInfoKeySpecifier = ('canActiveSessionAccess' | 'disabled' | 'id' | 'page' | 'private' | 'type' | 'visibility' | EventPageInfoKeySpecifier)[];
export type EventPageInfoFieldPolicy = {
	canActiveSessionAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventPageKeySpecifier = ('createdAt' | 'disabled' | 'event' | 'firebaseId' | 'firebaseMobilePhotoPath' | 'firebasePhotoPath' | 'id' | 'isPageContainer' | 'mobilePhoto' | 'mobilePhotoV2' | 'pageSlug' | 'pageSubTitle' | 'pageSubTitleV0918' | 'pageTitle' | 'photo' | 'photoPresentation' | 'photoV2' | 'private' | 'type' | 'visibility' | EventPageKeySpecifier)[];
export type EventPageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseId?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseMobilePhotoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePhotoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPageContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	mobilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	mobilePhotoV2?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSubTitleV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photoPresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	photoV2?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsitePagePhotoPresentationKeySpecifier = ('cropInfo' | 'id' | 'photo' | 'presentationLayout' | WebsitePagePhotoPresentationKeySpecifier)[];
export type WebsitePagePhotoPresentationFieldPolicy = {
	cropInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	presentationLayout?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebsitePagePhotoPresentationCropInfoKeySpecifier = ('height' | 'unit' | 'width' | 'x' | 'y' | WebsitePagePhotoPresentationCropInfoKeySpecifier)[];
export type WebsitePagePhotoPresentationCropInfoFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>,
	x?: FieldPolicy<any> | FieldReadFunction<any>,
	y?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventPlaceKeySpecifier = ('city' | 'country' | 'countryCode' | 'displayAddress' | 'googlePlaceId' | 'id' | 'isInvalid' | 'latitude' | 'longitude' | 'name' | 'photos' | 'rating' | 'stateProvince' | 'type' | EventPlaceKeySpecifier)[];
export type EventPlaceFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	displayAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInvalid?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	stateProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventPlacePhotoKeySpecifier = ('name' | EventPlacePhotoKeySpecifier)[];
export type EventPlacePhotoFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventProductVerticalsKeySpecifier = ('optOutOfGuestList' | 'optOutOfInvites' | 'optOutOfRegistry' | 'optOutOfWebsite' | EventProductVerticalsKeySpecifier)[];
export type EventProductVerticalsFieldPolicy = {
	optOutOfGuestList?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutOfInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutOfRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutOfWebsite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecommendEventKeySpecifier = ('registryAdvisor' | 'registryOnboardingSurvey' | RecommendEventKeySpecifier)[];
export type RecommendEventFieldPolicy = {
	registryAdvisor?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOnboardingSurvey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecommendRegistryAdvisorDataKeySpecifier = ('currentGiftCount' | 'guestCount' | 'priceRanges' | 'targetGiftCount' | RecommendRegistryAdvisorDataKeySpecifier)[];
export type RecommendRegistryAdvisorDataFieldPolicy = {
	currentGiftCount?: FieldPolicy<any> | FieldReadFunction<any>,
	guestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRanges?: FieldPolicy<any> | FieldReadFunction<any>,
	targetGiftCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalculatedPriceRangeKeySpecifier = ('currentGiftCount' | 'endPrice' | 'startPrice' | 'targetGiftCount' | CalculatedPriceRangeKeySpecifier)[];
export type CalculatedPriceRangeFieldPolicy = {
	currentGiftCount?: FieldPolicy<any> | FieldReadFunction<any>,
	endPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	startPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	targetGiftCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecommendRegistryOnboardingSurveyResultsKeySpecifier = ('coupleInterests' | 'guestCount' | 'id' | 'interestedInBrowserButton' | 'lastUpdatedAt' | 'registeringAtOtherStores' | 'registryTypes' | RecommendRegistryOnboardingSurveyResultsKeySpecifier)[];
export type RecommendRegistryOnboardingSurveyResultsFieldPolicy = {
	coupleInterests?: FieldPolicy<any> | FieldReadFunction<any>,
	guestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedInBrowserButton?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	registeringAtOtherStores?: FieldPolicy<any> | FieldReadFunction<any>,
	registryTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDataKeySpecifier = ('cc4cFeeStrategy' | 'checklist' | 'completionDiscount' | 'currency' | 'delayedShippingOrderCount' | 'delayOrderFulfillment' | 'disableWhiteGloveforPartnerItems' | 'disableWhiteGloveforSyncedItems' | 'disableWhiteGloveforTransferredItems' | 'donationFundInfo' | 'event' | 'hideDelayShipSetting' | 'hideRegistryInMessaging' | 'id' | 'itemCount' | 'items' | 'joyCreditStatus' | 'orders' | 'payoutAccount' | 'registries' | 'shippingAddress' | 'summary' | EventDataKeySpecifier)[];
export type EventDataFieldPolicy = {
	cc4cFeeStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	checklist?: FieldPolicy<any> | FieldReadFunction<any>,
	completionDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	delayedShippingOrderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	delayOrderFulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	disableWhiteGloveforPartnerItems?: FieldPolicy<any> | FieldReadFunction<any>,
	disableWhiteGloveforSyncedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	disableWhiteGloveforTransferredItems?: FieldPolicy<any> | FieldReadFunction<any>,
	donationFundInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDelayShipSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	hideRegistryInMessaging?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	joyCreditStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	payoutAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	registries?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryChecklistKeySpecifier = ('checklistProgress' | 'checklistSections' | 'checklistTemplate' | 'id' | RegistryChecklistKeySpecifier)[];
export type RegistryChecklistFieldPolicy = {
	checklistProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	checklistSections?: FieldPolicy<any> | FieldReadFunction<any>,
	checklistTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryChecklistProgressResultKeySpecifier = ('checkedCount' | 'totalCount' | RegistryChecklistProgressResultKeySpecifier)[];
export type RegistryChecklistProgressResultFieldPolicy = {
	checkedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryChecklistSectionKeySpecifier = ('checklistItems' | 'id' | 'sectionProgress' | 'sectionTitle' | 'sortKey' | 'thumbnail' | RegistryChecklistSectionKeySpecifier)[];
export type RegistryChecklistSectionFieldPolicy = {
	checklistItems?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryChecklistItemKeySpecifier = ('completeCTAUrlPath' | 'id' | 'isCheckable' | 'isChecked' | 'registryItem' | 'sortKey' | 'subTitle' | 'thumbnail' | 'title' | 'type' | RegistryChecklistItemKeySpecifier)[];
export type RegistryChecklistItemFieldPolicy = {
	completeCTAUrlPath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCheckable?: FieldPolicy<any> | FieldReadFunction<any>,
	isChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	sortKey?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCompletionDiscountKeySpecifier = ('discountPolicyClausesNotMet' | 'items' | RegistryCompletionDiscountKeySpecifier)[];
export type RegistryCompletionDiscountFieldPolicy = {
	discountPolicyClausesNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiscountedRegistryItemKeySpecifier = ('discountDetails' | 'registryItem' | DiscountedRegistryItemKeySpecifier)[];
export type DiscountedRegistryItemFieldPolicy = {
	discountDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	registryItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemDiscountCampaignDetailsKeySpecifier = ('campaign' | 'discountedPrice' | 'discountPolicyClausesNotMet' | 'eligible' | ItemDiscountCampaignDetailsKeySpecifier)[];
export type ItemDiscountCampaignDetailsFieldPolicy = {
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	discountedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPolicyClausesNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	eligible?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemCountKeySpecifier = ('available' | 'everything' | 'purchasedOrReserved' | 'shippable' | RegistryItemCountKeySpecifier)[];
export type RegistryItemCountFieldPolicy = {
	available?: FieldPolicy<any> | FieldReadFunction<any>,
	everything?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedOrReserved?: FieldPolicy<any> | FieldReadFunction<any>,
	shippable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryJoyCreditStatusKeySpecifier = ('joyCredit' | RegistryJoyCreditStatusKeySpecifier)[];
export type RegistryJoyCreditStatusFieldPolicy = {
	joyCredit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryJoyCreditKeySpecifier = ('active' | 'amount' | 'code' | RegistryJoyCreditKeySpecifier)[];
export type RegistryJoyCreditFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommerceMonetaryValueKeySpecifier = ('currencyCode' | 'valueInMajorUnits' | 'valueInMinorUnits' | CommerceMonetaryValueKeySpecifier)[];
export type CommerceMonetaryValueFieldPolicy = {
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMajorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPayoutAccountKeySpecifier = ('balance' | 'externalAccountLast4' | 'lastKnownAvailableBalance' | 'lastKnownBalance' | 'onboardingUrl' | 'serviceDashboardUrl' | 'status' | 'statusDetails' | 'withdrawals' | RegistryPayoutAccountKeySpecifier)[];
export type RegistryPayoutAccountFieldPolicy = {
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAccountLast4?: FieldPolicy<any> | FieldReadFunction<any>,
	lastKnownAvailableBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	lastKnownBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceDashboardUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPayoutAccountBalanceKeySpecifier = ('available' | 'availablePending' | 'cash' | 'gce' | 'received' | 'total' | 'withdrawn' | 'withdrawnPending' | RegistryPayoutAccountBalanceKeySpecifier)[];
export type RegistryPayoutAccountBalanceFieldPolicy = {
	available?: FieldPolicy<any> | FieldReadFunction<any>,
	availablePending?: FieldPolicy<any> | FieldReadFunction<any>,
	cash?: FieldPolicy<any> | FieldReadFunction<any>,
	gce?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawn?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawnPending?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPayoutAccountWithdrawalKeySpecifier = ('createdAt' | 'id' | 'status' | 'totalValue' | RegistryPayoutAccountWithdrawalKeySpecifier)[];
export type RegistryPayoutAccountWithdrawalFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingAddressKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'countryCode' | 'hash' | 'name' | 'phone' | 'postalCode' | 'state' | 'validated' | ShippingAddressKeySpecifier)[];
export type ShippingAddressFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	hash?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	validated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventRegistriesSummaryKeySpecifier = ('cannotSync' | 'lastSyncAt' | EventRegistriesSummaryKeySpecifier)[];
export type EventRegistriesSummaryFieldPolicy = {
	cannotSync?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSyncAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSettingsKeySpecifier = ('allowFacebookAndInstagramSharingOnApp' | 'allowGuestsNotInGuestListToRSVP' | 'allowGuestsToInviteOtherGuestsOnApp' | 'allowGuestsToRSVPPlusOne' | 'allowGuestsToViewOtherGuestsOnApp' | 'event' | 'hideDownloadAppPage' | 'hideEventCountdown' | 'hideFromJoySearch' | 'hideFromSearchEngines' | 'id' | 'optOutOfCharm' | 'privacyMode' | 'published' | 'requirePasswordForEventDate' | 'requirePasswordForEventLocation' | 'requirePasswordToUploadPhotos' | 'requirePasswordToViewEngagementPhotos' | EventSettingsKeySpecifier)[];
export type EventSettingsFieldPolicy = {
	allowFacebookAndInstagramSharingOnApp?: FieldPolicy<any> | FieldReadFunction<any>,
	allowGuestsNotInGuestListToRSVP?: FieldPolicy<any> | FieldReadFunction<any>,
	allowGuestsToInviteOtherGuestsOnApp?: FieldPolicy<any> | FieldReadFunction<any>,
	allowGuestsToRSVPPlusOne?: FieldPolicy<any> | FieldReadFunction<any>,
	allowGuestsToViewOtherGuestsOnApp?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDownloadAppPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hideEventCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromJoySearch?: FieldPolicy<any> | FieldReadFunction<any>,
	hideFromSearchEngines?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutOfCharm?: FieldPolicy<any> | FieldReadFunction<any>,
	privacyMode?: FieldPolicy<any> | FieldReadFunction<any>,
	published?: FieldPolicy<any> | FieldReadFunction<any>,
	requirePasswordForEventDate?: FieldPolicy<any> | FieldReadFunction<any>,
	requirePasswordForEventLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	requirePasswordToUploadPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	requirePasswordToViewEngagementPhotos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventStyleKeySpecifier = ('accent' | 'backgroundType' | 'border' | 'customCss' | 'event' | 'font' | 'id' | 'layout' | 'light' | 'primaryColor' | 'primaryColorV0918' | 'primaryTextColor' | 'secondaryColor' | 'secondaryColorV0918' | 'suggestedColor' | 'theme' | 'translucent' | 'useSuggestedThemeColorAloha' | EventStyleKeySpecifier)[];
export type EventStyleFieldPolicy = {
	accent?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundType?: FieldPolicy<any> | FieldReadFunction<any>,
	border?: FieldPolicy<any> | FieldReadFunction<any>,
	customCss?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	light?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryColor?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryColorV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryColor?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryColorV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedColor?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>,
	translucent?: FieldPolicy<any> | FieldReadFunction<any>,
	useSuggestedThemeColorAloha?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSuggestionInfoKeySpecifier = ('items' | EventSuggestionInfoKeySpecifier)[];
export type EventSuggestionInfoFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSuggestionKeySpecifier = ('createdAt' | 'id' | 'identifier' | 'offeredAt' | 'stateJSON' | EventSuggestionKeySpecifier)[];
export type EventSuggestionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	offeredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	stateJSON?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelSettingsKeySpecifier = ('accommodationsNotePrompt' | 'checkInDate' | 'checkOutDate' | 'currencyCode' | 'datesMatchingReminder' | TravelSettingsKeySpecifier)[];
export type TravelSettingsFieldPolicy = {
	accommodationsNotePrompt?: FieldPolicy<any> | FieldReadFunction<any>,
	checkInDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOutDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	datesMatchingReminder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoKeySpecifier = ('caption' | 'eventId' | 'firebasePath' | 'id' | 'mimeType' | 'thumbnailUrl' | 'title' | 'url' | VideoKeySpecifier)[];
export type VideoFieldPolicy = {
	caption?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VipKeySpecifier = ('alias' | 'description' | 'event' | 'firebasePhotoPath' | 'id' | 'monogram' | 'photo' | 'photoUrl' | 'title' | VipKeySpecifier)[];
export type VipFieldPolicy = {
	alias?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	firebasePhotoPath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	monogram?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeedMessageKeySpecifier = ('channel' | 'id' | 'message' | 'pushNotificationType' | 'status' | 'targets' | 'timestamp' | 'type' | FeedMessageKeySpecifier)[];
export type FeedMessageFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	pushNotificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	targets?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeedMessageTargetKeySpecifier = ('identifier' | 'identifierType' | 'isDefault' | 'label' | 'slug' | FeedMessageTargetKeySpecifier)[];
export type FeedMessageTargetFieldPolicy = {
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	identifierType?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorKeySpecifier = ('aggregateSyntheticCollection' | 'collectionIds' | 'collections' | 'description' | 'discoveryNodeItems' | 'email' | 'emailsSentFor' | 'handle' | 'id' | 'instagramAuthLink' | 'instagramCollection' | 'instagramHandle' | 'location' | 'locked' | 'matches' | 'matchForEvent' | 'name' | 'phone' | 'photo' | 'photosTaggedIn' | 'serviceTags' | 'startingPrice' | 'suggestions' | 'testimony' | 'tokens' | 'type' | 'typicalSpend' | 'vendorUserByUserId' | 'vendorUsers' | 'videoCollection' | 'website' | VendorKeySpecifier)[];
export type VendorFieldPolicy = {
	aggregateSyntheticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discoveryNodeItems?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailsSentFor?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	instagramAuthLink?: FieldPolicy<any> | FieldReadFunction<any>,
	instagramCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	instagramHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>,
	matchForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photosTaggedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTags?: FieldPolicy<any> | FieldReadFunction<any>,
	startingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	testimony?: FieldPolicy<any> | FieldReadFunction<any>,
	tokens?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	typicalSpend?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUserByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	videoCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyntheticCollectionKeySpecifier = ('collectionIds' | 'currentUserIsOwner' | 'default' | 'description' | 'disabled' | 'excludeTags' | 'id' | 'includeTags' | 'itemCount' | 'items' | 'name' | 'owner' | 'private' | SyntheticCollectionKeySpecifier)[];
export type SyntheticCollectionFieldPolicy = {
	collectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUserIsOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeTags?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	includeTags?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemsConnectionKeySpecifier = ('edges' | 'pageInfo' | CollectionItemsConnectionKeySpecifier)[];
export type CollectionItemsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConnectionKeySpecifier = ('pageInfo' | ConnectionKeySpecifier)[];
export type ConnectionFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemsEdgeKeySpecifier = ('cursor' | 'node' | CollectionItemsEdgeKeySpecifier)[];
export type CollectionItemsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdgeKeySpecifier = ('cursor' | EdgeKeySpecifier)[];
export type EdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorDiscoveryNodeItemKeySpecifier = ('collection' | 'collectionIds' | 'id' | 'vendor' | 'vendorDiscoveryNode' | VendorDiscoveryNodeItemKeySpecifier)[];
export type VendorDiscoveryNodeItemFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorDiscoveryNode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorDiscoveryNodeKeySpecifier = ('aggregateSyntheticCollection' | 'aggregateSyntheticCollectionGroupsCollection' | 'breadcrumbs' | 'canonicalUrl' | 'collectionGroupByUrlSlug' | 'collectionGroupCollectionIds' | 'collectionGroupCollections' | 'collectionGroups' | 'collectionIds' | 'collectionListTitle' | 'collections' | 'description' | 'featuredCollection' | 'id' | 'items' | 'metaPageDescription' | 'metaPageTitle' | 'photo' | 'photoListTitle' | 'suggestionGroup' | 'title' | 'urls' | 'vendorListTitle' | VendorDiscoveryNodeKeySpecifier)[];
export type VendorDiscoveryNodeFieldPolicy = {
	aggregateSyntheticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateSyntheticCollectionGroupsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	breadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	canonicalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupByUrlSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCollectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionListTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	metaPageDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	metaPageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photoListTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	urls?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorListTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorCollectionGroupKeySpecifier = ('aggregateSyntheticCollection' | 'collectionIds' | 'collections' | 'discoveryNode' | 'excludeTags' | 'id' | 'includeTags' | 'photo' | 'title' | 'urlSlug' | VendorCollectionGroupKeySpecifier)[];
export type VendorCollectionGroupFieldPolicy = {
	aggregateSyntheticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionIds?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	discoveryNode?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeTags?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	includeTags?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	urlSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SuggestionGroupKeySpecifier = ('description' | 'id' | 'photo' | 'suggestions' | 'title' | SuggestionGroupKeySpecifier)[];
export type SuggestionGroupFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorSuggestionKeySpecifier = ('collection' | 'description' | 'id' | 'photo' | 'suggestionGroup' | 'title' | 'vendor' | VendorSuggestionKeySpecifier)[];
export type VendorSuggestionFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'latitude' | 'longitude' | 'name' | 'placeId' | 'postalCode' | 'state' | LocationKeySpecifier)[];
export type LocationFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceTagKeySpecifier = ('display' | 'id' | 'vendors' | ServiceTagKeySpecifier)[];
export type ServiceTagFieldPolicy = {
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TestimonyKeySpecifier = ('content' | 'id' | 'match' | 'reviewer' | 'vendor' | TestimonyKeySpecifier)[];
export type TestimonyFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	match?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewer?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorTypeKeySpecifier = ('category' | 'display' | 'id' | 'image' | 'index' | 'instance' | 'type' | VendorTypeKeySpecifier)[];
export type VendorTypeFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	instance?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorUserKeySpecifier = ('claimToken' | 'displayFirstName' | 'displayLastName' | 'email' | 'id' | 'phone' | 'photo' | 'status' | 'title' | 'user' | 'vendor' | VendorUserKeySpecifier)[];
export type VendorUserFieldPolicy = {
	claimToken?: FieldPolicy<any> | FieldReadFunction<any>,
	displayFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	displayLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorUserV2KeySpecifier = ('acceptedTermsAndConditions' | 'calendarCredentialsExpired' | 'credentialType' | 'email' | 'firstName' | 'id' | 'lastName' | 'role' | 'user' | 'vendor' | VendorUserV2KeySpecifier)[];
export type VendorUserV2FieldPolicy = {
	acceptedTermsAndConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	calendarCredentialsExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialType?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorV2KeySpecifier = ('bookingTypeAvailability' | 'bookingWindowLeadHours' | 'description' | 'email' | 'handle' | 'id' | 'name' | 'phoneNumber' | 'phoneNumberE164' | 'timezone' | 'vendorCustomization' | 'vendorLocation' | 'vendorUsers' | 'website' | VendorV2KeySpecifier)[];
export type VendorV2FieldPolicy = {
	bookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingWindowLeadHours?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberE164?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorCustomization?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingTypeAvailabilityKeySpecifier = ('friday' | 'monday' | 'saturday' | 'sunday' | 'thursday' | 'tuesday' | 'wednesday' | BookingTypeAvailabilityKeySpecifier)[];
export type BookingTypeAvailabilityFieldPolicy = {
	friday?: FieldPolicy<any> | FieldReadFunction<any>,
	monday?: FieldPolicy<any> | FieldReadFunction<any>,
	saturday?: FieldPolicy<any> | FieldReadFunction<any>,
	sunday?: FieldPolicy<any> | FieldReadFunction<any>,
	thursday?: FieldPolicy<any> | FieldReadFunction<any>,
	tuesday?: FieldPolicy<any> | FieldReadFunction<any>,
	wednesday?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingTypeAvailabilityDayKeySpecifier = ('end' | 'start' | BookingTypeAvailabilityDayKeySpecifier)[];
export type BookingTypeAvailabilityDayFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorCustomizationTypeKeySpecifier = ('hexColor' | 'id' | 'photo' | 'photoId' | VendorCustomizationTypeKeySpecifier)[];
export type VendorCustomizationTypeFieldPolicy = {
	hexColor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photoId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationV2KeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'displayName' | 'id' | 'latitude' | 'longitude' | 'placeId' | 'postalCode' | 'state' | VendorLocationV2KeySpecifier)[];
export type VendorLocationV2FieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExifMetadataKeySpecifier = ('colorSpace' | 'dateTimeOriginal' | 'imageHeight' | 'imageWidth' | 'orientation' | 'software' | 'uploadDateTime' | ExifMetadataKeySpecifier)[];
export type ExifMetadataFieldPolicy = {
	colorSpace?: FieldPolicy<any> | FieldReadFunction<any>,
	dateTimeOriginal?: FieldPolicy<any> | FieldReadFunction<any>,
	imageHeight?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	orientation?: FieldPolicy<any> | FieldReadFunction<any>,
	software?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadDateTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoLayoutKeySpecifier = ('alignX' | 'alignY' | PhotoLayoutKeySpecifier)[];
export type PhotoLayoutFieldPolicy = {
	alignX?: FieldPolicy<any> | FieldReadFunction<any>,
	alignY?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetaTagKeySpecifier = ('event' | 'id' | 'photo' | 'user' | 'vendor' | MetaTagKeySpecifier)[];
export type MetaTagFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoPaletteKeySpecifier = ('darkMuted' | 'darkVibrant' | 'lightMuted' | 'lightVibrant' | 'muted' | 'mutedV0918' | 'vibrant' | 'vibrantV0918' | PhotoPaletteKeySpecifier)[];
export type PhotoPaletteFieldPolicy = {
	darkMuted?: FieldPolicy<any> | FieldReadFunction<any>,
	darkVibrant?: FieldPolicy<any> | FieldReadFunction<any>,
	lightMuted?: FieldPolicy<any> | FieldReadFunction<any>,
	lightVibrant?: FieldPolicy<any> | FieldReadFunction<any>,
	muted?: FieldPolicy<any> | FieldReadFunction<any>,
	mutedV0918?: FieldPolicy<any> | FieldReadFunction<any>,
	vibrant?: FieldPolicy<any> | FieldReadFunction<any>,
	vibrantV0918?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoTransformKeySpecifier = ('height' | 'width' | 'x' | 'y' | PhotoTransformKeySpecifier)[];
export type PhotoTransformFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>,
	x?: FieldPolicy<any> | FieldReadFunction<any>,
	y?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPhotoSubjectKeySpecifier = ('label' | 'type' | AccommodationCatalogPhotoSubjectKeySpecifier)[];
export type AccommodationCatalogPhotoSubjectFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPropertyPolicyFieldKeySpecifier = ('description' | 'title' | AccommodationPropertyPolicyFieldKeySpecifier)[];
export type AccommodationPropertyPolicyFieldFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthenticationErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | AuthenticationErrorTypeKeySpecifier)[];
export type AuthenticationErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | ErrorTypeKeySpecifier)[];
export type ErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BadRequestErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | BadRequestErrorTypeKeySpecifier)[];
export type BadRequestErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ForbiddenErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | ForbiddenErrorTypeKeySpecifier)[];
export type ForbiddenErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalServerErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | InternalServerErrorTypeKeySpecifier)[];
export type InternalServerErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotFoundErrorTypeKeySpecifier = ('code' | 'message' | 'meta' | 'type' | NotFoundErrorTypeKeySpecifier)[];
export type NotFoundErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttendanceKeySpecifier = ('attendanceState' | 'contact' | 'createdAt' | 'createdBy' | 'eventId' | 'formId' | 'guestKey' | 'id' | 'notes' | 'reason' | AttendanceKeySpecifier)[];
export type AttendanceFieldPolicy = {
	attendanceState?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormContactItemKeySpecifier = ('email' | 'firstName' | 'guestKey' | 'lastName' | 'phoneNumber' | 'tags' | FormContactItemKeySpecifier)[];
export type FormContactItemFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormContactPhoneNumberKeySpecifier = ('allowSMS' | 'label' | 'mobile' | 'number' | FormContactPhoneNumberKeySpecifier)[];
export type FormContactPhoneNumberFieldPolicy = {
	allowSMS?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	mobile?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestAttendanceStatusKeySpecifier = ('attendanceState' | 'guestKey' | GuestAttendanceStatusKeySpecifier)[];
export type GuestAttendanceStatusFieldPolicy = {
	attendanceState?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttendanceResultKeySpecifier = ('attendanceCount' | 'nodes' | AttendanceResultKeySpecifier)[];
export type AttendanceResultFieldPolicy = {
	attendanceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttendanceStatusCountKeySpecifier = ('attending' | 'maybe' | 'notAttending' | 'pending' | AttendanceStatusCountKeySpecifier)[];
export type AttendanceStatusCountFieldPolicy = {
	attending?: FieldPolicy<any> | FieldReadFunction<any>,
	maybe?: FieldPolicy<any> | FieldReadFunction<any>,
	notAttending?: FieldPolicy<any> | FieldReadFunction<any>,
	pending?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthenticatedUserResultKeySpecifier = ('auth0Id' | 'user' | 'userJWT' | 'version' | AuthenticatedUserResultKeySpecifier)[];
export type AuthenticatedUserResultFieldPolicy = {
	auth0Id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userJWT?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateOperationsByEventIdResponseKeySpecifier = ('operations' | AutopopulateOperationsByEventIdResponseKeySpecifier)[];
export type AutopopulateOperationsByEventIdResponseFieldPolicy = {
	operations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateOperationItemKeySpecifier = ('completedAt' | 'createdAt' | 'error' | 'eventId' | 'idempotentId' | 'operationType' | 'result' | 'status' | 'updatedAt' | AutopopulateOperationItemKeySpecifier)[];
export type AutopopulateOperationItemFieldPolicy = {
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	operationType?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutoPopulateResultItemV4KeySpecifier = ('accommodationPlaceId' | 'proposedNoteFromHostToGuest' | 'whyThisHotelIsAGreatPick' | AutoPopulateResultItemV4KeySpecifier)[];
export type AutoPopulateResultItemV4FieldPolicy = {
	accommodationPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedNoteFromHostToGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	whyThisHotelIsAGreatPick?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateOperationsByEventIdResponseV20251203KeySpecifier = ('operations' | AutopopulateOperationsByEventIdResponseV20251203KeySpecifier)[];
export type AutopopulateOperationsByEventIdResponseV20251203FieldPolicy = {
	operations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateOperationItemV20251203KeySpecifier = ('completedAt' | 'createdAt' | 'error' | 'eventId' | 'idempotentId' | 'operationType' | 'result' | 'status' | 'updatedAt' | AutopopulateOperationItemV20251203KeySpecifier)[];
export type AutopopulateOperationItemV20251203FieldPolicy = {
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	operationType?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutoPopulateResultV20251203KeySpecifier = ('algoTag' | 'items' | AutoPopulateResultV20251203KeySpecifier)[];
export type AutoPopulateResultV20251203FieldPolicy = {
	algoTag?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateStayAreaOperationsByEventIdResponseKeySpecifier = ('operations' | AutopopulateStayAreaOperationsByEventIdResponseKeySpecifier)[];
export type AutopopulateStayAreaOperationsByEventIdResponseFieldPolicy = {
	operations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutopopulateStayAreaOperationItemKeySpecifier = ('completedAt' | 'createdAt' | 'error' | 'eventId' | 'idempotentId' | 'operationType' | 'result' | 'status' | 'updatedAt' | AutopopulateStayAreaOperationItemKeySpecifier)[];
export type AutopopulateStayAreaOperationItemFieldPolicy = {
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	operationType?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JoyStayAreaKeySpecifier = ('address' | 'areaType' | 'bestForTags' | 'bounds' | 'center' | 'description' | 'distanceFromVenue' | 'distances' | 'driveTimeInMinutes' | 'id' | 'landmarkNames' | 'name' | 'photos' | 'proposedNoteFromHostToGuest' | 'radiusMeters' | 'status' | 'walkTimeInMinutes' | 'watchOuts' | 'whyThisAreaIsAGreatPick' | JoyStayAreaKeySpecifier)[];
export type JoyStayAreaFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	areaType?: FieldPolicy<any> | FieldReadFunction<any>,
	bestForTags?: FieldPolicy<any> | FieldReadFunction<any>,
	bounds?: FieldPolicy<any> | FieldReadFunction<any>,
	center?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	distanceFromVenue?: FieldPolicy<any> | FieldReadFunction<any>,
	distances?: FieldPolicy<any> | FieldReadFunction<any>,
	driveTimeInMinutes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	landmarkNames?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedNoteFromHostToGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	radiusMeters?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	walkTimeInMinutes?: FieldPolicy<any> | FieldReadFunction<any>,
	watchOuts?: FieldPolicy<any> | FieldReadFunction<any>,
	whyThisAreaIsAGreatPick?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationBoundsOutputKeySpecifier = ('ne' | 'sw' | LocationBoundsOutputKeySpecifier)[];
export type LocationBoundsOutputFieldPolicy = {
	ne?: FieldPolicy<any> | FieldReadFunction<any>,
	sw?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationCoordinatesKeySpecifier = ('lat' | 'lng' | LocationCoordinatesKeySpecifier)[];
export type LocationCoordinatesFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingSlotKeySpecifier = ('alternateEmail' | 'bookingType' | 'calendarInfo' | 'customerInsights' | 'date' | 'dateBooked' | 'displayName' | 'email' | 'icsLink' | 'id' | 'phoneNumber' | 'simpleNotes' | 'status' | 'timezone' | BookingSlotKeySpecifier)[];
export type BookingSlotFieldPolicy = {
	alternateEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	calendarInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	customerInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dateBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	icsLink?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingTypeKeySpecifier = ('availabilityType' | 'bookingProcess' | 'bookingSlots' | 'bookingTypeLocation' | 'defaultAvailability' | 'description' | 'displayOrder' | 'eventLength' | 'eventType' | 'handle' | 'hosts' | 'id' | 'interval' | 'locationString' | 'locationType' | 'meetingInfoNotes' | 'meetingUrl' | 'private' | 'timezone' | 'title' | 'vendor' | BookingTypeKeySpecifier)[];
export type BookingTypeFieldPolicy = {
	availabilityType?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingProcess?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingSlots?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingTypeLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	eventLength?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	hosts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interval?: FieldPolicy<any> | FieldReadFunction<any>,
	locationString?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingInfoNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingTypeHostKeySpecifier = ('id' | 'vendorUser' | BookingTypeHostKeySpecifier)[];
export type BookingTypeHostFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingSlotCalendarInfoKeySpecifier = ('htmlLink' | 'id' | BookingSlotCalendarInfoKeySpecifier)[];
export type BookingSlotCalendarInfoFieldPolicy = {
	htmlLink?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingSlotCustomerInsightsKeySpecifier = ('address' | 'companyWebsite' | 'consideredVenues' | 'engagementDate' | 'hiredVendors' | 'hostedEventBefore' | 'id' | 'pastVenues' | 'venueEventType' | BookingSlotCustomerInsightsKeySpecifier)[];
export type BookingSlotCustomerInsightsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	companyWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	consideredVenues?: FieldPolicy<any> | FieldReadFunction<any>,
	engagementDate?: FieldPolicy<any> | FieldReadFunction<any>,
	hiredVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	hostedEventBefore?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	pastVenues?: FieldPolicy<any> | FieldReadFunction<any>,
	venueEventType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MeetingBlockKeySpecifier = ('end' | 'meetingEnd' | 'meetingStart' | 'start' | MeetingBlockKeySpecifier)[];
export type MeetingBlockFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	meetingStart?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundContributionReceiptKeySpecifier = ('contributionAmount' | 'fees' | 'total' | 'totalFees' | CashFundContributionReceiptKeySpecifier)[];
export type CashFundContributionReceiptFieldPolicy = {
	contributionAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFees?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundContributionFeeKeySpecifier = ('amount' | CashFundContributionFeeKeySpecifier)[];
export type CashFundContributionFeeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalculateRegistryPurchaseInfoKeySpecifier = ('checkoutWarningCodes' | 'compensation' | 'compensationTotal' | 'orderCharges' | 'orderChargesTotal' | 'postPurchaseFees' | 'postPurchaseFeesTotal' | 'shippingAndHandling' | 'shippingAndHandlingTotal' | CalculateRegistryPurchaseInfoKeySpecifier)[];
export type CalculateRegistryPurchaseInfoFieldPolicy = {
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	compensation?: FieldPolicy<any> | FieldReadFunction<any>,
	compensationTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	orderChargesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	postPurchaseFees?: FieldPolicy<any> | FieldReadFunction<any>,
	postPurchaseFeesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAndHandling?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAndHandlingTotal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderCompensationLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderCompensationLineKeySpecifier)[];
export type SalesOrderCompensationLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderLineKeySpecifier)[];
export type SalesOrderLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderChargeLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderChargeLineKeySpecifier)[];
export type SalesOrderChargeLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderPostPurchaseFeeLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderPostPurchaseFeeLineKeySpecifier)[];
export type SalesOrderPostPurchaseFeeLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderShippingAndHandlingLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderShippingAndHandlingLineKeySpecifier)[];
export type SalesOrderShippingAndHandlingLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckRegistryUrlResultKeySpecifier = ('canSync' | 'canTransfer' | CheckRegistryUrlResultKeySpecifier)[];
export type CheckRegistryUrlResultFieldPolicy = {
	canSync?: FieldPolicy<any> | FieldReadFunction<any>,
	canTransfer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvalidTransitionalRegistryUrlResultKeySpecifier = ('message' | 'reasonCode' | InvalidTransitionalRegistryUrlResultKeySpecifier)[];
export type InvalidTransitionalRegistryUrlResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidTransitionalRegistryUrlResultKeySpecifier = ('canonicalUrl' | ValidTransitionalRegistryUrlResultKeySpecifier)[];
export type ValidTransitionalRegistryUrlResultFieldPolicy = {
	canonicalUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComputedProductHeuristicOutputKeySpecifier = ('lines' | 'shipWhatWeCan' | ComputedProductHeuristicOutputKeySpecifier)[];
export type ComputedProductHeuristicOutputFieldPolicy = {
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	shipWhatWeCan?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComputedProductHeuristicOutput_LineKeySpecifier = ('declineReason' | 'match' | 'pricingWindow' | 'telemetry' | ComputedProductHeuristicOutput_LineKeySpecifier)[];
export type ComputedProductHeuristicOutput_LineFieldPolicy = {
	declineReason?: FieldPolicy<any> | FieldReadFunction<any>,
	match?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingWindow?: FieldPolicy<any> | FieldReadFunction<any>,
	telemetry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeuristicMatchedProductKeySpecifier = ('catalogItem' | 'itemType' | 'joySKU' | ProductHeuristicMatchedProductKeySpecifier)[];
export type ProductHeuristicMatchedProductFieldPolicy = {
	catalogItem?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	joySKU?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemKeySpecifier = ('attributes' | 'brand' | 'checkoutUrl' | 'collectionDisplayInfos' | 'fulfillmentMethod' | 'fullPrice' | 'group' | 'groupDimensionOptions' | 'id' | 'isFullPrice' | 'isNewArrival' | 'itemType' | 'joySKU' | 'longDescription' | 'mediaAssets' | 'parentCategories' | 'pdpSections' | 'photos' | 'price' | 'product' | 'productUrl' | 'publicUrlPath' | 'rating' | 'retailer' | 'shortDescription' | 'storefrontInfo' | 'subCategories' | 'tags' | 'tilePresentation' | 'title' | 'whyWeLoveIt' | ProductCatalogItemKeySpecifier)[];
export type ProductCatalogItemFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDisplayInfos?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillmentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	fullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupDimensionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewArrival?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	joySKU?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	parentCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	pdpSections?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrlPath?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	retailer?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	storefrontInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	subCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tilePresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	whyWeLoveIt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeJunctionKeySpecifier = ('compositeCode' | 'group' | 'id' | 'value' | ProductAttributeJunctionKeySpecifier)[];
export type ProductAttributeJunctionFieldPolicy = {
	compositeCode?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeGroupKeySpecifier = ('attributes' | 'code' | 'description' | 'filterSelectionType' | 'id' | 'title' | 'valueType' | ProductAttributeGroupKeySpecifier)[];
export type ProductAttributeGroupFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	filterSelectionType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeValueKeySpecifier = ('code' | 'color' | 'description' | 'id' | 'imageUrl' | 'price' | 'title' | ProductAttributeValueKeySpecifier)[];
export type ProductAttributeValueFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandKeySpecifier = ('description' | 'featuredCategories' | 'header' | 'id' | 'logoImage' | 'name' | 'publicUrlPath' | 'showcaseCategories' | ProductCatalogBrandKeySpecifier)[];
export type ProductCatalogBrandFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrlPath?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseCategories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogFeaturedBrandCategoryKeySpecifier = ('category' | 'title' | ProductCatalogFeaturedBrandCategoryKeySpecifier)[];
export type ProductCatalogFeaturedBrandCategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCategoryKeySpecifier = ('browseMoreBanner' | 'campaignLabel' | 'categoryExtensionsData' | 'children' | 'curationData' | 'directItemCount' | 'heroText' | 'id' | 'isFeatured' | 'isParentType' | 'isSpotlight' | 'lineage' | 'locator' | 'parent' | 'prunedChildren' | 'prunedLineage' | 'publicUrlPath' | 'seoRedirectPath' | 'showcase' | 'showcaseBrands' | 'spotlight' | 'thumbnail' | 'tileItemImages' | 'title' | 'totalItemCount' | ProductCatalogCategoryKeySpecifier)[];
export type ProductCatalogCategoryFieldPolicy = {
	browseMoreBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	campaignLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryExtensionsData?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	curationData?: FieldPolicy<any> | FieldReadFunction<any>,
	directItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	heroText?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFeatured?: FieldPolicy<any> | FieldReadFunction<any>,
	isParentType?: FieldPolicy<any> | FieldReadFunction<any>,
	isSpotlight?: FieldPolicy<any> | FieldReadFunction<any>,
	lineage?: FieldPolicy<any> | FieldReadFunction<any>,
	locator?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	prunedChildren?: FieldPolicy<any> | FieldReadFunction<any>,
	prunedLineage?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrlPath?: FieldPolicy<any> | FieldReadFunction<any>,
	seoRedirectPath?: FieldPolicy<any> | FieldReadFunction<any>,
	showcase?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseBrands?: FieldPolicy<any> | FieldReadFunction<any>,
	spotlight?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	tileItemImages?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItemCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCategoryBrowseBannerMoreKeySpecifier = ('image' | 'videoPlaceholder' | 'videoThumbnail' | 'videoUrl' | ProductCatalogCategoryBrowseBannerMoreKeySpecifier)[];
export type ProductCatalogCategoryBrowseBannerMoreFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	videoPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>,
	videoThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCategoryExtensionsKeySpecifier = ('topBrandsCollectionDisplayInfo' | ProductCatalogCategoryExtensionsKeySpecifier)[];
export type ProductCatalogCategoryExtensionsFieldPolicy = {
	topBrandsCollectionDisplayInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCollectionDisplayInfoToCategoryKeySpecifier = ('collection' | 'displayInfoId' | 'displayType' | 'id' | 'title' | ProductCatalogCollectionDisplayInfoToCategoryKeySpecifier)[];
export type ProductCatalogCollectionDisplayInfoToCategoryFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	displayInfoId?: FieldPolicy<any> | FieldReadFunction<any>,
	displayType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCollectionDisplayInfoInterfaceKeySpecifier = ('collection' | 'displayInfoId' | 'displayType' | 'id' | 'title' | ProductCatalogCollectionDisplayInfoInterfaceKeySpecifier)[];
export type ProductCatalogCollectionDisplayInfoInterfaceFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	displayInfoId?: FieldPolicy<any> | FieldReadFunction<any>,
	displayType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCollectionKeySpecifier = ('collectionType' | 'id' | 'members' | ProductCatalogCollectionKeySpecifier)[];
export type ProductCatalogCollectionFieldPolicy = {
	collectionType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityKeySpecifier = ('id' | ProductCatalogEntityKeySpecifier)[];
export type ProductCatalogEntityFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCurationKeySpecifier = ('category' | 'curationSource' | 'description' | 'header' | 'id' | 'photos' | 'videoThumbnailUrl' | 'videoUrl' | ProductCatalogCurationKeySpecifier)[];
export type ProductCatalogCurationFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	curationSource?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	videoThumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCurationHeaderKeySpecifier = ('backgroundImage' | 'description' | 'eyebrow' | 'gradient1' | 'gradient2' | 'gradientColor' | 'id' | 'logoImage' | 'textColor' | 'title' | 'video' | 'videoThumbnail' | ProductCatalogCurationHeaderKeySpecifier)[];
export type ProductCatalogCurationHeaderFieldPolicy = {
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eyebrow?: FieldPolicy<any> | FieldReadFunction<any>,
	gradient1?: FieldPolicy<any> | FieldReadFunction<any>,
	gradient2?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>,
	videoThumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCategoryShowcaseKeySpecifier = ('image' | 'title' | 'video' | ProductCatalogCategoryShowcaseKeySpecifier)[];
export type ProductCatalogCategoryShowcaseFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogVideoKeySpecifier = ('fallbackImage' | 'thumbnail' | 'url' | ProductCatalogVideoKeySpecifier)[];
export type ProductCatalogVideoFieldPolicy = {
	fallbackImage?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogShowcaseBrandKeySpecifier = ('brand' | 'showcase' | ProductCatalogShowcaseBrandKeySpecifier)[];
export type ProductCatalogShowcaseBrandFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	showcase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandShowcaseKeySpecifier = ('image' | 'title' | 'video' | ProductCatalogBrandShowcaseKeySpecifier)[];
export type ProductCatalogBrandShowcaseFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCategorySpotlightKeySpecifier = ('image' | 'title' | 'videoPlaceholder' | 'videoThumbnail' | 'videoUrl' | ProductCatalogCategorySpotlightKeySpecifier)[];
export type ProductCatalogCategorySpotlightFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	videoPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>,
	videoThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandHeaderKeySpecifier = ('backgroundImage' | 'description' | 'gradientColor' | 'gradientMarkup' | 'id' | 'logoImage' | 'textColor' | 'title' | 'videoThumbnail' | 'videoUrl' | ProductCatalogBrandHeaderKeySpecifier)[];
export type ProductCatalogBrandHeaderFieldPolicy = {
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientMarkup?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	videoThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogShowcaseCategoryKeySpecifier = ('category' | 'showcase' | ProductCatalogShowcaseCategoryKeySpecifier)[];
export type ProductCatalogShowcaseCategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	showcase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogCollectionDisplayInfoKeySpecifier = ('collection' | 'displayInfoId' | 'displayType' | 'id' | 'pdpSectionType' | 'title' | ProductCatalogCollectionDisplayInfoKeySpecifier)[];
export type ProductCatalogCollectionDisplayInfoFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	displayInfoId?: FieldPolicy<any> | FieldReadFunction<any>,
	displayType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	pdpSectionType?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemGroupKeySpecifier = ('groupDimensionCount' | 'groupDimensions' | 'id' | 'items' | 'prunedItems' | 'tileViewDimension' | 'tileViewItem' | 'totalItemCount' | ProductCatalogItemGroupKeySpecifier)[];
export type ProductCatalogItemGroupFieldPolicy = {
	groupDimensionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	groupDimensions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	prunedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	tileViewDimension?: FieldPolicy<any> | FieldReadFunction<any>,
	tileViewItem?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItemCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemGroupDimensionKeySpecifier = ('id' | 'options' | 'swatchType' | 'title' | ProductCatalogItemGroupDimensionKeySpecifier)[];
export type ProductCatalogItemGroupDimensionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	swatchType?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemGroupDimensionOptionKeySpecifier = ('displayString' | 'groupDimension' | 'id' | 'swatchColor' | 'swatchType' | 'swatchUrl' | ProductCatalogItemGroupDimensionOptionKeySpecifier)[];
export type ProductCatalogItemGroupDimensionOptionFieldPolicy = {
	displayString?: FieldPolicy<any> | FieldReadFunction<any>,
	groupDimension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	swatchColor?: FieldPolicy<any> | FieldReadFunction<any>,
	swatchType?: FieldPolicy<any> | FieldReadFunction<any>,
	swatchUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogPhotoAssetKeySpecifier = ('photo' | 'type' | ProductCatalogPhotoAssetKeySpecifier)[];
export type ProductCatalogPhotoAssetFieldPolicy = {
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogVideoAssetKeySpecifier = ('type' | 'video' | ProductCatalogVideoAssetKeySpecifier)[];
export type ProductCatalogVideoAssetFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PDPSectionKeySpecifier = ('collectionType' | 'sectionTree' | 'sectionType' | PDPSectionKeySpecifier)[];
export type PDPSectionFieldPolicy = {
	collectionType?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTree?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PDPSectionTreeKeySpecifier = ('elements' | 'rootElementKey' | PDPSectionTreeKeySpecifier)[];
export type PDPSectionTreeFieldPolicy = {
	elements?: FieldPolicy<any> | FieldReadFunction<any>,
	rootElementKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PDPElementKeySpecifier = ('childrenKeys' | 'elementType' | 'html' | 'key' | 'photo' | 'text' | PDPElementKeySpecifier)[];
export type PDPElementFieldPolicy = {
	childrenKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	elementType?: FieldPolicy<any> | FieldReadFunction<any>,
	html?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingProductKeySpecifier = ('id' | 'reviews' | 'stats' | RatingProductKeySpecifier)[];
export type RatingProductFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reviews?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewSearchResultContainerKeySpecifier = ('pagedResults' | RatingReviewSearchResultContainerKeySpecifier)[];
export type RatingReviewSearchResultContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewsPaginationKeySpecifier = ('edges' | 'pageInfo' | RatingReviewsPaginationKeySpecifier)[];
export type RatingReviewsPaginationFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewEdgeKeySpecifier = ('cursor' | 'node' | RatingReviewEdgeKeySpecifier)[];
export type RatingReviewEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewKeySpecifier = ('authorName' | 'description' | 'id' | 'mediaAssets' | 'ratingBucket' | 'submittedAt' | 'syndicationSource' | 'syndicationSourceV2' | 'title' | RatingReviewKeySpecifier)[];
export type RatingReviewFieldPolicy = {
	authorName?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	syndicationSource?: FieldPolicy<any> | FieldReadFunction<any>,
	syndicationSourceV2?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewPhotoAssetKeySpecifier = ('photo' | 'type' | RatingReviewPhotoAssetKeySpecifier)[];
export type RatingReviewPhotoAssetFieldPolicy = {
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewPhotoKeySpecifier = ('normal' | 'thumbnail' | RatingReviewPhotoKeySpecifier)[];
export type RatingReviewPhotoFieldPolicy = {
	normal?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewPhotoDataKeySpecifier = ('id' | 'url' | RatingReviewPhotoDataKeySpecifier)[];
export type RatingReviewPhotoDataFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewVideoAssetKeySpecifier = ('type' | 'video' | RatingReviewVideoAssetKeySpecifier)[];
export type RatingReviewVideoAssetFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewVideoKeySpecifier = ('id' | RatingReviewVideoKeySpecifier)[];
export type RatingReviewVideoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingSyndicationSourceKeySpecifier = ('id' | 'logoImage' | 'name' | RatingSyndicationSourceKeySpecifier)[];
export type RatingSyndicationSourceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingSyndicationSourceV2KeySpecifier = ('id' | 'logoImage' | 'name' | RatingSyndicationSourceV2KeySpecifier)[];
export type RatingSyndicationSourceV2FieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingReviewsPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'totalCount' | RatingReviewsPageInfoKeySpecifier)[];
export type RatingReviewsPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingStatsKeySpecifier = ('averageRating' | 'distribution' | 'id' | 'totalReviewCount' | 'traits' | RatingStatsKeySpecifier)[];
export type RatingStatsFieldPolicy = {
	averageRating?: FieldPolicy<any> | FieldReadFunction<any>,
	distribution?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	totalReviewCount?: FieldPolicy<any> | FieldReadFunction<any>,
	traits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingBucketDistributionKeySpecifier = ('count' | 'id' | 'percentage' | 'ratingBucket' | RatingBucketDistributionKeySpecifier)[];
export type RatingBucketDistributionFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingBucket?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingTraitKeySpecifier = ('averageRating' | 'id' | 'label' | RatingTraitKeySpecifier)[];
export type RatingTraitFieldPolicy = {
	averageRating?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogRetailerKeySpecifier = ('name' | ProductCatalogRetailerKeySpecifier)[];
export type ProductCatalogRetailerFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogStorefrontInfoKeySpecifier = ('canAddToCart' | 'canAddToRegistry' | 'storefrontStatus' | ProductCatalogStorefrontInfoKeySpecifier)[];
export type ProductCatalogStorefrontInfoFieldPolicy = {
	canAddToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	storefrontStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemTilePresentationKeySpecifier = ('fullPriceRange' | 'isFullPrice' | 'longDescription' | 'photos' | 'presentationType' | 'priceRange' | 'shortDescription' | 'title' | ProductCatalogItemTilePresentationKeySpecifier)[];
export type ProductCatalogItemTilePresentationFieldPolicy = {
	fullPriceRange?: FieldPolicy<any> | FieldReadFunction<any>,
	isFullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	presentationType?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRange?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMonetaryValueRangeKeySpecifier = ('isSinglePrice' | 'lowerPrice' | 'upperPrice' | ProductMonetaryValueRangeKeySpecifier)[];
export type ProductMonetaryValueRangeFieldPolicy = {
	isSinglePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	lowerPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	upperPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeuristicPricingWindowKeySpecifier = ('costInMinorUnits' | 'currency' | 'mapInMinorUnits' | 'msrpInMinorUnits' | ProductHeuristicPricingWindowKeySpecifier)[];
export type ProductHeuristicPricingWindowFieldPolicy = {
	costInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	mapInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	msrpInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComputedProductHeuristicExtraInfoKeySpecifier = ('warehouseItem' | ComputedProductHeuristicExtraInfoKeySpecifier)[];
export type ComputedProductHeuristicExtraInfoFieldPolicy = {
	warehouseItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseItemKeySpecifier = ('fulfillmentMethod' | 'id' | 'itemType' | 'productPolicyType' | 'safeInventoryQty' | 'supplierProducts' | 'taxCode' | WarehouseItemKeySpecifier)[];
export type WarehouseItemFieldPolicy = {
	fulfillmentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	productPolicyType?: FieldPolicy<any> | FieldReadFunction<any>,
	safeInventoryQty?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseSupplierProductKeySpecifier = ('inventory' | 'inventoryCost' | 'shippingMethods' | 'supplier' | WarehouseSupplierProductKeySpecifier)[];
export type WarehouseSupplierProductFieldPolicy = {
	inventory?: FieldPolicy<any> | FieldReadFunction<any>,
	inventoryCost?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseSupplierProductInventoryKeySpecifier = ('cost' | 'qty' | WarehouseSupplierProductInventoryKeySpecifier)[];
export type WarehouseSupplierProductInventoryFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseShippingMethodKeySpecifier = ('carrierCode' | 'serviceLevel' | 'standardCode' | 'title' | WarehouseShippingMethodKeySpecifier)[];
export type WarehouseShippingMethodFieldPolicy = {
	carrierCode?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	standardCode?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseSupplierKeySpecifier = ('hasSubstitutionEmailsEnabled' | 'logicbrokerId' | WarehouseSupplierKeySpecifier)[];
export type WarehouseSupplierFieldPolicy = {
	hasSubstitutionEmailsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	logicbrokerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactQuarantinedMessageBatchContainerKeySpecifier = ('pagedResults' | ContactQuarantinedMessageBatchContainerKeySpecifier)[];
export type ContactQuarantinedMessageBatchContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactQuarantinedMessageBatchConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ContactQuarantinedMessageBatchConnectionKeySpecifier)[];
export type ContactQuarantinedMessageBatchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactQuarantinedMessageBatchEdgeKeySpecifier = ('cursor' | 'node' | ContactQuarantinedMessageBatchEdgeKeySpecifier)[];
export type ContactQuarantinedMessageBatchEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactQuarantinedMessageBatchDetailsKeySpecifier = ('createdAt' | 'eventId' | 'id' | 'messageBatchId' | 'messageBatchPayload' | 'messageBatchType' | 'quarantineStatus' | 'reviewedAt' | 'reviewedByUserId' | 'spamIndicatorsPayload' | 'updatedAt' | ContactQuarantinedMessageBatchDetailsKeySpecifier)[];
export type ContactQuarantinedMessageBatchDetailsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchPayload?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchType?: FieldPolicy<any> | FieldReadFunction<any>,
	quarantineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	spamIndicatorsPayload?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactQuarantinedMessageBatchPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | ContactQuarantinedMessageBatchPageInfoKeySpecifier)[];
export type ContactQuarantinedMessageBatchPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SanitizedContactQuarantinedMessageBatchDetailsKeySpecifier = ('createdAt' | 'eventId' | 'id' | 'messageBatchId' | 'messageBatchPayload' | 'messageBatchType' | 'updatedAt' | SanitizedContactQuarantinedMessageBatchDetailsKeySpecifier)[];
export type SanitizedContactQuarantinedMessageBatchDetailsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchPayload?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyConversionKeySpecifier = ('currencyCode' | 'exchangeRate' | 'fixedCostPerCardInMinorUnits' | 'precision' | 'taxesAndFeesMultiplier' | CurrencyConversionKeySpecifier)[];
export type CurrencyConversionFieldPolicy = {
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeRate?: FieldPolicy<any> | FieldReadFunction<any>,
	fixedCostPerCardInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	precision?: FieldPolicy<any> | FieldReadFunction<any>,
	taxesAndFeesMultiplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerInsightsKeySpecifier = ('alternateEmail' | 'displayName' | 'email' | 'enrichedCompanyInsights' | 'enrichedInsights' | 'enrichedInsightsData' | 'id' | 'isCompanyInsights' | 'phoneNumber' | 'phoneNumberE164' | 'rawData' | CustomerInsightsKeySpecifier)[];
export type CustomerInsightsFieldPolicy = {
	alternateEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enrichedCompanyInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	enrichedInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	enrichedInsightsData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCompanyInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberE164?: FieldPolicy<any> | FieldReadFunction<any>,
	rawData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnrichedCompanyInsightsKeySpecifier = ('companyDisplayName' | 'employeeCount' | 'facebookUrl' | 'founded' | 'industry' | 'linkedInUrl' | 'logo' | 'summary' | 'twitterUrl' | 'website' | EnrichedCompanyInsightsKeySpecifier)[];
export type EnrichedCompanyInsightsFieldPolicy = {
	companyDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	facebookUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	founded?: FieldPolicy<any> | FieldReadFunction<any>,
	industry?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedInUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	twitterUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnrichedCustomerInsightsKeySpecifier = ('age' | 'earnings' | 'econStability' | 'education' | 'employmentCity' | 'employmentCompany' | 'employmentCountry' | 'employmentHistory' | 'employmentLinkedIn' | 'employmentLogo' | 'employmentPostalCode' | 'employmentState' | 'employmentTitle' | 'employmentWeb' | 'homeOwner' | 'homeWorth' | 'interests' | 'language' | 'linkedInProfile' | 'netWork' | 'socioeconStatus' | EnrichedCustomerInsightsKeySpecifier)[];
export type EnrichedCustomerInsightsFieldPolicy = {
	age?: FieldPolicy<any> | FieldReadFunction<any>,
	earnings?: FieldPolicy<any> | FieldReadFunction<any>,
	econStability?: FieldPolicy<any> | FieldReadFunction<any>,
	education?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentCity?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentLinkedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentLogo?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentPostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentState?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	employmentWeb?: FieldPolicy<any> | FieldReadFunction<any>,
	homeOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	homeWorth?: FieldPolicy<any> | FieldReadFunction<any>,
	interests?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedInProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	netWork?: FieldPolicy<any> | FieldReadFunction<any>,
	socioeconStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnrichedCustomerEmploymentDataKeySpecifier = ('current' | 'endDate' | 'monthsOfExperience' | 'organization' | 'startDate' | 'title' | 'website' | 'yearsOfExperience' | EnrichedCustomerEmploymentDataKeySpecifier)[];
export type EnrichedCustomerEmploymentDataFieldPolicy = {
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	monthsOfExperience?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>,
	yearsOfExperience?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnrichedCustomerInterestKeySpecifier = ('description' | 'interest' | EnrichedCustomerInterestKeySpecifier)[];
export type EnrichedCustomerInterestFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	interest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventAdminInviteKeySpecifier = ('emailId' | 'id' | 'name' | 'status' | EventAdminInviteKeySpecifier)[];
export type EventAdminInviteFieldPolicy = {
	emailId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTypesConfigKeySpecifier = ('category' | 'categorySubtype' | 'configJson' | 'createAt' | 'deleted' | 'description' | 'enabled' | 'id' | 'schemaUrl' | 'title' | 'updateAt' | EventTypesConfigKeySpecifier)[];
export type EventTypesConfigFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categorySubtype?: FieldPolicy<any> | FieldReadFunction<any>,
	configJson?: FieldPolicy<any> | FieldReadFunction<any>,
	createAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilestackKeySpecifier = ('apiKey' | 'policy' | 'signature' | FilestackKeySpecifier)[];
export type FilestackFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	policy?: FieldPolicy<any> | FieldReadFunction<any>,
	signature?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundsHostKeySpecifier = ('cashFunds' | 'event' | 'firstName' | 'id' | 'lastName' | 'payoutAccount' | CashFundsHostKeySpecifier)[];
export type CashFundsHostFieldPolicy = {
	cashFunds?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	payoutAccount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundKeySpecifier = ('adminUrl' | 'archived' | 'contributions' | 'createdAt' | 'currencyCode' | 'fixedContributionAmount' | 'hideGoal' | 'id' | 'name' | 'note' | 'photo' | 'publicTotalContributedAmount' | 'publicTotalGoal' | 'publicUrl' | 'solicitations' | 'totalContributedAmount' | 'totalGoal' | 'updatedAt' | CashFundKeySpecifier)[];
export type CashFundFieldPolicy = {
	adminUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	archived?: FieldPolicy<any> | FieldReadFunction<any>,
	contributions?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	fixedContributionAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	hideGoal?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	publicTotalContributedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	publicTotalGoal?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	solicitations?: FieldPolicy<any> | FieldReadFunction<any>,
	totalContributedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGoal?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundContributionKeySpecifier = ('adminUrl' | 'amount' | 'cashFund' | 'contributor' | 'createdAt' | 'id' | 'message' | 'order' | 'receiptUrl' | 'status' | CashFundContributionKeySpecifier)[];
export type CashFundContributionFieldPolicy = {
	adminUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	cashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	contributor?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundContributorKeySpecifier = ('email' | 'fullName' | 'id' | CashFundContributorKeySpecifier)[];
export type CashFundContributorFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundOrderKeySpecifier = ('contributionAmount' | 'id' | 'status' | 'total' | 'totalFees' | 'totalTaxes' | CashFundOrderKeySpecifier)[];
export type CashFundOrderFieldPolicy = {
	contributionAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFees?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTaxes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundSolicitationKeySpecifier = ('cashFund' | 'config' | 'createdAt' | 'id' | 'inviteMessage' | 'invites' | 'inviteSubject' | 'lastSentAt' | 'name' | 'status' | 'updatedAt' | CashFundSolicitationKeySpecifier)[];
export type CashFundSolicitationFieldPolicy = {
	cashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	invites?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteSubject?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundSolicitationConfigKeySpecifier = ('buttonText' | 'includeRecipientNames' | 'photo' | 'salutation' | CashFundSolicitationConfigKeySpecifier)[];
export type CashFundSolicitationConfigFieldPolicy = {
	buttonText?: FieldPolicy<any> | FieldReadFunction<any>,
	includeRecipientNames?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundSolicitationInviteKeySpecifier = ('actionUrl' | 'email' | 'fullName' | 'guestKey' | 'id' | 'solicitation' | 'token' | CashFundSolicitationInviteKeySpecifier)[];
export type CashFundSolicitationInviteFieldPolicy = {
	actionUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	solicitation?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundsPayoutAccountKeySpecifier = ('balance' | 'onboardingUrl' | 'status' | 'withdrawals' | CashFundsPayoutAccountKeySpecifier)[];
export type CashFundsPayoutAccountFieldPolicy = {
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundsPayoutAccountBalanceKeySpecifier = ('available' | 'availablePending' | 'received' | 'withdrawn' | 'withdrawnPending' | CashFundsPayoutAccountBalanceKeySpecifier)[];
export type CashFundsPayoutAccountBalanceFieldPolicy = {
	available?: FieldPolicy<any> | FieldReadFunction<any>,
	availablePending?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawn?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawnPending?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundsPayoutAccountWithdrawalKeySpecifier = ('id' | 'status' | CashFundsPayoutAccountWithdrawalKeySpecifier)[];
export type CashFundsPayoutAccountWithdrawalFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailDeliverySearchResultKeySpecifier = ('createdDate' | 'emailType' | 'eventId' | 'fromEmail' | 'mainContent' | 'messageBatchId' | 'messageId' | 'replyToEmail' | 'status' | 'statusHistory' | 'subject' | 'toEmail' | EmailDeliverySearchResultKeySpecifier)[];
export type EmailDeliverySearchResultFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailType?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	fromEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	mainContent?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageId?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	toEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelMatchResponseKeySpecifier = ('address' | 'link' | 'mainPhotoUrl' | 'name' | 'rate' | 'rating' | 'thumbnailUrl' | HotelMatchResponseKeySpecifier)[];
export type HotelMatchResponseFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	mainPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelMatchAddressKeySpecifier = ('address' | 'city' | 'country' | HotelMatchAddressKeySpecifier)[];
export type HotelMatchAddressFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindMatchingAccommodationCatalogPropertiesByDetailsResultKeySpecifier = ('accommodationCatalogProperty' | 'isExactMatch' | FindMatchingAccommodationCatalogPropertiesByDetailsResultKeySpecifier)[];
export type FindMatchingAccommodationCatalogPropertiesByDetailsResultFieldPolicy = {
	accommodationCatalogProperty?: FieldPolicy<any> | FieldReadFunction<any>,
	isExactMatch?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindMatchingAccommodationCatalogPropertyResultKeySpecifier = ('accommodationCatalogProperty' | FindMatchingAccommodationCatalogPropertyResultKeySpecifier)[];
export type FindMatchingAccommodationCatalogPropertyResultFieldPolicy = {
	accommodationCatalogProperty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FontPackKeySpecifier = ('configuration' | 'id' | 'name' | FontPackKeySpecifier)[];
export type FontPackFieldPolicy = {
	configuration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnswerKeySpecifier = ('answerValue' | 'contact' | 'createdAt' | 'formId' | 'guestKey' | 'id' | 'questionId' | 'questionValue' | AnswerKeySpecifier)[];
export type AnswerFieldPolicy = {
	answerValue?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	questionId?: FieldPolicy<any> | FieldReadFunction<any>,
	questionValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionValueKeySpecifier = ('field' | 'placeholder' | 'stepDescription' | 'stepName' | 'stepTitle' | QuestionValueKeySpecifier)[];
export type QuestionValueFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholder?: FieldPolicy<any> | FieldReadFunction<any>,
	stepDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	stepName?: FieldPolicy<any> | FieldReadFunction<any>,
	stepTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestFormAnswersKeySpecifier = ('answers' | 'guestKey' | GuestFormAnswersKeySpecifier)[];
export type GuestFormAnswersFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormKeySpecifier = ('answers' | 'config' | 'description' | 'enabled' | 'eventId' | 'id' | 'schemaUrl' | 'settings' | 'ticketTypes' | 'title' | 'type' | FormKeySpecifier)[];
export type FormFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TicketTypeKeySpecifier = ('availableCount' | 'capacity' | 'createdAt' | 'currency' | 'description' | 'eventId' | 'formId' | 'id' | 'name' | 'priceInMinorUnits' | 'reservedCount' | 'salesEndAt' | 'salesStartAt' | 'soldCount' | 'state' | 'updatedAt' | 'updatedBy' | TicketTypeKeySpecifier)[];
export type TicketTypeFieldPolicy = {
	availableCount?: FieldPolicy<any> | FieldReadFunction<any>,
	capacity?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	priceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	reservedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	salesEndAt?: FieldPolicy<any> | FieldReadFunction<any>,
	salesStartAt?: FieldPolicy<any> | FieldReadFunction<any>,
	soldCount?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormTemplateKeySpecifier = ('config' | 'description' | 'eventCategoryTags' | 'eventSubTypeTags' | 'id' | 'schemaUrl' | 'tags' | 'title' | FormTemplateKeySpecifier)[];
export type FormTemplateFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCategoryTags?: FieldPolicy<any> | FieldReadFunction<any>,
	eventSubTypeTags?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchTagKeySpecifier = ('name' | SearchTagKeySpecifier)[];
export type SearchTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundForContributionKeySpecifier = ('cashFund' | 'host' | 'invite' | CashFundForContributionKeySpecifier)[];
export type CashFundForContributionFieldPolicy = {
	cashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	host?: FieldPolicy<any> | FieldReadFunction<any>,
	invite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundPaymentAttemptKeySpecifier = ('amount' | 'cashFund' | 'completed' | 'contribution' | 'createdAt' | 'id' | 'order' | 'payer' | CashFundPaymentAttemptKeySpecifier)[];
export type CashFundPaymentAttemptFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	cashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	contribution?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundPayerKeySpecifier = ('email' | 'fullName' | 'message' | CashFundPayerKeySpecifier)[];
export type CashFundPayerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollaborationInviteKeySpecifier = ('eventId' | 'id' | 'inviteeEmailAddress' | 'inviteeFirstName' | 'inviteeLastName' | 'senderUserId' | 'state' | CollaborationInviteKeySpecifier)[];
export type CollaborationInviteFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteeEmailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	senderUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactCollectionKeySpecifier = ('active' | 'collectHousehold' | 'contacts' | 'eventDateDisplayEnabled' | 'eventId' | 'id' | 'magicLink' | 'mediaSource' | 'mediaType' | 'message' | 'websiteLinkEnabled' | ContactCollectionKeySpecifier)[];
export type ContactCollectionFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	collectHousehold?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDateDisplayEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	magicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaSource?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaType?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteLinkEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactKeySpecifier = ('createdAt' | 'email' | 'firstName' | 'guestKey' | 'household' | 'householdId' | 'id' | 'lastName' | 'legacyAddressString' | 'phoneNumber' | 'tags' | 'updatedAt' | ContactKeySpecifier)[];
export type ContactFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	household?: FieldPolicy<any> | FieldReadFunction<any>,
	householdId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyAddressString?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactHouseholdKeySpecifier = ('address' | 'authorizedUse' | 'contacts' | 'displayName' | 'id' | 'owner' | ContactHouseholdKeySpecifier)[];
export type ContactHouseholdFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizedUse?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactAddressKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'countryCode' | 'householdId' | 'id' | 'postalCode' | 'region' | 'validated' | ContactAddressKeySpecifier)[];
export type ContactAddressFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	householdId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	validated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactAuthorizedUseKeySpecifier = ('allow' | 'household' | 'personId' | ContactAuthorizedUseKeySpecifier)[];
export type ContactAuthorizedUseFieldPolicy = {
	allow?: FieldPolicy<any> | FieldReadFunction<any>,
	household?: FieldPolicy<any> | FieldReadFunction<any>,
	personId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactPhoneNumberKeySpecifier = ('allowSMS' | 'contact' | 'id' | 'label' | 'lastVerifiedAt' | 'mobile' | 'number' | ContactPhoneNumberKeySpecifier)[];
export type ContactPhoneNumberFieldPolicy = {
	allowSMS?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	lastVerifiedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	mobile?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactByFirebaseIdKeySpecifier = ('contact' | 'firebaseId' | ContactByFirebaseIdKeySpecifier)[];
export type ContactByFirebaseIdFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupKeySpecifier = ('eventId' | 'id' | 'members' | GroupKeySpecifier)[];
export type GroupFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMemberKeySpecifier = ('contact' | 'contactId' | 'groupId' | 'groupLeader' | 'id' | GroupMemberKeySpecifier)[];
export type GroupMemberFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupLeader?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElectronicCardKeySpecifier = ('activePerson' | 'additionalMessage' | 'coupleNameFormat' | 'design' | 'displayDateFormat' | 'displayDateFormatOptions' | 'displayDateString' | 'displayEventLink' | 'event' | 'eventId' | 'formattedCoupleName' | 'formattedCouplesNameOptions' | 'formattedLocationOptions' | 'guidId' | 'householdDisplayName' | 'id' | 'linkOptionPrimary' | 'linkOptionSecondary' | 'locationString' | 'locationStringFormat' | 'message' | 'owner' | 'photo' | 'photoEcardTheme' | 'photoEcardThemePositionX' | 'photoEcardThemePositionY' | 'photoEcardThemeScale' | 'recipients' | 'subTitle' | 'title' | 'type' | ElectronicCardKeySpecifier)[];
export type ElectronicCardFieldPolicy = {
	activePerson?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	coupleNameFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>,
	displayDateFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	displayDateFormatOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	displayDateString?: FieldPolicy<any> | FieldReadFunction<any>,
	displayEventLink?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedCoupleName?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedCouplesNameOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedLocationOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	guidId?: FieldPolicy<any> | FieldReadFunction<any>,
	householdDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkOptionPrimary?: FieldPolicy<any> | FieldReadFunction<any>,
	linkOptionSecondary?: FieldPolicy<any> | FieldReadFunction<any>,
	locationString?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStringFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	photoEcardTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	photoEcardThemePositionX?: FieldPolicy<any> | FieldReadFunction<any>,
	photoEcardThemePositionY?: FieldPolicy<any> | FieldReadFunction<any>,
	photoEcardThemeScale?: FieldPolicy<any> | FieldReadFunction<any>,
	recipients?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EcardDesignKeySpecifier = ('shouldUseEventDesign' | 'theme' | EcardDesignKeySpecifier)[];
export type EcardDesignFieldPolicy = {
	shouldUseEventDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElectronicCardEcardEmailDraftKeySpecifier = ('buttonLink' | 'buttonText' | 'date' | 'ecardId' | 'ecardType' | 'id' | 'imageUrl' | 'includeAddToCalendar' | 'includeAppInstructions' | 'includeDate' | 'includeEventPassword' | 'includeGuestNames' | 'includeWebsiteDetails' | 'message' | 'recipientIds' | 'replyToEmail' | 'salutation' | 'subject' | 'subTitle' | 'testEmail' | 'testName' | 'title' | ElectronicCardEcardEmailDraftKeySpecifier)[];
export type ElectronicCardEcardEmailDraftFieldPolicy = {
	buttonLink?: FieldPolicy<any> | FieldReadFunction<any>,
	buttonText?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	ecardId?: FieldPolicy<any> | FieldReadFunction<any>,
	ecardType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	includeAddToCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	includeAppInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	includeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	includeEventPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	includeGuestNames?: FieldPolicy<any> | FieldReadFunction<any>,
	includeWebsiteDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientIds?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	testEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	testName?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElectronicCardCardLinkOptionKeySpecifier = ('label' | 'name' | ElectronicCardCardLinkOptionKeySpecifier)[];
export type ElectronicCardCardLinkOptionFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailSearchResultsSummaryViewKeySpecifier = ('edges' | 'pageInfo' | EmailSearchResultsSummaryViewKeySpecifier)[];
export type EmailSearchResultsSummaryViewFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Email_ConnectionKeySpecifier = ('pageInfo' | Email_ConnectionKeySpecifier)[];
export type Email_ConnectionFieldPolicy = {
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Email_PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'totalPageCount' | Email_PageInfoKeySpecifier)[];
export type Email_PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPageCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailSearchCollectionItemsEdgeKeySpecifier = ('cursor' | 'node' | EmailSearchCollectionItemsEdgeKeySpecifier)[];
export type EmailSearchCollectionItemsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Email_EdgeKeySpecifier = ('cursor' | Email_EdgeKeySpecifier)[];
export type Email_EdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSearchResultSetKeySpecifier = ('resultCount' | 'results' | 'scoringBias' | 'terms' | 'totalCount' | EventSearchResultSetKeySpecifier)[];
export type EventSearchResultSetFieldPolicy = {
	resultCount?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>,
	scoringBias?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSearchResultKeySpecifier = ('event' | 'scoring' | EventSearchResultKeySpecifier)[];
export type EventSearchResultFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	scoring?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSearchScoringKeySpecifier = ('score' | 'scoreProximity' | 'scoreWeighted' | 'vectorSize' | EventSearchScoringKeySpecifier)[];
export type EventSearchScoringFieldPolicy = {
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	scoreProximity?: FieldPolicy<any> | FieldReadFunction<any>,
	scoreWeighted?: FieldPolicy<any> | FieldReadFunction<any>,
	vectorSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GreetingCardKeySpecifier = ('cardDetails' | 'eventId' | 'id' | 'purchaseID' | 'theme' | 'type' | GreetingCardKeySpecifier)[];
export type GreetingCardFieldPolicy = {
	cardDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseID?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMemberConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GroupMemberConnectionKeySpecifier)[];
export type GroupMemberConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMemberEdgeKeySpecifier = ('cursor' | 'node' | GroupMemberEdgeKeySpecifier)[];
export type GroupMemberEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupWithMembersKeySpecifier = ('eventId' | 'id' | 'members' | GroupWithMembersKeySpecifier)[];
export type GroupWithMembersFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberKeySpecifier = ('attendanceStatus' | 'contact' | 'groups' | 'guestKeys' | 'id' | 'registrationAnswers' | 'tags' | GuestListMemberKeySpecifier)[];
export type GuestListMemberFieldPolicy = {
	attendanceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberGroupKeySpecifier = ('groupId' | 'groupLeader' | GuestListMemberGroupKeySpecifier)[];
export type GuestListMemberGroupFieldPolicy = {
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupLeader?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberKeyKeySpecifier = ('disabledAt' | 'guestKey' | GuestListMemberKeyKeySpecifier)[];
export type GuestListMemberKeyFieldPolicy = {
	disabledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestRegistrationAnswerKeySpecifier = ('answerValue' | 'questionId' | GuestRegistrationAnswerKeySpecifier)[];
export type GuestRegistrationAnswerFieldPolicy = {
	answerValue?: FieldPolicy<any> | FieldReadFunction<any>,
	questionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberTagKeySpecifier = ('tagDefinitionId' | 'tagLabel' | GuestListMemberTagKeySpecifier)[];
export type GuestListMemberTagFieldPolicy = {
	tagDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	tagLabel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMemberPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | GroupMemberPageInfoKeySpecifier)[];
export type GroupMemberPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestFormViewKeySpecifier = ('form' | 'hiddenQuestionIds' | GuestFormViewKeySpecifier)[];
export type GuestFormViewFieldPolicy = {
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	hiddenQuestionIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeneralEventScheduleInfoKeySpecifier = ('formattedScheduleCount' | 'formattedSchedules' | 'itemCount' | 'items' | 'mainItem' | 'tbaSchedules' | GeneralEventScheduleInfoKeySpecifier)[];
export type GeneralEventScheduleInfoFieldPolicy = {
	formattedScheduleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedSchedules?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	mainItem?: FieldPolicy<any> | FieldReadFunction<any>,
	tbaSchedules?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GuestListMemberConnectionKeySpecifier)[];
export type GuestListMemberConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberEdgeKeySpecifier = ('cursor' | 'node' | GuestListMemberEdgeKeySpecifier)[];
export type GuestListMemberEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestListMemberPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | GuestListMemberPageInfoKeySpecifier)[];
export type GuestListMemberPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageBatchKeySpecifier = ('displayLabel' | 'emailCount' | 'id' | 'messageType' | 'sentOn' | 'smsCount' | MessageBatchKeySpecifier)[];
export type MessageBatchFieldPolicy = {
	displayLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	emailCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	messageType?: FieldPolicy<any> | FieldReadFunction<any>,
	sentOn?: FieldPolicy<any> | FieldReadFunction<any>,
	smsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageRelationResultKeySpecifier = ('externalMessageId' | 'id' | 'redirectUri' | 'relationshipTag' | 'status' | MessageRelationResultKeySpecifier)[];
export type MessageRelationResultFieldPolicy = {
	externalMessageId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUri?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipTag?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessagingSettingsKeySpecifier = ('eventDetailsAutomaticRemindersEnabled' | 'eventDetailsMessagingEnabled' | 'eventId' | 'id' | 'messagingTier' | 'rsvpNoCustomRedirectEnabled' | 'rsvpNoCustomRedirectUrl' | 'rsvpYesCustomRedirectEnabled' | 'rsvpYesCustomRedirectUrl' | MessagingSettingsKeySpecifier)[];
export type MessagingSettingsFieldPolicy = {
	eventDetailsAutomaticRemindersEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDetailsMessagingEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	messagingTier?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpNoCustomRedirectEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpNoCustomRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpYesCustomRedirectEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvpYesCustomRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhoneNumberInformationKeySpecifier = ('countryCode' | 'phoneNumber' | 'supportedDeliveryMethods' | 'valid' | PhoneNumberInformationKeySpecifier)[];
export type PhoneNumberInformationFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	supportedDeliveryMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostOfficeGenericEmailDraftKeySpecifier = ('eventId' | 'id' | 'imageUrl' | 'includeAppInstructions' | 'includeEventPassword' | 'includeGuestNames' | 'includeWebsiteDetails' | 'message' | 'personIds' | 'replyToEmail' | 'salutation' | 'subject' | PostOfficeGenericEmailDraftKeySpecifier)[];
export type PostOfficeGenericEmailDraftFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	includeAppInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	includeEventPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	includeGuestNames?: FieldPolicy<any> | FieldReadFunction<any>,
	includeWebsiteDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	personIds?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostOfficeGiftWrapEmailDraftKeySpecifier = ('assetId' | 'containerId' | 'eventId' | 'giftExtraCount' | 'giftImage' | 'giftLink' | 'giftProvider' | 'giftTitle' | 'id' | 'imageUrl' | 'message' | 'replyToEmail' | 'subject' | 'theme' | PostOfficeGiftWrapEmailDraftKeySpecifier)[];
export type PostOfficeGiftWrapEmailDraftFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	containerId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	giftExtraCount?: FieldPolicy<any> | FieldReadFunction<any>,
	giftImage?: FieldPolicy<any> | FieldReadFunction<any>,
	giftLink?: FieldPolicy<any> | FieldReadFunction<any>,
	giftProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	giftTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	theme?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostOfficeGreetingCardEmailDraftKeySpecifier = ('assetId' | 'containerId' | 'eventId' | 'greetingCardUrl' | 'id' | 'imageUrl' | 'replyToEmail' | 'subject' | PostOfficeGreetingCardEmailDraftKeySpecifier)[];
export type PostOfficeGreetingCardEmailDraftFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	containerId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	greetingCardUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostOfficeReminderEmailDraftKeySpecifier = ('eventId' | 'id' | 'imageUrl' | 'includeAppInstructions' | 'includeEventPassword' | 'includeGuestNames' | 'includeWebsiteDetails' | 'message' | 'personIds' | 'replyToEmail' | 'salutation' | 'subject' | PostOfficeReminderEmailDraftKeySpecifier)[];
export type PostOfficeReminderEmailDraftFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	includeAppInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	includeEventPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	includeGuestNames?: FieldPolicy<any> | FieldReadFunction<any>,
	includeWebsiteDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	personIds?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostOfficeThankYouEmailDraftKeySpecifier = ('assetId' | 'containerId' | 'eventId' | 'id' | 'imageUrl' | 'message' | 'personEmails' | 'personIds' | 'replyToEmail' | 'subject' | PostOfficeThankYouEmailDraftKeySpecifier)[];
export type PostOfficeThankYouEmailDraftFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	containerId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	personEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	personIds?: FieldPolicy<any> | FieldReadFunction<any>,
	replyToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistrationQuestionKeySpecifier = ('label' | 'questionId' | 'type' | RegistrationQuestionKeySpecifier)[];
export type RegistrationQuestionFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	questionId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryStaticDataKeySpecifier = ('countries' | 'currencies' | 'productStoreSections' | 'registryStoreSections' | RegistryStaticDataKeySpecifier)[];
export type RegistryStaticDataFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	productStoreSections?: FieldPolicy<any> | FieldReadFunction<any>,
	registryStoreSections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCountryResultsKeySpecifier = ('ordered' | 'topRanked' | RegistryCountryResultsKeySpecifier)[];
export type RegistryCountryResultsFieldPolicy = {
	ordered?: FieldPolicy<any> | FieldReadFunction<any>,
	topRanked?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCurrencyResultsKeySpecifier = ('ordered' | 'topRanked' | RegistryCurrencyResultsKeySpecifier)[];
export type RegistryCurrencyResultsFieldPolicy = {
	ordered?: FieldPolicy<any> | FieldReadFunction<any>,
	topRanked?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryStoreSectionKeySpecifier = ('name' | 'stores' | RegistryStoreSectionKeySpecifier)[];
export type RegistryStoreSectionFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stores?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryStoreKeySpecifier = ('addGiftsUrl' | 'allowCreateBeforeConnect' | 'connectAction' | 'createRegistryUrl' | 'domain' | 'homePageUrl' | 'hostname' | 'id' | 'isRecommended' | 'logos' | 'logosCompact' | 'longDescription' | 'name' | 'onlyForEventTypes' | 'recommendationsLocator' | 'searchUrl' | 'sectionName' | 'shortDescription' | 'valueProps' | RegistryStoreKeySpecifier)[];
export type RegistryStoreFieldPolicy = {
	addGiftsUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	allowCreateBeforeConnect?: FieldPolicy<any> | FieldReadFunction<any>,
	connectAction?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	homePageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	hostname?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRecommended?: FieldPolicy<any> | FieldReadFunction<any>,
	logos?: FieldPolicy<any> | FieldReadFunction<any>,
	logosCompact?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	onlyForEventTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendationsLocator?: FieldPolicy<any> | FieldReadFunction<any>,
	searchUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	valueProps?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('mimeType' | 'url' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryStoreValuePropositionKeySpecifier = ('image' | 'text' | RegistryStoreValuePropositionKeySpecifier)[];
export type RegistryStoreValuePropositionFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaggedResourceKeySpecifier = ('resourceId' | 'resourceType' | TaggedResourceKeySpecifier)[];
export type TaggedResourceFieldPolicy = {
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResourceVisibilityKeySpecifier = ('isVisible' | 'resourceId' | ResourceVisibilityKeySpecifier)[];
export type ResourceVisibilityFieldPolicy = {
	isVisible?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuestRsvpAnswerKeySpecifier = ('email' | 'personIdTag' | 'rsvp' | GuestRsvpAnswerKeySpecifier)[];
export type GuestRsvpAnswerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	personIdTag?: FieldPolicy<any> | FieldReadFunction<any>,
	rsvp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateSearchMetadataKeySpecifier = ('description' | 'tags' | 'templateID' | TemplateSearchMetadataKeySpecifier)[];
export type TemplateSearchMetadataFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	templateID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagDefinitionKeySpecifier = ('createdAt' | 'createdBy' | 'eventId' | 'id' | 'label' | 'updatedAt' | TagDefinitionKeySpecifier)[];
export type TagDefinitionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResourceTagsKeySpecifier = ('resourceId' | 'tags' | ResourceTagsKeySpecifier)[];
export type ResourceTagsFieldPolicy = {
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GoogleCalendarSyncOptionKeySpecifier = ('description' | 'id' | 'summary' | 'timeZone' | GoogleCalendarSyncOptionKeySpecifier)[];
export type GoogleCalendarSyncOptionFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GreetingsKeySpecifier = ('greeting' | GreetingsKeySpecifier)[];
export type GreetingsFieldPolicy = {
	greeting?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelInventoryImagesKeySpecifier = ('hotelId' | 'images' | HotelInventoryImagesKeySpecifier)[];
export type HotelInventoryImagesFieldPolicy = {
	hotelId?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelInventoryImageKeySpecifier = ('imageName' | 'thumbnailUrl' | 'url' | HotelInventoryImageKeySpecifier)[];
export type HotelInventoryImageFieldPolicy = {
	imageName?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelInventoryKeySpecifier = ('address' | 'city' | 'country' | 'description' | 'displayName' | 'distance' | 'facilityGroups' | 'hotelUrl' | 'isPreferredHotel' | 'location' | 'photo' | 'postalCode' | 'ratingCount' | 'starRating' | 'state' | 'type' | 'userRating' | 'zhId' | HotelInventoryKeySpecifier)[];
export type HotelInventoryFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	facilityGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreferredHotel?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>,
	zhId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FacilityGroupKeySpecifier = ('id' | 'name' | FacilityGroupKeySpecifier)[];
export type FacilityGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InventoryLocationKeySpecifier = ('lat' | 'lon' | InventoryLocationKeySpecifier)[];
export type InventoryLocationFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lon?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomsAndRatesKeySpecifier = ('hotelId' | 'rates' | 'rooms' | HotelRoomsAndRatesKeySpecifier)[];
export type HotelRoomsAndRatesFieldPolicy = {
	hotelId?: FieldPolicy<any> | FieldReadFunction<any>,
	rates?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomsAndRatesRateKeySpecifier = ('currency' | 'occupancies' | 'publishedRateWithTax' | 'rateId' | 'totalRateWithTax' | HotelRoomsAndRatesRateKeySpecifier)[];
export type HotelRoomsAndRatesRateFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	occupancies?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedRateWithTax?: FieldPolicy<any> | FieldReadFunction<any>,
	rateId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRateWithTax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomsAndRatesOccupancyKeySpecifier = ('childAges' | 'numOfAdults' | 'numOfChildren' | 'roomId' | HotelRoomsAndRatesOccupancyKeySpecifier)[];
export type HotelRoomsAndRatesOccupancyFieldPolicy = {
	childAges?: FieldPolicy<any> | FieldReadFunction<any>,
	numOfAdults?: FieldPolicy<any> | FieldReadFunction<any>,
	numOfChildren?: FieldPolicy<any> | FieldReadFunction<any>,
	roomId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelMonetaryValueKeySpecifier = ('currency' | 'digits' | 'floatingPointDecimalString' | 'valueInMinorUnits' | 'valueInMinorUnitsBigInt' | TravelMonetaryValueKeySpecifier)[];
export type TravelMonetaryValueFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	digits?: FieldPolicy<any> | FieldReadFunction<any>,
	floatingPointDecimalString?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnitsBigInt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomsAndRatesRoomKeySpecifier = ('beds' | 'description' | 'facilities' | 'id' | 'images' | 'name' | 'roomSquareFeet' | 'roomSquareMeters' | HotelRoomsAndRatesRoomKeySpecifier)[];
export type HotelRoomsAndRatesRoomFieldPolicy = {
	beds?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	roomSquareFeet?: FieldPolicy<any> | FieldReadFunction<any>,
	roomSquareMeters?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelRoomsAndRatesBedKeySpecifier = ('count' | 'type' | HotelRoomsAndRatesBedKeySpecifier)[];
export type HotelRoomsAndRatesBedFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HotelInventoryWithRoomsAndRatesKeySpecifier = ('address' | 'city' | 'country' | 'description' | 'displayName' | 'distance' | 'facilityGroups' | 'hotelId' | 'hotelUrl' | 'isPreferredHotel' | 'location' | 'photo' | 'postalCode' | 'rates' | 'ratingCount' | 'rooms' | 'starRating' | 'state' | 'type' | 'userRating' | 'zhId' | HotelInventoryWithRoomsAndRatesKeySpecifier)[];
export type HotelInventoryWithRoomsAndRatesFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	facilityGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelId?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreferredHotel?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	rates?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>,
	zhId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImprovedTextResponseKeySpecifier = ('action' | 'context' | 'improvedText' | 'originalText' | 'tokensUsed' | ImprovedTextResponseKeySpecifier)[];
export type ImprovedTextResponseFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	improvedText?: FieldPolicy<any> | FieldReadFunction<any>,
	originalText?: FieldPolicy<any> | FieldReadFunction<any>,
	tokensUsed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsightRagQueryResponseKeySpecifier = ('content' | 'posts' | InsightRagQueryResponseKeySpecifier)[];
export type InsightRagQueryResponseFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	posts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsightRagPostKeySpecifier = ('content' | 'description' | 'id' | 'title' | 'url' | InsightRagPostKeySpecifier)[];
export type InsightRagPostFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventSearchContainerKeySpecifier = ('pagedResults' | InternalEventSearchContainerKeySpecifier)[];
export type InternalEventSearchContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventSearchConnectionKeySpecifier = ('edges' | 'pageInfo' | InternalEventSearchConnectionKeySpecifier)[];
export type InternalEventSearchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventSearchEdgeKeySpecifier = ('cursor' | 'node' | InternalEventSearchEdgeKeySpecifier)[];
export type InternalEventSearchEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventSearchResultItemKeySpecifier = ('item' | InternalEventSearchResultItemKeySpecifier)[];
export type InternalEventSearchResultItemFieldPolicy = {
	item?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventKeySpecifier = ('firebaseId' | 'id' | 'info' | 'website' | InternalEventKeySpecifier)[];
export type InternalEventFieldPolicy = {
	firebaseId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalEventInfoKeySpecifier = ('eventDisplayName' | 'eventType' | 'id' | 'locale' | 'tentativeDate' | 'timezone' | InternalEventInfoKeySpecifier)[];
export type InternalEventInfoFieldPolicy = {
	eventDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	tentativeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSearchPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | EventSearchPageInfoKeySpecifier)[];
export type EventSearchPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalMessageSearchResultContainerKeySpecifier = ('allResults' | InternalMessageSearchResultContainerKeySpecifier)[];
export type InternalMessageSearchResultContainerFieldPolicy = {
	allResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalMessageResultKeySpecifier = ('messages' | 'totalSearchCount' | InternalMessageResultKeySpecifier)[];
export type InternalMessageResultFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSearchCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalMessageKeySpecifier = ('createAt' | 'id' | 'lastStatusUpdate' | 'messageBatchId' | 'messageId' | 'messageType' | 'rawStatus' | 'rawStatusHistory' | 'recipient' | 'sentForEventId' | 'type' | InternalMessageKeySpecifier)[];
export type InternalMessageFieldPolicy = {
	createAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageType?: FieldPolicy<any> | FieldReadFunction<any>,
	rawStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rawStatusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sentForEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalMessageStatusRecordKeySpecifier = ('date' | 'rawStatus' | 'statusMessage' | InternalMessageStatusRecordKeySpecifier)[];
export type InternalMessageStatusRecordFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	rawStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	statusMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalRecipientInfoKeySpecifier = ('email' | 'guestKey' | 'personId' | 'phoneNumber' | InternalRecipientInfoKeySpecifier)[];
export type InternalRecipientInfoFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	personId?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalPersonKeySpecifier = ('email' | 'firstName' | 'fullName' | 'id' | 'isGuest' | 'lastName' | 'personIdTag' | InternalPersonKeySpecifier)[];
export type InternalPersonFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	personIdTag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectBlockContainerKeySpecifier = ('pagedResults' | LinkRedirectBlockContainerKeySpecifier)[];
export type LinkRedirectBlockContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectBlockConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | LinkRedirectBlockConnectionKeySpecifier)[];
export type LinkRedirectBlockConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectBlockEdgeKeySpecifier = ('cursor' | 'node' | LinkRedirectBlockEdgeKeySpecifier)[];
export type LinkRedirectBlockEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectBlockKeySpecifier = ('blockType' | 'createdAt' | 'createdByUserId' | 'id' | 'reason' | 'targetValue' | LinkRedirectBlockKeySpecifier)[];
export type LinkRedirectBlockFieldPolicy = {
	blockType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	targetValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | LinkPageInfoKeySpecifier)[];
export type LinkPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectContainerKeySpecifier = ('pagedResults' | LinkRedirectContainerKeySpecifier)[];
export type LinkRedirectContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | LinkRedirectConnectionKeySpecifier)[];
export type LinkRedirectConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectEdgeKeySpecifier = ('cursor' | 'node' | LinkRedirectEdgeKeySpecifier)[];
export type LinkRedirectEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectKeySpecifier = ('active' | 'createdAt' | 'createdByUserId' | 'eventId' | 'history' | 'id' | 'joyUrl' | 'lastUpdatedAt' | 'lastUpdatedByUserId' | 'link' | 'redirectUrl' | LinkRedirectKeySpecifier)[];
export type LinkRedirectFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	joyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkRedirectHistoryEntryKeySpecifier = ('createdAt' | 'joyUrl' | 'linkRedirectId' | 'redirectUrl' | LinkRedirectHistoryEntryKeySpecifier)[];
export type LinkRedirectHistoryEntryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	joyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	linkRedirectId?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationSuggestionKeySpecifier = ('city' | 'coordinates' | 'country' | 'fullName' | 'name' | 'state' | 'type' | 'zhHotelId' | LocationSuggestionKeySpecifier)[];
export type LocationSuggestionFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	zhHotelId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarketingEmailPreferencesKeySpecifier = ('email' | 'preferences' | 'userId' | MarketingEmailPreferencesKeySpecifier)[];
export type MarketingEmailPreferencesFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	preferences?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessagePreferenceKeySpecifier = ('id' | 'isSubscribed' | 'name' | MessagePreferenceKeySpecifier)[];
export type MessagePreferenceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSubscribed?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaMagicTokenKeySpecifier = ('disabled' | 'permissions' | 'token' | MediaMagicTokenKeySpecifier)[];
export type MediaMagicTokenFieldPolicy = {
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageSearchResultContainerKeySpecifier = ('allResult' | MessageSearchResultContainerKeySpecifier)[];
export type MessageSearchResultContainerFieldPolicy = {
	allResult?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageResultKeySpecifier = ('messages' | 'totalSearchCount' | MessageResultKeySpecifier)[];
export type MessageResultFieldPolicy = {
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSearchCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageKeySpecifier = ('id' | 'lastStatusUpdate' | 'messageBatch' | 'messageId' | 'messageType' | 'recipient' | 'sentOn' | 'status' | 'statusHistory' | 'type' | MessageKeySpecifier)[];
export type MessageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	messageId?: FieldPolicy<any> | FieldReadFunction<any>,
	messageType?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sentOn?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecipientInfoKeySpecifier = ('email' | 'guestKey' | 'personId' | 'phoneNumber' | RecipientInfoKeySpecifier)[];
export type RecipientInfoFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	personId?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageStatusRecordKeySpecifier = ('date' | 'status' | MessageStatusRecordKeySpecifier)[];
export type MessageStatusRecordFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesActivityConnectionKeySpecifier = ('activities' | 'hasMore' | MilestonesActivityConnectionKeySpecifier)[];
export type MilestonesActivityConnectionFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesActivityKeySpecifier = ('action' | 'createdAt' | 'id' | 'metadata' | 'milestoneId' | 'milestoneName' | 'projectId' | 'userId' | MilestonesActivityKeySpecifier)[];
export type MilestonesActivityFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneId?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneName?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCalendarViewKeySpecifier = ('days' | 'month' | 'year' | MilestonesCalendarViewKeySpecifier)[];
export type MilestonesCalendarViewFieldPolicy = {
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCalendarDayKeySpecifier = ('date' | 'milestones' | MilestonesCalendarDayKeySpecifier)[];
export type MilestonesCalendarDayFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	milestones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesMilestoneKeySpecifier = ('activities' | 'assigneeUserId' | 'attachments' | 'category' | 'categoryId' | 'categoryRef' | 'comments' | 'dependencies' | 'dependents' | 'description' | 'dueDate' | 'id' | 'name' | 'phaseId' | 'projectId' | 'sortOrder' | 'startDate' | 'status' | 'statusNotes' | 'updatedAt' | 'updatedByUserId' | MilestonesMilestoneKeySpecifier)[];
export type MilestonesMilestoneFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	assigneeUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryRef?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	dependencies?: FieldPolicy<any> | FieldReadFunction<any>,
	dependents?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseId?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesAttachmentKeySpecifier = ('createdAt' | 'id' | 'milestoneId' | 'name' | 'uploadedByUserId' | 'url' | MilestonesAttachmentKeySpecifier)[];
export type MilestonesAttachmentFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCategoryKeySpecifier = ('createdAt' | 'id' | 'isSystemCategory' | 'milestoneCount' | 'name' | 'projectId' | MilestonesCategoryKeySpecifier)[];
export type MilestonesCategoryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSystemCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCommentKeySpecifier = ('createdAt' | 'id' | 'milestoneId' | 'text' | 'userId' | MilestonesCommentKeySpecifier)[];
export type MilestonesCommentFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneId?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesStatusNoteKeySpecifier = ('createdAt' | 'id' | 'milestoneId' | 'statusAtTime' | 'text' | 'userId' | MilestonesStatusNoteKeySpecifier)[];
export type MilestonesStatusNoteFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneId?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAtTime?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesGanttViewKeySpecifier = ('dependencyEdges' | 'milestones' | 'phases' | 'timeframe' | MilestonesGanttViewKeySpecifier)[];
export type MilestonesGanttViewFieldPolicy = {
	dependencyEdges?: FieldPolicy<any> | FieldReadFunction<any>,
	milestones?: FieldPolicy<any> | FieldReadFunction<any>,
	phases?: FieldPolicy<any> | FieldReadFunction<any>,
	timeframe?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesDependencyEdgeKeySpecifier = ('from' | 'to' | MilestonesDependencyEdgeKeySpecifier)[];
export type MilestonesDependencyEdgeFieldPolicy = {
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesGanttMilestoneKeySpecifier = ('dependencyIds' | 'milestone' | MilestonesGanttMilestoneKeySpecifier)[];
export type MilestonesGanttMilestoneFieldPolicy = {
	dependencyIds?: FieldPolicy<any> | FieldReadFunction<any>,
	milestone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesPhaseKeySpecifier = ('collapsed' | 'endDate' | 'focus' | 'id' | 'label' | 'projectId' | 'sortOrder' | 'startDate' | MilestonesPhaseKeySpecifier)[];
export type MilestonesPhaseFieldPolicy = {
	collapsed?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	focus?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesTimeframeKeySpecifier = ('end' | 'start' | MilestonesTimeframeKeySpecifier)[];
export type MilestonesTimeframeFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportJobKeySpecifier = ('createdAt' | 'createdMilestonesCount' | 'createdPhasesCount' | 'errorRows' | 'errors' | 'format' | 'id' | 'preview' | 'projectId' | 'status' | 'totalRows' | 'updatedMilestonesCount' | 'updatedPhasesCount' | 'validRows' | MilestonesImportJobKeySpecifier)[];
export type MilestonesImportJobFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdMilestonesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdPhasesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	errorRows?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	format?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	preview?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRows?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedMilestonesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedPhasesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	validRows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportErrorKeySpecifier = ('field' | 'message' | 'rowNumber' | MilestonesImportErrorKeySpecifier)[];
export type MilestonesImportErrorFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	rowNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportPreviewKeySpecifier = ('dependencies' | 'milestones' | 'phases' | 'summary' | MilestonesImportPreviewKeySpecifier)[];
export type MilestonesImportPreviewFieldPolicy = {
	dependencies?: FieldPolicy<any> | FieldReadFunction<any>,
	milestones?: FieldPolicy<any> | FieldReadFunction<any>,
	phases?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportDependencyPreviewKeySpecifier = ('dependsOnRef' | 'error' | 'isValid' | 'milestoneRef' | MilestonesImportDependencyPreviewKeySpecifier)[];
export type MilestonesImportDependencyPreviewFieldPolicy = {
	dependsOnRef?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	milestoneRef?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportMilestonePreviewKeySpecifier = ('dependencyRefs' | 'errors' | 'existingId' | 'externalId' | 'name' | 'operation' | 'phaseRef' | 'rowNumber' | MilestonesImportMilestonePreviewKeySpecifier)[];
export type MilestonesImportMilestonePreviewFieldPolicy = {
	dependencyRefs?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	existingId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	operation?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseRef?: FieldPolicy<any> | FieldReadFunction<any>,
	rowNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportRowErrorKeySpecifier = ('field' | 'message' | 'severity' | MilestonesImportRowErrorKeySpecifier)[];
export type MilestonesImportRowErrorFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportPhasePreviewKeySpecifier = ('errors' | 'existingId' | 'externalId' | 'label' | 'operation' | 'rowNumber' | MilestonesImportPhasePreviewKeySpecifier)[];
export type MilestonesImportPhasePreviewFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	existingId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	operation?: FieldPolicy<any> | FieldReadFunction<any>,
	rowNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesImportPreviewSummaryKeySpecifier = ('milestonesToCreate' | 'milestonesToUpdate' | 'phasesToCreate' | 'phasesToUpdate' | 'totalDependencies' | 'totalMilestones' | 'totalPhases' | 'validationErrors' | MilestonesImportPreviewSummaryKeySpecifier)[];
export type MilestonesImportPreviewSummaryFieldPolicy = {
	milestonesToCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesToUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	phasesToCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	phasesToUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDependencies?: FieldPolicy<any> | FieldReadFunction<any>,
	totalMilestones?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPhases?: FieldPolicy<any> | FieldReadFunction<any>,
	validationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesKanbanViewKeySpecifier = ('atRisk' | 'done' | 'inProgress' | 'notStarted' | MilestonesKanbanViewKeySpecifier)[];
export type MilestonesKanbanViewFieldPolicy = {
	atRisk?: FieldPolicy<any> | FieldReadFunction<any>,
	done?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	notStarted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesKanbanColumnKeySpecifier = ('count' | 'milestones' | MilestonesKanbanColumnKeySpecifier)[];
export type MilestonesKanbanColumnFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	milestones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesMilestoneConnectionKeySpecifier = ('groupCounts' | 'nodes' | 'pageInfo' | 'totalCount' | MilestonesMilestoneConnectionKeySpecifier)[];
export type MilestonesMilestoneConnectionFieldPolicy = {
	groupCounts?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesGroupCountKeySpecifier = ('count' | 'key' | 'label' | MilestonesGroupCountKeySpecifier)[];
export type MilestonesGroupCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | MilestonesPageInfoKeySpecifier)[];
export type MilestonesPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesProjectKeySpecifier = ('endDate' | 'eventId' | 'id' | 'startDate' | 'summary' | 'title' | MilestonesProjectKeySpecifier)[];
export type MilestonesProjectFieldPolicy = {
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NearbyAttractionsSearchResponseKeySpecifier = ('attractions' | NearbyAttractionsSearchResponseKeySpecifier)[];
export type NearbyAttractionsSearchResponseFieldPolicy = {
	attractions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NearbySearchAttractionKeySpecifier = ('km' | 'mi' | 'name' | NearbySearchAttractionKeySpecifier)[];
export type NearbySearchAttractionFieldPolicy = {
	km?: FieldPolicy<any> | FieldReadFunction<any>,
	mi?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferTokenResultKeySpecifier = ('channelId' | 'checkoutType' | 'dates' | 'externalOfferProvider' | 'joyOfferId' | 'joyPlaceId' | 'offerProvider' | 'providerOfferId' | 'token' | OfferTokenResultKeySpecifier)[];
export type OfferTokenResultFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutType?: FieldPolicy<any> | FieldReadFunction<any>,
	dates?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOfferProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	joyOfferId?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	offerProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerOfferId?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferTokenDatesKeySpecifier = ('checkIn' | 'checkOut' | OfferTokenDatesKeySpecifier)[];
export type OfferTokenDatesFieldPolicy = {
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('buyerEmail' | 'buyerName' | 'createdAt' | 'currency' | 'eventId' | 'expiresAt' | 'formId' | 'guestKey' | 'id' | 'orderNumber' | 'quantity' | 'status' | 'tickets' | 'ticketType' | 'ticketTypeId' | 'totalAmountInMinorUnits' | 'type' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	buyerEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tickets?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketType?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmountInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TicketKeySpecifier = ('checkedInAt' | 'createdAt' | 'eventId' | 'guestKey' | 'id' | 'order' | 'pkpassUrl' | 'status' | 'ticketData' | 'ticketNumber' | 'ticketType' | TicketKeySpecifier)[];
export type TicketFieldPolicy = {
	checkedInAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	pkpassUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketData?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderConnectionKeySpecifier = ('hasMore' | 'limit' | 'offset' | 'orders' | 'totalCount' | OrderConnectionKeySpecifier)[];
export type OrderConnectionFieldPolicy = {
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoTokenKeySpecifier = ('nextToken' | 'photos' | 'vendorIds' | 'vendors' | PhotoTokenKeySpecifier)[];
export type PhotoTokenFieldPolicy = {
	nextToken?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorIds?: FieldPolicy<any> | FieldReadFunction<any>,
	vendors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPricingsResultKeySpecifier = ('pricings' | TravelPricingsResultKeySpecifier)[];
export type TravelPricingsResultFieldPolicy = {
	pricings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPricingKeySpecifier = ('fees' | 'property' | 'totalAmount' | TravelPricingKeySpecifier)[];
export type TravelPricingFieldPolicy = {
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	property?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferFeeKeySpecifier = ('amount' | 'isIncludedInTotal' | 'rate' | 'type' | 'visibility' | TravelOfferFeeKeySpecifier)[];
export type TravelOfferFeeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncludedInTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPropertyPricingsSearchResultKeySpecifier = ('pricings' | TravelPropertyPricingsSearchResultKeySpecifier)[];
export type TravelPropertyPricingsSearchResultFieldPolicy = {
	pricings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPropertyPricingSearchItemKeySpecifier = ('pricingData' | 'property' | TravelPropertyPricingSearchItemKeySpecifier)[];
export type TravelPropertyPricingSearchItemFieldPolicy = {
	pricingData?: FieldPolicy<any> | FieldReadFunction<any>,
	property?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPropertyPricingAndBookingDetailsKeySpecifier = ('pricingInfo' | 'redirectMechanisms' | TravelPropertyPricingAndBookingDetailsKeySpecifier)[];
export type TravelPropertyPricingAndBookingDetailsFieldPolicy = {
	pricingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanisms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPropertyPricingKeySpecifier = ('baseRate' | 'fees' | 'nightlyBaseRate' | 'nightlyTotalRate' | 'perNightPerOccupancyBaseAmount' | 'perNightPerOccupancyStrikeoutBaseAmount' | 'perNightPerOccupancyTotalAmount' | 'strikeoutBaseRate' | 'strikeoutNightlyBaseRate' | 'strikeoutNightlyTotalRate' | 'strikeoutRateProvider' | 'strikeoutTotalRate' | 'totalRate' | TravelPropertyPricingKeySpecifier)[];
export type TravelPropertyPricingFieldPolicy = {
	baseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyStrikeoutBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutRateProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogAdsKeySpecifier = ('brandPromoMosaic' | 'departmentBrandPromos' | ProductCatalogAdsKeySpecifier)[];
export type ProductCatalogAdsFieldPolicy = {
	brandPromoMosaic?: FieldPolicy<any> | FieldReadFunction<any>,
	departmentBrandPromos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandPromoMosaicKeySpecifier = ('tiles' | ProductCatalogBrandPromoMosaicKeySpecifier)[];
export type ProductCatalogBrandPromoMosaicFieldPolicy = {
	tiles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandPromoKeySpecifier = ('brand' | 'customRedirectUrl' | 'image' | 'mobileImage' | ProductCatalogBrandPromoKeySpecifier)[];
export type ProductCatalogBrandPromoFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	customRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogDepartmentBrandPromoKeySpecifier = ('categoryCarousel' | 'department' | 'navBar' | 'productGrid' | ProductCatalogDepartmentBrandPromoKeySpecifier)[];
export type ProductCatalogDepartmentBrandPromoFieldPolicy = {
	categoryCarousel?: FieldPolicy<any> | FieldReadFunction<any>,
	department?: FieldPolicy<any> | FieldReadFunction<any>,
	navBar?: FieldPolicy<any> | FieldReadFunction<any>,
	productGrid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogBrandsDirectoryKeySpecifier = ('brands' | 'categories' | 'showcaseBrands' | ProductCatalogBrandsDirectoryKeySpecifier)[];
export type ProductCatalogBrandsDirectoryFieldPolicy = {
	brands?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseBrands?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemRecommendationContainerKeySpecifier = ('productUrl' | 'recommendations' | ProductCatalogItemRecommendationContainerKeySpecifier)[];
export type ProductCatalogItemRecommendationContainerFieldPolicy = {
	productUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogItemRecommendationKeySpecifier = ('catalogItem' | 'reason' | ProductCatalogItemRecommendationKeySpecifier)[];
export type ProductCatalogItemRecommendationFieldPolicy = {
	catalogItem?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchResultContainerKeySpecifier = ('allFilters' | 'allResults' | 'orderedBy' | 'pagedResults' | 'seoRedirectPath' | 'topResults' | ProductCatalogSearchResultContainerKeySpecifier)[];
export type ProductCatalogSearchResultContainerFieldPolicy = {
	allFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	allResults?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>,
	seoRedirectPath?: FieldPolicy<any> | FieldReadFunction<any>,
	topResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchFilterGroupKeySpecifier = ('attributeGroup' | 'attributes' | 'filterSelectionType' | 'selectedPriceRange' | ProductCatalogSearchFilterGroupKeySpecifier)[];
export type ProductCatalogSearchFilterGroupFieldPolicy = {
	attributeGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	filterSelectionType?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedPriceRange?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductSearchFilterAttributeKeySpecifier = ('compositeCode' | 'group' | 'id' | 'isActive' | 'matchingItemsCount' | 'priceRange' | 'value' | ProductSearchFilterAttributeKeySpecifier)[];
export type ProductSearchFilterAttributeFieldPolicy = {
	compositeCode?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	matchingItemsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRange?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeMonetaryRangeKeySpecifier = ('max' | 'min' | AttributeMonetaryRangeKeySpecifier)[];
export type AttributeMonetaryRangeFieldPolicy = {
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchFilterGroupSelectedPriceKeySpecifier = ('maxValueInMinorUnits' | 'minValueInMinorUnits' | ProductCatalogSearchFilterGroupSelectedPriceKeySpecifier)[];
export type ProductCatalogSearchFilterGroupSelectedPriceFieldPolicy = {
	maxValueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	minValueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchResultItemKeySpecifier = ('catalogItem' | 'score' | ProductCatalogSearchResultItemKeySpecifier)[];
export type ProductCatalogSearchResultItemFieldPolicy = {
	catalogItem?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchConnectionKeySpecifier = ('edges' | 'pageInfo' | ProductCatalogSearchConnectionKeySpecifier)[];
export type ProductCatalogSearchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchEdgeKeySpecifier = ('cursor' | 'node' | ProductCatalogSearchEdgeKeySpecifier)[];
export type ProductCatalogSearchEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogSearchPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'totalCount' | ProductCatalogSearchPageInfoKeySpecifier)[];
export type ProductCatalogSearchPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExternalKeySpecifier = ('description' | 'id' | 'photos' | 'rating' | 'sellers' | 'title' | ProductExternalKeySpecifier)[];
export type ProductExternalFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	sellers?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductRatingKeySpecifier = ('averageRating' | 'id' | 'reviewsCount' | ProductRatingKeySpecifier)[];
export type ProductRatingFieldPolicy = {
	averageRating?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExternalSellerKeySpecifier = ('fullPrice' | 'id' | 'name' | 'salePrice' | 'url' | ProductExternalSellerKeySpecifier)[];
export type ProductExternalSellerFieldPolicy = {
	fullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	salePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExternalSearchResultKeySpecifier = ('offers' | ProductExternalSearchResultKeySpecifier)[];
export type ProductExternalSearchResultFieldPolicy = {
	offers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExternalOfferKeySpecifier = ('id' | 'productId' | 'productRating' | 'productThumbnail' | 'productTitle' | 'sellerFullPrice' | 'sellerName' | 'sellerSalePrice' | 'sellerUrl' | ProductExternalOfferKeySpecifier)[];
export type ProductExternalOfferFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	productRating?: FieldPolicy<any> | FieldReadFunction<any>,
	productThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	productTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerFullPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerName?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerSalePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroContentKeySpecifier = ('cta' | 'description' | 'desktopMedia' | 'eyebrow' | 'gradientCustomColorValue' | 'gradientMode' | 'horizontalAlignment' | 'id' | 'mobileMedia' | 'storefront' | 'tabletMedia' | 'textColorMode' | 'textCustomColorValue' | 'title' | 'watchVideoUrl' | ProductHeroContentKeySpecifier)[];
export type ProductHeroContentFieldPolicy = {
	cta?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	desktopMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	eyebrow?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientCustomColorValue?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientMode?: FieldPolicy<any> | FieldReadFunction<any>,
	horizontalAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	storefront?: FieldPolicy<any> | FieldReadFunction<any>,
	tabletMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	textColorMode?: FieldPolicy<any> | FieldReadFunction<any>,
	textCustomColorValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	watchVideoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroContentCtaKeySpecifier = ('publicUrlPath' | 'redirectUrlType' | 'text' | ProductHeroContentCtaKeySpecifier)[];
export type ProductHeroContentCtaFieldPolicy = {
	publicUrlPath?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrlType?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroImageKeySpecifier = ('photo' | ProductHeroImageKeySpecifier)[];
export type ProductHeroImageFieldPolicy = {
	photo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroImagePhotoAssetKeySpecifier = ('image' | ProductHeroImagePhotoAssetKeySpecifier)[];
export type ProductHeroImagePhotoAssetFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroVideoKeySpecifier = ('video' | ProductHeroVideoKeySpecifier)[];
export type ProductHeroVideoFieldPolicy = {
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeroVideoAssetKeySpecifier = ('fallbackImage' | 'videoUrl' | ProductHeroVideoAssetKeySpecifier)[];
export type ProductHeroVideoAssetFieldPolicy = {
	fallbackImage?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductInventoryResultKeySpecifier = ('maxQty' | 'shipWhatWeCan' | ProductInventoryResultKeySpecifier)[];
export type ProductInventoryResultFieldPolicy = {
	maxQty?: FieldPolicy<any> | FieldReadFunction<any>,
	shipWhatWeCan?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeuristicSearchOutputKeySpecifier = ('lines' | ProductHeuristicSearchOutputKeySpecifier)[];
export type ProductHeuristicSearchOutputFieldPolicy = {
	lines?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductHeuristicSearchOutput_LineKeySpecifier = ('joySKU' | ProductHeuristicSearchOutput_LineKeySpecifier)[];
export type ProductHeuristicSearchOutput_LineFieldPolicy = {
	joySKU?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchResultKeySpecifier = ('items' | 'regularItems' | 'sponsoredItems' | ProductUniversalSearchResultKeySpecifier)[];
export type ProductUniversalSearchResultFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	regularItems?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsoredItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchResultItemKeySpecifier = ('source' | 'universalProduct' | ProductUniversalSearchResultItemKeySpecifier)[];
export type ProductUniversalSearchResultItemFieldPolicy = {
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	universalProduct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UniversalProductKeySpecifier = ('description' | 'id' | 'listPrice' | 'photos' | 'rating' | 'salePrice' | 'storeName' | 'title' | 'url' | UniversalProductKeySpecifier)[];
export type UniversalProductFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	listPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	salePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	storeName?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchResultContainerKeySpecifier = ('allFilters' | 'pagedResults' | ProductUniversalSearchResultContainerKeySpecifier)[];
export type ProductUniversalSearchResultContainerFieldPolicy = {
	allFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchConnectionKeySpecifier = ('edges' | 'pageInfo' | ProductUniversalSearchConnectionKeySpecifier)[];
export type ProductUniversalSearchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchEdgeKeySpecifier = ('cursor' | 'node' | ProductUniversalSearchEdgeKeySpecifier)[];
export type ProductUniversalSearchEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalSearchNodeKeySpecifier = ('item' | 'score' | 'source' | ProductUniversalSearchNodeKeySpecifier)[];
export type ProductUniversalSearchNodeFieldPolicy = {
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExternalOfferContainerKeySpecifier = ('offer' | ProductExternalOfferContainerKeySpecifier)[];
export type ProductExternalOfferContainerFieldPolicy = {
	offer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalCatalogItemContainerKeySpecifier = ('catalogItem' | ProductUniversalCatalogItemContainerKeySpecifier)[];
export type ProductUniversalCatalogItemContainerFieldPolicy = {
	catalogItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUniversalProductContainerKeySpecifier = ('product' | ProductUniversalProductContainerKeySpecifier)[];
export type ProductUniversalProductContainerFieldPolicy = {
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionWithAnswersKeySpecifier = ('answers' | 'question' | QuestionWithAnswersKeySpecifier)[];
export type QuestionWithAnswersFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecentTravelReservationKeySpecifier = ('bookingInfo' | 'joyPlace' | 'reservationId' | RecentTravelReservationKeySpecifier)[];
export type RecentTravelReservationFieldPolicy = {
	bookingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	reservationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationBookingInfoKeySpecifier = ('bookingDate' | 'checkInDate' | 'checkOutDate' | 'email' | 'firstName' | 'id' | 'lastName' | 'occupancy' | 'propertyName' | 'roomTypes' | 'status' | TravelReservationBookingInfoKeySpecifier)[];
export type TravelReservationBookingInfoFieldPolicy = {
	bookingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkInDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOutDate?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	occupancy?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyName?: FieldPolicy<any> | FieldReadFunction<any>,
	roomTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OccupancyKeySpecifier = ('adults' | 'children' | OccupancyKeySpecifier)[];
export type OccupancyFieldPolicy = {
	adults?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogPageSectionContainerKeySpecifier = ('id' | 'sectionById' | 'sections' | ProductCatalogPageSectionContainerKeySpecifier)[];
export type ProductCatalogPageSectionContainerFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionById?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogPageSectionKeySpecifier = ('catalogEntities' | 'cursor' | 'displayType' | 'id' | 'paginatedCatalogEntities' | ProductCatalogPageSectionKeySpecifier)[];
export type ProductCatalogPageSectionFieldPolicy = {
	catalogEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	displayType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paginatedCatalogEntities?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntitiesPaginationKeySpecifier = ('edges' | 'pageInfo' | ProductCatalogEntitiesPaginationKeySpecifier)[];
export type ProductCatalogEntitiesPaginationFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityEdgeKeySpecifier = ('cursor' | 'node' | ProductCatalogEntityEdgeKeySpecifier)[];
export type ProductCatalogEntityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntitiesPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'totalCount' | ProductCatalogEntitiesPageInfoKeySpecifier)[];
export type ProductCatalogEntitiesPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistrationConnectionKeySpecifier = ('attendanceCount' | 'hasNextPage' | 'hasPreviousPage' | 'nodes' | 'totalCount' | RegistrationConnectionKeySpecifier)[];
export type RegistrationConnectionFieldPolicy = {
	attendanceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCatalogInventoryResultKeySpecifier = ('checkoutWarningCodes' | 'maxQty' | RegistryCatalogInventoryResultKeySpecifier)[];
export type RegistryCatalogInventoryResultFieldPolicy = {
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	maxQty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPageKeySpecifier = ('event' | 'photo' | RegistryPageKeySpecifier)[];
export type RegistryPageFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPurchaseConfirmationDetailsKeySpecifier = ('salesOrder' | RegistryPurchaseConfirmationDetailsKeySpecifier)[];
export type RegistryPurchaseConfirmationDetailsFieldPolicy = {
	salesOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderKeySpecifier = ('compensation' | 'compensationTotal' | 'id' | 'isDelayedShipment' | 'items' | 'orderCharges' | 'orderChargesTotal' | 'orderTags' | 'paymentMethod' | 'postPurchaseFees' | 'postPurchaseFeesTotal' | 'sender' | 'shippingAndHandling' | 'shippingAndHandlingTotal' | 'subtotal' | 'taxes' | 'taxesTotal' | 'total' | SalesOrderKeySpecifier)[];
export type SalesOrderFieldPolicy = {
	compensation?: FieldPolicy<any> | FieldReadFunction<any>,
	compensationTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDelayedShipment?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	orderChargesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTags?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	postPurchaseFees?: FieldPolicy<any> | FieldReadFunction<any>,
	postPurchaseFeesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAndHandling?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAndHandlingTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	taxesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderItemLineKeySpecifier = ('isCashFund' | 'isEdelivery' | 'lineTags' | 'lineValue' | 'photos' | 'quantity' | 'title' | 'unitValue' | SalesOrderItemLineKeySpecifier)[];
export type SalesOrderItemLineFieldPolicy = {
	isCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	isEdelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	unitValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodKeySpecifier = ('card' | PaymentMethodKeySpecifier)[];
export type PaymentMethodFieldPolicy = {
	card?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCardKeySpecifier = ('brand' | 'last4' | PaymentCardKeySpecifier)[];
export type PaymentCardFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	last4?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryCustomerKeySpecifier = ('email' | 'name' | RegistryCustomerKeySpecifier)[];
export type RegistryCustomerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesOrderTaxLineKeySpecifier = ('lineTags' | 'lineValue' | 'title' | SalesOrderTaxLineKeySpecifier)[];
export type SalesOrderTaxLineFieldPolicy = {
	lineTags?: FieldPolicy<any> | FieldReadFunction<any>,
	lineValue?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventUsersRobustKeySpecifier = ('eventUsers' | 'user' | EventUsersRobustKeySpecifier)[];
export type EventUsersRobustFieldPolicy = {
	eventUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationContentSearchResultKeySpecifier = ('properties' | 'searchContext' | AccommodationContentSearchResultKeySpecifier)[];
export type AccommodationContentSearchResultFieldPolicy = {
	properties?: FieldPolicy<any> | FieldReadFunction<any>,
	searchContext?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationContentSearchContextKeySpecifier = ('propertiesCircularSearchContext' | AccommodationContentSearchContextKeySpecifier)[];
export type AccommodationContentSearchContextFieldPolicy = {
	propertiesCircularSearchContext?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyCircularSearchContextKeySpecifier = ('distance' | AccommodationCatalogPropertyCircularSearchContextKeySpecifier)[];
export type AccommodationCatalogPropertyCircularSearchContextFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExtendedAccommodationContentSearchResultKeySpecifier = ('properties' | ExtendedAccommodationContentSearchResultKeySpecifier)[];
export type ExtendedAccommodationContentSearchResultFieldPolicy = {
	properties?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExtendedAccommodationCatalogPropertyKeySpecifier = ('accommodationCategory' | 'address' | 'chain' | 'checkIn' | 'checkOut' | 'distances' | 'facilities' | 'joyPlaceId' | 'location' | 'name' | 'otaProvider' | 'photos' | 'plainTextLongDescription' | 'policies' | 'pricingInfo' | 'propertyType' | 'redirectMechanisms' | 'relevanceScore' | 'score' | 'starRating' | 'url' | 'userRating' | ExtendedAccommodationCatalogPropertyKeySpecifier)[];
export type ExtendedAccommodationCatalogPropertyFieldPolicy = {
	accommodationCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	chain?: FieldPolicy<any> | FieldReadFunction<any>,
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	distances?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	otaProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	plainTextLongDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	policies?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyType?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanisms?: FieldPolicy<any> | FieldReadFunction<any>,
	relevanceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	starRating?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	userRating?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyPricingInfoKeySpecifier = ('baseRate' | 'fees' | 'nightlyBaseRate' | 'nightlyTotalRate' | 'perNightPerOccupancyBaseAmount' | 'perNightPerOccupancyStrikeoutBaseAmount' | 'perNightPerOccupancyTotalAmount' | 'strikeoutBaseRate' | 'strikeoutNightlyBaseRate' | 'strikeoutNightlyTotalRate' | 'strikeoutRateProvider' | 'strikeoutTotalRate' | 'totalRate' | AccommodationCatalogPropertyPricingInfoKeySpecifier)[];
export type AccommodationCatalogPropertyPricingInfoFieldPolicy = {
	baseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyStrikeoutBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutRateProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchTermToTemplatesResponseKeySpecifier = ('query' | 'tags' | 'templates' | SearchTermToTemplatesResponseKeySpecifier)[];
export type SearchTermToTemplatesResponseFieldPolicy = {
	query?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateWithTaggingInfoKeySpecifier = ('allTags' | 'dbSearchRank' | 'dbTagsRank' | 'description' | 'matchingDescriptionWords' | 'matchingTags' | 'templateID' | TemplateWithTaggingInfoKeySpecifier)[];
export type TemplateWithTaggingInfoFieldPolicy = {
	allTags?: FieldPolicy<any> | FieldReadFunction<any>,
	dbSearchRank?: FieldPolicy<any> | FieldReadFunction<any>,
	dbTagsRank?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	matchingDescriptionWords?: FieldPolicy<any> | FieldReadFunction<any>,
	matchingTags?: FieldPolicy<any> | FieldReadFunction<any>,
	templateID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationKeySpecifier = ('cancellationFees' | 'confirmation' | 'email' | 'id' | 'offerToken' | 'roomGuests' | 'status' | TravelOfferReservationKeySpecifier)[];
export type TravelOfferReservationFieldPolicy = {
	cancellationFees?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	offerToken?: FieldPolicy<any> | FieldReadFunction<any>,
	roomGuests?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationMonetaryValueKeySpecifier = ('currency' | 'digits' | 'floatingPointDecimalString' | 'valueInMinorUnits' | 'valueInMinorUnitsBigInt' | TravelReservationMonetaryValueKeySpecifier)[];
export type TravelReservationMonetaryValueFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	digits?: FieldPolicy<any> | FieldReadFunction<any>,
	floatingPointDecimalString?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInMinorUnitsBigInt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationConfirmationKeySpecifier = ('baseAmount' | 'billingContact' | 'checkIn' | 'checkOut' | 'discountAmount' | 'externalOrderId' | 'fees' | 'onsiteCharges' | 'propertyConfirmationCode' | 'propertyInfo' | 'provider' | 'reservationItems' | 'totalAmount' | TravelOfferReservationConfirmationKeySpecifier)[];
export type TravelOfferReservationConfirmationFieldPolicy = {
	baseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	billingContact?: FieldPolicy<any> | FieldReadFunction<any>,
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	discountAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	externalOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	onsiteCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyConfirmationCode?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	reservationItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationContactInfoKeySpecifier = ('address' | 'email' | 'firstName' | 'lastName' | 'middleName' | 'phone' | 'title' | TravelOfferReservationContactInfoKeySpecifier)[];
export type TravelOfferReservationContactInfoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	middleName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationAddressKeySpecifier = ('city' | 'country' | 'line1' | 'line2' | 'postalCode' | 'state' | TravelReservationAddressKeySpecifier)[];
export type TravelReservationAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationFeeKeySpecifier = ('amount' | 'isIncludedInTotal' | 'rate' | 'type' | 'visibility' | TravelOfferReservationFeeKeySpecifier)[];
export type TravelOfferReservationFeeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncludedInTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationOnsiteChargeKeySpecifier = ('title' | 'unitPrice' | 'units' | TravelOfferReservationOnsiteChargeKeySpecifier)[];
export type TravelOfferReservationOnsiteChargeFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationConfirmationPropertyInfoKeySpecifier = ('address' | 'heroImageUrl' | 'name' | 'policies' | TravelOfferReservationConfirmationPropertyInfoKeySpecifier)[];
export type TravelOfferReservationConfirmationPropertyInfoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	heroImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	policies?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferPolicyKeySpecifier = ('description' | 'title' | OfferPolicyKeySpecifier)[];
export type OfferPolicyFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationItemKeySpecifier = ('occupancy' | 'refundability' | 'unit' | TravelOfferReservationItemKeySpecifier)[];
export type TravelOfferReservationItemFieldPolicy = {
	occupancy?: FieldPolicy<any> | FieldReadFunction<any>,
	refundability?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationItemOccupancyKeySpecifier = ('adults' | 'children' | TravelOfferReservationItemOccupancyKeySpecifier)[];
export type TravelOfferReservationItemOccupancyFieldPolicy = {
	adults?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationUnitKeySpecifier = ('description' | 'id' | 'name' | TravelOfferReservationUnitKeySpecifier)[];
export type TravelOfferReservationUnitFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationRoomGuestsKeySpecifier = ('guests' | 'unitId' | TravelOfferReservationRoomGuestsKeySpecifier)[];
export type TravelOfferReservationRoomGuestsFieldPolicy = {
	guests?: FieldPolicy<any> | FieldReadFunction<any>,
	unitId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationGuestInformationKeySpecifier = ('ageClassification' | 'countryCode' | 'firstName' | 'lastName' | 'phoneNumber' | 'title' | TravelOfferReservationGuestInformationKeySpecifier)[];
export type TravelOfferReservationGuestInformationFieldPolicy = {
	ageClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SMSKeySpecifier = ('id' | 'linkUrlDetails' | 'mediaUrls' | 'messageBatchId' | 'personSentTo' | 'smsContent' | 'status' | 'statusHistory' | 'toPhone' | SMSKeySpecifier)[];
export type SMSFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrlDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	personSentTo?: FieldPolicy<any> | FieldReadFunction<any>,
	smsContent?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	toPhone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SMSLinkUrlDetailKeySpecifier = ('linkLastClickedAt' | 'url' | SMSLinkUrlDetailKeySpecifier)[];
export type SMSLinkUrlDetailFieldPolicy = {
	linkLastClickedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SMSStatusKeySpecifier = ('status' | 'timestamp' | SMSStatusKeySpecifier)[];
export type SMSStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryDigitalViewKeySpecifier = ('cardOrderId' | 'firstViewedAt' | 'id' | 'lastViewedAt' | 'personId' | 'src' | StationeryDigitalViewKeySpecifier)[];
export type StationeryDigitalViewFieldPolicy = {
	cardOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstViewedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastViewedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	personId?: FieldPolicy<any> | FieldReadFunction<any>,
	src?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryDraftKeySpecifier = ('cardJSON' | 'eventId' | 'format' | 'id' | 'ownerId' | 'priceConfigId' | 'product' | 'recipientIdList' | 'stationeryTemplate' | 'updatedAt' | StationeryDraftKeySpecifier)[];
export type StationeryDraftFieldPolicy = {
	cardJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	format?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	priceConfigId?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientIdList?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryProductKeySpecifier = ('attributes' | 'id' | 'priceConfigId' | 'priceCurrency' | 'pricing' | 'productType' | 'shippingOptions' | 'variantGroups' | 'vendor' | 'vendorBaseSKU' | StationeryProductKeySpecifier)[];
export type StationeryProductFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	priceConfigId?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	variantGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorBaseSKU?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryProductAttributeKeySpecifier = ('attributeId' | 'attributeOptions' | 'category' | StationeryProductAttributeKeySpecifier)[];
export type StationeryProductAttributeFieldPolicy = {
	attributeId?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryProductAttributeOptionKeySpecifier = ('attributeOption' | 'pricing' | StationeryProductAttributeOptionKeySpecifier)[];
export type StationeryProductAttributeOptionFieldPolicy = {
	attributeOption?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryAttributeOptionKeySpecifier = ('attributeId' | 'id' | StationeryAttributeOptionKeySpecifier)[];
export type StationeryAttributeOptionFieldPolicy = {
	attributeId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryFlatFeePricingKeySpecifier = ('priceInMinorUnits' | StationeryFlatFeePricingKeySpecifier)[];
export type StationeryFlatFeePricingFieldPolicy = {
	priceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTieredFlatFeePricingKeySpecifier = ('priceTiers' | StationeryTieredFlatFeePricingKeySpecifier)[];
export type StationeryTieredFlatFeePricingFieldPolicy = {
	priceTiers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTieredFlatFeePriceKeySpecifier = ('minQuantity' | 'totalPriceInMinorUnits' | StationeryTieredFlatFeePriceKeySpecifier)[];
export type StationeryTieredFlatFeePriceFieldPolicy = {
	minQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTieredPricingKeySpecifier = ('priceTiers' | StationeryTieredPricingKeySpecifier)[];
export type StationeryTieredPricingFieldPolicy = {
	priceTiers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTieredPriceKeySpecifier = ('minQuantity' | 'unitPriceInMinorUnits' | StationeryTieredPriceKeySpecifier)[];
export type StationeryTieredPriceFieldPolicy = {
	minQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPriceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryProductShippingOptionV1KeySpecifier = ('constraints' | 'id' | 'pricing' | StationeryProductShippingOptionV1KeySpecifier)[];
export type StationeryProductShippingOptionV1FieldPolicy = {
	constraints?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryAllowPoBoxShippingConstraintKeySpecifier = ('allowPoBox' | StationeryAllowPoBoxShippingConstraintKeySpecifier)[];
export type StationeryAllowPoBoxShippingConstraintFieldPolicy = {
	allowPoBox?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryCountryShippingConstraintKeySpecifier = ('excludedCountries' | 'includedCountries' | StationeryCountryShippingConstraintKeySpecifier)[];
export type StationeryCountryShippingConstraintFieldPolicy = {
	excludedCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	includedCountries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryQuantityShippingConstraintKeySpecifier = ('maxQuantity' | 'minQuantity' | StationeryQuantityShippingConstraintKeySpecifier)[];
export type StationeryQuantityShippingConstraintFieldPolicy = {
	maxQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	minQuantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryProductVariantGroupKeySpecifier = ('id' | 'options' | 'vendorSKU' | StationeryProductVariantGroupKeySpecifier)[];
export type StationeryProductVariantGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	vendorSKU?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTemplateKeySpecifier = ('approved' | 'category' | 'enabled' | 'favorites' | 'heightInches' | 'id' | 'isFavorite' | 'name' | 'premium' | 'productIds' | 'products' | 'side' | 'tags' | 'themeId' | 'themeJSON' | 'thumbnailUrl' | 'widthInches' | StationeryTemplateKeySpecifier)[];
export type StationeryTemplateFieldPolicy = {
	approved?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	favorites?: FieldPolicy<any> | FieldReadFunction<any>,
	heightInches?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	premium?: FieldPolicy<any> | FieldReadFunction<any>,
	productIds?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	side?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	themeId?: FieldPolicy<any> | FieldReadFunction<any>,
	themeJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	widthInches?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryFavoriteKeySpecifier = ('createdAt' | 'id' | StationeryFavoriteKeySpecifier)[];
export type StationeryFavoriteFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderKeySpecifier = ('cardDraft' | 'cardDraftId' | 'cardDraftJSONBlob' | 'category' | 'createdAt' | 'currencyConversionData' | 'currencyISO4217' | 'currentStatus' | 'deliveryMethod' | 'designSetName' | 'digitalEnvelopeImageUrl' | 'digitalFeatures' | 'discount' | 'envelopeBackImageUrl' | 'envelopeFrontImageUrl' | 'envelopePDFUrl' | 'eventId' | 'formLink' | 'id' | 'issues' | 'magnetCard' | 'orderNumber' | 'ownerId' | 'priceConfigId' | 'priceInMinorUnits' | 'printCardBackPreviewUrl' | 'printCardFrontPreviewUrl' | 'printPayment' | 'product' | 'quantity' | 'refunds' | 'selectedProduct' | 'shippingAddress' | 'state' | 'stationeryPDFUrl' | 'statusHistory' | 'taxInMinorUnits' | 'trackingNumbers' | 'type' | 'vendor' | StationeryPrintOrderKeySpecifier)[];
export type StationeryPrintOrderFieldPolicy = {
	cardDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDraftId?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDraftJSONBlob?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversionData?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyISO4217?: FieldPolicy<any> | FieldReadFunction<any>,
	currentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	designSetName?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalEnvelopeImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalFeatures?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopeBackImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopeFrontImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopePDFUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formLink?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issues?: FieldPolicy<any> | FieldReadFunction<any>,
	magnetCard?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	priceConfigId?: FieldPolicy<any> | FieldReadFunction<any>,
	priceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	printCardBackPreviewUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	printCardFrontPreviewUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	printPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPDFUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	statusHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	taxInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderDiscountKeySpecifier = ('amountInMinorUnits' | 'code' | 'percentage' | StationeryPrintOrderDiscountKeySpecifier)[];
export type StationeryPrintOrderDiscountFieldPolicy = {
	amountInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderIssueKeySpecifier = ('additionalUserFacingDescription' | 'createdAt' | 'id' | 'issueTarget' | 'issueType' | 'resolvedAt' | 'resolvedByUserId' | 'updatedAt' | StationeryPrintOrderIssueKeySpecifier)[];
export type StationeryPrintOrderIssueFieldPolicy = {
	additionalUserFacingDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	issueType?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderPaymentKeySpecifier = ('id' | 'paid' | 'paidAt' | 'paymentInfo' | 'purchaseContextId' | 'salesOrderId' | 'stationeryPrintOrderId' | StationeryPrintOrderPaymentKeySpecifier)[];
export type StationeryPrintOrderPaymentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paid?: FieldPolicy<any> | FieldReadFunction<any>,
	paidAt?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseContextId?: FieldPolicy<any> | FieldReadFunction<any>,
	salesOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPrintOrderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderPaymentInfoKeySpecifier = ('creditCardBrand' | 'creditCardLast4' | StationeryPrintOrderPaymentInfoKeySpecifier)[];
export type StationeryPrintOrderPaymentInfoFieldPolicy = {
	creditCardBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	creditCardLast4?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderRefundViewKeySpecifier = ('createdAt' | 'message' | 'refundAmountInMinorUnits' | StationeryPrintOrderRefundViewKeySpecifier)[];
export type StationeryPrintOrderRefundViewFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	refundAmountInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderSelectedProductKeySpecifier = ('attributes' | 'selectedShippingMethodId' | 'variantGroupId' | StationeryPrintOrderSelectedProductKeySpecifier)[];
export type StationeryPrintOrderSelectedProductFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedShippingMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	variantGroupId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderProductAttributeKeySpecifier = ('attributeId' | 'optionId' | StationeryPrintOrderProductAttributeKeySpecifier)[];
export type StationeryPrintOrderProductAttributeFieldPolicy = {
	attributeId?: FieldPolicy<any> | FieldReadFunction<any>,
	optionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderShippingAddressKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'countryCode' | 'name' | 'postalCode' | 'region' | StationeryPrintOrderShippingAddressKeySpecifier)[];
export type StationeryPrintOrderShippingAddressFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderStatusKeySpecifier = ('date' | 'id' | 'orderId' | 'status' | StationeryPrintOrderStatusKeySpecifier)[];
export type StationeryPrintOrderStatusFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintTrackingNumberViewKeySpecifier = ('trackingNumber' | 'trackingUrl' | StationeryPrintTrackingNumberViewKeySpecifier)[];
export type StationeryPrintTrackingNumberViewFieldPolicy = {
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderCardDetailsKeySpecifier = ('detailsJSONBlob' | 'digitalEnvelopeImageUrl' | 'eventId' | 'orderId' | StationeryPrintOrderCardDetailsKeySpecifier)[];
export type StationeryPrintOrderCardDetailsFieldPolicy = {
	detailsJSONBlob?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalEnvelopeImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrderDebuggingInfoKeySpecifier = ('extendedPrintOrderJSON' | 'storedVendorOrderJSON' | StationeryPrintOrderDebuggingInfoKeySpecifier)[];
export type StationeryPrintOrderDebuggingInfoFieldPolicy = {
	extendedPrintOrderJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	storedVendorOrderJSON?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPrintOrdersViewKeySpecifier = ('count' | 'orders' | StationeryPrintOrdersViewKeySpecifier)[];
export type StationeryPrintOrdersViewFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTagKeySpecifier = ('category' | 'displayLabel' | 'name' | 'thumbnailUrl' | StationeryTagKeySpecifier)[];
export type StationeryTagFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	displayLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTemplateContainerKeySpecifier = ('pagedResults' | StationeryTemplateContainerKeySpecifier)[];
export type StationeryTemplateContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTemplateConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | StationeryTemplateConnectionKeySpecifier)[];
export type StationeryTemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryTemplateEdgeKeySpecifier = ('cursor' | 'node' | StationeryTemplateEdgeKeySpecifier)[];
export type StationeryTemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | StationeryPageInfoKeySpecifier)[];
export type StationeryPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TextTaggingResponseKeySpecifier = ('tags' | TextTaggingResponseKeySpecifier)[];
export type TextTaggingResponseFieldPolicy = {
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThemeFilterAttributesKeySpecifier = ('colors' | 'tags' | 'variationTypes' | ThemeFilterAttributesKeySpecifier)[];
export type ThemeFilterAttributesFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	variationTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TicketConnectionKeySpecifier = ('hasMore' | 'limit' | 'offset' | 'tickets' | 'totalCount' | TicketConnectionKeySpecifier)[];
export type TicketConnectionFieldPolicy = {
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	tickets?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryKeySpecifier = ('eventId' | 'id' | 'items' | 'name' | 'scannedAt' | 'status' | 'url' | TransitionalRegistryKeySpecifier)[];
export type TransitionalRegistryFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	scannedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryItemKeySpecifier = ('id' | 'photo' | 'title' | TransitionalRegistryItemKeySpecifier)[];
export type TransitionalRegistryItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelDistancesFromOriginResponseKeySpecifier = ('distances' | TravelDistancesFromOriginResponseKeySpecifier)[];
export type TravelDistancesFromOriginResponseFieldPolicy = {
	distances?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferKeySpecifier = ('baseAmount' | 'checkIn' | 'checkOut' | 'components' | 'fees' | 'offerGroupId' | 'offerLocale' | 'offerToken' | 'onsiteCharges' | 'originalBaseAmount' | 'originalTotalAmount' | 'preTaxAmount' | 'providerName' | 'totalAmount' | TravelOfferKeySpecifier)[];
export type TravelOfferFieldPolicy = {
	baseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	offerGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	offerLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	offerToken?: FieldPolicy<any> | FieldReadFunction<any>,
	onsiteCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	originalBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	originalTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	preTaxAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferComponentKeySpecifier = ('baseAmount' | 'componentType' | 'distributionType' | 'policies' | 'refundability' | 'totalAmount' | TravelOfferComponentKeySpecifier)[];
export type TravelOfferComponentFieldPolicy = {
	baseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	componentType?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionType?: FieldPolicy<any> | FieldReadFunction<any>,
	policies?: FieldPolicy<any> | FieldReadFunction<any>,
	refundability?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferPolicyFieldKeySpecifier = ('description' | 'title' | TravelOfferPolicyFieldKeySpecifier)[];
export type TravelOfferPolicyFieldFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferOnsiteChargeKeySpecifier = ('title' | 'unitPrice' | 'units' | TravelOfferOnsiteChargeKeySpecifier)[];
export type TravelOfferOnsiteChargeFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOffersResultKeySpecifier = ('pagination' | 'someOffers' | TravelOffersResultKeySpecifier)[];
export type TravelOffersResultFieldPolicy = {
	pagination?: FieldPolicy<any> | FieldReadFunction<any>,
	someOffers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPaginationKeySpecifier = ('limit' | 'offset' | 'totalCount' | AccommodationCatalogPaginationKeySpecifier)[];
export type AccommodationCatalogPaginationFieldPolicy = {
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPlacePricingAndBookingDetailsResultKeySpecifier = ('accommodationPlaces' | 'joyPlaces' | 'stayDates' | TravelPlacePricingAndBookingDetailsResultKeySpecifier)[];
export type TravelPlacePricingAndBookingDetailsResultFieldPolicy = {
	accommodationPlaces?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlaces?: FieldPolicy<any> | FieldReadFunction<any>,
	stayDates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlacePricingAndBookingDetailsKeySpecifier = ('accommodationPlace' | 'pricingInfo' | 'redirectMechanisms' | AccommodationPlacePricingAndBookingDetailsKeySpecifier)[];
export type AccommodationPlacePricingAndBookingDetailsFieldPolicy = {
	accommodationPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanisms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PricingForAccommodationPlaceKeySpecifier = ('baseRate' | 'fees' | 'nightlyBaseRate' | 'nightlyTotalRate' | 'perNightPerOccupancyBaseAmount' | 'perNightPerOccupancyStrikeoutBaseAmount' | 'perNightPerOccupancyTotalAmount' | 'strikeoutBaseRate' | 'strikeoutNightlyBaseRate' | 'strikeoutNightlyTotalRate' | 'strikeoutRateProvider' | 'strikeoutTotalRate' | 'totalRate' | PricingForAccommodationPlaceKeySpecifier)[];
export type PricingForAccommodationPlaceFieldPolicy = {
	baseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyStrikeoutBaseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightPerOccupancyTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutNightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutRateProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	strikeoutTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JoyPlacePricingAndBookingDetailsKeySpecifier = ('joyPlace' | 'pricingInfo' | 'redirectMechanisms' | JoyPlacePricingAndBookingDetailsKeySpecifier)[];
export type JoyPlacePricingAndBookingDetailsFieldPolicy = {
	joyPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectMechanisms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StayDatesInfoKeySpecifier = ('available' | 'selected' | StayDatesInfoKeySpecifier)[];
export type StayDatesInfoFieldPolicy = {
	available?: FieldPolicy<any> | FieldReadFunction<any>,
	selected?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StayDateStrategyKeySpecifier = ('checkIn' | 'checkOut' | 'type' | StayDateStrategyKeySpecifier)[];
export type StayDateStrategyFieldPolicy = {
	checkIn?: FieldPolicy<any> | FieldReadFunction<any>,
	checkOut?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPricingsByPropertyIdResultKeySpecifier = ('pricings' | TravelPricingsByPropertyIdResultKeySpecifier)[];
export type TravelPricingsByPropertyIdResultFieldPolicy = {
	pricings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPricingByPropertyIdItemKeySpecifier = ('pricingData' | 'property' | TravelPricingByPropertyIdItemKeySpecifier)[];
export type TravelPricingByPropertyIdItemFieldPolicy = {
	pricingData?: FieldPolicy<any> | FieldReadFunction<any>,
	property?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPricingByPropertyIdDataKeySpecifier = ('fees' | 'originalAmount' | 'originalSource' | 'perNightFinalAmountBeforeTaxesAndFees' | 'perNightOriginalAmountBeforeTaxesAndFees' | 'totalAmount' | TravelPricingByPropertyIdDataKeySpecifier)[];
export type TravelPricingByPropertyIdDataFieldPolicy = {
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	originalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	originalSource?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightFinalAmountBeforeTaxesAndFees?: FieldPolicy<any> | FieldReadFunction<any>,
	perNightOriginalAmountBeforeTaxesAndFees?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPlaceComparisonKeySpecifier = ('joyPlaceId' | 'providers' | TravelPlaceComparisonKeySpecifier)[];
export type TravelPlaceComparisonFieldPolicy = {
	joyPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelPlaceComparisonForProviderKeySpecifier = ('nightlyBaseRate' | 'nightlyTotalRate' | 'providerFQDN' | 'providerSearchURL' | TravelPlaceComparisonForProviderKeySpecifier)[];
export type TravelPlaceComparisonForProviderFieldPolicy = {
	nightlyBaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyTotalRate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerFQDN?: FieldPolicy<any> | FieldReadFunction<any>,
	providerSearchURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationBookingByEventIdKeySpecifier = ('bookingInfo' | 'joyPlace' | TravelReservationBookingByEventIdKeySpecifier)[];
export type TravelReservationBookingByEventIdFieldPolicy = {
	bookingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	joyPlace?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationSummariesByPropertyIdentifiersResultKeySpecifier = ('reservationSummaries' | TravelReservationSummariesByPropertyIdentifiersResultKeySpecifier)[];
export type TravelReservationSummariesByPropertyIdentifiersResultFieldPolicy = {
	reservationSummaries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelReservationsSummaryKeySpecifier = ('identifier' | 'reservationsCount' | TravelReservationsSummaryKeySpecifier)[];
export type TravelReservationsSummaryFieldPolicy = {
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	reservationsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyIdentifierKeySpecifier = ('id' | 'type' | AccommodationCatalogPropertyIdentifierKeySpecifier)[];
export type AccommodationCatalogPropertyIdentifierFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaUploadCollectionKeySpecifier = ('attemptInMs' | 'id' | 'name' | 'status' | 'uploadId' | 'uploads' | MediaUploadCollectionKeySpecifier)[];
export type MediaUploadCollectionFieldPolicy = {
	attemptInMs?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadId?: FieldPolicy<any> | FieldReadFunction<any>,
	uploads?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaUploadKeySpecifier = ('assetId' | 'id' | 'photo' | 'status' | MediaUploadKeySpecifier)[];
export type MediaUploadFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaUploadPhotoKeySpecifier = ('height' | 'id' | 'url' | 'width' | MediaUploadPhotoKeySpecifier)[];
export type MediaUploadPhotoFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UrlMetadataResponseKeySpecifier = ('error' | 'finalUrl' | 'fromCache' | 'metadata' | UrlMetadataResponseKeySpecifier)[];
export type UrlMetadataResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	finalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fromCache?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UrlMetadataErrorKeySpecifier = ('code' | 'message' | 'type' | UrlMetadataErrorKeySpecifier)[];
export type UrlMetadataErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UrlMetadataKeySpecifier = ('author' | 'date' | 'description' | 'imageUrl' | 'lang' | 'logoUrl' | 'publisher' | 'title' | UrlMetadataKeySpecifier)[];
export type UrlMetadataFieldPolicy = {
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publisher?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserActivityContainerKeySpecifier = ('pagedResults' | UserActivityContainerKeySpecifier)[];
export type UserActivityContainerFieldPolicy = {
	pagedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserActivityConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | UserActivityConnectionKeySpecifier)[];
export type UserActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserActivityEdgeKeySpecifier = ('cursor' | 'node' | UserActivityEdgeKeySpecifier)[];
export type UserActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserActivityKeySpecifier = ('activity' | 'business' | 'count' | 'eventId' | 'firstOccurredAt' | 'id' | 'isJoyAdmin' | 'lastOccurredAt' | 'userId' | UserActivityKeySpecifier)[];
export type UserActivityFieldPolicy = {
	activity?: FieldPolicy<any> | FieldReadFunction<any>,
	business?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstOccurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isJoyAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastOccurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserActivityPageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | UserActivityPageInfoKeySpecifier)[];
export type UserActivityPageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserConsentKeySpecifier = ('consentAnswer' | 'consentKey' | 'consentTermsOfServiceLink' | 'createdAt' | 'createdByUserId' | 'eventId' | 'id' | 'updatedAt' | 'updatedByUserId' | UserConsentKeySpecifier)[];
export type UserConsentFieldPolicy = {
	consentAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	consentKey?: FieldPolicy<any> | FieldReadFunction<any>,
	consentTermsOfServiceLink?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicUserConsentKeySpecifier = ('consentAnswer' | 'consentKey' | 'createdAt' | 'eventId' | 'id' | PublicUserConsentKeySpecifier)[];
export type PublicUserConsentFieldPolicy = {
	consentAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	consentKey?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorUserInviteKeySpecifier = ('claimed' | 'claimedAt' | 'email' | 'firstName' | 'id' | 'lastName' | 'role' | VendorUserInviteKeySpecifier)[];
export type VendorUserInviteFieldPolicy = {
	claimed?: FieldPolicy<any> | FieldReadFunction<any>,
	claimedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VisionTaggingResponseKeySpecifier = ('tags' | VisionTaggingResponseKeySpecifier)[];
export type VisionTaggingResponseFieldPolicy = {
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseInventorySearchResultDataKeySpecifier = ('checkResult' | 'requestedSKU' | 'resolvedSKU' | 'selectedSupplierProduct' | 'shipWhatWeCan' | 'warehouseItem' | WarehouseInventorySearchResultDataKeySpecifier)[];
export type WarehouseInventorySearchResultDataFieldPolicy = {
	checkResult?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedSKU?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedSKU?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedSupplierProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	shipWhatWeCan?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ZentrumHubHotelIsValidKeySpecifier = ('hasInventory' | 'hasRates' | 'isValid' | ZentrumHubHotelIsValidKeySpecifier)[];
export type ZentrumHubHotelIsValidFieldPolicy = {
	hasInventory?: FieldPolicy<any> | FieldReadFunction<any>,
	hasRates?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('acceptCashFundContribution' | 'acceptCollaborationInvite' | 'acceptEventAdminInvite' | 'activateLinkRedirect' | 'addAccommodationPlaceV2' | 'addAccommodationRecommendationToEvent' | 'addAddressToVendor' | 'addContactsToHouseholdById' | 'addContactToGroup' | 'addDonationFundPhoto' | 'addEventCountdownComponent' | 'addEventDetailsComponent' | 'addEventDisplayNameComponent' | 'addGreetingMessageComponent' | 'addHostToBookingType' | 'addInvitee' | 'addJsonDataBlobComponent' | 'addMediaGalleryComponent' | 'addMediaToCollection' | 'addMediaToCollectionV2' | 'addPhotoComponent' | 'addPhotosToCollection' | 'addPointOnMap' | 'addRegistryItemPhoto' | 'addRegistryPagePhoto' | 'addRegistryPhoto' | 'addRsvpAndUnlockGuestDetailsButtonComponent' | 'addStationeryPrintOrderIssues' | 'addTagItemsToContact' | 'addTagsToGuest' | 'addTagsToResource' | 'addTagToVendor' | 'addTestimony' | 'addTextComponent' | 'addTravelMapComponent' | 'addVendorLogoPhoto' | 'addVendorProfilePhoto' | 'addVendorToContactList' | 'addVendorToShowcase' | 'addVideoComponent' | 'annotateRegistryOrder' | 'applyEventConfig' | 'applyFontPack' | 'applyFontPackByName' | 'applyWebsiteColors' | 'applyWebSiteTemplateSettings' | 'approveContactMessageBatch' | 'approveRegistration' | 'archiveBookingType' | 'archiveCashFund' | 'archiveCollection' | 'archiveMatch' | 'archiveUserActivity' | 'assignAddress' | 'authenticateRegistryReservation' | 'autoPopulateAccommodationPlaces' | 'autoPopulateAccommodationPlacesV3' | 'autoPopulateAccommodationPlacesV4' | 'autoPopulateAccommodationPlacesV5' | 'autoPopulateStayAreas' | 'batchUpdateEventPages' | 'cancelContactMessageBatch' | 'cancelEventAdminInvite' | 'cancelOrder' | 'cancelRegistryOrders' | 'cancelStationeryPrintOrderById' | 'cancelTicket' | 'changeLinkRedirectUrl' | 'changePassword' | 'checkEmailContentSafety' | 'checkPhoneNumberVerification' | 'checkSmsContentSafety' | 'claimVendor' | 'claimVendorUserInvite' | 'claimVendorUserWithToken' | 'combineStationeryPrintOrders' | 'convertRegistryDrafts' | 'convertRegistryToTransferred' | 'createAndStartCheckoutConciergePrintOrder' | 'createAndStartCheckoutDigitalPrintOrder' | 'createAndStartCheckoutSamplePrintOrder' | 'createAndStartInternationalCheckoutConciergePrintOrder' | 'createAndStartInternationalCheckoutDigitalPrintOrder' | 'createBookingSlot' | 'createBookingTravelItem' | 'createBookingType' | 'createCashFund' | 'createCashFundCheckoutSession' | 'createCashFundPaymentIntent' | 'createCashFundSolicitation' | 'createChecklistItem' | 'createChecklistSubItem' | 'createCollectionOnEventMatch' | 'createCollectionOnVendor' | 'createCollectionWithPhotos' | 'createContact' | 'createContactAndReturnGuestKey' | 'createContactCollection' | 'createContacts' | 'createContactsWithoutTags' | 'createContactTag' | 'createCustomerInsights' | 'createDonationFund' | 'createDonationFundDonation' | 'createDonationFundDonationWithResult' | 'createDonationFundPlatform' | 'createEventChecklist' | 'createEventDesign' | 'createEventFeatureFlag' | 'createEventMatch' | 'createEventPage' | 'createEventPlace' | 'createEventScheduleItem' | 'createEventType' | 'createEventV0301' | 'createFerryTravelItem' | 'createFlightTravelItem' | 'createForm' | 'createFormTemplate' | 'createGeneralEvent' | 'createHiredMatch' | 'createHotelTravelItem' | 'createInvitee' | 'createJoyFeatureCheckout' | 'createJsonDataContainer' | 'createLinkRedirect' | 'createLinkRedirectBlock' | 'createListTravelItem' | 'createMatch' | 'createMediaCollection' | 'createMediaPhoto' | 'createMediaPhotos' | 'createModernEcardsFlag' | 'createNewEventAdminInvite' | 'createNoteTravelItem' | 'createPageContainer' | 'createPaletteColor' | 'createPlusOneGuest' | 'createPostRsvpHotelBookReminderMessage' | 'createQanda' | 'createQRCode' | 'createRegistry' | 'createRegistryChecklist' | 'createRegistryChecklistFromTemplate' | 'createRegistryItem' | 'createRegistryItemFromCatalogItem' | 'createRegistryItemsFromCatalogCategory' | 'createRegistryItemsFromCatalogItems' | 'createRegistryOrderAfterPayment' | 'createRegistryPaymentIntent' | 'createRegistryPayoutAccount' | 'createRegistryPurchaseContext' | 'createRegistryWithResult' | 'createRemindMeLaterEmail' | 'createRentalCarTravelItem' | 'createRentalHomeTravelItem' | 'createServiceTag' | 'createShuttleTravelItem' | 'createSingleRegistryItemOrder' | 'createSlimEventAndCollection' | 'createStationeryDigitalDraftPreview' | 'createStationeryDraft' | 'createStationeryDraftFromPrintOrder' | 'createStationeryDraftPreview' | 'createStationeryPriceConfig' | 'createStationeryPrintOrder' | 'createTag' | 'createTaxiTravelItem' | 'createTentTravelItem' | 'createTicketType' | 'createTrainTravelItem' | 'createTransferredRegistry' | 'createTransitionalRegistry' | 'createVendor' | 'createVendorAsCoupleForContactList' | 'createVendorOrganization' | 'createVendorUserInvite' | 'createVendorUserOnVendor' | 'createVendorV2' | 'createVenueFromPlaceId' | 'createVip' | 'deactivateLinkRedirect' | 'deleteAccommodationPlaceV2' | 'deleteBookingSlot' | 'deleteChecklistItem' | 'deleteChecklistSubItem' | 'deleteContact' | 'deleteContactCollection' | 'deleteContactGuestByGuestId' | 'deleteContactsByContactIds' | 'deleteContactsByGuestIds' | 'deleteContactTag' | 'deleteCustomTheme' | 'deleteCustomThemeAsset' | 'deleteDonationFund' | 'deleteDonationFundDonation' | 'deleteDonationFundPlatform' | 'deleteEvent' | 'deleteEventAsset' | 'deleteEventChecklist' | 'deleteEventFeatureFlag' | 'deleteEventPage' | 'deleteEventPlace' | 'deleteEventScheduleItem' | 'deleteEventType' | 'deleteForm' | 'deleteFormAnswer' | 'deleteFormTemplate' | 'deleteGuestFromContact' | 'deleteJsonDataContainer' | 'deleteLinkRedirect' | 'deleteLinkRedirectBlock' | 'deleteMedia' | 'deleteMediaCollection' | 'deleteMetaTag' | 'deleteModernEcardsFlag' | 'deletePageComponentV2' | 'deletePageContainer' | 'deletePointOnMap' | 'deletePostOfficeDraftById' | 'deleteQanda' | 'deleteRegistry' | 'deleteRegistryChecklist' | 'deleteRegistryItem' | 'deleteRegistryOrder' | 'deleteRegistryWithResult' | 'deleteReserveRoomBlock' | 'deleteStationeryDraftById' | 'deleteStationeryDraftsByEventId' | 'deleteStationeryPrintOrderForFailedCheckoutUrl' | 'deleteStationeryTagByName' | 'deleteTestimony' | 'deleteTicketType' | 'deleteTransitionalRegistry' | 'deleteTravelItem' | 'deleteUser' | 'deleteVendorUserInvite' | 'deleteVip' | 'deliverGuestNotFoundMessage' | 'deliverRequestForPassword' | 'disableMagicTokenForMediaCollection' | 'disablePostRsvpSms' | 'duplicateCashFund' | 'editCachedResource' | 'editCardTemplate' | 'editCollectionInfo' | 'editCollectionItemData' | 'editFontConfiguration' | 'editStationeryPrintOrder' | 'enableMagicTokenForMediaCollection' | 'enablePostRsvpSms' | 'endRegistrySession' | 'enrichCustomerInsights' | 'ensureRegistrationForm' | 'eventSetWebsiteState' | 'experimentalStationeryBundlePrintOrder' | 'extractMetadata' | 'generateAccommodationRecommendations' | 'generateAltTextForImage' | 'generateAltTextForImages' | 'generateAltTextForImagesInCollection' | 'generateAltTextForImagesInCollections' | 'generateAltTextForImageWithVenueAndPhotographer' | 'generateMagicTokenForMediaCollection' | 'groupContacts' | 'hardDeleteTestUser' | 'hotelRoomBlocksSubmitted' | 'imageRemoveBackground' | 'imageToImage' | 'imageToImageMasked' | 'imageTransferStyle' | 'importEvent' | 'importFirebasePhotoFromPath' | 'importProductByUrl' | 'importProductsByUrl' | 'importRegistry' | 'incrementInterestedGuestCount' | 'initCashFundsHost' | 'instagramAuthorization' | 'instantlyProcessStationeryPrintOrderById' | 'joinEventAsActiveUserWithPassword' | 'joinEventAsPersonWithPassword' | 'joinEventWithGuid' | 'killSchemaCaches' | 'leaveEvent' | 'likeMultiplePhotos' | 'likePhoto' | 'linkGoogleAccount' | 'linkOutlookAccount' | 'loadImagesMetadata' | 'loginEventSession' | 'logoutEventSession' | 'logUserActivity' | 'manageCashFundSolicitationRecipients' | 'marketingUpdateEvent' | 'marketingUpdateUserEvents' | 'markTemplateAsFavorite' | 'markUserForMFAEnrollment' | 'mergeContacts' | 'milestonesAddDependencies' | 'milestonesAddDependency' | 'milestonesAssignMilestone' | 'milestonesCancelImport' | 'milestonesCreateAttachment' | 'milestonesCreateCategories' | 'milestonesCreateCategory' | 'milestonesCreateComment' | 'milestonesCreateMilestone' | 'milestonesCreateMilestones' | 'milestonesCreatePhase' | 'milestonesCreatePhases' | 'milestonesCreateProject' | 'milestonesCreateStatusNote' | 'milestonesDeleteAttachment' | 'milestonesDeleteCategories' | 'milestonesDeleteCategory' | 'milestonesDeleteComment' | 'milestonesDeleteMilestone' | 'milestonesDeleteMilestones' | 'milestonesDeletePhase' | 'milestonesDeletePhases' | 'milestonesDeleteProject' | 'milestonesExecuteImport' | 'milestonesExport' | 'milestonesMoveMilestoneToPhase' | 'milestonesRemoveDependencies' | 'milestonesRemoveDependency' | 'milestonesReorderPhases' | 'milestonesStartImport' | 'milestonesUpdateCategory' | 'milestonesUpdateMilestone' | 'milestonesUpdateMilestoneStatus' | 'milestonesUpdatePhase' | 'milestonesUpdateProject' | 'moveCollectionItems' | 'offerEventSuggestions' | 'optInRsvpExperiments' | 'optOutRsvpExperiments' | 'pauseStationeryPrintOrderById' | 'populateAccommodationPage' | 'processPrintOrder' | 'processRecommendations' | 'publishEventDesignDraft' | 'purchaseRegistryOrder' | 'quarantineContactMessageBatch' | 'quarantineLinkRedirect' | 'reactivateCashFund' | 'recentTravelReservationsByEventMarkAsRead' | 'refreshOfferTokenAfterReservation' | 'refreshRegistryDrafts' | 'refreshVendorUserClaimToken' | 'refundCashFundContribution' | 'refundStationeryPrintOrderById' | 'regeneratePaymentToken' | 'rejectContactMessageBatch' | 'rejectRegistration' | 'reloadFirebasePhotoFromPath' | 'removeBookingTypeAvailability' | 'removeCalendarCredentials' | 'removeContactFromGroup' | 'removeContactsFromHouseholdById' | 'removeContactTagItemsByIds' | 'removeEventAdminUser' | 'removeEventPagePhoto' | 'removeHostFromBookingType' | 'removeInvitee' | 'removeLocationFromBookingType' | 'removeMagicTokenFromMediaCollection' | 'removeMediaFromCollection' | 'removeMultipleInvitees' | 'removePhotosFromCollection' | 'removeRegistryAddress' | 'removeRegistryItem' | 'removeRegistryPagePhoto' | 'removeStayArea' | 'removeTagFromVendor' | 'removeTagsFromGuest' | 'removeTagsFromResource' | 'removeVendorFromContactList' | 'removeVendorFromShowcase' | 'reorderBookingTypes' | 'reorderEventPages' | 'reorderPageComponents' | 'reorderQandas' | 'reorderRegistries' | 'requestVendorEdit' | 'resendCollaborationInvite' | 'resendEventAdminInvite' | 'resendRegistryOrderConfirmationEmail' | 'resendStationeryPrintOrderToVendor' | 'resendVendorUserInvite' | 'resendWithNewEmail' | 'reserveRegistryOrder' | 'resetAllThemePreferences' | 'resetFontConfiguration' | 'resetRegistryOrderShippingAddress' | 'resetUserActivity' | 'resetUserMFA' | 'resolveStationeryPrintOrderIssue' | 'restoreEvent' | 'resumeStationeryPrintOrderById' | 'revokeCollaborationInvite' | 'revokeCollaboratorAdminPermissions' | 'saveEcard' | 'saveEcardDesign' | 'saveEcardEmailDraft' | 'saveEcardPhoto' | 'saveEmailPhoto' | 'saveEventProductVerticals' | 'saveEventRegistration' | 'saveGreetingCard' | 'saveGreetingCardAndEmailDraft' | 'saveInsightRagPostWithEmbedding' | 'savePostOfficeGenericEmailDraft' | 'savePostOfficeGiftWrapEmailDraft' | 'savePostOfficeGreetingCardEmailDraft' | 'savePostOfficeReminderEmailDraft' | 'savePostOfficeThankYouEmailDraft' | 'saveStationeryProduct' | 'saveStationeryTemplate' | 'saveUserConsentKeyForEvent' | 'saveVendorToShortlist' | 'saveVendorToShortListAndCreateEvent' | 'scheduleAutomaticEventReminder' | 'sendCashFundSolicitationEmails' | 'sendCashFundSolicitationTestEmail' | 'sendCollaborationInvite' | 'sendContactCollectorMessages' | 'sendCoupleUpdateEmails' | 'sendEcardEmail' | 'sendEcardGuestEmail' | 'sendEmailWithTemplate' | 'sendEventDateReminder' | 'sendGenericEmail' | 'sendGiftCardEmail' | 'sendGuestNotFound' | 'sendHotelBlockReminder' | 'sendHotelBlockReminderEmail' | 'sendHotelBlockReminderEmailV2' | 'sendJoyJsonMessageEmail' | 'sendJoyJsonMessageEmailByPeopleIds' | 'sendJoyJsonMessages' | 'sendJoyJsonMessagesByPersonIds' | 'sendJoyProGeneralMessageEmail' | 'sendMessageToHost' | 'sendMessageToMultipleVendors' | 'sendMessageToVendor' | 'sendPhoneNumberVerification' | 'sendPostOfficeGenericEmail' | 'sendPostOfficeGreetingCardEmail' | 'sendPostOfficeReminderEmail' | 'sendPostOfficeThankYouEmail' | 'sendPostOfficeThankYouEmailV2' | 'sendPostRsvpEventDetailsEmail' | 'sendPostRsvpMessages' | 'sendPostRsvpMessagesV2' | 'sendPostRsvpSms' | 'sendPremiumDigitalOrder' | 'sendRegistryOrderConfirmation' | 'sendReminderEmail' | 'sendRequestCode' | 'sendRsvpReminderV2' | 'sendTestAutomaticEventReminder' | 'sendTestEmailWithTemplate' | 'sendTestJoyJsonMessageEmail' | 'sendTestJoyProGeneralMessageEmail' | 'sendTestPremiumDigitalCard' | 'sendTestRsvpReminderV2' | 'sendThankYouEmail' | 'sendTrackingInfoRequestEmail' | 'sendVendorNote' | 'setAccent' | 'setAlohaColorPreference' | 'setAlohaTextColorPreference' | 'setAttendanceByGuestKey' | 'setBookingTypeAvailability' | 'setBrannanBackgroundTransparency' | 'setBrannanColorPreference' | 'setBrannanInnerFrameBorder' | 'setBrannanTextColorPreference' | 'setCalendarOnCredentials' | 'setCustomCss' | 'setDefaultBookingTypeAvailability' | 'setEventAsset' | 'setEventDesignPhoto' | 'setEventPageAsset' | 'setEventPhotoV2Url' | 'setEventPhotoV2UrlMobile' | 'setEventStyle' | 'setEventWebOnboardingComplete' | 'setFont' | 'setFormEnabled' | 'setHasVisitedDesignPage' | 'setMainEventSchedule' | 'setMediaTokenPermissions' | 'setPaletteColor' | 'setPhotoAlignment' | 'setPrintOrderStatus' | 'setProperties' | 'setRegistryAddress' | 'setRegistryCurrency' | 'setRegistryEventData' | 'setReserveRoomBlock' | 'setSearchMetadataByID' | 'setStationeryDigitalPrintOrderFeatureSms' | 'setStationeryDraftRecipientIdList' | 'setTagsForGuest' | 'setTagsForResource' | 'setTheme' | 'setThemeAndLayout' | 'setWebsiteLayout' | 'simpleTagAllPhotosInCollection' | 'simpleTagPhotos' | 'sortTravelItems' | 'startFulfillment' | 'startRefund' | 'startStationeryCheckout' | 'startStationeryInternationalCheckout' | 'stationeryDraftAddAIBackground' | 'stationeryDraftModifyAIBackground' | 'stationeryTrackDigitalCardView' | 'submitFormAnswers' | 'submitLead' | 'syncReserveRoomBlocksToAccommodationPlaces' | 'tagUserInPhoto' | 'tagVendorInPhoto' | 'tagVendorsInAllPhotosInCollection' | 'toggleDesignFavorite' | 'toggleDesignFavorites' | 'trackImpactRadius' | 'transferEventOwnership' | 'transferEventOwnershipV2' | 'transferTransitionalRegistryItems' | 'travelOfferReservationCancel' | 'travelOfferReservationConfirm' | 'travelOfferReservationCreate' | 'travelOfferReservationUpdate' | 'triggerTravelCacheWarmupForEvent' | 'unarchiveUserActivity' | 'unLikePhoto' | 'unlockRequestForProposal' | 'unmarkTemplateAsFavorite' | 'unquarantineLinkRedirect' | 'unsaveVendorFromShortlist' | 'unsetMainEventSchedule' | 'updateAccommodationPlaceV2' | 'updateActiveEventSession' | 'updateBookingSlot' | 'updateBookingSlotStatus' | 'updateBookingTravelItem' | 'updateBookingType' | 'updateCashFund' | 'updateCashFundSolicitation' | 'updateChecklistItem' | 'updateChecklistSubItem' | 'updateConciergeImage' | 'updateContact' | 'updateContactByGuestKey' | 'updateContactCollection' | 'updateContactTag' | 'updateDonationFund' | 'updateDonationFundDonation' | 'updateDonationFundPlatform' | 'updateEventChecklist' | 'updateEventCountdownComponent' | 'updateEventDetailsComponent' | 'updateEventDetailsMessaging' | 'updateEventDisplayNameComponent' | 'updateEventDomain' | 'updateEventInfo' | 'updateEventMatchData' | 'updateEventPage' | 'updateEventPassword' | 'updateEventPlace' | 'updateEventScheduleItem' | 'updateEventSettings' | 'updateEventSuggestion' | 'updateEventType' | 'updateFeedMessagesWithStatus' | 'updateFerryTravelItem' | 'updateFlightTravelItem' | 'updateForm' | 'updateFormAnswer' | 'updateFormTemplate' | 'updateGreetingMessageComponent' | 'updateHotelTravelItem' | 'updateInvitee' | 'updateJsonDataBlobComponent' | 'updateJsonDataContainer' | 'updateListTravelItem' | 'updateMarketingEmailPreferences' | 'updateMatchNote' | 'updateMatchStatus' | 'updateMediaCollection' | 'updateMediaGalleryComponent' | 'updateNoteTravelItem' | 'updatePageContainer' | 'updatePaidMessagingSettings' | 'updatePhotoComponent' | 'updatePointOnMap' | 'updateQanda' | 'updateRecommendRegistryOnboardingSurvey' | 'updateRegistry' | 'updateRegistryChecklistItem' | 'updateRegistryItem' | 'updateRegistryItemQuantity' | 'updateRegistryWithResult' | 'updateRentalCarTravelItem' | 'updateRentalHomeTravelItem' | 'updateReservedRoomBlock' | 'updateRsvpAndUnlockGuestDetailsButtonComponent' | 'updateSafetyRating' | 'updateShuttleTravelItem' | 'updateStationeryDraft' | 'updateStationeryPrintOrderShippingAddress' | 'updateTag' | 'updateTaxiTravelItem' | 'updateTentTravelItem' | 'updateTestimony' | 'updateTextComponent' | 'updateThingsToDoContainers' | 'updateTicketType' | 'updateTrainTravelItem' | 'updateTravelMapComponent' | 'updateTravelSettings' | 'updateUser' | 'updateVendor' | 'updateVendorAsCouple' | 'updateVendorState' | 'updateVendorUser' | 'updateVendorUserInvite' | 'updateVendorUserV2' | 'updateVendorV2' | 'updateVideoComponent' | 'updateVip' | 'updateWebsiteEventGreeting' | 'updateWebsiteHandle' | 'uploadCustomThemeAsset' | 'uploadMediaFromUrls' | 'uploadPhoto' | 'uploadPhotoEnvelopeFromUrl' | 'uploadPhotoEnvelopesFromUrls' | 'uploadPhotoFromUrl' | 'uploadPhotosFromUrls' | 'uploadPhotosFromUrlsV2' | 'uploadPhotosToCollection' | 'uploadPhotoToCollection' | 'upsertCustomTheme' | 'upsertStationeryTag' | 'verifyAccountEmail' | 'websiteActivateHeaderLayout' | 'websiteActivateHeaderLayoutForEvent' | 'websiteApplyHeaderPresentationSettings' | 'websiteCreateOrUpdatePagePhotoPresentation' | 'websiteEnableVideoBackgroundFeature' | 'websiteRemoveActiveHeaderLayoutForEvent' | 'withdrawCashFundsPayoutAccount' | 'withdrawFromPayoutAccount' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	acceptCashFundContribution?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptCollaborationInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptEventAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	activateLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	addAccommodationPlaceV2?: FieldPolicy<any> | FieldReadFunction<any>,
	addAccommodationRecommendationToEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	addAddressToVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	addContactsToHouseholdById?: FieldPolicy<any> | FieldReadFunction<any>,
	addContactToGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	addDonationFundPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addEventCountdownComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addEventDetailsComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addEventDisplayNameComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addGreetingMessageComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addHostToBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	addInvitee?: FieldPolicy<any> | FieldReadFunction<any>,
	addJsonDataBlobComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addMediaGalleryComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addMediaToCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	addMediaToCollectionV2?: FieldPolicy<any> | FieldReadFunction<any>,
	addPhotoComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addPhotosToCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	addPointOnMap?: FieldPolicy<any> | FieldReadFunction<any>,
	addRegistryItemPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addRegistryPagePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addRegistryPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addRsvpAndUnlockGuestDetailsButtonComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addStationeryPrintOrderIssues?: FieldPolicy<any> | FieldReadFunction<any>,
	addTagItemsToContact?: FieldPolicy<any> | FieldReadFunction<any>,
	addTagsToGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	addTagsToResource?: FieldPolicy<any> | FieldReadFunction<any>,
	addTagToVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	addTestimony?: FieldPolicy<any> | FieldReadFunction<any>,
	addTextComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addTravelMapComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	addVendorLogoPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addVendorProfilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	addVendorToContactList?: FieldPolicy<any> | FieldReadFunction<any>,
	addVendorToShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	addVideoComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	annotateRegistryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	applyEventConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	applyFontPack?: FieldPolicy<any> | FieldReadFunction<any>,
	applyFontPackByName?: FieldPolicy<any> | FieldReadFunction<any>,
	applyWebsiteColors?: FieldPolicy<any> | FieldReadFunction<any>,
	applyWebSiteTemplateSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	approveContactMessageBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	approveRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveUserActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	assignAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	authenticateRegistryReservation?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulateAccommodationPlaces?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulateAccommodationPlacesV3?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulateAccommodationPlacesV4?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulateAccommodationPlacesV5?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPopulateStayAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	batchUpdateEventPages?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelContactMessageBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelEventAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelRegistryOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelStationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelTicket?: FieldPolicy<any> | FieldReadFunction<any>,
	changeLinkRedirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	changePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	checkEmailContentSafety?: FieldPolicy<any> | FieldReadFunction<any>,
	checkPhoneNumberVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	checkSmsContentSafety?: FieldPolicy<any> | FieldReadFunction<any>,
	claimVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	claimVendorUserInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	claimVendorUserWithToken?: FieldPolicy<any> | FieldReadFunction<any>,
	combineStationeryPrintOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	convertRegistryDrafts?: FieldPolicy<any> | FieldReadFunction<any>,
	convertRegistryToTransferred?: FieldPolicy<any> | FieldReadFunction<any>,
	createAndStartCheckoutConciergePrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createAndStartCheckoutDigitalPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createAndStartCheckoutSamplePrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createAndStartInternationalCheckoutConciergePrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createAndStartInternationalCheckoutDigitalPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createBookingSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	createBookingTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	createCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	createCashFundCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createCashFundPaymentIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createCashFundSolicitation?: FieldPolicy<any> | FieldReadFunction<any>,
	createChecklistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createChecklistSubItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createCollectionOnEventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createCollectionOnVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	createCollectionWithPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	createContact?: FieldPolicy<any> | FieldReadFunction<any>,
	createContactAndReturnGuestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	createContactCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	createContactsWithoutTags?: FieldPolicy<any> | FieldReadFunction<any>,
	createContactTag?: FieldPolicy<any> | FieldReadFunction<any>,
	createCustomerInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	createDonationFund?: FieldPolicy<any> | FieldReadFunction<any>,
	createDonationFundDonation?: FieldPolicy<any> | FieldReadFunction<any>,
	createDonationFundDonationWithResult?: FieldPolicy<any> | FieldReadFunction<any>,
	createDonationFundPlatform?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventFeatureFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventPage?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventScheduleItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventV0301?: FieldPolicy<any> | FieldReadFunction<any>,
	createFerryTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createFlightTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createForm?: FieldPolicy<any> | FieldReadFunction<any>,
	createFormTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createGeneralEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	createHiredMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createHotelTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createInvitee?: FieldPolicy<any> | FieldReadFunction<any>,
	createJoyFeatureCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	createJsonDataContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	createLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	createLinkRedirectBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	createListTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createMediaPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	createMediaPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	createModernEcardsFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	createNewEventAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	createNoteTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createPageContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	createPaletteColor?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlusOneGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	createPostRsvpHotelBookReminderMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	createQanda?: FieldPolicy<any> | FieldReadFunction<any>,
	createQRCode?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryChecklistFromTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryItemFromCatalogItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryItemsFromCatalogCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryItemsFromCatalogItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryOrderAfterPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryPaymentIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryPayoutAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryPurchaseContext?: FieldPolicy<any> | FieldReadFunction<any>,
	createRegistryWithResult?: FieldPolicy<any> | FieldReadFunction<any>,
	createRemindMeLaterEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	createRentalCarTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createRentalHomeTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createServiceTag?: FieldPolicy<any> | FieldReadFunction<any>,
	createShuttleTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createSingleRegistryItemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createSlimEventAndCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryDigitalDraftPreview?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryDraftFromPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryDraftPreview?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryPriceConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	createStationeryPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createTag?: FieldPolicy<any> | FieldReadFunction<any>,
	createTaxiTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createTentTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createTicketType?: FieldPolicy<any> | FieldReadFunction<any>,
	createTrainTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createTransferredRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	createTransitionalRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorAsCoupleForContactList?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorUserInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorUserOnVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	createVendorV2?: FieldPolicy<any> | FieldReadFunction<any>,
	createVenueFromPlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	createVip?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivateLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccommodationPlaceV2?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBookingSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChecklistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChecklistSubItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContact?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContactCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContactGuestByGuestId?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContactsByContactIds?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContactsByGuestIds?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContactTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCustomTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCustomThemeAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDonationFund?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDonationFundDonation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDonationFundPlatform?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventFeatureFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventPage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventScheduleItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteForm?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFormAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFormTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGuestFromContact?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteJsonDataContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLinkRedirectBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetaTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteModernEcardsFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePageComponentV2?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePageContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePointOnMap?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePostOfficeDraftById?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteQanda?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegistryChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegistryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegistryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegistryWithResult?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReserveRoomBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStationeryDraftById?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStationeryDraftsByEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStationeryPrintOrderForFailedCheckoutUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStationeryTagByName?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTestimony?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTicketType?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTransitionalRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVendorUserInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVip?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverGuestNotFoundMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverRequestForPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	disableMagicTokenForMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	disablePostRsvpSms?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	editCachedResource?: FieldPolicy<any> | FieldReadFunction<any>,
	editCardTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	editCollectionInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	editCollectionItemData?: FieldPolicy<any> | FieldReadFunction<any>,
	editFontConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	editStationeryPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	enableMagicTokenForMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	enablePostRsvpSms?: FieldPolicy<any> | FieldReadFunction<any>,
	endRegistrySession?: FieldPolicy<any> | FieldReadFunction<any>,
	enrichCustomerInsights?: FieldPolicy<any> | FieldReadFunction<any>,
	ensureRegistrationForm?: FieldPolicy<any> | FieldReadFunction<any>,
	eventSetWebsiteState?: FieldPolicy<any> | FieldReadFunction<any>,
	experimentalStationeryBundlePrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	extractMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAccommodationRecommendations?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAltTextForImage?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAltTextForImages?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAltTextForImagesInCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAltTextForImagesInCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAltTextForImageWithVenueAndPhotographer?: FieldPolicy<any> | FieldReadFunction<any>,
	generateMagicTokenForMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	groupContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	hardDeleteTestUser?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelRoomBlocksSubmitted?: FieldPolicy<any> | FieldReadFunction<any>,
	imageRemoveBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	imageToImage?: FieldPolicy<any> | FieldReadFunction<any>,
	imageToImageMasked?: FieldPolicy<any> | FieldReadFunction<any>,
	imageTransferStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	importEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	importFirebasePhotoFromPath?: FieldPolicy<any> | FieldReadFunction<any>,
	importProductByUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	importProductsByUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	importRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	incrementInterestedGuestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	initCashFundsHost?: FieldPolicy<any> | FieldReadFunction<any>,
	instagramAuthorization?: FieldPolicy<any> | FieldReadFunction<any>,
	instantlyProcessStationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	joinEventAsActiveUserWithPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	joinEventAsPersonWithPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	joinEventWithGuid?: FieldPolicy<any> | FieldReadFunction<any>,
	killSchemaCaches?: FieldPolicy<any> | FieldReadFunction<any>,
	leaveEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	likeMultiplePhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	likePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	linkGoogleAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	linkOutlookAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	loadImagesMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	loginEventSession?: FieldPolicy<any> | FieldReadFunction<any>,
	logoutEventSession?: FieldPolicy<any> | FieldReadFunction<any>,
	logUserActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	manageCashFundSolicitationRecipients?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingUpdateEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingUpdateUserEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	markTemplateAsFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	markUserForMFAEnrollment?: FieldPolicy<any> | FieldReadFunction<any>,
	mergeContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesAddDependencies?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesAddDependency?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesAssignMilestone?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCancelImport?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateAttachment?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateComment?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateMilestone?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateMilestones?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreatePhase?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreatePhases?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateProject?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesCreateStatusNote?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteAttachment?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteComment?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteMilestone?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteMilestones?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeletePhase?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeletePhases?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesDeleteProject?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesExecuteImport?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesExport?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesMoveMilestoneToPhase?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesRemoveDependencies?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesRemoveDependency?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesReorderPhases?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesStartImport?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUpdateCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUpdateMilestone?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUpdateMilestoneStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUpdatePhase?: FieldPolicy<any> | FieldReadFunction<any>,
	milestonesUpdateProject?: FieldPolicy<any> | FieldReadFunction<any>,
	moveCollectionItems?: FieldPolicy<any> | FieldReadFunction<any>,
	offerEventSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	optInRsvpExperiments?: FieldPolicy<any> | FieldReadFunction<any>,
	optOutRsvpExperiments?: FieldPolicy<any> | FieldReadFunction<any>,
	pauseStationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	populateAccommodationPage?: FieldPolicy<any> | FieldReadFunction<any>,
	processPrintOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	processRecommendations?: FieldPolicy<any> | FieldReadFunction<any>,
	publishEventDesignDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseRegistryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	quarantineContactMessageBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	quarantineLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	reactivateCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	recentTravelReservationsByEventMarkAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshOfferTokenAfterReservation?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshRegistryDrafts?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshVendorUserClaimToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refundCashFundContribution?: FieldPolicy<any> | FieldReadFunction<any>,
	refundStationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	regeneratePaymentToken?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectContactMessageBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	reloadFirebasePhotoFromPath?: FieldPolicy<any> | FieldReadFunction<any>,
	removeBookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	removeCalendarCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	removeContactFromGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	removeContactsFromHouseholdById?: FieldPolicy<any> | FieldReadFunction<any>,
	removeContactTagItemsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	removeEventAdminUser?: FieldPolicy<any> | FieldReadFunction<any>,
	removeEventPagePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	removeHostFromBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	removeInvitee?: FieldPolicy<any> | FieldReadFunction<any>,
	removeLocationFromBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	removeMagicTokenFromMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	removeMediaFromCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	removeMultipleInvitees?: FieldPolicy<any> | FieldReadFunction<any>,
	removePhotosFromCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRegistryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRegistryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRegistryPagePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	removeStayArea?: FieldPolicy<any> | FieldReadFunction<any>,
	removeTagFromVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	removeTagsFromGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	removeTagsFromResource?: FieldPolicy<any> | FieldReadFunction<any>,
	removeVendorFromContactList?: FieldPolicy<any> | FieldReadFunction<any>,
	removeVendorFromShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	reorderBookingTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	reorderEventPages?: FieldPolicy<any> | FieldReadFunction<any>,
	reorderPageComponents?: FieldPolicy<any> | FieldReadFunction<any>,
	reorderQandas?: FieldPolicy<any> | FieldReadFunction<any>,
	reorderRegistries?: FieldPolicy<any> | FieldReadFunction<any>,
	requestVendorEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	resendCollaborationInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	resendEventAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	resendRegistryOrderConfirmationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resendStationeryPrintOrderToVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	resendVendorUserInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	resendWithNewEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	reserveRegistryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	resetAllThemePreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	resetFontConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	resetRegistryOrderShippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	resetUserActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	resetUserMFA?: FieldPolicy<any> | FieldReadFunction<any>,
	resolveStationeryPrintOrderIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	resumeStationeryPrintOrderById?: FieldPolicy<any> | FieldReadFunction<any>,
	revokeCollaborationInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	revokeCollaboratorAdminPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEcard?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEcardDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEcardEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEcardPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEmailPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEventProductVerticals?: FieldPolicy<any> | FieldReadFunction<any>,
	saveEventRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	saveGreetingCard?: FieldPolicy<any> | FieldReadFunction<any>,
	saveGreetingCardAndEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	saveInsightRagPostWithEmbedding?: FieldPolicy<any> | FieldReadFunction<any>,
	savePostOfficeGenericEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	savePostOfficeGiftWrapEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	savePostOfficeGreetingCardEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	savePostOfficeReminderEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	savePostOfficeThankYouEmailDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	saveStationeryProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	saveStationeryTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	saveUserConsentKeyForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	saveVendorToShortlist?: FieldPolicy<any> | FieldReadFunction<any>,
	saveVendorToShortListAndCreateEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleAutomaticEventReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCashFundSolicitationEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCashFundSolicitationTestEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCollaborationInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	sendContactCollectorMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCoupleUpdateEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	sendEcardEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendEcardGuestEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendEmailWithTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	sendEventDateReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGenericEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGiftCardEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGuestNotFound?: FieldPolicy<any> | FieldReadFunction<any>,
	sendHotelBlockReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendHotelBlockReminderEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendHotelBlockReminderEmailV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sendJoyJsonMessageEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendJoyJsonMessageEmailByPeopleIds?: FieldPolicy<any> | FieldReadFunction<any>,
	sendJoyJsonMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	sendJoyJsonMessagesByPersonIds?: FieldPolicy<any> | FieldReadFunction<any>,
	sendJoyProGeneralMessageEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMessageToHost?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMessageToMultipleVendors?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMessageToVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPhoneNumberVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostOfficeGenericEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostOfficeGreetingCardEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostOfficeReminderEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostOfficeThankYouEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostOfficeThankYouEmailV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostRsvpEventDetailsEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostRsvpMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostRsvpMessagesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPostRsvpSms?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPremiumDigitalOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendRegistryOrderConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	sendReminderEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendRequestCode?: FieldPolicy<any> | FieldReadFunction<any>,
	sendRsvpReminderV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestAutomaticEventReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestEmailWithTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestJoyJsonMessageEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestJoyProGeneralMessageEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestPremiumDigitalCard?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTestRsvpReminderV2?: FieldPolicy<any> | FieldReadFunction<any>,
	sendThankYouEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTrackingInfoRequestEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendVendorNote?: FieldPolicy<any> | FieldReadFunction<any>,
	setAccent?: FieldPolicy<any> | FieldReadFunction<any>,
	setAlohaColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	setAlohaTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	setAttendanceByGuestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	setBookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	setBrannanBackgroundTransparency?: FieldPolicy<any> | FieldReadFunction<any>,
	setBrannanColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	setBrannanInnerFrameBorder?: FieldPolicy<any> | FieldReadFunction<any>,
	setBrannanTextColorPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	setCalendarOnCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	setCustomCss?: FieldPolicy<any> | FieldReadFunction<any>,
	setDefaultBookingTypeAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventDesignPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventPageAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventPhotoV2Url?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventPhotoV2UrlMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	setEventWebOnboardingComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	setFont?: FieldPolicy<any> | FieldReadFunction<any>,
	setFormEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	setHasVisitedDesignPage?: FieldPolicy<any> | FieldReadFunction<any>,
	setMainEventSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	setMediaTokenPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	setPaletteColor?: FieldPolicy<any> | FieldReadFunction<any>,
	setPhotoAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	setPrintOrderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	setProperties?: FieldPolicy<any> | FieldReadFunction<any>,
	setRegistryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	setRegistryCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	setRegistryEventData?: FieldPolicy<any> | FieldReadFunction<any>,
	setReserveRoomBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	setSearchMetadataByID?: FieldPolicy<any> | FieldReadFunction<any>,
	setStationeryDigitalPrintOrderFeatureSms?: FieldPolicy<any> | FieldReadFunction<any>,
	setStationeryDraftRecipientIdList?: FieldPolicy<any> | FieldReadFunction<any>,
	setTagsForGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	setTagsForResource?: FieldPolicy<any> | FieldReadFunction<any>,
	setTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	setThemeAndLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	setWebsiteLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleTagAllPhotosInCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleTagPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	sortTravelItems?: FieldPolicy<any> | FieldReadFunction<any>,
	startFulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	startRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	startStationeryCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	startStationeryInternationalCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryDraftAddAIBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryDraftModifyAIBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryTrackDigitalCardView?: FieldPolicy<any> | FieldReadFunction<any>,
	submitFormAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	submitLead?: FieldPolicy<any> | FieldReadFunction<any>,
	syncReserveRoomBlocksToAccommodationPlaces?: FieldPolicy<any> | FieldReadFunction<any>,
	tagUserInPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	tagVendorInPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	tagVendorsInAllPhotosInCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleDesignFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleDesignFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	trackImpactRadius?: FieldPolicy<any> | FieldReadFunction<any>,
	transferEventOwnership?: FieldPolicy<any> | FieldReadFunction<any>,
	transferEventOwnershipV2?: FieldPolicy<any> | FieldReadFunction<any>,
	transferTransitionalRegistryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationConfirm?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	travelOfferReservationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	triggerTravelCacheWarmupForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	unarchiveUserActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	unLikePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockRequestForProposal?: FieldPolicy<any> | FieldReadFunction<any>,
	unmarkTemplateAsFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	unquarantineLinkRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	unsaveVendorFromShortlist?: FieldPolicy<any> | FieldReadFunction<any>,
	unsetMainEventSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccommodationPlaceV2?: FieldPolicy<any> | FieldReadFunction<any>,
	updateActiveEventSession?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBookingSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBookingSlotStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBookingTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCashFund?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCashFundSolicitation?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChecklistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChecklistSubItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateConciergeImage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContactByGuestKey?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContactCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContactTag?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDonationFund?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDonationFundDonation?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDonationFundPlatform?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventCountdownComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventDetailsComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventDetailsMessaging?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventDisplayNameComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventMatchData?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventPage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventScheduleItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventSuggestion?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFeedMessagesWithStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFerryTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFlightTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateForm?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFormAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFormTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGreetingMessageComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHotelTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInvitee?: FieldPolicy<any> | FieldReadFunction<any>,
	updateJsonDataBlobComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateJsonDataContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	updateListTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMarketingEmailPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMatchNote?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMatchStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMediaGalleryComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNoteTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePageContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePaidMessagingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePhotoComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePointOnMap?: FieldPolicy<any> | FieldReadFunction<any>,
	updateQanda?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRecommendRegistryOnboardingSurvey?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRegistry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRegistryChecklistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRegistryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRegistryItemQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRegistryWithResult?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRentalCarTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRentalHomeTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReservedRoomBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRsvpAndUnlockGuestDetailsButtonComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSafetyRating?: FieldPolicy<any> | FieldReadFunction<any>,
	updateShuttleTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStationeryDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStationeryPrintOrderShippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTag?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTaxiTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTentTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTestimony?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTextComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateThingsToDoContainers?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTicketType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTrainTravelItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTravelMapComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTravelSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendor?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorAsCouple?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorState?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorUserInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorUserV2?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVendorV2?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVideoComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVip?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWebsiteEventGreeting?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWebsiteHandle?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadCustomThemeAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadMediaFromUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotoEnvelopeFromUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotoEnvelopesFromUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotoFromUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotosFromUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotosFromUrlsV2?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotosToCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadPhotoToCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertCustomTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertStationeryTag?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyAccountEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteActivateHeaderLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteActivateHeaderLayoutForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteApplyHeaderPresentationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteCreateOrUpdatePagePhotoPresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteEnableVideoBackgroundFeature?: FieldPolicy<any> | FieldReadFunction<any>,
	websiteRemoveActiveHeaderLayoutForEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawCashFundsPayoutAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawFromPayoutAccount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundGeneralErrorKeySpecifier = ('code' | 'nativeMessage' | CashFundGeneralErrorKeySpecifier)[];
export type CashFundGeneralErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	nativeMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundErrorKeySpecifier = ('code' | CashFundErrorKeySpecifier)[];
export type CashFundErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddContactToGroupKeySpecifier = ('group' | AddContactToGroupKeySpecifier)[];
export type AddContactToGroupFieldPolicy = {
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type addMediaToCollectionResponseKeySpecifier = ('mediaCollection' | 'message' | 'newMedia' | 'success' | addMediaToCollectionResponseKeySpecifier)[];
export type addMediaToCollectionResponseFieldPolicy = {
	mediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	newMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationResponseKeySpecifier = ('message' | 'success' | MutationResponseKeySpecifier)[];
export type MutationResponseFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type addMediaToCollectionResponseErrorKeySpecifier = ('failedMediaIds' | 'mediaCollection' | 'message' | 'newMedia' | 'success' | addMediaToCollectionResponseErrorKeySpecifier)[];
export type addMediaToCollectionResponseErrorFieldPolicy = {
	failedMediaIds?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	newMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactTagItemKeySpecifier = ('contactId' | 'id' | 'tagIds' | ContactTagItemKeySpecifier)[];
export type ContactTagItemFieldPolicy = {
	contactId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tagIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagAssociationGuestKeySpecifier = ('createdAt' | 'createdBy' | 'eventId' | 'guestListMemberId' | 'id' | 'tagDefinitionId' | TagAssociationGuestKeySpecifier)[];
export type TagAssociationGuestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestListMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagAssociationResourceKeySpecifier = ('createdAt' | 'createdBy' | 'eventId' | 'id' | 'resourceId' | 'resourceType' | 'tagDefinitionId' | TagAssociationResourceKeySpecifier)[];
export type TagAssociationResourceFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceType?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderResultKeySpecifier = ('alreadyExists' | 'model' | 'status' | RegistryOrderResultKeySpecifier)[];
export type RegistryOrderResultFieldPolicy = {
	alreadyExists?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResultStatusKeySpecifier = ('id' | 'modified' | ResultStatusKeySpecifier)[];
export type ResultStatusFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApprovalResultKeySpecifier = ('attendance' | 'notificationError' | 'notificationSent' | ApprovalResultKeySpecifier)[];
export type ApprovalResultFieldPolicy = {
	attendance?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationError?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationSent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArchiveCashFundSuccessKeySpecifier = ('id' | ArchiveCashFundSuccessKeySpecifier)[];
export type ArchiveCashFundSuccessFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveRegistrySessionKeySpecifier = ('isAuthenticated' | 'registryOrders' | ActiveRegistrySessionKeySpecifier)[];
export type ActiveRegistrySessionFieldPolicy = {
	isAuthenticated?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlaceIdKeySpecifier = ('id' | AccommodationPlaceIdKeySpecifier)[];
export type AccommodationPlaceIdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationPlaceV3IdKeySpecifier = ('id' | AccommodationPlaceV3IdKeySpecifier)[];
export type AccommodationPlaceV3IdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutoPopulateResponseV5KeySpecifier = ('error' | 'idempotentId' | 'result' | 'status' | AutoPopulateResponseV5KeySpecifier)[];
export type AutoPopulateResponseV5FieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutoPopulateStayAreasResponseKeySpecifier = ('error' | 'idempotentId' | 'result' | 'status' | AutoPopulateStayAreasResponseKeySpecifier)[];
export type AutoPopulateStayAreasResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentSafetyRatingResponseKeySpecifier = ('isLikelySpam' | 'promptVersion' | 'spamIndicators' | 'spamRating' | 'summary' | 'urls' | ContentSafetyRatingResponseKeySpecifier)[];
export type ContentSafetyRatingResponseFieldPolicy = {
	isLikelySpam?: FieldPolicy<any> | FieldReadFunction<any>,
	promptVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	spamIndicators?: FieldPolicy<any> | FieldReadFunction<any>,
	spamRating?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransferRegistryResultKeySpecifier = ('completed' | 'failed' | 'initialItemCount' | 'registry' | 'registryEventData' | 'succeeded' | 'unsupportedUrlError' | TransferRegistryResultKeySpecifier)[];
export type TransferRegistryResultFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	failed?: FieldPolicy<any> | FieldReadFunction<any>,
	initialItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	registry?: FieldPolicy<any> | FieldReadFunction<any>,
	registryEventData?: FieldPolicy<any> | FieldReadFunction<any>,
	succeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	unsupportedUrlError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StartStationeryCheckoutResponseKeySpecifier = ('checkoutUrl' | StartStationeryCheckoutResponseKeySpecifier)[];
export type StartStationeryCheckoutResponseFieldPolicy = {
	checkoutUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundCheckoutSessionKeySpecifier = ('id' | 'paymentAttempt' | 'redirectUrl' | CashFundCheckoutSessionKeySpecifier)[];
export type CashFundCheckoutSessionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAttempt?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashFundPaymentIntentKeySpecifier = ('clientSecret' | 'id' | 'paymentAttempt' | CashFundPaymentIntentKeySpecifier)[];
export type CashFundPaymentIntentFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAttempt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactTagKeySpecifier = ('contactCollectionId' | 'id' | 'tagValue' | ContactTagKeySpecifier)[];
export type ContactTagFieldPolicy = {
	contactCollectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tagValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DonationFundResultKeySpecifier = ('alreadyExists' | 'model' | 'registryOrder' | 'status' | DonationFundResultKeySpecifier)[];
export type DonationFundResultFieldPolicy = {
	alreadyExists?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureFlagKeySpecifier = ('flag' | 'id' | FeatureFlagKeySpecifier)[];
export type FeatureFlagFieldPolicy = {
	flag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type createMediaPhotosResponseKeySpecifier = ('mediaPhoto' | 'message' | 'success' | createMediaPhotosResponseKeySpecifier)[];
export type createMediaPhotosResponseFieldPolicy = {
	mediaPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePlusOneGuestKeySpecifier = ('contact' | 'plusOne' | CreatePlusOneGuestKeySpecifier)[];
export type CreatePlusOneGuestFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	plusOne?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlusOneGuestKeySpecifier = ('consumedAt' | 'createdAt' | 'eventId' | 'guestListMemberId' | 'householdId' | 'id' | 'name' | 'updatedAt' | PlusOneGuestKeySpecifier)[];
export type PlusOneGuestFieldPolicy = {
	consumedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	guestListMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	householdId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemResultKeySpecifier = ('model' | 'status' | RegistryItemResultKeySpecifier)[];
export type RegistryItemResultFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemsResultKeySpecifier = ('models' | RegistryItemsResultKeySpecifier)[];
export type RegistryItemsResultFieldPolicy = {
	models?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPaymentIntentKeySpecifier = ('checkoutWarningCodes' | 'clientSecret' | 'returnUrl' | 'status' | RegistryPaymentIntentKeySpecifier)[];
export type RegistryPaymentIntentFieldPolicy = {
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	returnUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPaymentIntentErrorKeySpecifier = ('checkoutFailureCode' | 'checkoutWarningCodes' | RegistryPaymentIntentErrorKeySpecifier)[];
export type RegistryPaymentIntentErrorFieldPolicy = {
	checkoutFailureCode?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryErrorResultKeySpecifier = ('error' | RegistryErrorResultKeySpecifier)[];
export type RegistryErrorResultFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryErrorPayloadKeySpecifier = ('code' | 'nativeMessage' | RegistryErrorPayloadKeySpecifier)[];
export type RegistryErrorPayloadFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	nativeMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPurchaseContextEnvelopeKeySpecifier = ('checkoutFailureCode' | 'checkoutUrl' | 'checkoutWarningCodes' | RegistryPurchaseContextEnvelopeKeySpecifier)[];
export type RegistryPurchaseContextEnvelopeFieldPolicy = {
	checkoutFailureCode?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutWarningCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryResultKeySpecifier = ('model' | 'status' | 'summary' | RegistryResultKeySpecifier)[];
export type RegistryResultFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryDigitalDraftPreviewKeySpecifier = ('digitalEnvelopeImage' | 'stationeryBackImage' | 'stationeryFrontImage' | StationeryDigitalDraftPreviewKeySpecifier)[];
export type StationeryDigitalDraftPreviewFieldPolicy = {
	digitalEnvelopeImage?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryBackImage?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryFrontImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StationeryDraftPreviewKeySpecifier = ('envelopeBackImage' | 'envelopeFrontImage' | 'envelopePDF' | 'stationeryBackImage' | 'stationeryFrontImage' | 'stationeryPDF' | StationeryDraftPreviewKeySpecifier)[];
export type StationeryDraftPreviewFieldPolicy = {
	envelopeBackImage?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopeFrontImage?: FieldPolicy<any> | FieldReadFunction<any>,
	envelopePDF?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryBackImage?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryFrontImage?: FieldPolicy<any> | FieldReadFunction<any>,
	stationeryPDF?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorOrganizationKeySpecifier = ('handle' | 'id' | 'name' | VendorOrganizationKeySpecifier)[];
export type VendorOrganizationFieldPolicy = {
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardResponseKeySpecifier = ('resourceID' | 'url' | CardResponseKeySpecifier)[];
export type CardResponseFieldPolicy = {
	resourceID?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetImagesMetadataResponseKeySpecifier = ('failureCount' | 'results' | 'successCount' | GetImagesMetadataResponseKeySpecifier)[];
export type GetImagesMetadataResponseFieldPolicy = {
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetImageMetadataResultItemKeySpecifier = ('data' | 'status' | GetImageMetadataResultItemKeySpecifier)[];
export type GetImageMetadataResultItemFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FailedImageMetadataResponseKeySpecifier = ('assetId' | 'containerId' | 'errorMessage' | FailedImageMetadataResponseKeySpecifier)[];
export type FailedImageMetadataResponseFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	containerId?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateAccommodationRecommendationsResponseKeySpecifier = ('error' | 'idempotentId' | 'result' | 'status' | GenerateAccommodationRecommendationsResponseKeySpecifier)[];
export type GenerateAccommodationRecommendationsResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotentId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateRecommendationsResultKeySpecifier = ('recommendations' | 'searchLocation' | GenerateRecommendationsResultKeySpecifier)[];
export type GenerateRecommendationsResultFieldPolicy = {
	recommendations?: FieldPolicy<any> | FieldReadFunction<any>,
	searchLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationRecommendationsSearchLocationInfoKeySpecifier = ('displayAddress' | 'googlePlaceId' | 'latitude' | 'longitude' | 'name' | AccommodationRecommendationsSearchLocationInfoKeySpecifier)[];
export type AccommodationRecommendationsSearchLocationInfoFieldPolicy = {
	displayAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupContactsKeySpecifier = ('group' | GroupContactsKeySpecifier)[];
export type GroupContactsFieldPolicy = {
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JoinEventWithGuidResponseKeySpecifier = ('event' | 'eventSession' | 'guidId' | 'mustLogoutEventUser' | JoinEventWithGuidResponseKeySpecifier)[];
export type JoinEventWithGuidResponseFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventSession?: FieldPolicy<any> | FieldReadFunction<any>,
	guidId?: FieldPolicy<any> | FieldReadFunction<any>,
	mustLogoutEventUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEventResultKeySpecifier = ('message' | 'statusCode' | UpdateEventResultKeySpecifier)[];
export type UpdateEventResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	statusCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateUserResultKeySpecifier = ('message' | 'statusCode' | UpdateUserResultKeySpecifier)[];
export type UpdateUserResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	statusCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesDependenciesBatchResultKeySpecifier = ('createdCount' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesDependenciesBatchResultKeySpecifier)[];
export type MilestonesDependenciesBatchResultFieldPolicy = {
	createdCount?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesBatchOperationErrorKeySpecifier = ('code' | 'id' | 'index' | 'message' | MilestonesBatchOperationErrorKeySpecifier)[];
export type MilestonesBatchOperationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCategoriesBatchCreateResultKeySpecifier = ('created' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesCategoriesBatchCreateResultKeySpecifier)[];
export type MilestonesCategoriesBatchCreateResultFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesBatchCreateResultKeySpecifier = ('created' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesBatchCreateResultKeySpecifier)[];
export type MilestonesBatchCreateResultFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesPhasesBatchCreateResultKeySpecifier = ('created' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesPhasesBatchCreateResultKeySpecifier)[];
export type MilestonesPhasesBatchCreateResultFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesCategoriesBatchDeleteResultKeySpecifier = ('deletedIds' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesCategoriesBatchDeleteResultKeySpecifier)[];
export type MilestonesCategoriesBatchDeleteResultFieldPolicy = {
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesBatchDeleteResultKeySpecifier = ('deletedIds' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesBatchDeleteResultKeySpecifier)[];
export type MilestonesBatchDeleteResultFieldPolicy = {
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesPhasesBatchDeleteResultKeySpecifier = ('deletedIds' | 'errors' | 'failureCount' | 'successCount' | 'totalRequested' | MilestonesPhasesBatchDeleteResultKeySpecifier)[];
export type MilestonesPhasesBatchDeleteResultFieldPolicy = {
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MilestonesExportResultKeySpecifier = ('downloadUrl' | 'expiresAt' | 'fileName' | MilestonesExportResultKeySpecifier)[];
export type MilestonesExportResultFieldPolicy = {
	downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefreshOfferTokenResultKeySpecifier = ('currency' | 'originalPriceInMinorUnits' | 'priceDifferenceInMinorUnits' | 'refreshedPriceInMinorUnits' | 'tokenRefreshedAt' | 'tokenUpdated' | RefreshOfferTokenResultKeySpecifier)[];
export type RefreshOfferTokenResultFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	originalPriceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	priceDifferenceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshedPriceInMinorUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenRefreshedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenUpdated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationCreateStripeNativeResultKeySpecifier = ('checkoutUrl' | 'paymentIntentClientSecret' | 'reservation' | TravelOfferReservationCreateStripeNativeResultKeySpecifier)[];
export type TravelOfferReservationCreateStripeNativeResultFieldPolicy = {
	checkoutUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentIntentClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	reservation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationCreateVaulteraVaultResultKeySpecifier = ('reservation' | 'vaulteraToken' | TravelOfferReservationCreateVaulteraVaultResultKeySpecifier)[];
export type TravelOfferReservationCreateVaulteraVaultResultFieldPolicy = {
	reservation?: FieldPolicy<any> | FieldReadFunction<any>,
	vaulteraToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveContactFromGroupKeySpecifier = ('group' | RemoveContactFromGroupKeySpecifier)[];
export type RemoveContactFromGroupFieldPolicy = {
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RawPageComponentKeySpecifier = ('id' | 'sortOrder' | RawPageComponentKeySpecifier)[];
export type RawPageComponentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventRegistrationResponseKeySpecifier = ('guestKey' | EventRegistrationResponseKeySpecifier)[];
export type EventRegistrationResponseFieldPolicy = {
	guestKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendCashFundSolicitationEmailsSuccessKeySpecifier = ('id' | SendCashFundSolicitationEmailsSuccessKeySpecifier)[];
export type SendCashFundSolicitationEmailsSuccessFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendCashFundSolicitationTestEmailSuccessKeySpecifier = ('id' | SendCashFundSolicitationTestEmailSuccessKeySpecifier)[];
export type SendCashFundSolicitationTestEmailSuccessFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendMessageBatchResultKeySpecifier = ('messageBatchId' | 'quarantined' | 'sentEmails' | 'sentSms' | 'skippedEmails' | 'skippedSms' | SendMessageBatchResultKeySpecifier)[];
export type SendMessageBatchResultFieldPolicy = {
	messageBatchId?: FieldPolicy<any> | FieldReadFunction<any>,
	quarantined?: FieldPolicy<any> | FieldReadFunction<any>,
	sentEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	sentSms?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedSms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhoneNumberSendVerificationResponseKeySpecifier = ('dateCreated' | 'dateUpdated' | 'numberOfAttempts' | 'phoneNumber' | 'sendCodeAttempts' | 'status' | PhoneNumberSendVerificationResponseKeySpecifier)[];
export type PhoneNumberSendVerificationResponseFieldPolicy = {
	dateCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	dateUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCodeAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhoneNumberVerificationAttemptKeySpecifier = ('channel' | 'timestamp' | PhoneNumberVerificationAttemptKeySpecifier)[];
export type PhoneNumberVerificationAttemptFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendPostRsvpSmsResponseKeySpecifier = ('messageSent' | 'verifyStatus' | SendPostRsvpSmsResponseKeySpecifier)[];
export type SendPostRsvpSmsResponseFieldPolicy = {
	messageSent?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryStartFulfillmentResultKeySpecifier = ('failedStatusDetails' | 'registryOrderId' | 'salesOrderId' | 'status' | RegistryStartFulfillmentResultKeySpecifier)[];
export type RegistryStartFulfillmentResultFieldPolicy = {
	failedStatusDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	registryOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	salesOrderId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageHistoryVariationKeySpecifier = ('baseUrl' | 'promptPayload' | 'resourceID' | 'type' | 'url' | ImageHistoryVariationKeySpecifier)[];
export type ImageHistoryVariationFieldPolicy = {
	baseUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	promptPayload?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceID?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariationPromptKeySpecifier = ('prompt' | 'style' | VariationPromptKeySpecifier)[];
export type VariationPromptFieldPolicy = {
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	style?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationCancelFailureKeySpecifier = ('errorMessage' | TravelOfferReservationCancelFailureKeySpecifier)[];
export type TravelOfferReservationCancelFailureFieldPolicy = {
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationCancelSuccessKeySpecifier = ('reservation' | TravelOfferReservationCancelSuccessKeySpecifier)[];
export type TravelOfferReservationCancelSuccessFieldPolicy = {
	reservation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationConfirmFailureKeySpecifier = ('errorMessage' | TravelOfferReservationConfirmFailureKeySpecifier)[];
export type TravelOfferReservationConfirmFailureFieldPolicy = {
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferReservationConfirmSuccessKeySpecifier = ('reservation' | TravelOfferReservationConfirmSuccessKeySpecifier)[];
export type TravelOfferReservationConfirmSuccessFieldPolicy = {
	reservation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventGreetingResponseKeySpecifier = ('eventId' | 'greeting' | EventGreetingResponseKeySpecifier)[];
export type EventGreetingResponseFieldPolicy = {
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	greeting?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoEnvelopeResultKeySpecifier = ('actionCode' | 'actionRetryDelay' | 'error' | 'photo' | PhotoEnvelopeResultKeySpecifier)[];
export type PhotoEnvelopeResultFieldPolicy = {
	actionCode?: FieldPolicy<any> | FieldReadFunction<any>,
	actionRetryDelay?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoEnvelopeErrorKeySpecifier = ('code' | 'message' | 'name' | 'stack' | PhotoEnvelopeErrorKeySpecifier)[];
export type PhotoEnvelopeErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stack?: FieldPolicy<any> | FieldReadFunction<any>
};
export type uploadPhotosFromUrlsResponseErrorKeySpecifier = ('failedPayloads' | 'photos' | uploadPhotosFromUrlsResponseErrorKeySpecifier)[];
export type uploadPhotosFromUrlsResponseErrorFieldPolicy = {
	failedPayloads?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FailedPhotoUploadResponseKeySpecifier = ('assetId' | 'containerId' | 'url' | FailedPhotoUploadResponseKeySpecifier)[];
export type FailedPhotoUploadResponseFieldPolicy = {
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	containerId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type uploadPhotosFromUrlsResponseSuccessKeySpecifier = ('photos' | uploadPhotosFromUrlsResponseSuccessKeySpecifier)[];
export type uploadPhotosFromUrlsResponseSuccessFieldPolicy = {
	photos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type websiteCreateOrUpdatePagePhotoPresentationResponseKeySpecifier = ('message' | 'photoPresentation' | 'success' | websiteCreateOrUpdatePagePhotoPresentationResponseKeySpecifier)[];
export type websiteCreateOrUpdatePagePhotoPresentationResponseFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	photoPresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type websiteCreateOrUpdatePagePhotoPresentationResponseErrorKeySpecifier = ('id' | 'message' | 'pageId' | 'success' | websiteCreateOrUpdatePagePhotoPresentationResponseErrorKeySpecifier)[];
export type websiteCreateOrUpdatePagePhotoPresentationResponseErrorFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	pageId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryPayoutWithdrawalKeySpecifier = ('status' | 'url' | RegistryPayoutWithdrawalKeySpecifier)[];
export type RegistryPayoutWithdrawalFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccommodationCatalogPropertyUnitKeySpecifier = ('adults' | 'boardBasis' | 'children' | 'facilities' | 'id' | 'name' | 'photos' | 'plainTextLongDescription' | 'property' | AccommodationCatalogPropertyUnitKeySpecifier)[];
export type AccommodationCatalogPropertyUnitFieldPolicy = {
	adults?: FieldPolicy<any> | FieldReadFunction<any>,
	boardBasis?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	photos?: FieldPolicy<any> | FieldReadFunction<any>,
	plainTextLongDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	property?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlogArticleKeySpecifier = ('description' | 'eyebrow' | 'image' | 'imageUrl' | 'title' | 'url' | BlogArticleKeySpecifier)[];
export type BlogArticleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eyebrow?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignFeatureKeySpecifier = ('featureName' | 'featureValueType' | 'id' | DesignFeatureKeySpecifier)[];
export type DesignFeatureFieldPolicy = {
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	featureValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PricingKeySpecifier = ('sourcePrice' | PricingKeySpecifier)[];
export type PricingFieldPolicy = {
	sourcePrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityBrandKeySpecifier = ('catalogBrandData' | 'id' | ProductCatalogEntityBrandKeySpecifier)[];
export type ProductCatalogEntityBrandFieldPolicy = {
	catalogBrandData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityCategoryKeySpecifier = ('catalogCategoryData' | 'id' | ProductCatalogEntityCategoryKeySpecifier)[];
export type ProductCatalogEntityCategoryFieldPolicy = {
	catalogCategoryData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityCurationKeySpecifier = ('catalogCurationData' | 'id' | ProductCatalogEntityCurationKeySpecifier)[];
export type ProductCatalogEntityCurationFieldPolicy = {
	catalogCurationData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityItemKeySpecifier = ('catalogItemData' | 'id' | ProductCatalogEntityItemKeySpecifier)[];
export type ProductCatalogEntityItemFieldPolicy = {
	catalogItemData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogEntityItemGroupKeySpecifier = ('catalogItemGroupData' | 'id' | ProductCatalogEntityItemGroupKeySpecifier)[];
export type ProductCatalogEntityItemGroupFieldPolicy = {
	catalogItemGroupData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCatalogRegistryStoreRecommandationKeySpecifier = ('id' | 'locator' | 'name' | ProductCatalogRegistryStoreRecommandationKeySpecifier)[];
export type ProductCatalogRegistryStoreRecommandationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locator?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryItemRecommendationResultKeySpecifier = ('recommendableItems' | RegistryItemRecommendationResultKeySpecifier)[];
export type RegistryItemRecommendationResultFieldPolicy = {
	recommendableItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistryOrderLineItemCommerceDataKeySpecifier = ('isEdelivery' | RegistryOrderLineItemCommerceDataKeySpecifier)[];
export type RegistryOrderLineItemCommerceDataFieldPolicy = {
	isEdelivery?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryFundKeySpecifier = ('fundData' | 'id' | 'photo' | 'title' | TransitionalRegistryFundKeySpecifier)[];
export type TransitionalRegistryFundFieldPolicy = {
	fundData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryFundDataKeySpecifier = ('goal' | TransitionalRegistryFundDataKeySpecifier)[];
export type TransitionalRegistryFundDataFieldPolicy = {
	goal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryProductKeySpecifier = ('id' | 'photo' | 'productData' | 'title' | TransitionalRegistryProductKeySpecifier)[];
export type TransitionalRegistryProductFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	productData?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransitionalRegistryProductDataKeySpecifier = ('price' | TransitionalRegistryProductDataKeySpecifier)[];
export type TransitionalRegistryProductDataFieldPolicy = {
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferAccommodationUnitsComponentKeySpecifier = ('baseAmount' | 'boardBasis' | 'componentType' | 'distributionType' | 'occupancies' | 'policies' | 'refundability' | 'totalAmount' | 'unit' | 'unitCount' | TravelOfferAccommodationUnitsComponentKeySpecifier)[];
export type TravelOfferAccommodationUnitsComponentFieldPolicy = {
	baseAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	boardBasis?: FieldPolicy<any> | FieldReadFunction<any>,
	componentType?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionType?: FieldPolicy<any> | FieldReadFunction<any>,
	occupancies?: FieldPolicy<any> | FieldReadFunction<any>,
	policies?: FieldPolicy<any> | FieldReadFunction<any>,
	refundability?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TravelOfferAccommodationUnitsComponentOccupancyKeySpecifier = ('adults' | 'children' | 'childrenAges' | TravelOfferAccommodationUnitsComponentOccupancyKeySpecifier)[];
export type TravelOfferAccommodationUnitsComponentOccupancyFieldPolicy = {
	adults?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	childrenAges?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VendorLocationKeySpecifier = ('address1' | 'address2' | 'city' | 'country' | 'latitude' | 'longitude' | 'name' | 'placeId' | 'postalCode' | 'state' | VendorLocationKeySpecifier)[];
export type VendorLocationFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	AccommodationCatalogProperty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyKeySpecifier | (() => undefined | AccommodationCatalogPropertyKeySpecifier),
		fields?: AccommodationCatalogPropertyFieldPolicy,
	},
	AccommodationCatalogPropertyAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyAddressKeySpecifier | (() => undefined | AccommodationCatalogPropertyAddressKeySpecifier),
		fields?: AccommodationCatalogPropertyAddressFieldPolicy,
	},
	AccommodationCatalogPropertyCheckInOutRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyCheckInOutRangeKeySpecifier | (() => undefined | AccommodationCatalogPropertyCheckInOutRangeKeySpecifier),
		fields?: AccommodationCatalogPropertyCheckInOutRangeFieldPolicy,
	},
	AccommodationCatalogFacilityOrAmenity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogFacilityOrAmenityKeySpecifier | (() => undefined | AccommodationCatalogFacilityOrAmenityKeySpecifier),
		fields?: AccommodationCatalogFacilityOrAmenityFieldPolicy,
	},
	AccommodationCatalogLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogLocationKeySpecifier | (() => undefined | AccommodationCatalogLocationKeySpecifier),
		fields?: AccommodationCatalogLocationFieldPolicy,
	},
	AccommodationCatalogPhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPhotoKeySpecifier | (() => undefined | AccommodationCatalogPhotoKeySpecifier),
		fields?: AccommodationCatalogPhotoFieldPolicy,
	},
	Photo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoKeySpecifier | (() => undefined | PhotoKeySpecifier),
		fields?: PhotoFieldPolicy,
	},
	CollectionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemKeySpecifier | (() => undefined | CollectionItemKeySpecifier),
		fields?: CollectionItemFieldPolicy,
	},
	Collection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionKeySpecifier | (() => undefined | CollectionKeySpecifier),
		fields?: CollectionFieldPolicy,
	},
	EventMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventMatchKeySpecifier | (() => undefined | EventMatchKeySpecifier),
		fields?: EventMatchFieldPolicy,
	},
	Match?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchKeySpecifier | (() => undefined | MatchKeySpecifier),
		fields?: MatchFieldPolicy,
	},
	RequestForProposal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestForProposalKeySpecifier | (() => undefined | RequestForProposalKeySpecifier),
		fields?: RequestForProposalFieldPolicy,
	},
	Date?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateKeySpecifier | (() => undefined | DateKeySpecifier),
		fields?: DateFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserAlias?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAliasKeySpecifier | (() => undefined | UserAliasKeySpecifier),
		fields?: UserAliasFieldPolicy,
	},
	EventUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventUserKeySpecifier | (() => undefined | EventUserKeySpecifier),
		fields?: EventUserFieldPolicy,
	},
	Event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventKeySpecifier | (() => undefined | EventKeySpecifier),
		fields?: EventFieldPolicy,
	},
	AccommodationPlaceV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlaceV2KeySpecifier | (() => undefined | AccommodationPlaceV2KeySpecifier),
		fields?: AccommodationPlaceV2FieldPolicy,
	},
	AccommodationPlaceRoomBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlaceRoomBlockKeySpecifier | (() => undefined | AccommodationPlaceRoomBlockKeySpecifier),
		fields?: AccommodationPlaceRoomBlockFieldPolicy,
	},
	AccommodationPlaceRecommendation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlaceRecommendationKeySpecifier | (() => undefined | AccommodationPlaceRecommendationKeySpecifier),
		fields?: AccommodationPlaceRecommendationFieldPolicy,
	},
	DistanceInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistanceInfoKeySpecifier | (() => undefined | DistanceInfoKeySpecifier),
		fields?: DistanceInfoFieldPolicy,
	},
	JoyPlace?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JoyPlaceKeySpecifier | (() => undefined | JoyPlaceKeySpecifier),
		fields?: JoyPlaceFieldPolicy,
	},
	RedirectMechanism?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RedirectMechanismKeySpecifier | (() => undefined | RedirectMechanismKeySpecifier),
		fields?: RedirectMechanismFieldPolicy,
	},
	UserRating?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRatingKeySpecifier | (() => undefined | UserRatingKeySpecifier),
		fields?: UserRatingFieldPolicy,
	},
	TravelPropertyPricingV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPropertyPricingV2KeySpecifier | (() => undefined | TravelPropertyPricingV2KeySpecifier),
		fields?: TravelPropertyPricingV2FieldPolicy,
	},
	TravelMonetaryValueV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelMonetaryValueV2KeySpecifier | (() => undefined | TravelMonetaryValueV2KeySpecifier),
		fields?: TravelMonetaryValueV2FieldPolicy,
	},
	TravelOfferFeeV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferFeeV2KeySpecifier | (() => undefined | TravelOfferFeeV2KeySpecifier),
		fields?: TravelOfferFeeV2FieldPolicy,
	},
	TravelDistancesBetweenPointsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelDistancesBetweenPointsResponseKeySpecifier | (() => undefined | TravelDistancesBetweenPointsResponseKeySpecifier),
		fields?: TravelDistancesBetweenPointsResponseFieldPolicy,
	},
	TravelDistanceBetweenPoints?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelDistanceBetweenPointsKeySpecifier | (() => undefined | TravelDistanceBetweenPointsKeySpecifier),
		fields?: TravelDistanceBetweenPointsFieldPolicy,
	},
	ExternalPDP?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalPDPKeySpecifier | (() => undefined | ExternalPDPKeySpecifier),
		fields?: ExternalPDPFieldPolicy,
	},
	EventSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSessionKeySpecifier | (() => undefined | EventSessionKeySpecifier),
		fields?: EventSessionFieldPolicy,
	},
	EventSessionCTA?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSessionCTAKeySpecifier | (() => undefined | EventSessionCTAKeySpecifier),
		fields?: EventSessionCTAFieldPolicy,
	},
	EventSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventScheduleKeySpecifier | (() => undefined | EventScheduleKeySpecifier),
		fields?: EventScheduleFieldPolicy,
	},
	EventScheduleGuests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventScheduleGuestsKeySpecifier | (() => undefined | EventScheduleGuestsKeySpecifier),
		fields?: EventScheduleGuestsFieldPolicy,
	},
	EventLabel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventLabelKeySpecifier | (() => undefined | EventLabelKeySpecifier),
		fields?: EventLabelFieldPolicy,
	},
	Person?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonKeySpecifier | (() => undefined | PersonKeySpecifier),
		fields?: PersonFieldPolicy,
	},
	InviteeLocationOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InviteeLocationOutputKeySpecifier | (() => undefined | InviteeLocationOutputKeySpecifier),
		fields?: InviteeLocationOutputFieldPolicy,
	},
	Email?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailKeySpecifier | (() => undefined | EmailKeySpecifier),
		fields?: EmailFieldPolicy,
	},
	EmailStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailStatusKeySpecifier | (() => undefined | EmailStatusKeySpecifier),
		fields?: EmailStatusFieldPolicy,
	},
	Household?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HouseholdKeySpecifier | (() => undefined | HouseholdKeySpecifier),
		fields?: HouseholdFieldPolicy,
	},
	LegacyRsvpAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyRsvpAnswerKeySpecifier | (() => undefined | LegacyRsvpAnswerKeySpecifier),
		fields?: LegacyRsvpAnswerFieldPolicy,
	},
	EventLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventLocationKeySpecifier | (() => undefined | EventLocationKeySpecifier),
		fields?: EventLocationFieldPolicy,
	},
	LocationInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationInterfaceKeySpecifier | (() => undefined | LocationInterfaceKeySpecifier),
		fields?: LocationInterfaceFieldPolicy,
	},
	VirtualEventLinkParseResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VirtualEventLinkParseResultKeySpecifier | (() => undefined | VirtualEventLinkParseResultKeySpecifier),
		fields?: VirtualEventLinkParseResultFieldPolicy,
	},
	LocationAnchor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationAnchorKeySpecifier | (() => undefined | LocationAnchorKeySpecifier),
		fields?: LocationAnchorFieldPolicy,
	},
	EventChecklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventChecklistKeySpecifier | (() => undefined | EventChecklistKeySpecifier),
		fields?: EventChecklistFieldPolicy,
	},
	ChecklistItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChecklistItemKeySpecifier | (() => undefined | ChecklistItemKeySpecifier),
		fields?: ChecklistItemFieldPolicy,
	},
	ChecklistSubItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChecklistSubItemKeySpecifier | (() => undefined | ChecklistSubItemKeySpecifier),
		fields?: ChecklistSubItemFieldPolicy,
	},
	CustomTheme?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomThemeKeySpecifier | (() => undefined | CustomThemeKeySpecifier),
		fields?: CustomThemeFieldPolicy,
	},
	CustomThemeAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomThemeAssetKeySpecifier | (() => undefined | CustomThemeAssetKeySpecifier),
		fields?: CustomThemeAssetFieldPolicy,
	},
	DesignFavorite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignFavoriteKeySpecifier | (() => undefined | DesignFavoriteKeySpecifier),
		fields?: DesignFavoriteFieldPolicy,
	},
	DesignLayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignLayoutKeySpecifier | (() => undefined | DesignLayoutKeySpecifier),
		fields?: DesignLayoutFieldPolicy,
	},
	Theme?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThemeKeySpecifier | (() => undefined | ThemeKeySpecifier),
		fields?: ThemeFieldPolicy,
	},
	ThemeColorScheme?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThemeColorSchemeKeySpecifier | (() => undefined | ThemeColorSchemeKeySpecifier),
		fields?: ThemeColorSchemeFieldPolicy,
	},
	Color?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColorKeySpecifier | (() => undefined | ColorKeySpecifier),
		fields?: ColorFieldPolicy,
	},
	DesignBucket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignBucketKeySpecifier | (() => undefined | DesignBucketKeySpecifier),
		fields?: DesignBucketFieldPolicy,
	},
	Font?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FontKeySpecifier | (() => undefined | FontKeySpecifier),
		fields?: FontFieldPolicy,
	},
	ThemeMarketingData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThemeMarketingDataKeySpecifier | (() => undefined | ThemeMarketingDataKeySpecifier),
		fields?: ThemeMarketingDataFieldPolicy,
	},
	PrintProviderTheme?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrintProviderThemeKeySpecifier | (() => undefined | PrintProviderThemeKeySpecifier),
		fields?: PrintProviderThemeFieldPolicy,
	},
	PrintProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrintProviderKeySpecifier | (() => undefined | PrintProviderKeySpecifier),
		fields?: PrintProviderFieldPolicy,
	},
	DesignPreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignPreferenceKeySpecifier | (() => undefined | DesignPreferenceKeySpecifier),
		fields?: DesignPreferenceFieldPolicy,
	},
	WebsiteLayoutAlohaSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutAlohaSettingsKeySpecifier | (() => undefined | WebsiteLayoutAlohaSettingsKeySpecifier),
		fields?: WebsiteLayoutAlohaSettingsFieldPolicy,
	},
	WebsiteLayoutAlohaOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutAlohaOptionsKeySpecifier | (() => undefined | WebsiteLayoutAlohaOptionsKeySpecifier),
		fields?: WebsiteLayoutAlohaOptionsFieldPolicy,
	},
	DesignPreferenceColor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignPreferenceColorKeySpecifier | (() => undefined | DesignPreferenceColorKeySpecifier),
		fields?: DesignPreferenceColorFieldPolicy,
	},
	WebsiteLayoutBrannanSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutBrannanSettingsKeySpecifier | (() => undefined | WebsiteLayoutBrannanSettingsKeySpecifier),
		fields?: WebsiteLayoutBrannanSettingsFieldPolicy,
	},
	WebsiteLayoutBrannanOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutBrannanOptionsKeySpecifier | (() => undefined | WebsiteLayoutBrannanOptionsKeySpecifier),
		fields?: WebsiteLayoutBrannanOptionsFieldPolicy,
	},
	DesignPreferenceRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignPreferenceRangeKeySpecifier | (() => undefined | DesignPreferenceRangeKeySpecifier),
		fields?: DesignPreferenceRangeFieldPolicy,
	},
	DesignPreferenceBoolean?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignPreferenceBooleanKeySpecifier | (() => undefined | DesignPreferenceBooleanKeySpecifier),
		fields?: DesignPreferenceBooleanFieldPolicy,
	},
	EventDomain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDomainKeySpecifier | (() => undefined | EventDomainKeySpecifier),
		fields?: EventDomainFieldPolicy,
	},
	EventDesign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDesignKeySpecifier | (() => undefined | EventDesignKeySpecifier),
		fields?: EventDesignFieldPolicy,
	},
	WebsiteHeaderPresentationSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteHeaderPresentationSettingsKeySpecifier | (() => undefined | WebsiteHeaderPresentationSettingsKeySpecifier),
		fields?: WebsiteHeaderPresentationSettingsFieldPolicy,
	},
	ColorSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ColorSetKeySpecifier | (() => undefined | ColorSetKeySpecifier),
		fields?: ColorSetFieldPolicy,
	},
	EventDesignPreferenceBoolean?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDesignPreferenceBooleanKeySpecifier | (() => undefined | EventDesignPreferenceBooleanKeySpecifier),
		fields?: EventDesignPreferenceBooleanFieldPolicy,
	},
	EventDesignPreferenceColorPointer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDesignPreferenceColorPointerKeySpecifier | (() => undefined | EventDesignPreferenceColorPointerKeySpecifier),
		fields?: EventDesignPreferenceColorPointerFieldPolicy,
	},
	EventDesignPreferenceRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDesignPreferenceRangeKeySpecifier | (() => undefined | EventDesignPreferenceRangeKeySpecifier),
		fields?: EventDesignPreferenceRangeFieldPolicy,
	},
	FontPackConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FontPackConfigurationKeySpecifier | (() => undefined | FontPackConfigurationKeySpecifier),
		fields?: FontPackConfigurationFieldPolicy,
	},
	WebsiteLayoutAlohaPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutAlohaPreferencesKeySpecifier | (() => undefined | WebsiteLayoutAlohaPreferencesKeySpecifier),
		fields?: WebsiteLayoutAlohaPreferencesFieldPolicy,
	},
	EventDesignPreferenceColor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDesignPreferenceColorKeySpecifier | (() => undefined | EventDesignPreferenceColorKeySpecifier),
		fields?: EventDesignPreferenceColorFieldPolicy,
	},
	WebsiteLayoutBrannanPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsiteLayoutBrannanPreferencesKeySpecifier | (() => undefined | WebsiteLayoutBrannanPreferencesKeySpecifier),
		fields?: WebsiteLayoutBrannanPreferencesFieldPolicy,
	},
	EventOnboarding?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventOnboardingKeySpecifier | (() => undefined | EventOnboardingKeySpecifier),
		fields?: EventOnboardingFieldPolicy,
	},
	PeopleFindResultSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PeopleFindResultSetKeySpecifier | (() => undefined | PeopleFindResultSetKeySpecifier),
		fields?: PeopleFindResultSetFieldPolicy,
	},
	PeopleFindResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PeopleFindResultKeySpecifier | (() => undefined | PeopleFindResultKeySpecifier),
		fields?: PeopleFindResultFieldPolicy,
	},
	EventGuests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventGuestsKeySpecifier | (() => undefined | EventGuestsKeySpecifier),
		fields?: EventGuestsFieldPolicy,
	},
	HotelRoomBlocks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomBlocksKeySpecifier | (() => undefined | HotelRoomBlocksKeySpecifier),
		fields?: HotelRoomBlocksFieldPolicy,
	},
	OwnerDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnerDetailsKeySpecifier | (() => undefined | OwnerDetailsKeySpecifier),
		fields?: OwnerDetailsFieldPolicy,
	},
	LeadDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadDestinationKeySpecifier | (() => undefined | LeadDestinationKeySpecifier),
		fields?: LeadDestinationFieldPolicy,
	},
	ReservedRoomBlocks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReservedRoomBlocksKeySpecifier | (() => undefined | ReservedRoomBlocksKeySpecifier),
		fields?: ReservedRoomBlocksFieldPolicy,
	},
	EventInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventInfoKeySpecifier | (() => undefined | EventInfoKeySpecifier),
		fields?: EventInfoFieldPolicy,
	},
	EventAnnouncementBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventAnnouncementBannerKeySpecifier | (() => undefined | EventAnnouncementBannerKeySpecifier),
		fields?: EventAnnouncementBannerFieldPolicy,
	},
	EventQanda?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventQandaKeySpecifier | (() => undefined | EventQandaKeySpecifier),
		fields?: EventQandaFieldPolicy,
	},
	Registry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryKeySpecifier | (() => undefined | RegistryKeySpecifier),
		fields?: RegistryFieldPolicy,
	},
	RegistryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemKeySpecifier | (() => undefined | RegistryItemKeySpecifier),
		fields?: RegistryItemFieldPolicy,
	},
	CannedRegistryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CannedRegistryItemKeySpecifier | (() => undefined | CannedRegistryItemKeySpecifier),
		fields?: CannedRegistryItemFieldPolicy,
	},
	PhotoSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoSummaryKeySpecifier | (() => undefined | PhotoSummaryKeySpecifier),
		fields?: PhotoSummaryFieldPolicy,
	},
	MonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MonetaryValueKeySpecifier | (() => undefined | MonetaryValueKeySpecifier),
		fields?: MonetaryValueFieldPolicy,
	},
	Currency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyKeySpecifier | (() => undefined | CurrencyKeySpecifier),
		fields?: CurrencyFieldPolicy,
	},
	CustomItemData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomItemDataKeySpecifier | (() => undefined | CustomItemDataKeySpecifier),
		fields?: CustomItemDataFieldPolicy,
	},
	DonationFund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DonationFundKeySpecifier | (() => undefined | DonationFundKeySpecifier),
		fields?: DonationFundFieldPolicy,
	},
	RegistryCurrency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCurrencyKeySpecifier | (() => undefined | RegistryCurrencyKeySpecifier),
		fields?: RegistryCurrencyFieldPolicy,
	},
	RegistryCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCountryKeySpecifier | (() => undefined | RegistryCountryKeySpecifier),
		fields?: RegistryCountryFieldPolicy,
	},
	DonationFundDonation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DonationFundDonationKeySpecifier | (() => undefined | DonationFundDonationKeySpecifier),
		fields?: DonationFundDonationFieldPolicy,
	},
	DonationFundPlatform?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DonationFundPlatformKeySpecifier | (() => undefined | DonationFundPlatformKeySpecifier),
		fields?: DonationFundPlatformFieldPolicy,
	},
	DonationFundInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DonationFundInfoKeySpecifier | (() => undefined | DonationFundInfoKeySpecifier),
		fields?: DonationFundInfoFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	RegistryItemProductData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemProductDataKeySpecifier | (() => undefined | RegistryItemProductDataKeySpecifier),
		fields?: RegistryItemProductDataFieldPolicy,
	},
	CheckoutMechanism?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutMechanismKeySpecifier | (() => undefined | CheckoutMechanismKeySpecifier),
		fields?: CheckoutMechanismFieldPolicy,
	},
	RegistryMonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryMonetaryValueKeySpecifier | (() => undefined | RegistryMonetaryValueKeySpecifier),
		fields?: RegistryMonetaryValueFieldPolicy,
	},
	RegistryOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderKeySpecifier | (() => undefined | RegistryOrderKeySpecifier),
		fields?: RegistryOrderFieldPolicy,
	},
	RegistryOrderAnnotations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderAnnotationsKeySpecifier | (() => undefined | RegistryOrderAnnotationsKeySpecifier),
		fields?: RegistryOrderAnnotationsFieldPolicy,
	},
	RegistryFulfillment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryFulfillmentKeySpecifier | (() => undefined | RegistryFulfillmentKeySpecifier),
		fields?: RegistryFulfillmentFieldPolicy,
	},
	RegistryFulfillmentShipment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryFulfillmentShipmentKeySpecifier | (() => undefined | RegistryFulfillmentShipmentKeySpecifier),
		fields?: RegistryFulfillmentShipmentFieldPolicy,
	},
	RegistryFulfillmentShipmentTrackingInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryFulfillmentShipmentTrackingInformationKeySpecifier | (() => undefined | RegistryFulfillmentShipmentTrackingInformationKeySpecifier),
		fields?: RegistryFulfillmentShipmentTrackingInformationFieldPolicy,
	},
	LineItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineItemKeySpecifier | (() => undefined | LineItemKeySpecifier),
		fields?: LineItemFieldPolicy,
	},
	RegistryOrderLineItemAnnotations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderLineItemAnnotationsKeySpecifier | (() => undefined | RegistryOrderLineItemAnnotationsKeySpecifier),
		fields?: RegistryOrderLineItemAnnotationsFieldPolicy,
	},
	RegistryDonationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryDonationDataKeySpecifier | (() => undefined | RegistryDonationDataKeySpecifier),
		fields?: RegistryDonationDataFieldPolicy,
	},
	RegistrySummaryProductData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistrySummaryProductDataKeySpecifier | (() => undefined | RegistrySummaryProductDataKeySpecifier),
		fields?: RegistrySummaryProductDataFieldPolicy,
	},
	RegistryOrderLineItemData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderLineItemDataKeySpecifier | (() => undefined | RegistryOrderLineItemDataKeySpecifier),
		fields?: RegistryOrderLineItemDataFieldPolicy,
	},
	CommerceTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommerceTagKeySpecifier | (() => undefined | CommerceTagKeySpecifier),
		fields?: CommerceTagFieldPolicy,
	},
	RegistryOrderRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderRefundKeySpecifier | (() => undefined | RegistryOrderRefundKeySpecifier),
		fields?: RegistryOrderRefundFieldPolicy,
	},
	RegistryOrderRefundItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderRefundItemKeySpecifier | (() => undefined | RegistryOrderRefundItemKeySpecifier),
		fields?: RegistryOrderRefundItemFieldPolicy,
	},
	RegistryOrderShippingAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderShippingAddressKeySpecifier | (() => undefined | RegistryOrderShippingAddressKeySpecifier),
		fields?: RegistryOrderShippingAddressFieldPolicy,
	},
	RegistrySession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistrySessionKeySpecifier | (() => undefined | RegistrySessionKeySpecifier),
		fields?: RegistrySessionFieldPolicy,
	},
	TransferredRegistryData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransferredRegistryDataKeySpecifier | (() => undefined | TransferredRegistryDataKeySpecifier),
		fields?: TransferredRegistryDataFieldPolicy,
	},
	ExternalRegistryStatusData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalRegistryStatusDataKeySpecifier | (() => undefined | ExternalRegistryStatusDataKeySpecifier),
		fields?: ExternalRegistryStatusDataFieldPolicy,
	},
	EventScheduleInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventScheduleInfoKeySpecifier | (() => undefined | EventScheduleInfoKeySpecifier),
		fields?: EventScheduleInfoFieldPolicy,
	},
	FormattedSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormattedScheduleKeySpecifier | (() => undefined | FormattedScheduleKeySpecifier),
		fields?: FormattedScheduleFieldPolicy,
	},
	EventTravelBookingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTravelBookingTypeKeySpecifier | (() => undefined | EventTravelBookingTypeKeySpecifier),
		fields?: EventTravelBookingTypeFieldPolicy,
	},
	EventTravelShared?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTravelSharedKeySpecifier | (() => undefined | EventTravelSharedKeySpecifier),
		fields?: EventTravelSharedFieldPolicy,
	},
	EventTravelList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTravelListKeySpecifier | (() => undefined | EventTravelListKeySpecifier),
		fields?: EventTravelListFieldPolicy,
	},
	EventTravelListItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTravelListItemKeySpecifier | (() => undefined | EventTravelListItemKeySpecifier),
		fields?: EventTravelListItemFieldPolicy,
	},
	EventTravelNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTravelNoteKeySpecifier | (() => undefined | EventTravelNoteKeySpecifier),
		fields?: EventTravelNoteFieldPolicy,
	},
	Ferry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FerryKeySpecifier | (() => undefined | FerryKeySpecifier),
		fields?: FerryFieldPolicy,
	},
	Flight?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FlightKeySpecifier | (() => undefined | FlightKeySpecifier),
		fields?: FlightFieldPolicy,
	},
	Hotel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelKeySpecifier | (() => undefined | HotelKeySpecifier),
		fields?: HotelFieldPolicy,
	},
	RentalCar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RentalCarKeySpecifier | (() => undefined | RentalCarKeySpecifier),
		fields?: RentalCarFieldPolicy,
	},
	RentalHome?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RentalHomeKeySpecifier | (() => undefined | RentalHomeKeySpecifier),
		fields?: RentalHomeFieldPolicy,
	},
	Shuttle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShuttleKeySpecifier | (() => undefined | ShuttleKeySpecifier),
		fields?: ShuttleFieldPolicy,
	},
	ShuttleItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShuttleItemKeySpecifier | (() => undefined | ShuttleItemKeySpecifier),
		fields?: ShuttleItemFieldPolicy,
	},
	Taxi?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxiKeySpecifier | (() => undefined | TaxiKeySpecifier),
		fields?: TaxiFieldPolicy,
	},
	Tent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TentKeySpecifier | (() => undefined | TentKeySpecifier),
		fields?: TentFieldPolicy,
	},
	Train?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrainKeySpecifier | (() => undefined | TrainKeySpecifier),
		fields?: TrainFieldPolicy,
	},
	LegacyRsvpQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyRsvpQuestionKeySpecifier | (() => undefined | LegacyRsvpQuestionKeySpecifier),
		fields?: LegacyRsvpQuestionFieldPolicy,
	},
	Choice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceKeySpecifier | (() => undefined | ChoiceKeySpecifier),
		fields?: ChoiceFieldPolicy,
	},
	MediaPhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaPhotoKeySpecifier | (() => undefined | MediaPhotoKeySpecifier),
		fields?: MediaPhotoFieldPolicy,
	},
	MediaVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaVideoKeySpecifier | (() => undefined | MediaVideoKeySpecifier),
		fields?: MediaVideoFieldPolicy,
	},
	MediaCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaCollectionKeySpecifier | (() => undefined | MediaCollectionKeySpecifier),
		fields?: MediaCollectionFieldPolicy,
	},
	MediaInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaInfoKeySpecifier | (() => undefined | MediaInfoKeySpecifier),
		fields?: MediaInfoFieldPolicy,
	},
	PageContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageContainerKeySpecifier | (() => undefined | PageContainerKeySpecifier),
		fields?: PageContainerFieldPolicy,
	},
	EventCountdownComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventCountdownComponentKeySpecifier | (() => undefined | EventCountdownComponentKeySpecifier),
		fields?: EventCountdownComponentFieldPolicy,
	},
	EventDetailsComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDetailsComponentKeySpecifier | (() => undefined | EventDetailsComponentKeySpecifier),
		fields?: EventDetailsComponentFieldPolicy,
	},
	EventDisplayNameComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDisplayNameComponentKeySpecifier | (() => undefined | EventDisplayNameComponentKeySpecifier),
		fields?: EventDisplayNameComponentFieldPolicy,
	},
	GreetingMessageComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GreetingMessageComponentKeySpecifier | (() => undefined | GreetingMessageComponentKeySpecifier),
		fields?: GreetingMessageComponentFieldPolicy,
	},
	JsonDataBlobComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JsonDataBlobComponentKeySpecifier | (() => undefined | JsonDataBlobComponentKeySpecifier),
		fields?: JsonDataBlobComponentFieldPolicy,
	},
	JsonDataContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JsonDataContainerKeySpecifier | (() => undefined | JsonDataContainerKeySpecifier),
		fields?: JsonDataContainerFieldPolicy,
	},
	MediaGalleryComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaGalleryComponentKeySpecifier | (() => undefined | MediaGalleryComponentKeySpecifier),
		fields?: MediaGalleryComponentFieldPolicy,
	},
	PhotoComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoComponentKeySpecifier | (() => undefined | PhotoComponentKeySpecifier),
		fields?: PhotoComponentFieldPolicy,
	},
	RsvpAndUnlockGuestDetailsButtonComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RsvpAndUnlockGuestDetailsButtonComponentKeySpecifier | (() => undefined | RsvpAndUnlockGuestDetailsButtonComponentKeySpecifier),
		fields?: RsvpAndUnlockGuestDetailsButtonComponentFieldPolicy,
	},
	TextComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TextComponentKeySpecifier | (() => undefined | TextComponentKeySpecifier),
		fields?: TextComponentFieldPolicy,
	},
	TravelMapComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelMapComponentKeySpecifier | (() => undefined | TravelMapComponentKeySpecifier),
		fields?: TravelMapComponentFieldPolicy,
	},
	PointsOnMap?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PointsOnMapKeySpecifier | (() => undefined | PointsOnMapKeySpecifier),
		fields?: PointsOnMapFieldPolicy,
	},
	VideoComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoComponentKeySpecifier | (() => undefined | VideoComponentKeySpecifier),
		fields?: VideoComponentFieldPolicy,
	},
	PhotoAlignmentValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoAlignmentValueKeySpecifier | (() => undefined | PhotoAlignmentValueKeySpecifier),
		fields?: PhotoAlignmentValueFieldPolicy,
	},
	MainPhotoCropInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainPhotoCropInfoKeySpecifier | (() => undefined | MainPhotoCropInfoKeySpecifier),
		fields?: MainPhotoCropInfoFieldPolicy,
	},
	DefaultPagePhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultPagePhotoKeySpecifier | (() => undefined | DefaultPagePhotoKeySpecifier),
		fields?: DefaultPagePhotoFieldPolicy,
	},
	DefaultPageCollectionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultPageCollectionItemKeySpecifier | (() => undefined | DefaultPageCollectionItemKeySpecifier),
		fields?: DefaultPageCollectionItemFieldPolicy,
	},
	DefaultPageCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultPageCollectionKeySpecifier | (() => undefined | DefaultPageCollectionKeySpecifier),
		fields?: DefaultPageCollectionFieldPolicy,
	},
	DefaultPagePhotoLayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultPagePhotoLayoutKeySpecifier | (() => undefined | DefaultPagePhotoLayoutKeySpecifier),
		fields?: DefaultPagePhotoLayoutFieldPolicy,
	},
	DefaultPageMetaTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultPageMetaTagKeySpecifier | (() => undefined | DefaultPageMetaTagKeySpecifier),
		fields?: DefaultPageMetaTagFieldPolicy,
	},
	EventPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventPageInfoKeySpecifier | (() => undefined | EventPageInfoKeySpecifier),
		fields?: EventPageInfoFieldPolicy,
	},
	EventPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventPageKeySpecifier | (() => undefined | EventPageKeySpecifier),
		fields?: EventPageFieldPolicy,
	},
	WebsitePagePhotoPresentation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsitePagePhotoPresentationKeySpecifier | (() => undefined | WebsitePagePhotoPresentationKeySpecifier),
		fields?: WebsitePagePhotoPresentationFieldPolicy,
	},
	WebsitePagePhotoPresentationCropInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebsitePagePhotoPresentationCropInfoKeySpecifier | (() => undefined | WebsitePagePhotoPresentationCropInfoKeySpecifier),
		fields?: WebsitePagePhotoPresentationCropInfoFieldPolicy,
	},
	EventPlace?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventPlaceKeySpecifier | (() => undefined | EventPlaceKeySpecifier),
		fields?: EventPlaceFieldPolicy,
	},
	EventPlacePhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventPlacePhotoKeySpecifier | (() => undefined | EventPlacePhotoKeySpecifier),
		fields?: EventPlacePhotoFieldPolicy,
	},
	EventProductVerticals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventProductVerticalsKeySpecifier | (() => undefined | EventProductVerticalsKeySpecifier),
		fields?: EventProductVerticalsFieldPolicy,
	},
	RecommendEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecommendEventKeySpecifier | (() => undefined | RecommendEventKeySpecifier),
		fields?: RecommendEventFieldPolicy,
	},
	RecommendRegistryAdvisorData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecommendRegistryAdvisorDataKeySpecifier | (() => undefined | RecommendRegistryAdvisorDataKeySpecifier),
		fields?: RecommendRegistryAdvisorDataFieldPolicy,
	},
	CalculatedPriceRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalculatedPriceRangeKeySpecifier | (() => undefined | CalculatedPriceRangeKeySpecifier),
		fields?: CalculatedPriceRangeFieldPolicy,
	},
	RecommendRegistryOnboardingSurveyResults?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecommendRegistryOnboardingSurveyResultsKeySpecifier | (() => undefined | RecommendRegistryOnboardingSurveyResultsKeySpecifier),
		fields?: RecommendRegistryOnboardingSurveyResultsFieldPolicy,
	},
	EventData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDataKeySpecifier | (() => undefined | EventDataKeySpecifier),
		fields?: EventDataFieldPolicy,
	},
	RegistryChecklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryChecklistKeySpecifier | (() => undefined | RegistryChecklistKeySpecifier),
		fields?: RegistryChecklistFieldPolicy,
	},
	RegistryChecklistProgressResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryChecklistProgressResultKeySpecifier | (() => undefined | RegistryChecklistProgressResultKeySpecifier),
		fields?: RegistryChecklistProgressResultFieldPolicy,
	},
	RegistryChecklistSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryChecklistSectionKeySpecifier | (() => undefined | RegistryChecklistSectionKeySpecifier),
		fields?: RegistryChecklistSectionFieldPolicy,
	},
	RegistryChecklistItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryChecklistItemKeySpecifier | (() => undefined | RegistryChecklistItemKeySpecifier),
		fields?: RegistryChecklistItemFieldPolicy,
	},
	RegistryCompletionDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCompletionDiscountKeySpecifier | (() => undefined | RegistryCompletionDiscountKeySpecifier),
		fields?: RegistryCompletionDiscountFieldPolicy,
	},
	DiscountedRegistryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiscountedRegistryItemKeySpecifier | (() => undefined | DiscountedRegistryItemKeySpecifier),
		fields?: DiscountedRegistryItemFieldPolicy,
	},
	ItemDiscountCampaignDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemDiscountCampaignDetailsKeySpecifier | (() => undefined | ItemDiscountCampaignDetailsKeySpecifier),
		fields?: ItemDiscountCampaignDetailsFieldPolicy,
	},
	RegistryItemCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemCountKeySpecifier | (() => undefined | RegistryItemCountKeySpecifier),
		fields?: RegistryItemCountFieldPolicy,
	},
	RegistryJoyCreditStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryJoyCreditStatusKeySpecifier | (() => undefined | RegistryJoyCreditStatusKeySpecifier),
		fields?: RegistryJoyCreditStatusFieldPolicy,
	},
	RegistryJoyCredit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryJoyCreditKeySpecifier | (() => undefined | RegistryJoyCreditKeySpecifier),
		fields?: RegistryJoyCreditFieldPolicy,
	},
	CommerceMonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommerceMonetaryValueKeySpecifier | (() => undefined | CommerceMonetaryValueKeySpecifier),
		fields?: CommerceMonetaryValueFieldPolicy,
	},
	RegistryPayoutAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPayoutAccountKeySpecifier | (() => undefined | RegistryPayoutAccountKeySpecifier),
		fields?: RegistryPayoutAccountFieldPolicy,
	},
	RegistryPayoutAccountBalance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPayoutAccountBalanceKeySpecifier | (() => undefined | RegistryPayoutAccountBalanceKeySpecifier),
		fields?: RegistryPayoutAccountBalanceFieldPolicy,
	},
	RegistryPayoutAccountWithdrawal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPayoutAccountWithdrawalKeySpecifier | (() => undefined | RegistryPayoutAccountWithdrawalKeySpecifier),
		fields?: RegistryPayoutAccountWithdrawalFieldPolicy,
	},
	ShippingAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingAddressKeySpecifier | (() => undefined | ShippingAddressKeySpecifier),
		fields?: ShippingAddressFieldPolicy,
	},
	EventRegistriesSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventRegistriesSummaryKeySpecifier | (() => undefined | EventRegistriesSummaryKeySpecifier),
		fields?: EventRegistriesSummaryFieldPolicy,
	},
	EventSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSettingsKeySpecifier | (() => undefined | EventSettingsKeySpecifier),
		fields?: EventSettingsFieldPolicy,
	},
	EventStyle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventStyleKeySpecifier | (() => undefined | EventStyleKeySpecifier),
		fields?: EventStyleFieldPolicy,
	},
	EventSuggestionInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSuggestionInfoKeySpecifier | (() => undefined | EventSuggestionInfoKeySpecifier),
		fields?: EventSuggestionInfoFieldPolicy,
	},
	EventSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSuggestionKeySpecifier | (() => undefined | EventSuggestionKeySpecifier),
		fields?: EventSuggestionFieldPolicy,
	},
	TravelSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelSettingsKeySpecifier | (() => undefined | TravelSettingsKeySpecifier),
		fields?: TravelSettingsFieldPolicy,
	},
	Video?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoKeySpecifier | (() => undefined | VideoKeySpecifier),
		fields?: VideoFieldPolicy,
	},
	Vip?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VipKeySpecifier | (() => undefined | VipKeySpecifier),
		fields?: VipFieldPolicy,
	},
	FeedMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeedMessageKeySpecifier | (() => undefined | FeedMessageKeySpecifier),
		fields?: FeedMessageFieldPolicy,
	},
	FeedMessageTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeedMessageTargetKeySpecifier | (() => undefined | FeedMessageTargetKeySpecifier),
		fields?: FeedMessageTargetFieldPolicy,
	},
	Vendor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorKeySpecifier | (() => undefined | VendorKeySpecifier),
		fields?: VendorFieldPolicy,
	},
	SyntheticCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyntheticCollectionKeySpecifier | (() => undefined | SyntheticCollectionKeySpecifier),
		fields?: SyntheticCollectionFieldPolicy,
	},
	CollectionItemsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemsConnectionKeySpecifier | (() => undefined | CollectionItemsConnectionKeySpecifier),
		fields?: CollectionItemsConnectionFieldPolicy,
	},
	Connection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConnectionKeySpecifier | (() => undefined | ConnectionKeySpecifier),
		fields?: ConnectionFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	CollectionItemsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemsEdgeKeySpecifier | (() => undefined | CollectionItemsEdgeKeySpecifier),
		fields?: CollectionItemsEdgeFieldPolicy,
	},
	Edge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdgeKeySpecifier | (() => undefined | EdgeKeySpecifier),
		fields?: EdgeFieldPolicy,
	},
	VendorDiscoveryNodeItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorDiscoveryNodeItemKeySpecifier | (() => undefined | VendorDiscoveryNodeItemKeySpecifier),
		fields?: VendorDiscoveryNodeItemFieldPolicy,
	},
	VendorDiscoveryNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorDiscoveryNodeKeySpecifier | (() => undefined | VendorDiscoveryNodeKeySpecifier),
		fields?: VendorDiscoveryNodeFieldPolicy,
	},
	VendorCollectionGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorCollectionGroupKeySpecifier | (() => undefined | VendorCollectionGroupKeySpecifier),
		fields?: VendorCollectionGroupFieldPolicy,
	},
	SuggestionGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SuggestionGroupKeySpecifier | (() => undefined | SuggestionGroupKeySpecifier),
		fields?: SuggestionGroupFieldPolicy,
	},
	VendorSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorSuggestionKeySpecifier | (() => undefined | VendorSuggestionKeySpecifier),
		fields?: VendorSuggestionFieldPolicy,
	},
	Location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationKeySpecifier | (() => undefined | LocationKeySpecifier),
		fields?: LocationFieldPolicy,
	},
	ServiceTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceTagKeySpecifier | (() => undefined | ServiceTagKeySpecifier),
		fields?: ServiceTagFieldPolicy,
	},
	Testimony?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TestimonyKeySpecifier | (() => undefined | TestimonyKeySpecifier),
		fields?: TestimonyFieldPolicy,
	},
	VendorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorTypeKeySpecifier | (() => undefined | VendorTypeKeySpecifier),
		fields?: VendorTypeFieldPolicy,
	},
	VendorUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorUserKeySpecifier | (() => undefined | VendorUserKeySpecifier),
		fields?: VendorUserFieldPolicy,
	},
	VendorUserV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorUserV2KeySpecifier | (() => undefined | VendorUserV2KeySpecifier),
		fields?: VendorUserV2FieldPolicy,
	},
	VendorV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorV2KeySpecifier | (() => undefined | VendorV2KeySpecifier),
		fields?: VendorV2FieldPolicy,
	},
	BookingTypeAvailability?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingTypeAvailabilityKeySpecifier | (() => undefined | BookingTypeAvailabilityKeySpecifier),
		fields?: BookingTypeAvailabilityFieldPolicy,
	},
	BookingTypeAvailabilityDay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingTypeAvailabilityDayKeySpecifier | (() => undefined | BookingTypeAvailabilityDayKeySpecifier),
		fields?: BookingTypeAvailabilityDayFieldPolicy,
	},
	VendorCustomizationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorCustomizationTypeKeySpecifier | (() => undefined | VendorCustomizationTypeKeySpecifier),
		fields?: VendorCustomizationTypeFieldPolicy,
	},
	VendorLocationV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationV2KeySpecifier | (() => undefined | VendorLocationV2KeySpecifier),
		fields?: VendorLocationV2FieldPolicy,
	},
	ExifMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExifMetadataKeySpecifier | (() => undefined | ExifMetadataKeySpecifier),
		fields?: ExifMetadataFieldPolicy,
	},
	PhotoLayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoLayoutKeySpecifier | (() => undefined | PhotoLayoutKeySpecifier),
		fields?: PhotoLayoutFieldPolicy,
	},
	MetaTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetaTagKeySpecifier | (() => undefined | MetaTagKeySpecifier),
		fields?: MetaTagFieldPolicy,
	},
	PhotoPalette?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoPaletteKeySpecifier | (() => undefined | PhotoPaletteKeySpecifier),
		fields?: PhotoPaletteFieldPolicy,
	},
	PhotoTransform?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoTransformKeySpecifier | (() => undefined | PhotoTransformKeySpecifier),
		fields?: PhotoTransformFieldPolicy,
	},
	AccommodationCatalogPhotoSubject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPhotoSubjectKeySpecifier | (() => undefined | AccommodationCatalogPhotoSubjectKeySpecifier),
		fields?: AccommodationCatalogPhotoSubjectFieldPolicy,
	},
	AccommodationPropertyPolicyField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPropertyPolicyFieldKeySpecifier | (() => undefined | AccommodationPropertyPolicyFieldKeySpecifier),
		fields?: AccommodationPropertyPolicyFieldFieldPolicy,
	},
	AuthenticationErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthenticationErrorTypeKeySpecifier | (() => undefined | AuthenticationErrorTypeKeySpecifier),
		fields?: AuthenticationErrorTypeFieldPolicy,
	},
	ErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ErrorTypeKeySpecifier | (() => undefined | ErrorTypeKeySpecifier),
		fields?: ErrorTypeFieldPolicy,
	},
	BadRequestErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BadRequestErrorTypeKeySpecifier | (() => undefined | BadRequestErrorTypeKeySpecifier),
		fields?: BadRequestErrorTypeFieldPolicy,
	},
	ForbiddenErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ForbiddenErrorTypeKeySpecifier | (() => undefined | ForbiddenErrorTypeKeySpecifier),
		fields?: ForbiddenErrorTypeFieldPolicy,
	},
	InternalServerErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalServerErrorTypeKeySpecifier | (() => undefined | InternalServerErrorTypeKeySpecifier),
		fields?: InternalServerErrorTypeFieldPolicy,
	},
	NotFoundErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotFoundErrorTypeKeySpecifier | (() => undefined | NotFoundErrorTypeKeySpecifier),
		fields?: NotFoundErrorTypeFieldPolicy,
	},
	Attendance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttendanceKeySpecifier | (() => undefined | AttendanceKeySpecifier),
		fields?: AttendanceFieldPolicy,
	},
	FormContactItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormContactItemKeySpecifier | (() => undefined | FormContactItemKeySpecifier),
		fields?: FormContactItemFieldPolicy,
	},
	FormContactPhoneNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormContactPhoneNumberKeySpecifier | (() => undefined | FormContactPhoneNumberKeySpecifier),
		fields?: FormContactPhoneNumberFieldPolicy,
	},
	GuestAttendanceStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestAttendanceStatusKeySpecifier | (() => undefined | GuestAttendanceStatusKeySpecifier),
		fields?: GuestAttendanceStatusFieldPolicy,
	},
	AttendanceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttendanceResultKeySpecifier | (() => undefined | AttendanceResultKeySpecifier),
		fields?: AttendanceResultFieldPolicy,
	},
	AttendanceStatusCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttendanceStatusCountKeySpecifier | (() => undefined | AttendanceStatusCountKeySpecifier),
		fields?: AttendanceStatusCountFieldPolicy,
	},
	AuthenticatedUserResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthenticatedUserResultKeySpecifier | (() => undefined | AuthenticatedUserResultKeySpecifier),
		fields?: AuthenticatedUserResultFieldPolicy,
	},
	AutopopulateOperationsByEventIdResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateOperationsByEventIdResponseKeySpecifier | (() => undefined | AutopopulateOperationsByEventIdResponseKeySpecifier),
		fields?: AutopopulateOperationsByEventIdResponseFieldPolicy,
	},
	AutopopulateOperationItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateOperationItemKeySpecifier | (() => undefined | AutopopulateOperationItemKeySpecifier),
		fields?: AutopopulateOperationItemFieldPolicy,
	},
	AutoPopulateResultItemV4?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutoPopulateResultItemV4KeySpecifier | (() => undefined | AutoPopulateResultItemV4KeySpecifier),
		fields?: AutoPopulateResultItemV4FieldPolicy,
	},
	AutopopulateOperationsByEventIdResponseV20251203?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateOperationsByEventIdResponseV20251203KeySpecifier | (() => undefined | AutopopulateOperationsByEventIdResponseV20251203KeySpecifier),
		fields?: AutopopulateOperationsByEventIdResponseV20251203FieldPolicy,
	},
	AutopopulateOperationItemV20251203?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateOperationItemV20251203KeySpecifier | (() => undefined | AutopopulateOperationItemV20251203KeySpecifier),
		fields?: AutopopulateOperationItemV20251203FieldPolicy,
	},
	AutoPopulateResultV20251203?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutoPopulateResultV20251203KeySpecifier | (() => undefined | AutoPopulateResultV20251203KeySpecifier),
		fields?: AutoPopulateResultV20251203FieldPolicy,
	},
	AutopopulateStayAreaOperationsByEventIdResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateStayAreaOperationsByEventIdResponseKeySpecifier | (() => undefined | AutopopulateStayAreaOperationsByEventIdResponseKeySpecifier),
		fields?: AutopopulateStayAreaOperationsByEventIdResponseFieldPolicy,
	},
	AutopopulateStayAreaOperationItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutopopulateStayAreaOperationItemKeySpecifier | (() => undefined | AutopopulateStayAreaOperationItemKeySpecifier),
		fields?: AutopopulateStayAreaOperationItemFieldPolicy,
	},
	JoyStayArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JoyStayAreaKeySpecifier | (() => undefined | JoyStayAreaKeySpecifier),
		fields?: JoyStayAreaFieldPolicy,
	},
	LocationBoundsOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationBoundsOutputKeySpecifier | (() => undefined | LocationBoundsOutputKeySpecifier),
		fields?: LocationBoundsOutputFieldPolicy,
	},
	LocationCoordinates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationCoordinatesKeySpecifier | (() => undefined | LocationCoordinatesKeySpecifier),
		fields?: LocationCoordinatesFieldPolicy,
	},
	BookingSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingSlotKeySpecifier | (() => undefined | BookingSlotKeySpecifier),
		fields?: BookingSlotFieldPolicy,
	},
	BookingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingTypeKeySpecifier | (() => undefined | BookingTypeKeySpecifier),
		fields?: BookingTypeFieldPolicy,
	},
	BookingTypeHost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingTypeHostKeySpecifier | (() => undefined | BookingTypeHostKeySpecifier),
		fields?: BookingTypeHostFieldPolicy,
	},
	BookingSlotCalendarInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingSlotCalendarInfoKeySpecifier | (() => undefined | BookingSlotCalendarInfoKeySpecifier),
		fields?: BookingSlotCalendarInfoFieldPolicy,
	},
	BookingSlotCustomerInsights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingSlotCustomerInsightsKeySpecifier | (() => undefined | BookingSlotCustomerInsightsKeySpecifier),
		fields?: BookingSlotCustomerInsightsFieldPolicy,
	},
	MeetingBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MeetingBlockKeySpecifier | (() => undefined | MeetingBlockKeySpecifier),
		fields?: MeetingBlockFieldPolicy,
	},
	CashFundContributionReceipt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundContributionReceiptKeySpecifier | (() => undefined | CashFundContributionReceiptKeySpecifier),
		fields?: CashFundContributionReceiptFieldPolicy,
	},
	CashFundContributionFee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundContributionFeeKeySpecifier | (() => undefined | CashFundContributionFeeKeySpecifier),
		fields?: CashFundContributionFeeFieldPolicy,
	},
	CalculateRegistryPurchaseInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalculateRegistryPurchaseInfoKeySpecifier | (() => undefined | CalculateRegistryPurchaseInfoKeySpecifier),
		fields?: CalculateRegistryPurchaseInfoFieldPolicy,
	},
	SalesOrderCompensationLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderCompensationLineKeySpecifier | (() => undefined | SalesOrderCompensationLineKeySpecifier),
		fields?: SalesOrderCompensationLineFieldPolicy,
	},
	SalesOrderLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderLineKeySpecifier | (() => undefined | SalesOrderLineKeySpecifier),
		fields?: SalesOrderLineFieldPolicy,
	},
	SalesOrderChargeLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderChargeLineKeySpecifier | (() => undefined | SalesOrderChargeLineKeySpecifier),
		fields?: SalesOrderChargeLineFieldPolicy,
	},
	SalesOrderPostPurchaseFeeLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderPostPurchaseFeeLineKeySpecifier | (() => undefined | SalesOrderPostPurchaseFeeLineKeySpecifier),
		fields?: SalesOrderPostPurchaseFeeLineFieldPolicy,
	},
	SalesOrderShippingAndHandlingLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderShippingAndHandlingLineKeySpecifier | (() => undefined | SalesOrderShippingAndHandlingLineKeySpecifier),
		fields?: SalesOrderShippingAndHandlingLineFieldPolicy,
	},
	CheckRegistryUrlResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckRegistryUrlResultKeySpecifier | (() => undefined | CheckRegistryUrlResultKeySpecifier),
		fields?: CheckRegistryUrlResultFieldPolicy,
	},
	InvalidTransitionalRegistryUrlResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvalidTransitionalRegistryUrlResultKeySpecifier | (() => undefined | InvalidTransitionalRegistryUrlResultKeySpecifier),
		fields?: InvalidTransitionalRegistryUrlResultFieldPolicy,
	},
	ValidTransitionalRegistryUrlResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidTransitionalRegistryUrlResultKeySpecifier | (() => undefined | ValidTransitionalRegistryUrlResultKeySpecifier),
		fields?: ValidTransitionalRegistryUrlResultFieldPolicy,
	},
	ComputedProductHeuristicOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComputedProductHeuristicOutputKeySpecifier | (() => undefined | ComputedProductHeuristicOutputKeySpecifier),
		fields?: ComputedProductHeuristicOutputFieldPolicy,
	},
	ComputedProductHeuristicOutput_Line?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComputedProductHeuristicOutput_LineKeySpecifier | (() => undefined | ComputedProductHeuristicOutput_LineKeySpecifier),
		fields?: ComputedProductHeuristicOutput_LineFieldPolicy,
	},
	ProductHeuristicMatchedProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeuristicMatchedProductKeySpecifier | (() => undefined | ProductHeuristicMatchedProductKeySpecifier),
		fields?: ProductHeuristicMatchedProductFieldPolicy,
	},
	ProductCatalogItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemKeySpecifier | (() => undefined | ProductCatalogItemKeySpecifier),
		fields?: ProductCatalogItemFieldPolicy,
	},
	ProductAttributeJunction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeJunctionKeySpecifier | (() => undefined | ProductAttributeJunctionKeySpecifier),
		fields?: ProductAttributeJunctionFieldPolicy,
	},
	ProductAttributeGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeGroupKeySpecifier | (() => undefined | ProductAttributeGroupKeySpecifier),
		fields?: ProductAttributeGroupFieldPolicy,
	},
	ProductAttributeValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeValueKeySpecifier | (() => undefined | ProductAttributeValueKeySpecifier),
		fields?: ProductAttributeValueFieldPolicy,
	},
	ProductCatalogBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandKeySpecifier | (() => undefined | ProductCatalogBrandKeySpecifier),
		fields?: ProductCatalogBrandFieldPolicy,
	},
	ProductCatalogFeaturedBrandCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogFeaturedBrandCategoryKeySpecifier | (() => undefined | ProductCatalogFeaturedBrandCategoryKeySpecifier),
		fields?: ProductCatalogFeaturedBrandCategoryFieldPolicy,
	},
	ProductCatalogCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCategoryKeySpecifier | (() => undefined | ProductCatalogCategoryKeySpecifier),
		fields?: ProductCatalogCategoryFieldPolicy,
	},
	ProductCatalogCategoryBrowseBannerMore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCategoryBrowseBannerMoreKeySpecifier | (() => undefined | ProductCatalogCategoryBrowseBannerMoreKeySpecifier),
		fields?: ProductCatalogCategoryBrowseBannerMoreFieldPolicy,
	},
	ProductCatalogCategoryExtensions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCategoryExtensionsKeySpecifier | (() => undefined | ProductCatalogCategoryExtensionsKeySpecifier),
		fields?: ProductCatalogCategoryExtensionsFieldPolicy,
	},
	ProductCatalogCollectionDisplayInfoToCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCollectionDisplayInfoToCategoryKeySpecifier | (() => undefined | ProductCatalogCollectionDisplayInfoToCategoryKeySpecifier),
		fields?: ProductCatalogCollectionDisplayInfoToCategoryFieldPolicy,
	},
	ProductCatalogCollectionDisplayInfoInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCollectionDisplayInfoInterfaceKeySpecifier | (() => undefined | ProductCatalogCollectionDisplayInfoInterfaceKeySpecifier),
		fields?: ProductCatalogCollectionDisplayInfoInterfaceFieldPolicy,
	},
	ProductCatalogCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCollectionKeySpecifier | (() => undefined | ProductCatalogCollectionKeySpecifier),
		fields?: ProductCatalogCollectionFieldPolicy,
	},
	ProductCatalogEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityKeySpecifier | (() => undefined | ProductCatalogEntityKeySpecifier),
		fields?: ProductCatalogEntityFieldPolicy,
	},
	ProductCatalogCuration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCurationKeySpecifier | (() => undefined | ProductCatalogCurationKeySpecifier),
		fields?: ProductCatalogCurationFieldPolicy,
	},
	ProductCatalogCurationHeader?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCurationHeaderKeySpecifier | (() => undefined | ProductCatalogCurationHeaderKeySpecifier),
		fields?: ProductCatalogCurationHeaderFieldPolicy,
	},
	ProductCatalogCategoryShowcase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCategoryShowcaseKeySpecifier | (() => undefined | ProductCatalogCategoryShowcaseKeySpecifier),
		fields?: ProductCatalogCategoryShowcaseFieldPolicy,
	},
	ProductCatalogVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogVideoKeySpecifier | (() => undefined | ProductCatalogVideoKeySpecifier),
		fields?: ProductCatalogVideoFieldPolicy,
	},
	ProductCatalogShowcaseBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogShowcaseBrandKeySpecifier | (() => undefined | ProductCatalogShowcaseBrandKeySpecifier),
		fields?: ProductCatalogShowcaseBrandFieldPolicy,
	},
	ProductCatalogBrandShowcase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandShowcaseKeySpecifier | (() => undefined | ProductCatalogBrandShowcaseKeySpecifier),
		fields?: ProductCatalogBrandShowcaseFieldPolicy,
	},
	ProductCatalogCategorySpotlight?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCategorySpotlightKeySpecifier | (() => undefined | ProductCatalogCategorySpotlightKeySpecifier),
		fields?: ProductCatalogCategorySpotlightFieldPolicy,
	},
	ProductCatalogBrandHeader?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandHeaderKeySpecifier | (() => undefined | ProductCatalogBrandHeaderKeySpecifier),
		fields?: ProductCatalogBrandHeaderFieldPolicy,
	},
	ProductCatalogShowcaseCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogShowcaseCategoryKeySpecifier | (() => undefined | ProductCatalogShowcaseCategoryKeySpecifier),
		fields?: ProductCatalogShowcaseCategoryFieldPolicy,
	},
	ProductCatalogCollectionDisplayInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogCollectionDisplayInfoKeySpecifier | (() => undefined | ProductCatalogCollectionDisplayInfoKeySpecifier),
		fields?: ProductCatalogCollectionDisplayInfoFieldPolicy,
	},
	ProductCatalogItemGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemGroupKeySpecifier | (() => undefined | ProductCatalogItemGroupKeySpecifier),
		fields?: ProductCatalogItemGroupFieldPolicy,
	},
	ProductCatalogItemGroupDimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemGroupDimensionKeySpecifier | (() => undefined | ProductCatalogItemGroupDimensionKeySpecifier),
		fields?: ProductCatalogItemGroupDimensionFieldPolicy,
	},
	ProductCatalogItemGroupDimensionOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemGroupDimensionOptionKeySpecifier | (() => undefined | ProductCatalogItemGroupDimensionOptionKeySpecifier),
		fields?: ProductCatalogItemGroupDimensionOptionFieldPolicy,
	},
	ProductCatalogPhotoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogPhotoAssetKeySpecifier | (() => undefined | ProductCatalogPhotoAssetKeySpecifier),
		fields?: ProductCatalogPhotoAssetFieldPolicy,
	},
	ProductCatalogVideoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogVideoAssetKeySpecifier | (() => undefined | ProductCatalogVideoAssetKeySpecifier),
		fields?: ProductCatalogVideoAssetFieldPolicy,
	},
	PDPSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PDPSectionKeySpecifier | (() => undefined | PDPSectionKeySpecifier),
		fields?: PDPSectionFieldPolicy,
	},
	PDPSectionTree?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PDPSectionTreeKeySpecifier | (() => undefined | PDPSectionTreeKeySpecifier),
		fields?: PDPSectionTreeFieldPolicy,
	},
	PDPElement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PDPElementKeySpecifier | (() => undefined | PDPElementKeySpecifier),
		fields?: PDPElementFieldPolicy,
	},
	RatingProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingProductKeySpecifier | (() => undefined | RatingProductKeySpecifier),
		fields?: RatingProductFieldPolicy,
	},
	RatingReviewSearchResultContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewSearchResultContainerKeySpecifier | (() => undefined | RatingReviewSearchResultContainerKeySpecifier),
		fields?: RatingReviewSearchResultContainerFieldPolicy,
	},
	RatingReviewsPagination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewsPaginationKeySpecifier | (() => undefined | RatingReviewsPaginationKeySpecifier),
		fields?: RatingReviewsPaginationFieldPolicy,
	},
	RatingReviewEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewEdgeKeySpecifier | (() => undefined | RatingReviewEdgeKeySpecifier),
		fields?: RatingReviewEdgeFieldPolicy,
	},
	RatingReview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewKeySpecifier | (() => undefined | RatingReviewKeySpecifier),
		fields?: RatingReviewFieldPolicy,
	},
	RatingReviewPhotoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewPhotoAssetKeySpecifier | (() => undefined | RatingReviewPhotoAssetKeySpecifier),
		fields?: RatingReviewPhotoAssetFieldPolicy,
	},
	RatingReviewPhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewPhotoKeySpecifier | (() => undefined | RatingReviewPhotoKeySpecifier),
		fields?: RatingReviewPhotoFieldPolicy,
	},
	RatingReviewPhotoData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewPhotoDataKeySpecifier | (() => undefined | RatingReviewPhotoDataKeySpecifier),
		fields?: RatingReviewPhotoDataFieldPolicy,
	},
	RatingReviewVideoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewVideoAssetKeySpecifier | (() => undefined | RatingReviewVideoAssetKeySpecifier),
		fields?: RatingReviewVideoAssetFieldPolicy,
	},
	RatingReviewVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewVideoKeySpecifier | (() => undefined | RatingReviewVideoKeySpecifier),
		fields?: RatingReviewVideoFieldPolicy,
	},
	RatingSyndicationSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingSyndicationSourceKeySpecifier | (() => undefined | RatingSyndicationSourceKeySpecifier),
		fields?: RatingSyndicationSourceFieldPolicy,
	},
	RatingSyndicationSourceV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingSyndicationSourceV2KeySpecifier | (() => undefined | RatingSyndicationSourceV2KeySpecifier),
		fields?: RatingSyndicationSourceV2FieldPolicy,
	},
	RatingReviewsPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingReviewsPageInfoKeySpecifier | (() => undefined | RatingReviewsPageInfoKeySpecifier),
		fields?: RatingReviewsPageInfoFieldPolicy,
	},
	RatingStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingStatsKeySpecifier | (() => undefined | RatingStatsKeySpecifier),
		fields?: RatingStatsFieldPolicy,
	},
	RatingBucketDistribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingBucketDistributionKeySpecifier | (() => undefined | RatingBucketDistributionKeySpecifier),
		fields?: RatingBucketDistributionFieldPolicy,
	},
	RatingTrait?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingTraitKeySpecifier | (() => undefined | RatingTraitKeySpecifier),
		fields?: RatingTraitFieldPolicy,
	},
	ProductCatalogRetailer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogRetailerKeySpecifier | (() => undefined | ProductCatalogRetailerKeySpecifier),
		fields?: ProductCatalogRetailerFieldPolicy,
	},
	ProductCatalogStorefrontInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogStorefrontInfoKeySpecifier | (() => undefined | ProductCatalogStorefrontInfoKeySpecifier),
		fields?: ProductCatalogStorefrontInfoFieldPolicy,
	},
	ProductCatalogItemTilePresentation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemTilePresentationKeySpecifier | (() => undefined | ProductCatalogItemTilePresentationKeySpecifier),
		fields?: ProductCatalogItemTilePresentationFieldPolicy,
	},
	ProductMonetaryValueRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMonetaryValueRangeKeySpecifier | (() => undefined | ProductMonetaryValueRangeKeySpecifier),
		fields?: ProductMonetaryValueRangeFieldPolicy,
	},
	ProductHeuristicPricingWindow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeuristicPricingWindowKeySpecifier | (() => undefined | ProductHeuristicPricingWindowKeySpecifier),
		fields?: ProductHeuristicPricingWindowFieldPolicy,
	},
	ComputedProductHeuristicExtraInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComputedProductHeuristicExtraInfoKeySpecifier | (() => undefined | ComputedProductHeuristicExtraInfoKeySpecifier),
		fields?: ComputedProductHeuristicExtraInfoFieldPolicy,
	},
	WarehouseItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseItemKeySpecifier | (() => undefined | WarehouseItemKeySpecifier),
		fields?: WarehouseItemFieldPolicy,
	},
	WarehouseSupplierProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseSupplierProductKeySpecifier | (() => undefined | WarehouseSupplierProductKeySpecifier),
		fields?: WarehouseSupplierProductFieldPolicy,
	},
	WarehouseSupplierProductInventory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseSupplierProductInventoryKeySpecifier | (() => undefined | WarehouseSupplierProductInventoryKeySpecifier),
		fields?: WarehouseSupplierProductInventoryFieldPolicy,
	},
	WarehouseShippingMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseShippingMethodKeySpecifier | (() => undefined | WarehouseShippingMethodKeySpecifier),
		fields?: WarehouseShippingMethodFieldPolicy,
	},
	WarehouseSupplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseSupplierKeySpecifier | (() => undefined | WarehouseSupplierKeySpecifier),
		fields?: WarehouseSupplierFieldPolicy,
	},
	ContactQuarantinedMessageBatchContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactQuarantinedMessageBatchContainerKeySpecifier | (() => undefined | ContactQuarantinedMessageBatchContainerKeySpecifier),
		fields?: ContactQuarantinedMessageBatchContainerFieldPolicy,
	},
	ContactQuarantinedMessageBatchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactQuarantinedMessageBatchConnectionKeySpecifier | (() => undefined | ContactQuarantinedMessageBatchConnectionKeySpecifier),
		fields?: ContactQuarantinedMessageBatchConnectionFieldPolicy,
	},
	ContactQuarantinedMessageBatchEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactQuarantinedMessageBatchEdgeKeySpecifier | (() => undefined | ContactQuarantinedMessageBatchEdgeKeySpecifier),
		fields?: ContactQuarantinedMessageBatchEdgeFieldPolicy,
	},
	ContactQuarantinedMessageBatchDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactQuarantinedMessageBatchDetailsKeySpecifier | (() => undefined | ContactQuarantinedMessageBatchDetailsKeySpecifier),
		fields?: ContactQuarantinedMessageBatchDetailsFieldPolicy,
	},
	ContactQuarantinedMessageBatchPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactQuarantinedMessageBatchPageInfoKeySpecifier | (() => undefined | ContactQuarantinedMessageBatchPageInfoKeySpecifier),
		fields?: ContactQuarantinedMessageBatchPageInfoFieldPolicy,
	},
	SanitizedContactQuarantinedMessageBatchDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SanitizedContactQuarantinedMessageBatchDetailsKeySpecifier | (() => undefined | SanitizedContactQuarantinedMessageBatchDetailsKeySpecifier),
		fields?: SanitizedContactQuarantinedMessageBatchDetailsFieldPolicy,
	},
	CurrencyConversion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyConversionKeySpecifier | (() => undefined | CurrencyConversionKeySpecifier),
		fields?: CurrencyConversionFieldPolicy,
	},
	CustomerInsights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerInsightsKeySpecifier | (() => undefined | CustomerInsightsKeySpecifier),
		fields?: CustomerInsightsFieldPolicy,
	},
	EnrichedCompanyInsights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnrichedCompanyInsightsKeySpecifier | (() => undefined | EnrichedCompanyInsightsKeySpecifier),
		fields?: EnrichedCompanyInsightsFieldPolicy,
	},
	EnrichedCustomerInsights?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnrichedCustomerInsightsKeySpecifier | (() => undefined | EnrichedCustomerInsightsKeySpecifier),
		fields?: EnrichedCustomerInsightsFieldPolicy,
	},
	EnrichedCustomerEmploymentData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnrichedCustomerEmploymentDataKeySpecifier | (() => undefined | EnrichedCustomerEmploymentDataKeySpecifier),
		fields?: EnrichedCustomerEmploymentDataFieldPolicy,
	},
	EnrichedCustomerInterest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnrichedCustomerInterestKeySpecifier | (() => undefined | EnrichedCustomerInterestKeySpecifier),
		fields?: EnrichedCustomerInterestFieldPolicy,
	},
	EventAdminInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventAdminInviteKeySpecifier | (() => undefined | EventAdminInviteKeySpecifier),
		fields?: EventAdminInviteFieldPolicy,
	},
	EventTypesConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTypesConfigKeySpecifier | (() => undefined | EventTypesConfigKeySpecifier),
		fields?: EventTypesConfigFieldPolicy,
	},
	Filestack?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilestackKeySpecifier | (() => undefined | FilestackKeySpecifier),
		fields?: FilestackFieldPolicy,
	},
	CashFundsHost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundsHostKeySpecifier | (() => undefined | CashFundsHostKeySpecifier),
		fields?: CashFundsHostFieldPolicy,
	},
	CashFund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundKeySpecifier | (() => undefined | CashFundKeySpecifier),
		fields?: CashFundFieldPolicy,
	},
	CashFundContribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundContributionKeySpecifier | (() => undefined | CashFundContributionKeySpecifier),
		fields?: CashFundContributionFieldPolicy,
	},
	CashFundContributor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundContributorKeySpecifier | (() => undefined | CashFundContributorKeySpecifier),
		fields?: CashFundContributorFieldPolicy,
	},
	CashFundOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundOrderKeySpecifier | (() => undefined | CashFundOrderKeySpecifier),
		fields?: CashFundOrderFieldPolicy,
	},
	CashFundSolicitation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundSolicitationKeySpecifier | (() => undefined | CashFundSolicitationKeySpecifier),
		fields?: CashFundSolicitationFieldPolicy,
	},
	CashFundSolicitationConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundSolicitationConfigKeySpecifier | (() => undefined | CashFundSolicitationConfigKeySpecifier),
		fields?: CashFundSolicitationConfigFieldPolicy,
	},
	CashFundSolicitationInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundSolicitationInviteKeySpecifier | (() => undefined | CashFundSolicitationInviteKeySpecifier),
		fields?: CashFundSolicitationInviteFieldPolicy,
	},
	CashFundsPayoutAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundsPayoutAccountKeySpecifier | (() => undefined | CashFundsPayoutAccountKeySpecifier),
		fields?: CashFundsPayoutAccountFieldPolicy,
	},
	CashFundsPayoutAccountBalance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundsPayoutAccountBalanceKeySpecifier | (() => undefined | CashFundsPayoutAccountBalanceKeySpecifier),
		fields?: CashFundsPayoutAccountBalanceFieldPolicy,
	},
	CashFundsPayoutAccountWithdrawal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundsPayoutAccountWithdrawalKeySpecifier | (() => undefined | CashFundsPayoutAccountWithdrawalKeySpecifier),
		fields?: CashFundsPayoutAccountWithdrawalFieldPolicy,
	},
	EmailDeliverySearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailDeliverySearchResultKeySpecifier | (() => undefined | EmailDeliverySearchResultKeySpecifier),
		fields?: EmailDeliverySearchResultFieldPolicy,
	},
	HotelMatchResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelMatchResponseKeySpecifier | (() => undefined | HotelMatchResponseKeySpecifier),
		fields?: HotelMatchResponseFieldPolicy,
	},
	HotelMatchAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelMatchAddressKeySpecifier | (() => undefined | HotelMatchAddressKeySpecifier),
		fields?: HotelMatchAddressFieldPolicy,
	},
	FindMatchingAccommodationCatalogPropertiesByDetailsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindMatchingAccommodationCatalogPropertiesByDetailsResultKeySpecifier | (() => undefined | FindMatchingAccommodationCatalogPropertiesByDetailsResultKeySpecifier),
		fields?: FindMatchingAccommodationCatalogPropertiesByDetailsResultFieldPolicy,
	},
	FindMatchingAccommodationCatalogPropertyResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindMatchingAccommodationCatalogPropertyResultKeySpecifier | (() => undefined | FindMatchingAccommodationCatalogPropertyResultKeySpecifier),
		fields?: FindMatchingAccommodationCatalogPropertyResultFieldPolicy,
	},
	FontPack?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FontPackKeySpecifier | (() => undefined | FontPackKeySpecifier),
		fields?: FontPackFieldPolicy,
	},
	Answer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnswerKeySpecifier | (() => undefined | AnswerKeySpecifier),
		fields?: AnswerFieldPolicy,
	},
	QuestionValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionValueKeySpecifier | (() => undefined | QuestionValueKeySpecifier),
		fields?: QuestionValueFieldPolicy,
	},
	GuestFormAnswers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestFormAnswersKeySpecifier | (() => undefined | GuestFormAnswersKeySpecifier),
		fields?: GuestFormAnswersFieldPolicy,
	},
	Form?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormKeySpecifier | (() => undefined | FormKeySpecifier),
		fields?: FormFieldPolicy,
	},
	TicketType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TicketTypeKeySpecifier | (() => undefined | TicketTypeKeySpecifier),
		fields?: TicketTypeFieldPolicy,
	},
	FormTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormTemplateKeySpecifier | (() => undefined | FormTemplateKeySpecifier),
		fields?: FormTemplateFieldPolicy,
	},
	SearchTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchTagKeySpecifier | (() => undefined | SearchTagKeySpecifier),
		fields?: SearchTagFieldPolicy,
	},
	CashFundForContribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundForContributionKeySpecifier | (() => undefined | CashFundForContributionKeySpecifier),
		fields?: CashFundForContributionFieldPolicy,
	},
	CashFundPaymentAttempt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundPaymentAttemptKeySpecifier | (() => undefined | CashFundPaymentAttemptKeySpecifier),
		fields?: CashFundPaymentAttemptFieldPolicy,
	},
	CashFundPayer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundPayerKeySpecifier | (() => undefined | CashFundPayerKeySpecifier),
		fields?: CashFundPayerFieldPolicy,
	},
	CollaborationInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollaborationInviteKeySpecifier | (() => undefined | CollaborationInviteKeySpecifier),
		fields?: CollaborationInviteFieldPolicy,
	},
	ContactCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactCollectionKeySpecifier | (() => undefined | ContactCollectionKeySpecifier),
		fields?: ContactCollectionFieldPolicy,
	},
	Contact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactKeySpecifier | (() => undefined | ContactKeySpecifier),
		fields?: ContactFieldPolicy,
	},
	ContactHousehold?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactHouseholdKeySpecifier | (() => undefined | ContactHouseholdKeySpecifier),
		fields?: ContactHouseholdFieldPolicy,
	},
	ContactAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactAddressKeySpecifier | (() => undefined | ContactAddressKeySpecifier),
		fields?: ContactAddressFieldPolicy,
	},
	ContactAuthorizedUse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactAuthorizedUseKeySpecifier | (() => undefined | ContactAuthorizedUseKeySpecifier),
		fields?: ContactAuthorizedUseFieldPolicy,
	},
	ContactPhoneNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactPhoneNumberKeySpecifier | (() => undefined | ContactPhoneNumberKeySpecifier),
		fields?: ContactPhoneNumberFieldPolicy,
	},
	ContactByFirebaseId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactByFirebaseIdKeySpecifier | (() => undefined | ContactByFirebaseIdKeySpecifier),
		fields?: ContactByFirebaseIdFieldPolicy,
	},
	Group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupKeySpecifier | (() => undefined | GroupKeySpecifier),
		fields?: GroupFieldPolicy,
	},
	GroupMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMemberKeySpecifier | (() => undefined | GroupMemberKeySpecifier),
		fields?: GroupMemberFieldPolicy,
	},
	ElectronicCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElectronicCardKeySpecifier | (() => undefined | ElectronicCardKeySpecifier),
		fields?: ElectronicCardFieldPolicy,
	},
	EcardDesign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EcardDesignKeySpecifier | (() => undefined | EcardDesignKeySpecifier),
		fields?: EcardDesignFieldPolicy,
	},
	ElectronicCardEcardEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElectronicCardEcardEmailDraftKeySpecifier | (() => undefined | ElectronicCardEcardEmailDraftKeySpecifier),
		fields?: ElectronicCardEcardEmailDraftFieldPolicy,
	},
	ElectronicCardCardLinkOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElectronicCardCardLinkOptionKeySpecifier | (() => undefined | ElectronicCardCardLinkOptionKeySpecifier),
		fields?: ElectronicCardCardLinkOptionFieldPolicy,
	},
	EmailSearchResultsSummaryView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailSearchResultsSummaryViewKeySpecifier | (() => undefined | EmailSearchResultsSummaryViewKeySpecifier),
		fields?: EmailSearchResultsSummaryViewFieldPolicy,
	},
	Email_Connection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Email_ConnectionKeySpecifier | (() => undefined | Email_ConnectionKeySpecifier),
		fields?: Email_ConnectionFieldPolicy,
	},
	Email_PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Email_PageInfoKeySpecifier | (() => undefined | Email_PageInfoKeySpecifier),
		fields?: Email_PageInfoFieldPolicy,
	},
	EmailSearchCollectionItemsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailSearchCollectionItemsEdgeKeySpecifier | (() => undefined | EmailSearchCollectionItemsEdgeKeySpecifier),
		fields?: EmailSearchCollectionItemsEdgeFieldPolicy,
	},
	Email_Edge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Email_EdgeKeySpecifier | (() => undefined | Email_EdgeKeySpecifier),
		fields?: Email_EdgeFieldPolicy,
	},
	EventSearchResultSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSearchResultSetKeySpecifier | (() => undefined | EventSearchResultSetKeySpecifier),
		fields?: EventSearchResultSetFieldPolicy,
	},
	EventSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSearchResultKeySpecifier | (() => undefined | EventSearchResultKeySpecifier),
		fields?: EventSearchResultFieldPolicy,
	},
	EventSearchScoring?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSearchScoringKeySpecifier | (() => undefined | EventSearchScoringKeySpecifier),
		fields?: EventSearchScoringFieldPolicy,
	},
	GreetingCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GreetingCardKeySpecifier | (() => undefined | GreetingCardKeySpecifier),
		fields?: GreetingCardFieldPolicy,
	},
	GroupMemberConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMemberConnectionKeySpecifier | (() => undefined | GroupMemberConnectionKeySpecifier),
		fields?: GroupMemberConnectionFieldPolicy,
	},
	GroupMemberEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMemberEdgeKeySpecifier | (() => undefined | GroupMemberEdgeKeySpecifier),
		fields?: GroupMemberEdgeFieldPolicy,
	},
	GroupWithMembers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupWithMembersKeySpecifier | (() => undefined | GroupWithMembersKeySpecifier),
		fields?: GroupWithMembersFieldPolicy,
	},
	GuestListMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberKeySpecifier | (() => undefined | GuestListMemberKeySpecifier),
		fields?: GuestListMemberFieldPolicy,
	},
	GuestListMemberGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberGroupKeySpecifier | (() => undefined | GuestListMemberGroupKeySpecifier),
		fields?: GuestListMemberGroupFieldPolicy,
	},
	GuestListMemberKey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberKeyKeySpecifier | (() => undefined | GuestListMemberKeyKeySpecifier),
		fields?: GuestListMemberKeyFieldPolicy,
	},
	GuestRegistrationAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestRegistrationAnswerKeySpecifier | (() => undefined | GuestRegistrationAnswerKeySpecifier),
		fields?: GuestRegistrationAnswerFieldPolicy,
	},
	GuestListMemberTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberTagKeySpecifier | (() => undefined | GuestListMemberTagKeySpecifier),
		fields?: GuestListMemberTagFieldPolicy,
	},
	GroupMemberPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMemberPageInfoKeySpecifier | (() => undefined | GroupMemberPageInfoKeySpecifier),
		fields?: GroupMemberPageInfoFieldPolicy,
	},
	GuestFormView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestFormViewKeySpecifier | (() => undefined | GuestFormViewKeySpecifier),
		fields?: GuestFormViewFieldPolicy,
	},
	GeneralEventScheduleInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeneralEventScheduleInfoKeySpecifier | (() => undefined | GeneralEventScheduleInfoKeySpecifier),
		fields?: GeneralEventScheduleInfoFieldPolicy,
	},
	GuestListMemberConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberConnectionKeySpecifier | (() => undefined | GuestListMemberConnectionKeySpecifier),
		fields?: GuestListMemberConnectionFieldPolicy,
	},
	GuestListMemberEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberEdgeKeySpecifier | (() => undefined | GuestListMemberEdgeKeySpecifier),
		fields?: GuestListMemberEdgeFieldPolicy,
	},
	GuestListMemberPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestListMemberPageInfoKeySpecifier | (() => undefined | GuestListMemberPageInfoKeySpecifier),
		fields?: GuestListMemberPageInfoFieldPolicy,
	},
	MessageBatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageBatchKeySpecifier | (() => undefined | MessageBatchKeySpecifier),
		fields?: MessageBatchFieldPolicy,
	},
	MessageRelationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageRelationResultKeySpecifier | (() => undefined | MessageRelationResultKeySpecifier),
		fields?: MessageRelationResultFieldPolicy,
	},
	MessagingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessagingSettingsKeySpecifier | (() => undefined | MessagingSettingsKeySpecifier),
		fields?: MessagingSettingsFieldPolicy,
	},
	PhoneNumberInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhoneNumberInformationKeySpecifier | (() => undefined | PhoneNumberInformationKeySpecifier),
		fields?: PhoneNumberInformationFieldPolicy,
	},
	PostOfficeGenericEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostOfficeGenericEmailDraftKeySpecifier | (() => undefined | PostOfficeGenericEmailDraftKeySpecifier),
		fields?: PostOfficeGenericEmailDraftFieldPolicy,
	},
	PostOfficeGiftWrapEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostOfficeGiftWrapEmailDraftKeySpecifier | (() => undefined | PostOfficeGiftWrapEmailDraftKeySpecifier),
		fields?: PostOfficeGiftWrapEmailDraftFieldPolicy,
	},
	PostOfficeGreetingCardEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostOfficeGreetingCardEmailDraftKeySpecifier | (() => undefined | PostOfficeGreetingCardEmailDraftKeySpecifier),
		fields?: PostOfficeGreetingCardEmailDraftFieldPolicy,
	},
	PostOfficeReminderEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostOfficeReminderEmailDraftKeySpecifier | (() => undefined | PostOfficeReminderEmailDraftKeySpecifier),
		fields?: PostOfficeReminderEmailDraftFieldPolicy,
	},
	PostOfficeThankYouEmailDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostOfficeThankYouEmailDraftKeySpecifier | (() => undefined | PostOfficeThankYouEmailDraftKeySpecifier),
		fields?: PostOfficeThankYouEmailDraftFieldPolicy,
	},
	RegistrationQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistrationQuestionKeySpecifier | (() => undefined | RegistrationQuestionKeySpecifier),
		fields?: RegistrationQuestionFieldPolicy,
	},
	RegistryStaticData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryStaticDataKeySpecifier | (() => undefined | RegistryStaticDataKeySpecifier),
		fields?: RegistryStaticDataFieldPolicy,
	},
	RegistryCountryResults?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCountryResultsKeySpecifier | (() => undefined | RegistryCountryResultsKeySpecifier),
		fields?: RegistryCountryResultsFieldPolicy,
	},
	RegistryCurrencyResults?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCurrencyResultsKeySpecifier | (() => undefined | RegistryCurrencyResultsKeySpecifier),
		fields?: RegistryCurrencyResultsFieldPolicy,
	},
	RegistryStoreSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryStoreSectionKeySpecifier | (() => undefined | RegistryStoreSectionKeySpecifier),
		fields?: RegistryStoreSectionFieldPolicy,
	},
	RegistryStore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryStoreKeySpecifier | (() => undefined | RegistryStoreKeySpecifier),
		fields?: RegistryStoreFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	RegistryStoreValueProposition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryStoreValuePropositionKeySpecifier | (() => undefined | RegistryStoreValuePropositionKeySpecifier),
		fields?: RegistryStoreValuePropositionFieldPolicy,
	},
	TaggedResource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaggedResourceKeySpecifier | (() => undefined | TaggedResourceKeySpecifier),
		fields?: TaggedResourceFieldPolicy,
	},
	ResourceVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResourceVisibilityKeySpecifier | (() => undefined | ResourceVisibilityKeySpecifier),
		fields?: ResourceVisibilityFieldPolicy,
	},
	GuestRsvpAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuestRsvpAnswerKeySpecifier | (() => undefined | GuestRsvpAnswerKeySpecifier),
		fields?: GuestRsvpAnswerFieldPolicy,
	},
	TemplateSearchMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateSearchMetadataKeySpecifier | (() => undefined | TemplateSearchMetadataKeySpecifier),
		fields?: TemplateSearchMetadataFieldPolicy,
	},
	TagDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagDefinitionKeySpecifier | (() => undefined | TagDefinitionKeySpecifier),
		fields?: TagDefinitionFieldPolicy,
	},
	ResourceTags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResourceTagsKeySpecifier | (() => undefined | ResourceTagsKeySpecifier),
		fields?: ResourceTagsFieldPolicy,
	},
	GoogleCalendarSyncOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GoogleCalendarSyncOptionKeySpecifier | (() => undefined | GoogleCalendarSyncOptionKeySpecifier),
		fields?: GoogleCalendarSyncOptionFieldPolicy,
	},
	Greetings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GreetingsKeySpecifier | (() => undefined | GreetingsKeySpecifier),
		fields?: GreetingsFieldPolicy,
	},
	HotelInventoryImages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelInventoryImagesKeySpecifier | (() => undefined | HotelInventoryImagesKeySpecifier),
		fields?: HotelInventoryImagesFieldPolicy,
	},
	HotelInventoryImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelInventoryImageKeySpecifier | (() => undefined | HotelInventoryImageKeySpecifier),
		fields?: HotelInventoryImageFieldPolicy,
	},
	HotelInventory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelInventoryKeySpecifier | (() => undefined | HotelInventoryKeySpecifier),
		fields?: HotelInventoryFieldPolicy,
	},
	FacilityGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FacilityGroupKeySpecifier | (() => undefined | FacilityGroupKeySpecifier),
		fields?: FacilityGroupFieldPolicy,
	},
	InventoryLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InventoryLocationKeySpecifier | (() => undefined | InventoryLocationKeySpecifier),
		fields?: InventoryLocationFieldPolicy,
	},
	HotelRoomsAndRates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomsAndRatesKeySpecifier | (() => undefined | HotelRoomsAndRatesKeySpecifier),
		fields?: HotelRoomsAndRatesFieldPolicy,
	},
	HotelRoomsAndRatesRate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomsAndRatesRateKeySpecifier | (() => undefined | HotelRoomsAndRatesRateKeySpecifier),
		fields?: HotelRoomsAndRatesRateFieldPolicy,
	},
	HotelRoomsAndRatesOccupancy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomsAndRatesOccupancyKeySpecifier | (() => undefined | HotelRoomsAndRatesOccupancyKeySpecifier),
		fields?: HotelRoomsAndRatesOccupancyFieldPolicy,
	},
	TravelMonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelMonetaryValueKeySpecifier | (() => undefined | TravelMonetaryValueKeySpecifier),
		fields?: TravelMonetaryValueFieldPolicy,
	},
	HotelRoomsAndRatesRoom?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomsAndRatesRoomKeySpecifier | (() => undefined | HotelRoomsAndRatesRoomKeySpecifier),
		fields?: HotelRoomsAndRatesRoomFieldPolicy,
	},
	HotelRoomsAndRatesBed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelRoomsAndRatesBedKeySpecifier | (() => undefined | HotelRoomsAndRatesBedKeySpecifier),
		fields?: HotelRoomsAndRatesBedFieldPolicy,
	},
	HotelInventoryWithRoomsAndRates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HotelInventoryWithRoomsAndRatesKeySpecifier | (() => undefined | HotelInventoryWithRoomsAndRatesKeySpecifier),
		fields?: HotelInventoryWithRoomsAndRatesFieldPolicy,
	},
	ImprovedTextResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImprovedTextResponseKeySpecifier | (() => undefined | ImprovedTextResponseKeySpecifier),
		fields?: ImprovedTextResponseFieldPolicy,
	},
	InsightRagQueryResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsightRagQueryResponseKeySpecifier | (() => undefined | InsightRagQueryResponseKeySpecifier),
		fields?: InsightRagQueryResponseFieldPolicy,
	},
	InsightRagPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsightRagPostKeySpecifier | (() => undefined | InsightRagPostKeySpecifier),
		fields?: InsightRagPostFieldPolicy,
	},
	InternalEventSearchContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventSearchContainerKeySpecifier | (() => undefined | InternalEventSearchContainerKeySpecifier),
		fields?: InternalEventSearchContainerFieldPolicy,
	},
	InternalEventSearchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventSearchConnectionKeySpecifier | (() => undefined | InternalEventSearchConnectionKeySpecifier),
		fields?: InternalEventSearchConnectionFieldPolicy,
	},
	InternalEventSearchEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventSearchEdgeKeySpecifier | (() => undefined | InternalEventSearchEdgeKeySpecifier),
		fields?: InternalEventSearchEdgeFieldPolicy,
	},
	InternalEventSearchResultItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventSearchResultItemKeySpecifier | (() => undefined | InternalEventSearchResultItemKeySpecifier),
		fields?: InternalEventSearchResultItemFieldPolicy,
	},
	InternalEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventKeySpecifier | (() => undefined | InternalEventKeySpecifier),
		fields?: InternalEventFieldPolicy,
	},
	InternalEventInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalEventInfoKeySpecifier | (() => undefined | InternalEventInfoKeySpecifier),
		fields?: InternalEventInfoFieldPolicy,
	},
	EventSearchPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSearchPageInfoKeySpecifier | (() => undefined | EventSearchPageInfoKeySpecifier),
		fields?: EventSearchPageInfoFieldPolicy,
	},
	InternalMessageSearchResultContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalMessageSearchResultContainerKeySpecifier | (() => undefined | InternalMessageSearchResultContainerKeySpecifier),
		fields?: InternalMessageSearchResultContainerFieldPolicy,
	},
	InternalMessageResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalMessageResultKeySpecifier | (() => undefined | InternalMessageResultKeySpecifier),
		fields?: InternalMessageResultFieldPolicy,
	},
	InternalMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalMessageKeySpecifier | (() => undefined | InternalMessageKeySpecifier),
		fields?: InternalMessageFieldPolicy,
	},
	InternalMessageStatusRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalMessageStatusRecordKeySpecifier | (() => undefined | InternalMessageStatusRecordKeySpecifier),
		fields?: InternalMessageStatusRecordFieldPolicy,
	},
	InternalRecipientInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalRecipientInfoKeySpecifier | (() => undefined | InternalRecipientInfoKeySpecifier),
		fields?: InternalRecipientInfoFieldPolicy,
	},
	InternalPerson?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalPersonKeySpecifier | (() => undefined | InternalPersonKeySpecifier),
		fields?: InternalPersonFieldPolicy,
	},
	LinkRedirectBlockContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectBlockContainerKeySpecifier | (() => undefined | LinkRedirectBlockContainerKeySpecifier),
		fields?: LinkRedirectBlockContainerFieldPolicy,
	},
	LinkRedirectBlockConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectBlockConnectionKeySpecifier | (() => undefined | LinkRedirectBlockConnectionKeySpecifier),
		fields?: LinkRedirectBlockConnectionFieldPolicy,
	},
	LinkRedirectBlockEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectBlockEdgeKeySpecifier | (() => undefined | LinkRedirectBlockEdgeKeySpecifier),
		fields?: LinkRedirectBlockEdgeFieldPolicy,
	},
	LinkRedirectBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectBlockKeySpecifier | (() => undefined | LinkRedirectBlockKeySpecifier),
		fields?: LinkRedirectBlockFieldPolicy,
	},
	LinkPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkPageInfoKeySpecifier | (() => undefined | LinkPageInfoKeySpecifier),
		fields?: LinkPageInfoFieldPolicy,
	},
	LinkRedirectContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectContainerKeySpecifier | (() => undefined | LinkRedirectContainerKeySpecifier),
		fields?: LinkRedirectContainerFieldPolicy,
	},
	LinkRedirectConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectConnectionKeySpecifier | (() => undefined | LinkRedirectConnectionKeySpecifier),
		fields?: LinkRedirectConnectionFieldPolicy,
	},
	LinkRedirectEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectEdgeKeySpecifier | (() => undefined | LinkRedirectEdgeKeySpecifier),
		fields?: LinkRedirectEdgeFieldPolicy,
	},
	LinkRedirect?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectKeySpecifier | (() => undefined | LinkRedirectKeySpecifier),
		fields?: LinkRedirectFieldPolicy,
	},
	LinkRedirectHistoryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkRedirectHistoryEntryKeySpecifier | (() => undefined | LinkRedirectHistoryEntryKeySpecifier),
		fields?: LinkRedirectHistoryEntryFieldPolicy,
	},
	LocationSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationSuggestionKeySpecifier | (() => undefined | LocationSuggestionKeySpecifier),
		fields?: LocationSuggestionFieldPolicy,
	},
	MarketingEmailPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarketingEmailPreferencesKeySpecifier | (() => undefined | MarketingEmailPreferencesKeySpecifier),
		fields?: MarketingEmailPreferencesFieldPolicy,
	},
	MessagePreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessagePreferenceKeySpecifier | (() => undefined | MessagePreferenceKeySpecifier),
		fields?: MessagePreferenceFieldPolicy,
	},
	MediaMagicToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaMagicTokenKeySpecifier | (() => undefined | MediaMagicTokenKeySpecifier),
		fields?: MediaMagicTokenFieldPolicy,
	},
	MessageSearchResultContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageSearchResultContainerKeySpecifier | (() => undefined | MessageSearchResultContainerKeySpecifier),
		fields?: MessageSearchResultContainerFieldPolicy,
	},
	MessageResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageResultKeySpecifier | (() => undefined | MessageResultKeySpecifier),
		fields?: MessageResultFieldPolicy,
	},
	Message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageKeySpecifier | (() => undefined | MessageKeySpecifier),
		fields?: MessageFieldPolicy,
	},
	RecipientInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecipientInfoKeySpecifier | (() => undefined | RecipientInfoKeySpecifier),
		fields?: RecipientInfoFieldPolicy,
	},
	MessageStatusRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageStatusRecordKeySpecifier | (() => undefined | MessageStatusRecordKeySpecifier),
		fields?: MessageStatusRecordFieldPolicy,
	},
	MilestonesActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesActivityConnectionKeySpecifier | (() => undefined | MilestonesActivityConnectionKeySpecifier),
		fields?: MilestonesActivityConnectionFieldPolicy,
	},
	MilestonesActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesActivityKeySpecifier | (() => undefined | MilestonesActivityKeySpecifier),
		fields?: MilestonesActivityFieldPolicy,
	},
	MilestonesCalendarView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCalendarViewKeySpecifier | (() => undefined | MilestonesCalendarViewKeySpecifier),
		fields?: MilestonesCalendarViewFieldPolicy,
	},
	MilestonesCalendarDay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCalendarDayKeySpecifier | (() => undefined | MilestonesCalendarDayKeySpecifier),
		fields?: MilestonesCalendarDayFieldPolicy,
	},
	MilestonesMilestone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesMilestoneKeySpecifier | (() => undefined | MilestonesMilestoneKeySpecifier),
		fields?: MilestonesMilestoneFieldPolicy,
	},
	MilestonesAttachment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesAttachmentKeySpecifier | (() => undefined | MilestonesAttachmentKeySpecifier),
		fields?: MilestonesAttachmentFieldPolicy,
	},
	MilestonesCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCategoryKeySpecifier | (() => undefined | MilestonesCategoryKeySpecifier),
		fields?: MilestonesCategoryFieldPolicy,
	},
	MilestonesComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCommentKeySpecifier | (() => undefined | MilestonesCommentKeySpecifier),
		fields?: MilestonesCommentFieldPolicy,
	},
	MilestonesStatusNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesStatusNoteKeySpecifier | (() => undefined | MilestonesStatusNoteKeySpecifier),
		fields?: MilestonesStatusNoteFieldPolicy,
	},
	MilestonesGanttView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesGanttViewKeySpecifier | (() => undefined | MilestonesGanttViewKeySpecifier),
		fields?: MilestonesGanttViewFieldPolicy,
	},
	MilestonesDependencyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesDependencyEdgeKeySpecifier | (() => undefined | MilestonesDependencyEdgeKeySpecifier),
		fields?: MilestonesDependencyEdgeFieldPolicy,
	},
	MilestonesGanttMilestone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesGanttMilestoneKeySpecifier | (() => undefined | MilestonesGanttMilestoneKeySpecifier),
		fields?: MilestonesGanttMilestoneFieldPolicy,
	},
	MilestonesPhase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesPhaseKeySpecifier | (() => undefined | MilestonesPhaseKeySpecifier),
		fields?: MilestonesPhaseFieldPolicy,
	},
	MilestonesTimeframe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesTimeframeKeySpecifier | (() => undefined | MilestonesTimeframeKeySpecifier),
		fields?: MilestonesTimeframeFieldPolicy,
	},
	MilestonesImportJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportJobKeySpecifier | (() => undefined | MilestonesImportJobKeySpecifier),
		fields?: MilestonesImportJobFieldPolicy,
	},
	MilestonesImportError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportErrorKeySpecifier | (() => undefined | MilestonesImportErrorKeySpecifier),
		fields?: MilestonesImportErrorFieldPolicy,
	},
	MilestonesImportPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportPreviewKeySpecifier | (() => undefined | MilestonesImportPreviewKeySpecifier),
		fields?: MilestonesImportPreviewFieldPolicy,
	},
	MilestonesImportDependencyPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportDependencyPreviewKeySpecifier | (() => undefined | MilestonesImportDependencyPreviewKeySpecifier),
		fields?: MilestonesImportDependencyPreviewFieldPolicy,
	},
	MilestonesImportMilestonePreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportMilestonePreviewKeySpecifier | (() => undefined | MilestonesImportMilestonePreviewKeySpecifier),
		fields?: MilestonesImportMilestonePreviewFieldPolicy,
	},
	MilestonesImportRowError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportRowErrorKeySpecifier | (() => undefined | MilestonesImportRowErrorKeySpecifier),
		fields?: MilestonesImportRowErrorFieldPolicy,
	},
	MilestonesImportPhasePreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportPhasePreviewKeySpecifier | (() => undefined | MilestonesImportPhasePreviewKeySpecifier),
		fields?: MilestonesImportPhasePreviewFieldPolicy,
	},
	MilestonesImportPreviewSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesImportPreviewSummaryKeySpecifier | (() => undefined | MilestonesImportPreviewSummaryKeySpecifier),
		fields?: MilestonesImportPreviewSummaryFieldPolicy,
	},
	MilestonesKanbanView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesKanbanViewKeySpecifier | (() => undefined | MilestonesKanbanViewKeySpecifier),
		fields?: MilestonesKanbanViewFieldPolicy,
	},
	MilestonesKanbanColumn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesKanbanColumnKeySpecifier | (() => undefined | MilestonesKanbanColumnKeySpecifier),
		fields?: MilestonesKanbanColumnFieldPolicy,
	},
	MilestonesMilestoneConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesMilestoneConnectionKeySpecifier | (() => undefined | MilestonesMilestoneConnectionKeySpecifier),
		fields?: MilestonesMilestoneConnectionFieldPolicy,
	},
	MilestonesGroupCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesGroupCountKeySpecifier | (() => undefined | MilestonesGroupCountKeySpecifier),
		fields?: MilestonesGroupCountFieldPolicy,
	},
	MilestonesPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesPageInfoKeySpecifier | (() => undefined | MilestonesPageInfoKeySpecifier),
		fields?: MilestonesPageInfoFieldPolicy,
	},
	MilestonesProject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesProjectKeySpecifier | (() => undefined | MilestonesProjectKeySpecifier),
		fields?: MilestonesProjectFieldPolicy,
	},
	NearbyAttractionsSearchResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NearbyAttractionsSearchResponseKeySpecifier | (() => undefined | NearbyAttractionsSearchResponseKeySpecifier),
		fields?: NearbyAttractionsSearchResponseFieldPolicy,
	},
	NearbySearchAttraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NearbySearchAttractionKeySpecifier | (() => undefined | NearbySearchAttractionKeySpecifier),
		fields?: NearbySearchAttractionFieldPolicy,
	},
	OfferTokenResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferTokenResultKeySpecifier | (() => undefined | OfferTokenResultKeySpecifier),
		fields?: OfferTokenResultFieldPolicy,
	},
	OfferTokenDates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferTokenDatesKeySpecifier | (() => undefined | OfferTokenDatesKeySpecifier),
		fields?: OfferTokenDatesFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	Ticket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TicketKeySpecifier | (() => undefined | TicketKeySpecifier),
		fields?: TicketFieldPolicy,
	},
	OrderConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderConnectionKeySpecifier | (() => undefined | OrderConnectionKeySpecifier),
		fields?: OrderConnectionFieldPolicy,
	},
	PhotoToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoTokenKeySpecifier | (() => undefined | PhotoTokenKeySpecifier),
		fields?: PhotoTokenFieldPolicy,
	},
	TravelPricingsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPricingsResultKeySpecifier | (() => undefined | TravelPricingsResultKeySpecifier),
		fields?: TravelPricingsResultFieldPolicy,
	},
	TravelPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPricingKeySpecifier | (() => undefined | TravelPricingKeySpecifier),
		fields?: TravelPricingFieldPolicy,
	},
	TravelOfferFee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferFeeKeySpecifier | (() => undefined | TravelOfferFeeKeySpecifier),
		fields?: TravelOfferFeeFieldPolicy,
	},
	TravelPropertyPricingsSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPropertyPricingsSearchResultKeySpecifier | (() => undefined | TravelPropertyPricingsSearchResultKeySpecifier),
		fields?: TravelPropertyPricingsSearchResultFieldPolicy,
	},
	TravelPropertyPricingSearchItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPropertyPricingSearchItemKeySpecifier | (() => undefined | TravelPropertyPricingSearchItemKeySpecifier),
		fields?: TravelPropertyPricingSearchItemFieldPolicy,
	},
	TravelPropertyPricingAndBookingDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPropertyPricingAndBookingDetailsKeySpecifier | (() => undefined | TravelPropertyPricingAndBookingDetailsKeySpecifier),
		fields?: TravelPropertyPricingAndBookingDetailsFieldPolicy,
	},
	TravelPropertyPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPropertyPricingKeySpecifier | (() => undefined | TravelPropertyPricingKeySpecifier),
		fields?: TravelPropertyPricingFieldPolicy,
	},
	ProductCatalogAds?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogAdsKeySpecifier | (() => undefined | ProductCatalogAdsKeySpecifier),
		fields?: ProductCatalogAdsFieldPolicy,
	},
	ProductCatalogBrandPromoMosaic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandPromoMosaicKeySpecifier | (() => undefined | ProductCatalogBrandPromoMosaicKeySpecifier),
		fields?: ProductCatalogBrandPromoMosaicFieldPolicy,
	},
	ProductCatalogBrandPromo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandPromoKeySpecifier | (() => undefined | ProductCatalogBrandPromoKeySpecifier),
		fields?: ProductCatalogBrandPromoFieldPolicy,
	},
	ProductCatalogDepartmentBrandPromo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogDepartmentBrandPromoKeySpecifier | (() => undefined | ProductCatalogDepartmentBrandPromoKeySpecifier),
		fields?: ProductCatalogDepartmentBrandPromoFieldPolicy,
	},
	ProductCatalogBrandsDirectory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogBrandsDirectoryKeySpecifier | (() => undefined | ProductCatalogBrandsDirectoryKeySpecifier),
		fields?: ProductCatalogBrandsDirectoryFieldPolicy,
	},
	ProductCatalogItemRecommendationContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemRecommendationContainerKeySpecifier | (() => undefined | ProductCatalogItemRecommendationContainerKeySpecifier),
		fields?: ProductCatalogItemRecommendationContainerFieldPolicy,
	},
	ProductCatalogItemRecommendation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogItemRecommendationKeySpecifier | (() => undefined | ProductCatalogItemRecommendationKeySpecifier),
		fields?: ProductCatalogItemRecommendationFieldPolicy,
	},
	ProductCatalogSearchResultContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchResultContainerKeySpecifier | (() => undefined | ProductCatalogSearchResultContainerKeySpecifier),
		fields?: ProductCatalogSearchResultContainerFieldPolicy,
	},
	ProductCatalogSearchFilterGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchFilterGroupKeySpecifier | (() => undefined | ProductCatalogSearchFilterGroupKeySpecifier),
		fields?: ProductCatalogSearchFilterGroupFieldPolicy,
	},
	ProductSearchFilterAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductSearchFilterAttributeKeySpecifier | (() => undefined | ProductSearchFilterAttributeKeySpecifier),
		fields?: ProductSearchFilterAttributeFieldPolicy,
	},
	AttributeMonetaryRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeMonetaryRangeKeySpecifier | (() => undefined | AttributeMonetaryRangeKeySpecifier),
		fields?: AttributeMonetaryRangeFieldPolicy,
	},
	ProductCatalogSearchFilterGroupSelectedPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchFilterGroupSelectedPriceKeySpecifier | (() => undefined | ProductCatalogSearchFilterGroupSelectedPriceKeySpecifier),
		fields?: ProductCatalogSearchFilterGroupSelectedPriceFieldPolicy,
	},
	ProductCatalogSearchResultItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchResultItemKeySpecifier | (() => undefined | ProductCatalogSearchResultItemKeySpecifier),
		fields?: ProductCatalogSearchResultItemFieldPolicy,
	},
	ProductCatalogSearchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchConnectionKeySpecifier | (() => undefined | ProductCatalogSearchConnectionKeySpecifier),
		fields?: ProductCatalogSearchConnectionFieldPolicy,
	},
	ProductCatalogSearchEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchEdgeKeySpecifier | (() => undefined | ProductCatalogSearchEdgeKeySpecifier),
		fields?: ProductCatalogSearchEdgeFieldPolicy,
	},
	ProductCatalogSearchPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogSearchPageInfoKeySpecifier | (() => undefined | ProductCatalogSearchPageInfoKeySpecifier),
		fields?: ProductCatalogSearchPageInfoFieldPolicy,
	},
	ProductExternal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExternalKeySpecifier | (() => undefined | ProductExternalKeySpecifier),
		fields?: ProductExternalFieldPolicy,
	},
	ProductRating?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductRatingKeySpecifier | (() => undefined | ProductRatingKeySpecifier),
		fields?: ProductRatingFieldPolicy,
	},
	ProductExternalSeller?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExternalSellerKeySpecifier | (() => undefined | ProductExternalSellerKeySpecifier),
		fields?: ProductExternalSellerFieldPolicy,
	},
	ProductExternalSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExternalSearchResultKeySpecifier | (() => undefined | ProductExternalSearchResultKeySpecifier),
		fields?: ProductExternalSearchResultFieldPolicy,
	},
	ProductExternalOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExternalOfferKeySpecifier | (() => undefined | ProductExternalOfferKeySpecifier),
		fields?: ProductExternalOfferFieldPolicy,
	},
	ProductHeroContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroContentKeySpecifier | (() => undefined | ProductHeroContentKeySpecifier),
		fields?: ProductHeroContentFieldPolicy,
	},
	ProductHeroContentCta?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroContentCtaKeySpecifier | (() => undefined | ProductHeroContentCtaKeySpecifier),
		fields?: ProductHeroContentCtaFieldPolicy,
	},
	ProductHeroImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroImageKeySpecifier | (() => undefined | ProductHeroImageKeySpecifier),
		fields?: ProductHeroImageFieldPolicy,
	},
	ProductHeroImagePhotoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroImagePhotoAssetKeySpecifier | (() => undefined | ProductHeroImagePhotoAssetKeySpecifier),
		fields?: ProductHeroImagePhotoAssetFieldPolicy,
	},
	ProductHeroVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroVideoKeySpecifier | (() => undefined | ProductHeroVideoKeySpecifier),
		fields?: ProductHeroVideoFieldPolicy,
	},
	ProductHeroVideoAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeroVideoAssetKeySpecifier | (() => undefined | ProductHeroVideoAssetKeySpecifier),
		fields?: ProductHeroVideoAssetFieldPolicy,
	},
	ProductInventoryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductInventoryResultKeySpecifier | (() => undefined | ProductInventoryResultKeySpecifier),
		fields?: ProductInventoryResultFieldPolicy,
	},
	ProductHeuristicSearchOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeuristicSearchOutputKeySpecifier | (() => undefined | ProductHeuristicSearchOutputKeySpecifier),
		fields?: ProductHeuristicSearchOutputFieldPolicy,
	},
	ProductHeuristicSearchOutput_Line?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductHeuristicSearchOutput_LineKeySpecifier | (() => undefined | ProductHeuristicSearchOutput_LineKeySpecifier),
		fields?: ProductHeuristicSearchOutput_LineFieldPolicy,
	},
	ProductUniversalSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchResultKeySpecifier | (() => undefined | ProductUniversalSearchResultKeySpecifier),
		fields?: ProductUniversalSearchResultFieldPolicy,
	},
	ProductUniversalSearchResultItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchResultItemKeySpecifier | (() => undefined | ProductUniversalSearchResultItemKeySpecifier),
		fields?: ProductUniversalSearchResultItemFieldPolicy,
	},
	UniversalProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UniversalProductKeySpecifier | (() => undefined | UniversalProductKeySpecifier),
		fields?: UniversalProductFieldPolicy,
	},
	ProductUniversalSearchResultContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchResultContainerKeySpecifier | (() => undefined | ProductUniversalSearchResultContainerKeySpecifier),
		fields?: ProductUniversalSearchResultContainerFieldPolicy,
	},
	ProductUniversalSearchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchConnectionKeySpecifier | (() => undefined | ProductUniversalSearchConnectionKeySpecifier),
		fields?: ProductUniversalSearchConnectionFieldPolicy,
	},
	ProductUniversalSearchEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchEdgeKeySpecifier | (() => undefined | ProductUniversalSearchEdgeKeySpecifier),
		fields?: ProductUniversalSearchEdgeFieldPolicy,
	},
	ProductUniversalSearchNode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalSearchNodeKeySpecifier | (() => undefined | ProductUniversalSearchNodeKeySpecifier),
		fields?: ProductUniversalSearchNodeFieldPolicy,
	},
	ProductExternalOfferContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExternalOfferContainerKeySpecifier | (() => undefined | ProductExternalOfferContainerKeySpecifier),
		fields?: ProductExternalOfferContainerFieldPolicy,
	},
	ProductUniversalCatalogItemContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalCatalogItemContainerKeySpecifier | (() => undefined | ProductUniversalCatalogItemContainerKeySpecifier),
		fields?: ProductUniversalCatalogItemContainerFieldPolicy,
	},
	ProductUniversalProductContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUniversalProductContainerKeySpecifier | (() => undefined | ProductUniversalProductContainerKeySpecifier),
		fields?: ProductUniversalProductContainerFieldPolicy,
	},
	QuestionWithAnswers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionWithAnswersKeySpecifier | (() => undefined | QuestionWithAnswersKeySpecifier),
		fields?: QuestionWithAnswersFieldPolicy,
	},
	RecentTravelReservation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecentTravelReservationKeySpecifier | (() => undefined | RecentTravelReservationKeySpecifier),
		fields?: RecentTravelReservationFieldPolicy,
	},
	TravelReservationBookingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationBookingInfoKeySpecifier | (() => undefined | TravelReservationBookingInfoKeySpecifier),
		fields?: TravelReservationBookingInfoFieldPolicy,
	},
	Occupancy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OccupancyKeySpecifier | (() => undefined | OccupancyKeySpecifier),
		fields?: OccupancyFieldPolicy,
	},
	ProductCatalogPageSectionContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogPageSectionContainerKeySpecifier | (() => undefined | ProductCatalogPageSectionContainerKeySpecifier),
		fields?: ProductCatalogPageSectionContainerFieldPolicy,
	},
	ProductCatalogPageSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogPageSectionKeySpecifier | (() => undefined | ProductCatalogPageSectionKeySpecifier),
		fields?: ProductCatalogPageSectionFieldPolicy,
	},
	ProductCatalogEntitiesPagination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntitiesPaginationKeySpecifier | (() => undefined | ProductCatalogEntitiesPaginationKeySpecifier),
		fields?: ProductCatalogEntitiesPaginationFieldPolicy,
	},
	ProductCatalogEntityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityEdgeKeySpecifier | (() => undefined | ProductCatalogEntityEdgeKeySpecifier),
		fields?: ProductCatalogEntityEdgeFieldPolicy,
	},
	ProductCatalogEntitiesPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntitiesPageInfoKeySpecifier | (() => undefined | ProductCatalogEntitiesPageInfoKeySpecifier),
		fields?: ProductCatalogEntitiesPageInfoFieldPolicy,
	},
	RegistrationConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistrationConnectionKeySpecifier | (() => undefined | RegistrationConnectionKeySpecifier),
		fields?: RegistrationConnectionFieldPolicy,
	},
	RegistryCatalogInventoryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCatalogInventoryResultKeySpecifier | (() => undefined | RegistryCatalogInventoryResultKeySpecifier),
		fields?: RegistryCatalogInventoryResultFieldPolicy,
	},
	RegistryPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPageKeySpecifier | (() => undefined | RegistryPageKeySpecifier),
		fields?: RegistryPageFieldPolicy,
	},
	RegistryPurchaseConfirmationDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPurchaseConfirmationDetailsKeySpecifier | (() => undefined | RegistryPurchaseConfirmationDetailsKeySpecifier),
		fields?: RegistryPurchaseConfirmationDetailsFieldPolicy,
	},
	SalesOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderKeySpecifier | (() => undefined | SalesOrderKeySpecifier),
		fields?: SalesOrderFieldPolicy,
	},
	SalesOrderItemLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderItemLineKeySpecifier | (() => undefined | SalesOrderItemLineKeySpecifier),
		fields?: SalesOrderItemLineFieldPolicy,
	},
	PaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodKeySpecifier | (() => undefined | PaymentMethodKeySpecifier),
		fields?: PaymentMethodFieldPolicy,
	},
	PaymentCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCardKeySpecifier | (() => undefined | PaymentCardKeySpecifier),
		fields?: PaymentCardFieldPolicy,
	},
	RegistryCustomer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryCustomerKeySpecifier | (() => undefined | RegistryCustomerKeySpecifier),
		fields?: RegistryCustomerFieldPolicy,
	},
	SalesOrderTaxLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesOrderTaxLineKeySpecifier | (() => undefined | SalesOrderTaxLineKeySpecifier),
		fields?: SalesOrderTaxLineFieldPolicy,
	},
	EventUsersRobust?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventUsersRobustKeySpecifier | (() => undefined | EventUsersRobustKeySpecifier),
		fields?: EventUsersRobustFieldPolicy,
	},
	AccommodationContentSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationContentSearchResultKeySpecifier | (() => undefined | AccommodationContentSearchResultKeySpecifier),
		fields?: AccommodationContentSearchResultFieldPolicy,
	},
	AccommodationContentSearchContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationContentSearchContextKeySpecifier | (() => undefined | AccommodationContentSearchContextKeySpecifier),
		fields?: AccommodationContentSearchContextFieldPolicy,
	},
	AccommodationCatalogPropertyCircularSearchContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyCircularSearchContextKeySpecifier | (() => undefined | AccommodationCatalogPropertyCircularSearchContextKeySpecifier),
		fields?: AccommodationCatalogPropertyCircularSearchContextFieldPolicy,
	},
	ExtendedAccommodationContentSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExtendedAccommodationContentSearchResultKeySpecifier | (() => undefined | ExtendedAccommodationContentSearchResultKeySpecifier),
		fields?: ExtendedAccommodationContentSearchResultFieldPolicy,
	},
	ExtendedAccommodationCatalogProperty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExtendedAccommodationCatalogPropertyKeySpecifier | (() => undefined | ExtendedAccommodationCatalogPropertyKeySpecifier),
		fields?: ExtendedAccommodationCatalogPropertyFieldPolicy,
	},
	AccommodationCatalogPropertyPricingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyPricingInfoKeySpecifier | (() => undefined | AccommodationCatalogPropertyPricingInfoKeySpecifier),
		fields?: AccommodationCatalogPropertyPricingInfoFieldPolicy,
	},
	SearchTermToTemplatesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchTermToTemplatesResponseKeySpecifier | (() => undefined | SearchTermToTemplatesResponseKeySpecifier),
		fields?: SearchTermToTemplatesResponseFieldPolicy,
	},
	TemplateWithTaggingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateWithTaggingInfoKeySpecifier | (() => undefined | TemplateWithTaggingInfoKeySpecifier),
		fields?: TemplateWithTaggingInfoFieldPolicy,
	},
	TravelOfferReservation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationKeySpecifier | (() => undefined | TravelOfferReservationKeySpecifier),
		fields?: TravelOfferReservationFieldPolicy,
	},
	TravelReservationMonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationMonetaryValueKeySpecifier | (() => undefined | TravelReservationMonetaryValueKeySpecifier),
		fields?: TravelReservationMonetaryValueFieldPolicy,
	},
	TravelOfferReservationConfirmation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationConfirmationKeySpecifier | (() => undefined | TravelOfferReservationConfirmationKeySpecifier),
		fields?: TravelOfferReservationConfirmationFieldPolicy,
	},
	TravelOfferReservationContactInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationContactInfoKeySpecifier | (() => undefined | TravelOfferReservationContactInfoKeySpecifier),
		fields?: TravelOfferReservationContactInfoFieldPolicy,
	},
	TravelReservationAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationAddressKeySpecifier | (() => undefined | TravelReservationAddressKeySpecifier),
		fields?: TravelReservationAddressFieldPolicy,
	},
	TravelOfferReservationFee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationFeeKeySpecifier | (() => undefined | TravelOfferReservationFeeKeySpecifier),
		fields?: TravelOfferReservationFeeFieldPolicy,
	},
	TravelOfferReservationOnsiteCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationOnsiteChargeKeySpecifier | (() => undefined | TravelOfferReservationOnsiteChargeKeySpecifier),
		fields?: TravelOfferReservationOnsiteChargeFieldPolicy,
	},
	TravelOfferReservationConfirmationPropertyInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationConfirmationPropertyInfoKeySpecifier | (() => undefined | TravelOfferReservationConfirmationPropertyInfoKeySpecifier),
		fields?: TravelOfferReservationConfirmationPropertyInfoFieldPolicy,
	},
	OfferPolicy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferPolicyKeySpecifier | (() => undefined | OfferPolicyKeySpecifier),
		fields?: OfferPolicyFieldPolicy,
	},
	TravelOfferReservationItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationItemKeySpecifier | (() => undefined | TravelOfferReservationItemKeySpecifier),
		fields?: TravelOfferReservationItemFieldPolicy,
	},
	TravelOfferReservationItemOccupancy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationItemOccupancyKeySpecifier | (() => undefined | TravelOfferReservationItemOccupancyKeySpecifier),
		fields?: TravelOfferReservationItemOccupancyFieldPolicy,
	},
	TravelOfferReservationUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationUnitKeySpecifier | (() => undefined | TravelOfferReservationUnitKeySpecifier),
		fields?: TravelOfferReservationUnitFieldPolicy,
	},
	TravelOfferReservationRoomGuests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationRoomGuestsKeySpecifier | (() => undefined | TravelOfferReservationRoomGuestsKeySpecifier),
		fields?: TravelOfferReservationRoomGuestsFieldPolicy,
	},
	TravelOfferReservationGuestInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationGuestInformationKeySpecifier | (() => undefined | TravelOfferReservationGuestInformationKeySpecifier),
		fields?: TravelOfferReservationGuestInformationFieldPolicy,
	},
	SMS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SMSKeySpecifier | (() => undefined | SMSKeySpecifier),
		fields?: SMSFieldPolicy,
	},
	SMSLinkUrlDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SMSLinkUrlDetailKeySpecifier | (() => undefined | SMSLinkUrlDetailKeySpecifier),
		fields?: SMSLinkUrlDetailFieldPolicy,
	},
	SMSStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SMSStatusKeySpecifier | (() => undefined | SMSStatusKeySpecifier),
		fields?: SMSStatusFieldPolicy,
	},
	StationeryDigitalView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryDigitalViewKeySpecifier | (() => undefined | StationeryDigitalViewKeySpecifier),
		fields?: StationeryDigitalViewFieldPolicy,
	},
	StationeryDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryDraftKeySpecifier | (() => undefined | StationeryDraftKeySpecifier),
		fields?: StationeryDraftFieldPolicy,
	},
	StationeryProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryProductKeySpecifier | (() => undefined | StationeryProductKeySpecifier),
		fields?: StationeryProductFieldPolicy,
	},
	StationeryProductAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryProductAttributeKeySpecifier | (() => undefined | StationeryProductAttributeKeySpecifier),
		fields?: StationeryProductAttributeFieldPolicy,
	},
	StationeryProductAttributeOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryProductAttributeOptionKeySpecifier | (() => undefined | StationeryProductAttributeOptionKeySpecifier),
		fields?: StationeryProductAttributeOptionFieldPolicy,
	},
	StationeryAttributeOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryAttributeOptionKeySpecifier | (() => undefined | StationeryAttributeOptionKeySpecifier),
		fields?: StationeryAttributeOptionFieldPolicy,
	},
	StationeryFlatFeePricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryFlatFeePricingKeySpecifier | (() => undefined | StationeryFlatFeePricingKeySpecifier),
		fields?: StationeryFlatFeePricingFieldPolicy,
	},
	StationeryTieredFlatFeePricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTieredFlatFeePricingKeySpecifier | (() => undefined | StationeryTieredFlatFeePricingKeySpecifier),
		fields?: StationeryTieredFlatFeePricingFieldPolicy,
	},
	StationeryTieredFlatFeePrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTieredFlatFeePriceKeySpecifier | (() => undefined | StationeryTieredFlatFeePriceKeySpecifier),
		fields?: StationeryTieredFlatFeePriceFieldPolicy,
	},
	StationeryTieredPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTieredPricingKeySpecifier | (() => undefined | StationeryTieredPricingKeySpecifier),
		fields?: StationeryTieredPricingFieldPolicy,
	},
	StationeryTieredPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTieredPriceKeySpecifier | (() => undefined | StationeryTieredPriceKeySpecifier),
		fields?: StationeryTieredPriceFieldPolicy,
	},
	StationeryProductShippingOptionV1?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryProductShippingOptionV1KeySpecifier | (() => undefined | StationeryProductShippingOptionV1KeySpecifier),
		fields?: StationeryProductShippingOptionV1FieldPolicy,
	},
	StationeryAllowPoBoxShippingConstraint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryAllowPoBoxShippingConstraintKeySpecifier | (() => undefined | StationeryAllowPoBoxShippingConstraintKeySpecifier),
		fields?: StationeryAllowPoBoxShippingConstraintFieldPolicy,
	},
	StationeryCountryShippingConstraint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryCountryShippingConstraintKeySpecifier | (() => undefined | StationeryCountryShippingConstraintKeySpecifier),
		fields?: StationeryCountryShippingConstraintFieldPolicy,
	},
	StationeryQuantityShippingConstraint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryQuantityShippingConstraintKeySpecifier | (() => undefined | StationeryQuantityShippingConstraintKeySpecifier),
		fields?: StationeryQuantityShippingConstraintFieldPolicy,
	},
	StationeryProductVariantGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryProductVariantGroupKeySpecifier | (() => undefined | StationeryProductVariantGroupKeySpecifier),
		fields?: StationeryProductVariantGroupFieldPolicy,
	},
	StationeryTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTemplateKeySpecifier | (() => undefined | StationeryTemplateKeySpecifier),
		fields?: StationeryTemplateFieldPolicy,
	},
	StationeryFavorite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryFavoriteKeySpecifier | (() => undefined | StationeryFavoriteKeySpecifier),
		fields?: StationeryFavoriteFieldPolicy,
	},
	StationeryPrintOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderKeySpecifier | (() => undefined | StationeryPrintOrderKeySpecifier),
		fields?: StationeryPrintOrderFieldPolicy,
	},
	StationeryPrintOrderDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderDiscountKeySpecifier | (() => undefined | StationeryPrintOrderDiscountKeySpecifier),
		fields?: StationeryPrintOrderDiscountFieldPolicy,
	},
	StationeryPrintOrderIssue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderIssueKeySpecifier | (() => undefined | StationeryPrintOrderIssueKeySpecifier),
		fields?: StationeryPrintOrderIssueFieldPolicy,
	},
	StationeryPrintOrderPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderPaymentKeySpecifier | (() => undefined | StationeryPrintOrderPaymentKeySpecifier),
		fields?: StationeryPrintOrderPaymentFieldPolicy,
	},
	StationeryPrintOrderPaymentInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderPaymentInfoKeySpecifier | (() => undefined | StationeryPrintOrderPaymentInfoKeySpecifier),
		fields?: StationeryPrintOrderPaymentInfoFieldPolicy,
	},
	StationeryPrintOrderRefundView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderRefundViewKeySpecifier | (() => undefined | StationeryPrintOrderRefundViewKeySpecifier),
		fields?: StationeryPrintOrderRefundViewFieldPolicy,
	},
	StationeryPrintOrderSelectedProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderSelectedProductKeySpecifier | (() => undefined | StationeryPrintOrderSelectedProductKeySpecifier),
		fields?: StationeryPrintOrderSelectedProductFieldPolicy,
	},
	StationeryPrintOrderProductAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderProductAttributeKeySpecifier | (() => undefined | StationeryPrintOrderProductAttributeKeySpecifier),
		fields?: StationeryPrintOrderProductAttributeFieldPolicy,
	},
	StationeryPrintOrderShippingAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderShippingAddressKeySpecifier | (() => undefined | StationeryPrintOrderShippingAddressKeySpecifier),
		fields?: StationeryPrintOrderShippingAddressFieldPolicy,
	},
	StationeryPrintOrderStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderStatusKeySpecifier | (() => undefined | StationeryPrintOrderStatusKeySpecifier),
		fields?: StationeryPrintOrderStatusFieldPolicy,
	},
	StationeryPrintTrackingNumberView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintTrackingNumberViewKeySpecifier | (() => undefined | StationeryPrintTrackingNumberViewKeySpecifier),
		fields?: StationeryPrintTrackingNumberViewFieldPolicy,
	},
	StationeryPrintOrderCardDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderCardDetailsKeySpecifier | (() => undefined | StationeryPrintOrderCardDetailsKeySpecifier),
		fields?: StationeryPrintOrderCardDetailsFieldPolicy,
	},
	StationeryPrintOrderDebuggingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrderDebuggingInfoKeySpecifier | (() => undefined | StationeryPrintOrderDebuggingInfoKeySpecifier),
		fields?: StationeryPrintOrderDebuggingInfoFieldPolicy,
	},
	StationeryPrintOrdersView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPrintOrdersViewKeySpecifier | (() => undefined | StationeryPrintOrdersViewKeySpecifier),
		fields?: StationeryPrintOrdersViewFieldPolicy,
	},
	StationeryTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTagKeySpecifier | (() => undefined | StationeryTagKeySpecifier),
		fields?: StationeryTagFieldPolicy,
	},
	StationeryTemplateContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTemplateContainerKeySpecifier | (() => undefined | StationeryTemplateContainerKeySpecifier),
		fields?: StationeryTemplateContainerFieldPolicy,
	},
	StationeryTemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTemplateConnectionKeySpecifier | (() => undefined | StationeryTemplateConnectionKeySpecifier),
		fields?: StationeryTemplateConnectionFieldPolicy,
	},
	StationeryTemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryTemplateEdgeKeySpecifier | (() => undefined | StationeryTemplateEdgeKeySpecifier),
		fields?: StationeryTemplateEdgeFieldPolicy,
	},
	StationeryPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryPageInfoKeySpecifier | (() => undefined | StationeryPageInfoKeySpecifier),
		fields?: StationeryPageInfoFieldPolicy,
	},
	TextTaggingResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TextTaggingResponseKeySpecifier | (() => undefined | TextTaggingResponseKeySpecifier),
		fields?: TextTaggingResponseFieldPolicy,
	},
	ThemeFilterAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThemeFilterAttributesKeySpecifier | (() => undefined | ThemeFilterAttributesKeySpecifier),
		fields?: ThemeFilterAttributesFieldPolicy,
	},
	TicketConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TicketConnectionKeySpecifier | (() => undefined | TicketConnectionKeySpecifier),
		fields?: TicketConnectionFieldPolicy,
	},
	TransitionalRegistry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryKeySpecifier | (() => undefined | TransitionalRegistryKeySpecifier),
		fields?: TransitionalRegistryFieldPolicy,
	},
	TransitionalRegistryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryItemKeySpecifier | (() => undefined | TransitionalRegistryItemKeySpecifier),
		fields?: TransitionalRegistryItemFieldPolicy,
	},
	TravelDistancesFromOriginResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelDistancesFromOriginResponseKeySpecifier | (() => undefined | TravelDistancesFromOriginResponseKeySpecifier),
		fields?: TravelDistancesFromOriginResponseFieldPolicy,
	},
	TravelOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferKeySpecifier | (() => undefined | TravelOfferKeySpecifier),
		fields?: TravelOfferFieldPolicy,
	},
	TravelOfferComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferComponentKeySpecifier | (() => undefined | TravelOfferComponentKeySpecifier),
		fields?: TravelOfferComponentFieldPolicy,
	},
	TravelOfferPolicyField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferPolicyFieldKeySpecifier | (() => undefined | TravelOfferPolicyFieldKeySpecifier),
		fields?: TravelOfferPolicyFieldFieldPolicy,
	},
	TravelOfferOnsiteCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferOnsiteChargeKeySpecifier | (() => undefined | TravelOfferOnsiteChargeKeySpecifier),
		fields?: TravelOfferOnsiteChargeFieldPolicy,
	},
	TravelOffersResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOffersResultKeySpecifier | (() => undefined | TravelOffersResultKeySpecifier),
		fields?: TravelOffersResultFieldPolicy,
	},
	AccommodationCatalogPagination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPaginationKeySpecifier | (() => undefined | AccommodationCatalogPaginationKeySpecifier),
		fields?: AccommodationCatalogPaginationFieldPolicy,
	},
	TravelPlacePricingAndBookingDetailsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPlacePricingAndBookingDetailsResultKeySpecifier | (() => undefined | TravelPlacePricingAndBookingDetailsResultKeySpecifier),
		fields?: TravelPlacePricingAndBookingDetailsResultFieldPolicy,
	},
	AccommodationPlacePricingAndBookingDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlacePricingAndBookingDetailsKeySpecifier | (() => undefined | AccommodationPlacePricingAndBookingDetailsKeySpecifier),
		fields?: AccommodationPlacePricingAndBookingDetailsFieldPolicy,
	},
	PricingForAccommodationPlace?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PricingForAccommodationPlaceKeySpecifier | (() => undefined | PricingForAccommodationPlaceKeySpecifier),
		fields?: PricingForAccommodationPlaceFieldPolicy,
	},
	JoyPlacePricingAndBookingDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JoyPlacePricingAndBookingDetailsKeySpecifier | (() => undefined | JoyPlacePricingAndBookingDetailsKeySpecifier),
		fields?: JoyPlacePricingAndBookingDetailsFieldPolicy,
	},
	StayDatesInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StayDatesInfoKeySpecifier | (() => undefined | StayDatesInfoKeySpecifier),
		fields?: StayDatesInfoFieldPolicy,
	},
	StayDateStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StayDateStrategyKeySpecifier | (() => undefined | StayDateStrategyKeySpecifier),
		fields?: StayDateStrategyFieldPolicy,
	},
	TravelPricingsByPropertyIdResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPricingsByPropertyIdResultKeySpecifier | (() => undefined | TravelPricingsByPropertyIdResultKeySpecifier),
		fields?: TravelPricingsByPropertyIdResultFieldPolicy,
	},
	TravelPricingByPropertyIdItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPricingByPropertyIdItemKeySpecifier | (() => undefined | TravelPricingByPropertyIdItemKeySpecifier),
		fields?: TravelPricingByPropertyIdItemFieldPolicy,
	},
	TravelPricingByPropertyIdData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPricingByPropertyIdDataKeySpecifier | (() => undefined | TravelPricingByPropertyIdDataKeySpecifier),
		fields?: TravelPricingByPropertyIdDataFieldPolicy,
	},
	TravelPlaceComparison?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPlaceComparisonKeySpecifier | (() => undefined | TravelPlaceComparisonKeySpecifier),
		fields?: TravelPlaceComparisonFieldPolicy,
	},
	TravelPlaceComparisonForProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelPlaceComparisonForProviderKeySpecifier | (() => undefined | TravelPlaceComparisonForProviderKeySpecifier),
		fields?: TravelPlaceComparisonForProviderFieldPolicy,
	},
	TravelReservationBookingByEventId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationBookingByEventIdKeySpecifier | (() => undefined | TravelReservationBookingByEventIdKeySpecifier),
		fields?: TravelReservationBookingByEventIdFieldPolicy,
	},
	TravelReservationSummariesByPropertyIdentifiersResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationSummariesByPropertyIdentifiersResultKeySpecifier | (() => undefined | TravelReservationSummariesByPropertyIdentifiersResultKeySpecifier),
		fields?: TravelReservationSummariesByPropertyIdentifiersResultFieldPolicy,
	},
	TravelReservationsSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelReservationsSummaryKeySpecifier | (() => undefined | TravelReservationsSummaryKeySpecifier),
		fields?: TravelReservationsSummaryFieldPolicy,
	},
	AccommodationCatalogPropertyIdentifier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyIdentifierKeySpecifier | (() => undefined | AccommodationCatalogPropertyIdentifierKeySpecifier),
		fields?: AccommodationCatalogPropertyIdentifierFieldPolicy,
	},
	MediaUploadCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaUploadCollectionKeySpecifier | (() => undefined | MediaUploadCollectionKeySpecifier),
		fields?: MediaUploadCollectionFieldPolicy,
	},
	MediaUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaUploadKeySpecifier | (() => undefined | MediaUploadKeySpecifier),
		fields?: MediaUploadFieldPolicy,
	},
	MediaUploadPhoto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaUploadPhotoKeySpecifier | (() => undefined | MediaUploadPhotoKeySpecifier),
		fields?: MediaUploadPhotoFieldPolicy,
	},
	UrlMetadataResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UrlMetadataResponseKeySpecifier | (() => undefined | UrlMetadataResponseKeySpecifier),
		fields?: UrlMetadataResponseFieldPolicy,
	},
	UrlMetadataError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UrlMetadataErrorKeySpecifier | (() => undefined | UrlMetadataErrorKeySpecifier),
		fields?: UrlMetadataErrorFieldPolicy,
	},
	UrlMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UrlMetadataKeySpecifier | (() => undefined | UrlMetadataKeySpecifier),
		fields?: UrlMetadataFieldPolicy,
	},
	UserActivityContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserActivityContainerKeySpecifier | (() => undefined | UserActivityContainerKeySpecifier),
		fields?: UserActivityContainerFieldPolicy,
	},
	UserActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserActivityConnectionKeySpecifier | (() => undefined | UserActivityConnectionKeySpecifier),
		fields?: UserActivityConnectionFieldPolicy,
	},
	UserActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserActivityEdgeKeySpecifier | (() => undefined | UserActivityEdgeKeySpecifier),
		fields?: UserActivityEdgeFieldPolicy,
	},
	UserActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserActivityKeySpecifier | (() => undefined | UserActivityKeySpecifier),
		fields?: UserActivityFieldPolicy,
	},
	UserActivityPageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserActivityPageInfoKeySpecifier | (() => undefined | UserActivityPageInfoKeySpecifier),
		fields?: UserActivityPageInfoFieldPolicy,
	},
	UserConsent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserConsentKeySpecifier | (() => undefined | UserConsentKeySpecifier),
		fields?: UserConsentFieldPolicy,
	},
	PublicUserConsent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicUserConsentKeySpecifier | (() => undefined | PublicUserConsentKeySpecifier),
		fields?: PublicUserConsentFieldPolicy,
	},
	VendorUserInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorUserInviteKeySpecifier | (() => undefined | VendorUserInviteKeySpecifier),
		fields?: VendorUserInviteFieldPolicy,
	},
	VisionTaggingResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VisionTaggingResponseKeySpecifier | (() => undefined | VisionTaggingResponseKeySpecifier),
		fields?: VisionTaggingResponseFieldPolicy,
	},
	WarehouseInventorySearchResultData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseInventorySearchResultDataKeySpecifier | (() => undefined | WarehouseInventorySearchResultDataKeySpecifier),
		fields?: WarehouseInventorySearchResultDataFieldPolicy,
	},
	ZentrumHubHotelIsValid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ZentrumHubHotelIsValidKeySpecifier | (() => undefined | ZentrumHubHotelIsValidKeySpecifier),
		fields?: ZentrumHubHotelIsValidFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	CashFundGeneralError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundGeneralErrorKeySpecifier | (() => undefined | CashFundGeneralErrorKeySpecifier),
		fields?: CashFundGeneralErrorFieldPolicy,
	},
	CashFundError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundErrorKeySpecifier | (() => undefined | CashFundErrorKeySpecifier),
		fields?: CashFundErrorFieldPolicy,
	},
	AddContactToGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddContactToGroupKeySpecifier | (() => undefined | AddContactToGroupKeySpecifier),
		fields?: AddContactToGroupFieldPolicy,
	},
	addMediaToCollectionResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | addMediaToCollectionResponseKeySpecifier | (() => undefined | addMediaToCollectionResponseKeySpecifier),
		fields?: addMediaToCollectionResponseFieldPolicy,
	},
	MutationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationResponseKeySpecifier | (() => undefined | MutationResponseKeySpecifier),
		fields?: MutationResponseFieldPolicy,
	},
	addMediaToCollectionResponseError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | addMediaToCollectionResponseErrorKeySpecifier | (() => undefined | addMediaToCollectionResponseErrorKeySpecifier),
		fields?: addMediaToCollectionResponseErrorFieldPolicy,
	},
	ContactTagItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactTagItemKeySpecifier | (() => undefined | ContactTagItemKeySpecifier),
		fields?: ContactTagItemFieldPolicy,
	},
	TagAssociationGuest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagAssociationGuestKeySpecifier | (() => undefined | TagAssociationGuestKeySpecifier),
		fields?: TagAssociationGuestFieldPolicy,
	},
	TagAssociationResource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagAssociationResourceKeySpecifier | (() => undefined | TagAssociationResourceKeySpecifier),
		fields?: TagAssociationResourceFieldPolicy,
	},
	RegistryOrderResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderResultKeySpecifier | (() => undefined | RegistryOrderResultKeySpecifier),
		fields?: RegistryOrderResultFieldPolicy,
	},
	ResultStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResultStatusKeySpecifier | (() => undefined | ResultStatusKeySpecifier),
		fields?: ResultStatusFieldPolicy,
	},
	ApprovalResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApprovalResultKeySpecifier | (() => undefined | ApprovalResultKeySpecifier),
		fields?: ApprovalResultFieldPolicy,
	},
	ArchiveCashFundSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArchiveCashFundSuccessKeySpecifier | (() => undefined | ArchiveCashFundSuccessKeySpecifier),
		fields?: ArchiveCashFundSuccessFieldPolicy,
	},
	ActiveRegistrySession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveRegistrySessionKeySpecifier | (() => undefined | ActiveRegistrySessionKeySpecifier),
		fields?: ActiveRegistrySessionFieldPolicy,
	},
	AccommodationPlaceId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlaceIdKeySpecifier | (() => undefined | AccommodationPlaceIdKeySpecifier),
		fields?: AccommodationPlaceIdFieldPolicy,
	},
	AccommodationPlaceV3Id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationPlaceV3IdKeySpecifier | (() => undefined | AccommodationPlaceV3IdKeySpecifier),
		fields?: AccommodationPlaceV3IdFieldPolicy,
	},
	AutoPopulateResponseV5?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutoPopulateResponseV5KeySpecifier | (() => undefined | AutoPopulateResponseV5KeySpecifier),
		fields?: AutoPopulateResponseV5FieldPolicy,
	},
	AutoPopulateStayAreasResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutoPopulateStayAreasResponseKeySpecifier | (() => undefined | AutoPopulateStayAreasResponseKeySpecifier),
		fields?: AutoPopulateStayAreasResponseFieldPolicy,
	},
	ContentSafetyRatingResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentSafetyRatingResponseKeySpecifier | (() => undefined | ContentSafetyRatingResponseKeySpecifier),
		fields?: ContentSafetyRatingResponseFieldPolicy,
	},
	TransferRegistryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransferRegistryResultKeySpecifier | (() => undefined | TransferRegistryResultKeySpecifier),
		fields?: TransferRegistryResultFieldPolicy,
	},
	StartStationeryCheckoutResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StartStationeryCheckoutResponseKeySpecifier | (() => undefined | StartStationeryCheckoutResponseKeySpecifier),
		fields?: StartStationeryCheckoutResponseFieldPolicy,
	},
	CashFundCheckoutSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundCheckoutSessionKeySpecifier | (() => undefined | CashFundCheckoutSessionKeySpecifier),
		fields?: CashFundCheckoutSessionFieldPolicy,
	},
	CashFundPaymentIntent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashFundPaymentIntentKeySpecifier | (() => undefined | CashFundPaymentIntentKeySpecifier),
		fields?: CashFundPaymentIntentFieldPolicy,
	},
	ContactTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactTagKeySpecifier | (() => undefined | ContactTagKeySpecifier),
		fields?: ContactTagFieldPolicy,
	},
	DonationFundResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DonationFundResultKeySpecifier | (() => undefined | DonationFundResultKeySpecifier),
		fields?: DonationFundResultFieldPolicy,
	},
	FeatureFlag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureFlagKeySpecifier | (() => undefined | FeatureFlagKeySpecifier),
		fields?: FeatureFlagFieldPolicy,
	},
	createMediaPhotosResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | createMediaPhotosResponseKeySpecifier | (() => undefined | createMediaPhotosResponseKeySpecifier),
		fields?: createMediaPhotosResponseFieldPolicy,
	},
	CreatePlusOneGuest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePlusOneGuestKeySpecifier | (() => undefined | CreatePlusOneGuestKeySpecifier),
		fields?: CreatePlusOneGuestFieldPolicy,
	},
	PlusOneGuest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlusOneGuestKeySpecifier | (() => undefined | PlusOneGuestKeySpecifier),
		fields?: PlusOneGuestFieldPolicy,
	},
	RegistryItemResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemResultKeySpecifier | (() => undefined | RegistryItemResultKeySpecifier),
		fields?: RegistryItemResultFieldPolicy,
	},
	RegistryItemsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemsResultKeySpecifier | (() => undefined | RegistryItemsResultKeySpecifier),
		fields?: RegistryItemsResultFieldPolicy,
	},
	RegistryPaymentIntent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPaymentIntentKeySpecifier | (() => undefined | RegistryPaymentIntentKeySpecifier),
		fields?: RegistryPaymentIntentFieldPolicy,
	},
	RegistryPaymentIntentError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPaymentIntentErrorKeySpecifier | (() => undefined | RegistryPaymentIntentErrorKeySpecifier),
		fields?: RegistryPaymentIntentErrorFieldPolicy,
	},
	RegistryErrorResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryErrorResultKeySpecifier | (() => undefined | RegistryErrorResultKeySpecifier),
		fields?: RegistryErrorResultFieldPolicy,
	},
	RegistryErrorPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryErrorPayloadKeySpecifier | (() => undefined | RegistryErrorPayloadKeySpecifier),
		fields?: RegistryErrorPayloadFieldPolicy,
	},
	RegistryPurchaseContextEnvelope?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPurchaseContextEnvelopeKeySpecifier | (() => undefined | RegistryPurchaseContextEnvelopeKeySpecifier),
		fields?: RegistryPurchaseContextEnvelopeFieldPolicy,
	},
	RegistryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryResultKeySpecifier | (() => undefined | RegistryResultKeySpecifier),
		fields?: RegistryResultFieldPolicy,
	},
	StationeryDigitalDraftPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryDigitalDraftPreviewKeySpecifier | (() => undefined | StationeryDigitalDraftPreviewKeySpecifier),
		fields?: StationeryDigitalDraftPreviewFieldPolicy,
	},
	StationeryDraftPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StationeryDraftPreviewKeySpecifier | (() => undefined | StationeryDraftPreviewKeySpecifier),
		fields?: StationeryDraftPreviewFieldPolicy,
	},
	VendorOrganization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorOrganizationKeySpecifier | (() => undefined | VendorOrganizationKeySpecifier),
		fields?: VendorOrganizationFieldPolicy,
	},
	CardResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardResponseKeySpecifier | (() => undefined | CardResponseKeySpecifier),
		fields?: CardResponseFieldPolicy,
	},
	GetImagesMetadataResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetImagesMetadataResponseKeySpecifier | (() => undefined | GetImagesMetadataResponseKeySpecifier),
		fields?: GetImagesMetadataResponseFieldPolicy,
	},
	GetImageMetadataResultItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetImageMetadataResultItemKeySpecifier | (() => undefined | GetImageMetadataResultItemKeySpecifier),
		fields?: GetImageMetadataResultItemFieldPolicy,
	},
	FailedImageMetadataResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FailedImageMetadataResponseKeySpecifier | (() => undefined | FailedImageMetadataResponseKeySpecifier),
		fields?: FailedImageMetadataResponseFieldPolicy,
	},
	GenerateAccommodationRecommendationsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateAccommodationRecommendationsResponseKeySpecifier | (() => undefined | GenerateAccommodationRecommendationsResponseKeySpecifier),
		fields?: GenerateAccommodationRecommendationsResponseFieldPolicy,
	},
	GenerateRecommendationsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateRecommendationsResultKeySpecifier | (() => undefined | GenerateRecommendationsResultKeySpecifier),
		fields?: GenerateRecommendationsResultFieldPolicy,
	},
	AccommodationRecommendationsSearchLocationInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationRecommendationsSearchLocationInfoKeySpecifier | (() => undefined | AccommodationRecommendationsSearchLocationInfoKeySpecifier),
		fields?: AccommodationRecommendationsSearchLocationInfoFieldPolicy,
	},
	GroupContacts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupContactsKeySpecifier | (() => undefined | GroupContactsKeySpecifier),
		fields?: GroupContactsFieldPolicy,
	},
	JoinEventWithGuidResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JoinEventWithGuidResponseKeySpecifier | (() => undefined | JoinEventWithGuidResponseKeySpecifier),
		fields?: JoinEventWithGuidResponseFieldPolicy,
	},
	UpdateEventResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEventResultKeySpecifier | (() => undefined | UpdateEventResultKeySpecifier),
		fields?: UpdateEventResultFieldPolicy,
	},
	UpdateUserResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateUserResultKeySpecifier | (() => undefined | UpdateUserResultKeySpecifier),
		fields?: UpdateUserResultFieldPolicy,
	},
	MilestonesDependenciesBatchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesDependenciesBatchResultKeySpecifier | (() => undefined | MilestonesDependenciesBatchResultKeySpecifier),
		fields?: MilestonesDependenciesBatchResultFieldPolicy,
	},
	MilestonesBatchOperationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesBatchOperationErrorKeySpecifier | (() => undefined | MilestonesBatchOperationErrorKeySpecifier),
		fields?: MilestonesBatchOperationErrorFieldPolicy,
	},
	MilestonesCategoriesBatchCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCategoriesBatchCreateResultKeySpecifier | (() => undefined | MilestonesCategoriesBatchCreateResultKeySpecifier),
		fields?: MilestonesCategoriesBatchCreateResultFieldPolicy,
	},
	MilestonesBatchCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesBatchCreateResultKeySpecifier | (() => undefined | MilestonesBatchCreateResultKeySpecifier),
		fields?: MilestonesBatchCreateResultFieldPolicy,
	},
	MilestonesPhasesBatchCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesPhasesBatchCreateResultKeySpecifier | (() => undefined | MilestonesPhasesBatchCreateResultKeySpecifier),
		fields?: MilestonesPhasesBatchCreateResultFieldPolicy,
	},
	MilestonesCategoriesBatchDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesCategoriesBatchDeleteResultKeySpecifier | (() => undefined | MilestonesCategoriesBatchDeleteResultKeySpecifier),
		fields?: MilestonesCategoriesBatchDeleteResultFieldPolicy,
	},
	MilestonesBatchDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesBatchDeleteResultKeySpecifier | (() => undefined | MilestonesBatchDeleteResultKeySpecifier),
		fields?: MilestonesBatchDeleteResultFieldPolicy,
	},
	MilestonesPhasesBatchDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesPhasesBatchDeleteResultKeySpecifier | (() => undefined | MilestonesPhasesBatchDeleteResultKeySpecifier),
		fields?: MilestonesPhasesBatchDeleteResultFieldPolicy,
	},
	MilestonesExportResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MilestonesExportResultKeySpecifier | (() => undefined | MilestonesExportResultKeySpecifier),
		fields?: MilestonesExportResultFieldPolicy,
	},
	RefreshOfferTokenResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefreshOfferTokenResultKeySpecifier | (() => undefined | RefreshOfferTokenResultKeySpecifier),
		fields?: RefreshOfferTokenResultFieldPolicy,
	},
	TravelOfferReservationCreateStripeNativeResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationCreateStripeNativeResultKeySpecifier | (() => undefined | TravelOfferReservationCreateStripeNativeResultKeySpecifier),
		fields?: TravelOfferReservationCreateStripeNativeResultFieldPolicy,
	},
	TravelOfferReservationCreateVaulteraVaultResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationCreateVaulteraVaultResultKeySpecifier | (() => undefined | TravelOfferReservationCreateVaulteraVaultResultKeySpecifier),
		fields?: TravelOfferReservationCreateVaulteraVaultResultFieldPolicy,
	},
	RemoveContactFromGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveContactFromGroupKeySpecifier | (() => undefined | RemoveContactFromGroupKeySpecifier),
		fields?: RemoveContactFromGroupFieldPolicy,
	},
	RawPageComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RawPageComponentKeySpecifier | (() => undefined | RawPageComponentKeySpecifier),
		fields?: RawPageComponentFieldPolicy,
	},
	EventRegistrationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventRegistrationResponseKeySpecifier | (() => undefined | EventRegistrationResponseKeySpecifier),
		fields?: EventRegistrationResponseFieldPolicy,
	},
	SendCashFundSolicitationEmailsSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendCashFundSolicitationEmailsSuccessKeySpecifier | (() => undefined | SendCashFundSolicitationEmailsSuccessKeySpecifier),
		fields?: SendCashFundSolicitationEmailsSuccessFieldPolicy,
	},
	SendCashFundSolicitationTestEmailSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendCashFundSolicitationTestEmailSuccessKeySpecifier | (() => undefined | SendCashFundSolicitationTestEmailSuccessKeySpecifier),
		fields?: SendCashFundSolicitationTestEmailSuccessFieldPolicy,
	},
	SendMessageBatchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendMessageBatchResultKeySpecifier | (() => undefined | SendMessageBatchResultKeySpecifier),
		fields?: SendMessageBatchResultFieldPolicy,
	},
	PhoneNumberSendVerificationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhoneNumberSendVerificationResponseKeySpecifier | (() => undefined | PhoneNumberSendVerificationResponseKeySpecifier),
		fields?: PhoneNumberSendVerificationResponseFieldPolicy,
	},
	PhoneNumberVerificationAttempt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhoneNumberVerificationAttemptKeySpecifier | (() => undefined | PhoneNumberVerificationAttemptKeySpecifier),
		fields?: PhoneNumberVerificationAttemptFieldPolicy,
	},
	SendPostRsvpSmsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendPostRsvpSmsResponseKeySpecifier | (() => undefined | SendPostRsvpSmsResponseKeySpecifier),
		fields?: SendPostRsvpSmsResponseFieldPolicy,
	},
	RegistryStartFulfillmentResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryStartFulfillmentResultKeySpecifier | (() => undefined | RegistryStartFulfillmentResultKeySpecifier),
		fields?: RegistryStartFulfillmentResultFieldPolicy,
	},
	ImageHistoryVariation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageHistoryVariationKeySpecifier | (() => undefined | ImageHistoryVariationKeySpecifier),
		fields?: ImageHistoryVariationFieldPolicy,
	},
	VariationPrompt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariationPromptKeySpecifier | (() => undefined | VariationPromptKeySpecifier),
		fields?: VariationPromptFieldPolicy,
	},
	TravelOfferReservationCancelFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationCancelFailureKeySpecifier | (() => undefined | TravelOfferReservationCancelFailureKeySpecifier),
		fields?: TravelOfferReservationCancelFailureFieldPolicy,
	},
	TravelOfferReservationCancelSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationCancelSuccessKeySpecifier | (() => undefined | TravelOfferReservationCancelSuccessKeySpecifier),
		fields?: TravelOfferReservationCancelSuccessFieldPolicy,
	},
	TravelOfferReservationConfirmFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationConfirmFailureKeySpecifier | (() => undefined | TravelOfferReservationConfirmFailureKeySpecifier),
		fields?: TravelOfferReservationConfirmFailureFieldPolicy,
	},
	TravelOfferReservationConfirmSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferReservationConfirmSuccessKeySpecifier | (() => undefined | TravelOfferReservationConfirmSuccessKeySpecifier),
		fields?: TravelOfferReservationConfirmSuccessFieldPolicy,
	},
	EventGreetingResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventGreetingResponseKeySpecifier | (() => undefined | EventGreetingResponseKeySpecifier),
		fields?: EventGreetingResponseFieldPolicy,
	},
	PhotoEnvelopeResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoEnvelopeResultKeySpecifier | (() => undefined | PhotoEnvelopeResultKeySpecifier),
		fields?: PhotoEnvelopeResultFieldPolicy,
	},
	PhotoEnvelopeError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoEnvelopeErrorKeySpecifier | (() => undefined | PhotoEnvelopeErrorKeySpecifier),
		fields?: PhotoEnvelopeErrorFieldPolicy,
	},
	uploadPhotosFromUrlsResponseError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | uploadPhotosFromUrlsResponseErrorKeySpecifier | (() => undefined | uploadPhotosFromUrlsResponseErrorKeySpecifier),
		fields?: uploadPhotosFromUrlsResponseErrorFieldPolicy,
	},
	FailedPhotoUploadResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FailedPhotoUploadResponseKeySpecifier | (() => undefined | FailedPhotoUploadResponseKeySpecifier),
		fields?: FailedPhotoUploadResponseFieldPolicy,
	},
	uploadPhotosFromUrlsResponseSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | uploadPhotosFromUrlsResponseSuccessKeySpecifier | (() => undefined | uploadPhotosFromUrlsResponseSuccessKeySpecifier),
		fields?: uploadPhotosFromUrlsResponseSuccessFieldPolicy,
	},
	websiteCreateOrUpdatePagePhotoPresentationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | websiteCreateOrUpdatePagePhotoPresentationResponseKeySpecifier | (() => undefined | websiteCreateOrUpdatePagePhotoPresentationResponseKeySpecifier),
		fields?: websiteCreateOrUpdatePagePhotoPresentationResponseFieldPolicy,
	},
	websiteCreateOrUpdatePagePhotoPresentationResponseError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | websiteCreateOrUpdatePagePhotoPresentationResponseErrorKeySpecifier | (() => undefined | websiteCreateOrUpdatePagePhotoPresentationResponseErrorKeySpecifier),
		fields?: websiteCreateOrUpdatePagePhotoPresentationResponseErrorFieldPolicy,
	},
	RegistryPayoutWithdrawal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryPayoutWithdrawalKeySpecifier | (() => undefined | RegistryPayoutWithdrawalKeySpecifier),
		fields?: RegistryPayoutWithdrawalFieldPolicy,
	},
	AccommodationCatalogPropertyUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccommodationCatalogPropertyUnitKeySpecifier | (() => undefined | AccommodationCatalogPropertyUnitKeySpecifier),
		fields?: AccommodationCatalogPropertyUnitFieldPolicy,
	},
	BlogArticle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlogArticleKeySpecifier | (() => undefined | BlogArticleKeySpecifier),
		fields?: BlogArticleFieldPolicy,
	},
	DesignFeature?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignFeatureKeySpecifier | (() => undefined | DesignFeatureKeySpecifier),
		fields?: DesignFeatureFieldPolicy,
	},
	Pricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PricingKeySpecifier | (() => undefined | PricingKeySpecifier),
		fields?: PricingFieldPolicy,
	},
	ProductCatalogEntityBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityBrandKeySpecifier | (() => undefined | ProductCatalogEntityBrandKeySpecifier),
		fields?: ProductCatalogEntityBrandFieldPolicy,
	},
	ProductCatalogEntityCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityCategoryKeySpecifier | (() => undefined | ProductCatalogEntityCategoryKeySpecifier),
		fields?: ProductCatalogEntityCategoryFieldPolicy,
	},
	ProductCatalogEntityCuration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityCurationKeySpecifier | (() => undefined | ProductCatalogEntityCurationKeySpecifier),
		fields?: ProductCatalogEntityCurationFieldPolicy,
	},
	ProductCatalogEntityItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityItemKeySpecifier | (() => undefined | ProductCatalogEntityItemKeySpecifier),
		fields?: ProductCatalogEntityItemFieldPolicy,
	},
	ProductCatalogEntityItemGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogEntityItemGroupKeySpecifier | (() => undefined | ProductCatalogEntityItemGroupKeySpecifier),
		fields?: ProductCatalogEntityItemGroupFieldPolicy,
	},
	ProductCatalogRegistryStoreRecommandation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCatalogRegistryStoreRecommandationKeySpecifier | (() => undefined | ProductCatalogRegistryStoreRecommandationKeySpecifier),
		fields?: ProductCatalogRegistryStoreRecommandationFieldPolicy,
	},
	RegistryItemRecommendationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryItemRecommendationResultKeySpecifier | (() => undefined | RegistryItemRecommendationResultKeySpecifier),
		fields?: RegistryItemRecommendationResultFieldPolicy,
	},
	RegistryOrderLineItemCommerceData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistryOrderLineItemCommerceDataKeySpecifier | (() => undefined | RegistryOrderLineItemCommerceDataKeySpecifier),
		fields?: RegistryOrderLineItemCommerceDataFieldPolicy,
	},
	TransitionalRegistryFund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryFundKeySpecifier | (() => undefined | TransitionalRegistryFundKeySpecifier),
		fields?: TransitionalRegistryFundFieldPolicy,
	},
	TransitionalRegistryFundData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryFundDataKeySpecifier | (() => undefined | TransitionalRegistryFundDataKeySpecifier),
		fields?: TransitionalRegistryFundDataFieldPolicy,
	},
	TransitionalRegistryProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryProductKeySpecifier | (() => undefined | TransitionalRegistryProductKeySpecifier),
		fields?: TransitionalRegistryProductFieldPolicy,
	},
	TransitionalRegistryProductData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransitionalRegistryProductDataKeySpecifier | (() => undefined | TransitionalRegistryProductDataKeySpecifier),
		fields?: TransitionalRegistryProductDataFieldPolicy,
	},
	TravelOfferAccommodationUnitsComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferAccommodationUnitsComponentKeySpecifier | (() => undefined | TravelOfferAccommodationUnitsComponentKeySpecifier),
		fields?: TravelOfferAccommodationUnitsComponentFieldPolicy,
	},
	TravelOfferAccommodationUnitsComponentOccupancy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TravelOfferAccommodationUnitsComponentOccupancyKeySpecifier | (() => undefined | TravelOfferAccommodationUnitsComponentOccupancyKeySpecifier),
		fields?: TravelOfferAccommodationUnitsComponentOccupancyFieldPolicy,
	},
	VendorLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VendorLocationKeySpecifier | (() => undefined | VendorLocationKeySpecifier),
		fields?: VendorLocationFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;